webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);





/* harmony default export */ __webpack_exports__["a"] = ({
    data: function data() {
        return {
            patientError: null
        };
    },


    computed: {
        preventBodyScroll: function preventBodyScroll() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.preventBodyScroll;
        },
        patient: function patient() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.patient;
        },
        patientPosition: function patientPosition() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.patientPosition;
        },
        patientPlace: function patientPlace() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.patientPlace;
        },
        patientPlaceName: function patientPlaceName() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.patientPlaceName;
        },
        patientMedicalPractice: function patientMedicalPractice() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.patientMedicalPractice;
        },
        frontLanguage: function frontLanguage() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.frontLanguage;
        },
        patientLanguage: function patientLanguage() {
            return _.find(this.languages, { shortCode: this.frontLanguage || 'en' });
        },
        patientLanguageName: function patientLanguageName() {
            return this.patientLanguage ? this.patientLanguage.name : 'English';
        },
        currentLayout: function currentLayout() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.currentLayout;
        },
        online: function online() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.online;
        },
        userId: function userId() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.userId;
        },
        listenAppointments: function listenAppointments() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.listenAppointments;
        },
        isLoading: function isLoading() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.loading;
        },


        currentOffice: function currentOffice() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.currentOffice;
        },

        currentDate: function currentDate() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.currentDate;
        },

        doctor: function doctor() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.doctor;
        },

        offices: function offices() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.offices;
        },

        languages: function languages() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.languages;
        },

        countries: function countries() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.countries;
        },

        defaultCountryId: function defaultCountryId() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.defaultCountryId;
        },

        recommendations: function recommendations() {
            return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.recommendations;
        },

        notifications: function notifications() {
            return _.filter(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].state.notifications, function (n) {
                return n.active;
            });
        },

        showCookieNotification: function showCookieNotification() {
            return !this.doctor && !this.consentForCookies;
        },
        showRecommendationsModal: function showRecommendationsModal() {
            return this.doctor && !this.closedRecommendationsModal && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.recommendations).length < 1 ? true : false;
        }
    },

    methods: {
        goBack: function goBack() {
            this.$router.go(-1);
        },
        timeAgo: function timeAgo(date, format) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date, format).fromNow();
        },
        setPreventBodyScroll: function setPreventBodyScroll(preventBodyScroll) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setPreventBodyScroll', preventBodyScroll);
        },
        setLoading: function setLoading(loading) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setLoading', loading);
        },
        setLocale: function setLocale(locale) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setLocale', locale);
        },
        setLoaded: function setLoaded(loaded) {
            this.loaded = loaded;
        },
        setFormError: function setFormError(error) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setFormError', error);
        },
        setCurrentDate: function setCurrentDate(date) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setCurrentDate', date);
        },
        setCurrentOffice: function setCurrentOffice(office) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setCurrentOffice', office);
        },
        setPatientPosition: function setPatientPosition(position) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setPatientPosition', position);
        },
        setPatientPlace: function setPatientPlace(place) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setPatientPlace', place);
        },
        setPatientPlaceName: function setPatientPlaceName(name) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setPatientPlaceName', name);
        },
        setPatientMedicalPractice: function setPatientMedicalPractice(type) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setPatientMedicalPractice', type);
        },
        setListenAppointments: function setListenAppointments(listen) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('listenAppointments', listen);
        },
        setUserId: function setUserId(userId) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setUserId', userId);
        },
        setDoctor: function setDoctor(doctor) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setDoctor', doctor);
        },
        setOffices: function setOffices(offices) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setOffices', offices);
        },
        setLanguages: function setLanguages(languages) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setLanguages', languages);
        },
        addNotification: function addNotification(notification) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('addNotification', notification);
        },
        disableNotification: function disableNotification(notification) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('disableNotification', notification);
        },
        setCountries: function setCountries(countries) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setCountries', countries);

            var country = _.find(countries, { code: 'be' });

            if (country) {
                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setDefaultCountryId', country.id);
            }
        },
        setRecommendations: function setRecommendations(recommendations) {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setRecommendations', recommendations);
        },
        alertPatientError: function alertPatientError(message) {
            var _this = this;

            var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2500;

            this.patientError = message;

            setTimeout(function () {
                _this.patientError = null;
            }, delay);
        },
        alertError: function alertError(message) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var opts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ message: message, type: 'is-danger' }, options);

            this.$toast.open(opts);
        },
        alertWarning: function alertWarning(message) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var opts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ message: message, type: 'is-warning' }, options);

            this.$toast.open(opts);
        },
        alertSuccess: function alertSuccess(message) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var opts = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ message: message, type: 'is-success' }, options);

            this.$toast.open(opts);
        },
        hashPatientInfo: function hashPatientInfo(value) {
            if (value.length) {
                var hashedValue = [];
                var alphabet = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+@#- )";
                var hashedAlphabet = "ghijklabcdefopmnvwxyzqrstuGHIJKLABCDEFOPMNVWXYZQRSTU3450128967#-+@) ";

                for (var i = 0; i < value.length; i++) {
                    var index = alphabet.indexOf(value[i]);

                    if (index > -1) {
                        hashedValue.push(hashedAlphabet[index]);
                    } else {
                        hashedValue.push(value[i]);
                    }
                }

                return hashedValue.join('');
            }
        },
        hasGivenConsentForCookies: function hasGivenConsentForCookies() {
            if (this.consentForCookies) return true;

            var value = '; ' + document.cookie;
            var parts = value.split('; cookieconsent_status=');

            return parts.length != 2 ? false : true;
        },
        consentCookies: function consentCookies() {
            var expirationDate = __WEBPACK_IMPORTED_MODULE_3_moment___default()().add(365, 'days');

            var cookie = ['cookieconsent_status=1', 'expires=' + expirationDate.utc().toString(), 'path=/'];

            document.cookie = cookie.join(';');

            this.consentForCookies = true;
        },
        checkIfHasReadCovidNotification: function checkIfHasReadCovidNotification() {
            if (this.hasReadCovidNotification) return true;

            var value = '; ' + document.cookie;
            var parts = value.split('; covid_read=');

            return parts.length != 2 ? false : true;
        },
        convertArrayOfObjectsToCSV: function convertArrayOfObjectsToCSV(args) {
            var result = void 0,
                ctr = void 0,
                keys = void 0,
                attributes = void 0,
                headers = void 0,
                columnDelimiter = void 0,
                lineDelimiter = void 0,
                data = void 0;

            data = args.data || null;
            if (data == null || !data.length) {
                return null;
            }

            columnDelimiter = args.columnDelimiter || ',';
            lineDelimiter = args.lineDelimiter || '\n';

            keys = args.keys;
            attributes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(keys);
            headers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(keys).map(function (key) {
                return keys[key];
            });

            result = '';
            result += headers.join(columnDelimiter);
            result += lineDelimiter;

            data.forEach(function (item) {
                ctr = 0;
                attributes.forEach(function (key) {
                    if (ctr > 0) result += columnDelimiter;
                    if (item.hasOwnProperty(key)) {
                        result += item[key] ? item[key] : '';
                    }
                    ctr++;
                });
                result += lineDelimiter;
            });

            return result;
        }
    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__state__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getters__ = __webpack_require__(782);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: __WEBPACK_IMPORTED_MODULE_2__state__["a" /* state */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* mutations */],
    actions: __WEBPACK_IMPORTED_MODULE_4__actions__["a" /* actions */],
    getters: __WEBPACK_IMPORTED_MODULE_5__getters__["a" /* getters */]
});

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return authProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return db; });
/* unused harmony export storage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_firestore__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_storage__ = __webpack_require__(538);






var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.initializeApp({
    apiKey: "AIzaSyBXIAl3Iq97-Z58_VMVY-UZQc_OQKrpIxw",
    authDomain: "tooddoc-dev.firebaseapp.com",
    projectId: "tooddoc-dev",
    storageBucket: "tooddoc-dev.appspot.com",
    messagingSenderId: "281054974604"
});

var authProviders = {
    Email: __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth.EmailAuthProvider.PROVIDER_ID,
    Google: __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth.GoogleAuthProvider.PROVIDER_ID,
    Facebook: __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth.FacebookAuthProvider.PROVIDER_ID
};

var auth = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth();
var db = firebaseApp.firestore();
var storage = firebaseApp.storage();

/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderNav_vue__ = __webpack_require__(323);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_041ce2a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderNav_vue__ = __webpack_require__(582);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeaderNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_041ce2a8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeaderNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/HeaderNav.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-041ce2a8", Component.options)
  } else {
    hotAPI.reload("data-v-041ce2a8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PatientRepository__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__mixins_helpers__ = __webpack_require__(2);












// Extend EventEmitter so user of EmergencyRepository can react to our own defined events. (ex: emergencyRepository.on('added'))

var EmergencyRepository = function (_EventEmitter) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(EmergencyRepository, _EventEmitter);

    function EmergencyRepository() {
        var _ret;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, EmergencyRepository);

        var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (EmergencyRepository.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(EmergencyRepository)).call(this));

        _this.collection = __WEBPACK_IMPORTED_MODULE_6__firebase__["c" /* db */].collection('emergencies');

        return _ret = _this, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(EmergencyRepository, [{
        key: 'find',
        value: function find(id, onSuccess, onError) {
            this.collection.doc(id).get().then(function (snapshot) {
                if (snapshot.exists) {
                    onSuccess(snapshot.data());
                } else {
                    onError({ message: "This emergency does not exist." });
                }
            }).catch(onError);
        }
    }, {
        key: 'allAvailable',
        value: function allAvailable(type, onSuccess, onError) {
            var office = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* store */].state.offices[__WEBPACK_IMPORTED_MODULE_8__store__["a" /* store */].state.currentOffice];

            this.collection.where('type', '==', type).where('hasBeenCancelled', '==', false).where('hasBeenAutoCancelled', '==', false).where('appointmentId', '==', null).where('appointmentInvitationId', '==', null).get().then(function (querySnapshot) {
                var emergencies = {};

                querySnapshot.forEach(function (doc) {
                    var data = doc.data();

                    // Only emergencies in a 20km radius
                    if (window.distanceBetween(data.location._lat, data.location._long, office.location._lat, office.location._long) <= 20) {
                        emergencies[doc.id] = data;
                    }
                });

                onSuccess(emergencies);
            }).catch(function (error) {
                onError(error);
            });
        }
    }, {
        key: 'allForPatient',
        value: function allForPatient(patientId, onSuccess, onError) {
            this.collection.where('patientId', '==', patientId).where('hasBeenAutoCancelled', '==', false).where('hasBeenCancelled', '==', false).where('appointmentId', '==', null).where('appointmentInvitationId', '==', null).get().then(function (querySnapshot) {
                var emergencies = {};

                querySnapshot.forEach(function (doc) {
                    if (!doc.data().hasBeenTaken) {
                        emergencies[doc.id] = doc.data();
                    }
                });

                onSuccess(emergencies);
            }).catch(onError);
        }
    }, {
        key: 'create',
        value: function create(patient, onSuccess, onError) {
            var newEmergency = this.collection.doc();

            var emergency = {
                id: newEmergency.id,
                dateTimeCreated: new Date(),
                appointmentId: null,
                appointmentInvitationId: null,
                hasBeenCancelled: false,
                hasBeenAutoCancelled: false,
                type: patient.type,
                patientId: patient.id,
                patientFirstName: patient.firstName,
                patientLastName: patient.lastName,
                patientAge: parseInt(patient.age),
                patientEmail: patient.email,
                patientPhone: patient.phone,
                locality: patient.locality,
                zipCode: patient.zipCode,
                location: patient.location,
                symptoms: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_freeze___default()(patient.symptoms),
                pictures: []
            };

            this.collection.doc(emergency.id).set(emergency).then(function () {
                if (__WEBPACK_IMPORTED_MODULE_8__store__["a" /* store */].state.patient.email === null) {

                    __WEBPACK_IMPORTED_MODULE_9__PatientRepository__["a" /* default */].update({
                        id: patient.id,
                        email: __WEBPACK_IMPORTED_MODULE_10__mixins_helpers__["a" /* default */].methods.hashPatientInfo(patient.email)
                    }, onSuccess, onError);
                } else {
                    onSuccess();
                }
            }).catch(onError);
        }
    }, {
        key: 'delete',
        value: function _delete(emergency, onSuccess, onError) {
            this.collection.doc(emergency.id).update({
                hasBeenCancelled: true
            }).then(onSuccess).catch(onError);
        }

        // Attach listeners to Firebase

    }, {
        key: 'attachFirebaseListeners',
        value: function attachFirebaseListeners() {
            var _this2 = this;

            this.collection.onSnapshot(function (querySnapshot) {
                for (var key in querySnapshot.docChanges()) {
                    var docChange = querySnapshot.docChanges()[key];
                    var type = docChange.type;
                    var doc = docChange.doc;

                    _this2.onChanged(type, doc);
                }
            });
        }
    }, {
        key: 'onChanged',
        value: function onChanged(type, doc) {
            this.emit(type, doc.id, doc.exists ? doc.data() : null);
        }
    }]);

    return EmergencyRepository;
}(__WEBPACK_IMPORTED_MODULE_7_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new EmergencyRepository());

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_events__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DoctorRepository__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OfficeRepository__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PatientRepository__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);



















// Extend EventEmitter so user of EmergencyRepository can react to our own defined events. (ex: emergencyRepository.on('added'))

var TimeSlotRepository = function (_EventEmitter) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(TimeSlotRepository, _EventEmitter);

    function TimeSlotRepository() {
        var _ret;

        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, TimeSlotRepository);

        var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (TimeSlotRepository.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(TimeSlotRepository)).call(this));

        _this.collection = __WEBPACK_IMPORTED_MODULE_7__firebase__["c" /* db */].collection('timeSlots');

        return _ret = _this, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(TimeSlotRepository, [{
        key: 'subscribe',
        value: function subscribe() {
            this.attachFirebaseListeners();
        }
    }, {
        key: 'unsubscribe',
        value: function unsubscribe() {
            console.log('unsubscribed DoctorOfficeRepository');

            this.detachFirebaseListeners();
        }
    }, {
        key: 'create',
        value: function create(doctor, office, date, time, onSuccess, onError) {
            var _this2 = this;

            this.collection.where('doctorId', '==', doctor.id).where('officeId', '==', office.id).where('date', '==', date).where('time', '==', time).get().then(function (querySnapshot) {
                if (!querySnapshot.empty) {
                    onError({
                        message: "You already created this time slot.",
                        query: {
                            doctor: doctor.id,
                            office: office.id,
                            date: date,
                            time: time
                        }
                    });
                    return false;
                }

                var newDoc = _this2.collection.doc();
                var id = newDoc.id;

                var timeSlot = {
                    id: id, date: date, time: time,
                    type: doctor.type,
                    appointmentId: null,
                    appointmentInvitationId: null,
                    doctorId: doctor.id,
                    doctorFirstName: doctor.firstName,
                    doctorLastName: doctor.lastName,
                    doctorAvatar: doctor.avatar,
                    isDoctorRegulated: doctor.isRegulated,
                    officeId: office.id,
                    officeName: office.name,
                    officeStreetName: office.streetName,
                    officeStreetNumber: office.streetNumber,
                    officeZipCode: office.zipCode,
                    officeLocality: office.locality,
                    officeCountryId: office.countryId,
                    officeCountry: __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('Countries.' + __WEBPACK_IMPORTED_MODULE_9__store__["a" /* store */].state.countries[office.countryId].code) || 'Belgique',
                    officeLocation: office.location,
                    officePhone: office.phone
                };

                _this2.collection.doc(id).set(timeSlot).then(function () {
                    onSuccess(timeSlot);
                }).catch(onError);
            }).catch(function (error) {
                onError(error);
            });
        }
    }, {
        key: 'delete',
        value: function _delete(doctor, office, date, time, onSuccess, onError) {
            this.collection.where('doctorId', '==', doctor.id).where('officeId', '==', office.id).where('date', '==', date).where('time', '==', time).get().then(function (querySnapshot) {
                if (querySnapshot.empty) {
                    onError({ message: "This time slot is already deactivated." });
                    return false;
                }

                querySnapshot.docs[0].ref.delete().then(onSuccess, onError).catch(onError);
            }).catch(onError);
        }
    }, {
        key: 'allForDate',
        value: function allForDate(doctorId, officeId, date, onSuccess, onError) {
            this.collection.where('doctorId', '==', doctorId).where('officeId', '==', officeId).where('date', '==', date).get().then(function (querySnapshot) {
                var timeSlots = {};

                querySnapshot.forEach(function (doc) {
                    timeSlots[doc.id] = doc.data();
                });

                onSuccess(timeSlots);
            }).catch(function (error) {
                onError(error);
            });
        }
    }, {
        key: 'allAvailable',
        value: function allAvailable(doctorId, officeId, date, onSuccess, onError) {
            this.collection.where('doctorId', '==', doctorId).where('officeId', '==', officeId).where('date', '==', date).get().then(function (querySnapshot) {
                var timeSlots = {};

                querySnapshot.forEach(function (doc) {
                    timeSlots[doc.id] = doc.data();
                });

                onSuccess(timeSlots);
            }).catch(function (error) {
                onError(error);
            });
        }
    }, {
        key: 'allFutureAvailable',
        value: function allFutureAvailable(doctorId, officeId, onSuccess, onError) {
            this.collection.where('doctorId', '==', doctorId).where('officeId', '==', officeId).where('appointmentId', '==', null).where('appointmentInvitationId', '==', null).where('date', '>=', __WEBPACK_IMPORTED_MODULE_15_moment___default()().format('YYYY-MM-DD')) // TODO add an index
            .where('date', '<=', __WEBPACK_IMPORTED_MODULE_15_moment___default()().add(4, 'days').format('YYYY-MM-DD')).get().then(function (querySnapshot) {
                var timeSlots = {};

                querySnapshot.forEach(function (doc) {
                    timeSlots[doc.id] = doc.data();
                });

                onSuccess(timeSlots);
            }).catch(function (error) {
                console.error(error);
                onError(error);
            });
        }
    }, {
        key: 'allForPatient',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(type, onSuccess, onError) {
                var currentTime, uncertifiedOfficesIds;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                currentTime = Math.floor((__WEBPACK_IMPORTED_MODULE_15_moment___default()().hour() * 60 + __WEBPACK_IMPORTED_MODULE_15_moment___default()().minute()) / 15);
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_13__OfficeRepository__["a" /* default */].uncertifiedIds();

                            case 3:
                                uncertifiedOfficesIds = _context.sent;


                                this.collection.where('type', '==', type).where('appointmentId', '==', null).where('appointmentInvitationId', '==', null).where('date', '>=', __WEBPACK_IMPORTED_MODULE_15_moment___default()().format('YYYY-MM-DD')).where('date', '<=', __WEBPACK_IMPORTED_MODULE_15_moment___default()().add(8, 'days').format('YYYY-MM-DD')).get().then(function (querySnapshot) {
                                    var timeSlots = {};

                                    querySnapshot.forEach(function (doc) {
                                        var timeslot = doc.data();

                                        // Don't add timeslots of uncertified offices
                                        if (uncertifiedOfficesIds.includes(timeslot.officeId)) {
                                            return;
                                        }

                                        // Only get timeslots for other days or later this day
                                        if (timeslot.date >= __WEBPACK_IMPORTED_MODULE_15_moment___default()().format('YYYY-MM-DD')) {
                                            if (!(timeslot.time <= currentTime && timeslot.date == __WEBPACK_IMPORTED_MODULE_15_moment___default()().format('YYYY-MM-DD'))) {
                                                timeSlots[doc.id] = timeslot;
                                            }
                                        }
                                    });

                                    onSuccess(timeSlots);
                                }).catch(function (error) {
                                    onError(error);
                                });

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function allForPatient(_x, _x2, _x3) {
                return _ref.apply(this, arguments);
            }

            return allForPatient;
        }()
    }, {
        key: 'allForOffice',
        value: function allForOffice(officeId, onSuccess, onError) {
            var currentTime = Math.floor((__WEBPACK_IMPORTED_MODULE_15_moment___default()().hour() * 60 + __WEBPACK_IMPORTED_MODULE_15_moment___default()().minute()) / 15);

            this.collection.where('officeId', '==', officeId).where('appointmentId', '==', null).where('appointmentInvitationId', '==', null).where('date', '>=', __WEBPACK_IMPORTED_MODULE_15_moment___default()().format('YYYY-MM-DD')).where('date', '<=', __WEBPACK_IMPORTED_MODULE_15_moment___default()().add(4, 'days').format('YYYY-MM-DD')).get().then(function (querySnapshot) {
                var timeSlots = {};

                querySnapshot.forEach(function (doc) {
                    var timeslot = doc.data();

                    // Only get timeslots for other days or later this day
                    if (timeslot.date != __WEBPACK_IMPORTED_MODULE_15_moment___default()().format('YYYY-MM-DD') || timeslot.time >= currentTime) {
                        timeSlots[doc.id] = timeslot;
                    }
                });

                onSuccess(timeSlots);
            }).catch(function (error) {
                onError(error);
            });
        }
    }, {
        key: 'bookForPatient',
        value: function bookForPatient(patient, timeslot, onSuccess, onError) {
            var symptoms = timeslot.symptoms;
            this.find(timeslot.id, function (timeslot) {
                if (timeslot.appointmentId || timeslot.appointmentInvitationId) {
                    onError({ message: "Timeslot was booked by someone else" });
                    return false;
                }

                var batch = __WEBPACK_IMPORTED_MODULE_7__firebase__["c" /* db */].batch();
                var newAppointment = __WEBPACK_IMPORTED_MODULE_7__firebase__["c" /* db */].collection('appointments').doc();

                var appointment = {
                    id: newAppointment.id,
                    appointmentInvitationId: null,
                    emergencyType: timeslot.type,
                    patientId: patient.id,
                    patientFirstName: patient.firstName,
                    patientLastName: patient.lastName,
                    patientAge: parseInt(patient.age),
                    patientEmail: patient.email,
                    patientPhone: patient.phone,
                    timeSlotId: timeslot.id,
                    date: timeslot.date,
                    time: timeslot.time,
                    doctorId: timeslot.doctorId,
                    doctorFirstName: timeslot.doctorFirstName,
                    doctorLastName: timeslot.doctorLastName,
                    doctorAvatar: timeslot.doctorAvatar,
                    isDoctorRegulated: timeslot.isDoctorRegulated,
                    officeId: timeslot.officeId,
                    officeName: timeslot.officeName,
                    officeStreetName: timeslot.officeStreetName,
                    officeStreetNumber: timeslot.officeStreetNumber,
                    officeZipCode: timeslot.officeZipCode,
                    officeLocality: timeslot.officeLocality,
                    officeCountry: timeslot.officeCountry,
                    officeLocation: timeslot.officeLocation,
                    officePhone: timeslot.officePhone,
                    symptoms: symptoms
                };

                batch.set(newAppointment, appointment).update(__WEBPACK_IMPORTED_MODULE_7__firebase__["c" /* db */].collection('timeSlots').doc(timeslot.id), {
                    appointmentId: appointment.id
                }).commit().then(function () {
                    if (__WEBPACK_IMPORTED_MODULE_9__store__["a" /* store */].state.patient.email === null) {
                        __WEBPACK_IMPORTED_MODULE_14__PatientRepository__["a" /* default */].update({
                            id: patient.id,
                            email: __WEBPACK_IMPORTED_MODULE_11__mixins_helpers__["a" /* default */].methods.hashPatientInfo(patient.email)
                        }, onSuccess, onError);
                    } else {
                        onSuccess();
                    }
                }).catch(onError);
            }, onError);
        }
    }, {
        key: 'find',
        value: function find(id, onSuccess, onError) {
            this.collection.doc(id).get().then(function (doc) {
                if (doc.exists) {
                    onSuccess(doc.data());
                } else {
                    onError({ error: "Timeslot was not found" });
                }
            }).catch(function (error) {
                onError(error);
            });
        }

        // Attach listeners to Firebase

    }, {
        key: 'attachFirebaseListeners',
        value: function attachFirebaseListeners() {
            var _this3 = this;

            this.collection.onSnapshot(function (querySnapshot) {
                for (var key in querySnapshot.docChanges()) {
                    var docChange = querySnapshot.docChanges()[key];
                    var type = docChange.type;
                    var doc = docChange.doc;

                    _this3.onChanged(type, doc);
                }
            });
        }

        // Detach listeners to Firebase

    }, {
        key: 'detachFirebaseListeners',
        value: function detachFirebaseListeners() {
            this.collection.onSnapshot(function () {});
        }
    }, {
        key: 'onChanged',
        value: function onChanged(type, doc) {
            this.emit(type, doc.id, doc.exists ? doc.data() : null);
        }
    }]);

    return TimeSlotRepository;
}(__WEBPACK_IMPORTED_MODULE_8_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new TimeSlotRepository());

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(3);









// Extend EventEmitter so user of AdminRepository can react to our own defined events. (ex: doctorRepository.on('added'))

var PatientRepository = function (_EventEmitter) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PatientRepository, _EventEmitter);

    function PatientRepository() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PatientRepository);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PatientRepository.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(PatientRepository)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PatientRepository, [{
        key: 'find',
        value: function find(userId, onSuccess, onError) {
            __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('patients').doc(userId).get().then(function (doc) {
                if (doc.exists) {
                    onSuccess(doc.data());
                } else {
                    onError();
                }
            });
        }
    }, {
        key: 'all',
        value: function all(onSuccess, onError) {
            __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('patients').get().then(function (querySnapshot) {
                var patients = querySnapshot.docs.map(function (doc) {
                    return doc.data();
                });

                onSuccess(patients);
            }).catch(function (error) {
                onError(error);
            });
        }
    }, {
        key: 'create',
        value: function create(user, onSuccess, onError) {
            var patient = {
                id: user.uid,
                name: user.displayName,
                email: user.email,
                language: __WEBPACK_IMPORTED_MODULE_7__store__["a" /* store */].state.frontLanguage ? __WEBPACK_IMPORTED_MODULE_7__store__["a" /* store */].state.frontLanguage : 'en',
                registrationDate: new Date(),
                notificationTokens: []
            };

            __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('patients').doc(user.uid).set(patient).then(function () {
                onSuccess(patient);
            }).catch(onError);
        }
    }, {
        key: 'createOrUpdate',
        value: function createOrUpdate(firebaseUser, onSuccess, onError) {
            var _this2 = this;

            this.find(firebaseUser.uid, function () {
                // Patient exists
                var patient = {
                    id: firebaseUser.uid,
                    name: firebaseUser.displayName
                    // email: firebaseUser.email
                };
                _this2.update(patient, function () {
                    _this2.find(firebaseUser.uid, onSuccess, onError);
                }, onError);
            }, function () {
                // Patient does not exist
                _this2.create(firebaseUser, onSuccess, onError);
            });
        }
    }, {
        key: 'update',
        value: function update(patient, onSuccess, onError) {
            __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('patients').doc(patient.id).update(patient).then(onSuccess).catch(onError);
        }
    }]);

    return PatientRepository;
}(__WEBPACK_IMPORTED_MODULE_6_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new PatientRepository());

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerAvatar_vue__ = __webpack_require__(332);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dcc607e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerAvatar_vue__ = __webpack_require__(591);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(589)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerAvatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1dcc607e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerAvatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/PartnerAvatar.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1dcc607e", Component.options)
  } else {
    hotAPI.reload("data-v-1dcc607e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n__ = __webpack_require__(90);











var AppointmentInvitationRepository = function (_EventEmitter) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AppointmentInvitationRepository, _EventEmitter);

    function AppointmentInvitationRepository() {
        var _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AppointmentInvitationRepository);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AppointmentInvitationRepository.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AppointmentInvitationRepository)).call(this));

        _this.collection = __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('appointmentInvitations');

        return _ret = _this, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AppointmentInvitationRepository, [{
        key: 'find',
        value: function find(id, onSuccess, onError) {
            this.collection.doc(id).get().then(function (doc) {
                if (doc.exists) {
                    onSuccess(doc.data());
                } else {
                    onError({ message: __WEBPACK_IMPORTED_MODULE_9__i18n__["a" /* default */].t('Errors.appointment_invitation_could_not_be_loaded') });
                }
            }).catch(onError);
        }
    }, {
        key: 'allForPatient',
        value: function allForPatient(patientId, onSuccess, onError) {
            var currentTime = Math.floor((__WEBPACK_IMPORTED_MODULE_8_moment___default()().hour() * 60 + __WEBPACK_IMPORTED_MODULE_8_moment___default()().minute()) / 15);

            this.collection.where('patientId', '==', patientId).where('date', '>=', __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD')).where('appointmentId', '==', null).where('hasBeenAutoCancelled', '==', false).where('hasBeenCancelled', '==', false).where('hasBeenDeclined', '==', false).get().then(function (querySnapshot) {
                var invitations = {};

                querySnapshot.forEach(function (doc) {
                    var invitation = doc.data();

                    // Only get appointments for other days or later this day
                    if (invitation.date != __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD') || invitation.time >= currentTime) {
                        invitations[doc.id] = invitation;
                    }
                });

                onSuccess(invitations);
            }).catch(onError);
        }
    }, {
        key: 'declineByPatient',
        value: function declineByPatient(invitation, onSuccess, onError) {
            this.find(invitation.id, function (invitation) {
                if (invitation.appointmentId) {
                    onError({ message: __WEBPACK_IMPORTED_MODULE_9__i18n__["a" /* default */].t('Errors.appointment_invitation_already_accepted') });
                    return false;
                }

                if (invitation.hasBeenCancelled || invitation.hasBeenAutoCancelled) {
                    onError({ message: __WEBPACK_IMPORTED_MODULE_9__i18n__["a" /* default */].t('Errors.appointment_invitation_cancelled') });
                    return false;
                }

                if (invitation.hasBeenDeclined) {
                    onError({ message: __WEBPACK_IMPORTED_MODULE_9__i18n__["a" /* default */].t('Errors.appointment_invitation_declined') });
                    return false;
                }

                __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('appointmentInvitations').doc(invitation.id).update({
                    hasBeenDeclined: true
                }).then(onSuccess());
            }, onError);
        }
    }, {
        key: 'acceptByPatient',
        value: function acceptByPatient(invitation, onSuccess, onError) {
            this.find(invitation.id, function (invitation) {
                if (invitation.appointmentId) {
                    onError({ message: __WEBPACK_IMPORTED_MODULE_9__i18n__["a" /* default */].t('Errors.appointment_invitation_already_accepted') });
                    return false;
                }

                if (invitation.hasBeenCancelled || invitation.hasBeenAutoCancelled) {
                    onError({ message: __WEBPACK_IMPORTED_MODULE_9__i18n__["a" /* default */].t('Errors.appointment_invitation_cancelled') });
                    return false;
                }

                if (invitation.hasBeenDeclined) {
                    onError({ message: __WEBPACK_IMPORTED_MODULE_9__i18n__["a" /* default */].t('Errors.appointment_invitation_declined') });
                    return false;
                }

                var batch = __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].batch();
                var newAppointment = __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('appointments').doc();

                var appointment = {
                    appointmentInvitationId: invitation.id,
                    id: newAppointment.id,
                    emergencyId: invitation.emergencyId,
                    emergencyType: invitation.emergencyType,
                    emergencyPictures: invitation.emergencyPictures,
                    patientId: invitation.patientId,
                    patientFirstName: invitation.patientFirstName,
                    patientLastName: invitation.patientLastName,
                    patientAge: invitation.patientAge,
                    patientEmail: invitation.patientEmail,
                    patientPhone: invitation.patientPhone,
                    timeSlotId: invitation.timeSlotId,
                    date: invitation.date,
                    time: invitation.time,
                    doctorId: invitation.doctorId,
                    doctorFirstName: invitation.doctorFirstName,
                    doctorLastName: invitation.doctorLastName,
                    doctorAvatar: invitation.doctorAvatar,
                    isDoctorRegulated: invitation.isDoctorRegulated,
                    officeId: invitation.officeId,
                    officeName: invitation.officeName,
                    officePhone: invitation.officePhone,
                    officeStreetName: invitation.officeStreetName,
                    officeStreetNumber: invitation.officeStreetNumber,
                    officeZipCode: invitation.officeZipCode,
                    officeLocality: invitation.officeLocality,
                    officeCountry: invitation.officeCountry,
                    officeLocation: invitation.officeLocation
                };

                batch
                // 1. Create Appointment
                .set(newAppointment, appointment)
                // 2. Update Emergency (set a reference to the Appointment and AppointmentInvitation)
                .update(__WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('emergencies').doc(invitation.emergencyId), {
                    appointmentId: appointment.id,
                    appointmentInvitationId: invitation.id
                })
                // 3. Update TimeSlot (set a reference to the Appointment and remove reference to AppointmentInvitation)
                .update(__WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('timeSlots').doc(invitation.timeSlotId), {
                    appointmentId: appointment.id
                })
                // 4. Update AppointmentInvitation (set a reference to the Appointment)
                .update(__WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('appointmentInvitations').doc(invitation.id), {
                    appointmentId: appointment.id
                }).commit().then(onSuccess(appointment.id));
            }, onError);
        }
    }, {
        key: 'allForOfficeDate',
        value: function allForOfficeDate(doctorId, officeId, date, onSuccess, onError) {
            this.collection.where('doctorId', '==', doctorId).where('officeId', '==', officeId).where('date', '==', date).get().then(function (querySnapshot) {
                var appointmentInvitations = {};

                querySnapshot.forEach(function (doc) {
                    appointmentInvitations[doc.id] = doc.data();
                });

                onSuccess(appointmentInvitations);
            }).catch(onError);
        }
    }, {
        key: 'cancel',
        value: function cancel(appointmentInvitation, onSuccess, onError) {
            var batch = __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].batch();

            var appointmentInvitationRef = this.collection.doc(appointmentInvitation.id);
            var emergencyRef = __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('emergencies').doc(appointmentInvitation.emergencyId);
            var timeSlotRef = __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('timeSlots').doc(appointmentInvitation.timeSlotId);

            var emergency;
            var timeSlot;

            appointmentInvitationRef.get().then(function (doc) {
                appointmentInvitation = doc.data();

                appointmentInvitation.hasBeenCancelled = true;

                emergencyRef.get().then(function (doc) {
                    emergency = doc.data();

                    emergency.appointmentInvitationId = null;

                    timeSlotRef.get().then(function (doc) {
                        timeSlot = doc.data();

                        timeSlot.appointmentInvitationId = null;

                        batch.set(appointmentInvitationRef, appointmentInvitation);
                        batch.set(emergencyRef, emergency);
                        batch.set(timeSlotRef, timeSlot);

                        batch.commit().then(onSuccess).catch(onError);
                    }).catch(onError);
                }).catch(onError);
            }).catch(onError);
        }
    }, {
        key: 'accept',
        value: function accept(emergency, availability, doctor, office, onSuccess, onError) {
            var batch = __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].batch();

            var appointmentInvitationRef = this.collection.doc();

            // Create the appointmentInvitationRef
            batch.set(appointmentInvitationRef, {
                appointmentId: null,
                id: appointmentInvitationRef.id,
                dateTimeCreated: new Date(),
                hasBeenDeclined: false,
                hasBeenCancelled: false,
                hasBeenAutoCancelled: false,
                timeSlotId: availability.id,
                time: availability.time,
                date: availability.date,
                doctorId: doctor.id,
                doctorFirstName: doctor.firstName,
                doctorLastName: doctor.lastName,
                doctorAvatar: doctor.avatar,
                isDoctorRegulated: doctor.isRegulated,
                officeId: office.id,
                officeName: office.name,
                officeStreetName: office.streetName,
                officeStreetNumber: office.streetNumber,
                officeZipCode: office.zipCode,
                officeLocality: office.locality,
                officeCountry: office.countryId,
                officeLocation: office.location,
                officePhone: office.phone,
                emergencyId: emergency.id,
                emergencyType: emergency.type,
                emergencyPictures: emergency.pictures,
                patientId: emergency.patientId,
                patientAge: emergency.patientAge,
                patientFirstName: emergency.patientFirstName,
                patientLastName: emergency.patientLastName,
                patientEmail: emergency.patientEmail,
                patientPhone: emergency.patientPhone
            });

            batch.update(__WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('emergencies').doc(emergency.id), {
                appointmentInvitationId: appointmentInvitationRef.id
            });

            batch.update(__WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('timeSlots').doc(availability.id), {
                appointmentInvitationId: appointmentInvitationRef.id
            });

            batch.commit().then(onSuccess).catch(onError);
        }
    }]);

    return AppointmentInvitationRepository;
}(__WEBPACK_IMPORTED_MODULE_6_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new AppointmentInvitationRepository());

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_events__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_firebase_app__);














// Extend EventEmitter so user of DoctorRepository can react to our own defined events. (ex: doctorRepository.on('added'))

var DoctorRepository = function (_EventEmitter) {
    __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(DoctorRepository, _EventEmitter);

    function DoctorRepository() {
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, DoctorRepository);

        return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DoctorRepository.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(DoctorRepository)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(DoctorRepository, [{
        key: 'setKey',
        value: function setKey(key) {
            if (this.key) return this;

            this.key = key;
            this.doc = __WEBPACK_IMPORTED_MODULE_9__firebase__["c" /* db */].collection('doctors').doc(this.key);

            this.subscribe();

            return this;
        }
    }, {
        key: 'uncertifiedIds',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
                var results, querySnapshot;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                results = [];
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_9__firebase__["c" /* db */].collection('doctors').where('isCertified', '==', false).get();

                            case 3:
                                querySnapshot = _context.sent;


                                querySnapshot.forEach(function (doc) {
                                    results.push(doc.id);
                                });

                                return _context.abrupt('return', results);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function uncertifiedIds() {
                return _ref.apply(this, arguments);
            }

            return uncertifiedIds;
        }()
    }, {
        key: 'all',
        value: function all(onSuccess, onError) {
            __WEBPACK_IMPORTED_MODULE_9__firebase__["c" /* db */].collection('doctors').get().then(function (querySnapshot) {
                var doctors = [];

                querySnapshot.forEach(function (doc) {
                    var doctor = doc.data();
                    doctor.offices = {};

                    __WEBPACK_IMPORTED_MODULE_9__firebase__["c" /* db */].collection('offices').where('doctorId', '==', doc.id).get().then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            doctor.offices[doc.id] = doc.data();
                        });

                        doctors.push(doctor);
                    });
                });

                onSuccess(doctors);
            }).catch(function (error) {
                onError(error);
            });
        }
    }, {
        key: 'allWithoutOffices',
        value: function allWithoutOffices(onSuccess, onError) {
            __WEBPACK_IMPORTED_MODULE_9__firebase__["c" /* db */].collection('doctors').get().then(function (querySnapshot) {
                var doctors = [];

                querySnapshot.forEach(function (doc) {
                    doctors.push(doc.data());
                });

                onSuccess(doctors);
            }).catch(function (error) {
                onError(error);
            });
        }
    }, {
        key: 'onlyCertified',
        value: function onlyCertified(isCertified, onSuccess, onError) {
            __WEBPACK_IMPORTED_MODULE_9__firebase__["c" /* db */].collection('doctors').where('isCertified', '==', isCertified == 1 || isCertified == '1' ? true : false).get().then(function (querySnapshot) {
                var doctors = [];

                querySnapshot.forEach(function (doc) {
                    var doctor = doc.data();
                    doctor.offices = {};

                    __WEBPACK_IMPORTED_MODULE_9__firebase__["c" /* db */].collection('offices').where('doctorId', '==', doc.id).get().then(function (querySnapshot) {
                        querySnapshot.forEach(function (doc) {
                            doctor.offices[doc.id] = doc.data();
                        });

                        doctors.push(doctor);
                    });
                });

                onSuccess(doctors);
            }).catch(function (error) {
                onError(error);
            });
        }

        // Retrieve a doctor

    }, {
        key: 'find',
        value: function () {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2(id) {
                var snapshot;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.setKey(id).doc.get();

                            case 2:
                                snapshot = _context2.sent;

                                if (!snapshot.exists) {
                                    _context2.next = 5;
                                    break;
                                }

                                return _context2.abrupt('return', snapshot.data());

                            case 5:
                                return _context2.abrupt('return', null);

                            case 6:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function find(_x) {
                return _ref2.apply(this, arguments);
            }

            return find;
        }()

        // Retrieve all uncertified doctors IDs

    }, {
        key: 'getUncertifiedIds',
        value: function () {
            var _ref3 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var querySnapshot, ids;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_9__firebase__["c" /* db */].collection('doctors').where('isCertified', '==', false).get();

                            case 2:
                                querySnapshot = _context3.sent;
                                ids = [];


                                querySnapshot.forEach(function (doc) {
                                    return ids.push(doc.id);
                                });

                                return _context3.abrupt('return', ids);

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function getUncertifiedIds() {
                return _ref3.apply(this, arguments);
            }

            return getUncertifiedIds;
        }()

        // Check if a Doctor exists

    }, {
        key: 'load',
        value: function load(userId, onSuccess, onError) {
            this.setKey(userId).doc.get().then(function (snapshot) {
                if (snapshot.exists) {
                    onSuccess(snapshot.data());
                } else {
                    onError();
                }
            });
        }

        // Update a Doctor

    }, {
        key: 'update',
        value: function () {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4(id, data, onComplete, onError) {
                var batch, doctorRef, officeData;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                batch = __WEBPACK_IMPORTED_MODULE_9__firebase__["c" /* db */].batch();
                                doctorRef = __WEBPACK_IMPORTED_MODULE_9__firebase__["c" /* db */].collection('doctors').doc(id);

                                batch.update(doctorRef, data);

                                officeData = {};


                                if (data.hasOwnProperty('firstName')) {
                                    officeData['doctorFirstName'] = data.firstName;
                                }
                                if (data.hasOwnProperty('lastName')) {
                                    officeData['doctorLastName'] = data.lastName;
                                }
                                if (data.hasOwnProperty('type')) {
                                    officeData['doctorType'] = data.type;
                                }
                                if (data.hasOwnProperty('avatar')) {
                                    officeData['doctorAvatar'] = data.avatar;
                                }
                                if (data.hasOwnProperty('isRegulated')) {
                                    officeData['isDoctorRegulated'] = data.isRegulated;
                                }

                                if (!(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(officeData).length > 0)) {
                                    _context4.next = 12;
                                    break;
                                }

                                _context4.next = 12;
                                return __WEBPACK_IMPORTED_MODULE_9__firebase__["c" /* db */].collection('offices').where('doctorId', '==', id).get().then(function (querySnapshot) {
                                    querySnapshot.forEach(function (doc) {
                                        var office = doc.data();
                                        var ref = __WEBPACK_IMPORTED_MODULE_9__firebase__["c" /* db */].collection('offices').doc(office.id);

                                        var newData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, office, officeData);

                                        if (!newData.schedule) {
                                            newData['schedule'] = [];
                                        }

                                        batch.update(ref, newData);
                                    });
                                }).catch(onError);

                            case 12:

                                batch.commit().then(onComplete).catch(onError);

                            case 13:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function update(_x2, _x3, _x4, _x5) {
                return _ref4.apply(this, arguments);
            }

            return update;
        }()

        // Remove a Doctor

    }, {
        key: 'remove',
        value: function remove(onComplete) {
            this.doc.remove(onComplete);
        }

        // Check if a Doctor exists

    }, {
        key: 'exists',
        value: function exists(onSuccess, onError) {
            this.doc.get().then(function (snapshot) {
                if (snapshot.exists) {
                    onSuccess(snapshot.data());
                } else {
                    onError();
                }
            });
        }

        // Attach listeners to Firebase

    }, {
        key: 'subscribe',
        value: function subscribe() {
            var _this2 = this;

            this.doc.onSnapshot(function (doc) {
                _this2.onChanged(doc);
            });
        }

        // Detach listeners to Firebase

    }, {
        key: 'unsubscribe',
        value: function unsubscribe() {
            console.log('unsubscribed DoctorRepository');
            this.doc.onSnapshot(function () {});
        }
    }, {
        key: 'onChanged',
        value: function onChanged(snapshot) {
            this.emit('changed', snapshot.id, snapshot.exists ? snapshot.data() : null);
        }
    }]);

    return DoctorRepository;
}(__WEBPACK_IMPORTED_MODULE_10_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new DoctorRepository());

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OfficeSettings_vue__ = __webpack_require__(330);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f055ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OfficeSettings_vue__ = __webpack_require__(586);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(584)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-25f055ce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OfficeSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25f055ce_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OfficeSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/OfficeSettings.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-25f055ce", Component.options)
  } else {
    hotAPI.reload("data-v-25f055ce", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);










var AppointmentRepository = function (_EventEmitter) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AppointmentRepository, _EventEmitter);

    function AppointmentRepository() {
        var _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AppointmentRepository);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AppointmentRepository.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AppointmentRepository)).call(this));

        _this.collection = __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('appointments');

        return _ret = _this, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AppointmentRepository, [{
        key: 'find',
        value: function find(id, onSuccess, onError) {
            this.collection.doc(id).get().then(function (doc) {
                if (doc.exists) {
                    onSuccess(doc.data());
                } else {
                    onError({ message: "Appointment was not found" });
                }
            }).catch(onError);
        }
    }, {
        key: 'allForOfficeDate',
        value: function allForOfficeDate(doctorId, officeId, date, onSuccess, onError) {
            this.collection.where('doctorId', '==', doctorId).where('officeId', '==', officeId).where('date', '==', date).get().then(function (querySnapshot) {
                var appointments = {};

                querySnapshot.forEach(function (doc) {
                    appointments[doc.id] = doc.data();
                });

                onSuccess(appointments);
            }).catch(onError);
        }
    }, {
        key: 'allForPatient',
        value: function allForPatient(patientId, onSuccess, onError) {
            var currentTime = Math.floor((__WEBPACK_IMPORTED_MODULE_8_moment___default()().hour() * 60 + __WEBPACK_IMPORTED_MODULE_8_moment___default()().minute()) / 15);

            this.collection.where('patientId', '==', patientId).where('date', '>=', __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD')).get().then(function (querySnapshot) {
                var appointments = {};

                querySnapshot.forEach(function (doc) {
                    var appointment = doc.data();

                    // Only get appointments for other days or later this day
                    appointments[doc.id] = appointment;
                    // if (appointment.time >= currentTime) {
                    // }
                });

                onSuccess(appointments);
            }).catch(onError);
        }
    }]);

    return AppointmentRepository;
}(__WEBPACK_IMPORTED_MODULE_6_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new AppointmentRepository());

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_events__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_events__);












var OfficeRepository = function (_EventEmitter) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(OfficeRepository, _EventEmitter);

    function OfficeRepository() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, OfficeRepository);

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OfficeRepository.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(OfficeRepository)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(OfficeRepository, [{
        key: 'uncertifiedIds',
        value: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var results, querySnapshot;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                results = [];
                                _context.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_8__firebase__["c" /* db */].collection('offices').where('isDoctorCertified', '==', false).get();

                            case 3:
                                querySnapshot = _context.sent;


                                querySnapshot.forEach(function (doc) {
                                    results.push(doc.id);
                                });

                                return _context.abrupt('return', results);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function uncertifiedIds() {
                return _ref.apply(this, arguments);
            }

            return uncertifiedIds;
        }()
    }, {
        key: 'allNearby',
        value: function allNearby(position, type, onSuccess, onError) {
            __WEBPACK_IMPORTED_MODULE_8__firebase__["c" /* db */].collection('offices').where('doctorType', '==', type).where('isDoctorCertified', '==', true).get().then(function (querySnapshot) {
                var offices = {};
                var distance = void 0;

                querySnapshot.forEach(function (doc) {
                    var data = doc.data();

                    if (data.location) {
                        // Only offices in a 30km radius
                        distance = window.distanceBetween(data.location._lat, data.location._long, position._lat, position._long);
                        if (distance <= 30) {
                            data['distance'] = distance;
                            offices[doc.id] = data;
                        }
                    }
                });

                onSuccess(offices);
            }).catch(function (error) {
                onError(error);
            });
        }
    }, {
        key: 'find',
        value: function find(id, onSuccess, onError) {
            __WEBPACK_IMPORTED_MODULE_8__firebase__["c" /* db */].collection('offices').doc(id).get().then(function (doc) {
                if (doc.exists) {
                    onSuccess(doc.data());
                } else {
                    onError({ error: "Office was not found" });
                }
            }).catch(function (error) {
                onError(error);
            });
        }
    }, {
        key: 'getAll',
        value: function getAll(onSuccess, onError) {
            __WEBPACK_IMPORTED_MODULE_8__firebase__["c" /* db */].collection('offices').get().then(function (querySnapshot) {
                var data = [];
                querySnapshot.forEach(function (doc) {
                    data.push(doc.data());
                });
                onSuccess(data);
            }).catch(function (error) {
                onError(error);
            });
        }
    }]);

    return OfficeRepository;
}(__WEBPACK_IMPORTED_MODULE_10_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new OfficeRepository());

/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_events__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_events__);










// Extend EventEmitter so user of DoctorRepository can react to our own defined events. (ex: doctorRepository.on('added'))

var DoctorOfficeRepository = function (_EventEmitter) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DoctorOfficeRepository, _EventEmitter);

    function DoctorOfficeRepository() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DoctorOfficeRepository);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DoctorOfficeRepository.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DoctorOfficeRepository)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DoctorOfficeRepository, [{
        key: 'load',

        // Check if a Doctor exists
        value: function load(userId, onSuccess, onError) {
            __WEBPACK_IMPORTED_MODULE_6__firebase__["c" /* db */].collection('offices').where('doctorId', '==', userId).get().then(function (querySnapshot) {
                var offices = {};

                querySnapshot.forEach(function (doc) {
                    offices[doc.id] = doc.data();
                });

                onSuccess(offices);
            }).catch(function (error) {
                onError(error);
            });
        }

        // Create an Office

    }, {
        key: 'create',
        value: function create(doctor, _ref, onComplete, onError) {
            var _ref$name = _ref.name,
                name = _ref$name === undefined ? '' : _ref$name,
                _ref$streetName = _ref.streetName,
                streetName = _ref$streetName === undefined ? '' : _ref$streetName,
                _ref$streetNumber = _ref.streetNumber,
                streetNumber = _ref$streetNumber === undefined ? '' : _ref$streetNumber,
                _ref$zipCode = _ref.zipCode,
                zipCode = _ref$zipCode === undefined ? '' : _ref$zipCode,
                _ref$locality = _ref.locality,
                locality = _ref$locality === undefined ? '' : _ref$locality,
                _ref$phone = _ref.phone,
                phone = _ref$phone === undefined ? '' : _ref$phone,
                _ref$countryId = _ref.countryId,
                countryId = _ref$countryId === undefined ? '' : _ref$countryId,
                _ref$location = _ref.location,
                location = _ref$location === undefined ? null : _ref$location,
                _ref$isEmergencyEmail = _ref.isEmergencyEmailAlertEnabled,
                isEmergencyEmailAlertEnabled = _ref$isEmergencyEmail === undefined ? false : _ref$isEmergencyEmail;

            var _this2 = this;

            var newDoc = __WEBPACK_IMPORTED_MODULE_6__firebase__["c" /* db */].collection('offices').doc();

            var office = {
                id: newDoc.id,
                name: name,
                streetName: streetName,
                streetNumber: streetNumber,
                zipCode: zipCode,
                locality: locality,
                phone: phone,
                countryId: countryId,
                location: location,
                isEmergencyEmailAlertEnabled: isEmergencyEmailAlertEnabled,
                doctorId: doctor.id,
                doctorFirstName: doctor.firstName,
                doctorLastName: doctor.lastName,
                doctorType: doctor.type,
                doctorAvatar: doctor.avatar,
                isDoctorRegulated: doctor.isRegulated
            };

            if (location == null) {
                office.location = new __WEBPACK_IMPORTED_MODULE_5_firebase_app___default.a.firestore.GeoPoint(51.501527, process.DEFAULT_LNG);
            }

            __WEBPACK_IMPORTED_MODULE_6__firebase__["c" /* db */].collection('offices').doc(office.id).set(office).then(function () {
                _this2.load(doctor.id, function (offices) {
                    __WEBPACK_IMPORTED_MODULE_7__store__["a" /* store */].dispatch('setOffices', offices);

                    onComplete(office.id);
                });
            }).catch(onError);
        }

        // Update an Office

    }, {
        key: 'update',
        value: function update(doctorId, officeId, data, onComplete, onError) {
            var _this3 = this;

            if (data.location == null) {
                data.location = new __WEBPACK_IMPORTED_MODULE_5_firebase_app___default.a.firestore.GeoPoint(51.501527, process.DEFAULT_LNG);
            }

            __WEBPACK_IMPORTED_MODULE_6__firebase__["c" /* db */].collection('offices').doc(officeId).update(data).then(function () {
                _this3.load(doctorId, function (offices) {
                    __WEBPACK_IMPORTED_MODULE_7__store__["a" /* store */].dispatch('setOffices', offices);

                    onComplete();
                });
            }).catch(onError);
        }

        // Remove a Doctor

    }, {
        key: 'remove',
        value: function remove(_ref2, onComplete) {
            var key = _ref2.key;

            __WEBPACK_IMPORTED_MODULE_6__firebase__["c" /* db */].collection('offices').doc(key).remove(onComplete);
        }
    }, {
        key: 'onChanged',
        value: function onChanged(type, doc) {
            if (type == 'modified' || type == 'added') {
                __WEBPACK_IMPORTED_MODULE_7__store__["a" /* store */].dispatch('setOffice', doc.data());
            }

            if (type == 'removed') {
                __WEBPACK_IMPORTED_MODULE_7__store__["a" /* store */].dispatch('removeOffice', doc.id);
            }

            this.emit(type, doc.id, doc.exists ? doc.data() : null);
        }
    }]);

    return DoctorOfficeRepository;
}(__WEBPACK_IMPORTED_MODULE_8_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new DoctorOfficeRepository());
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(81)))

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(602);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
    locale: 'en',
    fallbackLocale: 'en',
    messages: {
        'en': __webpack_require__(603),
        'fr_BE': __webpack_require__(604),
        'nl_BE': __webpack_require__(605)
    },
    silentTranslationWarn: true
});

if (false) {
    module.hot.accept(['./en.json', './fr_BE.json', './nl_BE.json'], function () {
        i18n.setLocaleMessage('en', require('./en.json'));
        i18n.setLocaleMessage('fr_BE', require('./fr_BE.json'));
        i18n.setLocaleMessage('nl_BE', require('./nl_BE.json'));
    });
}

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Onboarding_vue__ = __webpack_require__(345);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b23788aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Onboarding_vue__ = __webpack_require__(626);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(624)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Onboarding_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b23788aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Onboarding_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/Onboarding.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b23788aa", Component.options)
  } else {
    hotAPI.reload("data-v-b23788aa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bubble_vue__ = __webpack_require__(355);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc78bb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bubble_vue__ = __webpack_require__(648);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bubble_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fc78bb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bubble_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/Bubble.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0fc78bb4", Component.options)
  } else {
    hotAPI.reload("data-v-0fc78bb4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmergencyModal_vue__ = __webpack_require__(339);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3670ea8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmergencyModal_vue__ = __webpack_require__(614);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmergencyModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3670ea8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmergencyModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/EmergencyModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f3670ea8", Component.options)
  } else {
    hotAPI.reload("data-v-f3670ea8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidebar_vue__ = __webpack_require__(342);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99e870ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__ = __webpack_require__(623);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_99e870ea_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/AppSidebar.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-99e870ea", Component.options)
  } else {
    hotAPI.reload("data-v-99e870ea", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(493)));

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(499)));

/***/ }),
/* 308 */,
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(504)));

/***/ }),
/* 310 */,
/* 311 */,
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__(509)));

/***/ }),
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home_vue__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Doctor_Home_vue__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Doctor_App_vue__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Doctor_Register_vue__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Doctor_Dashboard_vue__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Doctor_Profile_vue__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Doctor_ProfileDetails_vue__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Doctor_ProfileNewOffice_vue__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Doctor_ProfileOffice_vue__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Doctor_Availabilities_vue__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Doctor_Emergencies_vue__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Patient_Search_vue__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Patient_EmergencyNew_vue__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Patient_OfficeShow_vue__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Patient_TimeslotShow_vue__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Patient_PartnerOfficeShow_vue__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Patient_PartnerTimeslotShow_vue__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Patient_AppointmentShow_vue__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Patient_InvitationShow_vue__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__store__ = __webpack_require__(3);



















// import PatientOfficeTimeslotsShow from '@/components/Patient/OfficeTimeslotsShow.vue'









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routesOptions = [{
    path: '*',
    redirect: '/'
}, {
    path: '/',
    // redirect: '/doctor'
    component: __WEBPACK_IMPORTED_MODULE_3__components_Home_vue__["a" /* default */],
    meta: { layout: 'PatientLayout' }
}, {
    path: '/search',
    name: 'search',
    component: __WEBPACK_IMPORTED_MODULE_14__components_Patient_Search_vue__["a" /* default */],
    meta: { layout: 'PatientLayout' }
}, {
    path: '/emergency',
    name: 'emergency.new',
    component: __WEBPACK_IMPORTED_MODULE_15__components_Patient_EmergencyNew_vue__["a" /* default */],
    meta: { layout: 'PatientLayout' }
}, {
    path: '/appointment/:id',
    name: 'appointment.show',
    component: __WEBPACK_IMPORTED_MODULE_20__components_Patient_AppointmentShow_vue__["a" /* default */],
    meta: {
        layout: 'PatientLayout',
        analytics: {
            pageviewTemplate: function pageviewTemplate(route) {
                return {
                    page: 'appointment/:id',
                    title: 'appointment.show'
                };
            }
        }
    }
}, {
    path: '/office/:id',
    name: 'office.show',
    component: __WEBPACK_IMPORTED_MODULE_16__components_Patient_OfficeShow_vue__["a" /* default */],
    meta: {
        layout: 'PatientLayout',
        analytics: {
            pageviewTemplate: function pageviewTemplate(route) {
                return {
                    page: 'office/:id',
                    title: 'office.show'
                };
            }
        }
    }
}, {
    path: '/partner-timeslot',
    name: 'partner-timeslot.show',
    component: __WEBPACK_IMPORTED_MODULE_19__components_Patient_PartnerTimeslotShow_vue__["a" /* default */],
    meta: {
        layout: 'PatientLayout',
        analytics: {
            pageviewTemplate: function pageviewTemplate(route) {
                return {
                    page: 'partner-timeslot',
                    title: 'partner-timeslot.show'
                };
            }
        }
    }
}, {
    path: '/partner-office',
    name: 'partner-office.show',
    component: __WEBPACK_IMPORTED_MODULE_18__components_Patient_PartnerOfficeShow_vue__["a" /* default */],
    meta: {
        layout: 'PatientLayout',
        analytics: {
            pageviewTemplate: function pageviewTemplate(route) {
                return {
                    page: 'partner-office',
                    title: 'partner-office.show'
                };
            }
        }
    }
}, {
    path: '/timeslot/:id',
    name: 'timeslot.show',
    component: __WEBPACK_IMPORTED_MODULE_17__components_Patient_TimeslotShow_vue__["a" /* default */],
    meta: {
        layout: 'PatientLayout',
        analytics: {
            pageviewTemplate: function pageviewTemplate(route) {
                return {
                    page: 'timeslot/:id',
                    title: 'timeslot.show'
                };
            }
        }
    }
}, {
    path: '/invitation/:id',
    name: 'invitation.show',
    component: __WEBPACK_IMPORTED_MODULE_21__components_Patient_InvitationShow_vue__["a" /* default */],
    meta: {
        layout: 'PatientLayout',
        analytics: {
            pageviewTemplate: function pageviewTemplate(route) {
                return {
                    page: 'invitation/:id',
                    title: 'invitation.show'
                };
            }
        }
    }
}, {
    path: '/doctor/login',
    name: 'doctor.login',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Doctor_Home_vue__["a" /* default */],
    meta: { layout: 'DoctorLayout' }
}, {
    path: '/doctor/register',
    name: 'doctor.register',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Doctor_Register_vue__["a" /* default */],
    meta: { layout: 'DoctorLayout', requiresAuth: true }
}, {
    path: '/doctor',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Doctor_App_vue__["a" /* default */],
    meta: { layout: 'DoctorLayout', requiresAuth: true, doctorAuth: true },
    children: [{
        path: '',
        name: 'doctor.dashboard',
        component: __WEBPACK_IMPORTED_MODULE_7__components_Doctor_Dashboard_vue__["a" /* default */]
    }, {
        path: 'profile',
        component: __WEBPACK_IMPORTED_MODULE_8__components_Doctor_Profile_vue__["a" /* default */],
        children: [{
            path: '',
            name: 'doctor.profile',
            component: __WEBPACK_IMPORTED_MODULE_9__components_Doctor_ProfileDetails_vue__["a" /* default */]
        }, {
            path: 'new-office',
            name: 'doctor.profile.newOffice',
            component: __WEBPACK_IMPORTED_MODULE_10__components_Doctor_ProfileNewOffice_vue__["a" /* default */]
        }, {
            path: 'office/:id',
            name: 'doctor.profile.office',
            component: __WEBPACK_IMPORTED_MODULE_11__components_Doctor_ProfileOffice_vue__["a" /* default */],
            meta: {
                analytics: {
                    pageviewTemplate: function pageviewTemplate(route) {
                        return {
                            page: 'doctor/profile/office/:id',
                            title: 'doctor.profile.office'
                        };
                    }
                }
            }
        }]
    }, {
        path: 'availabilities',
        name: 'doctor.availabilities',
        component: __WEBPACK_IMPORTED_MODULE_12__components_Doctor_Availabilities_vue__["a" /* default */]
    }, {
        path: 'emergencies',
        name: 'doctor.emergencies',
        component: __WEBPACK_IMPORTED_MODULE_13__components_Doctor_Emergencies_vue__["a" /* default */]
    }]
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 };
    },

    linkExactActiveClass: 'is-active',
    routes: routesOptions.map(function (route) {
        return route;
    })
});

router.beforeEach(function (to, from, next) {
    // Reset the body class if necessary
    if (__WEBPACK_IMPORTED_MODULE_22__store__["a" /* store */].state.preventBodyScroll === true) {
        __WEBPACK_IMPORTED_MODULE_22__store__["a" /* store */].commit('setPreventBodyScroll', false);
    }

    var recordWithLayout = to.matched.slice().reverse().find(function (record) {
        return record.meta && record.meta.layout;
    });
    if (__WEBPACK_IMPORTED_MODULE_22__store__["a" /* store */].getters.layout != recordWithLayout.meta.layout) {
        __WEBPACK_IMPORTED_MODULE_22__store__["a" /* store */].commit('SET_LAYOUT', recordWithLayout.meta.layout);
    }

    if (to.matched.some(function (record) {
        return record.meta.requiresAuth;
    })) {
        if (to.matched.some(function (record) {
            return record.meta.doctorAuth;
        })) {
            if (!__WEBPACK_IMPORTED_MODULE_22__store__["a" /* store */].state.userId) {
                // User is not signed in
                // console.log('doctorAuth, no userId -> /doctor/login', to, from)
                next('/doctor/login');
                return;
            }

            if (!__WEBPACK_IMPORTED_MODULE_22__store__["a" /* store */].state.doctor) {
                // User is not a doctor
                // console.log('doctorAuth, userId but not a doctor -> /doctor/register', to, from)
                next('/doctor/register');
                return;
            }
        }

        if (!__WEBPACK_IMPORTED_MODULE_22__store__["a" /* store */].state.userId) {
            // console.log('requiresAuth, no userId -> /', to, from)
            next('/');

            return;
        }
    }

    next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Patient_HeaderNav__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Patient_AppointmentListItem__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Patient_PartnerAppointmentListItem__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Patient_InvitationListItem__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Patient_EmergencyListItem__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_AppointmentRepository__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__data_OfficeRepository__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_AppointmentInvitationRepository__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__data_EmergencyRepository__ = __webpack_require__(31);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Home',

    mixins: [__WEBPACK_IMPORTED_MODULE_6__mixins_helpers__["a" /* default */]],

    components: { HeaderNav: __WEBPACK_IMPORTED_MODULE_8__components_Patient_HeaderNav__["a" /* default */], AppointmentListItem: __WEBPACK_IMPORTED_MODULE_9__components_Patient_AppointmentListItem__["a" /* default */], PartnerAppointmentListItem: __WEBPACK_IMPORTED_MODULE_10__components_Patient_PartnerAppointmentListItem__["a" /* default */], InvitationListItem: __WEBPACK_IMPORTED_MODULE_11__components_Patient_InvitationListItem__["a" /* default */], EmergencyListItem: __WEBPACK_IMPORTED_MODULE_12__components_Patient_EmergencyListItem__["a" /* default */] },

    data: function data() {
        return {
            errorText: null,
            loadingOffices: false,
            loadingAppointments: false,
            loadingPartnerAppointments: false,
            loadingInvitations: false,
            loadingEmergencies: false,
            appointments: [],
            officesData: [],
            invitations: [],
            emergencies: [],
            partnerAppointments: []
        };
    },


    computed: {
        sortedAppointments: function sortedAppointments() {
            var _this = this;

            var appointmentsAndOffices = [];
            var entries = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_entries___default()(this.appointments).forEach(function (_ref) {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                    id = _ref2[0],
                    appointment = _ref2[1];

                _this.officesData && _this.officesData.length > 0 && _this.officesData.forEach(function (office) {
                    if (office.id === appointment.officeId) {
                        appointmentsAndOffices.push(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, office, appointment));
                    }
                });
            });

            return _.sortBy(appointmentsAndOffices, ['date', 'time']);
        },
        sortedPartnerAppointments: function sortedPartnerAppointments() {
            var now = __WEBPACK_IMPORTED_MODULE_7_moment___default()();
            return _.sortBy(this.partnerAppointments.filter(function (appointment) {
                return now.diff(__WEBPACK_IMPORTED_MODULE_7_moment___default()(appointment.dateTime)) < 0;
            }), ['dateTime']);
        },
        sortedInvitations: function sortedInvitations() {
            return _.sortBy(this.invitations, ['date', 'time']);
        },
        sortedEmergencies: function sortedEmergencies() {
            return _.sortBy(this.emergencies, ['date', 'time']);
        }
    },

    mounted: function mounted() {
        var _this2 = this;

        // if (this.userId) {
        //     this.fetchAppointments()
        //     this.fetchPartnerAppointments()
        //     this.fetchInvitations()
        //     this.fetchEmergencies()
        // } else {
        //     this.$router.push("/search")
        // }

        __WEBPACK_IMPORTED_MODULE_5_firebase_app___default.a.auth().onAuthStateChanged(function (user) {
            if (user) {
                _this2.fetchOffices();
                _this2.fetchAppointments();
                _this2.fetchPartnerAppointments();
                _this2.fetchInvitations();
                _this2.fetchEmergencies();
            } else {
                _this2.invitations = [];
                _this2.appointments = [];
                _this2.partnerAppointments = [];
                _this2.emergencies = [];
            }
        });
    },


    methods: {
        fetchOffices: function fetchOffices() {
            var _this3 = this;

            this.loadingOffices = true;
            __WEBPACK_IMPORTED_MODULE_14__data_OfficeRepository__["a" /* default */].getAll(function (offices) {
                _this3.officesData = offices;
                _this3.loadingOffices = false;
            }, function (error) {
                _this3.errorText = _this3.$t('appointments_could_not_be_loaded');
                _this3.loadingOffices = false;
            });
        },
        fetchAppointments: function fetchAppointments() {
            var _this4 = this;

            if (!this.userId) {
                return false;
            }

            this.loadingAppointments = true;

            __WEBPACK_IMPORTED_MODULE_13__data_AppointmentRepository__["a" /* default */].allForPatient(this.userId, function (appointments) {
                _this4.appointments = appointments;

                _this4.loadingAppointments = false;
            }, function (error) {
                _this4.errorText = _this4.$t('appointments_could_not_be_loaded');
                _this4.loadingAppointments = false;
            });
        },
        fetchPartnerAppointments: function fetchPartnerAppointments() {
            var _this5 = this;

            if (!this.userId) {
                return false;
            }

            this.loadingPartnerAppointments = true;

            __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get("https://us-central1-tooddoc-dev.cloudfunctions.net" + '/getPartnerAppointments', {
                params: {
                    userId: this.userId,
                    language: this.patientLanguage.shortCode
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                _this5.partnerAppointments = response.data;

                _this5.loadingPartnerAppointments = false;
            }).catch(function (error) {
                // this.errorText = this.$t('Errors.partner_appointment_invitations_could_not_be_loaded')
                _this5.loadingPartnerAppointments = false;
            });
        },
        fetchInvitations: function fetchInvitations() {
            var _this6 = this;

            if (!this.userId) {
                return false;
            }

            this.loadingInvitations = true;

            __WEBPACK_IMPORTED_MODULE_15__data_AppointmentInvitationRepository__["a" /* default */].allForPatient(this.userId, function (invitations) {
                _this6.invitations = invitations;

                _this6.loadingInvitations = false;
            }, function (error) {
                _this6.errorText = _this6.$t('appointment_invitations_could_not_be_loaded');

                _this6.loadingInvitations = false;
            });
        },
        fetchEmergencies: function fetchEmergencies() {
            var _this7 = this;

            if (!this.userId) {
                return false;
            }

            this.loadingEmergencies = true;

            __WEBPACK_IMPORTED_MODULE_16__data_EmergencyRepository__["a" /* default */].allForPatient(this.userId, function (emergencies) {
                _this7.emergencies = emergencies;

                _this7.loadingEmergencies = false;
            }, function (error) {
                _this7.errorText = _this7.$t('emergencies_could_not_be_loaded');

                _this7.loadingEmergencies = false;
            });
        },
        redirectIfEmpty: function redirectIfEmpty() {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.invitations).length === 0 && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.appointments).length === 0 && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.emergencies).length === 0 && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.partnerAppointments).length === 0) {
                this.$router.push('/search');
            }
        }
    },

    watch: {
        loadingAppointments: function loadingAppointments(newValue, oldValue) {
            // Redirect to search if there is no appointements nor invitations nor emergencies
            if (newValue == false && this.loadingInvitations == false && this.loadingEmergencies == false && this.loadingPartnerAppointments == false) {
                this.redirectIfEmpty();
            }
        },
        loadingInvitations: function loadingInvitations(newValue, oldValue) {
            // Redirect to search if there is no appointements nor invitations nor emergencies
            if (newValue == false && this.loadingAppointments == false && this.loadingEmergencies == false && this.loadingPartnerAppointments == false) {
                this.redirectIfEmpty();
            }
        },
        loadingEmergencies: function loadingEmergencies(newValue, oldValue) {
            // Redirect to search if there is no appointements nor invitations nor emergencies
            if (newValue == false && this.loadingAppointments == false && this.loadingInvitations == false && this.loadingPartnerAppointments == false) {
                this.redirectIfEmpty();
            }
        },
        loadingPartnerAppointments: function loadingPartnerAppointments(newValue, oldValue) {
            // Redirect to search if there is no appointements nor invitations nor emergencies
            if (newValue == false && this.loadingAppointments == false && this.loadingInvitations == false && this.loadingEmergencies == false) {
                this.redirectIfEmpty();
            }
        }
    }
});

/***/ }),
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Patient_LoginModal_vue__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Patient_LogoutModal_vue__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Patient_LanguageSwitcherModal_vue__ = __webpack_require__(580);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'HeaderNav',

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    components: { LoginModal: __WEBPACK_IMPORTED_MODULE_1__components_Patient_LoginModal_vue__["a" /* default */], LogoutModal: __WEBPACK_IMPORTED_MODULE_2__components_Patient_LogoutModal_vue__["a" /* default */], LanguageSwitcherModal: __WEBPACK_IMPORTED_MODULE_3__components_Patient_LanguageSwitcherModal_vue__["a" /* default */] },

    data: function data() {
        return {
            showLoginModal: false,
            showLogoutModal: false,
            showLanguageSwitcherModal: false
        };
    },

    methods: {
        logout: function logout() {
            var _this = this;

            this.showLogoutModal = true;
            setTimeout(function () {
                _this.$store.dispatch('logout');
                // this.showLogoutModal = false
            }, 1000);
        },
        showLogin: function showLogin() {
            this.showLoginModal = true;
        },
        hideLogin: function hideLogin() {
            this.showLoginModal = false;
        },
        showLanguageSwitcher: function showLanguageSwitcher() {
            this.showLanguageSwitcherModal = true;
        },
        hideLanguageSwitcher: function hideLanguageSwitcher() {
            this.showLanguageSwitcherModal = false;
        }
    }
});

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebaseui__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebaseui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebaseui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_PatientRepository__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'login-modal',

    props: ['active'],

    data: function data() {
        return {
            terms_accepted: false
        };
    },

    methods: {
        close: function close() {
            this.$emit('close');
        },
        acceptTerms: function acceptTerms() {
            this.terms_accepted = true;
            this.loadFirebaseUi();
        },
        loadFirebaseUi: function loadFirebaseUi() {
            var ui = __WEBPACK_IMPORTED_MODULE_0_firebaseui___default.a.auth.AuthUI.getInstance() || new __WEBPACK_IMPORTED_MODULE_0_firebaseui___default.a.auth.AuthUI(__WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* auth */]);

            ui.start('#firebaseui-auth-container', {
                signInOptions: [__WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* authProviders */].Email, __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* authProviders */].Google, __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* authProviders */].Facebook],
                signInFlow: 'popup',
                credentialHelper: __WEBPACK_IMPORTED_MODULE_0_firebaseui___default.a.auth.CredentialHelper.NONE,
                callbacks: {
                    signInSuccessWithAuthResult: function signInSuccessWithAuthResult(result) {
                        if (result && result.user) {
                            // Patient does not exist
                            __WEBPACK_IMPORTED_MODULE_3__data_PatientRepository__["a" /* default */].createOrUpdate(result.user, function (patient) {
                                __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setPatient', patient);
                                window.location.reload();
                            }, function (error) {
                                // Could not create patient
                                console.error(error);
                            });
                        }
                    }
                }
            });
        }
    }
});

/***/ }),
/* 325 */,
/* 326 */,
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'logout-modal',

    props: ['active']
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_PatientRepository__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'language-switcher-modal',

    props: ['active'],

    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            selectedLanguage: null
        };
    },

    mounted: function mounted() {
        var language = localStorage.getItem('language') || (this.patient ? this.patient.language : this.frontLanguage) || 'en';
        this.selectedLanguage = _.find(this.languages, { shortCode: language });
    },


    methods: {
        submit: function submit() {
            var _this = this;

            if (this.patient) {
                __WEBPACK_IMPORTED_MODULE_2__data_PatientRepository__["a" /* default */].update({
                    id: this.patient.id,
                    language: this.selectedLanguage.shortCode
                }, function (patient) {
                    __WEBPACK_IMPORTED_MODULE_2__data_PatientRepository__["a" /* default */].find(_this.patient.id, function (patient) {
                        _this.$store.dispatch('setPatient', patient);
                        _this.$store.dispatch('setFrontLanguage', _this.selectedLanguage.shortCode);
                        _this.$store.dispatch('setLocale', _this.selectedLanguage.code);
                        _this.$emit('close');
                    }, function (error) {
                        console.log(error);
                    });
                    // this.$store.dispatch('setPatient', Object.assign(this.patient, {language: this.selectedLanguage.shortCode}))
                }, function () {});
            } else {
                this.$store.dispatch('setFrontLanguage', this.selectedLanguage.shortCode);
                this.$store.dispatch('setLocale', this.selectedLanguage.code);
                this.$emit('close');
            }
        },
        close: function close() {
            this.$emit('close');
        }
    }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Patient_OfficeSettings__ = __webpack_require__(71);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "appointment-list-item",

  components: { OfficeSettings: __WEBPACK_IMPORTED_MODULE_0__components_Patient_OfficeSettings__["a" /* default */] },

  props: ["appointment"]
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        accessible: {
            type: Boolean,
            default: false
        },
        card: {
            type: Boolean,
            default: false
        },
        cash: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        getTooltip: function getTooltip(prop) {
            if (!this[prop]) {
                return this.$t("Office_" + prop + "_disabled");
            } else {
                return this.$t("Office_" + prop);
            }
        }
    }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PartnerAvatar_vue__ = __webpack_require__(53);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'partner-appointment-list-item',

    props: ['appointment'],

    components: { PartnerAvatar: __WEBPACK_IMPORTED_MODULE_0__components_PartnerAvatar_vue__["a" /* default */] }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'avatar',

    props: ['externalUrl']
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'invitation-list-item',

    props: ['invitation']
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Patient_DeleteEmergencyModal__ = __webpack_require__(596);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'emergency-list-item',

    props: ['emergency'],

    components: { DeleteEmergencyModal: __WEBPACK_IMPORTED_MODULE_0__components_Patient_DeleteEmergencyModal__["a" /* default */] },

    data: function data() {
        return {
            showDeleteModal: false,
            step: 'details'
        };
    },


    methods: {
        showDelete: function showDelete() {
            this.showDeleteModal = true;
        },
        hideDelete: function hideDelete() {
            this.showDeleteModal = false;
        },
        deleted: function deleted() {
            this.$emit('deleted');
        }
    }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_EmergencyRepository__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'delete-emergency-modal',

    props: ['active', 'emergency'],

    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            step: 'details',
            errorText: null
        };
    },


    methods: {
        close: function close() {
            this.$emit('close');

            this.step = 'details';
            this.errorText = null;
        },
        changeStep: function changeStep(step) {
            this.step = step;
        },
        confirm: function confirm() {
            var _this = this;

            this.changeStep('deleting');

            __WEBPACK_IMPORTED_MODULE_2__data_EmergencyRepository__["a" /* default */].delete(this.emergency, function () {
                _this.$ga.event({
                    eventCategory: 'Emergencies',
                    eventAction: 'DeleteEmergency'
                });

                setTimeout(function () {
                    _this.$emit('deleted');
                }, 1000);
            }, function (error) {
                console.log('error', error);
                _this.errorText = error.message;
                _this.changeStep('errors');
            });
        }
    }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebaseui__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebaseui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebaseui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_helpers__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'DoctorHome',

    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_helpers__["a" /* default */]],

    computed: {
        links: function links() {
            var links = [];

            if (this.userId) {
                if (this.doctor) {
                    links.push({
                        to: { name: 'doctor.dashboard' },
                        label: this.$t('go_to_doctor_dashboard'),
                        classes: "is-light"
                    });
                } else {
                    links.push({
                        to: { name: 'doctor.register' },
                        label: this.$t('register_as_doctor_link_label'),
                        classes: "is-light"
                    });
                }
            }

            return links;
        }
    },

    mounted: function mounted() {
        // Redirect to the link if there is only one
        if (this.links.length == 1) {
            this.$router.push(this.links[0].to);
        } else {
            var ui = __WEBPACK_IMPORTED_MODULE_0_firebaseui___default.a.auth.AuthUI.getInstance() || new __WEBPACK_IMPORTED_MODULE_0_firebaseui___default.a.auth.AuthUI(__WEBPACK_IMPORTED_MODULE_1__firebase__["a" /* auth */]);

            ui.start('#firebaseui-auth-container', {
                signInOptions: [__WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* authProviders */].Email, __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* authProviders */].Google, __WEBPACK_IMPORTED_MODULE_1__firebase__["b" /* authProviders */].Facebook],
                signInFlow: 'popup',
                credentialHelper: __WEBPACK_IMPORTED_MODULE_0_firebaseui___default.a.auth.CredentialHelper.NONE,
                signInSuccessUrl: '/doctor'
            });
        }
    },


    methods: {
        logout: function logout() {
            __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('logout', { name: 'doctor.login' });
        }
    }
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_DoctorRepository__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_DoctorOfficeRepository__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_EmergencyRepository__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_TimeSlotRepository__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Doctor_AppNav_vue__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Doctor_EmergencyModal_vue__ = __webpack_require__(139);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'doctor-app',

    components: { AppNav: __WEBPACK_IMPORTED_MODULE_8__components_Doctor_AppNav_vue__["a" /* default */], EmergencyModal: __WEBPACK_IMPORTED_MODULE_9__components_Doctor_EmergencyModal_vue__["a" /* default */] },

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            loaded: false,
            showEmergencyModal: false,
            currentEmergency: {},
            currentAvailability: {}
        };
    },
    created: function created() {
        this.setLoaded(false);
        this.setLoading(true);

        this.setListenAppointments(false);

        // Load doctor dependencies
        this.loadOffices();
        this.listenForAppointments();
    },


    methods: {
        loadOffices: function loadOffices() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_5__data_DoctorOfficeRepository__["a" /* default */].load(this.userId, function (offices) {
                _this.setOffices(offices);

                _this.setLoaded(true);
                _this.setLoading(false);
            }, function (error) {
                _this.alertError(error.message);

                _this.setLoaded(true);
                _this.setLoading(false);
            });
        },
        listenForAppointments: function listenForAppointments() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_3__firebase__["c" /* db */].collection('appointments').where('doctorId', '==', this.userId).onSnapshot(function (snapshot) {
                if (!_this2.listenAppointments) {
                    _this2.setListenAppointments(true);

                    return false;
                }

                var size = 0;

                snapshot.docChanges().forEach(function (change) {
                    if (change.type == 'added') {
                        var appointment = change.doc.data();

                        var start = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(appointment.time * 15, 'minutes');
                        var end = start.clone().add(15, 'minutes');

                        appointment.start = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(start.asMilliseconds()).format(_this2.$t('time_format'));
                        appointment.end = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(end.asMilliseconds()).format(_this2.$t('time_format'));

                        var messageDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(appointment.date, "YYYY-MM-DD").format(_this2.$t('appointment_notification_date_format'));
                        var messageTime = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.utc(start.asMilliseconds()).format(_this2.$t('time_format'));

                        var message = _this2.$t('appointment_notification_content', {
                            firstName: _this2.hashPatientInfo(appointment.patientFirstName),
                            lastName: _this2.hashPatientInfo(appointment.patientLastName),
                            date: messageDate,
                            time: messageTime
                        });

                        _this2.addNotification({
                            type: 'is-info',
                            content: message,
                            active: true,
                            appointment: appointment
                        });
                    }

                    size++;
                });
            });
        },
        closeEmergencyModal: function closeEmergencyModal() {
            this.showEmergencyModal = false;
            this.currentAvailability = {};
            this.currentEmergency = {};
            document.documentElement.classList.toggle('is-clipped', false);
        },
        showEmergency: function showEmergency(appointment) {
            var _this3 = this;

            this.setLoading(true);

            var emergencyId = appointment.emergencyId;

            __WEBPACK_IMPORTED_MODULE_6__data_EmergencyRepository__["a" /* default */].find(emergencyId, function (emergency) {
                _this3.currentAvailability = appointment;
                _this3.currentEmergency = emergency;
                _this3.showEmergencyModal = true;

                _this3.setLoading(false);
            }, function (error) {
                _this3.alertError(error.message);

                _this3.setLoading(false);
            });
        }
    }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(3);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            FIREBASE_PROJECT_ID: "tooddoc-dev"
        };
    },


    methods: {
        logout: function logout() {
            __WEBPACK_IMPORTED_MODULE_1__store__["a" /* store */].dispatch('logout', { name: 'doctor.login' });
        }
    }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['active', 'availability', 'emergency'],

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    methods: {
        close: function close() {
            this.$emit('close');
            document.documentElement.classList.toggle('is-clipped', false);
        }
    }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(3);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var GEOCODE_BASE_URL = 'https://maps.googleapis.com/maps/api/geocode/json';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'register',

    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            acceptTerms: false,
            socialEmail: __WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.auth().currentUser.email,
            medicalPractices: ['DENTIST', 'GENERAL_PRACTITIONER', 'GYNECOLOGIST', 'OPHTHALMOLOGIST', 'PEDIATRICIAN', 'PSYCHOLOGIST', 'DERMATOLOGIST', 'OSTEOPATH', 'PSYCHIATRIST', 'PHYSIOTHERAPIST'],
            newDoctor: {
                avatar: "MALE_CAUCASIAN_BLOND_BEARD",
                lastName: "",
                firstName: "",
                contactEmail: __WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.auth().currentUser.email,
                inami: "",
                isRegulated: false,
                language: "en",
                type: 'DENTIST',
                countryId: ""
            },
            newOffices: [],
            avatars: Object({"FEMALE_AFRO_AMERICAN_BROWN_LONG_HAIR":"avatar_female_afro_american_brown_long_hair","FEMALE_AFRO_AMERICAN_BLACK_ATTACHED_HAIR":"avatar_female_afro_american_black_attached_hair","FEMALE_ASIAN_BROWN_LONG_HAIR":"avatar_female_asian_brown_long_hair","FEMALE_ASIAN_BLACK_ATTACHED_HAIR":"avatar_female_asian_black_attached_hair","FEMALE_CAUCASIAN_BLOND_LONG_HAIR":"avatar_female_caucasian_blond_long_hair","FEMALE_CAUCASIAN_BLOND_ATTACHED_HAIR":"avatar_female_caucasian_blond_attached_hair","FEMALE_CAUCASIAN_GINGER_LONG_HAIR":"avatar_female_caucasian_ginger_long_hair","FEMALE_CAUCASIAN_BROWN_ATTACHED_HAIR":"avatar_female_caucasian_brown_attached_hair","MALE_AFRO_AMERICAN_BLACK_HAIR":"avatar_male_afro_american_black_hair","MALE_AFRO_AMERICAN_BLACK_MOUSTACHE":"avatar_male_afro_american_black_moustache","MALE_AFRO_AMERICAN_GREY_BEARD":"avatar_male_afro_american_grey_beard","MALE_ASIAN_BLACK_HAIR":"avatar_male_asian_black_hair","MALE_ASIAN_BLACK_MOUSTACHE":"avatar_male_asian_black_moustache","MALE_ASIAN_GREY_BEARD":"avatar_male_grey_beard","MALE_CAUCASIAN_BLOND_HAIR":"avatar_male_caucasian_blond_hair","MALE_CAUCASIAN_BLOND_MOUSTACHE":"avatar_male_caucasian_blond_moustache","MALE_CAUCASIAN_BLOND_BEARD":"avatar_male_caucasian_blond_beard","MALE_CAUCASIAN_GINGER_HAIR":"avatar_male_caucasian_ginger_hair","MALE_CAUCASIAN_GINGER_MOUSTACHE":"avatar_male_caucasian_ginger_moustache","MALE_CAUCASIAN_GINGER_BEARD":"avatar_male_caucasian_ginger_beard"}),
            showAvatarSelector: false
        };
    },


    computed: {
        error: function error() {
            return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* store */].state.formError;
        }
    },

    created: function created() {
        this.setFormError(null);

        // Use navigator language if available
        var navigatorLanguage = navigator.language || 'en';
        this.newDoctor.language = navigatorLanguage.substring(0, 2);

        var language = navigatorLanguage === 'en' ? 'en' : navigatorLanguage + '_BE';
        window.location.href = 'https://pro.tooddoc.com/login?source=old_version&lang=' + language;

        if (!this.defaultCountryId) {
            var country = _.find(this.countries, { code: 'be' });

            if (country) {
                __WEBPACK_IMPORTED_MODULE_4__store__["a" /* store */].dispatch('setDefaultCountryId', country.id);
            }
        }

        this.newDoctor.countryId = this.defaultCountryId;

        // TODO: change the locale of the app

        this.addOffice();
    },


    methods: {
        getCurrentCountryPhonePrefix: function getCurrentCountryPhonePrefix(office) {
            return this.countries[office.countryId] ? this.countries[office.countryId].phonePrefix : '';
        },
        deleteError: function deleteError() {
            this.setFormError(null);
        },
        addOffice: function addOffice() {
            this.newOffices.push({
                "name": "",
                "streetName": "",
                "streetNumber": "",
                "zipCode": "",
                "locality": "",
                "location": null,
                "phone": "",
                "countryId": this.newDoctor.countryId
            });
        },
        removeOffice: function removeOffice(key) {
            this.newOffices.splice(key, 1);
        },
        geocode: function geocode(key) {
            var _this = this;

            // var vue = this

            return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(GEOCODE_BASE_URL, {
                params: {
                    address: this.getFullAddress(key),
                    key: "AIzaSyBXIAl3Iq97-Z58_VMVY-UZQc_OQKrpIxw"
                }
            }).then(function (_ref) {
                var data = _ref.data;

                if (data.results.length) {
                    _this.newOffices[key].location = new __WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.firestore.GeoPoint(data.results[0].geometry.location.lat, data.results[0].geometry.location.lng);
                } else {
                    _this.alertError(_this.$t('DoctorProfile.geocoding_no_results_found'));
                }
            });
        },
        getPhoneRegex: function getPhoneRegex(officeKey) {
            return '^(\\' + this.getCountryPhonePrefix(officeKey) + '[0-9]{8,10})$';
        },
        getCountryName: function getCountryName(officeKey) {
            return this.$t('Countries.' + (this.countries[this.newOffices[officeKey].countryId] ? this.countries[this.newOffices[officeKey].countryId].code : 'default'));
        },
        getCountryPhonePrefix: function getCountryPhonePrefix(officeKey) {
            return this.countries[this.newOffices[officeKey].countryId] ? this.countries[this.newOffices[officeKey].countryId].phonePrefix : '';
        },
        getFullAddress: function getFullAddress(key) {
            return this.newOffices[key].streetNumber + ' ' + this.newOffices[key].streetName + ',' + this.newOffices[key].zipCode + ' ' + this.newOffices[key].locality + ' ' + this.getCountryName(key);
        },
        toggleAvatarSelector: function toggleAvatarSelector(show) {
            this.showAvatarSelector = show;
        },
        selectAvatar: function selectAvatar(avatar) {
            this.newDoctor.avatar = avatar;
            this.toggleAvatarSelector(false);
        },
        submit: function submit() {
            var _this2 = this;

            var vm = this;

            if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* store */].state.loading) {
                return false;
            }

            this.setLoading(true);
            this.setFormError(null);

            this.$validator.validateAll().then(function (result) {
                if (!result) {
                    _this2.setLoading(false);

                    return false;
                }

                var promises = [];

                for (var k in _this2.newOffices) {
                    promises.push(_this2.geocode(k));

                    _this2.newOffices[k].name = _this2.newOffices[k].name.trim();
                    _this2.newOffices[k].name = _this2.newOffices[k].name.charAt(0).toUpperCase() + _this2.newOffices[k].name.slice(1);
                    _this2.newOffices[k].streetName = _this2.newOffices[k].streetName.trim();
                    _this2.newOffices[k].streetName = _this2.newOffices[k].streetName.charAt(0).toUpperCase() + _this2.newOffices[k].streetName.slice(1);
                    _this2.newOffices[k].locality = _this2.newOffices[k].locality.trim();
                    _this2.newOffices[k].locality = _this2.newOffices[k].locality.charAt(0).toUpperCase() + _this2.newOffices[k].locality.slice(1);
                }

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
                    // Make sure last & first names starts with an uppercase
                    vm.newDoctor.lastName = vm.newDoctor.lastName.trim();
                    vm.newDoctor.lastName = vm.newDoctor.lastName.charAt(0).toUpperCase() + vm.newDoctor.lastName.slice(1);
                    vm.newDoctor.firstName = vm.newDoctor.firstName.trim();
                    vm.newDoctor.firstName = vm.newDoctor.firstName.charAt(0).toUpperCase() + vm.newDoctor.firstName.slice(1);

                    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* store */].dispatch('createDoctor', { doctor: vm.newDoctor, offices: vm.newOffices });

                    // this.setLoading(false)
                }, function (error) {
                    _this2.alertError(error.message);
                    _this2.setLoading(false);
                });
            });
        },
        logout: function logout() {
            __WEBPACK_IMPORTED_MODULE_4__store__["a" /* store */].dispatch('logout', { name: 'doctor.login' });
        }
    },

    watch: {
        'newDoctor.language': function newDoctorLanguage(to, from) {
            this.setLocale(to);
        }
    }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_TimeSlotRepository__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_AppointmentRepository__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_AppointmentInvitationRepository__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_EmergencyRepository__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Doctor_AppSidebar_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Doctor_EmergencyModal_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Doctor_Onboarding_vue__ = __webpack_require__(91);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'dashboard',

    components: { AppSidebar: __WEBPACK_IMPORTED_MODULE_9__components_Doctor_AppSidebar_vue__["a" /* default */], EmergencyModal: __WEBPACK_IMPORTED_MODULE_10__components_Doctor_EmergencyModal_vue__["a" /* default */], Onboarding: __WEBPACK_IMPORTED_MODULE_11__components_Doctor_Onboarding_vue__["a" /* default */] },

    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            officeReservedAvailabilities: {},
            officeAvailabilities: {},
            officeAppointments: {},
            officeAppointmentInvitations: {},
            dates: [],
            showEmergencyModal: false,
            currentAvailability: {},
            currentEmergency: {}
        };
    },
    mounted: function mounted() {
        this.setupDates();
        this.refresh();
    },


    methods: {
        refresh: function refresh() {
            this.refreshOfficeAppointments();
            this.refreshOfficeAvailabilities();
        },
        setupDates: function setupDates() {
            var futureDays = 4;

            for (var i = 0; i < futureDays; i++) {
                var date = __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(i, 'days').startOf('day').format('YYYY-MM-DD');
                this.dates.push(date);

                if (!this.currentDate && i == 0) {
                    this.selectDate(date);
                }
            }
        },
        selectDate: function selectDate(date) {
            this.setCurrentDate(date);
        },
        refreshOfficeAppointments: function refreshOfficeAppointments() {
            var _this = this;

            if (!this.doctor) {
                return false;
            }

            // Load Appointments & Invitations
            this.setLoading(true);

            __WEBPACK_IMPORTED_MODULE_7__data_AppointmentInvitationRepository__["a" /* default */].allForOfficeDate(this.doctor.id, this.currentOffice, this.currentDate, function (appointmentInvitations) {
                _this.officeAppointmentInvitations = {};

                _.forEach(appointmentInvitations, function (appointmentInvitation) {
                    _this.officeAppointmentInvitations[appointmentInvitation.id] = appointmentInvitation;
                });

                _this.setLoading(false);
            }, function () {
                _this.alertError(_this.$t('appointment_invitations_could_not_be_loaded'));

                _this.setLoading(false);
            });

            __WEBPACK_IMPORTED_MODULE_6__data_AppointmentRepository__["a" /* default */].allForOfficeDate(this.doctor.id, this.currentOffice, this.currentDate, function (appointments) {
                _this.officeAppointments = {};

                _.forEach(appointments, function (appointment) {
                    _this.officeAppointments[appointment.id] = appointment;
                });

                _this.setLoading(false);
            }, function () {
                _this.alertError(_this.$t('appointments_could_not_be_loaded'));

                _this.setLoading(false);
            });
        },
        refreshOfficeAvailabilities: function refreshOfficeAvailabilities() {
            var _this2 = this;

            if (!this.doctor) {
                return false;
            }

            this.setLoading(true);

            __WEBPACK_IMPORTED_MODULE_5__data_TimeSlotRepository__["a" /* default */].allForDate(this.doctor.id, this.currentOffice, this.currentDate, function (timeSlots) {
                _this2.officeAvailabilities = {};
                _this2.officeReservedAvailabilities = {};

                _.forEach(timeSlots, function (timeSlot) {
                    var start = __WEBPACK_IMPORTED_MODULE_4_moment___default.a.duration(timeSlot.time * 15, 'minutes');
                    var end = start.clone().add(15, 'minutes');

                    var officeTimeSlot = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(timeSlot, {
                        start: __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(start.asMilliseconds()).format(_this2.$t('time_format')),
                        end: __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(end.asMilliseconds()).format(_this2.$t('time_format'))
                    });

                    // Ignore timeSlots of today that are already past
                    if (officeTimeSlot.date == __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD') && __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('HH:mm') > __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(start.asMilliseconds()).format('HH:mm')) {
                        return;
                    }

                    if (timeSlot.appointmentId || timeSlot.appointmentInvitationId) {
                        _this2.officeReservedAvailabilities[timeSlot.time] = officeTimeSlot;
                    } else {
                        _this2.officeAvailabilities[timeSlot.time] = officeTimeSlot;
                    }
                });

                _this2.setLoading(false);
            }, function () {
                _this2.alertError(_this2.$t('timeslots_could_not_be_loaded'));

                _this2.setLoading(false);
            });
        },
        cancelInvitation: function cancelInvitation(invitationId) {
            var _this3 = this;

            this.setLoading(true);

            var appointmentInvitation = this.officeAppointmentInvitations[invitationId];

            __WEBPACK_IMPORTED_MODULE_7__data_AppointmentInvitationRepository__["a" /* default */].cancel(appointmentInvitation, function () {
                _this3.refresh();
            }, function (error) {
                _this3.setLoading(false);
                _this3.alertError(error.message);
            });
        },
        closeEmergencyModal: function closeEmergencyModal() {
            this.showEmergencyModal = false;
            this.currentEmergency = {};
            this.currentAvailability = {};
            document.documentElement.classList.toggle('is-clipped', false);
        },
        showEmergency: function showEmergency(availability) {
            var _this4 = this;

            this.setLoading(true);
            var appointment = this.getAppointmentByAvailability(availability);

            var emergencyId = appointment.emergencyId;

            __WEBPACK_IMPORTED_MODULE_8__data_EmergencyRepository__["a" /* default */].find(emergencyId, function (emergency) {
                _this4.currentAvailability = availability;
                _this4.currentEmergency = emergency;
                _this4.showEmergencyModal = true;

                _this4.setLoading(false);
            }, function (error) {
                _this4.alertError(error.message);

                _this4.setLoading(false);
            });
        },
        getAppointmentByAvailability: function getAppointmentByAvailability(availability) {
            var appointment = {};

            if (availability.appointmentId) {
                appointment = this.officeAppointments[availability.appointmentId];
            } else if (availability.appointmentInvitationId) {
                appointment = this.officeAppointmentInvitations[availability.appointmentInvitationId];
            }

            return appointment;
        },
        hasAvailabilityPictures: function hasAvailabilityPictures(availability) {
            var appointment = this.getAppointmentByAvailability(availability);

            return appointment && appointment.emergencyPictures.length > 0;
        },
        getAvailabilityPicture: function getAvailabilityPicture(availability) {
            var appointment = this.getAppointmentByAvailability(availability);

            return appointment.emergencyPictures[0];
        },
        getAvailabilityStatus: function getAvailabilityStatus(availability) {
            var appointment = {};

            if (availability.appointmentId) {
                appointment = this.officeAppointments[availability.appointmentId];

                return "(" + this.$t('status_confirmed_label') + ")";
            } else if (availability.appointmentInvitationId) {
                appointment = this.officeAppointmentInvitations[availability.appointmentInvitationId];

                if (appointment) {
                    if (appointment.hasBeenCancelled || appointment.hasBeenAutoCancelled) {
                        return "(" + this.$t('status_cancelled_label') + ")";
                    }

                    if (appointment.hasBeenDeclined) {
                        return "(" + this.$t('status_declined_label') + ")";
                    }
                }

                return "(" + this.$t('status_pending_label') + ")";
            }

            return "";
        },
        getPatientInfo: function getPatientInfo(availability) {
            var appointment = {};

            if (availability.appointmentId) {
                appointment = this.officeAppointments[availability.appointmentId];
            } else if (availability.appointmentInvitationId) {
                appointment = this.officeAppointmentInvitations[availability.appointmentInvitationId];
            }

            if (appointment && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(appointment).length) {
                return this.hashPatientInfo(appointment.patientFirstName) + ' ' + this.hashPatientInfo(appointment.patientLastName) + ' (' + appointment.patientAge + ')';
            }

            return "N/A";
        },
        showPicture: function showPicture(picture) {
            this.$modal.open('<p class="image">\n                    <img src="' + picture + '" alt="Image" />\n                </p>');
        }
    },

    watch: {
        currentOffice: function currentOffice(newCurrentOffice) {
            this.refresh();
        },
        currentDate: function currentDate(newCurrentOffice) {
            this.refresh();
        }
    }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Advertisements__ = __webpack_require__(343);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app-sidebar',

    components: { Advertisements: __WEBPACK_IMPORTED_MODULE_2__Advertisements__["a" /* default */] },

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    methods: {
        switchOffice: function switchOffice(key) {
            this.setCurrentOffice(key);
        }
    }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Advertisements_vue__ = __webpack_require__(344);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7471c71e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Advertisements_vue__ = __webpack_require__(622);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Advertisements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7471c71e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Advertisements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/Advertisements.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7471c71e", Component.options)
  } else {
    hotAPI.reload("data-v-7471c71e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_DoctorAdvertisementRepository__ = __webpack_require__(621);
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            advertisements: [],
            currentKey: 0,
            timer: null,
            languageId: null
        };
    },
    mounted: function mounted() {
        if (this.doctor) {
            this.languageId = _.find(this.languages, { code: this.doctor.language }).id;
        } else {
            this.languageId = _.find(this.languages, { code: 'en' }).id;
        }

        this.refresh();
    },
    beforeDestroy: function beforeDestroy() {
        clearTimeout(this.timer);

        this.timer = null;
    },


    methods: {
        refresh: function refresh() {
            var _this = this;

            clearTimeout(this.timer);

            this.setLoading(true);

            __WEBPACK_IMPORTED_MODULE_1__data_DoctorAdvertisementRepository__["a" /* default */].allForDoctor(this.doctor, function (advertisements) {
                _this.advertisements = _.sortBy(_.filter(advertisements, function (advertisement) {
                    if (advertisement.isPublished && advertisement.hasOwnProperty('items') && advertisement.items.hasOwnProperty(_this.languageId)) {
                        var item = advertisement.items[_this.languageId];

                        return item.url && item.image;
                    }

                    return false;
                }), 'position');

                _this.currentKey = Math.floor(Math.random() * (_this.advertisements.length - 1));

                _this.dispatchAnalyticsEvent('View');

                if (_this.advertisements.length > 1) {
                    _this.timer = _this.rotate();
                }

                _this.setLoading(false);
            });
        },
        rotate: function rotate() {
            if (this.advertisements.length <= 0) return false;

            if (this.currentKey == this.advertisements.length - 1) {
                this.currentKey = 0;
            } else {
                this.currentKey++;
            }

            this.dispatchAnalyticsEvent('View');

            this.timer = setTimeout(this.rotate, 30000);
        },
        dispatchAnalyticsEvent: function dispatchAnalyticsEvent() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'View';

            if (this.advertisements[this.currentKey]) {
                var event = {
                    eventCategory: 'DoctorAdvertisement',
                    eventAction: action,
                    // eventLabel: 'doctorAdvertisement.id',
                    eventLabel: this.advertisements[this.currentKey].id
                };

                this.$ga.event(event);
            }
        }
    }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_DoctorRepository__ = __webpack_require__(68);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'onboarding',

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    methods: {
        setOnboardingStep: function setOnboardingStep(step) {
            var _this = this;

            this.doctor.onboardingStep = step;

            __WEBPACK_IMPORTED_MODULE_1__data_DoctorRepository__["a" /* default */].update(this.doctor.id, { onboardingStep: step }, function () {
                // DO nothing
            }, function (error) {
                _this.alertError(error.message);
            });
        }
    }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Doctor_Advertisements_vue__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Doctor_Onboarding_vue__ = __webpack_require__(91);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'profile',

    components: { Advertisements: __WEBPACK_IMPORTED_MODULE_1__components_Doctor_Advertisements_vue__["a" /* default */], Onboarding: __WEBPACK_IMPORTED_MODULE_2__components_Doctor_Onboarding_vue__["a" /* default */] },

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]]
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_DoctorRepository__ = __webpack_require__(68);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'profile-details',

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            avatars: Object({"FEMALE_AFRO_AMERICAN_BROWN_LONG_HAIR":"avatar_female_afro_american_brown_long_hair","FEMALE_AFRO_AMERICAN_BLACK_ATTACHED_HAIR":"avatar_female_afro_american_black_attached_hair","FEMALE_ASIAN_BROWN_LONG_HAIR":"avatar_female_asian_brown_long_hair","FEMALE_ASIAN_BLACK_ATTACHED_HAIR":"avatar_female_asian_black_attached_hair","FEMALE_CAUCASIAN_BLOND_LONG_HAIR":"avatar_female_caucasian_blond_long_hair","FEMALE_CAUCASIAN_BLOND_ATTACHED_HAIR":"avatar_female_caucasian_blond_attached_hair","FEMALE_CAUCASIAN_GINGER_LONG_HAIR":"avatar_female_caucasian_ginger_long_hair","FEMALE_CAUCASIAN_BROWN_ATTACHED_HAIR":"avatar_female_caucasian_brown_attached_hair","MALE_AFRO_AMERICAN_BLACK_HAIR":"avatar_male_afro_american_black_hair","MALE_AFRO_AMERICAN_BLACK_MOUSTACHE":"avatar_male_afro_american_black_moustache","MALE_AFRO_AMERICAN_GREY_BEARD":"avatar_male_afro_american_grey_beard","MALE_ASIAN_BLACK_HAIR":"avatar_male_asian_black_hair","MALE_ASIAN_BLACK_MOUSTACHE":"avatar_male_asian_black_moustache","MALE_ASIAN_GREY_BEARD":"avatar_male_grey_beard","MALE_CAUCASIAN_BLOND_HAIR":"avatar_male_caucasian_blond_hair","MALE_CAUCASIAN_BLOND_MOUSTACHE":"avatar_male_caucasian_blond_moustache","MALE_CAUCASIAN_BLOND_BEARD":"avatar_male_caucasian_blond_beard","MALE_CAUCASIAN_GINGER_HAIR":"avatar_male_caucasian_ginger_hair","MALE_CAUCASIAN_GINGER_MOUSTACHE":"avatar_male_caucasian_ginger_moustache","MALE_CAUCASIAN_GINGER_BEARD":"avatar_male_caucasian_ginger_beard"}),
            medicalPractices: ['DENTIST', 'GENERAL_PRACTITIONER', 'GYNECOLOGIST', 'OPHTHALMOLOGIST', 'PEDIATRICIAN', 'PSYCHOLOGIST', 'DERMATOLOGIST', 'OSTEOPATH', 'PSYCHIATRIST', 'PHYSIOTHERAPIST'],
            showAvatarSelector: false
        };
    },
    mounted: function mounted() {
        if (!this.doctor.hasOwnProperty('countryId')) {
            var country = _.find(this.countries, { code: 'be' });

            this.doctor.countryId = country.id;
        }
    },


    methods: {
        saveDetails: function saveDetails() {
            var _this = this;

            this.setLoading(true);

            this.$validator.validateAll().then(function (result) {
                if (!result) {
                    _this.alertError(_this.$t('fields_are_missing'));
                    _this.setLoading(false);

                    return false;
                }

                _this.doctor.lastName = _this.doctor.lastName.trim();
                _this.doctor.lastName = _this.doctor.lastName.charAt(0).toUpperCase() + _this.doctor.lastName.slice(1);
                _this.doctor.firstName = _this.doctor.firstName.trim();
                _this.doctor.firstName = _this.doctor.firstName.charAt(0).toUpperCase() + _this.doctor.firstName.slice(1);

                // Only pass fields that can be updated
                var data = {
                    avatar: _this.doctor.avatar,
                    lastName: _this.doctor.lastName,
                    firstName: _this.doctor.firstName,
                    contactEmail: _this.doctor.contactEmail,
                    type: _this.doctor.type,
                    isRegulated: _this.doctor.isRegulated,
                    language: _this.doctor.language,
                    countryId: _this.doctor.countryId
                };

                __WEBPACK_IMPORTED_MODULE_3__data_DoctorRepository__["a" /* default */].update(_this.doctor.id, data, function () {
                    _this.alertSuccess(_this.$t('alert_update_successful'));

                    _this.setLocale(_this.doctor.language);

                    _this.setLoading(false);
                }, function (error) {
                    _this.alertError(error.message);

                    _this.setLoading(false);
                });
            });
        },
        toggleAvatarSelector: function toggleAvatarSelector(show) {
            this.showAvatarSelector = show;
        },
        selectAvatar: function selectAvatar(avatar) {
            this.doctor.avatar = avatar;
            this.toggleAvatarSelector(false);
        }
    }
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_DoctorOfficeRepository__ = __webpack_require__(89);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var GEOCODE_BASE_URL = 'https://maps.googleapis.com/maps/api/geocode/json';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'profile-new-office',

    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            newOffice: {}
        };
    },
    created: function created() {
        if (!this.defaultCountryId) {
            var country = _.find(this.countries, { code: 'be' });

            if (country) {
                __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */].dispatch('setDefaultCountryId', country.id);
            }
        }

        this.resetNewOffice();
    },


    methods: {
        getPhoneRegex: function getPhoneRegex() {
            return '^(\\' + this.getCurrentCountryPhonePrefix() + '[0-9]{8,10})$';
        },
        resetNewOffice: function resetNewOffice() {
            this.newOffice = {
                "name": "",
                "streetName": "",
                "streetNumber": "",
                "zipCode": "",
                "locality": "",
                "location": null,
                "countryId": this.defaultCountryId,
                "phone": "",
                "isEmergencyEmailAlertEnabled": true
            };

            this.$emit('positionChanged', {
                name: 'office',
                location: null
            });
        },
        geocode: function geocode(onSuccess, onError) {
            var _this = this;

            this.setLoading(true);

            __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(GEOCODE_BASE_URL, {
                params: {
                    address: this.getFullAddress(),
                    key: "AIzaSyBXIAl3Iq97-Z58_VMVY-UZQc_OQKrpIxw"
                }
            }).then(function (_ref) {
                var data = _ref.data;

                if (data.results.length) {
                    _this.newOffice.location = new __WEBPACK_IMPORTED_MODULE_2_firebase_app___default.a.firestore.GeoPoint(data.results[0].geometry.location.lat, data.results[0].geometry.location.lng);

                    _this.$emit('positionChanged', {
                        name: 'office',
                        location: _this.newOffice.location
                    });

                    onSuccess();
                } else {
                    onError({ message: _this.$t('DoctorProfile.geocoding_no_results_found') });
                }
            }).catch(onError);
        },
        getCurrentCountryName: function getCurrentCountryName() {
            return this.$t('Countries.' + (this.countries[this.newOffice.countryId] ? this.countries[this.newOffice.countryId].code : 'default'));
        },
        getCurrentCountryPhonePrefix: function getCurrentCountryPhonePrefix() {
            return this.countries[this.newOffice.countryId] ? this.countries[this.newOffice.countryId].phonePrefix : '';
        },
        getFullAddress: function getFullAddress() {
            return this.newOffice.streetNumber + ' ' + this.newOffice.streetName + ',' + this.newOffice.zipCode + ' ' + this.newOffice.locality + ' ' + this.getCurrentCountryName();
        },
        createOffice: function createOffice() {
            var _this2 = this;

            this.setLoading(true);

            this.$validator.validateAll().then(function (result) {
                if (!result) {
                    _this2.setLoading(false);

                    _this2.alertError(_this2.$t('fields_are_missing'));

                    return false;
                }

                _this2.newOffice.name = _this2.newOffice.name.trim();
                _this2.newOffice.name = _this2.newOffice.name.charAt(0).toUpperCase() + _this2.newOffice.name.slice(1);
                _this2.newOffice.streetName = _this2.newOffice.streetName.trim();
                _this2.newOffice.streetName = _this2.newOffice.streetName.charAt(0).toUpperCase() + _this2.newOffice.streetName.slice(1);
                _this2.newOffice.locality = _this2.newOffice.locality.trim();
                _this2.newOffice.locality = _this2.newOffice.locality.charAt(0).toUpperCase() + _this2.newOffice.locality.slice(1);

                _this2.geocode(function () {

                    if (!_this2.newOffice.location || _this2.newOffice.location.lat == 51.501527 && _this2.newOffice.location.lng == 0) {
                        _this2.setLoading(false);

                        return false;
                    }

                    __WEBPACK_IMPORTED_MODULE_4__data_DoctorOfficeRepository__["a" /* default */].create(_this2.doctor, _this2.newOffice, function (officeId) {
                        _this2.setCurrentOffice(officeId);

                        _this2.$router.push({ name: 'doctor.profile.office', params: { id: officeId } });

                        _this2.alertSuccess(_this2.$t('alert_create_successful'));

                        _this2.$validator.reset();
                        _this2.resetNewOffice();

                        _this2.setLoading(false);
                    });
                }, function (error) {
                    _this2.setLoading(false);

                    _this2.alertWarning(error.message);
                });
            });
        }
    }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_DoctorOfficeRepository__ = __webpack_require__(89);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var GEOCODE_BASE_URL = 'https://maps.googleapis.com/maps/api/geocode/json';

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'profile-office',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            editOffice: {}
        };
    },
    mounted: function mounted() {
        this.fetchOffice();
    },


    methods: {
        getPhoneRegex: function getPhoneRegex() {
            return '^(\\' + this.getCurrentCountryPhonePrefix() + '[0-9]{8,10})$';
        },
        fetchOffice: function fetchOffice() {
            this.editOffice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.offices[this.$route.params.id]);
            this.$validator.reset();

            this.$emit('positionChanged', {
                name: 'office',
                location: this.editOffice.location
            });
        },
        geocode: function geocode(onSuccess, onError) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(GEOCODE_BASE_URL, {
                params: {
                    address: this.getFullAddress(),
                    key: "AIzaSyBXIAl3Iq97-Z58_VMVY-UZQc_OQKrpIxw"
                }
            }).then(function (_ref) {
                var data = _ref.data;

                _this.editOffice.location = new __WEBPACK_IMPORTED_MODULE_3_firebase_app___default.a.firestore.GeoPoint(data.results[0].geometry.location.lat, data.results[0].geometry.location.lng);

                _this.$emit('positionChanged', {
                    name: 'office',
                    location: _this.editOffice.location
                });

                onSuccess();
            }).catch(onError);
        },
        getCurrentCountryName: function getCurrentCountryName() {
            return this.$t('Countries.' + (this.countries[this.editOffice.countryId] ? this.countries[this.editOffice.countryId].code : 'default'));
        },
        getCurrentCountryPhonePrefix: function getCurrentCountryPhonePrefix() {
            return this.countries[this.editOffice.countryId] ? this.countries[this.editOffice.countryId].phonePrefix : '';
        },
        getFullAddress: function getFullAddress() {
            return this.editOffice.streetNumber + ' ' + this.editOffice.streetName + ',' + this.editOffice.zipCode + ' ' + this.editOffice.locality + ' ' + this.getCurrentCountryName();
        },
        updateOffice: function updateOffice() {
            var _this2 = this;

            if (this.isLoading) {
                return false;
            }

            this.setLoading(true);

            this.$validator.validateAll().then(function (result) {
                if (!result) {
                    _this2.setLoading(false);

                    _this2.alertError(_this2.$t('fields_are_missing'));

                    return false;
                }

                _this2.editOffice.name = _this2.editOffice.name.trim();
                _this2.editOffice.name = _this2.editOffice.name.charAt(0).toUpperCase() + _this2.editOffice.name.slice(1);
                _this2.editOffice.streetName = _this2.editOffice.streetName.trim();
                _this2.editOffice.streetName = _this2.editOffice.streetName.charAt(0).toUpperCase() + _this2.editOffice.streetName.slice(1);
                _this2.editOffice.locality = _this2.editOffice.locality.trim();
                _this2.editOffice.locality = _this2.editOffice.locality.charAt(0).toUpperCase() + _this2.editOffice.locality.slice(1);

                _this2.geocode(function () {

                    if (!_this2.editOffice.location || _this2.editOffice.location.lat == 51.501527 && _this2.editOffice.location.lng == 0) {
                        _this2.setLoading(false);

                        _this2.alertWarning(_this2.$t('DoctorProfile.geocoding_no_results_found'));

                        return false;
                    }

                    __WEBPACK_IMPORTED_MODULE_5__data_DoctorOfficeRepository__["a" /* default */].update(_this2.doctor.id, _this2.editOffice.id, _this2.editOffice, function () {

                        _this2.alertSuccess(_this2.$t('office_alert_update_successful'));

                        _this2.fetchOffice();

                        _this2.setLoading(false);
                    }, function (error) {
                        _this2.alertError(error.message);

                        _this2.setLoading(false);
                    });
                }, function (error) {
                    _this2.setLoading(false);

                    _this2.alertWarning(error.message);
                });
            });
        },
        confirmDeleteOffice: function confirmDeleteOffice() {
            this.$dialog.confirm({
                title: this.$t('delete_dialog_title'),
                message: this.$t('delete_dialog_message'),
                type: 'is-danger',
                hasIcon: 'true',
                cancelText: this.$t('cancel_button_label'),
                confirmText: this.$t('ok_button_label')
            });
        }
    },

    watch: {
        '$route': function $route(to, from) {
            this.fetchOffice();
        }
    }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Doctor_AppSidebar_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Doctor_EmergencyModal_vue__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Doctor_Onboarding_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_TimeSlotRepository__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_AppointmentRepository__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_AppointmentInvitationRepository__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_EmergencyRepository__ = __webpack_require__(31);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'availabilities',

    components: { AppSidebar: __WEBPACK_IMPORTED_MODULE_5__components_Doctor_AppSidebar_vue__["a" /* default */], EmergencyModal: __WEBPACK_IMPORTED_MODULE_6__components_Doctor_EmergencyModal_vue__["a" /* default */], Onboarding: __WEBPACK_IMPORTED_MODULE_7__components_Doctor_Onboarding_vue__["a" /* default */] },

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            timeSlots: {},
            officeReservedAvailabilities: {},
            officeAvailabilities: {},
            officeAppointments: {},
            officeAppointmentInvitations: {},
            dates: [],
            showEmergencyModal: false,
            currentAvailability: {},
            currentEmergency: {},
            showEarlySlots: false,
            showLateSlots: false
        };
    },
    mounted: function mounted() {
        this.setupDates();
        this.setupTimeSlots();

        if (this.doctor && this.doctor.isCertified) {
            this.refresh();
        }
    },


    methods: {
        refresh: function refresh() {
            this.refreshOfficeAppointments();
            this.refreshOfficeAvailabilities();
        },
        setupDates: function setupDates() {
            var futureDays = 4;

            for (var i = 0; i < futureDays; i++) {
                var date = __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(i, 'days').startOf('day').format('YYYY-MM-DD');
                this.dates.push(date);

                if (!this.currentDate && i == 0) {
                    this.selectDate(date);
                }
            }
        },
        selectDate: function selectDate(date) {
            this.showEarlySlots = false;
            this.showLateSlots = false;
            this.setCurrentDate(date);
        },
        isTimeSlotActive: function isTimeSlotActive(time) {
            return _.has(this.officeAvailabilities, time) || _.has(this.officeReservedAvailabilities, time);
        },
        toggleEarlySlots: function toggleEarlySlots() {
            this.showEarlySlots = !this.showEarlySlots;
        },
        toggleLateSlots: function toggleLateSlots() {
            this.showLateSlots = !this.showLateSlots;
        },
        toggle: function toggle(time) {
            if (!this.doctor.isCertified) {
                this.alertError(this.$t('doctor_not_certified_warning'));
                return false;
            }

            // this.setLoading(true)

            if (this.isTimeSlotActive(time)) {
                this.deactivateTimeSlot(time);
            } else {
                this.activateTimeSlot(time);
            }
        },
        activateTimeSlot: function activateTimeSlot(time) {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_8__data_TimeSlotRepository__["a" /* default */].create(this.doctor, this.offices[this.currentOffice], this.currentDate, time, function (timeSlot) {
                // Add the timeSlot to the office availabilities
                _this.officeAvailabilities[time] = timeSlot;
            }, function (error) {
                _this.alertError(error.message);

                _this.refresh();
            });
        },
        deactivateTimeSlot: function deactivateTimeSlot(time) {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_8__data_TimeSlotRepository__["a" /* default */].delete(this.doctor, this.offices[this.currentOffice], this.currentDate, time, function (timeSlot) {
                // Remove the timeSlot from the office availabilities
                delete _this2.officeAvailabilities[time];
            }, function (error) {
                _this2.alertError(error.message);

                _this2.refresh();
            });
        },
        refreshOfficeAppointments: function refreshOfficeAppointments() {
            var _this3 = this;

            if (!this.doctor) {
                return false;
            }

            // Load Appointments & Invitations
            this.setLoading(true);

            __WEBPACK_IMPORTED_MODULE_10__data_AppointmentInvitationRepository__["a" /* default */].allForOfficeDate(this.doctor.id, this.currentOffice, this.currentDate, function (appointmentInvitations) {
                _this3.officeAppointmentInvitations = {};

                _.forEach(appointmentInvitations, function (appointmentInvitation) {
                    _this3.officeAppointmentInvitations[appointmentInvitation.id] = appointmentInvitation;
                });

                _this3.setLoading(false);
            }, function () {
                _this3.alertError(_this3.$t('appointment_invitations_could_not_be_loaded'));

                _this3.setLoading(false);
            });

            __WEBPACK_IMPORTED_MODULE_9__data_AppointmentRepository__["a" /* default */].allForOfficeDate(this.doctor.id, this.currentOffice, this.currentDate, function (appointments) {
                _this3.officeAppointments = {};

                _.forEach(appointments, function (appointment) {
                    _this3.officeAppointments[appointment.id] = appointment;
                });

                _this3.setLoading(false);
            }, function () {
                _this3.alertError(_this3.$t('appointments_could_not_be_loaded'));

                _this3.setLoading(false);
            });
        },
        refreshOfficeAvailabilities: function refreshOfficeAvailabilities() {
            var _this4 = this;

            if (!this.doctor) {
                return false;
            }

            this.setLoading(true);

            __WEBPACK_IMPORTED_MODULE_8__data_TimeSlotRepository__["a" /* default */].allForDate(this.doctor.id, this.currentOffice, this.currentDate, function (timeSlots) {
                _this4.officeAvailabilities = {};
                _this4.officeReservedAvailabilities = {};

                _.forEach(timeSlots, function (timeSlot) {
                    var start = __WEBPACK_IMPORTED_MODULE_4_moment___default.a.duration(timeSlot.time * 15, 'minutes');
                    var end = start.clone().add(15, 'minutes');

                    var officeTimeSlot = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(timeSlot, {
                        start: __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(start.asMilliseconds()).format(_this4.$t('time_format')),
                        end: __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(end.asMilliseconds()).format(_this4.$t('time_format'))
                    });

                    if (timeSlot.appointmentId || timeSlot.appointmentInvitationId) {
                        _this4.officeReservedAvailabilities[timeSlot.time] = officeTimeSlot;
                    } else {
                        _this4.officeAvailabilities[timeSlot.time] = officeTimeSlot;
                    }
                });

                _this4.setLoading(false);
            }, function () {
                _this4.alertError(_this4.$t('timeslots_could_not_be_loaded'));

                _this4.setLoading(false);
            });
        },
        setupTimeSlots: function setupTimeSlots() {
            for (var i = 0; i < 96; i++) {
                var start = __WEBPACK_IMPORTED_MODULE_4_moment___default.a.duration(i * 15, 'minutes');
                var end = start.clone().add(15, 'minutes');
                this.timeSlots[i] = {
                    key: i,
                    start: __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(start.asMilliseconds()).format(this.$t('time_format')),
                    end: __WEBPACK_IMPORTED_MODULE_4_moment___default.a.utc(end.asMilliseconds()).format(this.$t('time_format'))
                };
            }
        },
        cancelInvitation: function cancelInvitation(invitationId) {
            var _this5 = this;

            this.setLoading(true);

            var appointmentInvitation = this.officeAppointmentInvitations[invitationId];

            __WEBPACK_IMPORTED_MODULE_10__data_AppointmentInvitationRepository__["a" /* default */].cancel(appointmentInvitation, function () {
                _this5.refresh();
            }, function (error) {
                _this5.setLoading(false);
                _this5.alertError(error.message);
            });
        },
        getAvailabilityByTime: function getAvailabilityByTime(time) {
            return this.officeReservedAvailabilities[time];
        },
        getAppointmentByAvailability: function getAppointmentByAvailability(availability) {
            var appointment = {};

            if (availability.appointmentId) {
                appointment = this.officeAppointments[availability.appointmentId];
            } else if (availability.appointmentInvitationId) {
                appointment = this.officeAppointmentInvitations[availability.appointmentInvitationId];
            }

            return appointment;
        },
        hasAvailabilityPictures: function hasAvailabilityPictures(time) {
            var availability = this.getAvailabilityByTime(time);
            var appointment = this.getAppointmentByAvailability(availability);

            return appointment && appointment.emergencyPictures.length > 0;
        },
        getAvailabilityPicture: function getAvailabilityPicture(time) {
            var availability = this.getAvailabilityByTime(time);
            var appointment = this.getAppointmentByAvailability(availability);

            return appointment.emergencyPictures[0];
        },
        getAvailabilityStatus: function getAvailabilityStatus(time) {
            var availability = this.getAvailabilityByTime(time);
            var appointment = this.getAppointmentByAvailability(availability);

            if (availability.appointmentId) {
                appointment = this.officeAppointments[availability.appointmentId];

                return "(" + this.$t('status_confirmed_label') + ")";
            } else if (availability.appointmentInvitationId) {
                appointment = this.officeAppointmentInvitations[availability.appointmentInvitationId];

                if (appointment) {
                    if (appointment.hasBeenCancelled || appointment.hasBeenAutoCancelled) {
                        return "(" + this.$t('status_cancelled_label') + ")";
                    }

                    if (appointment.hasBeenDeclined) {
                        return "(" + this.$t('status_declined_label') + ")";
                    }
                }

                return "(" + this.$t('status_pending_label') + ")";
            }

            return "";
        },
        getPatientInfo: function getPatientInfo(time) {
            var availability = this.getAvailabilityByTime(time);
            var appointment = this.getAppointmentByAvailability(availability);

            if (appointment && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(appointment).length) {
                return this.hashPatientInfo(appointment.patientFirstName) + ' ' + this.hashPatientInfo(appointment.patientLastName) + ' (' + appointment.patientAge + ')';
            }

            return "N/A";
        },
        closeEmergencyModal: function closeEmergencyModal() {
            this.showEmergencyModal = false;
            this.currentEmergency = {};
            this.currentAvailability = {};
            document.documentElement.classList.toggle('is-clipped', false);
        },
        showEmergency: function showEmergency(time) {
            var _this6 = this;

            this.setLoading(true);
            var availability = this.getAvailabilityByTime(time);
            var appointment = this.getAppointmentByAvailability(availability);

            var emergencyId = appointment.emergencyId;

            __WEBPACK_IMPORTED_MODULE_11__data_EmergencyRepository__["a" /* default */].find(emergencyId, function (emergency) {
                _this6.currentAvailability = availability;
                _this6.currentEmergency = emergency;
                _this6.showEmergencyModal = true;

                _this6.setLoading(false);
            }, function (error) {
                _this6.alertError(error.message);

                _this6.setLoading(false);
            });
        },
        isPastSlot: function isPastSlot(slot) {
            if (this.currentDate > __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD')) {
                return false;
            }

            return slot.start < __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('HH:mm');
        }
    },

    watch: {
        currentOffice: function currentOffice(newCurrentOffice) {
            this.refresh();
        },
        currentDate: function currentDate(newCurrentOffice) {
            this.refresh();
        }
    }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_EmergencyRepository__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_TimeSlotRepository__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Doctor_AppSidebar_vue__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Doctor_AcceptEmergencyForm_vue__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Doctor_Onboarding_vue__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_scrollto__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_scrollto__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'emergencies',

    components: { AppSidebar: __WEBPACK_IMPORTED_MODULE_6__components_Doctor_AppSidebar_vue__["a" /* default */], AcceptEmergencyForm: __WEBPACK_IMPORTED_MODULE_7__components_Doctor_AcceptEmergencyForm_vue__["a" /* default */], Onboarding: __WEBPACK_IMPORTED_MODULE_8__components_Doctor_Onboarding_vue__["a" /* default */] },

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            emergencies: {},
            showAcceptModal: false,
            openedEmergency: null,
            selectedEmergency: null,
            availabilities: {},
            loadedAvailabilities: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        // Check if we queried a specific office
        if (this.$route.query.officeId && this.$route.query.officeId != this.currentOffice) {
            if (typeof this.offices[this.$route.query.officeId] !== 'undefined') {
                this.setCurrentOffice(this.$route.query.officeId);
            } else {
                this.$router.push({ name: 'doctor.emergencies' });
            }
        }

        if (this.doctor.isCertified) {
            this.refresh();
        }

        this.$on('emergency-accepted', function () {
            _this.refresh();
        });
    },


    methods: {
        refresh: function refresh() {
            this.refreshEmergencies();
            this.refreshOfficeAvailabilities();
        },
        refreshEmergencies: function refreshEmergencies() {
            var _this2 = this;

            this.setLoading(true);

            __WEBPACK_IMPORTED_MODULE_4__data_EmergencyRepository__["a" /* default */].allAvailable(this.doctor.type, function (emergencies) {
                _this2.emergencies = emergencies;

                _this2.openedEmergency = null;

                for (var emergency in emergencies) {
                    _this2.selectEmergency(emergency);
                    break;
                }

                _this2.setLoading(false);
            }, function () {
                _this2.alertError(_this2.$t('emergencies_could_not_be_loaded'));

                _this2.setLoading(false);
            });
        },
        refreshOfficeAvailabilities: function refreshOfficeAvailabilities() {
            var _this3 = this;

            if (!this.doctor) {
                return false;
            }

            this.loadedAvailabilities = false;
            this.setLoading(true);

            __WEBPACK_IMPORTED_MODULE_5__data_TimeSlotRepository__["a" /* default */].allFutureAvailable(this.doctor.id, this.currentOffice, function (timeSlots) {
                _this3.availabilities = timeSlots;

                _this3.setLoading(false);
                _this3.loadedAvailabilities = true;
            }, function (error) {
                _this3.alertError(error.message);

                _this3.setLoading(false);
            });
        },
        selectEmergency: function selectEmergency(key, scroll) {
            this.openedEmergency = this.openedEmergency == key ? null : key;

            this.$nextTick(function () {
                if (scroll === true) {
                    var div = document.getElementById('emergency-' + key);
                    __WEBPACK_IMPORTED_MODULE_9_vue_scrollto___default.a.scrollTo(div, 500);
                }
            });
        },
        acceptEmergency: function acceptEmergency(key) {
            this.openedEmergency = key;
            this.selectedEmergency = this.emergencies[key];
            this.toggleEmergencyForm(true);
        },
        toggleEmergencyForm: function toggleEmergencyForm(open) {
            this.showAcceptModal = open;
        },
        showPicture: function showPicture(picture) {
            this.$modal.open('<p class="image">\n                    <img src="' + picture + '" alt="Image" />\n                </p>');
        }
    },

    watch: {
        currentOffice: function currentOffice(newCurrentOffice) {
            this.refresh();
        }
    }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_AppointmentInvitationRepository__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_TimeSlotRepository__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'accept-emergency',

    props: ['emergency', 'availabilities', 'active'],

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            selectedAvailability: null,
            selectedDate: null,
            selectedTimeslot: null,
            isModalLoading: false,
            timeSlots: {},
            dates: [],
            showEarlySlots: false,
            showLateSlots: false,
            currentTimeslot: Math.floor((__WEBPACK_IMPORTED_MODULE_2_moment___default()().hour() * 60 + __WEBPACK_IMPORTED_MODULE_2_moment___default()().minute()) / 15)
        };
    },


    computed: {
        fileredAvailabilities: function fileredAvailabilities() {
            var _this = this;

            return _.filter(this.availabilities, function (availability, key) {
                return availability.date != __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD') || availability.time > _this.currentTimeslot;
            });
        }
    },

    mounted: function mounted() {
        this.setupDates();
        this.setupTimeSlots();
    },


    methods: {
        close: function close() {
            if (!this.isModalLoading) {
                this.$emit('close');
                document.documentElement.classList.toggle('is-clipped', false);
            }
        },
        confirm: function confirm() {
            var _this2 = this;

            this.isModalLoading = true;

            if (this.selectedAvailability) {
                __WEBPACK_IMPORTED_MODULE_3__data_AppointmentInvitationRepository__["a" /* default */].accept(this.emergency, this.selectedAvailability, this.doctor, this.offices[this.currentOffice], function () {
                    // Success
                    _this2.isModalLoading = false;

                    _this2.close();

                    _this2.$dialog.alert({
                        title: _this2.$t('accepted_dialog_title'),
                        message: _this2.$t('accepted_dialog_message'),
                        hasIcon: true,
                        type: 'is-success',
                        onConfirm: function onConfirm() {
                            _this2.$emit('accepted');
                        },
                        cancelText: _this2.$t('cancel_button_label'),
                        confirmText: _this2.$t('ok_button_label')
                    });
                }, function (error) {
                    // Error
                    _this2.isModalLoading = false;

                    _this2.alertError(error.message);
                });
            } else if (this.selectedDate && this.selectedTimeslot) {
                __WEBPACK_IMPORTED_MODULE_4__data_TimeSlotRepository__["a" /* default */].create(this.doctor, this.offices[this.currentOffice], this.selectedDate, this.selectedTimeslot.key, function (timeSlot) {
                    __WEBPACK_IMPORTED_MODULE_3__data_AppointmentInvitationRepository__["a" /* default */].accept(_this2.emergency, timeSlot, _this2.doctor, _this2.offices[_this2.currentOffice], function () {
                        // Success
                        _this2.isModalLoading = false;

                        _this2.close();

                        _this2.$dialog.alert({
                            title: _this2.$t('accepted_dialog_title'),
                            message: _this2.$t('accepted_dialog_message'),
                            hasIcon: true,
                            type: 'is-success',
                            onConfirm: function onConfirm() {
                                _this2.$emit('accepted');
                            },
                            cancelText: _this2.$t('cancel_button_label'),
                            confirmText: _this2.$t('ok_button_label')
                        });
                    }, function (error) {
                        // Error
                        _this2.isModalLoading = false;

                        _this2.alertError(error.message);
                    });
                }, function (error) {
                    _this2.isModalLoading = false;

                    _this2.alertError(error.message);
                });
            } else {
                this.isModalLoading = false;

                this.alertError(this.$t('nothing_selected'));
            }
        },
        selectAvailability: function selectAvailability(availability) {
            this.selectedDate = null;
            this.selectedTimeslot = null;
            this.selectedAvailability = availability;
        },
        selectDateAndTimeslot: function selectDateAndTimeslot(date, timeslot) {
            this.selectedAvailability = null;
            this.selectedDate = date;
            this.selectedTimeslot = timeslot;
        },
        toggleEarlySlots: function toggleEarlySlots() {
            this.showEarlySlots = !this.showEarlySlots;
        },
        toggleLateSlots: function toggleLateSlots() {
            this.showLateSlots = !this.showLateSlots;
        },
        setupDates: function setupDates() {
            for (var i = 0; i < 3; i++) {
                var date = __WEBPACK_IMPORTED_MODULE_2_moment___default()().add(i, 'days').startOf('day').format('YYYY-MM-DD');
                this.dates.push(date);
            }
        },
        setupTimeSlots: function setupTimeSlots() {
            for (var i = 0; i < 96; i++) {
                var start = __WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(i * 15, 'minutes');
                var end = start.clone().add(15, 'minutes');
                this.timeSlots[i] = {
                    key: i,
                    start: __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(start.asMilliseconds()).format(this.$t('time_format')),
                    end: __WEBPACK_IMPORTED_MODULE_2_moment___default.a.utc(end.asMilliseconds()).format(this.$t('time_format'))
                };
            }
        },
        timeslotIsAvailable: function timeslotIsAvailable(date, timeslot) {
            return _.filter(this.availabilities, function (availability, key) {
                return availability.date == date && availability.time == timeslot;
            }).length == 0;
        },
        timeslotIsVisible: function timeslotIsVisible(timeslot) {
            return this.showEarlySlots && this.showLateSlots ? true : this.showEarlySlots ? timeslot < 80 : this.showLateSlots ? timeslot > 32 : timeslot > 32 && timeslot < 80;
        },
        timeslotIsInFuture: function timeslotIsInFuture(date, timeslot) {
            return date != __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('YYYY-MM-DD') || timeslot > this.currentTimeslot;
        }
    },

    watch: {
        active: function active(newStatus) {
            this.selectedAvailability = null;
        }
    }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Patient_Bubble__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Patient_HeaderNav__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Patient_SearchForm__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Patient_OfficeListItem__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Patient_PartnerTimeslotListItem__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Patient_PartnerOfficeListItem__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Patient_TimeslotGroupListItem__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Patient_WaitingListButton__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__data_AppointmentRepository__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__data_AppointmentInvitationRepository__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__data_EmergencyRepository__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__data_OfficeRepository__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__data_TimeSlotRepository__ = __webpack_require__(36);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





















/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Search",

  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_helpers__["a" /* default */]],

  components: {
    Bubble: __WEBPACK_IMPORTED_MODULE_9__components_Patient_Bubble__["a" /* default */],
    HeaderNav: __WEBPACK_IMPORTED_MODULE_10__components_Patient_HeaderNav__["a" /* default */],
    SearchForm: __WEBPACK_IMPORTED_MODULE_11__components_Patient_SearchForm__["a" /* default */],
    OfficeListItem: __WEBPACK_IMPORTED_MODULE_12__components_Patient_OfficeListItem__["a" /* default */],
    PartnerOfficeListItem: __WEBPACK_IMPORTED_MODULE_14__components_Patient_PartnerOfficeListItem__["a" /* default */],
    PartnerTimeslotListItem: __WEBPACK_IMPORTED_MODULE_13__components_Patient_PartnerTimeslotListItem__["a" /* default */],
    TimeslotGroupListItem: __WEBPACK_IMPORTED_MODULE_15__components_Patient_TimeslotGroupListItem__["a" /* default */],
    WaitingListButton: __WEBPACK_IMPORTED_MODULE_16__components_Patient_WaitingListButton__["a" /* default */]
  },

  data: function data() {
    return {
      loadingTimeslots: false,
      timeslots: [],
      groups: [],
      loadingNearbyOffices: false,
      nearbyOffices: [],
      nearbyPartnerOffices: [],
      loadingAppointments: false,
      hasAppointments: false,
      loadingInvitations: false,
      hasInvitations: false,
      loadingEmergencies: false,
      hasEmergencies: false,
      partners: [],
      searchForm: {
        type: null,
        place: null
      },
      isDoctorMemberOfOsteopathie: false
    };
  },


  computed: {
    shortCode: function shortCode() {
      return this.patientLanguage.shortCode ? this.patientLanguage.shortCode : 'en';
    },
    pluralType: function pluralType() {
      return this.$t("type_" + this.searchForm.type + "_plural");
    },
    sortedMixAvailabilities: function sortedMixAvailabilities() {
      var _this = this;

      var groups = this.groups.map(function (g) {
        var firstTimeSlot = g.timeslots[0];
        var foundOffice = _this.nearbyOffices.find(function (office) {
          return office.id === g.officeId;
        });
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, g, { component: "TimeslotGroupListItem", foundOffice: foundOffice });
      });
      var partners = this.partners.map(function (p) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, p, { component: "PartnerTimeslotListItem" });
      });

      var mix = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(groups), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(partners)).filter(function (doctor) {
        if (_this.isDoctorMemberOfOsteopathie) {
          return doctor.foundOffice && doctor.foundOffice.isDoctorMemberOfOsteopathie;
        }
        return doctor;
      });

      return _.sortBy(mix.filter(function (i) {
        return i.distance <= 30;
      }), ["distance"]);
    },
    sortedMixOffices: function sortedMixOffices() {
      var _this2 = this;

      var officeIds = this.groups.map(function (g) {
        return g.officeId;
      });
      var nearbyOffices = this.nearbyOffices.map(function (g) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, g, { component: "OfficeListItem" });
      }).filter(function (g) {
        return officeIds.indexOf(g.id) < 0;
      }); // Filter offices that are already represented in the availabilities

      var nearbyPartnerOffices = this.nearbyPartnerOffices.map(function (p) {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, p, { component: "PartnerOfficeListItem" });
      });

      var mix = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(nearbyOffices), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(nearbyPartnerOffices)).filter(function (office) {
        if (_this2.isDoctorMemberOfOsteopathie) {
          return office.isDoctorMemberOfOsteopathie;
        } else {
          return office;
        }
      });

      return _.take(_.sortBy(mix.filter(function (i) {
        return i.distance <= 30;
      }), ["distance"]), 20);
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this3.patientPosition) {
                _this3.search();
              }

              if (_this3.userId) {
                _this3.fetchPatientResources();
              }

              __WEBPACK_IMPORTED_MODULE_6_firebase_app___default.a.auth().onAuthStateChanged(function (user) {
                if (user) {
                  _this3.fetchPatientResources();
                }
              });

              if (_this3.$route.query.memberosteo === "true") {
                _this3.isDoctorMemberOfOsteopathie = true;
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  },


  methods: {
    search: function search() {
      this.fetchTimeslots();
      this.fetchPartnerTimeslots();
      this.fetchPartnerOffices();
    },
    fetchNearbyOffices: function fetchNearbyOffices() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this4.patientPosition) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", false);

              case 2:

                _this4.loadingNearbyOffices = true;

                __WEBPACK_IMPORTED_MODULE_20__data_OfficeRepository__["a" /* default */].allNearby(_this4.patientPosition, _this4.searchForm.type, function (offices) {
                  _this4.nearbyOffices = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(offices).map(function (key) {
                    return offices[key];
                  });
                }, function (error) {
                  console.log("error", error);
                  _this4.alertPatientError(error.message);

                  _this4.loadingNearbyOffices = false;
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    fetchTimeslots: function fetchTimeslots() {
      var _this5 = this;

      if (!this.patientPosition || !this.searchForm.type) {
        return false;
      }

      this.loadingTimeslots = true;

      __WEBPACK_IMPORTED_MODULE_21__data_TimeSlotRepository__["a" /* default */].allForPatient(this.searchForm.type, function (timeSlots) {
        _this5.timeslots = _.map(timeSlots, function (timeslot) {
          return _.extend({}, timeslot, {
            distance: 0.1 * window.distanceBetween(timeslot.officeLocation._lat || timeslot.officeLocation._latitude, timeslot.officeLocation._long || timeslot.officeLocation._longitude, _this5.patientPosition._lat, _this5.patientPosition._long)
          });
        });

        _this5.refreshGroups();
      }, function (error) {
        _this5.alertPatientError(error.message);

        _this5.loadingTimeslots = false;
      });
    },
    fetchPartnerTimeslots: function fetchPartnerTimeslots() {
      var _this6 = this;

      if (!this.patientPosition || !this.searchForm.type) {
        return false;
      }

      this.partners = [];

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("https://us-central1-tooddoc-dev.cloudfunctions.net" + "/getPartnerTimeSlots", {
        params: {
          userId: this.userId ? this.userId : "XXXXXXXXXXXXXXXXXXXXXXXXXXXX",
          medicalPractice: this.searchForm.type,
          language: this.shortCode,
          latitude: this.patientPosition._lat,
          longitude: this.patientPosition._long
        },
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        var partners = [];

        for (var i = 0; i < response.data.length; i++) {
          var timeslot = response.data[i];
          var index = _.findIndex(partners, { doctorId: timeslot.doctorId });

          if (index >= 0) {
            var partner = partners[index];

            if (partner.dateTime >= timeslot.dateTime) {
              partner.dateTime = timeslot.dateTime;
            }

            partner.timeslots.push(timeslot);

            _this6.$set(partners, index, partner);
          } else {
            partners.push({
              dateTime: timeslot.dateTime,
              doctorAvatar: timeslot.doctorAvatar,
              doctorFirstName: timeslot.doctorFirstName,
              doctorId: timeslot.doctorId,
              doctorLastName: timeslot.doctorLastName,
              isDoctorRegulated: timeslot.isDoctorRegulated,
              medicalPractice: timeslot.medicalPractice,
              officeCountry: timeslot.officeCountry,
              officeLatitude: timeslot.officeLatitude,
              officeLocality: timeslot.officeLocality,
              officeLongitude: timeslot.officeLongitude,
              officeName: timeslot.officeName,
              officeStreetName: timeslot.officeStreetName,
              officeZipCode: timeslot.officeZipCode,
              partnerName: timeslot.partnerName,
              partnerUrl: timeslot.partnerUrl,
              distance: window.distanceBetween(timeslot.officeLatitude, timeslot.officeLongitude, _this6.patientPosition._lat, _this6.patientPosition._long),
              timeslots: [timeslot]
            });
          }
        }

        _this6.partners = partners;
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    fetchPartnerOffices: function fetchPartnerOffices() {
      var _this7 = this;

      if (!this.patientPosition || !this.searchForm.type) {
        return false;
      }

      this.nearbyPartnerOffices = [];

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("https://us-central1-tooddoc-dev.cloudfunctions.net" + "/getPartnerOffices", {
        params: {
          userId: this.userId ? this.userId : "XXXXXXXXXXXXXXXXXXXXXXXXXXXX",
          medicalPractice: this.searchForm.type,
          language: this.shortCode,
          latitude: this.patientPosition._lat,
          longitude: this.patientPosition._long
        },
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function (response) {
        _this7.nearbyPartnerOffices = response.data.map(function (office) {
          office["distance"] = window.distanceBetween(office.officeLatitude, office.officeLongitude, _this7.patientPosition._lat, _this7.patientPosition._long);

          return office;
        });
      }).catch(function (error) {
        console.log("error", error);
      });
    },
    refreshGroups: function refreshGroups() {
      this.groups = [];
      var groupIndexes = [];

      for (var i = 0; i < this.timeslots.length; i++) {
        var timeslot = this.timeslots[i];
        var index = _.findIndex(this.groups, { officeId: timeslot.officeId });

        if (index >= 0) {
          var group = this.groups[index];

          if (group.date >= timeslot.date) {
            group.date = timeslot.date;

            if (group.time >= timeslot.time) {
              group.time = timeslot.time;
            }
          }

          group.timeslots.push(timeslot);

          this.$set(this.groups, index, group);
        } else {
          this.groups.push({
            date: timeslot.date,
            time: timeslot.time,
            distance: timeslot.distance,
            doctorId: timeslot.doctorId,
            doctorAvatar: timeslot.doctorAvatar,
            doctorFirstName: timeslot.doctorFirstName,
            doctorLastName: timeslot.doctorLastName,
            isDoctorRegulated: timeslot.isDoctorRegulated,
            officeCountry: timeslot.officeCountry,
            officeCountryId: timeslot.officeCountryId,
            officeId: timeslot.officeId,
            officeLocality: timeslot.officeLocality,
            officeLocation: timeslot.officeLocation,
            officeName: timeslot.officeName,
            officePhone: timeslot.officePhone,
            officeStreetName: timeslot.officeStreetName,
            officeStreetNumber: timeslot.officeStreetNumber,
            officeZipCode: timeslot.officeZipCode,
            type: timeslot.type,
            timeslots: [timeslot]
          });
        }
      }

      this.loadingTimeslots = false;
      this.fetchNearbyOffices();
    },
    fetchPatientResources: function fetchPatientResources() {
      var _this8 = this;

      this.hasAppointments = false;
      this.loadingAppointments = true;
      this.hasInvitations = false;
      this.loadingInvitations = true;
      this.hasEmergencies = false;
      this.loadingEmergencies = true;

      __WEBPACK_IMPORTED_MODULE_17__data_AppointmentRepository__["a" /* default */].allForPatient(this.userId, function (appointments) {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(appointments).length > 0) {
          _this8.loadingAppointments = false;
          _this8.hasAppointments = true;
        } else {
          __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("https://us-central1-tooddoc-dev.cloudfunctions.net" + "/getPartnerAppointments", {
            params: {
              userId: _this8.userId,
              language: _this8.shortCode
            },
            headers: {
              "Content-Type": "application/json"
            }
          }).then(function (response) {
            var now = __WEBPACK_IMPORTED_MODULE_8_moment___default()();
            var partnerAppointments = response.data.filter(function (appointment) {
              return now.diff(__WEBPACK_IMPORTED_MODULE_8_moment___default()(appointment.dateTime)) < 0;
            });

            _this8.loadingAppointments = false;
            if (partnerAppointments.length > 0) {
              _this8.hasAppointments = true;
            }
          }).catch(function (error) {
            _this8.loadingAppointments = false;
          });
        }
      }, function () {
        _this8.loadingAppointments = false;
      });

      __WEBPACK_IMPORTED_MODULE_18__data_AppointmentInvitationRepository__["a" /* default */].allForPatient(this.userId, function (invitations) {
        _this8.loadingInvitations = false;
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(invitations).length > 0) {
          _this8.hasInvitations = true;
        }
      }, function () {
        _this8.loadingInvitations = false;
      });

      __WEBPACK_IMPORTED_MODULE_19__data_EmergencyRepository__["a" /* default */].allForPatient(this.userId, function (emergencies) {
        _this8.loadingEmergencies = false;
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(emergencies).length > 0) {
          _this8.hasEmergencies = true;
        }
      }, function () {
        _this8.loadingEmergencies = false;
      });
    }
  }
});

/***/ }),
/* 354 */,
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_helpers__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'search-form',

    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            autocompleteOptions: {
                types: ['(regions)'],
                componentRestrictions: { country: 'be' }
            },
            isGeolocated: false,
            isGeolocating: false,
            google: null,
            type: null,
            place_id: null,
            types: ['DENTIST', 'GENERAL_PRACTITIONER', 'GYNECOLOGIST', 'OPHTHALMOLOGIST', 'PEDIATRICIAN', 'PSYCHOLOGIST', 'DERMATOLOGIST', 'OSTEOPATH', 'PSYCHIATRIST', 'PHYSIOTHERAPIST']
        };
    },

    computed: {
        sortedTypes: function sortedTypes() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(this.types.map(function (type) {
                return {
                    key: type,
                    label: _this.$t('type_' + type)
                };
            }), 'label');
        }
    },

    mounted: function mounted() {
        this.type = this.$route.query.type || this.patientMedicalPractice || localStorage.getItem('medicalPractice');

        if (!this.isGeolocating && !this.isGeolocated && !this.patientPlace) {
            if (this.$route.query.lat && this.$route.query.long) {
                this.isGeolocated = true;
                this.setPatientPlace(this.$t('Your_current_position'));
                this.setPatientPosition({
                    _lat: this.$route.query.lat,
                    _long: this.$route.query.long
                });

                this.submit();
            } else {
                var place = this.$route.query.place || localStorage.getItem('patientPlace');
                if (place && place !== 'null' && place !== null) {
                    this.useGoogleToSetPlace(place);
                } else {
                    this.geolocate();
                }
            }
        }
    },


    methods: {
        useGoogleToSetPlace: function useGoogleToSetPlace(place) {
            var _this2 = this;

            if (typeof window.google === 'undefined') {
                setTimeout(function () {
                    _this2.useGoogleToSetPlace(place);
                }, 500);

                return false;
            }
            if (window.google && window.google.maps && window.google.maps.places) {
                var service = new window.google.maps.places.PlacesService(document.getElementById('search-form-field'));

                service.getDetails({
                    placeId: place
                }, function (place, status) {
                    if (status == 'OK') {
                        _this2.setPlace(place);
                    } else {
                        _this2.geolocate();
                    }
                });
            }
        },
        geolocate: function geolocate() {
            var _this3 = this;

            this.isGeolocating = true;

            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function (position) {
                    _this3.isGeolocated = true;
                    _this3.setPatientPlace(_this3.$t('Your_current_position'));
                    _this3.setPatientPosition({
                        _lat: position.coords.latitude,
                        _long: position.coords.longitude
                    });

                    _this3.isGeolocating = false;

                    _this3.submit();
                }, function () {
                    _this3.isGeolocating = false;
                });
            } else {
                setTimeout(function () {
                    _this3.isGeolocating = false;
                }, 1000);
            }
        },
        setPlace: function setPlace(place) {
            this.isGeolocated = false;
            this.place_id = place.place_id;
            if (place.geometry) {
                this.setPatientPlace(place.formatted_address);
                this.setPatientPlaceName(place.name);
                this.setPatientPosition({
                    _lat: place.geometry.location.lat(),
                    _long: place.geometry.location.lng()
                });
            } else {
                this.setPatientPlace('');
                this.setPatientPlaceName('');
                this.setPatientPosition(null);
            }

            this.submit();
        },
        submit: function submit() {
            if (this.type === null) {
                return false;
            }

            this.setPatientMedicalPractice(this.type);

            this.$router.push({ query: { type: this.type, place: this.place_id } });

            this.$emit('input', { type: this.type, place: this.place_id });

            this.$emit('submit');

            this.$ga.event({
                eventCategory: 'SearchTimeSlot',
                eventAction: 'Location',
                eventLabel: this.patientPlaceName
            });

            this.$ga.event({
                eventCategory: 'SearchTimeSlot',
                eventAction: 'MedicalPractice',
                eventLabel: this.type
            });
        }
    },

    watch: {
        place_id: function place_id(newValue, oldValue) {
            localStorage.setItem('patientPlace', newValue);
        },
        type: function type(newValue, oldValue) {
            localStorage.setItem('medicalPractice', newValue);
            this.submit();
        }
    }
});

/***/ }),
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Patient_OfficeSettings__ = __webpack_require__(71);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "office-list-item",

  components: { OfficeSettings: __WEBPACK_IMPORTED_MODULE_1__components_Patient_OfficeSettings__["a" /* default */] },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

  props: ["office"],

  methods: {
    handleClick: function handleClick() {
      this.$router.push({
        name: "office.show",
        params: { id: this.office.id }
      });
    }
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PartnerAvatar_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Patient_PartnerTimeslotSelectionModal_vue__ = __webpack_require__(752);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'partner-timeslot-list-item',

    components: { PartnerAvatar: __WEBPACK_IMPORTED_MODULE_1__components_PartnerAvatar_vue__["a" /* default */], PartnerTimeslotSelectionModal: __WEBPACK_IMPORTED_MODULE_2__components_Patient_PartnerTimeslotSelectionModal_vue__["a" /* default */] },

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    props: ['item'],

    data: function data() {
        return {
            showTimeslotSelection: false
        };
    },


    computed: {
        sortedSlots: function sortedSlots() {
            return _.take(_.sortBy(this.item.timeslots, ['dateTime']), 5);
        }
    },

    methods: {
        handleClick: function handleClick() {
            if (this.item.timeslots.length > 1) {
                this.showTimeslotSelectionModal();
            } else {
                this.$router.push({ name: 'partner-timeslot.show', query: {
                        doctorId: this.item.timeslots[0].doctorId,
                        dateTime: this.item.timeslots[0].dateTime,
                        medicalPractice: this.item.timeslots[0].medicalPractice,
                        latitude: this.item.timeslots[0].officeLatitude,
                        longitude: this.item.timeslots[0].officeLongitude
                    } });
            }
        },
        showTimeslotSelectionModal: function showTimeslotSelectionModal() {
            this.showTimeslotSelection = true;
            this.setPreventBodyScroll(true);
        },
        hideTimeslotSelectionModal: function hideTimeslotSelectionModal() {
            this.showTimeslotSelection = false;
            this.setPreventBodyScroll(false);
        }
    }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PartnerAvatar_vue__ = __webpack_require__(53);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'timeslot-selection-modal',

    props: ['active', 'partner'],

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    components: { PartnerAvatar: __WEBPACK_IMPORTED_MODULE_1__components_PartnerAvatar_vue__["a" /* default */] },

    data: function data() {
        return {
            selectedTimeslot: null
        };
    },


    computed: {
        sortedTimeslots: function sortedTimeslots() {
            return _.sortBy(this.partner.timeslots, ['dateTime']);
        }
    },

    methods: {
        close: function close() {
            this.$emit('close');
        }
    }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PartnerAvatar_vue__ = __webpack_require__(53);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'partner-office-list-item',

    components: { PartnerAvatar: __WEBPACK_IMPORTED_MODULE_1__components_PartnerAvatar_vue__["a" /* default */] },

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    props: ['office'],

    methods: {
        handleClick: function handleClick() {
            this.$router.push({ name: 'partner-office.show', query: {
                    doctorId: this.office.doctorId,
                    medicalPractice: this.office.medicalPractice,
                    latitude: this.office.officeLatitude,
                    longitude: this.office.officeLongitude
                } });
        }
    }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Patient_TimeslotSelectionModal_vue__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Patient_OfficeSettings_vue__ = __webpack_require__(71);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'timeslot-group-list-item',

    components: { TimeslotSelectionModal: __WEBPACK_IMPORTED_MODULE_1__components_Patient_TimeslotSelectionModal_vue__["a" /* default */], OfficeSettings: __WEBPACK_IMPORTED_MODULE_2__components_Patient_OfficeSettings_vue__["a" /* default */] },

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    props: ['item'],

    data: function data() {
        return {
            showTimeslotSelection: false
        };
    },


    computed: {
        sortedSlots: function sortedSlots() {
            return _.take(_.sortBy(this.item.timeslots, ['date', 'time']), 5);
        }
    },

    methods: {
        handleClick: function handleClick() {
            if (this.item.timeslots.length > 1) {
                this.showTimeslotSelectionModal();
            } else {
                this.$router.push({ name: 'timeslot.show', params: { id: this.item.timeslots[0].id } });
            }
        },
        showTimeslotSelectionModal: function showTimeslotSelectionModal() {
            this.showTimeslotSelection = true;
            this.setPreventBodyScroll(true);
        },
        hideTimeslotSelectionModal: function hideTimeslotSelectionModal() {
            this.showTimeslotSelection = false;
            this.setPreventBodyScroll(false);
        }
    }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'timeslot-selection-modal',

    props: ['active', 'group'],

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            selectedTimeslot: null
        };
    },


    computed: {
        sortedTimeslots: function sortedTimeslots() {
            return _.sortBy(this.group.timeslots, ['date', 'time']);
        }
    },

    methods: {
        close: function close() {
            this.$emit('close');
        }
    }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WaitingListButton_vue__ = __webpack_require__(379);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14fa5973_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WaitingListButton_vue__ = __webpack_require__(761);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WaitingListButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14fa5973_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WaitingListButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/WaitingListButton.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-14fa5973", Component.options)
  } else {
    hotAPI.reload("data-v-14fa5973", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'waiting-list-button'
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_awesome_phonenumber__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_awesome_phonenumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_awesome_phonenumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Patient_Bubble__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Patient_HeaderNav__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_EmergencyRepository__ = __webpack_require__(31);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'EmergencyNew',

    mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_helpers__["a" /* default */]],

    components: { Bubble: __WEBPACK_IMPORTED_MODULE_9__components_Patient_Bubble__["a" /* default */], HeaderNav: __WEBPACK_IMPORTED_MODULE_10__components_Patient_HeaderNav__["a" /* default */] },

    data: function data() {
        return {
            step: 'patientForm',
            isBooked: false,
            emergency: null,
            questions: [],
            sections: [],
            symptoms: {},
            currentSection: 0,
            errorText: false,
            autocompleteOptions: {
                types: ['(regions)'],
                componentRestrictions: { country: 'be' }
            },
            patientForm: {
                lastName: '',
                firstName: '',
                email: '',
                id: '',
                phone: '',
                age: '',
                locality: '',
                zipCode: null,
                location: '',
                type: null
            },
            types: ['DENTIST', 'GENERAL_PRACTITIONER', 'GYNECOLOGIST', 'OPHTHALMOLOGIST', 'PEDIATRICIAN', 'PSYCHOLOGIST', 'DERMATOLOGIST', 'OSTEOPATH', 'PSYCHIATRIST', 'PHYSIOTHERAPIST']
        };
    },
    mounted: function mounted() {
        var firebaseUser = __WEBPACK_IMPORTED_MODULE_5_firebase_app___default.a.auth().currentUser;

        if (firebaseUser) {
            this.prefillFromFirebase();
        } else {
            this.showLogin();
        }

        if (this.patientMedicalPractice) {
            this.patientForm.type = this.patientMedicalPractice;
        } else if (this.$route.query.type) {
            this.patientForm.type = this.$route.query.type;
        }

        this.populateSymptoms();
    },


    methods: {
        showLogin: function showLogin() {
            this.$refs.headerNav.showLogin();
        },
        changeStep: function changeStep(step) {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (step != 'submissionError') {
                                    _this.errorText = false;
                                }

                                if (!(step == 'patientSymptoms')) {
                                    _context.next = 4;
                                    break;
                                }

                                _context.next = 4;
                                return _this.populateSymptoms();

                            case 4:

                                _this.step = step;
                                window.scrollTo(0, 0);

                            case 6:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        submitPatientForm: function submitPatientForm() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (!_this2.patientForm.locality || !_this2.patientForm.location) {
                    _this2.errors.add({ field: 'locality', msg: 'Locality ou Location is missing.' });
                } else if (result) {
                    _this2.changeStep('patientSymptoms');
                }
            });
        },
        submitPatientSymptoms: function submitPatientSymptoms() {
            this.changeStep('submissionSummary');
        },
        confirmReservation: function confirmReservation() {
            var _this3 = this;

            this.changeStep('submitting');

            var patient = {
                id: this.patientForm.id,
                firstName: this.hashPatientInfo(this.patientForm.firstName),
                lastName: this.hashPatientInfo(this.patientForm.lastName),
                age: parseInt(this.patientForm.age),
                email: this.hashPatientInfo(this.patientForm.email),
                phone: this.hashPatientInfo(this.patientForm.phone),
                zipCode: this.patientForm.zipCode,
                locality: this.patientForm.locality,
                location: this.patientForm.location,
                symptoms: this.sections,
                type: this.patientForm.type
            };

            __WEBPACK_IMPORTED_MODULE_11__data_EmergencyRepository__["a" /* default */].create(patient, function () {
                _this3.changeStep('submitted');

                _this3.$ga.event({
                    eventCategory: 'Emergencies',
                    eventAction: 'CreateEmergency'
                });

                setTimeout(function () {
                    _this3.$router.push('/');
                }, 3000);
            }, function (error) {
                _this3.errorText = error.message;
                _this3.changeStep('submissionError');
            });
        },
        prefillFromFirebase: function prefillFromFirebase() {
            var firebaseUser = __WEBPACK_IMPORTED_MODULE_5_firebase_app___default.a.auth().currentUser;

            if (firebaseUser) {
                this.patientForm.id = firebaseUser.uid;

                this.patientForm.email = firebaseUser.email;
                this.patientForm.phone = firebaseUser.phoneNumber;

                var splittedName = firebaseUser.displayName.split(" ");
                this.patientForm.firstName = splittedName[0];
                delete splittedName[0];
                this.patientForm.lastName = splittedName.join(" ").trim();

                this.patientForm.locality = this.patientPlaceName ? this.patientPlace : '';
                this.patientForm.location = this.patientPosition ? new __WEBPACK_IMPORTED_MODULE_5_firebase_app___default.a.firestore.GeoPoint(this.patientPosition._lat, this.patientPosition._long) : null;
            }
        },
        getElementInLanguage: function getElementInLanguage(element) {
            var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            if ((typeof element === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(element)) !== 'object') {
                return null;
            }

            if (language === null) {
                language = this.$store.state.frontLanguage;
            }

            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(element).includes(language)) {
                return element[language];
            }

            if (language === 'en') {
                return element[__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(element)[0]];
            }

            return this.getElementInLanguage(element, 'en');
        },
        populateSymptoms: function populateSymptoms() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var _ref, data, splitInSections;

                return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return __WEBPACK_IMPORTED_MODULE_6_axios___default.a.get("https://us-central1-tooddoc-dev.cloudfunctions.net/api" + '/app/questions', {
                                    params: {
                                        type: _this4.patientForm.type
                                    }
                                });

                            case 2:
                                _ref = _context2.sent;
                                data = _ref.data;
                                splitInSections = false;

                                _this4.sections = [];
                                _this4.currentSection = 0;

                                data.map(function (question) {
                                    if (question.type === 'title') {
                                        splitInSections = true;

                                        var section = {
                                            title: _this4.getElementInLanguage(question.label),
                                            description: _this4.getElementInLanguage(question.description),
                                            questions: question.questions.map(function (q) {
                                                var mappedQ = q;
                                                if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(mappedQ).includes('choices')) {
                                                    mappedQ.choices = mappedQ.choices.map(function (choice) {
                                                        return _this4.getElementInLanguage(choice);
                                                    });
                                                }

                                                mappedQ.label = _this4.getElementInLanguage(mappedQ.label);
                                                if (mappedQ.type === 'boolean') {
                                                    mappedQ.value = false;
                                                } else if (mappedQ.type === 'checkboxes') {
                                                    mappedQ.value = [];
                                                } else {
                                                    mappedQ.value = '';
                                                }

                                                return mappedQ;
                                            })
                                        };

                                        _this4.sections.push(section);
                                    } else {
                                        _this4.sections.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, question, {
                                            value: []
                                        }));
                                    }
                                });

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4);
            }))();
        },
        transformPhone: function transformPhone() {
            if (this.patientForm.phone) {
                var phoneNumber = new __WEBPACK_IMPORTED_MODULE_8_awesome_phonenumber___default.a(this.patientForm.phone, "BE");

                if (phoneNumber.isValid()) {
                    this.patientForm.phone = phoneNumber.getNumber('international');
                }
            }
        },
        setPatientFormLocality: function setPatientFormLocality(place) {
            if (place.geometry) {
                this.patientForm.locality = place.formatted_address;
                this.patientForm.location = new __WEBPACK_IMPORTED_MODULE_5_firebase_app___default.a.firestore.GeoPoint(place.geometry.location.lat(), place.geometry.location.lng());
            } else {
                this.patientForm.locality = '';
                this.patientForm.location = null;
            }
        },
        nextSection: function nextSection() {
            var _this5 = this;

            this.$validator.validateAll('section-' + this.currentSection).then(function (result) {
                if (result) {
                    if (_this5.currentSection >= _this5.sections.length - 1) {
                        _this5.submitPatientSymptoms();
                    } else {
                        _this5.currentSection++;
                        window.scrollTo(0, 0);
                    }
                }
            });
        },
        previousSection: function previousSection() {
            if (this.currentSection > 0) {
                this.currentSection--;
                window.scrollTo(0, 0);
            }
        },
        toggleSymptom: function toggleSymptom(question, symptom) {
            if (question.value.length && question.value.includes(symptom)) {
                question.value = question.value.filter(function (val) {
                    return val !== symptom;
                });
            } else {
                if (question.value.length) {
                    question.value.push(symptom);
                } else {
                    question.value = [symptom];
                }
            }
        },
        conditionsMatches: function conditionsMatches(question, section) {
            var match = true;

            question.conditions.forEach(function (condition) {
                var conditionQuestion = section.questions[condition.question];
                if (condition.comparison === '=') {
                    if (conditionQuestion.value !== condition.value) {
                        match = false;
                    }
                }
            });

            return match;
        }
    },

    watch: {
        'patientForm.locality': function patientFormLocality(newValue, oldValue) {
            this.errors.remove('locality');
        },
        '$store.state.frontLanguage': function $storeStateFrontLanguage() {
            this.populateSymptoms();
        }
    }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Patient_Bubble__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Patient_HeaderNav__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Patient_WaitingListButton__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Patient_OfficeSettings__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_EmergencyRepository__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_OfficeRepository__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_TimeSlotRepository__ = __webpack_require__(36);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'OfficeShow',

    mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_helpers__["a" /* default */]],

    components: { Bubble: __WEBPACK_IMPORTED_MODULE_5__components_Patient_Bubble__["a" /* default */], HeaderNav: __WEBPACK_IMPORTED_MODULE_6__components_Patient_HeaderNav__["a" /* default */], WaitingListButton: __WEBPACK_IMPORTED_MODULE_7__components_Patient_WaitingListButton__["a" /* default */], OfficeSettings: __WEBPACK_IMPORTED_MODULE_8__components_Patient_OfficeSettings__["a" /* default */] },

    data: function data() {
        return {
            loadingTimeslots: true,
            office: null,
            timeslots: [],
            hasEmergencies: false
        };
    },


    computed: {
        sortedTimeslots: function sortedTimeslots() {
            return _.sortBy(this.timeslots, ['date', 'time']);
        }
    },

    mounted: function mounted() {
        this.fetchOffice();
    },


    methods: {
        showLogin: function showLogin() {
            this.$refs.headerNav.showLogin();
        },
        fetchOffice: function fetchOffice() {
            var _this = this;

            this.officeId = this.$route.params.id;

            __WEBPACK_IMPORTED_MODULE_10__data_OfficeRepository__["a" /* default */].find(this.officeId, function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(office) {
                    var ok;
                    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    if (office.isDoctorCertified) {
                                        _context.next = 5;
                                        break;
                                    }

                                    _this.alertPatientError(_this.$t('Errors.offices_could_not_be_loaded'));

                                    return _context.abrupt('return', _this.$router.push('/'));

                                case 5:
                                    _this.office = office;
                                    ok = office.isDoctorRegulated && office.doctorType !== 'OSTEOPATH';


                                    _this.fetchTimeslots();
                                    _this.fetchEmergencies();

                                case 9:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this);
                }));

                return function (_x) {
                    return _ref.apply(this, arguments);
                };
            }(), function () {
                _this.alertPatientError(_this.$t('Errors.offices_could_not_be_loaded'));
            });
        },
        fetchTimeslots: function fetchTimeslots() {
            var _this2 = this;

            this.loadingTimeslots = true;
            __WEBPACK_IMPORTED_MODULE_11__data_TimeSlotRepository__["a" /* default */].allForOffice(this.officeId, function (timeslots) {
                _this2.timeslots = timeslots;

                _this2.loadingTimeslots = false;
            }, function () {
                _this2.alertPatientError(_this2.$t('Errors.timeslotss_could_not_be_loaded'));

                _this2.loadingTimeslots = false;
            });
        },
        fetchEmergencies: function fetchEmergencies() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_9__data_EmergencyRepository__["a" /* default */].allForPatient(this.userId, function (emergencies) {
                _this3.loadingEmergencies = false;
                if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(emergencies).length > 0) {
                    _this3.hasEmergencies = true;
                }
            }, function () {
                _this3.loadingEmergencies = false;
            });
        }
    }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_awesome_phonenumber__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_awesome_phonenumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_awesome_phonenumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Patient_Bubble__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Patient_HeaderNav__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Patient_OfficeSettings__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_OfficeRepository__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_TimeSlotRepository__ = __webpack_require__(36);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'TimeslotShow',

    mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_helpers__["a" /* default */]],

    components: { Bubble: __WEBPACK_IMPORTED_MODULE_7__components_Patient_Bubble__["a" /* default */], HeaderNav: __WEBPACK_IMPORTED_MODULE_8__components_Patient_HeaderNav__["a" /* default */], OfficeSettings: __WEBPACK_IMPORTED_MODULE_9__components_Patient_OfficeSettings__["a" /* default */] },

    data: function data() {
        return {
            step: 'timeslotDetails',
            isBooked: false,
            timeslot: null,
            questions: [],
            errorText: false,
            patientForm: {
                lastName: '',
                firstName: '',
                email: '',
                id: '',
                phone: '',
                age: ''
            }
        };
    },
    mounted: function mounted() {
        this.prefillFromFirebase();

        this.fetchTimeslot();
    },


    methods: {
        showLogin: function showLogin() {
            this.$refs.headerNav.showLogin();
        },
        changeStep: function changeStep(step) {
            if (step != 'submissionError') {
                this.errorText = false;
            }

            if (step == 'patientSymptoms') {
                // Make sure this gets loaded after the translation is done
                this.populateSymptoms();
            }

            this.step = step;
            window.scrollTo(0, 0);
        },
        submitPatientForm: function submitPatientForm() {
            var _this = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this.changeStep('patientSymptoms');
                }
            });
        },
        submitPatientSymptoms: function submitPatientSymptoms() {
            var _this2 = this;

            this.$validator.validateAll().then(function (result) {
                if (result) {
                    _this2.changeStep('submissionSummary');
                }
            });
        },
        confirmReservation: function confirmReservation() {
            var _this3 = this;

            this.changeStep('submitting');

            var patient = {
                id: this.patientForm.id,
                firstName: this.hashPatientInfo(this.patientForm.firstName),
                lastName: this.hashPatientInfo(this.patientForm.lastName),
                age: parseInt(this.patientForm.age),
                email: this.hashPatientInfo(this.patientForm.email),
                phone: this.hashPatientInfo(this.patientForm.phone),
                symptoms: []
            };

            for (var i in this.questions) {
                if (i < 4 || this.questions[4].answer == this.$t('SYMPTOMS_ANSWER_5_1')) {
                    if (this.questions[i].answer) {
                        patient.symptoms.push({
                            question: this.questions[i].label.replace('&nbsp;', ' '),
                            answer: this.questions[i].answer
                        });
                    }
                }
            }

            var timeslotRemapped = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.timeslot, { symptoms: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.questions)) });

            __WEBPACK_IMPORTED_MODULE_11__data_TimeSlotRepository__["a" /* default */].bookForPatient(patient, timeslotRemapped, function () {
                _this3.isBooked = true;
                _this3.changeStep('submitted');

                _this3.$ga.event({
                    eventCategory: 'TimeSlots',
                    eventAction: 'BookTimeSlot'
                });

                setTimeout(function () {
                    _this3.$router.push('/');
                }, 3000);
            }, function (error) {
                window.bugsnagClient && window.bugsnagClient.notify(error.message);
                _this3.errorText = error.message;
                _this3.changeStep('submissionError');
            });
        },
        prefillFromFirebase: function prefillFromFirebase() {
            var firebaseUser = __WEBPACK_IMPORTED_MODULE_4_firebase_app___default.a.auth().currentUser;

            if (firebaseUser) {
                this.patientForm.id = firebaseUser.uid;

                this.patientForm.email = firebaseUser.email;
                this.patientForm.phone = firebaseUser.phoneNumber;

                var splittedName = firebaseUser.displayName.split(" ");
                this.patientForm.firstName = splittedName[0];
                delete splittedName[0];
                this.patientForm.lastName = splittedName.join(" ").trim();
            }
        },
        populateSymptoms: function populateSymptoms() {
            if (this.timeslot.type === 'DENTIST') {
                this.questions = [
                // 1
                {
                    label: this.$t('SYMPTOMS_QUESTION_1'),
                    choices: [this.$t('SYMPTOMS_ANSWER_1_1'), this.$t('SYMPTOMS_ANSWER_1_2'), this.$t('SYMPTOMS_ANSWER_1_3'), this.$t('SYMPTOMS_ANSWER_1_4')],
                    answer: null
                },
                // 2
                {
                    label: this.$t('SYMPTOMS_QUESTION_2'),
                    choices: [this.$t('SYMPTOMS_ANSWER_2_1'), this.$t('SYMPTOMS_ANSWER_2_2'), this.$t('SYMPTOMS_ANSWER_2_3'), this.$t('SYMPTOMS_ANSWER_2_4')],
                    answer: null
                },
                // 3
                {
                    label: this.$t('SYMPTOMS_QUESTION_3'),
                    choices: [this.$t('SYMPTOMS_ANSWER_3_1'), this.$t('SYMPTOMS_ANSWER_3_2')],
                    answer: null
                },
                // 4
                {
                    label: this.$t('SYMPTOMS_QUESTION_4'),
                    choices: [this.$t('SYMPTOMS_ANSWER_4_1'), this.$t('SYMPTOMS_ANSWER_4_2')],
                    answer: null
                },
                // 5
                {
                    label: this.$t('SYMPTOMS_QUESTION_5'),
                    choices: [this.$t('SYMPTOMS_ANSWER_5_1'), this.$t('SYMPTOMS_ANSWER_5_2')],
                    answer: null
                },
                // 6
                {
                    label: this.$t('SYMPTOMS_QUESTION_6'),
                    choices: [this.$t('SYMPTOMS_ANSWER_6_1'), this.$t('SYMPTOMS_ANSWER_6_2'), this.$t('SYMPTOMS_ANSWER_6_3'), this.$t('SYMPTOMS_ANSWER_6_4')],
                    answer: null
                },
                // 7
                {
                    label: this.$t('SYMPTOMS_QUESTION_7'),
                    choices: [this.$t('SYMPTOMS_ANSWER_7_1'), this.$t('SYMPTOMS_ANSWER_7_2')],
                    answer: null
                }];
            } else {
                this.questions = [{
                    label: this.$t('SYMPTOMS_QUESTION'),
                    answer: ''
                }];
            }
        },
        fetchTimeslot: function fetchTimeslot() {
            var _this4 = this;

            this.timeslotId = this.$route.params.id;

            __WEBPACK_IMPORTED_MODULE_11__data_TimeSlotRepository__["a" /* default */].find(this.timeslotId, function () {
                var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(timeslot) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    // Load office
                                    __WEBPACK_IMPORTED_MODULE_10__data_OfficeRepository__["a" /* default */].find(timeslot.officeId, function (office) {

                                        if (!office || !office.isDoctorCertified) {
                                            _this4.alertPatientError(_this4.$t('timeslots_could_not_be_loaded'));
                                            return _this4.$router.push('/');
                                        } else {
                                            _this4.timeslot = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, timeslot, { isDoctorMemberOfOsteopathie: office.isDoctorMemberOfOsteopathie, officeSettings: office.officeSettings });
                                            _this4.isBooked = timeslot.appointmentId ? true : false;
                                        }
                                    }, function (error) {
                                        _this4.alertPatientError(_this4.$t('timeslots_could_not_be_loaded'));
                                        return _this4.$router.push('/');
                                    });

                                case 1:
                                case 'end':
                                    return _context.stop();
                            }
                        }
                    }, _callee, _this4);
                }));

                return function (_x) {
                    return _ref.apply(this, arguments);
                };
            }(), function () {
                console.log('TIMESLOT ERROR');
                _this4.alertPatientError(_this4.$t('timeslots_could_not_be_loaded'));
                return _this4.$router.push('/');
            });
        },
        transformPhone: function transformPhone() {
            if (this.patientForm.phone) {
                var phoneNumber = new __WEBPACK_IMPORTED_MODULE_6_awesome_phonenumber___default.a(this.patientForm.phone, "BE");

                if (phoneNumber.isValid()) {
                    this.patientForm.phone = phoneNumber.getNumber('international');
                }
            }
        }
    }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Patient_HeaderNav__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PartnerAvatar_vue__ = __webpack_require__(53);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'PartnerOfficeShow',

    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_helpers__["a" /* default */]],

    components: { HeaderNav: __WEBPACK_IMPORTED_MODULE_4__components_Patient_HeaderNav__["a" /* default */], PartnerAvatar: __WEBPACK_IMPORTED_MODULE_5__components_PartnerAvatar_vue__["a" /* default */] },

    data: function data() {
        return {
            office: null
        };
    },
    mounted: function mounted() {
        this.fetchOffice();
    },


    methods: {
        showLogin: function showLogin() {
            this.$refs.headerNav.showLogin();
        },
        handleClick: function handleClick() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.$ga.event({
                                    eventCategory: 'PartnerTimeSlot',
                                    eventAction: 'BookPartnerTimeSlot',
                                    eventLabel: _this.office.partnerName
                                });

                            case 2:

                                window.open(_this.office.partnerUrl, '_blank');

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        fetchOffice: function fetchOffice() {
            var _this2 = this;

            var doctorId = this.$route.query.doctorId;
            var latitude = this.$route.query.latitude;
            var longitude = this.$route.query.longitude;
            var medicalPractice = this.$route.query.medicalPractice;

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://us-central1-tooddoc-dev.cloudfunctions.net" + '/getPartnerOffices', {
                params: {
                    userId: this.userId,
                    medicalPractice: medicalPractice,
                    language: this.patientLanguage.shortCode,
                    latitude: latitude,
                    longitude: longitude
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function (_ref) {
                var data = _ref.data;

                var offices = data.filter(function (office) {
                    return office.doctorId == doctorId;
                });

                if (offices.length > 0) {
                    _this2.office = offices[0];
                } else {
                    alert($('This_office_does_not_exist'));
                    _this2.$router.push('/');
                }
            }).catch(function (error) {
                console.log('error', error);
            });
        }
    }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Patient_HeaderNav__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PartnerAvatar_vue__ = __webpack_require__(53);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'PartnerTimeslotShow',

    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_helpers__["a" /* default */]],

    components: { HeaderNav: __WEBPACK_IMPORTED_MODULE_4__components_Patient_HeaderNav__["a" /* default */], PartnerAvatar: __WEBPACK_IMPORTED_MODULE_5__components_PartnerAvatar_vue__["a" /* default */] },

    data: function data() {
        return {
            isBooked: false,
            timeslot: null,
            showPartnerMessage: false
        };
    },
    mounted: function mounted() {
        var medicalPractice = this.$route.query.medicalPractice;

        if (medicalPractice) {
            this.fetchTimeslot();
        } else {
            this.fetchAppointment();
        }
    },


    methods: {
        showLogin: function showLogin() {
            this.$refs.headerNav.showLogin();
        },
        handleClick: function handleClick() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!_this.isBooked) {
                                    _context.next = 5;
                                    break;
                                }

                                _context.next = 3;
                                return _this.$ga.event({
                                    eventCategory: 'PartnerAppointment',
                                    eventAction: 'BookPartnerAppointment',
                                    eventLabel: _this.timeslot.partnerName
                                });

                            case 3:
                                _context.next = 7;
                                break;

                            case 5:
                                _context.next = 7;
                                return _this.$ga.event({
                                    eventCategory: 'PartnerTimeSlot',
                                    eventAction: 'BookPartnerTimeSlot',
                                    eventLabel: _this.timeslot.partnerName
                                });

                            case 7:

                                window.open(_this.timeslot.partnerUrl, '_blank');

                            case 8:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },
        fetchAppointment: function fetchAppointment() {
            var _this2 = this;

            if (!this.userId) {
                this.$router.push('/');

                return false;
            }

            var doctorId = this.$route.query.doctorId;
            var dateTime = this.$route.query.dateTime;
            var latitude = this.$route.query.latitude;
            var longitude = this.$route.query.longitude;
            var medicalPractice = this.$route.query.medicalPractice;

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://us-central1-tooddoc-dev.cloudfunctions.net" + '/getPartnerAppointments', {
                params: {
                    userId: this.userId,
                    language: this.patientLanguage.shortCode
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                var appointments = response.data.filter(function (appointment) {
                    return appointment.dateTime === dateTime && appointment.doctorId === doctorId;
                });

                if (appointments.length > 0) {
                    _this2.timeslot = appointments[0];
                    _this2.isBooked = true;
                } else {
                    // Timeslot does not exist
                    _this2.$router.push('/');
                }
            }).catch(function (error) {
                console.log('error', error);
            });
        },
        fetchTimeslot: function fetchTimeslot() {
            var _this3 = this;

            var doctorId = this.$route.query.doctorId;
            var dateTime = this.$route.query.dateTime;
            var latitude = this.$route.query.latitude;
            var longitude = this.$route.query.longitude;
            var medicalPractice = this.$route.query.medicalPractice;

            __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get("https://us-central1-tooddoc-dev.cloudfunctions.net" + '/getPartnerTimeSlots', {
                params: {
                    userId: this.userId ? this.userId : 'XXXXXXXXXXXXXXXXXXXXXXXXXXXX',
                    medicalPractice: medicalPractice,
                    language: this.patientLanguage.shortCode,
                    latitude: latitude,
                    longitude: longitude
                },
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(function (response) {
                var timeslots = response.data.filter(function (timeslot) {
                    return timeslot.dateTime === dateTime && timeslot.doctorId === doctorId;
                });

                if (timeslots.length > 0) {
                    _this3.timeslot = timeslots[0];
                } else {
                    _this3.fetchAppointment();
                }
            }).catch(function (error) {
                _this3.fetchAppointment();
                console.log('error', error);
            });
        }
    }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Patient_HeaderNav__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Patient_CancelAppointmentModal__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_AppointmentRepository__ = __webpack_require__(72);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AppointmentShow",

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_helpers__["a" /* default */]],

  components: { HeaderNav: __WEBPACK_IMPORTED_MODULE_2__components_Patient_HeaderNav__["a" /* default */], CancelAppointmentModal: __WEBPACK_IMPORTED_MODULE_3__components_Patient_CancelAppointmentModal__["a" /* default */] },

  data: function data() {
    return {
      appointment: null,
      showCancelModal: false,
      errorText: null
    };
  },
  mounted: function mounted() {
    this.fetchAppointment();
  },


  methods: {
    showCancel: function showCancel() {
      this.showCancelModal = true;
    },
    hideCancel: function hideCancel() {
      this.showCancelModal = false;
    },
    showOfficePhone: function showOfficePhone() {
      alert(this.$t("Call_the_doctor_at_this_number", {
        phoneNumber: this.appointment.officePhone
      }));
    },
    fetchAppointment: function fetchAppointment() {
      var _this = this;

      this.appointmentId = this.$route.params.id;

      __WEBPACK_IMPORTED_MODULE_4__data_AppointmentRepository__["a" /* default */].find(this.appointmentId, function (appointment) {
        if (appointment.patientId === _this.patient.id) {
          _this.appointment = appointment;
        } else {
          _this.$router.push("/");
        }

        _this.setLoading(false);
      }, function (error) {
        _this.errorText = error.message;
      });
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_helpers__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'cancel-appointment-modal',

    props: ['active', 'appointment'],

    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_helpers__["a" /* default */]],

    methods: {
        close: function close() {
            this.$emit('close');
        }
    }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Patient_HeaderNav__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Patient_DeclineInvitationModal__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_AppointmentInvitationRepository__ = __webpack_require__(54);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'InvitationShow',

    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_helpers__["a" /* default */]],

    components: { HeaderNav: __WEBPACK_IMPORTED_MODULE_2__components_Patient_HeaderNav__["a" /* default */], DeclineInvitationModal: __WEBPACK_IMPORTED_MODULE_3__components_Patient_DeclineInvitationModal__["a" /* default */] },

    data: function data() {
        return {
            step: 'invitationDetails',
            invitation: null,
            showDeclineModal: false,
            errorText: false
        };
    },
    mounted: function mounted() {
        this.fetchInvitation();
    },


    methods: {
        showDecline: function showDecline() {
            this.showDeclineModal = true;
        },
        hideDecline: function hideDecline() {
            this.showDeclineModal = false;
        },
        fetchInvitation: function fetchInvitation() {
            var _this = this;

            this.setLoading(true);

            var invitationId = this.$route.params.id;

            __WEBPACK_IMPORTED_MODULE_4__data_AppointmentInvitationRepository__["a" /* default */].find(invitationId, function (invitation) {
                if (invitation.patientId != _this.userId) {
                    throw new Error(_this.$t('Errors.appointment_invitation_could_not_be_loaded'));
                }

                if (invitation.appointmentId) {
                    throw new Error(_this.$t('Errors.appointment_invitation_already_accepted'));
                }

                if (invitation.hasBeenCancelled || invitation.hasBeenAutoCancelled) {
                    throw new Error(_this.$t('Errors.appointment_invitation_cancelled'));
                }

                if (invitation.hasBeenDeclined) {
                    throw new Error(_this.$t('Errors.appointment_invitation_declined'));
                }

                _this.invitation = invitation;

                if (_this.$route.params.decline == true) {
                    _this.showDecline();
                }
            }, function (error) {
                _this.changeStep('submissionError');
                _this.errorText = error.message;
            });
        },
        changeStep: function changeStep(step) {
            if (step != 'submissionError') {
                this.errorText = false;
            }

            this.step = step;
            window.scrollTo(0, 0);
        },
        accept: function accept() {
            var _this2 = this;

            this.changeStep('submitting');

            __WEBPACK_IMPORTED_MODULE_4__data_AppointmentInvitationRepository__["a" /* default */].acceptByPatient(this.invitation, function (id) {
                _this2.changeStep('submitted');

                _this2.$ga.event({
                    eventCategory: 'AppointmentInvitations',
                    eventAction: 'AcceptAppointmentInvitations'
                });

                setTimeout(function () {
                    _this2.$router.push({
                        name: 'appointment.show',
                        params: {
                            id: id
                        }
                    });
                }, 3000);
            }, function (error) {
                _this2.errorText = error.message;
                _this2.changeStep('submissionError');
            });
        },
        decline: function decline() {
            var _this3 = this;

            this.hideDecline();
            this.changeStep('submitting');

            __WEBPACK_IMPORTED_MODULE_4__data_AppointmentInvitationRepository__["a" /* default */].declineByPatient(this.invitation, function () {
                _this3.changeStep('submittedDeclination');

                _this3.$ga.event({
                    eventCategory: 'AppointmentInvitations',
                    eventAction: 'DeclineAppointmentInvitations'
                });

                setTimeout(function () {
                    _this3.$router.push("/");
                }, 3000);
            }, function (error) {
                console.log('error', error);
                _this3.errorText = error.message;
                _this3.changeStep('submissionError');
            });
        }
    }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_helpers__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'decline-invitation-modal',

    props: ['active', 'invitation'],

    mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_helpers__["a" /* default */]],

    methods: {
        close: function close() {
            this.$emit('close');
        },
        decline: function decline() {
            this.$emit('declined');
        }
    }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'avatar',

    props: ['avatar', 'name'],

    data: function data() {
        return {
            alt: this.name + ' avatar'
        };
    },


    computed: {
        avatarUrl: function avatarUrl() {
            return this.url(this.avatar);
        }
    },

    methods: {
        url: function url(avatar) {
            var avatarPath = Object({"FEMALE_AFRO_AMERICAN_BROWN_LONG_HAIR":"avatar_female_afro_american_brown_long_hair","FEMALE_AFRO_AMERICAN_BLACK_ATTACHED_HAIR":"avatar_female_afro_american_black_attached_hair","FEMALE_ASIAN_BROWN_LONG_HAIR":"avatar_female_asian_brown_long_hair","FEMALE_ASIAN_BLACK_ATTACHED_HAIR":"avatar_female_asian_black_attached_hair","FEMALE_CAUCASIAN_BLOND_LONG_HAIR":"avatar_female_caucasian_blond_long_hair","FEMALE_CAUCASIAN_BLOND_ATTACHED_HAIR":"avatar_female_caucasian_blond_attached_hair","FEMALE_CAUCASIAN_GINGER_LONG_HAIR":"avatar_female_caucasian_ginger_long_hair","FEMALE_CAUCASIAN_BROWN_ATTACHED_HAIR":"avatar_female_caucasian_brown_attached_hair","MALE_AFRO_AMERICAN_BLACK_HAIR":"avatar_male_afro_american_black_hair","MALE_AFRO_AMERICAN_BLACK_MOUSTACHE":"avatar_male_afro_american_black_moustache","MALE_AFRO_AMERICAN_GREY_BEARD":"avatar_male_afro_american_grey_beard","MALE_ASIAN_BLACK_HAIR":"avatar_male_asian_black_hair","MALE_ASIAN_BLACK_MOUSTACHE":"avatar_male_asian_black_moustache","MALE_ASIAN_GREY_BEARD":"avatar_male_grey_beard","MALE_CAUCASIAN_BLOND_HAIR":"avatar_male_caucasian_blond_hair","MALE_CAUCASIAN_BLOND_MOUSTACHE":"avatar_male_caucasian_blond_moustache","MALE_CAUCASIAN_BLOND_BEARD":"avatar_male_caucasian_blond_beard","MALE_CAUCASIAN_GINGER_HAIR":"avatar_male_caucasian_ginger_hair","MALE_CAUCASIAN_GINGER_MOUSTACHE":"avatar_male_caucasian_ginger_moustache","MALE_CAUCASIAN_GINGER_BEARD":"avatar_male_caucasian_ginger_beard"})["MALE_CAUCASIAN_BLOND_BEARD"];

            if (_.has(Object({"FEMALE_AFRO_AMERICAN_BROWN_LONG_HAIR":"avatar_female_afro_american_brown_long_hair","FEMALE_AFRO_AMERICAN_BLACK_ATTACHED_HAIR":"avatar_female_afro_american_black_attached_hair","FEMALE_ASIAN_BROWN_LONG_HAIR":"avatar_female_asian_brown_long_hair","FEMALE_ASIAN_BLACK_ATTACHED_HAIR":"avatar_female_asian_black_attached_hair","FEMALE_CAUCASIAN_BLOND_LONG_HAIR":"avatar_female_caucasian_blond_long_hair","FEMALE_CAUCASIAN_BLOND_ATTACHED_HAIR":"avatar_female_caucasian_blond_attached_hair","FEMALE_CAUCASIAN_GINGER_LONG_HAIR":"avatar_female_caucasian_ginger_long_hair","FEMALE_CAUCASIAN_BROWN_ATTACHED_HAIR":"avatar_female_caucasian_brown_attached_hair","MALE_AFRO_AMERICAN_BLACK_HAIR":"avatar_male_afro_american_black_hair","MALE_AFRO_AMERICAN_BLACK_MOUSTACHE":"avatar_male_afro_american_black_moustache","MALE_AFRO_AMERICAN_GREY_BEARD":"avatar_male_afro_american_grey_beard","MALE_ASIAN_BLACK_HAIR":"avatar_male_asian_black_hair","MALE_ASIAN_BLACK_MOUSTACHE":"avatar_male_asian_black_moustache","MALE_ASIAN_GREY_BEARD":"avatar_male_grey_beard","MALE_CAUCASIAN_BLOND_HAIR":"avatar_male_caucasian_blond_hair","MALE_CAUCASIAN_BLOND_MOUSTACHE":"avatar_male_caucasian_blond_moustache","MALE_CAUCASIAN_BLOND_BEARD":"avatar_male_caucasian_blond_beard","MALE_CAUCASIAN_GINGER_HAIR":"avatar_male_caucasian_ginger_hair","MALE_CAUCASIAN_GINGER_MOUSTACHE":"avatar_male_caucasian_ginger_moustache","MALE_CAUCASIAN_GINGER_BEARD":"avatar_male_caucasian_ginger_beard"}), avatar)) {
                avatarPath = Object({"FEMALE_AFRO_AMERICAN_BROWN_LONG_HAIR":"avatar_female_afro_american_brown_long_hair","FEMALE_AFRO_AMERICAN_BLACK_ATTACHED_HAIR":"avatar_female_afro_american_black_attached_hair","FEMALE_ASIAN_BROWN_LONG_HAIR":"avatar_female_asian_brown_long_hair","FEMALE_ASIAN_BLACK_ATTACHED_HAIR":"avatar_female_asian_black_attached_hair","FEMALE_CAUCASIAN_BLOND_LONG_HAIR":"avatar_female_caucasian_blond_long_hair","FEMALE_CAUCASIAN_BLOND_ATTACHED_HAIR":"avatar_female_caucasian_blond_attached_hair","FEMALE_CAUCASIAN_GINGER_LONG_HAIR":"avatar_female_caucasian_ginger_long_hair","FEMALE_CAUCASIAN_BROWN_ATTACHED_HAIR":"avatar_female_caucasian_brown_attached_hair","MALE_AFRO_AMERICAN_BLACK_HAIR":"avatar_male_afro_american_black_hair","MALE_AFRO_AMERICAN_BLACK_MOUSTACHE":"avatar_male_afro_american_black_moustache","MALE_AFRO_AMERICAN_GREY_BEARD":"avatar_male_afro_american_grey_beard","MALE_ASIAN_BLACK_HAIR":"avatar_male_asian_black_hair","MALE_ASIAN_BLACK_MOUSTACHE":"avatar_male_asian_black_moustache","MALE_ASIAN_GREY_BEARD":"avatar_male_grey_beard","MALE_CAUCASIAN_BLOND_HAIR":"avatar_male_caucasian_blond_hair","MALE_CAUCASIAN_BLOND_MOUSTACHE":"avatar_male_caucasian_blond_moustache","MALE_CAUCASIAN_BLOND_BEARD":"avatar_male_caucasian_blond_beard","MALE_CAUCASIAN_GINGER_HAIR":"avatar_male_caucasian_ginger_hair","MALE_CAUCASIAN_GINGER_MOUSTACHE":"avatar_male_caucasian_ginger_moustache","MALE_CAUCASIAN_GINGER_BEARD":"avatar_male_caucasian_ginger_beard"})[avatar];
            }

            return '/static/avatars/' + avatarPath + '.png';
        }
    }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "DfpSlot",

  props: {
    size: Array,
    path: String,
    id: String,
    medicalPractice: {
      type: String,
      default: null
    }
  },

  beforeCreate: function beforeCreate() {
    window.googletag && window.googletag.cmd && window.googletag.cmd.push(function () {
      window.googletag.destroySlots();
    });
  },
  mounted: function mounted() {
    var _this = this;

    var path = this.path,
        size = this.size,
        id = this.id;


    var medicalPractice = this.medicalPractice ? this.medicalPractice : this.$store.state.patientMedicalPractice;
    medicalPractice && window.googletag && window.googletag.cmd && window.googletag.cmd.push(function () {
      window.googletag.defineSlot(path, size, id).addService(window.googletag.pubads()).setTargeting("platform", "web").setTargeting("audience", "patient").setTargeting("language", _this.$store.state.frontLanguage).setTargeting("practice", medicalPractice.toLowerCase());
      window.googletag.pubads().enableSingleRequest();
      window.googletag.pubads().collapseEmptyDivs();
      window.googletag.enableServices();
      window.googletag.display(id);
    });
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'loading-block'
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_auth__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_PatientRepository__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layouts_PatientLayout__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layouts_DoctorLayout__ = __webpack_require__(796);
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'App',

    computed: {
        layout: function layout() {
            return this.$store.getters.layout;
        }
    },

    components: { PatientLayout: __WEBPACK_IMPORTED_MODULE_4__layouts_PatientLayout__["a" /* default */], DoctorLayout: __WEBPACK_IMPORTED_MODULE_5__layouts_DoctorLayout__["a" /* default */] },

    mounted: function mounted() {
        var _this = this;

        this.checkOnlineStatus();
        window.addEventListener('online', this.checkOnlineStatus);
        window.addEventListener('offline', this.checkOnlineStatus);

        __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth().getRedirectResult().then(function (result) {
            if (result && result.user) {
                if (_this.layout == 'PatientLayout') {
                    // Patient does not exist
                    __WEBPACK_IMPORTED_MODULE_3__data_PatientRepository__["a" /* default */].createOrUpdate(result.user, function (patient) {
                        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */].dispatch('setPatient', patient);
                    }, function (error) {
                        // Could not create patient
                        console.error(error);
                    });
                    // this.$router.push('/');
                } else if (_this.layout == 'DoctorLayout') {
                    _this.$router.push({ name: 'doctor.dashboard' });
                }
            }
        }).catch(function (error) {
            _this.$store.dispatch('setFormError', error.message);
        });
    },


    methods: {
        checkOnlineStatus: function checkOnlineStatus() {
            if (typeof window.navigator.onLine === 'undefined') {
                this.$store.commit('SET_ONLINE', true);
            } else {
                this.$store.commit('SET_ONLINE', window.navigator.onLine);
            }
        }
    }
});

/***/ }),
/* 393 */,
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/materialdesignicons-webfont.c28acdf.eot";

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/materialdesignicons-webfont.c28acdf.eot";

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/materialdesignicons-webfont.32562ea.woff2";

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/materialdesignicons-webfont.40f483d.woff";

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/materialdesignicons-webfont.a33808e.ttf";

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/materialdesignicons-webfont.07c3c54.svg";

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_PatientRepository__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'PatientLayout',

    mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            consentForCookies: false
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.consentForCookies = this.hasGivenConsentForCookies();

        var language = this.$router.currentRoute.query.lang || localStorage.getItem('language') || this.frontLanguage || 'en';
        var locale = localStorage.getItem('locale') || 'en';

        if (language !== this.frontLanguage || language !== locale.slice(0, 2)) {
            __WEBPACK_IMPORTED_MODULE_1__firebase__["c" /* db */].collection('languages').where('shortCode', '==', language).get().then(function (querySnapshot) {
                if (querySnapshot.size >= 1) {
                    var _language = querySnapshot.docs[0].data();
                    _this.setLocale(_language.code);
                    _this.$store.dispatch('setFrontLanguage', _language.shortCode);
                }
            });
        } else {
            this.setLocale(locale);
            this.$store.dispatch('setFrontLanguage', language);
        }
    },


    watch: {
        preventBodyScroll: function preventBodyScroll(newVal, oldVal) {
            if (newVal === true) {
                document.body.classList.add('overflow-hidden');
            } else {
                document.body.classList.remove('overflow-hidden');
            }
        }
    }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Doctor_RecommendationsModal_vue__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Doctor_PartnersList_vue__ = __webpack_require__(802);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'DoctorLayout',

    mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_helpers__["a" /* default */]],

    components: { RecommendationsModal: __WEBPACK_IMPORTED_MODULE_5__components_Doctor_RecommendationsModal_vue__["a" /* default */], PartnersList: __WEBPACK_IMPORTED_MODULE_6__components_Doctor_PartnersList_vue__["a" /* default */] },

    data: function data() {
        return {
            consentForCookies: false,
            closedRecommendationsModal: false
        };
    },


    computed: {
        showCookieNotification: function showCookieNotification() {
            return !this.doctor && !this.consentForCookies;
        },
        showRecommendationsModal: function showRecommendationsModal() {
            return this.doctor && !this.closedRecommendationsModal && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.recommendations).length < 1 ? true : false;
        }
    },

    beforeMount: function beforeMount() {
        var language = this.doctor ? this.doctor.language : 'en';
        window.location.href = 'https://pro.tooddoc.com/login?source=old_version&lang=' + language;
    },
    mounted: function mounted() {
        this.consentForCookies = this.hasGivenConsentForCookies();
        this.closedRecommendationsModal = this.hasClosedRecommendationsModal();
        if (this.doctor) {
            this.setLocale(this.doctor.language);
        }
    },


    methods: {
        hasClosedRecommendationsModal: function hasClosedRecommendationsModal() {
            if (this.closedRecommendationsModal) return true;

            var value = '; ' + document.cookie;
            var parts = value.split('; closed_recommendations=');

            return parts.length != 2 ? false : true;
        },
        closeRecommendationsModal: function closeRecommendationsModal() {
            var expirationDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(1, 'days');

            var cookie = ['closed_recommendations=1', 'expires=' + expirationDate.utc().toString(), 'path=/'];

            document.cookie = cookie.join(';');

            this.closedRecommendationsModal = true;
        },
        hasGivenConsentForCookies: function hasGivenConsentForCookies() {
            if (this.consentForCookies) return true;

            var value = '; ' + document.cookie;
            var parts = value.split('; cookieconsent_status=');

            return parts.length != 2 ? false : true;
        },
        consentCookies: function consentCookies() {
            var expirationDate = __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(365, 'days');

            var cookie = ['cookieconsent_status=1', 'expires=' + expirationDate.utc().toString(), 'path=/'];

            document.cookie = cookie.join(';');

            this.consentForCookies = true;
        }
    }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_RecommendationRepository__ = __webpack_require__(800);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'recommendations-modal',

    props: ['active'],

    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            newRecommendations: [],
            isModalLoading: false
        };
    },
    mounted: function mounted() {
        this.addRecommendation();
        this.addRecommendation();
    },


    methods: {
        close: function close() {
            if (!this.isModalLoading) {
                this.$emit('close');
                document.documentElement.classList.toggle('is-clipped', false);
            }
        },
        addRecommendation: function addRecommendation() {
            this.newRecommendations.push({
                "email": "",
                "name": ""
            });
        },
        removeRecommendation: function removeRecommendation(key) {
            this.newRecommendations.splice(key, 1);
        },
        confirm: function confirm() {
            var _this = this;

            this.isModalLoading = true;

            this.$validator.validateAll().then(function (result) {
                if (!result) {
                    _this.isModalLoading = false;

                    return false;
                }

                __WEBPACK_IMPORTED_MODULE_2__data_RecommendationRepository__["a" /* default */].createMany(_this.doctor, _this.newRecommendations, function () {
                    // Success
                    _this.isModalLoading = false;

                    _this.close();

                    _this.alertSuccess(_this.$t('thanks_message'));
                }, function (error) {
                    // Error
                    _this.isModalLoading = false;

                    _this.alertError(error.message);
                });
            });
        }
    }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_helpers__ = __webpack_require__(2);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_helpers__["a" /* default */]],

    data: function data() {
        return {
            partners: [{
                id: 'smd',
                url: {
                    fr: 'https://www.dentiste.be',
                    nl: 'https://www.dentiste.be',
                    en: 'https://www.dentiste.be'
                }
            }, {
                id: 'partena_mut',
                url: {
                    fr: 'https://www.partenamut.be',
                    nl: 'https://www.partena-ziekenfonds.be',
                    en: 'https://www.partenamut.be'
                }
            }, {
                id: 'banque_van_breda',
                url: {
                    fr: 'https://www.banquevanbreda.be',
                    nl: 'https://www.bankvanbreda.be',
                    en: 'https://www.banquevanbreda.be'
                }
            }, {
                id: 'amonis',
                url: {
                    fr: 'http://www.amonis.be/fr',
                    nl: 'http://www.amonis.be/nl',
                    en: 'http://www.amonis.be/fr'
                }
            }, {
                id: 'dental_addict',
                url: {
                    fr: 'https://www.dental-addict.be/fr',
                    nl: 'https://www.dental-addict.be/nl',
                    en: 'https://www.dental-addict.be/fr'
                }
            }, {
                id: 'apb',
                url: {
                    fr: 'https://www.apb.be/fr',
                    nl: 'https://www.apb.be/nl',
                    en: 'https://www.apb.be/fr'
                }
            }]
        };
    },


    computed: {
        currentLanguage: function currentLanguage() {
            if (this.doctor) {
                return this.doctor.language.substring(0, 2) || 'en';
            }

            return 'en';
        }
    }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuefire__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_analytics__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vee_validate__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__bugsnag_js__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__bugsnag_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__bugsnag_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__bugsnag_plugin_vue__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__bugsnag_plugin_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__bugsnag_plugin_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_google_maps__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_PatientRepository__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_awesome_phonenumber__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_awesome_phonenumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_awesome_phonenumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_buefy__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_js_toggle_button__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Avatar_vue__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_DfpSlot_vue__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Patient_LoadingBlock_vue__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__App__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__router__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__i18n__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__data_CountryRepository__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__data_LanguageRepository__ = __webpack_require__(809);



















__WEBPACK_IMPORTED_MODULE_7_vee_validate__["a" /* default */].Validator.extend('phone', {
    getMessage: function getMessage(field) {
        return 'The ' + field + ' value is not a valid phone number.';
    },
    validate: function validate(value, _ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 1),
            country = _ref2[0];

        var phoneNumber = new __WEBPACK_IMPORTED_MODULE_14_awesome_phonenumber___default.a(value, country);
        return phoneNumber.isValid();
    }
});

















__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].config.devtools = true;

var app = void 0;

window.bugsnagClient = __WEBPACK_IMPORTED_MODULE_10__bugsnag_js___default()("6476b343ea1aa7ce6d410ecf5c80afb5");
window.bugsnagClient.use(__WEBPACK_IMPORTED_MODULE_11__bugsnag_plugin_vue___default.a, __WEBPACK_IMPORTED_MODULE_3_vue__["default"]);

var isProd = "dev" === 'prod';

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_analytics___default.a, {
    id: "UA-111445892-8",
    router: __WEBPACK_IMPORTED_MODULE_21__router__["a" /* default */],
    autoTracking: {
        page: true,
        screenview: false,
        transformQueryString: false,
        pageViewOnLoad: false
    },
    debug: {
        enabled: false, //!isProd,
        sentHitTask: isProd
    },
    checkDuplicatedScript: true
});
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_buefy___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_js_toggle_button___default.a);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue2_google_maps__, {
    load: {
        key: "AIzaSyBXIAl3Iq97-Z58_VMVY-UZQc_OQKrpIxw",
        libraries: "places"
    }
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('avatar', __WEBPACK_IMPORTED_MODULE_17__components_Avatar_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('dfp-slot', __WEBPACK_IMPORTED_MODULE_18__components_DfpSlot_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_3_vue__["default"].component('patient-loading', __WEBPACK_IMPORTED_MODULE_19__components_Patient_LoadingBlock_vue__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].set(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype, '_', __WEBPACK_IMPORTED_MODULE_8_lodash___default.a);

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('momentFormatTimestamp', function (timestamp, toFormat) {
    return __WEBPACK_IMPORTED_MODULE_9_moment___default()(timestamp).format(toFormat);
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('momentFormat', function (date, fromFormat, toFormat) {
    return __WEBPACK_IMPORTED_MODULE_9_moment___default()(date, fromFormat).format(toFormat);
});

__WEBPACK_IMPORTED_MODULE_3_vue__["default"].filter('momentFormatTime', function (time, toFormat) {
    var start = __WEBPACK_IMPORTED_MODULE_9_moment___default.a.duration(time * 15, 'minutes');

    return __WEBPACK_IMPORTED_MODULE_9_moment___default.a.utc(start.asMilliseconds()).format(toFormat);
});

__WEBPACK_IMPORTED_MODULE_4_firebase_app___default.a.auth().onAuthStateChanged(function (user) {
    var promises = [];
    promises.push(setupUser(user));
    promises.push(setupPatient(user));
    promises.push(setupDoctor(user));
    promises.push(setupRecommendations(user));
    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_23__store__["a" /* store */].state.countries).length == 0) {
        promises.push(setupCountries());
    }
    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_23__store__["a" /* store */].state.languages).length == 0) {
        promises.push(setupLanguages());
    }

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(promises).then(function () {
        if (document.getElementById('app')) {
            window.bugsnagClient.user = {
                userId: __WEBPACK_IMPORTED_MODULE_23__store__["a" /* store */].state.userId,
                doctor: __WEBPACK_IMPORTED_MODULE_23__store__["a" /* store */].state.doctor
            };

            new __WEBPACK_IMPORTED_MODULE_3_vue__["default"]({
                el: '#app',
                router: __WEBPACK_IMPORTED_MODULE_21__router__["a" /* default */],
                i18n: __WEBPACK_IMPORTED_MODULE_22__i18n__["a" /* default */],
                store: __WEBPACK_IMPORTED_MODULE_23__store__["a" /* store */],
                render: function render(h) {
                    return h(__WEBPACK_IMPORTED_MODULE_20__App__["a" /* default */]);
                }
            });
        }
    }).catch(function (error) {
        console.log('some promises could not resolve', error);
    });
});

// setup the user
var setupUser = function setupUser(user) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_23__store__["a" /* store */].dispatch('setUserId', user ? user.uid : null);

        resolve();
    });
};

// Check if user is a patient
var setupPatient = function setupPatient(user) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_23__store__["a" /* store */].dispatch('setPatient', null);

        if (!user) {
            resolve();

            return;
        }

        __WEBPACK_IMPORTED_MODULE_13__data_PatientRepository__["a" /* default */].createOrUpdate(user, function (patient) {
            __WEBPACK_IMPORTED_MODULE_23__store__["a" /* store */].dispatch('setPatient', patient);

            resolve();
        }, reject);
    });
};

// Check if user is a doctor
var setupDoctor = function setupDoctor(user) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_23__store__["a" /* store */].dispatch('setDoctor', null);

        if (!user) {
            resolve();

            return;
        }

        __WEBPACK_IMPORTED_MODULE_24__firebase__["c" /* db */].collection('doctors').doc(user.uid).get().then(function (doc) {
            if (doc.exists) {
                __WEBPACK_IMPORTED_MODULE_23__store__["a" /* store */].dispatch('setDoctor', doc.data());
            }

            resolve();
        }).catch(reject);
    });
};

// Fetch the doctor recommendations
var setupRecommendations = function setupRecommendations(user) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!user) {
            resolve();

            return;
        }

        __WEBPACK_IMPORTED_MODULE_24__firebase__["c" /* db */].collection('recommendations').where('fromId', '==', user.uid).get().then(function (querySnapshot) {
            var recommendations = {};

            querySnapshot.forEach(function (doc) {
                recommendations[doc.id] = doc.data();
            });

            __WEBPACK_IMPORTED_MODULE_23__store__["a" /* store */].dispatch('setRecommendations', recommendations);

            resolve();
        }).catch(reject);
    });
};

// fetch countries
var setupCountries = function setupCountries() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_25__data_CountryRepository__["a" /* default */].list(function (countries) {
            __WEBPACK_IMPORTED_MODULE_23__store__["a" /* store */].dispatch('setCountries', countries);
            resolve();
        }, reject);
    });
};

// fetch languages
var setupLanguages = function setupLanguages() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_26__data_LanguageRepository__["a" /* default */].list(function (languages) {
            __WEBPACK_IMPORTED_MODULE_23__store__["a" /* store */].dispatch('setLanguages', languages);
            resolve();
        }, reject);
    });
};

// calculate distance between 2 coordinates
window.distanceBetween = function (lat1, lon1, lat2, lon2, unit) {
    var radlat1 = Math.PI * lat1 / 180;
    var radlat2 = Math.PI * lat2 / 180;
    var theta = lon1 - lon2;
    var radtheta = Math.PI * theta / 180;
    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
    dist = Math.acos(dist);
    dist = dist * 180 / Math.PI;
    dist = dist * 60 * 1.1515;

    return dist * 1.609344; // Degrees to km, rounded to the km
};

/***/ }),
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 178,
	"./af.js": 178,
	"./ar": 179,
	"./ar-dz": 180,
	"./ar-dz.js": 180,
	"./ar-kw": 181,
	"./ar-kw.js": 181,
	"./ar-ly": 182,
	"./ar-ly.js": 182,
	"./ar-ma": 183,
	"./ar-ma.js": 183,
	"./ar-sa": 184,
	"./ar-sa.js": 184,
	"./ar-tn": 185,
	"./ar-tn.js": 185,
	"./ar.js": 179,
	"./az": 186,
	"./az.js": 186,
	"./be": 187,
	"./be.js": 187,
	"./bg": 188,
	"./bg.js": 188,
	"./bm": 189,
	"./bm.js": 189,
	"./bn": 190,
	"./bn.js": 190,
	"./bo": 191,
	"./bo.js": 191,
	"./br": 192,
	"./br.js": 192,
	"./bs": 193,
	"./bs.js": 193,
	"./ca": 194,
	"./ca.js": 194,
	"./cs": 195,
	"./cs.js": 195,
	"./cv": 196,
	"./cv.js": 196,
	"./cy": 197,
	"./cy.js": 197,
	"./da": 198,
	"./da.js": 198,
	"./de": 199,
	"./de-at": 200,
	"./de-at.js": 200,
	"./de-ch": 201,
	"./de-ch.js": 201,
	"./de.js": 199,
	"./dv": 202,
	"./dv.js": 202,
	"./el": 203,
	"./el.js": 203,
	"./en-SG": 204,
	"./en-SG.js": 204,
	"./en-au": 205,
	"./en-au.js": 205,
	"./en-ca": 206,
	"./en-ca.js": 206,
	"./en-gb": 207,
	"./en-gb.js": 207,
	"./en-ie": 208,
	"./en-ie.js": 208,
	"./en-il": 209,
	"./en-il.js": 209,
	"./en-nz": 210,
	"./en-nz.js": 210,
	"./eo": 211,
	"./eo.js": 211,
	"./es": 212,
	"./es-do": 213,
	"./es-do.js": 213,
	"./es-us": 214,
	"./es-us.js": 214,
	"./es.js": 212,
	"./et": 215,
	"./et.js": 215,
	"./eu": 216,
	"./eu.js": 216,
	"./fa": 217,
	"./fa.js": 217,
	"./fi": 218,
	"./fi.js": 218,
	"./fo": 219,
	"./fo.js": 219,
	"./fr": 220,
	"./fr-ca": 221,
	"./fr-ca.js": 221,
	"./fr-ch": 222,
	"./fr-ch.js": 222,
	"./fr.js": 220,
	"./fy": 223,
	"./fy.js": 223,
	"./ga": 224,
	"./ga.js": 224,
	"./gd": 225,
	"./gd.js": 225,
	"./gl": 226,
	"./gl.js": 226,
	"./gom-latn": 227,
	"./gom-latn.js": 227,
	"./gu": 228,
	"./gu.js": 228,
	"./he": 229,
	"./he.js": 229,
	"./hi": 230,
	"./hi.js": 230,
	"./hr": 231,
	"./hr.js": 231,
	"./hu": 232,
	"./hu.js": 232,
	"./hy-am": 233,
	"./hy-am.js": 233,
	"./id": 234,
	"./id.js": 234,
	"./is": 235,
	"./is.js": 235,
	"./it": 236,
	"./it-ch": 237,
	"./it-ch.js": 237,
	"./it.js": 236,
	"./ja": 238,
	"./ja.js": 238,
	"./jv": 239,
	"./jv.js": 239,
	"./ka": 240,
	"./ka.js": 240,
	"./kk": 241,
	"./kk.js": 241,
	"./km": 242,
	"./km.js": 242,
	"./kn": 243,
	"./kn.js": 243,
	"./ko": 244,
	"./ko.js": 244,
	"./ku": 245,
	"./ku.js": 245,
	"./ky": 246,
	"./ky.js": 246,
	"./lb": 247,
	"./lb.js": 247,
	"./lo": 248,
	"./lo.js": 248,
	"./lt": 249,
	"./lt.js": 249,
	"./lv": 250,
	"./lv.js": 250,
	"./me": 251,
	"./me.js": 251,
	"./mi": 252,
	"./mi.js": 252,
	"./mk": 253,
	"./mk.js": 253,
	"./ml": 254,
	"./ml.js": 254,
	"./mn": 255,
	"./mn.js": 255,
	"./mr": 256,
	"./mr.js": 256,
	"./ms": 257,
	"./ms-my": 258,
	"./ms-my.js": 258,
	"./ms.js": 257,
	"./mt": 259,
	"./mt.js": 259,
	"./my": 260,
	"./my.js": 260,
	"./nb": 261,
	"./nb.js": 261,
	"./ne": 262,
	"./ne.js": 262,
	"./nl": 263,
	"./nl-be": 264,
	"./nl-be.js": 264,
	"./nl.js": 263,
	"./nn": 265,
	"./nn.js": 265,
	"./pa-in": 266,
	"./pa-in.js": 266,
	"./pl": 267,
	"./pl.js": 267,
	"./pt": 268,
	"./pt-br": 269,
	"./pt-br.js": 269,
	"./pt.js": 268,
	"./ro": 270,
	"./ro.js": 270,
	"./ru": 271,
	"./ru.js": 271,
	"./sd": 272,
	"./sd.js": 272,
	"./se": 273,
	"./se.js": 273,
	"./si": 274,
	"./si.js": 274,
	"./sk": 275,
	"./sk.js": 275,
	"./sl": 276,
	"./sl.js": 276,
	"./sq": 277,
	"./sq.js": 277,
	"./sr": 278,
	"./sr-cyrl": 279,
	"./sr-cyrl.js": 279,
	"./sr.js": 278,
	"./ss": 280,
	"./ss.js": 280,
	"./sv": 281,
	"./sv.js": 281,
	"./sw": 282,
	"./sw.js": 282,
	"./ta": 283,
	"./ta.js": 283,
	"./te": 284,
	"./te.js": 284,
	"./tet": 285,
	"./tet.js": 285,
	"./tg": 286,
	"./tg.js": 286,
	"./th": 287,
	"./th.js": 287,
	"./tl-ph": 288,
	"./tl-ph.js": 288,
	"./tlh": 289,
	"./tlh.js": 289,
	"./tr": 290,
	"./tr.js": 290,
	"./tzl": 291,
	"./tzl.js": 291,
	"./tzm": 292,
	"./tzm-latn": 293,
	"./tzm-latn.js": 293,
	"./tzm.js": 292,
	"./ug-cn": 294,
	"./ug-cn.js": 294,
	"./uk": 295,
	"./uk.js": 295,
	"./ur": 296,
	"./ur.js": 296,
	"./uz": 297,
	"./uz-latn": 298,
	"./uz-latn.js": 298,
	"./uz.js": 297,
	"./vi": 299,
	"./vi.js": 299,
	"./x-pseudo": 300,
	"./x-pseudo.js": 300,
	"./yo": 301,
	"./yo.js": 301,
	"./zh-cn": 302,
	"./zh-cn.js": 302,
	"./zh-hk": 303,
	"./zh-hk.js": 303,
	"./zh-tw": 304,
	"./zh-tw.js": 304
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 480;

/***/ }),
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__ = __webpack_require__(306);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_17fc7ddc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(494);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_17fc7ddc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue2-google-maps/dist/components/infoWindow.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-17fc7ddc", Component.options)
  } else {
    hotAPI.reload("data-v-17fc7ddc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 493 */,
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [_c("div", { ref: "flyaway" }, [_vm._t("default")], 2)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17fc7ddc", esExports)
  }
}

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__(307);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_85ca06a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(500);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(496)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_85ca06a4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue2-google-maps/dist/components/map.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-85ca06a4", Component.options)
  } else {
    hotAPI.reload("data-v-85ca06a4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(497);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(20)("144a3769", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-85ca06a4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector.js?type=styles&index=0!./map.vue", function() {
     var newContent = require("!!../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-85ca06a4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector.js?type=styles&index=0!./map.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(19)(false);
// imports


// module
exports.push([module.i, "\n.vue-map-container {\n  position: relative;\n}\n.vue-map-container .vue-map {\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  position: absolute;\n}\n.vue-map-hidden {\n  display: none;\n}\n", ""]);

// exports


/***/ }),
/* 498 */,
/* 499 */,
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-map-container" },
    [
      _c("div", { ref: "vue-map", staticClass: "vue-map" }),
      _vm._v(" "),
      _c("div", { staticClass: "vue-map-hidden" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm._t("visible")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-85ca06a4", esExports)
  }
}

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__ = __webpack_require__(309);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ed35740a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(505);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(502)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ed35740a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ed35740a", Component.options)
  } else {
    hotAPI.reload("data-v-ed35740a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(503);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(20)("7ea3d7ac", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ed35740a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector.js?type=styles&index=0!./streetViewPanorama.vue", function() {
     var newContent = require("!!../../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-ed35740a\",\"scoped\":false,\"hasInlineConfig\":false}!../../../vue-loader/lib/selector.js?type=styles&index=0!./streetViewPanorama.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(19)(false);
// imports


// module
exports.push([module.i, "\n.vue-street-view-pano-container {\n  position: relative;\n}\n.vue-street-view-pano-container .vue-street-view-pano {\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  position: absolute;\n}\n", ""]);

// exports


/***/ }),
/* 504 */,
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-street-view-pano-container" },
    [
      _c("div", {
        ref: "vue-street-view-pano",
        staticClass: "vue-street-view-pano"
      }),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed35740a", esExports)
  }
}

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c1ab87be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(507);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_c1ab87be_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue2-google-maps/dist/components/placeInput.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c1ab87be", Component.options)
  } else {
    hotAPI.reload("data-v-c1ab87be", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("label", [
    _c("span", { domProps: { textContent: _vm._s(_vm.label) } }),
    _vm._v(" "),
    _c("input", {
      ref: "input",
      class: _vm.className,
      attrs: { type: "text", placeholder: _vm.placeholder }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c1ab87be", esExports)
  }
}

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__ = __webpack_require__(312);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2c922d06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(510);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_2c922d06_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "node_modules/vue2-google-maps/dist/components/autocomplete.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2c922d06", Component.options)
  } else {
    hotAPI.reload("data-v-2c922d06", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 509 */,
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "input",
    _vm._g(_vm._b({ ref: "input" }, "input", _vm.$attrs, false), _vm.$listeners)
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2c922d06", esExports)
  }
}

/***/ }),
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return state; });
var state = {
    currentLayout: 'PatientLayout',
    currentOffice: null,
    currentDate: null,
    firebaseToken: null,
    userId: null,
    doctor: false,
    patient: false,
    patientPosition: null,
    patientPlace: '',
    patientPlaceName: '',
    patientMedicalPractice: null,
    offices: {},
    online: true,
    countries: {},
    recommendations: {},
    notifications: [],
    defaultCountryId: null,
    frontLanguage: localStorage.getItem('language') || 'en',
    languages: {},
    loaded: false,
    loading: false,
    formError: null,
    listenAppointments: false,
    onboardingStep: 0,
    preventBodyScroll: false
};

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mutations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var mutations = {
    SET_LAYOUT: function SET_LAYOUT(state, payload) {
        state.currentLayout = payload;
    },
    SET_PATIENT: function SET_PATIENT(state, payload) {
        state.patient = payload;
    },
    SET_PATIENT_POSITION: function SET_PATIENT_POSITION(state, payload) {
        state.patientPosition = payload;
    },
    SET_PATIENT_PLACE: function SET_PATIENT_PLACE(state, payload) {
        state.patientPlace = payload;
    },
    SET_PATIENT_PLACE_NAME: function SET_PATIENT_PLACE_NAME(state, payload) {
        state.patientPlaceName = payload;
    },
    SET_PATIENT_MEDICAL_PRACTICE: function SET_PATIENT_MEDICAL_PRACTICE(state, payload) {
        state.patientMedicalPractice = payload;
    },
    SET_FRONT_LANGUAGE: function SET_FRONT_LANGUAGE(state, payload) {
        state.frontLanguage = payload;
    },
    SET_ONLINE: function SET_ONLINE(state, payload) {
        state.online = payload;
    },
    setPreventBodyScroll: function setPreventBodyScroll(state, payload) {
        state.preventBodyScroll = payload;
    },
    setLoading: function setLoading(state, payload) {
        state.loading = payload;
    },
    setOnboardingStep: function setOnboardingStep(state, payload) {
        state.onboardingStep = payload;
    },
    setLoaded: function setLoaded(state, payload) {
        state.loaded = payload;
    },
    setCurrentOffice: function setCurrentOffice(state, payload) {
        state.currentOffice = payload;
    },
    setCurrentDate: function setCurrentDate(state, payload) {
        state.currentDate = payload;
    },
    listenAppointments: function listenAppointments(state, payload) {
        state.listenAppointments = payload;
    },
    setFirebaseToken: function setFirebaseToken(state, payload) {
        state.firebaseToken = payload;
    },
    setUserId: function setUserId(state, payload) {
        state.userId = payload;
    },
    addNotification: function addNotification(state, payload) {
        state.notifications.push(payload);
    },
    disableNotification: function disableNotification(state, payload) {
        payload.active = false;
    },
    setDoctor: function setDoctor(state, payload) {
        state.doctor = payload;
    },
    setOffices: function setOffices(state, payload) {
        state.offices = payload;
        if (!state.currentOffice && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(payload).length) {
            for (var i in state.offices) {
                state.currentOffice = i;

                break;
            }
        }
    },
    setOffice: function setOffice(state, payload) {
        state.offices[payload.id] = payload;
    },
    setRecommendations: function setRecommendations(state, payload) {
        state.recommendations = payload;
    },
    removeOffice: function removeOffice(state, payload) {
        // Update Current Office if we deleted this one
        if (state.currentOffice == payload) {
            if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(state.offices).length) {
                for (var i in state.offices) {
                    state.currentOffice = i;

                    break;
                }
            } else {
                state.currentOffice = null;
            }
        }

        delete state.offices[payload];
    },
    setLanguages: function setLanguages(state, payload) {
        state.languages = payload;
    },
    setCountries: function setCountries(state, payload) {
        state.countries = payload;
    },
    setDefaultCountryId: function setDefaultCountryId(state, payload) {
        state.defaultCountryId = payload;
    },
    setFormError: function setFormError(state, payload) {
        state.formError = payload;
    }
};

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return actions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_DoctorRepository__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_DoctorOfficeRepository__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);








var actions = {
    setLoaded: function setLoaded(_ref, payload) {
        var commit = _ref.commit;

        commit('setLoaded', payload);
    },
    setPreventBodyScroll: function setPreventBodyScroll(_ref2, payload) {
        var commit = _ref2.commit;

        commit('setPreventBodyScroll', payload);
    },
    setFrontLanguage: function setFrontLanguage(_ref3, payload) {
        var commit = _ref3.commit;

        if (typeof localStorage !== 'undefined') {
            localStorage.setItem('language', payload);
        }

        commit('SET_FRONT_LANGUAGE', payload);
    },
    setPatient: function setPatient(_ref4, payload) {
        var commit = _ref4.commit;

        commit('SET_PATIENT', payload);
    },
    setPatientPosition: function setPatientPosition(_ref5, payload) {
        var commit = _ref5.commit;

        commit('SET_PATIENT_POSITION', payload);
    },
    setPatientPlace: function setPatientPlace(_ref6, payload) {
        var commit = _ref6.commit;

        commit('SET_PATIENT_PLACE', payload);
    },
    setPatientPlaceName: function setPatientPlaceName(_ref7, payload) {
        var commit = _ref7.commit;

        commit('SET_PATIENT_PLACE_NAME', payload);
    },
    setPatientMedicalPractice: function setPatientMedicalPractice(_ref8, payload) {
        var commit = _ref8.commit;

        commit('SET_PATIENT_MEDICAL_PRACTICE', payload);
    },
    setOnboardingStep: function setOnboardingStep(_ref9, payload) {
        var commit = _ref9.commit;

        commit('setOnboardingStep', payload);
    },
    setLoading: function setLoading(_ref10, payload) {
        var commit = _ref10.commit;

        commit('setLoading', payload);
    },
    setCurrentOffice: function setCurrentOffice(_ref11, payload) {
        var commit = _ref11.commit;

        commit('setCurrentOffice', payload);
    },
    setCurrentDate: function setCurrentDate(_ref12, payload) {
        var commit = _ref12.commit;

        commit('setCurrentDate', payload);
    },
    setUserId: function setUserId(_ref13, payload) {
        var commit = _ref13.commit;

        commit('setUserId', payload);
    },
    setDoctor: function setDoctor(_ref14, payload) {
        var commit = _ref14.commit;

        commit('setDoctor', payload);
    },
    setRecommendations: function setRecommendations(_ref15, payload) {
        var commit = _ref15.commit;

        commit('setRecommendations', payload);
    },
    addNotification: function addNotification(_ref16, payload) {
        var commit = _ref16.commit;

        commit('addNotification', payload);
    },
    disableNotification: function disableNotification(_ref17, payload) {
        var commit = _ref17.commit;

        commit('disableNotification', payload);
    },
    listenAppointments: function listenAppointments(_ref18, payload) {
        var commit = _ref18.commit;

        commit('listenAppointments', payload);
    },
    setOffices: function setOffices(_ref19, payload) {
        var commit = _ref19.commit;

        commit('setOffices', payload);
    },
    setOffice: function setOffice(_ref20, payload) {
        var commit = _ref20.commit;

        commit('setOffice', payload);
    },
    setLocale: function setLocale(_ref21, payload) {
        var commit = _ref21.commit;

        if (typeof localStorage !== 'undefined') {
            localStorage.setItem('locale', payload);
        }

        __WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].locale = payload;
        __WEBPACK_IMPORTED_MODULE_6_moment___default.a.locale(__WEBPACK_IMPORTED_MODULE_5__i18n__["a" /* default */].t('moment_locale'));
    },
    removeOffice: function removeOffice(_ref22, payload) {
        var commit = _ref22.commit;

        commit('removeOffice', payload);
    },
    setLanguages: function setLanguages(_ref23, payload) {
        var commit = _ref23.commit;

        commit('setLanguages', payload);
    },
    setCountries: function setCountries(_ref24, payload) {
        var commit = _ref24.commit;

        commit('setCountries', payload);
    },
    setDefaultCountryId: function setDefaultCountryId(_ref25, payload) {
        var commit = _ref25.commit;

        commit('setDefaultCountryId', payload);
    },
    setFormError: function setFormError(_ref26, payload) {
        var commit = _ref26.commit;

        commit('setFormError', payload);
    },
    logout: function logout(_ref27, payload) {
        var commit = _ref27.commit;

        commit('setLoaded', false);
        commit('setLoading', true);
        commit('setUserId', null);
        commit('setDoctor', null);
        commit('setOffices', {});
        commit('setCurrentOffice', null);
        commit('setCurrentDate', null);

        __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth().signOut().then(function () {
            window.location.reload();
            // router.push(payload)

            commit('setLoaded', true);
            commit('setLoading', false);
        });
    },
    createDoctor: function createDoctor(_ref28, payload) {
        var commit = _ref28.commit;

        commit('setLoading', true);
        commit('setFormError', null);

        var doctor = payload.doctor;
        var offices = payload.offices;
        var userId = __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.auth().currentUser.uid;

        var batch = __WEBPACK_IMPORTED_MODULE_1__firebase__["c" /* db */].batch();

        var doctorRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["c" /* db */].collection('doctors').doc(userId);

        var doctorDoc = {
            id: userId,
            countryId: doctor.countryId,
            lastName: doctor.lastName,
            firstName: doctor.firstName,
            contactEmail: doctor.contactEmail,
            inami: doctor.inami,
            language: doctor.language,
            avatar: doctor.avatar,
            isRegulated: doctor.isRegulated,
            isCertified: false,
            type: doctor.type,
            dateTimeCreated: new Date(),
            onboardingStep: 0
        };

        batch.set(doctorRef, doctorDoc);

        var officeDocs = {};

        offices.forEach(function (item, index, array) {
            var officeRef = __WEBPACK_IMPORTED_MODULE_1__firebase__["c" /* db */].collection('offices').doc();

            if (item.location == null) {
                item.location = new __WEBPACK_IMPORTED_MODULE_0_firebase_app___default.a.firestore.GeoPoint(51.501527, process.DEFAULT_LNG);
            }

            officeDocs[officeRef.id] = {
                countryId: item.countryId,
                doctorAvatar: doctor.avatar,
                doctorFirstName: doctor.firstName,
                doctorId: userId,
                doctorLastName: doctor.lastName,
                doctorType: doctor.type,
                id: officeRef.id,
                isDoctorRegulated: doctor.isRegulated,
                isEmergencyEmailAlertEnabled: true,
                locality: item.locality,
                location: item.location,
                name: item.name,
                phone: item.phone,
                streetName: item.streetName,
                streetNumber: item.streetNumber,
                zipCode: item.zipCode
            };

            batch.set(officeRef, officeDocs[officeRef.id]);
        });

        batch.commit().then(function () {
            commit('setDoctor', doctorDoc);
            commit('setOffices', officeDocs);
            commit('setLoaded', true);
            commit('setLoading', false);

            __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].push({
                name: 'doctor.dashboard'
            });
        }).catch(function (error) {
            console.error(error);
        });
    }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(81)))

/***/ }),
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dc7cce2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(606);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8dc7cce2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Home.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8dc7cce2", Component.options)
  } else {
    hotAPI.reload("data-v-8dc7cce2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginModal_vue__ = __webpack_require__(324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b56a544_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginModal_vue__ = __webpack_require__(577);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(574)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b56a544_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/LoginModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8b56a544", Component.options)
  } else {
    hotAPI.reload("data-v-8b56a544", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(575);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(20)("7daf484c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8b56a544\",\"scoped\":false,\"hasInlineConfig\":false}!./firebaseui.css", function() {
     var newContent = require("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8b56a544\",\"scoped\":false,\"hasInlineConfig\":false}!./firebaseui.css");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(19)(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,500,700);", ""]);

// module
exports.push([module.i, "\n.mdl-button {\n  background: 0 0;\n  border: none;\n  border-radius: 2px;\n  color: #000;\n  position: relative;\n  height: 36px;\n  margin: 0;\n  min-width: 64px;\n  padding: 0 16px;\n  display: inline-block;\n  font-family: Roboto, Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  line-height: 1;\n  letter-spacing: 0;\n  overflow: hidden;\n  will-change: box-shadow;\n  -webkit-transition: background-color .2s cubic-bezier(.4, 0, .2, 1), color .2s cubic-bezier(.4, 0, .2, 1), -webkit-box-shadow .2s cubic-bezier(.4, 0, 1, 1);\n          transition: background-color .2s cubic-bezier(.4, 0, .2, 1), color .2s cubic-bezier(.4, 0, .2, 1), -webkit-box-shadow .2s cubic-bezier(.4, 0, 1, 1);\n          transition: box-shadow .2s cubic-bezier(.4, 0, 1, 1), background-color .2s cubic-bezier(.4, 0, .2, 1), color .2s cubic-bezier(.4, 0, .2, 1);\n          transition: box-shadow .2s cubic-bezier(.4, 0, 1, 1), background-color .2s cubic-bezier(.4, 0, .2, 1), color .2s cubic-bezier(.4, 0, .2, 1), -webkit-box-shadow .2s cubic-bezier(.4, 0, 1, 1);\n  outline: 0;\n  cursor: pointer;\n  text-decoration: none;\n  text-align: center;\n  line-height: 36px;\n  vertical-align: middle;\n}\n.mdl-button::-moz-focus-inner {\n  border: 0;\n}\n.mdl-button:hover {\n  background-color: rgba(158, 158, 158, .2);\n}\n.mdl-button:focus:not(:active) {\n  background-color: rgba(0, 0, 0, .12);\n}\n.mdl-button:active {\n  background-color: rgba(158, 158, 158, .4);\n}\n.mdl-button.mdl-button--colored {\n  color: #3f51b5;\n}\n.mdl-button.mdl-button--colored:focus:not(:active) {\n  background-color: rgba(0, 0, 0, .12);\n}\ninput.mdl-button[type=submit] {\n  -webkit-appearance: none;\n}\n.mdl-button--raised {\n  background: rgba(158, 158, 158, .2);\n  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);\n          box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);\n}\n.mdl-button--raised:active {\n  -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);\n          box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);\n  background-color: rgba(158, 158, 158, .4);\n}\n.mdl-button--raised:focus:not(:active) {\n  -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, .18), 0 8px 16px rgba(0, 0, 0, .36);\n          box-shadow: 0 0 8px rgba(0, 0, 0, .18), 0 8px 16px rgba(0, 0, 0, .36);\n  background-color: rgba(158, 158, 158, .4);\n}\n.mdl-button--raised.mdl-button--colored {\n  background: #3f51b5;\n  color: #fff;\n}\n.mdl-button--raised.mdl-button--colored:hover {\n  background-color: #3f51b5;\n}\n.mdl-button--raised.mdl-button--colored:active {\n  background-color: #3f51b5;\n}\n.mdl-button--raised.mdl-button--colored:focus:not(:active) {\n  background-color: #3f51b5;\n}\n.mdl-button--raised.mdl-button--colored .mdl-ripple {\n  background: #fff;\n}\n.mdl-button--fab {\n  border-radius: 50%;\n  font-size: 24px;\n  height: 56px;\n  margin: auto;\n  min-width: 56px;\n  width: 56px;\n  padding: 0;\n  overflow: hidden;\n  background: rgba(158, 158, 158, .2);\n  -webkit-box-shadow: 0 1px 1.5px 0 rgba(0, 0, 0, .12), 0 1px 1px 0 rgba(0, 0, 0, .24);\n          box-shadow: 0 1px 1.5px 0 rgba(0, 0, 0, .12), 0 1px 1px 0 rgba(0, 0, 0, .24);\n  position: relative;\n  line-height: normal;\n}\n.mdl-button--fab .material-icons {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-12px, -12px);\n          transform: translate(-12px, -12px);\n  line-height: 24px;\n  width: 24px;\n}\n.mdl-button--fab.mdl-button--mini-fab {\n  height: 40px;\n  min-width: 40px;\n  width: 40px;\n}\n.mdl-button--fab .mdl-button__ripple-container {\n  border-radius: 50%;\n  -webkit-mask-image: -webkit-radial-gradient(circle, #fff, #000);\n}\n.mdl-button--fab:active {\n  -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);\n          box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);\n  background-color: rgba(158, 158, 158, .4);\n}\n.mdl-button--fab:focus:not(:active) {\n  -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, .18), 0 8px 16px rgba(0, 0, 0, .36);\n          box-shadow: 0 0 8px rgba(0, 0, 0, .18), 0 8px 16px rgba(0, 0, 0, .36);\n  background-color: rgba(158, 158, 158, .4);\n}\n.mdl-button--fab.mdl-button--colored {\n  background: #ff4081;\n  color: #fff;\n}\n.mdl-button--fab.mdl-button--colored:hover {\n  background-color: #ff4081;\n}\n.mdl-button--fab.mdl-button--colored:focus:not(:active) {\n  background-color: #ff4081;\n}\n.mdl-button--fab.mdl-button--colored:active {\n  background-color: #ff4081;\n}\n.mdl-button--fab.mdl-button--colored .mdl-ripple {\n  background: #fff;\n}\n.mdl-button--icon {\n  border-radius: 50%;\n  font-size: 24px;\n  height: 32px;\n  margin-left: 0;\n  margin-right: 0;\n  min-width: 32px;\n  width: 32px;\n  padding: 0;\n  overflow: hidden;\n  color: inherit;\n  line-height: normal;\n}\n.mdl-button--icon .material-icons {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-12px, -12px);\n          transform: translate(-12px, -12px);\n  line-height: 24px;\n  width: 24px;\n}\n.mdl-button--icon.mdl-button--mini-icon {\n  height: 24px;\n  min-width: 24px;\n  width: 24px;\n}\n.mdl-button--icon.mdl-button--mini-icon .material-icons {\n  top: 0;\n  left: 0;\n}\n.mdl-button--icon .mdl-button__ripple-container {\n  border-radius: 50%;\n  -webkit-mask-image: -webkit-radial-gradient(circle, #fff, #000);\n}\n.mdl-button__ripple-container {\n  display: block;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 0;\n  overflow: hidden;\n}\n.mdl-button.mdl-button--disabled .mdl-button__ripple-container .mdl-ripple,\n.mdl-button[disabled] .mdl-button__ripple-container .mdl-ripple {\n  background-color: transparent;\n}\n.mdl-button--primary.mdl-button--primary {\n  color: #3f51b5;\n}\n.mdl-button--primary.mdl-button--primary .mdl-ripple {\n  background: #fff;\n}\n.mdl-button--primary.mdl-button--primary.mdl-button--fab,\n.mdl-button--primary.mdl-button--primary.mdl-button--raised {\n  color: #fff;\n  background-color: #3f51b5;\n}\n.mdl-button--accent.mdl-button--accent {\n  color: #ff4081;\n}\n.mdl-button--accent.mdl-button--accent .mdl-ripple {\n  background: #fff;\n}\n.mdl-button--accent.mdl-button--accent.mdl-button--fab,\n.mdl-button--accent.mdl-button--accent.mdl-button--raised {\n  color: #fff;\n  background-color: #ff4081;\n}\n.mdl-button.mdl-button--disabled.mdl-button--disabled,\n.mdl-button[disabled][disabled] {\n  color: rgba(0, 0, 0, .26);\n  cursor: default;\n  background-color: transparent;\n}\n.mdl-button--fab.mdl-button--disabled.mdl-button--disabled,\n.mdl-button--fab[disabled][disabled] {\n  background-color: rgba(0, 0, 0, .12);\n  color: rgba(0, 0, 0, .26);\n}\n.mdl-button--raised.mdl-button--disabled.mdl-button--disabled,\n.mdl-button--raised[disabled][disabled] {\n  background-color: rgba(0, 0, 0, .12);\n  color: rgba(0, 0, 0, .26);\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.mdl-button--colored.mdl-button--disabled.mdl-button--disabled,\n.mdl-button--colored[disabled][disabled] {\n  color: rgba(0, 0, 0, .26);\n}\n.mdl-button .material-icons {\n  vertical-align: middle;\n}\n.mdl-card {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  font-size: 16px;\n  font-weight: 400;\n  min-height: 200px;\n  overflow: hidden;\n  width: 330px;\n  z-index: 1;\n  position: relative;\n  background: #fff;\n  border-radius: 2px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.mdl-card__media {\n  background-color: #ff4081;\n  background-repeat: repeat;\n  background-position: 50% 50%;\n  background-size: cover;\n  background-origin: padding-box;\n  background-attachment: scroll;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.mdl-card__title {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  color: #000;\n  display: block;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: stretch;\n  -ms-flex-pack: stretch;\n  justify-content: stretch;\n  line-height: normal;\n  padding: 16px 16px;\n  -webkit-perspective-origin: 165px 56px;\n          perspective-origin: 165px 56px;\n  -webkit-transform-origin: 165px 56px;\n          transform-origin: 165px 56px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.mdl-card__title.mdl-card--border {\n  border-bottom: 1px solid rgba(0, 0, 0, .1);\n}\n.mdl-card__title-text {\n  -ms-flex-item-align: end;\n  align-self: flex-end;\n  color: inherit;\n  display: block;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 24px;\n  font-weight: 300;\n  line-height: normal;\n  overflow: hidden;\n  -webkit-transform-origin: 149px 48px;\n          transform-origin: 149px 48px;\n  margin: 0;\n}\n.mdl-card__subtitle-text {\n  font-size: 14px;\n  color: rgba(0, 0, 0, .54);\n  margin: 0;\n}\n.mdl-card__supporting-text {\n  color: rgba(0, 0, 0, .54);\n  font-size: 1rem;\n  line-height: 18px;\n  overflow: hidden;\n  padding: 16px 16px;\n  width: 90%;\n}\n.mdl-card__supporting-text.mdl-card--border {\n  border-bottom: 1px solid rgba(0, 0, 0, .1);\n}\n.mdl-card__actions {\n  font-size: 16px;\n  line-height: normal;\n  width: 100%;\n  background-color: transparent;\n  padding: 8px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.mdl-card__actions.mdl-card--border {\n  border-top: 1px solid rgba(0, 0, 0, .1);\n}\n.mdl-card--expand {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n}\n.mdl-card__menu {\n  position: absolute;\n  right: 16px;\n  top: 16px;\n}\n.mdl-dialog {\n  border: none;\n  -webkit-box-shadow: 0 9px 46px 8px rgba(0, 0, 0, .14), 0 11px 15px -7px rgba(0, 0, 0, .12), 0 24px 38px 3px rgba(0, 0, 0, .2);\n          box-shadow: 0 9px 46px 8px rgba(0, 0, 0, .14), 0 11px 15px -7px rgba(0, 0, 0, .12), 0 24px 38px 3px rgba(0, 0, 0, .2);\n  width: 280px;\n}\n.mdl-dialog__title {\n  padding: 24px 24px 0;\n  margin: 0;\n  font-size: 2.5rem;\n}\n.mdl-dialog__actions {\n  padding: 8px 8px 8px 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n  -ms-flex-direction: row-reverse;\n      flex-direction: row-reverse;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.mdl-dialog__actions>* {\n  margin-right: 8px;\n  height: 36px;\n}\n.mdl-dialog__actions>:first-child {\n  margin-right: 0;\n}\n.mdl-dialog__actions--full-width {\n  padding: 0 0 8px 0;\n}\n.mdl-dialog__actions--full-width>* {\n  height: 48px;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 100%;\n      flex: 0 0 100%;\n  padding-right: 16px;\n  margin-right: 0;\n  text-align: right;\n}\n.mdl-dialog__content {\n  padding: 20px 24px 24px 24px;\n  color: rgba(0, 0, 0, .54);\n}\n.mdl-progress {\n  display: block;\n  position: relative;\n  height: 4px;\n  width: 500px;\n  max-width: 100%;\n}\n.mdl-progress>.bar {\n  display: block;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 0%;\n  -webkit-transition: width .2s cubic-bezier(.4, 0, .2, 1);\n          transition: width .2s cubic-bezier(.4, 0, .2, 1);\n}\n.mdl-progress>.progressbar {\n  background-color: #3f51b5;\n  z-index: 1;\n  left: 0;\n}\n.mdl-progress>.bufferbar {\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, .7)), to(rgba(255, 255, 255, .7))), -webkit-gradient(linear, left top, right top, from(#3f51b5), to(#3f51b5));\n  background-image: linear-gradient(to right, rgba(255, 255, 255, .7), rgba(255, 255, 255, .7)), linear-gradient(to right, #3f51b5, #3f51b5);\n  z-index: 0;\n  left: 0;\n}\n.mdl-progress>.auxbar {\n  right: 0;\n}\n@supports (-webkit-appearance:none) {\n.mdl-progress:not(.mdl-progress--indeterminate):not(.mdl-progress--indeterminate)>.auxbar,\n  .mdl-progress:not(.mdl-progress__indeterminate):not(.mdl-progress__indeterminate)>.auxbar {\n    background-image: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, .7)), to(rgba(255, 255, 255, .7))), -webkit-gradient(linear, left top, right top, from(#3f51b5), to(#3f51b5));\n    background-image: linear-gradient(to right, rgba(255, 255, 255, .7), rgba(255, 255, 255, .7)), linear-gradient(to right, #3f51b5, #3f51b5);\n    -webkit-mask: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+Cjxzdmcgd2lkdGg9IjEyIiBoZWlnaHQ9IjQiIHZpZXdQb3J0PSIwIDAgMTIgNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxlbGxpcHNlIGN4PSIyIiBjeT0iMiIgcng9IjIiIHJ5PSIyIj4KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN4IiBmcm9tPSIyIiB0bz0iLTEwIiBkdXI9IjAuNnMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogIDwvZWxsaXBzZT4KICA8ZWxsaXBzZSBjeD0iMTQiIGN5PSIyIiByeD0iMiIgcnk9IjIiIGNsYXNzPSJsb2FkZXIiPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iY3giIGZyb209IjE0IiB0bz0iMiIgZHVyPSIwLjZzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgLz4KICA8L2VsbGlwc2U+Cjwvc3ZnPgo=);\n            mask: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+Cjxzdmcgd2lkdGg9IjEyIiBoZWlnaHQ9IjQiIHZpZXdQb3J0PSIwIDAgMTIgNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxlbGxpcHNlIGN4PSIyIiBjeT0iMiIgcng9IjIiIHJ5PSIyIj4KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN4IiBmcm9tPSIyIiB0bz0iLTEwIiBkdXI9IjAuNnMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogIDwvZWxsaXBzZT4KICA8ZWxsaXBzZSBjeD0iMTQiIGN5PSIyIiByeD0iMiIgcnk9IjIiIGNsYXNzPSJsb2FkZXIiPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iY3giIGZyb209IjE0IiB0bz0iMiIgZHVyPSIwLjZzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgLz4KICA8L2VsbGlwc2U+Cjwvc3ZnPgo=);\n}\n}\n.mdl-progress:not(.mdl-progress--indeterminate)>.auxbar,\n.mdl-progress:not(.mdl-progress__indeterminate)>.auxbar {\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, .9)), to(rgba(255, 255, 255, .9))), -webkit-gradient(linear, left top, right top, from(#3f51b5), to(#3f51b5));\n  background-image: linear-gradient(to right, rgba(255, 255, 255, .9), rgba(255, 255, 255, .9)), linear-gradient(to right, #3f51b5, #3f51b5);\n}\n.mdl-progress.mdl-progress--indeterminate>.bar1,\n.mdl-progress.mdl-progress__indeterminate>.bar1 {\n  background-color: #3f51b5;\n  -webkit-animation-name: indeterminate1;\n          animation-name: indeterminate1;\n  -webkit-animation-duration: 2s;\n          animation-duration: 2s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n}\n.mdl-progress.mdl-progress--indeterminate>.bar3,\n.mdl-progress.mdl-progress__indeterminate>.bar3 {\n  background-image: none;\n  background-color: #3f51b5;\n  -webkit-animation-name: indeterminate2;\n          animation-name: indeterminate2;\n  -webkit-animation-duration: 2s;\n          animation-duration: 2s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n}\n@-webkit-keyframes indeterminate1 {\n0% {\n    left: 0;\n    width: 0%;\n}\n50% {\n    left: 25%;\n    width: 75%;\n}\n75% {\n    left: 100%;\n    width: 0%;\n}\n}\n@keyframes indeterminate1 {\n0% {\n    left: 0;\n    width: 0%;\n}\n50% {\n    left: 25%;\n    width: 75%;\n}\n75% {\n    left: 100%;\n    width: 0%;\n}\n}\n@-webkit-keyframes indeterminate2 {\n0% {\n    left: 0;\n    width: 0%;\n}\n50% {\n    left: 0;\n    width: 0%;\n}\n75% {\n    left: 0;\n    width: 25%;\n}\n100% {\n    left: 100%;\n    width: 0%;\n}\n}\n@keyframes indeterminate2 {\n0% {\n    left: 0;\n    width: 0%;\n}\n50% {\n    left: 0;\n    width: 0%;\n}\n75% {\n    left: 0;\n    width: 25%;\n}\n100% {\n    left: 100%;\n    width: 0%;\n}\n}\n.mdl-shadow--2dp {\n  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);\n          box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);\n}\n.mdl-shadow--3dp {\n  -webkit-box-shadow: 0 3px 4px 0 rgba(0, 0, 0, .14), 0 3px 3px -2px rgba(0, 0, 0, .2), 0 1px 8px 0 rgba(0, 0, 0, .12);\n          box-shadow: 0 3px 4px 0 rgba(0, 0, 0, .14), 0 3px 3px -2px rgba(0, 0, 0, .2), 0 1px 8px 0 rgba(0, 0, 0, .12);\n}\n.mdl-shadow--4dp {\n  -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);\n          box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);\n}\n.mdl-shadow--6dp {\n  -webkit-box-shadow: 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px -1px rgba(0, 0, 0, .2);\n          box-shadow: 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px -1px rgba(0, 0, 0, .2);\n}\n.mdl-shadow--8dp {\n  -webkit-box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12), 0 5px 5px -3px rgba(0, 0, 0, .2);\n          box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12), 0 5px 5px -3px rgba(0, 0, 0, .2);\n}\n.mdl-shadow--16dp {\n  -webkit-box-shadow: 0 16px 24px 2px rgba(0, 0, 0, .14), 0 6px 30px 5px rgba(0, 0, 0, .12), 0 8px 10px -5px rgba(0, 0, 0, .2);\n          box-shadow: 0 16px 24px 2px rgba(0, 0, 0, .14), 0 6px 30px 5px rgba(0, 0, 0, .12), 0 8px 10px -5px rgba(0, 0, 0, .2);\n}\n.mdl-shadow--24dp {\n  -webkit-box-shadow: 0 9px 46px 8px rgba(0, 0, 0, .14), 0 11px 15px -7px rgba(0, 0, 0, .12), 0 24px 38px 3px rgba(0, 0, 0, .2);\n          box-shadow: 0 9px 46px 8px rgba(0, 0, 0, .14), 0 11px 15px -7px rgba(0, 0, 0, .12), 0 24px 38px 3px rgba(0, 0, 0, .2);\n}\n.mdl-spinner {\n  display: inline-block;\n  position: relative;\n  width: 28px;\n  height: 28px;\n}\n.mdl-spinner:not(.is-upgraded).is-active:after {\n  content: \"Loading...\";\n}\n.mdl-spinner.is-upgraded.is-active {\n  -webkit-animation: mdl-spinner__container-rotate 1.568s linear infinite;\n          animation: mdl-spinner__container-rotate 1.568s linear infinite;\n}\n@-webkit-keyframes mdl-spinner__container-rotate {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes mdl-spinner__container-rotate {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.mdl-spinner__layer {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n}\n.mdl-spinner__layer-1 {\n  border-color: #42a5f5;\n}\n.mdl-spinner--single-color .mdl-spinner__layer-1 {\n  border-color: #3f51b5;\n}\n.mdl-spinner.is-active .mdl-spinner__layer-1 {\n  -webkit-animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-1-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n          animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-1-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n}\n.mdl-spinner__layer-2 {\n  border-color: #f44336;\n}\n.mdl-spinner--single-color .mdl-spinner__layer-2 {\n  border-color: #3f51b5;\n}\n.mdl-spinner.is-active .mdl-spinner__layer-2 {\n  -webkit-animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-2-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n          animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-2-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n}\n.mdl-spinner__layer-3 {\n  border-color: #fdd835;\n}\n.mdl-spinner--single-color .mdl-spinner__layer-3 {\n  border-color: #3f51b5;\n}\n.mdl-spinner.is-active .mdl-spinner__layer-3 {\n  -webkit-animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-3-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n          animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-3-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n}\n.mdl-spinner__layer-4 {\n  border-color: #4caf50;\n}\n.mdl-spinner--single-color .mdl-spinner__layer-4 {\n  border-color: #3f51b5;\n}\n.mdl-spinner.is-active .mdl-spinner__layer-4 {\n  -webkit-animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-4-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n          animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-4-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n}\n@-webkit-keyframes mdl-spinner__fill-unfill-rotate {\n12.5% {\n    -webkit-transform: rotate(135deg);\n            transform: rotate(135deg);\n}\n25% {\n    -webkit-transform: rotate(270deg);\n            transform: rotate(270deg);\n}\n37.5% {\n    -webkit-transform: rotate(405deg);\n            transform: rotate(405deg);\n}\n50% {\n    -webkit-transform: rotate(540deg);\n            transform: rotate(540deg);\n}\n62.5% {\n    -webkit-transform: rotate(675deg);\n            transform: rotate(675deg);\n}\n75% {\n    -webkit-transform: rotate(810deg);\n            transform: rotate(810deg);\n}\n87.5% {\n    -webkit-transform: rotate(945deg);\n            transform: rotate(945deg);\n}\nto {\n    -webkit-transform: rotate(1080deg);\n            transform: rotate(1080deg);\n}\n}\n@keyframes mdl-spinner__fill-unfill-rotate {\n12.5% {\n    -webkit-transform: rotate(135deg);\n            transform: rotate(135deg);\n}\n25% {\n    -webkit-transform: rotate(270deg);\n            transform: rotate(270deg);\n}\n37.5% {\n    -webkit-transform: rotate(405deg);\n            transform: rotate(405deg);\n}\n50% {\n    -webkit-transform: rotate(540deg);\n            transform: rotate(540deg);\n}\n62.5% {\n    -webkit-transform: rotate(675deg);\n            transform: rotate(675deg);\n}\n75% {\n    -webkit-transform: rotate(810deg);\n            transform: rotate(810deg);\n}\n87.5% {\n    -webkit-transform: rotate(945deg);\n            transform: rotate(945deg);\n}\nto {\n    -webkit-transform: rotate(1080deg);\n            transform: rotate(1080deg);\n}\n}\n@-webkit-keyframes mdl-spinner__layer-1-fade-in-out {\nfrom {\n    opacity: .99;\n}\n25% {\n    opacity: .99;\n}\n26% {\n    opacity: 0;\n}\n89% {\n    opacity: 0;\n}\n90% {\n    opacity: .99;\n}\n100% {\n    opacity: .99;\n}\n}\n@keyframes mdl-spinner__layer-1-fade-in-out {\nfrom {\n    opacity: .99;\n}\n25% {\n    opacity: .99;\n}\n26% {\n    opacity: 0;\n}\n89% {\n    opacity: 0;\n}\n90% {\n    opacity: .99;\n}\n100% {\n    opacity: .99;\n}\n}\n@-webkit-keyframes mdl-spinner__layer-2-fade-in-out {\nfrom {\n    opacity: 0;\n}\n15% {\n    opacity: 0;\n}\n25% {\n    opacity: .99;\n}\n50% {\n    opacity: .99;\n}\n51% {\n    opacity: 0;\n}\n}\n@keyframes mdl-spinner__layer-2-fade-in-out {\nfrom {\n    opacity: 0;\n}\n15% {\n    opacity: 0;\n}\n25% {\n    opacity: .99;\n}\n50% {\n    opacity: .99;\n}\n51% {\n    opacity: 0;\n}\n}\n@-webkit-keyframes mdl-spinner__layer-3-fade-in-out {\nfrom {\n    opacity: 0;\n}\n40% {\n    opacity: 0;\n}\n50% {\n    opacity: .99;\n}\n75% {\n    opacity: .99;\n}\n76% {\n    opacity: 0;\n}\n}\n@keyframes mdl-spinner__layer-3-fade-in-out {\nfrom {\n    opacity: 0;\n}\n40% {\n    opacity: 0;\n}\n50% {\n    opacity: .99;\n}\n75% {\n    opacity: .99;\n}\n76% {\n    opacity: 0;\n}\n}\n@-webkit-keyframes mdl-spinner__layer-4-fade-in-out {\nfrom {\n    opacity: 0;\n}\n65% {\n    opacity: 0;\n}\n75% {\n    opacity: .99;\n}\n90% {\n    opacity: .99;\n}\n100% {\n    opacity: 0;\n}\n}\n@keyframes mdl-spinner__layer-4-fade-in-out {\nfrom {\n    opacity: 0;\n}\n65% {\n    opacity: 0;\n}\n75% {\n    opacity: .99;\n}\n90% {\n    opacity: .99;\n}\n100% {\n    opacity: 0;\n}\n}\n.mdl-spinner__gap-patch {\n  position: absolute;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  top: 0;\n  left: 45%;\n  width: 10%;\n  height: 100%;\n  overflow: hidden;\n  border-color: inherit;\n}\n.mdl-spinner__gap-patch .mdl-spinner__circle {\n  width: 1000%;\n  left: -450%;\n}\n.mdl-spinner__circle-clipper {\n  display: inline-block;\n  position: relative;\n  width: 50%;\n  height: 100%;\n  overflow: hidden;\n  border-color: inherit;\n}\n.mdl-spinner__circle-clipper.mdl-spinner__left {\n  float: left;\n}\n.mdl-spinner__circle-clipper.mdl-spinner__right {\n  float: right;\n}\n.mdl-spinner__circle-clipper .mdl-spinner__circle {\n  width: 200%;\n}\n.mdl-spinner__circle {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 100%;\n  border-width: 3px;\n  border-style: solid;\n  border-color: inherit;\n  border-bottom-color: transparent !important;\n  border-radius: 50%;\n  -webkit-animation: none;\n          animation: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.mdl-spinner__left .mdl-spinner__circle {\n  border-right-color: transparent !important;\n  -webkit-transform: rotate(129deg);\n          transform: rotate(129deg);\n}\n.mdl-spinner.is-active .mdl-spinner__left .mdl-spinner__circle {\n  -webkit-animation: mdl-spinner__left-spin 1333ms cubic-bezier(.4, 0, .2, 1) infinite both;\n          animation: mdl-spinner__left-spin 1333ms cubic-bezier(.4, 0, .2, 1) infinite both;\n}\n.mdl-spinner__right .mdl-spinner__circle {\n  left: -100%;\n  border-left-color: transparent !important;\n  -webkit-transform: rotate(-129deg);\n          transform: rotate(-129deg);\n}\n.mdl-spinner.is-active .mdl-spinner__right .mdl-spinner__circle {\n  -webkit-animation: mdl-spinner__right-spin 1333ms cubic-bezier(.4, 0, .2, 1) infinite both;\n          animation: mdl-spinner__right-spin 1333ms cubic-bezier(.4, 0, .2, 1) infinite both;\n}\n@-webkit-keyframes mdl-spinner__left-spin {\nfrom {\n    -webkit-transform: rotate(130deg);\n            transform: rotate(130deg);\n}\n50% {\n    -webkit-transform: rotate(-5deg);\n            transform: rotate(-5deg);\n}\nto {\n    -webkit-transform: rotate(130deg);\n            transform: rotate(130deg);\n}\n}\n@keyframes mdl-spinner__left-spin {\nfrom {\n    -webkit-transform: rotate(130deg);\n            transform: rotate(130deg);\n}\n50% {\n    -webkit-transform: rotate(-5deg);\n            transform: rotate(-5deg);\n}\nto {\n    -webkit-transform: rotate(130deg);\n            transform: rotate(130deg);\n}\n}\n@-webkit-keyframes mdl-spinner__right-spin {\nfrom {\n    -webkit-transform: rotate(-130deg);\n            transform: rotate(-130deg);\n}\n50% {\n    -webkit-transform: rotate(5deg);\n            transform: rotate(5deg);\n}\nto {\n    -webkit-transform: rotate(-130deg);\n            transform: rotate(-130deg);\n}\n}\n@keyframes mdl-spinner__right-spin {\nfrom {\n    -webkit-transform: rotate(-130deg);\n            transform: rotate(-130deg);\n}\n50% {\n    -webkit-transform: rotate(5deg);\n            transform: rotate(5deg);\n}\nto {\n    -webkit-transform: rotate(-130deg);\n            transform: rotate(-130deg);\n}\n}\n.mdl-textfield {\n  position: relative;\n  font-size: 16px;\n  display: inline-block;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 300px;\n  max-width: 100%;\n  margin: 0;\n  padding: 20px 0;\n}\n.mdl-textfield .mdl-button {\n  position: absolute;\n  bottom: 20px;\n}\n.mdl-textfield--align-right {\n  text-align: right;\n}\n.mdl-textfield--full-width {\n  width: 100%;\n}\n.mdl-textfield--expandable {\n  min-width: 32px;\n  width: auto;\n  min-height: 32px;\n}\n.mdl-textfield--expandable .mdl-button--icon {\n  top: 16px;\n}\n.mdl-textfield__input {\n  border: none;\n  border-bottom: 1px solid rgba(0, 0, 0, .12);\n  display: block;\n  font-size: 16px;\n  font-family: Helvetica, Arial, sans-serif;\n  margin: 0;\n  padding: 4px 0;\n  width: 100%;\n  background: 0 0;\n  text-align: left;\n  color: inherit;\n}\n.mdl-textfield__input[type=number] {\n  -moz-appearance: textfield;\n}\n.mdl-textfield__input[type=number]::-webkit-inner-spin-button,\n.mdl-textfield__input[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.mdl-textfield.is-focused .mdl-textfield__input {\n  outline: 0;\n}\n.mdl-textfield.is-invalid .mdl-textfield__input {\n  border-color: #d50000;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.mdl-textfield.is-disabled .mdl-textfield__input,\nfieldset[disabled] .mdl-textfield .mdl-textfield__input {\n  background-color: transparent;\n  border-bottom: 1px dotted rgba(0, 0, 0, .12);\n  color: rgba(0, 0, 0, .26);\n}\n.mdl-textfield textarea.mdl-textfield__input {\n  display: block;\n}\n.mdl-textfield__label {\n  bottom: 0;\n  color: rgba(0, 0, 0, .26);\n  font-size: 16px;\n  left: 0;\n  right: 0;\n  pointer-events: none;\n  position: absolute;\n  display: block;\n  top: 24px;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-align: left;\n}\n.mdl-textfield.has-placeholder .mdl-textfield__label,\n.mdl-textfield.is-dirty .mdl-textfield__label {\n  visibility: hidden;\n}\n.mdl-textfield--floating-label .mdl-textfield__label {\n  -webkit-transition-duration: .2s;\n          transition-duration: .2s;\n  -webkit-transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n          transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n}\n.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label {\n  -webkit-transition: none;\n          transition: none;\n}\n.mdl-textfield.is-disabled.is-disabled .mdl-textfield__label,\nfieldset[disabled] .mdl-textfield .mdl-textfield__label {\n  color: rgba(0, 0, 0, .26);\n}\n.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label,\n.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,\n.mdl-textfield--floating-label.is-focused .mdl-textfield__label {\n  color: #3f51b5;\n  font-size: 12px;\n  top: 4px;\n  visibility: visible;\n}\n.mdl-textfield--floating-label.has-placeholder .mdl-textfield__expandable-holder .mdl-textfield__label,\n.mdl-textfield--floating-label.is-dirty .mdl-textfield__expandable-holder .mdl-textfield__label,\n.mdl-textfield--floating-label.is-focused .mdl-textfield__expandable-holder .mdl-textfield__label {\n  top: -16px;\n}\n.mdl-textfield--floating-label.is-invalid .mdl-textfield__label {\n  color: #d50000;\n  font-size: 12px;\n}\n.mdl-textfield__label:after {\n  background-color: #3f51b5;\n  bottom: 20px;\n  content: '';\n  height: 2px;\n  left: 45%;\n  position: absolute;\n  -webkit-transition-duration: .2s;\n          transition-duration: .2s;\n  -webkit-transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n          transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n  visibility: hidden;\n  width: 10px;\n}\n.mdl-textfield.is-focused .mdl-textfield__label:after {\n  left: 0;\n  visibility: visible;\n  width: 100%;\n}\n.mdl-textfield.is-invalid .mdl-textfield__label:after {\n  background-color: #d50000;\n}\n.mdl-textfield__error {\n  color: #d50000;\n  position: absolute;\n  font-size: 12px;\n  margin-top: 3px;\n  visibility: hidden;\n  display: block;\n}\n.mdl-textfield.is-invalid .mdl-textfield__error {\n  visibility: visible;\n}\n.mdl-textfield__expandable-holder {\n  display: inline-block;\n  position: relative;\n  margin-left: 32px;\n  -webkit-transition-duration: .2s;\n          transition-duration: .2s;\n  -webkit-transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n          transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n  display: inline-block;\n  max-width: .1px;\n}\n.mdl-textfield.is-dirty .mdl-textfield__expandable-holder,\n.mdl-textfield.is-focused .mdl-textfield__expandable-holder {\n  max-width: 600px;\n}\n.mdl-textfield__expandable-holder .mdl-textfield__label:after {\n  bottom: 0;\n}\ndialog {\n  position: absolute;\n  left: 0;\n  right: 0;\n  width: -moz-fit-content;\n  width: -webkit-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: -webkit-fit-content;\n  height: fit-content;\n  margin: auto;\n  border: solid;\n  padding: 1em;\n  background: #fff;\n  color: #000;\n  display: block;\n}\ndialog:not([open]) {\n  display: none;\n}\ndialog+.backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(0, 0, 0, .1);\n}\n._dialog_overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\ndialog.fixed {\n  position: fixed;\n  top: 50%;\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%);\n}\n.firebaseui-container {\n  background-color: #fff;\n          box-sizing: border-box;\n     -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  color: rgba(0, 0, 0, .87);\n  direction: ltr;\n  font: 16px Roboto, arial, sans-serif;\n  margin: 0 auto;\n  max-width: 360px;\n  overflow: visible;\n  position: relative;\n  text-align: left;\n  width: 100%;\n}\n.firebaseui-container.mdl-card {\n  overflow: visible;\n}\n.firebaseui-card-header {\n  padding: 24px 24px 0 24px;\n}\n.firebaseui-card-content {\n  padding: 0 24px;\n}\n.firebaseui-card-footer {\n  padding: 0 24px;\n}\n.firebaseui-card-actions {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: table;\n  font-size: 14px;\n  padding: 8px 24px 24px 24px;\n  text-align: left;\n  width: 100%;\n}\n.firebaseui-form-links {\n  display: table-cell;\n  vertical-align: middle;\n  width: 100%;\n}\n.firebaseui-form-actions {\n  display: table-cell;\n  text-align: right;\n  white-space: nowrap;\n  width: 100%;\n}\n.firebaseui-subtitle,\n.firebaseui-title {\n  color: rgba(0, 0, 0, .87);\n  direction: ltr;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 24px;\n  margin: 0;\n  padding: 0;\n  text-align: left;\n}\n.firebaseui-title {\n  padding-bottom: 16px;\n}\n.firebaseui-subtitle {\n  margin: 16px 0;\n}\n.firebaseui-text {\n  color: rgba(0, 0, 0, .87);\n  direction: ltr;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: left;\n}\n.firebaseui-id-page-password-recovery-email-sent p.firebaseui-text {\n  margin: 16px 0;\n}\n.firebaseui-text-emphasis {\n  font-weight: 700;\n}\n.firebaseui-error {\n  color: #dd2c00;\n  direction: ltr;\n  font-size: 12px;\n  line-height: 16px;\n  margin: 0;\n  text-align: left;\n}\n.firebaseui-text-input-error {\n  margin: -16px 0 16px;\n}\n.firebaseui-error-wrapper {\n  min-height: 16px;\n}\n.firebaseui-list-item {\n  direction: ltr;\n  margin: 0;\n  padding: 0;\n  text-align: left;\n}\n.firebaseui-hidden {\n  display: none;\n}\n.firebaseui-relative-wrapper {\n  position: relative;\n}\n.firebaseui-label {\n  color: rgba(0, 0, 0, .54);\n  direction: ltr;\n  font-size: 16px;\n  text-align: left;\n}\n.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,\n.mdl-textfield--floating-label.is-focused .mdl-textfield__label {\n  color: #757575;\n}\n.firebaseui-input,\n.firebaseui-input-invalid {\n  border-radius: 0;\n  color: rgba(0, 0, 0, .87);\n  direction: ltr;\n  font-size: 16px;\n  width: 100%;\n}\ninput.firebaseui-input,\ninput.firebaseui-input-invalid {\n  direction: ltr;\n  text-align: left;\n}\n.firebaseui-input-invalid {\n  border-color: #dd2c00;\n}\n.firebaseui-textfield {\n  width: 100%;\n}\n.firebaseui-textfield.mdl-textfield .firebaseui-input {\n  border-color: rgba(0, 0, 0, .12);\n}\n.firebaseui-textfield.mdl-textfield .firebaseui-label::after {\n  background-color: #3f51b5;\n}\n.firebaseui-textfield-invalid.mdl-textfield .firebaseui-input {\n  border-color: #dd2c00;\n}\n.firebaseui-textfield-invalid.mdl-textfield .firebaseui-label::after {\n  background-color: #dd2c00;\n}\n.firebaseui-button {\n  display: inline-block;\n  height: 36px;\n  margin-left: 8px;\n  min-width: 88px;\n}\n.firebaseui-link {\n  color: #4285f4;\n  font-variant: normal;\n  font-weight: 400;\n  text-decoration: none;\n}\n.firebaseui-link:hover {\n  text-decoration: underline;\n}\n.firebaseui-indent {\n  margin-left: 1em;\n}\n.firebaseui-tos {\n  color: #757575;\n  direction: ltr;\n  font-size: 12px;\n  line-height: 16px;\n  margin-bottom: 24px;\n  margin-top: 0;\n  text-align: left;\n}\n.firebaseui-provider-sign-in-footer>.firebaseui-tos {\n  text-align: center;\n}\n.firebaseui-tos-list {\n  list-style: none;\n  text-align: right;\n}\n.firebaseui-inline-list-item {\n  display: inline-block;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.firebaseui-page-provider-sign-in {\n  background: inherit;\n}\n.firebaseui-idp-list {\n  list-style: none;\n  margin: 1em 0;\n  padding: 0;\n}\n.firebaseui-idp-button {\n  direction: ltr;\n  font-weight: 500;\n  height: auto;\n  line-height: normal;\n  max-width: 220px;\n  min-height: 40px;\n  padding: 8px 16px;\n  text-align: left;\n  width: 100%;\n}\n.firebaseui-idp-list>.firebaseui-list-item {\n  margin-bottom: 15px;\n  text-align: center;\n}\n.firebaseui-idp-icon-wrapper {\n  display: table-cell;\n  vertical-align: middle;\n}\n.firebaseui-idp-icon {\n  border: none;\n  display: inline-block;\n  height: 18px;\n  vertical-align: middle;\n  width: 18px;\n}\n.firebaseui-idp-favicon {\n  border: none;\n  display: inline-block;\n  height: 14px;\n  margin-right: 5px;\n  vertical-align: middle;\n  width: 14px;\n}\n.firebaseui-idp-text {\n  color: #fff;\n  display: table-cell;\n  font-size: 14px;\n  padding-left: 16px;\n  text-transform: none;\n  vertical-align: middle;\n}\n.firebaseui-idp-text.firebaseui-idp-text-long {\n  display: table-cell;\n}\n.firebaseui-idp-text.firebaseui-idp-text-short {\n  display: none;\n}\n@media (max-width:268px) {\n.firebaseui-idp-text.firebaseui-idp-text-long {\n    display: none;\n}\n.firebaseui-idp-text.firebaseui-idp-text-short {\n    display: table-cell;\n}\n}\n@media (max-width:320px) {\n.firebaseui-recaptcha-container>div>div {\n            transform: scale(.9);\n    -webkit-transform: scale(.9);\n             transform-origin: 0 0;\n    -webkit-transform-origin: 0 0;\n}\n}\n.firebaseui-idp-password,\n.firebaseui-idp-password:hover,\n.mdl-button.firebaseui-idp-password:active,\n.mdl-button.firebaseui-idp-password:focus {\n  background-color: #db4437;\n}\n.firebaseui-idp-phone,\n.firebaseui-idp-phone:hover,\n.mdl-button.firebaseui-idp-phone:active,\n.mdl-button.firebaseui-idp-phone:focus {\n  background-color: #02bd7e;\n}\n.firebaseui-idp-google,\n.firebaseui-idp-google:hover,\n.mdl-button.firebaseui-idp-google:active,\n.mdl-button.firebaseui-idp-google:focus {\n  background-color: #fff;\n}\n.firebaseui-idp-google>.firebaseui-idp-text {\n  color: #757575;\n}\n.firebaseui-idp-github,\n.firebaseui-idp-github:hover,\n.mdl-button.firebaseui-idp-github:active,\n.mdl-button.firebaseui-idp-github:focus {\n  background-color: #333;\n}\n.firebaseui-idp-facebook,\n.firebaseui-idp-facebook:hover,\n.mdl-button.firebaseui-idp-facebook:active,\n.mdl-button.firebaseui-idp-facebook:focus {\n  background-color: #3b5998;\n}\n.firebaseui-idp-twitter,\n.firebaseui-idp-twitter:hover,\n.mdl-button.firebaseui-idp-twitter:active,\n.mdl-button.firebaseui-idp-twitter:focus {\n  background-color: #55acee;\n}\n.firebaseui-idp-anonymous,\n.firebaseui-idp-anonymous:hover,\n.mdl-button.firebaseui-idp-anonymous:active,\n.mdl-button.firebaseui-idp-anonymous:focus {\n  background-color: #f4b400;\n}\n.firebaseui-info-bar {\n  background-color: #f9edbe;\n  border: 1px solid #f0c36d;\n          box-shadow: 0 2px 4px rgba(0, 0, 0, .2);\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, .2);\n     -moz-box-shadow: 0 2px 4px rgba(0, 0, 0, .2);\n  left: 10%;\n  padding: 8px 16px;\n  position: absolute;\n  right: 10%;\n  text-align: center;\n  top: 0;\n}\n.firebaseui-info-bar-message {\n  font-size: 12px;\n  margin: 0;\n}\n.firebaseui-dialog {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: rgba(0, 0, 0, .87);\n  font: 16px Roboto, arial, sans-serif;\n  height: auto;\n  padding: 24px;\n  text-align: left;\n}\n.firebaseui-dialog-icon-wrapper {\n  display: table-cell;\n  vertical-align: middle;\n}\n.firebaseui-dialog-icon {\n  float: left;\n  height: 40px;\n  margin-right: 24px;\n  width: 40px;\n}\n.firebaseui-progress-dialog-message {\n  display: table-cell;\n  font-size: 16px;\n  font-weight: 400;\n  min-height: 40px;\n  vertical-align: middle;\n}\n.firebaseui-progress-dialog-loading-icon {\n  height: 28px;\n  margin: 6px 30px 6px 6px;\n  width: 28px;\n}\n.firebaseui-icon-done {\n  background-image: url(https://www.gstatic.com/images/icons/material/system/2x/done_googgreen_36dp.png);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 36px 36px;\n}\n.firebaseui-phone-number {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.firebaseui-country-selector {\n  background-image: url(https://www.gstatic.com/images/icons/material/system/1x/arrow_drop_down_grey600_18dp.png);\n  background-position: right center;\n  background-repeat: no-repeat;\n  background-size: 18px auto;\n  border-radius: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, .12);\n  color: rgba(0, 0, 0, .87);\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  font-size: 16px;\n  font-weight: 400;\n  height: initial;\n  line-height: normal;\n  margin: 20px 24px 20px 0;\n  padding: 4px 20px 4px 0;\n  width: 90px;\n}\n.firebaseui-country-selector-flag {\n  display: inline-block;\n  margin-right: 1ex;\n}\n.firebaseui-flag {\n  background-image: url(https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/flags_sprite_2x.png);\n  background-size: 100% auto;\n  -webkit-filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, .54));\n          filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, .54));\n  height: 14px;\n  width: 24px;\n}\n.firebaseui-list-box-dialog {\n  max-height: 90%;\n  overflow: auto;\n  padding: 8px 0 0 0;\n}\n.firebaseui-list-box-actions {\n  padding-bottom: 8px;\n}\n.firebaseui-list-box-icon-wrapper {\n  display: table-cell;\n  padding-right: 24px;\n  vertical-align: top;\n}\n.firebaseui-list-box-label-wrapper {\n  display: table-cell;\n  vertical-align: top;\n}\n.firebaseui-list-box-dialog-button {\n  color: rgba(0, 0, 0, .87);\n  direction: ltr;\n  font-size: 16px;\n  font-weight: 400;\n  height: initial;\n  line-height: normal;\n  min-height: 48px;\n  padding: 14px 24px;\n  text-align: left;\n  text-transform: none;\n  width: 100%;\n}\n.firebaseui-phone-number-error {\n  margin-left: 114px;\n}\n.mdl-progress.firebaseui-busy-indicator {\n  height: 2px;\n  left: 0;\n  position: absolute;\n  top: 55px;\n  width: 100%;\n}\n.mdl-spinner.firebaseui-busy-indicator {\n  height: 56px;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 30%;\n  width: 56px;\n}\n.firebaseui-callback-indicator-container .firebaseui-busy-indicator {\n  top: 0;\n}\n.firebaseui-callback-indicator-container {\n  height: 120px;\n}\n.firebaseui-new-password-component {\n  display: inline-block;\n  position: relative;\n  width: 100%;\n}\n.firebaseui-input-floating-button {\n  background-position: center;\n  background-repeat: no-repeat;\n  display: block;\n  height: 24px;\n  position: absolute;\n  right: 0;\n  top: 20px;\n  width: 24px;\n}\n.firebaseui-input-toggle-on {\n  background-image: url(https://www.gstatic.com/images/icons/material/system/1x/visibility_black_24dp.png);\n}\n.firebaseui-input-toggle-off {\n  background-image: url(https://www.gstatic.com/images/icons/material/system/1x/visibility_off_black_24dp.png);\n}\n.firebaseui-input-toggle-focus {\n  opacity: .87;\n}\n.firebaseui-input-toggle-blur {\n  opacity: .38;\n}\n.firebaseui-recaptcha-wrapper {\n  display: table;\n  margin: 0 auto;\n  padding-bottom: 8px;\n}\n.firebaseui-recaptcha-container {\n  display: table-cell;\n}\n.firebaseui-recaptcha-error-wrapper {\n  caption-side: bottom;\n  display: table-caption;\n}\n.firebaseui-change-phone-number-link {\n  display: block;\n}\n.firebaseui-resend-container {\n  direction: ltr;\n  margin: 20px 0;\n  text-align: center;\n}\n.firebaseui-id-resend-countdown {\n  color: rgba(0, 0, 0, .38);\n}\n.firebaseui-id-page-phone-sign-in-start .firebaseui-form-actions div {\n  float: left;\n}\n@media (max-width:480px) {\n.firebaseui-container {\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    max-width: none;\n    width: 100%;\n}\n.firebaseui-card-header {\n    border-bottom: 1px solid #e0e0e0;\n    margin-bottom: 16px;\n    padding: 16px 24px 0 24px;\n}\n.firebaseui-title {\n    padding-bottom: 16px;\n}\n.firebaseui-card-actions {\n    padding-right: 24px;\n}\n.firebaseui-busy-indicator {\n    top: 0;\n}\n}\n.mdl-textfield__label {\n  font-weight: 400;\n  margin-bottom: 0;\n}\n.firebaseui-id-page-blank {\n  background: inherit;\n  height: 64px;\n}\n.firebaseui-email-sent {\n  background-image: url(https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/success_status.png);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 64px 64px;\n  height: 64px;\n  margin-top: 16px;\n  text-align: center;\n}\n.firebaseui-text-justify {\n  text-align: justify;\n}\n.firebaseui-flag-KY {\n  background-position: 0 0;\n}\n.firebaseui-flag-AC {\n  background-position: 0 -14px;\n}\n.firebaseui-flag-AE {\n  background-position: 0 -28px;\n}\n.firebaseui-flag-AF {\n  background-position: 0 -42px;\n}\n.firebaseui-flag-AG {\n  background-position: 0 -56px;\n}\n.firebaseui-flag-AI {\n  background-position: 0 -70px;\n}\n.firebaseui-flag-AL {\n  background-position: 0 -84px;\n}\n.firebaseui-flag-AM {\n  background-position: 0 -98px;\n}\n.firebaseui-flag-AO {\n  background-position: 0 -112px;\n}\n.firebaseui-flag-AQ {\n  background-position: 0 -126px;\n}\n.firebaseui-flag-AR {\n  background-position: 0 -140px;\n}\n.firebaseui-flag-AS {\n  background-position: 0 -154px;\n}\n.firebaseui-flag-AT {\n  background-position: 0 -168px;\n}\n.firebaseui-flag-AU {\n  background-position: 0 -182px;\n}\n.firebaseui-flag-AW {\n  background-position: 0 -196px;\n}\n.firebaseui-flag-AX {\n  background-position: 0 -210px;\n}\n.firebaseui-flag-AZ {\n  background-position: 0 -224px;\n}\n.firebaseui-flag-BA {\n  background-position: 0 -238px;\n}\n.firebaseui-flag-BB {\n  background-position: 0 -252px;\n}\n.firebaseui-flag-BD {\n  background-position: 0 -266px;\n}\n.firebaseui-flag-BE {\n  background-position: 0 -280px;\n}\n.firebaseui-flag-BF {\n  background-position: 0 -294px;\n}\n.firebaseui-flag-BG {\n  background-position: 0 -308px;\n}\n.firebaseui-flag-BH {\n  background-position: 0 -322px;\n}\n.firebaseui-flag-BI {\n  background-position: 0 -336px;\n}\n.firebaseui-flag-BJ {\n  background-position: 0 -350px;\n}\n.firebaseui-flag-BL {\n  background-position: 0 -364px;\n}\n.firebaseui-flag-BM {\n  background-position: 0 -378px;\n}\n.firebaseui-flag-BN {\n  background-position: 0 -392px;\n}\n.firebaseui-flag-BO {\n  background-position: 0 -406px;\n}\n.firebaseui-flag-BQ {\n  background-position: 0 -420px;\n}\n.firebaseui-flag-BR {\n  background-position: 0 -434px;\n}\n.firebaseui-flag-BS {\n  background-position: 0 -448px;\n}\n.firebaseui-flag-BT {\n  background-position: 0 -462px;\n}\n.firebaseui-flag-BV {\n  background-position: 0 -476px;\n}\n.firebaseui-flag-BW {\n  background-position: 0 -490px;\n}\n.firebaseui-flag-BY {\n  background-position: 0 -504px;\n}\n.firebaseui-flag-BZ {\n  background-position: 0 -518px;\n}\n.firebaseui-flag-CA {\n  background-position: 0 -532px;\n}\n.firebaseui-flag-CC {\n  background-position: 0 -546px;\n}\n.firebaseui-flag-CD {\n  background-position: 0 -560px;\n}\n.firebaseui-flag-CF {\n  background-position: 0 -574px;\n}\n.firebaseui-flag-CG {\n  background-position: 0 -588px;\n}\n.firebaseui-flag-CH {\n  background-position: 0 -602px;\n}\n.firebaseui-flag-CI {\n  background-position: 0 -616px;\n}\n.firebaseui-flag-CK {\n  background-position: 0 -630px;\n}\n.firebaseui-flag-CL {\n  background-position: 0 -644px;\n}\n.firebaseui-flag-CM {\n  background-position: 0 -658px;\n}\n.firebaseui-flag-CN {\n  background-position: 0 -672px;\n}\n.firebaseui-flag-CO {\n  background-position: 0 -686px;\n}\n.firebaseui-flag-CP {\n  background-position: 0 -700px;\n}\n.firebaseui-flag-CR {\n  background-position: 0 -714px;\n}\n.firebaseui-flag-CU {\n  background-position: 0 -728px;\n}\n.firebaseui-flag-CV {\n  background-position: 0 -742px;\n}\n.firebaseui-flag-CW {\n  background-position: 0 -756px;\n}\n.firebaseui-flag-CX {\n  background-position: 0 -770px;\n}\n.firebaseui-flag-CY {\n  background-position: 0 -784px;\n}\n.firebaseui-flag-CZ {\n  background-position: 0 -798px;\n}\n.firebaseui-flag-DE {\n  background-position: 0 -812px;\n}\n.firebaseui-flag-DG {\n  background-position: 0 -826px;\n}\n.firebaseui-flag-DJ {\n  background-position: 0 -840px;\n}\n.firebaseui-flag-DK {\n  background-position: 0 -854px;\n}\n.firebaseui-flag-DM {\n  background-position: 0 -868px;\n}\n.firebaseui-flag-DO {\n  background-position: 0 -882px;\n}\n.firebaseui-flag-DZ {\n  background-position: 0 -896px;\n}\n.firebaseui-flag-EA {\n  background-position: 0 -910px;\n}\n.firebaseui-flag-EC {\n  background-position: 0 -924px;\n}\n.firebaseui-flag-EE {\n  background-position: 0 -938px;\n}\n.firebaseui-flag-EG {\n  background-position: 0 -952px;\n}\n.firebaseui-flag-EH {\n  background-position: 0 -966px;\n}\n.firebaseui-flag-ER {\n  background-position: 0 -980px;\n}\n.firebaseui-flag-ES {\n  background-position: 0 -994px;\n}\n.firebaseui-flag-ET {\n  background-position: 0 -1008px;\n}\n.firebaseui-flag-EU {\n  background-position: 0 -1022px;\n}\n.firebaseui-flag-FI {\n  background-position: 0 -1036px;\n}\n.firebaseui-flag-FJ {\n  background-position: 0 -1050px;\n}\n.firebaseui-flag-FK {\n  background-position: 0 -1064px;\n}\n.firebaseui-flag-FM {\n  background-position: 0 -1078px;\n}\n.firebaseui-flag-FO {\n  background-position: 0 -1092px;\n}\n.firebaseui-flag-FR {\n  background-position: 0 -1106px;\n}\n.firebaseui-flag-GA {\n  background-position: 0 -1120px;\n}\n.firebaseui-flag-GB {\n  background-position: 0 -1134px;\n}\n.firebaseui-flag-GD {\n  background-position: 0 -1148px;\n}\n.firebaseui-flag-GE {\n  background-position: 0 -1162px;\n}\n.firebaseui-flag-GF {\n  background-position: 0 -1176px;\n}\n.firebaseui-flag-GG {\n  background-position: 0 -1190px;\n}\n.firebaseui-flag-GH {\n  background-position: 0 -1204px;\n}\n.firebaseui-flag-GI {\n  background-position: 0 -1218px;\n}\n.firebaseui-flag-GL {\n  background-position: 0 -1232px;\n}\n.firebaseui-flag-GM {\n  background-position: 0 -1246px;\n}\n.firebaseui-flag-GN {\n  background-position: 0 -1260px;\n}\n.firebaseui-flag-GP {\n  background-position: 0 -1274px;\n}\n.firebaseui-flag-GQ {\n  background-position: 0 -1288px;\n}\n.firebaseui-flag-GR {\n  background-position: 0 -1302px;\n}\n.firebaseui-flag-GS {\n  background-position: 0 -1316px;\n}\n.firebaseui-flag-GT {\n  background-position: 0 -1330px;\n}\n.firebaseui-flag-GU {\n  background-position: 0 -1344px;\n}\n.firebaseui-flag-GW {\n  background-position: 0 -1358px;\n}\n.firebaseui-flag-GY {\n  background-position: 0 -1372px;\n}\n.firebaseui-flag-HK {\n  background-position: 0 -1386px;\n}\n.firebaseui-flag-HM {\n  background-position: 0 -1400px;\n}\n.firebaseui-flag-HN {\n  background-position: 0 -1414px;\n}\n.firebaseui-flag-HR {\n  background-position: 0 -1428px;\n}\n.firebaseui-flag-HT {\n  background-position: 0 -1442px;\n}\n.firebaseui-flag-HU {\n  background-position: 0 -1456px;\n}\n.firebaseui-flag-IC {\n  background-position: 0 -1470px;\n}\n.firebaseui-flag-ID {\n  background-position: 0 -1484px;\n}\n.firebaseui-flag-IE {\n  background-position: 0 -1498px;\n}\n.firebaseui-flag-IL {\n  background-position: 0 -1512px;\n}\n.firebaseui-flag-IM {\n  background-position: 0 -1526px;\n}\n.firebaseui-flag-IN {\n  background-position: 0 -1540px;\n}\n.firebaseui-flag-IO {\n  background-position: 0 -1554px;\n}\n.firebaseui-flag-IQ {\n  background-position: 0 -1568px;\n}\n.firebaseui-flag-IR {\n  background-position: 0 -1582px;\n}\n.firebaseui-flag-IS {\n  background-position: 0 -1596px;\n}\n.firebaseui-flag-IT {\n  background-position: 0 -1610px;\n}\n.firebaseui-flag-JE {\n  background-position: 0 -1624px;\n}\n.firebaseui-flag-JM {\n  background-position: 0 -1638px;\n}\n.firebaseui-flag-JO {\n  background-position: 0 -1652px;\n}\n.firebaseui-flag-JP {\n  background-position: 0 -1666px;\n}\n.firebaseui-flag-KE {\n  background-position: 0 -1680px;\n}\n.firebaseui-flag-KG {\n  background-position: 0 -1694px;\n}\n.firebaseui-flag-KH {\n  background-position: 0 -1708px;\n}\n.firebaseui-flag-KI {\n  background-position: 0 -1722px;\n}\n.firebaseui-flag-KM {\n  background-position: 0 -1736px;\n}\n.firebaseui-flag-KN {\n  background-position: 0 -1750px;\n}\n.firebaseui-flag-KP {\n  background-position: 0 -1764px;\n}\n.firebaseui-flag-KR {\n  background-position: 0 -1778px;\n}\n.firebaseui-flag-KW {\n  background-position: 0 -1792px;\n}\n.firebaseui-flag-AD {\n  background-position: 0 -1806px;\n}\n.firebaseui-flag-KZ {\n  background-position: 0 -1820px;\n}\n.firebaseui-flag-LA {\n  background-position: 0 -1834px;\n}\n.firebaseui-flag-LB {\n  background-position: 0 -1848px;\n}\n.firebaseui-flag-LC {\n  background-position: 0 -1862px;\n}\n.firebaseui-flag-LI {\n  background-position: 0 -1876px;\n}\n.firebaseui-flag-LK {\n  background-position: 0 -1890px;\n}\n.firebaseui-flag-LR {\n  background-position: 0 -1904px;\n}\n.firebaseui-flag-LS {\n  background-position: 0 -1918px;\n}\n.firebaseui-flag-LT {\n  background-position: 0 -1932px;\n}\n.firebaseui-flag-LU {\n  background-position: 0 -1946px;\n}\n.firebaseui-flag-LV {\n  background-position: 0 -1960px;\n}\n.firebaseui-flag-LY {\n  background-position: 0 -1974px;\n}\n.firebaseui-flag-MA {\n  background-position: 0 -1988px;\n}\n.firebaseui-flag-MC {\n  background-position: 0 -2002px;\n}\n.firebaseui-flag-MD {\n  background-position: 0 -2016px;\n}\n.firebaseui-flag-ME {\n  background-position: 0 -2030px;\n}\n.firebaseui-flag-MF {\n  background-position: 0 -2044px;\n}\n.firebaseui-flag-MG {\n  background-position: 0 -2058px;\n}\n.firebaseui-flag-MH {\n  background-position: 0 -2072px;\n}\n.firebaseui-flag-MK {\n  background-position: 0 -2086px;\n}\n.firebaseui-flag-ML {\n  background-position: 0 -2100px;\n}\n.firebaseui-flag-MM {\n  background-position: 0 -2114px;\n}\n.firebaseui-flag-MN {\n  background-position: 0 -2128px;\n}\n.firebaseui-flag-MO {\n  background-position: 0 -2142px;\n}\n.firebaseui-flag-MP {\n  background-position: 0 -2156px;\n}\n.firebaseui-flag-MQ {\n  background-position: 0 -2170px;\n}\n.firebaseui-flag-MR {\n  background-position: 0 -2184px;\n}\n.firebaseui-flag-MS {\n  background-position: 0 -2198px;\n}\n.firebaseui-flag-MT {\n  background-position: 0 -2212px;\n}\n.firebaseui-flag-MU {\n  background-position: 0 -2226px;\n}\n.firebaseui-flag-MV {\n  background-position: 0 -2240px;\n}\n.firebaseui-flag-MW {\n  background-position: 0 -2254px;\n}\n.firebaseui-flag-MX {\n  background-position: 0 -2268px;\n}\n.firebaseui-flag-MY {\n  background-position: 0 -2282px;\n}\n.firebaseui-flag-MZ {\n  background-position: 0 -2296px;\n}\n.firebaseui-flag-NA {\n  background-position: 0 -2310px;\n}\n.firebaseui-flag-NC {\n  background-position: 0 -2324px;\n}\n.firebaseui-flag-NE {\n  background-position: 0 -2338px;\n}\n.firebaseui-flag-NF {\n  background-position: 0 -2352px;\n}\n.firebaseui-flag-NG {\n  background-position: 0 -2366px;\n}\n.firebaseui-flag-NI {\n  background-position: 0 -2380px;\n}\n.firebaseui-flag-NL {\n  background-position: 0 -2394px;\n}\n.firebaseui-flag-NO {\n  background-position: 0 -2408px;\n}\n.firebaseui-flag-NP {\n  background-position: 0 -2422px;\n}\n.firebaseui-flag-NR {\n  background-position: 0 -2436px;\n}\n.firebaseui-flag-NU {\n  background-position: 0 -2450px;\n}\n.firebaseui-flag-NZ {\n  background-position: 0 -2464px;\n}\n.firebaseui-flag-OM {\n  background-position: 0 -2478px;\n}\n.firebaseui-flag-PA {\n  background-position: 0 -2492px;\n}\n.firebaseui-flag-PE {\n  background-position: 0 -2506px;\n}\n.firebaseui-flag-PF {\n  background-position: 0 -2520px;\n}\n.firebaseui-flag-PG {\n  background-position: 0 -2534px;\n}\n.firebaseui-flag-PH {\n  background-position: 0 -2548px;\n}\n.firebaseui-flag-PK {\n  background-position: 0 -2562px;\n}\n.firebaseui-flag-PL {\n  background-position: 0 -2576px;\n}\n.firebaseui-flag-PM {\n  background-position: 0 -2590px;\n}\n.firebaseui-flag-PN {\n  background-position: 0 -2604px;\n}\n.firebaseui-flag-PR {\n  background-position: 0 -2618px;\n}\n.firebaseui-flag-PS {\n  background-position: 0 -2632px;\n}\n.firebaseui-flag-PT {\n  background-position: 0 -2646px;\n}\n.firebaseui-flag-PW {\n  background-position: 0 -2660px;\n}\n.firebaseui-flag-PY {\n  background-position: 0 -2674px;\n}\n.firebaseui-flag-QA {\n  background-position: 0 -2688px;\n}\n.firebaseui-flag-RE {\n  background-position: 0 -2702px;\n}\n.firebaseui-flag-RO {\n  background-position: 0 -2716px;\n}\n.firebaseui-flag-RS {\n  background-position: 0 -2730px;\n}\n.firebaseui-flag-RU {\n  background-position: 0 -2744px;\n}\n.firebaseui-flag-RW {\n  background-position: 0 -2758px;\n}\n.firebaseui-flag-SA {\n  background-position: 0 -2772px;\n}\n.firebaseui-flag-SB {\n  background-position: 0 -2786px;\n}\n.firebaseui-flag-SC {\n  background-position: 0 -2800px;\n}\n.firebaseui-flag-SD {\n  background-position: 0 -2814px;\n}\n.firebaseui-flag-SE {\n  background-position: 0 -2828px;\n}\n.firebaseui-flag-SG {\n  background-position: 0 -2842px;\n}\n.firebaseui-flag-SH {\n  background-position: 0 -2856px;\n}\n.firebaseui-flag-SI {\n  background-position: 0 -2870px;\n}\n.firebaseui-flag-SJ {\n  background-position: 0 -2884px;\n}\n.firebaseui-flag-SK {\n  background-position: 0 -2898px;\n}\n.firebaseui-flag-SL {\n  background-position: 0 -2912px;\n}\n.firebaseui-flag-SM {\n  background-position: 0 -2926px;\n}\n.firebaseui-flag-SN {\n  background-position: 0 -2940px;\n}\n.firebaseui-flag-SO {\n  background-position: 0 -2954px;\n}\n.firebaseui-flag-SR {\n  background-position: 0 -2968px;\n}\n.firebaseui-flag-SS {\n  background-position: 0 -2982px;\n}\n.firebaseui-flag-ST {\n  background-position: 0 -2996px;\n}\n.firebaseui-flag-SV {\n  background-position: 0 -3010px;\n}\n.firebaseui-flag-SX {\n  background-position: 0 -3024px;\n}\n.firebaseui-flag-SY {\n  background-position: 0 -3038px;\n}\n.firebaseui-flag-SZ {\n  background-position: 0 -3052px;\n}\n.firebaseui-flag-TA {\n  background-position: 0 -3066px;\n}\n.firebaseui-flag-TC {\n  background-position: 0 -3080px;\n}\n.firebaseui-flag-TD {\n  background-position: 0 -3094px;\n}\n.firebaseui-flag-TF {\n  background-position: 0 -3108px;\n}\n.firebaseui-flag-TG {\n  background-position: 0 -3122px;\n}\n.firebaseui-flag-TH {\n  background-position: 0 -3136px;\n}\n.firebaseui-flag-TJ {\n  background-position: 0 -3150px;\n}\n.firebaseui-flag-TK {\n  background-position: 0 -3164px;\n}\n.firebaseui-flag-TL {\n  background-position: 0 -3178px;\n}\n.firebaseui-flag-TM {\n  background-position: 0 -3192px;\n}\n.firebaseui-flag-TN {\n  background-position: 0 -3206px;\n}\n.firebaseui-flag-TO {\n  background-position: 0 -3220px;\n}\n.firebaseui-flag-TR {\n  background-position: 0 -3234px;\n}\n.firebaseui-flag-TT {\n  background-position: 0 -3248px;\n}\n.firebaseui-flag-TV {\n  background-position: 0 -3262px;\n}\n.firebaseui-flag-TW {\n  background-position: 0 -3276px;\n}\n.firebaseui-flag-TZ {\n  background-position: 0 -3290px;\n}\n.firebaseui-flag-UA {\n  background-position: 0 -3304px;\n}\n.firebaseui-flag-UG {\n  background-position: 0 -3318px;\n}\n.firebaseui-flag-UM {\n  background-position: 0 -3332px;\n}\n.firebaseui-flag-UN {\n  background-position: 0 -3346px;\n}\n.firebaseui-flag-US {\n  background-position: 0 -3360px;\n}\n.firebaseui-flag-UY {\n  background-position: 0 -3374px;\n}\n.firebaseui-flag-UZ {\n  background-position: 0 -3388px;\n}\n.firebaseui-flag-VA {\n  background-position: 0 -3402px;\n}\n.firebaseui-flag-VC {\n  background-position: 0 -3416px;\n}\n.firebaseui-flag-VE {\n  background-position: 0 -3430px;\n}\n.firebaseui-flag-VG {\n  background-position: 0 -3444px;\n}\n.firebaseui-flag-VI {\n  background-position: 0 -3458px;\n}\n.firebaseui-flag-VN {\n  background-position: 0 -3472px;\n}\n.firebaseui-flag-VU {\n  background-position: 0 -3486px;\n}\n.firebaseui-flag-WF {\n  background-position: 0 -3500px;\n}\n.firebaseui-flag-WS {\n  background-position: 0 -3514px;\n}\n.firebaseui-flag-XK {\n  background-position: 0 -3528px;\n}\n.firebaseui-flag-YE {\n  background-position: 0 -3542px;\n}\n.firebaseui-flag-YT {\n  background-position: 0 -3556px;\n}\n.firebaseui-flag-ZA {\n  background-position: 0 -3570px;\n}\n.firebaseui-flag-ZM {\n  background-position: 0 -3584px;\n}\n.firebaseui-flag-ZW {\n  background-position: 0 -3598px;\n}\n", ""]);

// exports


/***/ }),
/* 576 */,
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.active ? "block" : "hidden" }, [
    _c("div", {
      staticClass: "fixed z-50 pin overflow-hidden bg-modal",
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.close($event)
        }
      }
    }),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass:
          "z-50 text-grey-light hover:text-grey-lightest outline-0 text-xl absolute pin-t pin-r p-2 m-2",
        attrs: { type: "button" },
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.close($event)
          }
        }
      },
      [_vm._m(0)]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "fixed z-50 pin-t pin-x overflow-hidden max-w-sm mx-auto mt-24 px-4 md:px-0 mb-4"
      },
      [
        _c("div", { staticClass: "bg-primary rounded shadow" }, [
          _c("div", { staticClass: "p-6" }, [
            _vm._m(1),
            _vm._v(" "),
            _vm.$store.state.formError
              ? _c(
                  "div",
                  { staticClass: "block bg-red rounded text-white mb-6" },
                  [
                    _c("div", { staticClass: "flex items-center" }, [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("div", [
                        _c("p", {
                          domProps: {
                            textContent: _vm._s(_vm.$store.state.formError)
                          }
                        })
                      ])
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.terms_accepted,
                    expression: "! terms_accepted"
                  }
                ],
                staticClass: "text-center"
              },
              [
                _c(
                  "label",
                  { staticClass: "block mb-4 text-white text-center" },
                  [
                    _c("span", {
                      staticClass: "text-sm font-semibold ml-1 text-white",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t(
                            "By_continuing_you_accept_our_terms_of_service_and_our_privacy_policy",
                            {
                              termsUri: _vm.$t("terms_uri"),
                              privacyUri: _vm.$t("privacy_policy_uri")
                            }
                          )
                        )
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "flex items-center justify-center rounded bg-blue-dark hover:bg-blue-darker text-white px-4 py-2 w-full",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.acceptTerms()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("Continue")) +
                        "\n                    "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.terms_accepted,
                    expression: "terms_accepted"
                  }
                ]
              },
              [_c("div", { attrs: { id: "firebaseui-auth-container" } })]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center mb-4" }, [
      _c("img", {
        staticClass: "h-48",
        attrs: { src: "/static/img/login_img.png", alt: "Tooddoc Logo" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-alert" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8b56a544", esExports)
  }
}

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogoutModal_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ca88c99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogoutModal_vue__ = __webpack_require__(579);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LogoutModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ca88c99_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LogoutModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/LogoutModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5ca88c99", Component.options)
  } else {
    hotAPI.reload("data-v-5ca88c99", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "fixed z-50 pin overflow-auto bg-modal",
      class: _vm.active ? "block" : "hidden"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "bg-grey-dark relative rounded shadow max-w-sm h-auto mx-auto mt-24"
        },
        [
          _c("div", { staticClass: "p-6" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "text-center text-white" }, [
              _vm._v(_vm._s(_vm.$t("Signing_out")))
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center mb-4" }, [
      _c("img", {
        staticClass: "h-48",
        attrs: { src: "/static/img/login_img.png", alt: "Tooddoc Logo" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5ca88c99", esExports)
  }
}

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageSwitcherModal_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ec77f2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageSwitcherModal_vue__ = __webpack_require__(581);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LanguageSwitcherModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ec77f2a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LanguageSwitcherModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/LanguageSwitcherModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2ec77f2a", Component.options)
  } else {
    hotAPI.reload("data-v-2ec77f2a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.active ? "block" : "hidden" }, [
    _c("div", {
      staticClass: "fixed z-50 pin overflow-hidden bg-modal",
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.close($event)
        }
      }
    }),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass:
          "z-50 text-grey-light hover:text-grey-lightest outline-0 text-xl absolute pin-t pin-r p-2 m-2",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.close($event)
          }
        }
      },
      [_vm._m(0)]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "fixed z-50 pin-t pin-x overflow-hidden max-w-sm mx-auto mt-24 px-4 md:px-0 mb-4"
      },
      [
        _c(
          "div",
          { staticClass: "bg-white rounded shadow" },
          [
            _c("div", { staticClass: "px-6 py-3" }, [
              _c(
                "span",
                {
                  staticClass:
                    "uppercase tracking-wide text-grey-dark font-semibold"
                },
                [_vm._v(_vm._s(_vm.$t("Choose_your_language")))]
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.languages, function(language) {
              return _c(
                "label",
                {
                  key: language.id,
                  staticClass:
                    "block w-full border-t px-6 py-3 hover:bg-grey-lightest text-grey-darker"
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectedLanguage,
                        expression: "selectedLanguage"
                      }
                    ],
                    staticClass: "mr-2",
                    attrs: { type: "radio" },
                    domProps: {
                      value: language,
                      checked: _vm._q(_vm.selectedLanguage, language)
                    },
                    on: {
                      change: [
                        function($event) {
                          _vm.selectedLanguage = language
                        },
                        _vm.submit
                      ]
                    }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: { textContent: _vm._s(language.name) }
                  })
                ]
              )
            })
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ec77f2a", esExports)
  }
}

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "max-w-md mx-auto px-6" },
    [
      _c(
        "div",
        { staticClass: "flex items-center justify-between" },
        [
          _c("router-link", { attrs: { to: { path: "/" } } }, [
            _c("img", {
              staticClass: "h-4",
              attrs: { src: "/static/img/tooddoc.png", alt: "Tooddoc" }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex flex-col items-end md:flex-row" }, [
            _c(
              "button",
              {
                staticClass:
                  "block appearance-none bg-transparent text-white outline-0 text-sm text-right mb-3 md:mb-0 md:mr-4",
                on: { click: _vm.showLanguageSwitcher }
              },
              [
                _c("span", {
                  domProps: { textContent: _vm._s(_vm.patientLanguageName) }
                }),
                _vm._v(" "),
                _vm._m(0)
              ]
            ),
            _vm._v(" "),
            _vm.userId
              ? _c(
                  "button",
                  {
                    staticClass: "text-blue-lightest text-sm",
                    on: { click: _vm.logout }
                  },
                  [_vm._v(_vm._s(_vm.$t("Sign_out")))]
                )
              : _c(
                  "button",
                  {
                    staticClass: "text-white text-sm",
                    on: { click: _vm.showLogin }
                  },
                  [_vm._v(_vm._s(_vm.$t("Sign_in")))]
                )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("login-modal", {
        attrs: { active: _vm.showLoginModal },
        on: { close: _vm.hideLogin }
      }),
      _vm._v(" "),
      _c("logout-modal", { attrs: { active: _vm.showLogoutModal } }),
      _vm._v(" "),
      _c("language-switcher-modal", {
        attrs: { active: _vm.showLanguageSwitcherModal },
        on: { close: _vm.hideLanguageSwitcher }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-chevron-down" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-041ce2a8", esExports)
  }
}

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppointmentListItem_vue__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_079f1334_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppointmentListItem_vue__ = __webpack_require__(587);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppointmentListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_079f1334_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppointmentListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/AppointmentListItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-079f1334", Component.options)
  } else {
    hotAPI.reload("data-v-079f1334", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(585);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(20)("7a207a23", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25f055ce\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OfficeSettings.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-25f055ce\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./OfficeSettings.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(19)(false);
// imports


// module
exports.push([module.i, "\n.settings-icon[data-v-25f055ce] {\n  font-size: 1.4rem;\n}\n.enabled[data-v-25f055ce] {\n  color: #2196f3;\n}\n.disabled[data-v-25f055ce] {\n  color: #e3342f;\n}\n", ""]);

// exports


/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex" }, [
    _vm.cash !== null
      ? _c("div", { staticClass: "flex items-center" }, [
          _c(
            "i",
            {
              staticClass: "tooltip mdi mdi-cash text-xl mr-1 settings-icon",
              class: _vm.cash ? "enabled" : "disabled"
            },
            [
              _c("span", { staticClass: "tooltip-text text-sm" }, [
                _vm._v(_vm._s(_vm.getTooltip("cash")))
              ])
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.card !== null
      ? _c("div", { staticClass: "flex items-center text-grey" }, [
          _c(
            "i",
            {
              staticClass:
                "tooltip mdi mdi-credit-card text-xl mr-1 settings-icon",
              class: _vm.card ? "enabled" : "disabled"
            },
            [
              _c("span", { staticClass: "tooltip-text text-sm" }, [
                _vm._v(_vm._s(_vm.getTooltip("card")))
              ])
            ]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.accessible !== null
      ? _c("div", { staticClass: "flex items-center text-grey" }, [
          _c(
            "i",
            {
              staticClass:
                "tooltip mdi mdi-wheelchair-accessibility text-xl mr-1 settings-icon",
              class: _vm.accessible ? "enabled" : "disabled"
            },
            [
              _c("span", { staticClass: "tooltip-text text-sm" }, [
                _vm._v(_vm._s(_vm.getTooltip("accessible")))
              ])
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-25f055ce", esExports)
  }
}

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass:
        "group shadow mb-6 cursor-pointer text-grey-darkest leading-normal",
      attrs: {
        to: { name: "appointment.show", params: { id: _vm.appointment.id } },
        tag: "div"
      }
    },
    [
      _c(
        "div",
        { staticClass: "flex items-top p-3 md:p-6 bg-white rounded-t" },
        [
          _c("avatar", {
            staticClass: "mr-2 w-10 h-10 md:w-12 md:h-12",
            attrs: {
              avatar: _vm.appointment.doctorAvatar,
              name:
                _vm.appointment.doctorFirstName +
                " " +
                _vm.appointment.doctorLastName
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "ml-4" },
            [
              _c("div", { staticClass: "flex md:mb-1" }, [
                _c(
                  "span",
                  { staticClass: "icon mr-2 md:text-lg text-grey-darkest" },
                  [_c("i", { staticClass: "mdi mdi-calendar-check" })]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "text-grey-darkest font-semibold text-sm md:text-base"
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm._f("momentFormat")(
                          _vm.appointment.date,
                          "YYYY-MM-DD",
                          _vm.$t("date_selector_format")
                        )
                      ) +
                        " " +
                        _vm._s(_vm.$t("at")) +
                        " " +
                        _vm._s(
                          _vm._f("momentFormatTime")(
                            _vm.appointment.time,
                            _vm.$t("time_format")
                          )
                        )
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex md:mb-1" }, [
                _c(
                  "span",
                  { staticClass: "icon mr-2 text-lg text-red-light" },
                  [_c("i", { staticClass: "mdi mdi-map-marker" })]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "text-sm md:text-base" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.appointment.officeZipCode) +
                      " " +
                      _vm._s(_vm.appointment.officeLocality) +
                      "\n          "
                  ),
                  _c("br"),
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.appointment.officeStreetNumber) +
                      " " +
                      _vm._s(_vm.appointment.officeStreetName) +
                      "\n        "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex md:mb-1" }, [
                _c(
                  "span",
                  { staticClass: "icon mr-2 text-lg text-blue-light" },
                  [_c("i", { staticClass: "mdi mdi-account" })]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "text-sm md:text-base" }, [
                  _vm._v(
                    _vm._s(
                      _vm.appointment.doctorFirstName +
                        " " +
                        _vm.appointment.doctorLastName
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex md:mb-1" }, [
                _c("span", { staticClass: "icon mr-2 text-sm text-grey" }, [
                  _c("i", { staticClass: "mdi mdi-briefcase" })
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "text-sm" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("type_" + _vm.appointment.emergencyType)) +
                      "\n          "
                  ),
                  _vm.appointment.isDoctorMemberOfOsteopathie
                    ? _c("span", {
                        staticClass: "mdi mdi-check-circle text-green"
                      })
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex" },
                [
                  _vm.appointment.isDoctorRegulated &&
                  (_vm.appointment.emergencyType !== "OSTEOPATH" &&
                    _vm.appointment.emergencyType !== "PSYCHOLOGIST")
                    ? [
                        _c(
                          "span",
                          { staticClass: "icon mr-2 text-sm text-green" },
                          [_c("i", { staticClass: "mdi mdi-currency-eur" })]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-sm text-green" }, [
                          _vm._v(_vm._s(_vm.$t("Contracted_doctor")))
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.appointment.isDoctorRegulated &&
                  (_vm.appointment.emergencyType !== "OSTEOPATH" &&
                    _vm.appointment.emergencyType !== "PSYCHOLOGIST")
                    ? [
                        _c(
                          "span",
                          { staticClass: "icon mr-2 text-sm text-red" },
                          [_c("i", { staticClass: "mdi mdi-currency-eur" })]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-sm text-red" }, [
                          _vm._v(_vm._s(_vm.$t("Contracted_doctor_negative")))
                        ])
                      ]
                    : _vm._e()
                ],
                2
              ),
              _vm._v(" "),
              _vm.appointment.officeSettings
                ? _c("OfficeSettings", {
                    attrs: {
                      accessible: _vm.appointment.officeSettings.accessible,
                      card: _vm.appointment.officeSettings.card,
                      cash: _vm.appointment.officeSettings.cash
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "transition flex rounded-b bg-teal group-hover:bg-teal-dark text-white py-1 justify-center"
        },
        [
          _c("span", {
            staticClass: "uppercase tracking-wide font-semibold text-sm",
            domProps: { textContent: _vm._s(_vm.$t("Appointment_confirmed")) }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-079f1334", esExports)
  }
}

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerAppointmentListItem_vue__ = __webpack_require__(331);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88748b7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerAppointmentListItem_vue__ = __webpack_require__(592);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerAppointmentListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88748b7c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerAppointmentListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/PartnerAppointmentListItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-88748b7c", Component.options)
  } else {
    hotAPI.reload("data-v-88748b7c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(590);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(20)("f7bb044c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1dcc607e\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PartnerAvatar.vue", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-1dcc607e\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PartnerAvatar.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(19)(false);
// imports


// module
exports.push([module.i, "\n.avatar-rounded {\n  display: inline-block;\n  background-color: #f7f9fc;\n  border-radius: 50%;\n  background-size: cover;\n  background-position: top center;\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c("span", {
      staticClass: "avatar-rounded",
      style: "background-image: url(" + _vm.externalUrl + ");"
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1dcc607e", esExports)
  }
}

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass:
        "group shadow mb-6 cursor-pointer text-grey-darkest leading-normal",
      attrs: {
        to: {
          name: "partner-timeslot.show",
          query: {
            doctorId: _vm.appointment.doctorId,
            dateTime: _vm.appointment.dateTime,
            medicalPractice: _vm.appointment.medicalPractice,
            latitude: _vm.appointment.officeLatitude,
            longitude: _vm.appointment.officeLongitude
          }
        },
        tag: "div"
      }
    },
    [
      _c(
        "div",
        { staticClass: "flex items-top p-3 md:p-6 bg-white rounded-t" },
        [
          _c("partner-avatar", {
            staticClass: "mr-2 w-10 h-10 md:w-12 md:h-12",
            attrs: { "external-url": _vm.appointment.doctorAvatar }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "ml-4" }, [
            _c("div", { staticClass: "flex md:mb-1" }, [
              _c(
                "span",
                { staticClass: "icon mr-2 md:text-lg text-grey-darkest" },
                [_c("i", { staticClass: "mdi mdi-calendar-check" })]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "text-grey-darkest font-semibold text-sm md:text-base"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("momentFormatTimestamp")(
                        _vm.appointment.dateTime,
                        _vm.$t("date_selector_format") +
                          " [" +
                          _vm.$t("at") +
                          "] " +
                          _vm.$t("time_format")
                      )
                    )
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex md:mb-1" }, [
              _c("span", { staticClass: "icon mr-2 text-lg text-red-light" }, [
                _c("i", { staticClass: "mdi mdi-map-marker" })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-sm md:text-base" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.appointment.officeZipCode) +
                    " " +
                    _vm._s(_vm.appointment.officeLocality)
                ),
                _c("br"),
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.appointment.officeStreetName) +
                    "\n                "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex" }, [
              _c("span", { staticClass: "icon mr-2 text-lg text-blue-light" }, [
                _c("i", { staticClass: "mdi mdi-account" })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-sm md:text-base" }, [
                _vm._v(
                  _vm._s(
                    _vm.appointment.doctorFirstName +
                      " " +
                      _vm.appointment.doctorLastName
                  )
                )
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "transition flex rounded-b bg-teal group-hover:bg-teal-dark text-white py-1 justify-center"
        },
        [
          _c("span", {
            staticClass: "uppercase tracking-wide font-semibold text-sm",
            domProps: { textContent: _vm._s(_vm.$t("Appointment_confirmed")) }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88748b7c", esExports)
  }
}

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvitationListItem_vue__ = __webpack_require__(333);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a60b724_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvitationListItem_vue__ = __webpack_require__(594);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvitationListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a60b724_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvitationListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/InvitationListItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7a60b724", Component.options)
  } else {
    hotAPI.reload("data-v-7a60b724", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass: "group shadow mb-6 text-grey-darkest leading-normal rounded",
      attrs: {
        to: { name: "invitation.show", params: { id: _vm.invitation.id } },
        tag: "div"
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "flex items-top p-3 md:p-6 bg-white rounded-t cursor-pointer"
        },
        [
          _c("avatar", {
            staticClass: "mr-2 w-10 h-10 md:w-12 md:h-12",
            attrs: {
              avatar: _vm.invitation.doctorAvatar,
              name:
                _vm.invitation.doctorFirstName +
                " " +
                _vm.invitation.doctorLastName
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "ml-4" }, [
            _c("div", { staticClass: "flex md:mb-1" }, [
              _c(
                "span",
                { staticClass: "icon mr-2 md:text-lg text-grey-darkest" },
                [_c("i", { staticClass: "mdi mdi-calendar-check" })]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass:
                    "text-grey-darkest font-semibold text-sm md:text-base"
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm._f("momentFormat")(
                        _vm.invitation.date,
                        "YYYY-MM-DD",
                        _vm.$t("date_selector_format")
                      )
                    ) +
                      " " +
                      _vm._s(_vm.$t("at")) +
                      " " +
                      _vm._s(
                        _vm._f("momentFormatTime")(
                          _vm.invitation.time,
                          _vm.$t("time_format")
                        )
                      )
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex md:mb-1" }, [
              _c("span", { staticClass: "icon mr-2 text-lg text-red-light" }, [
                _c("i", { staticClass: "mdi mdi-map-marker" })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-sm md:text-base" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.invitation.officeZipCode) +
                    " " +
                    _vm._s(_vm.invitation.officeLocality) +
                    "\n                "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex md:mb-1" }, [
              _c("span", { staticClass: "icon mr-2 text-lg text-blue-light" }, [
                _c("i", { staticClass: "mdi mdi-account" })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-sm md:text-base" }, [
                _vm._v(
                  _vm._s(
                    _vm.invitation.doctorFirstName +
                      " " +
                      _vm.invitation.doctorLastName
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex" }, [
              _c("span", { staticClass: "icon mr-2 text-sm text-grey" }, [
                _c("i", { staticClass: "mdi mdi-briefcase" })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-sm" }, [
                _vm._v(
                  _vm._s(_vm.$t("type_" + _vm.invitation.emergencyType)) + " "
                ),
                _vm.invitation.isDoctorMemberOfOsteopathie
                  ? _c("span", {
                      staticClass: "mdi mdi-check-circle text-green"
                    })
                  : _vm._e()
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex rounded-b py-3 px-2 justify-end items-center" },
        [
          _c(
            "router-link",
            {
              staticClass:
                "text-blue hover:text-blue-dark uppercase tracking-wide font-semibold text-sm px-2",
              attrs: {
                to: {
                  name: "invitation.show",
                  params: { id: _vm.invitation.id, decline: true }
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Decline")))]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass:
                "text-blue hover:text-blue-dark uppercase tracking-wide font-semibold text-sm px-2",
              attrs: {
                to: {
                  name: "invitation.show",
                  params: { id: _vm.invitation.id }
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("Accept")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a60b724", esExports)
  }
}

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmergencyListItem_vue__ = __webpack_require__(334);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9ffcd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmergencyListItem_vue__ = __webpack_require__(601);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmergencyListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e9ffcd8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmergencyListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/EmergencyListItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7e9ffcd8", Component.options)
  } else {
    hotAPI.reload("data-v-7e9ffcd8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteEmergencyModal_vue__ = __webpack_require__(335);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3305f6c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteEmergencyModal_vue__ = __webpack_require__(600);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeleteEmergencyModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3305f6c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeleteEmergencyModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/DeleteEmergencyModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3305f6c1", Component.options)
  } else {
    hotAPI.reload("data-v-3305f6c1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.emergency
    ? _c(
        "div",
        {
          staticClass: "fixed z-50 pin overflow-auto bg-modal",
          class: _vm.active ? "block" : "hidden"
        },
        [
          _c(
            "div",
            { staticClass: "shadow max-w-sm mx-auto mt-24 px-4 md:px-0" },
            [
              _vm.step == "errors"
                ? _c(
                    "div",
                    { staticClass: "rounded bg-white shadow relative" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "text-red-lighter hover:text-red-lightest text-xl absolute pin-t pin-r p-2 m-2",
                          on: { click: _vm.close }
                        },
                        [_vm._m(0)]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-center bg-red text-white rounded px-4 py-10 w-full"
                        },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "text-sm text-xl ml-4",
                            domProps: {
                              textContent: _vm._s(
                                _vm.errorText
                                  ? _vm.errorText
                                  : _vm.$t("an_error_occured")
                              )
                            }
                          })
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.step == "deleting"
                ? _c(
                    "div",
                    { staticClass: "rounded bg-white shadow relative" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex items-center justify-center h-32"
                        },
                        [
                          _c("div", { staticClass: "text-center" }, [
                            _vm._m(2),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "text-sm text-grey-darker mt-4" },
                              [_vm._v(_vm._s(_vm.$t("Loading")))]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.step == "details"
                ? _c("div", [
                    _c("div", { staticClass: "bg-white rounded-t p-6" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "text-center text-grey-dark leading-normal"
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$t(
                                  "Do_you_really_want_to_delete_your_request"
                                )
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex border-t items-center" }, [
                      _c(
                        "button",
                        {
                          staticClass:
                            "block text-center bg-white rounded-bl w-1/2 border-r py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-black",
                          on: { click: _vm.close }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("Cancel")) +
                              "\n                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "block text-center bg-white rounded-br w-1/2 py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-red",
                          on: { click: _vm.confirm }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("Yes_delete")) +
                              "\n                "
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e()
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-white" }, [
      _c("i", { staticClass: "mdi mdi-alert-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-grey" }, [
      _c("i", { staticClass: "mdi mdi-loading mdi-spin" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3305f6c1", esExports)
  }
}

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "group shadow mb-6 text-grey-darkest leading-normal rounded"
        },
        [
          _c(
            "div",
            { staticClass: "flex items-top p-3 md:p-6 bg-white rounded-t" },
            [
              _c("img", {
                staticClass: "mr-2 w-10 h-10 md:w-12 md:h-12",
                attrs: { src: "/static/img/ic_emergency.png" }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "ml-4" }, [
                _c("div", { staticClass: "flex md:mb-1" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "text-grey-darkest font-semibold text-sm md:text-base"
                    },
                    [_vm._v(_vm._s(_vm.$t("Waiting_list")))]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex md:mb-1" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-sm md:text-base" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.emergency.zipCode) +
                        " " +
                        _vm._s(_vm.emergency.locality) +
                        "\n                    "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex" }, [
                  _vm._m(2),
                  _vm._v(" "),
                  _c("span", { staticClass: "text-sm md:text-base" }, [
                    _vm._v(_vm._s(_vm.$t("type_" + _vm.emergency.type)))
                  ])
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex rounded-b py-3 px-2 justify-end items-center"
            },
            [
              _c(
                "button",
                {
                  staticClass:
                    "text-blue hover:text-blue-dark uppercase tracking-wide font-semibold text-sm px-2",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.showDelete($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Delete_my_request")))]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("delete-emergency-modal", {
        attrs: { active: _vm.showDeleteModal, emergency: _vm.emergency },
        on: { close: _vm.hideDelete, deleted: _vm.deleted }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "icon mr-2 md:text-lg text-grey-darkest" },
      [_c("i", { staticClass: "mdi mdi-clock" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-lg text-red-light" }, [
      _c("i", { staticClass: "mdi mdi-map-marker" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-lg text-grey" }, [
      _c("i", { staticClass: "mdi mdi-briefcase" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e9ffcd8", esExports)
  }
}

/***/ }),
/* 602 */,
/* 603 */
/***/ (function(module, exports) {

module.exports = {"Countries_be":"Belgium","Countries_fr":"France","footer_copyrights":"© {year} Tooddoc","doctor_not_certified_warning":"Your account is not certified yet. You'll be able to setup your availabilities and accept emergencies once an administrator has verified your account.","cancel_button_label":"Cancel","close_button_label":"Close","ok_button_label":"OK","date_selector_format":"MMMM Do","time_format":"HH:mm","moment_locale":"en","appointment_notification_date_format":"MMMM Do","appointment_notification_content":"A new appointment has been booked by {firstName} {lastName}.<br />Appointment date: {date} at {time}","public_site_uri":"https://tooddoc.com/en","public_site_label":"Website","terms_uri":"https://tooddoc.com/en/terms-of-use","terms_label":"Terms of Use","privacy_policy_uri":"https://tooddoc.com/en/privacy-policy","privacy_policy_label":"Privacy Policy","cookie_policy_uri":"https://tooddoc.com/en/cookie-policy","cookie_policy_label":"Cookie Policy","app_message_on_mobile":"This app does not work on small screens yet. Please try on your computer.","contact_uri":"https://tooddoc.com/en/contact","contact_label":"Contact us","i_am_a_dentist_label":"I am a practitioner","cookie_notification":"By using this website you agree to our cookie policy","play_store_uri":"https://play.google.com/store/apps/details?id=com.tooddoc.app","app_store_uri":"https://itunes.apple.com/us/app/tooddoc/id1331906587?ls=1&mt=8","my_profile_link_label":"My profile","logout_link_label":"Logout","dashboard_link_label":"Dashboard","my_availabilities_link_label":"My Availabilities","find_emergencies_link_label":"Find Emergencies","morning_label":"Morning","afternoon_label":"Afternoon","available_label":"Available?","show_early_slots":"Show timeslots before 8AM","show_late_slots":"Show timeslots after 8PM","status_confirmed_label":"Confirmed","status_cancelled_label":"Cancelled","status_declined_label":"Declined","status_pending_label":"Pending confirmation","avatar_title":"Choose an avatar","next_appointments_section_title":"Your next appointments","next_appointments_section_empty_placeholder":"No appointments","next_appointments_table_details_header":"Details","next_availabilities_section_title":"Your next availabilities","next_availabilities_section_empty_placeholder":"No Availabilities","next_availabilities_table_details_header":"Details","emergency_modal_title":"Details of an emergency","refresh_button_label":"Refresh","accept_emergency_button_label":"Accept emergency","accept_modal_title":"Accept an emergency","accept_modal_select_availability_error":"Please choose a date & time","accept_modal_confirm_button_label":"Confirm","accepted_dialog_title":"Emergency accepted","accepted_dialog_message":"This emergency has been added to your list of appointments on your dashboard.","no_emergencies_placeholder":"Sorry but we don't have any emergency to show you at the moment.","availability_date_format":"MMMM Do","patient_symptoms_title":"Patient symptoms","patient_information_title":"Patient information","pictures_title":"Pictures","patient_first_name_label":"First name","patient_last_name_label":"Last name","patient_age_label":"Age","patient_email_label":"Email address","patient_phone_label":"Phone number","patient_locality_label":"Locality","patient_zip_code_label":"Zip code","no_pictures_placeholder":"No pictures were taken","picture_alt":"Picture of the patient","date_label":"Date","time_label":"Time","office_name_label":"Office","patient_header":"{age} years old patient, from {locality}","name_label":"Name","street_name_label":"Street","street_number_label":"Number","zip_code_label":"Zip code","locality_label":"Locality","country_label":"Country","phone_label":"Phone","select_country_label":"Select a country","phone_error":"The phone number must be 11 or 12 numeric characters starting with the prefix {prefix}.","create_button_label":"Create","delete_button_label":"Delete office","alert_create_successful":"Office created with success!","office_alert_update_successful":"Office updated with success!","delete_dialog_title":"Delete this office","delete_dialog_message":"In order to delete an office of yours, please contact an administrator.","emergency_alert_label":"I accept to receive email notification for new emergencies near this office.","click_to_change_avatar":"Click the avatar to change","first_name_label":"First Name","last_name_label":"Last Name","contact_email_label":"Email address","inami_label":"INAMI","language_label":"Language","inami_error":"The INAMI number has to be 11 numeric characters.","update_button_label":"Save Changes","alert_update_successful":"Profile updated with success!","accept_terms_label":"I accept the <a href='https://tooddoc.com/en/terms-of-use' target=\"_blank\">terms of use</a> & <a href='https://tooddoc.com/en/privacy-policy' target=\"_blank\">privacy policy</a>","accept_terms_error":"You must accept the terms to register","is_regulated_label":"I am regulated","email_error":"The email address is required and must be a valid email address.","medical_practice_label":"Medical Practice","doctor_details_label":"Your details","offices_title":"Your offices","add_office_button_label":"Add an office","doctorRegister_title":"Register as a doctor","doctor_legend":"Your details","office_legend":"Office details","add_another_office_button_label":"Add another office","remove_office_button_label":"Remove this office","register_button_label":"Register","fields_are_missing":"Please check the fields in red.","appointment_invitations_could_not_be_loaded":"We could't fetch the appointment invitations.","appointments_could_not_be_loaded":"We could't fetch the appointments.","emergencies_could_not_be_loaded":"We could't fetch the emergencies.","timeslots_could_not_be_loaded":"We could't fetch the availabilities.","no_office_selected":"You haven't selected any office! Pick one on the left.","an_error_occured":"An error occured, please try again.","partner_appointments_could_not_be_loaded":"We could't fetch the partner appointments.","sign_in_with_google":"Sign in with Google","sign_in_with_facebook":"Sign in with Facebook","go_to_doctor_dashboard":"Your dashboard (Practitioner)","go_to_admin_dashboard":"Admin dashboard","register_as_doctor_link_label":"Register as a doctor","thanks_message":"Thanks for your support!","add_another_doctor":"Add another practitioner","remove_doctor":"Remove","contact_name_label":"Full name","intro_text":"We'd like to connect with other practitioners to make this app greater. Please recommend 2 or more practitioners. This popup will disappear after.","recommandation_title":"Please recommend at least 2 practitioners","submit_button_label":"Submit","step_0_text":"<p>Bonjour Dr. {name},</p><br><p>Je suis Tood et je vais vous expliquer comment utiliser cette application.</p>","step_0_button":"Voir la présentation","step_1_text":"<p>Dans l'onglet \"Mes disponibilités\", définissez vos plages disponibles pour la prise en charge des urgences via Tooddoc.</p><br><p>Il vous est possible de prendre une urgence toutes les 15 minutes.</p><p>Si vous avez besoin de plus de 15 minutes, sautez le quart d'heure suivant en cochant la demi-heure d'après.</p> (ex: cochez 9h00 et ensuite 9:30)</p><br><p>Je vous conseille de noter les rendez-vous Toodoc dans votre agenda personnel afin de ne pas les oublier ni d'accepter un autre rendez-vous au même moment.</p><br /><p>Vous pouvez annuler ces plages horaires tant qu'elles ne sont pas réservées par un patient !</p>","step_1_button":"Continuer la présentation","step_1_helper_text":"<p>Rends-toi sur \"Mes disponibilités\" pour la suite de la présentation.</p>","step_2_text":"<p>Bienvenue sur votre Tableau de bord!</p><br><p>C'est une vue globale sur laquelle vous voyez vos prochaines disponibilités, vos rendez-vous occupés  ainsi que vos rendez-vous en attente de confirmation.</p>","step_2_button":"Continuer la présentation","step_2_helper_text":"<p>Rends-toi sur ton tableau de bord pour la suite de la présentation.</p>","step_2_helper_button":"Mon tableau de bord","step_3_text":"<p>Voici la liste des patients en attente d'un rendez-vous dans votre région.</p><p>Pour chaque patient, un résumé des principaux symptômes et la possibilité d'une photo de la zone concernée.</p><br /><p>Sélectionnez l'urgence que vous souhaitez prendre en charge, ensuite vous introduisez votre heure de rendez-vous et une demande instantanée est envoyée au patient.</p><p>Une confirmation vous sera notifiée.</p>","step_3_button":"Continuer","step_3_helper_text":"<p>Rends-toi sur \"Trouver une urgence\" pour la suite de la présentation.</p>","step_3_helper_button":"Trouver une urgence","step_4_text":"<p>Bravo !</p><br /><p>Vous pouvez dès à présent utiliser Tooddoc pour accepter des urgences.</p><br /><p>N'oubliez pas de compléter régulièrement vos disponibilités afin que les patients puissent vous contacter directement depuis l'App mobile.</p>","step_4_button":"OK","step_1_helper_button":"Continuer la présentation","my_availabilities":"My availabilities","other_availabilities":"Other availabilities","nothing_selected":"Please select an availability","select":"Select","selected":"Selected","Call_the_doctor_at_this_number":"Call the doctor on: {phoneNumber}","Appointment_confirmed":"Appointment confirmed","When_":"When?","Who_will_treat_me_":"Which doctor will take care of me?","Call":"Call","Where_have_I_to_go_":"Where do I have to go?","Itinerary":"Itinerary","Firstname_":"First name *","Lastname_":"Last name *","Age_":"Age *","Phone_number_":"Phone number *","What_are_your_symptoms_":"What are your symptoms?","Where_do_you_want_to_find_a_appointment_":"In which area are you looking for an appointment?","Confirm":"Confirm","Decline":"Decline","Accept":"Accept","Delete_my_request":"Delete my request","Next":"Next","Please_answer_to_all_questions_of_the_form":"Please answer to all the questions","Please_fill_your_first_name":"Please fill in your first name","Please_fill_your_last_name":"Please fill in your name","Please_fill_your_age":"Please fill in your age","Please_fill_your_phone_number":"Please fill in your telephone number","By_continuing_you_accept_our_terms_of_service_and_our_privacy_policy":"By continuing you accept our <a href=\"{termsUri}\" target=\"_blank\" class=\"text-white underline\">terms of service</a> and our <a href=\"{privacyUri}\" target=\"_blank\" class=\"text-white underline\">privacy policy</a>.","Continue":"Continue","Book_this_appointment":"Book this appointment","Detail_of_the_appointment":"Details of the appointment","Symptoms":"Symptoms","Cancel_the_appointment":"Cancel the appointment","To_cancel_the_appointment_call_the_doctor_via_X":"To cancel this appointment, please contact the doctor at {phoneNumber}","Cancel":"Cancel","Edit":"Edit","Are_you_sure_to_decline_this_appointment_":"Are you sure you want to decline this appointment?","Yes_decline":"Yes, decline","Do_you_really_want_to_delete_your_request_":"Do you really want to delete your request?","Delete":"Delete","Invitation_from_dentist":"Invitation from doctor","Waiting":"Waiting","Your_confirmed_appointments":"your confirmed appointments","Whoops_an_error_has_occured_Please_try_again":"Whoops an error has occurred. Please try again :)","at":"at","SYMPTOMS_QUESTION_1":"Where do you have a problem?","SYMPTOMS_QUESTION_2":"Which part is affected?","SYMPTOMS_QUESTION_3":"Is their a fracture?","SYMPTOMS_QUESTION_4":"Is it swollen?","SYMPTOMS_QUESTION_5":"Do you have pain?","SYMPTOMS_QUESTION_6":"When?","SYMPTOMS_QUESTION_7":"How would you describe the pain?","Save_my_symptoms":"Save my symptoms","SYMPTOMS_ANSWER_1_1":"Upper dentures in the front","SYMPTOMS_ANSWER_1_2":"Lower dentures in the front","SYMPTOMS_ANSWER_1_3":"Upper dentures in the back","SYMPTOMS_ANSWER_1_4":"Lower dentures in the back","SYMPTOMS_ANSWER_2_1":"Teeth","SYMPTOMS_ANSWER_2_2":"Gum(line)","SYMPTOMS_ANSWER_2_3":"Teeth and gums","SYMPTOMS_ANSWER_2_4":"False teeth","SYMPTOMS_ANSWER_3_1":"Yes","SYMPTOMS_ANSWER_3_2":"No","SYMPTOMS_ANSWER_4_1":"Yes","SYMPTOMS_ANSWER_4_2":"No","SYMPTOMS_ANSWER_5_1":"Yes","SYMPTOMS_ANSWER_5_2":"No","SYMPTOMS_ANSWER_6_1":"Cold","SYMPTOMS_ANSWER_6_2":"Hot","SYMPTOMS_ANSWER_6_3":"Pressure","SYMPTOMS_ANSWER_6_4":"All 3","SYMPTOMS_ANSWER_7_1":"All the time","SYMPTOMS_ANSWER_7_2":"Sometimes","This_appointment_is_not_available_anymore":"This appointment is not available anymore","This_invitation_is_not_valid_anymore":"This invitation is no longer available","The_practitioner_will_be_informed_immediately_of_your_reservation":"The doctor will be immediately informed about your reservation","Contracted_doctor":"Contracted Doctor","Accept_this_appointment_invitation":"Accept this appointment","First_name":"First Name","Last_name":"Last Name","Age":"Age","Phone_number":"Phone number","Find_an_appointment":"Find an appointment","Your_appointments":"Your appointments","Sign_out":"Sign out","Sign_in":"Sign in","Loading":"Loading...","Appointment_declined":"Appointment declined","Redirecting":"Redirecting...","Choose_your_language":"Choose your language","Signing_out":"Signing out...","Please_give_your_location_to_look_for_doctors_in_your_region":"Please give your location to look for doctors in your region.","Sorry_we_don_t_have_any_appointment_available_in_your_region":"Sorry, we don't have any appointment available in your region.","Enter_a_location":"Enter a location","Your_current_position":"Your current position","Sign_in_to_book_this_appointment":"Sign in to book this appointment","Summary":"Summary","Please_fill_your_locality":"Please fill in your locality","Select_an_availability":"Select an availability","x_more_availabilities":"{count} more availabilities...","Pending":"Pending","Waiting_list":"Waiting list","Do_you_really_want_to_delete_your_request":"Do you really want to delete your request?","Yes_delete":"Yes, Delete","Deleting_":"Deleting...","You_did_not_find_an_appointment_Activate_the_alert_and_I_will_inform_you_":"You did not find an appointment? Register on the waiting list and we will inform you as soon as an appointment is available.","Enable_the_appointment_alert":"Register on the waiting list","Locality_":"Locality *","I_will_inform_you_as_soon_as_a_timeslot_is_available":"We will inform you as soon as a timeslot is available","As_soon_as_a_appointment_is_available_Tood_will_inform_you":"As soon as an appointment is available, Tooddoc will inform you","Activate_the_alert_and_I_will_inform_you_":"Register on the waiting list and we will inform you as soon as an appointment is available.","You_are_already_in_the_waiting_list":"You are already in the waiting list","X_is_not_available_Register_on_the_waiting_list_to_inform_the_dentists_near_Y":"{name} has no slot available at the moment. Register on the waiting list to inform him, as well as the practitioners near {location}, of your request.","Regulated_Doctor":"€ Contracted Doctor","See_office_availabilities":"See availabilities","Please_specify":"Please answer to this question","Locality":"Locality","Book_this_appointment_with_X":"Book this appointment with {partner}","Manage_this_appointment_with_X":"Manage this appointment with {partner}","This_timeslot_does_not_exist":"This timeslot does not exist","This_appointment_is_provided_by_our_partner_X":"This appointment is provided by our partner {name}.","Thus_you_will_be_redirected_to_their_website_in_order_to_book_it":"Thus, you will be redirected to their website in order to book it.","Appointment_provided_by_X":"Appointment provided by {name}","SYMPTOMS_QUESTION":"Describe your symptoms...","Medical_practice_":"Medical practice *","Select_a_medical_practice":"Select a medical practice","type_DENTIST":"Dentist","type_GENERAL_PRACTITIONER":"General practitioner","type_GYNECOLOGIST":"Gynecologist","type_OPHTHALMOLOGIST":"Ophthalmologist","type_PEDIATRICIAN":"Pediatrician","type_PSYCHOLOGIST":"Psychologist","type_DERMATOLOGIST":"Dermatologist","type_OSTEOPATH":"Osteopath","type_PSYCHIATRIST":"Psychiatrist","type_PHYSIOTHERAPIST":"Physiotherapist","Available_X":"Available {type}","Name":"Name","X_near_Y":"{type} near {location}","type_DENTIST_plural":"Dentists","type_GENERAL_PRACTITIONER_plural":"General practitioners","type_GYNECOLOGIST_plural":"Gynecologists","type_OPHTHALMOLOGIST_plural":"Ophthalmologists","type_PEDIATRICIAN_plural":"Pediatricians","type_PSYCHOLOGIST_plural":"Psychologists","type_DERMATOLOGIST_plural":"Dermatologists","type_OSTEOPATH_plural":"Osteopaths","type_PSYCHIATRIST_plural":"Psychiatrists","type_PHYSIOTHERAPIST_plural":"Physiotherapists","No_x_is_currently_available_in_Y":"No {type} is currently available in {location}","The_practitioner_is_allowed_to_ask_for_a_compensation_if_you_dont_show_up_at_the_appointment_":"The practitioner is entitled to claim compensation if you do not show up for the appointment. Article 77 of the Code of Ethics of the Order of Physicians.","You_have_booked_this_appointment_with_X_In_order_to_manage_it_you_will_be_redirecter_do_thier_website":"You have booked this appointment with {name}. In order to manage it, you'll be redirected to their website.","Please_select_a_medical_practice":"Please select a medical practice.","Email_address_":"Email address *","Please_fill_your_email_address":"Please fill in your email address","Contracted_doctor_negative":"Non contracted Doctor","Member_of_Osteopathie":"Member of osteopathie.be","Email_address":"Email address","Select_an_option":"Select an option","Go_back":"Go back","Yes":"Yes","No":"No","The_phone_number_is_X":"The phone number is {phone}","Sign_in_to_display_the_phone_number":"Sign in to display the phone number","Display_phone_number":"Display the phone number","Office_accessible":"Office accessible to people with reduced mobility","Office_card":"Payment by card accepted","Office_cash":"Payment by cash accepted","Office_accessible_disabled":"Office not accessible to persons with reduced mobility","Office_card_disabled":"Payment by card not accepted","Office_cash_disabled":"Payment by cash not accepted","Oste_tooltip":"Recognized union of osteopaths meeting high quality criteria."}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = {"Countries_be":"Belgique","Countries_fr":"France","footer_copyrights":"© {year} Tooddoc","doctor_not_certified_warning":"Votre compte n'est pas encore certifié. Vous pourrez configurer vos disponibilités et accepter des urgences dès qu'un administrateur aura certifié votre compte.","cancel_button_label":"Annuler","close_button_label":"Fermer","ok_button_label":"OK","date_selector_format":"D MMMM","time_format":"HH:mm","moment_locale":"fr","appointment_notification_date_format":"D MMMM","appointment_notification_content":"Un nouveau rendez-vous a été réservé par {firstName} {lastName}.<br />Date du RDV: {date} à {time}","public_site_uri":"https://tooddoc.com/fr","public_site_label":"Site web","terms_uri":"https://tooddoc.com/fr/terms-of-use","terms_label":"Conditions générales","privacy_policy_uri":"https://tooddoc.com/fr/privacy-policy","privacy_policy_label":"Politique de vie privée","cookie_policy_uri":"https://tooddoc.com/fr/cookie-policy","cookie_policy_label":"Politique des cookies","app_message_on_mobile":"Cette application ne fonctionne pas encore sur petit écran. Veuillez essayer sur votre ordinateur.","contact_uri":"https://tooddoc.com/fr/contact","contact_label":"Contact","i_am_a_dentist_label":"Je suis un praticien","cookie_notification":"En utilisant ce site internet, vous acceptez notre politique de cookies.","play_store_uri":"https://play.google.com/store/apps/details?id=com.tooddoc.app","app_store_uri":"https://itunes.apple.com/us/app/tooddoc/id1331906587?ls=1&mt=8","my_profile_link_label":"Mon profil","logout_link_label":"Déconnexion","dashboard_link_label":"Tableau de bord","my_availabilities_link_label":"Mes disponibilités","find_emergencies_link_label":"Trouver une urgence","morning_label":"Matin","afternoon_label":"Après-midi","available_label":"Disponible ?","show_early_slots":"Afficher les plages horaires avant 08:00","show_late_slots":"Afficher les plages horaires après 20:00","status_confirmed_label":"Confirmé","status_cancelled_label":"Annulé","status_declined_label":"Refusé","status_pending_label":"En attente de confirmation","avatar_title":"Choisissez un avatar","next_appointments_section_title":"Vos prochains rendez-vous","next_appointments_section_empty_placeholder":"Aucun rendez-vous","next_appointments_table_details_header":"Détails","next_availabilities_section_title":"Vos prochaines disponibilités","next_availabilities_section_empty_placeholder":"Aucune disponibilité","next_availabilities_table_details_header":"Détails","emergency_modal_title":"Détails d'une urgence","refresh_button_label":"Rafraichir","accept_emergency_button_label":"Accepter l'urgence","accept_modal_title":"Accepter une urgence","accept_modal_select_availability_error":"Veuillez choisir une date et une heure","accept_modal_confirm_button_label":"Confirmer","accepted_dialog_title":"Urgence acceptée","accepted_dialog_message":"Cette urgence a été ajoutée à la liste de vos rendez-vous sur votre tableau de bord.","no_emergencies_placeholder":"Désolé mais nous n'avons aucune urgence à vous montrer pour l'instant.","availability_date_format":"D MMMM","patient_symptoms_title":"Symptômes du patient","patient_information_title":"Informations du patient","pictures_title":"Photos","patient_first_name_label":"Prénom","patient_last_name_label":"Nom","patient_age_label":"Âge","patient_email_label":"Adresse email","patient_phone_label":"Numéro de téléphone","patient_locality_label":"Localité","patient_zip_code_label":"Code postal","no_pictures_placeholder":"Aucune photo n'a été prise","picture_alt":"Photo du patient","date_label":"Date","time_label":"Heure","office_name_label":"Cabinet","patient_header":"Patient de {age} ans, à {locality}","name_label":"Nom","street_name_label":"Rue","street_number_label":"Numéro","zip_code_label":"Code postal","locality_label":"Localité","country_label":"Pays","phone_label":"Téléphone","select_country_label":"Choisissez un pays","phone_error":"Le numéro de téléphone doit être composé du préfixe {prefix} et faire entre 11 et 12 caractères numériques.","create_button_label":"Créer","delete_button_label":"Supprimer le cabinet","alert_create_successful":"Cabinet créé avec succès !","office_alert_update_successful":"Cabinet mis à jour avec succès !","delete_dialog_title":"Supprimer ce cabinet","delete_dialog_message":"Veuillez contacter un administrateur afin de supprimer un cabinet.","emergency_alert_label":"J'accepte de recevoir des notifications email pour les nouvelles urgences près de ce cabinet.","click_to_change_avatar":"Cliquez sur l'avatar pour le changer","first_name_label":"Prénom","last_name_label":"Nom","contact_email_label":"Adresse email","inami_label":"INAMI","language_label":"Langue","inami_error":"Le numéro INAMI doit faire 11 caractères numériques.","update_button_label":"Enregistrer les changements","alert_update_successful":"Profil enregistré avec succès !","accept_terms_label":"J'accepte les <a href=\"https://tooddoc.com/fr/terms-of-use\" target=\"_blank\">conditions d'utilisation</a> et la <a href=\"https://tooddoc.com/fr/privacy-policy\" target=\"_blank\">politique de vie privée</a>.","accept_terms_error":"Vous devez accepter les conditions pour vous inscrire","is_regulated_label":"Je suis conventionné","email_error":"L'adresse email est obligatoire et doit être valide.","medical_practice_label":"Pratique médicale","doctor_details_label":"Vos détails","offices_title":"Vos cabinets","add_office_button_label":"Ajouter un cabinet","doctorRegister_title":"S'enregistrer comme praticien","doctor_legend":"Vos détails","office_legend":"Détails du cabinet","add_another_office_button_label":"Ajouter un autre cabinet","remove_office_button_label":"Supprimer ce cabinet","register_button_label":"S'inscrire","fields_are_missing":"Veuillez vérifier les champs en rouge.","appointment_invitations_could_not_be_loaded":"Erreur technique: nous n'avons pas réussi à récupérer les invitations de rendez-vous.","appointments_could_not_be_loaded":"Erreur technique: nous n'avons pas réussi à récupérer les rendez-vous.","emergencies_could_not_be_loaded":"Erreur technique: nous n'avons pas réussi à récupérer les urgences.","timeslots_could_not_be_loaded":"Erreur technique: nous n'avons pas réussi à récupérer les disponibilités.","no_office_selected":"Vous n'avez pas sélectionné de cabinet. Veuillez en choisir un sur la gauche.","an_error_occured":"Une erreur est survenue, veuillez réessayer.","partner_appointments_could_not_be_loaded":"Nous n'avons pas réussi à charger les rendez-vous de nos partenaires.","sign_in_with_google":"Se connecter avec Google","sign_in_with_facebook":"Se connecter avec Facebook","go_to_doctor_dashboard":"Tableau de bord (Praticien)","go_to_admin_dashboard":"Administration","register_as_doctor_link_label":"S'inscrire comme praticien","thanks_message":"Merci de votre soutient !","add_another_doctor":"Ajouter un autre praticien","remove_doctor":"Retirer","contact_name_label":"Nom complet","intro_text":"Nous souhaiterions contacter d'autres praticiens pour améliorer notre application. Veuillez recommander au moins 2 praticiens. Cette fenêtre disparaitra ensuite.","recommandation_title":"Veuillez recommander au moins 2 praticiens","submit_button_label":"Envoyer","step_0_text":"<p>Bonjour Dr. {name},</p><br><p>Je suis Tood et je vais vous expliquer comment utiliser cette application.</p>","step_0_button":"Voir la présentation","step_1_text":"<p>Dans l'onglet \"Mes disponibilités\", définissez vos plages disponibles pour la prise en charge des urgences via Tooddoc.</p><br><p>Il vous est possible de prendre une urgence toutes les 15 minutes.</p><p>Si vous avez besoin de plus de 15 minutes, sautez le quart d'heure suivant en cochant la demi-heure d'après.</p> (ex: cochez 9h00 et ensuite 9:30)</p><br><p>Je vous conseille de noter les rendez-vous Toodoc dans votre agenda personnel afin de ne pas les oublier ni d'accepter un autre rendez-vous au même moment.</p><br /><p>Vous pouvez annuler ces plages horaires tant qu'elles ne sont pas réservées par un patient !</p>","step_1_button":"Continuer la présentation","step_1_helper_text":"<p>Rends-toi sur \"Mes disponibilités\" pour la suite de la présentation.</p>","step_2_text":"<p>Bienvenue sur votre Tableau de bord!</p><br><p>C'est une vue globale sur laquelle vous voyez vos prochaines disponibilités, vos rendez-vous occupés  ainsi que vos rendez-vous en attente de confirmation.</p>","step_2_button":"Continuer la présentation","step_2_helper_text":"<p>Rends-toi sur ton tableau de bord pour la suite de la présentation.</p>","step_2_helper_button":"Mon tableau de bord","step_3_text":"<p>Voici la liste des patients en attente d'un rendez-vous dans votre région.</p><p>Pour chaque patient, un résumé des principaux symptômes et la possibilité d'une photo de la zone concernée.</p><br /><p>Sélectionnez l'urgence que vous souhaitez prendre en charge, ensuite vous introduisez votre heure de rendez-vous et une demande instantanée est envoyée au patient.</p><p>Une confirmation vous sera notifiée.</p>","step_3_button":"Continuer","step_3_helper_text":"<p>Rends-toi sur \"Trouver une urgence\" pour la suite de la présentation.</p>","step_3_helper_button":"Trouver une urgence","step_4_text":"<p>Bravo !</p><br /><p>Vous pouvez dès à présent utiliser Tooddoc pour accepter des urgences.</p><br /><p>N'oubliez pas de compléter régulièrement vos disponibilités afin que les patients puissent vous contacter directement depuis l'App mobile.</p>","step_4_button":"OK","step_1_helper_button":"Continuer la présentation","my_availabilities":"Mes disponibilités","other_availabilities":"Autres disponibilités","nothing_selected":"Veuillez sélectionner une disponibilité","select":"Selectionner","selected":"Selectionné","Call_the_doctor_at_this_number":"Appelez le praticien au: {phoneNumber}","Appointment_confirmed":"Rendez-vous confirmé","When_":"Quand ?","Who_will_treat_me_":"Qui me soignera ?","Call":"Appeler","Where_have_I_to_go_":"Où dois-je me rendre ?","Itinerary":"Itineraire","Firstname_":"Prénom *","Lastname_":"Nom *","Age_":"Age *","Phone_number_":"N° de téléphone *","What_are_your_symptoms_":"Quels sont vos symptomes ?","Where_do_you_want_to_find_a_appointment_":"Dans quelle région cherchez-vous un rendez-vous ?","Confirm":"Confirmer","Decline":"Refuser","Accept":"Accepter","Delete_my_request":"Supprimer ma demande","Next":"Suivant","Please_answer_to_all_questions_of_the_form":"Veuillez répondre à toute les questions du formulaire","Please_fill_your_first_name":"Veuillez entrer votre prénom","Please_fill_your_last_name":"Veuillez entrer votre nom","Please_fill_your_age":"Veuillez entrer votre âge","Please_fill_your_phone_number":"Veuillez entrer votre numéro de téléphone","By_continuing_you_accept_our_terms_of_service_and_our_privacy_policy":"En continuant, vous acceptez nos <a href=\"{termsUri}\" target=\"_blank\" class=\"text-white underline\">Conditions d'utilisation</a> ainsi que notre <a href=\"{privacyUri}\" target=\"_blank\" class=\"text-white underline\">politique de vie privée</a>.","Continue":"Continuer","Book_this_appointment":"Réserver ce rendez-vous","Detail_of_the_appointment":"Détails du rendez-vous","Symptoms":"Symptômes","Cancel_the_appointment":"Annuler le rendez-vous","To_cancel_the_appointment_call_the_doctor_via_X":"Pour annuler ce rendez-vous, veuillez avertir le médecin au {phoneNumber}","Cancel":"Annuler","Edit":"Modifier","Are_you_sure_to_decline_this_appointment_":"Êtes-vous certain de vouloir refuser ce rendez-vous ?","Yes_decline":"Oui, refuser","Do_you_really_want_to_delete_your_request_":"Voulez-vous vraiment supprimer votre demande ?","Delete":"Supprimer","Invitation_from_dentist":"Proposition du praticien","Waiting":"En attente","Your_confirmed_appointments":"Vos rendez-vous confirmés","Whoops_an_error_has_occured_Please_try_again":"Oups, une erreur est survenue. Veuillez réessayer :)","at":"à","SYMPTOMS_QUESTION_1":"Dans quelle zone avez-vous un problème?","SYMPTOMS_QUESTION_2":"Quelle est la partie affectée?","SYMPTOMS_QUESTION_3":"Avez-vous une fracture?","SYMPTOMS_QUESTION_4":"Voyez-vous un gonflement?","SYMPTOMS_QUESTION_5":"Souffrez-vous de douleurs?","SYMPTOMS_QUESTION_6":"Au contact de quel type d'exposition?","SYMPTOMS_QUESTION_7":"Comment est cette douleur?","Save_my_symptoms":"Enregistrer mes symptomes","SYMPTOMS_ANSWER_1_1":"À l'avant dans le haut","SYMPTOMS_ANSWER_1_2":"À l'avant dans le bas","SYMPTOMS_ANSWER_1_3":"À l'arrière dans le haut","SYMPTOMS_ANSWER_1_4":"À l'arrière dans le bas","SYMPTOMS_ANSWER_2_1":"Les dents","SYMPTOMS_ANSWER_2_2":"Les gencives","SYMPTOMS_ANSWER_2_3":"Les dents et les gencives","SYMPTOMS_ANSWER_2_4":"Prothèse","SYMPTOMS_ANSWER_3_1":"Oui","SYMPTOMS_ANSWER_3_2":"Non","SYMPTOMS_ANSWER_4_1":"Oui","SYMPTOMS_ANSWER_4_2":"Non","SYMPTOMS_ANSWER_5_1":"Oui","SYMPTOMS_ANSWER_5_2":"Non","SYMPTOMS_ANSWER_6_1":"Le froid","SYMPTOMS_ANSWER_6_2":"Le chaud","SYMPTOMS_ANSWER_6_3":"La pression","SYMPTOMS_ANSWER_6_4":"Les trois","SYMPTOMS_ANSWER_7_1":"Spontanée ( Pulsatile )","SYMPTOMS_ANSWER_7_2":"Provoquée ( Sucre, chaud, froid )","This_appointment_is_not_available_anymore":"Ce rendez-vous n'est plus disponible","This_invitation_is_not_valid_anymore":"Cette invitation n'est plus disponible","The_practitioner_will_be_informed_immediately_of_your_reservation":"Le praticien sera immédiatement informé de votre réservation.","Contracted_doctor":"Médecin conventionné","Accept_this_appointment_invitation":"Accepter ce rendez-vous","First_name":"Prénom","Last_name":"Nom","Age":"Age","Phone_number":"Téléphone","Find_an_appointment":"Trouver un rendez-vous","Your_appointments":"Vos rendez-vous","Sign_out":"Déconnexion","Sign_in":"Connexion","Loading":"Chargement...","Appointment_declined":"Rendez-vous refusé","Redirecting":"Redirection en cours...","Choose_your_language":"Choisissez votre langue","Signing_out":"Déconnexion...","Please_give_your_location_to_look_for_doctors_in_your_region":"Veuillez entrer votre position pour chercher des médecins dans votre région.","Sorry_we_don_t_have_any_appointment_available_in_your_region":"Désolé, nous n'avons aucun rendez-vous disponible dans votre région.","Enter_a_location":"Entrez une localisation","Your_current_position":"Votre position actuelle","Sign_in_to_book_this_appointment":"Connectez-vous pour réserver","Summary":"Résumé","Please_fill_your_locality":"Veuillez entrer votre localité","Select_an_availability":"Choisissez une disponibilité","x_more_availabilities":"{cout} disponibilités en plus","Pending":"En attente","Waiting_list":"Liste d'attente","Do_you_really_want_to_delete_your_request":"Voulez-vous vraiment supprimer votre demande ?","Yes_delete":"Oui, supprimer","Deleting_":"Suppression...","You_did_not_find_an_appointment_Activate_the_alert_and_I_will_inform_you_":"Vous n'avez pas trouvé de rendez-vous? Inscrivez-vous sur la liste d'attente.","Enable_the_appointment_alert":"S'inscrire sur liste d'attente","Locality_":"Localité *","I_will_inform_you_as_soon_as_a_timeslot_is_available":"Je vous avertirai dès qu'un créneau se libère.","As_soon_as_a_appointment_is_available_Tood_will_inform_you":"Dès qu'une place se libère, Tood vous avertira","Activate_the_alert_and_I_will_inform_you_":"Inscrivez-vous sur la liste d'attente.","You_are_already_in_the_waiting_list":"Vous êtes déjà sur liste d'attente","X_is_not_available_Register_on_the_waiting_list_to_inform_the_dentists_near_Y":"{name} n'a pas de créneau disponible pour le moment.\nInscrivez-vous sur la liste d'attente pour l'informer, ainsi que les praticiens proches de {location}, de votre demande.","Regulated_Doctor":"€ Médecin conventionné","See_office_availabilities":"Voir les disponibilités","Please_specify":"Veuillez réponde à cette question","Locality":"Localité","Book_this_appointment_with_X":"Réservez ce rendez-vous avec {partner}","Manage_this_appointment_with_X":"Gérer ce rendez-vous avec {partner}","This_timeslot_does_not_exist":"Cette disponibilité n'existe pas","This_appointment_is_provided_by_our_partner_X":"Ce rendez-vous est proposé par notre partenaire {name}.","Thus_you_will_be_redirected_to_their_website_in_order_to_book_it":"Afin de le réserver, vous serez dirigé vers leur site web.","Appointment_provided_by_X":"Rendez-vous proposé par {name}","SYMPTOMS_QUESTION":"Décrivez vos symptômes","Medical_practice_":"Pratique médicale","Select_a_medical_practice":"Choisissez une pratique médicale","type_DENTIST":"Dentiste","type_GENERAL_PRACTITIONER":"Généraliste","type_GYNECOLOGIST":"Gynécologue","type_OPHTHALMOLOGIST":"Ophtalmologue","type_PEDIATRICIAN":"Pédiatre","type_PSYCHOLOGIST":"Psychologue","type_DERMATOLOGIST":"Dermatologue","type_OSTEOPATH":"Ostéopathe","type_PSYCHIATRIST":"Psychiatre","type_PHYSIOTHERAPIST":"Kinésithérapeute","Available_X":"{type} disponibles","Name":"Nom","X_near_Y":"{type} proches de {location}","type_DENTIST_plural":"Dentiste","type_GENERAL_PRACTITIONER_plural":"Généralistes","type_GYNECOLOGIST_plural":"Gynécologues","type_OPHTHALMOLOGIST_plural":"Ophtalmologues","type_PEDIATRICIAN_plural":"Pédiatres","type_PSYCHOLOGIST_plural":"Psychologues","type_DERMATOLOGIST_plural":"Dermatologues","type_OSTEOPATH_plural":"Ostéopathes","type_PSYCHIATRIST_plural":"Psychiatres","type_PHYSIOTHERAPIST_plural":"Kinésithérapeutes","No_x_is_currently_available_in_Y":"Aucun {type} n'est actuellement disponible à {location}","The_practitioner_is_allowed_to_ask_for_a_compensation_if_you_dont_show_up_at_the_appointment_":"Le prestataire est autorisé à réclamer une indemnisation si vous ne vous présentez pas au rendez-vous. Article 77 du Code de Déontologie de l’Ordre des Médecins.","You_have_booked_this_appointment_with_X_In_order_to_manage_it_you_will_be_redirecter_do_thier_website":"Vous avez réservé ce rendez-vous via notre partenaire {name}. Afin de le gérer, vous serez dirigé vers leur site web.","Please_select_a_medical_practice":"Veuillez sélectionner une pratique médicale","Email_address_":"Adresse email *","Please_fill_your_email_address":"Veuillez entrer votre adresse email","Contracted_doctor_negative":"Médecin non conventionné","Member_of_Osteopathie":"Membre de osteopathie.be","Email_address":"Adresse email","Select_an_option":"Choisissez une option","Go_back":"Revenir en arrière","Yes":"Oui","No":"Non","The_phone_number_is_X":"The phone number is {phone}","Sign_in_to_display_the_phone_number":"Sign in to display the phone number","Display_phone_number":"Display the phone number","Office_accessible":"Cabinet accessible aux personnes à mobilité réduite","Office_card":"Paiement par carte bancaire accepté","Office_cash":"Paiement en liquide accepté","Office_accessible_disabled":"Cabinet non accessible aux personnes à mobilité réduite","Office_card_disabled":"Paiement par carte bancaire non accepté","Office_cash_disabled":"Paiement en liquide non accepté","Oste_tooltip":"Union reconnue qui regroupe des ostéopathes répondant à des critères de haute qualité."}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = {"Countries_be":"België","Countries_fr":"Frankrijk","footer_copyrights":"© {year} Tooddoc","doctor_not_certified_warning":"Uw account werd nog niet goedgekeurd. Zodra een Tooddoc verantwoordelijke uw account heeft bevestigd, kunt u uw beschikbare afspraken aangeven en de wachtlijst raadplegen.","cancel_button_label":"Annuleren","close_button_label":"Sluiten","ok_button_label":"OK","date_selector_format":"D MMMM","time_format":"HH:mm","moment_locale":"nl-be","appointment_notification_date_format":"D MMMM","appointment_notification_content":"Een nieuwe afspraak is ingepland door {firstName} {lastName}.<br />datum afspraak: {date} at {time}","public_site_uri":"https://tooddoc.com/nl","public_site_label":"Website","terms_uri":"https://tooddoc.com/nl/terms-of-use","terms_label":"Gebruiksvoorwaarden","privacy_policy_uri":"https://tooddoc.com/nl/privacy-policy","privacy_policy_label":"Privacy beleid","cookie_policy_uri":"https://tooddoc.com/nl/cookie-policy","cookie_policy_label":"Cookie beleid","app_message_on_mobile":"Deze app werkt niet op kleine schermen, gelieve op PC of laptop te proberen.","contact_uri":"https://tooddoc.com/nl/contact","contact_label":"Contact","i_am_a_dentist_label":"Ik ben beoefenaar","cookie_notification":"Door deze website te gebruiken, aanvaardt u onze cookie policy","play_store_uri":"https://play.google.com/store/apps/details?id=com.tooddoc.app","app_store_uri":"https://itunes.apple.com/us/app/tooddoc/id1331906587?ls=1&mt=8\n","my_profile_link_label":"Mijn Profiel","logout_link_label":"Uitloggen","dashboard_link_label":"Dashboard","my_availabilities_link_label":"Mijn beschikbaarheid","find_emergencies_link_label":"Zoek noodgevallen op de wachtlijst","morning_label":"Ochtend","afternoon_label":"Namiddag","available_label":"Beschikbaar?","show_early_slots":"Timeslots voor 08h00","show_late_slots":"Timeslots na 20h00","status_confirmed_label":"Bevestigd","status_cancelled_label":"Geannuleerd","status_declined_label":"Afgewezen","status_pending_label":"In afwachting","avatar_title":"Kies een avatar","next_appointments_section_title":"Opkomende afspraken","next_appointments_section_empty_placeholder":"Geen afspraken","next_appointments_table_details_header":"Details","next_availabilities_section_title":"Volgende beschikbaarheid","next_availabilities_section_empty_placeholder":"Geen beschikbaarheid","next_availabilities_table_details_header":"Details","emergency_modal_title":"Details van het noodgeval","refresh_button_label":"Herladen","accept_emergency_button_label":"Noodgeval aanvaarden","accept_modal_title":"Een noodgeval herladen","accept_modal_select_availability_error":"Kies datum en tijdstip","accept_modal_confirm_button_label":"Bevestigen","accepted_dialog_title":"Noodgeval aanvaard","accepted_dialog_message":"Dit noodgeval is aan uw lijst op het dashboard toegevoegd","no_emergencies_placeholder":"Momenteel zijn er geen noodgevallen","availability_date_format":"D MMMM","patient_symptoms_title":"Symptomen","patient_information_title":"Patient gegevens","pictures_title":"Afbeeldingen","patient_first_name_label":"Voornaam","patient_last_name_label":"Naam","patient_age_label":"Leeftijd","patient_email_label":"Email","patient_phone_label":"Telefoon nr","patient_locality_label":"Plaats","patient_zip_code_label":"Postcode","no_pictures_placeholder":"Geen beschikbare afbeeldingen","picture_alt":"Afbeelding","date_label":"Datum","time_label":"Tijdstip","office_name_label":"Kantoor","patient_header":"{age} jarige patient, uit {locality}","name_label":"Naam Praktijk","street_name_label":"Straat","street_number_label":"Nr","zip_code_label":"Postcode","locality_label":"Plaats","country_label":"Land","phone_label":"Telefoon","select_country_label":"Kies een land","phone_error":"Het telefoon nr dient te bestaan uit 11 of 12 tekens, beginnende met de land code {prefix}","create_button_label":"Aanmaken","delete_button_label":"Praktijk verwijderen","alert_create_successful":"Praktijk aangemaakt","office_alert_update_successful":"Praktijk geactualiseerd","delete_dialog_title":"Praktijk verwijderen","delete_dialog_message":"Om uw praktijk te verwijderen, gelieve een Tooddoc verantwoordelijke te contacteren","emergency_alert_label":"Ik krijg graag de melding over de spoedgevallen dicht bij mijn praktijk.","click_to_change_avatar":"Klik om de avatar te wijzigen","first_name_label":"Voornaam","last_name_label":"Naam","contact_email_label":"Email","inami_label":"RIZIV","language_label":"Taal","inami_error":"Het RIZIV nr bestaat uit 11 tekens","update_button_label":"Veranderingen opslaan","alert_update_successful":"Profiel gewijzigd","accept_terms_label":"Ik aanvaard de <a href='https://tooddoc.com/nl/terms-of-use' target=\"_blank\">Gebruiksvoorwaarden</a> & <a href='https://tooddoc.com/nl/privacy-policy' target=\"_blank\">Privacy beleid</a>","accept_terms_error":"Teneinde te registreren, dient u de voorwaarden te aanvaarden","is_regulated_label":"Ik ben geconventioneerd","email_error":"Het email adres is een verplicht veld. U dient een geldig email adres op te geven.","medical_practice_label":"Medische specialiteit","doctor_details_label":"Uw details","offices_title":"Uw kantoren","add_office_button_label":"Een kantoor toevoegen","doctorRegister_title":"Als arts registreren","doctor_legend":"Uw details","office_legend":"Details praktijk","add_another_office_button_label":"Een praktijk toevoegen","remove_office_button_label":"Deze praktijk verwijderen","register_button_label":"Registreren","fields_are_missing":"Controleer de gegevens in het rood","appointment_invitations_could_not_be_loaded":"Uitnodigingen konden niet worden opgelijst","appointments_could_not_be_loaded":"Afspraken konden niet worden opgelijst","emergencies_could_not_be_loaded":"Wachtijst kon niet worden opgelijst","timeslots_could_not_be_loaded":"Beschikbaarheden konden niet worden opgelijst","no_office_selected":"Gelieve een praktijk te selecteren (Linkerzijde)","an_error_occured":"Er is een fout opgetreden, gelieve opnieuw te proberen","partner_appointments_could_not_be_loaded":"Wij hebben de tijdvakken van onze partners niet kunnen loaden.","sign_in_with_google":"Inloggen met Google","sign_in_with_facebook":"Inloggen met Facebook","go_to_doctor_dashboard":"My dashboard (Beoefenaar)","go_to_admin_dashboard":"Verantwoordelijke dashboard","register_as_doctor_link_label":"Als beoefenaar registreren","thanks_message":"Bedankt !","add_another_doctor":"Een andere beoefenaar toevoegen","remove_doctor":"Verwijderen","contact_name_label":"Voornaam en Naam","intro_text":"Om Tooddoc zo efficiënt mogelijk te maken, willen we u vragen 2 collega's uit te nodigen. Dit bericht krijgt u nadien niet meer te zien.","recommandation_title":"Gelieve minstens 2 collega's aan te bevelen","submit_button_label":"Toevoegen","step_0_text":"\n<p>Hallo Dr. {name},</p><br><p> Ik ben Tood en ga u meer uitleg verschaffen over deze toepassing.</p>","step_0_button":"De presentatie bekijken","step_1_text":"<p>In de tab \"Mijn beschikbaarheid\", dient u de tijdstippen te selecteren waarop u nood-afspraken van Tooddoc kan behandelen.</p><br><p>De beschikbaarheid is ingedeeld per schijf van 15 minuten.</p><p>Als u meer dan 15 minuten nodig denkt te hebben, dan slaat u de volgende schijf van 15 minuten over en klikt meteen op de daarop volgende schijf. </p> (bvb: klik aan 9h00 en vervolgens 9:30)</p><br><p>Ik raad aan om deze afspraken in uw persoonlijke agenda te noteren om deze zeker niet uit het oog te verliezen.</p><br /><p>U kan uw beschikbaarheid steeds aanpassen zolang een patiënt nog niet heeft bevestigd!</p>","step_1_button":"Verdergaan met de presentatie","step_1_helper_text":"<p>Ga naar \"Mijn beschikbaarheid\" voor het vervolg van deze presentatie.</p>","step_2_text":"<p> Welkom op uw dashboard!</p><br><p>Hier kan u in een oogopslag uw beschikbaarheid, uw opkomende afspraken en de door de patiënt te bevestigen afspraken zien. </p>","step_2_button":"Verdergaan met de presentatie","step_2_helper_text":"<p>Ga naar \"uw dashboard\" voor het vervolg van deze presentatie.</p>","step_2_helper_button":"Mijn dashboard","step_3_text":"<p>Ziehier de wachtlijst van patiënten in uw buurt die een afspraak wensen.</p><p>Elke patiënt heeft de mogelijkheid een samenvatting van zijn symptomen te vermelden alsook een foto van het probleem toe te voegen.</p><br /><p>Selecteer de patiënt die u wenst te behandelen, bevestig het uur van de afspraak en Tooddoc verwittigt de patiënt.</p><p>Zodra de patiënt de afspraak bevestigt, wordt u op de hoogte gebracht.</p>","step_3_button":"Verdergaan","step_3_helper_text":"<p>Ga naar \"overzicht patiënten\" voor het vervolg van deze presentatie.</p>","step_3_helper_button":"Overzicht patiënten ","step_4_text":"<p>Proficiat !</p><br /><p>U kan nu Tooddoc gebruiken.</p><br /><p>Vergeet niet uw beschikbaarheid regelmatig up te daten.</p>","step_4_button":"OK","step_1_helper_button":"De presentatie verder bekijken","my_availabilities":"Mijn beschikbaarheid","other_availabilities":"Andere beschikbaarheden","nothing_selected":"Selecteer beschikbaarheid","select":"Selecteer","selected":"Geselecteerd","Call_the_doctor_at_this_number":"Bel de arts op:","Appointment_confirmed":"Afspraak bevestigd","When_":"Wanneer ?","Who_will_treat_me_":"Wie behandelt mij ?","Call":"Bellen","Where_have_I_to_go_":"Waar moet ik naartoe gaan ?","Itinerary":"Wegbeschrijving","Firstname_":"Voornaam *","Lastname_":"Familienaam *","Age_":"Leeftijd *","Phone_number_":"Telefoonnummer *","What_are_your_symptoms_":"Welke zijn de symptomen ?","Where_do_you_want_to_find_a_appointment_":"In welke regio wenst u een afspraak ?","Confirm":"Bevestigen","Decline":"Weigeren","Accept":"Aanvaarden","Delete_my_request":"Mijn aanvraag verwijderen","Next":"Volgender","Please_answer_to_all_questions_of_the_form":"Gelieve alle vragen in het formulier te beantwoorden opdat we u optimaal kunnen helpen","Please_fill_your_first_name":"Uw voornaam","Please_fill_your_last_name":"Uw naam","Please_fill_your_age":"Uw leeftijd","Please_fill_your_phone_number":"Uw telefoonnummer","By_continuing_you_accept_our_terms_of_service_and_our_privacy_policy":"Als u verder gaat, aanvaardt u onze <a href=\"{termsUri}\" target=\"_blank\" class=\"text-white underline\">algemene voorwaarden</a> and our <a href=\"{privacyUri}\" target=\"_blank\" class=\"text-white underline\">privacy policy</a>.","Continue":"Verdergaan","Book_this_appointment":"Deze afspraak bevestigen","Detail_of_the_appointment":"Details van deze afspraak","Symptoms":"Symptomen","Cancel_the_appointment":"Deze afspraak annuleren","To_cancel_the_appointment_call_the_doctor_via_X":"Om deze afspraak te annuleren, gelieve de arts te bellen op {phoneNumber}","Cancel":"Annuleren","Edit":"Wijzigen","Are_you_sure_to_decline_this_appointment_":"Bent u zeker deze afspraak te weigeren?","Yes_decline":"Ja, ik weiger deze afspraak","Do_you_really_want_to_delete_your_request_":"Bent u zeker uw aanvraag te willen verwijderen?","Delete":"Verwijderen","Invitation_from_dentist":"De arts stelt voor","Waiting":"In afwachting","Your_confirmed_appointments":"Uw bevestigde afspraken","Whoops_an_error_has_occured_Please_try_again":"Oeps, er is een fout opgetreden, gelieve het opnieuw te proberen :)","at":"om","SYMPTOMS_QUESTION_1":"Waar is het probleem?","SYMPTOMS_QUESTION_2":"Welk deel is aangetast?","SYMPTOMS_QUESTION_3":"Is er een breuk?","SYMPTOMS_QUESTION_4":"Is het gezwollen?","SYMPTOMS_QUESTION_5":"Hebt u pijn?","SYMPTOMS_QUESTION_6":"Zoja, in welke omstandigheden?","SYMPTOMS_QUESTION_7":"Hoe zou u de pijn omschrijven?","Save_my_symptoms":"Symptomen omschrijven","SYMPTOMS_ANSWER_1_1":"Vooraan aan de bovenzijde","SYMPTOMS_ANSWER_1_2":"Vooraan aan de onderzijde","SYMPTOMS_ANSWER_1_3":"Achteraan aan de bovenzijde","SYMPTOMS_ANSWER_1_4":"Achteraan aan de onderzijde","SYMPTOMS_ANSWER_2_1":"De tanden","SYMPTOMS_ANSWER_2_2":"Het tandvlees","SYMPTOMS_ANSWER_2_3":"De tanden en het tandvlees","SYMPTOMS_ANSWER_2_4":"Tandprothese","SYMPTOMS_ANSWER_3_1":"Ja","SYMPTOMS_ANSWER_3_2":"Nee","SYMPTOMS_ANSWER_4_1":"Ja","SYMPTOMS_ANSWER_4_2":"Nee","SYMPTOMS_ANSWER_5_1":"Ja","SYMPTOMS_ANSWER_5_2":"Nee","SYMPTOMS_ANSWER_6_1":"Bij koude","SYMPTOMS_ANSWER_6_2":"Bij Warmte","SYMPTOMS_ANSWER_6_3":"Bij druk","SYMPTOMS_ANSWER_6_4":"Bij alle drie","SYMPTOMS_ANSWER_7_1":"Spontaan, steeds aanwezig","SYMPTOMS_ANSWER_7_2":"Uitgelokt door suiker, koude, warmte","This_appointment_is_not_available_anymore":"Deze afspraak is niet langer beschikbaar","This_invitation_is_not_valid_anymore":"Deze afspraak is niet langer beschikbaar","The_practitioner_will_be_informed_immediately_of_your_reservation":"De beoefenaar zal onmiddellijk op de hoogte worden gebracht van uw reservatie","Contracted_doctor":"De arts is geconventioneerd","Accept_this_appointment_invitation":"De afspraak aanvaarden","First_name":"Voornaam","Last_name":"Naam","Age":"Leeftijd","Phone_number":"Telefoonnummer","Find_an_appointment":"Vind een afspraak","Your_appointments":"Uw afspraken","Sign_out":"Log uit","Sign_in":"Log in","Loading":"Loading","Appointment_declined":"Afspraak geweigerd","Redirecting":"Redirecting","Choose_your_language":"Kies uw taal","Signing_out":"Aan het uitloggen","Please_give_your_location_to_look_for_doctors_in_your_region":"Om een arts in uw buurt te vinden, gelieve uw locatie in te geven.","Sorry_we_don_t_have_any_appointment_available_in_your_region":"Sorry, momenteel zijn er geen afspraken in uw buurt beschikbaar.","Enter_a_location":"Geef een locatie in","Your_current_position":"Uw huidige locatie","Sign_in_to_book_this_appointment":"Log in om deze afspraak in te plannen.","Summary":"Samenvatting","Please_fill_your_locality":"Vul uw plaats in","Select_an_availability":"Kies een tijdvak","x_more_availabilities":"{count} toegevoegde tijdvakken","Pending":"Pending","Waiting_list":"Wachtlijst","Do_you_really_want_to_delete_your_request":"Wilt u zeker deze aanvraag verwijderen?","Yes_delete":"Ja, verwijderen","Deleting_":"Annulering...","You_did_not_find_an_appointment_Activate_the_alert_and_I_will_inform_you_":"Hebt u geen afspraak gevonden? Registreer op de wachtlijst.","Enable_the_appointment_alert":"Op de wachtlijst registreren","Locality_":"Plaats *","I_will_inform_you_as_soon_as_a_timeslot_is_available":"Wij zullen u waarschuwen wanneer een afspraak mogelijk wordt.","As_soon_as_a_appointment_is_available_Tood_will_inform_you":"Zodra een afspraak mogelijk wordt, wordt u gewaarschuwd","Activate_the_alert_and_I_will_inform_you_":"Registreer op de wachtlijst.","You_are_already_in_the_waiting_list":"U ben al op de wachtlijst ingeschreven","X_is_not_available_Register_on_the_waiting_list_to_inform_the_dentists_near_Y":"{name} heeft op dit moment geen slot beschikbaar. Meld u aan op de wachtlijst om alle beoefenaars in de buurt van {location} op de hoogte te brengen van uw verzoek.","Regulated_Doctor":"€ De arts is geconventioneerd","See_office_availabilities":"Beschikbaarheid bekijken","Please_specify":"Beantwoord deze vraag","Locality":"Plaats","Book_this_appointment_with_X":"Boek deze afspraak met {partner}","Manage_this_appointment_with_X":"Beheer de afspraak met {partner}","This_timeslot_does_not_exist":"Deze tijdvak bestaat niet","This_appointment_is_provided_by_our_partner_X":"Deze afspraak is aangeboden door onze partner {name}. ","Thus_you_will_be_redirected_to_their_website_in_order_to_book_it":"Om deze afspraak te boeken, zult u doorgestuurd worden naar hun website.","Appointment_provided_by_X":"Afspraak aangeboden door {name}","SYMPTOMS_QUESTION":"Beschrijf uw symptomen","Medical_practice_":"Medische specialiteit","Select_a_medical_practice":"Kies een medische specialiteit","type_DENTIST":"Tandarts","type_GENERAL_PRACTITIONER":"Huisarts","type_GYNECOLOGIST":"Gynaecoloog","type_OPHTHALMOLOGIST":"Oogarts","type_PEDIATRICIAN":"Kinderarts","type_PSYCHOLOGIST":"Psycholoog","type_DERMATOLOGIST":"Dermatoloog","type_OSTEOPATH":"Osteopaat","type_PSYCHIATRIST":"Psychiater","type_PHYSIOTHERAPIST":"Fysiotherapeut","Available_X":"Beschikbare {type}","Name":"Naam","X_near_Y":"{type} in de buurt van {location}","type_DENTIST_plural":"Tandartsen","type_GENERAL_PRACTITIONER_plural":"Huisartsen","type_GYNECOLOGIST_plural":"Gynaecologen","type_OPHTHALMOLOGIST_plural":"Oogartsen","type_PEDIATRICIAN_plural":"Kinderartsen","type_PSYCHOLOGIST_plural":"Psychologen","type_DERMATOLOGIST_plural":"Dermatologen","type_OSTEOPATH_plural":"Osteopaten","type_PSYCHIATRIST_plural":"Psychiaters","type_PHYSIOTHERAPIST_plural":"Fysiotherapeuten","No_x_is_currently_available_in_Y":"Geen {type} is momenteel beschikbaar dicht bij {location}","The_practitioner_is_allowed_to_ask_for_a_compensation_if_you_dont_show_up_at_the_appointment_":"De behandelaar heeft recht op een schadevergoeding als u niet komt opdagen voor de afspraak. Artikel 77 van de deontologische code van de Orde van Geneesheren.","You_have_booked_this_appointment_with_X_In_order_to_manage_it_you_will_be_redirecter_do_thier_website":"U hebt deze afspraak geboekt dankzij onze partner {name}. Om deze afspraak te beheren, zult u doorgestuurd worden naar hun website.","Please_select_a_medical_practice":"Kies een medische specialiteit a.u.b.","Email_address_":"Email *","Please_fill_your_email_address":"Uw email","Contracted_doctor_negative":"De arts is niet geconventioneerd","Member_of_Osteopathie":"Lid van osteopathie.be","Email_address":"Email","Select_an_option":"Kies een optie","Go_back":"Ga terug","Yes":"Ja","No":"Nee","The_phone_number_is_X":"The phone number is {phone}","Sign_in_to_display_the_phone_number":"Sign in to display the phone number","Display_phone_number":"Display the phone number","Office_accessible":"Kabinet toegankelijk voor mensen met beperkte mobiliteit","Office_card":"Betaling met creditcard geaccepteerd","Office_cash":"Contante betaling geaccepteerd","Office_accessible_disabled":"Kantoor niet toegankelijk voor personen met beperkte mobiliteit","Office_card_disabled":"Betaling per kaart niet geaccepteerd","Office_cash_disabled":"Betaling in contanten niet geaccepteerd","Oste_tooltip":"Erkende beroepsvereniging van osteopaten die voldoen aan hoge kwaliteitscriteria."}

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "section",
      { staticClass: "py-12", attrs: { id: "heading" } },
      [_c("header-nav")],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "py-12" },
      [
        _vm.errorText
          ? _c("div", { staticClass: "max-w-sm mx-auto px-6 mb-6" }, [
              _c(
                "div",
                {
                  staticClass:
                    "bg-red-light w-full shadow border border-red-light text-white px-4 py-3 rounded relative"
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "font-semibold",
                    domProps: { textContent: _vm._s(_vm.errorText) }
                  })
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.loadingAppointments ||
        _vm.loadingInvitations ||
        _vm.loadingEmergencies ||
        _vm.loadingPartnerAppointments
          ? _c("patient-loading")
          : _vm._e(),
        _vm._v(" "),
        !_vm.loadingInvitations &&
        Object.keys(_vm.invitations).length &&
        _vm.patient
          ? _c(
              "div",
              { staticClass: "max-w-sm mx-auto px-6" },
              [
                _c("div", {
                  staticClass:
                    "uppercase tracking-wide text-grey-darker text-sm font-semibold mb-6",
                  domProps: {
                    textContent: _vm._s(_vm.$t("Invitation_from_dentist"))
                  }
                }),
                _vm._v(" "),
                _vm._l(_vm.sortedInvitations, function(invitation) {
                  return _c("invitation-list-item", {
                    key: invitation.id,
                    attrs: { invitation: invitation }
                  })
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.loadingEmergencies &&
        Object.keys(_vm.emergencies).length &&
        _vm.patient
          ? _c(
              "div",
              { staticClass: "max-w-sm mx-auto px-6" },
              [
                _c("div", {
                  staticClass:
                    "uppercase tracking-wide text-grey-darker text-sm font-semibold mb-6",
                  domProps: { textContent: _vm._s(_vm.$t("Pending")) }
                }),
                _vm._v(" "),
                _vm._l(_vm.sortedEmergencies, function(emergency) {
                  return _c("emergency-list-item", {
                    key: emergency.id,
                    attrs: { emergency: emergency },
                    on: { deleted: _vm.fetchEmergencies }
                  })
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.loadingAppointments &&
        (Object.keys(_vm.appointments).length ||
          Object.keys(_vm.partnerAppointments).length) &&
        _vm.patient
          ? _c(
              "div",
              { staticClass: "max-w-sm mx-auto px-6" },
              [
                _c("div", {
                  staticClass:
                    "uppercase tracking-wide text-grey-darker text-sm font-semibold mb-6",
                  domProps: {
                    textContent: _vm._s(_vm.$t("Your_confirmed_appointments"))
                  }
                }),
                _vm._v(" "),
                _vm._l(_vm.sortedAppointments, function(appointment) {
                  return _c("appointment-list-item", {
                    key: appointment.id,
                    attrs: { appointment: appointment }
                  })
                }),
                _vm._v(" "),
                _vm._l(_vm.sortedPartnerAppointments, function(appointment) {
                  return _c("partner-appointment-list-item", {
                    key: appointment.id,
                    attrs: { appointment: appointment }
                  })
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "max-w-sm mx-auto px-6" },
          [
            _c(
              "router-link",
              {
                staticClass:
                  "inline-block w-full px-4 py-3 rounded bg-blue hover:bg-blue-dark text-sm text-white uppercase tracking-wide font-semibold text-center",
                attrs: { to: { name: "search" } }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("Find_an_appointment")) +
                    "\n            "
                )
              ]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-1 text-lg" }, [
      _c("i", { staticClass: "mdi mdi-alert-circle-outline" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8dc7cce2", esExports)
  }
}

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b97b26f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(610);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(608)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b97b26f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/Home.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2b97b26f", Component.options)
  } else {
    hotAPI.reload("data-v-2b97b26f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(609);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(20)("dae0a046", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2b97b26f\",\"scoped\":false,\"hasInlineConfig\":false}!./firebaseui.css", function() {
     var newContent = require("!!../../css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2b97b26f\",\"scoped\":false,\"hasInlineConfig\":false}!./firebaseui.css");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(19)(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Roboto:400,500,700);", ""]);

// module
exports.push([module.i, "\n.mdl-button {\n  background: 0 0;\n  border: none;\n  border-radius: 2px;\n  color: #000;\n  position: relative;\n  height: 36px;\n  margin: 0;\n  min-width: 64px;\n  padding: 0 16px;\n  display: inline-block;\n  font-family: Roboto, Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  font-weight: 500;\n  text-transform: uppercase;\n  line-height: 1;\n  letter-spacing: 0;\n  overflow: hidden;\n  will-change: box-shadow;\n  -webkit-transition: background-color .2s cubic-bezier(.4, 0, .2, 1), color .2s cubic-bezier(.4, 0, .2, 1), -webkit-box-shadow .2s cubic-bezier(.4, 0, 1, 1);\n          transition: background-color .2s cubic-bezier(.4, 0, .2, 1), color .2s cubic-bezier(.4, 0, .2, 1), -webkit-box-shadow .2s cubic-bezier(.4, 0, 1, 1);\n          transition: box-shadow .2s cubic-bezier(.4, 0, 1, 1), background-color .2s cubic-bezier(.4, 0, .2, 1), color .2s cubic-bezier(.4, 0, .2, 1);\n          transition: box-shadow .2s cubic-bezier(.4, 0, 1, 1), background-color .2s cubic-bezier(.4, 0, .2, 1), color .2s cubic-bezier(.4, 0, .2, 1), -webkit-box-shadow .2s cubic-bezier(.4, 0, 1, 1);\n  outline: 0;\n  cursor: pointer;\n  text-decoration: none;\n  text-align: center;\n  line-height: 36px;\n  vertical-align: middle;\n}\n.mdl-button::-moz-focus-inner {\n  border: 0;\n}\n.mdl-button:hover {\n  background-color: rgba(158, 158, 158, .2);\n}\n.mdl-button:focus:not(:active) {\n  background-color: rgba(0, 0, 0, .12);\n}\n.mdl-button:active {\n  background-color: rgba(158, 158, 158, .4);\n}\n.mdl-button.mdl-button--colored {\n  color: #3f51b5;\n}\n.mdl-button.mdl-button--colored:focus:not(:active) {\n  background-color: rgba(0, 0, 0, .12);\n}\ninput.mdl-button[type=submit] {\n  -webkit-appearance: none;\n}\n.mdl-button--raised {\n  background: rgba(158, 158, 158, .2);\n  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);\n          box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);\n}\n.mdl-button--raised:active {\n  -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);\n          box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);\n  background-color: rgba(158, 158, 158, .4);\n}\n.mdl-button--raised:focus:not(:active) {\n  -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, .18), 0 8px 16px rgba(0, 0, 0, .36);\n          box-shadow: 0 0 8px rgba(0, 0, 0, .18), 0 8px 16px rgba(0, 0, 0, .36);\n  background-color: rgba(158, 158, 158, .4);\n}\n.mdl-button--raised.mdl-button--colored {\n  background: #3f51b5;\n  color: #fff;\n}\n.mdl-button--raised.mdl-button--colored:hover {\n  background-color: #3f51b5;\n}\n.mdl-button--raised.mdl-button--colored:active {\n  background-color: #3f51b5;\n}\n.mdl-button--raised.mdl-button--colored:focus:not(:active) {\n  background-color: #3f51b5;\n}\n.mdl-button--raised.mdl-button--colored .mdl-ripple {\n  background: #fff;\n}\n.mdl-button--fab {\n  border-radius: 50%;\n  font-size: 24px;\n  height: 56px;\n  margin: auto;\n  min-width: 56px;\n  width: 56px;\n  padding: 0;\n  overflow: hidden;\n  background: rgba(158, 158, 158, .2);\n  -webkit-box-shadow: 0 1px 1.5px 0 rgba(0, 0, 0, .12), 0 1px 1px 0 rgba(0, 0, 0, .24);\n          box-shadow: 0 1px 1.5px 0 rgba(0, 0, 0, .12), 0 1px 1px 0 rgba(0, 0, 0, .24);\n  position: relative;\n  line-height: normal;\n}\n.mdl-button--fab .material-icons {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-12px, -12px);\n          transform: translate(-12px, -12px);\n  line-height: 24px;\n  width: 24px;\n}\n.mdl-button--fab.mdl-button--mini-fab {\n  height: 40px;\n  min-width: 40px;\n  width: 40px;\n}\n.mdl-button--fab .mdl-button__ripple-container {\n  border-radius: 50%;\n  -webkit-mask-image: -webkit-radial-gradient(circle, #fff, #000);\n}\n.mdl-button--fab:active {\n  -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);\n          box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);\n  background-color: rgba(158, 158, 158, .4);\n}\n.mdl-button--fab:focus:not(:active) {\n  -webkit-box-shadow: 0 0 8px rgba(0, 0, 0, .18), 0 8px 16px rgba(0, 0, 0, .36);\n          box-shadow: 0 0 8px rgba(0, 0, 0, .18), 0 8px 16px rgba(0, 0, 0, .36);\n  background-color: rgba(158, 158, 158, .4);\n}\n.mdl-button--fab.mdl-button--colored {\n  background: #ff4081;\n  color: #fff;\n}\n.mdl-button--fab.mdl-button--colored:hover {\n  background-color: #ff4081;\n}\n.mdl-button--fab.mdl-button--colored:focus:not(:active) {\n  background-color: #ff4081;\n}\n.mdl-button--fab.mdl-button--colored:active {\n  background-color: #ff4081;\n}\n.mdl-button--fab.mdl-button--colored .mdl-ripple {\n  background: #fff;\n}\n.mdl-button--icon {\n  border-radius: 50%;\n  font-size: 24px;\n  height: 32px;\n  margin-left: 0;\n  margin-right: 0;\n  min-width: 32px;\n  width: 32px;\n  padding: 0;\n  overflow: hidden;\n  color: inherit;\n  line-height: normal;\n}\n.mdl-button--icon .material-icons {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-12px, -12px);\n          transform: translate(-12px, -12px);\n  line-height: 24px;\n  width: 24px;\n}\n.mdl-button--icon.mdl-button--mini-icon {\n  height: 24px;\n  min-width: 24px;\n  width: 24px;\n}\n.mdl-button--icon.mdl-button--mini-icon .material-icons {\n  top: 0;\n  left: 0;\n}\n.mdl-button--icon .mdl-button__ripple-container {\n  border-radius: 50%;\n  -webkit-mask-image: -webkit-radial-gradient(circle, #fff, #000);\n}\n.mdl-button__ripple-container {\n  display: block;\n  height: 100%;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: 0;\n  overflow: hidden;\n}\n.mdl-button.mdl-button--disabled .mdl-button__ripple-container .mdl-ripple,\n.mdl-button[disabled] .mdl-button__ripple-container .mdl-ripple {\n  background-color: transparent;\n}\n.mdl-button--primary.mdl-button--primary {\n  color: #3f51b5;\n}\n.mdl-button--primary.mdl-button--primary .mdl-ripple {\n  background: #fff;\n}\n.mdl-button--primary.mdl-button--primary.mdl-button--fab,\n.mdl-button--primary.mdl-button--primary.mdl-button--raised {\n  color: #fff;\n  background-color: #3f51b5;\n}\n.mdl-button--accent.mdl-button--accent {\n  color: #ff4081;\n}\n.mdl-button--accent.mdl-button--accent .mdl-ripple {\n  background: #fff;\n}\n.mdl-button--accent.mdl-button--accent.mdl-button--fab,\n.mdl-button--accent.mdl-button--accent.mdl-button--raised {\n  color: #fff;\n  background-color: #ff4081;\n}\n.mdl-button.mdl-button--disabled.mdl-button--disabled,\n.mdl-button[disabled][disabled] {\n  color: rgba(0, 0, 0, .26);\n  cursor: default;\n  background-color: transparent;\n}\n.mdl-button--fab.mdl-button--disabled.mdl-button--disabled,\n.mdl-button--fab[disabled][disabled] {\n  background-color: rgba(0, 0, 0, .12);\n  color: rgba(0, 0, 0, .26);\n}\n.mdl-button--raised.mdl-button--disabled.mdl-button--disabled,\n.mdl-button--raised[disabled][disabled] {\n  background-color: rgba(0, 0, 0, .12);\n  color: rgba(0, 0, 0, .26);\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.mdl-button--colored.mdl-button--disabled.mdl-button--disabled,\n.mdl-button--colored[disabled][disabled] {\n  color: rgba(0, 0, 0, .26);\n}\n.mdl-button .material-icons {\n  vertical-align: middle;\n}\n.mdl-card {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  font-size: 16px;\n  font-weight: 400;\n  min-height: 200px;\n  overflow: hidden;\n  width: 330px;\n  z-index: 1;\n  position: relative;\n  background: #fff;\n  border-radius: 2px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.mdl-card__media {\n  background-color: #ff4081;\n  background-repeat: repeat;\n  background-position: 50% 50%;\n  background-size: cover;\n  background-origin: padding-box;\n  background-attachment: scroll;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.mdl-card__title {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  color: #000;\n  display: block;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: stretch;\n  -ms-flex-pack: stretch;\n  justify-content: stretch;\n  line-height: normal;\n  padding: 16px 16px;\n  -webkit-perspective-origin: 165px 56px;\n          perspective-origin: 165px 56px;\n  -webkit-transform-origin: 165px 56px;\n          transform-origin: 165px 56px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.mdl-card__title.mdl-card--border {\n  border-bottom: 1px solid rgba(0, 0, 0, .1);\n}\n.mdl-card__title-text {\n  -ms-flex-item-align: end;\n  align-self: flex-end;\n  color: inherit;\n  display: block;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 24px;\n  font-weight: 300;\n  line-height: normal;\n  overflow: hidden;\n  -webkit-transform-origin: 149px 48px;\n          transform-origin: 149px 48px;\n  margin: 0;\n}\n.mdl-card__subtitle-text {\n  font-size: 14px;\n  color: rgba(0, 0, 0, .54);\n  margin: 0;\n}\n.mdl-card__supporting-text {\n  color: rgba(0, 0, 0, .54);\n  font-size: 1rem;\n  line-height: 18px;\n  overflow: hidden;\n  padding: 16px 16px;\n  width: 90%;\n}\n.mdl-card__supporting-text.mdl-card--border {\n  border-bottom: 1px solid rgba(0, 0, 0, .1);\n}\n.mdl-card__actions {\n  font-size: 16px;\n  line-height: normal;\n  width: 100%;\n  background-color: transparent;\n  padding: 8px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.mdl-card__actions.mdl-card--border {\n  border-top: 1px solid rgba(0, 0, 0, .1);\n}\n.mdl-card--expand {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n}\n.mdl-card__menu {\n  position: absolute;\n  right: 16px;\n  top: 16px;\n}\n.mdl-dialog {\n  border: none;\n  -webkit-box-shadow: 0 9px 46px 8px rgba(0, 0, 0, .14), 0 11px 15px -7px rgba(0, 0, 0, .12), 0 24px 38px 3px rgba(0, 0, 0, .2);\n          box-shadow: 0 9px 46px 8px rgba(0, 0, 0, .14), 0 11px 15px -7px rgba(0, 0, 0, .12), 0 24px 38px 3px rgba(0, 0, 0, .2);\n  width: 280px;\n}\n.mdl-dialog__title {\n  padding: 24px 24px 0;\n  margin: 0;\n  font-size: 2.5rem;\n}\n.mdl-dialog__actions {\n  padding: 8px 8px 8px 24px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n  -ms-flex-direction: row-reverse;\n      flex-direction: row-reverse;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.mdl-dialog__actions>* {\n  margin-right: 8px;\n  height: 36px;\n}\n.mdl-dialog__actions>:first-child {\n  margin-right: 0;\n}\n.mdl-dialog__actions--full-width {\n  padding: 0 0 8px 0;\n}\n.mdl-dialog__actions--full-width>* {\n  height: 48px;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 100%;\n      flex: 0 0 100%;\n  padding-right: 16px;\n  margin-right: 0;\n  text-align: right;\n}\n.mdl-dialog__content {\n  padding: 20px 24px 24px 24px;\n  color: rgba(0, 0, 0, .54);\n}\n.mdl-progress {\n  display: block;\n  position: relative;\n  height: 4px;\n  width: 500px;\n  max-width: 100%;\n}\n.mdl-progress>.bar {\n  display: block;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 0%;\n  -webkit-transition: width .2s cubic-bezier(.4, 0, .2, 1);\n          transition: width .2s cubic-bezier(.4, 0, .2, 1);\n}\n.mdl-progress>.progressbar {\n  background-color: #3f51b5;\n  z-index: 1;\n  left: 0;\n}\n.mdl-progress>.bufferbar {\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, .7)), to(rgba(255, 255, 255, .7))), -webkit-gradient(linear, left top, right top, from(#3f51b5), to(#3f51b5));\n  background-image: linear-gradient(to right, rgba(255, 255, 255, .7), rgba(255, 255, 255, .7)), linear-gradient(to right, #3f51b5, #3f51b5);\n  z-index: 0;\n  left: 0;\n}\n.mdl-progress>.auxbar {\n  right: 0;\n}\n@supports (-webkit-appearance:none) {\n.mdl-progress:not(.mdl-progress--indeterminate):not(.mdl-progress--indeterminate)>.auxbar,\n  .mdl-progress:not(.mdl-progress__indeterminate):not(.mdl-progress__indeterminate)>.auxbar {\n    background-image: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, .7)), to(rgba(255, 255, 255, .7))), -webkit-gradient(linear, left top, right top, from(#3f51b5), to(#3f51b5));\n    background-image: linear-gradient(to right, rgba(255, 255, 255, .7), rgba(255, 255, 255, .7)), linear-gradient(to right, #3f51b5, #3f51b5);\n    -webkit-mask: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+Cjxzdmcgd2lkdGg9IjEyIiBoZWlnaHQ9IjQiIHZpZXdQb3J0PSIwIDAgMTIgNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxlbGxpcHNlIGN4PSIyIiBjeT0iMiIgcng9IjIiIHJ5PSIyIj4KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN4IiBmcm9tPSIyIiB0bz0iLTEwIiBkdXI9IjAuNnMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogIDwvZWxsaXBzZT4KICA8ZWxsaXBzZSBjeD0iMTQiIGN5PSIyIiByeD0iMiIgcnk9IjIiIGNsYXNzPSJsb2FkZXIiPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iY3giIGZyb209IjE0IiB0bz0iMiIgZHVyPSIwLjZzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgLz4KICA8L2VsbGlwc2U+Cjwvc3ZnPgo=);\n            mask: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+Cjxzdmcgd2lkdGg9IjEyIiBoZWlnaHQ9IjQiIHZpZXdQb3J0PSIwIDAgMTIgNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgogIDxlbGxpcHNlIGN4PSIyIiBjeT0iMiIgcng9IjIiIHJ5PSIyIj4KICAgIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN4IiBmcm9tPSIyIiB0bz0iLTEwIiBkdXI9IjAuNnMiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiAvPgogIDwvZWxsaXBzZT4KICA8ZWxsaXBzZSBjeD0iMTQiIGN5PSIyIiByeD0iMiIgcnk9IjIiIGNsYXNzPSJsb2FkZXIiPgogICAgPGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iY3giIGZyb209IjE0IiB0bz0iMiIgZHVyPSIwLjZzIiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgLz4KICA8L2VsbGlwc2U+Cjwvc3ZnPgo=);\n}\n}\n.mdl-progress:not(.mdl-progress--indeterminate)>.auxbar,\n.mdl-progress:not(.mdl-progress__indeterminate)>.auxbar {\n  background-image: -webkit-gradient(linear, left top, right top, from(rgba(255, 255, 255, .9)), to(rgba(255, 255, 255, .9))), -webkit-gradient(linear, left top, right top, from(#3f51b5), to(#3f51b5));\n  background-image: linear-gradient(to right, rgba(255, 255, 255, .9), rgba(255, 255, 255, .9)), linear-gradient(to right, #3f51b5, #3f51b5);\n}\n.mdl-progress.mdl-progress--indeterminate>.bar1,\n.mdl-progress.mdl-progress__indeterminate>.bar1 {\n  background-color: #3f51b5;\n  -webkit-animation-name: indeterminate1;\n          animation-name: indeterminate1;\n  -webkit-animation-duration: 2s;\n          animation-duration: 2s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n}\n.mdl-progress.mdl-progress--indeterminate>.bar3,\n.mdl-progress.mdl-progress__indeterminate>.bar3 {\n  background-image: none;\n  background-color: #3f51b5;\n  -webkit-animation-name: indeterminate2;\n          animation-name: indeterminate2;\n  -webkit-animation-duration: 2s;\n          animation-duration: 2s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n}\n@-webkit-keyframes indeterminate1 {\n0% {\n    left: 0;\n    width: 0%;\n}\n50% {\n    left: 25%;\n    width: 75%;\n}\n75% {\n    left: 100%;\n    width: 0%;\n}\n}\n@keyframes indeterminate1 {\n0% {\n    left: 0;\n    width: 0%;\n}\n50% {\n    left: 25%;\n    width: 75%;\n}\n75% {\n    left: 100%;\n    width: 0%;\n}\n}\n@-webkit-keyframes indeterminate2 {\n0% {\n    left: 0;\n    width: 0%;\n}\n50% {\n    left: 0;\n    width: 0%;\n}\n75% {\n    left: 0;\n    width: 25%;\n}\n100% {\n    left: 100%;\n    width: 0%;\n}\n}\n@keyframes indeterminate2 {\n0% {\n    left: 0;\n    width: 0%;\n}\n50% {\n    left: 0;\n    width: 0%;\n}\n75% {\n    left: 0;\n    width: 25%;\n}\n100% {\n    left: 100%;\n    width: 0%;\n}\n}\n.mdl-shadow--2dp {\n  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);\n          box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12);\n}\n.mdl-shadow--3dp {\n  -webkit-box-shadow: 0 3px 4px 0 rgba(0, 0, 0, .14), 0 3px 3px -2px rgba(0, 0, 0, .2), 0 1px 8px 0 rgba(0, 0, 0, .12);\n          box-shadow: 0 3px 4px 0 rgba(0, 0, 0, .14), 0 3px 3px -2px rgba(0, 0, 0, .2), 0 1px 8px 0 rgba(0, 0, 0, .12);\n}\n.mdl-shadow--4dp {\n  -webkit-box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);\n          box-shadow: 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12), 0 2px 4px -1px rgba(0, 0, 0, .2);\n}\n.mdl-shadow--6dp {\n  -webkit-box-shadow: 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px -1px rgba(0, 0, 0, .2);\n          box-shadow: 0 6px 10px 0 rgba(0, 0, 0, .14), 0 1px 18px 0 rgba(0, 0, 0, .12), 0 3px 5px -1px rgba(0, 0, 0, .2);\n}\n.mdl-shadow--8dp {\n  -webkit-box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12), 0 5px 5px -3px rgba(0, 0, 0, .2);\n          box-shadow: 0 8px 10px 1px rgba(0, 0, 0, .14), 0 3px 14px 2px rgba(0, 0, 0, .12), 0 5px 5px -3px rgba(0, 0, 0, .2);\n}\n.mdl-shadow--16dp {\n  -webkit-box-shadow: 0 16px 24px 2px rgba(0, 0, 0, .14), 0 6px 30px 5px rgba(0, 0, 0, .12), 0 8px 10px -5px rgba(0, 0, 0, .2);\n          box-shadow: 0 16px 24px 2px rgba(0, 0, 0, .14), 0 6px 30px 5px rgba(0, 0, 0, .12), 0 8px 10px -5px rgba(0, 0, 0, .2);\n}\n.mdl-shadow--24dp {\n  -webkit-box-shadow: 0 9px 46px 8px rgba(0, 0, 0, .14), 0 11px 15px -7px rgba(0, 0, 0, .12), 0 24px 38px 3px rgba(0, 0, 0, .2);\n          box-shadow: 0 9px 46px 8px rgba(0, 0, 0, .14), 0 11px 15px -7px rgba(0, 0, 0, .12), 0 24px 38px 3px rgba(0, 0, 0, .2);\n}\n.mdl-spinner {\n  display: inline-block;\n  position: relative;\n  width: 28px;\n  height: 28px;\n}\n.mdl-spinner:not(.is-upgraded).is-active:after {\n  content: \"Loading...\";\n}\n.mdl-spinner.is-upgraded.is-active {\n  -webkit-animation: mdl-spinner__container-rotate 1.568s linear infinite;\n          animation: mdl-spinner__container-rotate 1.568s linear infinite;\n}\n@-webkit-keyframes mdl-spinner__container-rotate {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n@keyframes mdl-spinner__container-rotate {\nto {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n}\n}\n.mdl-spinner__layer {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  opacity: 0;\n}\n.mdl-spinner__layer-1 {\n  border-color: #42a5f5;\n}\n.mdl-spinner--single-color .mdl-spinner__layer-1 {\n  border-color: #3f51b5;\n}\n.mdl-spinner.is-active .mdl-spinner__layer-1 {\n  -webkit-animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-1-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n          animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-1-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n}\n.mdl-spinner__layer-2 {\n  border-color: #f44336;\n}\n.mdl-spinner--single-color .mdl-spinner__layer-2 {\n  border-color: #3f51b5;\n}\n.mdl-spinner.is-active .mdl-spinner__layer-2 {\n  -webkit-animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-2-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n          animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-2-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n}\n.mdl-spinner__layer-3 {\n  border-color: #fdd835;\n}\n.mdl-spinner--single-color .mdl-spinner__layer-3 {\n  border-color: #3f51b5;\n}\n.mdl-spinner.is-active .mdl-spinner__layer-3 {\n  -webkit-animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-3-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n          animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-3-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n}\n.mdl-spinner__layer-4 {\n  border-color: #4caf50;\n}\n.mdl-spinner--single-color .mdl-spinner__layer-4 {\n  border-color: #3f51b5;\n}\n.mdl-spinner.is-active .mdl-spinner__layer-4 {\n  -webkit-animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-4-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n          animation: mdl-spinner__fill-unfill-rotate 5332ms cubic-bezier(.4, 0, .2, 1) infinite both, mdl-spinner__layer-4-fade-in-out 5332ms cubic-bezier(.4, 0, .2, 1) infinite both;\n}\n@-webkit-keyframes mdl-spinner__fill-unfill-rotate {\n12.5% {\n    -webkit-transform: rotate(135deg);\n            transform: rotate(135deg);\n}\n25% {\n    -webkit-transform: rotate(270deg);\n            transform: rotate(270deg);\n}\n37.5% {\n    -webkit-transform: rotate(405deg);\n            transform: rotate(405deg);\n}\n50% {\n    -webkit-transform: rotate(540deg);\n            transform: rotate(540deg);\n}\n62.5% {\n    -webkit-transform: rotate(675deg);\n            transform: rotate(675deg);\n}\n75% {\n    -webkit-transform: rotate(810deg);\n            transform: rotate(810deg);\n}\n87.5% {\n    -webkit-transform: rotate(945deg);\n            transform: rotate(945deg);\n}\nto {\n    -webkit-transform: rotate(1080deg);\n            transform: rotate(1080deg);\n}\n}\n@keyframes mdl-spinner__fill-unfill-rotate {\n12.5% {\n    -webkit-transform: rotate(135deg);\n            transform: rotate(135deg);\n}\n25% {\n    -webkit-transform: rotate(270deg);\n            transform: rotate(270deg);\n}\n37.5% {\n    -webkit-transform: rotate(405deg);\n            transform: rotate(405deg);\n}\n50% {\n    -webkit-transform: rotate(540deg);\n            transform: rotate(540deg);\n}\n62.5% {\n    -webkit-transform: rotate(675deg);\n            transform: rotate(675deg);\n}\n75% {\n    -webkit-transform: rotate(810deg);\n            transform: rotate(810deg);\n}\n87.5% {\n    -webkit-transform: rotate(945deg);\n            transform: rotate(945deg);\n}\nto {\n    -webkit-transform: rotate(1080deg);\n            transform: rotate(1080deg);\n}\n}\n@-webkit-keyframes mdl-spinner__layer-1-fade-in-out {\nfrom {\n    opacity: .99;\n}\n25% {\n    opacity: .99;\n}\n26% {\n    opacity: 0;\n}\n89% {\n    opacity: 0;\n}\n90% {\n    opacity: .99;\n}\n100% {\n    opacity: .99;\n}\n}\n@keyframes mdl-spinner__layer-1-fade-in-out {\nfrom {\n    opacity: .99;\n}\n25% {\n    opacity: .99;\n}\n26% {\n    opacity: 0;\n}\n89% {\n    opacity: 0;\n}\n90% {\n    opacity: .99;\n}\n100% {\n    opacity: .99;\n}\n}\n@-webkit-keyframes mdl-spinner__layer-2-fade-in-out {\nfrom {\n    opacity: 0;\n}\n15% {\n    opacity: 0;\n}\n25% {\n    opacity: .99;\n}\n50% {\n    opacity: .99;\n}\n51% {\n    opacity: 0;\n}\n}\n@keyframes mdl-spinner__layer-2-fade-in-out {\nfrom {\n    opacity: 0;\n}\n15% {\n    opacity: 0;\n}\n25% {\n    opacity: .99;\n}\n50% {\n    opacity: .99;\n}\n51% {\n    opacity: 0;\n}\n}\n@-webkit-keyframes mdl-spinner__layer-3-fade-in-out {\nfrom {\n    opacity: 0;\n}\n40% {\n    opacity: 0;\n}\n50% {\n    opacity: .99;\n}\n75% {\n    opacity: .99;\n}\n76% {\n    opacity: 0;\n}\n}\n@keyframes mdl-spinner__layer-3-fade-in-out {\nfrom {\n    opacity: 0;\n}\n40% {\n    opacity: 0;\n}\n50% {\n    opacity: .99;\n}\n75% {\n    opacity: .99;\n}\n76% {\n    opacity: 0;\n}\n}\n@-webkit-keyframes mdl-spinner__layer-4-fade-in-out {\nfrom {\n    opacity: 0;\n}\n65% {\n    opacity: 0;\n}\n75% {\n    opacity: .99;\n}\n90% {\n    opacity: .99;\n}\n100% {\n    opacity: 0;\n}\n}\n@keyframes mdl-spinner__layer-4-fade-in-out {\nfrom {\n    opacity: 0;\n}\n65% {\n    opacity: 0;\n}\n75% {\n    opacity: .99;\n}\n90% {\n    opacity: .99;\n}\n100% {\n    opacity: 0;\n}\n}\n.mdl-spinner__gap-patch {\n  position: absolute;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  top: 0;\n  left: 45%;\n  width: 10%;\n  height: 100%;\n  overflow: hidden;\n  border-color: inherit;\n}\n.mdl-spinner__gap-patch .mdl-spinner__circle {\n  width: 1000%;\n  left: -450%;\n}\n.mdl-spinner__circle-clipper {\n  display: inline-block;\n  position: relative;\n  width: 50%;\n  height: 100%;\n  overflow: hidden;\n  border-color: inherit;\n}\n.mdl-spinner__circle-clipper.mdl-spinner__left {\n  float: left;\n}\n.mdl-spinner__circle-clipper.mdl-spinner__right {\n  float: right;\n}\n.mdl-spinner__circle-clipper .mdl-spinner__circle {\n  width: 200%;\n}\n.mdl-spinner__circle {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  height: 100%;\n  border-width: 3px;\n  border-style: solid;\n  border-color: inherit;\n  border-bottom-color: transparent !important;\n  border-radius: 50%;\n  -webkit-animation: none;\n          animation: none;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.mdl-spinner__left .mdl-spinner__circle {\n  border-right-color: transparent !important;\n  -webkit-transform: rotate(129deg);\n          transform: rotate(129deg);\n}\n.mdl-spinner.is-active .mdl-spinner__left .mdl-spinner__circle {\n  -webkit-animation: mdl-spinner__left-spin 1333ms cubic-bezier(.4, 0, .2, 1) infinite both;\n          animation: mdl-spinner__left-spin 1333ms cubic-bezier(.4, 0, .2, 1) infinite both;\n}\n.mdl-spinner__right .mdl-spinner__circle {\n  left: -100%;\n  border-left-color: transparent !important;\n  -webkit-transform: rotate(-129deg);\n          transform: rotate(-129deg);\n}\n.mdl-spinner.is-active .mdl-spinner__right .mdl-spinner__circle {\n  -webkit-animation: mdl-spinner__right-spin 1333ms cubic-bezier(.4, 0, .2, 1) infinite both;\n          animation: mdl-spinner__right-spin 1333ms cubic-bezier(.4, 0, .2, 1) infinite both;\n}\n@-webkit-keyframes mdl-spinner__left-spin {\nfrom {\n    -webkit-transform: rotate(130deg);\n            transform: rotate(130deg);\n}\n50% {\n    -webkit-transform: rotate(-5deg);\n            transform: rotate(-5deg);\n}\nto {\n    -webkit-transform: rotate(130deg);\n            transform: rotate(130deg);\n}\n}\n@keyframes mdl-spinner__left-spin {\nfrom {\n    -webkit-transform: rotate(130deg);\n            transform: rotate(130deg);\n}\n50% {\n    -webkit-transform: rotate(-5deg);\n            transform: rotate(-5deg);\n}\nto {\n    -webkit-transform: rotate(130deg);\n            transform: rotate(130deg);\n}\n}\n@-webkit-keyframes mdl-spinner__right-spin {\nfrom {\n    -webkit-transform: rotate(-130deg);\n            transform: rotate(-130deg);\n}\n50% {\n    -webkit-transform: rotate(5deg);\n            transform: rotate(5deg);\n}\nto {\n    -webkit-transform: rotate(-130deg);\n            transform: rotate(-130deg);\n}\n}\n@keyframes mdl-spinner__right-spin {\nfrom {\n    -webkit-transform: rotate(-130deg);\n            transform: rotate(-130deg);\n}\n50% {\n    -webkit-transform: rotate(5deg);\n            transform: rotate(5deg);\n}\nto {\n    -webkit-transform: rotate(-130deg);\n            transform: rotate(-130deg);\n}\n}\n.mdl-textfield {\n  position: relative;\n  font-size: 16px;\n  display: inline-block;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  width: 300px;\n  max-width: 100%;\n  margin: 0;\n  padding: 20px 0;\n}\n.mdl-textfield .mdl-button {\n  position: absolute;\n  bottom: 20px;\n}\n.mdl-textfield--align-right {\n  text-align: right;\n}\n.mdl-textfield--full-width {\n  width: 100%;\n}\n.mdl-textfield--expandable {\n  min-width: 32px;\n  width: auto;\n  min-height: 32px;\n}\n.mdl-textfield--expandable .mdl-button--icon {\n  top: 16px;\n}\n.mdl-textfield__input {\n  border: none;\n  border-bottom: 1px solid rgba(0, 0, 0, .12);\n  display: block;\n  font-size: 16px;\n  font-family: Helvetica, Arial, sans-serif;\n  margin: 0;\n  padding: 4px 0;\n  width: 100%;\n  background: 0 0;\n  text-align: left;\n  color: inherit;\n}\n.mdl-textfield__input[type=number] {\n  -moz-appearance: textfield;\n}\n.mdl-textfield__input[type=number]::-webkit-inner-spin-button,\n.mdl-textfield__input[type=number]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n.mdl-textfield.is-focused .mdl-textfield__input {\n  outline: 0;\n}\n.mdl-textfield.is-invalid .mdl-textfield__input {\n  border-color: #d50000;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.mdl-textfield.is-disabled .mdl-textfield__input,\nfieldset[disabled] .mdl-textfield .mdl-textfield__input {\n  background-color: transparent;\n  border-bottom: 1px dotted rgba(0, 0, 0, .12);\n  color: rgba(0, 0, 0, .26);\n}\n.mdl-textfield textarea.mdl-textfield__input {\n  display: block;\n}\n.mdl-textfield__label {\n  bottom: 0;\n  color: rgba(0, 0, 0, .26);\n  font-size: 16px;\n  left: 0;\n  right: 0;\n  pointer-events: none;\n  position: absolute;\n  display: block;\n  top: 24px;\n  width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-align: left;\n}\n.mdl-textfield.has-placeholder .mdl-textfield__label,\n.mdl-textfield.is-dirty .mdl-textfield__label {\n  visibility: hidden;\n}\n.mdl-textfield--floating-label .mdl-textfield__label {\n  -webkit-transition-duration: .2s;\n          transition-duration: .2s;\n  -webkit-transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n          transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n}\n.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label {\n  -webkit-transition: none;\n          transition: none;\n}\n.mdl-textfield.is-disabled.is-disabled .mdl-textfield__label,\nfieldset[disabled] .mdl-textfield .mdl-textfield__label {\n  color: rgba(0, 0, 0, .26);\n}\n.mdl-textfield--floating-label.has-placeholder .mdl-textfield__label,\n.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,\n.mdl-textfield--floating-label.is-focused .mdl-textfield__label {\n  color: #3f51b5;\n  font-size: 12px;\n  top: 4px;\n  visibility: visible;\n}\n.mdl-textfield--floating-label.has-placeholder .mdl-textfield__expandable-holder .mdl-textfield__label,\n.mdl-textfield--floating-label.is-dirty .mdl-textfield__expandable-holder .mdl-textfield__label,\n.mdl-textfield--floating-label.is-focused .mdl-textfield__expandable-holder .mdl-textfield__label {\n  top: -16px;\n}\n.mdl-textfield--floating-label.is-invalid .mdl-textfield__label {\n  color: #d50000;\n  font-size: 12px;\n}\n.mdl-textfield__label:after {\n  background-color: #3f51b5;\n  bottom: 20px;\n  content: '';\n  height: 2px;\n  left: 45%;\n  position: absolute;\n  -webkit-transition-duration: .2s;\n          transition-duration: .2s;\n  -webkit-transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n          transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n  visibility: hidden;\n  width: 10px;\n}\n.mdl-textfield.is-focused .mdl-textfield__label:after {\n  left: 0;\n  visibility: visible;\n  width: 100%;\n}\n.mdl-textfield.is-invalid .mdl-textfield__label:after {\n  background-color: #d50000;\n}\n.mdl-textfield__error {\n  color: #d50000;\n  position: absolute;\n  font-size: 12px;\n  margin-top: 3px;\n  visibility: hidden;\n  display: block;\n}\n.mdl-textfield.is-invalid .mdl-textfield__error {\n  visibility: visible;\n}\n.mdl-textfield__expandable-holder {\n  display: inline-block;\n  position: relative;\n  margin-left: 32px;\n  -webkit-transition-duration: .2s;\n          transition-duration: .2s;\n  -webkit-transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n          transition-timing-function: cubic-bezier(.4, 0, .2, 1);\n  display: inline-block;\n  max-width: .1px;\n}\n.mdl-textfield.is-dirty .mdl-textfield__expandable-holder,\n.mdl-textfield.is-focused .mdl-textfield__expandable-holder {\n  max-width: 600px;\n}\n.mdl-textfield__expandable-holder .mdl-textfield__label:after {\n  bottom: 0;\n}\ndialog {\n  position: absolute;\n  left: 0;\n  right: 0;\n  width: -moz-fit-content;\n  width: -webkit-fit-content;\n  width: fit-content;\n  height: -moz-fit-content;\n  height: -webkit-fit-content;\n  height: fit-content;\n  margin: auto;\n  border: solid;\n  padding: 1em;\n  background: #fff;\n  color: #000;\n  display: block;\n}\ndialog:not([open]) {\n  display: none;\n}\ndialog+.backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background: rgba(0, 0, 0, .1);\n}\n._dialog_overlay {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\ndialog.fixed {\n  position: fixed;\n  top: 50%;\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%);\n}\n.firebaseui-container {\n  background-color: #fff;\n          box-sizing: border-box;\n     -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  color: rgba(0, 0, 0, .87);\n  direction: ltr;\n  font: 16px Roboto, arial, sans-serif;\n  margin: 0 auto;\n  max-width: 360px;\n  overflow: visible;\n  position: relative;\n  text-align: left;\n  width: 100%;\n}\n.firebaseui-container.mdl-card {\n  overflow: visible;\n}\n.firebaseui-card-header {\n  padding: 24px 24px 0 24px;\n}\n.firebaseui-card-content {\n  padding: 0 24px;\n}\n.firebaseui-card-footer {\n  padding: 0 24px;\n}\n.firebaseui-card-actions {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  display: table;\n  font-size: 14px;\n  padding: 8px 24px 24px 24px;\n  text-align: left;\n  width: 100%;\n}\n.firebaseui-form-links {\n  display: table-cell;\n  vertical-align: middle;\n  width: 100%;\n}\n.firebaseui-form-actions {\n  display: table-cell;\n  text-align: right;\n  white-space: nowrap;\n  width: 100%;\n}\n.firebaseui-subtitle,\n.firebaseui-title {\n  color: rgba(0, 0, 0, .87);\n  direction: ltr;\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 24px;\n  margin: 0;\n  padding: 0;\n  text-align: left;\n}\n.firebaseui-title {\n  padding-bottom: 16px;\n}\n.firebaseui-subtitle {\n  margin: 16px 0;\n}\n.firebaseui-text {\n  color: rgba(0, 0, 0, .87);\n  direction: ltr;\n  font-size: 16px;\n  line-height: 24px;\n  text-align: left;\n}\n.firebaseui-id-page-password-recovery-email-sent p.firebaseui-text {\n  margin: 16px 0;\n}\n.firebaseui-text-emphasis {\n  font-weight: 700;\n}\n.firebaseui-error {\n  color: #dd2c00;\n  direction: ltr;\n  font-size: 12px;\n  line-height: 16px;\n  margin: 0;\n  text-align: left;\n}\n.firebaseui-text-input-error {\n  margin: -16px 0 16px;\n}\n.firebaseui-error-wrapper {\n  min-height: 16px;\n}\n.firebaseui-list-item {\n  direction: ltr;\n  margin: 0;\n  padding: 0;\n  text-align: left;\n}\n.firebaseui-hidden {\n  display: none;\n}\n.firebaseui-relative-wrapper {\n  position: relative;\n}\n.firebaseui-label {\n  color: rgba(0, 0, 0, .54);\n  direction: ltr;\n  font-size: 16px;\n  text-align: left;\n}\n.mdl-textfield--floating-label.is-dirty .mdl-textfield__label,\n.mdl-textfield--floating-label.is-focused .mdl-textfield__label {\n  color: #757575;\n}\n.firebaseui-input,\n.firebaseui-input-invalid {\n  border-radius: 0;\n  color: rgba(0, 0, 0, .87);\n  direction: ltr;\n  font-size: 16px;\n  width: 100%;\n}\ninput.firebaseui-input,\ninput.firebaseui-input-invalid {\n  direction: ltr;\n  text-align: left;\n}\n.firebaseui-input-invalid {\n  border-color: #dd2c00;\n}\n.firebaseui-textfield {\n  width: 100%;\n}\n.firebaseui-textfield.mdl-textfield .firebaseui-input {\n  border-color: rgba(0, 0, 0, .12);\n}\n.firebaseui-textfield.mdl-textfield .firebaseui-label::after {\n  background-color: #3f51b5;\n}\n.firebaseui-textfield-invalid.mdl-textfield .firebaseui-input {\n  border-color: #dd2c00;\n}\n.firebaseui-textfield-invalid.mdl-textfield .firebaseui-label::after {\n  background-color: #dd2c00;\n}\n.firebaseui-button {\n  display: inline-block;\n  height: 36px;\n  margin-left: 8px;\n  min-width: 88px;\n}\n.firebaseui-link {\n  color: #4285f4;\n  font-variant: normal;\n  font-weight: 400;\n  text-decoration: none;\n}\n.firebaseui-link:hover {\n  text-decoration: underline;\n}\n.firebaseui-indent {\n  margin-left: 1em;\n}\n.firebaseui-tos {\n  color: #757575;\n  direction: ltr;\n  font-size: 12px;\n  line-height: 16px;\n  margin-bottom: 24px;\n  margin-top: 0;\n  text-align: left;\n}\n.firebaseui-provider-sign-in-footer>.firebaseui-tos {\n  text-align: center;\n}\n.firebaseui-tos-list {\n  list-style: none;\n  text-align: right;\n}\n.firebaseui-inline-list-item {\n  display: inline-block;\n  margin-left: 5px;\n  margin-right: 5px;\n}\n.firebaseui-page-provider-sign-in {\n  background: inherit;\n}\n.firebaseui-idp-list {\n  list-style: none;\n  margin: 1em 0;\n  padding: 0;\n}\n.firebaseui-idp-button {\n  direction: ltr;\n  font-weight: 500;\n  height: auto;\n  line-height: normal;\n  max-width: 220px;\n  min-height: 40px;\n  padding: 8px 16px;\n  text-align: left;\n  width: 100%;\n}\n.firebaseui-idp-list>.firebaseui-list-item {\n  margin-bottom: 15px;\n  text-align: center;\n}\n.firebaseui-idp-icon-wrapper {\n  display: table-cell;\n  vertical-align: middle;\n}\n.firebaseui-idp-icon {\n  border: none;\n  display: inline-block;\n  height: 18px;\n  vertical-align: middle;\n  width: 18px;\n}\n.firebaseui-idp-favicon {\n  border: none;\n  display: inline-block;\n  height: 14px;\n  margin-right: 5px;\n  vertical-align: middle;\n  width: 14px;\n}\n.firebaseui-idp-text {\n  color: #fff;\n  display: table-cell;\n  font-size: 14px;\n  padding-left: 16px;\n  text-transform: none;\n  vertical-align: middle;\n}\n.firebaseui-idp-text.firebaseui-idp-text-long {\n  display: table-cell;\n}\n.firebaseui-idp-text.firebaseui-idp-text-short {\n  display: none;\n}\n@media (max-width:268px) {\n.firebaseui-idp-text.firebaseui-idp-text-long {\n    display: none;\n}\n.firebaseui-idp-text.firebaseui-idp-text-short {\n    display: table-cell;\n}\n}\n@media (max-width:320px) {\n.firebaseui-recaptcha-container>div>div {\n            transform: scale(.9);\n    -webkit-transform: scale(.9);\n             transform-origin: 0 0;\n    -webkit-transform-origin: 0 0;\n}\n}\n.firebaseui-idp-password,\n.firebaseui-idp-password:hover,\n.mdl-button.firebaseui-idp-password:active,\n.mdl-button.firebaseui-idp-password:focus {\n  background-color: #db4437;\n}\n.firebaseui-idp-phone,\n.firebaseui-idp-phone:hover,\n.mdl-button.firebaseui-idp-phone:active,\n.mdl-button.firebaseui-idp-phone:focus {\n  background-color: #02bd7e;\n}\n.firebaseui-idp-google,\n.firebaseui-idp-google:hover,\n.mdl-button.firebaseui-idp-google:active,\n.mdl-button.firebaseui-idp-google:focus {\n  background-color: #fff;\n}\n.firebaseui-idp-google>.firebaseui-idp-text {\n  color: #757575;\n}\n.firebaseui-idp-github,\n.firebaseui-idp-github:hover,\n.mdl-button.firebaseui-idp-github:active,\n.mdl-button.firebaseui-idp-github:focus {\n  background-color: #333;\n}\n.firebaseui-idp-facebook,\n.firebaseui-idp-facebook:hover,\n.mdl-button.firebaseui-idp-facebook:active,\n.mdl-button.firebaseui-idp-facebook:focus {\n  background-color: #3b5998;\n}\n.firebaseui-idp-twitter,\n.firebaseui-idp-twitter:hover,\n.mdl-button.firebaseui-idp-twitter:active,\n.mdl-button.firebaseui-idp-twitter:focus {\n  background-color: #55acee;\n}\n.firebaseui-idp-anonymous,\n.firebaseui-idp-anonymous:hover,\n.mdl-button.firebaseui-idp-anonymous:active,\n.mdl-button.firebaseui-idp-anonymous:focus {\n  background-color: #f4b400;\n}\n.firebaseui-info-bar {\n  background-color: #f9edbe;\n  border: 1px solid #f0c36d;\n          box-shadow: 0 2px 4px rgba(0, 0, 0, .2);\n  -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, .2);\n     -moz-box-shadow: 0 2px 4px rgba(0, 0, 0, .2);\n  left: 10%;\n  padding: 8px 16px;\n  position: absolute;\n  right: 10%;\n  text-align: center;\n  top: 0;\n}\n.firebaseui-info-bar-message {\n  font-size: 12px;\n  margin: 0;\n}\n.firebaseui-dialog {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: rgba(0, 0, 0, .87);\n  font: 16px Roboto, arial, sans-serif;\n  height: auto;\n  padding: 24px;\n  text-align: left;\n}\n.firebaseui-dialog-icon-wrapper {\n  display: table-cell;\n  vertical-align: middle;\n}\n.firebaseui-dialog-icon {\n  float: left;\n  height: 40px;\n  margin-right: 24px;\n  width: 40px;\n}\n.firebaseui-progress-dialog-message {\n  display: table-cell;\n  font-size: 16px;\n  font-weight: 400;\n  min-height: 40px;\n  vertical-align: middle;\n}\n.firebaseui-progress-dialog-loading-icon {\n  height: 28px;\n  margin: 6px 30px 6px 6px;\n  width: 28px;\n}\n.firebaseui-icon-done {\n  background-image: url(https://www.gstatic.com/images/icons/material/system/2x/done_googgreen_36dp.png);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 36px 36px;\n}\n.firebaseui-phone-number {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.firebaseui-country-selector {\n  background-image: url(https://www.gstatic.com/images/icons/material/system/1x/arrow_drop_down_grey600_18dp.png);\n  background-position: right center;\n  background-repeat: no-repeat;\n  background-size: 18px auto;\n  border-radius: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, .12);\n  color: rgba(0, 0, 0, .87);\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  font-size: 16px;\n  font-weight: 400;\n  height: initial;\n  line-height: normal;\n  margin: 20px 24px 20px 0;\n  padding: 4px 20px 4px 0;\n  width: 90px;\n}\n.firebaseui-country-selector-flag {\n  display: inline-block;\n  margin-right: 1ex;\n}\n.firebaseui-flag {\n  background-image: url(https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/flags_sprite_2x.png);\n  background-size: 100% auto;\n  -webkit-filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, .54));\n          filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, .54));\n  height: 14px;\n  width: 24px;\n}\n.firebaseui-list-box-dialog {\n  max-height: 90%;\n  overflow: auto;\n  padding: 8px 0 0 0;\n}\n.firebaseui-list-box-actions {\n  padding-bottom: 8px;\n}\n.firebaseui-list-box-icon-wrapper {\n  display: table-cell;\n  padding-right: 24px;\n  vertical-align: top;\n}\n.firebaseui-list-box-label-wrapper {\n  display: table-cell;\n  vertical-align: top;\n}\n.firebaseui-list-box-dialog-button {\n  color: rgba(0, 0, 0, .87);\n  direction: ltr;\n  font-size: 16px;\n  font-weight: 400;\n  height: initial;\n  line-height: normal;\n  min-height: 48px;\n  padding: 14px 24px;\n  text-align: left;\n  text-transform: none;\n  width: 100%;\n}\n.firebaseui-phone-number-error {\n  margin-left: 114px;\n}\n.mdl-progress.firebaseui-busy-indicator {\n  height: 2px;\n  left: 0;\n  position: absolute;\n  top: 55px;\n  width: 100%;\n}\n.mdl-spinner.firebaseui-busy-indicator {\n  height: 56px;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 30%;\n  width: 56px;\n}\n.firebaseui-callback-indicator-container .firebaseui-busy-indicator {\n  top: 0;\n}\n.firebaseui-callback-indicator-container {\n  height: 120px;\n}\n.firebaseui-new-password-component {\n  display: inline-block;\n  position: relative;\n  width: 100%;\n}\n.firebaseui-input-floating-button {\n  background-position: center;\n  background-repeat: no-repeat;\n  display: block;\n  height: 24px;\n  position: absolute;\n  right: 0;\n  top: 20px;\n  width: 24px;\n}\n.firebaseui-input-toggle-on {\n  background-image: url(https://www.gstatic.com/images/icons/material/system/1x/visibility_black_24dp.png);\n}\n.firebaseui-input-toggle-off {\n  background-image: url(https://www.gstatic.com/images/icons/material/system/1x/visibility_off_black_24dp.png);\n}\n.firebaseui-input-toggle-focus {\n  opacity: .87;\n}\n.firebaseui-input-toggle-blur {\n  opacity: .38;\n}\n.firebaseui-recaptcha-wrapper {\n  display: table;\n  margin: 0 auto;\n  padding-bottom: 8px;\n}\n.firebaseui-recaptcha-container {\n  display: table-cell;\n}\n.firebaseui-recaptcha-error-wrapper {\n  caption-side: bottom;\n  display: table-caption;\n}\n.firebaseui-change-phone-number-link {\n  display: block;\n}\n.firebaseui-resend-container {\n  direction: ltr;\n  margin: 20px 0;\n  text-align: center;\n}\n.firebaseui-id-resend-countdown {\n  color: rgba(0, 0, 0, .38);\n}\n.firebaseui-id-page-phone-sign-in-start .firebaseui-form-actions div {\n  float: left;\n}\n@media (max-width:480px) {\n.firebaseui-container {\n    -webkit-box-shadow: none;\n            box-shadow: none;\n    max-width: none;\n    width: 100%;\n}\n.firebaseui-card-header {\n    border-bottom: 1px solid #e0e0e0;\n    margin-bottom: 16px;\n    padding: 16px 24px 0 24px;\n}\n.firebaseui-title {\n    padding-bottom: 16px;\n}\n.firebaseui-card-actions {\n    padding-right: 24px;\n}\n.firebaseui-busy-indicator {\n    top: 0;\n}\n}\n.mdl-textfield__label {\n  font-weight: 400;\n  margin-bottom: 0;\n}\n.firebaseui-id-page-blank {\n  background: inherit;\n  height: 64px;\n}\n.firebaseui-email-sent {\n  background-image: url(https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/success_status.png);\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 64px 64px;\n  height: 64px;\n  margin-top: 16px;\n  text-align: center;\n}\n.firebaseui-text-justify {\n  text-align: justify;\n}\n.firebaseui-flag-KY {\n  background-position: 0 0;\n}\n.firebaseui-flag-AC {\n  background-position: 0 -14px;\n}\n.firebaseui-flag-AE {\n  background-position: 0 -28px;\n}\n.firebaseui-flag-AF {\n  background-position: 0 -42px;\n}\n.firebaseui-flag-AG {\n  background-position: 0 -56px;\n}\n.firebaseui-flag-AI {\n  background-position: 0 -70px;\n}\n.firebaseui-flag-AL {\n  background-position: 0 -84px;\n}\n.firebaseui-flag-AM {\n  background-position: 0 -98px;\n}\n.firebaseui-flag-AO {\n  background-position: 0 -112px;\n}\n.firebaseui-flag-AQ {\n  background-position: 0 -126px;\n}\n.firebaseui-flag-AR {\n  background-position: 0 -140px;\n}\n.firebaseui-flag-AS {\n  background-position: 0 -154px;\n}\n.firebaseui-flag-AT {\n  background-position: 0 -168px;\n}\n.firebaseui-flag-AU {\n  background-position: 0 -182px;\n}\n.firebaseui-flag-AW {\n  background-position: 0 -196px;\n}\n.firebaseui-flag-AX {\n  background-position: 0 -210px;\n}\n.firebaseui-flag-AZ {\n  background-position: 0 -224px;\n}\n.firebaseui-flag-BA {\n  background-position: 0 -238px;\n}\n.firebaseui-flag-BB {\n  background-position: 0 -252px;\n}\n.firebaseui-flag-BD {\n  background-position: 0 -266px;\n}\n.firebaseui-flag-BE {\n  background-position: 0 -280px;\n}\n.firebaseui-flag-BF {\n  background-position: 0 -294px;\n}\n.firebaseui-flag-BG {\n  background-position: 0 -308px;\n}\n.firebaseui-flag-BH {\n  background-position: 0 -322px;\n}\n.firebaseui-flag-BI {\n  background-position: 0 -336px;\n}\n.firebaseui-flag-BJ {\n  background-position: 0 -350px;\n}\n.firebaseui-flag-BL {\n  background-position: 0 -364px;\n}\n.firebaseui-flag-BM {\n  background-position: 0 -378px;\n}\n.firebaseui-flag-BN {\n  background-position: 0 -392px;\n}\n.firebaseui-flag-BO {\n  background-position: 0 -406px;\n}\n.firebaseui-flag-BQ {\n  background-position: 0 -420px;\n}\n.firebaseui-flag-BR {\n  background-position: 0 -434px;\n}\n.firebaseui-flag-BS {\n  background-position: 0 -448px;\n}\n.firebaseui-flag-BT {\n  background-position: 0 -462px;\n}\n.firebaseui-flag-BV {\n  background-position: 0 -476px;\n}\n.firebaseui-flag-BW {\n  background-position: 0 -490px;\n}\n.firebaseui-flag-BY {\n  background-position: 0 -504px;\n}\n.firebaseui-flag-BZ {\n  background-position: 0 -518px;\n}\n.firebaseui-flag-CA {\n  background-position: 0 -532px;\n}\n.firebaseui-flag-CC {\n  background-position: 0 -546px;\n}\n.firebaseui-flag-CD {\n  background-position: 0 -560px;\n}\n.firebaseui-flag-CF {\n  background-position: 0 -574px;\n}\n.firebaseui-flag-CG {\n  background-position: 0 -588px;\n}\n.firebaseui-flag-CH {\n  background-position: 0 -602px;\n}\n.firebaseui-flag-CI {\n  background-position: 0 -616px;\n}\n.firebaseui-flag-CK {\n  background-position: 0 -630px;\n}\n.firebaseui-flag-CL {\n  background-position: 0 -644px;\n}\n.firebaseui-flag-CM {\n  background-position: 0 -658px;\n}\n.firebaseui-flag-CN {\n  background-position: 0 -672px;\n}\n.firebaseui-flag-CO {\n  background-position: 0 -686px;\n}\n.firebaseui-flag-CP {\n  background-position: 0 -700px;\n}\n.firebaseui-flag-CR {\n  background-position: 0 -714px;\n}\n.firebaseui-flag-CU {\n  background-position: 0 -728px;\n}\n.firebaseui-flag-CV {\n  background-position: 0 -742px;\n}\n.firebaseui-flag-CW {\n  background-position: 0 -756px;\n}\n.firebaseui-flag-CX {\n  background-position: 0 -770px;\n}\n.firebaseui-flag-CY {\n  background-position: 0 -784px;\n}\n.firebaseui-flag-CZ {\n  background-position: 0 -798px;\n}\n.firebaseui-flag-DE {\n  background-position: 0 -812px;\n}\n.firebaseui-flag-DG {\n  background-position: 0 -826px;\n}\n.firebaseui-flag-DJ {\n  background-position: 0 -840px;\n}\n.firebaseui-flag-DK {\n  background-position: 0 -854px;\n}\n.firebaseui-flag-DM {\n  background-position: 0 -868px;\n}\n.firebaseui-flag-DO {\n  background-position: 0 -882px;\n}\n.firebaseui-flag-DZ {\n  background-position: 0 -896px;\n}\n.firebaseui-flag-EA {\n  background-position: 0 -910px;\n}\n.firebaseui-flag-EC {\n  background-position: 0 -924px;\n}\n.firebaseui-flag-EE {\n  background-position: 0 -938px;\n}\n.firebaseui-flag-EG {\n  background-position: 0 -952px;\n}\n.firebaseui-flag-EH {\n  background-position: 0 -966px;\n}\n.firebaseui-flag-ER {\n  background-position: 0 -980px;\n}\n.firebaseui-flag-ES {\n  background-position: 0 -994px;\n}\n.firebaseui-flag-ET {\n  background-position: 0 -1008px;\n}\n.firebaseui-flag-EU {\n  background-position: 0 -1022px;\n}\n.firebaseui-flag-FI {\n  background-position: 0 -1036px;\n}\n.firebaseui-flag-FJ {\n  background-position: 0 -1050px;\n}\n.firebaseui-flag-FK {\n  background-position: 0 -1064px;\n}\n.firebaseui-flag-FM {\n  background-position: 0 -1078px;\n}\n.firebaseui-flag-FO {\n  background-position: 0 -1092px;\n}\n.firebaseui-flag-FR {\n  background-position: 0 -1106px;\n}\n.firebaseui-flag-GA {\n  background-position: 0 -1120px;\n}\n.firebaseui-flag-GB {\n  background-position: 0 -1134px;\n}\n.firebaseui-flag-GD {\n  background-position: 0 -1148px;\n}\n.firebaseui-flag-GE {\n  background-position: 0 -1162px;\n}\n.firebaseui-flag-GF {\n  background-position: 0 -1176px;\n}\n.firebaseui-flag-GG {\n  background-position: 0 -1190px;\n}\n.firebaseui-flag-GH {\n  background-position: 0 -1204px;\n}\n.firebaseui-flag-GI {\n  background-position: 0 -1218px;\n}\n.firebaseui-flag-GL {\n  background-position: 0 -1232px;\n}\n.firebaseui-flag-GM {\n  background-position: 0 -1246px;\n}\n.firebaseui-flag-GN {\n  background-position: 0 -1260px;\n}\n.firebaseui-flag-GP {\n  background-position: 0 -1274px;\n}\n.firebaseui-flag-GQ {\n  background-position: 0 -1288px;\n}\n.firebaseui-flag-GR {\n  background-position: 0 -1302px;\n}\n.firebaseui-flag-GS {\n  background-position: 0 -1316px;\n}\n.firebaseui-flag-GT {\n  background-position: 0 -1330px;\n}\n.firebaseui-flag-GU {\n  background-position: 0 -1344px;\n}\n.firebaseui-flag-GW {\n  background-position: 0 -1358px;\n}\n.firebaseui-flag-GY {\n  background-position: 0 -1372px;\n}\n.firebaseui-flag-HK {\n  background-position: 0 -1386px;\n}\n.firebaseui-flag-HM {\n  background-position: 0 -1400px;\n}\n.firebaseui-flag-HN {\n  background-position: 0 -1414px;\n}\n.firebaseui-flag-HR {\n  background-position: 0 -1428px;\n}\n.firebaseui-flag-HT {\n  background-position: 0 -1442px;\n}\n.firebaseui-flag-HU {\n  background-position: 0 -1456px;\n}\n.firebaseui-flag-IC {\n  background-position: 0 -1470px;\n}\n.firebaseui-flag-ID {\n  background-position: 0 -1484px;\n}\n.firebaseui-flag-IE {\n  background-position: 0 -1498px;\n}\n.firebaseui-flag-IL {\n  background-position: 0 -1512px;\n}\n.firebaseui-flag-IM {\n  background-position: 0 -1526px;\n}\n.firebaseui-flag-IN {\n  background-position: 0 -1540px;\n}\n.firebaseui-flag-IO {\n  background-position: 0 -1554px;\n}\n.firebaseui-flag-IQ {\n  background-position: 0 -1568px;\n}\n.firebaseui-flag-IR {\n  background-position: 0 -1582px;\n}\n.firebaseui-flag-IS {\n  background-position: 0 -1596px;\n}\n.firebaseui-flag-IT {\n  background-position: 0 -1610px;\n}\n.firebaseui-flag-JE {\n  background-position: 0 -1624px;\n}\n.firebaseui-flag-JM {\n  background-position: 0 -1638px;\n}\n.firebaseui-flag-JO {\n  background-position: 0 -1652px;\n}\n.firebaseui-flag-JP {\n  background-position: 0 -1666px;\n}\n.firebaseui-flag-KE {\n  background-position: 0 -1680px;\n}\n.firebaseui-flag-KG {\n  background-position: 0 -1694px;\n}\n.firebaseui-flag-KH {\n  background-position: 0 -1708px;\n}\n.firebaseui-flag-KI {\n  background-position: 0 -1722px;\n}\n.firebaseui-flag-KM {\n  background-position: 0 -1736px;\n}\n.firebaseui-flag-KN {\n  background-position: 0 -1750px;\n}\n.firebaseui-flag-KP {\n  background-position: 0 -1764px;\n}\n.firebaseui-flag-KR {\n  background-position: 0 -1778px;\n}\n.firebaseui-flag-KW {\n  background-position: 0 -1792px;\n}\n.firebaseui-flag-AD {\n  background-position: 0 -1806px;\n}\n.firebaseui-flag-KZ {\n  background-position: 0 -1820px;\n}\n.firebaseui-flag-LA {\n  background-position: 0 -1834px;\n}\n.firebaseui-flag-LB {\n  background-position: 0 -1848px;\n}\n.firebaseui-flag-LC {\n  background-position: 0 -1862px;\n}\n.firebaseui-flag-LI {\n  background-position: 0 -1876px;\n}\n.firebaseui-flag-LK {\n  background-position: 0 -1890px;\n}\n.firebaseui-flag-LR {\n  background-position: 0 -1904px;\n}\n.firebaseui-flag-LS {\n  background-position: 0 -1918px;\n}\n.firebaseui-flag-LT {\n  background-position: 0 -1932px;\n}\n.firebaseui-flag-LU {\n  background-position: 0 -1946px;\n}\n.firebaseui-flag-LV {\n  background-position: 0 -1960px;\n}\n.firebaseui-flag-LY {\n  background-position: 0 -1974px;\n}\n.firebaseui-flag-MA {\n  background-position: 0 -1988px;\n}\n.firebaseui-flag-MC {\n  background-position: 0 -2002px;\n}\n.firebaseui-flag-MD {\n  background-position: 0 -2016px;\n}\n.firebaseui-flag-ME {\n  background-position: 0 -2030px;\n}\n.firebaseui-flag-MF {\n  background-position: 0 -2044px;\n}\n.firebaseui-flag-MG {\n  background-position: 0 -2058px;\n}\n.firebaseui-flag-MH {\n  background-position: 0 -2072px;\n}\n.firebaseui-flag-MK {\n  background-position: 0 -2086px;\n}\n.firebaseui-flag-ML {\n  background-position: 0 -2100px;\n}\n.firebaseui-flag-MM {\n  background-position: 0 -2114px;\n}\n.firebaseui-flag-MN {\n  background-position: 0 -2128px;\n}\n.firebaseui-flag-MO {\n  background-position: 0 -2142px;\n}\n.firebaseui-flag-MP {\n  background-position: 0 -2156px;\n}\n.firebaseui-flag-MQ {\n  background-position: 0 -2170px;\n}\n.firebaseui-flag-MR {\n  background-position: 0 -2184px;\n}\n.firebaseui-flag-MS {\n  background-position: 0 -2198px;\n}\n.firebaseui-flag-MT {\n  background-position: 0 -2212px;\n}\n.firebaseui-flag-MU {\n  background-position: 0 -2226px;\n}\n.firebaseui-flag-MV {\n  background-position: 0 -2240px;\n}\n.firebaseui-flag-MW {\n  background-position: 0 -2254px;\n}\n.firebaseui-flag-MX {\n  background-position: 0 -2268px;\n}\n.firebaseui-flag-MY {\n  background-position: 0 -2282px;\n}\n.firebaseui-flag-MZ {\n  background-position: 0 -2296px;\n}\n.firebaseui-flag-NA {\n  background-position: 0 -2310px;\n}\n.firebaseui-flag-NC {\n  background-position: 0 -2324px;\n}\n.firebaseui-flag-NE {\n  background-position: 0 -2338px;\n}\n.firebaseui-flag-NF {\n  background-position: 0 -2352px;\n}\n.firebaseui-flag-NG {\n  background-position: 0 -2366px;\n}\n.firebaseui-flag-NI {\n  background-position: 0 -2380px;\n}\n.firebaseui-flag-NL {\n  background-position: 0 -2394px;\n}\n.firebaseui-flag-NO {\n  background-position: 0 -2408px;\n}\n.firebaseui-flag-NP {\n  background-position: 0 -2422px;\n}\n.firebaseui-flag-NR {\n  background-position: 0 -2436px;\n}\n.firebaseui-flag-NU {\n  background-position: 0 -2450px;\n}\n.firebaseui-flag-NZ {\n  background-position: 0 -2464px;\n}\n.firebaseui-flag-OM {\n  background-position: 0 -2478px;\n}\n.firebaseui-flag-PA {\n  background-position: 0 -2492px;\n}\n.firebaseui-flag-PE {\n  background-position: 0 -2506px;\n}\n.firebaseui-flag-PF {\n  background-position: 0 -2520px;\n}\n.firebaseui-flag-PG {\n  background-position: 0 -2534px;\n}\n.firebaseui-flag-PH {\n  background-position: 0 -2548px;\n}\n.firebaseui-flag-PK {\n  background-position: 0 -2562px;\n}\n.firebaseui-flag-PL {\n  background-position: 0 -2576px;\n}\n.firebaseui-flag-PM {\n  background-position: 0 -2590px;\n}\n.firebaseui-flag-PN {\n  background-position: 0 -2604px;\n}\n.firebaseui-flag-PR {\n  background-position: 0 -2618px;\n}\n.firebaseui-flag-PS {\n  background-position: 0 -2632px;\n}\n.firebaseui-flag-PT {\n  background-position: 0 -2646px;\n}\n.firebaseui-flag-PW {\n  background-position: 0 -2660px;\n}\n.firebaseui-flag-PY {\n  background-position: 0 -2674px;\n}\n.firebaseui-flag-QA {\n  background-position: 0 -2688px;\n}\n.firebaseui-flag-RE {\n  background-position: 0 -2702px;\n}\n.firebaseui-flag-RO {\n  background-position: 0 -2716px;\n}\n.firebaseui-flag-RS {\n  background-position: 0 -2730px;\n}\n.firebaseui-flag-RU {\n  background-position: 0 -2744px;\n}\n.firebaseui-flag-RW {\n  background-position: 0 -2758px;\n}\n.firebaseui-flag-SA {\n  background-position: 0 -2772px;\n}\n.firebaseui-flag-SB {\n  background-position: 0 -2786px;\n}\n.firebaseui-flag-SC {\n  background-position: 0 -2800px;\n}\n.firebaseui-flag-SD {\n  background-position: 0 -2814px;\n}\n.firebaseui-flag-SE {\n  background-position: 0 -2828px;\n}\n.firebaseui-flag-SG {\n  background-position: 0 -2842px;\n}\n.firebaseui-flag-SH {\n  background-position: 0 -2856px;\n}\n.firebaseui-flag-SI {\n  background-position: 0 -2870px;\n}\n.firebaseui-flag-SJ {\n  background-position: 0 -2884px;\n}\n.firebaseui-flag-SK {\n  background-position: 0 -2898px;\n}\n.firebaseui-flag-SL {\n  background-position: 0 -2912px;\n}\n.firebaseui-flag-SM {\n  background-position: 0 -2926px;\n}\n.firebaseui-flag-SN {\n  background-position: 0 -2940px;\n}\n.firebaseui-flag-SO {\n  background-position: 0 -2954px;\n}\n.firebaseui-flag-SR {\n  background-position: 0 -2968px;\n}\n.firebaseui-flag-SS {\n  background-position: 0 -2982px;\n}\n.firebaseui-flag-ST {\n  background-position: 0 -2996px;\n}\n.firebaseui-flag-SV {\n  background-position: 0 -3010px;\n}\n.firebaseui-flag-SX {\n  background-position: 0 -3024px;\n}\n.firebaseui-flag-SY {\n  background-position: 0 -3038px;\n}\n.firebaseui-flag-SZ {\n  background-position: 0 -3052px;\n}\n.firebaseui-flag-TA {\n  background-position: 0 -3066px;\n}\n.firebaseui-flag-TC {\n  background-position: 0 -3080px;\n}\n.firebaseui-flag-TD {\n  background-position: 0 -3094px;\n}\n.firebaseui-flag-TF {\n  background-position: 0 -3108px;\n}\n.firebaseui-flag-TG {\n  background-position: 0 -3122px;\n}\n.firebaseui-flag-TH {\n  background-position: 0 -3136px;\n}\n.firebaseui-flag-TJ {\n  background-position: 0 -3150px;\n}\n.firebaseui-flag-TK {\n  background-position: 0 -3164px;\n}\n.firebaseui-flag-TL {\n  background-position: 0 -3178px;\n}\n.firebaseui-flag-TM {\n  background-position: 0 -3192px;\n}\n.firebaseui-flag-TN {\n  background-position: 0 -3206px;\n}\n.firebaseui-flag-TO {\n  background-position: 0 -3220px;\n}\n.firebaseui-flag-TR {\n  background-position: 0 -3234px;\n}\n.firebaseui-flag-TT {\n  background-position: 0 -3248px;\n}\n.firebaseui-flag-TV {\n  background-position: 0 -3262px;\n}\n.firebaseui-flag-TW {\n  background-position: 0 -3276px;\n}\n.firebaseui-flag-TZ {\n  background-position: 0 -3290px;\n}\n.firebaseui-flag-UA {\n  background-position: 0 -3304px;\n}\n.firebaseui-flag-UG {\n  background-position: 0 -3318px;\n}\n.firebaseui-flag-UM {\n  background-position: 0 -3332px;\n}\n.firebaseui-flag-UN {\n  background-position: 0 -3346px;\n}\n.firebaseui-flag-US {\n  background-position: 0 -3360px;\n}\n.firebaseui-flag-UY {\n  background-position: 0 -3374px;\n}\n.firebaseui-flag-UZ {\n  background-position: 0 -3388px;\n}\n.firebaseui-flag-VA {\n  background-position: 0 -3402px;\n}\n.firebaseui-flag-VC {\n  background-position: 0 -3416px;\n}\n.firebaseui-flag-VE {\n  background-position: 0 -3430px;\n}\n.firebaseui-flag-VG {\n  background-position: 0 -3444px;\n}\n.firebaseui-flag-VI {\n  background-position: 0 -3458px;\n}\n.firebaseui-flag-VN {\n  background-position: 0 -3472px;\n}\n.firebaseui-flag-VU {\n  background-position: 0 -3486px;\n}\n.firebaseui-flag-WF {\n  background-position: 0 -3500px;\n}\n.firebaseui-flag-WS {\n  background-position: 0 -3514px;\n}\n.firebaseui-flag-XK {\n  background-position: 0 -3528px;\n}\n.firebaseui-flag-YE {\n  background-position: 0 -3542px;\n}\n.firebaseui-flag-YT {\n  background-position: 0 -3556px;\n}\n.firebaseui-flag-ZA {\n  background-position: 0 -3570px;\n}\n.firebaseui-flag-ZM {\n  background-position: 0 -3584px;\n}\n.firebaseui-flag-ZW {\n  background-position: 0 -3598px;\n}\n", ""]);

// exports


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section bg-primary is-radiusless" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "columns is-mobile" }, [
        _c(
          "div",
          {
            staticClass:
              "column is-4-desktop is-offset-4-desktop is-6-tablet is-offset-3-tablet is-10-mobile is-offset-1-mobile"
          },
          [
            _c(
              "div",
              {},
              [
                _vm._m(0),
                _vm._v(" "),
                _vm.$store.state.formError
                  ? _c("div", { staticClass: "notification is-danger mb-6" }, [
                      _c("div", { staticClass: "media" }, [
                        _c(
                          "div",
                          { staticClass: "media-left" },
                          [_c("b-icon", { attrs: { icon: "alert" } })],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "media-content" }, [
                          _c("p", {
                            domProps: {
                              textContent: _vm._s(_vm.$store.state.formError)
                            }
                          })
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { attrs: { id: "firebaseui-auth-container" } }),
                _vm._v(" "),
                _vm._l(_vm.links, function(link, index) {
                  return _c(
                    "router-link",
                    {
                      key: index,
                      staticClass: "button is-fullwidth mt-2",
                      class: link.classes,
                      attrs: { to: link.to }
                    },
                    [
                      _c("span", {
                        domProps: { textContent: _vm._s(link.label) }
                      })
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.userId
                  ? _c(
                      "button",
                      {
                        staticClass: "button is-danger is-fullwidth mt-2",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.logout($event)
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("logout_link_label")))
                        ])
                      ]
                    )
                  : _vm._e()
              ],
              2
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "has-text-centered mb-4" }, [
      _c("img", {
        attrs: { src: "/static/img/login_img.png", alt: "Tooddoc Logo" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b97b26f", esExports)
  }
}

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(337);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_048072c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(615);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_048072c1_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-048072c1", Component.options)
  } else {
    hotAPI.reload("data-v-048072c1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppNav_vue__ = __webpack_require__(338);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58928d52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppNav_vue__ = __webpack_require__(613);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58928d52_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/AppNav.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-58928d52", Component.options)
  } else {
    hotAPI.reload("data-v-58928d52", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "navbar has-shadow",
      attrs: { role: "navigation", "aria-label": "main navigation" }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "navbar-brand" },
          [
            _c(
              "router-link",
              {
                staticClass: "navbar-item has-text-weight-bold has-icon",
                attrs: { to: "/doctor/login" }
              },
              [
                _c("span", [_vm._v("Tooddoc")]),
                _vm._v(" "),
                _vm.FIREBASE_PROJECT_ID == "tooddoc-dev"
                  ? _c(
                      "span",
                      {
                        staticClass: "tag is-primary ml-1",
                        staticStyle: { "font-size": "0.5rem" }
                      },
                      [_vm._v("DEV")]
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "navbar-item is-hidden-desktop v-flex" }, [
              _c(
                "p",
                { staticClass: "control is-fullwidth has-text-right" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "is-hidden-mobile button is-primary is-outlined mr-2",
                      attrs: { to: { name: "doctor.profile" } }
                    },
                    [
                      _vm.doctor
                        ? _c("avatar", {
                            staticClass: "mr-2",
                            attrs: {
                              avatar: _vm.doctor.avatar,
                              name:
                                _vm.doctor.firstName + " " + _vm.doctor.lastName
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("my_profile_link_label")))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-danger",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.logout($event)
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("logout_link_label")))])]
                  )
                ],
                1
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "navbar-menu" }, [
          _c(
            "div",
            { staticClass: "navbar-start" },
            [
              _c(
                "router-link",
                {
                  staticClass: "navbar-item",
                  attrs: { to: { name: "doctor.dashboard" } }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("dashboard_link_label")) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "navbar-item",
                  attrs: { to: { name: "doctor.availabilities" } }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("my_availabilities_link_label")) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "navbar-item",
                  attrs: { to: { name: "doctor.emergencies" } }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("find_emergencies_link_label")) +
                      "\n                "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "navbar-end" }, [
            _c("div", { staticClass: "navbar-item" }, [
              _c(
                "p",
                { staticClass: "control" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "button is-primary is-outlined mr-2",
                      attrs: { to: { name: "doctor.profile" } }
                    },
                    [
                      _vm.doctor
                        ? _c("avatar", {
                            staticClass: "mr-2",
                            attrs: {
                              avatar: _vm.doctor.avatar,
                              name:
                                _vm.doctor.firstName + " " + _vm.doctor.lastName
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("my_profile_link_label")))
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-danger",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.logout($event)
                        }
                      }
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.$t("logout_link_label")))])]
                  )
                ],
                1
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58928d52", esExports)
  }
}

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    { attrs: { active: _vm.active }, on: { close: _vm.close } },
    [
      _c("div", { staticClass: "modal-card" }, [
        _c("header", { staticClass: "modal-card-head" }, [
          _c("p", { staticClass: "modal-card-title" }, [
            _vm._v(_vm._s(_vm.$t("emergency_modal_title")))
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "modal-card-body" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("div", { staticClass: "columns is-multiline" }, [
                _c("div", { staticClass: "column is-12" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("office_name_label")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(_vm._s(_vm.availability.officeName))
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column is-6" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("date_label")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm._f("momentFormat")(
                              _vm.availability.date,
                              "YYYY-MM-DD",
                              _vm.$t("date_selector_format")
                            )
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column is-6" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("time_label")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_vm.availability.start) +
                            " - " +
                            _vm._s(_vm.availability.end)
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("h5", { staticClass: "title is-5" }, [
                _vm._v(_vm._s(_vm.$t("patient_symptoms_title")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "columns is-multiline" },
                _vm._l(_vm.emergency.symptoms, function(symptom) {
                  return _c("div", { staticClass: "column is-6" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", {
                        domProps: { textContent: _vm._s(symptom.question) }
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "is-size-7" }, [
                        _c("strong", {
                          domProps: { textContent: _vm._s(symptom.answer) }
                        })
                      ])
                    ])
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("h5", { staticClass: "title is-5" }, [
                _vm._v(_vm._s(_vm.$t("patient_information_title")))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "columns is-multiline" }, [
                _c("div", { staticClass: "column is-4" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("patient_first_name_label")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.emergency.patientFirstName
                              ? _vm.hashPatientInfo(
                                  _vm.emergency.patientFirstName
                                )
                              : "N/A"
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column is-4" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("patient_last_name_label")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.emergency.patientLastName
                              ? _vm.hashPatientInfo(
                                  _vm.emergency.patientLastName
                                )
                              : "N/A"
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column is-4" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [_vm._v(_vm._s(_vm.$t("patient_age_label")))]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.emergency.patientAge
                              ? _vm.emergency.patientAge
                              : "N/A"
                          )
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "columns is-multiline" }, [
                _c("div", { staticClass: "column is-4" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("patient_email_label")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.emergency.patientEmail
                              ? _vm.hashPatientInfo(_vm.emergency.patientEmail)
                              : "N/A"
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column is-4" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("patient_phone_label")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.emergency.patientPhone
                              ? _vm.hashPatientInfo(_vm.emergency.patientPhone)
                              : "N/A"
                          )
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "columns is-multiline" }, [
                _c("div", { staticClass: "column is-4" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("patient_locality_label")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.emergency.locality
                              ? _vm.emergency.locality
                              : "N/A"
                          )
                        )
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column is-4" }, [
                  _c("div", { staticClass: "field" }, [
                    _c("label", [
                      _vm._v(_vm._s(_vm.$t("patient_zip_code_label")))
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "is-size-7" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.emergency.zipCode
                              ? _vm.emergency.zipCode
                              : "N/A"
                          )
                        )
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("h5", { staticClass: "title is-5 mb-0" }, [
                _vm._v(_vm._s(_vm.$t("pictures_title")))
              ]),
              _vm._v(" "),
              _vm.emergency.pictures.length == 0
                ? _c("div", { staticClass: "message is-warning my-3" }, [
                    _c("div", { staticClass: "message-body" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.$t("no_pictures_placeholder")) +
                          "\n                    "
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.emergency.pictures, function(picture) {
                return _c(
                  "figure",
                  {
                    staticClass: "image thumbnail is-128x128 is-inline-block",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.showPicture(picture)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: picture, alt: _vm.$t("picture_alt") }
                    })
                  ]
                )
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("footer", { staticClass: "modal-card-foot" }, [
          _c(
            "button",
            {
              staticClass: "button",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.close($event)
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("close_button_label")))]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f3670ea8", esExports)
  }
}

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loaded
      ? _c(
          "div",
          [
            _c("app-nav"),
            _vm._v(" "),
            _vm.doctor && !_vm.doctor.isCertified
              ? _c(
                  "div",
                  {
                    staticClass: "is-hidden-mobile hero is-blue-dark py-3",
                    attrs: { id: "certification-banner" }
                  },
                  [
                    _c("div", { staticClass: "container" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "has-text-centered has-text-weight-semibold is-size-6"
                        },
                        [
                          _c(
                            "p",
                            { staticClass: "has-icon" },
                            [
                              _c("b-icon", { attrs: { icon: "alert" } }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t("doctor_not_certified_warning")
                                  ) +
                                  "\n                    "
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "main",
              {
                staticClass: "is-hidden-mobile mb-7",
                staticStyle: { position: "relative" }
              },
              [
                _c("router-view"),
                _vm._v(" "),
                _vm.notifications.length
                  ? _c(
                      "div",
                      { staticClass: "notifications-wrapper" },
                      _vm._l(_vm.notifications, function(notification) {
                        return _c(
                          "div",
                          {
                            key: notification.id,
                            staticClass: "notification clickable",
                            class: notification.type,
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.showEmergency(
                                  notification.appointment
                                )
                              }
                            }
                          },
                          [
                            _c("button", {
                              staticClass: "delete",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.disableNotification(notification)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "media" }, [
                              _c("div", {
                                staticClass: "media-content",
                                domProps: {
                                  innerHTML: _vm._s(notification.content)
                                }
                              })
                            ])
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                Object.keys(_vm.currentEmergency).length > 0
                  ? _c("emergency-modal", {
                      attrs: {
                        active: _vm.showEmergencyModal,
                        emergency: _vm.currentEmergency,
                        availability: _vm.currentAvailability
                      },
                      on: {
                        close: function($event) {
                          return _vm.closeEmergencyModal()
                        }
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("main", { staticClass: "is-hidden-tablet" }, [
              _c(
                "div",
                {
                  staticClass:
                    "has-text-centered has-text-weight-semibold is-size-6 mt-8 mx-4"
                },
                [
                  _c("p", [_vm._v(_vm._s(_vm.$t("app_message_on_mobile")))]),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "mt-8",
                    staticStyle: { width: "90px" },
                    attrs: {
                      src: "/static/img/tood.png",
                      alt: "Tooddoc Mascot"
                    }
                  })
                ]
              )
            ])
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-048072c1", esExports)
  }
}

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__ = __webpack_require__(340);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d6b239a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__ = __webpack_require__(619);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(617)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d6b239a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Register_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d6b239a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Register_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/Register.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2d6b239a", Component.options)
  } else {
    hotAPI.reload("data-v-2d6b239a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(618);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(20)("74d02072", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2d6b239a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Register.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2d6b239a\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Register.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(19)(false);
// imports


// module
exports.push([module.i, "\n.modal-card#avatars-modal-card[data-v-2d6b239a] {\n  margin: 0 auto;\n}\n", ""]);

// exports


/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section" },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "columns is-desktop" }, [
          _c("div", { staticClass: "column is-8 is-offset-2" }, [
            _c("h1", { staticClass: "title level" }, [
              _c("span", { staticClass: "flex" }, [
                _vm._v(_vm._s(_vm.$t("doctorRegister_title")))
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button is-secondary",
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.logout($event)
                    }
                  }
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("logout_link_label")))])]
              )
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("div", { staticClass: "box" }, [
              _c(
                "form",
                {
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        $event.keyCode !== 13
                      ) {
                        return null
                      }
                      return _vm.submit($event)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column is-3" }, [
                      _c("h4", {
                        staticClass: "subtitle",
                        domProps: {
                          textContent: _vm._s(_vm.$t("doctor_legend"))
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "column is-7" }, [
                      _c("div", { staticClass: "field has-text-centered" }, [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.toggleAvatarSelector(true)
                              }
                            }
                          },
                          [
                            _c("avatar", {
                              staticClass: "is-inline image is-96x96",
                              attrs: { avatar: _vm.newDoctor.avatar, name: "" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "is-size-7 has-text-grey is-block" },
                          [_vm._v(_vm._s(_vm.$t("click_to_change_avatar")))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "columns" }, [
                        _c("div", { staticClass: "column" }, [
                          _c("div", { staticClass: "field" }, [
                            _c("label", {
                              staticClass: "label",
                              domProps: {
                                textContent: _vm._s(_vm.$t("first_name_label"))
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "control has-icon has-icons-right"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newDoctor.firstName,
                                      expression: "newDoctor.firstName"
                                    }
                                  ],
                                  class: {
                                    input: true,
                                    "is-danger": _vm.errors.has(
                                      "doctor.firstName"
                                    )
                                  },
                                  attrs: {
                                    name: "doctor.firstName",
                                    type: "text"
                                  },
                                  domProps: { value: _vm.newDoctor.firstName },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.newDoctor,
                                        "firstName",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "doctor.firstName"
                                        ),
                                        expression:
                                          "errors.has('doctor.firstName')"
                                      }
                                    ],
                                    staticClass:
                                      "icon is-right is-danger has-text-danger"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-alert-circle mdi-24px"
                                    })
                                  ]
                                )
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "column" }, [
                          _c("div", { staticClass: "field" }, [
                            _c("label", {
                              staticClass: "label",
                              domProps: {
                                textContent: _vm._s(_vm.$t("last_name_label"))
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "control has-icon has-icons-right"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newDoctor.lastName,
                                      expression: "newDoctor.lastName"
                                    }
                                  ],
                                  class: {
                                    input: true,
                                    "is-danger": _vm.errors.has(
                                      "doctor.lastName"
                                    )
                                  },
                                  attrs: {
                                    name: "doctor.lastName",
                                    type: "text"
                                  },
                                  domProps: { value: _vm.newDoctor.lastName },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.newDoctor,
                                        "lastName",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "doctor.lastName"
                                        ),
                                        expression:
                                          "errors.has('doctor.lastName')"
                                      }
                                    ],
                                    staticClass:
                                      "icon is-right is-danger has-text-danger"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-alert-circle mdi-24px"
                                    })
                                  ]
                                )
                              ]
                            )
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("label", {
                          staticClass: "label",
                          domProps: {
                            textContent: _vm._s(_vm.$t("contact_email_label"))
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "control has-icon has-icons-right" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|email",
                                  expression: "'required|email'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newDoctor.contactEmail,
                                  expression: "newDoctor.contactEmail"
                                }
                              ],
                              class: {
                                input: true,
                                "is-danger": _vm.errors.has("contactEmail")
                              },
                              attrs: { name: "contactEmail", type: "email" },
                              domProps: { value: _vm.newDoctor.contactEmail },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.newDoctor,
                                    "contactEmail",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("contactEmail"),
                                    expression: "errors.has('contactEmail')"
                                  }
                                ],
                                staticClass:
                                  "icon is-right is-danger has-text-danger"
                              },
                              [
                                _c("i", {
                                  staticClass: "mdi mdi-alert-circle mdi-24px"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("contactEmail"),
                                    expression: "errors.has('contactEmail')"
                                  }
                                ],
                                staticClass: "help is-danger"
                              },
                              [_vm._v(_vm._s(_vm.$t("email_error")))]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("label", {
                          staticClass: "label",
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t("medical_practice_label")
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "control has-icon has-icons-right" },
                          [
                            _c("div", { staticClass: "select is-fullwidth" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newDoctor.type,
                                      expression: "newDoctor.type"
                                    }
                                  ],
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.newDoctor,
                                        "type",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.medicalPractices, function(type) {
                                  return _c(
                                    "option",
                                    { domProps: { value: type } },
                                    [_vm._v(_vm._s(_vm.$t("type_" + type)))]
                                  )
                                }),
                                0
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("label", {
                          staticClass: "label",
                          domProps: {
                            textContent: _vm._s(_vm.$t("inami_label"))
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "control has-icon has-icons-right" },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|numeric|min:11|max:11",
                                  expression: "'required|numeric|min:11|max:11'"
                                },
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.newDoctor.inami,
                                  expression: "newDoctor.inami"
                                }
                              ],
                              class: {
                                input: true,
                                "is-danger": _vm.errors.has("doctor.inami")
                              },
                              attrs: { name: "doctor.inami", type: "inami" },
                              domProps: { value: _vm.newDoctor.inami },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.newDoctor,
                                    "inami",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("doctor.inami"),
                                    expression: "errors.has('doctor.inami')"
                                  }
                                ],
                                staticClass:
                                  "icon is-right is-danger has-text-danger"
                              },
                              [
                                _c("i", {
                                  staticClass: "mdi mdi-alert-circle mdi-24px"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("doctor.inami"),
                                    expression: "errors.has('doctor.inami')"
                                  }
                                ],
                                staticClass: "help is-danger"
                              },
                              [_vm._v(_vm._s(_vm.$t("inami_error")))]
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("label", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newDoctor.isRegulated,
                                expression: "newDoctor.isRegulated"
                              }
                            ],
                            attrs: { type: "checkbox" },
                            domProps: {
                              checked: Array.isArray(_vm.newDoctor.isRegulated)
                                ? _vm._i(_vm.newDoctor.isRegulated, null) > -1
                                : _vm.newDoctor.isRegulated
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.newDoctor.isRegulated,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.newDoctor,
                                        "isRegulated",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.newDoctor,
                                        "isRegulated",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.newDoctor, "isRegulated", $$c)
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("is_regulated_label"))
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "field",
                          class:
                            Object.keys(_vm.countries).length == 1
                              ? "is-hidden"
                              : ""
                        },
                        [
                          _c("label", {
                            staticClass: "label",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("DoctorProfile.country_label")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "control has-icon has-icons-right" },
                            [
                              _c("div", { staticClass: "select" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.newDoctor.countryId,
                                        expression: "newDoctor.countryId"
                                      }
                                    ],
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          _vm.newDoctor,
                                          "countryId",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  _vm._l(_vm.countries, function(country) {
                                    return _c("option", {
                                      domProps: {
                                        value: country.id,
                                        textContent: _vm._s(
                                          _vm.$t("Countries_" + _vm.countr.code)
                                        )
                                      }
                                    })
                                  }),
                                  0
                                )
                              ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "field" }, [
                        _c("label", {
                          staticClass: "label",
                          domProps: {
                            textContent: _vm._s(_vm.$t("language_label"))
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "control has-icon has-icons-right" },
                          [
                            _c("div", { staticClass: "select" }, [
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.newDoctor.language,
                                      expression: "newDoctor.language"
                                    }
                                  ],
                                  attrs: { name: "doctor.language" },
                                  on: {
                                    change: function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.newDoctor,
                                        "language",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    }
                                  }
                                },
                                _vm._l(_vm.languages, function(language, id) {
                                  return _c(
                                    "option",
                                    { domProps: { value: language.code } },
                                    [_vm._v(_vm._s(language.name))]
                                  )
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("doctor.language"),
                                    expression: "errors.has('doctor.language')"
                                  }
                                ],
                                staticClass:
                                  "icon is-right is-danger has-text-danger"
                              },
                              [
                                _c("i", {
                                  staticClass: "mdi mdi-alert-circle mdi-24px"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("doctor.language"),
                                    expression: "errors.has('doctor.language')"
                                  }
                                ],
                                staticClass: "help is-danger"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.errors.first("doctor.language"))
                                )
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.newOffices, function(office, key) {
                    return _c("div", { key: key }, [
                      _c("hr"),
                      _vm._v(" "),
                      _c("div", { staticClass: "columns" }, [
                        _c("div", { staticClass: "column is-3" }, [
                          _c("h4", {
                            staticClass: "subtitle",
                            domProps: {
                              textContent: _vm._s(_vm.$t("office_legend"))
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "column is-7" }, [
                          _c("div", { staticClass: "field" }, [
                            _c("label", {
                              staticClass: "label",
                              domProps: {
                                textContent: _vm._s(_vm.$t("name_label"))
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "control has-icon has-icons-right"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required",
                                      expression: "'required'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: office.name,
                                      expression: "office.name"
                                    }
                                  ],
                                  class: {
                                    input: true,
                                    "is-danger": _vm.errors.has(
                                      "offices." + key + ".name"
                                    )
                                  },
                                  attrs: {
                                    name: "offices." + key + ".name",
                                    type: "name"
                                  },
                                  domProps: { value: office.name },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        office,
                                        "name",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "offices." + key + ".name"
                                        ),
                                        expression:
                                          "errors.has('offices.' + key + '.name')"
                                      }
                                    ],
                                    staticClass:
                                      "icon is-right is-danger has-text-danger"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-alert-circle mdi-24px"
                                    })
                                  ]
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "columns" }, [
                            _c("div", { staticClass: "column is-8" }, [
                              _c("div", { staticClass: "field" }, [
                                _c("label", {
                                  staticClass: "label",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("street_name_label")
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "control has-icon has-icons-right"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        },
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: office.streetName,
                                          expression: "office.streetName"
                                        }
                                      ],
                                      class: {
                                        input: true,
                                        "is-danger": _vm.errors.has(
                                          "offices." + key + ".streetName"
                                        )
                                      },
                                      attrs: {
                                        name: "offices." + key + ".streetName",
                                        type: "streetName"
                                      },
                                      domProps: { value: office.streetName },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            office,
                                            "streetName",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "offices." + key + ".streetName"
                                            ),
                                            expression:
                                              "errors.has('offices.' + key + '.streetName')"
                                          }
                                        ],
                                        staticClass:
                                          "icon is-right is-danger has-text-danger"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-alert-circle mdi-24px"
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column is-4" }, [
                              _c("div", { staticClass: "field" }, [
                                _c("label", {
                                  staticClass: "label",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("street_number_label")
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "control has-icon has-icons-right"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        },
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: office.streetNumber,
                                          expression: "office.streetNumber"
                                        }
                                      ],
                                      class: {
                                        input: true,
                                        "is-danger": _vm.errors.has(
                                          "offices." + key + ".streetNumber"
                                        )
                                      },
                                      attrs: {
                                        name:
                                          "offices." + key + ".streetNumber",
                                        type: "streetNumber"
                                      },
                                      domProps: { value: office.streetNumber },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            office,
                                            "streetNumber",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "offices." + key + ".streetNumber"
                                            ),
                                            expression:
                                              "errors.has('offices.' + key + '.streetNumber')"
                                          }
                                        ],
                                        staticClass:
                                          "icon is-right is-danger has-text-danger"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-alert-circle mdi-24px"
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "columns" }, [
                            _c("div", { staticClass: "column is-4" }, [
                              _c("div", { staticClass: "field" }, [
                                _c("label", {
                                  staticClass: "label",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("zip_code_label")
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "control has-icon has-icons-right"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        },
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: office.zipCode,
                                          expression: "office.zipCode"
                                        }
                                      ],
                                      class: {
                                        input: true,
                                        "is-danger": _vm.errors.has(
                                          "offices." + key + ".zipCode"
                                        )
                                      },
                                      attrs: {
                                        name: "offices." + key + ".zipCode",
                                        type: "zipCode"
                                      },
                                      domProps: { value: office.zipCode },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            office,
                                            "zipCode",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "offices." + key + ".zipCode"
                                            ),
                                            expression:
                                              "errors.has('offices.' + key + '.zipCode')"
                                          }
                                        ],
                                        staticClass:
                                          "icon is-right is-danger has-text-danger"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-alert-circle mdi-24px"
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "column is-8" }, [
                              _c("div", { staticClass: "field" }, [
                                _c("label", {
                                  staticClass: "label",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t("locality_label")
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "control has-icon has-icons-right"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "validate",
                                          rawName: "v-validate",
                                          value: "required",
                                          expression: "'required'"
                                        },
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: office.locality,
                                          expression: "office.locality"
                                        }
                                      ],
                                      class: {
                                        input: true,
                                        "is-danger": _vm.errors.has(
                                          "offices." + key + ".locality"
                                        )
                                      },
                                      attrs: {
                                        name: "offices." + key + ".locality",
                                        type: "locality"
                                      },
                                      domProps: { value: office.locality },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            office,
                                            "locality",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "offices." + key + ".locality"
                                            ),
                                            expression:
                                              "errors.has('offices.' + key + '.locality')"
                                          }
                                        ],
                                        staticClass:
                                          "icon is-right is-danger has-text-danger"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-alert-circle mdi-24px"
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "field" }, [
                            _c("label", {
                              staticClass: "label",
                              domProps: {
                                textContent: _vm._s(_vm.$t("country_label"))
                              }
                            }),
                            _vm._v(" "),
                            _c("p", { staticClass: "control" }),
                            _c(
                              "div",
                              {
                                class: {
                                  "select is-fullwidth": true,
                                  "is-danger": _vm.errors.has(
                                    "offices." + key + ".countryId"
                                  )
                                }
                              },
                              [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: office.countryId,
                                        expression: "office.countryId"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "is-block",
                                    attrs: {
                                      name: "offices." + key + ".countryId",
                                      disabled:
                                        Object.keys(_vm.countries).length == 1
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$selectedVal = Array.prototype.filter
                                          .call($event.target.options, function(
                                            o
                                          ) {
                                            return o.selected
                                          })
                                          .map(function(o) {
                                            var val =
                                              "_value" in o ? o._value : o.value
                                            return val
                                          })
                                        _vm.$set(
                                          office,
                                          "countryId",
                                          $event.target.multiple
                                            ? $$selectedVal
                                            : $$selectedVal[0]
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "option",
                                      { domProps: { value: null } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("select_country_label"))
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._l(_vm.countries, function(
                                      country,
                                      id
                                    ) {
                                      return _c("option", {
                                        domProps: {
                                          value: id,
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "Countries_" + _vm.countr.code
                                            )
                                          )
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("p"),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "offices." + key + ".countryId"
                                    ),
                                    expression:
                                      "errors.has('offices.' + key + '.countryId')"
                                  }
                                ],
                                staticClass: "help is-danger"
                              },
                              [_vm._v(_vm._s(_vm.$t("select_country_label")))]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "field" }, [
                            _c("label", {
                              staticClass: "label",
                              domProps: {
                                textContent: _vm._s(_vm.$t("phone_label"))
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "control has-icon has-icons-right"
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: {
                                        required: true,
                                        regex: _vm.getPhoneRegex(key)
                                      },
                                      expression:
                                        "{\n                                                    required: true,\n                                                    regex: getPhoneRegex(key)\n                                                }"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: office.phone,
                                      expression: "office.phone"
                                    }
                                  ],
                                  class: {
                                    input: true,
                                    "is-danger": _vm.errors.has(
                                      "offices." + key + ".phone"
                                    )
                                  },
                                  attrs: {
                                    name: "offices." + key + ".phone",
                                    placeholder:
                                      _vm.getCurrentCountryPhonePrefix(office) +
                                      "...",
                                    type: "phone"
                                  },
                                  domProps: { value: office.phone },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        office,
                                        "phone",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has(
                                          "offices." + key + ".phone"
                                        ),
                                        expression:
                                          "errors.has('offices.' + key + '.phone')"
                                      }
                                    ],
                                    staticClass:
                                      "icon is-right is-danger has-text-danger"
                                  },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-alert-circle mdi-24px"
                                    })
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has(
                                      "offices." + key + ".phone"
                                    ),
                                    expression:
                                      "errors.has('offices.' + key + '.phone')"
                                  }
                                ],
                                staticClass: "help is-danger"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("DoctorOffice.phone_error", {
                                      prefix: _vm.getCountryPhonePrefix(key)
                                    })
                                  )
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          key != 0
                            ? _c(
                                "button",
                                {
                                  staticClass: "button",
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.removeOffice(key)
                                    }
                                  }
                                },
                                [
                                  _c("b-icon", {
                                    attrs: { icon: "close-circle" }
                                  }),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t("remove_office_button_label")
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column is-7 is-offset-3" }, [
                      _c("div", [
                        _c("label", { staticClass: "checkbox" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.acceptTerms,
                                expression: "acceptTerms"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: { type: "checkbox", name: "acceptTerms" },
                            domProps: {
                              checked: Array.isArray(_vm.acceptTerms)
                                ? _vm._i(_vm.acceptTerms, null) > -1
                                : _vm.acceptTerms
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.acceptTerms,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.acceptTerms = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.acceptTerms = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.acceptTerms = $$c
                                }
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("accept_terms_label"))
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("acceptTerms"),
                                expression: "errors.has('acceptTerms')"
                              }
                            ],
                            staticClass: "help is-danger"
                          },
                          [_vm._v(_vm._s(_vm.$t("accept_terms_error")))]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.errors.any()
                    ? _c(
                        "div",
                        { staticClass: "notification is-danger mb-4" },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$t("fields_are_missing")) +
                              "\n                        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.error
                    ? _c(
                        "div",
                        { staticClass: "notification is-danger mb-4" },
                        [
                          _c("button", {
                            staticClass: "delete",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.deleteError($event)
                              }
                            }
                          }),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.error) +
                              "\n                        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("div", { staticClass: "columns" }, [
                    _c("div", { staticClass: "column is-7 is-offset-3" }, [
                      _c("div", { staticClass: "is-aligned-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "button is-info",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.addOffice($event)
                              }
                            }
                          },
                          [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("add_office_button_label")
                                )
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "button is-primary",
                            attrs: { disabled: _vm.errors.any() },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.submit($event)
                              }
                            }
                          },
                          [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t("register_button_label")
                                )
                              }
                            })
                          ]
                        )
                      ])
                    ])
                  ])
                ],
                2
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { active: _vm.showAvatarSelector },
          on: {
            "update:active": function($event) {
              _vm.showAvatarSelector = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "modal-card", attrs: { id: "avatars-modal-card" } },
            [
              _c("header", { staticClass: "modal-card-head" }, [
                _c("p", { staticClass: "modal-card-title" }, [
                  _vm._v(_vm._s(_vm.$t("doctorRegister_title")))
                ])
              ]),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "modal-card-body has-text-centered" },
                _vm._l(_vm.avatars, function(avatarPath, avatar) {
                  return _c(
                    "div",
                    {
                      staticClass: "is-inline-block mx-2 my-2",
                      class:
                        avatar == _vm.newDoctor.avatar
                          ? "selected-avatar"
                          : "unselected-avatar"
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.selectAvatar(avatar)
                            }
                          }
                        },
                        [
                          _c("avatar", {
                            staticClass: "image is-96x96",
                            attrs: { avatar: avatar, name: avatarPath }
                          })
                        ],
                        1
                      )
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("footer", { staticClass: "modal-card-foot" }, [
                _c(
                  "button",
                  {
                    staticClass: "button",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.toggleAvatarSelector(false)
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("cancel_button_label")))]
                )
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d6b239a", esExports)
  }
}

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__(341);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bcf6bb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__(627);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bcf6bb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/Dashboard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6bcf6bb4", Component.options)
  } else {
    hotAPI.reload("data-v-6bcf6bb4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);











// Extend EventEmitter so user of EmergencyRepository can react to our own defined events. (ex: emergencyRepository.on('added'))

var DoctorAdvertisementRepository = function (_EventEmitter) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DoctorAdvertisementRepository, _EventEmitter);

    function DoctorAdvertisementRepository() {
        var _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DoctorAdvertisementRepository);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DoctorAdvertisementRepository.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DoctorAdvertisementRepository)).call(this));

        _this.collection = __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('doctorAdvertisements');

        return _ret = _this, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DoctorAdvertisementRepository, [{
        key: 'all',
        value: function all(onSuccess, onError) {
            __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('doctorAdvertisements').get().then(function (querySnapshot) {
                var doctorAdvertisements = [];

                querySnapshot.forEach(function (doc) {
                    var doctorAdvertisement = doc.data();

                    doctorAdvertisements.push(doctorAdvertisement);
                });

                onSuccess(doctorAdvertisements);
            }).catch(function (error) {
                if (typeof onError != 'undefined') {
                    onError(error);
                } else {
                    console.error(error);
                }
            });
        }
    }, {
        key: 'allForDoctor',
        value: function allForDoctor(doctor, onSuccess, onError) {
            __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('doctorAdvertisements').where('countryId', '==', doctor.countryId).where('medicalPractices', 'array-contains', doctor.type).get().then(function (querySnapshot) {
                var doctorAdvertisements = [];

                querySnapshot.forEach(function (doc) {
                    var doctorAdvertisement = doc.data();

                    doctorAdvertisements.push(doctorAdvertisement);
                });

                onSuccess(doctorAdvertisements);
            }).catch(function (error) {
                if (typeof onError != 'undefined') {
                    onError(error);
                } else {
                    console.error(error);
                }
            });
        }
    }, {
        key: 'create',
        value: function create(_ref, onSuccess, onError) {
            var countryId = _ref.countryId,
                name = _ref.name;

            var doctorAdvertisementDocs = {};

            var doctorAdvertisementRef = __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('doctorAdvertisements').doc();

            this.collection.doc(doctorAdvertisementRef.id).set({
                id: doctorAdvertisementRef.id,
                name: name,
                countryId: countryId,
                isPublished: false,
                position: 999,
                items: {}
            }).then(function () {
                onSuccess(doctorAdvertisementRef.id);
            }).catch(onError);
        }
    }, {
        key: 'update',
        value: function update(doctorAdvertisement, onSuccess, onError) {
            this.collection.doc(doctorAdvertisement.id).update(doctorAdvertisement).then(function () {
                onSuccess(doctorAdvertisement.id);
            }).catch(onError);
        }
    }, {
        key: 'delete',
        value: function _delete(id, onSuccess, onError) {
            this.collection.doc(id).delete().then(onSuccess).catch(onError);
        }
    }, {
        key: 'find',
        value: function find(id, onSuccess, onError) {
            this.collection.doc(id).get().then(function (snapshot) {
                if (snapshot.exists) {
                    onSuccess(snapshot.data());
                } else {
                    onError({ message: "This doctor advertisement does not exist." });
                }
            }).catch(onError);
        }
    }]);

    return DoctorAdvertisementRepository;
}(__WEBPACK_IMPORTED_MODULE_6_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new DoctorAdvertisementRepository());

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.doctor && _vm.doctor.isCertified && _vm.doctor.onboardingStep >= 5
    ? _c("div", { staticClass: "advertisements-wrapper" }, [
        _vm.advertisements.length
          ? _c("div", { staticClass: "advertisement" }, [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      _vm.advertisements[_vm.currentKey].items[_vm.languageId]
                        .url,
                    target: "_blank"
                  },
                  on: {
                    click: function($event) {
                      return _vm.dispatchAnalyticsEvent("Click")
                    }
                  }
                },
                [
                  _c("img", {
                    staticStyle: { "max-width": "100%" },
                    attrs: {
                      src:
                        _vm.advertisements[_vm.currentKey].items[_vm.languageId]
                          .image
                    }
                  })
                ]
              )
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7471c71e", esExports)
  }
}

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("aside", { staticClass: "menu my-5" }, [
        _c("p", { staticClass: "menu-label" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.$t("offices_title")) + "\n        "
          )
        ]),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "menu-list" },
          _vm._l(_vm.offices, function(office) {
            return _c("li", [
              _c(
                "a",
                {
                  class: {
                    "is-active": _vm.$store.state.currentOffice == office.id
                  },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.switchOffice(office.id)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(office.name) +
                      "\n                "
                  )
                ]
              )
            ])
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("advertisements")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-99e870ea", esExports)
  }
}

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(625);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(20)("651ba016", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b23788aa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Onboarding.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b23788aa\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Onboarding.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(19)(false);
// imports


// module
exports.push([module.i, "\n.onboarding {\n  position: relative;\n}\n.onboarding .bubble {\n  background: #3277cb;\n  border: 2px solid #00538c;\n  border-radius: 5px;\n  color: #fff;\n  margin-bottom: 15px;\n  position: relative;\n}\n.onboarding .bubble .bubble-text {\n  padding: 15px;\n}\n.onboarding .bubble::before {\n  content: ' ';\n  position: absolute;\n  width: 0;\n  height: 0;\n  left: 28px;\n  right: auto;\n  top: auto;\n  bottom: -24px;\n  border: 12px solid;\n  border-color: #00538c transparent transparent;\n}\n.onboarding .bubble::after {\n  content: ' ';\n  position: absolute;\n  width: 0;\n  height: 0;\n  left: 32px;\n  right: auto;\n  top: auto;\n  bottom: -16px;\n  border: 8px solid;\n  border-color: #3277cb transparent transparent;\n}\n", ""]);

// exports


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.doctor && _vm.doctor.isCertified && _vm.doctor.onboardingStep < 5
    ? _c("div", { staticClass: "onboarding-wrapper" }, [
        _c("div", { staticClass: "onboarding" }, [
          _c("div", { staticClass: "bubble" }, [
            _vm.doctor.onboardingStep == 0
              ? _c(
                  "div",
                  { staticClass: "bubble-text" },
                  [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("step_0_text", { name: _vm.doctor.lastName })
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("router-link", {
                      staticClass: "button is-primary mt-5",
                      attrs: { to: { name: "doctor.availabilities" } },
                      domProps: {
                        textContent: _vm._s(_vm.$t("step_0_button"))
                      },
                      nativeOn: {
                        click: function($event) {
                          return _vm.setOnboardingStep(
                            _vm.doctor.onboardingStep + 1
                          )
                        }
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.doctor.onboardingStep == 1
              ? _c("div", { staticClass: "bubble-text" }, [
                  _vm.$route.name == "doctor.availabilities"
                    ? _c(
                        "div",
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("step_1_text"))
                            }
                          }),
                          _vm._v(" "),
                          _c("router-link", {
                            staticClass: "button is-primary mt-5",
                            attrs: { to: { name: "doctor.dashboard" } },
                            domProps: {
                              textContent: _vm._s(_vm.$t("step_1_button"))
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.setOnboardingStep(
                                  _vm.doctor.onboardingStep + 1
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("step_1_helper_text"))
                            }
                          }),
                          _vm._v(" "),
                          _c("router-link", {
                            staticClass: "button is-primary mt-5",
                            attrs: { to: { name: "doctor.availabilities" } },
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("step_1_helper_button")
                              )
                            }
                          })
                        ],
                        1
                      )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.doctor.onboardingStep == 2
              ? _c("div", { staticClass: "bubble-text" }, [
                  _vm.$route.name == "doctor.dashboard"
                    ? _c(
                        "div",
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("step_2_text"))
                            }
                          }),
                          _vm._v(" "),
                          _c("router-link", {
                            staticClass: "button is-primary mt-5",
                            attrs: { to: { name: "doctor.emergencies" } },
                            domProps: {
                              textContent: _vm._s(_vm.$t("step_2_button"))
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.setOnboardingStep(
                                  _vm.doctor.onboardingStep + 1
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _c(
                        "div",
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("step_2_helper_text"))
                            }
                          }),
                          _vm._v(" "),
                          _c("router-link", {
                            staticClass: "button is-primary mt-5",
                            attrs: { to: { name: "doctor.dashboard" } },
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("step_2_helper_button")
                              )
                            }
                          })
                        ],
                        1
                      )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.doctor.onboardingStep == 3
              ? _c("div", { staticClass: "bubble-text" }, [
                  _vm.$route.name == "doctor.emergencies"
                    ? _c("div", [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.$t("step_3_text")) }
                        }),
                        _vm._v(" "),
                        _c("button", {
                          staticClass: "button is-primary mt-5",
                          domProps: {
                            textContent: _vm._s(_vm.$t("step_3_button"))
                          },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.setOnboardingStep(
                                _vm.doctor.onboardingStep + 1
                              )
                            }
                          }
                        })
                      ])
                    : _c(
                        "div",
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.$t("step_3_helper_text"))
                            }
                          }),
                          _vm._v(" "),
                          _c("router-link", {
                            staticClass: "button is-primary mt-5",
                            attrs: { to: { name: "doctor.emergencies" } },
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("step_3_helper_button")
                              )
                            }
                          })
                        ],
                        1
                      )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.doctor.onboardingStep == 4
              ? _c("div", { staticClass: "bubble-text" }, [
                  _c("div", [
                    _c("div", {
                      domProps: { innerHTML: _vm._s(_vm.$t("step_4_text")) }
                    }),
                    _vm._v(" "),
                    _c("button", {
                      staticClass: "button is-primary mt-5",
                      domProps: {
                        textContent: _vm._s(_vm.$t("step_4_button"))
                      },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.setOnboardingStep(
                            _vm.doctor.onboardingStep + 1
                          )
                        }
                      }
                    })
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: "/static/img/mascot/z.png",
              alt: "Tooddoc Mascot",
              width: "90px"
            }
          })
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b23788aa", esExports)
  }
}

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboard" },
    [
      _vm.doctor
        ? _c("div", [
            _c("div", { staticClass: "container" }, [
              _c("div", { staticClass: "columns" }, [
                _c(
                  "div",
                  { staticClass: "column is-3" },
                  [_c("app-sidebar"), _vm._v(" "), _c("onboarding")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "column is-9" },
                  _vm._l(_vm.offices, function(office) {
                    return _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: office.id == _vm.currentOffice,
                            expression: "office.id == currentOffice"
                          }
                        ],
                        staticClass: "mt-7"
                      },
                      [
                        _c("div", { staticClass: "tabs" }, [
                          _c(
                            "ul",
                            _vm._l(_vm.dates, function(date) {
                              return _c(
                                "li",
                                {
                                  class: {
                                    "is-active": date == _vm.currentDate
                                  }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.selectDate(date)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("momentFormat")(
                                            date,
                                            "YYYY-MM-DD",
                                            _vm.$t("date_selector_format")
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "columns" }, [
                          _c("div", { staticClass: "column is-6" }, [
                            _c("nav", { staticClass: "panel" }, [
                              _c("p", { staticClass: "panel-heading" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("next_appointments_section_title")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "panel-block p-0" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table is-fullwidth is-striped mb-0"
                                  },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "next_appointments_table_details_header"
                                              )
                                            )
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("th")
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      [
                                        _vm._l(
                                          _vm.officeReservedAvailabilities,
                                          function(availability) {
                                            return _c("tr", [
                                              _c("td", [
                                                _vm.hasAvailabilityPictures(
                                                  availability
                                                )
                                                  ? _c(
                                                      "figure",
                                                      {
                                                        staticClass:
                                                          "image thumbnail is-32x32 is-inline-block is-pulled-left m-1 mr-2 clickable",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.showEmergency(
                                                              availability
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticStyle: {
                                                            "max-height":
                                                              "100%",
                                                            "max-width": "100%"
                                                          },
                                                          attrs: {
                                                            src: _vm.getAvailabilityPicture(
                                                              availability
                                                            ),
                                                            alt: "Image Preview"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "button is-info is-outline is-pulled-left mr-2",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.showEmergency(
                                                              availability
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("b-icon", {
                                                          attrs: {
                                                            icon:
                                                              "clipboard-account"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "data-title" },
                                                  [
                                                    _vm._v(
                                                      "\n                                                            " +
                                                        _vm._s(
                                                          availability.start
                                                        ) +
                                                        " - " +
                                                        _vm._s(
                                                          availability.end
                                                        ) +
                                                        "\n                                                            "
                                                    ),
                                                    _c("span", {
                                                      staticClass:
                                                        "is-size-7 has-text-grey has-text-weight-light",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.getAvailabilityStatus(
                                                            availability
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "data-value",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.getPatientInfo(
                                                        availability
                                                      )
                                                    )
                                                  }
                                                })
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "td",
                                                {
                                                  staticClass: "has-text-right",
                                                  attrs: { width: "105px" }
                                                },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "button is-danger",
                                                      attrs: {
                                                        disabled:
                                                          availability.appointmentId
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.cancelInvitation(
                                                            availability.appointmentInvitationId
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("b-icon", {
                                                        attrs: {
                                                          icon: "delete-forever"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ])
                                          }
                                        ),
                                        _vm._v(" "),
                                        Object.keys(
                                          _vm.officeReservedAvailabilities
                                        ).length == 0
                                          ? _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "has-text-centered has-text-grey",
                                                  attrs: { colspan: "2" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "next_appointments_section_empty_placeholder"
                                                        )
                                                      ) +
                                                      "\n                                                    "
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column is-6" }, [
                            _c("nav", { staticClass: "panel" }, [
                              _c("p", { staticClass: "panel-heading" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("next_availabilities_section_title")
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "panel-block p-0" }, [
                                _c(
                                  "table",
                                  {
                                    staticClass:
                                      "table is-fullwidth is-striped mb-0"
                                  },
                                  [
                                    _c("thead", [
                                      _c("tr", [
                                        _c("th", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "next_availabilities_table_details_header"
                                              )
                                            )
                                          )
                                        ])
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "tbody",
                                      [
                                        _vm._l(
                                          _vm.officeAvailabilities,
                                          function(availability) {
                                            return _c("tr", [
                                              _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "button is-info is-outline is-pulled-left mr-2",
                                                    attrs: { disabled: "" }
                                                  },
                                                  [
                                                    _c("b-icon", {
                                                      attrs: {
                                                        icon:
                                                          "clipboard-account"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "data-title" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        availability.start
                                                      ) +
                                                        " - " +
                                                        _vm._s(availability.end)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "data-value" },
                                                  [_vm._v("—")]
                                                )
                                              ])
                                            ])
                                          }
                                        ),
                                        _vm._v(" "),
                                        Object.keys(_vm.officeAvailabilities)
                                          .length == 0
                                          ? _c("tr", [
                                              _c(
                                                "td",
                                                {
                                                  staticClass:
                                                    "has-text-centered has-text-grey"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                        " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "next_availabilities_section_empty_placeholder"
                                                        )
                                                      ) +
                                                      "\n                                                    "
                                                  )
                                                ]
                                              )
                                            ])
                                          : _vm._e()
                                      ],
                                      2
                                    )
                                  ]
                                )
                              ])
                            ])
                          ])
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      Object.keys(_vm.currentEmergency).length > 0
        ? _c("emergency-modal", {
            attrs: {
              active: _vm.showEmergencyModal,
              emergency: _vm.currentEmergency,
              availability: _vm.currentAvailability
            },
            on: {
              close: function($event) {
                return _vm.closeEmergencyModal()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bcf6bb4", esExports)
  }
}

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(346);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d97fa49_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(629);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d97fa49_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/Profile.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1d97fa49", Component.options)
  } else {
    hotAPI.reload("data-v-1d97fa49", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "profile" }, [
    _c("div", [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column is-3" },
            [
              _c(
                "aside",
                { staticClass: "menu mt-5 mb-3" },
                [
                  _c("ul", { staticClass: "menu-list" }, [
                    _c(
                      "li",
                      [
                        _c(
                          "router-link",
                          { attrs: { to: { name: "doctor.profile" } } },
                          [_vm._v(_vm._s(_vm.$t("doctor_details_label")))]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c("p", { staticClass: "menu-label" }, [
                    _vm._v(
                      "\n                              " +
                        _vm._s(_vm.$t("offices_title")) +
                        "\n                          "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "menu-list" },
                    _vm._l(_vm.offices, function(office) {
                      return _c(
                        "li",
                        [
                          _c("router-link", {
                            attrs: {
                              to: {
                                name: "doctor.profile.office",
                                params: { id: office.id }
                              }
                            },
                            domProps: { textContent: _vm._s(office.name) }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "button is-outlined is-primary mt-3 has-icon",
                      attrs: { to: { name: "doctor.profile.newOffice" } }
                    },
                    [
                      _c("b-icon", { attrs: { icon: "plus-circle" } }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("add_another_office_button_label"))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("onboarding")
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "column is-7" }, [
            _c("div", { staticClass: "box mt-5" }, [_c("router-view")], 1)
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d97fa49", esExports)
  }
}

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileDetails_vue__ = __webpack_require__(347);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb33ae9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileDetails_vue__ = __webpack_require__(631);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fb33ae9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/ProfileDetails.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0fb33ae9", Component.options)
  } else {
    hotAPI.reload("data-v-0fb33ae9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.doctor
        ? _c("form", [
            _c("div", { staticClass: "field has-text-centered" }, [
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.toggleAvatarSelector(true)
                    }
                  }
                },
                [
                  _c("avatar", {
                    staticClass: "is-inline image is-96x96",
                    attrs: {
                      avatar: _vm.doctor.avatar,
                      name: _vm.doctor.firstName + " " + _vm.doctor.lastName
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "is-size-7 has-text-grey is-block" }, [
                _vm._v(_vm._s(_vm.$t("click_to_change_avatar")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "columns" }, [
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", {
                    staticClass: "label",
                    domProps: {
                      textContent: _vm._s(_vm.$t("first_name_label"))
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "control has-icon has-icons-right" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.doctor.firstName,
                          expression: "doctor.firstName"
                        }
                      ],
                      class: {
                        input: true,
                        "is-danger": _vm.errors.has("doctor.firstName")
                      },
                      attrs: { name: "doctor.firstName", type: "text" },
                      domProps: { value: _vm.doctor.firstName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.doctor, "firstName", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("doctor.firstName"),
                            expression: "errors.has('doctor.firstName')"
                          }
                        ],
                        staticClass: "icon is-right is-danger"
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-alert-circle mdi-24px"
                        })
                      ]
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "column" }, [
                _c("div", { staticClass: "field" }, [
                  _c("label", {
                    staticClass: "label",
                    domProps: { textContent: _vm._s(_vm.$t("last_name_label")) }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "control has-icon has-icons-right" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        },
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.doctor.lastName,
                          expression: "doctor.lastName"
                        }
                      ],
                      class: {
                        input: true,
                        "is-danger": _vm.errors.has("doctor.lastName")
                      },
                      attrs: { name: "doctor.lastName", type: "text" },
                      domProps: { value: _vm.doctor.lastName },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(_vm.doctor, "lastName", $event.target.value)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errors.has("doctor.lastName"),
                            expression: "errors.has('doctor.lastName')"
                          }
                        ],
                        staticClass: "icon is-right is-danger"
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-alert-circle mdi-24px"
                        })
                      ]
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("label", {
                staticClass: "label",
                domProps: { textContent: _vm._s(_vm.$t("contact_email_label")) }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "control has-icon has-icons-right" }, [
                _c("input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|email",
                      expression: "'required|email'"
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.doctor.contactEmail,
                      expression: "doctor.contactEmail"
                    }
                  ],
                  class: {
                    input: true,
                    "is-danger": _vm.errors.has("doctor.contactEmail")
                  },
                  attrs: { name: "doctor.contactEmail", type: "text" },
                  domProps: { value: _vm.doctor.contactEmail },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.doctor, "contactEmail", $event.target.value)
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("label", {
                staticClass: "label",
                domProps: {
                  textContent: _vm._s(_vm.$t("medical_practice_label"))
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "control has-icon has-icons-right" }, [
                _c("div", { staticClass: "select is-fullwidth" }, [
                  _c(
                    "select",
                    {
                      attrs: { disabled: "" },
                      domProps: { value: _vm.doctor.type }
                    },
                    _vm._l(_vm.medicalPractices, function(type) {
                      return _c("option", { domProps: { value: type } }, [
                        _vm._v(_vm._s(_vm.$t("type_" + type)))
                      ])
                    }),
                    0
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("label", {
                staticClass: "label",
                domProps: { textContent: _vm._s(_vm.$t("inami_label")) }
              }),
              _vm._v(" "),
              _c("p", { staticClass: "control has-icon has-icons-right" }, [
                _c("input", {
                  staticClass: "input disabled",
                  attrs: { type: "text", disabled: "", autocomplete: "off" },
                  domProps: { value: _vm.doctor.inami }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("label", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.doctor.isRegulated,
                      expression: "doctor.isRegulated"
                    }
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.doctor.isRegulated)
                      ? _vm._i(_vm.doctor.isRegulated, null) > -1
                      : _vm.doctor.isRegulated
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.doctor.isRegulated,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.doctor,
                              "isRegulated",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.doctor,
                              "isRegulated",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.doctor, "isRegulated", $$c)
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.$t("is_regulated_label")) }
                })
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "field",
                class: Object.keys(_vm.countries).length == 1 ? "is-hidden" : ""
              },
              [
                _c("label", {
                  staticClass: "label",
                  domProps: {
                    textContent: _vm._s(_vm.$t("DoctorProfile.country_label"))
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "control has-icon has-icons-right" }, [
                  _c("div", { staticClass: "select" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.doctor.countryId,
                            expression: "doctor.countryId"
                          }
                        ],
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.doctor,
                              "countryId",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          }
                        }
                      },
                      _vm._l(_vm.countries, function(country) {
                        return _c("option", {
                          domProps: {
                            value: country.id,
                            textContent: _vm._s(
                              _vm.$t("Countries_" + _vm.countr.code)
                            )
                          }
                        })
                      }),
                      0
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "field" }, [
              _c("label", {
                staticClass: "label",
                domProps: { textContent: _vm._s(_vm.$t("language_label")) }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "control has-icon has-icons-right" }, [
                _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.doctor.language,
                          expression: "doctor.language"
                        }
                      ],
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.doctor,
                            "language",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        }
                      }
                    },
                    _vm._l(_vm.languages, function(language, id) {
                      return _c(
                        "option",
                        { domProps: { value: language.code } },
                        [_vm._v(_vm._s(language.name))]
                      )
                    }),
                    0
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button is-primary has-icon",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.saveDetails($event)
                  }
                }
              },
              [
                _c("b-icon", { attrs: { icon: "check-circle" } }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("update_button_label")))])
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { active: _vm.showAvatarSelector },
          on: {
            "update:active": function($event) {
              _vm.showAvatarSelector = $event
            }
          }
        },
        [
          _c("div", { staticClass: "modal-card" }, [
            _c("header", { staticClass: "modal-card-head" }, [
              _c("p", { staticClass: "modal-card-title" }, [
                _vm._v(_vm._s(_vm.$t("avatar_title")))
              ])
            ]),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "modal-card-body has-text-centered" },
              _vm._l(_vm.avatars, function(avatarPath, avatar) {
                return _c(
                  "div",
                  {
                    staticClass: "is-inline-block mx-2 my-2",
                    class:
                      avatar == _vm.doctor.avatar
                        ? "selected-avatar"
                        : "unselected-avatar"
                  },
                  [
                    _c(
                      "a",
                      {
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.selectAvatar(avatar)
                          }
                        }
                      },
                      [
                        _c("avatar", {
                          staticClass: "image is-96x96",
                          attrs: { avatar: avatar, name: avatarPath }
                        })
                      ],
                      1
                    )
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("footer", { staticClass: "modal-card-foot" }, [
              _c(
                "button",
                {
                  staticClass: "button",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.toggleAvatarSelector(false)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("cancel_button_label")))]
              )
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fb33ae9", esExports)
  }
}

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileNewOffice_vue__ = __webpack_require__(348);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227d9f3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileNewOffice_vue__ = __webpack_require__(633);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileNewOffice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_227d9f3a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileNewOffice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/ProfileNewOffice.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-227d9f3a", Component.options)
  } else {
    hotAPI.reload("data-v-227d9f3a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", [
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", {
            staticClass: "label",
            domProps: { textContent: _vm._s(_vm.$t("name_label")) }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "control has-icon has-icons-right" }, [
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newOffice.name,
                  expression: "newOffice.name"
                }
              ],
              class: {
                input: true,
                "is-danger": _vm.errors.has("newOffice.name")
              },
              attrs: { name: "newOffice.name", type: "name" },
              domProps: { value: _vm.newOffice.name },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newOffice, "name", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("newOffice.name"),
                    expression: "errors.has('newOffice.name')"
                  }
                ],
                staticClass: "icon is-rightis-danger has-text-danger"
              },
              [_c("i", { staticClass: "mdi mdi-alert-circle mdi-24px" })]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-8" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", {
            staticClass: "label",
            domProps: { textContent: _vm._s(_vm.$t("street_name_label")) }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "control has-icon has-icons-right" }, [
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newOffice.streetName,
                  expression: "newOffice.streetName"
                }
              ],
              class: {
                input: true,
                "is-danger": _vm.errors.has("newOffice.streetName")
              },
              attrs: { name: "newOffice.streetName", type: "streetName" },
              domProps: { value: _vm.newOffice.streetName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newOffice, "streetName", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("newOffice.streetName"),
                    expression: "errors.has('newOffice.streetName')"
                  }
                ],
                staticClass: "icon is-rightis-danger has-text-danger"
              },
              [_c("i", { staticClass: "mdi mdi-alert-circle mdi-24px" })]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "column is-4" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", {
            staticClass: "label",
            domProps: { textContent: _vm._s(_vm.$t("street_number_label")) }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "control has-icon has-icons-right" }, [
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newOffice.streetNumber,
                  expression: "newOffice.streetNumber"
                }
              ],
              class: {
                input: true,
                "is-danger": _vm.errors.has("newOffice.streetNumber")
              },
              attrs: { name: "newOffice.streetNumber", type: "streetNumber" },
              domProps: { value: _vm.newOffice.streetNumber },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newOffice, "streetNumber", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("newOffice.streetNumber"),
                    expression: "errors.has('newOffice.streetNumber')"
                  }
                ],
                staticClass: "icon is-rightis-danger has-text-danger"
              },
              [_c("i", { staticClass: "mdi mdi-alert-circle mdi-24px" })]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-4" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", {
            staticClass: "label",
            domProps: { textContent: _vm._s(_vm.$t("zip_code_label")) }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "control has-icon has-icons-right" }, [
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newOffice.zipCode,
                  expression: "newOffice.zipCode"
                }
              ],
              class: {
                input: true,
                "is-danger": _vm.errors.has("newOffice.zipCode")
              },
              attrs: { name: "newOffice.zipCode", type: "zipCode" },
              domProps: { value: _vm.newOffice.zipCode },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newOffice, "zipCode", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("newOffice.zipCode"),
                    expression: "errors.has('newOffice.zipCode')"
                  }
                ],
                staticClass: "icon is-rightis-danger has-text-danger"
              },
              [_c("i", { staticClass: "mdi mdi-alert-circle mdi-24px" })]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "column is-8" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", {
            staticClass: "label",
            domProps: { textContent: _vm._s(_vm.$t("locality_label")) }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "control has-icon has-icons-right" }, [
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newOffice.locality,
                  expression: "newOffice.locality"
                }
              ],
              class: {
                input: true,
                "is-danger": _vm.errors.has("newOffice.locality")
              },
              attrs: { name: "newOffice.locality", type: "locality" },
              domProps: { value: _vm.newOffice.locality },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newOffice, "locality", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("newOffice.locality"),
                    expression: "errors.has('newOffice.locality')"
                  }
                ],
                staticClass: "icon is-rightis-danger has-text-danger"
              },
              [_c("i", { staticClass: "mdi mdi-alert-circle mdi-24px" })]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", {
            staticClass: "label",
            domProps: { textContent: _vm._s(_vm.$t("country_label")) }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "control" }),
          _c(
            "div",
            {
              class: {
                "select is-fullwidth": true,
                "is-danger": _vm.errors.has("newOffice.countryId")
              }
            },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newOffice.countryId,
                      expression: "newOffice.countryId"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "is-block",
                  attrs: {
                    name: "newOffice.countryId",
                    disabled: Object.keys(_vm.countries).length == 1
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.newOffice,
                        "countryId",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    }
                  }
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v(_vm._s(_vm.$t("select_country_label")))
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.countries, function(country, id) {
                    return _c("option", {
                      domProps: {
                        value: id,
                        textContent: _vm._s(
                          _vm.$t("Countries_" + _vm.countr.code)
                        )
                      }
                    })
                  })
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c("p"),
          _vm._v(" "),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("newOffice.countryId"),
                  expression: "errors.has('newOffice.countryId')"
                }
              ],
              staticClass: "help is-danger"
            },
            [_vm._v(_vm._s(_vm.$t("select_country_label")))]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", {
            staticClass: "label",
            domProps: { textContent: _vm._s(_vm.$t("phone_label")) }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "control has-icon has-icons-right" }, [
            _c("input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: {
                    required: true,
                    regex: _vm.getPhoneRegex()
                  },
                  expression:
                    "{\n                            required: true,\n                            regex: getPhoneRegex()\n                        }"
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newOffice.phone,
                  expression: "newOffice.phone"
                }
              ],
              class: {
                input: true,
                "is-danger": _vm.errors.has("newOffice.phone")
              },
              attrs: {
                name: "newOffice.phone",
                placeholder: _vm.getCurrentCountryPhonePrefix() + "...",
                type: "phone"
              },
              domProps: { value: _vm.newOffice.phone },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.newOffice, "phone", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("newOffice.phone"),
                    expression: "errors.has('newOffice.phone')"
                  }
                ],
                staticClass: "icon is-rightis-danger has-text-danger"
              },
              [_c("i", { staticClass: "mdi mdi-alert-circle mdi-24px" })]
            )
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.errors.has("newOffice.phone"),
                  expression: "errors.has('newOffice.phone')"
                }
              ],
              staticClass: "help is-danger"
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$t("phone_error", {
                    prefix: _vm.getCurrentCountryPhonePrefix()
                  })
                )
              )
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column" }, [
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "checkbox" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newOffice.isEmergencyEmailAlertEnabled,
                  expression: "newOffice.isEmergencyEmailAlertEnabled"
                }
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(
                  _vm.newOffice.isEmergencyEmailAlertEnabled
                )
                  ? _vm._i(_vm.newOffice.isEmergencyEmailAlertEnabled, null) >
                    -1
                  : _vm.newOffice.isEmergencyEmailAlertEnabled
              },
              on: {
                change: function($event) {
                  var $$a = _vm.newOffice.isEmergencyEmailAlertEnabled,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 &&
                        _vm.$set(
                          _vm.newOffice,
                          "isEmergencyEmailAlertEnabled",
                          $$a.concat([$$v])
                        )
                    } else {
                      $$i > -1 &&
                        _vm.$set(
                          _vm.newOffice,
                          "isEmergencyEmailAlertEnabled",
                          $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                        )
                    }
                  } else {
                    _vm.$set(_vm.newOffice, "isEmergencyEmailAlertEnabled", $$c)
                  }
                }
              }
            }),
            _vm._v(" "),
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.$t("emergency_alert_label")) }
            })
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button is-info mt-3",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.createOffice($event)
          }
        }
      },
      [
        _c("b-icon", { attrs: { icon: "plus-circle" } }),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.$t("create_button_label")))])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-227d9f3a", esExports)
  }
}

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileOffice_vue__ = __webpack_require__(349);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dede336_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileOffice_vue__ = __webpack_require__(635);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileOffice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3dede336_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileOffice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/ProfileOffice.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3dede336", Component.options)
  } else {
    hotAPI.reload("data-v-3dede336", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      on: {
        keyup: function($event) {
          if (!$event.type.indexOf("key") && $event.keyCode !== 13) {
            return null
          }
          return _vm.updateOffice($event)
        }
      }
    },
    [
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", {
              staticClass: "label",
              domProps: { textContent: _vm._s(_vm.$t("name_label")) }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "control has-icon has-icons-right" }, [
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.editOffice.name,
                    expression: "editOffice.name"
                  }
                ],
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("editOffice.name")
                },
                attrs: { name: "editOffice.name", type: "name" },
                domProps: { value: _vm.editOffice.name },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.editOffice, "name", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("editOffice.name"),
                      expression: "errors.has('editOffice.name')"
                    }
                  ],
                  staticClass: "icon is-right is-danger has-text-danger"
                },
                [_c("i", { staticClass: "mdi mdi-alert-circle mdi-24px" })]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-8" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", {
              staticClass: "label",
              domProps: { textContent: _vm._s(_vm.$t("street_name_label")) }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "control has-icon has-icons-right" }, [
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.editOffice.streetName,
                    expression: "editOffice.streetName"
                  }
                ],
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("editOffice.streetName")
                },
                attrs: { name: "editOffice.streetName", type: "streetName" },
                domProps: { value: _vm.editOffice.streetName },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.editOffice, "streetName", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("editOffice.streetName"),
                      expression: "errors.has('editOffice.streetName')"
                    }
                  ],
                  staticClass: "icon is-right is-danger has-text-danger"
                },
                [_c("i", { staticClass: "mdi mdi-alert-circle mdi-24px" })]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column is-4" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", {
              staticClass: "label",
              domProps: { textContent: _vm._s(_vm.$t("street_number_label")) }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "control has-icon has-icons-right" }, [
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.editOffice.streetNumber,
                    expression: "editOffice.streetNumber"
                  }
                ],
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("editOffice.streetNumber")
                },
                attrs: {
                  name: "editOffice.streetNumber",
                  type: "streetNumber"
                },
                domProps: { value: _vm.editOffice.streetNumber },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.editOffice,
                      "streetNumber",
                      $event.target.value
                    )
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("editOffice.streetNumber"),
                      expression: "errors.has('editOffice.streetNumber')"
                    }
                  ],
                  staticClass: "icon is-right is-danger has-text-danger"
                },
                [_c("i", { staticClass: "mdi mdi-alert-circle mdi-24px" })]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column is-4" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", {
              staticClass: "label",
              domProps: { textContent: _vm._s(_vm.$t("zip_code_label")) }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "control has-icon has-icons-right" }, [
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.editOffice.zipCode,
                    expression: "editOffice.zipCode"
                  }
                ],
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("editOffice.zipCode")
                },
                attrs: { name: "editOffice.zipCode", type: "zipCode" },
                domProps: { value: _vm.editOffice.zipCode },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.editOffice, "zipCode", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("editOffice.zipCode"),
                      expression: "errors.has('editOffice.zipCode')"
                    }
                  ],
                  staticClass: "icon is-right is-danger has-text-danger"
                },
                [_c("i", { staticClass: "mdi mdi-alert-circle mdi-24px" })]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "column is-8" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", {
              staticClass: "label",
              domProps: { textContent: _vm._s(_vm.$t("locality_label")) }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "control has-icon has-icons-right" }, [
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.editOffice.locality,
                    expression: "editOffice.locality"
                  }
                ],
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("editOffice.locality")
                },
                attrs: { name: "editOffice.locality", type: "locality" },
                domProps: { value: _vm.editOffice.locality },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.editOffice, "locality", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("editOffice.locality"),
                      expression: "errors.has('editOffice.locality')"
                    }
                  ],
                  staticClass: "icon is-right is-danger has-text-danger"
                },
                [_c("i", { staticClass: "mdi mdi-alert-circle mdi-24px" })]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", {
              staticClass: "label",
              domProps: { textContent: _vm._s(_vm.$t("country_label")) }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "control has-icon has-icons-right" }),
            _c(
              "div",
              {
                class: {
                  "select is-fullwidth": true,
                  "is-danger": _vm.errors.has("editOffice.countryId")
                }
              },
              [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.editOffice.countryId,
                        expression: "editOffice.countryId"
                      },
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    staticClass: "is-block",
                    attrs: {
                      name: "editOffice.countryId",
                      disabled: Object.keys(_vm.countries).length == 1
                    },
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.editOffice,
                          "countryId",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      }
                    }
                  },
                  [
                    _c("option", { domProps: { value: null } }, [
                      _vm._v(_vm._s(_vm.$t("select_country_label")))
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.countries, function(country, id) {
                      return _c("option", {
                        domProps: {
                          value: id,
                          textContent: _vm._s(
                            _vm.$t("Countries_" + _vm.countr.code)
                          )
                        }
                      })
                    })
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("editOffice.country"),
                    expression: "errors.has('editOffice.country')"
                  }
                ],
                staticClass: "icon is-right is-danger has-text-danger"
              },
              [_c("i", { staticClass: "mdi mdi-alert-circle mdi-24px" })]
            ),
            _vm._v(" "),
            _c("p")
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", {
              staticClass: "label",
              domProps: { textContent: _vm._s(_vm.$t("phone_label")) }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "control has-icon has-icons-right" }, [
              _c("input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: true,
                      regex: _vm.getPhoneRegex()
                    },
                    expression:
                      "{\n                            required: true,\n                            regex: getPhoneRegex()\n                        }"
                  },
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.editOffice.phone,
                    expression: "editOffice.phone"
                  }
                ],
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("editOffice.phone")
                },
                attrs: {
                  name: "editOffice.phone",
                  placeholder: _vm.getCurrentCountryPhonePrefix() + "...",
                  type: "phone"
                },
                domProps: { value: _vm.editOffice.phone },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.editOffice, "phone", $event.target.value)
                  }
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("editOffice.phone"),
                      expression: "errors.has('editOffice.phone')"
                    }
                  ],
                  staticClass: "icon is-right is-danger has-text-danger"
                },
                [_c("i", { staticClass: "mdi mdi-alert-circle mdi-24px" })]
              )
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("editOffice.phone"),
                    expression: "errors.has('editOffice.phone')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [
                _vm._v(
                  _vm._s(
                    _vm.$t("phone_error", {
                      prefix: _vm.getCurrentCountryPhonePrefix()
                    })
                  )
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "columns" }, [
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "field" }, [
            _c("label", { staticClass: "checkbox" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.editOffice.isEmergencyEmailAlertEnabled,
                    expression: "editOffice.isEmergencyEmailAlertEnabled"
                  }
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(
                    _vm.editOffice.isEmergencyEmailAlertEnabled
                  )
                    ? _vm._i(
                        _vm.editOffice.isEmergencyEmailAlertEnabled,
                        null
                      ) > -1
                    : _vm.editOffice.isEmergencyEmailAlertEnabled
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.editOffice.isEmergencyEmailAlertEnabled,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.editOffice,
                            "isEmergencyEmailAlertEnabled",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.editOffice,
                            "isEmergencyEmailAlertEnabled",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(
                        _vm.editOffice,
                        "isEmergencyEmailAlertEnabled",
                        $$c
                      )
                    }
                  }
                }
              }),
              _vm._v(" "),
              _c("span", {
                domProps: { innerHTML: _vm._s(_vm.$t("emergency_alert_label")) }
              })
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button is-primary mt-3",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.updateOffice($event)
            }
          }
        },
        [
          _c("b-icon", { attrs: { icon: "check-circle" } }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("update_button_label")))])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "button is-danger is-outlined is-pulled-right mt-3",
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.confirmDeleteOffice($event)
            }
          }
        },
        [
          _c("b-icon", { attrs: { icon: "delete-forever" } }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("delete_button_label")))])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3dede336", esExports)
  }
}

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Availabilities_vue__ = __webpack_require__(350);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_522d45c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Availabilities_vue__ = __webpack_require__(637);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Availabilities_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_522d45c9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Availabilities_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/Availabilities.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-522d45c9", Component.options)
  } else {
    hotAPI.reload("data-v-522d45c9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "availabilities" },
    [
      _c("div", [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column is-3" },
              [_c("app-sidebar"), _vm._v(" "), _c("onboarding")],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "column is-9" },
              [
                !_vm.currentOffice
                  ? _c("div", { staticClass: "section mt-7 mb-10" }, [
                      _c("p", { staticClass: "is-aligned-center" }, [
                        _vm._v(_vm._s(_vm.$t("no_office_selected")))
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.offices, function(office) {
                  return _vm.currentOffice == office.id
                    ? _c("div", { key: office.id, staticClass: "mt-7" }, [
                        _c("div", { staticClass: "tabs" }, [
                          _c(
                            "ul",
                            _vm._l(_vm.dates, function(date) {
                              return _c(
                                "li",
                                {
                                  class: {
                                    "is-active": date == _vm.currentDate
                                  }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.selectDate(date)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("momentFormat")(
                                            date,
                                            "YYYY-MM-DD",
                                            _vm.$t("date_selector_format")
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "columns" }, [
                          _c("div", { staticClass: "column" }, [
                            _c(
                              "table",
                              { staticClass: "table is-striped is-fullwidth" },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [
                                      _vm._v(_vm._s(_vm.$t("morning_label")))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      { staticClass: "has-text-right" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("available_label"))
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  [
                                    !_vm.showEarlySlots
                                      ? _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "has-text-centered clickable",
                                              attrs: { colspan: "2" },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.toggleEarlySlots()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "is-size-7",
                                                  attrs: { href: "#" }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("show_early_slots")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm._.filter(_vm.timeSlots, function(
                                        time,
                                        key
                                      ) {
                                        return (
                                          key < 48 &&
                                          (_vm.showEarlySlots
                                            ? true
                                            : key >= 32 ||
                                              _vm._.has(
                                                _vm.officeReservedAvailabilities,
                                                key
                                              ))
                                        )
                                      }),
                                      function(slot) {
                                        return _c(
                                          "tr",
                                          {
                                            staticStyle: { overflow: "hidden" }
                                          },
                                          [
                                            _vm._.has(
                                              _vm.officeReservedAvailabilities,
                                              slot.key
                                            )
                                              ? _c("td", [
                                                  _vm.hasAvailabilityPictures(
                                                    slot.key
                                                  )
                                                    ? _c(
                                                        "figure",
                                                        {
                                                          staticClass:
                                                            "image thumbnail is-32x32 is-inline-block is-pulled-left m-1 mr-2 clickable",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.showEmergency(
                                                                slot.key
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticStyle: {
                                                              "max-height":
                                                                "100%",
                                                              "max-width":
                                                                "100%"
                                                            },
                                                            attrs: {
                                                              src: _vm.getAvailabilityPicture(
                                                                slot.key
                                                              ),
                                                              alt:
                                                                "Image Preview"
                                                            }
                                                          })
                                                        ]
                                                      )
                                                    : _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "button is-info is-outline is-pulled-left mr-2",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.showEmergency(
                                                                slot.key
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("b-icon", {
                                                            attrs: {
                                                              icon:
                                                                "clipboard-account"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "data-title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                      " +
                                                          _vm._s(slot.start) +
                                                          " - " +
                                                          _vm._s(slot.end) +
                                                          "\n                                                      "
                                                      ),
                                                      _c("span", {
                                                        staticClass:
                                                          "is-size-7 has-text-grey has-text-weight-light",
                                                        domProps: {
                                                          textContent: _vm._s(
                                                            _vm.getAvailabilityStatus(
                                                              slot.key
                                                            )
                                                          )
                                                        }
                                                      })
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "data-value",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.getPatientInfo(
                                                          slot.key
                                                        )
                                                      )
                                                    }
                                                  })
                                                ])
                                              : _c("td", [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "button is-info is-outline is-pulled-left mr-2",
                                                      attrs: { disabled: "" }
                                                    },
                                                    [
                                                      _c("b-icon", {
                                                        attrs: {
                                                          icon:
                                                            "clipboard-account"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "data-title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(slot.start) +
                                                          " - " +
                                                          _vm._s(slot.end)
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "data-value"
                                                    },
                                                    [_vm._v("—")]
                                                  )
                                                ]),
                                            _vm._v(" "),
                                            _c(
                                              "td",
                                              { staticClass: "has-text-right" },
                                              [
                                                !_vm.isPastSlot(slot)
                                                  ? _c("toggle-button", {
                                                      attrs: {
                                                        value: _vm.isTimeSlotActive(
                                                          slot.key
                                                        ),
                                                        disabled:
                                                          !_vm.doctor
                                                            .isCertified ||
                                                          _vm._.has(
                                                            _vm.officeReservedAvailabilities,
                                                            slot.key
                                                          ),
                                                        width: 40,
                                                        sync: true
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.toggle(
                                                            slot.key
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ]
                                        )
                                      }
                                    )
                                  ],
                                  2
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "column" }, [
                            _c(
                              "table",
                              { staticClass: "table is-striped is-fullwidth" },
                              [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [
                                      _vm._v(_vm._s(_vm.$t("afternoon_label")))
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "th",
                                      { staticClass: "has-text-right" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("available_label"))
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  [
                                    _vm._l(
                                      _vm._.filter(_vm.timeSlots, function(
                                        time,
                                        key
                                      ) {
                                        return (
                                          key >= 48 &&
                                          (_vm.showLateSlots
                                            ? true
                                            : key < 80 ||
                                              _vm._.has(
                                                _vm.officeReservedAvailabilities,
                                                key
                                              ))
                                        )
                                      }),
                                      function(slot) {
                                        return _c("tr", [
                                          _vm._.has(
                                            _vm.officeReservedAvailabilities,
                                            slot.key
                                          )
                                            ? _c("td", [
                                                _vm.hasAvailabilityPictures(
                                                  slot.key
                                                )
                                                  ? _c(
                                                      "figure",
                                                      {
                                                        staticClass:
                                                          "image thumbnail is-32x32 is-inline-block is-pulled-left m-1 mr-2 clickable",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.showEmergency(
                                                              slot.key
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          staticStyle: {
                                                            "max-height":
                                                              "100%",
                                                            "max-width": "100%"
                                                          },
                                                          attrs: {
                                                            src: _vm.getAvailabilityPicture(
                                                              slot.key
                                                            ),
                                                            alt: "Image Preview"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "button is-info is-outline is-pulled-left mr-2",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.showEmergency(
                                                              slot.key
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("b-icon", {
                                                          attrs: {
                                                            icon:
                                                              "clipboard-account"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "data-title" },
                                                  [
                                                    _vm._v(
                                                      "\n                                                      " +
                                                        _vm._s(slot.start) +
                                                        " - " +
                                                        _vm._s(slot.end) +
                                                        "\n                                                      "
                                                    ),
                                                    _c("span", {
                                                      staticClass:
                                                        "is-size-7 has-text-grey has-text-weight-light",
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.getAvailabilityStatus(
                                                            slot.key
                                                          )
                                                        )
                                                      }
                                                    })
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "data-value",
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.getPatientInfo(
                                                        slot.key
                                                      )
                                                    )
                                                  }
                                                })
                                              ])
                                            : _c("td", [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "button is-info is-outline is-pulled-left mr-2",
                                                    attrs: { disabled: "" }
                                                  },
                                                  [
                                                    _c("b-icon", {
                                                      attrs: {
                                                        icon:
                                                          "clipboard-account"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "data-title" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(slot.start) +
                                                        " - " +
                                                        _vm._s(slot.end)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "data-value" },
                                                  [_vm._v("—")]
                                                )
                                              ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            { staticClass: "has-text-right" },
                                            [
                                              !_vm.isPastSlot(slot)
                                                ? _c("toggle-button", {
                                                    attrs: {
                                                      value: _vm.isTimeSlotActive(
                                                        slot.key
                                                      ),
                                                      disabled:
                                                        !_vm.doctor
                                                          .isCertified ||
                                                        _vm._.has(
                                                          _vm.officeReservedAvailabilities,
                                                          slot.key
                                                        ),
                                                      width: 40,
                                                      sync: true
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.toggle(
                                                          slot.key
                                                        )
                                                      }
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ])
                                      }
                                    ),
                                    _vm._v(" "),
                                    !_vm.showLateSlots
                                      ? _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticClass:
                                                "has-text-centered clickable",
                                              attrs: { colspan: "2" },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.toggleLateSlots()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "is-size-7",
                                                  attrs: { href: "#" }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("show_late_slots")
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      : _vm._e()
                                  ],
                                  2
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                })
              ],
              2
            )
          ])
        ])
      ]),
      _vm._v(" "),
      Object.keys(_vm.currentEmergency).length > 0
        ? _c("emergency-modal", {
            attrs: {
              active: _vm.showEmergencyModal,
              emergency: _vm.currentEmergency,
              availability: _vm.currentAvailability
            },
            on: {
              close: function($event) {
                return _vm.closeEmergencyModal()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-522d45c9", esExports)
  }
}

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Emergencies_vue__ = __webpack_require__(351);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c9acf8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Emergencies_vue__ = __webpack_require__(642);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Emergencies_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c9acf8f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Emergencies_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/Emergencies.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1c9acf8f", Component.options)
  } else {
    hotAPI.reload("data-v-1c9acf8f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AcceptEmergencyForm_vue__ = __webpack_require__(352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59c39f26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AcceptEmergencyForm_vue__ = __webpack_require__(640);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AcceptEmergencyForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59c39f26_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AcceptEmergencyForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/AcceptEmergencyForm.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-59c39f26", Component.options)
  } else {
    hotAPI.reload("data-v-59c39f26", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal", class: { "is-active": _vm.active } },
    [
      _c("div", { staticClass: "modal-background" }),
      _vm._v(" "),
      _c("div", { staticClass: "modal-card" }, [
        _c("header", { staticClass: "modal-card-head" }, [
          _c("p", { staticClass: "modal-card-title" }, [
            _vm._v(_vm._s(_vm.$t("accept_modal_title")))
          ])
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "modal-card-body px-0 py-0" }, [
          _c(
            "table",
            { staticClass: "table is-striped is-hoverable is-fullwidth mb-0" },
            [
              _c("thead", [
                _c("tr", [
                  _c("th", {
                    attrs: { colspan: "3" },
                    domProps: {
                      textContent: _vm._s(_vm.$t("my_availabilities"))
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(
                  _vm._.sortBy(_vm.fileredAvailabilities, ["date", "time"]),
                  function(availability) {
                    return _c(
                      "tr",
                      {
                        staticClass: "clickable",
                        class: {
                          "is-selected":
                            _vm.selectedAvailability &&
                            _vm.selectedAvailability.id == availability.id
                        },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.selectAvailability(availability)
                          }
                        }
                      },
                      [
                        _c(
                          "th",
                          {
                            staticStyle: {
                              "min-width": "125px",
                              width: "125px"
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm._f("momentFormat")(
                                  availability.date,
                                  "YYYY-MM-DD",
                                  _vm.$t("availability_date_format")
                                )
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", { staticStyle: { width: "100%" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.timeSlots[availability.time].start +
                                " - " +
                                _vm.timeSlots[availability.time].end
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "min-width": "125px",
                              width: "125px"
                            }
                          },
                          [
                            _vm.selectedAvailability &&
                            _vm.selectedAvailability.id == availability.id
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "tag is-fullwidth is-success is-small"
                                  },
                                  [
                                    _vm._m(0, true),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("selected")) +
                                        "\n                            "
                                    )
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass:
                                      "tag is-fullwidth is-primary is-small"
                                  },
                                  [
                                    _vm._m(1, true),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("select")) +
                                        "\n                            "
                                    )
                                  ]
                                )
                          ]
                        )
                      ]
                    )
                  }
                ),
                0
              ),
              _vm._v(" "),
              _c("thead", [
                _c("tr", [
                  _c("th", {
                    attrs: { colspan: "3" },
                    domProps: {
                      textContent: _vm._s(_vm.$t("other_availabilities"))
                    }
                  })
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.dates, function(date) {
                return _c(
                  "tbody",
                  [
                    !_vm.showEarlySlots && _vm.timeslotIsInFuture(date, 32)
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "has-text-centered clickable",
                              attrs: { colspan: "3" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.toggleEarlySlots()
                                }
                              }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "is-size-7",
                                  attrs: { href: "#" }
                                },
                                [_vm._v(_vm._s(_vm.$t("show_early_slots")))]
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(
                      _vm._.filter(_vm.timeSlots, function(time, key) {
                        return (
                          _vm.timeslotIsVisible(key) &&
                          _vm.timeslotIsAvailable(date, key) &&
                          _vm.timeslotIsInFuture(date, key)
                        )
                      }),
                      function(slot) {
                        return _c(
                          "tr",
                          {
                            staticClass: "clickable",
                            class: {
                              "is-selected":
                                _vm.selectedDate == date &&
                                _vm.selectedTimeslot == slot
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.selectDateAndTimeslot(date, slot)
                              }
                            }
                          },
                          [
                            _c(
                              "th",
                              {
                                staticStyle: {
                                  "min-width": "125px",
                                  width: "125px"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("momentFormat")(
                                      date,
                                      "YYYY-MM-DD",
                                      _vm.$t("availability_date_format")
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("td", { staticStyle: { width: "100%" } }, [
                              _vm._v(_vm._s(slot.start + " - " + slot.end))
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              {
                                staticStyle: {
                                  "min-width": "125px",
                                  width: "125px"
                                }
                              },
                              [
                                _vm.selectedDate == date &&
                                _vm.selectedTimeslot == slot
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "tag is-fullwidth is-success is-small"
                                      },
                                      [
                                        _vm._m(2, true),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.$t("selected")) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "tag is-fullwidth is-primary is-small"
                                      },
                                      [
                                        _vm._m(3, true),
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.$t("select")) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                              ]
                            )
                          ]
                        )
                      }
                    ),
                    _vm._v(" "),
                    !_vm.showLateSlots
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "has-text-centered clickable",
                              attrs: { colspan: "3" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.toggleLateSlots()
                                }
                              }
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "is-size-7",
                                  attrs: { href: "#" }
                                },
                                [_vm._v(_vm._s(_vm.$t("show_late_slots")))]
                              )
                            ]
                          )
                        ])
                      : _vm._e()
                  ],
                  2
                )
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c("footer", { staticClass: "modal-card-foot" }, [
          _c(
            "button",
            {
              staticClass: "button",
              attrs: { type: "button", disabled: _vm.isModalLoading },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.close()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("cancel_button_label")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button is-primary",
              class: { "is-loading": _vm.isModalLoading },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.confirm()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("accept_modal_confirm_button_label")))]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-check-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-check-circle-outline" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-check-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-check-circle-outline" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59c39f26", esExports)
  }
}

/***/ }),
/* 641 */,
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emergencies" },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column is-3" },
            [_c("app-sidebar"), _vm._v(" "), _c("onboarding")],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "column is-9" },
            [
              !_vm.currentOffice
                ? _c("div", { staticClass: "section mt-5 mb-10" }, [
                    _c("p", { staticClass: "is-aligned-center" }, [
                      _vm._v(_vm._s(_vm.$t("no_office_selected")))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.offices, function(office) {
                return _vm.currentOffice == office.id
                  ? _c("div", { key: office.id, staticClass: "mt-7" }, [
                      _c("div", { staticClass: "is-clearfix mb-3" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "button is-primary is-outlined is-pulled-right has-icon",
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.refreshEmergencies()
                              }
                            }
                          },
                          [
                            _c("b-icon", { attrs: { icon: "refresh" } }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("refresh_button_label")))
                            ])
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.doctor.isCertified
                        ? _c("div", [
                            _c("div", { staticClass: "section p-4 mb-10" }, [
                              _c("p", { staticClass: "has-text-center" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("doctor_not_certified_warning"))
                                )
                              ])
                            ])
                          ])
                        : _c(
                            "div",
                            [
                              Object.keys(_vm.emergencies).length == 0
                                ? _c(
                                    "div",
                                    { staticClass: "section p-4 mb-10" },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "has-text-center" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "no_emergencies_placeholder"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._l(_vm.emergencies, function(emergency, key) {
                                return _c(
                                  "article",
                                  {
                                    key: key,
                                    staticClass: "card",
                                    attrs: { id: "emergency-" + key }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "card-header clickable",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.selectEmergency(
                                              key,
                                              true
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-header-title" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "media" },
                                              [
                                                emergency.pictures.length > 0
                                                  ? _c(
                                                      "figure",
                                                      {
                                                        staticClass:
                                                          "image thumbnail is-128x128 is-inline-block mr-3"
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              emergency
                                                                .pictures[0],
                                                            alt: "Image Preview"
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "media-content"
                                                  },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "title is-6"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "patient_header",
                                                              {
                                                                age:
                                                                  emergency.patientAge,
                                                                locality:
                                                                  emergency.locality
                                                              }
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "h4",
                                                      {
                                                        staticClass:
                                                          "subtitle is-7"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.timeAgo(
                                                              emergency.dateTimeCreated,
                                                              "X"
                                                            )
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "a",
                                          { staticClass: "card-header-icon" },
                                          [
                                            _c("b-icon", {
                                              attrs: {
                                                icon:
                                                  _vm.openedEmergency == key
                                                    ? "arrow-drop-down"
                                                    : "arrow-drop-up"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.openedEmergency == key,
                                            expression: "openedEmergency == key"
                                          }
                                        ]
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "content" },
                                              [
                                                _c(
                                                  "h5",
                                                  { staticClass: "title is-5" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "patient_symptoms_title"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "columns is-multiline"
                                                  },
                                                  _vm._l(
                                                    emergency.symptoms,
                                                    function(symptom) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "column is-6"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "field"
                                                            },
                                                            [
                                                              _c("label", {
                                                                domProps: {
                                                                  textContent: _vm._s(
                                                                    symptom.question
                                                                  )
                                                                }
                                                              }),
                                                              _vm._v(" "),
                                                              _c(
                                                                "p",
                                                                {
                                                                  staticClass:
                                                                    "is-size-7"
                                                                },
                                                                [
                                                                  _c("strong", {
                                                                    domProps: {
                                                                      textContent: _vm._s(
                                                                        symptom.answer
                                                                      )
                                                                    }
                                                                  })
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                                _vm._v(" "),
                                                _c("hr"),
                                                _vm._v(" "),
                                                _c(
                                                  "h5",
                                                  { staticClass: "title is-5" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "patient_information_title"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "columns is-multiline"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "column is-4"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "field"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "patient_age_label"
                                                                  )
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "is-size-7"
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      emergency.patientAge
                                                                        ? emergency.patientAge
                                                                        : "N/A"
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "column is-4"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "field"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "patient_locality_label"
                                                                  )
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "is-size-7"
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      emergency.locality
                                                                        ? emergency.locality
                                                                        : "N/A"
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "column is-4"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "field"
                                                          },
                                                          [
                                                            _c("label", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "patient_zip_code_label"
                                                                  )
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "p",
                                                              {
                                                                staticClass:
                                                                  "is-size-7"
                                                              },
                                                              [
                                                                _c("strong", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      emergency.zipCode
                                                                        ? emergency.zipCode
                                                                        : "N/A"
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("hr"),
                                                _vm._v(" "),
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass:
                                                      "title is-5 mb-0"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("pictures_title")
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                emergency.pictures.length == 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "message is-warning mt-3"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "message-body"
                                                          },
                                                          [
                                                            _c("b-icon", {
                                                              attrs: {
                                                                icon: "alert"
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "no_pictures_placeholder"
                                                                  )
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _vm._l(
                                                  emergency.pictures,
                                                  function(picture) {
                                                    return _c(
                                                      "figure",
                                                      {
                                                        staticClass:
                                                          "image thumbnail is-128x128 is-inline-block",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.showPicture(
                                                              picture
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src: picture,
                                                            alt: _vm.$t(
                                                              "picture_alt"
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  }
                                                ),
                                                _vm._v(" "),
                                                _c("hr"),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "button is-primary has-icon",
                                                    attrs: {
                                                      disabled: !_vm.loadedAvailabilities
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        $event.preventDefault()
                                                        return _vm.acceptEmergency(
                                                          key
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("b-icon", {
                                                      attrs: {
                                                        icon: "check-circle"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "accept_emergency_button_label"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                    ])
                  : _vm._e()
              })
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c("accept-emergency-form", {
        attrs: {
          active: _vm.showAcceptModal,
          emergency: _vm.selectedEmergency,
          availabilities: _vm.availabilities
        },
        on: {
          close: function($event) {
            return _vm.toggleEmergencyForm(false)
          },
          accepted: function($event) {
            return _vm.refresh()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c9acf8f", esExports)
  }
}

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__ = __webpack_require__(353);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f2057c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__ = __webpack_require__(762);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f2057c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/Search.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-77f2057c", Component.options)
  } else {
    hotAPI.reload("data-v-77f2057c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "relative flex items-end" }, [
    _c("img", {
      staticClass: "mr-4",
      attrs: { src: "/static/img/mascot/z.png", alt: "Tood", width: "70px" }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "bubble px-4 py-2 leading-normal" },
      [_vm._t("default")],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fc78bb4", esExports)
  }
}

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchForm_vue__ = __webpack_require__(356);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efc7f1b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchForm_vue__ = __webpack_require__(748);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SearchForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_efc7f1b4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SearchForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/SearchForm.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-efc7f1b4", Component.options)
  } else {
    hotAPI.reload("data-v-efc7f1b4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "flex flex-wrap md:flex-no-wrap flex-row -mx-2",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.submit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "w-full md:w-1/2 md:px-2" }, [
        _c("div", { staticClass: "relative" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.type,
                  expression: "type"
                }
              ],
              staticClass:
                "appearance-none bg-white pl-4 pr-8 py-3 text-grey-darker rounded w-full block mb-3 outline-0",
              attrs: { required: "" },
              on: {
                change: function($event) {
                  var $$selectedVal = Array.prototype.filter
                    .call($event.target.options, function(o) {
                      return o.selected
                    })
                    .map(function(o) {
                      var val = "_value" in o ? o._value : o.value
                      return val
                    })
                  _vm.type = $event.target.multiple
                    ? $$selectedVal
                    : $$selectedVal[0]
                }
              }
            },
            [
              _c(
                "option",
                { attrs: { disabled: "" }, domProps: { value: null } },
                [_vm._v(_vm._s(_vm.$t("Select_a_medical_practice")))]
              ),
              _vm._v(" "),
              _vm._l(_vm.sortedTypes, function(type) {
                return _c(
                  "option",
                  { key: type.key, domProps: { value: type.key } },
                  [_vm._v(_vm._s(type.label))]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "pointer-events-none absolute pin-t h-10 pt-1 pin-r flex items-center px-2 text-grey-darker"
            },
            [
              _c(
                "svg",
                {
                  staticClass: "fill-current h-4 w-4",
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 20 20"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                    }
                  })
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "w-full md:w-1/2 md:px-2" }, [
        _c(
          "div",
          { staticClass: "relative" },
          [
            _c(
              "button",
              {
                staticClass: "absolute pin-r py-2 px-2 text-2xl",
                class:
                  _vm.isGeolocating || _vm.isGeolocated
                    ? "text-blue"
                    : "text-grey hover:text-grey-darkest",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.geolocate($event)
                  }
                }
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", {
                    staticClass: "mdi mdi-crosshairs-gps",
                    class: _vm.isGeolocating ? "animated infinite pulse" : ""
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c("gmap-autocomplete", {
              staticClass:
                "bg-white px-4 py-3 text-grey-darker rounded w-full block mb-3 outline-0 z-0",
              attrs: {
                selectFirstOnEnter: true,
                options: _vm.autocompleteOptions,
                value: _vm.isGeolocated ? "" : _vm.patientPlace,
                placeholder: _vm.patientPlace
                  ? _vm.patientPlace
                  : _vm.$t("Enter_a_location"),
                id: "search-form-field"
              },
              on: { place_changed: _vm.setPlace }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-efc7f1b4", esExports)
  }
}

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OfficeListItem_vue__ = __webpack_require__(372);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53f732c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OfficeListItem_vue__ = __webpack_require__(750);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OfficeListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53f732c7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OfficeListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/OfficeListItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-53f732c7", Component.options)
  } else {
    hotAPI.reload("data-v-53f732c7", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "group shadow mb-6 cursor-pointer text-grey-darkest leading-normal rounded",
        on: { click: _vm.handleClick }
      },
      [
        _c(
          "div",
          { staticClass: "flex items-top p-3 md:p-6 bg-white rounded-t" },
          [
            _c("avatar", {
              staticClass: "mr-2 w-10 h-10 md:w-12 md:h-12",
              attrs: {
                avatar: _vm.office.doctorAvatar,
                name:
                  _vm.office.doctorFirstName + " " + _vm.office.doctorLastName
              }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ml-4" },
              [
                _c("div", { staticClass: "flex items-center" }, [
                  _c(
                    "span",
                    { staticClass: "text-sm md:text-base font-bold" },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.office.doctorFirstName +
                            " " +
                            _vm.office.doctorLastName
                        )
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "flex items-top md:mt-1" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "text-sm text-grey font-semi-bold" },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.office.name) +
                          "\n            "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.office.zipCode) +
                          " " +
                          _vm._s(_vm.office.locality) +
                          "\n          "
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _vm.office.doctorType === "OSTEOPATH" &&
                _vm.office.isDoctorMemberOfOsteopathie
                  ? _c(
                      "div",
                      { staticClass: "tooltip flex md:mt-1 items-center" },
                      [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-sm" }, [
                          _vm._v(_vm._s(_vm.$t("Member_of_Osteopathie")))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip-text text-sm" }, [
                          _vm._v(_vm._s(_vm.$t("Oste_tooltip")))
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex mb-1" },
                  [
                    _vm.office.isDoctorRegulated &&
                    (_vm.office.doctorType !== "OSTEOPATH" &&
                      _vm.office.doctorType !== "PSYCHOLOGIST")
                      ? [
                          _vm._m(2),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-sm text-green" }, [
                            _vm._v(_vm._s(_vm.$t("Contracted_doctor")))
                          ])
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.office.isDoctorRegulated &&
                    (_vm.office.doctorType !== "OSTEOPATH" &&
                      _vm.office.doctorType !== "PSYCHOLOGIST")
                      ? [
                          _vm._m(3),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-sm text-red" }, [
                            _vm._v(_vm._s(_vm.$t("Contracted_doctor_negative")))
                          ])
                        ]
                      : _vm._e()
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.office.officeSettings
                  ? _c("OfficeSettings", {
                      attrs: {
                        accessible: _vm.office.officeSettings.accessible,
                        card: _vm.office.officeSettings.card,
                        cash: _vm.office.officeSettings.cash
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "transition flex rounded-b bg-grey-light group-hover:bg-blue text-grey-darker group-hover:text-white py-1 justify-center"
          },
          [
            _c(
              "span",
              { staticClass: "uppercase tracking-wide font-semibold text-sm" },
              [_vm._v(_vm._s(_vm.$t("See_office_availabilities")))]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-lg text-grey" }, [
      _c("i", { staticClass: "mdi mdi-map-marker" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-sm text-green" }, [
      _c("i", { staticClass: "mdi mdi-check-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-sm text-green" }, [
      _c("i", { staticClass: "mdi mdi-currency-eur" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-sm text-red" }, [
      _c("i", { staticClass: "mdi mdi-currency-eur" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53f732c7", esExports)
  }
}

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerTimeslotListItem_vue__ = __webpack_require__(373);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_441d14fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerTimeslotListItem_vue__ = __webpack_require__(754);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerTimeslotListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_441d14fa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerTimeslotListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/PartnerTimeslotListItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-441d14fa", Component.options)
  } else {
    hotAPI.reload("data-v-441d14fa", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerTimeslotSelectionModal_vue__ = __webpack_require__(374);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba0882c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerTimeslotSelectionModal_vue__ = __webpack_require__(753);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerTimeslotSelectionModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ba0882c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerTimeslotSelectionModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/PartnerTimeslotSelectionModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ba0882c", Component.options)
  } else {
    hotAPI.reload("data-v-3ba0882c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.active ? "block" : "hidden" }, [
    _c("div", {
      staticClass: "fixed z-50 pin overflow-hidden bg-modal",
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.close($event)
        }
      }
    }),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass:
          "z-50 text-grey-light hover:text-grey-lightest outline-0 text-xl absolute pin-t pin-r p-2 m-2",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.close($event)
          }
        }
      },
      [_vm._m(0)]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "fixed z-50 pin-t pin-x overflow-hidden max-w-sm mx-auto mt-24 px-4 md:px-0 mb-4"
      },
      [
        _c(
          "div",
          {
            staticClass: "bg-white rounded shadow",
            on: {
              click: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "flex items-top p-3 md:p-6 bg-white rounded-t" },
              [
                _c("partner-avatar", {
                  staticClass: "mr-2 w-10 h-10 md:w-12 md:h-12",
                  attrs: { "external-url": _vm.partner.doctorAvatar }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "ml-4" }, [
                  _c("div", { staticClass: "flex items-center" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-sm md:text-base" }, [
                      _vm._v(
                        _vm._s(_vm.partner.officeZipCode) +
                          " " +
                          _vm._s(_vm.partner.officeLocality)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex items-center md:mt-1" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-sm md:text-base" }, [
                      _vm._v(
                        _vm._s(
                          _vm.partner.doctorFirstName +
                            " " +
                            _vm.partner.doctorLastName
                        )
                      )
                    ])
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "uppercase tracking-wide text-grey-darker text-sm font-semibold px-3 md:px-6 mb-4"
              },
              [_vm._v(_vm._s(_vm.$t("Select_an_availability")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "max-h-timeslots overflow-scroll" },
              [
                _vm._l(_vm.sortedTimeslots, function(timeslot) {
                  return _c(
                    "router-link",
                    {
                      key: timeslot.id,
                      staticClass:
                        "block w-full border-t px-6 py-3 hover:bg-grey-lightest text-grey-darker",
                      attrs: {
                        to: {
                          name: "partner-timeslot.show",
                          query: {
                            doctorId: timeslot.doctorId,
                            dateTime: timeslot.dateTime,
                            medicalPractice: timeslot.medicalPractice,
                            latitude: timeslot.officeLatitude,
                            longitude: timeslot.officeLongitude
                          }
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("momentFormatTimestamp")(
                              timeslot.dateTime,
                              _vm.$t("date_selector_format") +
                                " [" +
                                _vm.$t("at") +
                                "] " +
                                _vm.$t("time_format")
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "py-1 rounded-b border-t" })
              ],
              2
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-lg text-red-light" }, [
      _c("i", { staticClass: "mdi mdi-map-marker" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-lg text-blue-light" }, [
      _c("i", { staticClass: "mdi mdi-account" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ba0882c", esExports)
  }
}

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "partner shadow mb-6 cursor-pointer text-grey-darkest leading-normal rounded",
          on: { click: _vm.handleClick }
        },
        [
          _c(
            "div",
            { staticClass: "flex items-top p-3 md:p-6 bg-white rounded-t" },
            [
              _c("partner-avatar", {
                staticClass: "mr-2 w-10 h-10 md:w-12 md:h-12",
                attrs: { "external-url": _vm.item.doctorAvatar }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml-4" },
                [
                  _c("div", { staticClass: "flex items-center md:mt-1" }, [
                    _c(
                      "span",
                      { staticClass: "text-sm md:text-base font-bold" },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.item.doctorFirstName +
                              " " +
                              _vm.item.doctorLastName
                          )
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex items-center" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "text-sm text-grey font-semi-bold" },
                      [
                        _vm._v(
                          _vm._s(_vm.item.officeZipCode) +
                            " " +
                            _vm._s(_vm.item.officeLocality)
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex mb-4" },
                    [
                      _vm.item.isDoctorRegulated &&
                      (_vm.item.medicalPractice !== "OSTEOPATH" &&
                        _vm.item.medicalPractice !== "PSYCHOLOGIST")
                        ? [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-sm text-green" }, [
                              _vm._v(_vm._s(_vm.$t("Contracted_doctor")))
                            ])
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.item.isDoctorRegulated &&
                      (_vm.item.medicalPractice !== "OSTEOPATH" &&
                        _vm.item.medicalPractice !== "PSYCHOLOGIST")
                        ? [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-sm text-red" }, [
                              _vm._v(
                                _vm._s(_vm.$t("Contracted_doctor_negative"))
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.sortedSlots, function(slot, index) {
                    return _c(
                      "div",
                      {
                        key: slot.id,
                        staticClass: "flex items-center md:mt-1"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "icon mr-2 text-lg",
                            class:
                              index == 0 ? "text-grey-darkest" : "text-white"
                          },
                          [_c("i", { staticClass: "mdi mdi-calendar-check" })]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-sm md:text-base" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("momentFormatTimestamp")(
                                slot.dateTime,
                                _vm.$t("date_selector_format") +
                                  " [" +
                                  _vm.$t("at") +
                                  "] " +
                                  _vm.$t("time_format")
                              )
                            )
                          )
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.sortedSlots.length < _vm.item.timeslots.length
                    ? _c("div", { staticClass: "flex items-center md:mt-1" }, [
                        _vm._m(3),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "text-sm md:text-base text-grey-dark"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("x_more_availabilities", {
                                  count:
                                    _vm.item.timeslots.length -
                                    _vm.sortedSlots.length
                                })
                              )
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "transition flex rounded-b bg-grey-light partner-hover:bg-blue text-grey-darker partner-hover:text-white py-1 justify-center"
            },
            [
              _c(
                "span",
                {
                  staticClass: "uppercase tracking-wide font-semibold text-sm"
                },
                [_vm._v(_vm._s(_vm.$t("Detail_of_the_appointment")))]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("partner-timeslot-selection-modal", {
        attrs: { active: _vm.showTimeslotSelection, partner: _vm.item },
        on: { close: _vm.hideTimeslotSelectionModal }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-lg text-grey" }, [
      _c("i", { staticClass: "mdi mdi-map-marker" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-sm text-green" }, [
      _c("i", { staticClass: "mdi mdi-currency-eur" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-sm text-red" }, [
      _c("i", { staticClass: "mdi mdi-currency-eur" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-lg text-white" }, [
      _c("i", { staticClass: "mdi mdi-calendar-check" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-441d14fa", esExports)
  }
}

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerOfficeListItem_vue__ = __webpack_require__(375);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4525f56b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerOfficeListItem_vue__ = __webpack_require__(756);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerOfficeListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4525f56b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerOfficeListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/PartnerOfficeListItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4525f56b", Component.options)
  } else {
    hotAPI.reload("data-v-4525f56b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "group shadow mb-6 cursor-pointer text-grey-darkest leading-normal rounded",
        on: { click: _vm.handleClick }
      },
      [
        _c(
          "div",
          { staticClass: "flex items-top p-3 md:p-6 bg-white rounded-t" },
          [
            _c("partner-avatar", {
              staticClass: "mr-2 w-10 h-10 md:w-12 md:h-12",
              attrs: { "external-url": _vm.office.doctorAvatar }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "ml-4" }, [
              _c("div", { staticClass: "flex items-center" }, [
                _c("span", { staticClass: "text-sm md:text-base font-bold" }, [
                  _vm._v(
                    _vm._s(
                      _vm.office.doctorFirstName +
                        " " +
                        _vm.office.doctorLastName
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex items-top md:mt-1" }, [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "text-sm text-grey font-semi-bold" },
                  [
                    _vm._v(
                      _vm._s(_vm.office.officeZipCode) +
                        " " +
                        _vm._s(_vm.office.officeLocality)
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex" },
                [
                  _vm.office.isDoctorRegulated &&
                  (_vm.office.medicalPractice !== "OSTEOPATH" &&
                    _vm.office.medicalPractice !== "PSYCHOLOGIST")
                    ? [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-sm text-green" }, [
                          _vm._v(_vm._s(_vm.$t("Contracted_doctor")))
                        ])
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.office.isDoctorRegulated &&
                  (_vm.office.medicalPractice !== "OSTEOPATH" &&
                    _vm.office.medicalPractice !== "PSYCHOLOGIST")
                    ? [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-sm text-red" }, [
                          _vm._v(_vm._s(_vm.$t("Contracted_doctor_negative")))
                        ])
                      ]
                    : _vm._e()
                ],
                2
              )
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "transition flex rounded-b bg-grey-light group-hover:bg-blue text-grey-darker group-hover:text-white py-1 justify-center"
          },
          [
            _c(
              "span",
              { staticClass: "uppercase tracking-wide font-semibold text-sm" },
              [_vm._v(_vm._s(_vm.$t("See_office_availabilities")))]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-sm text-grey" }, [
      _c("i", { staticClass: "mdi mdi-map-marker" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-sm text-green" }, [
      _c("i", { staticClass: "mdi mdi-currency-eur" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-sm text-red" }, [
      _c("i", { staticClass: "mdi mdi-currency-eur" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4525f56b", esExports)
  }
}

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeslotGroupListItem_vue__ = __webpack_require__(376);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff6f4a8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeslotGroupListItem_vue__ = __webpack_require__(760);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeslotGroupListItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff6f4a8a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeslotGroupListItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/TimeslotGroupListItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ff6f4a8a", Component.options)
  } else {
    hotAPI.reload("data-v-ff6f4a8a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeslotSelectionModal_vue__ = __webpack_require__(377);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270bdd46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeslotSelectionModal_vue__ = __webpack_require__(759);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeslotSelectionModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_270bdd46_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeslotSelectionModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/TimeslotSelectionModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-270bdd46", Component.options)
  } else {
    hotAPI.reload("data-v-270bdd46", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.active ? "block" : "hidden" }, [
    _c("div", {
      staticClass: "fixed z-50 pin overflow-hidden bg-modal",
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.close($event)
        }
      }
    }),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass:
          "z-50 text-grey-light hover:text-grey-lightest outline-0 text-xl absolute pin-t pin-r p-2 m-2",
        on: {
          click: function($event) {
            $event.preventDefault()
            return _vm.close($event)
          }
        }
      },
      [_vm._m(0)]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "fixed z-50 pin-t pin-x overflow-hidden max-w-sm mx-auto mt-24 px-4 md:px-0 mb-4"
      },
      [
        _c(
          "div",
          {
            staticClass: "bg-white rounded shadow",
            on: {
              click: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c(
              "div",
              { staticClass: "flex items-top p-3 md:p-6 bg-white rounded-t" },
              [
                _c("avatar", {
                  staticClass: "mr-2 w-10 h-10 md:w-12 md:h-12",
                  attrs: {
                    avatar: _vm.group.doctorAvatar,
                    name:
                      _vm.group.doctorFirstName + " " + _vm.group.doctorLastName
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "ml-4" }, [
                  _c("div", { staticClass: "flex items-center" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-sm md:text-base" }, [
                      _vm._v(
                        _vm._s(_vm.group.officeZipCode) +
                          " " +
                          _vm._s(_vm.group.officeLocality)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex items-center md:mt-1" }, [
                    _vm._m(2),
                    _vm._v(" "),
                    _c("span", { staticClass: "text-sm md:text-base" }, [
                      _vm._v(
                        _vm._s(
                          _vm.group.doctorFirstName +
                            " " +
                            _vm.group.doctorLastName
                        )
                      )
                    ])
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "uppercase tracking-wide text-grey-darker text-sm font-semibold px-3 md:px-6 mb-4"
              },
              [_vm._v(_vm._s(_vm.$t("Select_an_availability")))]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "max-h-timeslots overflow-scroll" },
              [
                _vm._l(_vm.sortedTimeslots, function(timeslot) {
                  return _c(
                    "router-link",
                    {
                      key: timeslot.id,
                      staticClass:
                        "block w-full border-t px-6 py-3 hover:bg-grey-lightest text-grey-darker",
                      attrs: {
                        to: {
                          name: "timeslot.show",
                          params: { id: timeslot.id }
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm._f("momentFormat")(
                              timeslot.date,
                              "YYYY-MM-DD",
                              _vm.$t("date_selector_format")
                            )
                          ) +
                          " " +
                          _vm._s(_vm.$t("at")) +
                          " " +
                          _vm._s(
                            _vm._f("momentFormatTime")(
                              timeslot.time,
                              _vm.$t("time_format")
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "py-1 rounded-b border-t" })
              ],
              2
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-lg text-red-light" }, [
      _c("i", { staticClass: "mdi mdi-map-marker" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-lg text-blue-light" }, [
      _c("i", { staticClass: "mdi mdi-account" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-270bdd46", esExports)
  }
}

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "group shadow mb-6 cursor-pointer text-grey-darkest leading-normal rounded",
          on: { click: _vm.handleClick }
        },
        [
          _c(
            "div",
            { staticClass: "flex items-top p-3 md:p-6 bg-white rounded-t" },
            [
              _c("avatar", {
                staticClass: "mr-2 w-10 h-10 md:w-12 md:h-12",
                attrs: {
                  avatar: _vm.item.doctorAvatar,
                  name: _vm.item.doctorFirstName + " " + _vm.item.doctorLastName
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml-4" },
                [
                  _c("div", { staticClass: "flex items-center md:mt-1" }, [
                    _c("span", { staticClass: "text-sm font-bold" }, [
                      _vm._v(
                        _vm._s(
                          _vm.item.doctorFirstName +
                            " " +
                            _vm.item.doctorLastName
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex items-center" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "text-sm text-grey font-semi-bold" },
                      [
                        _vm._v(
                          _vm._s(_vm.item.officeZipCode) +
                            " " +
                            _vm._s(_vm.item.officeLocality)
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.item.foundOffice &&
                  _vm.item.foundOffice.isDoctorMemberOfOsteopathie
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "tooltip text-green font-semibold text-sm mt-1 mb-2"
                        },
                        [
                          _c("i", { staticClass: "mdi mdi-check-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("Member_of_Osteopathie")) +
                              "\n                    "
                          ),
                          _c("span", { staticClass: "tooltip-text text-sm" }, [
                            _vm._v(_vm._s(_vm.$t("Oste_tooltip")))
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex mb-1" },
                    [
                      _vm.item.isDoctorRegulated &&
                      (_vm.item.type !== "OSTEOPATH" &&
                        _vm.item.type !== "PSYCHOLOGIST")
                        ? [
                            _vm._m(1),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-sm text-green" }, [
                              _vm._v(_vm._s(_vm.$t("Contracted_doctor")))
                            ])
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.item.isDoctorRegulated &&
                      (_vm.item.type !== "OSTEOPATH" &&
                        _vm.item.type !== "PSYCHOLOGIST")
                        ? [
                            _vm._m(2),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-sm text-red" }, [
                              _vm._v(
                                _vm._s(_vm.$t("Contracted_doctor_negative"))
                              )
                            ])
                          ]
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _vm.item.foundOffice && _vm.item.foundOffice.officeSettings
                    ? _c("OfficeSettings", {
                        attrs: {
                          accessible:
                            _vm.item.foundOffice.officeSettings.accessible,
                          card: _vm.item.foundOffice.officeSettings.card,
                          cash: _vm.item.foundOffice.officeSettings.cash
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.sortedSlots, function(slot, index) {
                    return _c(
                      "div",
                      {
                        key: slot.id,
                        staticClass: "flex items-center md:mt-1"
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "icon mr-2 text-lg",
                            class:
                              index == 0 ? "text-grey-darkest" : "text-white"
                          },
                          [_c("i", { staticClass: "mdi mdi-calendar-check" })]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-sm md:text-base" }, [
                          _vm._v(
                            _vm._s(
                              _vm._f("momentFormat")(
                                slot.date,
                                "YYYY-MM-DD",
                                _vm.$t("date_selector_format")
                              )
                            ) +
                              " " +
                              _vm._s(_vm.$t("at")) +
                              " " +
                              _vm._s(
                                _vm._f("momentFormatTime")(
                                  slot.time,
                                  _vm.$t("time_format")
                                )
                              )
                          )
                        ])
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.sortedSlots.length < _vm.item.timeslots.length
                    ? _c("div", { staticClass: "flex items-center md:mt-1" }, [
                        _vm._m(3),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "text-sm md:text-base text-grey-dark"
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("x_more_availabilities", {
                                  count:
                                    _vm.item.timeslots.length -
                                    _vm.sortedSlots.length
                                })
                              )
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "transition flex rounded-b bg-grey-light group-hover:bg-blue text-grey-darker group-hover:text-white py-1 justify-center"
            },
            [
              _c(
                "span",
                {
                  staticClass: "uppercase tracking-wide font-semibold text-sm"
                },
                [_vm._v(_vm._s(_vm.$t("Detail_of_the_appointment")))]
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("timeslot-selection-modal", {
        attrs: { active: _vm.showTimeslotSelection, group: _vm.item },
        on: { close: _vm.hideTimeslotSelectionModal }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-sm text-grey" }, [
      _c("i", { staticClass: "mdi mdi-map-marker" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-sm text-green" }, [
      _c("i", { staticClass: "mdi mdi-currency-eur" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-sm text-red" }, [
      _c("i", { staticClass: "mdi mdi-currency-eur" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-2 text-lg text-white" }, [
      _c("i", { staticClass: "mdi mdi-calendar-check" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ff6f4a8a", esExports)
  }
}

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      staticClass:
        "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide block text-center w-full px-4 py-3 mt-3",
      attrs: { to: { name: "emergency.new", query: _vm.$route.query } }
    },
    [_vm._v(_vm._s(_vm.$t("Enable_the_appointment_alert")))]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14fa5973", esExports)
  }
}

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "section",
      { staticClass: "py-12", attrs: { id: "heading" } },
      [
        _c("header-nav"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "max-w-md mx-auto px-6" },
          [
            _c("search-form", {
              staticClass: "mt-16",
              on: { submit: _vm.search },
              model: {
                value: _vm.searchForm,
                callback: function($$v) {
                  _vm.searchForm = $$v
                },
                expression: "searchForm"
              }
            }),
            _vm._v(" "),
            _vm.searchForm.type === "OSTEOPATH"
              ? _c(
                  "div",
                  { staticClass: "text-white" },
                  [
                    _c(
                      "b-checkbox",
                      {
                        model: {
                          value: _vm.isDoctorMemberOfOsteopathie,
                          callback: function($$v) {
                            _vm.isDoctorMemberOfOsteopathie = $$v
                          },
                          expression: "isDoctorMemberOfOsteopathie"
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("Member_of_Osteopathie")) +
                            "\n        "
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "py-12" },
      [
        _c(
          "div",
          { staticClass: "max-w-sm mx-auto text-left mb-6" },
          [
            _vm.userId &&
            (_vm.hasAppointments || _vm.hasInvitations || _vm.hasEmergencies)
              ? _c(
                  "router-link",
                  {
                    staticClass: "text-grey hover:text-black p-2",
                    attrs: { to: "/" }
                  },
                  [
                    _c("span", { staticClass: "icon" }, [
                      _c("i", { staticClass: "mdi mdi-arrow-left" })
                    ]),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("Your_appointments")) +
                        "\n      "
                    )
                  ]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.loadingTimeslots
          ? _c("patient-loading")
          : _c("div", { staticClass: "max-w-sm mx-auto px-6" }, [
              _vm.sortedMixAvailabilities.length == 0
                ? _c("div", [
                    !(_vm.patientPosition || _vm.searchForm.place)
                      ? _c(
                          "div",
                          [
                            _c("bubble", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "Please_give_your_location_to_look_for_doctors_in_your_region"
                                  )
                                )
                              )
                            ])
                          ],
                          1
                        )
                      : !_vm.searchForm.type
                      ? _c(
                          "div",
                          [
                            _c("bubble", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Please_select_a_medical_practice")
                                )
                              )
                            ])
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _c(
                    "div",
                    { staticClass: "mb-12" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "uppercase tracking-wide text-grey-darker text-sm font-semibold mb-6"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Available_X", { type: _vm.pluralType })
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.sortedMixAvailabilities, function(item, key) {
                        return [
                          _c(item.component, {
                            key: key,
                            tag: "component",
                            attrs: { item: item }
                          }),
                          _vm._v(" "),
                          [1, 3, 5].includes(key) &&
                          _vm.sortedMixAvailabilities.length > key
                            ? [
                                _c("dfp-slot", {
                                  staticClass: "mb-6",
                                  attrs: {
                                    path:
                                      "/21865209613/Patients/PatientsSearchResults",
                                    size: [300, 250],
                                    id: "div-gpt-ad-1575389215612-" + key
                                  }
                                })
                              ]
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  ),
              _vm._v(" "),
              _vm.sortedMixOffices.length > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "uppercase tracking-wide text-grey-darker text-sm font-semibold mb-6"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("X_near_Y", {
                                location: _vm.patientPlaceName
                                  ? _vm.patientPlaceName
                                  : _vm.patientPlace,
                                type: _vm.pluralType
                              })
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.sortedMixOffices, function(item, key) {
                        return _c(item.component, {
                          key: key,
                          tag: "component",
                          attrs: { office: item }
                        })
                      })
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.loadingTimeslots &&
              (_vm.patientPosition || _vm.searchForm.place) &&
              _vm.searchForm.type &&
              _vm.sortedMixAvailabilities.length == 0 &&
              _vm.sortedMixOffices.length == 0
                ? _c("div", [
                    _c(
                      "p",
                      {
                        staticClass:
                          "text-center mb-10 text-grey-darker leading-normal"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("No_x_is_currently_available_in_Y", {
                              type: _vm
                                .$t("type_" + _vm.searchForm.type)
                                .toLowerCase(),
                              location: _vm.patientPlaceName
                                ? _vm.patientPlaceName
                                : _vm.patientPlace
                            })
                          )
                        )
                      ]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.loadingTimeslots &&
              (_vm.patientPosition || _vm.searchForm.place) &&
              _vm.searchForm.type
                ? _c(
                    "div",
                    [
                      _c("bubble", [
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "You_did_not_find_an_appointment_Activate_the_alert_and_I_will_inform_you_"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _vm.hasEmergencies && !_vm.loadingEmergencies
                          ? _c("p", { staticClass: "mt-2" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("You_are_already_in_the_waiting_list")
                                )
                              )
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      !_vm.hasEmergencies && !_vm.loadingEmergencies
                        ? _c("waiting-list-button")
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77f2057c", esExports)
  }
}

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmergencyNew_vue__ = __webpack_require__(380);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56fbd8e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmergencyNew_vue__ = __webpack_require__(765);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmergencyNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56fbd8e9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmergencyNew_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/EmergencyNew.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-56fbd8e9", Component.options)
  } else {
    hotAPI.reload("data-v-56fbd8e9", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 764 */,
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-grey-lightest" }, [
    _c(
      "section",
      { staticClass: "pt-12 pb-24", attrs: { id: "heading" } },
      [_c("header-nav", { ref: "headerNav" })],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "py-12" }, [
      _c("div", { staticClass: "max-w-sm mx-auto px-6" }, [
        _c("div", { staticClass: "rounded bg-white shadow relative -mt-24" }, [
          _vm.step == "patientForm"
            ? _c(
                "form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.submitPatientForm($event)
                    }
                  }
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                      attrs: { to: { path: "/" } }
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "mdi mdi-arrow-left" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "p-6 pt-12" }, [
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Firstname_")))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.patientForm.firstName,
                            expression: "patientForm.firstName"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass:
                          "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                        class: { "border-red": _vm.errors.has("first_name") },
                        attrs: { name: "first_name", type: "text" },
                        domProps: { value: _vm.patientForm.firstName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.patientForm,
                              "firstName",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("first_name"),
                              expression: "errors.has('first_name')"
                            }
                          ],
                          staticClass: "text-xs text-red font-semibold"
                        },
                        [_vm._v(_vm._s(_vm.$t("Please_fill_your_first_name")))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Lastname_")))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.patientForm.lastName,
                            expression: "patientForm.lastName"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        staticClass:
                          "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                        class: { "border-red": _vm.errors.has("last_name") },
                        attrs: { name: "last_name", type: "text" },
                        domProps: { value: _vm.patientForm.lastName },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.patientForm,
                              "lastName",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("last_name"),
                              expression: "errors.has('last_name')"
                            }
                          ],
                          staticClass: "text-xs text-red font-semibold"
                        },
                        [_vm._v(_vm._s(_vm.$t("Please_fill_your_last_name")))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Age_")))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.patientForm.age,
                            expression: "patientForm.age"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|numeric",
                            expression: "'required|numeric'"
                          }
                        ],
                        staticClass:
                          "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                        class: {
                          "border-red": _vm.errors.has("patientForm.age")
                        },
                        attrs: {
                          name: "patientForm.age",
                          type: "number",
                          step: "1",
                          min: "0"
                        },
                        domProps: { value: _vm.patientForm.age },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.patientForm,
                              "age",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("patientForm.age"),
                              expression: "errors.has('patientForm.age')"
                            }
                          ],
                          staticClass: "text-xs text-red font-semibold"
                        },
                        [_vm._v(_vm._s(_vm.$t("Please_fill_your_age")))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Medical_practice_")))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "relative" }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.patientForm.type,
                                expression: "patientForm.type"
                              }
                            ],
                            staticClass:
                              "appearance-none bg-grey-lightest border pl-3 pr-8 py-2 text-grey-darker rounded w-full block outline-0",
                            attrs: { required: "" },
                            on: {
                              change: function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.patientForm,
                                  "type",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              }
                            }
                          },
                          [
                            _c(
                              "option",
                              {
                                attrs: { disabled: "" },
                                domProps: { value: null }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Select_a_medical_practice"))
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.types, function(type) {
                              return _c(
                                "option",
                                { key: type, domProps: { value: type } },
                                [_vm._v(_vm._s(_vm.$t("type_" + type)))]
                              )
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "pointer-events-none absolute pin-t pt-3 pin-r flex items-center px-2 text-grey-darker"
                          },
                          [
                            _c(
                              "svg",
                              {
                                staticClass: "fill-current h-4 w-4",
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 20 20"
                                }
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d:
                                      "M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mb-4" },
                      [
                        _c(
                          "label",
                          {
                            staticClass:
                              "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                          },
                          [_vm._v(_vm._s(_vm.$t("Locality_")))]
                        ),
                        _vm._v(" "),
                        _c("gmap-autocomplete", {
                          staticClass:
                            "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                          class: { "border-red": _vm.errors.has("locality") },
                          attrs: {
                            selectFirstOnEnter: true,
                            options: _vm.autocompleteOptions,
                            value: _vm.patientForm.locality,
                            placeholder: _vm.patientForm.locality
                              ? _vm.patientForm.locality
                              : _vm.$t("Enter_a_location"),
                            id: "search-form-field"
                          },
                          on: { place_changed: _vm.setPatientFormLocality }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.errors.has("locality"),
                                expression: "errors.has('locality')"
                              }
                            ],
                            staticClass: "text-xs text-red font-semibold"
                          },
                          [_vm._v(_vm._s(_vm.$t("Please_fill_your_locality")))]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.patient || _vm.patient.email === null
                      ? _c("div", { staticClass: "mb-4" }, [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                            },
                            [_vm._v(_vm._s(_vm.$t("Email_address_")))]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.patientForm.email,
                                expression: "patientForm.email"
                              },
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|email",
                                expression: "'required|email'"
                              }
                            ],
                            staticClass:
                              "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                            class: { "border-red": _vm.errors.has("email") },
                            attrs: { name: "email", type: "email" },
                            domProps: { value: _vm.patientForm.email },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.patientForm,
                                  "email",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has("email"),
                                  expression: "errors.has('email')"
                                }
                              ],
                              staticClass: "text-xs text-red font-semibold"
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Please_fill_your_email_address"))
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Phone_number_")))]
                      ),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.patientForm.phone,
                            expression: "patientForm.phone"
                          },
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|phone:BE",
                            expression: "'required|phone:BE'"
                          }
                        ],
                        staticClass:
                          "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                        class: { "border-red": _vm.errors.has("phone") },
                        attrs: { name: "phone", type: "phone" },
                        domProps: { value: _vm.patientForm.phone },
                        on: {
                          blur: _vm.transformPhone,
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.patientForm,
                              "phone",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.errors.has("phone"),
                              expression: "errors.has('phone')"
                            }
                          ],
                          staticClass: "text-xs text-red font-semibold"
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("Please_fill_your_phone_number"))
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                        attrs: { type: "submit" }
                      },
                      [_vm._v(_vm._s(_vm.$t("Next")))]
                    )
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.step == "patientSymptoms"
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass:
                      "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.changeStep("patientForm")
                      }
                    }
                  },
                  [_vm._m(0)]
                ),
                _vm._v(" "),
                _vm.sections.length > 0
                  ? _c(
                      "div",
                      { staticClass: "px-6 pt-12 pb-4" },
                      _vm._l(_vm.sections, function(section, sectionIndex) {
                        return _c(
                          "form",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: sectionIndex === _vm.currentSection,
                                expression: "sectionIndex === currentSection"
                              }
                            ],
                            key: "section-" + sectionIndex,
                            staticClass: "mb-4",
                            attrs: {
                              "data-vv-scope": "section-" + sectionIndex
                            },
                            on: {
                              submit: function($event) {
                                $event.preventDefault()
                                return _vm.nextSection($event)
                              }
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "mb-4 text-lg font-semibold" },
                              [_vm._v(_vm._s(section.title))]
                            ),
                            _vm._v(" "),
                            section.description
                              ? _c("div", {
                                  staticClass: "text-sm text-grey-dark mb-4",
                                  domProps: {
                                    innerHTML: _vm._s(section.description)
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(section.questions, function(
                              question,
                              questionIndex
                            ) {
                              return !Object.keys(question).includes(
                                "conditions"
                              ) || _vm.conditionsMatches(question, section)
                                ? _c(
                                    "div",
                                    {
                                      key: "question-" + questionIndex,
                                      staticClass: "mb-4"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-blue text-sm font-semibold mb-4"
                                        },
                                        [_vm._v(_vm._s(question.label))]
                                      ),
                                      _vm._v(" "),
                                      question.type === "checkboxes"
                                        ? [
                                            _vm._l(question.choices, function(
                                              choice,
                                              choiceIndex
                                            ) {
                                              return _c(
                                                "label",
                                                {
                                                  key: "choice-" + choiceIndex,
                                                  staticClass:
                                                    "relative flex items-center text-sm text-grey-dark group-hover:text-grey-darkest mb-2"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      type: "checkbox",
                                                      name:
                                                        "section." +
                                                        sectionIndex +
                                                        "." +
                                                        questionIndex
                                                    },
                                                    domProps: {
                                                      value: choice,
                                                      checked:
                                                        question.value.length &&
                                                        question.value.includes(
                                                          choice
                                                        )
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.toggleSymptom(
                                                          question,
                                                          choice
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(_vm._s(choice))
                                                  ])
                                                ]
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "section." +
                                                        sectionIndex +
                                                        "." +
                                                        questionIndex
                                                    ),
                                                    expression:
                                                      "errors.has(`section.${sectionIndex}.${questionIndex}`)"
                                                  }
                                                ],
                                                staticClass:
                                                  "text-xs text-red font-semibold"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Please_specify")
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      question.type === "select"
                                        ? [
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: question.value,
                                                    expression: "question.value"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                staticClass:
                                                  "appearance-none bg-grey-lightest border pl-3 pr-8 py-2 text-grey-darker rounded w-full block outline-0",
                                                attrs: {
                                                  name:
                                                    "section." +
                                                    sectionIndex +
                                                    "." +
                                                    questionIndex
                                                },
                                                on: {
                                                  change: function($event) {
                                                    var $$selectedVal = Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function(o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function(o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                    _vm.$set(
                                                      question,
                                                      "value",
                                                      $event.target.multiple
                                                        ? $$selectedVal
                                                        : $$selectedVal[0]
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  { domProps: { value: null } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Select_an_option"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm._l(
                                                  question.choices,
                                                  function(
                                                    choice,
                                                    choiceIndex
                                                  ) {
                                                    return _c(
                                                      "option",
                                                      {
                                                        key:
                                                          "choice-" +
                                                          choiceIndex,
                                                        domProps: {
                                                          value: choice
                                                        }
                                                      },
                                                      [_vm._v(_vm._s(choice))]
                                                    )
                                                  }
                                                )
                                              ],
                                              2
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "section." +
                                                        sectionIndex +
                                                        "." +
                                                        questionIndex
                                                    ),
                                                    expression:
                                                      "errors.has(`section.${sectionIndex}.${questionIndex}`)"
                                                  }
                                                ],
                                                staticClass:
                                                  "text-xs text-red font-semibold"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Please_specify")
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      question.type === "radio"
                                        ? [
                                            _vm._l(question.choices, function(
                                              choice,
                                              choiceIndex
                                            ) {
                                              return _c(
                                                "label",
                                                {
                                                  key: "choice-" + choiceIndex,
                                                  staticClass:
                                                    "relative flex items-center text-sm text-grey-dark group-hover:text-grey-darkest mb-3"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value: question.value,
                                                        expression:
                                                          "question.value"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      type: "radio",
                                                      name:
                                                        "section." +
                                                        sectionIndex +
                                                        "." +
                                                        questionIndex
                                                    },
                                                    domProps: {
                                                      value: choice,
                                                      checked: _vm._q(
                                                        question.value,
                                                        choice
                                                      )
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.$set(
                                                          question,
                                                          "value",
                                                          choice
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(_vm._s(choice))
                                                  ])
                                                ]
                                              )
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "section." +
                                                        sectionIndex +
                                                        "." +
                                                        questionIndex
                                                    ),
                                                    expression:
                                                      "errors.has(`section.${sectionIndex}.${questionIndex}`)"
                                                  }
                                                ],
                                                staticClass:
                                                  "text-xs text-red font-semibold"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Please_specify")
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      question.type === "boolean"
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex flex-wrap -mx-4"
                                              },
                                              [
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "block group mb-2 px-4"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: question.value,
                                                          expression:
                                                            "question.value"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        }
                                                      ],
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        type: "radio",
                                                        name:
                                                          "section." +
                                                          sectionIndex +
                                                          "." +
                                                          questionIndex
                                                      },
                                                      domProps: {
                                                        value: true,
                                                        checked: _vm._q(
                                                          question.value,
                                                          true
                                                        )
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            question,
                                                            "value",
                                                            true
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-sm text-grey-dark group-hover:text-grey-darkest"
                                                      },
                                                      [_vm._v("Yes")]
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "label",
                                                  {
                                                    staticClass:
                                                      "block group mb-2 px-4"
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: question.value,
                                                          expression:
                                                            "question.value"
                                                        },
                                                        {
                                                          name: "validate",
                                                          rawName: "v-validate",
                                                          value: "required",
                                                          expression:
                                                            "'required'"
                                                        }
                                                      ],
                                                      staticClass: "mr-2",
                                                      attrs: {
                                                        type: "radio",
                                                        name:
                                                          "section." +
                                                          sectionIndex +
                                                          "." +
                                                          questionIndex
                                                      },
                                                      domProps: {
                                                        value: false,
                                                        checked: _vm._q(
                                                          question.value,
                                                          false
                                                        )
                                                      },
                                                      on: {
                                                        change: function(
                                                          $event
                                                        ) {
                                                          return _vm.$set(
                                                            question,
                                                            "value",
                                                            false
                                                          )
                                                        }
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-sm text-grey-dark group-hover:text-grey-darkest"
                                                      },
                                                      [_vm._v("No")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "section." +
                                                        sectionIndex +
                                                        "." +
                                                        questionIndex
                                                    ),
                                                    expression:
                                                      "errors.has(`section.${sectionIndex}.${questionIndex}`)"
                                                  }
                                                ],
                                                staticClass:
                                                  "text-xs text-red font-semibold"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Please_specify")
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      question.type === "textarea"
                                        ? [
                                            _c("textarea", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: question.value,
                                                  expression: "question.value"
                                                },
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                }
                                              ],
                                              staticClass:
                                                "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                                              attrs: {
                                                rows: "5",
                                                name:
                                                  "section." +
                                                  sectionIndex +
                                                  "." +
                                                  questionIndex
                                              },
                                              domProps: {
                                                value: question.value
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing) {
                                                    return
                                                  }
                                                  _vm.$set(
                                                    question,
                                                    "value",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.errors.has(
                                                      "section." +
                                                        sectionIndex +
                                                        "." +
                                                        questionIndex
                                                    ),
                                                    expression:
                                                      "errors.has(`section.${sectionIndex}.${questionIndex}`)"
                                                  }
                                                ],
                                                staticClass:
                                                  "text-xs text-red font-semibold"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("Please_specify")
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        : _vm._e()
                                    ],
                                    2
                                  )
                                : _vm._e()
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                                attrs: { type: "button" },
                                on: { click: _vm.nextSection }
                              },
                              [_vm._v(_vm._s(_vm.$t("Next")))]
                            ),
                            _vm._v(" "),
                            _vm.currentSection > 0
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "bg-transparent hover:underline text-sm text-grey-darker w-full px-4 py-3 mt-2",
                                    attrs: { type: "button" },
                                    on: { click: _vm.previousSection }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Go_back")))]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      }),
                      0
                    )
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.step == "submissionSummary"
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass:
                      "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                    on: {
                      click: function($event) {
                        return _vm.changeStep("patientSymptoms")
                      }
                    }
                  },
                  [_vm._m(1)]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "px-6 py-4" }, [
                  _c(
                    "h4",
                    {
                      staticClass:
                        "text-xl uppercase tracking-wide text-grey-darkest"
                    },
                    [_vm._v(_vm._s(_vm.$t("Summary")))]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "p-6 pt-4" },
                  [
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Name")))]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "block w-full text-grey-darker",
                        domProps: {
                          textContent: _vm._s(
                            _vm.patientForm.firstName +
                              " " +
                              _vm.patientForm.lastName
                          )
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Age")))]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "block w-full text-grey-darker",
                        domProps: { textContent: _vm._s(_vm.patientForm.age) }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Locality")))]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "block w-full text-grey-darker",
                        domProps: {
                          textContent: _vm._s(_vm.patientForm.locality)
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Email_address")))]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "block w-full text-grey-darker",
                        domProps: { textContent: _vm._s(_vm.patientForm.email) }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                        },
                        [_vm._v(_vm._s(_vm.$t("Phone_number")))]
                      ),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "block w-full text-grey-darker",
                        domProps: { textContent: _vm._s(_vm.patientForm.phone) }
                      })
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.sections, function(section, sectionIndex) {
                      return _c(
                        "div",
                        { key: sectionIndex },
                        [
                          _c(
                            "div",
                            { staticClass: "mb-4 text-lg font-semibold" },
                            [_vm._v(_vm._s(section.title))]
                          ),
                          _vm._v(" "),
                          _vm._l(section.questions, function(
                            question,
                            questionIndex
                          ) {
                            return _c(
                              "div",
                              {
                                key: "question-" + questionIndex,
                                staticClass: "mb-4"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                                  },
                                  [_vm._v(_vm._s(question.label))]
                                ),
                                _vm._v(" "),
                                typeof question.value === "boolean"
                                  ? [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "block w-full text-grey-darker"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              question.value ? "Yes" : "No"
                                            )
                                          )
                                        ]
                                      )
                                    ]
                                  : Array.isArray(question.value)
                                  ? [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "block w-full text-grey-darker"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(question.value.join(", "))
                                          )
                                        ]
                                      )
                                    ]
                                  : [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "block w-full text-grey-darker"
                                        },
                                        [_vm._v(_vm._s(question.value))]
                                      )
                                    ]
                              ],
                              2
                            )
                          })
                        ],
                        2
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "relative" },
                      [
                        _c("bubble", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "I_will_inform_you_as_soon_as_a_timeslot_is_available"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass:
                              "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3 mt-6",
                            on: { click: _vm.confirmReservation }
                          },
                          [_vm._v(_vm._s(_vm.$t("Confirm")))]
                        )
                      ],
                      1
                    )
                  ],
                  2
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.step == "submitting"
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "flex items-center justify-center h-64" },
                  [
                    _c("div", { staticClass: "text-center" }, [
                      _vm._m(2),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "text-sm text-grey-darker mt-4" },
                        [_vm._v(_vm._s(_vm.$t("Loading")))]
                      )
                    ])
                  ]
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.step == "submitted"
            ? _c(
                "div",
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "text-green-lighter hover:text-green-lightest text-xl absolute pin-t pin-r p-2 m-2",
                      attrs: { to: { path: "/" } }
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "mdi mdi-close" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center bg-green text-white rounded px-4 py-10 w-full"
                    },
                    [
                      _vm._m(3),
                      _vm._v(" "),
                      _c("span", { staticClass: "text-sm text-xl ml-4" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "As_soon_as_a_appointment_is_available_Tood_will_inform_you"
                            )
                          )
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.step == "submissionError"
            ? _c(
                "div",
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "text-red-lighter hover:text-red-lightest text-xl absolute pin-t pin-r p-2 m-2",
                      attrs: { to: { path: "/" } }
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "mdi mdi-close" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-center bg-red text-white rounded px-4 py-10 w-full"
                    },
                    [
                      _vm._m(4),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "text-sm text-xl ml-4",
                        domProps: {
                          textContent: _vm._s(
                            _vm.errorText
                              ? _vm.errorText
                              : _vm.$t("an_error_occured")
                          )
                        }
                      })
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.step == "submitted"
          ? _c(
              "div",
              { staticClass: "mt-3 text-sm text-center text-grey-dark" },
              [_vm._v(_vm._s(_vm.$t("Redirecting")))]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-arrow-left" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-arrow-left" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-grey" }, [
      _c("i", { staticClass: "mdi mdi-loading mdi-spin" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-white" }, [
      _c("i", { staticClass: "mdi mdi-verified" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-white" }, [
      _c("i", { staticClass: "mdi mdi-alert-circle" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56fbd8e9", esExports)
  }
}

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OfficeShow_vue__ = __webpack_require__(381);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_274ad41a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OfficeShow_vue__ = __webpack_require__(767);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OfficeShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_274ad41a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OfficeShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/OfficeShow.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-274ad41a", Component.options)
  } else {
    hotAPI.reload("data-v-274ad41a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-grey-lightest" }, [
    _c(
      "section",
      { staticClass: "pt-12 pb-24", attrs: { id: "heading" } },
      [_c("header-nav", { ref: "headerNav" })],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "py-12" }, [
      _c(
        "div",
        { staticClass: "max-w-sm mx-auto px-6" },
        [
          !_vm.office
            ? _c("patient-loading")
            : _c(
                "div",
                { staticClass: "rounded bg-white shadow relative -mt-24" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                      attrs: { to: { path: "/" } }
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "mdi mdi-close" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "p-6" }, [
                    _c(
                      "div",
                      { staticClass: "mb-4 flex" },
                      [
                        _c("avatar", {
                          staticClass: "mr-4 w-10 h-10",
                          attrs: {
                            avatar: _vm.office.doctorAvatar,
                            name:
                              _vm.office.doctorFirstName +
                              " " +
                              _vm.office.doctorLastName
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-black text-lg font-semibold mb-1"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.office.doctorFirstName) +
                                    " " +
                                    _vm._s(_vm.office.doctorLastName)
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.office.isDoctorRegulated &&
                            (_vm.office.doctorType !== "OSTEOPATH" &&
                              _vm.office.doctorType !== "PSYCHOLOGIST")
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-green font-semibold text-sm mb-1"
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-currency-eur"
                                    }),
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("Contracted_doctor"))
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !_vm.office.isDoctorRegulated &&
                            (_vm.office.doctorType !== "OSTEOPATH" &&
                              _vm.office.doctorType !== "PSYCHOLOGIST")
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-red font-semibold text-sm mb-1"
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-currency-eur"
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("Contracted_doctor_negative")
                                        )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.office.isDoctorMemberOfOsteopathie
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "tooltip text-green font-semibold text-sm mt-1 mb-2"
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "mdi mdi-check-circle"
                                    }),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.$t("Member_of_Osteopathie")
                                        ) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "tooltip-text text-sm" },
                                      [_vm._v(_vm._s(_vm.$t("Oste_tooltip")))]
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.office.officeSettings
                              ? _c("OfficeSettings", {
                                  attrs: {
                                    accessible:
                                      _vm.office.officeSettings.accessible,
                                    card: _vm.office.officeSettings.card,
                                    cash: _vm.office.officeSettings.cash
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {}, [
                      _c("div", { staticClass: "text-grey-darkest" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.office.name)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.office.streetNumber) +
                            " " +
                            _vm._s(_vm.office.streetName)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.office.zipCode) +
                            " " +
                            _vm._s(_vm.office.locality) +
                            "\n                        "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "gmap-map",
                    {
                      staticClass: "w-full",
                      staticStyle: { height: "250px" },
                      attrs: {
                        center: {
                          lat: _vm.office.location._lat,
                          lng: _vm.office.location._long
                        },
                        zoom: 13,
                        options: { disableDefaultUI: true }
                      }
                    },
                    [
                      _c("gmap-marker", {
                        attrs: {
                          position: {
                            lat: _vm.office.location._lat,
                            lng: _vm.office.location._long
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.loadingTimeslots
                    ? _c("div", [
                        Object.keys(_vm.timeslots).length
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "uppercase tracking-wide text-grey-darker text-sm font-semibold px-3 md:px-6 my-4"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Select_an_availability"))
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "max-h-timeslots overflow-scroll"
                                },
                                [
                                  _vm._l(_vm.sortedTimeslots, function(
                                    timeslot
                                  ) {
                                    return _c(
                                      "router-link",
                                      {
                                        key: timeslot.id,
                                        staticClass:
                                          "block w-full border-t px-6 py-3 hover:bg-grey-lightest text-grey-darker",
                                        attrs: {
                                          to: {
                                            name: "timeslot.show",
                                            params: { id: timeslot.id }
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm._f("momentFormat")(
                                                timeslot.date,
                                                "YYYY-MM-DD",
                                                _vm.$t("date_selector_format")
                                              )
                                            ) +
                                            " " +
                                            _vm._s(_vm.$t("at")) +
                                            " " +
                                            _vm._s(
                                              _vm._f("momentFormatTime")(
                                                timeslot.time,
                                                _vm.$t("time_format")
                                              )
                                            ) +
                                            "\n                            "
                                        )
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "py-1 rounded-b border-t"
                                  })
                                ],
                                2
                              )
                            ])
                          : _c(
                              "div",
                              { staticClass: "px-6 py-4" },
                              [
                                _c("bubble", [
                                  _c("p", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "X_is_not_available_Register_on_the_waiting_list_to_inform_the_dentists_near_Y",
                                          {
                                            name:
                                              _vm.office.doctorFirstName +
                                              " " +
                                              _vm.office.doctorLastName,
                                            location: _vm.patientPlace
                                          }
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  !_vm.hasEmergencies && !_vm.loadingTimeslots
                                    ? _c("p", { staticClass: "mt-2" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "Activate_the_alert_and_I_will_inform_you_"
                                            )
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.hasEmergencies && !_vm.loadingTimeslots
                                    ? _c("p", { staticClass: "mt-2" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "You_are_already_in_the_waiting_list"
                                            )
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                !_vm.hasEmergencies && !_vm.loadingTimeslots
                                  ? _c("waiting-list-button")
                                  : _vm._e()
                              ],
                              1
                            )
                      ])
                    : _vm._e()
                ],
                1
              ),
          _vm._v(" "),
          _vm.office
            ? _c("dfp-slot", {
                staticClass: "mt-6",
                attrs: {
                  path: "/21865209613/Patients/OfficeShow",
                  size: [300, 250],
                  id: "div-gpt-ad-office",
                  "medical-practice": _vm.office.medicalPractice
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-274ad41a", esExports)
  }
}

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeslotShow_vue__ = __webpack_require__(382);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59d06e02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeslotShow_vue__ = __webpack_require__(769);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TimeslotShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59d06e02_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TimeslotShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/TimeslotShow.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-59d06e02", Component.options)
  } else {
    hotAPI.reload("data-v-59d06e02", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-grey-lightest" }, [
    _c(
      "section",
      { staticClass: "pt-12 pb-24", attrs: { id: "heading" } },
      [_c("header-nav", { ref: "headerNav" })],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "py-12" }, [
      _c(
        "div",
        { staticClass: "max-w-sm mx-auto px-6" },
        [
          !_vm.timeslot
            ? _c("patient-loading")
            : _c("div", { staticClass: "card" }, [
                _vm.step == "timeslotDetails"
                  ? _c(
                      "div",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                            attrs: { to: { path: "/" } }
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", { staticClass: "mdi mdi-close" })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-6" }, [
                          _c("div", { staticClass: "mb-4" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-blue text-sm font-semibold mb-1"
                              },
                              [_vm._v(_vm._s(_vm.$t("When_")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text-black font-semibold text-lg"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm._f("momentFormat")(
                                      _vm.timeslot.date,
                                      "YYYY-MM-DD",
                                      _vm.$t("date_selector_format")
                                    )
                                  ) +
                                    " " +
                                    _vm._s(_vm.$t("at")) +
                                    " " +
                                    _vm._s(
                                      _vm._f("momentFormatTime")(
                                        _vm.timeslot.time,
                                        _vm.$t("time_format")
                                      )
                                    )
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "mb-4 flex justify-between" },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-blue text-sm font-semibold mb-1"
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("Who_will_treat_me_"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-grey-darkest" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.timeslot.doctorFirstName +
                                            " " +
                                            _vm.timeslot.doctorLastName
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-sm text-grey-darker" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("type_" + _vm.timeslot.type)
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.timeslot.isDoctorRegulated &&
                                  (_vm.timeslot.type !== "OSTEOPATH" &&
                                    _vm.timeslot.type !== "PSYCHOLOGIST")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-green font-semibold text-sm mt-1"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-currency-eur"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("Contracted_doctor")
                                              )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.timeslot.isDoctorRegulated &&
                                  (_vm.timeslot.type !== "OSTEOPATH" &&
                                    _vm.timeslot.type !== "PSYCHOLOGIST")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-red font-semibold text-sm mt-1"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-currency-eur"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "Contracted_doctor_negative"
                                                )
                                              )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.timeslot.isDoctorMemberOfOsteopathie
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "tooltip text-green font-semibold text-sm mt-1 mb-2"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-check-circle"
                                          }),
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.$t("Member_of_Osteopathie")
                                              ) +
                                              "\n                                    "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tooltip-text text-sm"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("Oste_tooltip"))
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.timeslot.officeSettings
                                    ? _c("OfficeSettings", {
                                        attrs: {
                                          accessible:
                                            _vm.timeslot.officeSettings
                                              .accessible,
                                          card:
                                            _vm.timeslot.officeSettings.card,
                                          cash: _vm.timeslot.officeSettings.cash
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("avatar", {
                                staticClass: "ml-2 w-10 h-10",
                                attrs: {
                                  avatar: _vm.timeslot.doctorAvatar,
                                  name:
                                    _vm.timeslot.doctorFirstName +
                                    " " +
                                    _vm.timeslot.doctorLastName
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", {}, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "text-blue text-sm font-semibold mb-1"
                              },
                              [_vm._v(_vm._s(_vm.$t("Where_have_I_to_go_")))]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-grey-darkest" }, [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.timeslot.officeStreetNumber) +
                                  " " +
                                  _vm._s(_vm.timeslot.officeStreetName)
                              ),
                              _c("br"),
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.timeslot.officeZipCode) +
                                  " " +
                                  _vm._s(_vm.timeslot.officeLocality) +
                                  "\n                            "
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "gmap-map",
                          {
                            staticClass: "w-full",
                            staticStyle: { height: "250px" },
                            attrs: {
                              center: {
                                lat: _vm.timeslot.officeLocation._lat,
                                lng: _vm.timeslot.officeLocation._long
                              },
                              zoom: 13,
                              options: { disableDefaultUI: true }
                            }
                          },
                          [
                            _c("gmap-marker", {
                              attrs: {
                                position: {
                                  lat: _vm.timeslot.officeLocation._lat,
                                  lng: _vm.timeslot.officeLocation._long
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        !_vm.isBooked
                          ? _c("div", { staticClass: "px-6 py-4" }, [
                              _vm.userId
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                                      on: {
                                        click: function($event) {
                                          return _vm.changeStep("patientForm")
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("Book_this_appointment"))
                                      )
                                    ]
                                  )
                                : _c(
                                    "button",
                                    {
                                      staticClass:
                                        "bg-blue-light hover:bg-blue rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                                      on: { click: _vm.showLogin }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "Sign_in_to_book_this_appointment"
                                          )
                                        )
                                      )
                                    ]
                                  )
                            ])
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "px-6 py-4 bg-teal text-center rounded-b"
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Appointment_confirmed"))
                                    )
                                  ]
                                )
                              ]
                            )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.step == "patientForm"
                  ? _c(
                      "form",
                      {
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.submitPatientForm($event)
                          }
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.changeStep("timeslotDetails")
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", { staticClass: "mdi mdi-arrow-left" })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "p-6 pt-12" }, [
                          _c("div", { staticClass: "mb-4" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                              },
                              [_vm._v(_vm._s(_vm.$t("Firstname_")))]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.patientForm.firstName,
                                  expression: "patientForm.firstName"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass:
                                "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                              class: {
                                "border-red": _vm.errors.has("first_name")
                              },
                              attrs: { name: "first_name", type: "text" },
                              domProps: { value: _vm.patientForm.firstName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.patientForm,
                                    "firstName",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("first_name"),
                                    expression: "errors.has('first_name')"
                                  }
                                ],
                                staticClass: "text-xs text-red font-semibold"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Please_fill_your_first_name"))
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-4" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                              },
                              [_vm._v(_vm._s(_vm.$t("Lastname_")))]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.patientForm.lastName,
                                  expression: "patientForm.lastName"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass:
                                "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                              class: {
                                "border-red": _vm.errors.has("last_name")
                              },
                              attrs: { name: "last_name", type: "text" },
                              domProps: { value: _vm.patientForm.lastName },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.patientForm,
                                    "lastName",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("last_name"),
                                    expression: "errors.has('last_name')"
                                  }
                                ],
                                staticClass: "text-xs text-red font-semibold"
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("Please_fill_your_last_name"))
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-4" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                              },
                              [_vm._v(_vm._s(_vm.$t("Age_")))]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.patientForm.age,
                                  expression: "patientForm.age"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|numeric",
                                  expression: "'required|numeric'"
                                }
                              ],
                              staticClass:
                                "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                              class: {
                                "border-red": _vm.errors.has("patientForm.age")
                              },
                              attrs: {
                                name: "patientForm.age",
                                type: "number",
                                step: "1",
                                min: "0"
                              },
                              domProps: { value: _vm.patientForm.age },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.patientForm,
                                    "age",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("patientForm.age"),
                                    expression: "errors.has('patientForm.age')"
                                  }
                                ],
                                staticClass: "text-xs text-red font-semibold"
                              },
                              [_vm._v(_vm._s(_vm.$t("Please_fill_your_age")))]
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.patient || _vm.patient.email === null
                            ? _c("div", { staticClass: "mb-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Email_address_")))]
                                ),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.patientForm.email,
                                      expression: "patientForm.email"
                                    },
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|email",
                                      expression: "'required|email'"
                                    }
                                  ],
                                  staticClass:
                                    "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                                  class: {
                                    "border-red": _vm.errors.has("email")
                                  },
                                  attrs: { name: "email", type: "email" },
                                  domProps: { value: _vm.patientForm.email },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.patientForm,
                                        "email",
                                        $event.target.value
                                      )
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.errors.has("email"),
                                        expression: "errors.has('email')"
                                      }
                                    ],
                                    staticClass:
                                      "text-xs text-red font-semibold"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Please_fill_your_email_address")
                                      )
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "mb-4" }, [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                              },
                              [_vm._v(_vm._s(_vm.$t("Phone_number_")))]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.patientForm.phone,
                                  expression: "patientForm.phone"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|phone:BE",
                                  expression: "'required|phone:BE'"
                                }
                              ],
                              staticClass:
                                "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                              class: { "border-red": _vm.errors.has("phone") },
                              attrs: { name: "phone", type: "phone" },
                              domProps: { value: _vm.patientForm.phone },
                              on: {
                                blur: _vm.transformPhone,
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.patientForm,
                                    "phone",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.errors.has("phone"),
                                    expression: "errors.has('phone')"
                                  }
                                ],
                                staticClass: "text-xs text-red font-semibold"
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Please_fill_your_phone_number")
                                  )
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                              attrs: { type: "submit" }
                            },
                            [_vm._v(_vm._s(_vm.$t("Next")))]
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.step == "patientSymptoms"
                  ? _c(
                      "form",
                      {
                        on: {
                          submit: function($event) {
                            $event.preventDefault()
                            return _vm.submitPatientSymptoms($event)
                          }
                        }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.changeStep("patientForm")
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", { staticClass: "mdi mdi-arrow-left" })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _vm.timeslot.type === "DENTIST"
                          ? _c(
                              "div",
                              { staticClass: "p-6 pt-12" },
                              [
                                _vm._l([0, 1, 2, 3, 4], function(qIndex) {
                                  return _c("div", { staticClass: "mb-4" }, [
                                    _c("div", {
                                      staticClass:
                                        "text-blue text-sm font-semibold mb-2",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.questions[qIndex].label
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-wrap -mx-4" },
                                      _vm._l(
                                        _vm.questions[qIndex].choices,
                                        function(answer, index) {
                                          return _c(
                                            "label",
                                            {
                                              key: index,
                                              staticClass:
                                                "block group mb-2 px-4",
                                              class:
                                                [2, 3, 4].indexOf(qIndex) >= 0
                                                  ? "w-1/2"
                                                  : "w-full"
                                            },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.questions[qIndex]
                                                        .answer,
                                                    expression:
                                                      "questions[qIndex].answer"
                                                  },
                                                  {
                                                    name: "validate",
                                                    rawName: "v-validate",
                                                    value: "required",
                                                    expression: "'required'"
                                                  }
                                                ],
                                                staticClass: "mr-2",
                                                attrs: {
                                                  type: "radio",
                                                  name: "symptomsForm." + qIndex
                                                },
                                                domProps: {
                                                  value: answer,
                                                  checked: _vm._q(
                                                    _vm.questions[qIndex]
                                                      .answer,
                                                    answer
                                                  )
                                                },
                                                on: {
                                                  change: function($event) {
                                                    return _vm.$set(
                                                      _vm.questions[qIndex],
                                                      "answer",
                                                      answer
                                                    )
                                                  }
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "text-sm",
                                                class:
                                                  _vm.questions[qIndex]
                                                    .answer == answer
                                                    ? "text-black"
                                                    : "text-grey-dark group-hover:text-grey-darkest",
                                                domProps: {
                                                  textContent: _vm._s(answer)
                                                }
                                              })
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "symptomsForm." + qIndex
                                            ),
                                            expression:
                                              "errors.has('symptomsForm.' + qIndex)"
                                          }
                                        ],
                                        staticClass:
                                          "text-xs text-red font-semibold"
                                      },
                                      [_vm._v(_vm._s(_vm.$t("Please_specify")))]
                                    )
                                  ])
                                }),
                                _vm._v(" "),
                                _vm._l([5, 6], function(qIndex) {
                                  return _vm.questions[4].answer ==
                                    _vm.$t("SYMPTOMS_ANSWER_5_1")
                                    ? _c("div", { staticClass: "mb-4" }, [
                                        _c("div", {
                                          staticClass:
                                            "text-blue text-sm font-semibold mb-2",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.questions[qIndex].label
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "flex flex-wrap -mx-4"
                                          },
                                          _vm._l(
                                            _vm.questions[qIndex].choices,
                                            function(answer, index) {
                                              return _c(
                                                "label",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "block group mb-2 px-4",
                                                  class:
                                                    [2, 3, 4].indexOf(qIndex) >=
                                                    0
                                                      ? "w-1/2"
                                                      : "w-full"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.questions[qIndex]
                                                            .answer,
                                                        expression:
                                                          "questions[qIndex].answer"
                                                      },
                                                      {
                                                        name: "validate",
                                                        rawName: "v-validate",
                                                        value: "required",
                                                        expression: "'required'"
                                                      }
                                                    ],
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      type: "radio",
                                                      name:
                                                        "symptomsForm." + qIndex
                                                    },
                                                    domProps: {
                                                      value: answer,
                                                      checked: _vm._q(
                                                        _vm.questions[qIndex]
                                                          .answer,
                                                        answer
                                                      )
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        return _vm.$set(
                                                          _vm.questions[qIndex],
                                                          "answer",
                                                          answer
                                                        )
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass: "text-sm",
                                                    class:
                                                      _vm.questions[qIndex]
                                                        .answer == answer
                                                        ? "text-black"
                                                        : "text-grey-dark group-hover:text-grey-darkest",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        answer
                                                      )
                                                    }
                                                  })
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.errors.has(
                                                  "symptomsForm." + qIndex
                                                ),
                                                expression:
                                                  "errors.has('symptomsForm.' + qIndex)"
                                              }
                                            ],
                                            staticClass:
                                              "text-xs text-red font-semibold"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("Please_specify"))
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                                    attrs: { type: "submit" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Next")))]
                                )
                              ],
                              2
                            )
                          : _c(
                              "div",
                              { staticClass: "p-6 pt-12" },
                              [
                                _vm._l(_vm.questions, function(
                                  question,
                                  qIndex
                                ) {
                                  return _c("div", { staticClass: "mb-4" }, [
                                    _c("div", {
                                      staticClass:
                                        "text-blue text-sm font-semibold mb-2",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.questions[qIndex].label
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-wrap" },
                                      [
                                        _c("textarea", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.questions[qIndex].answer,
                                              expression:
                                                "questions[qIndex].answer"
                                            },
                                            {
                                              name: "validate",
                                              rawName: "v-validate",
                                              value: "required",
                                              expression: "'required'"
                                            }
                                          ],
                                          staticClass:
                                            "block w-full rounded border bg-grey-lightest px-3 py-2 text-grey-darkest",
                                          attrs: {
                                            name: "symptomsForm." + qIndex,
                                            rows: "5"
                                          },
                                          domProps: {
                                            value: _vm.questions[qIndex].answer
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.questions[qIndex],
                                                "answer",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.errors.has(
                                              "symptomsForm." + qIndex
                                            ),
                                            expression:
                                              "errors.has('symptomsForm.' + qIndex)"
                                          }
                                        ],
                                        staticClass:
                                          "text-xs text-red font-semibold"
                                      },
                                      [_vm._v(_vm._s(_vm.$t("Please_specify")))]
                                    )
                                  ])
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                                    attrs: { type: "submit" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Next")))]
                                )
                              ],
                              2
                            )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.step == "submissionSummary"
                  ? _c("div", [
                      _c(
                        "button",
                        {
                          staticClass:
                            "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                          on: {
                            click: function($event) {
                              return _vm.changeStep("patientSymptoms")
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "mdi mdi-arrow-left" })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "px-6 py-4" }, [
                        _c(
                          "h4",
                          {
                            staticClass:
                              "text-xl uppercase tracking-wide text-grey-darkest"
                          },
                          [_vm._v(_vm._s(_vm.$t("Summary")))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "p-6 pt-4" }, [
                        _c("div", { staticClass: "mb-4" }, [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                            },
                            [_vm._v(_vm._s(_vm.$t("Name")))]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "block w-full text-grey-darker",
                            domProps: {
                              textContent: _vm._s(
                                _vm.patientForm.firstName +
                                  " " +
                                  _vm.patientForm.lastName
                              )
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-4" }, [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                            },
                            [_vm._v(_vm._s(_vm.$t("Age")))]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "block w-full text-grey-darker",
                            domProps: {
                              textContent: _vm._s(_vm.patientForm.age)
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-4" }, [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                            },
                            [_vm._v(_vm._s(_vm.$t("Email_address")))]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "block w-full text-grey-darker",
                            domProps: {
                              textContent: _vm._s(_vm.patientForm.email)
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-4" }, [
                          _c(
                            "label",
                            {
                              staticClass:
                                "block mb-1 uppercase tracking-wide text-sm font-semibold text-grey-dark"
                            },
                            [_vm._v(_vm._s(_vm.$t("Phone_number")))]
                          ),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "block w-full text-grey-darker",
                            domProps: {
                              textContent: _vm._s(_vm.patientForm.phone)
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _vm.timeslot.type === "DENTIST"
                          ? _c(
                              "div",
                              [
                                _vm._l([0, 1, 2, 3, 4], function(qIndex) {
                                  return _c("div", { staticClass: "mb-4" }, [
                                    _c("div", {
                                      staticClass:
                                        "text-blue text-sm font-semibold mb-2",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.questions[qIndex].label
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "flex flex-wrap" },
                                      [
                                        _c("span", {
                                          staticClass:
                                            "text-sm text-grey-darker",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.questions[qIndex].answer
                                            )
                                          }
                                        })
                                      ]
                                    )
                                  ])
                                }),
                                _vm._v(" "),
                                _vm._l([5, 6], function(qIndex) {
                                  return _vm.questions[4].answer ==
                                    _vm.$t("SYMPTOMS_ANSWER_5_1")
                                    ? _c("div", { staticClass: "mb-4" }, [
                                        _c("div", {
                                          staticClass:
                                            "text-blue text-sm font-semibold mb-2",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.questions[qIndex].label
                                            )
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "flex flex-wrap" },
                                          [
                                            _c("span", {
                                              staticClass:
                                                "text-sm text-grey-darker",
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.questions[qIndex].answer
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                })
                              ],
                              2
                            )
                          : _c(
                              "div",
                              _vm._l(_vm.questions, function(question, qIndex) {
                                return _c("div", { staticClass: "mb-4" }, [
                                  _c("div", {
                                    staticClass:
                                      "text-blue text-sm font-semibold mb-2",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.questions[qIndex].label
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "flex flex-wrap" }, [
                                    _c("span", {
                                      staticClass: "text-sm text-grey-darker",
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.questions[qIndex].answer
                                        )
                                      }
                                    })
                                  ])
                                ])
                              }),
                              0
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "relative" },
                          [
                            _c("bubble", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "The_practitioner_will_be_informed_immediately_of_your_reservation"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3 mt-6",
                                on: { click: _vm.confirmReservation }
                              },
                              [_vm._v(_vm._s(_vm.$t("Confirm")))]
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.step == "submitting"
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass: "flex items-center justify-center h-64"
                        },
                        [
                          _c("div", { staticClass: "text-center" }, [
                            _c(
                              "span",
                              { staticClass: "icon text-5xl text-grey" },
                              [
                                _c("i", {
                                  staticClass: "mdi mdi-loading mdi-spin"
                                })
                              ]
                            ),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "text-sm text-grey-darker mt-4" },
                              [_vm._v(_vm._s(_vm.$t("Loading")))]
                            )
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.step == "submitted"
                  ? _c(
                      "div",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "text-green-lighter hover:text-green-lightest text-xl absolute pin-t pin-r p-2 m-2",
                            attrs: { to: { path: "/" } }
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", { staticClass: "mdi mdi-close" })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center justify-center bg-green text-white rounded px-4 py-10 w-full"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "icon text-5xl text-white" },
                              [_c("i", { staticClass: "mdi mdi-verified" })]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "text-sm text-xl ml-4" },
                              [_vm._v(_vm._s(_vm.$t("Appointment_confirmed")))]
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.step == "submissionError"
                  ? _c(
                      "div",
                      [
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "text-red-lighter hover:text-red-lightest text-xl absolute pin-t pin-r p-2 m-2",
                            attrs: { to: { path: "/" } }
                          },
                          [
                            _c("span", { staticClass: "icon" }, [
                              _c("i", { staticClass: "mdi mdi-close" })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "flex items-center justify-center bg-red text-white rounded px-4 py-10 w-full"
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "icon text-5xl text-white" },
                              [_c("i", { staticClass: "mdi mdi-alert-circle" })]
                            ),
                            _vm._v(" "),
                            _c("span", {
                              staticClass: "text-sm text-xl ml-4",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.errorText
                                    ? _vm.errorText
                                    : _vm.$t("an_error_occured")
                                )
                              }
                            })
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
          _vm._v(" "),
          _vm.step == "submitted"
            ? _c(
                "div",
                { staticClass: "mt-3 text-sm text-center text-grey-dark" },
                [_vm._v(_vm._s(_vm.$t("Redirecting")))]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.timeslot
            ? _c("dfp-slot", {
                staticClass: "mt-6",
                attrs: {
                  path: "/21865209613/Patients/TimeslotShow",
                  size: [300, 250],
                  id: "div-gpt-ad-timeslot",
                  "medical-practice": _vm.timeslot.medicalPractice
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59d06e02", esExports)
  }
}

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerOfficeShow_vue__ = __webpack_require__(383);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37076ad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerOfficeShow_vue__ = __webpack_require__(771);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerOfficeShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37076ad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerOfficeShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/PartnerOfficeShow.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-37076ad2", Component.options)
  } else {
    hotAPI.reload("data-v-37076ad2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-grey-lightest" }, [
    _c(
      "section",
      { staticClass: "pt-12 pb-24", attrs: { id: "heading" } },
      [_c("header-nav", { ref: "headerNav" })],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "py-12" }, [
      _c(
        "div",
        { staticClass: "max-w-sm mx-auto px-6" },
        [
          !_vm.office
            ? _c("patient-loading")
            : _c(
                "div",
                { staticClass: "rounded bg-white shadow relative -mt-24" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass:
                        "text-whiter hover:text-white text-xl absolute pin-t pin-r p-2 m-2",
                      attrs: {
                        to: {
                          path: "/search",
                          query: { type: _vm.office.medicalPractice }
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "icon" }, [
                        _c("i", { staticClass: "mdi mdi-close" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "p-6 bg-orange text-white rounded-t" },
                    [
                      _c(
                        "span",
                        {
                          staticClass:
                            "inline-flex items-center justify-between bg-transparent uppercase font-semibold text-white text-left text-sm"
                        },
                        [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Appointment_provided_by_X", {
                                  name: _vm.office.partnerName
                                })
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-4 text-sm" }, [
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t(
                                "This_appointment_is_provided_by_our_partner_X",
                                { name: _vm.office.partnerName }
                              )
                            ) +
                            "\n                        " +
                            _vm._s(
                              _vm.$t(
                                "Thus_you_will_be_redirected_to_their_website_in_order_to_book_it"
                              )
                            ) +
                            "\n                    "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "p-6" }, [
                    _c(
                      "div",
                      { staticClass: "mb-4 flex justify-between" },
                      [
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-blue text-sm font-semibold mb-1"
                            },
                            [_vm._v(_vm._s(_vm.$t("Who_will_treat_me_")))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-grey-darkest" }, [
                            _vm._v(
                              _vm._s(
                                _vm.office.doctorFirstName +
                                  " " +
                                  _vm.office.doctorLastName
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm.office.isDoctorRegulated &&
                          (_vm.office.medicalPractice !== "OSTEOPATH" &&
                            _vm.office.medicalPractice !== "PSYCHOLOGIST")
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "text-green font-semibold text-sm mt-1"
                                },
                                [_vm._v(_vm._s(_vm.$t("Regulated_Doctor")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.office.isDoctorRegulated &&
                          (_vm.office.medicalPractice !== "OSTEOPATH" &&
                            _vm.office.medicalPractice !== "PSYCHOLOGIST")
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "text-red font-semibold text-sm mt-1"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Contracted_doctor_negative"))
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("partner-avatar", {
                          staticClass: "ml-2 w-10 h-10",
                          attrs: { "external-url": _vm.office.doctorAvatar }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {}, [
                      _c(
                        "div",
                        { staticClass: "text-blue text-sm font-semibold mb-1" },
                        [_vm._v(_vm._s(_vm.$t("Where_have_I_to_go_")))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-grey-darkest" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.office.officeStreetName)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.office.officeZipCode) +
                            " " +
                            _vm._s(_vm.office.officeLocality) +
                            "\n                        "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "gmap-map",
                    {
                      staticClass: "w-full",
                      staticStyle: { height: "250px" },
                      attrs: {
                        center: {
                          lat: parseFloat(_vm.office.officeLatitude),
                          lng: parseFloat(_vm.office.officeLongitude)
                        },
                        zoom: 13,
                        options: { disableDefaultUI: true }
                      }
                    },
                    [
                      _c("gmap-marker", {
                        attrs: {
                          position: {
                            lat: parseFloat(_vm.office.officeLatitude),
                            lng: parseFloat(_vm.office.officeLongitude)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "px-6 py-4" }, [
                    _vm.userId
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "inline-block text-center bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                            attrs: {
                              href: _vm.office.partnerUrl,
                              target: "_blank"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.handleClick($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Book_this_appointment_with_X", {
                                  partner: _vm.office.partnerName
                                })
                              )
                            )
                          ]
                        )
                      : _c(
                          "button",
                          {
                            staticClass:
                              "bg-blue-light hover:bg-blue rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                            on: { click: _vm.showLogin }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Sign_in_to_book_this_appointment"))
                            )
                          ]
                        )
                  ])
                ],
                1
              ),
          _vm._v(" "),
          _vm.office
            ? _c("dfp-slot", {
                staticClass: "mt-6",
                attrs: {
                  path: "/21865209613/Patients/PartnerOfficeShow",
                  size: [300, 250],
                  id: "div-gpt-ad-partner-office",
                  "medical-practice": _vm.office.medicalPractice
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37076ad2", esExports)
  }
}

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerTimeslotShow_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f50ecb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerTimeslotShow_vue__ = __webpack_require__(773);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerTimeslotShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f50ecb4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerTimeslotShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/PartnerTimeslotShow.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5f50ecb4", Component.options)
  } else {
    hotAPI.reload("data-v-5f50ecb4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-grey-lightest" }, [
    _c(
      "section",
      { staticClass: "pt-12 pb-24", attrs: { id: "heading" } },
      [_c("header-nav", { ref: "headerNav" })],
      1
    ),
    _vm._v(" "),
    _c("section", { staticClass: "py-12" }, [
      _c(
        "div",
        { staticClass: "max-w-sm mx-auto px-6" },
        [
          !_vm.timeslot
            ? _c("patient-loading")
            : _c(
                "div",
                { staticClass: "rounded bg-white shadow relative -mt-24" },
                [
                  !_vm.isBooked
                    ? _c(
                        "router-link",
                        {
                          staticClass:
                            "text-whiter hover:text-white text-xl absolute pin-t pin-r p-2 m-2",
                          attrs: {
                            to: {
                              path: "/search",
                              query: { type: _vm.timeslot.medicalPractice }
                            }
                          }
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "mdi mdi-close" })
                          ])
                        ]
                      )
                    : _c(
                        "router-link",
                        {
                          staticClass:
                            "text-whiter hover:text-white text-xl absolute pin-t pin-r p-2 m-2",
                          attrs: { to: { path: "/" } }
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "mdi mdi-close" })
                          ])
                        ]
                      ),
                  _vm._v(" "),
                  _vm.isBooked
                    ? _c(
                        "div",
                        { staticClass: "p-6 bg-teal text-white rounded-t" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "inline-flex items-center justify-between bg-transparent uppercase font-semibold text-white text-left text-sm",
                              on: {
                                click: function($event) {
                                  _vm.showPartnerMessage = !_vm.showPartnerMessage
                                }
                              }
                            },
                            [
                              _c("div", [
                                _vm._v(_vm._s(_vm.$t("Appointment_confirmed")))
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-4 text-sm" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    "You_have_booked_this_appointment_with_X_In_order_to_manage_it_you_will_be_redirecter_do_thier_website",
                                    { name: _vm.timeslot.partnerName }
                                  )
                                ) +
                                "\n                    "
                            )
                          ])
                        ]
                      )
                    : _c(
                        "div",
                        { staticClass: "p-6 bg-orange text-white rounded-t" },
                        [
                          _c(
                            "span",
                            {
                              staticClass:
                                "inline-flex items-center justify-between bg-transparent uppercase font-semibold text-white text-left text-sm",
                              on: {
                                click: function($event) {
                                  _vm.showPartnerMessage = !_vm.showPartnerMessage
                                }
                              }
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Appointment_provided_by_X", {
                                      name: _vm.timeslot.partnerName
                                    })
                                  )
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-4 text-sm" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    "This_appointment_is_provided_by_our_partner_X",
                                    { name: _vm.timeslot.partnerName }
                                  )
                                ) +
                                "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    "Thus_you_will_be_redirected_to_their_website_in_order_to_book_it"
                                  )
                                ) +
                                "\n                    "
                            )
                          ])
                        ]
                      ),
                  _vm._v(" "),
                  _c("div", { staticClass: "p-6" }, [
                    _c("div", { staticClass: "mb-4" }, [
                      _c(
                        "div",
                        { staticClass: "text-blue text-sm font-semibold mb-1" },
                        [_vm._v(_vm._s(_vm.$t("When_")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-black font-semibold text-lg" },
                        [
                          _vm._v(
                            _vm._s(
                              _vm._f("momentFormatTimestamp")(
                                _vm.timeslot.dateTime,
                                _vm.$t("date_selector_format") +
                                  " [" +
                                  _vm.$t("at") +
                                  "] " +
                                  _vm.$t("time_format")
                              )
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mb-4 flex justify-between" },
                      [
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-blue text-sm font-semibold mb-1"
                            },
                            [_vm._v(_vm._s(_vm.$t("Who_will_treat_me_")))]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "text-grey-darkest" }, [
                            _vm._v(
                              _vm._s(
                                _vm.timeslot.doctorFirstName +
                                  " " +
                                  _vm.timeslot.doctorLastName
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm.timeslot.isDoctorRegulated &&
                          (_vm.timeslot.medicalPractice !== "OSTEOPATH" &&
                            _vm.timeslot.medicalPractice !== "PSYCHOLOGIST")
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "text-green font-semibold text-sm mt-1"
                                },
                                [_vm._v(_vm._s(_vm.$t("Regulated_Doctor")))]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.timeslot.isDoctorRegulated &&
                          (_vm.timeslot.medicalPractice !== "OSTEOPATH" &&
                            _vm.timeslot.medicalPractice !== "PSYCHOLOGIST")
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "text-red font-semibold text-sm mt-1"
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("Contracted_doctor_negative"))
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("partner-avatar", {
                          staticClass: "ml-2 w-10 h-10",
                          attrs: { "external-url": _vm.timeslot.doctorAvatar }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", {}, [
                      _c(
                        "div",
                        { staticClass: "text-blue text-sm font-semibold mb-1" },
                        [_vm._v(_vm._s(_vm.$t("Where_have_I_to_go_")))]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-grey-darkest" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.timeslot.officeStreetName)
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.timeslot.officeZipCode) +
                            " " +
                            _vm._s(_vm.timeslot.officeLocality) +
                            "\n                        "
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "gmap-map",
                    {
                      staticClass: "w-full",
                      staticStyle: { height: "250px" },
                      attrs: {
                        center: {
                          lat: _vm.timeslot.officeLatitude,
                          lng: _vm.timeslot.officeLongitude
                        },
                        zoom: 13,
                        options: { disableDefaultUI: true }
                      }
                    },
                    [
                      _c("gmap-marker", {
                        attrs: {
                          position: {
                            lat: _vm.timeslot.officeLatitude,
                            lng: _vm.timeslot.officeLongitude
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.isBooked
                    ? _c("div", { staticClass: "px-6 py-4" }, [
                        _vm.userId
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "inline-block text-center bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                                attrs: {
                                  href: _vm.timeslot.partnerUrl,
                                  target: "_blank"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.handleClick($event)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Book_this_appointment_with_X", {
                                      partner: _vm.timeslot.partnerName
                                    })
                                  )
                                )
                              ]
                            )
                          : _c(
                              "button",
                              {
                                staticClass:
                                  "bg-blue-light hover:bg-blue rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                                on: { click: _vm.showLogin }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Sign_in_to_book_this_appointment")
                                  )
                                )
                              ]
                            )
                      ])
                    : _c("div", { staticClass: "px-6 py-4 rounded-b" }, [
                        _c(
                          "a",
                          {
                            staticClass:
                              "inline-block text-center bg-blue hover:bg-blue-dark rounded text-sm text-white font-semibold uppercase tracking-wide w-full px-4 py-3",
                            attrs: {
                              href: _vm.timeslot.partnerUrl,
                              target: "_blank"
                            },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.handleClick($event)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("Manage_this_appointment_with_X", {
                                  partner: _vm.timeslot.partnerName
                                })
                              )
                            )
                          ]
                        )
                      ])
                ],
                1
              ),
          _vm._v(" "),
          _vm.timeslot
            ? _c("dfp-slot", {
                staticClass: "mt-6",
                attrs: {
                  path: "/21865209613/Patients/PartnerTimeslotShow",
                  size: [300, 250],
                  id: "div-gpt-ad-partner-timeslot",
                  "medical-practice": _vm.timeslot.medicalPractice
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f50ecb4", esExports)
  }
}

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppointmentShow_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7866fddc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppointmentShow_vue__ = __webpack_require__(777);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppointmentShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7866fddc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppointmentShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/AppointmentShow.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7866fddc", Component.options)
  } else {
    hotAPI.reload("data-v-7866fddc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CancelAppointmentModal_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7efe6fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CancelAppointmentModal_vue__ = __webpack_require__(776);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CancelAppointmentModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7efe6fc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CancelAppointmentModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/CancelAppointmentModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e7efe6fc", Component.options)
  } else {
    hotAPI.reload("data-v-e7efe6fc", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.appointment
    ? _c(
        "div",
        {
          staticClass: "fixed z-50 pin overflow-auto bg-modal",
          class: _vm.active ? "block" : "hidden"
        },
        [
          _c(
            "div",
            { staticClass: "shadow max-w-sm mx-auto mt-24 px-4 md:px-0" },
            [
              _c("div", { staticClass: "bg-white rounded-t p-6" }, [
                _c(
                  "div",
                  { staticClass: "text-center text-grey-dark leading-normal" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t(
                            "To_cancel_the_appointment_call_the_doctor_via_X",
                            { phoneNumber: _vm.appointment.officePhone }
                          )
                        ) +
                        "\n            "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex md:hidden border-t items-center" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "block text-center bg-white rounded-bl w-1/2 border-r py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-black",
                      on: { click: _vm.close }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("Cancel")) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass:
                        "block text-center bg-white rounded-br w-1/2 py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-blue",
                      attrs: { href: "tel:" + _vm.appointment.officePhone }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("Call")) +
                          "\n            "
                      )
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "hidden md:flex border-t" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "bg-white rounded-b w-full text-grey-dark py-3 uppercase tracking-wide font-semibold text-sm hover:text-black",
                    on: { click: _vm.close }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("Cancel")) +
                        "\n            "
                    )
                  ]
                )
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e7efe6fc", esExports)
  }
}

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-grey-lightest" },
    [
      _c(
        "section",
        { staticClass: "pt-12 pb-24", attrs: { id: "heading" } },
        [_c("header-nav")],
        1
      ),
      _vm._v(" "),
      _c("section", { staticClass: "py-12" }, [
        _c("div", { staticClass: "max-w-sm mx-auto px-6" }, [
          _vm.errorText
            ? _c("div", [
                _c(
                  "div",
                  { staticClass: "rounded bg-white shadow relative -mt-24" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "text-red-lighter hover:text-red-lightest text-xl absolute pin-t pin-r p-2 m-2",
                        attrs: { to: { path: "/" } }
                      },
                      [
                        _c("span", { staticClass: "icon" }, [
                          _c("i", { staticClass: "mdi mdi-close" })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex items-center justify-center bg-red text-white rounded px-4 py-10 w-full"
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "text-sm text-xl ml-4",
                          domProps: {
                            textContent: _vm._s(
                              _vm.errorText
                                ? _vm.errorText
                                : _vm.$t("an_error_occured")
                            )
                          }
                        })
                      ]
                    )
                  ],
                  1
                )
              ])
            : _c("div", [
                _vm.appointment
                  ? _c(
                      "div",
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "rounded bg-white shadow relative -mt-24"
                          },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "text-whiter hover:text-white text-xl absolute pin-t pin-r p-2 m-2",
                                attrs: { to: { path: "/" } }
                              },
                              [
                                _c("span", { staticClass: "icon" }, [
                                  _c("i", { staticClass: "mdi mdi-close" })
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "p-6 bg-teal text-white rounded-t"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "inline-flex items-center justify-between bg-transparent uppercase font-semibold text-white text-left text-sm"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Appointment_confirmed"))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "mt-4 text-sm" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "The_practitioner_is_allowed_to_ask_for_a_compensation_if_you_dont_show_up_at_the_appointment_"
                                      )
                                    )
                                  )
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "p-4 md:p-6" }, [
                              _c("div", { staticClass: "mb-4" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-blue font-semibold text-sm mb-1"
                                  },
                                  [_vm._v(_vm._s(_vm.$t("When_")))]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-black font-semibold text-lg"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("momentFormat")(
                                          _vm.appointment.date,
                                          "YYYY-MM-DD",
                                          _vm.$t("date_selector_format")
                                        )
                                      ) +
                                        " " +
                                        _vm._s(_vm.$t("at")) +
                                        " " +
                                        _vm._s(
                                          _vm._f("momentFormatTime")(
                                            _vm.appointment.time,
                                            _vm.$t("time_format")
                                          )
                                        )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mb-4 flex justify-between" },
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "text-blue font-semibold text-sm mb-1"
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("Who_will_treat_me_"))
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "text-grey-darkest" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.appointment.doctorFirstName +
                                              " " +
                                              _vm.appointment.doctorLastName
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.appointment.isDoctorRegulated &&
                                    (_vm.appointment.emergencyType !==
                                      "OSTEOPATH" &&
                                      _vm.appointment.emergencyType !==
                                        "PSYCHOLOGIST")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-green font-semibold text-sm mt-1 mb-2"
                                          },
                                          [
                                            _vm._v(
                                              "€ " +
                                                _vm._s(
                                                  _vm.$t("Contracted_doctor")
                                                )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.appointment.isDoctorRegulated &&
                                    (_vm.appointment.emergencyType !==
                                      "OSTEOPATH" &&
                                      _vm.appointment.emergencyType !==
                                        "PSYCHOLOGIST")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text-red font-semibold text-sm mt-1 mb-2"
                                          },
                                          [
                                            _vm._v(
                                              "€ " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "Contracted_doctor_negative"
                                                  )
                                                )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "flex md:hidden items-center text-blue outline-0 uppercase tracking-wide",
                                        attrs: {
                                          href:
                                            "tel:" + _vm.appointment.officePhone
                                        }
                                      },
                                      [
                                        _vm._m(1),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ml-2 text-xs font-semibold"
                                          },
                                          [_vm._v(_vm._s(_vm.$t("Call")))]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "hidden md:inline-flex items-center text-blue outline-0 uppercase tracking-wide",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.showOfficePhone($event)
                                          }
                                        }
                                      },
                                      [
                                        _vm._m(2),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "ml-2 text-xs font-semibold"
                                          },
                                          [_vm._v(_vm._s(_vm.$t("Call")))]
                                        )
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("avatar", {
                                        staticClass: "w-10 h-10",
                                        attrs: {
                                          avatar: _vm.appointment.doctorAvatar,
                                          name:
                                            _vm.appointment.doctorFirstName +
                                            " " +
                                            _vm.appointment.doctorLastName
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "text-blue font-semibold text-sm mb-1"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Where_have_I_to_go_"))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "text-grey-darkest mb-2" },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.appointment.officeZipCode) +
                                        " " +
                                        _vm._s(_vm.appointment.officeLocality) +
                                        "\n                  "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.appointment.officeStreetNumber
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.appointment.officeStreetName
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "flex md:hidden items-center text-blue outline-0 uppercase tracking-wide",
                                    attrs: {
                                      href:
                                        "https://www.google.com/maps/dir/?api=1&destination=" +
                                        _vm.appointment.officeStreetNumber +
                                        " " +
                                        _vm.appointment.officeStreetName +
                                        ", " +
                                        _vm.appointment.officeZipCode +
                                        " " +
                                        _vm.appointment.officeLocality,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._m(3),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-2 text-xs font-semibold"
                                      },
                                      [_vm._v(_vm._s(_vm.$t("Itinerary")))]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "hidden md:inline-flex items-center text-blue outline-0 uppercase tracking-wide",
                                    attrs: {
                                      href:
                                        "https://www.google.com/maps/dir/?api=1&destination=" +
                                        _vm.appointment.officeStreetNumber +
                                        " " +
                                        _vm.appointment.officeStreetName +
                                        ", " +
                                        _vm.appointment.officeZipCode +
                                        " " +
                                        _vm.appointment.officeLocality,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._m(4),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "ml-2 text-xs font-semibold"
                                      },
                                      [_vm._v(_vm._s(_vm.$t("Itinerary")))]
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c(
                              "gmap-map",
                              {
                                staticClass: "w-full",
                                staticStyle: { height: "250px" },
                                attrs: {
                                  center: {
                                    lat: _vm.appointment.officeLocation._lat,
                                    lng: _vm.appointment.officeLocation._long
                                  },
                                  zoom: 12,
                                  options: { disableDefaultUI: true }
                                }
                              },
                              [
                                _c("gmap-marker", {
                                  attrs: {
                                    position: {
                                      lat: _vm.appointment.officeLocation._lat,
                                      lng: _vm.appointment.officeLocation._long
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "text-center mt-3" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "text-xs hover:underline text-grey font-semibold uppercase tracking-wide px-1 py-1",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.showCancel($event)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Cancel_the_appointment")))]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.appointment
                          ? _c("dfp-slot", {
                              staticClass: "mt-6",
                              attrs: {
                                path: "/21865209613/Patients/AppointmentShow",
                                size: [300, 250],
                                id: "div-gpt-ad-partner-appointment",
                                "medical-practice":
                                  _vm.appointment.emergencyType
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _c("div", [_c("patient-loading")], 1)
              ])
        ])
      ]),
      _vm._v(" "),
      _c("cancel-appointment-modal", {
        attrs: { active: _vm.showCancelModal, appointment: _vm.appointment },
        on: { close: _vm.hideCancel }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-white" }, [
      _c("i", { staticClass: "mdi mdi-alert-circle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-phone" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-phone" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-directions" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-directions" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7866fddc", esExports)
  }
}

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvitationShow_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b46d0d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvitationShow_vue__ = __webpack_require__(781);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvitationShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b46d0d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvitationShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/InvitationShow.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2b46d0d0", Component.options)
  } else {
    hotAPI.reload("data-v-2b46d0d0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeclineInvitationModal_vue__ = __webpack_require__(388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a1d8d58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeclineInvitationModal_vue__ = __webpack_require__(780);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeclineInvitationModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a1d8d58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeclineInvitationModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/DeclineInvitationModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5a1d8d58", Component.options)
  } else {
    hotAPI.reload("data-v-5a1d8d58", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.invitation
    ? _c(
        "div",
        {
          staticClass: "fixed z-50 pin overflow-auto bg-modal",
          class: _vm.active ? "block" : "hidden"
        },
        [
          _c(
            "div",
            { staticClass: "shadow max-w-sm mx-auto mt-24 px-4 md:px-0" },
            [
              _c("div", { staticClass: "bg-white rounded-t p-6" }, [
                _c(
                  "div",
                  { staticClass: "text-center text-grey-dark leading-normal" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t("Are_you_sure_to_decline_this_appointment_")
                        ) +
                        "\n            "
                    )
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "flex border-t items-center" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "block text-center bg-white rounded-bl w-1/2 border-r py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-black",
                    on: { click: _vm.close }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("Cancel")) +
                        "\n            "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "block text-center bg-white rounded-br w-1/2 py-3 uppercase tracking-wide font-semibold text-sm text-grey-dark hover:text-blue",
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.decline($event)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("Yes_decline")) +
                        "\n            "
                    )
                  ]
                )
              ])
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a1d8d58", esExports)
  }
}

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-grey-lightest" },
    [
      _c(
        "section",
        { staticClass: "pt-12 pb-24", attrs: { id: "heading" } },
        [_c("header-nav")],
        1
      ),
      _vm._v(" "),
      _c("section", { staticClass: "py-12" }, [
        _c(
          "div",
          { staticClass: "max-w-sm mx-auto px-6" },
          [
            _vm.step == "invitationDetails"
              ? _c("div", [
                  _vm.invitation
                    ? _c(
                        "div",
                        {
                          staticClass: "rounded bg-white shadow relative -mt-24"
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "text-grey hover:text-black text-xl absolute pin-t pin-r p-2 m-2",
                              on: { click: _vm.goBack }
                            },
                            [_vm._m(0)]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "p-4 md:p-6" }, [
                            _c("div", { staticClass: "mb-4" }, [
                              _c(
                                "div",
                                { staticClass: "text-blue text-sm mb-1" },
                                [_vm._v(_vm._s(_vm.$t("When_")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "text-black font-semibold text-lg"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("momentFormat")(
                                        _vm.invitation.date,
                                        "YYYY-MM-DD",
                                        _vm.$t("date_selector_format")
                                      )
                                    ) +
                                      " à " +
                                      _vm._s(
                                        _vm._f("momentFormatTime")(
                                          _vm.invitation.time,
                                          _vm.$t("time_format")
                                        )
                                      )
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "mb-4 flex justify-between" },
                              [
                                _c("div", [
                                  _c(
                                    "div",
                                    { staticClass: "text-blue text-sm mb-1" },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("Who_will_treat_me_"))
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-grey-darkest" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.invitation.doctorFirstName +
                                            " " +
                                            _vm.invitation.doctorLastName
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "text-sm text-grey-darker" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "type_" +
                                              _vm.invitation.emergencyType
                                          )
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.invitation.isDoctorRegulated &&
                                  (_vm.invitation.emergencyType !==
                                    "OSTEOPATH" &&
                                    _vm.invitation.emergencyType !==
                                      "PSYCHOLOGIST")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-green font-semibold text-sm mt-1 mb-2"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-currency-eur"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("Contracted_doctor")
                                              )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.invitation.isDoctorRegulated &&
                                  (_vm.invitation.emergencyType !==
                                    "OSTEOPATH" &&
                                    _vm.invitation.emergencyType !==
                                      "PSYCHOLOGIST")
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-red font-semibold text-sm mt-1 mb-2"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-currency-eur"
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "Contracted_doctor_negative"
                                                )
                                              )
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.invitation.isDoctorMemberOfOsteopathie
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            " tooltip text-green font-semibold text-sm mt-1 mb-2"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "mdi mdi-check-circle"
                                          }),
                                          _vm._v(
                                            "\n                                " +
                                              _vm._s(
                                                _vm.$t("Member_of_Osteopathie")
                                              ) +
                                              "\n                                "
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tooltip-text text-sm"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("Oste_tooltip"))
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  [
                                    _c("avatar", {
                                      staticClass: "w-10 h-10",
                                      attrs: {
                                        avatar: _vm.invitation.doctorAvatar,
                                        name:
                                          _vm.invitation.doctorFirstName +
                                          " " +
                                          _vm.invitation.doctorLastName
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex" }, [
                              _c(
                                "span",
                                { staticClass: "text-sm md:text-base" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "type_" + _vm.invitation.emergencyType
                                      )
                                    )
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "div",
                                { staticClass: "text-blue text-sm mb-1" },
                                [_vm._v(_vm._s(_vm.$t("Where_have_I_to_go_")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "text-grey-darkest mb-2" },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.invitation.officeStreetNumber
                                      ) +
                                      " " +
                                      _vm._s(_vm.invitation.officeStreetName)
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.invitation.officeZipCode) +
                                      " " +
                                      _vm._s(_vm.invitation.officeLocality) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "gmap-map",
                            {
                              staticClass: "w-full",
                              staticStyle: { height: "250px" },
                              attrs: {
                                center: {
                                  lat: _vm.invitation.officeLocation._lat,
                                  lng: _vm.invitation.officeLocation._long
                                },
                                zoom: 12,
                                options: { disableDefaultUI: true }
                              }
                            },
                            [
                              _c("gmap-marker", {
                                attrs: {
                                  position: {
                                    lat: _vm.invitation.officeLocation._lat,
                                    lng: _vm.invitation.officeLocation._long
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass:
                                "inline-block w-full px-6 py-4 bg-blue hover:bg-blue-dark text-center rounded-b",
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.accept($event)
                                }
                              }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "text-sm text-white font-semibold uppercase tracking-wide w-full px-2 py-3"
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "Accept_this_appointment_invitation"
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-center mt-3" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "text-xs hover:underline text-grey font-semibold uppercase tracking-wide px-1 py-1",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.showDecline($event)
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Decline")))]
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.step == "submitting"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "rounded bg-white shadow relative -mt-24" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "flex items-center justify-center h-64"
                        },
                        [
                          _c("div", { staticClass: "text-center" }, [
                            _vm._m(1),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "text-sm text-grey-darker mt-4" },
                              [_vm._v(_vm._s(_vm.$t("Loading")))]
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.step == "submitted"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "rounded bg-white shadow relative -mt-24" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "text-green-lighter hover:text-green-lightest text-xl absolute pin-t pin-r p-2 m-2",
                          attrs: { to: { path: "/" } }
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "mdi mdi-close" })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-center bg-green text-white rounded px-4 py-10 w-full"
                        },
                        [
                          _vm._m(2),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-sm text-xl ml-4" }, [
                            _vm._v(_vm._s(_vm.$t("Appointment_confirmed")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.step == "submittedDeclination"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "rounded bg-white shadow relative -mt-24" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "text-green-lighter hover:text-green-lightest text-xl absolute pin-t pin-r p-2 m-2",
                          attrs: { to: { path: "/" } }
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "mdi mdi-close" })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-center bg-green text-white rounded px-4 py-10 w-full"
                        },
                        [
                          _vm._m(3),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-sm text-xl ml-4" }, [
                            _vm._v(_vm._s(_vm.$t("Appointment_declined")))
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.step == "submissionError"
              ? _c("div", [
                  _c(
                    "div",
                    { staticClass: "rounded bg-white shadow relative -mt-24" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass:
                            "text-red-lighter hover:text-red-lightest text-xl absolute pin-t pin-r p-2 m-2",
                          attrs: { to: { path: "/" } }
                        },
                        [
                          _c("span", { staticClass: "icon" }, [
                            _c("i", { staticClass: "mdi mdi-close" })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex items-center justify-center bg-red text-white rounded px-4 py-10 w-full"
                        },
                        [
                          _vm._m(4),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "text-sm text-xl ml-4",
                            domProps: {
                              textContent: _vm._s(
                                _vm.errorText
                                  ? _vm.errorText
                                  : _vm.$t("an_error_occured")
                              )
                            }
                          })
                        ]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.step == "submitted" || _vm.step == "submittedDeclination"
              ? _c(
                  "div",
                  { staticClass: "mt-3 text-sm text-center text-grey-dark" },
                  [_vm._v(_vm._s(_vm.$t("Redirecting")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.invitation
              ? _c("dfp-slot", {
                  staticClass: "mt-6",
                  attrs: {
                    path: "/21865209613/Patients/InvitationShow",
                    size: [300, 250],
                    id: "div-gpt-ad-partner-invitation",
                    "medical-practice": _vm.invitation.emergencyType
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("decline-invitation-modal", {
        attrs: { active: _vm.showDeclineModal, invitation: _vm.invitation },
        on: { close: _vm.hideDecline, declined: _vm.decline }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-grey" }, [
      _c("i", { staticClass: "mdi mdi-loading mdi-spin" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-white" }, [
      _c("i", { staticClass: "mdi mdi-verified" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-white" }, [
      _c("i", { staticClass: "mdi mdi-verified" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-white" }, [
      _c("i", { staticClass: "mdi mdi-alert-circle" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b46d0d0", esExports)
  }
}

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getters; });
var getters = {
    layout: function layout(state) {
        return state.currentLayout;
    },
    patient: function patient(state) {
        return state.patient;
    },
    patientPosition: function patientPosition(state) {
        return state.patientPosition;
    },
    patientPlace: function patientPlace(state) {
        return state.patientPlace;
    },
    patientPlaceName: function patientPlaceName(state) {
        return state.patientPlaceName;
    },
    patientMedicalPractice: function patientMedicalPractice(state) {
        return state.patientMedicalPractice;
    },
    online: function online(state) {
        return state.online;
    },
    getOnboardingStep: function getOnboardingStep(state) {
        return state.onboardingStep;
    },
    getCurrentOffice: function getCurrentOffice(state) {
        return state.currentOffice;
    },
    getCurrentDate: function getCurrentDate(state) {
        return state.currentDate;
    },
    getUserId: function getUserId(state) {
        return state.userId;
    },
    getFirebaseToken: function getFirebaseToken(state) {
        return state.firebaseToken;
    },
    getListenAppointments: function getListenAppointments(state) {
        return state.listenAppointments;
    },
    getDoctor: function getDoctor(state) {
        return state.doctor;
    },
    getOffices: function getOffices(state) {
        return state.offices;
    },
    getRecommendations: function getRecommendations(state) {
        return state.offices;
    },
    getNotifications: function getNotifications(state) {
        return state.notifications;
    },
    getLanguages: function getLanguages(state) {
        return state.languages;
    },
    getCountries: function getCountries(state) {
        return state.countries;
    },
    getDefaultCountryId: function getDefaultCountryId(state) {
        return state.defaultCountryId;
    },
    getError: function getError(state) {
        return state.error;
    }
};

/***/ }),
/* 783 */,
/* 784 */,
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Avatar_vue__ = __webpack_require__(389);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5811d9ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Avatar_vue__ = __webpack_require__(786);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Avatar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5811d9ee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Avatar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Avatar.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5811d9ee", Component.options)
  } else {
    hotAPI.reload("data-v-5811d9ee", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.avatar
    ? _c("img", { attrs: { src: _vm.avatarUrl, alt: _vm.alt } })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5811d9ee", esExports)
  }
}

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DfpSlot_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95047168_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DfpSlot_vue__ = __webpack_require__(788);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DfpSlot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95047168_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DfpSlot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/DfpSlot.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-95047168", Component.options)
  } else {
    hotAPI.reload("data-v-95047168", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "flex items-center justify-center",
    attrs: { id: _vm.id }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-95047168", esExports)
  }
}

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingBlock_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa5a0b6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingBlock_vue__ = __webpack_require__(790);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingBlock_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa5a0b6a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingBlock_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Patient/LoadingBlock.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-aa5a0b6a", Component.options)
  } else {
    hotAPI.reload("data-v-aa5a0b6a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "max-w-sm mx-auto px-6" }, [
    _c("div", { staticClass: "flex items-center justify-center h-64" }, [
      _c("div", { staticClass: "text-center" }, [
        _vm._m(0),
        _c("br"),
        _vm._v(" "),
        _c("span", {
          staticClass: "text-sm text-grey-darker mt-4",
          domProps: { textContent: _vm._s(_vm.$t("Loading")) }
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon text-5xl text-grey" }, [
      _c("i", { staticClass: "mdi mdi-loading mdi-spin" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aa5a0b6a", esExports)
  }
}

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(807);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientLayout_vue__ = __webpack_require__(400);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6de776e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientLayout_vue__ = __webpack_require__(795);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(793)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PatientLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6de776e0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PatientLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/layouts/PatientLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6de776e0", Component.options)
  } else {
    hotAPI.reload("data-v-6de776e0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(794);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(20)("527fe414", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6de776e0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!./patient.scss", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6de776e0\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!./patient.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(393);
exports = module.exports = __webpack_require__(19)(false);
// imports


// module
exports.push([module.i, "/*! normalize.css v7.0.0 | MIT License | github.com/necolas/normalize.css */\n\n/* Document\n   ========================================================================== */\n\n/**\n * 1. Correct the line height in all browsers.\n * 2. Prevent adjustments of font size after orientation changes in\n *    IE on Windows Phone and in iOS.\n */\nhtml {\n  line-height: 1.15; /* 1 */\n      -ms-text-size-adjust: 100%; /* 2 */\n  -webkit-text-size-adjust: 100%; /* 2 */\n}\n\n/* Sections\n   ========================================================================== */\n\n/**\n * Remove the margin in all browsers (opinionated).\n */\nbody {\n  margin: 0;\n}\n\n/**\n * Add the correct display in IE 9-.\n */\narticle,\naside,\nfooter,\nheader,\nnav,\nsection {\n  display: block;\n}\n\n/**\n * Correct the font size and margin on `h1` elements within `section` and\n * `article` contexts in Chrome, Firefox, and Safari.\n */\nh1 {\n  font-size: 2em;\n  margin: .67em 0;\n}\n\n/* Grouping content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n * 1. Add the correct display in IE.\n */\nfigcaption,\nfigure,\nmain {\n  /* 1 */\n  display: block;\n}\n\n/**\n * Add the correct margin in IE 8.\n */\nfigure {\n  margin: 1em 40px;\n}\n\n/**\n * 1. Add the correct box sizing in Firefox.\n * 2. Show the overflow in Edge and IE.\n */\nhr {\n  box-sizing: content-box; /* 1 */\n  height: 0; /* 1 */\n  overflow: visible; /* 2 */\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\npre {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/* Text-level semantics\n   ========================================================================== */\n\n/**\n * 1. Remove the gray background on active links in IE 10.\n * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.\n */\na {\n  background-color: transparent; /* 1 */\n  -webkit-text-decoration-skip: objects; /* 2 */\n}\n\n/**\n * 1. Remove the bottom border in Chrome 57- and Firefox 39-.\n * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n */\nabbr[title] {\n  border-bottom: none; /* 1 */\n  text-decoration: underline; /* 2 */\n  text-decoration: underline dotted; /* 2 */\n}\n\n/**\n * Prevent the duplicate application of `bolder` by the next rule in Safari 6.\n */\nb,\nstrong {\n  font-weight: inherit;\n}\n\n/**\n * Add the correct font weight in Chrome, Edge, and Safari.\n */\nb,\nstrong {\n  font-weight: bolder;\n}\n\n/**\n * 1. Correct the inheritance and scaling of font size in all browsers.\n * 2. Correct the odd `em` font sizing in all browsers.\n */\ncode,\nkbd,\nsamp {\n  font-family: monospace, monospace; /* 1 */\n  font-size: 1em; /* 2 */\n}\n\n/**\n * Add the correct font style in Android 4.3-.\n */\ndfn {\n  font-style: italic;\n}\n\n/**\n * Add the correct background and color in IE 9-.\n */\nmark {\n  background-color: #ff0;\n  color: #000;\n}\n\n/**\n * Add the correct font size in all browsers.\n */\nsmall {\n  font-size: 80%;\n}\n\n/**\n * Prevent `sub` and `sup` elements from affecting the line height in\n * all browsers.\n */\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\n\n/* Embedded content\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\naudio,\nvideo {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in iOS 4-7.\n */\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\n\n/**\n * Remove the border on images inside links in IE 10-.\n */\nimg {\n  border-style: none;\n}\n\n/**\n * Hide the overflow in IE.\n */\nsvg:not(:root) {\n  overflow: hidden;\n}\n\n/* Forms\n   ========================================================================== */\n\n/**\n * 1. Change the font styles in all browsers (opinionated).\n * 2. Remove the margin in Firefox and Safari.\n */\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: sans-serif; /* 1 */\n  font-size: 100%; /* 1 */\n  line-height: 1.15; /* 1 */\n  margin: 0; /* 2 */\n}\n\n/**\n * Show the overflow in IE.\n * 1. Show the overflow in Edge.\n */\nbutton,\ninput {\n  /* 1 */\n  overflow: visible;\n}\n\n/**\n * Remove the inheritance of text transform in Edge, Firefox, and IE.\n * 1. Remove the inheritance of text transform in Firefox.\n */\nbutton,\nselect {\n  /* 1 */\n  text-transform: none;\n}\n\n/**\n * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n *    controls in Android 4.\n * 2. Correct the inability to style clickable types in iOS and Safari.\n */\nbutton,\nhtml [type=\"button\"],\n/* 1 */\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; /* 2 */\n}\n\n/**\n * Remove the inner border and padding in Firefox.\n */\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: none;\n  padding: 0;\n}\n\n/**\n * Restore the focus styles unset by the previous rule.\n */\nbutton:-moz-focusring,\n[type=\"button\"]:-moz-focusring,\n[type=\"reset\"]:-moz-focusring,\n[type=\"submit\"]:-moz-focusring {\n  outline: 1px dotted ButtonText;\n}\n\n/**\n * Correct the padding in Firefox.\n */\nfieldset {\n  padding: .35em .75em .625em;\n}\n\n/**\n * 1. Correct the text wrapping in Edge and IE.\n * 2. Correct the color inheritance from `fieldset` elements in IE.\n * 3. Remove the padding so developers are not caught out when they zero out\n *    `fieldset` elements in all browsers.\n */\nlegend {\n  box-sizing: border-box; /* 1 */\n  color: inherit; /* 2 */\n  display: table; /* 1 */\n  max-width: 100%; /* 1 */\n  padding: 0; /* 3 */\n  white-space: normal; /* 1 */\n}\n\n/**\n * 1. Add the correct display in IE 9-.\n * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.\n */\nprogress {\n  display: inline-block; /* 1 */\n  vertical-align: baseline; /* 2 */\n}\n\n/**\n * Remove the default vertical scrollbar in IE.\n */\ntextarea {\n  overflow: auto;\n}\n\n/**\n * 1. Add the correct box sizing in IE 10-.\n * 2. Remove the padding in IE 10-.\n */\n[type=\"checkbox\"],\n[type=\"radio\"] {\n  box-sizing: border-box; /* 1 */\n  padding: 0; /* 2 */\n}\n\n/**\n * Correct the cursor style of increment and decrement buttons in Chrome.\n */\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n/**\n * 1. Correct the odd appearance in Chrome and Safari.\n * 2. Correct the outline style in Safari.\n */\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* 1 */\n  outline-offset: -2px; /* 2 */\n}\n\n/**\n * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.\n */\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n/**\n * 1. Correct the inability to style clickable types in iOS and Safari.\n * 2. Change font properties to `inherit` in Safari.\n */\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* 1 */\n  font: inherit; /* 2 */\n}\n\n/* Interactive\n   ========================================================================== */\n\n/*\n * Add the correct display in IE 9-.\n * 1. Add the correct display in Edge, IE, and Firefox.\n */\ndetails,\n/* 1 */\nmenu {\n  display: block;\n}\n\n/*\n * Add the correct display in all browsers.\n */\nsummary {\n  display: list-item;\n}\n\n/* Scripting\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 9-.\n */\ncanvas {\n  display: inline-block;\n}\n\n/**\n * Add the correct display in IE.\n */\ntemplate {\n  display: none;\n}\n\n/* Hidden\n   ========================================================================== */\n\n/**\n * Add the correct display in IE 10-.\n */\n[hidden] {\n  display: none;\n}\n\n/**\n * Manually forked from SUIT CSS Base: https://github.com/suitcss/base\n * A thin layer on top of normalize.css that provides a starting point more\n * suitable for web applications.\n */\n\n/**\n * 1. Prevent padding and border from affecting element width\n * https://goo.gl/pYtbK7\n * 2. Change the default font family in all browsers (opinionated)\n */\nhtml {\n  box-sizing: border-box; /* 1 */\n  font-family: sans-serif; /* 2 */\n}\n*,\n*::before,\n*::after {\n  box-sizing: inherit;\n}\n\n/**\n * Removes the default spacing and border for appropriate elements.\n */\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nfigure,\np,\npre {\n  margin: 0;\n}\nbutton {\n  background: transparent;\n  padding: 0;\n}\n\n/**\n * Work around a Firefox/IE bug where the transparent `button` background\n * results in a loss of the default `button` focus styles.\n */\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\nfieldset {\n  margin: 0;\n  padding: 0;\n}\nol,\nul {\n  margin: 0;\n}\n\n/**\n * Suppress the focus outline on elements that cannot be accessed via keyboard.\n * This prevents an unwanted focus outline from appearing around elements that\n * might still respond to pointer events.\n */\n[tabindex=\"-1\"]:focus {\n  outline: none !important;\n}\n\n/**\n * Tailwind custom reset styles\n */\n\n/**\n * Allow adding a border to an element by just adding a border-width.\n *\n * By default, the way the browser specifies that an element should have no\n * border is by setting it's border-style to `none` in the user-agent\n * stylesheet.\n *\n * In order to easily add borders to elements by just setting the `border-width`\n * property, we change the default border-style for all elements to `solid`, and\n * use border-width to hide them instead. This way our `border` utilities only\n * need to set the `border-width` property instead of the entire `border`\n * shorthand, making our border utilities much more straightforward to compose.\n *\n * https://github.com/tailwindcss/tailwindcss/pull/116\n */\n*,\n*::before,\n*::after {\n  border-width: 0;\n  border-style: solid;\n  border-color: #dae1e7;\n}\n\n/**\n * Undo the `border-style: none` reset that Normalize applies to images so that\n * our `border-{width}` utilities have the expected effect.\n *\n * The Normalize reset is unnecessary for us since we default the border-width\n * to 0 on all elements.\n *\n * https://github.com/tailwindcss/tailwindcss/issues/362\n */\nimg {\n  border-style: solid;\n}\n\n/**\n * Temporary reset for a change introduced in Chrome 62 but now reverted.\n *\n * We can remove this when the reversion is in a normal Chrome release.\n */\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  border-radius: 0;\n}\ntextarea {\n  resize: vertical;\n}\nimg {\n  max-width: 100%;\n}\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-family: inherit;\n}\ninput::placeholder,\ntextarea::placeholder {\n  color: inherit;\n  opacity: .5;\n}\nbutton,\n[role=button] {\n  cursor: pointer;\n}\n.container {\n  width: 100%;\n}\n@media (min-width: 576px) {\n.container {\n    max-width: 576px;\n}\n}\n@media (min-width: 768px) {\n.container {\n    max-width: 768px;\n}\n}\n@media (min-width: 992px) {\n.container {\n    max-width: 992px;\n}\n}\n@media (min-width: 1200px) {\n.container {\n    max-width: 1200px;\n}\n}\n.list-reset {\n  list-style: none;\n  padding: 0;\n}\n.appearance-none {\n  appearance: none;\n}\n.bg-fixed {\n  background-attachment: fixed;\n}\n.bg-local {\n  background-attachment: local;\n}\n.bg-scroll {\n  background-attachment: scroll;\n}\n.bg-transparent {\n  background-color: transparent;\n}\n.bg-modal {\n  background-color: rgba(0, 0, 0, .4);\n}\n.bg-google {\n  background-color: #dc5b5b;\n}\n.bg-google-dark {\n  background-color: #da5050;\n}\n.bg-facebook {\n  background-color: #3b5998;\n}\n.bg-facebook-dark {\n  background-color: #37548f;\n}\n.bg-primary {\n  background-color: #2196f3;\n}\n.bg-primary-dark {\n  background-color: #3b5998;\n}\n.bg-footer {\n  background-color: #1976d2;\n}\n.bg-black {\n  background-color: #22292f;\n}\n.bg-grey-darkest {\n  background-color: #3d4852;\n}\n.bg-grey-darker {\n  background-color: #606f7b;\n}\n.bg-grey-dark {\n  background-color: #8795a1;\n}\n.bg-grey {\n  background-color: #b8c2cc;\n}\n.bg-grey-light {\n  background-color: #dae1e7;\n}\n.bg-grey-lighter {\n  background-color: #f1f5f8;\n}\n.bg-grey-lightest {\n  background-color: #f8fafc;\n}\n.bg-white {\n  background-color: #fff;\n}\n.bg-whiter {\n  background-color: rgba(255, 255, 255, .6);\n}\n.bg-red-darkest {\n  background-color: #3b0d0c;\n}\n.bg-red-darker {\n  background-color: #621b18;\n}\n.bg-red-dark {\n  background-color: #cc1f1a;\n}\n.bg-red {\n  background-color: #e3342f;\n}\n.bg-red-light {\n  background-color: #ef5753;\n}\n.bg-red-lighter {\n  background-color: #f9acaa;\n}\n.bg-red-lightest {\n  background-color: #fcebea;\n}\n.bg-orange-darkest {\n  background-color: #462a16;\n}\n.bg-orange-darker {\n  background-color: #613b1f;\n}\n.bg-orange-dark {\n  background-color: #de751f;\n}\n.bg-orange {\n  background-color: #f6993f;\n}\n.bg-orange-light {\n  background-color: #faad63;\n}\n.bg-orange-lighter {\n  background-color: #fcd9b6;\n}\n.bg-orange-lightest {\n  background-color: #fff5eb;\n}\n.bg-yellow-darkest {\n  background-color: #453411;\n}\n.bg-yellow-darker {\n  background-color: #684f1d;\n}\n.bg-yellow-dark {\n  background-color: #f2d024;\n}\n.bg-yellow {\n  background-color: #ffed4a;\n}\n.bg-yellow-light {\n  background-color: #fff382;\n}\n.bg-yellow-lighter {\n  background-color: #fff9c2;\n}\n.bg-yellow-lightest {\n  background-color: #fcfbeb;\n}\n.bg-green-darkest {\n  background-color: #0f2f21;\n}\n.bg-green-darker {\n  background-color: #1a4731;\n}\n.bg-green-dark {\n  background-color: #1f9d55;\n}\n.bg-green {\n  background-color: #38c172;\n}\n.bg-green-light {\n  background-color: #51d88a;\n}\n.bg-green-lighter {\n  background-color: #a2f5bf;\n}\n.bg-green-lightest {\n  background-color: #e3fcec;\n}\n.bg-teal-darkest {\n  background-color: #0d3331;\n}\n.bg-teal-darker {\n  background-color: #20504f;\n}\n.bg-teal-dark {\n  background-color: #009480;\n}\n.bg-teal {\n  background-color: #00ae98;\n}\n.bg-teal-light {\n  background-color: #64d5ca;\n}\n.bg-teal-lighter {\n  background-color: #a0f0ed;\n}\n.bg-teal-lightest {\n  background-color: #e8fffe;\n}\n.bg-blue-darkest {\n  background-color: #12283a;\n}\n.bg-blue-darker {\n  background-color: #2e6da2;\n}\n.bg-blue-dark {\n  background-color: #2779bd;\n}\n.bg-blue {\n  background-color: #3490dc;\n}\n.bg-blue-light {\n  background-color: #6cb2eb;\n}\n.bg-blue-lighter {\n  background-color: #bcdefa;\n}\n.bg-blue-lightest {\n  background-color: #eff8ff;\n}\n.bg-indigo-darkest {\n  background-color: #191e38;\n}\n.bg-indigo-darker {\n  background-color: #2f365f;\n}\n.bg-indigo-dark {\n  background-color: #5661b3;\n}\n.bg-indigo {\n  background-color: #6574cd;\n}\n.bg-indigo-light {\n  background-color: #7886d7;\n}\n.bg-indigo-lighter {\n  background-color: #b2b7ff;\n}\n.bg-indigo-lightest {\n  background-color: #e6e8ff;\n}\n.bg-purple-darkest {\n  background-color: #21183c;\n}\n.bg-purple-darker {\n  background-color: #382b5f;\n}\n.bg-purple-dark {\n  background-color: #794acf;\n}\n.bg-purple {\n  background-color: #9561e2;\n}\n.bg-purple-light {\n  background-color: #a779e9;\n}\n.bg-purple-lighter {\n  background-color: #d6bbfc;\n}\n.bg-purple-lightest {\n  background-color: #f3ebff;\n}\n.bg-pink-darkest {\n  background-color: #451225;\n}\n.bg-pink-darker {\n  background-color: #6f213f;\n}\n.bg-pink-dark {\n  background-color: #eb5286;\n}\n.bg-pink {\n  background-color: #f66d9b;\n}\n.bg-pink-light {\n  background-color: #fa7ea8;\n}\n.bg-pink-lighter {\n  background-color: #ffbbca;\n}\n.bg-pink-lightest {\n  background-color: #ffebef;\n}\n.group:hover .group-hover\\:bg-transparent {\n  background-color: transparent;\n}\n.group:hover .group-hover\\:bg-modal {\n  background-color: rgba(0, 0, 0, .4);\n}\n.group:hover .group-hover\\:bg-google {\n  background-color: #dc5b5b;\n}\n.group:hover .group-hover\\:bg-google-dark {\n  background-color: #da5050;\n}\n.group:hover .group-hover\\:bg-facebook {\n  background-color: #3b5998;\n}\n.group:hover .group-hover\\:bg-facebook-dark {\n  background-color: #37548f;\n}\n.group:hover .group-hover\\:bg-primary {\n  background-color: #2196f3;\n}\n.group:hover .group-hover\\:bg-primary-dark {\n  background-color: #3b5998;\n}\n.group:hover .group-hover\\:bg-footer {\n  background-color: #1976d2;\n}\n.group:hover .group-hover\\:bg-black {\n  background-color: #22292f;\n}\n.group:hover .group-hover\\:bg-grey-darkest {\n  background-color: #3d4852;\n}\n.group:hover .group-hover\\:bg-grey-darker {\n  background-color: #606f7b;\n}\n.group:hover .group-hover\\:bg-grey-dark {\n  background-color: #8795a1;\n}\n.group:hover .group-hover\\:bg-grey {\n  background-color: #b8c2cc;\n}\n.group:hover .group-hover\\:bg-grey-light {\n  background-color: #dae1e7;\n}\n.group:hover .group-hover\\:bg-grey-lighter {\n  background-color: #f1f5f8;\n}\n.group:hover .group-hover\\:bg-grey-lightest {\n  background-color: #f8fafc;\n}\n.group:hover .group-hover\\:bg-white {\n  background-color: #fff;\n}\n.group:hover .group-hover\\:bg-whiter {\n  background-color: rgba(255, 255, 255, .6);\n}\n.group:hover .group-hover\\:bg-red-darkest {\n  background-color: #3b0d0c;\n}\n.group:hover .group-hover\\:bg-red-darker {\n  background-color: #621b18;\n}\n.group:hover .group-hover\\:bg-red-dark {\n  background-color: #cc1f1a;\n}\n.group:hover .group-hover\\:bg-red {\n  background-color: #e3342f;\n}\n.group:hover .group-hover\\:bg-red-light {\n  background-color: #ef5753;\n}\n.group:hover .group-hover\\:bg-red-lighter {\n  background-color: #f9acaa;\n}\n.group:hover .group-hover\\:bg-red-lightest {\n  background-color: #fcebea;\n}\n.group:hover .group-hover\\:bg-orange-darkest {\n  background-color: #462a16;\n}\n.group:hover .group-hover\\:bg-orange-darker {\n  background-color: #613b1f;\n}\n.group:hover .group-hover\\:bg-orange-dark {\n  background-color: #de751f;\n}\n.group:hover .group-hover\\:bg-orange {\n  background-color: #f6993f;\n}\n.group:hover .group-hover\\:bg-orange-light {\n  background-color: #faad63;\n}\n.group:hover .group-hover\\:bg-orange-lighter {\n  background-color: #fcd9b6;\n}\n.group:hover .group-hover\\:bg-orange-lightest {\n  background-color: #fff5eb;\n}\n.group:hover .group-hover\\:bg-yellow-darkest {\n  background-color: #453411;\n}\n.group:hover .group-hover\\:bg-yellow-darker {\n  background-color: #684f1d;\n}\n.group:hover .group-hover\\:bg-yellow-dark {\n  background-color: #f2d024;\n}\n.group:hover .group-hover\\:bg-yellow {\n  background-color: #ffed4a;\n}\n.group:hover .group-hover\\:bg-yellow-light {\n  background-color: #fff382;\n}\n.group:hover .group-hover\\:bg-yellow-lighter {\n  background-color: #fff9c2;\n}\n.group:hover .group-hover\\:bg-yellow-lightest {\n  background-color: #fcfbeb;\n}\n.group:hover .group-hover\\:bg-green-darkest {\n  background-color: #0f2f21;\n}\n.group:hover .group-hover\\:bg-green-darker {\n  background-color: #1a4731;\n}\n.group:hover .group-hover\\:bg-green-dark {\n  background-color: #1f9d55;\n}\n.group:hover .group-hover\\:bg-green {\n  background-color: #38c172;\n}\n.group:hover .group-hover\\:bg-green-light {\n  background-color: #51d88a;\n}\n.group:hover .group-hover\\:bg-green-lighter {\n  background-color: #a2f5bf;\n}\n.group:hover .group-hover\\:bg-green-lightest {\n  background-color: #e3fcec;\n}\n.group:hover .group-hover\\:bg-teal-darkest {\n  background-color: #0d3331;\n}\n.group:hover .group-hover\\:bg-teal-darker {\n  background-color: #20504f;\n}\n.group:hover .group-hover\\:bg-teal-dark {\n  background-color: #009480;\n}\n.group:hover .group-hover\\:bg-teal {\n  background-color: #00ae98;\n}\n.group:hover .group-hover\\:bg-teal-light {\n  background-color: #64d5ca;\n}\n.group:hover .group-hover\\:bg-teal-lighter {\n  background-color: #a0f0ed;\n}\n.group:hover .group-hover\\:bg-teal-lightest {\n  background-color: #e8fffe;\n}\n.group:hover .group-hover\\:bg-blue-darkest {\n  background-color: #12283a;\n}\n.group:hover .group-hover\\:bg-blue-darker {\n  background-color: #2e6da2;\n}\n.group:hover .group-hover\\:bg-blue-dark {\n  background-color: #2779bd;\n}\n.group:hover .group-hover\\:bg-blue {\n  background-color: #3490dc;\n}\n.group:hover .group-hover\\:bg-blue-light {\n  background-color: #6cb2eb;\n}\n.group:hover .group-hover\\:bg-blue-lighter {\n  background-color: #bcdefa;\n}\n.group:hover .group-hover\\:bg-blue-lightest {\n  background-color: #eff8ff;\n}\n.group:hover .group-hover\\:bg-indigo-darkest {\n  background-color: #191e38;\n}\n.group:hover .group-hover\\:bg-indigo-darker {\n  background-color: #2f365f;\n}\n.group:hover .group-hover\\:bg-indigo-dark {\n  background-color: #5661b3;\n}\n.group:hover .group-hover\\:bg-indigo {\n  background-color: #6574cd;\n}\n.group:hover .group-hover\\:bg-indigo-light {\n  background-color: #7886d7;\n}\n.group:hover .group-hover\\:bg-indigo-lighter {\n  background-color: #b2b7ff;\n}\n.group:hover .group-hover\\:bg-indigo-lightest {\n  background-color: #e6e8ff;\n}\n.group:hover .group-hover\\:bg-purple-darkest {\n  background-color: #21183c;\n}\n.group:hover .group-hover\\:bg-purple-darker {\n  background-color: #382b5f;\n}\n.group:hover .group-hover\\:bg-purple-dark {\n  background-color: #794acf;\n}\n.group:hover .group-hover\\:bg-purple {\n  background-color: #9561e2;\n}\n.group:hover .group-hover\\:bg-purple-light {\n  background-color: #a779e9;\n}\n.group:hover .group-hover\\:bg-purple-lighter {\n  background-color: #d6bbfc;\n}\n.group:hover .group-hover\\:bg-purple-lightest {\n  background-color: #f3ebff;\n}\n.group:hover .group-hover\\:bg-pink-darkest {\n  background-color: #451225;\n}\n.group:hover .group-hover\\:bg-pink-darker {\n  background-color: #6f213f;\n}\n.group:hover .group-hover\\:bg-pink-dark {\n  background-color: #eb5286;\n}\n.group:hover .group-hover\\:bg-pink {\n  background-color: #f66d9b;\n}\n.group:hover .group-hover\\:bg-pink-light {\n  background-color: #fa7ea8;\n}\n.group:hover .group-hover\\:bg-pink-lighter {\n  background-color: #ffbbca;\n}\n.group:hover .group-hover\\:bg-pink-lightest {\n  background-color: #ffebef;\n}\n.hover\\:bg-transparent:hover {\n  background-color: transparent;\n}\n.hover\\:bg-modal:hover {\n  background-color: rgba(0, 0, 0, .4);\n}\n.hover\\:bg-google:hover {\n  background-color: #dc5b5b;\n}\n.hover\\:bg-google-dark:hover {\n  background-color: #da5050;\n}\n.hover\\:bg-facebook:hover {\n  background-color: #3b5998;\n}\n.hover\\:bg-facebook-dark:hover {\n  background-color: #37548f;\n}\n.hover\\:bg-primary:hover {\n  background-color: #2196f3;\n}\n.hover\\:bg-primary-dark:hover {\n  background-color: #3b5998;\n}\n.hover\\:bg-footer:hover {\n  background-color: #1976d2;\n}\n.hover\\:bg-black:hover {\n  background-color: #22292f;\n}\n.hover\\:bg-grey-darkest:hover {\n  background-color: #3d4852;\n}\n.hover\\:bg-grey-darker:hover {\n  background-color: #606f7b;\n}\n.hover\\:bg-grey-dark:hover {\n  background-color: #8795a1;\n}\n.hover\\:bg-grey:hover {\n  background-color: #b8c2cc;\n}\n.hover\\:bg-grey-light:hover {\n  background-color: #dae1e7;\n}\n.hover\\:bg-grey-lighter:hover {\n  background-color: #f1f5f8;\n}\n.hover\\:bg-grey-lightest:hover {\n  background-color: #f8fafc;\n}\n.hover\\:bg-white:hover {\n  background-color: #fff;\n}\n.hover\\:bg-whiter:hover {\n  background-color: rgba(255, 255, 255, .6);\n}\n.hover\\:bg-red-darkest:hover {\n  background-color: #3b0d0c;\n}\n.hover\\:bg-red-darker:hover {\n  background-color: #621b18;\n}\n.hover\\:bg-red-dark:hover {\n  background-color: #cc1f1a;\n}\n.hover\\:bg-red:hover {\n  background-color: #e3342f;\n}\n.hover\\:bg-red-light:hover {\n  background-color: #ef5753;\n}\n.hover\\:bg-red-lighter:hover {\n  background-color: #f9acaa;\n}\n.hover\\:bg-red-lightest:hover {\n  background-color: #fcebea;\n}\n.hover\\:bg-orange-darkest:hover {\n  background-color: #462a16;\n}\n.hover\\:bg-orange-darker:hover {\n  background-color: #613b1f;\n}\n.hover\\:bg-orange-dark:hover {\n  background-color: #de751f;\n}\n.hover\\:bg-orange:hover {\n  background-color: #f6993f;\n}\n.hover\\:bg-orange-light:hover {\n  background-color: #faad63;\n}\n.hover\\:bg-orange-lighter:hover {\n  background-color: #fcd9b6;\n}\n.hover\\:bg-orange-lightest:hover {\n  background-color: #fff5eb;\n}\n.hover\\:bg-yellow-darkest:hover {\n  background-color: #453411;\n}\n.hover\\:bg-yellow-darker:hover {\n  background-color: #684f1d;\n}\n.hover\\:bg-yellow-dark:hover {\n  background-color: #f2d024;\n}\n.hover\\:bg-yellow:hover {\n  background-color: #ffed4a;\n}\n.hover\\:bg-yellow-light:hover {\n  background-color: #fff382;\n}\n.hover\\:bg-yellow-lighter:hover {\n  background-color: #fff9c2;\n}\n.hover\\:bg-yellow-lightest:hover {\n  background-color: #fcfbeb;\n}\n.hover\\:bg-green-darkest:hover {\n  background-color: #0f2f21;\n}\n.hover\\:bg-green-darker:hover {\n  background-color: #1a4731;\n}\n.hover\\:bg-green-dark:hover {\n  background-color: #1f9d55;\n}\n.hover\\:bg-green:hover {\n  background-color: #38c172;\n}\n.hover\\:bg-green-light:hover {\n  background-color: #51d88a;\n}\n.hover\\:bg-green-lighter:hover {\n  background-color: #a2f5bf;\n}\n.hover\\:bg-green-lightest:hover {\n  background-color: #e3fcec;\n}\n.hover\\:bg-teal-darkest:hover {\n  background-color: #0d3331;\n}\n.hover\\:bg-teal-darker:hover {\n  background-color: #20504f;\n}\n.hover\\:bg-teal-dark:hover {\n  background-color: #009480;\n}\n.hover\\:bg-teal:hover {\n  background-color: #00ae98;\n}\n.hover\\:bg-teal-light:hover {\n  background-color: #64d5ca;\n}\n.hover\\:bg-teal-lighter:hover {\n  background-color: #a0f0ed;\n}\n.hover\\:bg-teal-lightest:hover {\n  background-color: #e8fffe;\n}\n.hover\\:bg-blue-darkest:hover {\n  background-color: #12283a;\n}\n.hover\\:bg-blue-darker:hover {\n  background-color: #2e6da2;\n}\n.hover\\:bg-blue-dark:hover {\n  background-color: #2779bd;\n}\n.hover\\:bg-blue:hover {\n  background-color: #3490dc;\n}\n.hover\\:bg-blue-light:hover {\n  background-color: #6cb2eb;\n}\n.hover\\:bg-blue-lighter:hover {\n  background-color: #bcdefa;\n}\n.hover\\:bg-blue-lightest:hover {\n  background-color: #eff8ff;\n}\n.hover\\:bg-indigo-darkest:hover {\n  background-color: #191e38;\n}\n.hover\\:bg-indigo-darker:hover {\n  background-color: #2f365f;\n}\n.hover\\:bg-indigo-dark:hover {\n  background-color: #5661b3;\n}\n.hover\\:bg-indigo:hover {\n  background-color: #6574cd;\n}\n.hover\\:bg-indigo-light:hover {\n  background-color: #7886d7;\n}\n.hover\\:bg-indigo-lighter:hover {\n  background-color: #b2b7ff;\n}\n.hover\\:bg-indigo-lightest:hover {\n  background-color: #e6e8ff;\n}\n.hover\\:bg-purple-darkest:hover {\n  background-color: #21183c;\n}\n.hover\\:bg-purple-darker:hover {\n  background-color: #382b5f;\n}\n.hover\\:bg-purple-dark:hover {\n  background-color: #794acf;\n}\n.hover\\:bg-purple:hover {\n  background-color: #9561e2;\n}\n.hover\\:bg-purple-light:hover {\n  background-color: #a779e9;\n}\n.hover\\:bg-purple-lighter:hover {\n  background-color: #d6bbfc;\n}\n.hover\\:bg-purple-lightest:hover {\n  background-color: #f3ebff;\n}\n.hover\\:bg-pink-darkest:hover {\n  background-color: #451225;\n}\n.hover\\:bg-pink-darker:hover {\n  background-color: #6f213f;\n}\n.hover\\:bg-pink-dark:hover {\n  background-color: #eb5286;\n}\n.hover\\:bg-pink:hover {\n  background-color: #f66d9b;\n}\n.hover\\:bg-pink-light:hover {\n  background-color: #fa7ea8;\n}\n.hover\\:bg-pink-lighter:hover {\n  background-color: #ffbbca;\n}\n.hover\\:bg-pink-lightest:hover {\n  background-color: #ffebef;\n}\n.bg-bottom {\n  background-position: bottom;\n}\n.bg-center {\n  background-position: center;\n}\n.bg-left {\n  background-position: left;\n}\n.bg-left-bottom {\n  background-position: left bottom;\n}\n.bg-left-top {\n  background-position: left top;\n}\n.bg-right {\n  background-position: right;\n}\n.bg-right-bottom {\n  background-position: right bottom;\n}\n.bg-right-top {\n  background-position: right top;\n}\n.bg-top {\n  background-position: top;\n}\n.bg-repeat {\n  background-repeat: repeat;\n}\n.bg-no-repeat {\n  background-repeat: no-repeat;\n}\n.bg-repeat-x {\n  background-repeat: repeat-x;\n}\n.bg-repeat-y {\n  background-repeat: repeat-y;\n}\n.bg-auto {\n  background-size: auto;\n}\n.bg-cover {\n  background-size: cover;\n}\n.bg-contain {\n  background-size: contain;\n}\n.border-transparent {\n  border-color: transparent;\n}\n.border-modal {\n  border-color: rgba(0, 0, 0, .4);\n}\n.border-google {\n  border-color: #dc5b5b;\n}\n.border-google-dark {\n  border-color: #da5050;\n}\n.border-facebook {\n  border-color: #3b5998;\n}\n.border-facebook-dark {\n  border-color: #37548f;\n}\n.border-primary {\n  border-color: #2196f3;\n}\n.border-primary-dark {\n  border-color: #3b5998;\n}\n.border-footer {\n  border-color: #1976d2;\n}\n.border-black {\n  border-color: #22292f;\n}\n.border-grey-darkest {\n  border-color: #3d4852;\n}\n.border-grey-darker {\n  border-color: #606f7b;\n}\n.border-grey-dark {\n  border-color: #8795a1;\n}\n.border-grey {\n  border-color: #b8c2cc;\n}\n.border-grey-light {\n  border-color: #dae1e7;\n}\n.border-grey-lighter {\n  border-color: #f1f5f8;\n}\n.border-grey-lightest {\n  border-color: #f8fafc;\n}\n.border-white {\n  border-color: #fff;\n}\n.border-whiter {\n  border-color: rgba(255, 255, 255, .6);\n}\n.border-red-darkest {\n  border-color: #3b0d0c;\n}\n.border-red-darker {\n  border-color: #621b18;\n}\n.border-red-dark {\n  border-color: #cc1f1a;\n}\n.border-red {\n  border-color: #e3342f;\n}\n.border-red-light {\n  border-color: #ef5753;\n}\n.border-red-lighter {\n  border-color: #f9acaa;\n}\n.border-red-lightest {\n  border-color: #fcebea;\n}\n.border-orange-darkest {\n  border-color: #462a16;\n}\n.border-orange-darker {\n  border-color: #613b1f;\n}\n.border-orange-dark {\n  border-color: #de751f;\n}\n.border-orange {\n  border-color: #f6993f;\n}\n.border-orange-light {\n  border-color: #faad63;\n}\n.border-orange-lighter {\n  border-color: #fcd9b6;\n}\n.border-orange-lightest {\n  border-color: #fff5eb;\n}\n.border-yellow-darkest {\n  border-color: #453411;\n}\n.border-yellow-darker {\n  border-color: #684f1d;\n}\n.border-yellow-dark {\n  border-color: #f2d024;\n}\n.border-yellow {\n  border-color: #ffed4a;\n}\n.border-yellow-light {\n  border-color: #fff382;\n}\n.border-yellow-lighter {\n  border-color: #fff9c2;\n}\n.border-yellow-lightest {\n  border-color: #fcfbeb;\n}\n.border-green-darkest {\n  border-color: #0f2f21;\n}\n.border-green-darker {\n  border-color: #1a4731;\n}\n.border-green-dark {\n  border-color: #1f9d55;\n}\n.border-green {\n  border-color: #38c172;\n}\n.border-green-light {\n  border-color: #51d88a;\n}\n.border-green-lighter {\n  border-color: #a2f5bf;\n}\n.border-green-lightest {\n  border-color: #e3fcec;\n}\n.border-teal-darkest {\n  border-color: #0d3331;\n}\n.border-teal-darker {\n  border-color: #20504f;\n}\n.border-teal-dark {\n  border-color: #009480;\n}\n.border-teal {\n  border-color: #00ae98;\n}\n.border-teal-light {\n  border-color: #64d5ca;\n}\n.border-teal-lighter {\n  border-color: #a0f0ed;\n}\n.border-teal-lightest {\n  border-color: #e8fffe;\n}\n.border-blue-darkest {\n  border-color: #12283a;\n}\n.border-blue-darker {\n  border-color: #2e6da2;\n}\n.border-blue-dark {\n  border-color: #2779bd;\n}\n.border-blue {\n  border-color: #3490dc;\n}\n.border-blue-light {\n  border-color: #6cb2eb;\n}\n.border-blue-lighter {\n  border-color: #bcdefa;\n}\n.border-blue-lightest {\n  border-color: #eff8ff;\n}\n.border-indigo-darkest {\n  border-color: #191e38;\n}\n.border-indigo-darker {\n  border-color: #2f365f;\n}\n.border-indigo-dark {\n  border-color: #5661b3;\n}\n.border-indigo {\n  border-color: #6574cd;\n}\n.border-indigo-light {\n  border-color: #7886d7;\n}\n.border-indigo-lighter {\n  border-color: #b2b7ff;\n}\n.border-indigo-lightest {\n  border-color: #e6e8ff;\n}\n.border-purple-darkest {\n  border-color: #21183c;\n}\n.border-purple-darker {\n  border-color: #382b5f;\n}\n.border-purple-dark {\n  border-color: #794acf;\n}\n.border-purple {\n  border-color: #9561e2;\n}\n.border-purple-light {\n  border-color: #a779e9;\n}\n.border-purple-lighter {\n  border-color: #d6bbfc;\n}\n.border-purple-lightest {\n  border-color: #f3ebff;\n}\n.border-pink-darkest {\n  border-color: #451225;\n}\n.border-pink-darker {\n  border-color: #6f213f;\n}\n.border-pink-dark {\n  border-color: #eb5286;\n}\n.border-pink {\n  border-color: #f66d9b;\n}\n.border-pink-light {\n  border-color: #fa7ea8;\n}\n.border-pink-lighter {\n  border-color: #ffbbca;\n}\n.border-pink-lightest {\n  border-color: #ffebef;\n}\n.hover\\:border-transparent:hover {\n  border-color: transparent;\n}\n.hover\\:border-modal:hover {\n  border-color: rgba(0, 0, 0, .4);\n}\n.hover\\:border-google:hover {\n  border-color: #dc5b5b;\n}\n.hover\\:border-google-dark:hover {\n  border-color: #da5050;\n}\n.hover\\:border-facebook:hover {\n  border-color: #3b5998;\n}\n.hover\\:border-facebook-dark:hover {\n  border-color: #37548f;\n}\n.hover\\:border-primary:hover {\n  border-color: #2196f3;\n}\n.hover\\:border-primary-dark:hover {\n  border-color: #3b5998;\n}\n.hover\\:border-footer:hover {\n  border-color: #1976d2;\n}\n.hover\\:border-black:hover {\n  border-color: #22292f;\n}\n.hover\\:border-grey-darkest:hover {\n  border-color: #3d4852;\n}\n.hover\\:border-grey-darker:hover {\n  border-color: #606f7b;\n}\n.hover\\:border-grey-dark:hover {\n  border-color: #8795a1;\n}\n.hover\\:border-grey:hover {\n  border-color: #b8c2cc;\n}\n.hover\\:border-grey-light:hover {\n  border-color: #dae1e7;\n}\n.hover\\:border-grey-lighter:hover {\n  border-color: #f1f5f8;\n}\n.hover\\:border-grey-lightest:hover {\n  border-color: #f8fafc;\n}\n.hover\\:border-white:hover {\n  border-color: #fff;\n}\n.hover\\:border-whiter:hover {\n  border-color: rgba(255, 255, 255, .6);\n}\n.hover\\:border-red-darkest:hover {\n  border-color: #3b0d0c;\n}\n.hover\\:border-red-darker:hover {\n  border-color: #621b18;\n}\n.hover\\:border-red-dark:hover {\n  border-color: #cc1f1a;\n}\n.hover\\:border-red:hover {\n  border-color: #e3342f;\n}\n.hover\\:border-red-light:hover {\n  border-color: #ef5753;\n}\n.hover\\:border-red-lighter:hover {\n  border-color: #f9acaa;\n}\n.hover\\:border-red-lightest:hover {\n  border-color: #fcebea;\n}\n.hover\\:border-orange-darkest:hover {\n  border-color: #462a16;\n}\n.hover\\:border-orange-darker:hover {\n  border-color: #613b1f;\n}\n.hover\\:border-orange-dark:hover {\n  border-color: #de751f;\n}\n.hover\\:border-orange:hover {\n  border-color: #f6993f;\n}\n.hover\\:border-orange-light:hover {\n  border-color: #faad63;\n}\n.hover\\:border-orange-lighter:hover {\n  border-color: #fcd9b6;\n}\n.hover\\:border-orange-lightest:hover {\n  border-color: #fff5eb;\n}\n.hover\\:border-yellow-darkest:hover {\n  border-color: #453411;\n}\n.hover\\:border-yellow-darker:hover {\n  border-color: #684f1d;\n}\n.hover\\:border-yellow-dark:hover {\n  border-color: #f2d024;\n}\n.hover\\:border-yellow:hover {\n  border-color: #ffed4a;\n}\n.hover\\:border-yellow-light:hover {\n  border-color: #fff382;\n}\n.hover\\:border-yellow-lighter:hover {\n  border-color: #fff9c2;\n}\n.hover\\:border-yellow-lightest:hover {\n  border-color: #fcfbeb;\n}\n.hover\\:border-green-darkest:hover {\n  border-color: #0f2f21;\n}\n.hover\\:border-green-darker:hover {\n  border-color: #1a4731;\n}\n.hover\\:border-green-dark:hover {\n  border-color: #1f9d55;\n}\n.hover\\:border-green:hover {\n  border-color: #38c172;\n}\n.hover\\:border-green-light:hover {\n  border-color: #51d88a;\n}\n.hover\\:border-green-lighter:hover {\n  border-color: #a2f5bf;\n}\n.hover\\:border-green-lightest:hover {\n  border-color: #e3fcec;\n}\n.hover\\:border-teal-darkest:hover {\n  border-color: #0d3331;\n}\n.hover\\:border-teal-darker:hover {\n  border-color: #20504f;\n}\n.hover\\:border-teal-dark:hover {\n  border-color: #009480;\n}\n.hover\\:border-teal:hover {\n  border-color: #00ae98;\n}\n.hover\\:border-teal-light:hover {\n  border-color: #64d5ca;\n}\n.hover\\:border-teal-lighter:hover {\n  border-color: #a0f0ed;\n}\n.hover\\:border-teal-lightest:hover {\n  border-color: #e8fffe;\n}\n.hover\\:border-blue-darkest:hover {\n  border-color: #12283a;\n}\n.hover\\:border-blue-darker:hover {\n  border-color: #2e6da2;\n}\n.hover\\:border-blue-dark:hover {\n  border-color: #2779bd;\n}\n.hover\\:border-blue:hover {\n  border-color: #3490dc;\n}\n.hover\\:border-blue-light:hover {\n  border-color: #6cb2eb;\n}\n.hover\\:border-blue-lighter:hover {\n  border-color: #bcdefa;\n}\n.hover\\:border-blue-lightest:hover {\n  border-color: #eff8ff;\n}\n.hover\\:border-indigo-darkest:hover {\n  border-color: #191e38;\n}\n.hover\\:border-indigo-darker:hover {\n  border-color: #2f365f;\n}\n.hover\\:border-indigo-dark:hover {\n  border-color: #5661b3;\n}\n.hover\\:border-indigo:hover {\n  border-color: #6574cd;\n}\n.hover\\:border-indigo-light:hover {\n  border-color: #7886d7;\n}\n.hover\\:border-indigo-lighter:hover {\n  border-color: #b2b7ff;\n}\n.hover\\:border-indigo-lightest:hover {\n  border-color: #e6e8ff;\n}\n.hover\\:border-purple-darkest:hover {\n  border-color: #21183c;\n}\n.hover\\:border-purple-darker:hover {\n  border-color: #382b5f;\n}\n.hover\\:border-purple-dark:hover {\n  border-color: #794acf;\n}\n.hover\\:border-purple:hover {\n  border-color: #9561e2;\n}\n.hover\\:border-purple-light:hover {\n  border-color: #a779e9;\n}\n.hover\\:border-purple-lighter:hover {\n  border-color: #d6bbfc;\n}\n.hover\\:border-purple-lightest:hover {\n  border-color: #f3ebff;\n}\n.hover\\:border-pink-darkest:hover {\n  border-color: #451225;\n}\n.hover\\:border-pink-darker:hover {\n  border-color: #6f213f;\n}\n.hover\\:border-pink-dark:hover {\n  border-color: #eb5286;\n}\n.hover\\:border-pink:hover {\n  border-color: #f66d9b;\n}\n.hover\\:border-pink-light:hover {\n  border-color: #fa7ea8;\n}\n.hover\\:border-pink-lighter:hover {\n  border-color: #ffbbca;\n}\n.hover\\:border-pink-lightest:hover {\n  border-color: #ffebef;\n}\n.rounded-none {\n  border-radius: 0;\n}\n.rounded-sm {\n  border-radius: .125rem;\n}\n.rounded {\n  border-radius: .25rem;\n}\n.rounded-lg {\n  border-radius: .5rem;\n}\n.rounded-full {\n  border-radius: 9999px;\n}\n.rounded-t-none {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rounded-r-none {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rounded-b-none {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rounded-l-none {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rounded-t-sm {\n  border-top-left-radius: .125rem;\n  border-top-right-radius: .125rem;\n}\n.rounded-r-sm {\n  border-top-right-radius: .125rem;\n  border-bottom-right-radius: .125rem;\n}\n.rounded-b-sm {\n  border-bottom-right-radius: .125rem;\n  border-bottom-left-radius: .125rem;\n}\n.rounded-l-sm {\n  border-top-left-radius: .125rem;\n  border-bottom-left-radius: .125rem;\n}\n.rounded-t {\n  border-top-left-radius: .25rem;\n  border-top-right-radius: .25rem;\n}\n.rounded-r {\n  border-top-right-radius: .25rem;\n  border-bottom-right-radius: .25rem;\n}\n.rounded-b {\n  border-bottom-right-radius: .25rem;\n  border-bottom-left-radius: .25rem;\n}\n.rounded-l {\n  border-top-left-radius: .25rem;\n  border-bottom-left-radius: .25rem;\n}\n.rounded-t-lg {\n  border-top-left-radius: .5rem;\n  border-top-right-radius: .5rem;\n}\n.rounded-r-lg {\n  border-top-right-radius: .5rem;\n  border-bottom-right-radius: .5rem;\n}\n.rounded-b-lg {\n  border-bottom-right-radius: .5rem;\n  border-bottom-left-radius: .5rem;\n}\n.rounded-l-lg {\n  border-top-left-radius: .5rem;\n  border-bottom-left-radius: .5rem;\n}\n.rounded-t-full {\n  border-top-left-radius: 9999px;\n  border-top-right-radius: 9999px;\n}\n.rounded-r-full {\n  border-top-right-radius: 9999px;\n  border-bottom-right-radius: 9999px;\n}\n.rounded-b-full {\n  border-bottom-right-radius: 9999px;\n  border-bottom-left-radius: 9999px;\n}\n.rounded-l-full {\n  border-top-left-radius: 9999px;\n  border-bottom-left-radius: 9999px;\n}\n.rounded-tl-none {\n  border-top-left-radius: 0;\n}\n.rounded-tr-none {\n  border-top-right-radius: 0;\n}\n.rounded-br-none {\n  border-bottom-right-radius: 0;\n}\n.rounded-bl-none {\n  border-bottom-left-radius: 0;\n}\n.rounded-tl-sm {\n  border-top-left-radius: .125rem;\n}\n.rounded-tr-sm {\n  border-top-right-radius: .125rem;\n}\n.rounded-br-sm {\n  border-bottom-right-radius: .125rem;\n}\n.rounded-bl-sm {\n  border-bottom-left-radius: .125rem;\n}\n.rounded-tl {\n  border-top-left-radius: .25rem;\n}\n.rounded-tr {\n  border-top-right-radius: .25rem;\n}\n.rounded-br {\n  border-bottom-right-radius: .25rem;\n}\n.rounded-bl {\n  border-bottom-left-radius: .25rem;\n}\n.rounded-tl-lg {\n  border-top-left-radius: .5rem;\n}\n.rounded-tr-lg {\n  border-top-right-radius: .5rem;\n}\n.rounded-br-lg {\n  border-bottom-right-radius: .5rem;\n}\n.rounded-bl-lg {\n  border-bottom-left-radius: .5rem;\n}\n.rounded-tl-full {\n  border-top-left-radius: 9999px;\n}\n.rounded-tr-full {\n  border-top-right-radius: 9999px;\n}\n.rounded-br-full {\n  border-bottom-right-radius: 9999px;\n}\n.rounded-bl-full {\n  border-bottom-left-radius: 9999px;\n}\n.border-solid {\n  border-style: solid;\n}\n.border-dashed {\n  border-style: dashed;\n}\n.border-dotted {\n  border-style: dotted;\n}\n.border-none {\n  border-style: none;\n}\n.border-0 {\n  border-width: 0;\n}\n.border-2 {\n  border-width: 2px;\n}\n.border-4 {\n  border-width: 4px;\n}\n.border-8 {\n  border-width: 8px;\n}\n.border {\n  border-width: 1px;\n}\n.border-t-0 {\n  border-top-width: 0;\n}\n.border-r-0 {\n  border-right-width: 0;\n}\n.border-b-0 {\n  border-bottom-width: 0;\n}\n.border-l-0 {\n  border-left-width: 0;\n}\n.border-t-2 {\n  border-top-width: 2px;\n}\n.border-r-2 {\n  border-right-width: 2px;\n}\n.border-b-2 {\n  border-bottom-width: 2px;\n}\n.border-l-2 {\n  border-left-width: 2px;\n}\n.border-t-4 {\n  border-top-width: 4px;\n}\n.border-r-4 {\n  border-right-width: 4px;\n}\n.border-b-4 {\n  border-bottom-width: 4px;\n}\n.border-l-4 {\n  border-left-width: 4px;\n}\n.border-t-8 {\n  border-top-width: 8px;\n}\n.border-r-8 {\n  border-right-width: 8px;\n}\n.border-b-8 {\n  border-bottom-width: 8px;\n}\n.border-l-8 {\n  border-left-width: 8px;\n}\n.border-t {\n  border-top-width: 1px;\n}\n.border-r {\n  border-right-width: 1px;\n}\n.border-b {\n  border-bottom-width: 1px;\n}\n.border-l {\n  border-left-width: 1px;\n}\n.cursor-auto {\n  cursor: auto;\n}\n.cursor-default {\n  cursor: default;\n}\n.cursor-pointer {\n  cursor: pointer;\n}\n.cursor-wait {\n  cursor: wait;\n}\n.cursor-move {\n  cursor: move;\n}\n.cursor-not-allowed {\n  cursor: not-allowed;\n}\n.block {\n  display: block;\n}\n.inline-block {\n  display: inline-block;\n}\n.inline {\n  display: inline;\n}\n.table {\n  display: table;\n}\n.table-row {\n  display: table-row;\n}\n.table-cell {\n  display: table-cell;\n}\n.hidden {\n  display: none;\n}\n.flex {\n  display: flex;\n}\n.inline-flex {\n  display: inline-flex;\n}\n.flex-row {\n  flex-direction: row;\n}\n.flex-row-reverse {\n  flex-direction: row-reverse;\n}\n.flex-col {\n  flex-direction: column;\n}\n.flex-col-reverse {\n  flex-direction: column-reverse;\n}\n.flex-wrap {\n  flex-wrap: wrap;\n}\n.flex-wrap-reverse {\n  flex-wrap: wrap-reverse;\n}\n.flex-no-wrap {\n  flex-wrap: nowrap;\n}\n.items-start {\n  align-items: flex-start;\n}\n.items-end {\n  align-items: flex-end;\n}\n.items-center {\n  align-items: center;\n}\n.items-baseline {\n  align-items: baseline;\n}\n.items-stretch {\n  align-items: stretch;\n}\n.self-auto {\n  align-self: auto;\n}\n.self-start {\n  align-self: flex-start;\n}\n.self-end {\n  align-self: flex-end;\n}\n.self-center {\n  align-self: center;\n}\n.self-stretch {\n  align-self: stretch;\n}\n.justify-start {\n  justify-content: flex-start;\n}\n.justify-end {\n  justify-content: flex-end;\n}\n.justify-center {\n  justify-content: center;\n}\n.justify-between {\n  justify-content: space-between;\n}\n.justify-around {\n  justify-content: space-around;\n}\n.content-center {\n  align-content: center;\n}\n.content-start {\n  align-content: flex-start;\n}\n.content-end {\n  align-content: flex-end;\n}\n.content-between {\n  align-content: space-between;\n}\n.content-around {\n  align-content: space-around;\n}\n.flex-1 {\n  flex: 1;\n}\n.flex-auto {\n  flex: auto;\n}\n.flex-initial {\n  flex: initial;\n}\n.flex-none {\n  flex: none;\n}\n.flex-grow {\n  flex-grow: 1;\n}\n.flex-shrink {\n  flex-shrink: 1;\n}\n.flex-no-grow {\n  flex-grow: 0;\n}\n.flex-no-shrink {\n  flex-shrink: 0;\n}\n.float-right {\n  float: right;\n}\n.float-left {\n  float: left;\n}\n.float-none {\n  float: none;\n}\n.clearfix:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.font-sans {\n  font-family: system-ui, BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n}\n.font-serif {\n  font-family: Constantia, Lucida Bright, Lucidabright, Lucida Serif, Lucida, DejaVu Serif, Bitstream Vera Serif, Liberation Serif, Georgia, serif;\n}\n.font-mono {\n  font-family: Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;\n}\n.font-hairline {\n  font-weight: 100;\n}\n.font-thin {\n  font-weight: 200;\n}\n.font-light {\n  font-weight: 300;\n}\n.font-normal {\n  font-weight: 400;\n}\n.font-medium {\n  font-weight: 500;\n}\n.font-semibold {\n  font-weight: 600;\n}\n.font-bold {\n  font-weight: 700;\n}\n.font-extrabold {\n  font-weight: 800;\n}\n.font-black {\n  font-weight: 900;\n}\n.hover\\:font-hairline:hover {\n  font-weight: 100;\n}\n.hover\\:font-thin:hover {\n  font-weight: 200;\n}\n.hover\\:font-light:hover {\n  font-weight: 300;\n}\n.hover\\:font-normal:hover {\n  font-weight: 400;\n}\n.hover\\:font-medium:hover {\n  font-weight: 500;\n}\n.hover\\:font-semibold:hover {\n  font-weight: 600;\n}\n.hover\\:font-bold:hover {\n  font-weight: 700;\n}\n.hover\\:font-extrabold:hover {\n  font-weight: 800;\n}\n.hover\\:font-black:hover {\n  font-weight: 900;\n}\n.h-1 {\n  height: .25rem;\n}\n.h-2 {\n  height: .5rem;\n}\n.h-3 {\n  height: .75rem;\n}\n.h-4 {\n  height: 1rem;\n}\n.h-6 {\n  height: 1.5rem;\n}\n.h-8 {\n  height: 2rem;\n}\n.h-10 {\n  height: 2.5rem;\n}\n.h-12 {\n  height: 3rem;\n}\n.h-16 {\n  height: 4rem;\n}\n.h-24 {\n  height: 6rem;\n}\n.h-32 {\n  height: 8rem;\n}\n.h-48 {\n  height: 12rem;\n}\n.h-64 {\n  height: 16rem;\n}\n.h-auto {\n  height: auto;\n}\n.h-px {\n  height: 1px;\n}\n.h-full {\n  height: 100%;\n}\n.h-screen {\n  height: 100vh;\n}\n.h-screen-footer {\n  height: 80vh;\n}\n.h-timeslots {\n  height: calc(100vh - 3rem - 1rem);\n}\n.leading-none {\n  line-height: 1;\n}\n.leading-tight {\n  line-height: 1.25;\n}\n.leading-normal {\n  line-height: 1.5;\n}\n.leading-loose {\n  line-height: 2;\n}\n.m-0 {\n  margin: 0;\n}\n.m-1 {\n  margin: .25rem;\n}\n.m-2 {\n  margin: .5rem;\n}\n.m-3 {\n  margin: .75rem;\n}\n.m-4 {\n  margin: 1rem;\n}\n.m-6 {\n  margin: 1.5rem;\n}\n.m-8 {\n  margin: 2rem;\n}\n.m-10 {\n  margin: 2.5rem;\n}\n.m-12 {\n  margin: 3rem;\n}\n.m-16 {\n  margin: 4rem;\n}\n.m-24 {\n  margin: 6rem;\n}\n.m-32 {\n  margin: 8rem;\n}\n.m-48 {\n  margin: 10rem;\n}\n.m-auto {\n  margin: auto;\n}\n.m-px {\n  margin: 1px;\n}\n.my-0 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.mx-0 {\n  margin-left: 0;\n  margin-right: 0;\n}\n.my-1 {\n  margin-top: .25rem;\n  margin-bottom: .25rem;\n}\n.mx-1 {\n  margin-left: .25rem;\n  margin-right: .25rem;\n}\n.my-2 {\n  margin-top: .5rem;\n  margin-bottom: .5rem;\n}\n.mx-2 {\n  margin-left: .5rem;\n  margin-right: .5rem;\n}\n.my-3 {\n  margin-top: .75rem;\n  margin-bottom: .75rem;\n}\n.mx-3 {\n  margin-left: .75rem;\n  margin-right: .75rem;\n}\n.my-4 {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n.mx-4 {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n.my-6 {\n  margin-top: 1.5rem;\n  margin-bottom: 1.5rem;\n}\n.mx-6 {\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n}\n.my-8 {\n  margin-top: 2rem;\n  margin-bottom: 2rem;\n}\n.mx-8 {\n  margin-left: 2rem;\n  margin-right: 2rem;\n}\n.my-10 {\n  margin-top: 2.5rem;\n  margin-bottom: 2.5rem;\n}\n.mx-10 {\n  margin-left: 2.5rem;\n  margin-right: 2.5rem;\n}\n.my-12 {\n  margin-top: 3rem;\n  margin-bottom: 3rem;\n}\n.mx-12 {\n  margin-left: 3rem;\n  margin-right: 3rem;\n}\n.my-16 {\n  margin-top: 4rem;\n  margin-bottom: 4rem;\n}\n.mx-16 {\n  margin-left: 4rem;\n  margin-right: 4rem;\n}\n.my-24 {\n  margin-top: 6rem;\n  margin-bottom: 6rem;\n}\n.mx-24 {\n  margin-left: 6rem;\n  margin-right: 6rem;\n}\n.my-32 {\n  margin-top: 8rem;\n  margin-bottom: 8rem;\n}\n.mx-32 {\n  margin-left: 8rem;\n  margin-right: 8rem;\n}\n.my-48 {\n  margin-top: 10rem;\n  margin-bottom: 10rem;\n}\n.mx-48 {\n  margin-left: 10rem;\n  margin-right: 10rem;\n}\n.my-auto {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n.my-px {\n  margin-top: 1px;\n  margin-bottom: 1px;\n}\n.mx-px {\n  margin-left: 1px;\n  margin-right: 1px;\n}\n.mt-0 {\n  margin-top: 0;\n}\n.mr-0 {\n  margin-right: 0;\n}\n.mb-0 {\n  margin-bottom: 0;\n}\n.ml-0 {\n  margin-left: 0;\n}\n.mt-1 {\n  margin-top: .25rem;\n}\n.mr-1 {\n  margin-right: .25rem;\n}\n.mb-1 {\n  margin-bottom: .25rem;\n}\n.ml-1 {\n  margin-left: .25rem;\n}\n.mt-2 {\n  margin-top: .5rem;\n}\n.mr-2 {\n  margin-right: .5rem;\n}\n.mb-2 {\n  margin-bottom: .5rem;\n}\n.ml-2 {\n  margin-left: .5rem;\n}\n.mt-3 {\n  margin-top: .75rem;\n}\n.mr-3 {\n  margin-right: .75rem;\n}\n.mb-3 {\n  margin-bottom: .75rem;\n}\n.ml-3 {\n  margin-left: .75rem;\n}\n.mt-4 {\n  margin-top: 1rem;\n}\n.mr-4 {\n  margin-right: 1rem;\n}\n.mb-4 {\n  margin-bottom: 1rem;\n}\n.ml-4 {\n  margin-left: 1rem;\n}\n.mt-6 {\n  margin-top: 1.5rem;\n}\n.mr-6 {\n  margin-right: 1.5rem;\n}\n.mb-6 {\n  margin-bottom: 1.5rem;\n}\n.ml-6 {\n  margin-left: 1.5rem;\n}\n.mt-8 {\n  margin-top: 2rem;\n}\n.mr-8 {\n  margin-right: 2rem;\n}\n.mb-8 {\n  margin-bottom: 2rem;\n}\n.ml-8 {\n  margin-left: 2rem;\n}\n.mt-10 {\n  margin-top: 2.5rem;\n}\n.mr-10 {\n  margin-right: 2.5rem;\n}\n.mb-10 {\n  margin-bottom: 2.5rem;\n}\n.ml-10 {\n  margin-left: 2.5rem;\n}\n.mt-12 {\n  margin-top: 3rem;\n}\n.mr-12 {\n  margin-right: 3rem;\n}\n.mb-12 {\n  margin-bottom: 3rem;\n}\n.ml-12 {\n  margin-left: 3rem;\n}\n.mt-16 {\n  margin-top: 4rem;\n}\n.mr-16 {\n  margin-right: 4rem;\n}\n.mb-16 {\n  margin-bottom: 4rem;\n}\n.ml-16 {\n  margin-left: 4rem;\n}\n.mt-24 {\n  margin-top: 6rem;\n}\n.mr-24 {\n  margin-right: 6rem;\n}\n.mb-24 {\n  margin-bottom: 6rem;\n}\n.ml-24 {\n  margin-left: 6rem;\n}\n.mt-32 {\n  margin-top: 8rem;\n}\n.mr-32 {\n  margin-right: 8rem;\n}\n.mb-32 {\n  margin-bottom: 8rem;\n}\n.ml-32 {\n  margin-left: 8rem;\n}\n.mt-48 {\n  margin-top: 10rem;\n}\n.mr-48 {\n  margin-right: 10rem;\n}\n.mb-48 {\n  margin-bottom: 10rem;\n}\n.ml-48 {\n  margin-left: 10rem;\n}\n.mt-auto {\n  margin-top: auto;\n}\n.mr-auto {\n  margin-right: auto;\n}\n.mb-auto {\n  margin-bottom: auto;\n}\n.ml-auto {\n  margin-left: auto;\n}\n.mt-px {\n  margin-top: 1px;\n}\n.mr-px {\n  margin-right: 1px;\n}\n.mb-px {\n  margin-bottom: 1px;\n}\n.ml-px {\n  margin-left: 1px;\n}\n.max-h-full {\n  max-height: 100%;\n}\n.max-h-screen {\n  max-height: 100vh;\n}\n.max-h-timeslots {\n  max-height: calc(100vh - 3rem - 1rem - 14rem);\n}\n.max-w-xs {\n  max-width: 20rem;\n}\n.max-w-sm {\n  max-width: 30rem;\n}\n.max-w-md {\n  max-width: 40rem;\n}\n.max-w-lg {\n  max-width: 50rem;\n}\n.max-w-xl {\n  max-width: 60rem;\n}\n.max-w-2xl {\n  max-width: 70rem;\n}\n.max-w-3xl {\n  max-width: 80rem;\n}\n.max-w-4xl {\n  max-width: 90rem;\n}\n.max-w-5xl {\n  max-width: 100rem;\n}\n.max-w-full {\n  max-width: 100%;\n}\n.min-h-0 {\n  min-height: 0;\n}\n.min-h-full {\n  min-height: 100%;\n}\n.min-h-screen {\n  min-height: 100vh;\n}\n.min-h-\\(screen-footer-sm\\) {\n  min-height: calc(100vh - 350px);\n}\n.min-h-\\(screen-footer-md\\) {\n  min-height: calc(100vh - 180px);\n}\n.min-w-0 {\n  min-width: 0;\n}\n.min-w-full {\n  min-width: 100%;\n}\n.-m-0 {\n  margin: 0;\n}\n.-m-1 {\n  margin: -0.25rem;\n}\n.-m-2 {\n  margin: -0.5rem;\n}\n.-m-3 {\n  margin: -0.75rem;\n}\n.-m-4 {\n  margin: -1rem;\n}\n.-m-6 {\n  margin: -1.5rem;\n}\n.-m-8 {\n  margin: -2rem;\n}\n.-m-10 {\n  margin: -2.5rem;\n}\n.-m-12 {\n  margin: -3rem;\n}\n.-m-16 {\n  margin: -4rem;\n}\n.-m-24 {\n  margin: -6rem;\n}\n.-m-32 {\n  margin: -8rem;\n}\n.-m-48 {\n  margin: -10rem;\n}\n.-m-px {\n  margin: -1px;\n}\n.-my-0 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.-mx-0 {\n  margin-left: 0;\n  margin-right: 0;\n}\n.-my-1 {\n  margin-top: -0.25rem;\n  margin-bottom: -0.25rem;\n}\n.-mx-1 {\n  margin-left: -0.25rem;\n  margin-right: -0.25rem;\n}\n.-my-2 {\n  margin-top: -0.5rem;\n  margin-bottom: -0.5rem;\n}\n.-mx-2 {\n  margin-left: -0.5rem;\n  margin-right: -0.5rem;\n}\n.-my-3 {\n  margin-top: -0.75rem;\n  margin-bottom: -0.75rem;\n}\n.-mx-3 {\n  margin-left: -0.75rem;\n  margin-right: -0.75rem;\n}\n.-my-4 {\n  margin-top: -1rem;\n  margin-bottom: -1rem;\n}\n.-mx-4 {\n  margin-left: -1rem;\n  margin-right: -1rem;\n}\n.-my-6 {\n  margin-top: -1.5rem;\n  margin-bottom: -1.5rem;\n}\n.-mx-6 {\n  margin-left: -1.5rem;\n  margin-right: -1.5rem;\n}\n.-my-8 {\n  margin-top: -2rem;\n  margin-bottom: -2rem;\n}\n.-mx-8 {\n  margin-left: -2rem;\n  margin-right: -2rem;\n}\n.-my-10 {\n  margin-top: -2.5rem;\n  margin-bottom: -2.5rem;\n}\n.-mx-10 {\n  margin-left: -2.5rem;\n  margin-right: -2.5rem;\n}\n.-my-12 {\n  margin-top: -3rem;\n  margin-bottom: -3rem;\n}\n.-mx-12 {\n  margin-left: -3rem;\n  margin-right: -3rem;\n}\n.-my-16 {\n  margin-top: -4rem;\n  margin-bottom: -4rem;\n}\n.-mx-16 {\n  margin-left: -4rem;\n  margin-right: -4rem;\n}\n.-my-24 {\n  margin-top: -6rem;\n  margin-bottom: -6rem;\n}\n.-mx-24 {\n  margin-left: -6rem;\n  margin-right: -6rem;\n}\n.-my-32 {\n  margin-top: -8rem;\n  margin-bottom: -8rem;\n}\n.-mx-32 {\n  margin-left: -8rem;\n  margin-right: -8rem;\n}\n.-my-48 {\n  margin-top: -10rem;\n  margin-bottom: -10rem;\n}\n.-mx-48 {\n  margin-left: -10rem;\n  margin-right: -10rem;\n}\n.-my-px {\n  margin-top: -1px;\n  margin-bottom: -1px;\n}\n.-mx-px {\n  margin-left: -1px;\n  margin-right: -1px;\n}\n.-mt-0 {\n  margin-top: 0;\n}\n.-mr-0 {\n  margin-right: 0;\n}\n.-mb-0 {\n  margin-bottom: 0;\n}\n.-ml-0 {\n  margin-left: 0;\n}\n.-mt-1 {\n  margin-top: -0.25rem;\n}\n.-mr-1 {\n  margin-right: -0.25rem;\n}\n.-mb-1 {\n  margin-bottom: -0.25rem;\n}\n.-ml-1 {\n  margin-left: -0.25rem;\n}\n.-mt-2 {\n  margin-top: -0.5rem;\n}\n.-mr-2 {\n  margin-right: -0.5rem;\n}\n.-mb-2 {\n  margin-bottom: -0.5rem;\n}\n.-ml-2 {\n  margin-left: -0.5rem;\n}\n.-mt-3 {\n  margin-top: -0.75rem;\n}\n.-mr-3 {\n  margin-right: -0.75rem;\n}\n.-mb-3 {\n  margin-bottom: -0.75rem;\n}\n.-ml-3 {\n  margin-left: -0.75rem;\n}\n.-mt-4 {\n  margin-top: -1rem;\n}\n.-mr-4 {\n  margin-right: -1rem;\n}\n.-mb-4 {\n  margin-bottom: -1rem;\n}\n.-ml-4 {\n  margin-left: -1rem;\n}\n.-mt-6 {\n  margin-top: -1.5rem;\n}\n.-mr-6 {\n  margin-right: -1.5rem;\n}\n.-mb-6 {\n  margin-bottom: -1.5rem;\n}\n.-ml-6 {\n  margin-left: -1.5rem;\n}\n.-mt-8 {\n  margin-top: -2rem;\n}\n.-mr-8 {\n  margin-right: -2rem;\n}\n.-mb-8 {\n  margin-bottom: -2rem;\n}\n.-ml-8 {\n  margin-left: -2rem;\n}\n.-mt-10 {\n  margin-top: -2.5rem;\n}\n.-mr-10 {\n  margin-right: -2.5rem;\n}\n.-mb-10 {\n  margin-bottom: -2.5rem;\n}\n.-ml-10 {\n  margin-left: -2.5rem;\n}\n.-mt-12 {\n  margin-top: -3rem;\n}\n.-mr-12 {\n  margin-right: -3rem;\n}\n.-mb-12 {\n  margin-bottom: -3rem;\n}\n.-ml-12 {\n  margin-left: -3rem;\n}\n.-mt-16 {\n  margin-top: -4rem;\n}\n.-mr-16 {\n  margin-right: -4rem;\n}\n.-mb-16 {\n  margin-bottom: -4rem;\n}\n.-ml-16 {\n  margin-left: -4rem;\n}\n.-mt-24 {\n  margin-top: -6rem;\n}\n.-mr-24 {\n  margin-right: -6rem;\n}\n.-mb-24 {\n  margin-bottom: -6rem;\n}\n.-ml-24 {\n  margin-left: -6rem;\n}\n.-mt-32 {\n  margin-top: -8rem;\n}\n.-mr-32 {\n  margin-right: -8rem;\n}\n.-mb-32 {\n  margin-bottom: -8rem;\n}\n.-ml-32 {\n  margin-left: -8rem;\n}\n.-mt-48 {\n  margin-top: -10rem;\n}\n.-mr-48 {\n  margin-right: -10rem;\n}\n.-mb-48 {\n  margin-bottom: -10rem;\n}\n.-ml-48 {\n  margin-left: -10rem;\n}\n.-mt-px {\n  margin-top: -1px;\n}\n.-mr-px {\n  margin-right: -1px;\n}\n.-mb-px {\n  margin-bottom: -1px;\n}\n.-ml-px {\n  margin-left: -1px;\n}\n.opacity-0 {\n  opacity: 0;\n}\n.opacity-25 {\n  opacity: .25;\n}\n.opacity-50 {\n  opacity: .5;\n}\n.opacity-75 {\n  opacity: .75;\n}\n.opacity-100 {\n  opacity: 1;\n}\n.hover\\:opacity-0:hover {\n  opacity: 0;\n}\n.hover\\:opacity-25:hover {\n  opacity: .25;\n}\n.hover\\:opacity-50:hover {\n  opacity: .5;\n}\n.hover\\:opacity-75:hover {\n  opacity: .75;\n}\n.hover\\:opacity-100:hover {\n  opacity: 1;\n}\n.overflow-auto {\n  overflow: auto;\n}\n.overflow-hidden {\n  overflow: hidden;\n}\n.overflow-visible {\n  overflow: visible;\n}\n.overflow-scroll {\n  overflow: scroll;\n}\n.overflow-x-auto {\n  overflow-x: auto;\n}\n.overflow-y-auto {\n  overflow-y: auto;\n}\n.overflow-x-scroll {\n  overflow-x: scroll;\n}\n.overflow-y-scroll {\n  overflow-y: scroll;\n}\n.scrolling-touch {\n  -webkit-overflow-scrolling: touch;\n}\n.scrolling-auto {\n  -webkit-overflow-scrolling: auto;\n}\n.p-0 {\n  padding: 0;\n}\n.p-1 {\n  padding: .25rem;\n}\n.p-2 {\n  padding: .5rem;\n}\n.p-3 {\n  padding: .75rem;\n}\n.p-4 {\n  padding: 1rem;\n}\n.p-6 {\n  padding: 1.5rem;\n}\n.p-8 {\n  padding: 2rem;\n}\n.p-10 {\n  padding: 2.5rem;\n}\n.p-12 {\n  padding: 3rem;\n}\n.p-16 {\n  padding: 4rem;\n}\n.p-24 {\n  padding: 6rem;\n}\n.p-32 {\n  padding: 8rem;\n}\n.p-48 {\n  padding: 10rem;\n}\n.p-px {\n  padding: 1px;\n}\n.py-0 {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.px-0 {\n  padding-left: 0;\n  padding-right: 0;\n}\n.py-1 {\n  padding-top: .25rem;\n  padding-bottom: .25rem;\n}\n.px-1 {\n  padding-left: .25rem;\n  padding-right: .25rem;\n}\n.py-2 {\n  padding-top: .5rem;\n  padding-bottom: .5rem;\n}\n.px-2 {\n  padding-left: .5rem;\n  padding-right: .5rem;\n}\n.py-3 {\n  padding-top: .75rem;\n  padding-bottom: .75rem;\n}\n.px-3 {\n  padding-left: .75rem;\n  padding-right: .75rem;\n}\n.py-4 {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n.px-4 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n.py-6 {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n.px-6 {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n.py-8 {\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n}\n.px-8 {\n  padding-left: 2rem;\n  padding-right: 2rem;\n}\n.py-10 {\n  padding-top: 2.5rem;\n  padding-bottom: 2.5rem;\n}\n.px-10 {\n  padding-left: 2.5rem;\n  padding-right: 2.5rem;\n}\n.py-12 {\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n}\n.px-12 {\n  padding-left: 3rem;\n  padding-right: 3rem;\n}\n.py-16 {\n  padding-top: 4rem;\n  padding-bottom: 4rem;\n}\n.px-16 {\n  padding-left: 4rem;\n  padding-right: 4rem;\n}\n.py-24 {\n  padding-top: 6rem;\n  padding-bottom: 6rem;\n}\n.px-24 {\n  padding-left: 6rem;\n  padding-right: 6rem;\n}\n.py-32 {\n  padding-top: 8rem;\n  padding-bottom: 8rem;\n}\n.px-32 {\n  padding-left: 8rem;\n  padding-right: 8rem;\n}\n.py-48 {\n  padding-top: 10rem;\n  padding-bottom: 10rem;\n}\n.px-48 {\n  padding-left: 10rem;\n  padding-right: 10rem;\n}\n.py-px {\n  padding-top: 1px;\n  padding-bottom: 1px;\n}\n.px-px {\n  padding-left: 1px;\n  padding-right: 1px;\n}\n.pt-0 {\n  padding-top: 0;\n}\n.pr-0 {\n  padding-right: 0;\n}\n.pb-0 {\n  padding-bottom: 0;\n}\n.pl-0 {\n  padding-left: 0;\n}\n.pt-1 {\n  padding-top: .25rem;\n}\n.pr-1 {\n  padding-right: .25rem;\n}\n.pb-1 {\n  padding-bottom: .25rem;\n}\n.pl-1 {\n  padding-left: .25rem;\n}\n.pt-2 {\n  padding-top: .5rem;\n}\n.pr-2 {\n  padding-right: .5rem;\n}\n.pb-2 {\n  padding-bottom: .5rem;\n}\n.pl-2 {\n  padding-left: .5rem;\n}\n.pt-3 {\n  padding-top: .75rem;\n}\n.pr-3 {\n  padding-right: .75rem;\n}\n.pb-3 {\n  padding-bottom: .75rem;\n}\n.pl-3 {\n  padding-left: .75rem;\n}\n.pt-4 {\n  padding-top: 1rem;\n}\n.pr-4 {\n  padding-right: 1rem;\n}\n.pb-4 {\n  padding-bottom: 1rem;\n}\n.pl-4 {\n  padding-left: 1rem;\n}\n.pt-6 {\n  padding-top: 1.5rem;\n}\n.pr-6 {\n  padding-right: 1.5rem;\n}\n.pb-6 {\n  padding-bottom: 1.5rem;\n}\n.pl-6 {\n  padding-left: 1.5rem;\n}\n.pt-8 {\n  padding-top: 2rem;\n}\n.pr-8 {\n  padding-right: 2rem;\n}\n.pb-8 {\n  padding-bottom: 2rem;\n}\n.pl-8 {\n  padding-left: 2rem;\n}\n.pt-10 {\n  padding-top: 2.5rem;\n}\n.pr-10 {\n  padding-right: 2.5rem;\n}\n.pb-10 {\n  padding-bottom: 2.5rem;\n}\n.pl-10 {\n  padding-left: 2.5rem;\n}\n.pt-12 {\n  padding-top: 3rem;\n}\n.pr-12 {\n  padding-right: 3rem;\n}\n.pb-12 {\n  padding-bottom: 3rem;\n}\n.pl-12 {\n  padding-left: 3rem;\n}\n.pt-16 {\n  padding-top: 4rem;\n}\n.pr-16 {\n  padding-right: 4rem;\n}\n.pb-16 {\n  padding-bottom: 4rem;\n}\n.pl-16 {\n  padding-left: 4rem;\n}\n.pt-24 {\n  padding-top: 6rem;\n}\n.pr-24 {\n  padding-right: 6rem;\n}\n.pb-24 {\n  padding-bottom: 6rem;\n}\n.pl-24 {\n  padding-left: 6rem;\n}\n.pt-32 {\n  padding-top: 8rem;\n}\n.pr-32 {\n  padding-right: 8rem;\n}\n.pb-32 {\n  padding-bottom: 8rem;\n}\n.pl-32 {\n  padding-left: 8rem;\n}\n.pt-48 {\n  padding-top: 10rem;\n}\n.pr-48 {\n  padding-right: 10rem;\n}\n.pb-48 {\n  padding-bottom: 10rem;\n}\n.pl-48 {\n  padding-left: 10rem;\n}\n.pt-px {\n  padding-top: 1px;\n}\n.pr-px {\n  padding-right: 1px;\n}\n.pb-px {\n  padding-bottom: 1px;\n}\n.pl-px {\n  padding-left: 1px;\n}\n.pointer-events-none {\n  pointer-events: none;\n}\n.pointer-events-auto {\n  pointer-events: auto;\n}\n.static {\n  position: static;\n}\n.fixed {\n  position: fixed;\n}\n.absolute {\n  position: absolute;\n}\n.relative {\n  position: relative;\n}\n.sticky {\n  position: sticky;\n}\n.pin-none {\n  top: auto;\n  right: auto;\n  bottom: auto;\n  left: auto;\n}\n.pin {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n.pin-y {\n  top: 0;\n  bottom: 0;\n}\n.pin-x {\n  right: 0;\n  left: 0;\n}\n.pin-t {\n  top: 0;\n}\n.pin-r {\n  right: 0;\n}\n.pin-b {\n  bottom: 0;\n}\n.pin-l {\n  left: 0;\n}\n.resize-none {\n  resize: none;\n}\n.resize-y {\n  resize: vertical;\n}\n.resize-x {\n  resize: horizontal;\n}\n.resize {\n  resize: both;\n}\n.shadow {\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .1);\n}\n.shadow-md {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .12), 0 2px 4px 0 rgba(0, 0, 0, .08);\n}\n.shadow-lg {\n  box-shadow: 0 15px 30px 0 rgba(0, 0, 0, .11), 0 5px 15px 0 rgba(0, 0, 0, .08);\n}\n.shadow-inner {\n  box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, .06);\n}\n.shadow-none {\n  box-shadow: none;\n}\n.fill-current {\n  fill: currentColor;\n}\n.stroke-current {\n  stroke: currentColor;\n}\n.text-left {\n  text-align: left;\n}\n.text-center {\n  text-align: center;\n}\n.text-right {\n  text-align: right;\n}\n.text-justify {\n  text-align: justify;\n}\n.text-transparent {\n  color: transparent;\n}\n.text-modal {\n  color: rgba(0, 0, 0, .4);\n}\n.text-google {\n  color: #dc5b5b;\n}\n.text-google-dark {\n  color: #da5050;\n}\n.text-facebook {\n  color: #3b5998;\n}\n.text-facebook-dark {\n  color: #37548f;\n}\n.text-primary {\n  color: #2196f3;\n}\n.text-primary-dark {\n  color: #3b5998;\n}\n.text-footer {\n  color: #1976d2;\n}\n.text-black {\n  color: #22292f;\n}\n.text-grey-darkest {\n  color: #3d4852;\n}\n.text-grey-darker {\n  color: #606f7b;\n}\n.text-grey-dark {\n  color: #8795a1;\n}\n.text-grey {\n  color: #b8c2cc;\n}\n.text-grey-light {\n  color: #dae1e7;\n}\n.text-grey-lighter {\n  color: #f1f5f8;\n}\n.text-grey-lightest {\n  color: #f8fafc;\n}\n.text-white {\n  color: #fff;\n}\n.text-whiter {\n  color: rgba(255, 255, 255, .6);\n}\n.text-red-darkest {\n  color: #3b0d0c;\n}\n.text-red-darker {\n  color: #621b18;\n}\n.text-red-dark {\n  color: #cc1f1a;\n}\n.text-red {\n  color: #e3342f;\n}\n.text-red-light {\n  color: #ef5753;\n}\n.text-red-lighter {\n  color: #f9acaa;\n}\n.text-red-lightest {\n  color: #fcebea;\n}\n.text-orange-darkest {\n  color: #462a16;\n}\n.text-orange-darker {\n  color: #613b1f;\n}\n.text-orange-dark {\n  color: #de751f;\n}\n.text-orange {\n  color: #f6993f;\n}\n.text-orange-light {\n  color: #faad63;\n}\n.text-orange-lighter {\n  color: #fcd9b6;\n}\n.text-orange-lightest {\n  color: #fff5eb;\n}\n.text-yellow-darkest {\n  color: #453411;\n}\n.text-yellow-darker {\n  color: #684f1d;\n}\n.text-yellow-dark {\n  color: #f2d024;\n}\n.text-yellow {\n  color: #ffed4a;\n}\n.text-yellow-light {\n  color: #fff382;\n}\n.text-yellow-lighter {\n  color: #fff9c2;\n}\n.text-yellow-lightest {\n  color: #fcfbeb;\n}\n.text-green-darkest {\n  color: #0f2f21;\n}\n.text-green-darker {\n  color: #1a4731;\n}\n.text-green-dark {\n  color: #1f9d55;\n}\n.text-green {\n  color: #38c172;\n}\n.text-green-light {\n  color: #51d88a;\n}\n.text-green-lighter {\n  color: #a2f5bf;\n}\n.text-green-lightest {\n  color: #e3fcec;\n}\n.text-teal-darkest {\n  color: #0d3331;\n}\n.text-teal-darker {\n  color: #20504f;\n}\n.text-teal-dark {\n  color: #009480;\n}\n.text-teal {\n  color: #00ae98;\n}\n.text-teal-light {\n  color: #64d5ca;\n}\n.text-teal-lighter {\n  color: #a0f0ed;\n}\n.text-teal-lightest {\n  color: #e8fffe;\n}\n.text-blue-darkest {\n  color: #12283a;\n}\n.text-blue-darker {\n  color: #2e6da2;\n}\n.text-blue-dark {\n  color: #2779bd;\n}\n.text-blue {\n  color: #3490dc;\n}\n.text-blue-light {\n  color: #6cb2eb;\n}\n.text-blue-lighter {\n  color: #bcdefa;\n}\n.text-blue-lightest {\n  color: #eff8ff;\n}\n.text-indigo-darkest {\n  color: #191e38;\n}\n.text-indigo-darker {\n  color: #2f365f;\n}\n.text-indigo-dark {\n  color: #5661b3;\n}\n.text-indigo {\n  color: #6574cd;\n}\n.text-indigo-light {\n  color: #7886d7;\n}\n.text-indigo-lighter {\n  color: #b2b7ff;\n}\n.text-indigo-lightest {\n  color: #e6e8ff;\n}\n.text-purple-darkest {\n  color: #21183c;\n}\n.text-purple-darker {\n  color: #382b5f;\n}\n.text-purple-dark {\n  color: #794acf;\n}\n.text-purple {\n  color: #9561e2;\n}\n.text-purple-light {\n  color: #a779e9;\n}\n.text-purple-lighter {\n  color: #d6bbfc;\n}\n.text-purple-lightest {\n  color: #f3ebff;\n}\n.text-pink-darkest {\n  color: #451225;\n}\n.text-pink-darker {\n  color: #6f213f;\n}\n.text-pink-dark {\n  color: #eb5286;\n}\n.text-pink {\n  color: #f66d9b;\n}\n.text-pink-light {\n  color: #fa7ea8;\n}\n.text-pink-lighter {\n  color: #ffbbca;\n}\n.text-pink-lightest {\n  color: #ffebef;\n}\n.group:hover .group-hover\\:text-transparent {\n  color: transparent;\n}\n.group:hover .group-hover\\:text-modal {\n  color: rgba(0, 0, 0, .4);\n}\n.group:hover .group-hover\\:text-google {\n  color: #dc5b5b;\n}\n.group:hover .group-hover\\:text-google-dark {\n  color: #da5050;\n}\n.group:hover .group-hover\\:text-facebook {\n  color: #3b5998;\n}\n.group:hover .group-hover\\:text-facebook-dark {\n  color: #37548f;\n}\n.group:hover .group-hover\\:text-primary {\n  color: #2196f3;\n}\n.group:hover .group-hover\\:text-primary-dark {\n  color: #3b5998;\n}\n.group:hover .group-hover\\:text-footer {\n  color: #1976d2;\n}\n.group:hover .group-hover\\:text-black {\n  color: #22292f;\n}\n.group:hover .group-hover\\:text-grey-darkest {\n  color: #3d4852;\n}\n.group:hover .group-hover\\:text-grey-darker {\n  color: #606f7b;\n}\n.group:hover .group-hover\\:text-grey-dark {\n  color: #8795a1;\n}\n.group:hover .group-hover\\:text-grey {\n  color: #b8c2cc;\n}\n.group:hover .group-hover\\:text-grey-light {\n  color: #dae1e7;\n}\n.group:hover .group-hover\\:text-grey-lighter {\n  color: #f1f5f8;\n}\n.group:hover .group-hover\\:text-grey-lightest {\n  color: #f8fafc;\n}\n.group:hover .group-hover\\:text-white {\n  color: #fff;\n}\n.group:hover .group-hover\\:text-whiter {\n  color: rgba(255, 255, 255, .6);\n}\n.group:hover .group-hover\\:text-red-darkest {\n  color: #3b0d0c;\n}\n.group:hover .group-hover\\:text-red-darker {\n  color: #621b18;\n}\n.group:hover .group-hover\\:text-red-dark {\n  color: #cc1f1a;\n}\n.group:hover .group-hover\\:text-red {\n  color: #e3342f;\n}\n.group:hover .group-hover\\:text-red-light {\n  color: #ef5753;\n}\n.group:hover .group-hover\\:text-red-lighter {\n  color: #f9acaa;\n}\n.group:hover .group-hover\\:text-red-lightest {\n  color: #fcebea;\n}\n.group:hover .group-hover\\:text-orange-darkest {\n  color: #462a16;\n}\n.group:hover .group-hover\\:text-orange-darker {\n  color: #613b1f;\n}\n.group:hover .group-hover\\:text-orange-dark {\n  color: #de751f;\n}\n.group:hover .group-hover\\:text-orange {\n  color: #f6993f;\n}\n.group:hover .group-hover\\:text-orange-light {\n  color: #faad63;\n}\n.group:hover .group-hover\\:text-orange-lighter {\n  color: #fcd9b6;\n}\n.group:hover .group-hover\\:text-orange-lightest {\n  color: #fff5eb;\n}\n.group:hover .group-hover\\:text-yellow-darkest {\n  color: #453411;\n}\n.group:hover .group-hover\\:text-yellow-darker {\n  color: #684f1d;\n}\n.group:hover .group-hover\\:text-yellow-dark {\n  color: #f2d024;\n}\n.group:hover .group-hover\\:text-yellow {\n  color: #ffed4a;\n}\n.group:hover .group-hover\\:text-yellow-light {\n  color: #fff382;\n}\n.group:hover .group-hover\\:text-yellow-lighter {\n  color: #fff9c2;\n}\n.group:hover .group-hover\\:text-yellow-lightest {\n  color: #fcfbeb;\n}\n.group:hover .group-hover\\:text-green-darkest {\n  color: #0f2f21;\n}\n.group:hover .group-hover\\:text-green-darker {\n  color: #1a4731;\n}\n.group:hover .group-hover\\:text-green-dark {\n  color: #1f9d55;\n}\n.group:hover .group-hover\\:text-green {\n  color: #38c172;\n}\n.group:hover .group-hover\\:text-green-light {\n  color: #51d88a;\n}\n.group:hover .group-hover\\:text-green-lighter {\n  color: #a2f5bf;\n}\n.group:hover .group-hover\\:text-green-lightest {\n  color: #e3fcec;\n}\n.group:hover .group-hover\\:text-teal-darkest {\n  color: #0d3331;\n}\n.group:hover .group-hover\\:text-teal-darker {\n  color: #20504f;\n}\n.group:hover .group-hover\\:text-teal-dark {\n  color: #009480;\n}\n.group:hover .group-hover\\:text-teal {\n  color: #00ae98;\n}\n.group:hover .group-hover\\:text-teal-light {\n  color: #64d5ca;\n}\n.group:hover .group-hover\\:text-teal-lighter {\n  color: #a0f0ed;\n}\n.group:hover .group-hover\\:text-teal-lightest {\n  color: #e8fffe;\n}\n.group:hover .group-hover\\:text-blue-darkest {\n  color: #12283a;\n}\n.group:hover .group-hover\\:text-blue-darker {\n  color: #2e6da2;\n}\n.group:hover .group-hover\\:text-blue-dark {\n  color: #2779bd;\n}\n.group:hover .group-hover\\:text-blue {\n  color: #3490dc;\n}\n.group:hover .group-hover\\:text-blue-light {\n  color: #6cb2eb;\n}\n.group:hover .group-hover\\:text-blue-lighter {\n  color: #bcdefa;\n}\n.group:hover .group-hover\\:text-blue-lightest {\n  color: #eff8ff;\n}\n.group:hover .group-hover\\:text-indigo-darkest {\n  color: #191e38;\n}\n.group:hover .group-hover\\:text-indigo-darker {\n  color: #2f365f;\n}\n.group:hover .group-hover\\:text-indigo-dark {\n  color: #5661b3;\n}\n.group:hover .group-hover\\:text-indigo {\n  color: #6574cd;\n}\n.group:hover .group-hover\\:text-indigo-light {\n  color: #7886d7;\n}\n.group:hover .group-hover\\:text-indigo-lighter {\n  color: #b2b7ff;\n}\n.group:hover .group-hover\\:text-indigo-lightest {\n  color: #e6e8ff;\n}\n.group:hover .group-hover\\:text-purple-darkest {\n  color: #21183c;\n}\n.group:hover .group-hover\\:text-purple-darker {\n  color: #382b5f;\n}\n.group:hover .group-hover\\:text-purple-dark {\n  color: #794acf;\n}\n.group:hover .group-hover\\:text-purple {\n  color: #9561e2;\n}\n.group:hover .group-hover\\:text-purple-light {\n  color: #a779e9;\n}\n.group:hover .group-hover\\:text-purple-lighter {\n  color: #d6bbfc;\n}\n.group:hover .group-hover\\:text-purple-lightest {\n  color: #f3ebff;\n}\n.group:hover .group-hover\\:text-pink-darkest {\n  color: #451225;\n}\n.group:hover .group-hover\\:text-pink-darker {\n  color: #6f213f;\n}\n.group:hover .group-hover\\:text-pink-dark {\n  color: #eb5286;\n}\n.group:hover .group-hover\\:text-pink {\n  color: #f66d9b;\n}\n.group:hover .group-hover\\:text-pink-light {\n  color: #fa7ea8;\n}\n.group:hover .group-hover\\:text-pink-lighter {\n  color: #ffbbca;\n}\n.group:hover .group-hover\\:text-pink-lightest {\n  color: #ffebef;\n}\n.hover\\:text-transparent:hover {\n  color: transparent;\n}\n.hover\\:text-modal:hover {\n  color: rgba(0, 0, 0, .4);\n}\n.hover\\:text-google:hover {\n  color: #dc5b5b;\n}\n.hover\\:text-google-dark:hover {\n  color: #da5050;\n}\n.hover\\:text-facebook:hover {\n  color: #3b5998;\n}\n.hover\\:text-facebook-dark:hover {\n  color: #37548f;\n}\n.hover\\:text-primary:hover {\n  color: #2196f3;\n}\n.hover\\:text-primary-dark:hover {\n  color: #3b5998;\n}\n.hover\\:text-footer:hover {\n  color: #1976d2;\n}\n.hover\\:text-black:hover {\n  color: #22292f;\n}\n.hover\\:text-grey-darkest:hover {\n  color: #3d4852;\n}\n.hover\\:text-grey-darker:hover {\n  color: #606f7b;\n}\n.hover\\:text-grey-dark:hover {\n  color: #8795a1;\n}\n.hover\\:text-grey:hover {\n  color: #b8c2cc;\n}\n.hover\\:text-grey-light:hover {\n  color: #dae1e7;\n}\n.hover\\:text-grey-lighter:hover {\n  color: #f1f5f8;\n}\n.hover\\:text-grey-lightest:hover {\n  color: #f8fafc;\n}\n.hover\\:text-white:hover {\n  color: #fff;\n}\n.hover\\:text-whiter:hover {\n  color: rgba(255, 255, 255, .6);\n}\n.hover\\:text-red-darkest:hover {\n  color: #3b0d0c;\n}\n.hover\\:text-red-darker:hover {\n  color: #621b18;\n}\n.hover\\:text-red-dark:hover {\n  color: #cc1f1a;\n}\n.hover\\:text-red:hover {\n  color: #e3342f;\n}\n.hover\\:text-red-light:hover {\n  color: #ef5753;\n}\n.hover\\:text-red-lighter:hover {\n  color: #f9acaa;\n}\n.hover\\:text-red-lightest:hover {\n  color: #fcebea;\n}\n.hover\\:text-orange-darkest:hover {\n  color: #462a16;\n}\n.hover\\:text-orange-darker:hover {\n  color: #613b1f;\n}\n.hover\\:text-orange-dark:hover {\n  color: #de751f;\n}\n.hover\\:text-orange:hover {\n  color: #f6993f;\n}\n.hover\\:text-orange-light:hover {\n  color: #faad63;\n}\n.hover\\:text-orange-lighter:hover {\n  color: #fcd9b6;\n}\n.hover\\:text-orange-lightest:hover {\n  color: #fff5eb;\n}\n.hover\\:text-yellow-darkest:hover {\n  color: #453411;\n}\n.hover\\:text-yellow-darker:hover {\n  color: #684f1d;\n}\n.hover\\:text-yellow-dark:hover {\n  color: #f2d024;\n}\n.hover\\:text-yellow:hover {\n  color: #ffed4a;\n}\n.hover\\:text-yellow-light:hover {\n  color: #fff382;\n}\n.hover\\:text-yellow-lighter:hover {\n  color: #fff9c2;\n}\n.hover\\:text-yellow-lightest:hover {\n  color: #fcfbeb;\n}\n.hover\\:text-green-darkest:hover {\n  color: #0f2f21;\n}\n.hover\\:text-green-darker:hover {\n  color: #1a4731;\n}\n.hover\\:text-green-dark:hover {\n  color: #1f9d55;\n}\n.hover\\:text-green:hover {\n  color: #38c172;\n}\n.hover\\:text-green-light:hover {\n  color: #51d88a;\n}\n.hover\\:text-green-lighter:hover {\n  color: #a2f5bf;\n}\n.hover\\:text-green-lightest:hover {\n  color: #e3fcec;\n}\n.hover\\:text-teal-darkest:hover {\n  color: #0d3331;\n}\n.hover\\:text-teal-darker:hover {\n  color: #20504f;\n}\n.hover\\:text-teal-dark:hover {\n  color: #009480;\n}\n.hover\\:text-teal:hover {\n  color: #00ae98;\n}\n.hover\\:text-teal-light:hover {\n  color: #64d5ca;\n}\n.hover\\:text-teal-lighter:hover {\n  color: #a0f0ed;\n}\n.hover\\:text-teal-lightest:hover {\n  color: #e8fffe;\n}\n.hover\\:text-blue-darkest:hover {\n  color: #12283a;\n}\n.hover\\:text-blue-darker:hover {\n  color: #2e6da2;\n}\n.hover\\:text-blue-dark:hover {\n  color: #2779bd;\n}\n.hover\\:text-blue:hover {\n  color: #3490dc;\n}\n.hover\\:text-blue-light:hover {\n  color: #6cb2eb;\n}\n.hover\\:text-blue-lighter:hover {\n  color: #bcdefa;\n}\n.hover\\:text-blue-lightest:hover {\n  color: #eff8ff;\n}\n.hover\\:text-indigo-darkest:hover {\n  color: #191e38;\n}\n.hover\\:text-indigo-darker:hover {\n  color: #2f365f;\n}\n.hover\\:text-indigo-dark:hover {\n  color: #5661b3;\n}\n.hover\\:text-indigo:hover {\n  color: #6574cd;\n}\n.hover\\:text-indigo-light:hover {\n  color: #7886d7;\n}\n.hover\\:text-indigo-lighter:hover {\n  color: #b2b7ff;\n}\n.hover\\:text-indigo-lightest:hover {\n  color: #e6e8ff;\n}\n.hover\\:text-purple-darkest:hover {\n  color: #21183c;\n}\n.hover\\:text-purple-darker:hover {\n  color: #382b5f;\n}\n.hover\\:text-purple-dark:hover {\n  color: #794acf;\n}\n.hover\\:text-purple:hover {\n  color: #9561e2;\n}\n.hover\\:text-purple-light:hover {\n  color: #a779e9;\n}\n.hover\\:text-purple-lighter:hover {\n  color: #d6bbfc;\n}\n.hover\\:text-purple-lightest:hover {\n  color: #f3ebff;\n}\n.hover\\:text-pink-darkest:hover {\n  color: #451225;\n}\n.hover\\:text-pink-darker:hover {\n  color: #6f213f;\n}\n.hover\\:text-pink-dark:hover {\n  color: #eb5286;\n}\n.hover\\:text-pink:hover {\n  color: #f66d9b;\n}\n.hover\\:text-pink-light:hover {\n  color: #fa7ea8;\n}\n.hover\\:text-pink-lighter:hover {\n  color: #ffbbca;\n}\n.hover\\:text-pink-lightest:hover {\n  color: #ffebef;\n}\n.text-xs {\n  font-size: .75rem;\n}\n.text-sm {\n  font-size: .875rem;\n}\n.text-base {\n  font-size: 1rem;\n}\n.text-lg {\n  font-size: 1.125rem;\n}\n.text-xl {\n  font-size: 1.25rem;\n}\n.text-2xl {\n  font-size: 1.5rem;\n}\n.text-3xl {\n  font-size: 1.875rem;\n}\n.text-4xl {\n  font-size: 2.25rem;\n}\n.text-5xl {\n  font-size: 3rem;\n}\n.italic {\n  font-style: italic;\n}\n.roman {\n  font-style: normal;\n}\n.uppercase {\n  text-transform: uppercase;\n}\n.lowercase {\n  text-transform: lowercase;\n}\n.capitalize {\n  text-transform: capitalize;\n}\n.normal-case {\n  text-transform: none;\n}\n.underline {\n  text-decoration: underline;\n}\n.line-through {\n  text-decoration: line-through;\n}\n.no-underline {\n  text-decoration: none;\n}\n.antialiased {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.subpixel-antialiased {\n  -webkit-font-smoothing: auto;\n  -moz-osx-font-smoothing: auto;\n}\n.hover\\:italic:hover {\n  font-style: italic;\n}\n.hover\\:roman:hover {\n  font-style: normal;\n}\n.hover\\:uppercase:hover {\n  text-transform: uppercase;\n}\n.hover\\:lowercase:hover {\n  text-transform: lowercase;\n}\n.hover\\:capitalize:hover {\n  text-transform: capitalize;\n}\n.hover\\:normal-case:hover {\n  text-transform: none;\n}\n.hover\\:underline:hover {\n  text-decoration: underline;\n}\n.hover\\:line-through:hover {\n  text-decoration: line-through;\n}\n.hover\\:no-underline:hover {\n  text-decoration: none;\n}\n.hover\\:antialiased:hover {\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.hover\\:subpixel-antialiased:hover {\n  -webkit-font-smoothing: auto;\n  -moz-osx-font-smoothing: auto;\n}\n.tracking-tight {\n  letter-spacing: -0.05em;\n}\n.tracking-normal {\n  letter-spacing: 0;\n}\n.tracking-wide {\n  letter-spacing: .05em;\n}\n.select-none {\n  user-select: none;\n}\n.select-text {\n  user-select: text;\n}\n.align-baseline {\n  vertical-align: baseline;\n}\n.align-top {\n  vertical-align: top;\n}\n.align-middle {\n  vertical-align: middle;\n}\n.align-bottom {\n  vertical-align: bottom;\n}\n.align-text-top {\n  vertical-align: text-top;\n}\n.align-text-bottom {\n  vertical-align: text-bottom;\n}\n.visible {\n  visibility: visible;\n}\n.invisible {\n  visibility: hidden;\n}\n.whitespace-normal {\n  white-space: normal;\n}\n.whitespace-no-wrap {\n  white-space: nowrap;\n}\n.whitespace-pre {\n  white-space: pre;\n}\n.whitespace-pre-line {\n  white-space: pre-line;\n}\n.whitespace-pre-wrap {\n  white-space: pre-wrap;\n}\n.break-words {\n  word-wrap: break-word;\n}\n.break-normal {\n  word-wrap: normal;\n}\n.truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.w-1 {\n  width: .25rem;\n}\n.w-2 {\n  width: .5rem;\n}\n.w-3 {\n  width: .75rem;\n}\n.w-4 {\n  width: 1rem;\n}\n.w-6 {\n  width: 1.5rem;\n}\n.w-8 {\n  width: 2rem;\n}\n.w-10 {\n  width: 2.5rem;\n}\n.w-12 {\n  width: 3rem;\n}\n.w-16 {\n  width: 4rem;\n}\n.w-24 {\n  width: 6rem;\n}\n.w-32 {\n  width: 8rem;\n}\n.w-48 {\n  width: 12rem;\n}\n.w-64 {\n  width: 16rem;\n}\n.w-auto {\n  width: auto;\n}\n.w-px {\n  width: 1px;\n}\n.w-1\\/2 {\n  width: 50%;\n}\n.w-1\\/3 {\n  width: 33.33333%;\n}\n.w-2\\/3 {\n  width: 66.66667%;\n}\n.w-1\\/4 {\n  width: 25%;\n}\n.w-3\\/4 {\n  width: 75%;\n}\n.w-1\\/5 {\n  width: 20%;\n}\n.w-2\\/5 {\n  width: 40%;\n}\n.w-3\\/5 {\n  width: 60%;\n}\n.w-4\\/5 {\n  width: 80%;\n}\n.w-1\\/6 {\n  width: 16.66667%;\n}\n.w-5\\/6 {\n  width: 83.33333%;\n}\n.w-full {\n  width: 100%;\n}\n.w-screen {\n  width: 100vw;\n}\n.z-0 {\n  z-index: 0;\n}\n.z-10 {\n  z-index: 10;\n}\n.z-20 {\n  z-index: 20;\n}\n.z-30 {\n  z-index: 30;\n}\n.z-40 {\n  z-index: 40;\n}\n.z-50 {\n  z-index: 50;\n}\n.z-auto {\n  z-index: auto;\n}\n.z-max {\n  z-index: 1051 !important;\n}\n\n/* MaterialDesignIcons.com */\n@font-face {\n  font-family: \"Material Design Icons\";\n  src: url(" + escape(__webpack_require__(394)) + ");\n  src: url(" + escape(__webpack_require__(395)) + "?#iefix&v=2.2.43) format(\"embedded-opentype\"), url(" + escape(__webpack_require__(396)) + ") format(\"woff2\"), url(" + escape(__webpack_require__(397)) + ") format(\"woff\"), url(" + escape(__webpack_require__(398)) + ") format(\"truetype\"), url(" + escape(__webpack_require__(399)) + "#materialdesigniconsregular) format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n.mdi:before,\n.mdi-set {\n  display: inline-block;\n  font: normal normal normal 24px/1 \"Material Design Icons\";\n  font-size: inherit;\n  text-rendering: auto;\n  line-height: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.mdi-access-point:before {\n  content: \"\\F002\";\n}\n.mdi-access-point-network:before {\n  content: \"\\F003\";\n}\n.mdi-account:before {\n  content: \"\\F004\";\n}\n.mdi-account-alert:before {\n  content: \"\\F005\";\n}\n.mdi-account-box:before {\n  content: \"\\F006\";\n}\n.mdi-account-box-outline:before {\n  content: \"\\F007\";\n}\n.mdi-account-card-details:before {\n  content: \"\\F5D2\";\n}\n.mdi-account-check:before {\n  content: \"\\F008\";\n}\n.mdi-account-circle:before {\n  content: \"\\F009\";\n}\n.mdi-account-convert:before {\n  content: \"\\F00A\";\n}\n.mdi-account-edit:before {\n  content: \"\\F6BB\";\n}\n.mdi-account-group:before {\n  content: \"\\F848\";\n}\n.mdi-account-heart:before {\n  content: \"\\F898\";\n}\n.mdi-account-key:before {\n  content: \"\\F00B\";\n}\n.mdi-account-location:before {\n  content: \"\\F00C\";\n}\n.mdi-account-minus:before {\n  content: \"\\F00D\";\n}\n.mdi-account-multiple:before {\n  content: \"\\F00E\";\n}\n.mdi-account-multiple-minus:before {\n  content: \"\\F5D3\";\n}\n.mdi-account-multiple-outline:before {\n  content: \"\\F00F\";\n}\n.mdi-account-multiple-plus:before {\n  content: \"\\F010\";\n}\n.mdi-account-multiple-plus-outline:before {\n  content: \"\\F7FF\";\n}\n.mdi-account-network:before {\n  content: \"\\F011\";\n}\n.mdi-account-off:before {\n  content: \"\\F012\";\n}\n.mdi-account-outline:before {\n  content: \"\\F013\";\n}\n.mdi-account-plus:before {\n  content: \"\\F014\";\n}\n.mdi-account-plus-outline:before {\n  content: \"\\F800\";\n}\n.mdi-account-remove:before {\n  content: \"\\F015\";\n}\n.mdi-account-search:before {\n  content: \"\\F016\";\n}\n.mdi-account-settings:before {\n  content: \"\\F630\";\n}\n.mdi-account-settings-variant:before {\n  content: \"\\F631\";\n}\n.mdi-account-star:before {\n  content: \"\\F017\";\n}\n.mdi-account-switch:before {\n  content: \"\\F019\";\n}\n.mdi-accusoft:before {\n  content: \"\\F849\";\n}\n.mdi-adjust:before {\n  content: \"\\F01A\";\n}\n.mdi-air-conditioner:before {\n  content: \"\\F01B\";\n}\n.mdi-airballoon:before {\n  content: \"\\F01C\";\n}\n.mdi-airplane:before {\n  content: \"\\F01D\";\n}\n.mdi-airplane-landing:before {\n  content: \"\\F5D4\";\n}\n.mdi-airplane-off:before {\n  content: \"\\F01E\";\n}\n.mdi-airplane-takeoff:before {\n  content: \"\\F5D5\";\n}\n.mdi-airplay:before {\n  content: \"\\F01F\";\n}\n.mdi-airport:before {\n  content: \"\\F84A\";\n}\n.mdi-alarm:before {\n  content: \"\\F020\";\n}\n.mdi-alarm-bell:before {\n  content: \"\\F78D\";\n}\n.mdi-alarm-check:before {\n  content: \"\\F021\";\n}\n.mdi-alarm-light:before {\n  content: \"\\F78E\";\n}\n.mdi-alarm-multiple:before {\n  content: \"\\F022\";\n}\n.mdi-alarm-off:before {\n  content: \"\\F023\";\n}\n.mdi-alarm-plus:before {\n  content: \"\\F024\";\n}\n.mdi-alarm-snooze:before {\n  content: \"\\F68D\";\n}\n.mdi-album:before {\n  content: \"\\F025\";\n}\n.mdi-alert:before {\n  content: \"\\F026\";\n}\n.mdi-alert-box:before {\n  content: \"\\F027\";\n}\n.mdi-alert-circle:before {\n  content: \"\\F028\";\n}\n.mdi-alert-circle-outline:before {\n  content: \"\\F5D6\";\n}\n.mdi-alert-decagram:before {\n  content: \"\\F6BC\";\n}\n.mdi-alert-octagon:before {\n  content: \"\\F029\";\n}\n.mdi-alert-octagram:before {\n  content: \"\\F766\";\n}\n.mdi-alert-outline:before {\n  content: \"\\F02A\";\n}\n.mdi-alien:before {\n  content: \"\\F899\";\n}\n.mdi-all-inclusive:before {\n  content: \"\\F6BD\";\n}\n.mdi-allo:before {\n  content: \"\\F801\";\n}\n.mdi-alpha:before {\n  content: \"\\F02B\";\n}\n.mdi-alphabetical:before {\n  content: \"\\F02C\";\n}\n.mdi-altimeter:before {\n  content: \"\\F5D7\";\n}\n.mdi-amazon:before {\n  content: \"\\F02D\";\n}\n.mdi-amazon-clouddrive:before {\n  content: \"\\F02E\";\n}\n.mdi-ambulance:before {\n  content: \"\\F02F\";\n}\n.mdi-amplifier:before {\n  content: \"\\F030\";\n}\n.mdi-anchor:before {\n  content: \"\\F031\";\n}\n.mdi-android:before {\n  content: \"\\F032\";\n}\n.mdi-android-debug-bridge:before {\n  content: \"\\F033\";\n}\n.mdi-android-head:before {\n  content: \"\\F78F\";\n}\n.mdi-android-studio:before {\n  content: \"\\F034\";\n}\n.mdi-angular:before {\n  content: \"\\F6B1\";\n}\n.mdi-angularjs:before {\n  content: \"\\F6BE\";\n}\n.mdi-animation:before {\n  content: \"\\F5D8\";\n}\n.mdi-anvil:before {\n  content: \"\\F89A\";\n}\n.mdi-apple:before {\n  content: \"\\F035\";\n}\n.mdi-apple-finder:before {\n  content: \"\\F036\";\n}\n.mdi-apple-ios:before {\n  content: \"\\F037\";\n}\n.mdi-apple-keyboard-caps:before {\n  content: \"\\F632\";\n}\n.mdi-apple-keyboard-command:before {\n  content: \"\\F633\";\n}\n.mdi-apple-keyboard-control:before {\n  content: \"\\F634\";\n}\n.mdi-apple-keyboard-option:before {\n  content: \"\\F635\";\n}\n.mdi-apple-keyboard-shift:before {\n  content: \"\\F636\";\n}\n.mdi-apple-mobileme:before {\n  content: \"\\F038\";\n}\n.mdi-apple-safari:before {\n  content: \"\\F039\";\n}\n.mdi-application:before {\n  content: \"\\F614\";\n}\n.mdi-approval:before {\n  content: \"\\F790\";\n}\n.mdi-apps:before {\n  content: \"\\F03B\";\n}\n.mdi-archive:before {\n  content: \"\\F03C\";\n}\n.mdi-arrange-bring-forward:before {\n  content: \"\\F03D\";\n}\n.mdi-arrange-bring-to-front:before {\n  content: \"\\F03E\";\n}\n.mdi-arrange-send-backward:before {\n  content: \"\\F03F\";\n}\n.mdi-arrange-send-to-back:before {\n  content: \"\\F040\";\n}\n.mdi-arrow-all:before {\n  content: \"\\F041\";\n}\n.mdi-arrow-bottom-left:before {\n  content: \"\\F042\";\n}\n.mdi-arrow-bottom-right:before {\n  content: \"\\F043\";\n}\n.mdi-arrow-collapse:before {\n  content: \"\\F615\";\n}\n.mdi-arrow-collapse-all:before {\n  content: \"\\F044\";\n}\n.mdi-arrow-collapse-down:before {\n  content: \"\\F791\";\n}\n.mdi-arrow-collapse-horizontal:before {\n  content: \"\\F84B\";\n}\n.mdi-arrow-collapse-left:before {\n  content: \"\\F792\";\n}\n.mdi-arrow-collapse-right:before {\n  content: \"\\F793\";\n}\n.mdi-arrow-collapse-up:before {\n  content: \"\\F794\";\n}\n.mdi-arrow-collapse-vertical:before {\n  content: \"\\F84C\";\n}\n.mdi-arrow-down:before {\n  content: \"\\F045\";\n}\n.mdi-arrow-down-bold:before {\n  content: \"\\F72D\";\n}\n.mdi-arrow-down-bold-box:before {\n  content: \"\\F72E\";\n}\n.mdi-arrow-down-bold-box-outline:before {\n  content: \"\\F72F\";\n}\n.mdi-arrow-down-bold-circle:before {\n  content: \"\\F047\";\n}\n.mdi-arrow-down-bold-circle-outline:before {\n  content: \"\\F048\";\n}\n.mdi-arrow-down-bold-hexagon-outline:before {\n  content: \"\\F049\";\n}\n.mdi-arrow-down-box:before {\n  content: \"\\F6BF\";\n}\n.mdi-arrow-down-drop-circle:before {\n  content: \"\\F04A\";\n}\n.mdi-arrow-down-drop-circle-outline:before {\n  content: \"\\F04B\";\n}\n.mdi-arrow-down-thick:before {\n  content: \"\\F046\";\n}\n.mdi-arrow-expand:before {\n  content: \"\\F616\";\n}\n.mdi-arrow-expand-all:before {\n  content: \"\\F04C\";\n}\n.mdi-arrow-expand-down:before {\n  content: \"\\F795\";\n}\n.mdi-arrow-expand-horizontal:before {\n  content: \"\\F84D\";\n}\n.mdi-arrow-expand-left:before {\n  content: \"\\F796\";\n}\n.mdi-arrow-expand-right:before {\n  content: \"\\F797\";\n}\n.mdi-arrow-expand-up:before {\n  content: \"\\F798\";\n}\n.mdi-arrow-expand-vertical:before {\n  content: \"\\F84E\";\n}\n.mdi-arrow-left:before {\n  content: \"\\F04D\";\n}\n.mdi-arrow-left-bold:before {\n  content: \"\\F730\";\n}\n.mdi-arrow-left-bold-box:before {\n  content: \"\\F731\";\n}\n.mdi-arrow-left-bold-box-outline:before {\n  content: \"\\F732\";\n}\n.mdi-arrow-left-bold-circle:before {\n  content: \"\\F04F\";\n}\n.mdi-arrow-left-bold-circle-outline:before {\n  content: \"\\F050\";\n}\n.mdi-arrow-left-bold-hexagon-outline:before {\n  content: \"\\F051\";\n}\n.mdi-arrow-left-box:before {\n  content: \"\\F6C0\";\n}\n.mdi-arrow-left-drop-circle:before {\n  content: \"\\F052\";\n}\n.mdi-arrow-left-drop-circle-outline:before {\n  content: \"\\F053\";\n}\n.mdi-arrow-left-thick:before {\n  content: \"\\F04E\";\n}\n.mdi-arrow-right:before {\n  content: \"\\F054\";\n}\n.mdi-arrow-right-bold:before {\n  content: \"\\F733\";\n}\n.mdi-arrow-right-bold-box:before {\n  content: \"\\F734\";\n}\n.mdi-arrow-right-bold-box-outline:before {\n  content: \"\\F735\";\n}\n.mdi-arrow-right-bold-circle:before {\n  content: \"\\F056\";\n}\n.mdi-arrow-right-bold-circle-outline:before {\n  content: \"\\F057\";\n}\n.mdi-arrow-right-bold-hexagon-outline:before {\n  content: \"\\F058\";\n}\n.mdi-arrow-right-box:before {\n  content: \"\\F6C1\";\n}\n.mdi-arrow-right-drop-circle:before {\n  content: \"\\F059\";\n}\n.mdi-arrow-right-drop-circle-outline:before {\n  content: \"\\F05A\";\n}\n.mdi-arrow-right-thick:before {\n  content: \"\\F055\";\n}\n.mdi-arrow-top-left:before {\n  content: \"\\F05B\";\n}\n.mdi-arrow-top-right:before {\n  content: \"\\F05C\";\n}\n.mdi-arrow-up:before {\n  content: \"\\F05D\";\n}\n.mdi-arrow-up-bold:before {\n  content: \"\\F736\";\n}\n.mdi-arrow-up-bold-box:before {\n  content: \"\\F737\";\n}\n.mdi-arrow-up-bold-box-outline:before {\n  content: \"\\F738\";\n}\n.mdi-arrow-up-bold-circle:before {\n  content: \"\\F05F\";\n}\n.mdi-arrow-up-bold-circle-outline:before {\n  content: \"\\F060\";\n}\n.mdi-arrow-up-bold-hexagon-outline:before {\n  content: \"\\F061\";\n}\n.mdi-arrow-up-box:before {\n  content: \"\\F6C2\";\n}\n.mdi-arrow-up-drop-circle:before {\n  content: \"\\F062\";\n}\n.mdi-arrow-up-drop-circle-outline:before {\n  content: \"\\F063\";\n}\n.mdi-arrow-up-thick:before {\n  content: \"\\F05E\";\n}\n.mdi-artist:before {\n  content: \"\\F802\";\n}\n.mdi-assistant:before {\n  content: \"\\F064\";\n}\n.mdi-asterisk:before {\n  content: \"\\F6C3\";\n}\n.mdi-at:before {\n  content: \"\\F065\";\n}\n.mdi-atlassian:before {\n  content: \"\\F803\";\n}\n.mdi-atom:before {\n  content: \"\\F767\";\n}\n.mdi-attachment:before {\n  content: \"\\F066\";\n}\n.mdi-audiobook:before {\n  content: \"\\F067\";\n}\n.mdi-augmented-reality:before {\n  content: \"\\F84F\";\n}\n.mdi-auto-fix:before {\n  content: \"\\F068\";\n}\n.mdi-auto-upload:before {\n  content: \"\\F069\";\n}\n.mdi-autorenew:before {\n  content: \"\\F06A\";\n}\n.mdi-av-timer:before {\n  content: \"\\F06B\";\n}\n.mdi-azure:before {\n  content: \"\\F804\";\n}\n.mdi-baby:before {\n  content: \"\\F06C\";\n}\n.mdi-baby-buggy:before {\n  content: \"\\F68E\";\n}\n.mdi-backburger:before {\n  content: \"\\F06D\";\n}\n.mdi-backspace:before {\n  content: \"\\F06E\";\n}\n.mdi-backup-restore:before {\n  content: \"\\F06F\";\n}\n.mdi-badminton:before {\n  content: \"\\F850\";\n}\n.mdi-bandcamp:before {\n  content: \"\\F674\";\n}\n.mdi-bank:before {\n  content: \"\\F070\";\n}\n.mdi-barcode:before {\n  content: \"\\F071\";\n}\n.mdi-barcode-scan:before {\n  content: \"\\F072\";\n}\n.mdi-barley:before {\n  content: \"\\F073\";\n}\n.mdi-barrel:before {\n  content: \"\\F074\";\n}\n.mdi-baseball:before {\n  content: \"\\F851\";\n}\n.mdi-baseball-bat:before {\n  content: \"\\F852\";\n}\n.mdi-basecamp:before {\n  content: \"\\F075\";\n}\n.mdi-basket:before {\n  content: \"\\F076\";\n}\n.mdi-basket-fill:before {\n  content: \"\\F077\";\n}\n.mdi-basket-unfill:before {\n  content: \"\\F078\";\n}\n.mdi-basketball:before {\n  content: \"\\F805\";\n}\n.mdi-battery:before {\n  content: \"\\F079\";\n}\n.mdi-battery-10:before {\n  content: \"\\F07A\";\n}\n.mdi-battery-20:before {\n  content: \"\\F07B\";\n}\n.mdi-battery-30:before {\n  content: \"\\F07C\";\n}\n.mdi-battery-40:before {\n  content: \"\\F07D\";\n}\n.mdi-battery-50:before {\n  content: \"\\F07E\";\n}\n.mdi-battery-60:before {\n  content: \"\\F07F\";\n}\n.mdi-battery-70:before {\n  content: \"\\F080\";\n}\n.mdi-battery-80:before {\n  content: \"\\F081\";\n}\n.mdi-battery-90:before {\n  content: \"\\F082\";\n}\n.mdi-battery-alert:before {\n  content: \"\\F083\";\n}\n.mdi-battery-charging:before {\n  content: \"\\F084\";\n}\n.mdi-battery-charging-10:before {\n  content: \"\\F89B\";\n}\n.mdi-battery-charging-100:before {\n  content: \"\\F085\";\n}\n.mdi-battery-charging-20:before {\n  content: \"\\F086\";\n}\n.mdi-battery-charging-30:before {\n  content: \"\\F087\";\n}\n.mdi-battery-charging-40:before {\n  content: \"\\F088\";\n}\n.mdi-battery-charging-50:before {\n  content: \"\\F89C\";\n}\n.mdi-battery-charging-60:before {\n  content: \"\\F089\";\n}\n.mdi-battery-charging-70:before {\n  content: \"\\F89D\";\n}\n.mdi-battery-charging-80:before {\n  content: \"\\F08A\";\n}\n.mdi-battery-charging-90:before {\n  content: \"\\F08B\";\n}\n.mdi-battery-charging-outline:before {\n  content: \"\\F89E\";\n}\n.mdi-battery-charging-wireless:before {\n  content: \"\\F806\";\n}\n.mdi-battery-charging-wireless-10:before {\n  content: \"\\F807\";\n}\n.mdi-battery-charging-wireless-20:before {\n  content: \"\\F808\";\n}\n.mdi-battery-charging-wireless-30:before {\n  content: \"\\F809\";\n}\n.mdi-battery-charging-wireless-40:before {\n  content: \"\\F80A\";\n}\n.mdi-battery-charging-wireless-50:before {\n  content: \"\\F80B\";\n}\n.mdi-battery-charging-wireless-60:before {\n  content: \"\\F80C\";\n}\n.mdi-battery-charging-wireless-70:before {\n  content: \"\\F80D\";\n}\n.mdi-battery-charging-wireless-80:before {\n  content: \"\\F80E\";\n}\n.mdi-battery-charging-wireless-90:before {\n  content: \"\\F80F\";\n}\n.mdi-battery-charging-wireless-alert:before {\n  content: \"\\F810\";\n}\n.mdi-battery-charging-wireless-outline:before {\n  content: \"\\F811\";\n}\n.mdi-battery-minus:before {\n  content: \"\\F08C\";\n}\n.mdi-battery-negative:before {\n  content: \"\\F08D\";\n}\n.mdi-battery-outline:before {\n  content: \"\\F08E\";\n}\n.mdi-battery-plus:before {\n  content: \"\\F08F\";\n}\n.mdi-battery-positive:before {\n  content: \"\\F090\";\n}\n.mdi-battery-unknown:before {\n  content: \"\\F091\";\n}\n.mdi-beach:before {\n  content: \"\\F092\";\n}\n.mdi-beaker:before {\n  content: \"\\F68F\";\n}\n.mdi-beats:before {\n  content: \"\\F097\";\n}\n.mdi-bed-empty:before {\n  content: \"\\F89F\";\n}\n.mdi-beer:before {\n  content: \"\\F098\";\n}\n.mdi-behance:before {\n  content: \"\\F099\";\n}\n.mdi-bell:before {\n  content: \"\\F09A\";\n}\n.mdi-bell-off:before {\n  content: \"\\F09B\";\n}\n.mdi-bell-outline:before {\n  content: \"\\F09C\";\n}\n.mdi-bell-plus:before {\n  content: \"\\F09D\";\n}\n.mdi-bell-ring:before {\n  content: \"\\F09E\";\n}\n.mdi-bell-ring-outline:before {\n  content: \"\\F09F\";\n}\n.mdi-bell-sleep:before {\n  content: \"\\F0A0\";\n}\n.mdi-beta:before {\n  content: \"\\F0A1\";\n}\n.mdi-bible:before {\n  content: \"\\F0A2\";\n}\n.mdi-bike:before {\n  content: \"\\F0A3\";\n}\n.mdi-bing:before {\n  content: \"\\F0A4\";\n}\n.mdi-binoculars:before {\n  content: \"\\F0A5\";\n}\n.mdi-bio:before {\n  content: \"\\F0A6\";\n}\n.mdi-biohazard:before {\n  content: \"\\F0A7\";\n}\n.mdi-bitbucket:before {\n  content: \"\\F0A8\";\n}\n.mdi-bitcoin:before {\n  content: \"\\F812\";\n}\n.mdi-black-mesa:before {\n  content: \"\\F0A9\";\n}\n.mdi-blackberry:before {\n  content: \"\\F0AA\";\n}\n.mdi-blender:before {\n  content: \"\\F0AB\";\n}\n.mdi-blinds:before {\n  content: \"\\F0AC\";\n}\n.mdi-block-helper:before {\n  content: \"\\F0AD\";\n}\n.mdi-blogger:before {\n  content: \"\\F0AE\";\n}\n.mdi-bluetooth:before {\n  content: \"\\F0AF\";\n}\n.mdi-bluetooth-audio:before {\n  content: \"\\F0B0\";\n}\n.mdi-bluetooth-connect:before {\n  content: \"\\F0B1\";\n}\n.mdi-bluetooth-off:before {\n  content: \"\\F0B2\";\n}\n.mdi-bluetooth-settings:before {\n  content: \"\\F0B3\";\n}\n.mdi-bluetooth-transfer:before {\n  content: \"\\F0B4\";\n}\n.mdi-blur:before {\n  content: \"\\F0B5\";\n}\n.mdi-blur-linear:before {\n  content: \"\\F0B6\";\n}\n.mdi-blur-off:before {\n  content: \"\\F0B7\";\n}\n.mdi-blur-radial:before {\n  content: \"\\F0B8\";\n}\n.mdi-bomb:before {\n  content: \"\\F690\";\n}\n.mdi-bomb-off:before {\n  content: \"\\F6C4\";\n}\n.mdi-bone:before {\n  content: \"\\F0B9\";\n}\n.mdi-book:before {\n  content: \"\\F0BA\";\n}\n.mdi-book-minus:before {\n  content: \"\\F5D9\";\n}\n.mdi-book-multiple:before {\n  content: \"\\F0BB\";\n}\n.mdi-book-multiple-variant:before {\n  content: \"\\F0BC\";\n}\n.mdi-book-open:before {\n  content: \"\\F0BD\";\n}\n.mdi-book-open-page-variant:before {\n  content: \"\\F5DA\";\n}\n.mdi-book-open-variant:before {\n  content: \"\\F0BE\";\n}\n.mdi-book-plus:before {\n  content: \"\\F5DB\";\n}\n.mdi-book-secure:before {\n  content: \"\\F799\";\n}\n.mdi-book-unsecure:before {\n  content: \"\\F79A\";\n}\n.mdi-book-variant:before {\n  content: \"\\F0BF\";\n}\n.mdi-bookmark:before {\n  content: \"\\F0C0\";\n}\n.mdi-bookmark-check:before {\n  content: \"\\F0C1\";\n}\n.mdi-bookmark-music:before {\n  content: \"\\F0C2\";\n}\n.mdi-bookmark-outline:before {\n  content: \"\\F0C3\";\n}\n.mdi-bookmark-plus:before {\n  content: \"\\F0C5\";\n}\n.mdi-bookmark-plus-outline:before {\n  content: \"\\F0C4\";\n}\n.mdi-bookmark-remove:before {\n  content: \"\\F0C6\";\n}\n.mdi-boombox:before {\n  content: \"\\F5DC\";\n}\n.mdi-bootstrap:before {\n  content: \"\\F6C5\";\n}\n.mdi-border-all:before {\n  content: \"\\F0C7\";\n}\n.mdi-border-all-variant:before {\n  content: \"\\F8A0\";\n}\n.mdi-border-bottom:before {\n  content: \"\\F0C8\";\n}\n.mdi-border-bottom-variant:before {\n  content: \"\\F8A1\";\n}\n.mdi-border-color:before {\n  content: \"\\F0C9\";\n}\n.mdi-border-horizontal:before {\n  content: \"\\F0CA\";\n}\n.mdi-border-inside:before {\n  content: \"\\F0CB\";\n}\n.mdi-border-left:before {\n  content: \"\\F0CC\";\n}\n.mdi-border-left-variant:before {\n  content: \"\\F8A2\";\n}\n.mdi-border-none:before {\n  content: \"\\F0CD\";\n}\n.mdi-border-none-variant:before {\n  content: \"\\F8A3\";\n}\n.mdi-border-outside:before {\n  content: \"\\F0CE\";\n}\n.mdi-border-right:before {\n  content: \"\\F0CF\";\n}\n.mdi-border-right-variant:before {\n  content: \"\\F8A4\";\n}\n.mdi-border-style:before {\n  content: \"\\F0D0\";\n}\n.mdi-border-top:before {\n  content: \"\\F0D1\";\n}\n.mdi-border-top-variant:before {\n  content: \"\\F8A5\";\n}\n.mdi-border-vertical:before {\n  content: \"\\F0D2\";\n}\n.mdi-bottle-wine:before {\n  content: \"\\F853\";\n}\n.mdi-bow-tie:before {\n  content: \"\\F677\";\n}\n.mdi-bowl:before {\n  content: \"\\F617\";\n}\n.mdi-bowling:before {\n  content: \"\\F0D3\";\n}\n.mdi-box:before {\n  content: \"\\F0D4\";\n}\n.mdi-box-cutter:before {\n  content: \"\\F0D5\";\n}\n.mdi-box-shadow:before {\n  content: \"\\F637\";\n}\n.mdi-bridge:before {\n  content: \"\\F618\";\n}\n.mdi-briefcase:before {\n  content: \"\\F0D6\";\n}\n.mdi-briefcase-check:before {\n  content: \"\\F0D7\";\n}\n.mdi-briefcase-download:before {\n  content: \"\\F0D8\";\n}\n.mdi-briefcase-outline:before {\n  content: \"\\F813\";\n}\n.mdi-briefcase-upload:before {\n  content: \"\\F0D9\";\n}\n.mdi-brightness-1:before {\n  content: \"\\F0DA\";\n}\n.mdi-brightness-2:before {\n  content: \"\\F0DB\";\n}\n.mdi-brightness-3:before {\n  content: \"\\F0DC\";\n}\n.mdi-brightness-4:before {\n  content: \"\\F0DD\";\n}\n.mdi-brightness-5:before {\n  content: \"\\F0DE\";\n}\n.mdi-brightness-6:before {\n  content: \"\\F0DF\";\n}\n.mdi-brightness-7:before {\n  content: \"\\F0E0\";\n}\n.mdi-brightness-auto:before {\n  content: \"\\F0E1\";\n}\n.mdi-broom:before {\n  content: \"\\F0E2\";\n}\n.mdi-brush:before {\n  content: \"\\F0E3\";\n}\n.mdi-buffer:before {\n  content: \"\\F619\";\n}\n.mdi-bug:before {\n  content: \"\\F0E4\";\n}\n.mdi-bulletin-board:before {\n  content: \"\\F0E5\";\n}\n.mdi-bullhorn:before {\n  content: \"\\F0E6\";\n}\n.mdi-bullseye:before {\n  content: \"\\F5DD\";\n}\n.mdi-bus:before {\n  content: \"\\F0E7\";\n}\n.mdi-bus-articulated-end:before {\n  content: \"\\F79B\";\n}\n.mdi-bus-articulated-front:before {\n  content: \"\\F79C\";\n}\n.mdi-bus-double-decker:before {\n  content: \"\\F79D\";\n}\n.mdi-bus-school:before {\n  content: \"\\F79E\";\n}\n.mdi-bus-side:before {\n  content: \"\\F79F\";\n}\n.mdi-cached:before {\n  content: \"\\F0E8\";\n}\n.mdi-cake:before {\n  content: \"\\F0E9\";\n}\n.mdi-cake-layered:before {\n  content: \"\\F0EA\";\n}\n.mdi-cake-variant:before {\n  content: \"\\F0EB\";\n}\n.mdi-calculator:before {\n  content: \"\\F0EC\";\n}\n.mdi-calendar:before {\n  content: \"\\F0ED\";\n}\n.mdi-calendar-blank:before {\n  content: \"\\F0EE\";\n}\n.mdi-calendar-check:before {\n  content: \"\\F0EF\";\n}\n.mdi-calendar-clock:before {\n  content: \"\\F0F0\";\n}\n.mdi-calendar-edit:before {\n  content: \"\\F8A6\";\n}\n.mdi-calendar-multiple:before {\n  content: \"\\F0F1\";\n}\n.mdi-calendar-multiple-check:before {\n  content: \"\\F0F2\";\n}\n.mdi-calendar-plus:before {\n  content: \"\\F0F3\";\n}\n.mdi-calendar-question:before {\n  content: \"\\F691\";\n}\n.mdi-calendar-range:before {\n  content: \"\\F678\";\n}\n.mdi-calendar-remove:before {\n  content: \"\\F0F4\";\n}\n.mdi-calendar-text:before {\n  content: \"\\F0F5\";\n}\n.mdi-calendar-today:before {\n  content: \"\\F0F6\";\n}\n.mdi-call-made:before {\n  content: \"\\F0F7\";\n}\n.mdi-call-merge:before {\n  content: \"\\F0F8\";\n}\n.mdi-call-missed:before {\n  content: \"\\F0F9\";\n}\n.mdi-call-received:before {\n  content: \"\\F0FA\";\n}\n.mdi-call-split:before {\n  content: \"\\F0FB\";\n}\n.mdi-camcorder:before {\n  content: \"\\F0FC\";\n}\n.mdi-camcorder-box:before {\n  content: \"\\F0FD\";\n}\n.mdi-camcorder-box-off:before {\n  content: \"\\F0FE\";\n}\n.mdi-camcorder-off:before {\n  content: \"\\F0FF\";\n}\n.mdi-camera:before {\n  content: \"\\F100\";\n}\n.mdi-camera-burst:before {\n  content: \"\\F692\";\n}\n.mdi-camera-enhance:before {\n  content: \"\\F101\";\n}\n.mdi-camera-front:before {\n  content: \"\\F102\";\n}\n.mdi-camera-front-variant:before {\n  content: \"\\F103\";\n}\n.mdi-camera-gopro:before {\n  content: \"\\F7A0\";\n}\n.mdi-camera-iris:before {\n  content: \"\\F104\";\n}\n.mdi-camera-metering-center:before {\n  content: \"\\F7A1\";\n}\n.mdi-camera-metering-matrix:before {\n  content: \"\\F7A2\";\n}\n.mdi-camera-metering-partial:before {\n  content: \"\\F7A3\";\n}\n.mdi-camera-metering-spot:before {\n  content: \"\\F7A4\";\n}\n.mdi-camera-off:before {\n  content: \"\\F5DF\";\n}\n.mdi-camera-party-mode:before {\n  content: \"\\F105\";\n}\n.mdi-camera-rear:before {\n  content: \"\\F106\";\n}\n.mdi-camera-rear-variant:before {\n  content: \"\\F107\";\n}\n.mdi-camera-switch:before {\n  content: \"\\F108\";\n}\n.mdi-camera-timer:before {\n  content: \"\\F109\";\n}\n.mdi-cancel:before {\n  content: \"\\F739\";\n}\n.mdi-candle:before {\n  content: \"\\F5E2\";\n}\n.mdi-candycane:before {\n  content: \"\\F10A\";\n}\n.mdi-cannabis:before {\n  content: \"\\F7A5\";\n}\n.mdi-car:before {\n  content: \"\\F10B\";\n}\n.mdi-car-battery:before {\n  content: \"\\F10C\";\n}\n.mdi-car-connected:before {\n  content: \"\\F10D\";\n}\n.mdi-car-convertible:before {\n  content: \"\\F7A6\";\n}\n.mdi-car-estate:before {\n  content: \"\\F7A7\";\n}\n.mdi-car-hatchback:before {\n  content: \"\\F7A8\";\n}\n.mdi-car-pickup:before {\n  content: \"\\F7A9\";\n}\n.mdi-car-side:before {\n  content: \"\\F7AA\";\n}\n.mdi-car-sports:before {\n  content: \"\\F7AB\";\n}\n.mdi-car-wash:before {\n  content: \"\\F10E\";\n}\n.mdi-caravan:before {\n  content: \"\\F7AC\";\n}\n.mdi-cards:before {\n  content: \"\\F638\";\n}\n.mdi-cards-outline:before {\n  content: \"\\F639\";\n}\n.mdi-cards-playing-outline:before {\n  content: \"\\F63A\";\n}\n.mdi-cards-variant:before {\n  content: \"\\F6C6\";\n}\n.mdi-carrot:before {\n  content: \"\\F10F\";\n}\n.mdi-cart:before {\n  content: \"\\F110\";\n}\n.mdi-cart-off:before {\n  content: \"\\F66B\";\n}\n.mdi-cart-outline:before {\n  content: \"\\F111\";\n}\n.mdi-cart-plus:before {\n  content: \"\\F112\";\n}\n.mdi-case-sensitive-alt:before {\n  content: \"\\F113\";\n}\n.mdi-cash:before {\n  content: \"\\F114\";\n}\n.mdi-cash-100:before {\n  content: \"\\F115\";\n}\n.mdi-cash-multiple:before {\n  content: \"\\F116\";\n}\n.mdi-cash-usd:before {\n  content: \"\\F117\";\n}\n.mdi-cast:before {\n  content: \"\\F118\";\n}\n.mdi-cast-connected:before {\n  content: \"\\F119\";\n}\n.mdi-cast-off:before {\n  content: \"\\F789\";\n}\n.mdi-castle:before {\n  content: \"\\F11A\";\n}\n.mdi-cat:before {\n  content: \"\\F11B\";\n}\n.mdi-cctv:before {\n  content: \"\\F7AD\";\n}\n.mdi-ceiling-light:before {\n  content: \"\\F768\";\n}\n.mdi-cellphone:before {\n  content: \"\\F11C\";\n}\n.mdi-cellphone-android:before {\n  content: \"\\F11D\";\n}\n.mdi-cellphone-basic:before {\n  content: \"\\F11E\";\n}\n.mdi-cellphone-dock:before {\n  content: \"\\F11F\";\n}\n.mdi-cellphone-iphone:before {\n  content: \"\\F120\";\n}\n.mdi-cellphone-link:before {\n  content: \"\\F121\";\n}\n.mdi-cellphone-link-off:before {\n  content: \"\\F122\";\n}\n.mdi-cellphone-settings:before {\n  content: \"\\F123\";\n}\n.mdi-cellphone-wireless:before {\n  content: \"\\F814\";\n}\n.mdi-certificate:before {\n  content: \"\\F124\";\n}\n.mdi-chair-school:before {\n  content: \"\\F125\";\n}\n.mdi-chart-arc:before {\n  content: \"\\F126\";\n}\n.mdi-chart-areaspline:before {\n  content: \"\\F127\";\n}\n.mdi-chart-bar:before {\n  content: \"\\F128\";\n}\n.mdi-chart-bar-stacked:before {\n  content: \"\\F769\";\n}\n.mdi-chart-bubble:before {\n  content: \"\\F5E3\";\n}\n.mdi-chart-donut:before {\n  content: \"\\F7AE\";\n}\n.mdi-chart-donut-variant:before {\n  content: \"\\F7AF\";\n}\n.mdi-chart-gantt:before {\n  content: \"\\F66C\";\n}\n.mdi-chart-histogram:before {\n  content: \"\\F129\";\n}\n.mdi-chart-line:before {\n  content: \"\\F12A\";\n}\n.mdi-chart-line-stacked:before {\n  content: \"\\F76A\";\n}\n.mdi-chart-line-variant:before {\n  content: \"\\F7B0\";\n}\n.mdi-chart-pie:before {\n  content: \"\\F12B\";\n}\n.mdi-chart-scatterplot-hexbin:before {\n  content: \"\\F66D\";\n}\n.mdi-chart-timeline:before {\n  content: \"\\F66E\";\n}\n.mdi-check:before {\n  content: \"\\F12C\";\n}\n.mdi-check-all:before {\n  content: \"\\F12D\";\n}\n.mdi-check-circle:before {\n  content: \"\\F5E0\";\n}\n.mdi-check-circle-outline:before {\n  content: \"\\F5E1\";\n}\n.mdi-check-outline:before {\n  content: \"\\F854\";\n}\n.mdi-checkbox-blank:before {\n  content: \"\\F12E\";\n}\n.mdi-checkbox-blank-circle:before {\n  content: \"\\F12F\";\n}\n.mdi-checkbox-blank-circle-outline:before {\n  content: \"\\F130\";\n}\n.mdi-checkbox-blank-outline:before {\n  content: \"\\F131\";\n}\n.mdi-checkbox-intermediate:before {\n  content: \"\\F855\";\n}\n.mdi-checkbox-marked:before {\n  content: \"\\F132\";\n}\n.mdi-checkbox-marked-circle:before {\n  content: \"\\F133\";\n}\n.mdi-checkbox-marked-circle-outline:before {\n  content: \"\\F134\";\n}\n.mdi-checkbox-marked-outline:before {\n  content: \"\\F135\";\n}\n.mdi-checkbox-multiple-blank:before {\n  content: \"\\F136\";\n}\n.mdi-checkbox-multiple-blank-circle:before {\n  content: \"\\F63B\";\n}\n.mdi-checkbox-multiple-blank-circle-outline:before {\n  content: \"\\F63C\";\n}\n.mdi-checkbox-multiple-blank-outline:before {\n  content: \"\\F137\";\n}\n.mdi-checkbox-multiple-marked:before {\n  content: \"\\F138\";\n}\n.mdi-checkbox-multiple-marked-circle:before {\n  content: \"\\F63D\";\n}\n.mdi-checkbox-multiple-marked-circle-outline:before {\n  content: \"\\F63E\";\n}\n.mdi-checkbox-multiple-marked-outline:before {\n  content: \"\\F139\";\n}\n.mdi-checkerboard:before {\n  content: \"\\F13A\";\n}\n.mdi-chemical-weapon:before {\n  content: \"\\F13B\";\n}\n.mdi-chess-bishop:before {\n  content: \"\\F85B\";\n}\n.mdi-chess-king:before {\n  content: \"\\F856\";\n}\n.mdi-chess-knight:before {\n  content: \"\\F857\";\n}\n.mdi-chess-pawn:before {\n  content: \"\\F858\";\n}\n.mdi-chess-queen:before {\n  content: \"\\F859\";\n}\n.mdi-chess-rook:before {\n  content: \"\\F85A\";\n}\n.mdi-chevron-double-down:before {\n  content: \"\\F13C\";\n}\n.mdi-chevron-double-left:before {\n  content: \"\\F13D\";\n}\n.mdi-chevron-double-right:before {\n  content: \"\\F13E\";\n}\n.mdi-chevron-double-up:before {\n  content: \"\\F13F\";\n}\n.mdi-chevron-down:before {\n  content: \"\\F140\";\n}\n.mdi-chevron-left:before {\n  content: \"\\F141\";\n}\n.mdi-chevron-right:before {\n  content: \"\\F142\";\n}\n.mdi-chevron-up:before {\n  content: \"\\F143\";\n}\n.mdi-chili-hot:before {\n  content: \"\\F7B1\";\n}\n.mdi-chili-medium:before {\n  content: \"\\F7B2\";\n}\n.mdi-chili-mild:before {\n  content: \"\\F7B3\";\n}\n.mdi-chip:before {\n  content: \"\\F61A\";\n}\n.mdi-church:before {\n  content: \"\\F144\";\n}\n.mdi-circle:before {\n  content: \"\\F764\";\n}\n.mdi-circle-outline:before {\n  content: \"\\F765\";\n}\n.mdi-cisco-webex:before {\n  content: \"\\F145\";\n}\n.mdi-city:before {\n  content: \"\\F146\";\n}\n.mdi-clipboard:before {\n  content: \"\\F147\";\n}\n.mdi-clipboard-account:before {\n  content: \"\\F148\";\n}\n.mdi-clipboard-alert:before {\n  content: \"\\F149\";\n}\n.mdi-clipboard-arrow-down:before {\n  content: \"\\F14A\";\n}\n.mdi-clipboard-arrow-left:before {\n  content: \"\\F14B\";\n}\n.mdi-clipboard-check:before {\n  content: \"\\F14C\";\n}\n.mdi-clipboard-check-outline:before {\n  content: \"\\F8A7\";\n}\n.mdi-clipboard-flow:before {\n  content: \"\\F6C7\";\n}\n.mdi-clipboard-outline:before {\n  content: \"\\F14D\";\n}\n.mdi-clipboard-plus:before {\n  content: \"\\F750\";\n}\n.mdi-clipboard-pulse:before {\n  content: \"\\F85C\";\n}\n.mdi-clipboard-pulse-outline:before {\n  content: \"\\F85D\";\n}\n.mdi-clipboard-text:before {\n  content: \"\\F14E\";\n}\n.mdi-clippy:before {\n  content: \"\\F14F\";\n}\n.mdi-clock:before {\n  content: \"\\F150\";\n}\n.mdi-clock-alert:before {\n  content: \"\\F5CE\";\n}\n.mdi-clock-end:before {\n  content: \"\\F151\";\n}\n.mdi-clock-fast:before {\n  content: \"\\F152\";\n}\n.mdi-clock-in:before {\n  content: \"\\F153\";\n}\n.mdi-clock-out:before {\n  content: \"\\F154\";\n}\n.mdi-clock-start:before {\n  content: \"\\F155\";\n}\n.mdi-close:before {\n  content: \"\\F156\";\n}\n.mdi-close-box:before {\n  content: \"\\F157\";\n}\n.mdi-close-box-outline:before {\n  content: \"\\F158\";\n}\n.mdi-close-circle:before {\n  content: \"\\F159\";\n}\n.mdi-close-circle-outline:before {\n  content: \"\\F15A\";\n}\n.mdi-close-network:before {\n  content: \"\\F15B\";\n}\n.mdi-close-octagon:before {\n  content: \"\\F15C\";\n}\n.mdi-close-octagon-outline:before {\n  content: \"\\F15D\";\n}\n.mdi-close-outline:before {\n  content: \"\\F6C8\";\n}\n.mdi-closed-caption:before {\n  content: \"\\F15E\";\n}\n.mdi-cloud:before {\n  content: \"\\F15F\";\n}\n.mdi-cloud-braces:before {\n  content: \"\\F7B4\";\n}\n.mdi-cloud-check:before {\n  content: \"\\F160\";\n}\n.mdi-cloud-circle:before {\n  content: \"\\F161\";\n}\n.mdi-cloud-download:before {\n  content: \"\\F162\";\n}\n.mdi-cloud-off-outline:before {\n  content: \"\\F164\";\n}\n.mdi-cloud-outline:before {\n  content: \"\\F163\";\n}\n.mdi-cloud-print:before {\n  content: \"\\F165\";\n}\n.mdi-cloud-print-outline:before {\n  content: \"\\F166\";\n}\n.mdi-cloud-sync:before {\n  content: \"\\F63F\";\n}\n.mdi-cloud-tags:before {\n  content: \"\\F7B5\";\n}\n.mdi-cloud-upload:before {\n  content: \"\\F167\";\n}\n.mdi-clover:before {\n  content: \"\\F815\";\n}\n.mdi-code-array:before {\n  content: \"\\F168\";\n}\n.mdi-code-braces:before {\n  content: \"\\F169\";\n}\n.mdi-code-brackets:before {\n  content: \"\\F16A\";\n}\n.mdi-code-equal:before {\n  content: \"\\F16B\";\n}\n.mdi-code-greater-than:before {\n  content: \"\\F16C\";\n}\n.mdi-code-greater-than-or-equal:before {\n  content: \"\\F16D\";\n}\n.mdi-code-less-than:before {\n  content: \"\\F16E\";\n}\n.mdi-code-less-than-or-equal:before {\n  content: \"\\F16F\";\n}\n.mdi-code-not-equal:before {\n  content: \"\\F170\";\n}\n.mdi-code-not-equal-variant:before {\n  content: \"\\F171\";\n}\n.mdi-code-parentheses:before {\n  content: \"\\F172\";\n}\n.mdi-code-string:before {\n  content: \"\\F173\";\n}\n.mdi-code-tags:before {\n  content: \"\\F174\";\n}\n.mdi-code-tags-check:before {\n  content: \"\\F693\";\n}\n.mdi-codepen:before {\n  content: \"\\F175\";\n}\n.mdi-coffee:before {\n  content: \"\\F176\";\n}\n.mdi-coffee-outline:before {\n  content: \"\\F6C9\";\n}\n.mdi-coffee-to-go:before {\n  content: \"\\F177\";\n}\n.mdi-coin:before {\n  content: \"\\F178\";\n}\n.mdi-coins:before {\n  content: \"\\F694\";\n}\n.mdi-collage:before {\n  content: \"\\F640\";\n}\n.mdi-color-helper:before {\n  content: \"\\F179\";\n}\n.mdi-comment:before {\n  content: \"\\F17A\";\n}\n.mdi-comment-account:before {\n  content: \"\\F17B\";\n}\n.mdi-comment-account-outline:before {\n  content: \"\\F17C\";\n}\n.mdi-comment-alert:before {\n  content: \"\\F17D\";\n}\n.mdi-comment-alert-outline:before {\n  content: \"\\F17E\";\n}\n.mdi-comment-check:before {\n  content: \"\\F17F\";\n}\n.mdi-comment-check-outline:before {\n  content: \"\\F180\";\n}\n.mdi-comment-multiple:before {\n  content: \"\\F85E\";\n}\n.mdi-comment-multiple-outline:before {\n  content: \"\\F181\";\n}\n.mdi-comment-outline:before {\n  content: \"\\F182\";\n}\n.mdi-comment-plus-outline:before {\n  content: \"\\F183\";\n}\n.mdi-comment-processing:before {\n  content: \"\\F184\";\n}\n.mdi-comment-processing-outline:before {\n  content: \"\\F185\";\n}\n.mdi-comment-question:before {\n  content: \"\\F816\";\n}\n.mdi-comment-question-outline:before {\n  content: \"\\F186\";\n}\n.mdi-comment-remove:before {\n  content: \"\\F5DE\";\n}\n.mdi-comment-remove-outline:before {\n  content: \"\\F187\";\n}\n.mdi-comment-text:before {\n  content: \"\\F188\";\n}\n.mdi-comment-text-multiple:before {\n  content: \"\\F85F\";\n}\n.mdi-comment-text-multiple-outline:before {\n  content: \"\\F860\";\n}\n.mdi-comment-text-outline:before {\n  content: \"\\F189\";\n}\n.mdi-compare:before {\n  content: \"\\F18A\";\n}\n.mdi-compass:before {\n  content: \"\\F18B\";\n}\n.mdi-compass-outline:before {\n  content: \"\\F18C\";\n}\n.mdi-console:before {\n  content: \"\\F18D\";\n}\n.mdi-console-line:before {\n  content: \"\\F7B6\";\n}\n.mdi-console-network:before {\n  content: \"\\F8A8\";\n}\n.mdi-contact-mail:before {\n  content: \"\\F18E\";\n}\n.mdi-contacts:before {\n  content: \"\\F6CA\";\n}\n.mdi-content-copy:before {\n  content: \"\\F18F\";\n}\n.mdi-content-cut:before {\n  content: \"\\F190\";\n}\n.mdi-content-duplicate:before {\n  content: \"\\F191\";\n}\n.mdi-content-paste:before {\n  content: \"\\F192\";\n}\n.mdi-content-save:before {\n  content: \"\\F193\";\n}\n.mdi-content-save-all:before {\n  content: \"\\F194\";\n}\n.mdi-content-save-outline:before {\n  content: \"\\F817\";\n}\n.mdi-content-save-settings:before {\n  content: \"\\F61B\";\n}\n.mdi-contrast:before {\n  content: \"\\F195\";\n}\n.mdi-contrast-box:before {\n  content: \"\\F196\";\n}\n.mdi-contrast-circle:before {\n  content: \"\\F197\";\n}\n.mdi-cookie:before {\n  content: \"\\F198\";\n}\n.mdi-copyright:before {\n  content: \"\\F5E6\";\n}\n.mdi-corn:before {\n  content: \"\\F7B7\";\n}\n.mdi-counter:before {\n  content: \"\\F199\";\n}\n.mdi-cow:before {\n  content: \"\\F19A\";\n}\n.mdi-crane:before {\n  content: \"\\F861\";\n}\n.mdi-creation:before {\n  content: \"\\F1C9\";\n}\n.mdi-credit-card:before {\n  content: \"\\F19B\";\n}\n.mdi-credit-card-multiple:before {\n  content: \"\\F19C\";\n}\n.mdi-credit-card-off:before {\n  content: \"\\F5E4\";\n}\n.mdi-credit-card-plus:before {\n  content: \"\\F675\";\n}\n.mdi-credit-card-scan:before {\n  content: \"\\F19D\";\n}\n.mdi-crop:before {\n  content: \"\\F19E\";\n}\n.mdi-crop-free:before {\n  content: \"\\F19F\";\n}\n.mdi-crop-landscape:before {\n  content: \"\\F1A0\";\n}\n.mdi-crop-portrait:before {\n  content: \"\\F1A1\";\n}\n.mdi-crop-rotate:before {\n  content: \"\\F695\";\n}\n.mdi-crop-square:before {\n  content: \"\\F1A2\";\n}\n.mdi-crosshairs:before {\n  content: \"\\F1A3\";\n}\n.mdi-crosshairs-gps:before {\n  content: \"\\F1A4\";\n}\n.mdi-crown:before {\n  content: \"\\F1A5\";\n}\n.mdi-cube:before {\n  content: \"\\F1A6\";\n}\n.mdi-cube-outline:before {\n  content: \"\\F1A7\";\n}\n.mdi-cube-send:before {\n  content: \"\\F1A8\";\n}\n.mdi-cube-unfolded:before {\n  content: \"\\F1A9\";\n}\n.mdi-cup:before {\n  content: \"\\F1AA\";\n}\n.mdi-cup-off:before {\n  content: \"\\F5E5\";\n}\n.mdi-cup-water:before {\n  content: \"\\F1AB\";\n}\n.mdi-curling:before {\n  content: \"\\F862\";\n}\n.mdi-currency-bdt:before {\n  content: \"\\F863\";\n}\n.mdi-currency-btc:before {\n  content: \"\\F1AC\";\n}\n.mdi-currency-chf:before {\n  content: \"\\F7B8\";\n}\n.mdi-currency-cny:before {\n  content: \"\\F7B9\";\n}\n.mdi-currency-eth:before {\n  content: \"\\F7BA\";\n}\n.mdi-currency-eur:before {\n  content: \"\\F1AD\";\n}\n.mdi-currency-gbp:before {\n  content: \"\\F1AE\";\n}\n.mdi-currency-inr:before {\n  content: \"\\F1AF\";\n}\n.mdi-currency-jpy:before {\n  content: \"\\F7BB\";\n}\n.mdi-currency-krw:before {\n  content: \"\\F7BC\";\n}\n.mdi-currency-kzt:before {\n  content: \"\\F864\";\n}\n.mdi-currency-ngn:before {\n  content: \"\\F1B0\";\n}\n.mdi-currency-rub:before {\n  content: \"\\F1B1\";\n}\n.mdi-currency-sign:before {\n  content: \"\\F7BD\";\n}\n.mdi-currency-try:before {\n  content: \"\\F1B2\";\n}\n.mdi-currency-twd:before {\n  content: \"\\F7BE\";\n}\n.mdi-currency-usd:before {\n  content: \"\\F1B3\";\n}\n.mdi-currency-usd-off:before {\n  content: \"\\F679\";\n}\n.mdi-cursor-default:before {\n  content: \"\\F1B4\";\n}\n.mdi-cursor-default-outline:before {\n  content: \"\\F1B5\";\n}\n.mdi-cursor-move:before {\n  content: \"\\F1B6\";\n}\n.mdi-cursor-pointer:before {\n  content: \"\\F1B7\";\n}\n.mdi-cursor-text:before {\n  content: \"\\F5E7\";\n}\n.mdi-database:before {\n  content: \"\\F1B8\";\n}\n.mdi-database-minus:before {\n  content: \"\\F1B9\";\n}\n.mdi-database-plus:before {\n  content: \"\\F1BA\";\n}\n.mdi-database-search:before {\n  content: \"\\F865\";\n}\n.mdi-debug-step-into:before {\n  content: \"\\F1BB\";\n}\n.mdi-debug-step-out:before {\n  content: \"\\F1BC\";\n}\n.mdi-debug-step-over:before {\n  content: \"\\F1BD\";\n}\n.mdi-decagram:before {\n  content: \"\\F76B\";\n}\n.mdi-decagram-outline:before {\n  content: \"\\F76C\";\n}\n.mdi-decimal-decrease:before {\n  content: \"\\F1BE\";\n}\n.mdi-decimal-increase:before {\n  content: \"\\F1BF\";\n}\n.mdi-delete:before {\n  content: \"\\F1C0\";\n}\n.mdi-delete-circle:before {\n  content: \"\\F682\";\n}\n.mdi-delete-empty:before {\n  content: \"\\F6CB\";\n}\n.mdi-delete-forever:before {\n  content: \"\\F5E8\";\n}\n.mdi-delete-restore:before {\n  content: \"\\F818\";\n}\n.mdi-delete-sweep:before {\n  content: \"\\F5E9\";\n}\n.mdi-delete-variant:before {\n  content: \"\\F1C1\";\n}\n.mdi-delta:before {\n  content: \"\\F1C2\";\n}\n.mdi-deskphone:before {\n  content: \"\\F1C3\";\n}\n.mdi-desktop-classic:before {\n  content: \"\\F7BF\";\n}\n.mdi-desktop-mac:before {\n  content: \"\\F1C4\";\n}\n.mdi-desktop-tower:before {\n  content: \"\\F1C5\";\n}\n.mdi-details:before {\n  content: \"\\F1C6\";\n}\n.mdi-developer-board:before {\n  content: \"\\F696\";\n}\n.mdi-deviantart:before {\n  content: \"\\F1C7\";\n}\n.mdi-dialpad:before {\n  content: \"\\F61C\";\n}\n.mdi-diamond:before {\n  content: \"\\F1C8\";\n}\n.mdi-dice-1:before {\n  content: \"\\F1CA\";\n}\n.mdi-dice-2:before {\n  content: \"\\F1CB\";\n}\n.mdi-dice-3:before {\n  content: \"\\F1CC\";\n}\n.mdi-dice-4:before {\n  content: \"\\F1CD\";\n}\n.mdi-dice-5:before {\n  content: \"\\F1CE\";\n}\n.mdi-dice-6:before {\n  content: \"\\F1CF\";\n}\n.mdi-dice-d10:before {\n  content: \"\\F76E\";\n}\n.mdi-dice-d12:before {\n  content: \"\\F866\";\n}\n.mdi-dice-d20:before {\n  content: \"\\F5EA\";\n}\n.mdi-dice-d4:before {\n  content: \"\\F5EB\";\n}\n.mdi-dice-d6:before {\n  content: \"\\F5EC\";\n}\n.mdi-dice-d8:before {\n  content: \"\\F5ED\";\n}\n.mdi-dice-multiple:before {\n  content: \"\\F76D\";\n}\n.mdi-dictionary:before {\n  content: \"\\F61D\";\n}\n.mdi-dip-switch:before {\n  content: \"\\F7C0\";\n}\n.mdi-directions:before {\n  content: \"\\F1D0\";\n}\n.mdi-directions-fork:before {\n  content: \"\\F641\";\n}\n.mdi-discord:before {\n  content: \"\\F66F\";\n}\n.mdi-disk:before {\n  content: \"\\F5EE\";\n}\n.mdi-disk-alert:before {\n  content: \"\\F1D1\";\n}\n.mdi-disqus:before {\n  content: \"\\F1D2\";\n}\n.mdi-disqus-outline:before {\n  content: \"\\F1D3\";\n}\n.mdi-division:before {\n  content: \"\\F1D4\";\n}\n.mdi-division-box:before {\n  content: \"\\F1D5\";\n}\n.mdi-dna:before {\n  content: \"\\F683\";\n}\n.mdi-dns:before {\n  content: \"\\F1D6\";\n}\n.mdi-do-not-disturb:before {\n  content: \"\\F697\";\n}\n.mdi-do-not-disturb-off:before {\n  content: \"\\F698\";\n}\n.mdi-docker:before {\n  content: \"\\F867\";\n}\n.mdi-dolby:before {\n  content: \"\\F6B2\";\n}\n.mdi-domain:before {\n  content: \"\\F1D7\";\n}\n.mdi-donkey:before {\n  content: \"\\F7C1\";\n}\n.mdi-door:before {\n  content: \"\\F819\";\n}\n.mdi-door-closed:before {\n  content: \"\\F81A\";\n}\n.mdi-door-open:before {\n  content: \"\\F81B\";\n}\n.mdi-doorbell-video:before {\n  content: \"\\F868\";\n}\n.mdi-dots-horizontal:before {\n  content: \"\\F1D8\";\n}\n.mdi-dots-horizontal-circle:before {\n  content: \"\\F7C2\";\n}\n.mdi-dots-vertical:before {\n  content: \"\\F1D9\";\n}\n.mdi-dots-vertical-circle:before {\n  content: \"\\F7C3\";\n}\n.mdi-douban:before {\n  content: \"\\F699\";\n}\n.mdi-download:before {\n  content: \"\\F1DA\";\n}\n.mdi-download-network:before {\n  content: \"\\F6F3\";\n}\n.mdi-drag:before {\n  content: \"\\F1DB\";\n}\n.mdi-drag-horizontal:before {\n  content: \"\\F1DC\";\n}\n.mdi-drag-vertical:before {\n  content: \"\\F1DD\";\n}\n.mdi-drawing:before {\n  content: \"\\F1DE\";\n}\n.mdi-drawing-box:before {\n  content: \"\\F1DF\";\n}\n.mdi-dribbble:before {\n  content: \"\\F1E0\";\n}\n.mdi-dribbble-box:before {\n  content: \"\\F1E1\";\n}\n.mdi-drone:before {\n  content: \"\\F1E2\";\n}\n.mdi-dropbox:before {\n  content: \"\\F1E3\";\n}\n.mdi-drupal:before {\n  content: \"\\F1E4\";\n}\n.mdi-duck:before {\n  content: \"\\F1E5\";\n}\n.mdi-dumbbell:before {\n  content: \"\\F1E6\";\n}\n.mdi-ear-hearing:before {\n  content: \"\\F7C4\";\n}\n.mdi-earth:before {\n  content: \"\\F1E7\";\n}\n.mdi-earth-box:before {\n  content: \"\\F6CC\";\n}\n.mdi-earth-box-off:before {\n  content: \"\\F6CD\";\n}\n.mdi-earth-off:before {\n  content: \"\\F1E8\";\n}\n.mdi-edge:before {\n  content: \"\\F1E9\";\n}\n.mdi-eject:before {\n  content: \"\\F1EA\";\n}\n.mdi-elephant:before {\n  content: \"\\F7C5\";\n}\n.mdi-elevation-decline:before {\n  content: \"\\F1EB\";\n}\n.mdi-elevation-rise:before {\n  content: \"\\F1EC\";\n}\n.mdi-elevator:before {\n  content: \"\\F1ED\";\n}\n.mdi-email:before {\n  content: \"\\F1EE\";\n}\n.mdi-email-alert:before {\n  content: \"\\F6CE\";\n}\n.mdi-email-open:before {\n  content: \"\\F1EF\";\n}\n.mdi-email-open-outline:before {\n  content: \"\\F5EF\";\n}\n.mdi-email-outline:before {\n  content: \"\\F1F0\";\n}\n.mdi-email-secure:before {\n  content: \"\\F1F1\";\n}\n.mdi-email-variant:before {\n  content: \"\\F5F0\";\n}\n.mdi-emby:before {\n  content: \"\\F6B3\";\n}\n.mdi-emoticon:before {\n  content: \"\\F1F2\";\n}\n.mdi-emoticon-cool:before {\n  content: \"\\F1F3\";\n}\n.mdi-emoticon-dead:before {\n  content: \"\\F69A\";\n}\n.mdi-emoticon-devil:before {\n  content: \"\\F1F4\";\n}\n.mdi-emoticon-excited:before {\n  content: \"\\F69B\";\n}\n.mdi-emoticon-happy:before {\n  content: \"\\F1F5\";\n}\n.mdi-emoticon-neutral:before {\n  content: \"\\F1F6\";\n}\n.mdi-emoticon-poop:before {\n  content: \"\\F1F7\";\n}\n.mdi-emoticon-sad:before {\n  content: \"\\F1F8\";\n}\n.mdi-emoticon-tongue:before {\n  content: \"\\F1F9\";\n}\n.mdi-engine:before {\n  content: \"\\F1FA\";\n}\n.mdi-engine-outline:before {\n  content: \"\\F1FB\";\n}\n.mdi-equal:before {\n  content: \"\\F1FC\";\n}\n.mdi-equal-box:before {\n  content: \"\\F1FD\";\n}\n.mdi-eraser:before {\n  content: \"\\F1FE\";\n}\n.mdi-eraser-variant:before {\n  content: \"\\F642\";\n}\n.mdi-escalator:before {\n  content: \"\\F1FF\";\n}\n.mdi-ethereum:before {\n  content: \"\\F869\";\n}\n.mdi-ethernet:before {\n  content: \"\\F200\";\n}\n.mdi-ethernet-cable:before {\n  content: \"\\F201\";\n}\n.mdi-ethernet-cable-off:before {\n  content: \"\\F202\";\n}\n.mdi-etsy:before {\n  content: \"\\F203\";\n}\n.mdi-ev-station:before {\n  content: \"\\F5F1\";\n}\n.mdi-eventbrite:before {\n  content: \"\\F7C6\";\n}\n.mdi-evernote:before {\n  content: \"\\F204\";\n}\n.mdi-exclamation:before {\n  content: \"\\F205\";\n}\n.mdi-exit-to-app:before {\n  content: \"\\F206\";\n}\n.mdi-export:before {\n  content: \"\\F207\";\n}\n.mdi-eye:before {\n  content: \"\\F208\";\n}\n.mdi-eye-off:before {\n  content: \"\\F209\";\n}\n.mdi-eye-off-outline:before {\n  content: \"\\F6D0\";\n}\n.mdi-eye-outline:before {\n  content: \"\\F6CF\";\n}\n.mdi-eye-plus:before {\n  content: \"\\F86A\";\n}\n.mdi-eye-plus-outline:before {\n  content: \"\\F86B\";\n}\n.mdi-eye-settings:before {\n  content: \"\\F86C\";\n}\n.mdi-eye-settings-outline:before {\n  content: \"\\F86D\";\n}\n.mdi-eyedropper:before {\n  content: \"\\F20A\";\n}\n.mdi-eyedropper-variant:before {\n  content: \"\\F20B\";\n}\n.mdi-face:before {\n  content: \"\\F643\";\n}\n.mdi-face-profile:before {\n  content: \"\\F644\";\n}\n.mdi-facebook:before {\n  content: \"\\F20C\";\n}\n.mdi-facebook-box:before {\n  content: \"\\F20D\";\n}\n.mdi-facebook-messenger:before {\n  content: \"\\F20E\";\n}\n.mdi-factory:before {\n  content: \"\\F20F\";\n}\n.mdi-fan:before {\n  content: \"\\F210\";\n}\n.mdi-fan-off:before {\n  content: \"\\F81C\";\n}\n.mdi-fast-forward:before {\n  content: \"\\F211\";\n}\n.mdi-fast-forward-outline:before {\n  content: \"\\F6D1\";\n}\n.mdi-fax:before {\n  content: \"\\F212\";\n}\n.mdi-feather:before {\n  content: \"\\F6D2\";\n}\n.mdi-ferry:before {\n  content: \"\\F213\";\n}\n.mdi-file:before {\n  content: \"\\F214\";\n}\n.mdi-file-account:before {\n  content: \"\\F73A\";\n}\n.mdi-file-chart:before {\n  content: \"\\F215\";\n}\n.mdi-file-check:before {\n  content: \"\\F216\";\n}\n.mdi-file-cloud:before {\n  content: \"\\F217\";\n}\n.mdi-file-compare:before {\n  content: \"\\F8A9\";\n}\n.mdi-file-delimited:before {\n  content: \"\\F218\";\n}\n.mdi-file-document:before {\n  content: \"\\F219\";\n}\n.mdi-file-document-box:before {\n  content: \"\\F21A\";\n}\n.mdi-file-excel:before {\n  content: \"\\F21B\";\n}\n.mdi-file-excel-box:before {\n  content: \"\\F21C\";\n}\n.mdi-file-export:before {\n  content: \"\\F21D\";\n}\n.mdi-file-find:before {\n  content: \"\\F21E\";\n}\n.mdi-file-hidden:before {\n  content: \"\\F613\";\n}\n.mdi-file-image:before {\n  content: \"\\F21F\";\n}\n.mdi-file-import:before {\n  content: \"\\F220\";\n}\n.mdi-file-lock:before {\n  content: \"\\F221\";\n}\n.mdi-file-multiple:before {\n  content: \"\\F222\";\n}\n.mdi-file-music:before {\n  content: \"\\F223\";\n}\n.mdi-file-outline:before {\n  content: \"\\F224\";\n}\n.mdi-file-pdf:before {\n  content: \"\\F225\";\n}\n.mdi-file-pdf-box:before {\n  content: \"\\F226\";\n}\n.mdi-file-percent:before {\n  content: \"\\F81D\";\n}\n.mdi-file-plus:before {\n  content: \"\\F751\";\n}\n.mdi-file-powerpoint:before {\n  content: \"\\F227\";\n}\n.mdi-file-powerpoint-box:before {\n  content: \"\\F228\";\n}\n.mdi-file-presentation-box:before {\n  content: \"\\F229\";\n}\n.mdi-file-question:before {\n  content: \"\\F86E\";\n}\n.mdi-file-restore:before {\n  content: \"\\F670\";\n}\n.mdi-file-send:before {\n  content: \"\\F22A\";\n}\n.mdi-file-tree:before {\n  content: \"\\F645\";\n}\n.mdi-file-video:before {\n  content: \"\\F22B\";\n}\n.mdi-file-word:before {\n  content: \"\\F22C\";\n}\n.mdi-file-word-box:before {\n  content: \"\\F22D\";\n}\n.mdi-file-xml:before {\n  content: \"\\F22E\";\n}\n.mdi-film:before {\n  content: \"\\F22F\";\n}\n.mdi-filmstrip:before {\n  content: \"\\F230\";\n}\n.mdi-filmstrip-off:before {\n  content: \"\\F231\";\n}\n.mdi-filter:before {\n  content: \"\\F232\";\n}\n.mdi-filter-outline:before {\n  content: \"\\F233\";\n}\n.mdi-filter-remove:before {\n  content: \"\\F234\";\n}\n.mdi-filter-remove-outline:before {\n  content: \"\\F235\";\n}\n.mdi-filter-variant:before {\n  content: \"\\F236\";\n}\n.mdi-finance:before {\n  content: \"\\F81E\";\n}\n.mdi-find-replace:before {\n  content: \"\\F6D3\";\n}\n.mdi-fingerprint:before {\n  content: \"\\F237\";\n}\n.mdi-fire:before {\n  content: \"\\F238\";\n}\n.mdi-fire-truck:before {\n  content: \"\\F8AA\";\n}\n.mdi-firefox:before {\n  content: \"\\F239\";\n}\n.mdi-fish:before {\n  content: \"\\F23A\";\n}\n.mdi-flag:before {\n  content: \"\\F23B\";\n}\n.mdi-flag-checkered:before {\n  content: \"\\F23C\";\n}\n.mdi-flag-outline:before {\n  content: \"\\F23D\";\n}\n.mdi-flag-triangle:before {\n  content: \"\\F23F\";\n}\n.mdi-flag-variant:before {\n  content: \"\\F240\";\n}\n.mdi-flag-variant-outline:before {\n  content: \"\\F23E\";\n}\n.mdi-flash:before {\n  content: \"\\F241\";\n}\n.mdi-flash-auto:before {\n  content: \"\\F242\";\n}\n.mdi-flash-circle:before {\n  content: \"\\F81F\";\n}\n.mdi-flash-off:before {\n  content: \"\\F243\";\n}\n.mdi-flash-outline:before {\n  content: \"\\F6D4\";\n}\n.mdi-flash-red-eye:before {\n  content: \"\\F67A\";\n}\n.mdi-flashlight:before {\n  content: \"\\F244\";\n}\n.mdi-flashlight-off:before {\n  content: \"\\F245\";\n}\n.mdi-flask:before {\n  content: \"\\F093\";\n}\n.mdi-flask-empty:before {\n  content: \"\\F094\";\n}\n.mdi-flask-empty-outline:before {\n  content: \"\\F095\";\n}\n.mdi-flask-outline:before {\n  content: \"\\F096\";\n}\n.mdi-flattr:before {\n  content: \"\\F246\";\n}\n.mdi-flip-to-back:before {\n  content: \"\\F247\";\n}\n.mdi-flip-to-front:before {\n  content: \"\\F248\";\n}\n.mdi-floor-plan:before {\n  content: \"\\F820\";\n}\n.mdi-floppy:before {\n  content: \"\\F249\";\n}\n.mdi-flower:before {\n  content: \"\\F24A\";\n}\n.mdi-folder:before {\n  content: \"\\F24B\";\n}\n.mdi-folder-account:before {\n  content: \"\\F24C\";\n}\n.mdi-folder-download:before {\n  content: \"\\F24D\";\n}\n.mdi-folder-google-drive:before {\n  content: \"\\F24E\";\n}\n.mdi-folder-image:before {\n  content: \"\\F24F\";\n}\n.mdi-folder-key:before {\n  content: \"\\F8AB\";\n}\n.mdi-folder-key-network:before {\n  content: \"\\F8AC\";\n}\n.mdi-folder-lock:before {\n  content: \"\\F250\";\n}\n.mdi-folder-lock-open:before {\n  content: \"\\F251\";\n}\n.mdi-folder-move:before {\n  content: \"\\F252\";\n}\n.mdi-folder-multiple:before {\n  content: \"\\F253\";\n}\n.mdi-folder-multiple-image:before {\n  content: \"\\F254\";\n}\n.mdi-folder-multiple-outline:before {\n  content: \"\\F255\";\n}\n.mdi-folder-network:before {\n  content: \"\\F86F\";\n}\n.mdi-folder-open:before {\n  content: \"\\F76F\";\n}\n.mdi-folder-outline:before {\n  content: \"\\F256\";\n}\n.mdi-folder-plus:before {\n  content: \"\\F257\";\n}\n.mdi-folder-remove:before {\n  content: \"\\F258\";\n}\n.mdi-folder-star:before {\n  content: \"\\F69C\";\n}\n.mdi-folder-upload:before {\n  content: \"\\F259\";\n}\n.mdi-font-awesome:before {\n  content: \"\\F03A\";\n}\n.mdi-food:before {\n  content: \"\\F25A\";\n}\n.mdi-food-apple:before {\n  content: \"\\F25B\";\n}\n.mdi-food-croissant:before {\n  content: \"\\F7C7\";\n}\n.mdi-food-fork-drink:before {\n  content: \"\\F5F2\";\n}\n.mdi-food-off:before {\n  content: \"\\F5F3\";\n}\n.mdi-food-variant:before {\n  content: \"\\F25C\";\n}\n.mdi-football:before {\n  content: \"\\F25D\";\n}\n.mdi-football-australian:before {\n  content: \"\\F25E\";\n}\n.mdi-football-helmet:before {\n  content: \"\\F25F\";\n}\n.mdi-forklift:before {\n  content: \"\\F7C8\";\n}\n.mdi-format-align-bottom:before {\n  content: \"\\F752\";\n}\n.mdi-format-align-center:before {\n  content: \"\\F260\";\n}\n.mdi-format-align-justify:before {\n  content: \"\\F261\";\n}\n.mdi-format-align-left:before {\n  content: \"\\F262\";\n}\n.mdi-format-align-middle:before {\n  content: \"\\F753\";\n}\n.mdi-format-align-right:before {\n  content: \"\\F263\";\n}\n.mdi-format-align-top:before {\n  content: \"\\F754\";\n}\n.mdi-format-annotation-plus:before {\n  content: \"\\F646\";\n}\n.mdi-format-bold:before {\n  content: \"\\F264\";\n}\n.mdi-format-clear:before {\n  content: \"\\F265\";\n}\n.mdi-format-color-fill:before {\n  content: \"\\F266\";\n}\n.mdi-format-color-text:before {\n  content: \"\\F69D\";\n}\n.mdi-format-float-center:before {\n  content: \"\\F267\";\n}\n.mdi-format-float-left:before {\n  content: \"\\F268\";\n}\n.mdi-format-float-none:before {\n  content: \"\\F269\";\n}\n.mdi-format-float-right:before {\n  content: \"\\F26A\";\n}\n.mdi-format-font:before {\n  content: \"\\F6D5\";\n}\n.mdi-format-header-1:before {\n  content: \"\\F26B\";\n}\n.mdi-format-header-2:before {\n  content: \"\\F26C\";\n}\n.mdi-format-header-3:before {\n  content: \"\\F26D\";\n}\n.mdi-format-header-4:before {\n  content: \"\\F26E\";\n}\n.mdi-format-header-5:before {\n  content: \"\\F26F\";\n}\n.mdi-format-header-6:before {\n  content: \"\\F270\";\n}\n.mdi-format-header-decrease:before {\n  content: \"\\F271\";\n}\n.mdi-format-header-equal:before {\n  content: \"\\F272\";\n}\n.mdi-format-header-increase:before {\n  content: \"\\F273\";\n}\n.mdi-format-header-pound:before {\n  content: \"\\F274\";\n}\n.mdi-format-horizontal-align-center:before {\n  content: \"\\F61E\";\n}\n.mdi-format-horizontal-align-left:before {\n  content: \"\\F61F\";\n}\n.mdi-format-horizontal-align-right:before {\n  content: \"\\F620\";\n}\n.mdi-format-indent-decrease:before {\n  content: \"\\F275\";\n}\n.mdi-format-indent-increase:before {\n  content: \"\\F276\";\n}\n.mdi-format-italic:before {\n  content: \"\\F277\";\n}\n.mdi-format-line-spacing:before {\n  content: \"\\F278\";\n}\n.mdi-format-line-style:before {\n  content: \"\\F5C8\";\n}\n.mdi-format-line-weight:before {\n  content: \"\\F5C9\";\n}\n.mdi-format-list-bulleted:before {\n  content: \"\\F279\";\n}\n.mdi-format-list-bulleted-type:before {\n  content: \"\\F27A\";\n}\n.mdi-format-list-checks:before {\n  content: \"\\F755\";\n}\n.mdi-format-list-numbers:before {\n  content: \"\\F27B\";\n}\n.mdi-format-page-break:before {\n  content: \"\\F6D6\";\n}\n.mdi-format-paint:before {\n  content: \"\\F27C\";\n}\n.mdi-format-paragraph:before {\n  content: \"\\F27D\";\n}\n.mdi-format-pilcrow:before {\n  content: \"\\F6D7\";\n}\n.mdi-format-quote-close:before {\n  content: \"\\F27E\";\n}\n.mdi-format-quote-open:before {\n  content: \"\\F756\";\n}\n.mdi-format-rotate-90:before {\n  content: \"\\F6A9\";\n}\n.mdi-format-section:before {\n  content: \"\\F69E\";\n}\n.mdi-format-size:before {\n  content: \"\\F27F\";\n}\n.mdi-format-strikethrough:before {\n  content: \"\\F280\";\n}\n.mdi-format-strikethrough-variant:before {\n  content: \"\\F281\";\n}\n.mdi-format-subscript:before {\n  content: \"\\F282\";\n}\n.mdi-format-superscript:before {\n  content: \"\\F283\";\n}\n.mdi-format-text:before {\n  content: \"\\F284\";\n}\n.mdi-format-textdirection-l-to-r:before {\n  content: \"\\F285\";\n}\n.mdi-format-textdirection-r-to-l:before {\n  content: \"\\F286\";\n}\n.mdi-format-title:before {\n  content: \"\\F5F4\";\n}\n.mdi-format-underline:before {\n  content: \"\\F287\";\n}\n.mdi-format-vertical-align-bottom:before {\n  content: \"\\F621\";\n}\n.mdi-format-vertical-align-center:before {\n  content: \"\\F622\";\n}\n.mdi-format-vertical-align-top:before {\n  content: \"\\F623\";\n}\n.mdi-format-wrap-inline:before {\n  content: \"\\F288\";\n}\n.mdi-format-wrap-square:before {\n  content: \"\\F289\";\n}\n.mdi-format-wrap-tight:before {\n  content: \"\\F28A\";\n}\n.mdi-format-wrap-top-bottom:before {\n  content: \"\\F28B\";\n}\n.mdi-forum:before {\n  content: \"\\F28C\";\n}\n.mdi-forum-outline:before {\n  content: \"\\F821\";\n}\n.mdi-forward:before {\n  content: \"\\F28D\";\n}\n.mdi-foursquare:before {\n  content: \"\\F28E\";\n}\n.mdi-fridge:before {\n  content: \"\\F28F\";\n}\n.mdi-fridge-filled:before {\n  content: \"\\F290\";\n}\n.mdi-fridge-filled-bottom:before {\n  content: \"\\F291\";\n}\n.mdi-fridge-filled-top:before {\n  content: \"\\F292\";\n}\n.mdi-fuel:before {\n  content: \"\\F7C9\";\n}\n.mdi-fullscreen:before {\n  content: \"\\F293\";\n}\n.mdi-fullscreen-exit:before {\n  content: \"\\F294\";\n}\n.mdi-function:before {\n  content: \"\\F295\";\n}\n.mdi-function-variant:before {\n  content: \"\\F870\";\n}\n.mdi-gamepad:before {\n  content: \"\\F296\";\n}\n.mdi-gamepad-variant:before {\n  content: \"\\F297\";\n}\n.mdi-garage:before {\n  content: \"\\F6D8\";\n}\n.mdi-garage-alert:before {\n  content: \"\\F871\";\n}\n.mdi-garage-open:before {\n  content: \"\\F6D9\";\n}\n.mdi-gas-cylinder:before {\n  content: \"\\F647\";\n}\n.mdi-gas-station:before {\n  content: \"\\F298\";\n}\n.mdi-gate:before {\n  content: \"\\F299\";\n}\n.mdi-gauge:before {\n  content: \"\\F29A\";\n}\n.mdi-gauge-empty:before {\n  content: \"\\F872\";\n}\n.mdi-gauge-full:before {\n  content: \"\\F873\";\n}\n.mdi-gauge-low:before {\n  content: \"\\F874\";\n}\n.mdi-gavel:before {\n  content: \"\\F29B\";\n}\n.mdi-gender-female:before {\n  content: \"\\F29C\";\n}\n.mdi-gender-male:before {\n  content: \"\\F29D\";\n}\n.mdi-gender-male-female:before {\n  content: \"\\F29E\";\n}\n.mdi-gender-transgender:before {\n  content: \"\\F29F\";\n}\n.mdi-gesture:before {\n  content: \"\\F7CA\";\n}\n.mdi-gesture-double-tap:before {\n  content: \"\\F73B\";\n}\n.mdi-gesture-swipe-down:before {\n  content: \"\\F73C\";\n}\n.mdi-gesture-swipe-left:before {\n  content: \"\\F73D\";\n}\n.mdi-gesture-swipe-right:before {\n  content: \"\\F73E\";\n}\n.mdi-gesture-swipe-up:before {\n  content: \"\\F73F\";\n}\n.mdi-gesture-tap:before {\n  content: \"\\F740\";\n}\n.mdi-gesture-two-double-tap:before {\n  content: \"\\F741\";\n}\n.mdi-gesture-two-tap:before {\n  content: \"\\F742\";\n}\n.mdi-ghost:before {\n  content: \"\\F2A0\";\n}\n.mdi-gift:before {\n  content: \"\\F2A1\";\n}\n.mdi-git:before {\n  content: \"\\F2A2\";\n}\n.mdi-github-box:before {\n  content: \"\\F2A3\";\n}\n.mdi-github-circle:before {\n  content: \"\\F2A4\";\n}\n.mdi-github-face:before {\n  content: \"\\F6DA\";\n}\n.mdi-glass-cocktail:before {\n  content: \"\\F356\";\n}\n.mdi-glass-flute:before {\n  content: \"\\F2A5\";\n}\n.mdi-glass-mug:before {\n  content: \"\\F2A6\";\n}\n.mdi-glass-stange:before {\n  content: \"\\F2A7\";\n}\n.mdi-glass-tulip:before {\n  content: \"\\F2A8\";\n}\n.mdi-glass-wine:before {\n  content: \"\\F875\";\n}\n.mdi-glassdoor:before {\n  content: \"\\F2A9\";\n}\n.mdi-glasses:before {\n  content: \"\\F2AA\";\n}\n.mdi-gmail:before {\n  content: \"\\F2AB\";\n}\n.mdi-gnome:before {\n  content: \"\\F2AC\";\n}\n.mdi-golf:before {\n  content: \"\\F822\";\n}\n.mdi-gondola:before {\n  content: \"\\F685\";\n}\n.mdi-google:before {\n  content: \"\\F2AD\";\n}\n.mdi-google-analytics:before {\n  content: \"\\F7CB\";\n}\n.mdi-google-assistant:before {\n  content: \"\\F7CC\";\n}\n.mdi-google-cardboard:before {\n  content: \"\\F2AE\";\n}\n.mdi-google-chrome:before {\n  content: \"\\F2AF\";\n}\n.mdi-google-circles:before {\n  content: \"\\F2B0\";\n}\n.mdi-google-circles-communities:before {\n  content: \"\\F2B1\";\n}\n.mdi-google-circles-extended:before {\n  content: \"\\F2B2\";\n}\n.mdi-google-circles-group:before {\n  content: \"\\F2B3\";\n}\n.mdi-google-controller:before {\n  content: \"\\F2B4\";\n}\n.mdi-google-controller-off:before {\n  content: \"\\F2B5\";\n}\n.mdi-google-drive:before {\n  content: \"\\F2B6\";\n}\n.mdi-google-earth:before {\n  content: \"\\F2B7\";\n}\n.mdi-google-glass:before {\n  content: \"\\F2B8\";\n}\n.mdi-google-home:before {\n  content: \"\\F823\";\n}\n.mdi-google-keep:before {\n  content: \"\\F6DB\";\n}\n.mdi-google-maps:before {\n  content: \"\\F5F5\";\n}\n.mdi-google-nearby:before {\n  content: \"\\F2B9\";\n}\n.mdi-google-pages:before {\n  content: \"\\F2BA\";\n}\n.mdi-google-photos:before {\n  content: \"\\F6DC\";\n}\n.mdi-google-physical-web:before {\n  content: \"\\F2BB\";\n}\n.mdi-google-play:before {\n  content: \"\\F2BC\";\n}\n.mdi-google-plus:before {\n  content: \"\\F2BD\";\n}\n.mdi-google-plus-box:before {\n  content: \"\\F2BE\";\n}\n.mdi-google-translate:before {\n  content: \"\\F2BF\";\n}\n.mdi-google-wallet:before {\n  content: \"\\F2C0\";\n}\n.mdi-gpu:before {\n  content: \"\\F8AD\";\n}\n.mdi-gradient:before {\n  content: \"\\F69F\";\n}\n.mdi-graphql:before {\n  content: \"\\F876\";\n}\n.mdi-grease-pencil:before {\n  content: \"\\F648\";\n}\n.mdi-grid:before {\n  content: \"\\F2C1\";\n}\n.mdi-grid-large:before {\n  content: \"\\F757\";\n}\n.mdi-grid-off:before {\n  content: \"\\F2C2\";\n}\n.mdi-group:before {\n  content: \"\\F2C3\";\n}\n.mdi-guitar-acoustic:before {\n  content: \"\\F770\";\n}\n.mdi-guitar-electric:before {\n  content: \"\\F2C4\";\n}\n.mdi-guitar-pick:before {\n  content: \"\\F2C5\";\n}\n.mdi-guitar-pick-outline:before {\n  content: \"\\F2C6\";\n}\n.mdi-guy-fawkes-mask:before {\n  content: \"\\F824\";\n}\n.mdi-hackernews:before {\n  content: \"\\F624\";\n}\n.mdi-hamburger:before {\n  content: \"\\F684\";\n}\n.mdi-hand-pointing-right:before {\n  content: \"\\F2C7\";\n}\n.mdi-hanger:before {\n  content: \"\\F2C8\";\n}\n.mdi-hangouts:before {\n  content: \"\\F2C9\";\n}\n.mdi-harddisk:before {\n  content: \"\\F2CA\";\n}\n.mdi-headphones:before {\n  content: \"\\F2CB\";\n}\n.mdi-headphones-box:before {\n  content: \"\\F2CC\";\n}\n.mdi-headphones-off:before {\n  content: \"\\F7CD\";\n}\n.mdi-headphones-settings:before {\n  content: \"\\F2CD\";\n}\n.mdi-headset:before {\n  content: \"\\F2CE\";\n}\n.mdi-headset-dock:before {\n  content: \"\\F2CF\";\n}\n.mdi-headset-off:before {\n  content: \"\\F2D0\";\n}\n.mdi-heart:before {\n  content: \"\\F2D1\";\n}\n.mdi-heart-box:before {\n  content: \"\\F2D2\";\n}\n.mdi-heart-box-outline:before {\n  content: \"\\F2D3\";\n}\n.mdi-heart-broken:before {\n  content: \"\\F2D4\";\n}\n.mdi-heart-half:before {\n  content: \"\\F6DE\";\n}\n.mdi-heart-half-full:before {\n  content: \"\\F6DD\";\n}\n.mdi-heart-half-outline:before {\n  content: \"\\F6DF\";\n}\n.mdi-heart-off:before {\n  content: \"\\F758\";\n}\n.mdi-heart-outline:before {\n  content: \"\\F2D5\";\n}\n.mdi-heart-pulse:before {\n  content: \"\\F5F6\";\n}\n.mdi-help:before {\n  content: \"\\F2D6\";\n}\n.mdi-help-box:before {\n  content: \"\\F78A\";\n}\n.mdi-help-circle:before {\n  content: \"\\F2D7\";\n}\n.mdi-help-circle-outline:before {\n  content: \"\\F625\";\n}\n.mdi-help-network:before {\n  content: \"\\F6F4\";\n}\n.mdi-hexagon:before {\n  content: \"\\F2D8\";\n}\n.mdi-hexagon-multiple:before {\n  content: \"\\F6E0\";\n}\n.mdi-hexagon-outline:before {\n  content: \"\\F2D9\";\n}\n.mdi-high-definition:before {\n  content: \"\\F7CE\";\n}\n.mdi-high-definition-box:before {\n  content: \"\\F877\";\n}\n.mdi-highway:before {\n  content: \"\\F5F7\";\n}\n.mdi-history:before {\n  content: \"\\F2DA\";\n}\n.mdi-hockey-puck:before {\n  content: \"\\F878\";\n}\n.mdi-hockey-sticks:before {\n  content: \"\\F879\";\n}\n.mdi-hololens:before {\n  content: \"\\F2DB\";\n}\n.mdi-home:before {\n  content: \"\\F2DC\";\n}\n.mdi-home-account:before {\n  content: \"\\F825\";\n}\n.mdi-home-alert:before {\n  content: \"\\F87A\";\n}\n.mdi-home-assistant:before {\n  content: \"\\F7CF\";\n}\n.mdi-home-automation:before {\n  content: \"\\F7D0\";\n}\n.mdi-home-circle:before {\n  content: \"\\F7D1\";\n}\n.mdi-home-currency-usd:before {\n  content: \"\\F8AE\";\n}\n.mdi-home-heart:before {\n  content: \"\\F826\";\n}\n.mdi-home-map-marker:before {\n  content: \"\\F5F8\";\n}\n.mdi-home-modern:before {\n  content: \"\\F2DD\";\n}\n.mdi-home-outline:before {\n  content: \"\\F6A0\";\n}\n.mdi-home-variant:before {\n  content: \"\\F2DE\";\n}\n.mdi-hook:before {\n  content: \"\\F6E1\";\n}\n.mdi-hook-off:before {\n  content: \"\\F6E2\";\n}\n.mdi-hops:before {\n  content: \"\\F2DF\";\n}\n.mdi-hospital:before {\n  content: \"\\F2E0\";\n}\n.mdi-hospital-building:before {\n  content: \"\\F2E1\";\n}\n.mdi-hospital-marker:before {\n  content: \"\\F2E2\";\n}\n.mdi-hot-tub:before {\n  content: \"\\F827\";\n}\n.mdi-hotel:before {\n  content: \"\\F2E3\";\n}\n.mdi-houzz:before {\n  content: \"\\F2E4\";\n}\n.mdi-houzz-box:before {\n  content: \"\\F2E5\";\n}\n.mdi-hulu:before {\n  content: \"\\F828\";\n}\n.mdi-human:before {\n  content: \"\\F2E6\";\n}\n.mdi-human-child:before {\n  content: \"\\F2E7\";\n}\n.mdi-human-female:before {\n  content: \"\\F649\";\n}\n.mdi-human-greeting:before {\n  content: \"\\F64A\";\n}\n.mdi-human-handsdown:before {\n  content: \"\\F64B\";\n}\n.mdi-human-handsup:before {\n  content: \"\\F64C\";\n}\n.mdi-human-male:before {\n  content: \"\\F64D\";\n}\n.mdi-human-male-female:before {\n  content: \"\\F2E8\";\n}\n.mdi-human-pregnant:before {\n  content: \"\\F5CF\";\n}\n.mdi-humble-bundle:before {\n  content: \"\\F743\";\n}\n.mdi-ice-cream:before {\n  content: \"\\F829\";\n}\n.mdi-image:before {\n  content: \"\\F2E9\";\n}\n.mdi-image-album:before {\n  content: \"\\F2EA\";\n}\n.mdi-image-area:before {\n  content: \"\\F2EB\";\n}\n.mdi-image-area-close:before {\n  content: \"\\F2EC\";\n}\n.mdi-image-broken:before {\n  content: \"\\F2ED\";\n}\n.mdi-image-broken-variant:before {\n  content: \"\\F2EE\";\n}\n.mdi-image-filter:before {\n  content: \"\\F2EF\";\n}\n.mdi-image-filter-black-white:before {\n  content: \"\\F2F0\";\n}\n.mdi-image-filter-center-focus:before {\n  content: \"\\F2F1\";\n}\n.mdi-image-filter-center-focus-weak:before {\n  content: \"\\F2F2\";\n}\n.mdi-image-filter-drama:before {\n  content: \"\\F2F3\";\n}\n.mdi-image-filter-frames:before {\n  content: \"\\F2F4\";\n}\n.mdi-image-filter-hdr:before {\n  content: \"\\F2F5\";\n}\n.mdi-image-filter-none:before {\n  content: \"\\F2F6\";\n}\n.mdi-image-filter-tilt-shift:before {\n  content: \"\\F2F7\";\n}\n.mdi-image-filter-vintage:before {\n  content: \"\\F2F8\";\n}\n.mdi-image-multiple:before {\n  content: \"\\F2F9\";\n}\n.mdi-image-off:before {\n  content: \"\\F82A\";\n}\n.mdi-image-plus:before {\n  content: \"\\F87B\";\n}\n.mdi-import:before {\n  content: \"\\F2FA\";\n}\n.mdi-inbox:before {\n  content: \"\\F686\";\n}\n.mdi-inbox-arrow-down:before {\n  content: \"\\F2FB\";\n}\n.mdi-inbox-arrow-up:before {\n  content: \"\\F3D1\";\n}\n.mdi-inbox-multiple:before {\n  content: \"\\F8AF\";\n}\n.mdi-incognito:before {\n  content: \"\\F5F9\";\n}\n.mdi-infinity:before {\n  content: \"\\F6E3\";\n}\n.mdi-information:before {\n  content: \"\\F2FC\";\n}\n.mdi-information-outline:before {\n  content: \"\\F2FD\";\n}\n.mdi-information-variant:before {\n  content: \"\\F64E\";\n}\n.mdi-instagram:before {\n  content: \"\\F2FE\";\n}\n.mdi-instapaper:before {\n  content: \"\\F2FF\";\n}\n.mdi-internet-explorer:before {\n  content: \"\\F300\";\n}\n.mdi-invert-colors:before {\n  content: \"\\F301\";\n}\n.mdi-itunes:before {\n  content: \"\\F676\";\n}\n.mdi-jeepney:before {\n  content: \"\\F302\";\n}\n.mdi-jira:before {\n  content: \"\\F303\";\n}\n.mdi-jquery:before {\n  content: \"\\F87C\";\n}\n.mdi-jsfiddle:before {\n  content: \"\\F304\";\n}\n.mdi-json:before {\n  content: \"\\F626\";\n}\n.mdi-karate:before {\n  content: \"\\F82B\";\n}\n.mdi-keg:before {\n  content: \"\\F305\";\n}\n.mdi-kettle:before {\n  content: \"\\F5FA\";\n}\n.mdi-key:before {\n  content: \"\\F306\";\n}\n.mdi-key-change:before {\n  content: \"\\F307\";\n}\n.mdi-key-minus:before {\n  content: \"\\F308\";\n}\n.mdi-key-plus:before {\n  content: \"\\F309\";\n}\n.mdi-key-remove:before {\n  content: \"\\F30A\";\n}\n.mdi-key-variant:before {\n  content: \"\\F30B\";\n}\n.mdi-keyboard:before {\n  content: \"\\F30C\";\n}\n.mdi-keyboard-backspace:before {\n  content: \"\\F30D\";\n}\n.mdi-keyboard-caps:before {\n  content: \"\\F30E\";\n}\n.mdi-keyboard-close:before {\n  content: \"\\F30F\";\n}\n.mdi-keyboard-off:before {\n  content: \"\\F310\";\n}\n.mdi-keyboard-return:before {\n  content: \"\\F311\";\n}\n.mdi-keyboard-tab:before {\n  content: \"\\F312\";\n}\n.mdi-keyboard-variant:before {\n  content: \"\\F313\";\n}\n.mdi-kickstarter:before {\n  content: \"\\F744\";\n}\n.mdi-kodi:before {\n  content: \"\\F314\";\n}\n.mdi-label:before {\n  content: \"\\F315\";\n}\n.mdi-label-outline:before {\n  content: \"\\F316\";\n}\n.mdi-ladybug:before {\n  content: \"\\F82C\";\n}\n.mdi-lambda:before {\n  content: \"\\F627\";\n}\n.mdi-lamp:before {\n  content: \"\\F6B4\";\n}\n.mdi-lan:before {\n  content: \"\\F317\";\n}\n.mdi-lan-connect:before {\n  content: \"\\F318\";\n}\n.mdi-lan-disconnect:before {\n  content: \"\\F319\";\n}\n.mdi-lan-pending:before {\n  content: \"\\F31A\";\n}\n.mdi-language-c:before {\n  content: \"\\F671\";\n}\n.mdi-language-cpp:before {\n  content: \"\\F672\";\n}\n.mdi-language-csharp:before {\n  content: \"\\F31B\";\n}\n.mdi-language-css3:before {\n  content: \"\\F31C\";\n}\n.mdi-language-go:before {\n  content: \"\\F7D2\";\n}\n.mdi-language-html5:before {\n  content: \"\\F31D\";\n}\n.mdi-language-javascript:before {\n  content: \"\\F31E\";\n}\n.mdi-language-lua:before {\n  content: \"\\F8B0\";\n}\n.mdi-language-php:before {\n  content: \"\\F31F\";\n}\n.mdi-language-python:before {\n  content: \"\\F320\";\n}\n.mdi-language-python-text:before {\n  content: \"\\F321\";\n}\n.mdi-language-r:before {\n  content: \"\\F7D3\";\n}\n.mdi-language-swift:before {\n  content: \"\\F6E4\";\n}\n.mdi-language-typescript:before {\n  content: \"\\F6E5\";\n}\n.mdi-laptop:before {\n  content: \"\\F322\";\n}\n.mdi-laptop-chromebook:before {\n  content: \"\\F323\";\n}\n.mdi-laptop-mac:before {\n  content: \"\\F324\";\n}\n.mdi-laptop-off:before {\n  content: \"\\F6E6\";\n}\n.mdi-laptop-windows:before {\n  content: \"\\F325\";\n}\n.mdi-lastfm:before {\n  content: \"\\F326\";\n}\n.mdi-lastpass:before {\n  content: \"\\F446\";\n}\n.mdi-launch:before {\n  content: \"\\F327\";\n}\n.mdi-lava-lamp:before {\n  content: \"\\F7D4\";\n}\n.mdi-layers:before {\n  content: \"\\F328\";\n}\n.mdi-layers-off:before {\n  content: \"\\F329\";\n}\n.mdi-lead-pencil:before {\n  content: \"\\F64F\";\n}\n.mdi-leaf:before {\n  content: \"\\F32A\";\n}\n.mdi-led-off:before {\n  content: \"\\F32B\";\n}\n.mdi-led-on:before {\n  content: \"\\F32C\";\n}\n.mdi-led-outline:before {\n  content: \"\\F32D\";\n}\n.mdi-led-strip:before {\n  content: \"\\F7D5\";\n}\n.mdi-led-variant-off:before {\n  content: \"\\F32E\";\n}\n.mdi-led-variant-on:before {\n  content: \"\\F32F\";\n}\n.mdi-led-variant-outline:before {\n  content: \"\\F330\";\n}\n.mdi-library:before {\n  content: \"\\F331\";\n}\n.mdi-library-books:before {\n  content: \"\\F332\";\n}\n.mdi-library-music:before {\n  content: \"\\F333\";\n}\n.mdi-library-plus:before {\n  content: \"\\F334\";\n}\n.mdi-lifebuoy:before {\n  content: \"\\F87D\";\n}\n.mdi-lightbulb:before {\n  content: \"\\F335\";\n}\n.mdi-lightbulb-on:before {\n  content: \"\\F6E7\";\n}\n.mdi-lightbulb-on-outline:before {\n  content: \"\\F6E8\";\n}\n.mdi-lightbulb-outline:before {\n  content: \"\\F336\";\n}\n.mdi-link:before {\n  content: \"\\F337\";\n}\n.mdi-link-off:before {\n  content: \"\\F338\";\n}\n.mdi-link-variant:before {\n  content: \"\\F339\";\n}\n.mdi-link-variant-off:before {\n  content: \"\\F33A\";\n}\n.mdi-linkedin:before {\n  content: \"\\F33B\";\n}\n.mdi-linkedin-box:before {\n  content: \"\\F33C\";\n}\n.mdi-linux:before {\n  content: \"\\F33D\";\n}\n.mdi-loading:before {\n  content: \"\\F771\";\n}\n.mdi-lock:before {\n  content: \"\\F33E\";\n}\n.mdi-lock-open:before {\n  content: \"\\F33F\";\n}\n.mdi-lock-open-outline:before {\n  content: \"\\F340\";\n}\n.mdi-lock-outline:before {\n  content: \"\\F341\";\n}\n.mdi-lock-pattern:before {\n  content: \"\\F6E9\";\n}\n.mdi-lock-plus:before {\n  content: \"\\F5FB\";\n}\n.mdi-lock-reset:before {\n  content: \"\\F772\";\n}\n.mdi-lock-smart:before {\n  content: \"\\F8B1\";\n}\n.mdi-locker:before {\n  content: \"\\F7D6\";\n}\n.mdi-locker-multiple:before {\n  content: \"\\F7D7\";\n}\n.mdi-login:before {\n  content: \"\\F342\";\n}\n.mdi-login-variant:before {\n  content: \"\\F5FC\";\n}\n.mdi-logout:before {\n  content: \"\\F343\";\n}\n.mdi-logout-variant:before {\n  content: \"\\F5FD\";\n}\n.mdi-looks:before {\n  content: \"\\F344\";\n}\n.mdi-loop:before {\n  content: \"\\F6EA\";\n}\n.mdi-loupe:before {\n  content: \"\\F345\";\n}\n.mdi-lumx:before {\n  content: \"\\F346\";\n}\n.mdi-magnet:before {\n  content: \"\\F347\";\n}\n.mdi-magnet-on:before {\n  content: \"\\F348\";\n}\n.mdi-magnify:before {\n  content: \"\\F349\";\n}\n.mdi-magnify-minus:before {\n  content: \"\\F34A\";\n}\n.mdi-magnify-minus-outline:before {\n  content: \"\\F6EB\";\n}\n.mdi-magnify-plus:before {\n  content: \"\\F34B\";\n}\n.mdi-magnify-plus-outline:before {\n  content: \"\\F6EC\";\n}\n.mdi-mail-ru:before {\n  content: \"\\F34C\";\n}\n.mdi-mailbox:before {\n  content: \"\\F6ED\";\n}\n.mdi-map:before {\n  content: \"\\F34D\";\n}\n.mdi-map-marker:before {\n  content: \"\\F34E\";\n}\n.mdi-map-marker-circle:before {\n  content: \"\\F34F\";\n}\n.mdi-map-marker-minus:before {\n  content: \"\\F650\";\n}\n.mdi-map-marker-multiple:before {\n  content: \"\\F350\";\n}\n.mdi-map-marker-off:before {\n  content: \"\\F351\";\n}\n.mdi-map-marker-outline:before {\n  content: \"\\F7D8\";\n}\n.mdi-map-marker-plus:before {\n  content: \"\\F651\";\n}\n.mdi-map-marker-radius:before {\n  content: \"\\F352\";\n}\n.mdi-margin:before {\n  content: \"\\F353\";\n}\n.mdi-markdown:before {\n  content: \"\\F354\";\n}\n.mdi-marker:before {\n  content: \"\\F652\";\n}\n.mdi-marker-check:before {\n  content: \"\\F355\";\n}\n.mdi-material-ui:before {\n  content: \"\\F357\";\n}\n.mdi-math-compass:before {\n  content: \"\\F358\";\n}\n.mdi-matrix:before {\n  content: \"\\F628\";\n}\n.mdi-maxcdn:before {\n  content: \"\\F359\";\n}\n.mdi-medical-bag:before {\n  content: \"\\F6EE\";\n}\n.mdi-medium:before {\n  content: \"\\F35A\";\n}\n.mdi-memory:before {\n  content: \"\\F35B\";\n}\n.mdi-menu:before {\n  content: \"\\F35C\";\n}\n.mdi-menu-down:before {\n  content: \"\\F35D\";\n}\n.mdi-menu-down-outline:before {\n  content: \"\\F6B5\";\n}\n.mdi-menu-left:before {\n  content: \"\\F35E\";\n}\n.mdi-menu-right:before {\n  content: \"\\F35F\";\n}\n.mdi-menu-up:before {\n  content: \"\\F360\";\n}\n.mdi-menu-up-outline:before {\n  content: \"\\F6B6\";\n}\n.mdi-message:before {\n  content: \"\\F361\";\n}\n.mdi-message-alert:before {\n  content: \"\\F362\";\n}\n.mdi-message-bulleted:before {\n  content: \"\\F6A1\";\n}\n.mdi-message-bulleted-off:before {\n  content: \"\\F6A2\";\n}\n.mdi-message-draw:before {\n  content: \"\\F363\";\n}\n.mdi-message-image:before {\n  content: \"\\F364\";\n}\n.mdi-message-outline:before {\n  content: \"\\F365\";\n}\n.mdi-message-plus:before {\n  content: \"\\F653\";\n}\n.mdi-message-processing:before {\n  content: \"\\F366\";\n}\n.mdi-message-reply:before {\n  content: \"\\F367\";\n}\n.mdi-message-reply-text:before {\n  content: \"\\F368\";\n}\n.mdi-message-settings:before {\n  content: \"\\F6EF\";\n}\n.mdi-message-settings-variant:before {\n  content: \"\\F6F0\";\n}\n.mdi-message-text:before {\n  content: \"\\F369\";\n}\n.mdi-message-text-outline:before {\n  content: \"\\F36A\";\n}\n.mdi-message-video:before {\n  content: \"\\F36B\";\n}\n.mdi-meteor:before {\n  content: \"\\F629\";\n}\n.mdi-metronome:before {\n  content: \"\\F7D9\";\n}\n.mdi-metronome-tick:before {\n  content: \"\\F7DA\";\n}\n.mdi-micro-sd:before {\n  content: \"\\F7DB\";\n}\n.mdi-microphone:before {\n  content: \"\\F36C\";\n}\n.mdi-microphone-minus:before {\n  content: \"\\F8B2\";\n}\n.mdi-microphone-off:before {\n  content: \"\\F36D\";\n}\n.mdi-microphone-outline:before {\n  content: \"\\F36E\";\n}\n.mdi-microphone-plus:before {\n  content: \"\\F8B3\";\n}\n.mdi-microphone-settings:before {\n  content: \"\\F36F\";\n}\n.mdi-microphone-variant:before {\n  content: \"\\F370\";\n}\n.mdi-microphone-variant-off:before {\n  content: \"\\F371\";\n}\n.mdi-microscope:before {\n  content: \"\\F654\";\n}\n.mdi-microsoft:before {\n  content: \"\\F372\";\n}\n.mdi-minecraft:before {\n  content: \"\\F373\";\n}\n.mdi-minus:before {\n  content: \"\\F374\";\n}\n.mdi-minus-box:before {\n  content: \"\\F375\";\n}\n.mdi-minus-box-outline:before {\n  content: \"\\F6F1\";\n}\n.mdi-minus-circle:before {\n  content: \"\\F376\";\n}\n.mdi-minus-circle-outline:before {\n  content: \"\\F377\";\n}\n.mdi-minus-network:before {\n  content: \"\\F378\";\n}\n.mdi-mixcloud:before {\n  content: \"\\F62A\";\n}\n.mdi-mixed-reality:before {\n  content: \"\\F87E\";\n}\n.mdi-mixer:before {\n  content: \"\\F7DC\";\n}\n.mdi-monitor:before {\n  content: \"\\F379\";\n}\n.mdi-monitor-multiple:before {\n  content: \"\\F37A\";\n}\n.mdi-more:before {\n  content: \"\\F37B\";\n}\n.mdi-motorbike:before {\n  content: \"\\F37C\";\n}\n.mdi-mouse:before {\n  content: \"\\F37D\";\n}\n.mdi-mouse-off:before {\n  content: \"\\F37E\";\n}\n.mdi-mouse-variant:before {\n  content: \"\\F37F\";\n}\n.mdi-mouse-variant-off:before {\n  content: \"\\F380\";\n}\n.mdi-move-resize:before {\n  content: \"\\F655\";\n}\n.mdi-move-resize-variant:before {\n  content: \"\\F656\";\n}\n.mdi-movie:before {\n  content: \"\\F381\";\n}\n.mdi-movie-roll:before {\n  content: \"\\F7DD\";\n}\n.mdi-multiplication:before {\n  content: \"\\F382\";\n}\n.mdi-multiplication-box:before {\n  content: \"\\F383\";\n}\n.mdi-mushroom:before {\n  content: \"\\F7DE\";\n}\n.mdi-mushroom-outline:before {\n  content: \"\\F7DF\";\n}\n.mdi-music:before {\n  content: \"\\F759\";\n}\n.mdi-music-box:before {\n  content: \"\\F384\";\n}\n.mdi-music-box-outline:before {\n  content: \"\\F385\";\n}\n.mdi-music-circle:before {\n  content: \"\\F386\";\n}\n.mdi-music-note:before {\n  content: \"\\F387\";\n}\n.mdi-music-note-bluetooth:before {\n  content: \"\\F5FE\";\n}\n.mdi-music-note-bluetooth-off:before {\n  content: \"\\F5FF\";\n}\n.mdi-music-note-eighth:before {\n  content: \"\\F388\";\n}\n.mdi-music-note-half:before {\n  content: \"\\F389\";\n}\n.mdi-music-note-off:before {\n  content: \"\\F38A\";\n}\n.mdi-music-note-quarter:before {\n  content: \"\\F38B\";\n}\n.mdi-music-note-sixteenth:before {\n  content: \"\\F38C\";\n}\n.mdi-music-note-whole:before {\n  content: \"\\F38D\";\n}\n.mdi-music-off:before {\n  content: \"\\F75A\";\n}\n.mdi-nativescript:before {\n  content: \"\\F87F\";\n}\n.mdi-nature:before {\n  content: \"\\F38E\";\n}\n.mdi-nature-people:before {\n  content: \"\\F38F\";\n}\n.mdi-navigation:before {\n  content: \"\\F390\";\n}\n.mdi-near-me:before {\n  content: \"\\F5CD\";\n}\n.mdi-needle:before {\n  content: \"\\F391\";\n}\n.mdi-nest-protect:before {\n  content: \"\\F392\";\n}\n.mdi-nest-thermostat:before {\n  content: \"\\F393\";\n}\n.mdi-netflix:before {\n  content: \"\\F745\";\n}\n.mdi-network:before {\n  content: \"\\F6F2\";\n}\n.mdi-new-box:before {\n  content: \"\\F394\";\n}\n.mdi-newspaper:before {\n  content: \"\\F395\";\n}\n.mdi-nfc:before {\n  content: \"\\F396\";\n}\n.mdi-nfc-tap:before {\n  content: \"\\F397\";\n}\n.mdi-nfc-variant:before {\n  content: \"\\F398\";\n}\n.mdi-ninja:before {\n  content: \"\\F773\";\n}\n.mdi-nintendo-switch:before {\n  content: \"\\F7E0\";\n}\n.mdi-nodejs:before {\n  content: \"\\F399\";\n}\n.mdi-note:before {\n  content: \"\\F39A\";\n}\n.mdi-note-multiple:before {\n  content: \"\\F6B7\";\n}\n.mdi-note-multiple-outline:before {\n  content: \"\\F6B8\";\n}\n.mdi-note-outline:before {\n  content: \"\\F39B\";\n}\n.mdi-note-plus:before {\n  content: \"\\F39C\";\n}\n.mdi-note-plus-outline:before {\n  content: \"\\F39D\";\n}\n.mdi-note-text:before {\n  content: \"\\F39E\";\n}\n.mdi-notebook:before {\n  content: \"\\F82D\";\n}\n.mdi-notification-clear-all:before {\n  content: \"\\F39F\";\n}\n.mdi-npm:before {\n  content: \"\\F6F6\";\n}\n.mdi-nuke:before {\n  content: \"\\F6A3\";\n}\n.mdi-null:before {\n  content: \"\\F7E1\";\n}\n.mdi-numeric:before {\n  content: \"\\F3A0\";\n}\n.mdi-numeric-0-box:before {\n  content: \"\\F3A1\";\n}\n.mdi-numeric-0-box-multiple-outline:before {\n  content: \"\\F3A2\";\n}\n.mdi-numeric-0-box-outline:before {\n  content: \"\\F3A3\";\n}\n.mdi-numeric-1-box:before {\n  content: \"\\F3A4\";\n}\n.mdi-numeric-1-box-multiple-outline:before {\n  content: \"\\F3A5\";\n}\n.mdi-numeric-1-box-outline:before {\n  content: \"\\F3A6\";\n}\n.mdi-numeric-2-box:before {\n  content: \"\\F3A7\";\n}\n.mdi-numeric-2-box-multiple-outline:before {\n  content: \"\\F3A8\";\n}\n.mdi-numeric-2-box-outline:before {\n  content: \"\\F3A9\";\n}\n.mdi-numeric-3-box:before {\n  content: \"\\F3AA\";\n}\n.mdi-numeric-3-box-multiple-outline:before {\n  content: \"\\F3AB\";\n}\n.mdi-numeric-3-box-outline:before {\n  content: \"\\F3AC\";\n}\n.mdi-numeric-4-box:before {\n  content: \"\\F3AD\";\n}\n.mdi-numeric-4-box-multiple-outline:before {\n  content: \"\\F3AE\";\n}\n.mdi-numeric-4-box-outline:before {\n  content: \"\\F3AF\";\n}\n.mdi-numeric-5-box:before {\n  content: \"\\F3B0\";\n}\n.mdi-numeric-5-box-multiple-outline:before {\n  content: \"\\F3B1\";\n}\n.mdi-numeric-5-box-outline:before {\n  content: \"\\F3B2\";\n}\n.mdi-numeric-6-box:before {\n  content: \"\\F3B3\";\n}\n.mdi-numeric-6-box-multiple-outline:before {\n  content: \"\\F3B4\";\n}\n.mdi-numeric-6-box-outline:before {\n  content: \"\\F3B5\";\n}\n.mdi-numeric-7-box:before {\n  content: \"\\F3B6\";\n}\n.mdi-numeric-7-box-multiple-outline:before {\n  content: \"\\F3B7\";\n}\n.mdi-numeric-7-box-outline:before {\n  content: \"\\F3B8\";\n}\n.mdi-numeric-8-box:before {\n  content: \"\\F3B9\";\n}\n.mdi-numeric-8-box-multiple-outline:before {\n  content: \"\\F3BA\";\n}\n.mdi-numeric-8-box-outline:before {\n  content: \"\\F3BB\";\n}\n.mdi-numeric-9-box:before {\n  content: \"\\F3BC\";\n}\n.mdi-numeric-9-box-multiple-outline:before {\n  content: \"\\F3BD\";\n}\n.mdi-numeric-9-box-outline:before {\n  content: \"\\F3BE\";\n}\n.mdi-numeric-9-plus-box:before {\n  content: \"\\F3BF\";\n}\n.mdi-numeric-9-plus-box-multiple-outline:before {\n  content: \"\\F3C0\";\n}\n.mdi-numeric-9-plus-box-outline:before {\n  content: \"\\F3C1\";\n}\n.mdi-nut:before {\n  content: \"\\F6F7\";\n}\n.mdi-nutrition:before {\n  content: \"\\F3C2\";\n}\n.mdi-oar:before {\n  content: \"\\F67B\";\n}\n.mdi-octagon:before {\n  content: \"\\F3C3\";\n}\n.mdi-octagon-outline:before {\n  content: \"\\F3C4\";\n}\n.mdi-octagram:before {\n  content: \"\\F6F8\";\n}\n.mdi-octagram-outline:before {\n  content: \"\\F774\";\n}\n.mdi-odnoklassniki:before {\n  content: \"\\F3C5\";\n}\n.mdi-office:before {\n  content: \"\\F3C6\";\n}\n.mdi-oil:before {\n  content: \"\\F3C7\";\n}\n.mdi-oil-temperature:before {\n  content: \"\\F3C8\";\n}\n.mdi-omega:before {\n  content: \"\\F3C9\";\n}\n.mdi-onedrive:before {\n  content: \"\\F3CA\";\n}\n.mdi-onenote:before {\n  content: \"\\F746\";\n}\n.mdi-onepassword:before {\n  content: \"\\F880\";\n}\n.mdi-opacity:before {\n  content: \"\\F5CC\";\n}\n.mdi-open-in-app:before {\n  content: \"\\F3CB\";\n}\n.mdi-open-in-new:before {\n  content: \"\\F3CC\";\n}\n.mdi-openid:before {\n  content: \"\\F3CD\";\n}\n.mdi-opera:before {\n  content: \"\\F3CE\";\n}\n.mdi-orbit:before {\n  content: \"\\F018\";\n}\n.mdi-ornament:before {\n  content: \"\\F3CF\";\n}\n.mdi-ornament-variant:before {\n  content: \"\\F3D0\";\n}\n.mdi-owl:before {\n  content: \"\\F3D2\";\n}\n.mdi-package:before {\n  content: \"\\F3D3\";\n}\n.mdi-package-down:before {\n  content: \"\\F3D4\";\n}\n.mdi-package-up:before {\n  content: \"\\F3D5\";\n}\n.mdi-package-variant:before {\n  content: \"\\F3D6\";\n}\n.mdi-package-variant-closed:before {\n  content: \"\\F3D7\";\n}\n.mdi-page-first:before {\n  content: \"\\F600\";\n}\n.mdi-page-last:before {\n  content: \"\\F601\";\n}\n.mdi-page-layout-body:before {\n  content: \"\\F6F9\";\n}\n.mdi-page-layout-footer:before {\n  content: \"\\F6FA\";\n}\n.mdi-page-layout-header:before {\n  content: \"\\F6FB\";\n}\n.mdi-page-layout-sidebar-left:before {\n  content: \"\\F6FC\";\n}\n.mdi-page-layout-sidebar-right:before {\n  content: \"\\F6FD\";\n}\n.mdi-palette:before {\n  content: \"\\F3D8\";\n}\n.mdi-palette-advanced:before {\n  content: \"\\F3D9\";\n}\n.mdi-palette-swatch:before {\n  content: \"\\F8B4\";\n}\n.mdi-panda:before {\n  content: \"\\F3DA\";\n}\n.mdi-pandora:before {\n  content: \"\\F3DB\";\n}\n.mdi-panorama:before {\n  content: \"\\F3DC\";\n}\n.mdi-panorama-fisheye:before {\n  content: \"\\F3DD\";\n}\n.mdi-panorama-horizontal:before {\n  content: \"\\F3DE\";\n}\n.mdi-panorama-vertical:before {\n  content: \"\\F3DF\";\n}\n.mdi-panorama-wide-angle:before {\n  content: \"\\F3E0\";\n}\n.mdi-paper-cut-vertical:before {\n  content: \"\\F3E1\";\n}\n.mdi-paperclip:before {\n  content: \"\\F3E2\";\n}\n.mdi-parking:before {\n  content: \"\\F3E3\";\n}\n.mdi-passport:before {\n  content: \"\\F7E2\";\n}\n.mdi-patreon:before {\n  content: \"\\F881\";\n}\n.mdi-pause:before {\n  content: \"\\F3E4\";\n}\n.mdi-pause-circle:before {\n  content: \"\\F3E5\";\n}\n.mdi-pause-circle-outline:before {\n  content: \"\\F3E6\";\n}\n.mdi-pause-octagon:before {\n  content: \"\\F3E7\";\n}\n.mdi-pause-octagon-outline:before {\n  content: \"\\F3E8\";\n}\n.mdi-paw:before {\n  content: \"\\F3E9\";\n}\n.mdi-paw-off:before {\n  content: \"\\F657\";\n}\n.mdi-paypal:before {\n  content: \"\\F882\";\n}\n.mdi-peace:before {\n  content: \"\\F883\";\n}\n.mdi-pen:before {\n  content: \"\\F3EA\";\n}\n.mdi-pencil:before {\n  content: \"\\F3EB\";\n}\n.mdi-pencil-box:before {\n  content: \"\\F3EC\";\n}\n.mdi-pencil-box-outline:before {\n  content: \"\\F3ED\";\n}\n.mdi-pencil-circle:before {\n  content: \"\\F6FE\";\n}\n.mdi-pencil-circle-outline:before {\n  content: \"\\F775\";\n}\n.mdi-pencil-lock:before {\n  content: \"\\F3EE\";\n}\n.mdi-pencil-off:before {\n  content: \"\\F3EF\";\n}\n.mdi-pentagon:before {\n  content: \"\\F6FF\";\n}\n.mdi-pentagon-outline:before {\n  content: \"\\F700\";\n}\n.mdi-percent:before {\n  content: \"\\F3F0\";\n}\n.mdi-periodic-table:before {\n  content: \"\\F8B5\";\n}\n.mdi-periodic-table-co2:before {\n  content: \"\\F7E3\";\n}\n.mdi-periscope:before {\n  content: \"\\F747\";\n}\n.mdi-pharmacy:before {\n  content: \"\\F3F1\";\n}\n.mdi-phone:before {\n  content: \"\\F3F2\";\n}\n.mdi-phone-bluetooth:before {\n  content: \"\\F3F3\";\n}\n.mdi-phone-classic:before {\n  content: \"\\F602\";\n}\n.mdi-phone-forward:before {\n  content: \"\\F3F4\";\n}\n.mdi-phone-hangup:before {\n  content: \"\\F3F5\";\n}\n.mdi-phone-in-talk:before {\n  content: \"\\F3F6\";\n}\n.mdi-phone-incoming:before {\n  content: \"\\F3F7\";\n}\n.mdi-phone-locked:before {\n  content: \"\\F3F8\";\n}\n.mdi-phone-log:before {\n  content: \"\\F3F9\";\n}\n.mdi-phone-minus:before {\n  content: \"\\F658\";\n}\n.mdi-phone-missed:before {\n  content: \"\\F3FA\";\n}\n.mdi-phone-outgoing:before {\n  content: \"\\F3FB\";\n}\n.mdi-phone-paused:before {\n  content: \"\\F3FC\";\n}\n.mdi-phone-plus:before {\n  content: \"\\F659\";\n}\n.mdi-phone-return:before {\n  content: \"\\F82E\";\n}\n.mdi-phone-rotate-landscape:before {\n  content: \"\\F884\";\n}\n.mdi-phone-rotate-portrait:before {\n  content: \"\\F885\";\n}\n.mdi-phone-settings:before {\n  content: \"\\F3FD\";\n}\n.mdi-phone-voip:before {\n  content: \"\\F3FE\";\n}\n.mdi-pi:before {\n  content: \"\\F3FF\";\n}\n.mdi-pi-box:before {\n  content: \"\\F400\";\n}\n.mdi-piano:before {\n  content: \"\\F67C\";\n}\n.mdi-pickaxe:before {\n  content: \"\\F8B6\";\n}\n.mdi-pier:before {\n  content: \"\\F886\";\n}\n.mdi-pier-crane:before {\n  content: \"\\F887\";\n}\n.mdi-pig:before {\n  content: \"\\F401\";\n}\n.mdi-pill:before {\n  content: \"\\F402\";\n}\n.mdi-pillar:before {\n  content: \"\\F701\";\n}\n.mdi-pin:before {\n  content: \"\\F403\";\n}\n.mdi-pin-off:before {\n  content: \"\\F404\";\n}\n.mdi-pine-tree:before {\n  content: \"\\F405\";\n}\n.mdi-pine-tree-box:before {\n  content: \"\\F406\";\n}\n.mdi-pinterest:before {\n  content: \"\\F407\";\n}\n.mdi-pinterest-box:before {\n  content: \"\\F408\";\n}\n.mdi-pipe:before {\n  content: \"\\F7E4\";\n}\n.mdi-pipe-disconnected:before {\n  content: \"\\F7E5\";\n}\n.mdi-pipe-leak:before {\n  content: \"\\F888\";\n}\n.mdi-pistol:before {\n  content: \"\\F702\";\n}\n.mdi-piston:before {\n  content: \"\\F889\";\n}\n.mdi-pizza:before {\n  content: \"\\F409\";\n}\n.mdi-plane-shield:before {\n  content: \"\\F6BA\";\n}\n.mdi-play:before {\n  content: \"\\F40A\";\n}\n.mdi-play-box-outline:before {\n  content: \"\\F40B\";\n}\n.mdi-play-circle:before {\n  content: \"\\F40C\";\n}\n.mdi-play-circle-outline:before {\n  content: \"\\F40D\";\n}\n.mdi-play-network:before {\n  content: \"\\F88A\";\n}\n.mdi-play-pause:before {\n  content: \"\\F40E\";\n}\n.mdi-play-protected-content:before {\n  content: \"\\F40F\";\n}\n.mdi-playlist-check:before {\n  content: \"\\F5C7\";\n}\n.mdi-playlist-minus:before {\n  content: \"\\F410\";\n}\n.mdi-playlist-play:before {\n  content: \"\\F411\";\n}\n.mdi-playlist-plus:before {\n  content: \"\\F412\";\n}\n.mdi-playlist-remove:before {\n  content: \"\\F413\";\n}\n.mdi-playstation:before {\n  content: \"\\F414\";\n}\n.mdi-plex:before {\n  content: \"\\F6B9\";\n}\n.mdi-plus:before {\n  content: \"\\F415\";\n}\n.mdi-plus-box:before {\n  content: \"\\F416\";\n}\n.mdi-plus-box-outline:before {\n  content: \"\\F703\";\n}\n.mdi-plus-circle:before {\n  content: \"\\F417\";\n}\n.mdi-plus-circle-multiple-outline:before {\n  content: \"\\F418\";\n}\n.mdi-plus-circle-outline:before {\n  content: \"\\F419\";\n}\n.mdi-plus-network:before {\n  content: \"\\F41A\";\n}\n.mdi-plus-one:before {\n  content: \"\\F41B\";\n}\n.mdi-plus-outline:before {\n  content: \"\\F704\";\n}\n.mdi-pocket:before {\n  content: \"\\F41C\";\n}\n.mdi-pokeball:before {\n  content: \"\\F41D\";\n}\n.mdi-poker-chip:before {\n  content: \"\\F82F\";\n}\n.mdi-polaroid:before {\n  content: \"\\F41E\";\n}\n.mdi-poll:before {\n  content: \"\\F41F\";\n}\n.mdi-poll-box:before {\n  content: \"\\F420\";\n}\n.mdi-polymer:before {\n  content: \"\\F421\";\n}\n.mdi-pool:before {\n  content: \"\\F606\";\n}\n.mdi-popcorn:before {\n  content: \"\\F422\";\n}\n.mdi-pot:before {\n  content: \"\\F65A\";\n}\n.mdi-pot-mix:before {\n  content: \"\\F65B\";\n}\n.mdi-pound:before {\n  content: \"\\F423\";\n}\n.mdi-pound-box:before {\n  content: \"\\F424\";\n}\n.mdi-power:before {\n  content: \"\\F425\";\n}\n.mdi-power-plug:before {\n  content: \"\\F6A4\";\n}\n.mdi-power-plug-off:before {\n  content: \"\\F6A5\";\n}\n.mdi-power-settings:before {\n  content: \"\\F426\";\n}\n.mdi-power-socket:before {\n  content: \"\\F427\";\n}\n.mdi-power-socket-eu:before {\n  content: \"\\F7E6\";\n}\n.mdi-power-socket-uk:before {\n  content: \"\\F7E7\";\n}\n.mdi-power-socket-us:before {\n  content: \"\\F7E8\";\n}\n.mdi-prescription:before {\n  content: \"\\F705\";\n}\n.mdi-presentation:before {\n  content: \"\\F428\";\n}\n.mdi-presentation-play:before {\n  content: \"\\F429\";\n}\n.mdi-printer:before {\n  content: \"\\F42A\";\n}\n.mdi-printer-3d:before {\n  content: \"\\F42B\";\n}\n.mdi-printer-alert:before {\n  content: \"\\F42C\";\n}\n.mdi-printer-settings:before {\n  content: \"\\F706\";\n}\n.mdi-priority-high:before {\n  content: \"\\F603\";\n}\n.mdi-priority-low:before {\n  content: \"\\F604\";\n}\n.mdi-professional-hexagon:before {\n  content: \"\\F42D\";\n}\n.mdi-projector:before {\n  content: \"\\F42E\";\n}\n.mdi-projector-screen:before {\n  content: \"\\F42F\";\n}\n.mdi-publish:before {\n  content: \"\\F6A6\";\n}\n.mdi-pulse:before {\n  content: \"\\F430\";\n}\n.mdi-puzzle:before {\n  content: \"\\F431\";\n}\n.mdi-qqchat:before {\n  content: \"\\F605\";\n}\n.mdi-qrcode:before {\n  content: \"\\F432\";\n}\n.mdi-qrcode-edit:before {\n  content: \"\\F8B7\";\n}\n.mdi-qrcode-scan:before {\n  content: \"\\F433\";\n}\n.mdi-quadcopter:before {\n  content: \"\\F434\";\n}\n.mdi-quality-high:before {\n  content: \"\\F435\";\n}\n.mdi-quicktime:before {\n  content: \"\\F436\";\n}\n.mdi-radar:before {\n  content: \"\\F437\";\n}\n.mdi-radiator:before {\n  content: \"\\F438\";\n}\n.mdi-radio:before {\n  content: \"\\F439\";\n}\n.mdi-radio-handheld:before {\n  content: \"\\F43A\";\n}\n.mdi-radio-tower:before {\n  content: \"\\F43B\";\n}\n.mdi-radioactive:before {\n  content: \"\\F43C\";\n}\n.mdi-radiobox-blank:before {\n  content: \"\\F43D\";\n}\n.mdi-radiobox-marked:before {\n  content: \"\\F43E\";\n}\n.mdi-raspberrypi:before {\n  content: \"\\F43F\";\n}\n.mdi-ray-end:before {\n  content: \"\\F440\";\n}\n.mdi-ray-end-arrow:before {\n  content: \"\\F441\";\n}\n.mdi-ray-start:before {\n  content: \"\\F442\";\n}\n.mdi-ray-start-arrow:before {\n  content: \"\\F443\";\n}\n.mdi-ray-start-end:before {\n  content: \"\\F444\";\n}\n.mdi-ray-vertex:before {\n  content: \"\\F445\";\n}\n.mdi-react:before {\n  content: \"\\F707\";\n}\n.mdi-read:before {\n  content: \"\\F447\";\n}\n.mdi-receipt:before {\n  content: \"\\F449\";\n}\n.mdi-record:before {\n  content: \"\\F44A\";\n}\n.mdi-record-rec:before {\n  content: \"\\F44B\";\n}\n.mdi-recycle:before {\n  content: \"\\F44C\";\n}\n.mdi-reddit:before {\n  content: \"\\F44D\";\n}\n.mdi-redo:before {\n  content: \"\\F44E\";\n}\n.mdi-redo-variant:before {\n  content: \"\\F44F\";\n}\n.mdi-refresh:before {\n  content: \"\\F450\";\n}\n.mdi-regex:before {\n  content: \"\\F451\";\n}\n.mdi-relative-scale:before {\n  content: \"\\F452\";\n}\n.mdi-reload:before {\n  content: \"\\F453\";\n}\n.mdi-reminder:before {\n  content: \"\\F88B\";\n}\n.mdi-remote:before {\n  content: \"\\F454\";\n}\n.mdi-remote-desktop:before {\n  content: \"\\F8B8\";\n}\n.mdi-rename-box:before {\n  content: \"\\F455\";\n}\n.mdi-reorder-horizontal:before {\n  content: \"\\F687\";\n}\n.mdi-reorder-vertical:before {\n  content: \"\\F688\";\n}\n.mdi-repeat:before {\n  content: \"\\F456\";\n}\n.mdi-repeat-off:before {\n  content: \"\\F457\";\n}\n.mdi-repeat-once:before {\n  content: \"\\F458\";\n}\n.mdi-replay:before {\n  content: \"\\F459\";\n}\n.mdi-reply:before {\n  content: \"\\F45A\";\n}\n.mdi-reply-all:before {\n  content: \"\\F45B\";\n}\n.mdi-reproduction:before {\n  content: \"\\F45C\";\n}\n.mdi-resize-bottom-right:before {\n  content: \"\\F45D\";\n}\n.mdi-responsive:before {\n  content: \"\\F45E\";\n}\n.mdi-restart:before {\n  content: \"\\F708\";\n}\n.mdi-restore:before {\n  content: \"\\F6A7\";\n}\n.mdi-rewind:before {\n  content: \"\\F45F\";\n}\n.mdi-rewind-outline:before {\n  content: \"\\F709\";\n}\n.mdi-rhombus:before {\n  content: \"\\F70A\";\n}\n.mdi-rhombus-outline:before {\n  content: \"\\F70B\";\n}\n.mdi-ribbon:before {\n  content: \"\\F460\";\n}\n.mdi-rice:before {\n  content: \"\\F7E9\";\n}\n.mdi-ring:before {\n  content: \"\\F7EA\";\n}\n.mdi-road:before {\n  content: \"\\F461\";\n}\n.mdi-road-variant:before {\n  content: \"\\F462\";\n}\n.mdi-robot:before {\n  content: \"\\F6A8\";\n}\n.mdi-rocket:before {\n  content: \"\\F463\";\n}\n.mdi-room-service:before {\n  content: \"\\F88C\";\n}\n.mdi-roomba:before {\n  content: \"\\F70C\";\n}\n.mdi-rotate-3d:before {\n  content: \"\\F464\";\n}\n.mdi-rotate-left:before {\n  content: \"\\F465\";\n}\n.mdi-rotate-left-variant:before {\n  content: \"\\F466\";\n}\n.mdi-rotate-right:before {\n  content: \"\\F467\";\n}\n.mdi-rotate-right-variant:before {\n  content: \"\\F468\";\n}\n.mdi-rounded-corner:before {\n  content: \"\\F607\";\n}\n.mdi-router-wireless:before {\n  content: \"\\F469\";\n}\n.mdi-routes:before {\n  content: \"\\F46A\";\n}\n.mdi-rowing:before {\n  content: \"\\F608\";\n}\n.mdi-rss:before {\n  content: \"\\F46B\";\n}\n.mdi-rss-box:before {\n  content: \"\\F46C\";\n}\n.mdi-ruler:before {\n  content: \"\\F46D\";\n}\n.mdi-run:before {\n  content: \"\\F70D\";\n}\n.mdi-run-fast:before {\n  content: \"\\F46E\";\n}\n.mdi-sale:before {\n  content: \"\\F46F\";\n}\n.mdi-salesforce:before {\n  content: \"\\F88D\";\n}\n.mdi-sass:before {\n  content: \"\\F7EB\";\n}\n.mdi-satellite:before {\n  content: \"\\F470\";\n}\n.mdi-satellite-variant:before {\n  content: \"\\F471\";\n}\n.mdi-sausage:before {\n  content: \"\\F8B9\";\n}\n.mdi-saxophone:before {\n  content: \"\\F609\";\n}\n.mdi-scale:before {\n  content: \"\\F472\";\n}\n.mdi-scale-balance:before {\n  content: \"\\F5D1\";\n}\n.mdi-scale-bathroom:before {\n  content: \"\\F473\";\n}\n.mdi-scanner:before {\n  content: \"\\F6AA\";\n}\n.mdi-school:before {\n  content: \"\\F474\";\n}\n.mdi-screen-rotation:before {\n  content: \"\\F475\";\n}\n.mdi-screen-rotation-lock:before {\n  content: \"\\F476\";\n}\n.mdi-screwdriver:before {\n  content: \"\\F477\";\n}\n.mdi-script:before {\n  content: \"\\F478\";\n}\n.mdi-sd:before {\n  content: \"\\F479\";\n}\n.mdi-seal:before {\n  content: \"\\F47A\";\n}\n.mdi-search-web:before {\n  content: \"\\F70E\";\n}\n.mdi-seat-flat:before {\n  content: \"\\F47B\";\n}\n.mdi-seat-flat-angled:before {\n  content: \"\\F47C\";\n}\n.mdi-seat-individual-suite:before {\n  content: \"\\F47D\";\n}\n.mdi-seat-legroom-extra:before {\n  content: \"\\F47E\";\n}\n.mdi-seat-legroom-normal:before {\n  content: \"\\F47F\";\n}\n.mdi-seat-legroom-reduced:before {\n  content: \"\\F480\";\n}\n.mdi-seat-recline-extra:before {\n  content: \"\\F481\";\n}\n.mdi-seat-recline-normal:before {\n  content: \"\\F482\";\n}\n.mdi-security:before {\n  content: \"\\F483\";\n}\n.mdi-security-account:before {\n  content: \"\\F88E\";\n}\n.mdi-security-home:before {\n  content: \"\\F689\";\n}\n.mdi-security-network:before {\n  content: \"\\F484\";\n}\n.mdi-select:before {\n  content: \"\\F485\";\n}\n.mdi-select-all:before {\n  content: \"\\F486\";\n}\n.mdi-select-inverse:before {\n  content: \"\\F487\";\n}\n.mdi-select-off:before {\n  content: \"\\F488\";\n}\n.mdi-selection:before {\n  content: \"\\F489\";\n}\n.mdi-selection-off:before {\n  content: \"\\F776\";\n}\n.mdi-send:before {\n  content: \"\\F48A\";\n}\n.mdi-send-secure:before {\n  content: \"\\F7EC\";\n}\n.mdi-serial-port:before {\n  content: \"\\F65C\";\n}\n.mdi-server:before {\n  content: \"\\F48B\";\n}\n.mdi-server-minus:before {\n  content: \"\\F48C\";\n}\n.mdi-server-network:before {\n  content: \"\\F48D\";\n}\n.mdi-server-network-off:before {\n  content: \"\\F48E\";\n}\n.mdi-server-off:before {\n  content: \"\\F48F\";\n}\n.mdi-server-plus:before {\n  content: \"\\F490\";\n}\n.mdi-server-remove:before {\n  content: \"\\F491\";\n}\n.mdi-server-security:before {\n  content: \"\\F492\";\n}\n.mdi-set-all:before {\n  content: \"\\F777\";\n}\n.mdi-set-center:before {\n  content: \"\\F778\";\n}\n.mdi-set-center-right:before {\n  content: \"\\F779\";\n}\n.mdi-set-left:before {\n  content: \"\\F77A\";\n}\n.mdi-set-left-center:before {\n  content: \"\\F77B\";\n}\n.mdi-set-left-right:before {\n  content: \"\\F77C\";\n}\n.mdi-set-none:before {\n  content: \"\\F77D\";\n}\n.mdi-set-right:before {\n  content: \"\\F77E\";\n}\n.mdi-settings:before {\n  content: \"\\F493\";\n}\n.mdi-settings-box:before {\n  content: \"\\F494\";\n}\n.mdi-settings-outline:before {\n  content: \"\\F8BA\";\n}\n.mdi-shape:before {\n  content: \"\\F830\";\n}\n.mdi-shape-circle-plus:before {\n  content: \"\\F65D\";\n}\n.mdi-shape-outline:before {\n  content: \"\\F831\";\n}\n.mdi-shape-plus:before {\n  content: \"\\F495\";\n}\n.mdi-shape-polygon-plus:before {\n  content: \"\\F65E\";\n}\n.mdi-shape-rectangle-plus:before {\n  content: \"\\F65F\";\n}\n.mdi-shape-square-plus:before {\n  content: \"\\F660\";\n}\n.mdi-share:before {\n  content: \"\\F496\";\n}\n.mdi-share-variant:before {\n  content: \"\\F497\";\n}\n.mdi-shield:before {\n  content: \"\\F498\";\n}\n.mdi-shield-half-full:before {\n  content: \"\\F77F\";\n}\n.mdi-shield-outline:before {\n  content: \"\\F499\";\n}\n.mdi-ship-wheel:before {\n  content: \"\\F832\";\n}\n.mdi-shopping:before {\n  content: \"\\F49A\";\n}\n.mdi-shopping-music:before {\n  content: \"\\F49B\";\n}\n.mdi-shovel:before {\n  content: \"\\F70F\";\n}\n.mdi-shovel-off:before {\n  content: \"\\F710\";\n}\n.mdi-shredder:before {\n  content: \"\\F49C\";\n}\n.mdi-shuffle:before {\n  content: \"\\F49D\";\n}\n.mdi-shuffle-disabled:before {\n  content: \"\\F49E\";\n}\n.mdi-shuffle-variant:before {\n  content: \"\\F49F\";\n}\n.mdi-sigma:before {\n  content: \"\\F4A0\";\n}\n.mdi-sigma-lower:before {\n  content: \"\\F62B\";\n}\n.mdi-sign-caution:before {\n  content: \"\\F4A1\";\n}\n.mdi-sign-direction:before {\n  content: \"\\F780\";\n}\n.mdi-sign-text:before {\n  content: \"\\F781\";\n}\n.mdi-signal:before {\n  content: \"\\F4A2\";\n}\n.mdi-signal-2g:before {\n  content: \"\\F711\";\n}\n.mdi-signal-3g:before {\n  content: \"\\F712\";\n}\n.mdi-signal-4g:before {\n  content: \"\\F713\";\n}\n.mdi-signal-cellular-1:before {\n  content: \"\\F8BB\";\n}\n.mdi-signal-cellular-2:before {\n  content: \"\\F8BC\";\n}\n.mdi-signal-cellular-3:before {\n  content: \"\\F8BD\";\n}\n.mdi-signal-cellular-outline:before {\n  content: \"\\F8BE\";\n}\n.mdi-signal-hspa:before {\n  content: \"\\F714\";\n}\n.mdi-signal-hspa-plus:before {\n  content: \"\\F715\";\n}\n.mdi-signal-off:before {\n  content: \"\\F782\";\n}\n.mdi-signal-variant:before {\n  content: \"\\F60A\";\n}\n.mdi-silverware:before {\n  content: \"\\F4A3\";\n}\n.mdi-silverware-fork:before {\n  content: \"\\F4A4\";\n}\n.mdi-silverware-spoon:before {\n  content: \"\\F4A5\";\n}\n.mdi-silverware-variant:before {\n  content: \"\\F4A6\";\n}\n.mdi-sim:before {\n  content: \"\\F4A7\";\n}\n.mdi-sim-alert:before {\n  content: \"\\F4A8\";\n}\n.mdi-sim-off:before {\n  content: \"\\F4A9\";\n}\n.mdi-sitemap:before {\n  content: \"\\F4AA\";\n}\n.mdi-skip-backward:before {\n  content: \"\\F4AB\";\n}\n.mdi-skip-forward:before {\n  content: \"\\F4AC\";\n}\n.mdi-skip-next:before {\n  content: \"\\F4AD\";\n}\n.mdi-skip-next-circle:before {\n  content: \"\\F661\";\n}\n.mdi-skip-next-circle-outline:before {\n  content: \"\\F662\";\n}\n.mdi-skip-previous:before {\n  content: \"\\F4AE\";\n}\n.mdi-skip-previous-circle:before {\n  content: \"\\F663\";\n}\n.mdi-skip-previous-circle-outline:before {\n  content: \"\\F664\";\n}\n.mdi-skull:before {\n  content: \"\\F68B\";\n}\n.mdi-skype:before {\n  content: \"\\F4AF\";\n}\n.mdi-skype-business:before {\n  content: \"\\F4B0\";\n}\n.mdi-slack:before {\n  content: \"\\F4B1\";\n}\n.mdi-sleep:before {\n  content: \"\\F4B2\";\n}\n.mdi-sleep-off:before {\n  content: \"\\F4B3\";\n}\n.mdi-smoking:before {\n  content: \"\\F4B4\";\n}\n.mdi-smoking-off:before {\n  content: \"\\F4B5\";\n}\n.mdi-snapchat:before {\n  content: \"\\F4B6\";\n}\n.mdi-snowflake:before {\n  content: \"\\F716\";\n}\n.mdi-snowman:before {\n  content: \"\\F4B7\";\n}\n.mdi-soccer:before {\n  content: \"\\F4B8\";\n}\n.mdi-soccer-field:before {\n  content: \"\\F833\";\n}\n.mdi-sofa:before {\n  content: \"\\F4B9\";\n}\n.mdi-solid:before {\n  content: \"\\F68C\";\n}\n.mdi-sort:before {\n  content: \"\\F4BA\";\n}\n.mdi-sort-alphabetical:before {\n  content: \"\\F4BB\";\n}\n.mdi-sort-ascending:before {\n  content: \"\\F4BC\";\n}\n.mdi-sort-descending:before {\n  content: \"\\F4BD\";\n}\n.mdi-sort-numeric:before {\n  content: \"\\F4BE\";\n}\n.mdi-sort-variant:before {\n  content: \"\\F4BF\";\n}\n.mdi-soundcloud:before {\n  content: \"\\F4C0\";\n}\n.mdi-source-branch:before {\n  content: \"\\F62C\";\n}\n.mdi-source-commit:before {\n  content: \"\\F717\";\n}\n.mdi-source-commit-end:before {\n  content: \"\\F718\";\n}\n.mdi-source-commit-end-local:before {\n  content: \"\\F719\";\n}\n.mdi-source-commit-local:before {\n  content: \"\\F71A\";\n}\n.mdi-source-commit-next-local:before {\n  content: \"\\F71B\";\n}\n.mdi-source-commit-start:before {\n  content: \"\\F71C\";\n}\n.mdi-source-commit-start-next-local:before {\n  content: \"\\F71D\";\n}\n.mdi-source-fork:before {\n  content: \"\\F4C1\";\n}\n.mdi-source-merge:before {\n  content: \"\\F62D\";\n}\n.mdi-source-pull:before {\n  content: \"\\F4C2\";\n}\n.mdi-soy-sauce:before {\n  content: \"\\F7ED\";\n}\n.mdi-speaker:before {\n  content: \"\\F4C3\";\n}\n.mdi-speaker-off:before {\n  content: \"\\F4C4\";\n}\n.mdi-speaker-wireless:before {\n  content: \"\\F71E\";\n}\n.mdi-speedometer:before {\n  content: \"\\F4C5\";\n}\n.mdi-spellcheck:before {\n  content: \"\\F4C6\";\n}\n.mdi-spotify:before {\n  content: \"\\F4C7\";\n}\n.mdi-spotlight:before {\n  content: \"\\F4C8\";\n}\n.mdi-spotlight-beam:before {\n  content: \"\\F4C9\";\n}\n.mdi-spray:before {\n  content: \"\\F665\";\n}\n.mdi-square:before {\n  content: \"\\F763\";\n}\n.mdi-square-inc:before {\n  content: \"\\F4CA\";\n}\n.mdi-square-inc-cash:before {\n  content: \"\\F4CB\";\n}\n.mdi-square-outline:before {\n  content: \"\\F762\";\n}\n.mdi-square-root:before {\n  content: \"\\F783\";\n}\n.mdi-ssh:before {\n  content: \"\\F8BF\";\n}\n.mdi-stack-overflow:before {\n  content: \"\\F4CC\";\n}\n.mdi-stackexchange:before {\n  content: \"\\F60B\";\n}\n.mdi-stadium:before {\n  content: \"\\F71F\";\n}\n.mdi-stairs:before {\n  content: \"\\F4CD\";\n}\n.mdi-standard-definition:before {\n  content: \"\\F7EE\";\n}\n.mdi-star:before {\n  content: \"\\F4CE\";\n}\n.mdi-star-circle:before {\n  content: \"\\F4CF\";\n}\n.mdi-star-half:before {\n  content: \"\\F4D0\";\n}\n.mdi-star-off:before {\n  content: \"\\F4D1\";\n}\n.mdi-star-outline:before {\n  content: \"\\F4D2\";\n}\n.mdi-steam:before {\n  content: \"\\F4D3\";\n}\n.mdi-steering:before {\n  content: \"\\F4D4\";\n}\n.mdi-step-backward:before {\n  content: \"\\F4D5\";\n}\n.mdi-step-backward-2:before {\n  content: \"\\F4D6\";\n}\n.mdi-step-forward:before {\n  content: \"\\F4D7\";\n}\n.mdi-step-forward-2:before {\n  content: \"\\F4D8\";\n}\n.mdi-stethoscope:before {\n  content: \"\\F4D9\";\n}\n.mdi-sticker:before {\n  content: \"\\F5D0\";\n}\n.mdi-sticker-emoji:before {\n  content: \"\\F784\";\n}\n.mdi-stocking:before {\n  content: \"\\F4DA\";\n}\n.mdi-stop:before {\n  content: \"\\F4DB\";\n}\n.mdi-stop-circle:before {\n  content: \"\\F666\";\n}\n.mdi-stop-circle-outline:before {\n  content: \"\\F667\";\n}\n.mdi-store:before {\n  content: \"\\F4DC\";\n}\n.mdi-store-24-hour:before {\n  content: \"\\F4DD\";\n}\n.mdi-stove:before {\n  content: \"\\F4DE\";\n}\n.mdi-subdirectory-arrow-left:before {\n  content: \"\\F60C\";\n}\n.mdi-subdirectory-arrow-right:before {\n  content: \"\\F60D\";\n}\n.mdi-subway:before {\n  content: \"\\F6AB\";\n}\n.mdi-subway-variant:before {\n  content: \"\\F4DF\";\n}\n.mdi-summit:before {\n  content: \"\\F785\";\n}\n.mdi-sunglasses:before {\n  content: \"\\F4E0\";\n}\n.mdi-surround-sound:before {\n  content: \"\\F5C5\";\n}\n.mdi-surround-sound-2-0:before {\n  content: \"\\F7EF\";\n}\n.mdi-surround-sound-3-1:before {\n  content: \"\\F7F0\";\n}\n.mdi-surround-sound-5-1:before {\n  content: \"\\F7F1\";\n}\n.mdi-surround-sound-7-1:before {\n  content: \"\\F7F2\";\n}\n.mdi-svg:before {\n  content: \"\\F720\";\n}\n.mdi-swap-horizontal:before {\n  content: \"\\F4E1\";\n}\n.mdi-swap-horizontal-variant:before {\n  content: \"\\F8C0\";\n}\n.mdi-swap-vertical:before {\n  content: \"\\F4E2\";\n}\n.mdi-swap-vertical-variant:before {\n  content: \"\\F8C1\";\n}\n.mdi-swim:before {\n  content: \"\\F4E3\";\n}\n.mdi-switch:before {\n  content: \"\\F4E4\";\n}\n.mdi-sword:before {\n  content: \"\\F4E5\";\n}\n.mdi-sword-cross:before {\n  content: \"\\F786\";\n}\n.mdi-sync:before {\n  content: \"\\F4E6\";\n}\n.mdi-sync-alert:before {\n  content: \"\\F4E7\";\n}\n.mdi-sync-off:before {\n  content: \"\\F4E8\";\n}\n.mdi-tab:before {\n  content: \"\\F4E9\";\n}\n.mdi-tab-plus:before {\n  content: \"\\F75B\";\n}\n.mdi-tab-unselected:before {\n  content: \"\\F4EA\";\n}\n.mdi-table:before {\n  content: \"\\F4EB\";\n}\n.mdi-table-column:before {\n  content: \"\\F834\";\n}\n.mdi-table-column-plus-after:before {\n  content: \"\\F4EC\";\n}\n.mdi-table-column-plus-before:before {\n  content: \"\\F4ED\";\n}\n.mdi-table-column-remove:before {\n  content: \"\\F4EE\";\n}\n.mdi-table-column-width:before {\n  content: \"\\F4EF\";\n}\n.mdi-table-edit:before {\n  content: \"\\F4F0\";\n}\n.mdi-table-large:before {\n  content: \"\\F4F1\";\n}\n.mdi-table-of-contents:before {\n  content: \"\\F835\";\n}\n.mdi-table-row:before {\n  content: \"\\F836\";\n}\n.mdi-table-row-height:before {\n  content: \"\\F4F2\";\n}\n.mdi-table-row-plus-after:before {\n  content: \"\\F4F3\";\n}\n.mdi-table-row-plus-before:before {\n  content: \"\\F4F4\";\n}\n.mdi-table-row-remove:before {\n  content: \"\\F4F5\";\n}\n.mdi-table-settings:before {\n  content: \"\\F837\";\n}\n.mdi-tablet:before {\n  content: \"\\F4F6\";\n}\n.mdi-tablet-android:before {\n  content: \"\\F4F7\";\n}\n.mdi-tablet-ipad:before {\n  content: \"\\F4F8\";\n}\n.mdi-taco:before {\n  content: \"\\F761\";\n}\n.mdi-tag:before {\n  content: \"\\F4F9\";\n}\n.mdi-tag-faces:before {\n  content: \"\\F4FA\";\n}\n.mdi-tag-heart:before {\n  content: \"\\F68A\";\n}\n.mdi-tag-multiple:before {\n  content: \"\\F4FB\";\n}\n.mdi-tag-outline:before {\n  content: \"\\F4FC\";\n}\n.mdi-tag-plus:before {\n  content: \"\\F721\";\n}\n.mdi-tag-remove:before {\n  content: \"\\F722\";\n}\n.mdi-tag-text-outline:before {\n  content: \"\\F4FD\";\n}\n.mdi-target:before {\n  content: \"\\F4FE\";\n}\n.mdi-taxi:before {\n  content: \"\\F4FF\";\n}\n.mdi-teach:before {\n  content: \"\\F88F\";\n}\n.mdi-teamviewer:before {\n  content: \"\\F500\";\n}\n.mdi-telegram:before {\n  content: \"\\F501\";\n}\n.mdi-television:before {\n  content: \"\\F502\";\n}\n.mdi-television-box:before {\n  content: \"\\F838\";\n}\n.mdi-television-classic:before {\n  content: \"\\F7F3\";\n}\n.mdi-television-classic-off:before {\n  content: \"\\F839\";\n}\n.mdi-television-guide:before {\n  content: \"\\F503\";\n}\n.mdi-television-off:before {\n  content: \"\\F83A\";\n}\n.mdi-temperature-celsius:before {\n  content: \"\\F504\";\n}\n.mdi-temperature-fahrenheit:before {\n  content: \"\\F505\";\n}\n.mdi-temperature-kelvin:before {\n  content: \"\\F506\";\n}\n.mdi-tennis:before {\n  content: \"\\F507\";\n}\n.mdi-tent:before {\n  content: \"\\F508\";\n}\n.mdi-terrain:before {\n  content: \"\\F509\";\n}\n.mdi-test-tube:before {\n  content: \"\\F668\";\n}\n.mdi-text-shadow:before {\n  content: \"\\F669\";\n}\n.mdi-text-to-speech:before {\n  content: \"\\F50A\";\n}\n.mdi-text-to-speech-off:before {\n  content: \"\\F50B\";\n}\n.mdi-textbox:before {\n  content: \"\\F60E\";\n}\n.mdi-textbox-password:before {\n  content: \"\\F7F4\";\n}\n.mdi-texture:before {\n  content: \"\\F50C\";\n}\n.mdi-theater:before {\n  content: \"\\F50D\";\n}\n.mdi-theme-light-dark:before {\n  content: \"\\F50E\";\n}\n.mdi-thermometer:before {\n  content: \"\\F50F\";\n}\n.mdi-thermometer-lines:before {\n  content: \"\\F510\";\n}\n.mdi-thermostat-box:before {\n  content: \"\\F890\";\n}\n.mdi-thought-bubble:before {\n  content: \"\\F7F5\";\n}\n.mdi-thought-bubble-outline:before {\n  content: \"\\F7F6\";\n}\n.mdi-thumb-down:before {\n  content: \"\\F511\";\n}\n.mdi-thumb-down-outline:before {\n  content: \"\\F512\";\n}\n.mdi-thumb-up:before {\n  content: \"\\F513\";\n}\n.mdi-thumb-up-outline:before {\n  content: \"\\F514\";\n}\n.mdi-thumbs-up-down:before {\n  content: \"\\F515\";\n}\n.mdi-ticket:before {\n  content: \"\\F516\";\n}\n.mdi-ticket-account:before {\n  content: \"\\F517\";\n}\n.mdi-ticket-confirmation:before {\n  content: \"\\F518\";\n}\n.mdi-ticket-percent:before {\n  content: \"\\F723\";\n}\n.mdi-tie:before {\n  content: \"\\F519\";\n}\n.mdi-tilde:before {\n  content: \"\\F724\";\n}\n.mdi-timelapse:before {\n  content: \"\\F51A\";\n}\n.mdi-timer:before {\n  content: \"\\F51B\";\n}\n.mdi-timer-10:before {\n  content: \"\\F51C\";\n}\n.mdi-timer-3:before {\n  content: \"\\F51D\";\n}\n.mdi-timer-off:before {\n  content: \"\\F51E\";\n}\n.mdi-timer-sand:before {\n  content: \"\\F51F\";\n}\n.mdi-timer-sand-empty:before {\n  content: \"\\F6AC\";\n}\n.mdi-timer-sand-full:before {\n  content: \"\\F78B\";\n}\n.mdi-timetable:before {\n  content: \"\\F520\";\n}\n.mdi-toggle-switch:before {\n  content: \"\\F521\";\n}\n.mdi-toggle-switch-off:before {\n  content: \"\\F522\";\n}\n.mdi-tooltip:before {\n  content: \"\\F523\";\n}\n.mdi-tooltip-edit:before {\n  content: \"\\F524\";\n}\n.mdi-tooltip-image:before {\n  content: \"\\F525\";\n}\n.mdi-tooltip-outline:before {\n  content: \"\\F526\";\n}\n.mdi-tooltip-outline-plus:before {\n  content: \"\\F527\";\n}\n.mdi-tooltip-text:before {\n  content: \"\\F528\";\n}\n.mdi-tooth:before {\n  content: \"\\F8C2\";\n}\n.mdi-tooth-outline:before {\n  content: \"\\F529\";\n}\n.mdi-tor:before {\n  content: \"\\F52A\";\n}\n.mdi-tower-beach:before {\n  content: \"\\F680\";\n}\n.mdi-tower-fire:before {\n  content: \"\\F681\";\n}\n.mdi-towing:before {\n  content: \"\\F83B\";\n}\n.mdi-trackpad:before {\n  content: \"\\F7F7\";\n}\n.mdi-tractor:before {\n  content: \"\\F891\";\n}\n.mdi-traffic-light:before {\n  content: \"\\F52B\";\n}\n.mdi-train:before {\n  content: \"\\F52C\";\n}\n.mdi-train-variant:before {\n  content: \"\\F8C3\";\n}\n.mdi-tram:before {\n  content: \"\\F52D\";\n}\n.mdi-transcribe:before {\n  content: \"\\F52E\";\n}\n.mdi-transcribe-close:before {\n  content: \"\\F52F\";\n}\n.mdi-transfer:before {\n  content: \"\\F530\";\n}\n.mdi-transit-transfer:before {\n  content: \"\\F6AD\";\n}\n.mdi-translate:before {\n  content: \"\\F5CA\";\n}\n.mdi-treasure-chest:before {\n  content: \"\\F725\";\n}\n.mdi-tree:before {\n  content: \"\\F531\";\n}\n.mdi-trello:before {\n  content: \"\\F532\";\n}\n.mdi-trending-down:before {\n  content: \"\\F533\";\n}\n.mdi-trending-neutral:before {\n  content: \"\\F534\";\n}\n.mdi-trending-up:before {\n  content: \"\\F535\";\n}\n.mdi-triangle:before {\n  content: \"\\F536\";\n}\n.mdi-triangle-outline:before {\n  content: \"\\F537\";\n}\n.mdi-trophy:before {\n  content: \"\\F538\";\n}\n.mdi-trophy-award:before {\n  content: \"\\F539\";\n}\n.mdi-trophy-outline:before {\n  content: \"\\F53A\";\n}\n.mdi-trophy-variant:before {\n  content: \"\\F53B\";\n}\n.mdi-trophy-variant-outline:before {\n  content: \"\\F53C\";\n}\n.mdi-truck:before {\n  content: \"\\F53D\";\n}\n.mdi-truck-delivery:before {\n  content: \"\\F53E\";\n}\n.mdi-truck-fast:before {\n  content: \"\\F787\";\n}\n.mdi-truck-trailer:before {\n  content: \"\\F726\";\n}\n.mdi-tshirt-crew:before {\n  content: \"\\F53F\";\n}\n.mdi-tshirt-v:before {\n  content: \"\\F540\";\n}\n.mdi-tumblr:before {\n  content: \"\\F541\";\n}\n.mdi-tumblr-reblog:before {\n  content: \"\\F542\";\n}\n.mdi-tune:before {\n  content: \"\\F62E\";\n}\n.mdi-tune-vertical:before {\n  content: \"\\F66A\";\n}\n.mdi-twitch:before {\n  content: \"\\F543\";\n}\n.mdi-twitter:before {\n  content: \"\\F544\";\n}\n.mdi-twitter-box:before {\n  content: \"\\F545\";\n}\n.mdi-twitter-circle:before {\n  content: \"\\F546\";\n}\n.mdi-twitter-retweet:before {\n  content: \"\\F547\";\n}\n.mdi-uber:before {\n  content: \"\\F748\";\n}\n.mdi-ubuntu:before {\n  content: \"\\F548\";\n}\n.mdi-ultra-high-definition:before {\n  content: \"\\F7F8\";\n}\n.mdi-umbraco:before {\n  content: \"\\F549\";\n}\n.mdi-umbrella:before {\n  content: \"\\F54A\";\n}\n.mdi-umbrella-outline:before {\n  content: \"\\F54B\";\n}\n.mdi-undo:before {\n  content: \"\\F54C\";\n}\n.mdi-undo-variant:before {\n  content: \"\\F54D\";\n}\n.mdi-unfold-less-horizontal:before {\n  content: \"\\F54E\";\n}\n.mdi-unfold-less-vertical:before {\n  content: \"\\F75F\";\n}\n.mdi-unfold-more-horizontal:before {\n  content: \"\\F54F\";\n}\n.mdi-unfold-more-vertical:before {\n  content: \"\\F760\";\n}\n.mdi-ungroup:before {\n  content: \"\\F550\";\n}\n.mdi-unity:before {\n  content: \"\\F6AE\";\n}\n.mdi-untappd:before {\n  content: \"\\F551\";\n}\n.mdi-update:before {\n  content: \"\\F6AF\";\n}\n.mdi-upload:before {\n  content: \"\\F552\";\n}\n.mdi-upload-multiple:before {\n  content: \"\\F83C\";\n}\n.mdi-upload-network:before {\n  content: \"\\F6F5\";\n}\n.mdi-usb:before {\n  content: \"\\F553\";\n}\n.mdi-van-passenger:before {\n  content: \"\\F7F9\";\n}\n.mdi-van-utility:before {\n  content: \"\\F7FA\";\n}\n.mdi-vanish:before {\n  content: \"\\F7FB\";\n}\n.mdi-vector-arrange-above:before {\n  content: \"\\F554\";\n}\n.mdi-vector-arrange-below:before {\n  content: \"\\F555\";\n}\n.mdi-vector-circle:before {\n  content: \"\\F556\";\n}\n.mdi-vector-circle-variant:before {\n  content: \"\\F557\";\n}\n.mdi-vector-combine:before {\n  content: \"\\F558\";\n}\n.mdi-vector-curve:before {\n  content: \"\\F559\";\n}\n.mdi-vector-difference:before {\n  content: \"\\F55A\";\n}\n.mdi-vector-difference-ab:before {\n  content: \"\\F55B\";\n}\n.mdi-vector-difference-ba:before {\n  content: \"\\F55C\";\n}\n.mdi-vector-ellipse:before {\n  content: \"\\F892\";\n}\n.mdi-vector-intersection:before {\n  content: \"\\F55D\";\n}\n.mdi-vector-line:before {\n  content: \"\\F55E\";\n}\n.mdi-vector-point:before {\n  content: \"\\F55F\";\n}\n.mdi-vector-polygon:before {\n  content: \"\\F560\";\n}\n.mdi-vector-polyline:before {\n  content: \"\\F561\";\n}\n.mdi-vector-radius:before {\n  content: \"\\F749\";\n}\n.mdi-vector-rectangle:before {\n  content: \"\\F5C6\";\n}\n.mdi-vector-selection:before {\n  content: \"\\F562\";\n}\n.mdi-vector-square:before {\n  content: \"\\F001\";\n}\n.mdi-vector-triangle:before {\n  content: \"\\F563\";\n}\n.mdi-vector-union:before {\n  content: \"\\F564\";\n}\n.mdi-venmo:before {\n  content: \"\\F578\";\n}\n.mdi-verified:before {\n  content: \"\\F565\";\n}\n.mdi-vibrate:before {\n  content: \"\\F566\";\n}\n.mdi-video:before {\n  content: \"\\F567\";\n}\n.mdi-video-3d:before {\n  content: \"\\F7FC\";\n}\n.mdi-video-4k-box:before {\n  content: \"\\F83D\";\n}\n.mdi-video-input-antenna:before {\n  content: \"\\F83E\";\n}\n.mdi-video-input-component:before {\n  content: \"\\F83F\";\n}\n.mdi-video-input-hdmi:before {\n  content: \"\\F840\";\n}\n.mdi-video-input-svideo:before {\n  content: \"\\F841\";\n}\n.mdi-video-off:before {\n  content: \"\\F568\";\n}\n.mdi-video-switch:before {\n  content: \"\\F569\";\n}\n.mdi-view-agenda:before {\n  content: \"\\F56A\";\n}\n.mdi-view-array:before {\n  content: \"\\F56B\";\n}\n.mdi-view-carousel:before {\n  content: \"\\F56C\";\n}\n.mdi-view-column:before {\n  content: \"\\F56D\";\n}\n.mdi-view-dashboard:before {\n  content: \"\\F56E\";\n}\n.mdi-view-dashboard-variant:before {\n  content: \"\\F842\";\n}\n.mdi-view-day:before {\n  content: \"\\F56F\";\n}\n.mdi-view-grid:before {\n  content: \"\\F570\";\n}\n.mdi-view-headline:before {\n  content: \"\\F571\";\n}\n.mdi-view-list:before {\n  content: \"\\F572\";\n}\n.mdi-view-module:before {\n  content: \"\\F573\";\n}\n.mdi-view-parallel:before {\n  content: \"\\F727\";\n}\n.mdi-view-quilt:before {\n  content: \"\\F574\";\n}\n.mdi-view-sequential:before {\n  content: \"\\F728\";\n}\n.mdi-view-stream:before {\n  content: \"\\F575\";\n}\n.mdi-view-week:before {\n  content: \"\\F576\";\n}\n.mdi-vimeo:before {\n  content: \"\\F577\";\n}\n.mdi-violin:before {\n  content: \"\\F60F\";\n}\n.mdi-virtual-reality:before {\n  content: \"\\F893\";\n}\n.mdi-visualstudio:before {\n  content: \"\\F610\";\n}\n.mdi-vk:before {\n  content: \"\\F579\";\n}\n.mdi-vk-box:before {\n  content: \"\\F57A\";\n}\n.mdi-vk-circle:before {\n  content: \"\\F57B\";\n}\n.mdi-vlc:before {\n  content: \"\\F57C\";\n}\n.mdi-voice:before {\n  content: \"\\F5CB\";\n}\n.mdi-voicemail:before {\n  content: \"\\F57D\";\n}\n.mdi-volume-high:before {\n  content: \"\\F57E\";\n}\n.mdi-volume-low:before {\n  content: \"\\F57F\";\n}\n.mdi-volume-medium:before {\n  content: \"\\F580\";\n}\n.mdi-volume-minus:before {\n  content: \"\\F75D\";\n}\n.mdi-volume-mute:before {\n  content: \"\\F75E\";\n}\n.mdi-volume-off:before {\n  content: \"\\F581\";\n}\n.mdi-volume-plus:before {\n  content: \"\\F75C\";\n}\n.mdi-vpn:before {\n  content: \"\\F582\";\n}\n.mdi-vuejs:before {\n  content: \"\\F843\";\n}\n.mdi-walk:before {\n  content: \"\\F583\";\n}\n.mdi-wall:before {\n  content: \"\\F7FD\";\n}\n.mdi-wallet:before {\n  content: \"\\F584\";\n}\n.mdi-wallet-giftcard:before {\n  content: \"\\F585\";\n}\n.mdi-wallet-membership:before {\n  content: \"\\F586\";\n}\n.mdi-wallet-travel:before {\n  content: \"\\F587\";\n}\n.mdi-wan:before {\n  content: \"\\F588\";\n}\n.mdi-washing-machine:before {\n  content: \"\\F729\";\n}\n.mdi-watch:before {\n  content: \"\\F589\";\n}\n.mdi-watch-export:before {\n  content: \"\\F58A\";\n}\n.mdi-watch-export-variant:before {\n  content: \"\\F894\";\n}\n.mdi-watch-import:before {\n  content: \"\\F58B\";\n}\n.mdi-watch-import-variant:before {\n  content: \"\\F895\";\n}\n.mdi-watch-variant:before {\n  content: \"\\F896\";\n}\n.mdi-watch-vibrate:before {\n  content: \"\\F6B0\";\n}\n.mdi-water:before {\n  content: \"\\F58C\";\n}\n.mdi-water-off:before {\n  content: \"\\F58D\";\n}\n.mdi-water-percent:before {\n  content: \"\\F58E\";\n}\n.mdi-water-pump:before {\n  content: \"\\F58F\";\n}\n.mdi-watermark:before {\n  content: \"\\F612\";\n}\n.mdi-waves:before {\n  content: \"\\F78C\";\n}\n.mdi-weather-cloudy:before {\n  content: \"\\F590\";\n}\n.mdi-weather-fog:before {\n  content: \"\\F591\";\n}\n.mdi-weather-hail:before {\n  content: \"\\F592\";\n}\n.mdi-weather-hurricane:before {\n  content: \"\\F897\";\n}\n.mdi-weather-lightning:before {\n  content: \"\\F593\";\n}\n.mdi-weather-lightning-rainy:before {\n  content: \"\\F67D\";\n}\n.mdi-weather-night:before {\n  content: \"\\F594\";\n}\n.mdi-weather-partlycloudy:before {\n  content: \"\\F595\";\n}\n.mdi-weather-pouring:before {\n  content: \"\\F596\";\n}\n.mdi-weather-rainy:before {\n  content: \"\\F597\";\n}\n.mdi-weather-snowy:before {\n  content: \"\\F598\";\n}\n.mdi-weather-snowy-rainy:before {\n  content: \"\\F67E\";\n}\n.mdi-weather-sunny:before {\n  content: \"\\F599\";\n}\n.mdi-weather-sunset:before {\n  content: \"\\F59A\";\n}\n.mdi-weather-sunset-down:before {\n  content: \"\\F59B\";\n}\n.mdi-weather-sunset-up:before {\n  content: \"\\F59C\";\n}\n.mdi-weather-windy:before {\n  content: \"\\F59D\";\n}\n.mdi-weather-windy-variant:before {\n  content: \"\\F59E\";\n}\n.mdi-web:before {\n  content: \"\\F59F\";\n}\n.mdi-webcam:before {\n  content: \"\\F5A0\";\n}\n.mdi-webhook:before {\n  content: \"\\F62F\";\n}\n.mdi-webpack:before {\n  content: \"\\F72A\";\n}\n.mdi-wechat:before {\n  content: \"\\F611\";\n}\n.mdi-weight:before {\n  content: \"\\F5A1\";\n}\n.mdi-weight-kilogram:before {\n  content: \"\\F5A2\";\n}\n.mdi-whatsapp:before {\n  content: \"\\F5A3\";\n}\n.mdi-wheelchair-accessibility:before {\n  content: \"\\F5A4\";\n}\n.mdi-white-balance-auto:before {\n  content: \"\\F5A5\";\n}\n.mdi-white-balance-incandescent:before {\n  content: \"\\F5A6\";\n}\n.mdi-white-balance-iridescent:before {\n  content: \"\\F5A7\";\n}\n.mdi-white-balance-sunny:before {\n  content: \"\\F5A8\";\n}\n.mdi-widgets:before {\n  content: \"\\F72B\";\n}\n.mdi-wifi:before {\n  content: \"\\F5A9\";\n}\n.mdi-wifi-off:before {\n  content: \"\\F5AA\";\n}\n.mdi-wii:before {\n  content: \"\\F5AB\";\n}\n.mdi-wiiu:before {\n  content: \"\\F72C\";\n}\n.mdi-wikipedia:before {\n  content: \"\\F5AC\";\n}\n.mdi-window-close:before {\n  content: \"\\F5AD\";\n}\n.mdi-window-closed:before {\n  content: \"\\F5AE\";\n}\n.mdi-window-maximize:before {\n  content: \"\\F5AF\";\n}\n.mdi-window-minimize:before {\n  content: \"\\F5B0\";\n}\n.mdi-window-open:before {\n  content: \"\\F5B1\";\n}\n.mdi-window-restore:before {\n  content: \"\\F5B2\";\n}\n.mdi-windows:before {\n  content: \"\\F5B3\";\n}\n.mdi-wordpress:before {\n  content: \"\\F5B4\";\n}\n.mdi-worker:before {\n  content: \"\\F5B5\";\n}\n.mdi-wrap:before {\n  content: \"\\F5B6\";\n}\n.mdi-wrench:before {\n  content: \"\\F5B7\";\n}\n.mdi-wunderlist:before {\n  content: \"\\F5B8\";\n}\n.mdi-xamarin:before {\n  content: \"\\F844\";\n}\n.mdi-xamarin-outline:before {\n  content: \"\\F845\";\n}\n.mdi-xaml:before {\n  content: \"\\F673\";\n}\n.mdi-xbox:before {\n  content: \"\\F5B9\";\n}\n.mdi-xbox-controller:before {\n  content: \"\\F5BA\";\n}\n.mdi-xbox-controller-battery-alert:before {\n  content: \"\\F74A\";\n}\n.mdi-xbox-controller-battery-empty:before {\n  content: \"\\F74B\";\n}\n.mdi-xbox-controller-battery-full:before {\n  content: \"\\F74C\";\n}\n.mdi-xbox-controller-battery-low:before {\n  content: \"\\F74D\";\n}\n.mdi-xbox-controller-battery-medium:before {\n  content: \"\\F74E\";\n}\n.mdi-xbox-controller-battery-unknown:before {\n  content: \"\\F74F\";\n}\n.mdi-xbox-controller-off:before {\n  content: \"\\F5BB\";\n}\n.mdi-xda:before {\n  content: \"\\F5BC\";\n}\n.mdi-xing:before {\n  content: \"\\F5BD\";\n}\n.mdi-xing-box:before {\n  content: \"\\F5BE\";\n}\n.mdi-xing-circle:before {\n  content: \"\\F5BF\";\n}\n.mdi-xml:before {\n  content: \"\\F5C0\";\n}\n.mdi-xmpp:before {\n  content: \"\\F7FE\";\n}\n.mdi-yammer:before {\n  content: \"\\F788\";\n}\n.mdi-yeast:before {\n  content: \"\\F5C1\";\n}\n.mdi-yelp:before {\n  content: \"\\F5C2\";\n}\n.mdi-yin-yang:before {\n  content: \"\\F67F\";\n}\n.mdi-youtube-creator-studio:before {\n  content: \"\\F846\";\n}\n.mdi-youtube-gaming:before {\n  content: \"\\F847\";\n}\n.mdi-youtube-play:before {\n  content: \"\\F5C3\";\n}\n.mdi-youtube-tv:before {\n  content: \"\\F448\";\n}\n.mdi-zip-box:before {\n  content: \"\\F5C4\";\n}\n.mdi-blank:before {\n  content: \"\\F68C\";\n  visibility: hidden;\n}\n.mdi-18px.mdi-set,\n.mdi-18px.mdi:before {\n  font-size: 18px;\n}\n.mdi-24px.mdi-set,\n.mdi-24px.mdi:before {\n  font-size: 24px;\n}\n.mdi-36px.mdi-set,\n.mdi-36px.mdi:before {\n  font-size: 36px;\n}\n.mdi-48px.mdi-set,\n.mdi-48px.mdi:before {\n  font-size: 48px;\n}\n.mdi-dark:before {\n  color: rgba(0, 0, 0, .54);\n}\n.mdi-dark.mdi-inactive:before {\n  color: rgba(0, 0, 0, .26);\n}\n.mdi-light:before {\n  color: white;\n}\n.mdi-light.mdi-inactive:before {\n  color: rgba(255, 255, 255, .3);\n}\n.mdi-rotate-45 {\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(45deg);\r\n            transform: scaleX(-1) rotate(45deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(45deg);\r\n            -ms-transform: rotate(45deg);\r\n            transform: scaleY(-1) rotate(45deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\n}\n.mdi-rotate-45:before {\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n.mdi-rotate-90 {\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(90deg);\r\n            transform: scaleX(-1) rotate(90deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(90deg);\r\n            -ms-transform: rotate(90deg);\r\n            transform: scaleY(-1) rotate(90deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\n}\n.mdi-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.mdi-rotate-135 {\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(135deg);\r\n            transform: scaleX(-1) rotate(135deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(135deg);\r\n            -ms-transform: rotate(135deg);\r\n            transform: scaleY(-1) rotate(135deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\n}\n.mdi-rotate-135:before {\n  -webkit-transform: rotate(135deg);\n          transform: rotate(135deg);\n}\n.mdi-rotate-180 {\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(180deg);\r\n            transform: scaleX(-1) rotate(180deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(180deg);\r\n            -ms-transform: rotate(180deg);\r\n            transform: scaleY(-1) rotate(180deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\n}\n.mdi-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n.mdi-rotate-225 {\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(225deg);\r\n            transform: scaleX(-1) rotate(225deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(225deg);\r\n            -ms-transform: rotate(225deg);\r\n            transform: scaleY(-1) rotate(225deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\n}\n.mdi-rotate-225:before {\n  -webkit-transform: rotate(225deg);\n          transform: rotate(225deg);\n}\n.mdi-rotate-270 {\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(270deg);\r\n            transform: scaleX(-1) rotate(270deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(270deg);\r\n            -ms-transform: rotate(270deg);\r\n            transform: scaleY(-1) rotate(270deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\n}\n.mdi-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n.mdi-rotate-315 {\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(315deg);\r\n            transform: scaleX(-1) rotate(315deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(315deg);\r\n            -ms-transform: rotate(315deg);\r\n            transform: scaleY(-1) rotate(315deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\n}\n.mdi-rotate-315:before {\n  -webkit-transform: rotate(315deg);\n          transform: rotate(315deg);\n}\n.mdi-flip-h:before {\n  -webkit-transform: scaleX(-1);\n          transform: scaleX(-1);\n  -webkit-filter: FlipH;\n          filter: FlipH;\n      -ms-filter: \"FlipH\";\n}\n.mdi-flip-v:before {\n  -webkit-transform: scaleY(-1);\n          transform: scaleY(-1);\n  -webkit-filter: FlipV;\n          filter: FlipV;\n      -ms-filter: \"FlipV\";\n}\n.mdi-spin:before {\n  -webkit-animation: mdi-spin 2s infinite linear;\n          animation: mdi-spin 2s infinite linear;\n}\n@-webkit-keyframes mdi-spin {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n@keyframes mdi-spin {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\nhtml {\n  background-color: #f8fafc;\n}\n.card {\n  border-radius: .25rem;\n  background-color: #fff;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .1);\n  position: relative;\n  margin-top: -6rem;\n}\n#heading {\n  background-image: url(\"/static/img/heading_background.png\");\n  background-repeat: no-repeat;\n  background-position: center bottom;\n}\n.transition {\n  -webkit-transition: all .25s ease;\n          transition: all .25s ease;\n}\n.bg-google:disabled,\n.bg-facebook:disabled {\n  cursor: not-allowed;\n  opacity: .75;\n}\n.bubble {\n  background: #fff;\n  border: 1px solid #dae1e7;\n  border-radius: 5px;\n  color: #606f7b;\n  margin-bottom: 15px;\n  position: relative;\n}\n.bubble .bubble-text {\n  padding: 15px;\n}\n.bubble::before {\n  content: ' ';\n  position: absolute;\n  width: 0;\n  height: 0;\n  left: -20px;\n  right: auto;\n  top: auto;\n  bottom: 10px;\n  border: 10px solid;\n  border-color: transparent #dae1e7 transparent transparent;\n}\n.bubble::after {\n  content: ' ';\n  position: absolute;\n  width: 0;\n  height: 0;\n  left: -16px;\n  right: auto;\n  top: auto;\n  bottom: 12px;\n  border: 8px solid;\n  border-color: transparent #fff transparent transparent;\n}\na {\n  text-decoration: none;\n}\na:focus,\na:active {\n  outline: 0;\n}\nbutton:focus,\nbutton:active {\n  outline: 0;\n}\n.outline-0,\n.outline-0:focus,\n.outline-0:active {\n  outline: 0;\n}\n.animated:before {\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n}\n.animated.infinite:before {\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n}\n@-webkit-keyframes pulse {\nfrom {\n    -webkit-transform: scale3d(1, 1, 1);\n            transform: scale3d(1, 1, 1);\n}\n50% {\n    -webkit-transform: scale3d(1.2, 1.2, 1.2);\n            transform: scale3d(1.2, 1.2, 1.2);\n}\nto {\n    -webkit-transform: scale3d(1, 1, 1);\n            transform: scale3d(1, 1, 1);\n}\n}\n@keyframes pulse {\nfrom {\n    -webkit-transform: scale3d(1, 1, 1);\n            transform: scale3d(1, 1, 1);\n}\n50% {\n    -webkit-transform: scale3d(1.2, 1.2, 1.2);\n            transform: scale3d(1.2, 1.2, 1.2);\n}\nto {\n    -webkit-transform: scale3d(1, 1, 1);\n            transform: scale3d(1, 1, 1);\n}\n}\n.pulse:before {\n  -webkit-animation-name: pulse;\n          animation-name: pulse;\n}\n.pac-container.pac-logo {\n  border-radius: .25rem;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .1);\n  border-top: none;\n}\n.pac-container.pac-logo .pac-item:first-of-type {\n  border-top: none;\n}\n.pac-container.pac-logo .pac-item:last-of-type {\n  border-bottom: 1px solid #e6e6e6;\n}\n.pac-container.pac-logo::after {\n  height: 26px;\n  background-position: top 6px right 10px;\n}\n.appearance-none {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n.tooltip {\n  position: relative;\n}\n.tooltip-text {\n  width: 180px;\n  visibility: hidden;\n  text-align: center;\n  padding: 2px;\n  position: absolute;\n  z-index: 100;\n  top: -50px;\n  left: 0;\n  font-size: 12px;\n  background: white;\n  color: black;\n  border: 1px solid rgba(0, 0, 0, .2);\n  border-radius: 5px;\n}\n.tooltip:hover .tooltip-text {\n  visibility: visible;\n}\n@media (min-width: 576px) {\n.sm\\:list-reset {\n    list-style: none;\n    padding: 0;\n}\n.sm\\:appearance-none {\n    appearance: none;\n}\n.sm\\:bg-fixed {\n    background-attachment: fixed;\n}\n.sm\\:bg-local {\n    background-attachment: local;\n}\n.sm\\:bg-scroll {\n    background-attachment: scroll;\n}\n.sm\\:bg-transparent {\n    background-color: transparent;\n}\n.sm\\:bg-modal {\n    background-color: rgba(0, 0, 0, .4);\n}\n.sm\\:bg-google {\n    background-color: #dc5b5b;\n}\n.sm\\:bg-google-dark {\n    background-color: #da5050;\n}\n.sm\\:bg-facebook {\n    background-color: #3b5998;\n}\n.sm\\:bg-facebook-dark {\n    background-color: #37548f;\n}\n.sm\\:bg-primary {\n    background-color: #2196f3;\n}\n.sm\\:bg-primary-dark {\n    background-color: #3b5998;\n}\n.sm\\:bg-footer {\n    background-color: #1976d2;\n}\n.sm\\:bg-black {\n    background-color: #22292f;\n}\n.sm\\:bg-grey-darkest {\n    background-color: #3d4852;\n}\n.sm\\:bg-grey-darker {\n    background-color: #606f7b;\n}\n.sm\\:bg-grey-dark {\n    background-color: #8795a1;\n}\n.sm\\:bg-grey {\n    background-color: #b8c2cc;\n}\n.sm\\:bg-grey-light {\n    background-color: #dae1e7;\n}\n.sm\\:bg-grey-lighter {\n    background-color: #f1f5f8;\n}\n.sm\\:bg-grey-lightest {\n    background-color: #f8fafc;\n}\n.sm\\:bg-white {\n    background-color: #fff;\n}\n.sm\\:bg-whiter {\n    background-color: rgba(255, 255, 255, .6);\n}\n.sm\\:bg-red-darkest {\n    background-color: #3b0d0c;\n}\n.sm\\:bg-red-darker {\n    background-color: #621b18;\n}\n.sm\\:bg-red-dark {\n    background-color: #cc1f1a;\n}\n.sm\\:bg-red {\n    background-color: #e3342f;\n}\n.sm\\:bg-red-light {\n    background-color: #ef5753;\n}\n.sm\\:bg-red-lighter {\n    background-color: #f9acaa;\n}\n.sm\\:bg-red-lightest {\n    background-color: #fcebea;\n}\n.sm\\:bg-orange-darkest {\n    background-color: #462a16;\n}\n.sm\\:bg-orange-darker {\n    background-color: #613b1f;\n}\n.sm\\:bg-orange-dark {\n    background-color: #de751f;\n}\n.sm\\:bg-orange {\n    background-color: #f6993f;\n}\n.sm\\:bg-orange-light {\n    background-color: #faad63;\n}\n.sm\\:bg-orange-lighter {\n    background-color: #fcd9b6;\n}\n.sm\\:bg-orange-lightest {\n    background-color: #fff5eb;\n}\n.sm\\:bg-yellow-darkest {\n    background-color: #453411;\n}\n.sm\\:bg-yellow-darker {\n    background-color: #684f1d;\n}\n.sm\\:bg-yellow-dark {\n    background-color: #f2d024;\n}\n.sm\\:bg-yellow {\n    background-color: #ffed4a;\n}\n.sm\\:bg-yellow-light {\n    background-color: #fff382;\n}\n.sm\\:bg-yellow-lighter {\n    background-color: #fff9c2;\n}\n.sm\\:bg-yellow-lightest {\n    background-color: #fcfbeb;\n}\n.sm\\:bg-green-darkest {\n    background-color: #0f2f21;\n}\n.sm\\:bg-green-darker {\n    background-color: #1a4731;\n}\n.sm\\:bg-green-dark {\n    background-color: #1f9d55;\n}\n.sm\\:bg-green {\n    background-color: #38c172;\n}\n.sm\\:bg-green-light {\n    background-color: #51d88a;\n}\n.sm\\:bg-green-lighter {\n    background-color: #a2f5bf;\n}\n.sm\\:bg-green-lightest {\n    background-color: #e3fcec;\n}\n.sm\\:bg-teal-darkest {\n    background-color: #0d3331;\n}\n.sm\\:bg-teal-darker {\n    background-color: #20504f;\n}\n.sm\\:bg-teal-dark {\n    background-color: #009480;\n}\n.sm\\:bg-teal {\n    background-color: #00ae98;\n}\n.sm\\:bg-teal-light {\n    background-color: #64d5ca;\n}\n.sm\\:bg-teal-lighter {\n    background-color: #a0f0ed;\n}\n.sm\\:bg-teal-lightest {\n    background-color: #e8fffe;\n}\n.sm\\:bg-blue-darkest {\n    background-color: #12283a;\n}\n.sm\\:bg-blue-darker {\n    background-color: #2e6da2;\n}\n.sm\\:bg-blue-dark {\n    background-color: #2779bd;\n}\n.sm\\:bg-blue {\n    background-color: #3490dc;\n}\n.sm\\:bg-blue-light {\n    background-color: #6cb2eb;\n}\n.sm\\:bg-blue-lighter {\n    background-color: #bcdefa;\n}\n.sm\\:bg-blue-lightest {\n    background-color: #eff8ff;\n}\n.sm\\:bg-indigo-darkest {\n    background-color: #191e38;\n}\n.sm\\:bg-indigo-darker {\n    background-color: #2f365f;\n}\n.sm\\:bg-indigo-dark {\n    background-color: #5661b3;\n}\n.sm\\:bg-indigo {\n    background-color: #6574cd;\n}\n.sm\\:bg-indigo-light {\n    background-color: #7886d7;\n}\n.sm\\:bg-indigo-lighter {\n    background-color: #b2b7ff;\n}\n.sm\\:bg-indigo-lightest {\n    background-color: #e6e8ff;\n}\n.sm\\:bg-purple-darkest {\n    background-color: #21183c;\n}\n.sm\\:bg-purple-darker {\n    background-color: #382b5f;\n}\n.sm\\:bg-purple-dark {\n    background-color: #794acf;\n}\n.sm\\:bg-purple {\n    background-color: #9561e2;\n}\n.sm\\:bg-purple-light {\n    background-color: #a779e9;\n}\n.sm\\:bg-purple-lighter {\n    background-color: #d6bbfc;\n}\n.sm\\:bg-purple-lightest {\n    background-color: #f3ebff;\n}\n.sm\\:bg-pink-darkest {\n    background-color: #451225;\n}\n.sm\\:bg-pink-darker {\n    background-color: #6f213f;\n}\n.sm\\:bg-pink-dark {\n    background-color: #eb5286;\n}\n.sm\\:bg-pink {\n    background-color: #f66d9b;\n}\n.sm\\:bg-pink-light {\n    background-color: #fa7ea8;\n}\n.sm\\:bg-pink-lighter {\n    background-color: #ffbbca;\n}\n.sm\\:bg-pink-lightest {\n    background-color: #ffebef;\n}\n.sm\\:group:hover .group-hover\\:bg-transparent {\n    background-color: transparent;\n}\n.sm\\:group:hover .group-hover\\:bg-modal {\n    background-color: rgba(0, 0, 0, .4);\n}\n.sm\\:group:hover .group-hover\\:bg-google {\n    background-color: #dc5b5b;\n}\n.sm\\:group:hover .group-hover\\:bg-google-dark {\n    background-color: #da5050;\n}\n.sm\\:group:hover .group-hover\\:bg-facebook {\n    background-color: #3b5998;\n}\n.sm\\:group:hover .group-hover\\:bg-facebook-dark {\n    background-color: #37548f;\n}\n.sm\\:group:hover .group-hover\\:bg-primary {\n    background-color: #2196f3;\n}\n.sm\\:group:hover .group-hover\\:bg-primary-dark {\n    background-color: #3b5998;\n}\n.sm\\:group:hover .group-hover\\:bg-footer {\n    background-color: #1976d2;\n}\n.sm\\:group:hover .group-hover\\:bg-black {\n    background-color: #22292f;\n}\n.sm\\:group:hover .group-hover\\:bg-grey-darkest {\n    background-color: #3d4852;\n}\n.sm\\:group:hover .group-hover\\:bg-grey-darker {\n    background-color: #606f7b;\n}\n.sm\\:group:hover .group-hover\\:bg-grey-dark {\n    background-color: #8795a1;\n}\n.sm\\:group:hover .group-hover\\:bg-grey {\n    background-color: #b8c2cc;\n}\n.sm\\:group:hover .group-hover\\:bg-grey-light {\n    background-color: #dae1e7;\n}\n.sm\\:group:hover .group-hover\\:bg-grey-lighter {\n    background-color: #f1f5f8;\n}\n.sm\\:group:hover .group-hover\\:bg-grey-lightest {\n    background-color: #f8fafc;\n}\n.sm\\:group:hover .group-hover\\:bg-white {\n    background-color: #fff;\n}\n.sm\\:group:hover .group-hover\\:bg-whiter {\n    background-color: rgba(255, 255, 255, .6);\n}\n.sm\\:group:hover .group-hover\\:bg-red-darkest {\n    background-color: #3b0d0c;\n}\n.sm\\:group:hover .group-hover\\:bg-red-darker {\n    background-color: #621b18;\n}\n.sm\\:group:hover .group-hover\\:bg-red-dark {\n    background-color: #cc1f1a;\n}\n.sm\\:group:hover .group-hover\\:bg-red {\n    background-color: #e3342f;\n}\n.sm\\:group:hover .group-hover\\:bg-red-light {\n    background-color: #ef5753;\n}\n.sm\\:group:hover .group-hover\\:bg-red-lighter {\n    background-color: #f9acaa;\n}\n.sm\\:group:hover .group-hover\\:bg-red-lightest {\n    background-color: #fcebea;\n}\n.sm\\:group:hover .group-hover\\:bg-orange-darkest {\n    background-color: #462a16;\n}\n.sm\\:group:hover .group-hover\\:bg-orange-darker {\n    background-color: #613b1f;\n}\n.sm\\:group:hover .group-hover\\:bg-orange-dark {\n    background-color: #de751f;\n}\n.sm\\:group:hover .group-hover\\:bg-orange {\n    background-color: #f6993f;\n}\n.sm\\:group:hover .group-hover\\:bg-orange-light {\n    background-color: #faad63;\n}\n.sm\\:group:hover .group-hover\\:bg-orange-lighter {\n    background-color: #fcd9b6;\n}\n.sm\\:group:hover .group-hover\\:bg-orange-lightest {\n    background-color: #fff5eb;\n}\n.sm\\:group:hover .group-hover\\:bg-yellow-darkest {\n    background-color: #453411;\n}\n.sm\\:group:hover .group-hover\\:bg-yellow-darker {\n    background-color: #684f1d;\n}\n.sm\\:group:hover .group-hover\\:bg-yellow-dark {\n    background-color: #f2d024;\n}\n.sm\\:group:hover .group-hover\\:bg-yellow {\n    background-color: #ffed4a;\n}\n.sm\\:group:hover .group-hover\\:bg-yellow-light {\n    background-color: #fff382;\n}\n.sm\\:group:hover .group-hover\\:bg-yellow-lighter {\n    background-color: #fff9c2;\n}\n.sm\\:group:hover .group-hover\\:bg-yellow-lightest {\n    background-color: #fcfbeb;\n}\n.sm\\:group:hover .group-hover\\:bg-green-darkest {\n    background-color: #0f2f21;\n}\n.sm\\:group:hover .group-hover\\:bg-green-darker {\n    background-color: #1a4731;\n}\n.sm\\:group:hover .group-hover\\:bg-green-dark {\n    background-color: #1f9d55;\n}\n.sm\\:group:hover .group-hover\\:bg-green {\n    background-color: #38c172;\n}\n.sm\\:group:hover .group-hover\\:bg-green-light {\n    background-color: #51d88a;\n}\n.sm\\:group:hover .group-hover\\:bg-green-lighter {\n    background-color: #a2f5bf;\n}\n.sm\\:group:hover .group-hover\\:bg-green-lightest {\n    background-color: #e3fcec;\n}\n.sm\\:group:hover .group-hover\\:bg-teal-darkest {\n    background-color: #0d3331;\n}\n.sm\\:group:hover .group-hover\\:bg-teal-darker {\n    background-color: #20504f;\n}\n.sm\\:group:hover .group-hover\\:bg-teal-dark {\n    background-color: #009480;\n}\n.sm\\:group:hover .group-hover\\:bg-teal {\n    background-color: #00ae98;\n}\n.sm\\:group:hover .group-hover\\:bg-teal-light {\n    background-color: #64d5ca;\n}\n.sm\\:group:hover .group-hover\\:bg-teal-lighter {\n    background-color: #a0f0ed;\n}\n.sm\\:group:hover .group-hover\\:bg-teal-lightest {\n    background-color: #e8fffe;\n}\n.sm\\:group:hover .group-hover\\:bg-blue-darkest {\n    background-color: #12283a;\n}\n.sm\\:group:hover .group-hover\\:bg-blue-darker {\n    background-color: #2e6da2;\n}\n.sm\\:group:hover .group-hover\\:bg-blue-dark {\n    background-color: #2779bd;\n}\n.sm\\:group:hover .group-hover\\:bg-blue {\n    background-color: #3490dc;\n}\n.sm\\:group:hover .group-hover\\:bg-blue-light {\n    background-color: #6cb2eb;\n}\n.sm\\:group:hover .group-hover\\:bg-blue-lighter {\n    background-color: #bcdefa;\n}\n.sm\\:group:hover .group-hover\\:bg-blue-lightest {\n    background-color: #eff8ff;\n}\n.sm\\:group:hover .group-hover\\:bg-indigo-darkest {\n    background-color: #191e38;\n}\n.sm\\:group:hover .group-hover\\:bg-indigo-darker {\n    background-color: #2f365f;\n}\n.sm\\:group:hover .group-hover\\:bg-indigo-dark {\n    background-color: #5661b3;\n}\n.sm\\:group:hover .group-hover\\:bg-indigo {\n    background-color: #6574cd;\n}\n.sm\\:group:hover .group-hover\\:bg-indigo-light {\n    background-color: #7886d7;\n}\n.sm\\:group:hover .group-hover\\:bg-indigo-lighter {\n    background-color: #b2b7ff;\n}\n.sm\\:group:hover .group-hover\\:bg-indigo-lightest {\n    background-color: #e6e8ff;\n}\n.sm\\:group:hover .group-hover\\:bg-purple-darkest {\n    background-color: #21183c;\n}\n.sm\\:group:hover .group-hover\\:bg-purple-darker {\n    background-color: #382b5f;\n}\n.sm\\:group:hover .group-hover\\:bg-purple-dark {\n    background-color: #794acf;\n}\n.sm\\:group:hover .group-hover\\:bg-purple {\n    background-color: #9561e2;\n}\n.sm\\:group:hover .group-hover\\:bg-purple-light {\n    background-color: #a779e9;\n}\n.sm\\:group:hover .group-hover\\:bg-purple-lighter {\n    background-color: #d6bbfc;\n}\n.sm\\:group:hover .group-hover\\:bg-purple-lightest {\n    background-color: #f3ebff;\n}\n.sm\\:group:hover .group-hover\\:bg-pink-darkest {\n    background-color: #451225;\n}\n.sm\\:group:hover .group-hover\\:bg-pink-darker {\n    background-color: #6f213f;\n}\n.sm\\:group:hover .group-hover\\:bg-pink-dark {\n    background-color: #eb5286;\n}\n.sm\\:group:hover .group-hover\\:bg-pink {\n    background-color: #f66d9b;\n}\n.sm\\:group:hover .group-hover\\:bg-pink-light {\n    background-color: #fa7ea8;\n}\n.sm\\:group:hover .group-hover\\:bg-pink-lighter {\n    background-color: #ffbbca;\n}\n.sm\\:group:hover .group-hover\\:bg-pink-lightest {\n    background-color: #ffebef;\n}\n.sm\\:hover\\:bg-transparent:hover {\n    background-color: transparent;\n}\n.sm\\:hover\\:bg-modal:hover {\n    background-color: rgba(0, 0, 0, .4);\n}\n.sm\\:hover\\:bg-google:hover {\n    background-color: #dc5b5b;\n}\n.sm\\:hover\\:bg-google-dark:hover {\n    background-color: #da5050;\n}\n.sm\\:hover\\:bg-facebook:hover {\n    background-color: #3b5998;\n}\n.sm\\:hover\\:bg-facebook-dark:hover {\n    background-color: #37548f;\n}\n.sm\\:hover\\:bg-primary:hover {\n    background-color: #2196f3;\n}\n.sm\\:hover\\:bg-primary-dark:hover {\n    background-color: #3b5998;\n}\n.sm\\:hover\\:bg-footer:hover {\n    background-color: #1976d2;\n}\n.sm\\:hover\\:bg-black:hover {\n    background-color: #22292f;\n}\n.sm\\:hover\\:bg-grey-darkest:hover {\n    background-color: #3d4852;\n}\n.sm\\:hover\\:bg-grey-darker:hover {\n    background-color: #606f7b;\n}\n.sm\\:hover\\:bg-grey-dark:hover {\n    background-color: #8795a1;\n}\n.sm\\:hover\\:bg-grey:hover {\n    background-color: #b8c2cc;\n}\n.sm\\:hover\\:bg-grey-light:hover {\n    background-color: #dae1e7;\n}\n.sm\\:hover\\:bg-grey-lighter:hover {\n    background-color: #f1f5f8;\n}\n.sm\\:hover\\:bg-grey-lightest:hover {\n    background-color: #f8fafc;\n}\n.sm\\:hover\\:bg-white:hover {\n    background-color: #fff;\n}\n.sm\\:hover\\:bg-whiter:hover {\n    background-color: rgba(255, 255, 255, .6);\n}\n.sm\\:hover\\:bg-red-darkest:hover {\n    background-color: #3b0d0c;\n}\n.sm\\:hover\\:bg-red-darker:hover {\n    background-color: #621b18;\n}\n.sm\\:hover\\:bg-red-dark:hover {\n    background-color: #cc1f1a;\n}\n.sm\\:hover\\:bg-red:hover {\n    background-color: #e3342f;\n}\n.sm\\:hover\\:bg-red-light:hover {\n    background-color: #ef5753;\n}\n.sm\\:hover\\:bg-red-lighter:hover {\n    background-color: #f9acaa;\n}\n.sm\\:hover\\:bg-red-lightest:hover {\n    background-color: #fcebea;\n}\n.sm\\:hover\\:bg-orange-darkest:hover {\n    background-color: #462a16;\n}\n.sm\\:hover\\:bg-orange-darker:hover {\n    background-color: #613b1f;\n}\n.sm\\:hover\\:bg-orange-dark:hover {\n    background-color: #de751f;\n}\n.sm\\:hover\\:bg-orange:hover {\n    background-color: #f6993f;\n}\n.sm\\:hover\\:bg-orange-light:hover {\n    background-color: #faad63;\n}\n.sm\\:hover\\:bg-orange-lighter:hover {\n    background-color: #fcd9b6;\n}\n.sm\\:hover\\:bg-orange-lightest:hover {\n    background-color: #fff5eb;\n}\n.sm\\:hover\\:bg-yellow-darkest:hover {\n    background-color: #453411;\n}\n.sm\\:hover\\:bg-yellow-darker:hover {\n    background-color: #684f1d;\n}\n.sm\\:hover\\:bg-yellow-dark:hover {\n    background-color: #f2d024;\n}\n.sm\\:hover\\:bg-yellow:hover {\n    background-color: #ffed4a;\n}\n.sm\\:hover\\:bg-yellow-light:hover {\n    background-color: #fff382;\n}\n.sm\\:hover\\:bg-yellow-lighter:hover {\n    background-color: #fff9c2;\n}\n.sm\\:hover\\:bg-yellow-lightest:hover {\n    background-color: #fcfbeb;\n}\n.sm\\:hover\\:bg-green-darkest:hover {\n    background-color: #0f2f21;\n}\n.sm\\:hover\\:bg-green-darker:hover {\n    background-color: #1a4731;\n}\n.sm\\:hover\\:bg-green-dark:hover {\n    background-color: #1f9d55;\n}\n.sm\\:hover\\:bg-green:hover {\n    background-color: #38c172;\n}\n.sm\\:hover\\:bg-green-light:hover {\n    background-color: #51d88a;\n}\n.sm\\:hover\\:bg-green-lighter:hover {\n    background-color: #a2f5bf;\n}\n.sm\\:hover\\:bg-green-lightest:hover {\n    background-color: #e3fcec;\n}\n.sm\\:hover\\:bg-teal-darkest:hover {\n    background-color: #0d3331;\n}\n.sm\\:hover\\:bg-teal-darker:hover {\n    background-color: #20504f;\n}\n.sm\\:hover\\:bg-teal-dark:hover {\n    background-color: #009480;\n}\n.sm\\:hover\\:bg-teal:hover {\n    background-color: #00ae98;\n}\n.sm\\:hover\\:bg-teal-light:hover {\n    background-color: #64d5ca;\n}\n.sm\\:hover\\:bg-teal-lighter:hover {\n    background-color: #a0f0ed;\n}\n.sm\\:hover\\:bg-teal-lightest:hover {\n    background-color: #e8fffe;\n}\n.sm\\:hover\\:bg-blue-darkest:hover {\n    background-color: #12283a;\n}\n.sm\\:hover\\:bg-blue-darker:hover {\n    background-color: #2e6da2;\n}\n.sm\\:hover\\:bg-blue-dark:hover {\n    background-color: #2779bd;\n}\n.sm\\:hover\\:bg-blue:hover {\n    background-color: #3490dc;\n}\n.sm\\:hover\\:bg-blue-light:hover {\n    background-color: #6cb2eb;\n}\n.sm\\:hover\\:bg-blue-lighter:hover {\n    background-color: #bcdefa;\n}\n.sm\\:hover\\:bg-blue-lightest:hover {\n    background-color: #eff8ff;\n}\n.sm\\:hover\\:bg-indigo-darkest:hover {\n    background-color: #191e38;\n}\n.sm\\:hover\\:bg-indigo-darker:hover {\n    background-color: #2f365f;\n}\n.sm\\:hover\\:bg-indigo-dark:hover {\n    background-color: #5661b3;\n}\n.sm\\:hover\\:bg-indigo:hover {\n    background-color: #6574cd;\n}\n.sm\\:hover\\:bg-indigo-light:hover {\n    background-color: #7886d7;\n}\n.sm\\:hover\\:bg-indigo-lighter:hover {\n    background-color: #b2b7ff;\n}\n.sm\\:hover\\:bg-indigo-lightest:hover {\n    background-color: #e6e8ff;\n}\n.sm\\:hover\\:bg-purple-darkest:hover {\n    background-color: #21183c;\n}\n.sm\\:hover\\:bg-purple-darker:hover {\n    background-color: #382b5f;\n}\n.sm\\:hover\\:bg-purple-dark:hover {\n    background-color: #794acf;\n}\n.sm\\:hover\\:bg-purple:hover {\n    background-color: #9561e2;\n}\n.sm\\:hover\\:bg-purple-light:hover {\n    background-color: #a779e9;\n}\n.sm\\:hover\\:bg-purple-lighter:hover {\n    background-color: #d6bbfc;\n}\n.sm\\:hover\\:bg-purple-lightest:hover {\n    background-color: #f3ebff;\n}\n.sm\\:hover\\:bg-pink-darkest:hover {\n    background-color: #451225;\n}\n.sm\\:hover\\:bg-pink-darker:hover {\n    background-color: #6f213f;\n}\n.sm\\:hover\\:bg-pink-dark:hover {\n    background-color: #eb5286;\n}\n.sm\\:hover\\:bg-pink:hover {\n    background-color: #f66d9b;\n}\n.sm\\:hover\\:bg-pink-light:hover {\n    background-color: #fa7ea8;\n}\n.sm\\:hover\\:bg-pink-lighter:hover {\n    background-color: #ffbbca;\n}\n.sm\\:hover\\:bg-pink-lightest:hover {\n    background-color: #ffebef;\n}\n.sm\\:bg-bottom {\n    background-position: bottom;\n}\n.sm\\:bg-center {\n    background-position: center;\n}\n.sm\\:bg-left {\n    background-position: left;\n}\n.sm\\:bg-left-bottom {\n    background-position: left bottom;\n}\n.sm\\:bg-left-top {\n    background-position: left top;\n}\n.sm\\:bg-right {\n    background-position: right;\n}\n.sm\\:bg-right-bottom {\n    background-position: right bottom;\n}\n.sm\\:bg-right-top {\n    background-position: right top;\n}\n.sm\\:bg-top {\n    background-position: top;\n}\n.sm\\:bg-repeat {\n    background-repeat: repeat;\n}\n.sm\\:bg-no-repeat {\n    background-repeat: no-repeat;\n}\n.sm\\:bg-repeat-x {\n    background-repeat: repeat-x;\n}\n.sm\\:bg-repeat-y {\n    background-repeat: repeat-y;\n}\n.sm\\:bg-auto {\n    background-size: auto;\n}\n.sm\\:bg-cover {\n    background-size: cover;\n}\n.sm\\:bg-contain {\n    background-size: contain;\n}\n.sm\\:border-transparent {\n    border-color: transparent;\n}\n.sm\\:border-modal {\n    border-color: rgba(0, 0, 0, .4);\n}\n.sm\\:border-google {\n    border-color: #dc5b5b;\n}\n.sm\\:border-google-dark {\n    border-color: #da5050;\n}\n.sm\\:border-facebook {\n    border-color: #3b5998;\n}\n.sm\\:border-facebook-dark {\n    border-color: #37548f;\n}\n.sm\\:border-primary {\n    border-color: #2196f3;\n}\n.sm\\:border-primary-dark {\n    border-color: #3b5998;\n}\n.sm\\:border-footer {\n    border-color: #1976d2;\n}\n.sm\\:border-black {\n    border-color: #22292f;\n}\n.sm\\:border-grey-darkest {\n    border-color: #3d4852;\n}\n.sm\\:border-grey-darker {\n    border-color: #606f7b;\n}\n.sm\\:border-grey-dark {\n    border-color: #8795a1;\n}\n.sm\\:border-grey {\n    border-color: #b8c2cc;\n}\n.sm\\:border-grey-light {\n    border-color: #dae1e7;\n}\n.sm\\:border-grey-lighter {\n    border-color: #f1f5f8;\n}\n.sm\\:border-grey-lightest {\n    border-color: #f8fafc;\n}\n.sm\\:border-white {\n    border-color: #fff;\n}\n.sm\\:border-whiter {\n    border-color: rgba(255, 255, 255, .6);\n}\n.sm\\:border-red-darkest {\n    border-color: #3b0d0c;\n}\n.sm\\:border-red-darker {\n    border-color: #621b18;\n}\n.sm\\:border-red-dark {\n    border-color: #cc1f1a;\n}\n.sm\\:border-red {\n    border-color: #e3342f;\n}\n.sm\\:border-red-light {\n    border-color: #ef5753;\n}\n.sm\\:border-red-lighter {\n    border-color: #f9acaa;\n}\n.sm\\:border-red-lightest {\n    border-color: #fcebea;\n}\n.sm\\:border-orange-darkest {\n    border-color: #462a16;\n}\n.sm\\:border-orange-darker {\n    border-color: #613b1f;\n}\n.sm\\:border-orange-dark {\n    border-color: #de751f;\n}\n.sm\\:border-orange {\n    border-color: #f6993f;\n}\n.sm\\:border-orange-light {\n    border-color: #faad63;\n}\n.sm\\:border-orange-lighter {\n    border-color: #fcd9b6;\n}\n.sm\\:border-orange-lightest {\n    border-color: #fff5eb;\n}\n.sm\\:border-yellow-darkest {\n    border-color: #453411;\n}\n.sm\\:border-yellow-darker {\n    border-color: #684f1d;\n}\n.sm\\:border-yellow-dark {\n    border-color: #f2d024;\n}\n.sm\\:border-yellow {\n    border-color: #ffed4a;\n}\n.sm\\:border-yellow-light {\n    border-color: #fff382;\n}\n.sm\\:border-yellow-lighter {\n    border-color: #fff9c2;\n}\n.sm\\:border-yellow-lightest {\n    border-color: #fcfbeb;\n}\n.sm\\:border-green-darkest {\n    border-color: #0f2f21;\n}\n.sm\\:border-green-darker {\n    border-color: #1a4731;\n}\n.sm\\:border-green-dark {\n    border-color: #1f9d55;\n}\n.sm\\:border-green {\n    border-color: #38c172;\n}\n.sm\\:border-green-light {\n    border-color: #51d88a;\n}\n.sm\\:border-green-lighter {\n    border-color: #a2f5bf;\n}\n.sm\\:border-green-lightest {\n    border-color: #e3fcec;\n}\n.sm\\:border-teal-darkest {\n    border-color: #0d3331;\n}\n.sm\\:border-teal-darker {\n    border-color: #20504f;\n}\n.sm\\:border-teal-dark {\n    border-color: #009480;\n}\n.sm\\:border-teal {\n    border-color: #00ae98;\n}\n.sm\\:border-teal-light {\n    border-color: #64d5ca;\n}\n.sm\\:border-teal-lighter {\n    border-color: #a0f0ed;\n}\n.sm\\:border-teal-lightest {\n    border-color: #e8fffe;\n}\n.sm\\:border-blue-darkest {\n    border-color: #12283a;\n}\n.sm\\:border-blue-darker {\n    border-color: #2e6da2;\n}\n.sm\\:border-blue-dark {\n    border-color: #2779bd;\n}\n.sm\\:border-blue {\n    border-color: #3490dc;\n}\n.sm\\:border-blue-light {\n    border-color: #6cb2eb;\n}\n.sm\\:border-blue-lighter {\n    border-color: #bcdefa;\n}\n.sm\\:border-blue-lightest {\n    border-color: #eff8ff;\n}\n.sm\\:border-indigo-darkest {\n    border-color: #191e38;\n}\n.sm\\:border-indigo-darker {\n    border-color: #2f365f;\n}\n.sm\\:border-indigo-dark {\n    border-color: #5661b3;\n}\n.sm\\:border-indigo {\n    border-color: #6574cd;\n}\n.sm\\:border-indigo-light {\n    border-color: #7886d7;\n}\n.sm\\:border-indigo-lighter {\n    border-color: #b2b7ff;\n}\n.sm\\:border-indigo-lightest {\n    border-color: #e6e8ff;\n}\n.sm\\:border-purple-darkest {\n    border-color: #21183c;\n}\n.sm\\:border-purple-darker {\n    border-color: #382b5f;\n}\n.sm\\:border-purple-dark {\n    border-color: #794acf;\n}\n.sm\\:border-purple {\n    border-color: #9561e2;\n}\n.sm\\:border-purple-light {\n    border-color: #a779e9;\n}\n.sm\\:border-purple-lighter {\n    border-color: #d6bbfc;\n}\n.sm\\:border-purple-lightest {\n    border-color: #f3ebff;\n}\n.sm\\:border-pink-darkest {\n    border-color: #451225;\n}\n.sm\\:border-pink-darker {\n    border-color: #6f213f;\n}\n.sm\\:border-pink-dark {\n    border-color: #eb5286;\n}\n.sm\\:border-pink {\n    border-color: #f66d9b;\n}\n.sm\\:border-pink-light {\n    border-color: #fa7ea8;\n}\n.sm\\:border-pink-lighter {\n    border-color: #ffbbca;\n}\n.sm\\:border-pink-lightest {\n    border-color: #ffebef;\n}\n.sm\\:hover\\:border-transparent:hover {\n    border-color: transparent;\n}\n.sm\\:hover\\:border-modal:hover {\n    border-color: rgba(0, 0, 0, .4);\n}\n.sm\\:hover\\:border-google:hover {\n    border-color: #dc5b5b;\n}\n.sm\\:hover\\:border-google-dark:hover {\n    border-color: #da5050;\n}\n.sm\\:hover\\:border-facebook:hover {\n    border-color: #3b5998;\n}\n.sm\\:hover\\:border-facebook-dark:hover {\n    border-color: #37548f;\n}\n.sm\\:hover\\:border-primary:hover {\n    border-color: #2196f3;\n}\n.sm\\:hover\\:border-primary-dark:hover {\n    border-color: #3b5998;\n}\n.sm\\:hover\\:border-footer:hover {\n    border-color: #1976d2;\n}\n.sm\\:hover\\:border-black:hover {\n    border-color: #22292f;\n}\n.sm\\:hover\\:border-grey-darkest:hover {\n    border-color: #3d4852;\n}\n.sm\\:hover\\:border-grey-darker:hover {\n    border-color: #606f7b;\n}\n.sm\\:hover\\:border-grey-dark:hover {\n    border-color: #8795a1;\n}\n.sm\\:hover\\:border-grey:hover {\n    border-color: #b8c2cc;\n}\n.sm\\:hover\\:border-grey-light:hover {\n    border-color: #dae1e7;\n}\n.sm\\:hover\\:border-grey-lighter:hover {\n    border-color: #f1f5f8;\n}\n.sm\\:hover\\:border-grey-lightest:hover {\n    border-color: #f8fafc;\n}\n.sm\\:hover\\:border-white:hover {\n    border-color: #fff;\n}\n.sm\\:hover\\:border-whiter:hover {\n    border-color: rgba(255, 255, 255, .6);\n}\n.sm\\:hover\\:border-red-darkest:hover {\n    border-color: #3b0d0c;\n}\n.sm\\:hover\\:border-red-darker:hover {\n    border-color: #621b18;\n}\n.sm\\:hover\\:border-red-dark:hover {\n    border-color: #cc1f1a;\n}\n.sm\\:hover\\:border-red:hover {\n    border-color: #e3342f;\n}\n.sm\\:hover\\:border-red-light:hover {\n    border-color: #ef5753;\n}\n.sm\\:hover\\:border-red-lighter:hover {\n    border-color: #f9acaa;\n}\n.sm\\:hover\\:border-red-lightest:hover {\n    border-color: #fcebea;\n}\n.sm\\:hover\\:border-orange-darkest:hover {\n    border-color: #462a16;\n}\n.sm\\:hover\\:border-orange-darker:hover {\n    border-color: #613b1f;\n}\n.sm\\:hover\\:border-orange-dark:hover {\n    border-color: #de751f;\n}\n.sm\\:hover\\:border-orange:hover {\n    border-color: #f6993f;\n}\n.sm\\:hover\\:border-orange-light:hover {\n    border-color: #faad63;\n}\n.sm\\:hover\\:border-orange-lighter:hover {\n    border-color: #fcd9b6;\n}\n.sm\\:hover\\:border-orange-lightest:hover {\n    border-color: #fff5eb;\n}\n.sm\\:hover\\:border-yellow-darkest:hover {\n    border-color: #453411;\n}\n.sm\\:hover\\:border-yellow-darker:hover {\n    border-color: #684f1d;\n}\n.sm\\:hover\\:border-yellow-dark:hover {\n    border-color: #f2d024;\n}\n.sm\\:hover\\:border-yellow:hover {\n    border-color: #ffed4a;\n}\n.sm\\:hover\\:border-yellow-light:hover {\n    border-color: #fff382;\n}\n.sm\\:hover\\:border-yellow-lighter:hover {\n    border-color: #fff9c2;\n}\n.sm\\:hover\\:border-yellow-lightest:hover {\n    border-color: #fcfbeb;\n}\n.sm\\:hover\\:border-green-darkest:hover {\n    border-color: #0f2f21;\n}\n.sm\\:hover\\:border-green-darker:hover {\n    border-color: #1a4731;\n}\n.sm\\:hover\\:border-green-dark:hover {\n    border-color: #1f9d55;\n}\n.sm\\:hover\\:border-green:hover {\n    border-color: #38c172;\n}\n.sm\\:hover\\:border-green-light:hover {\n    border-color: #51d88a;\n}\n.sm\\:hover\\:border-green-lighter:hover {\n    border-color: #a2f5bf;\n}\n.sm\\:hover\\:border-green-lightest:hover {\n    border-color: #e3fcec;\n}\n.sm\\:hover\\:border-teal-darkest:hover {\n    border-color: #0d3331;\n}\n.sm\\:hover\\:border-teal-darker:hover {\n    border-color: #20504f;\n}\n.sm\\:hover\\:border-teal-dark:hover {\n    border-color: #009480;\n}\n.sm\\:hover\\:border-teal:hover {\n    border-color: #00ae98;\n}\n.sm\\:hover\\:border-teal-light:hover {\n    border-color: #64d5ca;\n}\n.sm\\:hover\\:border-teal-lighter:hover {\n    border-color: #a0f0ed;\n}\n.sm\\:hover\\:border-teal-lightest:hover {\n    border-color: #e8fffe;\n}\n.sm\\:hover\\:border-blue-darkest:hover {\n    border-color: #12283a;\n}\n.sm\\:hover\\:border-blue-darker:hover {\n    border-color: #2e6da2;\n}\n.sm\\:hover\\:border-blue-dark:hover {\n    border-color: #2779bd;\n}\n.sm\\:hover\\:border-blue:hover {\n    border-color: #3490dc;\n}\n.sm\\:hover\\:border-blue-light:hover {\n    border-color: #6cb2eb;\n}\n.sm\\:hover\\:border-blue-lighter:hover {\n    border-color: #bcdefa;\n}\n.sm\\:hover\\:border-blue-lightest:hover {\n    border-color: #eff8ff;\n}\n.sm\\:hover\\:border-indigo-darkest:hover {\n    border-color: #191e38;\n}\n.sm\\:hover\\:border-indigo-darker:hover {\n    border-color: #2f365f;\n}\n.sm\\:hover\\:border-indigo-dark:hover {\n    border-color: #5661b3;\n}\n.sm\\:hover\\:border-indigo:hover {\n    border-color: #6574cd;\n}\n.sm\\:hover\\:border-indigo-light:hover {\n    border-color: #7886d7;\n}\n.sm\\:hover\\:border-indigo-lighter:hover {\n    border-color: #b2b7ff;\n}\n.sm\\:hover\\:border-indigo-lightest:hover {\n    border-color: #e6e8ff;\n}\n.sm\\:hover\\:border-purple-darkest:hover {\n    border-color: #21183c;\n}\n.sm\\:hover\\:border-purple-darker:hover {\n    border-color: #382b5f;\n}\n.sm\\:hover\\:border-purple-dark:hover {\n    border-color: #794acf;\n}\n.sm\\:hover\\:border-purple:hover {\n    border-color: #9561e2;\n}\n.sm\\:hover\\:border-purple-light:hover {\n    border-color: #a779e9;\n}\n.sm\\:hover\\:border-purple-lighter:hover {\n    border-color: #d6bbfc;\n}\n.sm\\:hover\\:border-purple-lightest:hover {\n    border-color: #f3ebff;\n}\n.sm\\:hover\\:border-pink-darkest:hover {\n    border-color: #451225;\n}\n.sm\\:hover\\:border-pink-darker:hover {\n    border-color: #6f213f;\n}\n.sm\\:hover\\:border-pink-dark:hover {\n    border-color: #eb5286;\n}\n.sm\\:hover\\:border-pink:hover {\n    border-color: #f66d9b;\n}\n.sm\\:hover\\:border-pink-light:hover {\n    border-color: #fa7ea8;\n}\n.sm\\:hover\\:border-pink-lighter:hover {\n    border-color: #ffbbca;\n}\n.sm\\:hover\\:border-pink-lightest:hover {\n    border-color: #ffebef;\n}\n.sm\\:rounded-none {\n    border-radius: 0;\n}\n.sm\\:rounded-sm {\n    border-radius: .125rem;\n}\n.sm\\:rounded {\n    border-radius: .25rem;\n}\n.sm\\:rounded-lg {\n    border-radius: .5rem;\n}\n.sm\\:rounded-full {\n    border-radius: 9999px;\n}\n.sm\\:rounded-t-none {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n.sm\\:rounded-r-none {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.sm\\:rounded-b-none {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n}\n.sm\\:rounded-l-none {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n.sm\\:rounded-t-sm {\n    border-top-left-radius: .125rem;\n    border-top-right-radius: .125rem;\n}\n.sm\\:rounded-r-sm {\n    border-top-right-radius: .125rem;\n    border-bottom-right-radius: .125rem;\n}\n.sm\\:rounded-b-sm {\n    border-bottom-right-radius: .125rem;\n    border-bottom-left-radius: .125rem;\n}\n.sm\\:rounded-l-sm {\n    border-top-left-radius: .125rem;\n    border-bottom-left-radius: .125rem;\n}\n.sm\\:rounded-t {\n    border-top-left-radius: .25rem;\n    border-top-right-radius: .25rem;\n}\n.sm\\:rounded-r {\n    border-top-right-radius: .25rem;\n    border-bottom-right-radius: .25rem;\n}\n.sm\\:rounded-b {\n    border-bottom-right-radius: .25rem;\n    border-bottom-left-radius: .25rem;\n}\n.sm\\:rounded-l {\n    border-top-left-radius: .25rem;\n    border-bottom-left-radius: .25rem;\n}\n.sm\\:rounded-t-lg {\n    border-top-left-radius: .5rem;\n    border-top-right-radius: .5rem;\n}\n.sm\\:rounded-r-lg {\n    border-top-right-radius: .5rem;\n    border-bottom-right-radius: .5rem;\n}\n.sm\\:rounded-b-lg {\n    border-bottom-right-radius: .5rem;\n    border-bottom-left-radius: .5rem;\n}\n.sm\\:rounded-l-lg {\n    border-top-left-radius: .5rem;\n    border-bottom-left-radius: .5rem;\n}\n.sm\\:rounded-t-full {\n    border-top-left-radius: 9999px;\n    border-top-right-radius: 9999px;\n}\n.sm\\:rounded-r-full {\n    border-top-right-radius: 9999px;\n    border-bottom-right-radius: 9999px;\n}\n.sm\\:rounded-b-full {\n    border-bottom-right-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n}\n.sm\\:rounded-l-full {\n    border-top-left-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n}\n.sm\\:rounded-tl-none {\n    border-top-left-radius: 0;\n}\n.sm\\:rounded-tr-none {\n    border-top-right-radius: 0;\n}\n.sm\\:rounded-br-none {\n    border-bottom-right-radius: 0;\n}\n.sm\\:rounded-bl-none {\n    border-bottom-left-radius: 0;\n}\n.sm\\:rounded-tl-sm {\n    border-top-left-radius: .125rem;\n}\n.sm\\:rounded-tr-sm {\n    border-top-right-radius: .125rem;\n}\n.sm\\:rounded-br-sm {\n    border-bottom-right-radius: .125rem;\n}\n.sm\\:rounded-bl-sm {\n    border-bottom-left-radius: .125rem;\n}\n.sm\\:rounded-tl {\n    border-top-left-radius: .25rem;\n}\n.sm\\:rounded-tr {\n    border-top-right-radius: .25rem;\n}\n.sm\\:rounded-br {\n    border-bottom-right-radius: .25rem;\n}\n.sm\\:rounded-bl {\n    border-bottom-left-radius: .25rem;\n}\n.sm\\:rounded-tl-lg {\n    border-top-left-radius: .5rem;\n}\n.sm\\:rounded-tr-lg {\n    border-top-right-radius: .5rem;\n}\n.sm\\:rounded-br-lg {\n    border-bottom-right-radius: .5rem;\n}\n.sm\\:rounded-bl-lg {\n    border-bottom-left-radius: .5rem;\n}\n.sm\\:rounded-tl-full {\n    border-top-left-radius: 9999px;\n}\n.sm\\:rounded-tr-full {\n    border-top-right-radius: 9999px;\n}\n.sm\\:rounded-br-full {\n    border-bottom-right-radius: 9999px;\n}\n.sm\\:rounded-bl-full {\n    border-bottom-left-radius: 9999px;\n}\n.sm\\:border-solid {\n    border-style: solid;\n}\n.sm\\:border-dashed {\n    border-style: dashed;\n}\n.sm\\:border-dotted {\n    border-style: dotted;\n}\n.sm\\:border-none {\n    border-style: none;\n}\n.sm\\:border-0 {\n    border-width: 0;\n}\n.sm\\:border-2 {\n    border-width: 2px;\n}\n.sm\\:border-4 {\n    border-width: 4px;\n}\n.sm\\:border-8 {\n    border-width: 8px;\n}\n.sm\\:border {\n    border-width: 1px;\n}\n.sm\\:border-t-0 {\n    border-top-width: 0;\n}\n.sm\\:border-r-0 {\n    border-right-width: 0;\n}\n.sm\\:border-b-0 {\n    border-bottom-width: 0;\n}\n.sm\\:border-l-0 {\n    border-left-width: 0;\n}\n.sm\\:border-t-2 {\n    border-top-width: 2px;\n}\n.sm\\:border-r-2 {\n    border-right-width: 2px;\n}\n.sm\\:border-b-2 {\n    border-bottom-width: 2px;\n}\n.sm\\:border-l-2 {\n    border-left-width: 2px;\n}\n.sm\\:border-t-4 {\n    border-top-width: 4px;\n}\n.sm\\:border-r-4 {\n    border-right-width: 4px;\n}\n.sm\\:border-b-4 {\n    border-bottom-width: 4px;\n}\n.sm\\:border-l-4 {\n    border-left-width: 4px;\n}\n.sm\\:border-t-8 {\n    border-top-width: 8px;\n}\n.sm\\:border-r-8 {\n    border-right-width: 8px;\n}\n.sm\\:border-b-8 {\n    border-bottom-width: 8px;\n}\n.sm\\:border-l-8 {\n    border-left-width: 8px;\n}\n.sm\\:border-t {\n    border-top-width: 1px;\n}\n.sm\\:border-r {\n    border-right-width: 1px;\n}\n.sm\\:border-b {\n    border-bottom-width: 1px;\n}\n.sm\\:border-l {\n    border-left-width: 1px;\n}\n.sm\\:cursor-auto {\n    cursor: auto;\n}\n.sm\\:cursor-default {\n    cursor: default;\n}\n.sm\\:cursor-pointer {\n    cursor: pointer;\n}\n.sm\\:cursor-wait {\n    cursor: wait;\n}\n.sm\\:cursor-move {\n    cursor: move;\n}\n.sm\\:cursor-not-allowed {\n    cursor: not-allowed;\n}\n.sm\\:block {\n    display: block;\n}\n.sm\\:inline-block {\n    display: inline-block;\n}\n.sm\\:inline {\n    display: inline;\n}\n.sm\\:table {\n    display: table;\n}\n.sm\\:table-row {\n    display: table-row;\n}\n.sm\\:table-cell {\n    display: table-cell;\n}\n.sm\\:hidden {\n    display: none;\n}\n.sm\\:flex {\n    display: flex;\n}\n.sm\\:inline-flex {\n    display: inline-flex;\n}\n.sm\\:flex-row {\n    flex-direction: row;\n}\n.sm\\:flex-row-reverse {\n    flex-direction: row-reverse;\n}\n.sm\\:flex-col {\n    flex-direction: column;\n}\n.sm\\:flex-col-reverse {\n    flex-direction: column-reverse;\n}\n.sm\\:flex-wrap {\n    flex-wrap: wrap;\n}\n.sm\\:flex-wrap-reverse {\n    flex-wrap: wrap-reverse;\n}\n.sm\\:flex-no-wrap {\n    flex-wrap: nowrap;\n}\n.sm\\:items-start {\n    align-items: flex-start;\n}\n.sm\\:items-end {\n    align-items: flex-end;\n}\n.sm\\:items-center {\n    align-items: center;\n}\n.sm\\:items-baseline {\n    align-items: baseline;\n}\n.sm\\:items-stretch {\n    align-items: stretch;\n}\n.sm\\:self-auto {\n    align-self: auto;\n}\n.sm\\:self-start {\n    align-self: flex-start;\n}\n.sm\\:self-end {\n    align-self: flex-end;\n}\n.sm\\:self-center {\n    align-self: center;\n}\n.sm\\:self-stretch {\n    align-self: stretch;\n}\n.sm\\:justify-start {\n    justify-content: flex-start;\n}\n.sm\\:justify-end {\n    justify-content: flex-end;\n}\n.sm\\:justify-center {\n    justify-content: center;\n}\n.sm\\:justify-between {\n    justify-content: space-between;\n}\n.sm\\:justify-around {\n    justify-content: space-around;\n}\n.sm\\:content-center {\n    align-content: center;\n}\n.sm\\:content-start {\n    align-content: flex-start;\n}\n.sm\\:content-end {\n    align-content: flex-end;\n}\n.sm\\:content-between {\n    align-content: space-between;\n}\n.sm\\:content-around {\n    align-content: space-around;\n}\n.sm\\:flex-1 {\n    flex: 1;\n}\n.sm\\:flex-auto {\n    flex: auto;\n}\n.sm\\:flex-initial {\n    flex: initial;\n}\n.sm\\:flex-none {\n    flex: none;\n}\n.sm\\:flex-grow {\n    flex-grow: 1;\n}\n.sm\\:flex-shrink {\n    flex-shrink: 1;\n}\n.sm\\:flex-no-grow {\n    flex-grow: 0;\n}\n.sm\\:flex-no-shrink {\n    flex-shrink: 0;\n}\n.sm\\:float-right {\n    float: right;\n}\n.sm\\:float-left {\n    float: left;\n}\n.sm\\:float-none {\n    float: none;\n}\n.sm\\:clearfix:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.sm\\:font-sans {\n    font-family: system-ui, BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n}\n.sm\\:font-serif {\n    font-family: Constantia, Lucida Bright, Lucidabright, Lucida Serif, Lucida, DejaVu Serif, Bitstream Vera Serif, Liberation Serif, Georgia, serif;\n}\n.sm\\:font-mono {\n    font-family: Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;\n}\n.sm\\:font-hairline {\n    font-weight: 100;\n}\n.sm\\:font-thin {\n    font-weight: 200;\n}\n.sm\\:font-light {\n    font-weight: 300;\n}\n.sm\\:font-normal {\n    font-weight: 400;\n}\n.sm\\:font-medium {\n    font-weight: 500;\n}\n.sm\\:font-semibold {\n    font-weight: 600;\n}\n.sm\\:font-bold {\n    font-weight: 700;\n}\n.sm\\:font-extrabold {\n    font-weight: 800;\n}\n.sm\\:font-black {\n    font-weight: 900;\n}\n.sm\\:hover\\:font-hairline:hover {\n    font-weight: 100;\n}\n.sm\\:hover\\:font-thin:hover {\n    font-weight: 200;\n}\n.sm\\:hover\\:font-light:hover {\n    font-weight: 300;\n}\n.sm\\:hover\\:font-normal:hover {\n    font-weight: 400;\n}\n.sm\\:hover\\:font-medium:hover {\n    font-weight: 500;\n}\n.sm\\:hover\\:font-semibold:hover {\n    font-weight: 600;\n}\n.sm\\:hover\\:font-bold:hover {\n    font-weight: 700;\n}\n.sm\\:hover\\:font-extrabold:hover {\n    font-weight: 800;\n}\n.sm\\:hover\\:font-black:hover {\n    font-weight: 900;\n}\n.sm\\:h-1 {\n    height: .25rem;\n}\n.sm\\:h-2 {\n    height: .5rem;\n}\n.sm\\:h-3 {\n    height: .75rem;\n}\n.sm\\:h-4 {\n    height: 1rem;\n}\n.sm\\:h-6 {\n    height: 1.5rem;\n}\n.sm\\:h-8 {\n    height: 2rem;\n}\n.sm\\:h-10 {\n    height: 2.5rem;\n}\n.sm\\:h-12 {\n    height: 3rem;\n}\n.sm\\:h-16 {\n    height: 4rem;\n}\n.sm\\:h-24 {\n    height: 6rem;\n}\n.sm\\:h-32 {\n    height: 8rem;\n}\n.sm\\:h-48 {\n    height: 12rem;\n}\n.sm\\:h-64 {\n    height: 16rem;\n}\n.sm\\:h-auto {\n    height: auto;\n}\n.sm\\:h-px {\n    height: 1px;\n}\n.sm\\:h-full {\n    height: 100%;\n}\n.sm\\:h-screen {\n    height: 100vh;\n}\n.sm\\:h-screen-footer {\n    height: 80vh;\n}\n.sm\\:h-timeslots {\n    height: calc(100vh - 3rem - 1rem);\n}\n.sm\\:leading-none {\n    line-height: 1;\n}\n.sm\\:leading-tight {\n    line-height: 1.25;\n}\n.sm\\:leading-normal {\n    line-height: 1.5;\n}\n.sm\\:leading-loose {\n    line-height: 2;\n}\n.sm\\:m-0 {\n    margin: 0;\n}\n.sm\\:m-1 {\n    margin: .25rem;\n}\n.sm\\:m-2 {\n    margin: .5rem;\n}\n.sm\\:m-3 {\n    margin: .75rem;\n}\n.sm\\:m-4 {\n    margin: 1rem;\n}\n.sm\\:m-6 {\n    margin: 1.5rem;\n}\n.sm\\:m-8 {\n    margin: 2rem;\n}\n.sm\\:m-10 {\n    margin: 2.5rem;\n}\n.sm\\:m-12 {\n    margin: 3rem;\n}\n.sm\\:m-16 {\n    margin: 4rem;\n}\n.sm\\:m-24 {\n    margin: 6rem;\n}\n.sm\\:m-32 {\n    margin: 8rem;\n}\n.sm\\:m-48 {\n    margin: 10rem;\n}\n.sm\\:m-auto {\n    margin: auto;\n}\n.sm\\:m-px {\n    margin: 1px;\n}\n.sm\\:my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n.sm\\:mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n}\n.sm\\:my-1 {\n    margin-top: .25rem;\n    margin-bottom: .25rem;\n}\n.sm\\:mx-1 {\n    margin-left: .25rem;\n    margin-right: .25rem;\n}\n.sm\\:my-2 {\n    margin-top: .5rem;\n    margin-bottom: .5rem;\n}\n.sm\\:mx-2 {\n    margin-left: .5rem;\n    margin-right: .5rem;\n}\n.sm\\:my-3 {\n    margin-top: .75rem;\n    margin-bottom: .75rem;\n}\n.sm\\:mx-3 {\n    margin-left: .75rem;\n    margin-right: .75rem;\n}\n.sm\\:my-4 {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n}\n.sm\\:mx-4 {\n    margin-left: 1rem;\n    margin-right: 1rem;\n}\n.sm\\:my-6 {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n}\n.sm\\:mx-6 {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n}\n.sm\\:my-8 {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n}\n.sm\\:mx-8 {\n    margin-left: 2rem;\n    margin-right: 2rem;\n}\n.sm\\:my-10 {\n    margin-top: 2.5rem;\n    margin-bottom: 2.5rem;\n}\n.sm\\:mx-10 {\n    margin-left: 2.5rem;\n    margin-right: 2.5rem;\n}\n.sm\\:my-12 {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n}\n.sm\\:mx-12 {\n    margin-left: 3rem;\n    margin-right: 3rem;\n}\n.sm\\:my-16 {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n}\n.sm\\:mx-16 {\n    margin-left: 4rem;\n    margin-right: 4rem;\n}\n.sm\\:my-24 {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n}\n.sm\\:mx-24 {\n    margin-left: 6rem;\n    margin-right: 6rem;\n}\n.sm\\:my-32 {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n}\n.sm\\:mx-32 {\n    margin-left: 8rem;\n    margin-right: 8rem;\n}\n.sm\\:my-48 {\n    margin-top: 10rem;\n    margin-bottom: 10rem;\n}\n.sm\\:mx-48 {\n    margin-left: 10rem;\n    margin-right: 10rem;\n}\n.sm\\:my-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n}\n.sm\\:mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n}\n.sm\\:my-px {\n    margin-top: 1px;\n    margin-bottom: 1px;\n}\n.sm\\:mx-px {\n    margin-left: 1px;\n    margin-right: 1px;\n}\n.sm\\:mt-0 {\n    margin-top: 0;\n}\n.sm\\:mr-0 {\n    margin-right: 0;\n}\n.sm\\:mb-0 {\n    margin-bottom: 0;\n}\n.sm\\:ml-0 {\n    margin-left: 0;\n}\n.sm\\:mt-1 {\n    margin-top: .25rem;\n}\n.sm\\:mr-1 {\n    margin-right: .25rem;\n}\n.sm\\:mb-1 {\n    margin-bottom: .25rem;\n}\n.sm\\:ml-1 {\n    margin-left: .25rem;\n}\n.sm\\:mt-2 {\n    margin-top: .5rem;\n}\n.sm\\:mr-2 {\n    margin-right: .5rem;\n}\n.sm\\:mb-2 {\n    margin-bottom: .5rem;\n}\n.sm\\:ml-2 {\n    margin-left: .5rem;\n}\n.sm\\:mt-3 {\n    margin-top: .75rem;\n}\n.sm\\:mr-3 {\n    margin-right: .75rem;\n}\n.sm\\:mb-3 {\n    margin-bottom: .75rem;\n}\n.sm\\:ml-3 {\n    margin-left: .75rem;\n}\n.sm\\:mt-4 {\n    margin-top: 1rem;\n}\n.sm\\:mr-4 {\n    margin-right: 1rem;\n}\n.sm\\:mb-4 {\n    margin-bottom: 1rem;\n}\n.sm\\:ml-4 {\n    margin-left: 1rem;\n}\n.sm\\:mt-6 {\n    margin-top: 1.5rem;\n}\n.sm\\:mr-6 {\n    margin-right: 1.5rem;\n}\n.sm\\:mb-6 {\n    margin-bottom: 1.5rem;\n}\n.sm\\:ml-6 {\n    margin-left: 1.5rem;\n}\n.sm\\:mt-8 {\n    margin-top: 2rem;\n}\n.sm\\:mr-8 {\n    margin-right: 2rem;\n}\n.sm\\:mb-8 {\n    margin-bottom: 2rem;\n}\n.sm\\:ml-8 {\n    margin-left: 2rem;\n}\n.sm\\:mt-10 {\n    margin-top: 2.5rem;\n}\n.sm\\:mr-10 {\n    margin-right: 2.5rem;\n}\n.sm\\:mb-10 {\n    margin-bottom: 2.5rem;\n}\n.sm\\:ml-10 {\n    margin-left: 2.5rem;\n}\n.sm\\:mt-12 {\n    margin-top: 3rem;\n}\n.sm\\:mr-12 {\n    margin-right: 3rem;\n}\n.sm\\:mb-12 {\n    margin-bottom: 3rem;\n}\n.sm\\:ml-12 {\n    margin-left: 3rem;\n}\n.sm\\:mt-16 {\n    margin-top: 4rem;\n}\n.sm\\:mr-16 {\n    margin-right: 4rem;\n}\n.sm\\:mb-16 {\n    margin-bottom: 4rem;\n}\n.sm\\:ml-16 {\n    margin-left: 4rem;\n}\n.sm\\:mt-24 {\n    margin-top: 6rem;\n}\n.sm\\:mr-24 {\n    margin-right: 6rem;\n}\n.sm\\:mb-24 {\n    margin-bottom: 6rem;\n}\n.sm\\:ml-24 {\n    margin-left: 6rem;\n}\n.sm\\:mt-32 {\n    margin-top: 8rem;\n}\n.sm\\:mr-32 {\n    margin-right: 8rem;\n}\n.sm\\:mb-32 {\n    margin-bottom: 8rem;\n}\n.sm\\:ml-32 {\n    margin-left: 8rem;\n}\n.sm\\:mt-48 {\n    margin-top: 10rem;\n}\n.sm\\:mr-48 {\n    margin-right: 10rem;\n}\n.sm\\:mb-48 {\n    margin-bottom: 10rem;\n}\n.sm\\:ml-48 {\n    margin-left: 10rem;\n}\n.sm\\:mt-auto {\n    margin-top: auto;\n}\n.sm\\:mr-auto {\n    margin-right: auto;\n}\n.sm\\:mb-auto {\n    margin-bottom: auto;\n}\n.sm\\:ml-auto {\n    margin-left: auto;\n}\n.sm\\:mt-px {\n    margin-top: 1px;\n}\n.sm\\:mr-px {\n    margin-right: 1px;\n}\n.sm\\:mb-px {\n    margin-bottom: 1px;\n}\n.sm\\:ml-px {\n    margin-left: 1px;\n}\n.sm\\:max-h-full {\n    max-height: 100%;\n}\n.sm\\:max-h-screen {\n    max-height: 100vh;\n}\n.sm\\:max-h-timeslots {\n    max-height: calc(100vh - 3rem - 1rem - 14rem);\n}\n.sm\\:max-w-xs {\n    max-width: 20rem;\n}\n.sm\\:max-w-sm {\n    max-width: 30rem;\n}\n.sm\\:max-w-md {\n    max-width: 40rem;\n}\n.sm\\:max-w-lg {\n    max-width: 50rem;\n}\n.sm\\:max-w-xl {\n    max-width: 60rem;\n}\n.sm\\:max-w-2xl {\n    max-width: 70rem;\n}\n.sm\\:max-w-3xl {\n    max-width: 80rem;\n}\n.sm\\:max-w-4xl {\n    max-width: 90rem;\n}\n.sm\\:max-w-5xl {\n    max-width: 100rem;\n}\n.sm\\:max-w-full {\n    max-width: 100%;\n}\n.sm\\:min-h-0 {\n    min-height: 0;\n}\n.sm\\:min-h-full {\n    min-height: 100%;\n}\n.sm\\:min-h-screen {\n    min-height: 100vh;\n}\n.sm\\:min-h-\\(screen-footer-sm\\) {\n    min-height: calc(100vh - 350px);\n}\n.sm\\:min-h-\\(screen-footer-md\\) {\n    min-height: calc(100vh - 180px);\n}\n.sm\\:min-w-0 {\n    min-width: 0;\n}\n.sm\\:min-w-full {\n    min-width: 100%;\n}\n.sm\\:-m-0 {\n    margin: 0;\n}\n.sm\\:-m-1 {\n    margin: -0.25rem;\n}\n.sm\\:-m-2 {\n    margin: -0.5rem;\n}\n.sm\\:-m-3 {\n    margin: -0.75rem;\n}\n.sm\\:-m-4 {\n    margin: -1rem;\n}\n.sm\\:-m-6 {\n    margin: -1.5rem;\n}\n.sm\\:-m-8 {\n    margin: -2rem;\n}\n.sm\\:-m-10 {\n    margin: -2.5rem;\n}\n.sm\\:-m-12 {\n    margin: -3rem;\n}\n.sm\\:-m-16 {\n    margin: -4rem;\n}\n.sm\\:-m-24 {\n    margin: -6rem;\n}\n.sm\\:-m-32 {\n    margin: -8rem;\n}\n.sm\\:-m-48 {\n    margin: -10rem;\n}\n.sm\\:-m-px {\n    margin: -1px;\n}\n.sm\\:-my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n.sm\\:-mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n}\n.sm\\:-my-1 {\n    margin-top: -0.25rem;\n    margin-bottom: -0.25rem;\n}\n.sm\\:-mx-1 {\n    margin-left: -0.25rem;\n    margin-right: -0.25rem;\n}\n.sm\\:-my-2 {\n    margin-top: -0.5rem;\n    margin-bottom: -0.5rem;\n}\n.sm\\:-mx-2 {\n    margin-left: -0.5rem;\n    margin-right: -0.5rem;\n}\n.sm\\:-my-3 {\n    margin-top: -0.75rem;\n    margin-bottom: -0.75rem;\n}\n.sm\\:-mx-3 {\n    margin-left: -0.75rem;\n    margin-right: -0.75rem;\n}\n.sm\\:-my-4 {\n    margin-top: -1rem;\n    margin-bottom: -1rem;\n}\n.sm\\:-mx-4 {\n    margin-left: -1rem;\n    margin-right: -1rem;\n}\n.sm\\:-my-6 {\n    margin-top: -1.5rem;\n    margin-bottom: -1.5rem;\n}\n.sm\\:-mx-6 {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n}\n.sm\\:-my-8 {\n    margin-top: -2rem;\n    margin-bottom: -2rem;\n}\n.sm\\:-mx-8 {\n    margin-left: -2rem;\n    margin-right: -2rem;\n}\n.sm\\:-my-10 {\n    margin-top: -2.5rem;\n    margin-bottom: -2.5rem;\n}\n.sm\\:-mx-10 {\n    margin-left: -2.5rem;\n    margin-right: -2.5rem;\n}\n.sm\\:-my-12 {\n    margin-top: -3rem;\n    margin-bottom: -3rem;\n}\n.sm\\:-mx-12 {\n    margin-left: -3rem;\n    margin-right: -3rem;\n}\n.sm\\:-my-16 {\n    margin-top: -4rem;\n    margin-bottom: -4rem;\n}\n.sm\\:-mx-16 {\n    margin-left: -4rem;\n    margin-right: -4rem;\n}\n.sm\\:-my-24 {\n    margin-top: -6rem;\n    margin-bottom: -6rem;\n}\n.sm\\:-mx-24 {\n    margin-left: -6rem;\n    margin-right: -6rem;\n}\n.sm\\:-my-32 {\n    margin-top: -8rem;\n    margin-bottom: -8rem;\n}\n.sm\\:-mx-32 {\n    margin-left: -8rem;\n    margin-right: -8rem;\n}\n.sm\\:-my-48 {\n    margin-top: -10rem;\n    margin-bottom: -10rem;\n}\n.sm\\:-mx-48 {\n    margin-left: -10rem;\n    margin-right: -10rem;\n}\n.sm\\:-my-px {\n    margin-top: -1px;\n    margin-bottom: -1px;\n}\n.sm\\:-mx-px {\n    margin-left: -1px;\n    margin-right: -1px;\n}\n.sm\\:-mt-0 {\n    margin-top: 0;\n}\n.sm\\:-mr-0 {\n    margin-right: 0;\n}\n.sm\\:-mb-0 {\n    margin-bottom: 0;\n}\n.sm\\:-ml-0 {\n    margin-left: 0;\n}\n.sm\\:-mt-1 {\n    margin-top: -0.25rem;\n}\n.sm\\:-mr-1 {\n    margin-right: -0.25rem;\n}\n.sm\\:-mb-1 {\n    margin-bottom: -0.25rem;\n}\n.sm\\:-ml-1 {\n    margin-left: -0.25rem;\n}\n.sm\\:-mt-2 {\n    margin-top: -0.5rem;\n}\n.sm\\:-mr-2 {\n    margin-right: -0.5rem;\n}\n.sm\\:-mb-2 {\n    margin-bottom: -0.5rem;\n}\n.sm\\:-ml-2 {\n    margin-left: -0.5rem;\n}\n.sm\\:-mt-3 {\n    margin-top: -0.75rem;\n}\n.sm\\:-mr-3 {\n    margin-right: -0.75rem;\n}\n.sm\\:-mb-3 {\n    margin-bottom: -0.75rem;\n}\n.sm\\:-ml-3 {\n    margin-left: -0.75rem;\n}\n.sm\\:-mt-4 {\n    margin-top: -1rem;\n}\n.sm\\:-mr-4 {\n    margin-right: -1rem;\n}\n.sm\\:-mb-4 {\n    margin-bottom: -1rem;\n}\n.sm\\:-ml-4 {\n    margin-left: -1rem;\n}\n.sm\\:-mt-6 {\n    margin-top: -1.5rem;\n}\n.sm\\:-mr-6 {\n    margin-right: -1.5rem;\n}\n.sm\\:-mb-6 {\n    margin-bottom: -1.5rem;\n}\n.sm\\:-ml-6 {\n    margin-left: -1.5rem;\n}\n.sm\\:-mt-8 {\n    margin-top: -2rem;\n}\n.sm\\:-mr-8 {\n    margin-right: -2rem;\n}\n.sm\\:-mb-8 {\n    margin-bottom: -2rem;\n}\n.sm\\:-ml-8 {\n    margin-left: -2rem;\n}\n.sm\\:-mt-10 {\n    margin-top: -2.5rem;\n}\n.sm\\:-mr-10 {\n    margin-right: -2.5rem;\n}\n.sm\\:-mb-10 {\n    margin-bottom: -2.5rem;\n}\n.sm\\:-ml-10 {\n    margin-left: -2.5rem;\n}\n.sm\\:-mt-12 {\n    margin-top: -3rem;\n}\n.sm\\:-mr-12 {\n    margin-right: -3rem;\n}\n.sm\\:-mb-12 {\n    margin-bottom: -3rem;\n}\n.sm\\:-ml-12 {\n    margin-left: -3rem;\n}\n.sm\\:-mt-16 {\n    margin-top: -4rem;\n}\n.sm\\:-mr-16 {\n    margin-right: -4rem;\n}\n.sm\\:-mb-16 {\n    margin-bottom: -4rem;\n}\n.sm\\:-ml-16 {\n    margin-left: -4rem;\n}\n.sm\\:-mt-24 {\n    margin-top: -6rem;\n}\n.sm\\:-mr-24 {\n    margin-right: -6rem;\n}\n.sm\\:-mb-24 {\n    margin-bottom: -6rem;\n}\n.sm\\:-ml-24 {\n    margin-left: -6rem;\n}\n.sm\\:-mt-32 {\n    margin-top: -8rem;\n}\n.sm\\:-mr-32 {\n    margin-right: -8rem;\n}\n.sm\\:-mb-32 {\n    margin-bottom: -8rem;\n}\n.sm\\:-ml-32 {\n    margin-left: -8rem;\n}\n.sm\\:-mt-48 {\n    margin-top: -10rem;\n}\n.sm\\:-mr-48 {\n    margin-right: -10rem;\n}\n.sm\\:-mb-48 {\n    margin-bottom: -10rem;\n}\n.sm\\:-ml-48 {\n    margin-left: -10rem;\n}\n.sm\\:-mt-px {\n    margin-top: -1px;\n}\n.sm\\:-mr-px {\n    margin-right: -1px;\n}\n.sm\\:-mb-px {\n    margin-bottom: -1px;\n}\n.sm\\:-ml-px {\n    margin-left: -1px;\n}\n.sm\\:opacity-0 {\n    opacity: 0;\n}\n.sm\\:opacity-25 {\n    opacity: .25;\n}\n.sm\\:opacity-50 {\n    opacity: .5;\n}\n.sm\\:opacity-75 {\n    opacity: .75;\n}\n.sm\\:opacity-100 {\n    opacity: 1;\n}\n.sm\\:hover\\:opacity-0:hover {\n    opacity: 0;\n}\n.sm\\:hover\\:opacity-25:hover {\n    opacity: .25;\n}\n.sm\\:hover\\:opacity-50:hover {\n    opacity: .5;\n}\n.sm\\:hover\\:opacity-75:hover {\n    opacity: .75;\n}\n.sm\\:hover\\:opacity-100:hover {\n    opacity: 1;\n}\n.sm\\:overflow-auto {\n    overflow: auto;\n}\n.sm\\:overflow-hidden {\n    overflow: hidden;\n}\n.sm\\:overflow-visible {\n    overflow: visible;\n}\n.sm\\:overflow-scroll {\n    overflow: scroll;\n}\n.sm\\:overflow-x-auto {\n    overflow-x: auto;\n}\n.sm\\:overflow-y-auto {\n    overflow-y: auto;\n}\n.sm\\:overflow-x-scroll {\n    overflow-x: scroll;\n}\n.sm\\:overflow-y-scroll {\n    overflow-y: scroll;\n}\n.sm\\:scrolling-touch {\n    -webkit-overflow-scrolling: touch;\n}\n.sm\\:scrolling-auto {\n    -webkit-overflow-scrolling: auto;\n}\n.sm\\:p-0 {\n    padding: 0;\n}\n.sm\\:p-1 {\n    padding: .25rem;\n}\n.sm\\:p-2 {\n    padding: .5rem;\n}\n.sm\\:p-3 {\n    padding: .75rem;\n}\n.sm\\:p-4 {\n    padding: 1rem;\n}\n.sm\\:p-6 {\n    padding: 1.5rem;\n}\n.sm\\:p-8 {\n    padding: 2rem;\n}\n.sm\\:p-10 {\n    padding: 2.5rem;\n}\n.sm\\:p-12 {\n    padding: 3rem;\n}\n.sm\\:p-16 {\n    padding: 4rem;\n}\n.sm\\:p-24 {\n    padding: 6rem;\n}\n.sm\\:p-32 {\n    padding: 8rem;\n}\n.sm\\:p-48 {\n    padding: 10rem;\n}\n.sm\\:p-px {\n    padding: 1px;\n}\n.sm\\:py-0 {\n    padding-top: 0;\n    padding-bottom: 0;\n}\n.sm\\:px-0 {\n    padding-left: 0;\n    padding-right: 0;\n}\n.sm\\:py-1 {\n    padding-top: .25rem;\n    padding-bottom: .25rem;\n}\n.sm\\:px-1 {\n    padding-left: .25rem;\n    padding-right: .25rem;\n}\n.sm\\:py-2 {\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n}\n.sm\\:px-2 {\n    padding-left: .5rem;\n    padding-right: .5rem;\n}\n.sm\\:py-3 {\n    padding-top: .75rem;\n    padding-bottom: .75rem;\n}\n.sm\\:px-3 {\n    padding-left: .75rem;\n    padding-right: .75rem;\n}\n.sm\\:py-4 {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n}\n.sm\\:px-4 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n}\n.sm\\:py-6 {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n}\n.sm\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n}\n.sm\\:py-8 {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n}\n.sm\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n}\n.sm\\:py-10 {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n}\n.sm\\:px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n}\n.sm\\:py-12 {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n}\n.sm\\:px-12 {\n    padding-left: 3rem;\n    padding-right: 3rem;\n}\n.sm\\:py-16 {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n}\n.sm\\:px-16 {\n    padding-left: 4rem;\n    padding-right: 4rem;\n}\n.sm\\:py-24 {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n}\n.sm\\:px-24 {\n    padding-left: 6rem;\n    padding-right: 6rem;\n}\n.sm\\:py-32 {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n}\n.sm\\:px-32 {\n    padding-left: 8rem;\n    padding-right: 8rem;\n}\n.sm\\:py-48 {\n    padding-top: 10rem;\n    padding-bottom: 10rem;\n}\n.sm\\:px-48 {\n    padding-left: 10rem;\n    padding-right: 10rem;\n}\n.sm\\:py-px {\n    padding-top: 1px;\n    padding-bottom: 1px;\n}\n.sm\\:px-px {\n    padding-left: 1px;\n    padding-right: 1px;\n}\n.sm\\:pt-0 {\n    padding-top: 0;\n}\n.sm\\:pr-0 {\n    padding-right: 0;\n}\n.sm\\:pb-0 {\n    padding-bottom: 0;\n}\n.sm\\:pl-0 {\n    padding-left: 0;\n}\n.sm\\:pt-1 {\n    padding-top: .25rem;\n}\n.sm\\:pr-1 {\n    padding-right: .25rem;\n}\n.sm\\:pb-1 {\n    padding-bottom: .25rem;\n}\n.sm\\:pl-1 {\n    padding-left: .25rem;\n}\n.sm\\:pt-2 {\n    padding-top: .5rem;\n}\n.sm\\:pr-2 {\n    padding-right: .5rem;\n}\n.sm\\:pb-2 {\n    padding-bottom: .5rem;\n}\n.sm\\:pl-2 {\n    padding-left: .5rem;\n}\n.sm\\:pt-3 {\n    padding-top: .75rem;\n}\n.sm\\:pr-3 {\n    padding-right: .75rem;\n}\n.sm\\:pb-3 {\n    padding-bottom: .75rem;\n}\n.sm\\:pl-3 {\n    padding-left: .75rem;\n}\n.sm\\:pt-4 {\n    padding-top: 1rem;\n}\n.sm\\:pr-4 {\n    padding-right: 1rem;\n}\n.sm\\:pb-4 {\n    padding-bottom: 1rem;\n}\n.sm\\:pl-4 {\n    padding-left: 1rem;\n}\n.sm\\:pt-6 {\n    padding-top: 1.5rem;\n}\n.sm\\:pr-6 {\n    padding-right: 1.5rem;\n}\n.sm\\:pb-6 {\n    padding-bottom: 1.5rem;\n}\n.sm\\:pl-6 {\n    padding-left: 1.5rem;\n}\n.sm\\:pt-8 {\n    padding-top: 2rem;\n}\n.sm\\:pr-8 {\n    padding-right: 2rem;\n}\n.sm\\:pb-8 {\n    padding-bottom: 2rem;\n}\n.sm\\:pl-8 {\n    padding-left: 2rem;\n}\n.sm\\:pt-10 {\n    padding-top: 2.5rem;\n}\n.sm\\:pr-10 {\n    padding-right: 2.5rem;\n}\n.sm\\:pb-10 {\n    padding-bottom: 2.5rem;\n}\n.sm\\:pl-10 {\n    padding-left: 2.5rem;\n}\n.sm\\:pt-12 {\n    padding-top: 3rem;\n}\n.sm\\:pr-12 {\n    padding-right: 3rem;\n}\n.sm\\:pb-12 {\n    padding-bottom: 3rem;\n}\n.sm\\:pl-12 {\n    padding-left: 3rem;\n}\n.sm\\:pt-16 {\n    padding-top: 4rem;\n}\n.sm\\:pr-16 {\n    padding-right: 4rem;\n}\n.sm\\:pb-16 {\n    padding-bottom: 4rem;\n}\n.sm\\:pl-16 {\n    padding-left: 4rem;\n}\n.sm\\:pt-24 {\n    padding-top: 6rem;\n}\n.sm\\:pr-24 {\n    padding-right: 6rem;\n}\n.sm\\:pb-24 {\n    padding-bottom: 6rem;\n}\n.sm\\:pl-24 {\n    padding-left: 6rem;\n}\n.sm\\:pt-32 {\n    padding-top: 8rem;\n}\n.sm\\:pr-32 {\n    padding-right: 8rem;\n}\n.sm\\:pb-32 {\n    padding-bottom: 8rem;\n}\n.sm\\:pl-32 {\n    padding-left: 8rem;\n}\n.sm\\:pt-48 {\n    padding-top: 10rem;\n}\n.sm\\:pr-48 {\n    padding-right: 10rem;\n}\n.sm\\:pb-48 {\n    padding-bottom: 10rem;\n}\n.sm\\:pl-48 {\n    padding-left: 10rem;\n}\n.sm\\:pt-px {\n    padding-top: 1px;\n}\n.sm\\:pr-px {\n    padding-right: 1px;\n}\n.sm\\:pb-px {\n    padding-bottom: 1px;\n}\n.sm\\:pl-px {\n    padding-left: 1px;\n}\n.sm\\:pointer-events-none {\n    pointer-events: none;\n}\n.sm\\:pointer-events-auto {\n    pointer-events: auto;\n}\n.sm\\:static {\n    position: static;\n}\n.sm\\:fixed {\n    position: fixed;\n}\n.sm\\:absolute {\n    position: absolute;\n}\n.sm\\:relative {\n    position: relative;\n}\n.sm\\:sticky {\n    position: sticky;\n}\n.sm\\:pin-none {\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n}\n.sm\\:pin {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n.sm\\:pin-y {\n    top: 0;\n    bottom: 0;\n}\n.sm\\:pin-x {\n    right: 0;\n    left: 0;\n}\n.sm\\:pin-t {\n    top: 0;\n}\n.sm\\:pin-r {\n    right: 0;\n}\n.sm\\:pin-b {\n    bottom: 0;\n}\n.sm\\:pin-l {\n    left: 0;\n}\n.sm\\:resize-none {\n    resize: none;\n}\n.sm\\:resize-y {\n    resize: vertical;\n}\n.sm\\:resize-x {\n    resize: horizontal;\n}\n.sm\\:resize {\n    resize: both;\n}\n.sm\\:shadow {\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .1);\n}\n.sm\\:shadow-md {\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .12), 0 2px 4px 0 rgba(0, 0, 0, .08);\n}\n.sm\\:shadow-lg {\n    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, .11), 0 5px 15px 0 rgba(0, 0, 0, .08);\n}\n.sm\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, .06);\n}\n.sm\\:shadow-none {\n    box-shadow: none;\n}\n.sm\\:text-left {\n    text-align: left;\n}\n.sm\\:text-center {\n    text-align: center;\n}\n.sm\\:text-right {\n    text-align: right;\n}\n.sm\\:text-justify {\n    text-align: justify;\n}\n.sm\\:text-transparent {\n    color: transparent;\n}\n.sm\\:text-modal {\n    color: rgba(0, 0, 0, .4);\n}\n.sm\\:text-google {\n    color: #dc5b5b;\n}\n.sm\\:text-google-dark {\n    color: #da5050;\n}\n.sm\\:text-facebook {\n    color: #3b5998;\n}\n.sm\\:text-facebook-dark {\n    color: #37548f;\n}\n.sm\\:text-primary {\n    color: #2196f3;\n}\n.sm\\:text-primary-dark {\n    color: #3b5998;\n}\n.sm\\:text-footer {\n    color: #1976d2;\n}\n.sm\\:text-black {\n    color: #22292f;\n}\n.sm\\:text-grey-darkest {\n    color: #3d4852;\n}\n.sm\\:text-grey-darker {\n    color: #606f7b;\n}\n.sm\\:text-grey-dark {\n    color: #8795a1;\n}\n.sm\\:text-grey {\n    color: #b8c2cc;\n}\n.sm\\:text-grey-light {\n    color: #dae1e7;\n}\n.sm\\:text-grey-lighter {\n    color: #f1f5f8;\n}\n.sm\\:text-grey-lightest {\n    color: #f8fafc;\n}\n.sm\\:text-white {\n    color: #fff;\n}\n.sm\\:text-whiter {\n    color: rgba(255, 255, 255, .6);\n}\n.sm\\:text-red-darkest {\n    color: #3b0d0c;\n}\n.sm\\:text-red-darker {\n    color: #621b18;\n}\n.sm\\:text-red-dark {\n    color: #cc1f1a;\n}\n.sm\\:text-red {\n    color: #e3342f;\n}\n.sm\\:text-red-light {\n    color: #ef5753;\n}\n.sm\\:text-red-lighter {\n    color: #f9acaa;\n}\n.sm\\:text-red-lightest {\n    color: #fcebea;\n}\n.sm\\:text-orange-darkest {\n    color: #462a16;\n}\n.sm\\:text-orange-darker {\n    color: #613b1f;\n}\n.sm\\:text-orange-dark {\n    color: #de751f;\n}\n.sm\\:text-orange {\n    color: #f6993f;\n}\n.sm\\:text-orange-light {\n    color: #faad63;\n}\n.sm\\:text-orange-lighter {\n    color: #fcd9b6;\n}\n.sm\\:text-orange-lightest {\n    color: #fff5eb;\n}\n.sm\\:text-yellow-darkest {\n    color: #453411;\n}\n.sm\\:text-yellow-darker {\n    color: #684f1d;\n}\n.sm\\:text-yellow-dark {\n    color: #f2d024;\n}\n.sm\\:text-yellow {\n    color: #ffed4a;\n}\n.sm\\:text-yellow-light {\n    color: #fff382;\n}\n.sm\\:text-yellow-lighter {\n    color: #fff9c2;\n}\n.sm\\:text-yellow-lightest {\n    color: #fcfbeb;\n}\n.sm\\:text-green-darkest {\n    color: #0f2f21;\n}\n.sm\\:text-green-darker {\n    color: #1a4731;\n}\n.sm\\:text-green-dark {\n    color: #1f9d55;\n}\n.sm\\:text-green {\n    color: #38c172;\n}\n.sm\\:text-green-light {\n    color: #51d88a;\n}\n.sm\\:text-green-lighter {\n    color: #a2f5bf;\n}\n.sm\\:text-green-lightest {\n    color: #e3fcec;\n}\n.sm\\:text-teal-darkest {\n    color: #0d3331;\n}\n.sm\\:text-teal-darker {\n    color: #20504f;\n}\n.sm\\:text-teal-dark {\n    color: #009480;\n}\n.sm\\:text-teal {\n    color: #00ae98;\n}\n.sm\\:text-teal-light {\n    color: #64d5ca;\n}\n.sm\\:text-teal-lighter {\n    color: #a0f0ed;\n}\n.sm\\:text-teal-lightest {\n    color: #e8fffe;\n}\n.sm\\:text-blue-darkest {\n    color: #12283a;\n}\n.sm\\:text-blue-darker {\n    color: #2e6da2;\n}\n.sm\\:text-blue-dark {\n    color: #2779bd;\n}\n.sm\\:text-blue {\n    color: #3490dc;\n}\n.sm\\:text-blue-light {\n    color: #6cb2eb;\n}\n.sm\\:text-blue-lighter {\n    color: #bcdefa;\n}\n.sm\\:text-blue-lightest {\n    color: #eff8ff;\n}\n.sm\\:text-indigo-darkest {\n    color: #191e38;\n}\n.sm\\:text-indigo-darker {\n    color: #2f365f;\n}\n.sm\\:text-indigo-dark {\n    color: #5661b3;\n}\n.sm\\:text-indigo {\n    color: #6574cd;\n}\n.sm\\:text-indigo-light {\n    color: #7886d7;\n}\n.sm\\:text-indigo-lighter {\n    color: #b2b7ff;\n}\n.sm\\:text-indigo-lightest {\n    color: #e6e8ff;\n}\n.sm\\:text-purple-darkest {\n    color: #21183c;\n}\n.sm\\:text-purple-darker {\n    color: #382b5f;\n}\n.sm\\:text-purple-dark {\n    color: #794acf;\n}\n.sm\\:text-purple {\n    color: #9561e2;\n}\n.sm\\:text-purple-light {\n    color: #a779e9;\n}\n.sm\\:text-purple-lighter {\n    color: #d6bbfc;\n}\n.sm\\:text-purple-lightest {\n    color: #f3ebff;\n}\n.sm\\:text-pink-darkest {\n    color: #451225;\n}\n.sm\\:text-pink-darker {\n    color: #6f213f;\n}\n.sm\\:text-pink-dark {\n    color: #eb5286;\n}\n.sm\\:text-pink {\n    color: #f66d9b;\n}\n.sm\\:text-pink-light {\n    color: #fa7ea8;\n}\n.sm\\:text-pink-lighter {\n    color: #ffbbca;\n}\n.sm\\:text-pink-lightest {\n    color: #ffebef;\n}\n.sm\\:group:hover .group-hover\\:text-transparent {\n    color: transparent;\n}\n.sm\\:group:hover .group-hover\\:text-modal {\n    color: rgba(0, 0, 0, .4);\n}\n.sm\\:group:hover .group-hover\\:text-google {\n    color: #dc5b5b;\n}\n.sm\\:group:hover .group-hover\\:text-google-dark {\n    color: #da5050;\n}\n.sm\\:group:hover .group-hover\\:text-facebook {\n    color: #3b5998;\n}\n.sm\\:group:hover .group-hover\\:text-facebook-dark {\n    color: #37548f;\n}\n.sm\\:group:hover .group-hover\\:text-primary {\n    color: #2196f3;\n}\n.sm\\:group:hover .group-hover\\:text-primary-dark {\n    color: #3b5998;\n}\n.sm\\:group:hover .group-hover\\:text-footer {\n    color: #1976d2;\n}\n.sm\\:group:hover .group-hover\\:text-black {\n    color: #22292f;\n}\n.sm\\:group:hover .group-hover\\:text-grey-darkest {\n    color: #3d4852;\n}\n.sm\\:group:hover .group-hover\\:text-grey-darker {\n    color: #606f7b;\n}\n.sm\\:group:hover .group-hover\\:text-grey-dark {\n    color: #8795a1;\n}\n.sm\\:group:hover .group-hover\\:text-grey {\n    color: #b8c2cc;\n}\n.sm\\:group:hover .group-hover\\:text-grey-light {\n    color: #dae1e7;\n}\n.sm\\:group:hover .group-hover\\:text-grey-lighter {\n    color: #f1f5f8;\n}\n.sm\\:group:hover .group-hover\\:text-grey-lightest {\n    color: #f8fafc;\n}\n.sm\\:group:hover .group-hover\\:text-white {\n    color: #fff;\n}\n.sm\\:group:hover .group-hover\\:text-whiter {\n    color: rgba(255, 255, 255, .6);\n}\n.sm\\:group:hover .group-hover\\:text-red-darkest {\n    color: #3b0d0c;\n}\n.sm\\:group:hover .group-hover\\:text-red-darker {\n    color: #621b18;\n}\n.sm\\:group:hover .group-hover\\:text-red-dark {\n    color: #cc1f1a;\n}\n.sm\\:group:hover .group-hover\\:text-red {\n    color: #e3342f;\n}\n.sm\\:group:hover .group-hover\\:text-red-light {\n    color: #ef5753;\n}\n.sm\\:group:hover .group-hover\\:text-red-lighter {\n    color: #f9acaa;\n}\n.sm\\:group:hover .group-hover\\:text-red-lightest {\n    color: #fcebea;\n}\n.sm\\:group:hover .group-hover\\:text-orange-darkest {\n    color: #462a16;\n}\n.sm\\:group:hover .group-hover\\:text-orange-darker {\n    color: #613b1f;\n}\n.sm\\:group:hover .group-hover\\:text-orange-dark {\n    color: #de751f;\n}\n.sm\\:group:hover .group-hover\\:text-orange {\n    color: #f6993f;\n}\n.sm\\:group:hover .group-hover\\:text-orange-light {\n    color: #faad63;\n}\n.sm\\:group:hover .group-hover\\:text-orange-lighter {\n    color: #fcd9b6;\n}\n.sm\\:group:hover .group-hover\\:text-orange-lightest {\n    color: #fff5eb;\n}\n.sm\\:group:hover .group-hover\\:text-yellow-darkest {\n    color: #453411;\n}\n.sm\\:group:hover .group-hover\\:text-yellow-darker {\n    color: #684f1d;\n}\n.sm\\:group:hover .group-hover\\:text-yellow-dark {\n    color: #f2d024;\n}\n.sm\\:group:hover .group-hover\\:text-yellow {\n    color: #ffed4a;\n}\n.sm\\:group:hover .group-hover\\:text-yellow-light {\n    color: #fff382;\n}\n.sm\\:group:hover .group-hover\\:text-yellow-lighter {\n    color: #fff9c2;\n}\n.sm\\:group:hover .group-hover\\:text-yellow-lightest {\n    color: #fcfbeb;\n}\n.sm\\:group:hover .group-hover\\:text-green-darkest {\n    color: #0f2f21;\n}\n.sm\\:group:hover .group-hover\\:text-green-darker {\n    color: #1a4731;\n}\n.sm\\:group:hover .group-hover\\:text-green-dark {\n    color: #1f9d55;\n}\n.sm\\:group:hover .group-hover\\:text-green {\n    color: #38c172;\n}\n.sm\\:group:hover .group-hover\\:text-green-light {\n    color: #51d88a;\n}\n.sm\\:group:hover .group-hover\\:text-green-lighter {\n    color: #a2f5bf;\n}\n.sm\\:group:hover .group-hover\\:text-green-lightest {\n    color: #e3fcec;\n}\n.sm\\:group:hover .group-hover\\:text-teal-darkest {\n    color: #0d3331;\n}\n.sm\\:group:hover .group-hover\\:text-teal-darker {\n    color: #20504f;\n}\n.sm\\:group:hover .group-hover\\:text-teal-dark {\n    color: #009480;\n}\n.sm\\:group:hover .group-hover\\:text-teal {\n    color: #00ae98;\n}\n.sm\\:group:hover .group-hover\\:text-teal-light {\n    color: #64d5ca;\n}\n.sm\\:group:hover .group-hover\\:text-teal-lighter {\n    color: #a0f0ed;\n}\n.sm\\:group:hover .group-hover\\:text-teal-lightest {\n    color: #e8fffe;\n}\n.sm\\:group:hover .group-hover\\:text-blue-darkest {\n    color: #12283a;\n}\n.sm\\:group:hover .group-hover\\:text-blue-darker {\n    color: #2e6da2;\n}\n.sm\\:group:hover .group-hover\\:text-blue-dark {\n    color: #2779bd;\n}\n.sm\\:group:hover .group-hover\\:text-blue {\n    color: #3490dc;\n}\n.sm\\:group:hover .group-hover\\:text-blue-light {\n    color: #6cb2eb;\n}\n.sm\\:group:hover .group-hover\\:text-blue-lighter {\n    color: #bcdefa;\n}\n.sm\\:group:hover .group-hover\\:text-blue-lightest {\n    color: #eff8ff;\n}\n.sm\\:group:hover .group-hover\\:text-indigo-darkest {\n    color: #191e38;\n}\n.sm\\:group:hover .group-hover\\:text-indigo-darker {\n    color: #2f365f;\n}\n.sm\\:group:hover .group-hover\\:text-indigo-dark {\n    color: #5661b3;\n}\n.sm\\:group:hover .group-hover\\:text-indigo {\n    color: #6574cd;\n}\n.sm\\:group:hover .group-hover\\:text-indigo-light {\n    color: #7886d7;\n}\n.sm\\:group:hover .group-hover\\:text-indigo-lighter {\n    color: #b2b7ff;\n}\n.sm\\:group:hover .group-hover\\:text-indigo-lightest {\n    color: #e6e8ff;\n}\n.sm\\:group:hover .group-hover\\:text-purple-darkest {\n    color: #21183c;\n}\n.sm\\:group:hover .group-hover\\:text-purple-darker {\n    color: #382b5f;\n}\n.sm\\:group:hover .group-hover\\:text-purple-dark {\n    color: #794acf;\n}\n.sm\\:group:hover .group-hover\\:text-purple {\n    color: #9561e2;\n}\n.sm\\:group:hover .group-hover\\:text-purple-light {\n    color: #a779e9;\n}\n.sm\\:group:hover .group-hover\\:text-purple-lighter {\n    color: #d6bbfc;\n}\n.sm\\:group:hover .group-hover\\:text-purple-lightest {\n    color: #f3ebff;\n}\n.sm\\:group:hover .group-hover\\:text-pink-darkest {\n    color: #451225;\n}\n.sm\\:group:hover .group-hover\\:text-pink-darker {\n    color: #6f213f;\n}\n.sm\\:group:hover .group-hover\\:text-pink-dark {\n    color: #eb5286;\n}\n.sm\\:group:hover .group-hover\\:text-pink {\n    color: #f66d9b;\n}\n.sm\\:group:hover .group-hover\\:text-pink-light {\n    color: #fa7ea8;\n}\n.sm\\:group:hover .group-hover\\:text-pink-lighter {\n    color: #ffbbca;\n}\n.sm\\:group:hover .group-hover\\:text-pink-lightest {\n    color: #ffebef;\n}\n.sm\\:hover\\:text-transparent:hover {\n    color: transparent;\n}\n.sm\\:hover\\:text-modal:hover {\n    color: rgba(0, 0, 0, .4);\n}\n.sm\\:hover\\:text-google:hover {\n    color: #dc5b5b;\n}\n.sm\\:hover\\:text-google-dark:hover {\n    color: #da5050;\n}\n.sm\\:hover\\:text-facebook:hover {\n    color: #3b5998;\n}\n.sm\\:hover\\:text-facebook-dark:hover {\n    color: #37548f;\n}\n.sm\\:hover\\:text-primary:hover {\n    color: #2196f3;\n}\n.sm\\:hover\\:text-primary-dark:hover {\n    color: #3b5998;\n}\n.sm\\:hover\\:text-footer:hover {\n    color: #1976d2;\n}\n.sm\\:hover\\:text-black:hover {\n    color: #22292f;\n}\n.sm\\:hover\\:text-grey-darkest:hover {\n    color: #3d4852;\n}\n.sm\\:hover\\:text-grey-darker:hover {\n    color: #606f7b;\n}\n.sm\\:hover\\:text-grey-dark:hover {\n    color: #8795a1;\n}\n.sm\\:hover\\:text-grey:hover {\n    color: #b8c2cc;\n}\n.sm\\:hover\\:text-grey-light:hover {\n    color: #dae1e7;\n}\n.sm\\:hover\\:text-grey-lighter:hover {\n    color: #f1f5f8;\n}\n.sm\\:hover\\:text-grey-lightest:hover {\n    color: #f8fafc;\n}\n.sm\\:hover\\:text-white:hover {\n    color: #fff;\n}\n.sm\\:hover\\:text-whiter:hover {\n    color: rgba(255, 255, 255, .6);\n}\n.sm\\:hover\\:text-red-darkest:hover {\n    color: #3b0d0c;\n}\n.sm\\:hover\\:text-red-darker:hover {\n    color: #621b18;\n}\n.sm\\:hover\\:text-red-dark:hover {\n    color: #cc1f1a;\n}\n.sm\\:hover\\:text-red:hover {\n    color: #e3342f;\n}\n.sm\\:hover\\:text-red-light:hover {\n    color: #ef5753;\n}\n.sm\\:hover\\:text-red-lighter:hover {\n    color: #f9acaa;\n}\n.sm\\:hover\\:text-red-lightest:hover {\n    color: #fcebea;\n}\n.sm\\:hover\\:text-orange-darkest:hover {\n    color: #462a16;\n}\n.sm\\:hover\\:text-orange-darker:hover {\n    color: #613b1f;\n}\n.sm\\:hover\\:text-orange-dark:hover {\n    color: #de751f;\n}\n.sm\\:hover\\:text-orange:hover {\n    color: #f6993f;\n}\n.sm\\:hover\\:text-orange-light:hover {\n    color: #faad63;\n}\n.sm\\:hover\\:text-orange-lighter:hover {\n    color: #fcd9b6;\n}\n.sm\\:hover\\:text-orange-lightest:hover {\n    color: #fff5eb;\n}\n.sm\\:hover\\:text-yellow-darkest:hover {\n    color: #453411;\n}\n.sm\\:hover\\:text-yellow-darker:hover {\n    color: #684f1d;\n}\n.sm\\:hover\\:text-yellow-dark:hover {\n    color: #f2d024;\n}\n.sm\\:hover\\:text-yellow:hover {\n    color: #ffed4a;\n}\n.sm\\:hover\\:text-yellow-light:hover {\n    color: #fff382;\n}\n.sm\\:hover\\:text-yellow-lighter:hover {\n    color: #fff9c2;\n}\n.sm\\:hover\\:text-yellow-lightest:hover {\n    color: #fcfbeb;\n}\n.sm\\:hover\\:text-green-darkest:hover {\n    color: #0f2f21;\n}\n.sm\\:hover\\:text-green-darker:hover {\n    color: #1a4731;\n}\n.sm\\:hover\\:text-green-dark:hover {\n    color: #1f9d55;\n}\n.sm\\:hover\\:text-green:hover {\n    color: #38c172;\n}\n.sm\\:hover\\:text-green-light:hover {\n    color: #51d88a;\n}\n.sm\\:hover\\:text-green-lighter:hover {\n    color: #a2f5bf;\n}\n.sm\\:hover\\:text-green-lightest:hover {\n    color: #e3fcec;\n}\n.sm\\:hover\\:text-teal-darkest:hover {\n    color: #0d3331;\n}\n.sm\\:hover\\:text-teal-darker:hover {\n    color: #20504f;\n}\n.sm\\:hover\\:text-teal-dark:hover {\n    color: #009480;\n}\n.sm\\:hover\\:text-teal:hover {\n    color: #00ae98;\n}\n.sm\\:hover\\:text-teal-light:hover {\n    color: #64d5ca;\n}\n.sm\\:hover\\:text-teal-lighter:hover {\n    color: #a0f0ed;\n}\n.sm\\:hover\\:text-teal-lightest:hover {\n    color: #e8fffe;\n}\n.sm\\:hover\\:text-blue-darkest:hover {\n    color: #12283a;\n}\n.sm\\:hover\\:text-blue-darker:hover {\n    color: #2e6da2;\n}\n.sm\\:hover\\:text-blue-dark:hover {\n    color: #2779bd;\n}\n.sm\\:hover\\:text-blue:hover {\n    color: #3490dc;\n}\n.sm\\:hover\\:text-blue-light:hover {\n    color: #6cb2eb;\n}\n.sm\\:hover\\:text-blue-lighter:hover {\n    color: #bcdefa;\n}\n.sm\\:hover\\:text-blue-lightest:hover {\n    color: #eff8ff;\n}\n.sm\\:hover\\:text-indigo-darkest:hover {\n    color: #191e38;\n}\n.sm\\:hover\\:text-indigo-darker:hover {\n    color: #2f365f;\n}\n.sm\\:hover\\:text-indigo-dark:hover {\n    color: #5661b3;\n}\n.sm\\:hover\\:text-indigo:hover {\n    color: #6574cd;\n}\n.sm\\:hover\\:text-indigo-light:hover {\n    color: #7886d7;\n}\n.sm\\:hover\\:text-indigo-lighter:hover {\n    color: #b2b7ff;\n}\n.sm\\:hover\\:text-indigo-lightest:hover {\n    color: #e6e8ff;\n}\n.sm\\:hover\\:text-purple-darkest:hover {\n    color: #21183c;\n}\n.sm\\:hover\\:text-purple-darker:hover {\n    color: #382b5f;\n}\n.sm\\:hover\\:text-purple-dark:hover {\n    color: #794acf;\n}\n.sm\\:hover\\:text-purple:hover {\n    color: #9561e2;\n}\n.sm\\:hover\\:text-purple-light:hover {\n    color: #a779e9;\n}\n.sm\\:hover\\:text-purple-lighter:hover {\n    color: #d6bbfc;\n}\n.sm\\:hover\\:text-purple-lightest:hover {\n    color: #f3ebff;\n}\n.sm\\:hover\\:text-pink-darkest:hover {\n    color: #451225;\n}\n.sm\\:hover\\:text-pink-darker:hover {\n    color: #6f213f;\n}\n.sm\\:hover\\:text-pink-dark:hover {\n    color: #eb5286;\n}\n.sm\\:hover\\:text-pink:hover {\n    color: #f66d9b;\n}\n.sm\\:hover\\:text-pink-light:hover {\n    color: #fa7ea8;\n}\n.sm\\:hover\\:text-pink-lighter:hover {\n    color: #ffbbca;\n}\n.sm\\:hover\\:text-pink-lightest:hover {\n    color: #ffebef;\n}\n.sm\\:text-xs {\n    font-size: .75rem;\n}\n.sm\\:text-sm {\n    font-size: .875rem;\n}\n.sm\\:text-base {\n    font-size: 1rem;\n}\n.sm\\:text-lg {\n    font-size: 1.125rem;\n}\n.sm\\:text-xl {\n    font-size: 1.25rem;\n}\n.sm\\:text-2xl {\n    font-size: 1.5rem;\n}\n.sm\\:text-3xl {\n    font-size: 1.875rem;\n}\n.sm\\:text-4xl {\n    font-size: 2.25rem;\n}\n.sm\\:text-5xl {\n    font-size: 3rem;\n}\n.sm\\:italic {\n    font-style: italic;\n}\n.sm\\:roman {\n    font-style: normal;\n}\n.sm\\:uppercase {\n    text-transform: uppercase;\n}\n.sm\\:lowercase {\n    text-transform: lowercase;\n}\n.sm\\:capitalize {\n    text-transform: capitalize;\n}\n.sm\\:normal-case {\n    text-transform: none;\n}\n.sm\\:underline {\n    text-decoration: underline;\n}\n.sm\\:line-through {\n    text-decoration: line-through;\n}\n.sm\\:no-underline {\n    text-decoration: none;\n}\n.sm\\:antialiased {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.sm\\:subpixel-antialiased {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n}\n.sm\\:hover\\:italic:hover {\n    font-style: italic;\n}\n.sm\\:hover\\:roman:hover {\n    font-style: normal;\n}\n.sm\\:hover\\:uppercase:hover {\n    text-transform: uppercase;\n}\n.sm\\:hover\\:lowercase:hover {\n    text-transform: lowercase;\n}\n.sm\\:hover\\:capitalize:hover {\n    text-transform: capitalize;\n}\n.sm\\:hover\\:normal-case:hover {\n    text-transform: none;\n}\n.sm\\:hover\\:underline:hover {\n    text-decoration: underline;\n}\n.sm\\:hover\\:line-through:hover {\n    text-decoration: line-through;\n}\n.sm\\:hover\\:no-underline:hover {\n    text-decoration: none;\n}\n.sm\\:hover\\:antialiased:hover {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.sm\\:hover\\:subpixel-antialiased:hover {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n}\n.sm\\:tracking-tight {\n    letter-spacing: -0.05em;\n}\n.sm\\:tracking-normal {\n    letter-spacing: 0;\n}\n.sm\\:tracking-wide {\n    letter-spacing: .05em;\n}\n.sm\\:select-none {\n    user-select: none;\n}\n.sm\\:select-text {\n    user-select: text;\n}\n.sm\\:align-baseline {\n    vertical-align: baseline;\n}\n.sm\\:align-top {\n    vertical-align: top;\n}\n.sm\\:align-middle {\n    vertical-align: middle;\n}\n.sm\\:align-bottom {\n    vertical-align: bottom;\n}\n.sm\\:align-text-top {\n    vertical-align: text-top;\n}\n.sm\\:align-text-bottom {\n    vertical-align: text-bottom;\n}\n.sm\\:visible {\n    visibility: visible;\n}\n.sm\\:invisible {\n    visibility: hidden;\n}\n.sm\\:whitespace-normal {\n    white-space: normal;\n}\n.sm\\:whitespace-no-wrap {\n    white-space: nowrap;\n}\n.sm\\:whitespace-pre {\n    white-space: pre;\n}\n.sm\\:whitespace-pre-line {\n    white-space: pre-line;\n}\n.sm\\:whitespace-pre-wrap {\n    white-space: pre-wrap;\n}\n.sm\\:break-words {\n    word-wrap: break-word;\n}\n.sm\\:break-normal {\n    word-wrap: normal;\n}\n.sm\\:truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.sm\\:w-1 {\n    width: .25rem;\n}\n.sm\\:w-2 {\n    width: .5rem;\n}\n.sm\\:w-3 {\n    width: .75rem;\n}\n.sm\\:w-4 {\n    width: 1rem;\n}\n.sm\\:w-6 {\n    width: 1.5rem;\n}\n.sm\\:w-8 {\n    width: 2rem;\n}\n.sm\\:w-10 {\n    width: 2.5rem;\n}\n.sm\\:w-12 {\n    width: 3rem;\n}\n.sm\\:w-16 {\n    width: 4rem;\n}\n.sm\\:w-24 {\n    width: 6rem;\n}\n.sm\\:w-32 {\n    width: 8rem;\n}\n.sm\\:w-48 {\n    width: 12rem;\n}\n.sm\\:w-64 {\n    width: 16rem;\n}\n.sm\\:w-auto {\n    width: auto;\n}\n.sm\\:w-px {\n    width: 1px;\n}\n.sm\\:w-1\\/2 {\n    width: 50%;\n}\n.sm\\:w-1\\/3 {\n    width: 33.33333%;\n}\n.sm\\:w-2\\/3 {\n    width: 66.66667%;\n}\n.sm\\:w-1\\/4 {\n    width: 25%;\n}\n.sm\\:w-3\\/4 {\n    width: 75%;\n}\n.sm\\:w-1\\/5 {\n    width: 20%;\n}\n.sm\\:w-2\\/5 {\n    width: 40%;\n}\n.sm\\:w-3\\/5 {\n    width: 60%;\n}\n.sm\\:w-4\\/5 {\n    width: 80%;\n}\n.sm\\:w-1\\/6 {\n    width: 16.66667%;\n}\n.sm\\:w-5\\/6 {\n    width: 83.33333%;\n}\n.sm\\:w-full {\n    width: 100%;\n}\n.sm\\:w-screen {\n    width: 100vw;\n}\n.sm\\:z-0 {\n    z-index: 0;\n}\n.sm\\:z-10 {\n    z-index: 10;\n}\n.sm\\:z-20 {\n    z-index: 20;\n}\n.sm\\:z-30 {\n    z-index: 30;\n}\n.sm\\:z-40 {\n    z-index: 40;\n}\n.sm\\:z-50 {\n    z-index: 50;\n}\n.sm\\:z-auto {\n    z-index: auto;\n}\n.sm\\:z-max {\n    z-index: 1051 !important;\n}\n}\n@media (min-width: 768px) {\n.md\\:list-reset {\n    list-style: none;\n    padding: 0;\n}\n.md\\:appearance-none {\n    appearance: none;\n}\n.md\\:bg-fixed {\n    background-attachment: fixed;\n}\n.md\\:bg-local {\n    background-attachment: local;\n}\n.md\\:bg-scroll {\n    background-attachment: scroll;\n}\n.md\\:bg-transparent {\n    background-color: transparent;\n}\n.md\\:bg-modal {\n    background-color: rgba(0, 0, 0, .4);\n}\n.md\\:bg-google {\n    background-color: #dc5b5b;\n}\n.md\\:bg-google-dark {\n    background-color: #da5050;\n}\n.md\\:bg-facebook {\n    background-color: #3b5998;\n}\n.md\\:bg-facebook-dark {\n    background-color: #37548f;\n}\n.md\\:bg-primary {\n    background-color: #2196f3;\n}\n.md\\:bg-primary-dark {\n    background-color: #3b5998;\n}\n.md\\:bg-footer {\n    background-color: #1976d2;\n}\n.md\\:bg-black {\n    background-color: #22292f;\n}\n.md\\:bg-grey-darkest {\n    background-color: #3d4852;\n}\n.md\\:bg-grey-darker {\n    background-color: #606f7b;\n}\n.md\\:bg-grey-dark {\n    background-color: #8795a1;\n}\n.md\\:bg-grey {\n    background-color: #b8c2cc;\n}\n.md\\:bg-grey-light {\n    background-color: #dae1e7;\n}\n.md\\:bg-grey-lighter {\n    background-color: #f1f5f8;\n}\n.md\\:bg-grey-lightest {\n    background-color: #f8fafc;\n}\n.md\\:bg-white {\n    background-color: #fff;\n}\n.md\\:bg-whiter {\n    background-color: rgba(255, 255, 255, .6);\n}\n.md\\:bg-red-darkest {\n    background-color: #3b0d0c;\n}\n.md\\:bg-red-darker {\n    background-color: #621b18;\n}\n.md\\:bg-red-dark {\n    background-color: #cc1f1a;\n}\n.md\\:bg-red {\n    background-color: #e3342f;\n}\n.md\\:bg-red-light {\n    background-color: #ef5753;\n}\n.md\\:bg-red-lighter {\n    background-color: #f9acaa;\n}\n.md\\:bg-red-lightest {\n    background-color: #fcebea;\n}\n.md\\:bg-orange-darkest {\n    background-color: #462a16;\n}\n.md\\:bg-orange-darker {\n    background-color: #613b1f;\n}\n.md\\:bg-orange-dark {\n    background-color: #de751f;\n}\n.md\\:bg-orange {\n    background-color: #f6993f;\n}\n.md\\:bg-orange-light {\n    background-color: #faad63;\n}\n.md\\:bg-orange-lighter {\n    background-color: #fcd9b6;\n}\n.md\\:bg-orange-lightest {\n    background-color: #fff5eb;\n}\n.md\\:bg-yellow-darkest {\n    background-color: #453411;\n}\n.md\\:bg-yellow-darker {\n    background-color: #684f1d;\n}\n.md\\:bg-yellow-dark {\n    background-color: #f2d024;\n}\n.md\\:bg-yellow {\n    background-color: #ffed4a;\n}\n.md\\:bg-yellow-light {\n    background-color: #fff382;\n}\n.md\\:bg-yellow-lighter {\n    background-color: #fff9c2;\n}\n.md\\:bg-yellow-lightest {\n    background-color: #fcfbeb;\n}\n.md\\:bg-green-darkest {\n    background-color: #0f2f21;\n}\n.md\\:bg-green-darker {\n    background-color: #1a4731;\n}\n.md\\:bg-green-dark {\n    background-color: #1f9d55;\n}\n.md\\:bg-green {\n    background-color: #38c172;\n}\n.md\\:bg-green-light {\n    background-color: #51d88a;\n}\n.md\\:bg-green-lighter {\n    background-color: #a2f5bf;\n}\n.md\\:bg-green-lightest {\n    background-color: #e3fcec;\n}\n.md\\:bg-teal-darkest {\n    background-color: #0d3331;\n}\n.md\\:bg-teal-darker {\n    background-color: #20504f;\n}\n.md\\:bg-teal-dark {\n    background-color: #009480;\n}\n.md\\:bg-teal {\n    background-color: #00ae98;\n}\n.md\\:bg-teal-light {\n    background-color: #64d5ca;\n}\n.md\\:bg-teal-lighter {\n    background-color: #a0f0ed;\n}\n.md\\:bg-teal-lightest {\n    background-color: #e8fffe;\n}\n.md\\:bg-blue-darkest {\n    background-color: #12283a;\n}\n.md\\:bg-blue-darker {\n    background-color: #2e6da2;\n}\n.md\\:bg-blue-dark {\n    background-color: #2779bd;\n}\n.md\\:bg-blue {\n    background-color: #3490dc;\n}\n.md\\:bg-blue-light {\n    background-color: #6cb2eb;\n}\n.md\\:bg-blue-lighter {\n    background-color: #bcdefa;\n}\n.md\\:bg-blue-lightest {\n    background-color: #eff8ff;\n}\n.md\\:bg-indigo-darkest {\n    background-color: #191e38;\n}\n.md\\:bg-indigo-darker {\n    background-color: #2f365f;\n}\n.md\\:bg-indigo-dark {\n    background-color: #5661b3;\n}\n.md\\:bg-indigo {\n    background-color: #6574cd;\n}\n.md\\:bg-indigo-light {\n    background-color: #7886d7;\n}\n.md\\:bg-indigo-lighter {\n    background-color: #b2b7ff;\n}\n.md\\:bg-indigo-lightest {\n    background-color: #e6e8ff;\n}\n.md\\:bg-purple-darkest {\n    background-color: #21183c;\n}\n.md\\:bg-purple-darker {\n    background-color: #382b5f;\n}\n.md\\:bg-purple-dark {\n    background-color: #794acf;\n}\n.md\\:bg-purple {\n    background-color: #9561e2;\n}\n.md\\:bg-purple-light {\n    background-color: #a779e9;\n}\n.md\\:bg-purple-lighter {\n    background-color: #d6bbfc;\n}\n.md\\:bg-purple-lightest {\n    background-color: #f3ebff;\n}\n.md\\:bg-pink-darkest {\n    background-color: #451225;\n}\n.md\\:bg-pink-darker {\n    background-color: #6f213f;\n}\n.md\\:bg-pink-dark {\n    background-color: #eb5286;\n}\n.md\\:bg-pink {\n    background-color: #f66d9b;\n}\n.md\\:bg-pink-light {\n    background-color: #fa7ea8;\n}\n.md\\:bg-pink-lighter {\n    background-color: #ffbbca;\n}\n.md\\:bg-pink-lightest {\n    background-color: #ffebef;\n}\n.md\\:group:hover .group-hover\\:bg-transparent {\n    background-color: transparent;\n}\n.md\\:group:hover .group-hover\\:bg-modal {\n    background-color: rgba(0, 0, 0, .4);\n}\n.md\\:group:hover .group-hover\\:bg-google {\n    background-color: #dc5b5b;\n}\n.md\\:group:hover .group-hover\\:bg-google-dark {\n    background-color: #da5050;\n}\n.md\\:group:hover .group-hover\\:bg-facebook {\n    background-color: #3b5998;\n}\n.md\\:group:hover .group-hover\\:bg-facebook-dark {\n    background-color: #37548f;\n}\n.md\\:group:hover .group-hover\\:bg-primary {\n    background-color: #2196f3;\n}\n.md\\:group:hover .group-hover\\:bg-primary-dark {\n    background-color: #3b5998;\n}\n.md\\:group:hover .group-hover\\:bg-footer {\n    background-color: #1976d2;\n}\n.md\\:group:hover .group-hover\\:bg-black {\n    background-color: #22292f;\n}\n.md\\:group:hover .group-hover\\:bg-grey-darkest {\n    background-color: #3d4852;\n}\n.md\\:group:hover .group-hover\\:bg-grey-darker {\n    background-color: #606f7b;\n}\n.md\\:group:hover .group-hover\\:bg-grey-dark {\n    background-color: #8795a1;\n}\n.md\\:group:hover .group-hover\\:bg-grey {\n    background-color: #b8c2cc;\n}\n.md\\:group:hover .group-hover\\:bg-grey-light {\n    background-color: #dae1e7;\n}\n.md\\:group:hover .group-hover\\:bg-grey-lighter {\n    background-color: #f1f5f8;\n}\n.md\\:group:hover .group-hover\\:bg-grey-lightest {\n    background-color: #f8fafc;\n}\n.md\\:group:hover .group-hover\\:bg-white {\n    background-color: #fff;\n}\n.md\\:group:hover .group-hover\\:bg-whiter {\n    background-color: rgba(255, 255, 255, .6);\n}\n.md\\:group:hover .group-hover\\:bg-red-darkest {\n    background-color: #3b0d0c;\n}\n.md\\:group:hover .group-hover\\:bg-red-darker {\n    background-color: #621b18;\n}\n.md\\:group:hover .group-hover\\:bg-red-dark {\n    background-color: #cc1f1a;\n}\n.md\\:group:hover .group-hover\\:bg-red {\n    background-color: #e3342f;\n}\n.md\\:group:hover .group-hover\\:bg-red-light {\n    background-color: #ef5753;\n}\n.md\\:group:hover .group-hover\\:bg-red-lighter {\n    background-color: #f9acaa;\n}\n.md\\:group:hover .group-hover\\:bg-red-lightest {\n    background-color: #fcebea;\n}\n.md\\:group:hover .group-hover\\:bg-orange-darkest {\n    background-color: #462a16;\n}\n.md\\:group:hover .group-hover\\:bg-orange-darker {\n    background-color: #613b1f;\n}\n.md\\:group:hover .group-hover\\:bg-orange-dark {\n    background-color: #de751f;\n}\n.md\\:group:hover .group-hover\\:bg-orange {\n    background-color: #f6993f;\n}\n.md\\:group:hover .group-hover\\:bg-orange-light {\n    background-color: #faad63;\n}\n.md\\:group:hover .group-hover\\:bg-orange-lighter {\n    background-color: #fcd9b6;\n}\n.md\\:group:hover .group-hover\\:bg-orange-lightest {\n    background-color: #fff5eb;\n}\n.md\\:group:hover .group-hover\\:bg-yellow-darkest {\n    background-color: #453411;\n}\n.md\\:group:hover .group-hover\\:bg-yellow-darker {\n    background-color: #684f1d;\n}\n.md\\:group:hover .group-hover\\:bg-yellow-dark {\n    background-color: #f2d024;\n}\n.md\\:group:hover .group-hover\\:bg-yellow {\n    background-color: #ffed4a;\n}\n.md\\:group:hover .group-hover\\:bg-yellow-light {\n    background-color: #fff382;\n}\n.md\\:group:hover .group-hover\\:bg-yellow-lighter {\n    background-color: #fff9c2;\n}\n.md\\:group:hover .group-hover\\:bg-yellow-lightest {\n    background-color: #fcfbeb;\n}\n.md\\:group:hover .group-hover\\:bg-green-darkest {\n    background-color: #0f2f21;\n}\n.md\\:group:hover .group-hover\\:bg-green-darker {\n    background-color: #1a4731;\n}\n.md\\:group:hover .group-hover\\:bg-green-dark {\n    background-color: #1f9d55;\n}\n.md\\:group:hover .group-hover\\:bg-green {\n    background-color: #38c172;\n}\n.md\\:group:hover .group-hover\\:bg-green-light {\n    background-color: #51d88a;\n}\n.md\\:group:hover .group-hover\\:bg-green-lighter {\n    background-color: #a2f5bf;\n}\n.md\\:group:hover .group-hover\\:bg-green-lightest {\n    background-color: #e3fcec;\n}\n.md\\:group:hover .group-hover\\:bg-teal-darkest {\n    background-color: #0d3331;\n}\n.md\\:group:hover .group-hover\\:bg-teal-darker {\n    background-color: #20504f;\n}\n.md\\:group:hover .group-hover\\:bg-teal-dark {\n    background-color: #009480;\n}\n.md\\:group:hover .group-hover\\:bg-teal {\n    background-color: #00ae98;\n}\n.md\\:group:hover .group-hover\\:bg-teal-light {\n    background-color: #64d5ca;\n}\n.md\\:group:hover .group-hover\\:bg-teal-lighter {\n    background-color: #a0f0ed;\n}\n.md\\:group:hover .group-hover\\:bg-teal-lightest {\n    background-color: #e8fffe;\n}\n.md\\:group:hover .group-hover\\:bg-blue-darkest {\n    background-color: #12283a;\n}\n.md\\:group:hover .group-hover\\:bg-blue-darker {\n    background-color: #2e6da2;\n}\n.md\\:group:hover .group-hover\\:bg-blue-dark {\n    background-color: #2779bd;\n}\n.md\\:group:hover .group-hover\\:bg-blue {\n    background-color: #3490dc;\n}\n.md\\:group:hover .group-hover\\:bg-blue-light {\n    background-color: #6cb2eb;\n}\n.md\\:group:hover .group-hover\\:bg-blue-lighter {\n    background-color: #bcdefa;\n}\n.md\\:group:hover .group-hover\\:bg-blue-lightest {\n    background-color: #eff8ff;\n}\n.md\\:group:hover .group-hover\\:bg-indigo-darkest {\n    background-color: #191e38;\n}\n.md\\:group:hover .group-hover\\:bg-indigo-darker {\n    background-color: #2f365f;\n}\n.md\\:group:hover .group-hover\\:bg-indigo-dark {\n    background-color: #5661b3;\n}\n.md\\:group:hover .group-hover\\:bg-indigo {\n    background-color: #6574cd;\n}\n.md\\:group:hover .group-hover\\:bg-indigo-light {\n    background-color: #7886d7;\n}\n.md\\:group:hover .group-hover\\:bg-indigo-lighter {\n    background-color: #b2b7ff;\n}\n.md\\:group:hover .group-hover\\:bg-indigo-lightest {\n    background-color: #e6e8ff;\n}\n.md\\:group:hover .group-hover\\:bg-purple-darkest {\n    background-color: #21183c;\n}\n.md\\:group:hover .group-hover\\:bg-purple-darker {\n    background-color: #382b5f;\n}\n.md\\:group:hover .group-hover\\:bg-purple-dark {\n    background-color: #794acf;\n}\n.md\\:group:hover .group-hover\\:bg-purple {\n    background-color: #9561e2;\n}\n.md\\:group:hover .group-hover\\:bg-purple-light {\n    background-color: #a779e9;\n}\n.md\\:group:hover .group-hover\\:bg-purple-lighter {\n    background-color: #d6bbfc;\n}\n.md\\:group:hover .group-hover\\:bg-purple-lightest {\n    background-color: #f3ebff;\n}\n.md\\:group:hover .group-hover\\:bg-pink-darkest {\n    background-color: #451225;\n}\n.md\\:group:hover .group-hover\\:bg-pink-darker {\n    background-color: #6f213f;\n}\n.md\\:group:hover .group-hover\\:bg-pink-dark {\n    background-color: #eb5286;\n}\n.md\\:group:hover .group-hover\\:bg-pink {\n    background-color: #f66d9b;\n}\n.md\\:group:hover .group-hover\\:bg-pink-light {\n    background-color: #fa7ea8;\n}\n.md\\:group:hover .group-hover\\:bg-pink-lighter {\n    background-color: #ffbbca;\n}\n.md\\:group:hover .group-hover\\:bg-pink-lightest {\n    background-color: #ffebef;\n}\n.md\\:hover\\:bg-transparent:hover {\n    background-color: transparent;\n}\n.md\\:hover\\:bg-modal:hover {\n    background-color: rgba(0, 0, 0, .4);\n}\n.md\\:hover\\:bg-google:hover {\n    background-color: #dc5b5b;\n}\n.md\\:hover\\:bg-google-dark:hover {\n    background-color: #da5050;\n}\n.md\\:hover\\:bg-facebook:hover {\n    background-color: #3b5998;\n}\n.md\\:hover\\:bg-facebook-dark:hover {\n    background-color: #37548f;\n}\n.md\\:hover\\:bg-primary:hover {\n    background-color: #2196f3;\n}\n.md\\:hover\\:bg-primary-dark:hover {\n    background-color: #3b5998;\n}\n.md\\:hover\\:bg-footer:hover {\n    background-color: #1976d2;\n}\n.md\\:hover\\:bg-black:hover {\n    background-color: #22292f;\n}\n.md\\:hover\\:bg-grey-darkest:hover {\n    background-color: #3d4852;\n}\n.md\\:hover\\:bg-grey-darker:hover {\n    background-color: #606f7b;\n}\n.md\\:hover\\:bg-grey-dark:hover {\n    background-color: #8795a1;\n}\n.md\\:hover\\:bg-grey:hover {\n    background-color: #b8c2cc;\n}\n.md\\:hover\\:bg-grey-light:hover {\n    background-color: #dae1e7;\n}\n.md\\:hover\\:bg-grey-lighter:hover {\n    background-color: #f1f5f8;\n}\n.md\\:hover\\:bg-grey-lightest:hover {\n    background-color: #f8fafc;\n}\n.md\\:hover\\:bg-white:hover {\n    background-color: #fff;\n}\n.md\\:hover\\:bg-whiter:hover {\n    background-color: rgba(255, 255, 255, .6);\n}\n.md\\:hover\\:bg-red-darkest:hover {\n    background-color: #3b0d0c;\n}\n.md\\:hover\\:bg-red-darker:hover {\n    background-color: #621b18;\n}\n.md\\:hover\\:bg-red-dark:hover {\n    background-color: #cc1f1a;\n}\n.md\\:hover\\:bg-red:hover {\n    background-color: #e3342f;\n}\n.md\\:hover\\:bg-red-light:hover {\n    background-color: #ef5753;\n}\n.md\\:hover\\:bg-red-lighter:hover {\n    background-color: #f9acaa;\n}\n.md\\:hover\\:bg-red-lightest:hover {\n    background-color: #fcebea;\n}\n.md\\:hover\\:bg-orange-darkest:hover {\n    background-color: #462a16;\n}\n.md\\:hover\\:bg-orange-darker:hover {\n    background-color: #613b1f;\n}\n.md\\:hover\\:bg-orange-dark:hover {\n    background-color: #de751f;\n}\n.md\\:hover\\:bg-orange:hover {\n    background-color: #f6993f;\n}\n.md\\:hover\\:bg-orange-light:hover {\n    background-color: #faad63;\n}\n.md\\:hover\\:bg-orange-lighter:hover {\n    background-color: #fcd9b6;\n}\n.md\\:hover\\:bg-orange-lightest:hover {\n    background-color: #fff5eb;\n}\n.md\\:hover\\:bg-yellow-darkest:hover {\n    background-color: #453411;\n}\n.md\\:hover\\:bg-yellow-darker:hover {\n    background-color: #684f1d;\n}\n.md\\:hover\\:bg-yellow-dark:hover {\n    background-color: #f2d024;\n}\n.md\\:hover\\:bg-yellow:hover {\n    background-color: #ffed4a;\n}\n.md\\:hover\\:bg-yellow-light:hover {\n    background-color: #fff382;\n}\n.md\\:hover\\:bg-yellow-lighter:hover {\n    background-color: #fff9c2;\n}\n.md\\:hover\\:bg-yellow-lightest:hover {\n    background-color: #fcfbeb;\n}\n.md\\:hover\\:bg-green-darkest:hover {\n    background-color: #0f2f21;\n}\n.md\\:hover\\:bg-green-darker:hover {\n    background-color: #1a4731;\n}\n.md\\:hover\\:bg-green-dark:hover {\n    background-color: #1f9d55;\n}\n.md\\:hover\\:bg-green:hover {\n    background-color: #38c172;\n}\n.md\\:hover\\:bg-green-light:hover {\n    background-color: #51d88a;\n}\n.md\\:hover\\:bg-green-lighter:hover {\n    background-color: #a2f5bf;\n}\n.md\\:hover\\:bg-green-lightest:hover {\n    background-color: #e3fcec;\n}\n.md\\:hover\\:bg-teal-darkest:hover {\n    background-color: #0d3331;\n}\n.md\\:hover\\:bg-teal-darker:hover {\n    background-color: #20504f;\n}\n.md\\:hover\\:bg-teal-dark:hover {\n    background-color: #009480;\n}\n.md\\:hover\\:bg-teal:hover {\n    background-color: #00ae98;\n}\n.md\\:hover\\:bg-teal-light:hover {\n    background-color: #64d5ca;\n}\n.md\\:hover\\:bg-teal-lighter:hover {\n    background-color: #a0f0ed;\n}\n.md\\:hover\\:bg-teal-lightest:hover {\n    background-color: #e8fffe;\n}\n.md\\:hover\\:bg-blue-darkest:hover {\n    background-color: #12283a;\n}\n.md\\:hover\\:bg-blue-darker:hover {\n    background-color: #2e6da2;\n}\n.md\\:hover\\:bg-blue-dark:hover {\n    background-color: #2779bd;\n}\n.md\\:hover\\:bg-blue:hover {\n    background-color: #3490dc;\n}\n.md\\:hover\\:bg-blue-light:hover {\n    background-color: #6cb2eb;\n}\n.md\\:hover\\:bg-blue-lighter:hover {\n    background-color: #bcdefa;\n}\n.md\\:hover\\:bg-blue-lightest:hover {\n    background-color: #eff8ff;\n}\n.md\\:hover\\:bg-indigo-darkest:hover {\n    background-color: #191e38;\n}\n.md\\:hover\\:bg-indigo-darker:hover {\n    background-color: #2f365f;\n}\n.md\\:hover\\:bg-indigo-dark:hover {\n    background-color: #5661b3;\n}\n.md\\:hover\\:bg-indigo:hover {\n    background-color: #6574cd;\n}\n.md\\:hover\\:bg-indigo-light:hover {\n    background-color: #7886d7;\n}\n.md\\:hover\\:bg-indigo-lighter:hover {\n    background-color: #b2b7ff;\n}\n.md\\:hover\\:bg-indigo-lightest:hover {\n    background-color: #e6e8ff;\n}\n.md\\:hover\\:bg-purple-darkest:hover {\n    background-color: #21183c;\n}\n.md\\:hover\\:bg-purple-darker:hover {\n    background-color: #382b5f;\n}\n.md\\:hover\\:bg-purple-dark:hover {\n    background-color: #794acf;\n}\n.md\\:hover\\:bg-purple:hover {\n    background-color: #9561e2;\n}\n.md\\:hover\\:bg-purple-light:hover {\n    background-color: #a779e9;\n}\n.md\\:hover\\:bg-purple-lighter:hover {\n    background-color: #d6bbfc;\n}\n.md\\:hover\\:bg-purple-lightest:hover {\n    background-color: #f3ebff;\n}\n.md\\:hover\\:bg-pink-darkest:hover {\n    background-color: #451225;\n}\n.md\\:hover\\:bg-pink-darker:hover {\n    background-color: #6f213f;\n}\n.md\\:hover\\:bg-pink-dark:hover {\n    background-color: #eb5286;\n}\n.md\\:hover\\:bg-pink:hover {\n    background-color: #f66d9b;\n}\n.md\\:hover\\:bg-pink-light:hover {\n    background-color: #fa7ea8;\n}\n.md\\:hover\\:bg-pink-lighter:hover {\n    background-color: #ffbbca;\n}\n.md\\:hover\\:bg-pink-lightest:hover {\n    background-color: #ffebef;\n}\n.md\\:bg-bottom {\n    background-position: bottom;\n}\n.md\\:bg-center {\n    background-position: center;\n}\n.md\\:bg-left {\n    background-position: left;\n}\n.md\\:bg-left-bottom {\n    background-position: left bottom;\n}\n.md\\:bg-left-top {\n    background-position: left top;\n}\n.md\\:bg-right {\n    background-position: right;\n}\n.md\\:bg-right-bottom {\n    background-position: right bottom;\n}\n.md\\:bg-right-top {\n    background-position: right top;\n}\n.md\\:bg-top {\n    background-position: top;\n}\n.md\\:bg-repeat {\n    background-repeat: repeat;\n}\n.md\\:bg-no-repeat {\n    background-repeat: no-repeat;\n}\n.md\\:bg-repeat-x {\n    background-repeat: repeat-x;\n}\n.md\\:bg-repeat-y {\n    background-repeat: repeat-y;\n}\n.md\\:bg-auto {\n    background-size: auto;\n}\n.md\\:bg-cover {\n    background-size: cover;\n}\n.md\\:bg-contain {\n    background-size: contain;\n}\n.md\\:border-transparent {\n    border-color: transparent;\n}\n.md\\:border-modal {\n    border-color: rgba(0, 0, 0, .4);\n}\n.md\\:border-google {\n    border-color: #dc5b5b;\n}\n.md\\:border-google-dark {\n    border-color: #da5050;\n}\n.md\\:border-facebook {\n    border-color: #3b5998;\n}\n.md\\:border-facebook-dark {\n    border-color: #37548f;\n}\n.md\\:border-primary {\n    border-color: #2196f3;\n}\n.md\\:border-primary-dark {\n    border-color: #3b5998;\n}\n.md\\:border-footer {\n    border-color: #1976d2;\n}\n.md\\:border-black {\n    border-color: #22292f;\n}\n.md\\:border-grey-darkest {\n    border-color: #3d4852;\n}\n.md\\:border-grey-darker {\n    border-color: #606f7b;\n}\n.md\\:border-grey-dark {\n    border-color: #8795a1;\n}\n.md\\:border-grey {\n    border-color: #b8c2cc;\n}\n.md\\:border-grey-light {\n    border-color: #dae1e7;\n}\n.md\\:border-grey-lighter {\n    border-color: #f1f5f8;\n}\n.md\\:border-grey-lightest {\n    border-color: #f8fafc;\n}\n.md\\:border-white {\n    border-color: #fff;\n}\n.md\\:border-whiter {\n    border-color: rgba(255, 255, 255, .6);\n}\n.md\\:border-red-darkest {\n    border-color: #3b0d0c;\n}\n.md\\:border-red-darker {\n    border-color: #621b18;\n}\n.md\\:border-red-dark {\n    border-color: #cc1f1a;\n}\n.md\\:border-red {\n    border-color: #e3342f;\n}\n.md\\:border-red-light {\n    border-color: #ef5753;\n}\n.md\\:border-red-lighter {\n    border-color: #f9acaa;\n}\n.md\\:border-red-lightest {\n    border-color: #fcebea;\n}\n.md\\:border-orange-darkest {\n    border-color: #462a16;\n}\n.md\\:border-orange-darker {\n    border-color: #613b1f;\n}\n.md\\:border-orange-dark {\n    border-color: #de751f;\n}\n.md\\:border-orange {\n    border-color: #f6993f;\n}\n.md\\:border-orange-light {\n    border-color: #faad63;\n}\n.md\\:border-orange-lighter {\n    border-color: #fcd9b6;\n}\n.md\\:border-orange-lightest {\n    border-color: #fff5eb;\n}\n.md\\:border-yellow-darkest {\n    border-color: #453411;\n}\n.md\\:border-yellow-darker {\n    border-color: #684f1d;\n}\n.md\\:border-yellow-dark {\n    border-color: #f2d024;\n}\n.md\\:border-yellow {\n    border-color: #ffed4a;\n}\n.md\\:border-yellow-light {\n    border-color: #fff382;\n}\n.md\\:border-yellow-lighter {\n    border-color: #fff9c2;\n}\n.md\\:border-yellow-lightest {\n    border-color: #fcfbeb;\n}\n.md\\:border-green-darkest {\n    border-color: #0f2f21;\n}\n.md\\:border-green-darker {\n    border-color: #1a4731;\n}\n.md\\:border-green-dark {\n    border-color: #1f9d55;\n}\n.md\\:border-green {\n    border-color: #38c172;\n}\n.md\\:border-green-light {\n    border-color: #51d88a;\n}\n.md\\:border-green-lighter {\n    border-color: #a2f5bf;\n}\n.md\\:border-green-lightest {\n    border-color: #e3fcec;\n}\n.md\\:border-teal-darkest {\n    border-color: #0d3331;\n}\n.md\\:border-teal-darker {\n    border-color: #20504f;\n}\n.md\\:border-teal-dark {\n    border-color: #009480;\n}\n.md\\:border-teal {\n    border-color: #00ae98;\n}\n.md\\:border-teal-light {\n    border-color: #64d5ca;\n}\n.md\\:border-teal-lighter {\n    border-color: #a0f0ed;\n}\n.md\\:border-teal-lightest {\n    border-color: #e8fffe;\n}\n.md\\:border-blue-darkest {\n    border-color: #12283a;\n}\n.md\\:border-blue-darker {\n    border-color: #2e6da2;\n}\n.md\\:border-blue-dark {\n    border-color: #2779bd;\n}\n.md\\:border-blue {\n    border-color: #3490dc;\n}\n.md\\:border-blue-light {\n    border-color: #6cb2eb;\n}\n.md\\:border-blue-lighter {\n    border-color: #bcdefa;\n}\n.md\\:border-blue-lightest {\n    border-color: #eff8ff;\n}\n.md\\:border-indigo-darkest {\n    border-color: #191e38;\n}\n.md\\:border-indigo-darker {\n    border-color: #2f365f;\n}\n.md\\:border-indigo-dark {\n    border-color: #5661b3;\n}\n.md\\:border-indigo {\n    border-color: #6574cd;\n}\n.md\\:border-indigo-light {\n    border-color: #7886d7;\n}\n.md\\:border-indigo-lighter {\n    border-color: #b2b7ff;\n}\n.md\\:border-indigo-lightest {\n    border-color: #e6e8ff;\n}\n.md\\:border-purple-darkest {\n    border-color: #21183c;\n}\n.md\\:border-purple-darker {\n    border-color: #382b5f;\n}\n.md\\:border-purple-dark {\n    border-color: #794acf;\n}\n.md\\:border-purple {\n    border-color: #9561e2;\n}\n.md\\:border-purple-light {\n    border-color: #a779e9;\n}\n.md\\:border-purple-lighter {\n    border-color: #d6bbfc;\n}\n.md\\:border-purple-lightest {\n    border-color: #f3ebff;\n}\n.md\\:border-pink-darkest {\n    border-color: #451225;\n}\n.md\\:border-pink-darker {\n    border-color: #6f213f;\n}\n.md\\:border-pink-dark {\n    border-color: #eb5286;\n}\n.md\\:border-pink {\n    border-color: #f66d9b;\n}\n.md\\:border-pink-light {\n    border-color: #fa7ea8;\n}\n.md\\:border-pink-lighter {\n    border-color: #ffbbca;\n}\n.md\\:border-pink-lightest {\n    border-color: #ffebef;\n}\n.md\\:hover\\:border-transparent:hover {\n    border-color: transparent;\n}\n.md\\:hover\\:border-modal:hover {\n    border-color: rgba(0, 0, 0, .4);\n}\n.md\\:hover\\:border-google:hover {\n    border-color: #dc5b5b;\n}\n.md\\:hover\\:border-google-dark:hover {\n    border-color: #da5050;\n}\n.md\\:hover\\:border-facebook:hover {\n    border-color: #3b5998;\n}\n.md\\:hover\\:border-facebook-dark:hover {\n    border-color: #37548f;\n}\n.md\\:hover\\:border-primary:hover {\n    border-color: #2196f3;\n}\n.md\\:hover\\:border-primary-dark:hover {\n    border-color: #3b5998;\n}\n.md\\:hover\\:border-footer:hover {\n    border-color: #1976d2;\n}\n.md\\:hover\\:border-black:hover {\n    border-color: #22292f;\n}\n.md\\:hover\\:border-grey-darkest:hover {\n    border-color: #3d4852;\n}\n.md\\:hover\\:border-grey-darker:hover {\n    border-color: #606f7b;\n}\n.md\\:hover\\:border-grey-dark:hover {\n    border-color: #8795a1;\n}\n.md\\:hover\\:border-grey:hover {\n    border-color: #b8c2cc;\n}\n.md\\:hover\\:border-grey-light:hover {\n    border-color: #dae1e7;\n}\n.md\\:hover\\:border-grey-lighter:hover {\n    border-color: #f1f5f8;\n}\n.md\\:hover\\:border-grey-lightest:hover {\n    border-color: #f8fafc;\n}\n.md\\:hover\\:border-white:hover {\n    border-color: #fff;\n}\n.md\\:hover\\:border-whiter:hover {\n    border-color: rgba(255, 255, 255, .6);\n}\n.md\\:hover\\:border-red-darkest:hover {\n    border-color: #3b0d0c;\n}\n.md\\:hover\\:border-red-darker:hover {\n    border-color: #621b18;\n}\n.md\\:hover\\:border-red-dark:hover {\n    border-color: #cc1f1a;\n}\n.md\\:hover\\:border-red:hover {\n    border-color: #e3342f;\n}\n.md\\:hover\\:border-red-light:hover {\n    border-color: #ef5753;\n}\n.md\\:hover\\:border-red-lighter:hover {\n    border-color: #f9acaa;\n}\n.md\\:hover\\:border-red-lightest:hover {\n    border-color: #fcebea;\n}\n.md\\:hover\\:border-orange-darkest:hover {\n    border-color: #462a16;\n}\n.md\\:hover\\:border-orange-darker:hover {\n    border-color: #613b1f;\n}\n.md\\:hover\\:border-orange-dark:hover {\n    border-color: #de751f;\n}\n.md\\:hover\\:border-orange:hover {\n    border-color: #f6993f;\n}\n.md\\:hover\\:border-orange-light:hover {\n    border-color: #faad63;\n}\n.md\\:hover\\:border-orange-lighter:hover {\n    border-color: #fcd9b6;\n}\n.md\\:hover\\:border-orange-lightest:hover {\n    border-color: #fff5eb;\n}\n.md\\:hover\\:border-yellow-darkest:hover {\n    border-color: #453411;\n}\n.md\\:hover\\:border-yellow-darker:hover {\n    border-color: #684f1d;\n}\n.md\\:hover\\:border-yellow-dark:hover {\n    border-color: #f2d024;\n}\n.md\\:hover\\:border-yellow:hover {\n    border-color: #ffed4a;\n}\n.md\\:hover\\:border-yellow-light:hover {\n    border-color: #fff382;\n}\n.md\\:hover\\:border-yellow-lighter:hover {\n    border-color: #fff9c2;\n}\n.md\\:hover\\:border-yellow-lightest:hover {\n    border-color: #fcfbeb;\n}\n.md\\:hover\\:border-green-darkest:hover {\n    border-color: #0f2f21;\n}\n.md\\:hover\\:border-green-darker:hover {\n    border-color: #1a4731;\n}\n.md\\:hover\\:border-green-dark:hover {\n    border-color: #1f9d55;\n}\n.md\\:hover\\:border-green:hover {\n    border-color: #38c172;\n}\n.md\\:hover\\:border-green-light:hover {\n    border-color: #51d88a;\n}\n.md\\:hover\\:border-green-lighter:hover {\n    border-color: #a2f5bf;\n}\n.md\\:hover\\:border-green-lightest:hover {\n    border-color: #e3fcec;\n}\n.md\\:hover\\:border-teal-darkest:hover {\n    border-color: #0d3331;\n}\n.md\\:hover\\:border-teal-darker:hover {\n    border-color: #20504f;\n}\n.md\\:hover\\:border-teal-dark:hover {\n    border-color: #009480;\n}\n.md\\:hover\\:border-teal:hover {\n    border-color: #00ae98;\n}\n.md\\:hover\\:border-teal-light:hover {\n    border-color: #64d5ca;\n}\n.md\\:hover\\:border-teal-lighter:hover {\n    border-color: #a0f0ed;\n}\n.md\\:hover\\:border-teal-lightest:hover {\n    border-color: #e8fffe;\n}\n.md\\:hover\\:border-blue-darkest:hover {\n    border-color: #12283a;\n}\n.md\\:hover\\:border-blue-darker:hover {\n    border-color: #2e6da2;\n}\n.md\\:hover\\:border-blue-dark:hover {\n    border-color: #2779bd;\n}\n.md\\:hover\\:border-blue:hover {\n    border-color: #3490dc;\n}\n.md\\:hover\\:border-blue-light:hover {\n    border-color: #6cb2eb;\n}\n.md\\:hover\\:border-blue-lighter:hover {\n    border-color: #bcdefa;\n}\n.md\\:hover\\:border-blue-lightest:hover {\n    border-color: #eff8ff;\n}\n.md\\:hover\\:border-indigo-darkest:hover {\n    border-color: #191e38;\n}\n.md\\:hover\\:border-indigo-darker:hover {\n    border-color: #2f365f;\n}\n.md\\:hover\\:border-indigo-dark:hover {\n    border-color: #5661b3;\n}\n.md\\:hover\\:border-indigo:hover {\n    border-color: #6574cd;\n}\n.md\\:hover\\:border-indigo-light:hover {\n    border-color: #7886d7;\n}\n.md\\:hover\\:border-indigo-lighter:hover {\n    border-color: #b2b7ff;\n}\n.md\\:hover\\:border-indigo-lightest:hover {\n    border-color: #e6e8ff;\n}\n.md\\:hover\\:border-purple-darkest:hover {\n    border-color: #21183c;\n}\n.md\\:hover\\:border-purple-darker:hover {\n    border-color: #382b5f;\n}\n.md\\:hover\\:border-purple-dark:hover {\n    border-color: #794acf;\n}\n.md\\:hover\\:border-purple:hover {\n    border-color: #9561e2;\n}\n.md\\:hover\\:border-purple-light:hover {\n    border-color: #a779e9;\n}\n.md\\:hover\\:border-purple-lighter:hover {\n    border-color: #d6bbfc;\n}\n.md\\:hover\\:border-purple-lightest:hover {\n    border-color: #f3ebff;\n}\n.md\\:hover\\:border-pink-darkest:hover {\n    border-color: #451225;\n}\n.md\\:hover\\:border-pink-darker:hover {\n    border-color: #6f213f;\n}\n.md\\:hover\\:border-pink-dark:hover {\n    border-color: #eb5286;\n}\n.md\\:hover\\:border-pink:hover {\n    border-color: #f66d9b;\n}\n.md\\:hover\\:border-pink-light:hover {\n    border-color: #fa7ea8;\n}\n.md\\:hover\\:border-pink-lighter:hover {\n    border-color: #ffbbca;\n}\n.md\\:hover\\:border-pink-lightest:hover {\n    border-color: #ffebef;\n}\n.md\\:rounded-none {\n    border-radius: 0;\n}\n.md\\:rounded-sm {\n    border-radius: .125rem;\n}\n.md\\:rounded {\n    border-radius: .25rem;\n}\n.md\\:rounded-lg {\n    border-radius: .5rem;\n}\n.md\\:rounded-full {\n    border-radius: 9999px;\n}\n.md\\:rounded-t-none {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n.md\\:rounded-r-none {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.md\\:rounded-b-none {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n}\n.md\\:rounded-l-none {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n.md\\:rounded-t-sm {\n    border-top-left-radius: .125rem;\n    border-top-right-radius: .125rem;\n}\n.md\\:rounded-r-sm {\n    border-top-right-radius: .125rem;\n    border-bottom-right-radius: .125rem;\n}\n.md\\:rounded-b-sm {\n    border-bottom-right-radius: .125rem;\n    border-bottom-left-radius: .125rem;\n}\n.md\\:rounded-l-sm {\n    border-top-left-radius: .125rem;\n    border-bottom-left-radius: .125rem;\n}\n.md\\:rounded-t {\n    border-top-left-radius: .25rem;\n    border-top-right-radius: .25rem;\n}\n.md\\:rounded-r {\n    border-top-right-radius: .25rem;\n    border-bottom-right-radius: .25rem;\n}\n.md\\:rounded-b {\n    border-bottom-right-radius: .25rem;\n    border-bottom-left-radius: .25rem;\n}\n.md\\:rounded-l {\n    border-top-left-radius: .25rem;\n    border-bottom-left-radius: .25rem;\n}\n.md\\:rounded-t-lg {\n    border-top-left-radius: .5rem;\n    border-top-right-radius: .5rem;\n}\n.md\\:rounded-r-lg {\n    border-top-right-radius: .5rem;\n    border-bottom-right-radius: .5rem;\n}\n.md\\:rounded-b-lg {\n    border-bottom-right-radius: .5rem;\n    border-bottom-left-radius: .5rem;\n}\n.md\\:rounded-l-lg {\n    border-top-left-radius: .5rem;\n    border-bottom-left-radius: .5rem;\n}\n.md\\:rounded-t-full {\n    border-top-left-radius: 9999px;\n    border-top-right-radius: 9999px;\n}\n.md\\:rounded-r-full {\n    border-top-right-radius: 9999px;\n    border-bottom-right-radius: 9999px;\n}\n.md\\:rounded-b-full {\n    border-bottom-right-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n}\n.md\\:rounded-l-full {\n    border-top-left-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n}\n.md\\:rounded-tl-none {\n    border-top-left-radius: 0;\n}\n.md\\:rounded-tr-none {\n    border-top-right-radius: 0;\n}\n.md\\:rounded-br-none {\n    border-bottom-right-radius: 0;\n}\n.md\\:rounded-bl-none {\n    border-bottom-left-radius: 0;\n}\n.md\\:rounded-tl-sm {\n    border-top-left-radius: .125rem;\n}\n.md\\:rounded-tr-sm {\n    border-top-right-radius: .125rem;\n}\n.md\\:rounded-br-sm {\n    border-bottom-right-radius: .125rem;\n}\n.md\\:rounded-bl-sm {\n    border-bottom-left-radius: .125rem;\n}\n.md\\:rounded-tl {\n    border-top-left-radius: .25rem;\n}\n.md\\:rounded-tr {\n    border-top-right-radius: .25rem;\n}\n.md\\:rounded-br {\n    border-bottom-right-radius: .25rem;\n}\n.md\\:rounded-bl {\n    border-bottom-left-radius: .25rem;\n}\n.md\\:rounded-tl-lg {\n    border-top-left-radius: .5rem;\n}\n.md\\:rounded-tr-lg {\n    border-top-right-radius: .5rem;\n}\n.md\\:rounded-br-lg {\n    border-bottom-right-radius: .5rem;\n}\n.md\\:rounded-bl-lg {\n    border-bottom-left-radius: .5rem;\n}\n.md\\:rounded-tl-full {\n    border-top-left-radius: 9999px;\n}\n.md\\:rounded-tr-full {\n    border-top-right-radius: 9999px;\n}\n.md\\:rounded-br-full {\n    border-bottom-right-radius: 9999px;\n}\n.md\\:rounded-bl-full {\n    border-bottom-left-radius: 9999px;\n}\n.md\\:border-solid {\n    border-style: solid;\n}\n.md\\:border-dashed {\n    border-style: dashed;\n}\n.md\\:border-dotted {\n    border-style: dotted;\n}\n.md\\:border-none {\n    border-style: none;\n}\n.md\\:border-0 {\n    border-width: 0;\n}\n.md\\:border-2 {\n    border-width: 2px;\n}\n.md\\:border-4 {\n    border-width: 4px;\n}\n.md\\:border-8 {\n    border-width: 8px;\n}\n.md\\:border {\n    border-width: 1px;\n}\n.md\\:border-t-0 {\n    border-top-width: 0;\n}\n.md\\:border-r-0 {\n    border-right-width: 0;\n}\n.md\\:border-b-0 {\n    border-bottom-width: 0;\n}\n.md\\:border-l-0 {\n    border-left-width: 0;\n}\n.md\\:border-t-2 {\n    border-top-width: 2px;\n}\n.md\\:border-r-2 {\n    border-right-width: 2px;\n}\n.md\\:border-b-2 {\n    border-bottom-width: 2px;\n}\n.md\\:border-l-2 {\n    border-left-width: 2px;\n}\n.md\\:border-t-4 {\n    border-top-width: 4px;\n}\n.md\\:border-r-4 {\n    border-right-width: 4px;\n}\n.md\\:border-b-4 {\n    border-bottom-width: 4px;\n}\n.md\\:border-l-4 {\n    border-left-width: 4px;\n}\n.md\\:border-t-8 {\n    border-top-width: 8px;\n}\n.md\\:border-r-8 {\n    border-right-width: 8px;\n}\n.md\\:border-b-8 {\n    border-bottom-width: 8px;\n}\n.md\\:border-l-8 {\n    border-left-width: 8px;\n}\n.md\\:border-t {\n    border-top-width: 1px;\n}\n.md\\:border-r {\n    border-right-width: 1px;\n}\n.md\\:border-b {\n    border-bottom-width: 1px;\n}\n.md\\:border-l {\n    border-left-width: 1px;\n}\n.md\\:cursor-auto {\n    cursor: auto;\n}\n.md\\:cursor-default {\n    cursor: default;\n}\n.md\\:cursor-pointer {\n    cursor: pointer;\n}\n.md\\:cursor-wait {\n    cursor: wait;\n}\n.md\\:cursor-move {\n    cursor: move;\n}\n.md\\:cursor-not-allowed {\n    cursor: not-allowed;\n}\n.md\\:block {\n    display: block;\n}\n.md\\:inline-block {\n    display: inline-block;\n}\n.md\\:inline {\n    display: inline;\n}\n.md\\:table {\n    display: table;\n}\n.md\\:table-row {\n    display: table-row;\n}\n.md\\:table-cell {\n    display: table-cell;\n}\n.md\\:hidden {\n    display: none;\n}\n.md\\:flex {\n    display: flex;\n}\n.md\\:inline-flex {\n    display: inline-flex;\n}\n.md\\:flex-row {\n    flex-direction: row;\n}\n.md\\:flex-row-reverse {\n    flex-direction: row-reverse;\n}\n.md\\:flex-col {\n    flex-direction: column;\n}\n.md\\:flex-col-reverse {\n    flex-direction: column-reverse;\n}\n.md\\:flex-wrap {\n    flex-wrap: wrap;\n}\n.md\\:flex-wrap-reverse {\n    flex-wrap: wrap-reverse;\n}\n.md\\:flex-no-wrap {\n    flex-wrap: nowrap;\n}\n.md\\:items-start {\n    align-items: flex-start;\n}\n.md\\:items-end {\n    align-items: flex-end;\n}\n.md\\:items-center {\n    align-items: center;\n}\n.md\\:items-baseline {\n    align-items: baseline;\n}\n.md\\:items-stretch {\n    align-items: stretch;\n}\n.md\\:self-auto {\n    align-self: auto;\n}\n.md\\:self-start {\n    align-self: flex-start;\n}\n.md\\:self-end {\n    align-self: flex-end;\n}\n.md\\:self-center {\n    align-self: center;\n}\n.md\\:self-stretch {\n    align-self: stretch;\n}\n.md\\:justify-start {\n    justify-content: flex-start;\n}\n.md\\:justify-end {\n    justify-content: flex-end;\n}\n.md\\:justify-center {\n    justify-content: center;\n}\n.md\\:justify-between {\n    justify-content: space-between;\n}\n.md\\:justify-around {\n    justify-content: space-around;\n}\n.md\\:content-center {\n    align-content: center;\n}\n.md\\:content-start {\n    align-content: flex-start;\n}\n.md\\:content-end {\n    align-content: flex-end;\n}\n.md\\:content-between {\n    align-content: space-between;\n}\n.md\\:content-around {\n    align-content: space-around;\n}\n.md\\:flex-1 {\n    flex: 1;\n}\n.md\\:flex-auto {\n    flex: auto;\n}\n.md\\:flex-initial {\n    flex: initial;\n}\n.md\\:flex-none {\n    flex: none;\n}\n.md\\:flex-grow {\n    flex-grow: 1;\n}\n.md\\:flex-shrink {\n    flex-shrink: 1;\n}\n.md\\:flex-no-grow {\n    flex-grow: 0;\n}\n.md\\:flex-no-shrink {\n    flex-shrink: 0;\n}\n.md\\:float-right {\n    float: right;\n}\n.md\\:float-left {\n    float: left;\n}\n.md\\:float-none {\n    float: none;\n}\n.md\\:clearfix:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.md\\:font-sans {\n    font-family: system-ui, BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n}\n.md\\:font-serif {\n    font-family: Constantia, Lucida Bright, Lucidabright, Lucida Serif, Lucida, DejaVu Serif, Bitstream Vera Serif, Liberation Serif, Georgia, serif;\n}\n.md\\:font-mono {\n    font-family: Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;\n}\n.md\\:font-hairline {\n    font-weight: 100;\n}\n.md\\:font-thin {\n    font-weight: 200;\n}\n.md\\:font-light {\n    font-weight: 300;\n}\n.md\\:font-normal {\n    font-weight: 400;\n}\n.md\\:font-medium {\n    font-weight: 500;\n}\n.md\\:font-semibold {\n    font-weight: 600;\n}\n.md\\:font-bold {\n    font-weight: 700;\n}\n.md\\:font-extrabold {\n    font-weight: 800;\n}\n.md\\:font-black {\n    font-weight: 900;\n}\n.md\\:hover\\:font-hairline:hover {\n    font-weight: 100;\n}\n.md\\:hover\\:font-thin:hover {\n    font-weight: 200;\n}\n.md\\:hover\\:font-light:hover {\n    font-weight: 300;\n}\n.md\\:hover\\:font-normal:hover {\n    font-weight: 400;\n}\n.md\\:hover\\:font-medium:hover {\n    font-weight: 500;\n}\n.md\\:hover\\:font-semibold:hover {\n    font-weight: 600;\n}\n.md\\:hover\\:font-bold:hover {\n    font-weight: 700;\n}\n.md\\:hover\\:font-extrabold:hover {\n    font-weight: 800;\n}\n.md\\:hover\\:font-black:hover {\n    font-weight: 900;\n}\n.md\\:h-1 {\n    height: .25rem;\n}\n.md\\:h-2 {\n    height: .5rem;\n}\n.md\\:h-3 {\n    height: .75rem;\n}\n.md\\:h-4 {\n    height: 1rem;\n}\n.md\\:h-6 {\n    height: 1.5rem;\n}\n.md\\:h-8 {\n    height: 2rem;\n}\n.md\\:h-10 {\n    height: 2.5rem;\n}\n.md\\:h-12 {\n    height: 3rem;\n}\n.md\\:h-16 {\n    height: 4rem;\n}\n.md\\:h-24 {\n    height: 6rem;\n}\n.md\\:h-32 {\n    height: 8rem;\n}\n.md\\:h-48 {\n    height: 12rem;\n}\n.md\\:h-64 {\n    height: 16rem;\n}\n.md\\:h-auto {\n    height: auto;\n}\n.md\\:h-px {\n    height: 1px;\n}\n.md\\:h-full {\n    height: 100%;\n}\n.md\\:h-screen {\n    height: 100vh;\n}\n.md\\:h-screen-footer {\n    height: 80vh;\n}\n.md\\:h-timeslots {\n    height: calc(100vh - 3rem - 1rem);\n}\n.md\\:leading-none {\n    line-height: 1;\n}\n.md\\:leading-tight {\n    line-height: 1.25;\n}\n.md\\:leading-normal {\n    line-height: 1.5;\n}\n.md\\:leading-loose {\n    line-height: 2;\n}\n.md\\:m-0 {\n    margin: 0;\n}\n.md\\:m-1 {\n    margin: .25rem;\n}\n.md\\:m-2 {\n    margin: .5rem;\n}\n.md\\:m-3 {\n    margin: .75rem;\n}\n.md\\:m-4 {\n    margin: 1rem;\n}\n.md\\:m-6 {\n    margin: 1.5rem;\n}\n.md\\:m-8 {\n    margin: 2rem;\n}\n.md\\:m-10 {\n    margin: 2.5rem;\n}\n.md\\:m-12 {\n    margin: 3rem;\n}\n.md\\:m-16 {\n    margin: 4rem;\n}\n.md\\:m-24 {\n    margin: 6rem;\n}\n.md\\:m-32 {\n    margin: 8rem;\n}\n.md\\:m-48 {\n    margin: 10rem;\n}\n.md\\:m-auto {\n    margin: auto;\n}\n.md\\:m-px {\n    margin: 1px;\n}\n.md\\:my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n.md\\:mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n}\n.md\\:my-1 {\n    margin-top: .25rem;\n    margin-bottom: .25rem;\n}\n.md\\:mx-1 {\n    margin-left: .25rem;\n    margin-right: .25rem;\n}\n.md\\:my-2 {\n    margin-top: .5rem;\n    margin-bottom: .5rem;\n}\n.md\\:mx-2 {\n    margin-left: .5rem;\n    margin-right: .5rem;\n}\n.md\\:my-3 {\n    margin-top: .75rem;\n    margin-bottom: .75rem;\n}\n.md\\:mx-3 {\n    margin-left: .75rem;\n    margin-right: .75rem;\n}\n.md\\:my-4 {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n}\n.md\\:mx-4 {\n    margin-left: 1rem;\n    margin-right: 1rem;\n}\n.md\\:my-6 {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n}\n.md\\:mx-6 {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n}\n.md\\:my-8 {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n}\n.md\\:mx-8 {\n    margin-left: 2rem;\n    margin-right: 2rem;\n}\n.md\\:my-10 {\n    margin-top: 2.5rem;\n    margin-bottom: 2.5rem;\n}\n.md\\:mx-10 {\n    margin-left: 2.5rem;\n    margin-right: 2.5rem;\n}\n.md\\:my-12 {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n}\n.md\\:mx-12 {\n    margin-left: 3rem;\n    margin-right: 3rem;\n}\n.md\\:my-16 {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n}\n.md\\:mx-16 {\n    margin-left: 4rem;\n    margin-right: 4rem;\n}\n.md\\:my-24 {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n}\n.md\\:mx-24 {\n    margin-left: 6rem;\n    margin-right: 6rem;\n}\n.md\\:my-32 {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n}\n.md\\:mx-32 {\n    margin-left: 8rem;\n    margin-right: 8rem;\n}\n.md\\:my-48 {\n    margin-top: 10rem;\n    margin-bottom: 10rem;\n}\n.md\\:mx-48 {\n    margin-left: 10rem;\n    margin-right: 10rem;\n}\n.md\\:my-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n}\n.md\\:mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n}\n.md\\:my-px {\n    margin-top: 1px;\n    margin-bottom: 1px;\n}\n.md\\:mx-px {\n    margin-left: 1px;\n    margin-right: 1px;\n}\n.md\\:mt-0 {\n    margin-top: 0;\n}\n.md\\:mr-0 {\n    margin-right: 0;\n}\n.md\\:mb-0 {\n    margin-bottom: 0;\n}\n.md\\:ml-0 {\n    margin-left: 0;\n}\n.md\\:mt-1 {\n    margin-top: .25rem;\n}\n.md\\:mr-1 {\n    margin-right: .25rem;\n}\n.md\\:mb-1 {\n    margin-bottom: .25rem;\n}\n.md\\:ml-1 {\n    margin-left: .25rem;\n}\n.md\\:mt-2 {\n    margin-top: .5rem;\n}\n.md\\:mr-2 {\n    margin-right: .5rem;\n}\n.md\\:mb-2 {\n    margin-bottom: .5rem;\n}\n.md\\:ml-2 {\n    margin-left: .5rem;\n}\n.md\\:mt-3 {\n    margin-top: .75rem;\n}\n.md\\:mr-3 {\n    margin-right: .75rem;\n}\n.md\\:mb-3 {\n    margin-bottom: .75rem;\n}\n.md\\:ml-3 {\n    margin-left: .75rem;\n}\n.md\\:mt-4 {\n    margin-top: 1rem;\n}\n.md\\:mr-4 {\n    margin-right: 1rem;\n}\n.md\\:mb-4 {\n    margin-bottom: 1rem;\n}\n.md\\:ml-4 {\n    margin-left: 1rem;\n}\n.md\\:mt-6 {\n    margin-top: 1.5rem;\n}\n.md\\:mr-6 {\n    margin-right: 1.5rem;\n}\n.md\\:mb-6 {\n    margin-bottom: 1.5rem;\n}\n.md\\:ml-6 {\n    margin-left: 1.5rem;\n}\n.md\\:mt-8 {\n    margin-top: 2rem;\n}\n.md\\:mr-8 {\n    margin-right: 2rem;\n}\n.md\\:mb-8 {\n    margin-bottom: 2rem;\n}\n.md\\:ml-8 {\n    margin-left: 2rem;\n}\n.md\\:mt-10 {\n    margin-top: 2.5rem;\n}\n.md\\:mr-10 {\n    margin-right: 2.5rem;\n}\n.md\\:mb-10 {\n    margin-bottom: 2.5rem;\n}\n.md\\:ml-10 {\n    margin-left: 2.5rem;\n}\n.md\\:mt-12 {\n    margin-top: 3rem;\n}\n.md\\:mr-12 {\n    margin-right: 3rem;\n}\n.md\\:mb-12 {\n    margin-bottom: 3rem;\n}\n.md\\:ml-12 {\n    margin-left: 3rem;\n}\n.md\\:mt-16 {\n    margin-top: 4rem;\n}\n.md\\:mr-16 {\n    margin-right: 4rem;\n}\n.md\\:mb-16 {\n    margin-bottom: 4rem;\n}\n.md\\:ml-16 {\n    margin-left: 4rem;\n}\n.md\\:mt-24 {\n    margin-top: 6rem;\n}\n.md\\:mr-24 {\n    margin-right: 6rem;\n}\n.md\\:mb-24 {\n    margin-bottom: 6rem;\n}\n.md\\:ml-24 {\n    margin-left: 6rem;\n}\n.md\\:mt-32 {\n    margin-top: 8rem;\n}\n.md\\:mr-32 {\n    margin-right: 8rem;\n}\n.md\\:mb-32 {\n    margin-bottom: 8rem;\n}\n.md\\:ml-32 {\n    margin-left: 8rem;\n}\n.md\\:mt-48 {\n    margin-top: 10rem;\n}\n.md\\:mr-48 {\n    margin-right: 10rem;\n}\n.md\\:mb-48 {\n    margin-bottom: 10rem;\n}\n.md\\:ml-48 {\n    margin-left: 10rem;\n}\n.md\\:mt-auto {\n    margin-top: auto;\n}\n.md\\:mr-auto {\n    margin-right: auto;\n}\n.md\\:mb-auto {\n    margin-bottom: auto;\n}\n.md\\:ml-auto {\n    margin-left: auto;\n}\n.md\\:mt-px {\n    margin-top: 1px;\n}\n.md\\:mr-px {\n    margin-right: 1px;\n}\n.md\\:mb-px {\n    margin-bottom: 1px;\n}\n.md\\:ml-px {\n    margin-left: 1px;\n}\n.md\\:max-h-full {\n    max-height: 100%;\n}\n.md\\:max-h-screen {\n    max-height: 100vh;\n}\n.md\\:max-h-timeslots {\n    max-height: calc(100vh - 3rem - 1rem - 14rem);\n}\n.md\\:max-w-xs {\n    max-width: 20rem;\n}\n.md\\:max-w-sm {\n    max-width: 30rem;\n}\n.md\\:max-w-md {\n    max-width: 40rem;\n}\n.md\\:max-w-lg {\n    max-width: 50rem;\n}\n.md\\:max-w-xl {\n    max-width: 60rem;\n}\n.md\\:max-w-2xl {\n    max-width: 70rem;\n}\n.md\\:max-w-3xl {\n    max-width: 80rem;\n}\n.md\\:max-w-4xl {\n    max-width: 90rem;\n}\n.md\\:max-w-5xl {\n    max-width: 100rem;\n}\n.md\\:max-w-full {\n    max-width: 100%;\n}\n.md\\:min-h-0 {\n    min-height: 0;\n}\n.md\\:min-h-full {\n    min-height: 100%;\n}\n.md\\:min-h-screen {\n    min-height: 100vh;\n}\n.md\\:min-h-\\(screen-footer-sm\\) {\n    min-height: calc(100vh - 350px);\n}\n.md\\:min-h-\\(screen-footer-md\\) {\n    min-height: calc(100vh - 180px);\n}\n.md\\:min-w-0 {\n    min-width: 0;\n}\n.md\\:min-w-full {\n    min-width: 100%;\n}\n.md\\:-m-0 {\n    margin: 0;\n}\n.md\\:-m-1 {\n    margin: -0.25rem;\n}\n.md\\:-m-2 {\n    margin: -0.5rem;\n}\n.md\\:-m-3 {\n    margin: -0.75rem;\n}\n.md\\:-m-4 {\n    margin: -1rem;\n}\n.md\\:-m-6 {\n    margin: -1.5rem;\n}\n.md\\:-m-8 {\n    margin: -2rem;\n}\n.md\\:-m-10 {\n    margin: -2.5rem;\n}\n.md\\:-m-12 {\n    margin: -3rem;\n}\n.md\\:-m-16 {\n    margin: -4rem;\n}\n.md\\:-m-24 {\n    margin: -6rem;\n}\n.md\\:-m-32 {\n    margin: -8rem;\n}\n.md\\:-m-48 {\n    margin: -10rem;\n}\n.md\\:-m-px {\n    margin: -1px;\n}\n.md\\:-my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n.md\\:-mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n}\n.md\\:-my-1 {\n    margin-top: -0.25rem;\n    margin-bottom: -0.25rem;\n}\n.md\\:-mx-1 {\n    margin-left: -0.25rem;\n    margin-right: -0.25rem;\n}\n.md\\:-my-2 {\n    margin-top: -0.5rem;\n    margin-bottom: -0.5rem;\n}\n.md\\:-mx-2 {\n    margin-left: -0.5rem;\n    margin-right: -0.5rem;\n}\n.md\\:-my-3 {\n    margin-top: -0.75rem;\n    margin-bottom: -0.75rem;\n}\n.md\\:-mx-3 {\n    margin-left: -0.75rem;\n    margin-right: -0.75rem;\n}\n.md\\:-my-4 {\n    margin-top: -1rem;\n    margin-bottom: -1rem;\n}\n.md\\:-mx-4 {\n    margin-left: -1rem;\n    margin-right: -1rem;\n}\n.md\\:-my-6 {\n    margin-top: -1.5rem;\n    margin-bottom: -1.5rem;\n}\n.md\\:-mx-6 {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n}\n.md\\:-my-8 {\n    margin-top: -2rem;\n    margin-bottom: -2rem;\n}\n.md\\:-mx-8 {\n    margin-left: -2rem;\n    margin-right: -2rem;\n}\n.md\\:-my-10 {\n    margin-top: -2.5rem;\n    margin-bottom: -2.5rem;\n}\n.md\\:-mx-10 {\n    margin-left: -2.5rem;\n    margin-right: -2.5rem;\n}\n.md\\:-my-12 {\n    margin-top: -3rem;\n    margin-bottom: -3rem;\n}\n.md\\:-mx-12 {\n    margin-left: -3rem;\n    margin-right: -3rem;\n}\n.md\\:-my-16 {\n    margin-top: -4rem;\n    margin-bottom: -4rem;\n}\n.md\\:-mx-16 {\n    margin-left: -4rem;\n    margin-right: -4rem;\n}\n.md\\:-my-24 {\n    margin-top: -6rem;\n    margin-bottom: -6rem;\n}\n.md\\:-mx-24 {\n    margin-left: -6rem;\n    margin-right: -6rem;\n}\n.md\\:-my-32 {\n    margin-top: -8rem;\n    margin-bottom: -8rem;\n}\n.md\\:-mx-32 {\n    margin-left: -8rem;\n    margin-right: -8rem;\n}\n.md\\:-my-48 {\n    margin-top: -10rem;\n    margin-bottom: -10rem;\n}\n.md\\:-mx-48 {\n    margin-left: -10rem;\n    margin-right: -10rem;\n}\n.md\\:-my-px {\n    margin-top: -1px;\n    margin-bottom: -1px;\n}\n.md\\:-mx-px {\n    margin-left: -1px;\n    margin-right: -1px;\n}\n.md\\:-mt-0 {\n    margin-top: 0;\n}\n.md\\:-mr-0 {\n    margin-right: 0;\n}\n.md\\:-mb-0 {\n    margin-bottom: 0;\n}\n.md\\:-ml-0 {\n    margin-left: 0;\n}\n.md\\:-mt-1 {\n    margin-top: -0.25rem;\n}\n.md\\:-mr-1 {\n    margin-right: -0.25rem;\n}\n.md\\:-mb-1 {\n    margin-bottom: -0.25rem;\n}\n.md\\:-ml-1 {\n    margin-left: -0.25rem;\n}\n.md\\:-mt-2 {\n    margin-top: -0.5rem;\n}\n.md\\:-mr-2 {\n    margin-right: -0.5rem;\n}\n.md\\:-mb-2 {\n    margin-bottom: -0.5rem;\n}\n.md\\:-ml-2 {\n    margin-left: -0.5rem;\n}\n.md\\:-mt-3 {\n    margin-top: -0.75rem;\n}\n.md\\:-mr-3 {\n    margin-right: -0.75rem;\n}\n.md\\:-mb-3 {\n    margin-bottom: -0.75rem;\n}\n.md\\:-ml-3 {\n    margin-left: -0.75rem;\n}\n.md\\:-mt-4 {\n    margin-top: -1rem;\n}\n.md\\:-mr-4 {\n    margin-right: -1rem;\n}\n.md\\:-mb-4 {\n    margin-bottom: -1rem;\n}\n.md\\:-ml-4 {\n    margin-left: -1rem;\n}\n.md\\:-mt-6 {\n    margin-top: -1.5rem;\n}\n.md\\:-mr-6 {\n    margin-right: -1.5rem;\n}\n.md\\:-mb-6 {\n    margin-bottom: -1.5rem;\n}\n.md\\:-ml-6 {\n    margin-left: -1.5rem;\n}\n.md\\:-mt-8 {\n    margin-top: -2rem;\n}\n.md\\:-mr-8 {\n    margin-right: -2rem;\n}\n.md\\:-mb-8 {\n    margin-bottom: -2rem;\n}\n.md\\:-ml-8 {\n    margin-left: -2rem;\n}\n.md\\:-mt-10 {\n    margin-top: -2.5rem;\n}\n.md\\:-mr-10 {\n    margin-right: -2.5rem;\n}\n.md\\:-mb-10 {\n    margin-bottom: -2.5rem;\n}\n.md\\:-ml-10 {\n    margin-left: -2.5rem;\n}\n.md\\:-mt-12 {\n    margin-top: -3rem;\n}\n.md\\:-mr-12 {\n    margin-right: -3rem;\n}\n.md\\:-mb-12 {\n    margin-bottom: -3rem;\n}\n.md\\:-ml-12 {\n    margin-left: -3rem;\n}\n.md\\:-mt-16 {\n    margin-top: -4rem;\n}\n.md\\:-mr-16 {\n    margin-right: -4rem;\n}\n.md\\:-mb-16 {\n    margin-bottom: -4rem;\n}\n.md\\:-ml-16 {\n    margin-left: -4rem;\n}\n.md\\:-mt-24 {\n    margin-top: -6rem;\n}\n.md\\:-mr-24 {\n    margin-right: -6rem;\n}\n.md\\:-mb-24 {\n    margin-bottom: -6rem;\n}\n.md\\:-ml-24 {\n    margin-left: -6rem;\n}\n.md\\:-mt-32 {\n    margin-top: -8rem;\n}\n.md\\:-mr-32 {\n    margin-right: -8rem;\n}\n.md\\:-mb-32 {\n    margin-bottom: -8rem;\n}\n.md\\:-ml-32 {\n    margin-left: -8rem;\n}\n.md\\:-mt-48 {\n    margin-top: -10rem;\n}\n.md\\:-mr-48 {\n    margin-right: -10rem;\n}\n.md\\:-mb-48 {\n    margin-bottom: -10rem;\n}\n.md\\:-ml-48 {\n    margin-left: -10rem;\n}\n.md\\:-mt-px {\n    margin-top: -1px;\n}\n.md\\:-mr-px {\n    margin-right: -1px;\n}\n.md\\:-mb-px {\n    margin-bottom: -1px;\n}\n.md\\:-ml-px {\n    margin-left: -1px;\n}\n.md\\:opacity-0 {\n    opacity: 0;\n}\n.md\\:opacity-25 {\n    opacity: .25;\n}\n.md\\:opacity-50 {\n    opacity: .5;\n}\n.md\\:opacity-75 {\n    opacity: .75;\n}\n.md\\:opacity-100 {\n    opacity: 1;\n}\n.md\\:hover\\:opacity-0:hover {\n    opacity: 0;\n}\n.md\\:hover\\:opacity-25:hover {\n    opacity: .25;\n}\n.md\\:hover\\:opacity-50:hover {\n    opacity: .5;\n}\n.md\\:hover\\:opacity-75:hover {\n    opacity: .75;\n}\n.md\\:hover\\:opacity-100:hover {\n    opacity: 1;\n}\n.md\\:overflow-auto {\n    overflow: auto;\n}\n.md\\:overflow-hidden {\n    overflow: hidden;\n}\n.md\\:overflow-visible {\n    overflow: visible;\n}\n.md\\:overflow-scroll {\n    overflow: scroll;\n}\n.md\\:overflow-x-auto {\n    overflow-x: auto;\n}\n.md\\:overflow-y-auto {\n    overflow-y: auto;\n}\n.md\\:overflow-x-scroll {\n    overflow-x: scroll;\n}\n.md\\:overflow-y-scroll {\n    overflow-y: scroll;\n}\n.md\\:scrolling-touch {\n    -webkit-overflow-scrolling: touch;\n}\n.md\\:scrolling-auto {\n    -webkit-overflow-scrolling: auto;\n}\n.md\\:p-0 {\n    padding: 0;\n}\n.md\\:p-1 {\n    padding: .25rem;\n}\n.md\\:p-2 {\n    padding: .5rem;\n}\n.md\\:p-3 {\n    padding: .75rem;\n}\n.md\\:p-4 {\n    padding: 1rem;\n}\n.md\\:p-6 {\n    padding: 1.5rem;\n}\n.md\\:p-8 {\n    padding: 2rem;\n}\n.md\\:p-10 {\n    padding: 2.5rem;\n}\n.md\\:p-12 {\n    padding: 3rem;\n}\n.md\\:p-16 {\n    padding: 4rem;\n}\n.md\\:p-24 {\n    padding: 6rem;\n}\n.md\\:p-32 {\n    padding: 8rem;\n}\n.md\\:p-48 {\n    padding: 10rem;\n}\n.md\\:p-px {\n    padding: 1px;\n}\n.md\\:py-0 {\n    padding-top: 0;\n    padding-bottom: 0;\n}\n.md\\:px-0 {\n    padding-left: 0;\n    padding-right: 0;\n}\n.md\\:py-1 {\n    padding-top: .25rem;\n    padding-bottom: .25rem;\n}\n.md\\:px-1 {\n    padding-left: .25rem;\n    padding-right: .25rem;\n}\n.md\\:py-2 {\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n}\n.md\\:px-2 {\n    padding-left: .5rem;\n    padding-right: .5rem;\n}\n.md\\:py-3 {\n    padding-top: .75rem;\n    padding-bottom: .75rem;\n}\n.md\\:px-3 {\n    padding-left: .75rem;\n    padding-right: .75rem;\n}\n.md\\:py-4 {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n}\n.md\\:px-4 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n}\n.md\\:py-6 {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n}\n.md\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n}\n.md\\:py-8 {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n}\n.md\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n}\n.md\\:py-10 {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n}\n.md\\:px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n}\n.md\\:py-12 {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n}\n.md\\:px-12 {\n    padding-left: 3rem;\n    padding-right: 3rem;\n}\n.md\\:py-16 {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n}\n.md\\:px-16 {\n    padding-left: 4rem;\n    padding-right: 4rem;\n}\n.md\\:py-24 {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n}\n.md\\:px-24 {\n    padding-left: 6rem;\n    padding-right: 6rem;\n}\n.md\\:py-32 {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n}\n.md\\:px-32 {\n    padding-left: 8rem;\n    padding-right: 8rem;\n}\n.md\\:py-48 {\n    padding-top: 10rem;\n    padding-bottom: 10rem;\n}\n.md\\:px-48 {\n    padding-left: 10rem;\n    padding-right: 10rem;\n}\n.md\\:py-px {\n    padding-top: 1px;\n    padding-bottom: 1px;\n}\n.md\\:px-px {\n    padding-left: 1px;\n    padding-right: 1px;\n}\n.md\\:pt-0 {\n    padding-top: 0;\n}\n.md\\:pr-0 {\n    padding-right: 0;\n}\n.md\\:pb-0 {\n    padding-bottom: 0;\n}\n.md\\:pl-0 {\n    padding-left: 0;\n}\n.md\\:pt-1 {\n    padding-top: .25rem;\n}\n.md\\:pr-1 {\n    padding-right: .25rem;\n}\n.md\\:pb-1 {\n    padding-bottom: .25rem;\n}\n.md\\:pl-1 {\n    padding-left: .25rem;\n}\n.md\\:pt-2 {\n    padding-top: .5rem;\n}\n.md\\:pr-2 {\n    padding-right: .5rem;\n}\n.md\\:pb-2 {\n    padding-bottom: .5rem;\n}\n.md\\:pl-2 {\n    padding-left: .5rem;\n}\n.md\\:pt-3 {\n    padding-top: .75rem;\n}\n.md\\:pr-3 {\n    padding-right: .75rem;\n}\n.md\\:pb-3 {\n    padding-bottom: .75rem;\n}\n.md\\:pl-3 {\n    padding-left: .75rem;\n}\n.md\\:pt-4 {\n    padding-top: 1rem;\n}\n.md\\:pr-4 {\n    padding-right: 1rem;\n}\n.md\\:pb-4 {\n    padding-bottom: 1rem;\n}\n.md\\:pl-4 {\n    padding-left: 1rem;\n}\n.md\\:pt-6 {\n    padding-top: 1.5rem;\n}\n.md\\:pr-6 {\n    padding-right: 1.5rem;\n}\n.md\\:pb-6 {\n    padding-bottom: 1.5rem;\n}\n.md\\:pl-6 {\n    padding-left: 1.5rem;\n}\n.md\\:pt-8 {\n    padding-top: 2rem;\n}\n.md\\:pr-8 {\n    padding-right: 2rem;\n}\n.md\\:pb-8 {\n    padding-bottom: 2rem;\n}\n.md\\:pl-8 {\n    padding-left: 2rem;\n}\n.md\\:pt-10 {\n    padding-top: 2.5rem;\n}\n.md\\:pr-10 {\n    padding-right: 2.5rem;\n}\n.md\\:pb-10 {\n    padding-bottom: 2.5rem;\n}\n.md\\:pl-10 {\n    padding-left: 2.5rem;\n}\n.md\\:pt-12 {\n    padding-top: 3rem;\n}\n.md\\:pr-12 {\n    padding-right: 3rem;\n}\n.md\\:pb-12 {\n    padding-bottom: 3rem;\n}\n.md\\:pl-12 {\n    padding-left: 3rem;\n}\n.md\\:pt-16 {\n    padding-top: 4rem;\n}\n.md\\:pr-16 {\n    padding-right: 4rem;\n}\n.md\\:pb-16 {\n    padding-bottom: 4rem;\n}\n.md\\:pl-16 {\n    padding-left: 4rem;\n}\n.md\\:pt-24 {\n    padding-top: 6rem;\n}\n.md\\:pr-24 {\n    padding-right: 6rem;\n}\n.md\\:pb-24 {\n    padding-bottom: 6rem;\n}\n.md\\:pl-24 {\n    padding-left: 6rem;\n}\n.md\\:pt-32 {\n    padding-top: 8rem;\n}\n.md\\:pr-32 {\n    padding-right: 8rem;\n}\n.md\\:pb-32 {\n    padding-bottom: 8rem;\n}\n.md\\:pl-32 {\n    padding-left: 8rem;\n}\n.md\\:pt-48 {\n    padding-top: 10rem;\n}\n.md\\:pr-48 {\n    padding-right: 10rem;\n}\n.md\\:pb-48 {\n    padding-bottom: 10rem;\n}\n.md\\:pl-48 {\n    padding-left: 10rem;\n}\n.md\\:pt-px {\n    padding-top: 1px;\n}\n.md\\:pr-px {\n    padding-right: 1px;\n}\n.md\\:pb-px {\n    padding-bottom: 1px;\n}\n.md\\:pl-px {\n    padding-left: 1px;\n}\n.md\\:pointer-events-none {\n    pointer-events: none;\n}\n.md\\:pointer-events-auto {\n    pointer-events: auto;\n}\n.md\\:static {\n    position: static;\n}\n.md\\:fixed {\n    position: fixed;\n}\n.md\\:absolute {\n    position: absolute;\n}\n.md\\:relative {\n    position: relative;\n}\n.md\\:sticky {\n    position: sticky;\n}\n.md\\:pin-none {\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n}\n.md\\:pin {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n.md\\:pin-y {\n    top: 0;\n    bottom: 0;\n}\n.md\\:pin-x {\n    right: 0;\n    left: 0;\n}\n.md\\:pin-t {\n    top: 0;\n}\n.md\\:pin-r {\n    right: 0;\n}\n.md\\:pin-b {\n    bottom: 0;\n}\n.md\\:pin-l {\n    left: 0;\n}\n.md\\:resize-none {\n    resize: none;\n}\n.md\\:resize-y {\n    resize: vertical;\n}\n.md\\:resize-x {\n    resize: horizontal;\n}\n.md\\:resize {\n    resize: both;\n}\n.md\\:shadow {\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .1);\n}\n.md\\:shadow-md {\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .12), 0 2px 4px 0 rgba(0, 0, 0, .08);\n}\n.md\\:shadow-lg {\n    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, .11), 0 5px 15px 0 rgba(0, 0, 0, .08);\n}\n.md\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, .06);\n}\n.md\\:shadow-none {\n    box-shadow: none;\n}\n.md\\:text-left {\n    text-align: left;\n}\n.md\\:text-center {\n    text-align: center;\n}\n.md\\:text-right {\n    text-align: right;\n}\n.md\\:text-justify {\n    text-align: justify;\n}\n.md\\:text-transparent {\n    color: transparent;\n}\n.md\\:text-modal {\n    color: rgba(0, 0, 0, .4);\n}\n.md\\:text-google {\n    color: #dc5b5b;\n}\n.md\\:text-google-dark {\n    color: #da5050;\n}\n.md\\:text-facebook {\n    color: #3b5998;\n}\n.md\\:text-facebook-dark {\n    color: #37548f;\n}\n.md\\:text-primary {\n    color: #2196f3;\n}\n.md\\:text-primary-dark {\n    color: #3b5998;\n}\n.md\\:text-footer {\n    color: #1976d2;\n}\n.md\\:text-black {\n    color: #22292f;\n}\n.md\\:text-grey-darkest {\n    color: #3d4852;\n}\n.md\\:text-grey-darker {\n    color: #606f7b;\n}\n.md\\:text-grey-dark {\n    color: #8795a1;\n}\n.md\\:text-grey {\n    color: #b8c2cc;\n}\n.md\\:text-grey-light {\n    color: #dae1e7;\n}\n.md\\:text-grey-lighter {\n    color: #f1f5f8;\n}\n.md\\:text-grey-lightest {\n    color: #f8fafc;\n}\n.md\\:text-white {\n    color: #fff;\n}\n.md\\:text-whiter {\n    color: rgba(255, 255, 255, .6);\n}\n.md\\:text-red-darkest {\n    color: #3b0d0c;\n}\n.md\\:text-red-darker {\n    color: #621b18;\n}\n.md\\:text-red-dark {\n    color: #cc1f1a;\n}\n.md\\:text-red {\n    color: #e3342f;\n}\n.md\\:text-red-light {\n    color: #ef5753;\n}\n.md\\:text-red-lighter {\n    color: #f9acaa;\n}\n.md\\:text-red-lightest {\n    color: #fcebea;\n}\n.md\\:text-orange-darkest {\n    color: #462a16;\n}\n.md\\:text-orange-darker {\n    color: #613b1f;\n}\n.md\\:text-orange-dark {\n    color: #de751f;\n}\n.md\\:text-orange {\n    color: #f6993f;\n}\n.md\\:text-orange-light {\n    color: #faad63;\n}\n.md\\:text-orange-lighter {\n    color: #fcd9b6;\n}\n.md\\:text-orange-lightest {\n    color: #fff5eb;\n}\n.md\\:text-yellow-darkest {\n    color: #453411;\n}\n.md\\:text-yellow-darker {\n    color: #684f1d;\n}\n.md\\:text-yellow-dark {\n    color: #f2d024;\n}\n.md\\:text-yellow {\n    color: #ffed4a;\n}\n.md\\:text-yellow-light {\n    color: #fff382;\n}\n.md\\:text-yellow-lighter {\n    color: #fff9c2;\n}\n.md\\:text-yellow-lightest {\n    color: #fcfbeb;\n}\n.md\\:text-green-darkest {\n    color: #0f2f21;\n}\n.md\\:text-green-darker {\n    color: #1a4731;\n}\n.md\\:text-green-dark {\n    color: #1f9d55;\n}\n.md\\:text-green {\n    color: #38c172;\n}\n.md\\:text-green-light {\n    color: #51d88a;\n}\n.md\\:text-green-lighter {\n    color: #a2f5bf;\n}\n.md\\:text-green-lightest {\n    color: #e3fcec;\n}\n.md\\:text-teal-darkest {\n    color: #0d3331;\n}\n.md\\:text-teal-darker {\n    color: #20504f;\n}\n.md\\:text-teal-dark {\n    color: #009480;\n}\n.md\\:text-teal {\n    color: #00ae98;\n}\n.md\\:text-teal-light {\n    color: #64d5ca;\n}\n.md\\:text-teal-lighter {\n    color: #a0f0ed;\n}\n.md\\:text-teal-lightest {\n    color: #e8fffe;\n}\n.md\\:text-blue-darkest {\n    color: #12283a;\n}\n.md\\:text-blue-darker {\n    color: #2e6da2;\n}\n.md\\:text-blue-dark {\n    color: #2779bd;\n}\n.md\\:text-blue {\n    color: #3490dc;\n}\n.md\\:text-blue-light {\n    color: #6cb2eb;\n}\n.md\\:text-blue-lighter {\n    color: #bcdefa;\n}\n.md\\:text-blue-lightest {\n    color: #eff8ff;\n}\n.md\\:text-indigo-darkest {\n    color: #191e38;\n}\n.md\\:text-indigo-darker {\n    color: #2f365f;\n}\n.md\\:text-indigo-dark {\n    color: #5661b3;\n}\n.md\\:text-indigo {\n    color: #6574cd;\n}\n.md\\:text-indigo-light {\n    color: #7886d7;\n}\n.md\\:text-indigo-lighter {\n    color: #b2b7ff;\n}\n.md\\:text-indigo-lightest {\n    color: #e6e8ff;\n}\n.md\\:text-purple-darkest {\n    color: #21183c;\n}\n.md\\:text-purple-darker {\n    color: #382b5f;\n}\n.md\\:text-purple-dark {\n    color: #794acf;\n}\n.md\\:text-purple {\n    color: #9561e2;\n}\n.md\\:text-purple-light {\n    color: #a779e9;\n}\n.md\\:text-purple-lighter {\n    color: #d6bbfc;\n}\n.md\\:text-purple-lightest {\n    color: #f3ebff;\n}\n.md\\:text-pink-darkest {\n    color: #451225;\n}\n.md\\:text-pink-darker {\n    color: #6f213f;\n}\n.md\\:text-pink-dark {\n    color: #eb5286;\n}\n.md\\:text-pink {\n    color: #f66d9b;\n}\n.md\\:text-pink-light {\n    color: #fa7ea8;\n}\n.md\\:text-pink-lighter {\n    color: #ffbbca;\n}\n.md\\:text-pink-lightest {\n    color: #ffebef;\n}\n.md\\:group:hover .group-hover\\:text-transparent {\n    color: transparent;\n}\n.md\\:group:hover .group-hover\\:text-modal {\n    color: rgba(0, 0, 0, .4);\n}\n.md\\:group:hover .group-hover\\:text-google {\n    color: #dc5b5b;\n}\n.md\\:group:hover .group-hover\\:text-google-dark {\n    color: #da5050;\n}\n.md\\:group:hover .group-hover\\:text-facebook {\n    color: #3b5998;\n}\n.md\\:group:hover .group-hover\\:text-facebook-dark {\n    color: #37548f;\n}\n.md\\:group:hover .group-hover\\:text-primary {\n    color: #2196f3;\n}\n.md\\:group:hover .group-hover\\:text-primary-dark {\n    color: #3b5998;\n}\n.md\\:group:hover .group-hover\\:text-footer {\n    color: #1976d2;\n}\n.md\\:group:hover .group-hover\\:text-black {\n    color: #22292f;\n}\n.md\\:group:hover .group-hover\\:text-grey-darkest {\n    color: #3d4852;\n}\n.md\\:group:hover .group-hover\\:text-grey-darker {\n    color: #606f7b;\n}\n.md\\:group:hover .group-hover\\:text-grey-dark {\n    color: #8795a1;\n}\n.md\\:group:hover .group-hover\\:text-grey {\n    color: #b8c2cc;\n}\n.md\\:group:hover .group-hover\\:text-grey-light {\n    color: #dae1e7;\n}\n.md\\:group:hover .group-hover\\:text-grey-lighter {\n    color: #f1f5f8;\n}\n.md\\:group:hover .group-hover\\:text-grey-lightest {\n    color: #f8fafc;\n}\n.md\\:group:hover .group-hover\\:text-white {\n    color: #fff;\n}\n.md\\:group:hover .group-hover\\:text-whiter {\n    color: rgba(255, 255, 255, .6);\n}\n.md\\:group:hover .group-hover\\:text-red-darkest {\n    color: #3b0d0c;\n}\n.md\\:group:hover .group-hover\\:text-red-darker {\n    color: #621b18;\n}\n.md\\:group:hover .group-hover\\:text-red-dark {\n    color: #cc1f1a;\n}\n.md\\:group:hover .group-hover\\:text-red {\n    color: #e3342f;\n}\n.md\\:group:hover .group-hover\\:text-red-light {\n    color: #ef5753;\n}\n.md\\:group:hover .group-hover\\:text-red-lighter {\n    color: #f9acaa;\n}\n.md\\:group:hover .group-hover\\:text-red-lightest {\n    color: #fcebea;\n}\n.md\\:group:hover .group-hover\\:text-orange-darkest {\n    color: #462a16;\n}\n.md\\:group:hover .group-hover\\:text-orange-darker {\n    color: #613b1f;\n}\n.md\\:group:hover .group-hover\\:text-orange-dark {\n    color: #de751f;\n}\n.md\\:group:hover .group-hover\\:text-orange {\n    color: #f6993f;\n}\n.md\\:group:hover .group-hover\\:text-orange-light {\n    color: #faad63;\n}\n.md\\:group:hover .group-hover\\:text-orange-lighter {\n    color: #fcd9b6;\n}\n.md\\:group:hover .group-hover\\:text-orange-lightest {\n    color: #fff5eb;\n}\n.md\\:group:hover .group-hover\\:text-yellow-darkest {\n    color: #453411;\n}\n.md\\:group:hover .group-hover\\:text-yellow-darker {\n    color: #684f1d;\n}\n.md\\:group:hover .group-hover\\:text-yellow-dark {\n    color: #f2d024;\n}\n.md\\:group:hover .group-hover\\:text-yellow {\n    color: #ffed4a;\n}\n.md\\:group:hover .group-hover\\:text-yellow-light {\n    color: #fff382;\n}\n.md\\:group:hover .group-hover\\:text-yellow-lighter {\n    color: #fff9c2;\n}\n.md\\:group:hover .group-hover\\:text-yellow-lightest {\n    color: #fcfbeb;\n}\n.md\\:group:hover .group-hover\\:text-green-darkest {\n    color: #0f2f21;\n}\n.md\\:group:hover .group-hover\\:text-green-darker {\n    color: #1a4731;\n}\n.md\\:group:hover .group-hover\\:text-green-dark {\n    color: #1f9d55;\n}\n.md\\:group:hover .group-hover\\:text-green {\n    color: #38c172;\n}\n.md\\:group:hover .group-hover\\:text-green-light {\n    color: #51d88a;\n}\n.md\\:group:hover .group-hover\\:text-green-lighter {\n    color: #a2f5bf;\n}\n.md\\:group:hover .group-hover\\:text-green-lightest {\n    color: #e3fcec;\n}\n.md\\:group:hover .group-hover\\:text-teal-darkest {\n    color: #0d3331;\n}\n.md\\:group:hover .group-hover\\:text-teal-darker {\n    color: #20504f;\n}\n.md\\:group:hover .group-hover\\:text-teal-dark {\n    color: #009480;\n}\n.md\\:group:hover .group-hover\\:text-teal {\n    color: #00ae98;\n}\n.md\\:group:hover .group-hover\\:text-teal-light {\n    color: #64d5ca;\n}\n.md\\:group:hover .group-hover\\:text-teal-lighter {\n    color: #a0f0ed;\n}\n.md\\:group:hover .group-hover\\:text-teal-lightest {\n    color: #e8fffe;\n}\n.md\\:group:hover .group-hover\\:text-blue-darkest {\n    color: #12283a;\n}\n.md\\:group:hover .group-hover\\:text-blue-darker {\n    color: #2e6da2;\n}\n.md\\:group:hover .group-hover\\:text-blue-dark {\n    color: #2779bd;\n}\n.md\\:group:hover .group-hover\\:text-blue {\n    color: #3490dc;\n}\n.md\\:group:hover .group-hover\\:text-blue-light {\n    color: #6cb2eb;\n}\n.md\\:group:hover .group-hover\\:text-blue-lighter {\n    color: #bcdefa;\n}\n.md\\:group:hover .group-hover\\:text-blue-lightest {\n    color: #eff8ff;\n}\n.md\\:group:hover .group-hover\\:text-indigo-darkest {\n    color: #191e38;\n}\n.md\\:group:hover .group-hover\\:text-indigo-darker {\n    color: #2f365f;\n}\n.md\\:group:hover .group-hover\\:text-indigo-dark {\n    color: #5661b3;\n}\n.md\\:group:hover .group-hover\\:text-indigo {\n    color: #6574cd;\n}\n.md\\:group:hover .group-hover\\:text-indigo-light {\n    color: #7886d7;\n}\n.md\\:group:hover .group-hover\\:text-indigo-lighter {\n    color: #b2b7ff;\n}\n.md\\:group:hover .group-hover\\:text-indigo-lightest {\n    color: #e6e8ff;\n}\n.md\\:group:hover .group-hover\\:text-purple-darkest {\n    color: #21183c;\n}\n.md\\:group:hover .group-hover\\:text-purple-darker {\n    color: #382b5f;\n}\n.md\\:group:hover .group-hover\\:text-purple-dark {\n    color: #794acf;\n}\n.md\\:group:hover .group-hover\\:text-purple {\n    color: #9561e2;\n}\n.md\\:group:hover .group-hover\\:text-purple-light {\n    color: #a779e9;\n}\n.md\\:group:hover .group-hover\\:text-purple-lighter {\n    color: #d6bbfc;\n}\n.md\\:group:hover .group-hover\\:text-purple-lightest {\n    color: #f3ebff;\n}\n.md\\:group:hover .group-hover\\:text-pink-darkest {\n    color: #451225;\n}\n.md\\:group:hover .group-hover\\:text-pink-darker {\n    color: #6f213f;\n}\n.md\\:group:hover .group-hover\\:text-pink-dark {\n    color: #eb5286;\n}\n.md\\:group:hover .group-hover\\:text-pink {\n    color: #f66d9b;\n}\n.md\\:group:hover .group-hover\\:text-pink-light {\n    color: #fa7ea8;\n}\n.md\\:group:hover .group-hover\\:text-pink-lighter {\n    color: #ffbbca;\n}\n.md\\:group:hover .group-hover\\:text-pink-lightest {\n    color: #ffebef;\n}\n.md\\:hover\\:text-transparent:hover {\n    color: transparent;\n}\n.md\\:hover\\:text-modal:hover {\n    color: rgba(0, 0, 0, .4);\n}\n.md\\:hover\\:text-google:hover {\n    color: #dc5b5b;\n}\n.md\\:hover\\:text-google-dark:hover {\n    color: #da5050;\n}\n.md\\:hover\\:text-facebook:hover {\n    color: #3b5998;\n}\n.md\\:hover\\:text-facebook-dark:hover {\n    color: #37548f;\n}\n.md\\:hover\\:text-primary:hover {\n    color: #2196f3;\n}\n.md\\:hover\\:text-primary-dark:hover {\n    color: #3b5998;\n}\n.md\\:hover\\:text-footer:hover {\n    color: #1976d2;\n}\n.md\\:hover\\:text-black:hover {\n    color: #22292f;\n}\n.md\\:hover\\:text-grey-darkest:hover {\n    color: #3d4852;\n}\n.md\\:hover\\:text-grey-darker:hover {\n    color: #606f7b;\n}\n.md\\:hover\\:text-grey-dark:hover {\n    color: #8795a1;\n}\n.md\\:hover\\:text-grey:hover {\n    color: #b8c2cc;\n}\n.md\\:hover\\:text-grey-light:hover {\n    color: #dae1e7;\n}\n.md\\:hover\\:text-grey-lighter:hover {\n    color: #f1f5f8;\n}\n.md\\:hover\\:text-grey-lightest:hover {\n    color: #f8fafc;\n}\n.md\\:hover\\:text-white:hover {\n    color: #fff;\n}\n.md\\:hover\\:text-whiter:hover {\n    color: rgba(255, 255, 255, .6);\n}\n.md\\:hover\\:text-red-darkest:hover {\n    color: #3b0d0c;\n}\n.md\\:hover\\:text-red-darker:hover {\n    color: #621b18;\n}\n.md\\:hover\\:text-red-dark:hover {\n    color: #cc1f1a;\n}\n.md\\:hover\\:text-red:hover {\n    color: #e3342f;\n}\n.md\\:hover\\:text-red-light:hover {\n    color: #ef5753;\n}\n.md\\:hover\\:text-red-lighter:hover {\n    color: #f9acaa;\n}\n.md\\:hover\\:text-red-lightest:hover {\n    color: #fcebea;\n}\n.md\\:hover\\:text-orange-darkest:hover {\n    color: #462a16;\n}\n.md\\:hover\\:text-orange-darker:hover {\n    color: #613b1f;\n}\n.md\\:hover\\:text-orange-dark:hover {\n    color: #de751f;\n}\n.md\\:hover\\:text-orange:hover {\n    color: #f6993f;\n}\n.md\\:hover\\:text-orange-light:hover {\n    color: #faad63;\n}\n.md\\:hover\\:text-orange-lighter:hover {\n    color: #fcd9b6;\n}\n.md\\:hover\\:text-orange-lightest:hover {\n    color: #fff5eb;\n}\n.md\\:hover\\:text-yellow-darkest:hover {\n    color: #453411;\n}\n.md\\:hover\\:text-yellow-darker:hover {\n    color: #684f1d;\n}\n.md\\:hover\\:text-yellow-dark:hover {\n    color: #f2d024;\n}\n.md\\:hover\\:text-yellow:hover {\n    color: #ffed4a;\n}\n.md\\:hover\\:text-yellow-light:hover {\n    color: #fff382;\n}\n.md\\:hover\\:text-yellow-lighter:hover {\n    color: #fff9c2;\n}\n.md\\:hover\\:text-yellow-lightest:hover {\n    color: #fcfbeb;\n}\n.md\\:hover\\:text-green-darkest:hover {\n    color: #0f2f21;\n}\n.md\\:hover\\:text-green-darker:hover {\n    color: #1a4731;\n}\n.md\\:hover\\:text-green-dark:hover {\n    color: #1f9d55;\n}\n.md\\:hover\\:text-green:hover {\n    color: #38c172;\n}\n.md\\:hover\\:text-green-light:hover {\n    color: #51d88a;\n}\n.md\\:hover\\:text-green-lighter:hover {\n    color: #a2f5bf;\n}\n.md\\:hover\\:text-green-lightest:hover {\n    color: #e3fcec;\n}\n.md\\:hover\\:text-teal-darkest:hover {\n    color: #0d3331;\n}\n.md\\:hover\\:text-teal-darker:hover {\n    color: #20504f;\n}\n.md\\:hover\\:text-teal-dark:hover {\n    color: #009480;\n}\n.md\\:hover\\:text-teal:hover {\n    color: #00ae98;\n}\n.md\\:hover\\:text-teal-light:hover {\n    color: #64d5ca;\n}\n.md\\:hover\\:text-teal-lighter:hover {\n    color: #a0f0ed;\n}\n.md\\:hover\\:text-teal-lightest:hover {\n    color: #e8fffe;\n}\n.md\\:hover\\:text-blue-darkest:hover {\n    color: #12283a;\n}\n.md\\:hover\\:text-blue-darker:hover {\n    color: #2e6da2;\n}\n.md\\:hover\\:text-blue-dark:hover {\n    color: #2779bd;\n}\n.md\\:hover\\:text-blue:hover {\n    color: #3490dc;\n}\n.md\\:hover\\:text-blue-light:hover {\n    color: #6cb2eb;\n}\n.md\\:hover\\:text-blue-lighter:hover {\n    color: #bcdefa;\n}\n.md\\:hover\\:text-blue-lightest:hover {\n    color: #eff8ff;\n}\n.md\\:hover\\:text-indigo-darkest:hover {\n    color: #191e38;\n}\n.md\\:hover\\:text-indigo-darker:hover {\n    color: #2f365f;\n}\n.md\\:hover\\:text-indigo-dark:hover {\n    color: #5661b3;\n}\n.md\\:hover\\:text-indigo:hover {\n    color: #6574cd;\n}\n.md\\:hover\\:text-indigo-light:hover {\n    color: #7886d7;\n}\n.md\\:hover\\:text-indigo-lighter:hover {\n    color: #b2b7ff;\n}\n.md\\:hover\\:text-indigo-lightest:hover {\n    color: #e6e8ff;\n}\n.md\\:hover\\:text-purple-darkest:hover {\n    color: #21183c;\n}\n.md\\:hover\\:text-purple-darker:hover {\n    color: #382b5f;\n}\n.md\\:hover\\:text-purple-dark:hover {\n    color: #794acf;\n}\n.md\\:hover\\:text-purple:hover {\n    color: #9561e2;\n}\n.md\\:hover\\:text-purple-light:hover {\n    color: #a779e9;\n}\n.md\\:hover\\:text-purple-lighter:hover {\n    color: #d6bbfc;\n}\n.md\\:hover\\:text-purple-lightest:hover {\n    color: #f3ebff;\n}\n.md\\:hover\\:text-pink-darkest:hover {\n    color: #451225;\n}\n.md\\:hover\\:text-pink-darker:hover {\n    color: #6f213f;\n}\n.md\\:hover\\:text-pink-dark:hover {\n    color: #eb5286;\n}\n.md\\:hover\\:text-pink:hover {\n    color: #f66d9b;\n}\n.md\\:hover\\:text-pink-light:hover {\n    color: #fa7ea8;\n}\n.md\\:hover\\:text-pink-lighter:hover {\n    color: #ffbbca;\n}\n.md\\:hover\\:text-pink-lightest:hover {\n    color: #ffebef;\n}\n.md\\:text-xs {\n    font-size: .75rem;\n}\n.md\\:text-sm {\n    font-size: .875rem;\n}\n.md\\:text-base {\n    font-size: 1rem;\n}\n.md\\:text-lg {\n    font-size: 1.125rem;\n}\n.md\\:text-xl {\n    font-size: 1.25rem;\n}\n.md\\:text-2xl {\n    font-size: 1.5rem;\n}\n.md\\:text-3xl {\n    font-size: 1.875rem;\n}\n.md\\:text-4xl {\n    font-size: 2.25rem;\n}\n.md\\:text-5xl {\n    font-size: 3rem;\n}\n.md\\:italic {\n    font-style: italic;\n}\n.md\\:roman {\n    font-style: normal;\n}\n.md\\:uppercase {\n    text-transform: uppercase;\n}\n.md\\:lowercase {\n    text-transform: lowercase;\n}\n.md\\:capitalize {\n    text-transform: capitalize;\n}\n.md\\:normal-case {\n    text-transform: none;\n}\n.md\\:underline {\n    text-decoration: underline;\n}\n.md\\:line-through {\n    text-decoration: line-through;\n}\n.md\\:no-underline {\n    text-decoration: none;\n}\n.md\\:antialiased {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.md\\:subpixel-antialiased {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n}\n.md\\:hover\\:italic:hover {\n    font-style: italic;\n}\n.md\\:hover\\:roman:hover {\n    font-style: normal;\n}\n.md\\:hover\\:uppercase:hover {\n    text-transform: uppercase;\n}\n.md\\:hover\\:lowercase:hover {\n    text-transform: lowercase;\n}\n.md\\:hover\\:capitalize:hover {\n    text-transform: capitalize;\n}\n.md\\:hover\\:normal-case:hover {\n    text-transform: none;\n}\n.md\\:hover\\:underline:hover {\n    text-decoration: underline;\n}\n.md\\:hover\\:line-through:hover {\n    text-decoration: line-through;\n}\n.md\\:hover\\:no-underline:hover {\n    text-decoration: none;\n}\n.md\\:hover\\:antialiased:hover {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.md\\:hover\\:subpixel-antialiased:hover {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n}\n.md\\:tracking-tight {\n    letter-spacing: -0.05em;\n}\n.md\\:tracking-normal {\n    letter-spacing: 0;\n}\n.md\\:tracking-wide {\n    letter-spacing: .05em;\n}\n.md\\:select-none {\n    user-select: none;\n}\n.md\\:select-text {\n    user-select: text;\n}\n.md\\:align-baseline {\n    vertical-align: baseline;\n}\n.md\\:align-top {\n    vertical-align: top;\n}\n.md\\:align-middle {\n    vertical-align: middle;\n}\n.md\\:align-bottom {\n    vertical-align: bottom;\n}\n.md\\:align-text-top {\n    vertical-align: text-top;\n}\n.md\\:align-text-bottom {\n    vertical-align: text-bottom;\n}\n.md\\:visible {\n    visibility: visible;\n}\n.md\\:invisible {\n    visibility: hidden;\n}\n.md\\:whitespace-normal {\n    white-space: normal;\n}\n.md\\:whitespace-no-wrap {\n    white-space: nowrap;\n}\n.md\\:whitespace-pre {\n    white-space: pre;\n}\n.md\\:whitespace-pre-line {\n    white-space: pre-line;\n}\n.md\\:whitespace-pre-wrap {\n    white-space: pre-wrap;\n}\n.md\\:break-words {\n    word-wrap: break-word;\n}\n.md\\:break-normal {\n    word-wrap: normal;\n}\n.md\\:truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.md\\:w-1 {\n    width: .25rem;\n}\n.md\\:w-2 {\n    width: .5rem;\n}\n.md\\:w-3 {\n    width: .75rem;\n}\n.md\\:w-4 {\n    width: 1rem;\n}\n.md\\:w-6 {\n    width: 1.5rem;\n}\n.md\\:w-8 {\n    width: 2rem;\n}\n.md\\:w-10 {\n    width: 2.5rem;\n}\n.md\\:w-12 {\n    width: 3rem;\n}\n.md\\:w-16 {\n    width: 4rem;\n}\n.md\\:w-24 {\n    width: 6rem;\n}\n.md\\:w-32 {\n    width: 8rem;\n}\n.md\\:w-48 {\n    width: 12rem;\n}\n.md\\:w-64 {\n    width: 16rem;\n}\n.md\\:w-auto {\n    width: auto;\n}\n.md\\:w-px {\n    width: 1px;\n}\n.md\\:w-1\\/2 {\n    width: 50%;\n}\n.md\\:w-1\\/3 {\n    width: 33.33333%;\n}\n.md\\:w-2\\/3 {\n    width: 66.66667%;\n}\n.md\\:w-1\\/4 {\n    width: 25%;\n}\n.md\\:w-3\\/4 {\n    width: 75%;\n}\n.md\\:w-1\\/5 {\n    width: 20%;\n}\n.md\\:w-2\\/5 {\n    width: 40%;\n}\n.md\\:w-3\\/5 {\n    width: 60%;\n}\n.md\\:w-4\\/5 {\n    width: 80%;\n}\n.md\\:w-1\\/6 {\n    width: 16.66667%;\n}\n.md\\:w-5\\/6 {\n    width: 83.33333%;\n}\n.md\\:w-full {\n    width: 100%;\n}\n.md\\:w-screen {\n    width: 100vw;\n}\n.md\\:z-0 {\n    z-index: 0;\n}\n.md\\:z-10 {\n    z-index: 10;\n}\n.md\\:z-20 {\n    z-index: 20;\n}\n.md\\:z-30 {\n    z-index: 30;\n}\n.md\\:z-40 {\n    z-index: 40;\n}\n.md\\:z-50 {\n    z-index: 50;\n}\n.md\\:z-auto {\n    z-index: auto;\n}\n.md\\:z-max {\n    z-index: 1051 !important;\n}\n}\n@media (min-width: 992px) {\n.lg\\:list-reset {\n    list-style: none;\n    padding: 0;\n}\n.lg\\:appearance-none {\n    appearance: none;\n}\n.lg\\:bg-fixed {\n    background-attachment: fixed;\n}\n.lg\\:bg-local {\n    background-attachment: local;\n}\n.lg\\:bg-scroll {\n    background-attachment: scroll;\n}\n.lg\\:bg-transparent {\n    background-color: transparent;\n}\n.lg\\:bg-modal {\n    background-color: rgba(0, 0, 0, .4);\n}\n.lg\\:bg-google {\n    background-color: #dc5b5b;\n}\n.lg\\:bg-google-dark {\n    background-color: #da5050;\n}\n.lg\\:bg-facebook {\n    background-color: #3b5998;\n}\n.lg\\:bg-facebook-dark {\n    background-color: #37548f;\n}\n.lg\\:bg-primary {\n    background-color: #2196f3;\n}\n.lg\\:bg-primary-dark {\n    background-color: #3b5998;\n}\n.lg\\:bg-footer {\n    background-color: #1976d2;\n}\n.lg\\:bg-black {\n    background-color: #22292f;\n}\n.lg\\:bg-grey-darkest {\n    background-color: #3d4852;\n}\n.lg\\:bg-grey-darker {\n    background-color: #606f7b;\n}\n.lg\\:bg-grey-dark {\n    background-color: #8795a1;\n}\n.lg\\:bg-grey {\n    background-color: #b8c2cc;\n}\n.lg\\:bg-grey-light {\n    background-color: #dae1e7;\n}\n.lg\\:bg-grey-lighter {\n    background-color: #f1f5f8;\n}\n.lg\\:bg-grey-lightest {\n    background-color: #f8fafc;\n}\n.lg\\:bg-white {\n    background-color: #fff;\n}\n.lg\\:bg-whiter {\n    background-color: rgba(255, 255, 255, .6);\n}\n.lg\\:bg-red-darkest {\n    background-color: #3b0d0c;\n}\n.lg\\:bg-red-darker {\n    background-color: #621b18;\n}\n.lg\\:bg-red-dark {\n    background-color: #cc1f1a;\n}\n.lg\\:bg-red {\n    background-color: #e3342f;\n}\n.lg\\:bg-red-light {\n    background-color: #ef5753;\n}\n.lg\\:bg-red-lighter {\n    background-color: #f9acaa;\n}\n.lg\\:bg-red-lightest {\n    background-color: #fcebea;\n}\n.lg\\:bg-orange-darkest {\n    background-color: #462a16;\n}\n.lg\\:bg-orange-darker {\n    background-color: #613b1f;\n}\n.lg\\:bg-orange-dark {\n    background-color: #de751f;\n}\n.lg\\:bg-orange {\n    background-color: #f6993f;\n}\n.lg\\:bg-orange-light {\n    background-color: #faad63;\n}\n.lg\\:bg-orange-lighter {\n    background-color: #fcd9b6;\n}\n.lg\\:bg-orange-lightest {\n    background-color: #fff5eb;\n}\n.lg\\:bg-yellow-darkest {\n    background-color: #453411;\n}\n.lg\\:bg-yellow-darker {\n    background-color: #684f1d;\n}\n.lg\\:bg-yellow-dark {\n    background-color: #f2d024;\n}\n.lg\\:bg-yellow {\n    background-color: #ffed4a;\n}\n.lg\\:bg-yellow-light {\n    background-color: #fff382;\n}\n.lg\\:bg-yellow-lighter {\n    background-color: #fff9c2;\n}\n.lg\\:bg-yellow-lightest {\n    background-color: #fcfbeb;\n}\n.lg\\:bg-green-darkest {\n    background-color: #0f2f21;\n}\n.lg\\:bg-green-darker {\n    background-color: #1a4731;\n}\n.lg\\:bg-green-dark {\n    background-color: #1f9d55;\n}\n.lg\\:bg-green {\n    background-color: #38c172;\n}\n.lg\\:bg-green-light {\n    background-color: #51d88a;\n}\n.lg\\:bg-green-lighter {\n    background-color: #a2f5bf;\n}\n.lg\\:bg-green-lightest {\n    background-color: #e3fcec;\n}\n.lg\\:bg-teal-darkest {\n    background-color: #0d3331;\n}\n.lg\\:bg-teal-darker {\n    background-color: #20504f;\n}\n.lg\\:bg-teal-dark {\n    background-color: #009480;\n}\n.lg\\:bg-teal {\n    background-color: #00ae98;\n}\n.lg\\:bg-teal-light {\n    background-color: #64d5ca;\n}\n.lg\\:bg-teal-lighter {\n    background-color: #a0f0ed;\n}\n.lg\\:bg-teal-lightest {\n    background-color: #e8fffe;\n}\n.lg\\:bg-blue-darkest {\n    background-color: #12283a;\n}\n.lg\\:bg-blue-darker {\n    background-color: #2e6da2;\n}\n.lg\\:bg-blue-dark {\n    background-color: #2779bd;\n}\n.lg\\:bg-blue {\n    background-color: #3490dc;\n}\n.lg\\:bg-blue-light {\n    background-color: #6cb2eb;\n}\n.lg\\:bg-blue-lighter {\n    background-color: #bcdefa;\n}\n.lg\\:bg-blue-lightest {\n    background-color: #eff8ff;\n}\n.lg\\:bg-indigo-darkest {\n    background-color: #191e38;\n}\n.lg\\:bg-indigo-darker {\n    background-color: #2f365f;\n}\n.lg\\:bg-indigo-dark {\n    background-color: #5661b3;\n}\n.lg\\:bg-indigo {\n    background-color: #6574cd;\n}\n.lg\\:bg-indigo-light {\n    background-color: #7886d7;\n}\n.lg\\:bg-indigo-lighter {\n    background-color: #b2b7ff;\n}\n.lg\\:bg-indigo-lightest {\n    background-color: #e6e8ff;\n}\n.lg\\:bg-purple-darkest {\n    background-color: #21183c;\n}\n.lg\\:bg-purple-darker {\n    background-color: #382b5f;\n}\n.lg\\:bg-purple-dark {\n    background-color: #794acf;\n}\n.lg\\:bg-purple {\n    background-color: #9561e2;\n}\n.lg\\:bg-purple-light {\n    background-color: #a779e9;\n}\n.lg\\:bg-purple-lighter {\n    background-color: #d6bbfc;\n}\n.lg\\:bg-purple-lightest {\n    background-color: #f3ebff;\n}\n.lg\\:bg-pink-darkest {\n    background-color: #451225;\n}\n.lg\\:bg-pink-darker {\n    background-color: #6f213f;\n}\n.lg\\:bg-pink-dark {\n    background-color: #eb5286;\n}\n.lg\\:bg-pink {\n    background-color: #f66d9b;\n}\n.lg\\:bg-pink-light {\n    background-color: #fa7ea8;\n}\n.lg\\:bg-pink-lighter {\n    background-color: #ffbbca;\n}\n.lg\\:bg-pink-lightest {\n    background-color: #ffebef;\n}\n.lg\\:group:hover .group-hover\\:bg-transparent {\n    background-color: transparent;\n}\n.lg\\:group:hover .group-hover\\:bg-modal {\n    background-color: rgba(0, 0, 0, .4);\n}\n.lg\\:group:hover .group-hover\\:bg-google {\n    background-color: #dc5b5b;\n}\n.lg\\:group:hover .group-hover\\:bg-google-dark {\n    background-color: #da5050;\n}\n.lg\\:group:hover .group-hover\\:bg-facebook {\n    background-color: #3b5998;\n}\n.lg\\:group:hover .group-hover\\:bg-facebook-dark {\n    background-color: #37548f;\n}\n.lg\\:group:hover .group-hover\\:bg-primary {\n    background-color: #2196f3;\n}\n.lg\\:group:hover .group-hover\\:bg-primary-dark {\n    background-color: #3b5998;\n}\n.lg\\:group:hover .group-hover\\:bg-footer {\n    background-color: #1976d2;\n}\n.lg\\:group:hover .group-hover\\:bg-black {\n    background-color: #22292f;\n}\n.lg\\:group:hover .group-hover\\:bg-grey-darkest {\n    background-color: #3d4852;\n}\n.lg\\:group:hover .group-hover\\:bg-grey-darker {\n    background-color: #606f7b;\n}\n.lg\\:group:hover .group-hover\\:bg-grey-dark {\n    background-color: #8795a1;\n}\n.lg\\:group:hover .group-hover\\:bg-grey {\n    background-color: #b8c2cc;\n}\n.lg\\:group:hover .group-hover\\:bg-grey-light {\n    background-color: #dae1e7;\n}\n.lg\\:group:hover .group-hover\\:bg-grey-lighter {\n    background-color: #f1f5f8;\n}\n.lg\\:group:hover .group-hover\\:bg-grey-lightest {\n    background-color: #f8fafc;\n}\n.lg\\:group:hover .group-hover\\:bg-white {\n    background-color: #fff;\n}\n.lg\\:group:hover .group-hover\\:bg-whiter {\n    background-color: rgba(255, 255, 255, .6);\n}\n.lg\\:group:hover .group-hover\\:bg-red-darkest {\n    background-color: #3b0d0c;\n}\n.lg\\:group:hover .group-hover\\:bg-red-darker {\n    background-color: #621b18;\n}\n.lg\\:group:hover .group-hover\\:bg-red-dark {\n    background-color: #cc1f1a;\n}\n.lg\\:group:hover .group-hover\\:bg-red {\n    background-color: #e3342f;\n}\n.lg\\:group:hover .group-hover\\:bg-red-light {\n    background-color: #ef5753;\n}\n.lg\\:group:hover .group-hover\\:bg-red-lighter {\n    background-color: #f9acaa;\n}\n.lg\\:group:hover .group-hover\\:bg-red-lightest {\n    background-color: #fcebea;\n}\n.lg\\:group:hover .group-hover\\:bg-orange-darkest {\n    background-color: #462a16;\n}\n.lg\\:group:hover .group-hover\\:bg-orange-darker {\n    background-color: #613b1f;\n}\n.lg\\:group:hover .group-hover\\:bg-orange-dark {\n    background-color: #de751f;\n}\n.lg\\:group:hover .group-hover\\:bg-orange {\n    background-color: #f6993f;\n}\n.lg\\:group:hover .group-hover\\:bg-orange-light {\n    background-color: #faad63;\n}\n.lg\\:group:hover .group-hover\\:bg-orange-lighter {\n    background-color: #fcd9b6;\n}\n.lg\\:group:hover .group-hover\\:bg-orange-lightest {\n    background-color: #fff5eb;\n}\n.lg\\:group:hover .group-hover\\:bg-yellow-darkest {\n    background-color: #453411;\n}\n.lg\\:group:hover .group-hover\\:bg-yellow-darker {\n    background-color: #684f1d;\n}\n.lg\\:group:hover .group-hover\\:bg-yellow-dark {\n    background-color: #f2d024;\n}\n.lg\\:group:hover .group-hover\\:bg-yellow {\n    background-color: #ffed4a;\n}\n.lg\\:group:hover .group-hover\\:bg-yellow-light {\n    background-color: #fff382;\n}\n.lg\\:group:hover .group-hover\\:bg-yellow-lighter {\n    background-color: #fff9c2;\n}\n.lg\\:group:hover .group-hover\\:bg-yellow-lightest {\n    background-color: #fcfbeb;\n}\n.lg\\:group:hover .group-hover\\:bg-green-darkest {\n    background-color: #0f2f21;\n}\n.lg\\:group:hover .group-hover\\:bg-green-darker {\n    background-color: #1a4731;\n}\n.lg\\:group:hover .group-hover\\:bg-green-dark {\n    background-color: #1f9d55;\n}\n.lg\\:group:hover .group-hover\\:bg-green {\n    background-color: #38c172;\n}\n.lg\\:group:hover .group-hover\\:bg-green-light {\n    background-color: #51d88a;\n}\n.lg\\:group:hover .group-hover\\:bg-green-lighter {\n    background-color: #a2f5bf;\n}\n.lg\\:group:hover .group-hover\\:bg-green-lightest {\n    background-color: #e3fcec;\n}\n.lg\\:group:hover .group-hover\\:bg-teal-darkest {\n    background-color: #0d3331;\n}\n.lg\\:group:hover .group-hover\\:bg-teal-darker {\n    background-color: #20504f;\n}\n.lg\\:group:hover .group-hover\\:bg-teal-dark {\n    background-color: #009480;\n}\n.lg\\:group:hover .group-hover\\:bg-teal {\n    background-color: #00ae98;\n}\n.lg\\:group:hover .group-hover\\:bg-teal-light {\n    background-color: #64d5ca;\n}\n.lg\\:group:hover .group-hover\\:bg-teal-lighter {\n    background-color: #a0f0ed;\n}\n.lg\\:group:hover .group-hover\\:bg-teal-lightest {\n    background-color: #e8fffe;\n}\n.lg\\:group:hover .group-hover\\:bg-blue-darkest {\n    background-color: #12283a;\n}\n.lg\\:group:hover .group-hover\\:bg-blue-darker {\n    background-color: #2e6da2;\n}\n.lg\\:group:hover .group-hover\\:bg-blue-dark {\n    background-color: #2779bd;\n}\n.lg\\:group:hover .group-hover\\:bg-blue {\n    background-color: #3490dc;\n}\n.lg\\:group:hover .group-hover\\:bg-blue-light {\n    background-color: #6cb2eb;\n}\n.lg\\:group:hover .group-hover\\:bg-blue-lighter {\n    background-color: #bcdefa;\n}\n.lg\\:group:hover .group-hover\\:bg-blue-lightest {\n    background-color: #eff8ff;\n}\n.lg\\:group:hover .group-hover\\:bg-indigo-darkest {\n    background-color: #191e38;\n}\n.lg\\:group:hover .group-hover\\:bg-indigo-darker {\n    background-color: #2f365f;\n}\n.lg\\:group:hover .group-hover\\:bg-indigo-dark {\n    background-color: #5661b3;\n}\n.lg\\:group:hover .group-hover\\:bg-indigo {\n    background-color: #6574cd;\n}\n.lg\\:group:hover .group-hover\\:bg-indigo-light {\n    background-color: #7886d7;\n}\n.lg\\:group:hover .group-hover\\:bg-indigo-lighter {\n    background-color: #b2b7ff;\n}\n.lg\\:group:hover .group-hover\\:bg-indigo-lightest {\n    background-color: #e6e8ff;\n}\n.lg\\:group:hover .group-hover\\:bg-purple-darkest {\n    background-color: #21183c;\n}\n.lg\\:group:hover .group-hover\\:bg-purple-darker {\n    background-color: #382b5f;\n}\n.lg\\:group:hover .group-hover\\:bg-purple-dark {\n    background-color: #794acf;\n}\n.lg\\:group:hover .group-hover\\:bg-purple {\n    background-color: #9561e2;\n}\n.lg\\:group:hover .group-hover\\:bg-purple-light {\n    background-color: #a779e9;\n}\n.lg\\:group:hover .group-hover\\:bg-purple-lighter {\n    background-color: #d6bbfc;\n}\n.lg\\:group:hover .group-hover\\:bg-purple-lightest {\n    background-color: #f3ebff;\n}\n.lg\\:group:hover .group-hover\\:bg-pink-darkest {\n    background-color: #451225;\n}\n.lg\\:group:hover .group-hover\\:bg-pink-darker {\n    background-color: #6f213f;\n}\n.lg\\:group:hover .group-hover\\:bg-pink-dark {\n    background-color: #eb5286;\n}\n.lg\\:group:hover .group-hover\\:bg-pink {\n    background-color: #f66d9b;\n}\n.lg\\:group:hover .group-hover\\:bg-pink-light {\n    background-color: #fa7ea8;\n}\n.lg\\:group:hover .group-hover\\:bg-pink-lighter {\n    background-color: #ffbbca;\n}\n.lg\\:group:hover .group-hover\\:bg-pink-lightest {\n    background-color: #ffebef;\n}\n.lg\\:hover\\:bg-transparent:hover {\n    background-color: transparent;\n}\n.lg\\:hover\\:bg-modal:hover {\n    background-color: rgba(0, 0, 0, .4);\n}\n.lg\\:hover\\:bg-google:hover {\n    background-color: #dc5b5b;\n}\n.lg\\:hover\\:bg-google-dark:hover {\n    background-color: #da5050;\n}\n.lg\\:hover\\:bg-facebook:hover {\n    background-color: #3b5998;\n}\n.lg\\:hover\\:bg-facebook-dark:hover {\n    background-color: #37548f;\n}\n.lg\\:hover\\:bg-primary:hover {\n    background-color: #2196f3;\n}\n.lg\\:hover\\:bg-primary-dark:hover {\n    background-color: #3b5998;\n}\n.lg\\:hover\\:bg-footer:hover {\n    background-color: #1976d2;\n}\n.lg\\:hover\\:bg-black:hover {\n    background-color: #22292f;\n}\n.lg\\:hover\\:bg-grey-darkest:hover {\n    background-color: #3d4852;\n}\n.lg\\:hover\\:bg-grey-darker:hover {\n    background-color: #606f7b;\n}\n.lg\\:hover\\:bg-grey-dark:hover {\n    background-color: #8795a1;\n}\n.lg\\:hover\\:bg-grey:hover {\n    background-color: #b8c2cc;\n}\n.lg\\:hover\\:bg-grey-light:hover {\n    background-color: #dae1e7;\n}\n.lg\\:hover\\:bg-grey-lighter:hover {\n    background-color: #f1f5f8;\n}\n.lg\\:hover\\:bg-grey-lightest:hover {\n    background-color: #f8fafc;\n}\n.lg\\:hover\\:bg-white:hover {\n    background-color: #fff;\n}\n.lg\\:hover\\:bg-whiter:hover {\n    background-color: rgba(255, 255, 255, .6);\n}\n.lg\\:hover\\:bg-red-darkest:hover {\n    background-color: #3b0d0c;\n}\n.lg\\:hover\\:bg-red-darker:hover {\n    background-color: #621b18;\n}\n.lg\\:hover\\:bg-red-dark:hover {\n    background-color: #cc1f1a;\n}\n.lg\\:hover\\:bg-red:hover {\n    background-color: #e3342f;\n}\n.lg\\:hover\\:bg-red-light:hover {\n    background-color: #ef5753;\n}\n.lg\\:hover\\:bg-red-lighter:hover {\n    background-color: #f9acaa;\n}\n.lg\\:hover\\:bg-red-lightest:hover {\n    background-color: #fcebea;\n}\n.lg\\:hover\\:bg-orange-darkest:hover {\n    background-color: #462a16;\n}\n.lg\\:hover\\:bg-orange-darker:hover {\n    background-color: #613b1f;\n}\n.lg\\:hover\\:bg-orange-dark:hover {\n    background-color: #de751f;\n}\n.lg\\:hover\\:bg-orange:hover {\n    background-color: #f6993f;\n}\n.lg\\:hover\\:bg-orange-light:hover {\n    background-color: #faad63;\n}\n.lg\\:hover\\:bg-orange-lighter:hover {\n    background-color: #fcd9b6;\n}\n.lg\\:hover\\:bg-orange-lightest:hover {\n    background-color: #fff5eb;\n}\n.lg\\:hover\\:bg-yellow-darkest:hover {\n    background-color: #453411;\n}\n.lg\\:hover\\:bg-yellow-darker:hover {\n    background-color: #684f1d;\n}\n.lg\\:hover\\:bg-yellow-dark:hover {\n    background-color: #f2d024;\n}\n.lg\\:hover\\:bg-yellow:hover {\n    background-color: #ffed4a;\n}\n.lg\\:hover\\:bg-yellow-light:hover {\n    background-color: #fff382;\n}\n.lg\\:hover\\:bg-yellow-lighter:hover {\n    background-color: #fff9c2;\n}\n.lg\\:hover\\:bg-yellow-lightest:hover {\n    background-color: #fcfbeb;\n}\n.lg\\:hover\\:bg-green-darkest:hover {\n    background-color: #0f2f21;\n}\n.lg\\:hover\\:bg-green-darker:hover {\n    background-color: #1a4731;\n}\n.lg\\:hover\\:bg-green-dark:hover {\n    background-color: #1f9d55;\n}\n.lg\\:hover\\:bg-green:hover {\n    background-color: #38c172;\n}\n.lg\\:hover\\:bg-green-light:hover {\n    background-color: #51d88a;\n}\n.lg\\:hover\\:bg-green-lighter:hover {\n    background-color: #a2f5bf;\n}\n.lg\\:hover\\:bg-green-lightest:hover {\n    background-color: #e3fcec;\n}\n.lg\\:hover\\:bg-teal-darkest:hover {\n    background-color: #0d3331;\n}\n.lg\\:hover\\:bg-teal-darker:hover {\n    background-color: #20504f;\n}\n.lg\\:hover\\:bg-teal-dark:hover {\n    background-color: #009480;\n}\n.lg\\:hover\\:bg-teal:hover {\n    background-color: #00ae98;\n}\n.lg\\:hover\\:bg-teal-light:hover {\n    background-color: #64d5ca;\n}\n.lg\\:hover\\:bg-teal-lighter:hover {\n    background-color: #a0f0ed;\n}\n.lg\\:hover\\:bg-teal-lightest:hover {\n    background-color: #e8fffe;\n}\n.lg\\:hover\\:bg-blue-darkest:hover {\n    background-color: #12283a;\n}\n.lg\\:hover\\:bg-blue-darker:hover {\n    background-color: #2e6da2;\n}\n.lg\\:hover\\:bg-blue-dark:hover {\n    background-color: #2779bd;\n}\n.lg\\:hover\\:bg-blue:hover {\n    background-color: #3490dc;\n}\n.lg\\:hover\\:bg-blue-light:hover {\n    background-color: #6cb2eb;\n}\n.lg\\:hover\\:bg-blue-lighter:hover {\n    background-color: #bcdefa;\n}\n.lg\\:hover\\:bg-blue-lightest:hover {\n    background-color: #eff8ff;\n}\n.lg\\:hover\\:bg-indigo-darkest:hover {\n    background-color: #191e38;\n}\n.lg\\:hover\\:bg-indigo-darker:hover {\n    background-color: #2f365f;\n}\n.lg\\:hover\\:bg-indigo-dark:hover {\n    background-color: #5661b3;\n}\n.lg\\:hover\\:bg-indigo:hover {\n    background-color: #6574cd;\n}\n.lg\\:hover\\:bg-indigo-light:hover {\n    background-color: #7886d7;\n}\n.lg\\:hover\\:bg-indigo-lighter:hover {\n    background-color: #b2b7ff;\n}\n.lg\\:hover\\:bg-indigo-lightest:hover {\n    background-color: #e6e8ff;\n}\n.lg\\:hover\\:bg-purple-darkest:hover {\n    background-color: #21183c;\n}\n.lg\\:hover\\:bg-purple-darker:hover {\n    background-color: #382b5f;\n}\n.lg\\:hover\\:bg-purple-dark:hover {\n    background-color: #794acf;\n}\n.lg\\:hover\\:bg-purple:hover {\n    background-color: #9561e2;\n}\n.lg\\:hover\\:bg-purple-light:hover {\n    background-color: #a779e9;\n}\n.lg\\:hover\\:bg-purple-lighter:hover {\n    background-color: #d6bbfc;\n}\n.lg\\:hover\\:bg-purple-lightest:hover {\n    background-color: #f3ebff;\n}\n.lg\\:hover\\:bg-pink-darkest:hover {\n    background-color: #451225;\n}\n.lg\\:hover\\:bg-pink-darker:hover {\n    background-color: #6f213f;\n}\n.lg\\:hover\\:bg-pink-dark:hover {\n    background-color: #eb5286;\n}\n.lg\\:hover\\:bg-pink:hover {\n    background-color: #f66d9b;\n}\n.lg\\:hover\\:bg-pink-light:hover {\n    background-color: #fa7ea8;\n}\n.lg\\:hover\\:bg-pink-lighter:hover {\n    background-color: #ffbbca;\n}\n.lg\\:hover\\:bg-pink-lightest:hover {\n    background-color: #ffebef;\n}\n.lg\\:bg-bottom {\n    background-position: bottom;\n}\n.lg\\:bg-center {\n    background-position: center;\n}\n.lg\\:bg-left {\n    background-position: left;\n}\n.lg\\:bg-left-bottom {\n    background-position: left bottom;\n}\n.lg\\:bg-left-top {\n    background-position: left top;\n}\n.lg\\:bg-right {\n    background-position: right;\n}\n.lg\\:bg-right-bottom {\n    background-position: right bottom;\n}\n.lg\\:bg-right-top {\n    background-position: right top;\n}\n.lg\\:bg-top {\n    background-position: top;\n}\n.lg\\:bg-repeat {\n    background-repeat: repeat;\n}\n.lg\\:bg-no-repeat {\n    background-repeat: no-repeat;\n}\n.lg\\:bg-repeat-x {\n    background-repeat: repeat-x;\n}\n.lg\\:bg-repeat-y {\n    background-repeat: repeat-y;\n}\n.lg\\:bg-auto {\n    background-size: auto;\n}\n.lg\\:bg-cover {\n    background-size: cover;\n}\n.lg\\:bg-contain {\n    background-size: contain;\n}\n.lg\\:border-transparent {\n    border-color: transparent;\n}\n.lg\\:border-modal {\n    border-color: rgba(0, 0, 0, .4);\n}\n.lg\\:border-google {\n    border-color: #dc5b5b;\n}\n.lg\\:border-google-dark {\n    border-color: #da5050;\n}\n.lg\\:border-facebook {\n    border-color: #3b5998;\n}\n.lg\\:border-facebook-dark {\n    border-color: #37548f;\n}\n.lg\\:border-primary {\n    border-color: #2196f3;\n}\n.lg\\:border-primary-dark {\n    border-color: #3b5998;\n}\n.lg\\:border-footer {\n    border-color: #1976d2;\n}\n.lg\\:border-black {\n    border-color: #22292f;\n}\n.lg\\:border-grey-darkest {\n    border-color: #3d4852;\n}\n.lg\\:border-grey-darker {\n    border-color: #606f7b;\n}\n.lg\\:border-grey-dark {\n    border-color: #8795a1;\n}\n.lg\\:border-grey {\n    border-color: #b8c2cc;\n}\n.lg\\:border-grey-light {\n    border-color: #dae1e7;\n}\n.lg\\:border-grey-lighter {\n    border-color: #f1f5f8;\n}\n.lg\\:border-grey-lightest {\n    border-color: #f8fafc;\n}\n.lg\\:border-white {\n    border-color: #fff;\n}\n.lg\\:border-whiter {\n    border-color: rgba(255, 255, 255, .6);\n}\n.lg\\:border-red-darkest {\n    border-color: #3b0d0c;\n}\n.lg\\:border-red-darker {\n    border-color: #621b18;\n}\n.lg\\:border-red-dark {\n    border-color: #cc1f1a;\n}\n.lg\\:border-red {\n    border-color: #e3342f;\n}\n.lg\\:border-red-light {\n    border-color: #ef5753;\n}\n.lg\\:border-red-lighter {\n    border-color: #f9acaa;\n}\n.lg\\:border-red-lightest {\n    border-color: #fcebea;\n}\n.lg\\:border-orange-darkest {\n    border-color: #462a16;\n}\n.lg\\:border-orange-darker {\n    border-color: #613b1f;\n}\n.lg\\:border-orange-dark {\n    border-color: #de751f;\n}\n.lg\\:border-orange {\n    border-color: #f6993f;\n}\n.lg\\:border-orange-light {\n    border-color: #faad63;\n}\n.lg\\:border-orange-lighter {\n    border-color: #fcd9b6;\n}\n.lg\\:border-orange-lightest {\n    border-color: #fff5eb;\n}\n.lg\\:border-yellow-darkest {\n    border-color: #453411;\n}\n.lg\\:border-yellow-darker {\n    border-color: #684f1d;\n}\n.lg\\:border-yellow-dark {\n    border-color: #f2d024;\n}\n.lg\\:border-yellow {\n    border-color: #ffed4a;\n}\n.lg\\:border-yellow-light {\n    border-color: #fff382;\n}\n.lg\\:border-yellow-lighter {\n    border-color: #fff9c2;\n}\n.lg\\:border-yellow-lightest {\n    border-color: #fcfbeb;\n}\n.lg\\:border-green-darkest {\n    border-color: #0f2f21;\n}\n.lg\\:border-green-darker {\n    border-color: #1a4731;\n}\n.lg\\:border-green-dark {\n    border-color: #1f9d55;\n}\n.lg\\:border-green {\n    border-color: #38c172;\n}\n.lg\\:border-green-light {\n    border-color: #51d88a;\n}\n.lg\\:border-green-lighter {\n    border-color: #a2f5bf;\n}\n.lg\\:border-green-lightest {\n    border-color: #e3fcec;\n}\n.lg\\:border-teal-darkest {\n    border-color: #0d3331;\n}\n.lg\\:border-teal-darker {\n    border-color: #20504f;\n}\n.lg\\:border-teal-dark {\n    border-color: #009480;\n}\n.lg\\:border-teal {\n    border-color: #00ae98;\n}\n.lg\\:border-teal-light {\n    border-color: #64d5ca;\n}\n.lg\\:border-teal-lighter {\n    border-color: #a0f0ed;\n}\n.lg\\:border-teal-lightest {\n    border-color: #e8fffe;\n}\n.lg\\:border-blue-darkest {\n    border-color: #12283a;\n}\n.lg\\:border-blue-darker {\n    border-color: #2e6da2;\n}\n.lg\\:border-blue-dark {\n    border-color: #2779bd;\n}\n.lg\\:border-blue {\n    border-color: #3490dc;\n}\n.lg\\:border-blue-light {\n    border-color: #6cb2eb;\n}\n.lg\\:border-blue-lighter {\n    border-color: #bcdefa;\n}\n.lg\\:border-blue-lightest {\n    border-color: #eff8ff;\n}\n.lg\\:border-indigo-darkest {\n    border-color: #191e38;\n}\n.lg\\:border-indigo-darker {\n    border-color: #2f365f;\n}\n.lg\\:border-indigo-dark {\n    border-color: #5661b3;\n}\n.lg\\:border-indigo {\n    border-color: #6574cd;\n}\n.lg\\:border-indigo-light {\n    border-color: #7886d7;\n}\n.lg\\:border-indigo-lighter {\n    border-color: #b2b7ff;\n}\n.lg\\:border-indigo-lightest {\n    border-color: #e6e8ff;\n}\n.lg\\:border-purple-darkest {\n    border-color: #21183c;\n}\n.lg\\:border-purple-darker {\n    border-color: #382b5f;\n}\n.lg\\:border-purple-dark {\n    border-color: #794acf;\n}\n.lg\\:border-purple {\n    border-color: #9561e2;\n}\n.lg\\:border-purple-light {\n    border-color: #a779e9;\n}\n.lg\\:border-purple-lighter {\n    border-color: #d6bbfc;\n}\n.lg\\:border-purple-lightest {\n    border-color: #f3ebff;\n}\n.lg\\:border-pink-darkest {\n    border-color: #451225;\n}\n.lg\\:border-pink-darker {\n    border-color: #6f213f;\n}\n.lg\\:border-pink-dark {\n    border-color: #eb5286;\n}\n.lg\\:border-pink {\n    border-color: #f66d9b;\n}\n.lg\\:border-pink-light {\n    border-color: #fa7ea8;\n}\n.lg\\:border-pink-lighter {\n    border-color: #ffbbca;\n}\n.lg\\:border-pink-lightest {\n    border-color: #ffebef;\n}\n.lg\\:hover\\:border-transparent:hover {\n    border-color: transparent;\n}\n.lg\\:hover\\:border-modal:hover {\n    border-color: rgba(0, 0, 0, .4);\n}\n.lg\\:hover\\:border-google:hover {\n    border-color: #dc5b5b;\n}\n.lg\\:hover\\:border-google-dark:hover {\n    border-color: #da5050;\n}\n.lg\\:hover\\:border-facebook:hover {\n    border-color: #3b5998;\n}\n.lg\\:hover\\:border-facebook-dark:hover {\n    border-color: #37548f;\n}\n.lg\\:hover\\:border-primary:hover {\n    border-color: #2196f3;\n}\n.lg\\:hover\\:border-primary-dark:hover {\n    border-color: #3b5998;\n}\n.lg\\:hover\\:border-footer:hover {\n    border-color: #1976d2;\n}\n.lg\\:hover\\:border-black:hover {\n    border-color: #22292f;\n}\n.lg\\:hover\\:border-grey-darkest:hover {\n    border-color: #3d4852;\n}\n.lg\\:hover\\:border-grey-darker:hover {\n    border-color: #606f7b;\n}\n.lg\\:hover\\:border-grey-dark:hover {\n    border-color: #8795a1;\n}\n.lg\\:hover\\:border-grey:hover {\n    border-color: #b8c2cc;\n}\n.lg\\:hover\\:border-grey-light:hover {\n    border-color: #dae1e7;\n}\n.lg\\:hover\\:border-grey-lighter:hover {\n    border-color: #f1f5f8;\n}\n.lg\\:hover\\:border-grey-lightest:hover {\n    border-color: #f8fafc;\n}\n.lg\\:hover\\:border-white:hover {\n    border-color: #fff;\n}\n.lg\\:hover\\:border-whiter:hover {\n    border-color: rgba(255, 255, 255, .6);\n}\n.lg\\:hover\\:border-red-darkest:hover {\n    border-color: #3b0d0c;\n}\n.lg\\:hover\\:border-red-darker:hover {\n    border-color: #621b18;\n}\n.lg\\:hover\\:border-red-dark:hover {\n    border-color: #cc1f1a;\n}\n.lg\\:hover\\:border-red:hover {\n    border-color: #e3342f;\n}\n.lg\\:hover\\:border-red-light:hover {\n    border-color: #ef5753;\n}\n.lg\\:hover\\:border-red-lighter:hover {\n    border-color: #f9acaa;\n}\n.lg\\:hover\\:border-red-lightest:hover {\n    border-color: #fcebea;\n}\n.lg\\:hover\\:border-orange-darkest:hover {\n    border-color: #462a16;\n}\n.lg\\:hover\\:border-orange-darker:hover {\n    border-color: #613b1f;\n}\n.lg\\:hover\\:border-orange-dark:hover {\n    border-color: #de751f;\n}\n.lg\\:hover\\:border-orange:hover {\n    border-color: #f6993f;\n}\n.lg\\:hover\\:border-orange-light:hover {\n    border-color: #faad63;\n}\n.lg\\:hover\\:border-orange-lighter:hover {\n    border-color: #fcd9b6;\n}\n.lg\\:hover\\:border-orange-lightest:hover {\n    border-color: #fff5eb;\n}\n.lg\\:hover\\:border-yellow-darkest:hover {\n    border-color: #453411;\n}\n.lg\\:hover\\:border-yellow-darker:hover {\n    border-color: #684f1d;\n}\n.lg\\:hover\\:border-yellow-dark:hover {\n    border-color: #f2d024;\n}\n.lg\\:hover\\:border-yellow:hover {\n    border-color: #ffed4a;\n}\n.lg\\:hover\\:border-yellow-light:hover {\n    border-color: #fff382;\n}\n.lg\\:hover\\:border-yellow-lighter:hover {\n    border-color: #fff9c2;\n}\n.lg\\:hover\\:border-yellow-lightest:hover {\n    border-color: #fcfbeb;\n}\n.lg\\:hover\\:border-green-darkest:hover {\n    border-color: #0f2f21;\n}\n.lg\\:hover\\:border-green-darker:hover {\n    border-color: #1a4731;\n}\n.lg\\:hover\\:border-green-dark:hover {\n    border-color: #1f9d55;\n}\n.lg\\:hover\\:border-green:hover {\n    border-color: #38c172;\n}\n.lg\\:hover\\:border-green-light:hover {\n    border-color: #51d88a;\n}\n.lg\\:hover\\:border-green-lighter:hover {\n    border-color: #a2f5bf;\n}\n.lg\\:hover\\:border-green-lightest:hover {\n    border-color: #e3fcec;\n}\n.lg\\:hover\\:border-teal-darkest:hover {\n    border-color: #0d3331;\n}\n.lg\\:hover\\:border-teal-darker:hover {\n    border-color: #20504f;\n}\n.lg\\:hover\\:border-teal-dark:hover {\n    border-color: #009480;\n}\n.lg\\:hover\\:border-teal:hover {\n    border-color: #00ae98;\n}\n.lg\\:hover\\:border-teal-light:hover {\n    border-color: #64d5ca;\n}\n.lg\\:hover\\:border-teal-lighter:hover {\n    border-color: #a0f0ed;\n}\n.lg\\:hover\\:border-teal-lightest:hover {\n    border-color: #e8fffe;\n}\n.lg\\:hover\\:border-blue-darkest:hover {\n    border-color: #12283a;\n}\n.lg\\:hover\\:border-blue-darker:hover {\n    border-color: #2e6da2;\n}\n.lg\\:hover\\:border-blue-dark:hover {\n    border-color: #2779bd;\n}\n.lg\\:hover\\:border-blue:hover {\n    border-color: #3490dc;\n}\n.lg\\:hover\\:border-blue-light:hover {\n    border-color: #6cb2eb;\n}\n.lg\\:hover\\:border-blue-lighter:hover {\n    border-color: #bcdefa;\n}\n.lg\\:hover\\:border-blue-lightest:hover {\n    border-color: #eff8ff;\n}\n.lg\\:hover\\:border-indigo-darkest:hover {\n    border-color: #191e38;\n}\n.lg\\:hover\\:border-indigo-darker:hover {\n    border-color: #2f365f;\n}\n.lg\\:hover\\:border-indigo-dark:hover {\n    border-color: #5661b3;\n}\n.lg\\:hover\\:border-indigo:hover {\n    border-color: #6574cd;\n}\n.lg\\:hover\\:border-indigo-light:hover {\n    border-color: #7886d7;\n}\n.lg\\:hover\\:border-indigo-lighter:hover {\n    border-color: #b2b7ff;\n}\n.lg\\:hover\\:border-indigo-lightest:hover {\n    border-color: #e6e8ff;\n}\n.lg\\:hover\\:border-purple-darkest:hover {\n    border-color: #21183c;\n}\n.lg\\:hover\\:border-purple-darker:hover {\n    border-color: #382b5f;\n}\n.lg\\:hover\\:border-purple-dark:hover {\n    border-color: #794acf;\n}\n.lg\\:hover\\:border-purple:hover {\n    border-color: #9561e2;\n}\n.lg\\:hover\\:border-purple-light:hover {\n    border-color: #a779e9;\n}\n.lg\\:hover\\:border-purple-lighter:hover {\n    border-color: #d6bbfc;\n}\n.lg\\:hover\\:border-purple-lightest:hover {\n    border-color: #f3ebff;\n}\n.lg\\:hover\\:border-pink-darkest:hover {\n    border-color: #451225;\n}\n.lg\\:hover\\:border-pink-darker:hover {\n    border-color: #6f213f;\n}\n.lg\\:hover\\:border-pink-dark:hover {\n    border-color: #eb5286;\n}\n.lg\\:hover\\:border-pink:hover {\n    border-color: #f66d9b;\n}\n.lg\\:hover\\:border-pink-light:hover {\n    border-color: #fa7ea8;\n}\n.lg\\:hover\\:border-pink-lighter:hover {\n    border-color: #ffbbca;\n}\n.lg\\:hover\\:border-pink-lightest:hover {\n    border-color: #ffebef;\n}\n.lg\\:rounded-none {\n    border-radius: 0;\n}\n.lg\\:rounded-sm {\n    border-radius: .125rem;\n}\n.lg\\:rounded {\n    border-radius: .25rem;\n}\n.lg\\:rounded-lg {\n    border-radius: .5rem;\n}\n.lg\\:rounded-full {\n    border-radius: 9999px;\n}\n.lg\\:rounded-t-none {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n.lg\\:rounded-r-none {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.lg\\:rounded-b-none {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n}\n.lg\\:rounded-l-none {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n.lg\\:rounded-t-sm {\n    border-top-left-radius: .125rem;\n    border-top-right-radius: .125rem;\n}\n.lg\\:rounded-r-sm {\n    border-top-right-radius: .125rem;\n    border-bottom-right-radius: .125rem;\n}\n.lg\\:rounded-b-sm {\n    border-bottom-right-radius: .125rem;\n    border-bottom-left-radius: .125rem;\n}\n.lg\\:rounded-l-sm {\n    border-top-left-radius: .125rem;\n    border-bottom-left-radius: .125rem;\n}\n.lg\\:rounded-t {\n    border-top-left-radius: .25rem;\n    border-top-right-radius: .25rem;\n}\n.lg\\:rounded-r {\n    border-top-right-radius: .25rem;\n    border-bottom-right-radius: .25rem;\n}\n.lg\\:rounded-b {\n    border-bottom-right-radius: .25rem;\n    border-bottom-left-radius: .25rem;\n}\n.lg\\:rounded-l {\n    border-top-left-radius: .25rem;\n    border-bottom-left-radius: .25rem;\n}\n.lg\\:rounded-t-lg {\n    border-top-left-radius: .5rem;\n    border-top-right-radius: .5rem;\n}\n.lg\\:rounded-r-lg {\n    border-top-right-radius: .5rem;\n    border-bottom-right-radius: .5rem;\n}\n.lg\\:rounded-b-lg {\n    border-bottom-right-radius: .5rem;\n    border-bottom-left-radius: .5rem;\n}\n.lg\\:rounded-l-lg {\n    border-top-left-radius: .5rem;\n    border-bottom-left-radius: .5rem;\n}\n.lg\\:rounded-t-full {\n    border-top-left-radius: 9999px;\n    border-top-right-radius: 9999px;\n}\n.lg\\:rounded-r-full {\n    border-top-right-radius: 9999px;\n    border-bottom-right-radius: 9999px;\n}\n.lg\\:rounded-b-full {\n    border-bottom-right-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n}\n.lg\\:rounded-l-full {\n    border-top-left-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n}\n.lg\\:rounded-tl-none {\n    border-top-left-radius: 0;\n}\n.lg\\:rounded-tr-none {\n    border-top-right-radius: 0;\n}\n.lg\\:rounded-br-none {\n    border-bottom-right-radius: 0;\n}\n.lg\\:rounded-bl-none {\n    border-bottom-left-radius: 0;\n}\n.lg\\:rounded-tl-sm {\n    border-top-left-radius: .125rem;\n}\n.lg\\:rounded-tr-sm {\n    border-top-right-radius: .125rem;\n}\n.lg\\:rounded-br-sm {\n    border-bottom-right-radius: .125rem;\n}\n.lg\\:rounded-bl-sm {\n    border-bottom-left-radius: .125rem;\n}\n.lg\\:rounded-tl {\n    border-top-left-radius: .25rem;\n}\n.lg\\:rounded-tr {\n    border-top-right-radius: .25rem;\n}\n.lg\\:rounded-br {\n    border-bottom-right-radius: .25rem;\n}\n.lg\\:rounded-bl {\n    border-bottom-left-radius: .25rem;\n}\n.lg\\:rounded-tl-lg {\n    border-top-left-radius: .5rem;\n}\n.lg\\:rounded-tr-lg {\n    border-top-right-radius: .5rem;\n}\n.lg\\:rounded-br-lg {\n    border-bottom-right-radius: .5rem;\n}\n.lg\\:rounded-bl-lg {\n    border-bottom-left-radius: .5rem;\n}\n.lg\\:rounded-tl-full {\n    border-top-left-radius: 9999px;\n}\n.lg\\:rounded-tr-full {\n    border-top-right-radius: 9999px;\n}\n.lg\\:rounded-br-full {\n    border-bottom-right-radius: 9999px;\n}\n.lg\\:rounded-bl-full {\n    border-bottom-left-radius: 9999px;\n}\n.lg\\:border-solid {\n    border-style: solid;\n}\n.lg\\:border-dashed {\n    border-style: dashed;\n}\n.lg\\:border-dotted {\n    border-style: dotted;\n}\n.lg\\:border-none {\n    border-style: none;\n}\n.lg\\:border-0 {\n    border-width: 0;\n}\n.lg\\:border-2 {\n    border-width: 2px;\n}\n.lg\\:border-4 {\n    border-width: 4px;\n}\n.lg\\:border-8 {\n    border-width: 8px;\n}\n.lg\\:border {\n    border-width: 1px;\n}\n.lg\\:border-t-0 {\n    border-top-width: 0;\n}\n.lg\\:border-r-0 {\n    border-right-width: 0;\n}\n.lg\\:border-b-0 {\n    border-bottom-width: 0;\n}\n.lg\\:border-l-0 {\n    border-left-width: 0;\n}\n.lg\\:border-t-2 {\n    border-top-width: 2px;\n}\n.lg\\:border-r-2 {\n    border-right-width: 2px;\n}\n.lg\\:border-b-2 {\n    border-bottom-width: 2px;\n}\n.lg\\:border-l-2 {\n    border-left-width: 2px;\n}\n.lg\\:border-t-4 {\n    border-top-width: 4px;\n}\n.lg\\:border-r-4 {\n    border-right-width: 4px;\n}\n.lg\\:border-b-4 {\n    border-bottom-width: 4px;\n}\n.lg\\:border-l-4 {\n    border-left-width: 4px;\n}\n.lg\\:border-t-8 {\n    border-top-width: 8px;\n}\n.lg\\:border-r-8 {\n    border-right-width: 8px;\n}\n.lg\\:border-b-8 {\n    border-bottom-width: 8px;\n}\n.lg\\:border-l-8 {\n    border-left-width: 8px;\n}\n.lg\\:border-t {\n    border-top-width: 1px;\n}\n.lg\\:border-r {\n    border-right-width: 1px;\n}\n.lg\\:border-b {\n    border-bottom-width: 1px;\n}\n.lg\\:border-l {\n    border-left-width: 1px;\n}\n.lg\\:cursor-auto {\n    cursor: auto;\n}\n.lg\\:cursor-default {\n    cursor: default;\n}\n.lg\\:cursor-pointer {\n    cursor: pointer;\n}\n.lg\\:cursor-wait {\n    cursor: wait;\n}\n.lg\\:cursor-move {\n    cursor: move;\n}\n.lg\\:cursor-not-allowed {\n    cursor: not-allowed;\n}\n.lg\\:block {\n    display: block;\n}\n.lg\\:inline-block {\n    display: inline-block;\n}\n.lg\\:inline {\n    display: inline;\n}\n.lg\\:table {\n    display: table;\n}\n.lg\\:table-row {\n    display: table-row;\n}\n.lg\\:table-cell {\n    display: table-cell;\n}\n.lg\\:hidden {\n    display: none;\n}\n.lg\\:flex {\n    display: flex;\n}\n.lg\\:inline-flex {\n    display: inline-flex;\n}\n.lg\\:flex-row {\n    flex-direction: row;\n}\n.lg\\:flex-row-reverse {\n    flex-direction: row-reverse;\n}\n.lg\\:flex-col {\n    flex-direction: column;\n}\n.lg\\:flex-col-reverse {\n    flex-direction: column-reverse;\n}\n.lg\\:flex-wrap {\n    flex-wrap: wrap;\n}\n.lg\\:flex-wrap-reverse {\n    flex-wrap: wrap-reverse;\n}\n.lg\\:flex-no-wrap {\n    flex-wrap: nowrap;\n}\n.lg\\:items-start {\n    align-items: flex-start;\n}\n.lg\\:items-end {\n    align-items: flex-end;\n}\n.lg\\:items-center {\n    align-items: center;\n}\n.lg\\:items-baseline {\n    align-items: baseline;\n}\n.lg\\:items-stretch {\n    align-items: stretch;\n}\n.lg\\:self-auto {\n    align-self: auto;\n}\n.lg\\:self-start {\n    align-self: flex-start;\n}\n.lg\\:self-end {\n    align-self: flex-end;\n}\n.lg\\:self-center {\n    align-self: center;\n}\n.lg\\:self-stretch {\n    align-self: stretch;\n}\n.lg\\:justify-start {\n    justify-content: flex-start;\n}\n.lg\\:justify-end {\n    justify-content: flex-end;\n}\n.lg\\:justify-center {\n    justify-content: center;\n}\n.lg\\:justify-between {\n    justify-content: space-between;\n}\n.lg\\:justify-around {\n    justify-content: space-around;\n}\n.lg\\:content-center {\n    align-content: center;\n}\n.lg\\:content-start {\n    align-content: flex-start;\n}\n.lg\\:content-end {\n    align-content: flex-end;\n}\n.lg\\:content-between {\n    align-content: space-between;\n}\n.lg\\:content-around {\n    align-content: space-around;\n}\n.lg\\:flex-1 {\n    flex: 1;\n}\n.lg\\:flex-auto {\n    flex: auto;\n}\n.lg\\:flex-initial {\n    flex: initial;\n}\n.lg\\:flex-none {\n    flex: none;\n}\n.lg\\:flex-grow {\n    flex-grow: 1;\n}\n.lg\\:flex-shrink {\n    flex-shrink: 1;\n}\n.lg\\:flex-no-grow {\n    flex-grow: 0;\n}\n.lg\\:flex-no-shrink {\n    flex-shrink: 0;\n}\n.lg\\:float-right {\n    float: right;\n}\n.lg\\:float-left {\n    float: left;\n}\n.lg\\:float-none {\n    float: none;\n}\n.lg\\:clearfix:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.lg\\:font-sans {\n    font-family: system-ui, BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n}\n.lg\\:font-serif {\n    font-family: Constantia, Lucida Bright, Lucidabright, Lucida Serif, Lucida, DejaVu Serif, Bitstream Vera Serif, Liberation Serif, Georgia, serif;\n}\n.lg\\:font-mono {\n    font-family: Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;\n}\n.lg\\:font-hairline {\n    font-weight: 100;\n}\n.lg\\:font-thin {\n    font-weight: 200;\n}\n.lg\\:font-light {\n    font-weight: 300;\n}\n.lg\\:font-normal {\n    font-weight: 400;\n}\n.lg\\:font-medium {\n    font-weight: 500;\n}\n.lg\\:font-semibold {\n    font-weight: 600;\n}\n.lg\\:font-bold {\n    font-weight: 700;\n}\n.lg\\:font-extrabold {\n    font-weight: 800;\n}\n.lg\\:font-black {\n    font-weight: 900;\n}\n.lg\\:hover\\:font-hairline:hover {\n    font-weight: 100;\n}\n.lg\\:hover\\:font-thin:hover {\n    font-weight: 200;\n}\n.lg\\:hover\\:font-light:hover {\n    font-weight: 300;\n}\n.lg\\:hover\\:font-normal:hover {\n    font-weight: 400;\n}\n.lg\\:hover\\:font-medium:hover {\n    font-weight: 500;\n}\n.lg\\:hover\\:font-semibold:hover {\n    font-weight: 600;\n}\n.lg\\:hover\\:font-bold:hover {\n    font-weight: 700;\n}\n.lg\\:hover\\:font-extrabold:hover {\n    font-weight: 800;\n}\n.lg\\:hover\\:font-black:hover {\n    font-weight: 900;\n}\n.lg\\:h-1 {\n    height: .25rem;\n}\n.lg\\:h-2 {\n    height: .5rem;\n}\n.lg\\:h-3 {\n    height: .75rem;\n}\n.lg\\:h-4 {\n    height: 1rem;\n}\n.lg\\:h-6 {\n    height: 1.5rem;\n}\n.lg\\:h-8 {\n    height: 2rem;\n}\n.lg\\:h-10 {\n    height: 2.5rem;\n}\n.lg\\:h-12 {\n    height: 3rem;\n}\n.lg\\:h-16 {\n    height: 4rem;\n}\n.lg\\:h-24 {\n    height: 6rem;\n}\n.lg\\:h-32 {\n    height: 8rem;\n}\n.lg\\:h-48 {\n    height: 12rem;\n}\n.lg\\:h-64 {\n    height: 16rem;\n}\n.lg\\:h-auto {\n    height: auto;\n}\n.lg\\:h-px {\n    height: 1px;\n}\n.lg\\:h-full {\n    height: 100%;\n}\n.lg\\:h-screen {\n    height: 100vh;\n}\n.lg\\:h-screen-footer {\n    height: 80vh;\n}\n.lg\\:h-timeslots {\n    height: calc(100vh - 3rem - 1rem);\n}\n.lg\\:leading-none {\n    line-height: 1;\n}\n.lg\\:leading-tight {\n    line-height: 1.25;\n}\n.lg\\:leading-normal {\n    line-height: 1.5;\n}\n.lg\\:leading-loose {\n    line-height: 2;\n}\n.lg\\:m-0 {\n    margin: 0;\n}\n.lg\\:m-1 {\n    margin: .25rem;\n}\n.lg\\:m-2 {\n    margin: .5rem;\n}\n.lg\\:m-3 {\n    margin: .75rem;\n}\n.lg\\:m-4 {\n    margin: 1rem;\n}\n.lg\\:m-6 {\n    margin: 1.5rem;\n}\n.lg\\:m-8 {\n    margin: 2rem;\n}\n.lg\\:m-10 {\n    margin: 2.5rem;\n}\n.lg\\:m-12 {\n    margin: 3rem;\n}\n.lg\\:m-16 {\n    margin: 4rem;\n}\n.lg\\:m-24 {\n    margin: 6rem;\n}\n.lg\\:m-32 {\n    margin: 8rem;\n}\n.lg\\:m-48 {\n    margin: 10rem;\n}\n.lg\\:m-auto {\n    margin: auto;\n}\n.lg\\:m-px {\n    margin: 1px;\n}\n.lg\\:my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n.lg\\:mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n}\n.lg\\:my-1 {\n    margin-top: .25rem;\n    margin-bottom: .25rem;\n}\n.lg\\:mx-1 {\n    margin-left: .25rem;\n    margin-right: .25rem;\n}\n.lg\\:my-2 {\n    margin-top: .5rem;\n    margin-bottom: .5rem;\n}\n.lg\\:mx-2 {\n    margin-left: .5rem;\n    margin-right: .5rem;\n}\n.lg\\:my-3 {\n    margin-top: .75rem;\n    margin-bottom: .75rem;\n}\n.lg\\:mx-3 {\n    margin-left: .75rem;\n    margin-right: .75rem;\n}\n.lg\\:my-4 {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n}\n.lg\\:mx-4 {\n    margin-left: 1rem;\n    margin-right: 1rem;\n}\n.lg\\:my-6 {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n}\n.lg\\:mx-6 {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n}\n.lg\\:my-8 {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n}\n.lg\\:mx-8 {\n    margin-left: 2rem;\n    margin-right: 2rem;\n}\n.lg\\:my-10 {\n    margin-top: 2.5rem;\n    margin-bottom: 2.5rem;\n}\n.lg\\:mx-10 {\n    margin-left: 2.5rem;\n    margin-right: 2.5rem;\n}\n.lg\\:my-12 {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n}\n.lg\\:mx-12 {\n    margin-left: 3rem;\n    margin-right: 3rem;\n}\n.lg\\:my-16 {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n}\n.lg\\:mx-16 {\n    margin-left: 4rem;\n    margin-right: 4rem;\n}\n.lg\\:my-24 {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n}\n.lg\\:mx-24 {\n    margin-left: 6rem;\n    margin-right: 6rem;\n}\n.lg\\:my-32 {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n}\n.lg\\:mx-32 {\n    margin-left: 8rem;\n    margin-right: 8rem;\n}\n.lg\\:my-48 {\n    margin-top: 10rem;\n    margin-bottom: 10rem;\n}\n.lg\\:mx-48 {\n    margin-left: 10rem;\n    margin-right: 10rem;\n}\n.lg\\:my-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n}\n.lg\\:mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n}\n.lg\\:my-px {\n    margin-top: 1px;\n    margin-bottom: 1px;\n}\n.lg\\:mx-px {\n    margin-left: 1px;\n    margin-right: 1px;\n}\n.lg\\:mt-0 {\n    margin-top: 0;\n}\n.lg\\:mr-0 {\n    margin-right: 0;\n}\n.lg\\:mb-0 {\n    margin-bottom: 0;\n}\n.lg\\:ml-0 {\n    margin-left: 0;\n}\n.lg\\:mt-1 {\n    margin-top: .25rem;\n}\n.lg\\:mr-1 {\n    margin-right: .25rem;\n}\n.lg\\:mb-1 {\n    margin-bottom: .25rem;\n}\n.lg\\:ml-1 {\n    margin-left: .25rem;\n}\n.lg\\:mt-2 {\n    margin-top: .5rem;\n}\n.lg\\:mr-2 {\n    margin-right: .5rem;\n}\n.lg\\:mb-2 {\n    margin-bottom: .5rem;\n}\n.lg\\:ml-2 {\n    margin-left: .5rem;\n}\n.lg\\:mt-3 {\n    margin-top: .75rem;\n}\n.lg\\:mr-3 {\n    margin-right: .75rem;\n}\n.lg\\:mb-3 {\n    margin-bottom: .75rem;\n}\n.lg\\:ml-3 {\n    margin-left: .75rem;\n}\n.lg\\:mt-4 {\n    margin-top: 1rem;\n}\n.lg\\:mr-4 {\n    margin-right: 1rem;\n}\n.lg\\:mb-4 {\n    margin-bottom: 1rem;\n}\n.lg\\:ml-4 {\n    margin-left: 1rem;\n}\n.lg\\:mt-6 {\n    margin-top: 1.5rem;\n}\n.lg\\:mr-6 {\n    margin-right: 1.5rem;\n}\n.lg\\:mb-6 {\n    margin-bottom: 1.5rem;\n}\n.lg\\:ml-6 {\n    margin-left: 1.5rem;\n}\n.lg\\:mt-8 {\n    margin-top: 2rem;\n}\n.lg\\:mr-8 {\n    margin-right: 2rem;\n}\n.lg\\:mb-8 {\n    margin-bottom: 2rem;\n}\n.lg\\:ml-8 {\n    margin-left: 2rem;\n}\n.lg\\:mt-10 {\n    margin-top: 2.5rem;\n}\n.lg\\:mr-10 {\n    margin-right: 2.5rem;\n}\n.lg\\:mb-10 {\n    margin-bottom: 2.5rem;\n}\n.lg\\:ml-10 {\n    margin-left: 2.5rem;\n}\n.lg\\:mt-12 {\n    margin-top: 3rem;\n}\n.lg\\:mr-12 {\n    margin-right: 3rem;\n}\n.lg\\:mb-12 {\n    margin-bottom: 3rem;\n}\n.lg\\:ml-12 {\n    margin-left: 3rem;\n}\n.lg\\:mt-16 {\n    margin-top: 4rem;\n}\n.lg\\:mr-16 {\n    margin-right: 4rem;\n}\n.lg\\:mb-16 {\n    margin-bottom: 4rem;\n}\n.lg\\:ml-16 {\n    margin-left: 4rem;\n}\n.lg\\:mt-24 {\n    margin-top: 6rem;\n}\n.lg\\:mr-24 {\n    margin-right: 6rem;\n}\n.lg\\:mb-24 {\n    margin-bottom: 6rem;\n}\n.lg\\:ml-24 {\n    margin-left: 6rem;\n}\n.lg\\:mt-32 {\n    margin-top: 8rem;\n}\n.lg\\:mr-32 {\n    margin-right: 8rem;\n}\n.lg\\:mb-32 {\n    margin-bottom: 8rem;\n}\n.lg\\:ml-32 {\n    margin-left: 8rem;\n}\n.lg\\:mt-48 {\n    margin-top: 10rem;\n}\n.lg\\:mr-48 {\n    margin-right: 10rem;\n}\n.lg\\:mb-48 {\n    margin-bottom: 10rem;\n}\n.lg\\:ml-48 {\n    margin-left: 10rem;\n}\n.lg\\:mt-auto {\n    margin-top: auto;\n}\n.lg\\:mr-auto {\n    margin-right: auto;\n}\n.lg\\:mb-auto {\n    margin-bottom: auto;\n}\n.lg\\:ml-auto {\n    margin-left: auto;\n}\n.lg\\:mt-px {\n    margin-top: 1px;\n}\n.lg\\:mr-px {\n    margin-right: 1px;\n}\n.lg\\:mb-px {\n    margin-bottom: 1px;\n}\n.lg\\:ml-px {\n    margin-left: 1px;\n}\n.lg\\:max-h-full {\n    max-height: 100%;\n}\n.lg\\:max-h-screen {\n    max-height: 100vh;\n}\n.lg\\:max-h-timeslots {\n    max-height: calc(100vh - 3rem - 1rem - 14rem);\n}\n.lg\\:max-w-xs {\n    max-width: 20rem;\n}\n.lg\\:max-w-sm {\n    max-width: 30rem;\n}\n.lg\\:max-w-md {\n    max-width: 40rem;\n}\n.lg\\:max-w-lg {\n    max-width: 50rem;\n}\n.lg\\:max-w-xl {\n    max-width: 60rem;\n}\n.lg\\:max-w-2xl {\n    max-width: 70rem;\n}\n.lg\\:max-w-3xl {\n    max-width: 80rem;\n}\n.lg\\:max-w-4xl {\n    max-width: 90rem;\n}\n.lg\\:max-w-5xl {\n    max-width: 100rem;\n}\n.lg\\:max-w-full {\n    max-width: 100%;\n}\n.lg\\:min-h-0 {\n    min-height: 0;\n}\n.lg\\:min-h-full {\n    min-height: 100%;\n}\n.lg\\:min-h-screen {\n    min-height: 100vh;\n}\n.lg\\:min-h-\\(screen-footer-sm\\) {\n    min-height: calc(100vh - 350px);\n}\n.lg\\:min-h-\\(screen-footer-md\\) {\n    min-height: calc(100vh - 180px);\n}\n.lg\\:min-w-0 {\n    min-width: 0;\n}\n.lg\\:min-w-full {\n    min-width: 100%;\n}\n.lg\\:-m-0 {\n    margin: 0;\n}\n.lg\\:-m-1 {\n    margin: -0.25rem;\n}\n.lg\\:-m-2 {\n    margin: -0.5rem;\n}\n.lg\\:-m-3 {\n    margin: -0.75rem;\n}\n.lg\\:-m-4 {\n    margin: -1rem;\n}\n.lg\\:-m-6 {\n    margin: -1.5rem;\n}\n.lg\\:-m-8 {\n    margin: -2rem;\n}\n.lg\\:-m-10 {\n    margin: -2.5rem;\n}\n.lg\\:-m-12 {\n    margin: -3rem;\n}\n.lg\\:-m-16 {\n    margin: -4rem;\n}\n.lg\\:-m-24 {\n    margin: -6rem;\n}\n.lg\\:-m-32 {\n    margin: -8rem;\n}\n.lg\\:-m-48 {\n    margin: -10rem;\n}\n.lg\\:-m-px {\n    margin: -1px;\n}\n.lg\\:-my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n.lg\\:-mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n}\n.lg\\:-my-1 {\n    margin-top: -0.25rem;\n    margin-bottom: -0.25rem;\n}\n.lg\\:-mx-1 {\n    margin-left: -0.25rem;\n    margin-right: -0.25rem;\n}\n.lg\\:-my-2 {\n    margin-top: -0.5rem;\n    margin-bottom: -0.5rem;\n}\n.lg\\:-mx-2 {\n    margin-left: -0.5rem;\n    margin-right: -0.5rem;\n}\n.lg\\:-my-3 {\n    margin-top: -0.75rem;\n    margin-bottom: -0.75rem;\n}\n.lg\\:-mx-3 {\n    margin-left: -0.75rem;\n    margin-right: -0.75rem;\n}\n.lg\\:-my-4 {\n    margin-top: -1rem;\n    margin-bottom: -1rem;\n}\n.lg\\:-mx-4 {\n    margin-left: -1rem;\n    margin-right: -1rem;\n}\n.lg\\:-my-6 {\n    margin-top: -1.5rem;\n    margin-bottom: -1.5rem;\n}\n.lg\\:-mx-6 {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n}\n.lg\\:-my-8 {\n    margin-top: -2rem;\n    margin-bottom: -2rem;\n}\n.lg\\:-mx-8 {\n    margin-left: -2rem;\n    margin-right: -2rem;\n}\n.lg\\:-my-10 {\n    margin-top: -2.5rem;\n    margin-bottom: -2.5rem;\n}\n.lg\\:-mx-10 {\n    margin-left: -2.5rem;\n    margin-right: -2.5rem;\n}\n.lg\\:-my-12 {\n    margin-top: -3rem;\n    margin-bottom: -3rem;\n}\n.lg\\:-mx-12 {\n    margin-left: -3rem;\n    margin-right: -3rem;\n}\n.lg\\:-my-16 {\n    margin-top: -4rem;\n    margin-bottom: -4rem;\n}\n.lg\\:-mx-16 {\n    margin-left: -4rem;\n    margin-right: -4rem;\n}\n.lg\\:-my-24 {\n    margin-top: -6rem;\n    margin-bottom: -6rem;\n}\n.lg\\:-mx-24 {\n    margin-left: -6rem;\n    margin-right: -6rem;\n}\n.lg\\:-my-32 {\n    margin-top: -8rem;\n    margin-bottom: -8rem;\n}\n.lg\\:-mx-32 {\n    margin-left: -8rem;\n    margin-right: -8rem;\n}\n.lg\\:-my-48 {\n    margin-top: -10rem;\n    margin-bottom: -10rem;\n}\n.lg\\:-mx-48 {\n    margin-left: -10rem;\n    margin-right: -10rem;\n}\n.lg\\:-my-px {\n    margin-top: -1px;\n    margin-bottom: -1px;\n}\n.lg\\:-mx-px {\n    margin-left: -1px;\n    margin-right: -1px;\n}\n.lg\\:-mt-0 {\n    margin-top: 0;\n}\n.lg\\:-mr-0 {\n    margin-right: 0;\n}\n.lg\\:-mb-0 {\n    margin-bottom: 0;\n}\n.lg\\:-ml-0 {\n    margin-left: 0;\n}\n.lg\\:-mt-1 {\n    margin-top: -0.25rem;\n}\n.lg\\:-mr-1 {\n    margin-right: -0.25rem;\n}\n.lg\\:-mb-1 {\n    margin-bottom: -0.25rem;\n}\n.lg\\:-ml-1 {\n    margin-left: -0.25rem;\n}\n.lg\\:-mt-2 {\n    margin-top: -0.5rem;\n}\n.lg\\:-mr-2 {\n    margin-right: -0.5rem;\n}\n.lg\\:-mb-2 {\n    margin-bottom: -0.5rem;\n}\n.lg\\:-ml-2 {\n    margin-left: -0.5rem;\n}\n.lg\\:-mt-3 {\n    margin-top: -0.75rem;\n}\n.lg\\:-mr-3 {\n    margin-right: -0.75rem;\n}\n.lg\\:-mb-3 {\n    margin-bottom: -0.75rem;\n}\n.lg\\:-ml-3 {\n    margin-left: -0.75rem;\n}\n.lg\\:-mt-4 {\n    margin-top: -1rem;\n}\n.lg\\:-mr-4 {\n    margin-right: -1rem;\n}\n.lg\\:-mb-4 {\n    margin-bottom: -1rem;\n}\n.lg\\:-ml-4 {\n    margin-left: -1rem;\n}\n.lg\\:-mt-6 {\n    margin-top: -1.5rem;\n}\n.lg\\:-mr-6 {\n    margin-right: -1.5rem;\n}\n.lg\\:-mb-6 {\n    margin-bottom: -1.5rem;\n}\n.lg\\:-ml-6 {\n    margin-left: -1.5rem;\n}\n.lg\\:-mt-8 {\n    margin-top: -2rem;\n}\n.lg\\:-mr-8 {\n    margin-right: -2rem;\n}\n.lg\\:-mb-8 {\n    margin-bottom: -2rem;\n}\n.lg\\:-ml-8 {\n    margin-left: -2rem;\n}\n.lg\\:-mt-10 {\n    margin-top: -2.5rem;\n}\n.lg\\:-mr-10 {\n    margin-right: -2.5rem;\n}\n.lg\\:-mb-10 {\n    margin-bottom: -2.5rem;\n}\n.lg\\:-ml-10 {\n    margin-left: -2.5rem;\n}\n.lg\\:-mt-12 {\n    margin-top: -3rem;\n}\n.lg\\:-mr-12 {\n    margin-right: -3rem;\n}\n.lg\\:-mb-12 {\n    margin-bottom: -3rem;\n}\n.lg\\:-ml-12 {\n    margin-left: -3rem;\n}\n.lg\\:-mt-16 {\n    margin-top: -4rem;\n}\n.lg\\:-mr-16 {\n    margin-right: -4rem;\n}\n.lg\\:-mb-16 {\n    margin-bottom: -4rem;\n}\n.lg\\:-ml-16 {\n    margin-left: -4rem;\n}\n.lg\\:-mt-24 {\n    margin-top: -6rem;\n}\n.lg\\:-mr-24 {\n    margin-right: -6rem;\n}\n.lg\\:-mb-24 {\n    margin-bottom: -6rem;\n}\n.lg\\:-ml-24 {\n    margin-left: -6rem;\n}\n.lg\\:-mt-32 {\n    margin-top: -8rem;\n}\n.lg\\:-mr-32 {\n    margin-right: -8rem;\n}\n.lg\\:-mb-32 {\n    margin-bottom: -8rem;\n}\n.lg\\:-ml-32 {\n    margin-left: -8rem;\n}\n.lg\\:-mt-48 {\n    margin-top: -10rem;\n}\n.lg\\:-mr-48 {\n    margin-right: -10rem;\n}\n.lg\\:-mb-48 {\n    margin-bottom: -10rem;\n}\n.lg\\:-ml-48 {\n    margin-left: -10rem;\n}\n.lg\\:-mt-px {\n    margin-top: -1px;\n}\n.lg\\:-mr-px {\n    margin-right: -1px;\n}\n.lg\\:-mb-px {\n    margin-bottom: -1px;\n}\n.lg\\:-ml-px {\n    margin-left: -1px;\n}\n.lg\\:opacity-0 {\n    opacity: 0;\n}\n.lg\\:opacity-25 {\n    opacity: .25;\n}\n.lg\\:opacity-50 {\n    opacity: .5;\n}\n.lg\\:opacity-75 {\n    opacity: .75;\n}\n.lg\\:opacity-100 {\n    opacity: 1;\n}\n.lg\\:hover\\:opacity-0:hover {\n    opacity: 0;\n}\n.lg\\:hover\\:opacity-25:hover {\n    opacity: .25;\n}\n.lg\\:hover\\:opacity-50:hover {\n    opacity: .5;\n}\n.lg\\:hover\\:opacity-75:hover {\n    opacity: .75;\n}\n.lg\\:hover\\:opacity-100:hover {\n    opacity: 1;\n}\n.lg\\:overflow-auto {\n    overflow: auto;\n}\n.lg\\:overflow-hidden {\n    overflow: hidden;\n}\n.lg\\:overflow-visible {\n    overflow: visible;\n}\n.lg\\:overflow-scroll {\n    overflow: scroll;\n}\n.lg\\:overflow-x-auto {\n    overflow-x: auto;\n}\n.lg\\:overflow-y-auto {\n    overflow-y: auto;\n}\n.lg\\:overflow-x-scroll {\n    overflow-x: scroll;\n}\n.lg\\:overflow-y-scroll {\n    overflow-y: scroll;\n}\n.lg\\:scrolling-touch {\n    -webkit-overflow-scrolling: touch;\n}\n.lg\\:scrolling-auto {\n    -webkit-overflow-scrolling: auto;\n}\n.lg\\:p-0 {\n    padding: 0;\n}\n.lg\\:p-1 {\n    padding: .25rem;\n}\n.lg\\:p-2 {\n    padding: .5rem;\n}\n.lg\\:p-3 {\n    padding: .75rem;\n}\n.lg\\:p-4 {\n    padding: 1rem;\n}\n.lg\\:p-6 {\n    padding: 1.5rem;\n}\n.lg\\:p-8 {\n    padding: 2rem;\n}\n.lg\\:p-10 {\n    padding: 2.5rem;\n}\n.lg\\:p-12 {\n    padding: 3rem;\n}\n.lg\\:p-16 {\n    padding: 4rem;\n}\n.lg\\:p-24 {\n    padding: 6rem;\n}\n.lg\\:p-32 {\n    padding: 8rem;\n}\n.lg\\:p-48 {\n    padding: 10rem;\n}\n.lg\\:p-px {\n    padding: 1px;\n}\n.lg\\:py-0 {\n    padding-top: 0;\n    padding-bottom: 0;\n}\n.lg\\:px-0 {\n    padding-left: 0;\n    padding-right: 0;\n}\n.lg\\:py-1 {\n    padding-top: .25rem;\n    padding-bottom: .25rem;\n}\n.lg\\:px-1 {\n    padding-left: .25rem;\n    padding-right: .25rem;\n}\n.lg\\:py-2 {\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n}\n.lg\\:px-2 {\n    padding-left: .5rem;\n    padding-right: .5rem;\n}\n.lg\\:py-3 {\n    padding-top: .75rem;\n    padding-bottom: .75rem;\n}\n.lg\\:px-3 {\n    padding-left: .75rem;\n    padding-right: .75rem;\n}\n.lg\\:py-4 {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n}\n.lg\\:px-4 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n}\n.lg\\:py-6 {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n}\n.lg\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n}\n.lg\\:py-8 {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n}\n.lg\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n}\n.lg\\:py-10 {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n}\n.lg\\:px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n}\n.lg\\:py-12 {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n}\n.lg\\:px-12 {\n    padding-left: 3rem;\n    padding-right: 3rem;\n}\n.lg\\:py-16 {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n}\n.lg\\:px-16 {\n    padding-left: 4rem;\n    padding-right: 4rem;\n}\n.lg\\:py-24 {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n}\n.lg\\:px-24 {\n    padding-left: 6rem;\n    padding-right: 6rem;\n}\n.lg\\:py-32 {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n}\n.lg\\:px-32 {\n    padding-left: 8rem;\n    padding-right: 8rem;\n}\n.lg\\:py-48 {\n    padding-top: 10rem;\n    padding-bottom: 10rem;\n}\n.lg\\:px-48 {\n    padding-left: 10rem;\n    padding-right: 10rem;\n}\n.lg\\:py-px {\n    padding-top: 1px;\n    padding-bottom: 1px;\n}\n.lg\\:px-px {\n    padding-left: 1px;\n    padding-right: 1px;\n}\n.lg\\:pt-0 {\n    padding-top: 0;\n}\n.lg\\:pr-0 {\n    padding-right: 0;\n}\n.lg\\:pb-0 {\n    padding-bottom: 0;\n}\n.lg\\:pl-0 {\n    padding-left: 0;\n}\n.lg\\:pt-1 {\n    padding-top: .25rem;\n}\n.lg\\:pr-1 {\n    padding-right: .25rem;\n}\n.lg\\:pb-1 {\n    padding-bottom: .25rem;\n}\n.lg\\:pl-1 {\n    padding-left: .25rem;\n}\n.lg\\:pt-2 {\n    padding-top: .5rem;\n}\n.lg\\:pr-2 {\n    padding-right: .5rem;\n}\n.lg\\:pb-2 {\n    padding-bottom: .5rem;\n}\n.lg\\:pl-2 {\n    padding-left: .5rem;\n}\n.lg\\:pt-3 {\n    padding-top: .75rem;\n}\n.lg\\:pr-3 {\n    padding-right: .75rem;\n}\n.lg\\:pb-3 {\n    padding-bottom: .75rem;\n}\n.lg\\:pl-3 {\n    padding-left: .75rem;\n}\n.lg\\:pt-4 {\n    padding-top: 1rem;\n}\n.lg\\:pr-4 {\n    padding-right: 1rem;\n}\n.lg\\:pb-4 {\n    padding-bottom: 1rem;\n}\n.lg\\:pl-4 {\n    padding-left: 1rem;\n}\n.lg\\:pt-6 {\n    padding-top: 1.5rem;\n}\n.lg\\:pr-6 {\n    padding-right: 1.5rem;\n}\n.lg\\:pb-6 {\n    padding-bottom: 1.5rem;\n}\n.lg\\:pl-6 {\n    padding-left: 1.5rem;\n}\n.lg\\:pt-8 {\n    padding-top: 2rem;\n}\n.lg\\:pr-8 {\n    padding-right: 2rem;\n}\n.lg\\:pb-8 {\n    padding-bottom: 2rem;\n}\n.lg\\:pl-8 {\n    padding-left: 2rem;\n}\n.lg\\:pt-10 {\n    padding-top: 2.5rem;\n}\n.lg\\:pr-10 {\n    padding-right: 2.5rem;\n}\n.lg\\:pb-10 {\n    padding-bottom: 2.5rem;\n}\n.lg\\:pl-10 {\n    padding-left: 2.5rem;\n}\n.lg\\:pt-12 {\n    padding-top: 3rem;\n}\n.lg\\:pr-12 {\n    padding-right: 3rem;\n}\n.lg\\:pb-12 {\n    padding-bottom: 3rem;\n}\n.lg\\:pl-12 {\n    padding-left: 3rem;\n}\n.lg\\:pt-16 {\n    padding-top: 4rem;\n}\n.lg\\:pr-16 {\n    padding-right: 4rem;\n}\n.lg\\:pb-16 {\n    padding-bottom: 4rem;\n}\n.lg\\:pl-16 {\n    padding-left: 4rem;\n}\n.lg\\:pt-24 {\n    padding-top: 6rem;\n}\n.lg\\:pr-24 {\n    padding-right: 6rem;\n}\n.lg\\:pb-24 {\n    padding-bottom: 6rem;\n}\n.lg\\:pl-24 {\n    padding-left: 6rem;\n}\n.lg\\:pt-32 {\n    padding-top: 8rem;\n}\n.lg\\:pr-32 {\n    padding-right: 8rem;\n}\n.lg\\:pb-32 {\n    padding-bottom: 8rem;\n}\n.lg\\:pl-32 {\n    padding-left: 8rem;\n}\n.lg\\:pt-48 {\n    padding-top: 10rem;\n}\n.lg\\:pr-48 {\n    padding-right: 10rem;\n}\n.lg\\:pb-48 {\n    padding-bottom: 10rem;\n}\n.lg\\:pl-48 {\n    padding-left: 10rem;\n}\n.lg\\:pt-px {\n    padding-top: 1px;\n}\n.lg\\:pr-px {\n    padding-right: 1px;\n}\n.lg\\:pb-px {\n    padding-bottom: 1px;\n}\n.lg\\:pl-px {\n    padding-left: 1px;\n}\n.lg\\:pointer-events-none {\n    pointer-events: none;\n}\n.lg\\:pointer-events-auto {\n    pointer-events: auto;\n}\n.lg\\:static {\n    position: static;\n}\n.lg\\:fixed {\n    position: fixed;\n}\n.lg\\:absolute {\n    position: absolute;\n}\n.lg\\:relative {\n    position: relative;\n}\n.lg\\:sticky {\n    position: sticky;\n}\n.lg\\:pin-none {\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n}\n.lg\\:pin {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n.lg\\:pin-y {\n    top: 0;\n    bottom: 0;\n}\n.lg\\:pin-x {\n    right: 0;\n    left: 0;\n}\n.lg\\:pin-t {\n    top: 0;\n}\n.lg\\:pin-r {\n    right: 0;\n}\n.lg\\:pin-b {\n    bottom: 0;\n}\n.lg\\:pin-l {\n    left: 0;\n}\n.lg\\:resize-none {\n    resize: none;\n}\n.lg\\:resize-y {\n    resize: vertical;\n}\n.lg\\:resize-x {\n    resize: horizontal;\n}\n.lg\\:resize {\n    resize: both;\n}\n.lg\\:shadow {\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .1);\n}\n.lg\\:shadow-md {\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .12), 0 2px 4px 0 rgba(0, 0, 0, .08);\n}\n.lg\\:shadow-lg {\n    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, .11), 0 5px 15px 0 rgba(0, 0, 0, .08);\n}\n.lg\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, .06);\n}\n.lg\\:shadow-none {\n    box-shadow: none;\n}\n.lg\\:text-left {\n    text-align: left;\n}\n.lg\\:text-center {\n    text-align: center;\n}\n.lg\\:text-right {\n    text-align: right;\n}\n.lg\\:text-justify {\n    text-align: justify;\n}\n.lg\\:text-transparent {\n    color: transparent;\n}\n.lg\\:text-modal {\n    color: rgba(0, 0, 0, .4);\n}\n.lg\\:text-google {\n    color: #dc5b5b;\n}\n.lg\\:text-google-dark {\n    color: #da5050;\n}\n.lg\\:text-facebook {\n    color: #3b5998;\n}\n.lg\\:text-facebook-dark {\n    color: #37548f;\n}\n.lg\\:text-primary {\n    color: #2196f3;\n}\n.lg\\:text-primary-dark {\n    color: #3b5998;\n}\n.lg\\:text-footer {\n    color: #1976d2;\n}\n.lg\\:text-black {\n    color: #22292f;\n}\n.lg\\:text-grey-darkest {\n    color: #3d4852;\n}\n.lg\\:text-grey-darker {\n    color: #606f7b;\n}\n.lg\\:text-grey-dark {\n    color: #8795a1;\n}\n.lg\\:text-grey {\n    color: #b8c2cc;\n}\n.lg\\:text-grey-light {\n    color: #dae1e7;\n}\n.lg\\:text-grey-lighter {\n    color: #f1f5f8;\n}\n.lg\\:text-grey-lightest {\n    color: #f8fafc;\n}\n.lg\\:text-white {\n    color: #fff;\n}\n.lg\\:text-whiter {\n    color: rgba(255, 255, 255, .6);\n}\n.lg\\:text-red-darkest {\n    color: #3b0d0c;\n}\n.lg\\:text-red-darker {\n    color: #621b18;\n}\n.lg\\:text-red-dark {\n    color: #cc1f1a;\n}\n.lg\\:text-red {\n    color: #e3342f;\n}\n.lg\\:text-red-light {\n    color: #ef5753;\n}\n.lg\\:text-red-lighter {\n    color: #f9acaa;\n}\n.lg\\:text-red-lightest {\n    color: #fcebea;\n}\n.lg\\:text-orange-darkest {\n    color: #462a16;\n}\n.lg\\:text-orange-darker {\n    color: #613b1f;\n}\n.lg\\:text-orange-dark {\n    color: #de751f;\n}\n.lg\\:text-orange {\n    color: #f6993f;\n}\n.lg\\:text-orange-light {\n    color: #faad63;\n}\n.lg\\:text-orange-lighter {\n    color: #fcd9b6;\n}\n.lg\\:text-orange-lightest {\n    color: #fff5eb;\n}\n.lg\\:text-yellow-darkest {\n    color: #453411;\n}\n.lg\\:text-yellow-darker {\n    color: #684f1d;\n}\n.lg\\:text-yellow-dark {\n    color: #f2d024;\n}\n.lg\\:text-yellow {\n    color: #ffed4a;\n}\n.lg\\:text-yellow-light {\n    color: #fff382;\n}\n.lg\\:text-yellow-lighter {\n    color: #fff9c2;\n}\n.lg\\:text-yellow-lightest {\n    color: #fcfbeb;\n}\n.lg\\:text-green-darkest {\n    color: #0f2f21;\n}\n.lg\\:text-green-darker {\n    color: #1a4731;\n}\n.lg\\:text-green-dark {\n    color: #1f9d55;\n}\n.lg\\:text-green {\n    color: #38c172;\n}\n.lg\\:text-green-light {\n    color: #51d88a;\n}\n.lg\\:text-green-lighter {\n    color: #a2f5bf;\n}\n.lg\\:text-green-lightest {\n    color: #e3fcec;\n}\n.lg\\:text-teal-darkest {\n    color: #0d3331;\n}\n.lg\\:text-teal-darker {\n    color: #20504f;\n}\n.lg\\:text-teal-dark {\n    color: #009480;\n}\n.lg\\:text-teal {\n    color: #00ae98;\n}\n.lg\\:text-teal-light {\n    color: #64d5ca;\n}\n.lg\\:text-teal-lighter {\n    color: #a0f0ed;\n}\n.lg\\:text-teal-lightest {\n    color: #e8fffe;\n}\n.lg\\:text-blue-darkest {\n    color: #12283a;\n}\n.lg\\:text-blue-darker {\n    color: #2e6da2;\n}\n.lg\\:text-blue-dark {\n    color: #2779bd;\n}\n.lg\\:text-blue {\n    color: #3490dc;\n}\n.lg\\:text-blue-light {\n    color: #6cb2eb;\n}\n.lg\\:text-blue-lighter {\n    color: #bcdefa;\n}\n.lg\\:text-blue-lightest {\n    color: #eff8ff;\n}\n.lg\\:text-indigo-darkest {\n    color: #191e38;\n}\n.lg\\:text-indigo-darker {\n    color: #2f365f;\n}\n.lg\\:text-indigo-dark {\n    color: #5661b3;\n}\n.lg\\:text-indigo {\n    color: #6574cd;\n}\n.lg\\:text-indigo-light {\n    color: #7886d7;\n}\n.lg\\:text-indigo-lighter {\n    color: #b2b7ff;\n}\n.lg\\:text-indigo-lightest {\n    color: #e6e8ff;\n}\n.lg\\:text-purple-darkest {\n    color: #21183c;\n}\n.lg\\:text-purple-darker {\n    color: #382b5f;\n}\n.lg\\:text-purple-dark {\n    color: #794acf;\n}\n.lg\\:text-purple {\n    color: #9561e2;\n}\n.lg\\:text-purple-light {\n    color: #a779e9;\n}\n.lg\\:text-purple-lighter {\n    color: #d6bbfc;\n}\n.lg\\:text-purple-lightest {\n    color: #f3ebff;\n}\n.lg\\:text-pink-darkest {\n    color: #451225;\n}\n.lg\\:text-pink-darker {\n    color: #6f213f;\n}\n.lg\\:text-pink-dark {\n    color: #eb5286;\n}\n.lg\\:text-pink {\n    color: #f66d9b;\n}\n.lg\\:text-pink-light {\n    color: #fa7ea8;\n}\n.lg\\:text-pink-lighter {\n    color: #ffbbca;\n}\n.lg\\:text-pink-lightest {\n    color: #ffebef;\n}\n.lg\\:group:hover .group-hover\\:text-transparent {\n    color: transparent;\n}\n.lg\\:group:hover .group-hover\\:text-modal {\n    color: rgba(0, 0, 0, .4);\n}\n.lg\\:group:hover .group-hover\\:text-google {\n    color: #dc5b5b;\n}\n.lg\\:group:hover .group-hover\\:text-google-dark {\n    color: #da5050;\n}\n.lg\\:group:hover .group-hover\\:text-facebook {\n    color: #3b5998;\n}\n.lg\\:group:hover .group-hover\\:text-facebook-dark {\n    color: #37548f;\n}\n.lg\\:group:hover .group-hover\\:text-primary {\n    color: #2196f3;\n}\n.lg\\:group:hover .group-hover\\:text-primary-dark {\n    color: #3b5998;\n}\n.lg\\:group:hover .group-hover\\:text-footer {\n    color: #1976d2;\n}\n.lg\\:group:hover .group-hover\\:text-black {\n    color: #22292f;\n}\n.lg\\:group:hover .group-hover\\:text-grey-darkest {\n    color: #3d4852;\n}\n.lg\\:group:hover .group-hover\\:text-grey-darker {\n    color: #606f7b;\n}\n.lg\\:group:hover .group-hover\\:text-grey-dark {\n    color: #8795a1;\n}\n.lg\\:group:hover .group-hover\\:text-grey {\n    color: #b8c2cc;\n}\n.lg\\:group:hover .group-hover\\:text-grey-light {\n    color: #dae1e7;\n}\n.lg\\:group:hover .group-hover\\:text-grey-lighter {\n    color: #f1f5f8;\n}\n.lg\\:group:hover .group-hover\\:text-grey-lightest {\n    color: #f8fafc;\n}\n.lg\\:group:hover .group-hover\\:text-white {\n    color: #fff;\n}\n.lg\\:group:hover .group-hover\\:text-whiter {\n    color: rgba(255, 255, 255, .6);\n}\n.lg\\:group:hover .group-hover\\:text-red-darkest {\n    color: #3b0d0c;\n}\n.lg\\:group:hover .group-hover\\:text-red-darker {\n    color: #621b18;\n}\n.lg\\:group:hover .group-hover\\:text-red-dark {\n    color: #cc1f1a;\n}\n.lg\\:group:hover .group-hover\\:text-red {\n    color: #e3342f;\n}\n.lg\\:group:hover .group-hover\\:text-red-light {\n    color: #ef5753;\n}\n.lg\\:group:hover .group-hover\\:text-red-lighter {\n    color: #f9acaa;\n}\n.lg\\:group:hover .group-hover\\:text-red-lightest {\n    color: #fcebea;\n}\n.lg\\:group:hover .group-hover\\:text-orange-darkest {\n    color: #462a16;\n}\n.lg\\:group:hover .group-hover\\:text-orange-darker {\n    color: #613b1f;\n}\n.lg\\:group:hover .group-hover\\:text-orange-dark {\n    color: #de751f;\n}\n.lg\\:group:hover .group-hover\\:text-orange {\n    color: #f6993f;\n}\n.lg\\:group:hover .group-hover\\:text-orange-light {\n    color: #faad63;\n}\n.lg\\:group:hover .group-hover\\:text-orange-lighter {\n    color: #fcd9b6;\n}\n.lg\\:group:hover .group-hover\\:text-orange-lightest {\n    color: #fff5eb;\n}\n.lg\\:group:hover .group-hover\\:text-yellow-darkest {\n    color: #453411;\n}\n.lg\\:group:hover .group-hover\\:text-yellow-darker {\n    color: #684f1d;\n}\n.lg\\:group:hover .group-hover\\:text-yellow-dark {\n    color: #f2d024;\n}\n.lg\\:group:hover .group-hover\\:text-yellow {\n    color: #ffed4a;\n}\n.lg\\:group:hover .group-hover\\:text-yellow-light {\n    color: #fff382;\n}\n.lg\\:group:hover .group-hover\\:text-yellow-lighter {\n    color: #fff9c2;\n}\n.lg\\:group:hover .group-hover\\:text-yellow-lightest {\n    color: #fcfbeb;\n}\n.lg\\:group:hover .group-hover\\:text-green-darkest {\n    color: #0f2f21;\n}\n.lg\\:group:hover .group-hover\\:text-green-darker {\n    color: #1a4731;\n}\n.lg\\:group:hover .group-hover\\:text-green-dark {\n    color: #1f9d55;\n}\n.lg\\:group:hover .group-hover\\:text-green {\n    color: #38c172;\n}\n.lg\\:group:hover .group-hover\\:text-green-light {\n    color: #51d88a;\n}\n.lg\\:group:hover .group-hover\\:text-green-lighter {\n    color: #a2f5bf;\n}\n.lg\\:group:hover .group-hover\\:text-green-lightest {\n    color: #e3fcec;\n}\n.lg\\:group:hover .group-hover\\:text-teal-darkest {\n    color: #0d3331;\n}\n.lg\\:group:hover .group-hover\\:text-teal-darker {\n    color: #20504f;\n}\n.lg\\:group:hover .group-hover\\:text-teal-dark {\n    color: #009480;\n}\n.lg\\:group:hover .group-hover\\:text-teal {\n    color: #00ae98;\n}\n.lg\\:group:hover .group-hover\\:text-teal-light {\n    color: #64d5ca;\n}\n.lg\\:group:hover .group-hover\\:text-teal-lighter {\n    color: #a0f0ed;\n}\n.lg\\:group:hover .group-hover\\:text-teal-lightest {\n    color: #e8fffe;\n}\n.lg\\:group:hover .group-hover\\:text-blue-darkest {\n    color: #12283a;\n}\n.lg\\:group:hover .group-hover\\:text-blue-darker {\n    color: #2e6da2;\n}\n.lg\\:group:hover .group-hover\\:text-blue-dark {\n    color: #2779bd;\n}\n.lg\\:group:hover .group-hover\\:text-blue {\n    color: #3490dc;\n}\n.lg\\:group:hover .group-hover\\:text-blue-light {\n    color: #6cb2eb;\n}\n.lg\\:group:hover .group-hover\\:text-blue-lighter {\n    color: #bcdefa;\n}\n.lg\\:group:hover .group-hover\\:text-blue-lightest {\n    color: #eff8ff;\n}\n.lg\\:group:hover .group-hover\\:text-indigo-darkest {\n    color: #191e38;\n}\n.lg\\:group:hover .group-hover\\:text-indigo-darker {\n    color: #2f365f;\n}\n.lg\\:group:hover .group-hover\\:text-indigo-dark {\n    color: #5661b3;\n}\n.lg\\:group:hover .group-hover\\:text-indigo {\n    color: #6574cd;\n}\n.lg\\:group:hover .group-hover\\:text-indigo-light {\n    color: #7886d7;\n}\n.lg\\:group:hover .group-hover\\:text-indigo-lighter {\n    color: #b2b7ff;\n}\n.lg\\:group:hover .group-hover\\:text-indigo-lightest {\n    color: #e6e8ff;\n}\n.lg\\:group:hover .group-hover\\:text-purple-darkest {\n    color: #21183c;\n}\n.lg\\:group:hover .group-hover\\:text-purple-darker {\n    color: #382b5f;\n}\n.lg\\:group:hover .group-hover\\:text-purple-dark {\n    color: #794acf;\n}\n.lg\\:group:hover .group-hover\\:text-purple {\n    color: #9561e2;\n}\n.lg\\:group:hover .group-hover\\:text-purple-light {\n    color: #a779e9;\n}\n.lg\\:group:hover .group-hover\\:text-purple-lighter {\n    color: #d6bbfc;\n}\n.lg\\:group:hover .group-hover\\:text-purple-lightest {\n    color: #f3ebff;\n}\n.lg\\:group:hover .group-hover\\:text-pink-darkest {\n    color: #451225;\n}\n.lg\\:group:hover .group-hover\\:text-pink-darker {\n    color: #6f213f;\n}\n.lg\\:group:hover .group-hover\\:text-pink-dark {\n    color: #eb5286;\n}\n.lg\\:group:hover .group-hover\\:text-pink {\n    color: #f66d9b;\n}\n.lg\\:group:hover .group-hover\\:text-pink-light {\n    color: #fa7ea8;\n}\n.lg\\:group:hover .group-hover\\:text-pink-lighter {\n    color: #ffbbca;\n}\n.lg\\:group:hover .group-hover\\:text-pink-lightest {\n    color: #ffebef;\n}\n.lg\\:hover\\:text-transparent:hover {\n    color: transparent;\n}\n.lg\\:hover\\:text-modal:hover {\n    color: rgba(0, 0, 0, .4);\n}\n.lg\\:hover\\:text-google:hover {\n    color: #dc5b5b;\n}\n.lg\\:hover\\:text-google-dark:hover {\n    color: #da5050;\n}\n.lg\\:hover\\:text-facebook:hover {\n    color: #3b5998;\n}\n.lg\\:hover\\:text-facebook-dark:hover {\n    color: #37548f;\n}\n.lg\\:hover\\:text-primary:hover {\n    color: #2196f3;\n}\n.lg\\:hover\\:text-primary-dark:hover {\n    color: #3b5998;\n}\n.lg\\:hover\\:text-footer:hover {\n    color: #1976d2;\n}\n.lg\\:hover\\:text-black:hover {\n    color: #22292f;\n}\n.lg\\:hover\\:text-grey-darkest:hover {\n    color: #3d4852;\n}\n.lg\\:hover\\:text-grey-darker:hover {\n    color: #606f7b;\n}\n.lg\\:hover\\:text-grey-dark:hover {\n    color: #8795a1;\n}\n.lg\\:hover\\:text-grey:hover {\n    color: #b8c2cc;\n}\n.lg\\:hover\\:text-grey-light:hover {\n    color: #dae1e7;\n}\n.lg\\:hover\\:text-grey-lighter:hover {\n    color: #f1f5f8;\n}\n.lg\\:hover\\:text-grey-lightest:hover {\n    color: #f8fafc;\n}\n.lg\\:hover\\:text-white:hover {\n    color: #fff;\n}\n.lg\\:hover\\:text-whiter:hover {\n    color: rgba(255, 255, 255, .6);\n}\n.lg\\:hover\\:text-red-darkest:hover {\n    color: #3b0d0c;\n}\n.lg\\:hover\\:text-red-darker:hover {\n    color: #621b18;\n}\n.lg\\:hover\\:text-red-dark:hover {\n    color: #cc1f1a;\n}\n.lg\\:hover\\:text-red:hover {\n    color: #e3342f;\n}\n.lg\\:hover\\:text-red-light:hover {\n    color: #ef5753;\n}\n.lg\\:hover\\:text-red-lighter:hover {\n    color: #f9acaa;\n}\n.lg\\:hover\\:text-red-lightest:hover {\n    color: #fcebea;\n}\n.lg\\:hover\\:text-orange-darkest:hover {\n    color: #462a16;\n}\n.lg\\:hover\\:text-orange-darker:hover {\n    color: #613b1f;\n}\n.lg\\:hover\\:text-orange-dark:hover {\n    color: #de751f;\n}\n.lg\\:hover\\:text-orange:hover {\n    color: #f6993f;\n}\n.lg\\:hover\\:text-orange-light:hover {\n    color: #faad63;\n}\n.lg\\:hover\\:text-orange-lighter:hover {\n    color: #fcd9b6;\n}\n.lg\\:hover\\:text-orange-lightest:hover {\n    color: #fff5eb;\n}\n.lg\\:hover\\:text-yellow-darkest:hover {\n    color: #453411;\n}\n.lg\\:hover\\:text-yellow-darker:hover {\n    color: #684f1d;\n}\n.lg\\:hover\\:text-yellow-dark:hover {\n    color: #f2d024;\n}\n.lg\\:hover\\:text-yellow:hover {\n    color: #ffed4a;\n}\n.lg\\:hover\\:text-yellow-light:hover {\n    color: #fff382;\n}\n.lg\\:hover\\:text-yellow-lighter:hover {\n    color: #fff9c2;\n}\n.lg\\:hover\\:text-yellow-lightest:hover {\n    color: #fcfbeb;\n}\n.lg\\:hover\\:text-green-darkest:hover {\n    color: #0f2f21;\n}\n.lg\\:hover\\:text-green-darker:hover {\n    color: #1a4731;\n}\n.lg\\:hover\\:text-green-dark:hover {\n    color: #1f9d55;\n}\n.lg\\:hover\\:text-green:hover {\n    color: #38c172;\n}\n.lg\\:hover\\:text-green-light:hover {\n    color: #51d88a;\n}\n.lg\\:hover\\:text-green-lighter:hover {\n    color: #a2f5bf;\n}\n.lg\\:hover\\:text-green-lightest:hover {\n    color: #e3fcec;\n}\n.lg\\:hover\\:text-teal-darkest:hover {\n    color: #0d3331;\n}\n.lg\\:hover\\:text-teal-darker:hover {\n    color: #20504f;\n}\n.lg\\:hover\\:text-teal-dark:hover {\n    color: #009480;\n}\n.lg\\:hover\\:text-teal:hover {\n    color: #00ae98;\n}\n.lg\\:hover\\:text-teal-light:hover {\n    color: #64d5ca;\n}\n.lg\\:hover\\:text-teal-lighter:hover {\n    color: #a0f0ed;\n}\n.lg\\:hover\\:text-teal-lightest:hover {\n    color: #e8fffe;\n}\n.lg\\:hover\\:text-blue-darkest:hover {\n    color: #12283a;\n}\n.lg\\:hover\\:text-blue-darker:hover {\n    color: #2e6da2;\n}\n.lg\\:hover\\:text-blue-dark:hover {\n    color: #2779bd;\n}\n.lg\\:hover\\:text-blue:hover {\n    color: #3490dc;\n}\n.lg\\:hover\\:text-blue-light:hover {\n    color: #6cb2eb;\n}\n.lg\\:hover\\:text-blue-lighter:hover {\n    color: #bcdefa;\n}\n.lg\\:hover\\:text-blue-lightest:hover {\n    color: #eff8ff;\n}\n.lg\\:hover\\:text-indigo-darkest:hover {\n    color: #191e38;\n}\n.lg\\:hover\\:text-indigo-darker:hover {\n    color: #2f365f;\n}\n.lg\\:hover\\:text-indigo-dark:hover {\n    color: #5661b3;\n}\n.lg\\:hover\\:text-indigo:hover {\n    color: #6574cd;\n}\n.lg\\:hover\\:text-indigo-light:hover {\n    color: #7886d7;\n}\n.lg\\:hover\\:text-indigo-lighter:hover {\n    color: #b2b7ff;\n}\n.lg\\:hover\\:text-indigo-lightest:hover {\n    color: #e6e8ff;\n}\n.lg\\:hover\\:text-purple-darkest:hover {\n    color: #21183c;\n}\n.lg\\:hover\\:text-purple-darker:hover {\n    color: #382b5f;\n}\n.lg\\:hover\\:text-purple-dark:hover {\n    color: #794acf;\n}\n.lg\\:hover\\:text-purple:hover {\n    color: #9561e2;\n}\n.lg\\:hover\\:text-purple-light:hover {\n    color: #a779e9;\n}\n.lg\\:hover\\:text-purple-lighter:hover {\n    color: #d6bbfc;\n}\n.lg\\:hover\\:text-purple-lightest:hover {\n    color: #f3ebff;\n}\n.lg\\:hover\\:text-pink-darkest:hover {\n    color: #451225;\n}\n.lg\\:hover\\:text-pink-darker:hover {\n    color: #6f213f;\n}\n.lg\\:hover\\:text-pink-dark:hover {\n    color: #eb5286;\n}\n.lg\\:hover\\:text-pink:hover {\n    color: #f66d9b;\n}\n.lg\\:hover\\:text-pink-light:hover {\n    color: #fa7ea8;\n}\n.lg\\:hover\\:text-pink-lighter:hover {\n    color: #ffbbca;\n}\n.lg\\:hover\\:text-pink-lightest:hover {\n    color: #ffebef;\n}\n.lg\\:text-xs {\n    font-size: .75rem;\n}\n.lg\\:text-sm {\n    font-size: .875rem;\n}\n.lg\\:text-base {\n    font-size: 1rem;\n}\n.lg\\:text-lg {\n    font-size: 1.125rem;\n}\n.lg\\:text-xl {\n    font-size: 1.25rem;\n}\n.lg\\:text-2xl {\n    font-size: 1.5rem;\n}\n.lg\\:text-3xl {\n    font-size: 1.875rem;\n}\n.lg\\:text-4xl {\n    font-size: 2.25rem;\n}\n.lg\\:text-5xl {\n    font-size: 3rem;\n}\n.lg\\:italic {\n    font-style: italic;\n}\n.lg\\:roman {\n    font-style: normal;\n}\n.lg\\:uppercase {\n    text-transform: uppercase;\n}\n.lg\\:lowercase {\n    text-transform: lowercase;\n}\n.lg\\:capitalize {\n    text-transform: capitalize;\n}\n.lg\\:normal-case {\n    text-transform: none;\n}\n.lg\\:underline {\n    text-decoration: underline;\n}\n.lg\\:line-through {\n    text-decoration: line-through;\n}\n.lg\\:no-underline {\n    text-decoration: none;\n}\n.lg\\:antialiased {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.lg\\:subpixel-antialiased {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n}\n.lg\\:hover\\:italic:hover {\n    font-style: italic;\n}\n.lg\\:hover\\:roman:hover {\n    font-style: normal;\n}\n.lg\\:hover\\:uppercase:hover {\n    text-transform: uppercase;\n}\n.lg\\:hover\\:lowercase:hover {\n    text-transform: lowercase;\n}\n.lg\\:hover\\:capitalize:hover {\n    text-transform: capitalize;\n}\n.lg\\:hover\\:normal-case:hover {\n    text-transform: none;\n}\n.lg\\:hover\\:underline:hover {\n    text-decoration: underline;\n}\n.lg\\:hover\\:line-through:hover {\n    text-decoration: line-through;\n}\n.lg\\:hover\\:no-underline:hover {\n    text-decoration: none;\n}\n.lg\\:hover\\:antialiased:hover {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.lg\\:hover\\:subpixel-antialiased:hover {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n}\n.lg\\:tracking-tight {\n    letter-spacing: -0.05em;\n}\n.lg\\:tracking-normal {\n    letter-spacing: 0;\n}\n.lg\\:tracking-wide {\n    letter-spacing: .05em;\n}\n.lg\\:select-none {\n    user-select: none;\n}\n.lg\\:select-text {\n    user-select: text;\n}\n.lg\\:align-baseline {\n    vertical-align: baseline;\n}\n.lg\\:align-top {\n    vertical-align: top;\n}\n.lg\\:align-middle {\n    vertical-align: middle;\n}\n.lg\\:align-bottom {\n    vertical-align: bottom;\n}\n.lg\\:align-text-top {\n    vertical-align: text-top;\n}\n.lg\\:align-text-bottom {\n    vertical-align: text-bottom;\n}\n.lg\\:visible {\n    visibility: visible;\n}\n.lg\\:invisible {\n    visibility: hidden;\n}\n.lg\\:whitespace-normal {\n    white-space: normal;\n}\n.lg\\:whitespace-no-wrap {\n    white-space: nowrap;\n}\n.lg\\:whitespace-pre {\n    white-space: pre;\n}\n.lg\\:whitespace-pre-line {\n    white-space: pre-line;\n}\n.lg\\:whitespace-pre-wrap {\n    white-space: pre-wrap;\n}\n.lg\\:break-words {\n    word-wrap: break-word;\n}\n.lg\\:break-normal {\n    word-wrap: normal;\n}\n.lg\\:truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.lg\\:w-1 {\n    width: .25rem;\n}\n.lg\\:w-2 {\n    width: .5rem;\n}\n.lg\\:w-3 {\n    width: .75rem;\n}\n.lg\\:w-4 {\n    width: 1rem;\n}\n.lg\\:w-6 {\n    width: 1.5rem;\n}\n.lg\\:w-8 {\n    width: 2rem;\n}\n.lg\\:w-10 {\n    width: 2.5rem;\n}\n.lg\\:w-12 {\n    width: 3rem;\n}\n.lg\\:w-16 {\n    width: 4rem;\n}\n.lg\\:w-24 {\n    width: 6rem;\n}\n.lg\\:w-32 {\n    width: 8rem;\n}\n.lg\\:w-48 {\n    width: 12rem;\n}\n.lg\\:w-64 {\n    width: 16rem;\n}\n.lg\\:w-auto {\n    width: auto;\n}\n.lg\\:w-px {\n    width: 1px;\n}\n.lg\\:w-1\\/2 {\n    width: 50%;\n}\n.lg\\:w-1\\/3 {\n    width: 33.33333%;\n}\n.lg\\:w-2\\/3 {\n    width: 66.66667%;\n}\n.lg\\:w-1\\/4 {\n    width: 25%;\n}\n.lg\\:w-3\\/4 {\n    width: 75%;\n}\n.lg\\:w-1\\/5 {\n    width: 20%;\n}\n.lg\\:w-2\\/5 {\n    width: 40%;\n}\n.lg\\:w-3\\/5 {\n    width: 60%;\n}\n.lg\\:w-4\\/5 {\n    width: 80%;\n}\n.lg\\:w-1\\/6 {\n    width: 16.66667%;\n}\n.lg\\:w-5\\/6 {\n    width: 83.33333%;\n}\n.lg\\:w-full {\n    width: 100%;\n}\n.lg\\:w-screen {\n    width: 100vw;\n}\n.lg\\:z-0 {\n    z-index: 0;\n}\n.lg\\:z-10 {\n    z-index: 10;\n}\n.lg\\:z-20 {\n    z-index: 20;\n}\n.lg\\:z-30 {\n    z-index: 30;\n}\n.lg\\:z-40 {\n    z-index: 40;\n}\n.lg\\:z-50 {\n    z-index: 50;\n}\n.lg\\:z-auto {\n    z-index: auto;\n}\n.lg\\:z-max {\n    z-index: 1051 !important;\n}\n}\n@media (min-width: 1200px) {\n.xl\\:list-reset {\n    list-style: none;\n    padding: 0;\n}\n.xl\\:appearance-none {\n    appearance: none;\n}\n.xl\\:bg-fixed {\n    background-attachment: fixed;\n}\n.xl\\:bg-local {\n    background-attachment: local;\n}\n.xl\\:bg-scroll {\n    background-attachment: scroll;\n}\n.xl\\:bg-transparent {\n    background-color: transparent;\n}\n.xl\\:bg-modal {\n    background-color: rgba(0, 0, 0, .4);\n}\n.xl\\:bg-google {\n    background-color: #dc5b5b;\n}\n.xl\\:bg-google-dark {\n    background-color: #da5050;\n}\n.xl\\:bg-facebook {\n    background-color: #3b5998;\n}\n.xl\\:bg-facebook-dark {\n    background-color: #37548f;\n}\n.xl\\:bg-primary {\n    background-color: #2196f3;\n}\n.xl\\:bg-primary-dark {\n    background-color: #3b5998;\n}\n.xl\\:bg-footer {\n    background-color: #1976d2;\n}\n.xl\\:bg-black {\n    background-color: #22292f;\n}\n.xl\\:bg-grey-darkest {\n    background-color: #3d4852;\n}\n.xl\\:bg-grey-darker {\n    background-color: #606f7b;\n}\n.xl\\:bg-grey-dark {\n    background-color: #8795a1;\n}\n.xl\\:bg-grey {\n    background-color: #b8c2cc;\n}\n.xl\\:bg-grey-light {\n    background-color: #dae1e7;\n}\n.xl\\:bg-grey-lighter {\n    background-color: #f1f5f8;\n}\n.xl\\:bg-grey-lightest {\n    background-color: #f8fafc;\n}\n.xl\\:bg-white {\n    background-color: #fff;\n}\n.xl\\:bg-whiter {\n    background-color: rgba(255, 255, 255, .6);\n}\n.xl\\:bg-red-darkest {\n    background-color: #3b0d0c;\n}\n.xl\\:bg-red-darker {\n    background-color: #621b18;\n}\n.xl\\:bg-red-dark {\n    background-color: #cc1f1a;\n}\n.xl\\:bg-red {\n    background-color: #e3342f;\n}\n.xl\\:bg-red-light {\n    background-color: #ef5753;\n}\n.xl\\:bg-red-lighter {\n    background-color: #f9acaa;\n}\n.xl\\:bg-red-lightest {\n    background-color: #fcebea;\n}\n.xl\\:bg-orange-darkest {\n    background-color: #462a16;\n}\n.xl\\:bg-orange-darker {\n    background-color: #613b1f;\n}\n.xl\\:bg-orange-dark {\n    background-color: #de751f;\n}\n.xl\\:bg-orange {\n    background-color: #f6993f;\n}\n.xl\\:bg-orange-light {\n    background-color: #faad63;\n}\n.xl\\:bg-orange-lighter {\n    background-color: #fcd9b6;\n}\n.xl\\:bg-orange-lightest {\n    background-color: #fff5eb;\n}\n.xl\\:bg-yellow-darkest {\n    background-color: #453411;\n}\n.xl\\:bg-yellow-darker {\n    background-color: #684f1d;\n}\n.xl\\:bg-yellow-dark {\n    background-color: #f2d024;\n}\n.xl\\:bg-yellow {\n    background-color: #ffed4a;\n}\n.xl\\:bg-yellow-light {\n    background-color: #fff382;\n}\n.xl\\:bg-yellow-lighter {\n    background-color: #fff9c2;\n}\n.xl\\:bg-yellow-lightest {\n    background-color: #fcfbeb;\n}\n.xl\\:bg-green-darkest {\n    background-color: #0f2f21;\n}\n.xl\\:bg-green-darker {\n    background-color: #1a4731;\n}\n.xl\\:bg-green-dark {\n    background-color: #1f9d55;\n}\n.xl\\:bg-green {\n    background-color: #38c172;\n}\n.xl\\:bg-green-light {\n    background-color: #51d88a;\n}\n.xl\\:bg-green-lighter {\n    background-color: #a2f5bf;\n}\n.xl\\:bg-green-lightest {\n    background-color: #e3fcec;\n}\n.xl\\:bg-teal-darkest {\n    background-color: #0d3331;\n}\n.xl\\:bg-teal-darker {\n    background-color: #20504f;\n}\n.xl\\:bg-teal-dark {\n    background-color: #009480;\n}\n.xl\\:bg-teal {\n    background-color: #00ae98;\n}\n.xl\\:bg-teal-light {\n    background-color: #64d5ca;\n}\n.xl\\:bg-teal-lighter {\n    background-color: #a0f0ed;\n}\n.xl\\:bg-teal-lightest {\n    background-color: #e8fffe;\n}\n.xl\\:bg-blue-darkest {\n    background-color: #12283a;\n}\n.xl\\:bg-blue-darker {\n    background-color: #2e6da2;\n}\n.xl\\:bg-blue-dark {\n    background-color: #2779bd;\n}\n.xl\\:bg-blue {\n    background-color: #3490dc;\n}\n.xl\\:bg-blue-light {\n    background-color: #6cb2eb;\n}\n.xl\\:bg-blue-lighter {\n    background-color: #bcdefa;\n}\n.xl\\:bg-blue-lightest {\n    background-color: #eff8ff;\n}\n.xl\\:bg-indigo-darkest {\n    background-color: #191e38;\n}\n.xl\\:bg-indigo-darker {\n    background-color: #2f365f;\n}\n.xl\\:bg-indigo-dark {\n    background-color: #5661b3;\n}\n.xl\\:bg-indigo {\n    background-color: #6574cd;\n}\n.xl\\:bg-indigo-light {\n    background-color: #7886d7;\n}\n.xl\\:bg-indigo-lighter {\n    background-color: #b2b7ff;\n}\n.xl\\:bg-indigo-lightest {\n    background-color: #e6e8ff;\n}\n.xl\\:bg-purple-darkest {\n    background-color: #21183c;\n}\n.xl\\:bg-purple-darker {\n    background-color: #382b5f;\n}\n.xl\\:bg-purple-dark {\n    background-color: #794acf;\n}\n.xl\\:bg-purple {\n    background-color: #9561e2;\n}\n.xl\\:bg-purple-light {\n    background-color: #a779e9;\n}\n.xl\\:bg-purple-lighter {\n    background-color: #d6bbfc;\n}\n.xl\\:bg-purple-lightest {\n    background-color: #f3ebff;\n}\n.xl\\:bg-pink-darkest {\n    background-color: #451225;\n}\n.xl\\:bg-pink-darker {\n    background-color: #6f213f;\n}\n.xl\\:bg-pink-dark {\n    background-color: #eb5286;\n}\n.xl\\:bg-pink {\n    background-color: #f66d9b;\n}\n.xl\\:bg-pink-light {\n    background-color: #fa7ea8;\n}\n.xl\\:bg-pink-lighter {\n    background-color: #ffbbca;\n}\n.xl\\:bg-pink-lightest {\n    background-color: #ffebef;\n}\n.xl\\:group:hover .group-hover\\:bg-transparent {\n    background-color: transparent;\n}\n.xl\\:group:hover .group-hover\\:bg-modal {\n    background-color: rgba(0, 0, 0, .4);\n}\n.xl\\:group:hover .group-hover\\:bg-google {\n    background-color: #dc5b5b;\n}\n.xl\\:group:hover .group-hover\\:bg-google-dark {\n    background-color: #da5050;\n}\n.xl\\:group:hover .group-hover\\:bg-facebook {\n    background-color: #3b5998;\n}\n.xl\\:group:hover .group-hover\\:bg-facebook-dark {\n    background-color: #37548f;\n}\n.xl\\:group:hover .group-hover\\:bg-primary {\n    background-color: #2196f3;\n}\n.xl\\:group:hover .group-hover\\:bg-primary-dark {\n    background-color: #3b5998;\n}\n.xl\\:group:hover .group-hover\\:bg-footer {\n    background-color: #1976d2;\n}\n.xl\\:group:hover .group-hover\\:bg-black {\n    background-color: #22292f;\n}\n.xl\\:group:hover .group-hover\\:bg-grey-darkest {\n    background-color: #3d4852;\n}\n.xl\\:group:hover .group-hover\\:bg-grey-darker {\n    background-color: #606f7b;\n}\n.xl\\:group:hover .group-hover\\:bg-grey-dark {\n    background-color: #8795a1;\n}\n.xl\\:group:hover .group-hover\\:bg-grey {\n    background-color: #b8c2cc;\n}\n.xl\\:group:hover .group-hover\\:bg-grey-light {\n    background-color: #dae1e7;\n}\n.xl\\:group:hover .group-hover\\:bg-grey-lighter {\n    background-color: #f1f5f8;\n}\n.xl\\:group:hover .group-hover\\:bg-grey-lightest {\n    background-color: #f8fafc;\n}\n.xl\\:group:hover .group-hover\\:bg-white {\n    background-color: #fff;\n}\n.xl\\:group:hover .group-hover\\:bg-whiter {\n    background-color: rgba(255, 255, 255, .6);\n}\n.xl\\:group:hover .group-hover\\:bg-red-darkest {\n    background-color: #3b0d0c;\n}\n.xl\\:group:hover .group-hover\\:bg-red-darker {\n    background-color: #621b18;\n}\n.xl\\:group:hover .group-hover\\:bg-red-dark {\n    background-color: #cc1f1a;\n}\n.xl\\:group:hover .group-hover\\:bg-red {\n    background-color: #e3342f;\n}\n.xl\\:group:hover .group-hover\\:bg-red-light {\n    background-color: #ef5753;\n}\n.xl\\:group:hover .group-hover\\:bg-red-lighter {\n    background-color: #f9acaa;\n}\n.xl\\:group:hover .group-hover\\:bg-red-lightest {\n    background-color: #fcebea;\n}\n.xl\\:group:hover .group-hover\\:bg-orange-darkest {\n    background-color: #462a16;\n}\n.xl\\:group:hover .group-hover\\:bg-orange-darker {\n    background-color: #613b1f;\n}\n.xl\\:group:hover .group-hover\\:bg-orange-dark {\n    background-color: #de751f;\n}\n.xl\\:group:hover .group-hover\\:bg-orange {\n    background-color: #f6993f;\n}\n.xl\\:group:hover .group-hover\\:bg-orange-light {\n    background-color: #faad63;\n}\n.xl\\:group:hover .group-hover\\:bg-orange-lighter {\n    background-color: #fcd9b6;\n}\n.xl\\:group:hover .group-hover\\:bg-orange-lightest {\n    background-color: #fff5eb;\n}\n.xl\\:group:hover .group-hover\\:bg-yellow-darkest {\n    background-color: #453411;\n}\n.xl\\:group:hover .group-hover\\:bg-yellow-darker {\n    background-color: #684f1d;\n}\n.xl\\:group:hover .group-hover\\:bg-yellow-dark {\n    background-color: #f2d024;\n}\n.xl\\:group:hover .group-hover\\:bg-yellow {\n    background-color: #ffed4a;\n}\n.xl\\:group:hover .group-hover\\:bg-yellow-light {\n    background-color: #fff382;\n}\n.xl\\:group:hover .group-hover\\:bg-yellow-lighter {\n    background-color: #fff9c2;\n}\n.xl\\:group:hover .group-hover\\:bg-yellow-lightest {\n    background-color: #fcfbeb;\n}\n.xl\\:group:hover .group-hover\\:bg-green-darkest {\n    background-color: #0f2f21;\n}\n.xl\\:group:hover .group-hover\\:bg-green-darker {\n    background-color: #1a4731;\n}\n.xl\\:group:hover .group-hover\\:bg-green-dark {\n    background-color: #1f9d55;\n}\n.xl\\:group:hover .group-hover\\:bg-green {\n    background-color: #38c172;\n}\n.xl\\:group:hover .group-hover\\:bg-green-light {\n    background-color: #51d88a;\n}\n.xl\\:group:hover .group-hover\\:bg-green-lighter {\n    background-color: #a2f5bf;\n}\n.xl\\:group:hover .group-hover\\:bg-green-lightest {\n    background-color: #e3fcec;\n}\n.xl\\:group:hover .group-hover\\:bg-teal-darkest {\n    background-color: #0d3331;\n}\n.xl\\:group:hover .group-hover\\:bg-teal-darker {\n    background-color: #20504f;\n}\n.xl\\:group:hover .group-hover\\:bg-teal-dark {\n    background-color: #009480;\n}\n.xl\\:group:hover .group-hover\\:bg-teal {\n    background-color: #00ae98;\n}\n.xl\\:group:hover .group-hover\\:bg-teal-light {\n    background-color: #64d5ca;\n}\n.xl\\:group:hover .group-hover\\:bg-teal-lighter {\n    background-color: #a0f0ed;\n}\n.xl\\:group:hover .group-hover\\:bg-teal-lightest {\n    background-color: #e8fffe;\n}\n.xl\\:group:hover .group-hover\\:bg-blue-darkest {\n    background-color: #12283a;\n}\n.xl\\:group:hover .group-hover\\:bg-blue-darker {\n    background-color: #2e6da2;\n}\n.xl\\:group:hover .group-hover\\:bg-blue-dark {\n    background-color: #2779bd;\n}\n.xl\\:group:hover .group-hover\\:bg-blue {\n    background-color: #3490dc;\n}\n.xl\\:group:hover .group-hover\\:bg-blue-light {\n    background-color: #6cb2eb;\n}\n.xl\\:group:hover .group-hover\\:bg-blue-lighter {\n    background-color: #bcdefa;\n}\n.xl\\:group:hover .group-hover\\:bg-blue-lightest {\n    background-color: #eff8ff;\n}\n.xl\\:group:hover .group-hover\\:bg-indigo-darkest {\n    background-color: #191e38;\n}\n.xl\\:group:hover .group-hover\\:bg-indigo-darker {\n    background-color: #2f365f;\n}\n.xl\\:group:hover .group-hover\\:bg-indigo-dark {\n    background-color: #5661b3;\n}\n.xl\\:group:hover .group-hover\\:bg-indigo {\n    background-color: #6574cd;\n}\n.xl\\:group:hover .group-hover\\:bg-indigo-light {\n    background-color: #7886d7;\n}\n.xl\\:group:hover .group-hover\\:bg-indigo-lighter {\n    background-color: #b2b7ff;\n}\n.xl\\:group:hover .group-hover\\:bg-indigo-lightest {\n    background-color: #e6e8ff;\n}\n.xl\\:group:hover .group-hover\\:bg-purple-darkest {\n    background-color: #21183c;\n}\n.xl\\:group:hover .group-hover\\:bg-purple-darker {\n    background-color: #382b5f;\n}\n.xl\\:group:hover .group-hover\\:bg-purple-dark {\n    background-color: #794acf;\n}\n.xl\\:group:hover .group-hover\\:bg-purple {\n    background-color: #9561e2;\n}\n.xl\\:group:hover .group-hover\\:bg-purple-light {\n    background-color: #a779e9;\n}\n.xl\\:group:hover .group-hover\\:bg-purple-lighter {\n    background-color: #d6bbfc;\n}\n.xl\\:group:hover .group-hover\\:bg-purple-lightest {\n    background-color: #f3ebff;\n}\n.xl\\:group:hover .group-hover\\:bg-pink-darkest {\n    background-color: #451225;\n}\n.xl\\:group:hover .group-hover\\:bg-pink-darker {\n    background-color: #6f213f;\n}\n.xl\\:group:hover .group-hover\\:bg-pink-dark {\n    background-color: #eb5286;\n}\n.xl\\:group:hover .group-hover\\:bg-pink {\n    background-color: #f66d9b;\n}\n.xl\\:group:hover .group-hover\\:bg-pink-light {\n    background-color: #fa7ea8;\n}\n.xl\\:group:hover .group-hover\\:bg-pink-lighter {\n    background-color: #ffbbca;\n}\n.xl\\:group:hover .group-hover\\:bg-pink-lightest {\n    background-color: #ffebef;\n}\n.xl\\:hover\\:bg-transparent:hover {\n    background-color: transparent;\n}\n.xl\\:hover\\:bg-modal:hover {\n    background-color: rgba(0, 0, 0, .4);\n}\n.xl\\:hover\\:bg-google:hover {\n    background-color: #dc5b5b;\n}\n.xl\\:hover\\:bg-google-dark:hover {\n    background-color: #da5050;\n}\n.xl\\:hover\\:bg-facebook:hover {\n    background-color: #3b5998;\n}\n.xl\\:hover\\:bg-facebook-dark:hover {\n    background-color: #37548f;\n}\n.xl\\:hover\\:bg-primary:hover {\n    background-color: #2196f3;\n}\n.xl\\:hover\\:bg-primary-dark:hover {\n    background-color: #3b5998;\n}\n.xl\\:hover\\:bg-footer:hover {\n    background-color: #1976d2;\n}\n.xl\\:hover\\:bg-black:hover {\n    background-color: #22292f;\n}\n.xl\\:hover\\:bg-grey-darkest:hover {\n    background-color: #3d4852;\n}\n.xl\\:hover\\:bg-grey-darker:hover {\n    background-color: #606f7b;\n}\n.xl\\:hover\\:bg-grey-dark:hover {\n    background-color: #8795a1;\n}\n.xl\\:hover\\:bg-grey:hover {\n    background-color: #b8c2cc;\n}\n.xl\\:hover\\:bg-grey-light:hover {\n    background-color: #dae1e7;\n}\n.xl\\:hover\\:bg-grey-lighter:hover {\n    background-color: #f1f5f8;\n}\n.xl\\:hover\\:bg-grey-lightest:hover {\n    background-color: #f8fafc;\n}\n.xl\\:hover\\:bg-white:hover {\n    background-color: #fff;\n}\n.xl\\:hover\\:bg-whiter:hover {\n    background-color: rgba(255, 255, 255, .6);\n}\n.xl\\:hover\\:bg-red-darkest:hover {\n    background-color: #3b0d0c;\n}\n.xl\\:hover\\:bg-red-darker:hover {\n    background-color: #621b18;\n}\n.xl\\:hover\\:bg-red-dark:hover {\n    background-color: #cc1f1a;\n}\n.xl\\:hover\\:bg-red:hover {\n    background-color: #e3342f;\n}\n.xl\\:hover\\:bg-red-light:hover {\n    background-color: #ef5753;\n}\n.xl\\:hover\\:bg-red-lighter:hover {\n    background-color: #f9acaa;\n}\n.xl\\:hover\\:bg-red-lightest:hover {\n    background-color: #fcebea;\n}\n.xl\\:hover\\:bg-orange-darkest:hover {\n    background-color: #462a16;\n}\n.xl\\:hover\\:bg-orange-darker:hover {\n    background-color: #613b1f;\n}\n.xl\\:hover\\:bg-orange-dark:hover {\n    background-color: #de751f;\n}\n.xl\\:hover\\:bg-orange:hover {\n    background-color: #f6993f;\n}\n.xl\\:hover\\:bg-orange-light:hover {\n    background-color: #faad63;\n}\n.xl\\:hover\\:bg-orange-lighter:hover {\n    background-color: #fcd9b6;\n}\n.xl\\:hover\\:bg-orange-lightest:hover {\n    background-color: #fff5eb;\n}\n.xl\\:hover\\:bg-yellow-darkest:hover {\n    background-color: #453411;\n}\n.xl\\:hover\\:bg-yellow-darker:hover {\n    background-color: #684f1d;\n}\n.xl\\:hover\\:bg-yellow-dark:hover {\n    background-color: #f2d024;\n}\n.xl\\:hover\\:bg-yellow:hover {\n    background-color: #ffed4a;\n}\n.xl\\:hover\\:bg-yellow-light:hover {\n    background-color: #fff382;\n}\n.xl\\:hover\\:bg-yellow-lighter:hover {\n    background-color: #fff9c2;\n}\n.xl\\:hover\\:bg-yellow-lightest:hover {\n    background-color: #fcfbeb;\n}\n.xl\\:hover\\:bg-green-darkest:hover {\n    background-color: #0f2f21;\n}\n.xl\\:hover\\:bg-green-darker:hover {\n    background-color: #1a4731;\n}\n.xl\\:hover\\:bg-green-dark:hover {\n    background-color: #1f9d55;\n}\n.xl\\:hover\\:bg-green:hover {\n    background-color: #38c172;\n}\n.xl\\:hover\\:bg-green-light:hover {\n    background-color: #51d88a;\n}\n.xl\\:hover\\:bg-green-lighter:hover {\n    background-color: #a2f5bf;\n}\n.xl\\:hover\\:bg-green-lightest:hover {\n    background-color: #e3fcec;\n}\n.xl\\:hover\\:bg-teal-darkest:hover {\n    background-color: #0d3331;\n}\n.xl\\:hover\\:bg-teal-darker:hover {\n    background-color: #20504f;\n}\n.xl\\:hover\\:bg-teal-dark:hover {\n    background-color: #009480;\n}\n.xl\\:hover\\:bg-teal:hover {\n    background-color: #00ae98;\n}\n.xl\\:hover\\:bg-teal-light:hover {\n    background-color: #64d5ca;\n}\n.xl\\:hover\\:bg-teal-lighter:hover {\n    background-color: #a0f0ed;\n}\n.xl\\:hover\\:bg-teal-lightest:hover {\n    background-color: #e8fffe;\n}\n.xl\\:hover\\:bg-blue-darkest:hover {\n    background-color: #12283a;\n}\n.xl\\:hover\\:bg-blue-darker:hover {\n    background-color: #2e6da2;\n}\n.xl\\:hover\\:bg-blue-dark:hover {\n    background-color: #2779bd;\n}\n.xl\\:hover\\:bg-blue:hover {\n    background-color: #3490dc;\n}\n.xl\\:hover\\:bg-blue-light:hover {\n    background-color: #6cb2eb;\n}\n.xl\\:hover\\:bg-blue-lighter:hover {\n    background-color: #bcdefa;\n}\n.xl\\:hover\\:bg-blue-lightest:hover {\n    background-color: #eff8ff;\n}\n.xl\\:hover\\:bg-indigo-darkest:hover {\n    background-color: #191e38;\n}\n.xl\\:hover\\:bg-indigo-darker:hover {\n    background-color: #2f365f;\n}\n.xl\\:hover\\:bg-indigo-dark:hover {\n    background-color: #5661b3;\n}\n.xl\\:hover\\:bg-indigo:hover {\n    background-color: #6574cd;\n}\n.xl\\:hover\\:bg-indigo-light:hover {\n    background-color: #7886d7;\n}\n.xl\\:hover\\:bg-indigo-lighter:hover {\n    background-color: #b2b7ff;\n}\n.xl\\:hover\\:bg-indigo-lightest:hover {\n    background-color: #e6e8ff;\n}\n.xl\\:hover\\:bg-purple-darkest:hover {\n    background-color: #21183c;\n}\n.xl\\:hover\\:bg-purple-darker:hover {\n    background-color: #382b5f;\n}\n.xl\\:hover\\:bg-purple-dark:hover {\n    background-color: #794acf;\n}\n.xl\\:hover\\:bg-purple:hover {\n    background-color: #9561e2;\n}\n.xl\\:hover\\:bg-purple-light:hover {\n    background-color: #a779e9;\n}\n.xl\\:hover\\:bg-purple-lighter:hover {\n    background-color: #d6bbfc;\n}\n.xl\\:hover\\:bg-purple-lightest:hover {\n    background-color: #f3ebff;\n}\n.xl\\:hover\\:bg-pink-darkest:hover {\n    background-color: #451225;\n}\n.xl\\:hover\\:bg-pink-darker:hover {\n    background-color: #6f213f;\n}\n.xl\\:hover\\:bg-pink-dark:hover {\n    background-color: #eb5286;\n}\n.xl\\:hover\\:bg-pink:hover {\n    background-color: #f66d9b;\n}\n.xl\\:hover\\:bg-pink-light:hover {\n    background-color: #fa7ea8;\n}\n.xl\\:hover\\:bg-pink-lighter:hover {\n    background-color: #ffbbca;\n}\n.xl\\:hover\\:bg-pink-lightest:hover {\n    background-color: #ffebef;\n}\n.xl\\:bg-bottom {\n    background-position: bottom;\n}\n.xl\\:bg-center {\n    background-position: center;\n}\n.xl\\:bg-left {\n    background-position: left;\n}\n.xl\\:bg-left-bottom {\n    background-position: left bottom;\n}\n.xl\\:bg-left-top {\n    background-position: left top;\n}\n.xl\\:bg-right {\n    background-position: right;\n}\n.xl\\:bg-right-bottom {\n    background-position: right bottom;\n}\n.xl\\:bg-right-top {\n    background-position: right top;\n}\n.xl\\:bg-top {\n    background-position: top;\n}\n.xl\\:bg-repeat {\n    background-repeat: repeat;\n}\n.xl\\:bg-no-repeat {\n    background-repeat: no-repeat;\n}\n.xl\\:bg-repeat-x {\n    background-repeat: repeat-x;\n}\n.xl\\:bg-repeat-y {\n    background-repeat: repeat-y;\n}\n.xl\\:bg-auto {\n    background-size: auto;\n}\n.xl\\:bg-cover {\n    background-size: cover;\n}\n.xl\\:bg-contain {\n    background-size: contain;\n}\n.xl\\:border-transparent {\n    border-color: transparent;\n}\n.xl\\:border-modal {\n    border-color: rgba(0, 0, 0, .4);\n}\n.xl\\:border-google {\n    border-color: #dc5b5b;\n}\n.xl\\:border-google-dark {\n    border-color: #da5050;\n}\n.xl\\:border-facebook {\n    border-color: #3b5998;\n}\n.xl\\:border-facebook-dark {\n    border-color: #37548f;\n}\n.xl\\:border-primary {\n    border-color: #2196f3;\n}\n.xl\\:border-primary-dark {\n    border-color: #3b5998;\n}\n.xl\\:border-footer {\n    border-color: #1976d2;\n}\n.xl\\:border-black {\n    border-color: #22292f;\n}\n.xl\\:border-grey-darkest {\n    border-color: #3d4852;\n}\n.xl\\:border-grey-darker {\n    border-color: #606f7b;\n}\n.xl\\:border-grey-dark {\n    border-color: #8795a1;\n}\n.xl\\:border-grey {\n    border-color: #b8c2cc;\n}\n.xl\\:border-grey-light {\n    border-color: #dae1e7;\n}\n.xl\\:border-grey-lighter {\n    border-color: #f1f5f8;\n}\n.xl\\:border-grey-lightest {\n    border-color: #f8fafc;\n}\n.xl\\:border-white {\n    border-color: #fff;\n}\n.xl\\:border-whiter {\n    border-color: rgba(255, 255, 255, .6);\n}\n.xl\\:border-red-darkest {\n    border-color: #3b0d0c;\n}\n.xl\\:border-red-darker {\n    border-color: #621b18;\n}\n.xl\\:border-red-dark {\n    border-color: #cc1f1a;\n}\n.xl\\:border-red {\n    border-color: #e3342f;\n}\n.xl\\:border-red-light {\n    border-color: #ef5753;\n}\n.xl\\:border-red-lighter {\n    border-color: #f9acaa;\n}\n.xl\\:border-red-lightest {\n    border-color: #fcebea;\n}\n.xl\\:border-orange-darkest {\n    border-color: #462a16;\n}\n.xl\\:border-orange-darker {\n    border-color: #613b1f;\n}\n.xl\\:border-orange-dark {\n    border-color: #de751f;\n}\n.xl\\:border-orange {\n    border-color: #f6993f;\n}\n.xl\\:border-orange-light {\n    border-color: #faad63;\n}\n.xl\\:border-orange-lighter {\n    border-color: #fcd9b6;\n}\n.xl\\:border-orange-lightest {\n    border-color: #fff5eb;\n}\n.xl\\:border-yellow-darkest {\n    border-color: #453411;\n}\n.xl\\:border-yellow-darker {\n    border-color: #684f1d;\n}\n.xl\\:border-yellow-dark {\n    border-color: #f2d024;\n}\n.xl\\:border-yellow {\n    border-color: #ffed4a;\n}\n.xl\\:border-yellow-light {\n    border-color: #fff382;\n}\n.xl\\:border-yellow-lighter {\n    border-color: #fff9c2;\n}\n.xl\\:border-yellow-lightest {\n    border-color: #fcfbeb;\n}\n.xl\\:border-green-darkest {\n    border-color: #0f2f21;\n}\n.xl\\:border-green-darker {\n    border-color: #1a4731;\n}\n.xl\\:border-green-dark {\n    border-color: #1f9d55;\n}\n.xl\\:border-green {\n    border-color: #38c172;\n}\n.xl\\:border-green-light {\n    border-color: #51d88a;\n}\n.xl\\:border-green-lighter {\n    border-color: #a2f5bf;\n}\n.xl\\:border-green-lightest {\n    border-color: #e3fcec;\n}\n.xl\\:border-teal-darkest {\n    border-color: #0d3331;\n}\n.xl\\:border-teal-darker {\n    border-color: #20504f;\n}\n.xl\\:border-teal-dark {\n    border-color: #009480;\n}\n.xl\\:border-teal {\n    border-color: #00ae98;\n}\n.xl\\:border-teal-light {\n    border-color: #64d5ca;\n}\n.xl\\:border-teal-lighter {\n    border-color: #a0f0ed;\n}\n.xl\\:border-teal-lightest {\n    border-color: #e8fffe;\n}\n.xl\\:border-blue-darkest {\n    border-color: #12283a;\n}\n.xl\\:border-blue-darker {\n    border-color: #2e6da2;\n}\n.xl\\:border-blue-dark {\n    border-color: #2779bd;\n}\n.xl\\:border-blue {\n    border-color: #3490dc;\n}\n.xl\\:border-blue-light {\n    border-color: #6cb2eb;\n}\n.xl\\:border-blue-lighter {\n    border-color: #bcdefa;\n}\n.xl\\:border-blue-lightest {\n    border-color: #eff8ff;\n}\n.xl\\:border-indigo-darkest {\n    border-color: #191e38;\n}\n.xl\\:border-indigo-darker {\n    border-color: #2f365f;\n}\n.xl\\:border-indigo-dark {\n    border-color: #5661b3;\n}\n.xl\\:border-indigo {\n    border-color: #6574cd;\n}\n.xl\\:border-indigo-light {\n    border-color: #7886d7;\n}\n.xl\\:border-indigo-lighter {\n    border-color: #b2b7ff;\n}\n.xl\\:border-indigo-lightest {\n    border-color: #e6e8ff;\n}\n.xl\\:border-purple-darkest {\n    border-color: #21183c;\n}\n.xl\\:border-purple-darker {\n    border-color: #382b5f;\n}\n.xl\\:border-purple-dark {\n    border-color: #794acf;\n}\n.xl\\:border-purple {\n    border-color: #9561e2;\n}\n.xl\\:border-purple-light {\n    border-color: #a779e9;\n}\n.xl\\:border-purple-lighter {\n    border-color: #d6bbfc;\n}\n.xl\\:border-purple-lightest {\n    border-color: #f3ebff;\n}\n.xl\\:border-pink-darkest {\n    border-color: #451225;\n}\n.xl\\:border-pink-darker {\n    border-color: #6f213f;\n}\n.xl\\:border-pink-dark {\n    border-color: #eb5286;\n}\n.xl\\:border-pink {\n    border-color: #f66d9b;\n}\n.xl\\:border-pink-light {\n    border-color: #fa7ea8;\n}\n.xl\\:border-pink-lighter {\n    border-color: #ffbbca;\n}\n.xl\\:border-pink-lightest {\n    border-color: #ffebef;\n}\n.xl\\:hover\\:border-transparent:hover {\n    border-color: transparent;\n}\n.xl\\:hover\\:border-modal:hover {\n    border-color: rgba(0, 0, 0, .4);\n}\n.xl\\:hover\\:border-google:hover {\n    border-color: #dc5b5b;\n}\n.xl\\:hover\\:border-google-dark:hover {\n    border-color: #da5050;\n}\n.xl\\:hover\\:border-facebook:hover {\n    border-color: #3b5998;\n}\n.xl\\:hover\\:border-facebook-dark:hover {\n    border-color: #37548f;\n}\n.xl\\:hover\\:border-primary:hover {\n    border-color: #2196f3;\n}\n.xl\\:hover\\:border-primary-dark:hover {\n    border-color: #3b5998;\n}\n.xl\\:hover\\:border-footer:hover {\n    border-color: #1976d2;\n}\n.xl\\:hover\\:border-black:hover {\n    border-color: #22292f;\n}\n.xl\\:hover\\:border-grey-darkest:hover {\n    border-color: #3d4852;\n}\n.xl\\:hover\\:border-grey-darker:hover {\n    border-color: #606f7b;\n}\n.xl\\:hover\\:border-grey-dark:hover {\n    border-color: #8795a1;\n}\n.xl\\:hover\\:border-grey:hover {\n    border-color: #b8c2cc;\n}\n.xl\\:hover\\:border-grey-light:hover {\n    border-color: #dae1e7;\n}\n.xl\\:hover\\:border-grey-lighter:hover {\n    border-color: #f1f5f8;\n}\n.xl\\:hover\\:border-grey-lightest:hover {\n    border-color: #f8fafc;\n}\n.xl\\:hover\\:border-white:hover {\n    border-color: #fff;\n}\n.xl\\:hover\\:border-whiter:hover {\n    border-color: rgba(255, 255, 255, .6);\n}\n.xl\\:hover\\:border-red-darkest:hover {\n    border-color: #3b0d0c;\n}\n.xl\\:hover\\:border-red-darker:hover {\n    border-color: #621b18;\n}\n.xl\\:hover\\:border-red-dark:hover {\n    border-color: #cc1f1a;\n}\n.xl\\:hover\\:border-red:hover {\n    border-color: #e3342f;\n}\n.xl\\:hover\\:border-red-light:hover {\n    border-color: #ef5753;\n}\n.xl\\:hover\\:border-red-lighter:hover {\n    border-color: #f9acaa;\n}\n.xl\\:hover\\:border-red-lightest:hover {\n    border-color: #fcebea;\n}\n.xl\\:hover\\:border-orange-darkest:hover {\n    border-color: #462a16;\n}\n.xl\\:hover\\:border-orange-darker:hover {\n    border-color: #613b1f;\n}\n.xl\\:hover\\:border-orange-dark:hover {\n    border-color: #de751f;\n}\n.xl\\:hover\\:border-orange:hover {\n    border-color: #f6993f;\n}\n.xl\\:hover\\:border-orange-light:hover {\n    border-color: #faad63;\n}\n.xl\\:hover\\:border-orange-lighter:hover {\n    border-color: #fcd9b6;\n}\n.xl\\:hover\\:border-orange-lightest:hover {\n    border-color: #fff5eb;\n}\n.xl\\:hover\\:border-yellow-darkest:hover {\n    border-color: #453411;\n}\n.xl\\:hover\\:border-yellow-darker:hover {\n    border-color: #684f1d;\n}\n.xl\\:hover\\:border-yellow-dark:hover {\n    border-color: #f2d024;\n}\n.xl\\:hover\\:border-yellow:hover {\n    border-color: #ffed4a;\n}\n.xl\\:hover\\:border-yellow-light:hover {\n    border-color: #fff382;\n}\n.xl\\:hover\\:border-yellow-lighter:hover {\n    border-color: #fff9c2;\n}\n.xl\\:hover\\:border-yellow-lightest:hover {\n    border-color: #fcfbeb;\n}\n.xl\\:hover\\:border-green-darkest:hover {\n    border-color: #0f2f21;\n}\n.xl\\:hover\\:border-green-darker:hover {\n    border-color: #1a4731;\n}\n.xl\\:hover\\:border-green-dark:hover {\n    border-color: #1f9d55;\n}\n.xl\\:hover\\:border-green:hover {\n    border-color: #38c172;\n}\n.xl\\:hover\\:border-green-light:hover {\n    border-color: #51d88a;\n}\n.xl\\:hover\\:border-green-lighter:hover {\n    border-color: #a2f5bf;\n}\n.xl\\:hover\\:border-green-lightest:hover {\n    border-color: #e3fcec;\n}\n.xl\\:hover\\:border-teal-darkest:hover {\n    border-color: #0d3331;\n}\n.xl\\:hover\\:border-teal-darker:hover {\n    border-color: #20504f;\n}\n.xl\\:hover\\:border-teal-dark:hover {\n    border-color: #009480;\n}\n.xl\\:hover\\:border-teal:hover {\n    border-color: #00ae98;\n}\n.xl\\:hover\\:border-teal-light:hover {\n    border-color: #64d5ca;\n}\n.xl\\:hover\\:border-teal-lighter:hover {\n    border-color: #a0f0ed;\n}\n.xl\\:hover\\:border-teal-lightest:hover {\n    border-color: #e8fffe;\n}\n.xl\\:hover\\:border-blue-darkest:hover {\n    border-color: #12283a;\n}\n.xl\\:hover\\:border-blue-darker:hover {\n    border-color: #2e6da2;\n}\n.xl\\:hover\\:border-blue-dark:hover {\n    border-color: #2779bd;\n}\n.xl\\:hover\\:border-blue:hover {\n    border-color: #3490dc;\n}\n.xl\\:hover\\:border-blue-light:hover {\n    border-color: #6cb2eb;\n}\n.xl\\:hover\\:border-blue-lighter:hover {\n    border-color: #bcdefa;\n}\n.xl\\:hover\\:border-blue-lightest:hover {\n    border-color: #eff8ff;\n}\n.xl\\:hover\\:border-indigo-darkest:hover {\n    border-color: #191e38;\n}\n.xl\\:hover\\:border-indigo-darker:hover {\n    border-color: #2f365f;\n}\n.xl\\:hover\\:border-indigo-dark:hover {\n    border-color: #5661b3;\n}\n.xl\\:hover\\:border-indigo:hover {\n    border-color: #6574cd;\n}\n.xl\\:hover\\:border-indigo-light:hover {\n    border-color: #7886d7;\n}\n.xl\\:hover\\:border-indigo-lighter:hover {\n    border-color: #b2b7ff;\n}\n.xl\\:hover\\:border-indigo-lightest:hover {\n    border-color: #e6e8ff;\n}\n.xl\\:hover\\:border-purple-darkest:hover {\n    border-color: #21183c;\n}\n.xl\\:hover\\:border-purple-darker:hover {\n    border-color: #382b5f;\n}\n.xl\\:hover\\:border-purple-dark:hover {\n    border-color: #794acf;\n}\n.xl\\:hover\\:border-purple:hover {\n    border-color: #9561e2;\n}\n.xl\\:hover\\:border-purple-light:hover {\n    border-color: #a779e9;\n}\n.xl\\:hover\\:border-purple-lighter:hover {\n    border-color: #d6bbfc;\n}\n.xl\\:hover\\:border-purple-lightest:hover {\n    border-color: #f3ebff;\n}\n.xl\\:hover\\:border-pink-darkest:hover {\n    border-color: #451225;\n}\n.xl\\:hover\\:border-pink-darker:hover {\n    border-color: #6f213f;\n}\n.xl\\:hover\\:border-pink-dark:hover {\n    border-color: #eb5286;\n}\n.xl\\:hover\\:border-pink:hover {\n    border-color: #f66d9b;\n}\n.xl\\:hover\\:border-pink-light:hover {\n    border-color: #fa7ea8;\n}\n.xl\\:hover\\:border-pink-lighter:hover {\n    border-color: #ffbbca;\n}\n.xl\\:hover\\:border-pink-lightest:hover {\n    border-color: #ffebef;\n}\n.xl\\:rounded-none {\n    border-radius: 0;\n}\n.xl\\:rounded-sm {\n    border-radius: .125rem;\n}\n.xl\\:rounded {\n    border-radius: .25rem;\n}\n.xl\\:rounded-lg {\n    border-radius: .5rem;\n}\n.xl\\:rounded-full {\n    border-radius: 9999px;\n}\n.xl\\:rounded-t-none {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n}\n.xl\\:rounded-r-none {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.xl\\:rounded-b-none {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n}\n.xl\\:rounded-l-none {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n}\n.xl\\:rounded-t-sm {\n    border-top-left-radius: .125rem;\n    border-top-right-radius: .125rem;\n}\n.xl\\:rounded-r-sm {\n    border-top-right-radius: .125rem;\n    border-bottom-right-radius: .125rem;\n}\n.xl\\:rounded-b-sm {\n    border-bottom-right-radius: .125rem;\n    border-bottom-left-radius: .125rem;\n}\n.xl\\:rounded-l-sm {\n    border-top-left-radius: .125rem;\n    border-bottom-left-radius: .125rem;\n}\n.xl\\:rounded-t {\n    border-top-left-radius: .25rem;\n    border-top-right-radius: .25rem;\n}\n.xl\\:rounded-r {\n    border-top-right-radius: .25rem;\n    border-bottom-right-radius: .25rem;\n}\n.xl\\:rounded-b {\n    border-bottom-right-radius: .25rem;\n    border-bottom-left-radius: .25rem;\n}\n.xl\\:rounded-l {\n    border-top-left-radius: .25rem;\n    border-bottom-left-radius: .25rem;\n}\n.xl\\:rounded-t-lg {\n    border-top-left-radius: .5rem;\n    border-top-right-radius: .5rem;\n}\n.xl\\:rounded-r-lg {\n    border-top-right-radius: .5rem;\n    border-bottom-right-radius: .5rem;\n}\n.xl\\:rounded-b-lg {\n    border-bottom-right-radius: .5rem;\n    border-bottom-left-radius: .5rem;\n}\n.xl\\:rounded-l-lg {\n    border-top-left-radius: .5rem;\n    border-bottom-left-radius: .5rem;\n}\n.xl\\:rounded-t-full {\n    border-top-left-radius: 9999px;\n    border-top-right-radius: 9999px;\n}\n.xl\\:rounded-r-full {\n    border-top-right-radius: 9999px;\n    border-bottom-right-radius: 9999px;\n}\n.xl\\:rounded-b-full {\n    border-bottom-right-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n}\n.xl\\:rounded-l-full {\n    border-top-left-radius: 9999px;\n    border-bottom-left-radius: 9999px;\n}\n.xl\\:rounded-tl-none {\n    border-top-left-radius: 0;\n}\n.xl\\:rounded-tr-none {\n    border-top-right-radius: 0;\n}\n.xl\\:rounded-br-none {\n    border-bottom-right-radius: 0;\n}\n.xl\\:rounded-bl-none {\n    border-bottom-left-radius: 0;\n}\n.xl\\:rounded-tl-sm {\n    border-top-left-radius: .125rem;\n}\n.xl\\:rounded-tr-sm {\n    border-top-right-radius: .125rem;\n}\n.xl\\:rounded-br-sm {\n    border-bottom-right-radius: .125rem;\n}\n.xl\\:rounded-bl-sm {\n    border-bottom-left-radius: .125rem;\n}\n.xl\\:rounded-tl {\n    border-top-left-radius: .25rem;\n}\n.xl\\:rounded-tr {\n    border-top-right-radius: .25rem;\n}\n.xl\\:rounded-br {\n    border-bottom-right-radius: .25rem;\n}\n.xl\\:rounded-bl {\n    border-bottom-left-radius: .25rem;\n}\n.xl\\:rounded-tl-lg {\n    border-top-left-radius: .5rem;\n}\n.xl\\:rounded-tr-lg {\n    border-top-right-radius: .5rem;\n}\n.xl\\:rounded-br-lg {\n    border-bottom-right-radius: .5rem;\n}\n.xl\\:rounded-bl-lg {\n    border-bottom-left-radius: .5rem;\n}\n.xl\\:rounded-tl-full {\n    border-top-left-radius: 9999px;\n}\n.xl\\:rounded-tr-full {\n    border-top-right-radius: 9999px;\n}\n.xl\\:rounded-br-full {\n    border-bottom-right-radius: 9999px;\n}\n.xl\\:rounded-bl-full {\n    border-bottom-left-radius: 9999px;\n}\n.xl\\:border-solid {\n    border-style: solid;\n}\n.xl\\:border-dashed {\n    border-style: dashed;\n}\n.xl\\:border-dotted {\n    border-style: dotted;\n}\n.xl\\:border-none {\n    border-style: none;\n}\n.xl\\:border-0 {\n    border-width: 0;\n}\n.xl\\:border-2 {\n    border-width: 2px;\n}\n.xl\\:border-4 {\n    border-width: 4px;\n}\n.xl\\:border-8 {\n    border-width: 8px;\n}\n.xl\\:border {\n    border-width: 1px;\n}\n.xl\\:border-t-0 {\n    border-top-width: 0;\n}\n.xl\\:border-r-0 {\n    border-right-width: 0;\n}\n.xl\\:border-b-0 {\n    border-bottom-width: 0;\n}\n.xl\\:border-l-0 {\n    border-left-width: 0;\n}\n.xl\\:border-t-2 {\n    border-top-width: 2px;\n}\n.xl\\:border-r-2 {\n    border-right-width: 2px;\n}\n.xl\\:border-b-2 {\n    border-bottom-width: 2px;\n}\n.xl\\:border-l-2 {\n    border-left-width: 2px;\n}\n.xl\\:border-t-4 {\n    border-top-width: 4px;\n}\n.xl\\:border-r-4 {\n    border-right-width: 4px;\n}\n.xl\\:border-b-4 {\n    border-bottom-width: 4px;\n}\n.xl\\:border-l-4 {\n    border-left-width: 4px;\n}\n.xl\\:border-t-8 {\n    border-top-width: 8px;\n}\n.xl\\:border-r-8 {\n    border-right-width: 8px;\n}\n.xl\\:border-b-8 {\n    border-bottom-width: 8px;\n}\n.xl\\:border-l-8 {\n    border-left-width: 8px;\n}\n.xl\\:border-t {\n    border-top-width: 1px;\n}\n.xl\\:border-r {\n    border-right-width: 1px;\n}\n.xl\\:border-b {\n    border-bottom-width: 1px;\n}\n.xl\\:border-l {\n    border-left-width: 1px;\n}\n.xl\\:cursor-auto {\n    cursor: auto;\n}\n.xl\\:cursor-default {\n    cursor: default;\n}\n.xl\\:cursor-pointer {\n    cursor: pointer;\n}\n.xl\\:cursor-wait {\n    cursor: wait;\n}\n.xl\\:cursor-move {\n    cursor: move;\n}\n.xl\\:cursor-not-allowed {\n    cursor: not-allowed;\n}\n.xl\\:block {\n    display: block;\n}\n.xl\\:inline-block {\n    display: inline-block;\n}\n.xl\\:inline {\n    display: inline;\n}\n.xl\\:table {\n    display: table;\n}\n.xl\\:table-row {\n    display: table-row;\n}\n.xl\\:table-cell {\n    display: table-cell;\n}\n.xl\\:hidden {\n    display: none;\n}\n.xl\\:flex {\n    display: flex;\n}\n.xl\\:inline-flex {\n    display: inline-flex;\n}\n.xl\\:flex-row {\n    flex-direction: row;\n}\n.xl\\:flex-row-reverse {\n    flex-direction: row-reverse;\n}\n.xl\\:flex-col {\n    flex-direction: column;\n}\n.xl\\:flex-col-reverse {\n    flex-direction: column-reverse;\n}\n.xl\\:flex-wrap {\n    flex-wrap: wrap;\n}\n.xl\\:flex-wrap-reverse {\n    flex-wrap: wrap-reverse;\n}\n.xl\\:flex-no-wrap {\n    flex-wrap: nowrap;\n}\n.xl\\:items-start {\n    align-items: flex-start;\n}\n.xl\\:items-end {\n    align-items: flex-end;\n}\n.xl\\:items-center {\n    align-items: center;\n}\n.xl\\:items-baseline {\n    align-items: baseline;\n}\n.xl\\:items-stretch {\n    align-items: stretch;\n}\n.xl\\:self-auto {\n    align-self: auto;\n}\n.xl\\:self-start {\n    align-self: flex-start;\n}\n.xl\\:self-end {\n    align-self: flex-end;\n}\n.xl\\:self-center {\n    align-self: center;\n}\n.xl\\:self-stretch {\n    align-self: stretch;\n}\n.xl\\:justify-start {\n    justify-content: flex-start;\n}\n.xl\\:justify-end {\n    justify-content: flex-end;\n}\n.xl\\:justify-center {\n    justify-content: center;\n}\n.xl\\:justify-between {\n    justify-content: space-between;\n}\n.xl\\:justify-around {\n    justify-content: space-around;\n}\n.xl\\:content-center {\n    align-content: center;\n}\n.xl\\:content-start {\n    align-content: flex-start;\n}\n.xl\\:content-end {\n    align-content: flex-end;\n}\n.xl\\:content-between {\n    align-content: space-between;\n}\n.xl\\:content-around {\n    align-content: space-around;\n}\n.xl\\:flex-1 {\n    flex: 1;\n}\n.xl\\:flex-auto {\n    flex: auto;\n}\n.xl\\:flex-initial {\n    flex: initial;\n}\n.xl\\:flex-none {\n    flex: none;\n}\n.xl\\:flex-grow {\n    flex-grow: 1;\n}\n.xl\\:flex-shrink {\n    flex-shrink: 1;\n}\n.xl\\:flex-no-grow {\n    flex-grow: 0;\n}\n.xl\\:flex-no-shrink {\n    flex-shrink: 0;\n}\n.xl\\:float-right {\n    float: right;\n}\n.xl\\:float-left {\n    float: left;\n}\n.xl\\:float-none {\n    float: none;\n}\n.xl\\:clearfix:after {\n    content: \"\";\n    display: table;\n    clear: both;\n}\n.xl\\:font-sans {\n    font-family: system-ui, BlinkMacSystemFont, -apple-system, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;\n}\n.xl\\:font-serif {\n    font-family: Constantia, Lucida Bright, Lucidabright, Lucida Serif, Lucida, DejaVu Serif, Bitstream Vera Serif, Liberation Serif, Georgia, serif;\n}\n.xl\\:font-mono {\n    font-family: Menlo, Monaco, Consolas, Liberation Mono, Courier New, monospace;\n}\n.xl\\:font-hairline {\n    font-weight: 100;\n}\n.xl\\:font-thin {\n    font-weight: 200;\n}\n.xl\\:font-light {\n    font-weight: 300;\n}\n.xl\\:font-normal {\n    font-weight: 400;\n}\n.xl\\:font-medium {\n    font-weight: 500;\n}\n.xl\\:font-semibold {\n    font-weight: 600;\n}\n.xl\\:font-bold {\n    font-weight: 700;\n}\n.xl\\:font-extrabold {\n    font-weight: 800;\n}\n.xl\\:font-black {\n    font-weight: 900;\n}\n.xl\\:hover\\:font-hairline:hover {\n    font-weight: 100;\n}\n.xl\\:hover\\:font-thin:hover {\n    font-weight: 200;\n}\n.xl\\:hover\\:font-light:hover {\n    font-weight: 300;\n}\n.xl\\:hover\\:font-normal:hover {\n    font-weight: 400;\n}\n.xl\\:hover\\:font-medium:hover {\n    font-weight: 500;\n}\n.xl\\:hover\\:font-semibold:hover {\n    font-weight: 600;\n}\n.xl\\:hover\\:font-bold:hover {\n    font-weight: 700;\n}\n.xl\\:hover\\:font-extrabold:hover {\n    font-weight: 800;\n}\n.xl\\:hover\\:font-black:hover {\n    font-weight: 900;\n}\n.xl\\:h-1 {\n    height: .25rem;\n}\n.xl\\:h-2 {\n    height: .5rem;\n}\n.xl\\:h-3 {\n    height: .75rem;\n}\n.xl\\:h-4 {\n    height: 1rem;\n}\n.xl\\:h-6 {\n    height: 1.5rem;\n}\n.xl\\:h-8 {\n    height: 2rem;\n}\n.xl\\:h-10 {\n    height: 2.5rem;\n}\n.xl\\:h-12 {\n    height: 3rem;\n}\n.xl\\:h-16 {\n    height: 4rem;\n}\n.xl\\:h-24 {\n    height: 6rem;\n}\n.xl\\:h-32 {\n    height: 8rem;\n}\n.xl\\:h-48 {\n    height: 12rem;\n}\n.xl\\:h-64 {\n    height: 16rem;\n}\n.xl\\:h-auto {\n    height: auto;\n}\n.xl\\:h-px {\n    height: 1px;\n}\n.xl\\:h-full {\n    height: 100%;\n}\n.xl\\:h-screen {\n    height: 100vh;\n}\n.xl\\:h-screen-footer {\n    height: 80vh;\n}\n.xl\\:h-timeslots {\n    height: calc(100vh - 3rem - 1rem);\n}\n.xl\\:leading-none {\n    line-height: 1;\n}\n.xl\\:leading-tight {\n    line-height: 1.25;\n}\n.xl\\:leading-normal {\n    line-height: 1.5;\n}\n.xl\\:leading-loose {\n    line-height: 2;\n}\n.xl\\:m-0 {\n    margin: 0;\n}\n.xl\\:m-1 {\n    margin: .25rem;\n}\n.xl\\:m-2 {\n    margin: .5rem;\n}\n.xl\\:m-3 {\n    margin: .75rem;\n}\n.xl\\:m-4 {\n    margin: 1rem;\n}\n.xl\\:m-6 {\n    margin: 1.5rem;\n}\n.xl\\:m-8 {\n    margin: 2rem;\n}\n.xl\\:m-10 {\n    margin: 2.5rem;\n}\n.xl\\:m-12 {\n    margin: 3rem;\n}\n.xl\\:m-16 {\n    margin: 4rem;\n}\n.xl\\:m-24 {\n    margin: 6rem;\n}\n.xl\\:m-32 {\n    margin: 8rem;\n}\n.xl\\:m-48 {\n    margin: 10rem;\n}\n.xl\\:m-auto {\n    margin: auto;\n}\n.xl\\:m-px {\n    margin: 1px;\n}\n.xl\\:my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n.xl\\:mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n}\n.xl\\:my-1 {\n    margin-top: .25rem;\n    margin-bottom: .25rem;\n}\n.xl\\:mx-1 {\n    margin-left: .25rem;\n    margin-right: .25rem;\n}\n.xl\\:my-2 {\n    margin-top: .5rem;\n    margin-bottom: .5rem;\n}\n.xl\\:mx-2 {\n    margin-left: .5rem;\n    margin-right: .5rem;\n}\n.xl\\:my-3 {\n    margin-top: .75rem;\n    margin-bottom: .75rem;\n}\n.xl\\:mx-3 {\n    margin-left: .75rem;\n    margin-right: .75rem;\n}\n.xl\\:my-4 {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n}\n.xl\\:mx-4 {\n    margin-left: 1rem;\n    margin-right: 1rem;\n}\n.xl\\:my-6 {\n    margin-top: 1.5rem;\n    margin-bottom: 1.5rem;\n}\n.xl\\:mx-6 {\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n}\n.xl\\:my-8 {\n    margin-top: 2rem;\n    margin-bottom: 2rem;\n}\n.xl\\:mx-8 {\n    margin-left: 2rem;\n    margin-right: 2rem;\n}\n.xl\\:my-10 {\n    margin-top: 2.5rem;\n    margin-bottom: 2.5rem;\n}\n.xl\\:mx-10 {\n    margin-left: 2.5rem;\n    margin-right: 2.5rem;\n}\n.xl\\:my-12 {\n    margin-top: 3rem;\n    margin-bottom: 3rem;\n}\n.xl\\:mx-12 {\n    margin-left: 3rem;\n    margin-right: 3rem;\n}\n.xl\\:my-16 {\n    margin-top: 4rem;\n    margin-bottom: 4rem;\n}\n.xl\\:mx-16 {\n    margin-left: 4rem;\n    margin-right: 4rem;\n}\n.xl\\:my-24 {\n    margin-top: 6rem;\n    margin-bottom: 6rem;\n}\n.xl\\:mx-24 {\n    margin-left: 6rem;\n    margin-right: 6rem;\n}\n.xl\\:my-32 {\n    margin-top: 8rem;\n    margin-bottom: 8rem;\n}\n.xl\\:mx-32 {\n    margin-left: 8rem;\n    margin-right: 8rem;\n}\n.xl\\:my-48 {\n    margin-top: 10rem;\n    margin-bottom: 10rem;\n}\n.xl\\:mx-48 {\n    margin-left: 10rem;\n    margin-right: 10rem;\n}\n.xl\\:my-auto {\n    margin-top: auto;\n    margin-bottom: auto;\n}\n.xl\\:mx-auto {\n    margin-left: auto;\n    margin-right: auto;\n}\n.xl\\:my-px {\n    margin-top: 1px;\n    margin-bottom: 1px;\n}\n.xl\\:mx-px {\n    margin-left: 1px;\n    margin-right: 1px;\n}\n.xl\\:mt-0 {\n    margin-top: 0;\n}\n.xl\\:mr-0 {\n    margin-right: 0;\n}\n.xl\\:mb-0 {\n    margin-bottom: 0;\n}\n.xl\\:ml-0 {\n    margin-left: 0;\n}\n.xl\\:mt-1 {\n    margin-top: .25rem;\n}\n.xl\\:mr-1 {\n    margin-right: .25rem;\n}\n.xl\\:mb-1 {\n    margin-bottom: .25rem;\n}\n.xl\\:ml-1 {\n    margin-left: .25rem;\n}\n.xl\\:mt-2 {\n    margin-top: .5rem;\n}\n.xl\\:mr-2 {\n    margin-right: .5rem;\n}\n.xl\\:mb-2 {\n    margin-bottom: .5rem;\n}\n.xl\\:ml-2 {\n    margin-left: .5rem;\n}\n.xl\\:mt-3 {\n    margin-top: .75rem;\n}\n.xl\\:mr-3 {\n    margin-right: .75rem;\n}\n.xl\\:mb-3 {\n    margin-bottom: .75rem;\n}\n.xl\\:ml-3 {\n    margin-left: .75rem;\n}\n.xl\\:mt-4 {\n    margin-top: 1rem;\n}\n.xl\\:mr-4 {\n    margin-right: 1rem;\n}\n.xl\\:mb-4 {\n    margin-bottom: 1rem;\n}\n.xl\\:ml-4 {\n    margin-left: 1rem;\n}\n.xl\\:mt-6 {\n    margin-top: 1.5rem;\n}\n.xl\\:mr-6 {\n    margin-right: 1.5rem;\n}\n.xl\\:mb-6 {\n    margin-bottom: 1.5rem;\n}\n.xl\\:ml-6 {\n    margin-left: 1.5rem;\n}\n.xl\\:mt-8 {\n    margin-top: 2rem;\n}\n.xl\\:mr-8 {\n    margin-right: 2rem;\n}\n.xl\\:mb-8 {\n    margin-bottom: 2rem;\n}\n.xl\\:ml-8 {\n    margin-left: 2rem;\n}\n.xl\\:mt-10 {\n    margin-top: 2.5rem;\n}\n.xl\\:mr-10 {\n    margin-right: 2.5rem;\n}\n.xl\\:mb-10 {\n    margin-bottom: 2.5rem;\n}\n.xl\\:ml-10 {\n    margin-left: 2.5rem;\n}\n.xl\\:mt-12 {\n    margin-top: 3rem;\n}\n.xl\\:mr-12 {\n    margin-right: 3rem;\n}\n.xl\\:mb-12 {\n    margin-bottom: 3rem;\n}\n.xl\\:ml-12 {\n    margin-left: 3rem;\n}\n.xl\\:mt-16 {\n    margin-top: 4rem;\n}\n.xl\\:mr-16 {\n    margin-right: 4rem;\n}\n.xl\\:mb-16 {\n    margin-bottom: 4rem;\n}\n.xl\\:ml-16 {\n    margin-left: 4rem;\n}\n.xl\\:mt-24 {\n    margin-top: 6rem;\n}\n.xl\\:mr-24 {\n    margin-right: 6rem;\n}\n.xl\\:mb-24 {\n    margin-bottom: 6rem;\n}\n.xl\\:ml-24 {\n    margin-left: 6rem;\n}\n.xl\\:mt-32 {\n    margin-top: 8rem;\n}\n.xl\\:mr-32 {\n    margin-right: 8rem;\n}\n.xl\\:mb-32 {\n    margin-bottom: 8rem;\n}\n.xl\\:ml-32 {\n    margin-left: 8rem;\n}\n.xl\\:mt-48 {\n    margin-top: 10rem;\n}\n.xl\\:mr-48 {\n    margin-right: 10rem;\n}\n.xl\\:mb-48 {\n    margin-bottom: 10rem;\n}\n.xl\\:ml-48 {\n    margin-left: 10rem;\n}\n.xl\\:mt-auto {\n    margin-top: auto;\n}\n.xl\\:mr-auto {\n    margin-right: auto;\n}\n.xl\\:mb-auto {\n    margin-bottom: auto;\n}\n.xl\\:ml-auto {\n    margin-left: auto;\n}\n.xl\\:mt-px {\n    margin-top: 1px;\n}\n.xl\\:mr-px {\n    margin-right: 1px;\n}\n.xl\\:mb-px {\n    margin-bottom: 1px;\n}\n.xl\\:ml-px {\n    margin-left: 1px;\n}\n.xl\\:max-h-full {\n    max-height: 100%;\n}\n.xl\\:max-h-screen {\n    max-height: 100vh;\n}\n.xl\\:max-h-timeslots {\n    max-height: calc(100vh - 3rem - 1rem - 14rem);\n}\n.xl\\:max-w-xs {\n    max-width: 20rem;\n}\n.xl\\:max-w-sm {\n    max-width: 30rem;\n}\n.xl\\:max-w-md {\n    max-width: 40rem;\n}\n.xl\\:max-w-lg {\n    max-width: 50rem;\n}\n.xl\\:max-w-xl {\n    max-width: 60rem;\n}\n.xl\\:max-w-2xl {\n    max-width: 70rem;\n}\n.xl\\:max-w-3xl {\n    max-width: 80rem;\n}\n.xl\\:max-w-4xl {\n    max-width: 90rem;\n}\n.xl\\:max-w-5xl {\n    max-width: 100rem;\n}\n.xl\\:max-w-full {\n    max-width: 100%;\n}\n.xl\\:min-h-0 {\n    min-height: 0;\n}\n.xl\\:min-h-full {\n    min-height: 100%;\n}\n.xl\\:min-h-screen {\n    min-height: 100vh;\n}\n.xl\\:min-h-\\(screen-footer-sm\\) {\n    min-height: calc(100vh - 350px);\n}\n.xl\\:min-h-\\(screen-footer-md\\) {\n    min-height: calc(100vh - 180px);\n}\n.xl\\:min-w-0 {\n    min-width: 0;\n}\n.xl\\:min-w-full {\n    min-width: 100%;\n}\n.xl\\:-m-0 {\n    margin: 0;\n}\n.xl\\:-m-1 {\n    margin: -0.25rem;\n}\n.xl\\:-m-2 {\n    margin: -0.5rem;\n}\n.xl\\:-m-3 {\n    margin: -0.75rem;\n}\n.xl\\:-m-4 {\n    margin: -1rem;\n}\n.xl\\:-m-6 {\n    margin: -1.5rem;\n}\n.xl\\:-m-8 {\n    margin: -2rem;\n}\n.xl\\:-m-10 {\n    margin: -2.5rem;\n}\n.xl\\:-m-12 {\n    margin: -3rem;\n}\n.xl\\:-m-16 {\n    margin: -4rem;\n}\n.xl\\:-m-24 {\n    margin: -6rem;\n}\n.xl\\:-m-32 {\n    margin: -8rem;\n}\n.xl\\:-m-48 {\n    margin: -10rem;\n}\n.xl\\:-m-px {\n    margin: -1px;\n}\n.xl\\:-my-0 {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n.xl\\:-mx-0 {\n    margin-left: 0;\n    margin-right: 0;\n}\n.xl\\:-my-1 {\n    margin-top: -0.25rem;\n    margin-bottom: -0.25rem;\n}\n.xl\\:-mx-1 {\n    margin-left: -0.25rem;\n    margin-right: -0.25rem;\n}\n.xl\\:-my-2 {\n    margin-top: -0.5rem;\n    margin-bottom: -0.5rem;\n}\n.xl\\:-mx-2 {\n    margin-left: -0.5rem;\n    margin-right: -0.5rem;\n}\n.xl\\:-my-3 {\n    margin-top: -0.75rem;\n    margin-bottom: -0.75rem;\n}\n.xl\\:-mx-3 {\n    margin-left: -0.75rem;\n    margin-right: -0.75rem;\n}\n.xl\\:-my-4 {\n    margin-top: -1rem;\n    margin-bottom: -1rem;\n}\n.xl\\:-mx-4 {\n    margin-left: -1rem;\n    margin-right: -1rem;\n}\n.xl\\:-my-6 {\n    margin-top: -1.5rem;\n    margin-bottom: -1.5rem;\n}\n.xl\\:-mx-6 {\n    margin-left: -1.5rem;\n    margin-right: -1.5rem;\n}\n.xl\\:-my-8 {\n    margin-top: -2rem;\n    margin-bottom: -2rem;\n}\n.xl\\:-mx-8 {\n    margin-left: -2rem;\n    margin-right: -2rem;\n}\n.xl\\:-my-10 {\n    margin-top: -2.5rem;\n    margin-bottom: -2.5rem;\n}\n.xl\\:-mx-10 {\n    margin-left: -2.5rem;\n    margin-right: -2.5rem;\n}\n.xl\\:-my-12 {\n    margin-top: -3rem;\n    margin-bottom: -3rem;\n}\n.xl\\:-mx-12 {\n    margin-left: -3rem;\n    margin-right: -3rem;\n}\n.xl\\:-my-16 {\n    margin-top: -4rem;\n    margin-bottom: -4rem;\n}\n.xl\\:-mx-16 {\n    margin-left: -4rem;\n    margin-right: -4rem;\n}\n.xl\\:-my-24 {\n    margin-top: -6rem;\n    margin-bottom: -6rem;\n}\n.xl\\:-mx-24 {\n    margin-left: -6rem;\n    margin-right: -6rem;\n}\n.xl\\:-my-32 {\n    margin-top: -8rem;\n    margin-bottom: -8rem;\n}\n.xl\\:-mx-32 {\n    margin-left: -8rem;\n    margin-right: -8rem;\n}\n.xl\\:-my-48 {\n    margin-top: -10rem;\n    margin-bottom: -10rem;\n}\n.xl\\:-mx-48 {\n    margin-left: -10rem;\n    margin-right: -10rem;\n}\n.xl\\:-my-px {\n    margin-top: -1px;\n    margin-bottom: -1px;\n}\n.xl\\:-mx-px {\n    margin-left: -1px;\n    margin-right: -1px;\n}\n.xl\\:-mt-0 {\n    margin-top: 0;\n}\n.xl\\:-mr-0 {\n    margin-right: 0;\n}\n.xl\\:-mb-0 {\n    margin-bottom: 0;\n}\n.xl\\:-ml-0 {\n    margin-left: 0;\n}\n.xl\\:-mt-1 {\n    margin-top: -0.25rem;\n}\n.xl\\:-mr-1 {\n    margin-right: -0.25rem;\n}\n.xl\\:-mb-1 {\n    margin-bottom: -0.25rem;\n}\n.xl\\:-ml-1 {\n    margin-left: -0.25rem;\n}\n.xl\\:-mt-2 {\n    margin-top: -0.5rem;\n}\n.xl\\:-mr-2 {\n    margin-right: -0.5rem;\n}\n.xl\\:-mb-2 {\n    margin-bottom: -0.5rem;\n}\n.xl\\:-ml-2 {\n    margin-left: -0.5rem;\n}\n.xl\\:-mt-3 {\n    margin-top: -0.75rem;\n}\n.xl\\:-mr-3 {\n    margin-right: -0.75rem;\n}\n.xl\\:-mb-3 {\n    margin-bottom: -0.75rem;\n}\n.xl\\:-ml-3 {\n    margin-left: -0.75rem;\n}\n.xl\\:-mt-4 {\n    margin-top: -1rem;\n}\n.xl\\:-mr-4 {\n    margin-right: -1rem;\n}\n.xl\\:-mb-4 {\n    margin-bottom: -1rem;\n}\n.xl\\:-ml-4 {\n    margin-left: -1rem;\n}\n.xl\\:-mt-6 {\n    margin-top: -1.5rem;\n}\n.xl\\:-mr-6 {\n    margin-right: -1.5rem;\n}\n.xl\\:-mb-6 {\n    margin-bottom: -1.5rem;\n}\n.xl\\:-ml-6 {\n    margin-left: -1.5rem;\n}\n.xl\\:-mt-8 {\n    margin-top: -2rem;\n}\n.xl\\:-mr-8 {\n    margin-right: -2rem;\n}\n.xl\\:-mb-8 {\n    margin-bottom: -2rem;\n}\n.xl\\:-ml-8 {\n    margin-left: -2rem;\n}\n.xl\\:-mt-10 {\n    margin-top: -2.5rem;\n}\n.xl\\:-mr-10 {\n    margin-right: -2.5rem;\n}\n.xl\\:-mb-10 {\n    margin-bottom: -2.5rem;\n}\n.xl\\:-ml-10 {\n    margin-left: -2.5rem;\n}\n.xl\\:-mt-12 {\n    margin-top: -3rem;\n}\n.xl\\:-mr-12 {\n    margin-right: -3rem;\n}\n.xl\\:-mb-12 {\n    margin-bottom: -3rem;\n}\n.xl\\:-ml-12 {\n    margin-left: -3rem;\n}\n.xl\\:-mt-16 {\n    margin-top: -4rem;\n}\n.xl\\:-mr-16 {\n    margin-right: -4rem;\n}\n.xl\\:-mb-16 {\n    margin-bottom: -4rem;\n}\n.xl\\:-ml-16 {\n    margin-left: -4rem;\n}\n.xl\\:-mt-24 {\n    margin-top: -6rem;\n}\n.xl\\:-mr-24 {\n    margin-right: -6rem;\n}\n.xl\\:-mb-24 {\n    margin-bottom: -6rem;\n}\n.xl\\:-ml-24 {\n    margin-left: -6rem;\n}\n.xl\\:-mt-32 {\n    margin-top: -8rem;\n}\n.xl\\:-mr-32 {\n    margin-right: -8rem;\n}\n.xl\\:-mb-32 {\n    margin-bottom: -8rem;\n}\n.xl\\:-ml-32 {\n    margin-left: -8rem;\n}\n.xl\\:-mt-48 {\n    margin-top: -10rem;\n}\n.xl\\:-mr-48 {\n    margin-right: -10rem;\n}\n.xl\\:-mb-48 {\n    margin-bottom: -10rem;\n}\n.xl\\:-ml-48 {\n    margin-left: -10rem;\n}\n.xl\\:-mt-px {\n    margin-top: -1px;\n}\n.xl\\:-mr-px {\n    margin-right: -1px;\n}\n.xl\\:-mb-px {\n    margin-bottom: -1px;\n}\n.xl\\:-ml-px {\n    margin-left: -1px;\n}\n.xl\\:opacity-0 {\n    opacity: 0;\n}\n.xl\\:opacity-25 {\n    opacity: .25;\n}\n.xl\\:opacity-50 {\n    opacity: .5;\n}\n.xl\\:opacity-75 {\n    opacity: .75;\n}\n.xl\\:opacity-100 {\n    opacity: 1;\n}\n.xl\\:hover\\:opacity-0:hover {\n    opacity: 0;\n}\n.xl\\:hover\\:opacity-25:hover {\n    opacity: .25;\n}\n.xl\\:hover\\:opacity-50:hover {\n    opacity: .5;\n}\n.xl\\:hover\\:opacity-75:hover {\n    opacity: .75;\n}\n.xl\\:hover\\:opacity-100:hover {\n    opacity: 1;\n}\n.xl\\:overflow-auto {\n    overflow: auto;\n}\n.xl\\:overflow-hidden {\n    overflow: hidden;\n}\n.xl\\:overflow-visible {\n    overflow: visible;\n}\n.xl\\:overflow-scroll {\n    overflow: scroll;\n}\n.xl\\:overflow-x-auto {\n    overflow-x: auto;\n}\n.xl\\:overflow-y-auto {\n    overflow-y: auto;\n}\n.xl\\:overflow-x-scroll {\n    overflow-x: scroll;\n}\n.xl\\:overflow-y-scroll {\n    overflow-y: scroll;\n}\n.xl\\:scrolling-touch {\n    -webkit-overflow-scrolling: touch;\n}\n.xl\\:scrolling-auto {\n    -webkit-overflow-scrolling: auto;\n}\n.xl\\:p-0 {\n    padding: 0;\n}\n.xl\\:p-1 {\n    padding: .25rem;\n}\n.xl\\:p-2 {\n    padding: .5rem;\n}\n.xl\\:p-3 {\n    padding: .75rem;\n}\n.xl\\:p-4 {\n    padding: 1rem;\n}\n.xl\\:p-6 {\n    padding: 1.5rem;\n}\n.xl\\:p-8 {\n    padding: 2rem;\n}\n.xl\\:p-10 {\n    padding: 2.5rem;\n}\n.xl\\:p-12 {\n    padding: 3rem;\n}\n.xl\\:p-16 {\n    padding: 4rem;\n}\n.xl\\:p-24 {\n    padding: 6rem;\n}\n.xl\\:p-32 {\n    padding: 8rem;\n}\n.xl\\:p-48 {\n    padding: 10rem;\n}\n.xl\\:p-px {\n    padding: 1px;\n}\n.xl\\:py-0 {\n    padding-top: 0;\n    padding-bottom: 0;\n}\n.xl\\:px-0 {\n    padding-left: 0;\n    padding-right: 0;\n}\n.xl\\:py-1 {\n    padding-top: .25rem;\n    padding-bottom: .25rem;\n}\n.xl\\:px-1 {\n    padding-left: .25rem;\n    padding-right: .25rem;\n}\n.xl\\:py-2 {\n    padding-top: .5rem;\n    padding-bottom: .5rem;\n}\n.xl\\:px-2 {\n    padding-left: .5rem;\n    padding-right: .5rem;\n}\n.xl\\:py-3 {\n    padding-top: .75rem;\n    padding-bottom: .75rem;\n}\n.xl\\:px-3 {\n    padding-left: .75rem;\n    padding-right: .75rem;\n}\n.xl\\:py-4 {\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n}\n.xl\\:px-4 {\n    padding-left: 1rem;\n    padding-right: 1rem;\n}\n.xl\\:py-6 {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n}\n.xl\\:px-6 {\n    padding-left: 1.5rem;\n    padding-right: 1.5rem;\n}\n.xl\\:py-8 {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n}\n.xl\\:px-8 {\n    padding-left: 2rem;\n    padding-right: 2rem;\n}\n.xl\\:py-10 {\n    padding-top: 2.5rem;\n    padding-bottom: 2.5rem;\n}\n.xl\\:px-10 {\n    padding-left: 2.5rem;\n    padding-right: 2.5rem;\n}\n.xl\\:py-12 {\n    padding-top: 3rem;\n    padding-bottom: 3rem;\n}\n.xl\\:px-12 {\n    padding-left: 3rem;\n    padding-right: 3rem;\n}\n.xl\\:py-16 {\n    padding-top: 4rem;\n    padding-bottom: 4rem;\n}\n.xl\\:px-16 {\n    padding-left: 4rem;\n    padding-right: 4rem;\n}\n.xl\\:py-24 {\n    padding-top: 6rem;\n    padding-bottom: 6rem;\n}\n.xl\\:px-24 {\n    padding-left: 6rem;\n    padding-right: 6rem;\n}\n.xl\\:py-32 {\n    padding-top: 8rem;\n    padding-bottom: 8rem;\n}\n.xl\\:px-32 {\n    padding-left: 8rem;\n    padding-right: 8rem;\n}\n.xl\\:py-48 {\n    padding-top: 10rem;\n    padding-bottom: 10rem;\n}\n.xl\\:px-48 {\n    padding-left: 10rem;\n    padding-right: 10rem;\n}\n.xl\\:py-px {\n    padding-top: 1px;\n    padding-bottom: 1px;\n}\n.xl\\:px-px {\n    padding-left: 1px;\n    padding-right: 1px;\n}\n.xl\\:pt-0 {\n    padding-top: 0;\n}\n.xl\\:pr-0 {\n    padding-right: 0;\n}\n.xl\\:pb-0 {\n    padding-bottom: 0;\n}\n.xl\\:pl-0 {\n    padding-left: 0;\n}\n.xl\\:pt-1 {\n    padding-top: .25rem;\n}\n.xl\\:pr-1 {\n    padding-right: .25rem;\n}\n.xl\\:pb-1 {\n    padding-bottom: .25rem;\n}\n.xl\\:pl-1 {\n    padding-left: .25rem;\n}\n.xl\\:pt-2 {\n    padding-top: .5rem;\n}\n.xl\\:pr-2 {\n    padding-right: .5rem;\n}\n.xl\\:pb-2 {\n    padding-bottom: .5rem;\n}\n.xl\\:pl-2 {\n    padding-left: .5rem;\n}\n.xl\\:pt-3 {\n    padding-top: .75rem;\n}\n.xl\\:pr-3 {\n    padding-right: .75rem;\n}\n.xl\\:pb-3 {\n    padding-bottom: .75rem;\n}\n.xl\\:pl-3 {\n    padding-left: .75rem;\n}\n.xl\\:pt-4 {\n    padding-top: 1rem;\n}\n.xl\\:pr-4 {\n    padding-right: 1rem;\n}\n.xl\\:pb-4 {\n    padding-bottom: 1rem;\n}\n.xl\\:pl-4 {\n    padding-left: 1rem;\n}\n.xl\\:pt-6 {\n    padding-top: 1.5rem;\n}\n.xl\\:pr-6 {\n    padding-right: 1.5rem;\n}\n.xl\\:pb-6 {\n    padding-bottom: 1.5rem;\n}\n.xl\\:pl-6 {\n    padding-left: 1.5rem;\n}\n.xl\\:pt-8 {\n    padding-top: 2rem;\n}\n.xl\\:pr-8 {\n    padding-right: 2rem;\n}\n.xl\\:pb-8 {\n    padding-bottom: 2rem;\n}\n.xl\\:pl-8 {\n    padding-left: 2rem;\n}\n.xl\\:pt-10 {\n    padding-top: 2.5rem;\n}\n.xl\\:pr-10 {\n    padding-right: 2.5rem;\n}\n.xl\\:pb-10 {\n    padding-bottom: 2.5rem;\n}\n.xl\\:pl-10 {\n    padding-left: 2.5rem;\n}\n.xl\\:pt-12 {\n    padding-top: 3rem;\n}\n.xl\\:pr-12 {\n    padding-right: 3rem;\n}\n.xl\\:pb-12 {\n    padding-bottom: 3rem;\n}\n.xl\\:pl-12 {\n    padding-left: 3rem;\n}\n.xl\\:pt-16 {\n    padding-top: 4rem;\n}\n.xl\\:pr-16 {\n    padding-right: 4rem;\n}\n.xl\\:pb-16 {\n    padding-bottom: 4rem;\n}\n.xl\\:pl-16 {\n    padding-left: 4rem;\n}\n.xl\\:pt-24 {\n    padding-top: 6rem;\n}\n.xl\\:pr-24 {\n    padding-right: 6rem;\n}\n.xl\\:pb-24 {\n    padding-bottom: 6rem;\n}\n.xl\\:pl-24 {\n    padding-left: 6rem;\n}\n.xl\\:pt-32 {\n    padding-top: 8rem;\n}\n.xl\\:pr-32 {\n    padding-right: 8rem;\n}\n.xl\\:pb-32 {\n    padding-bottom: 8rem;\n}\n.xl\\:pl-32 {\n    padding-left: 8rem;\n}\n.xl\\:pt-48 {\n    padding-top: 10rem;\n}\n.xl\\:pr-48 {\n    padding-right: 10rem;\n}\n.xl\\:pb-48 {\n    padding-bottom: 10rem;\n}\n.xl\\:pl-48 {\n    padding-left: 10rem;\n}\n.xl\\:pt-px {\n    padding-top: 1px;\n}\n.xl\\:pr-px {\n    padding-right: 1px;\n}\n.xl\\:pb-px {\n    padding-bottom: 1px;\n}\n.xl\\:pl-px {\n    padding-left: 1px;\n}\n.xl\\:pointer-events-none {\n    pointer-events: none;\n}\n.xl\\:pointer-events-auto {\n    pointer-events: auto;\n}\n.xl\\:static {\n    position: static;\n}\n.xl\\:fixed {\n    position: fixed;\n}\n.xl\\:absolute {\n    position: absolute;\n}\n.xl\\:relative {\n    position: relative;\n}\n.xl\\:sticky {\n    position: sticky;\n}\n.xl\\:pin-none {\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n}\n.xl\\:pin {\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n.xl\\:pin-y {\n    top: 0;\n    bottom: 0;\n}\n.xl\\:pin-x {\n    right: 0;\n    left: 0;\n}\n.xl\\:pin-t {\n    top: 0;\n}\n.xl\\:pin-r {\n    right: 0;\n}\n.xl\\:pin-b {\n    bottom: 0;\n}\n.xl\\:pin-l {\n    left: 0;\n}\n.xl\\:resize-none {\n    resize: none;\n}\n.xl\\:resize-y {\n    resize: vertical;\n}\n.xl\\:resize-x {\n    resize: horizontal;\n}\n.xl\\:resize {\n    resize: both;\n}\n.xl\\:shadow {\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, .1);\n}\n.xl\\:shadow-md {\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, .12), 0 2px 4px 0 rgba(0, 0, 0, .08);\n}\n.xl\\:shadow-lg {\n    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, .11), 0 5px 15px 0 rgba(0, 0, 0, .08);\n}\n.xl\\:shadow-inner {\n    box-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, .06);\n}\n.xl\\:shadow-none {\n    box-shadow: none;\n}\n.xl\\:text-left {\n    text-align: left;\n}\n.xl\\:text-center {\n    text-align: center;\n}\n.xl\\:text-right {\n    text-align: right;\n}\n.xl\\:text-justify {\n    text-align: justify;\n}\n.xl\\:text-transparent {\n    color: transparent;\n}\n.xl\\:text-modal {\n    color: rgba(0, 0, 0, .4);\n}\n.xl\\:text-google {\n    color: #dc5b5b;\n}\n.xl\\:text-google-dark {\n    color: #da5050;\n}\n.xl\\:text-facebook {\n    color: #3b5998;\n}\n.xl\\:text-facebook-dark {\n    color: #37548f;\n}\n.xl\\:text-primary {\n    color: #2196f3;\n}\n.xl\\:text-primary-dark {\n    color: #3b5998;\n}\n.xl\\:text-footer {\n    color: #1976d2;\n}\n.xl\\:text-black {\n    color: #22292f;\n}\n.xl\\:text-grey-darkest {\n    color: #3d4852;\n}\n.xl\\:text-grey-darker {\n    color: #606f7b;\n}\n.xl\\:text-grey-dark {\n    color: #8795a1;\n}\n.xl\\:text-grey {\n    color: #b8c2cc;\n}\n.xl\\:text-grey-light {\n    color: #dae1e7;\n}\n.xl\\:text-grey-lighter {\n    color: #f1f5f8;\n}\n.xl\\:text-grey-lightest {\n    color: #f8fafc;\n}\n.xl\\:text-white {\n    color: #fff;\n}\n.xl\\:text-whiter {\n    color: rgba(255, 255, 255, .6);\n}\n.xl\\:text-red-darkest {\n    color: #3b0d0c;\n}\n.xl\\:text-red-darker {\n    color: #621b18;\n}\n.xl\\:text-red-dark {\n    color: #cc1f1a;\n}\n.xl\\:text-red {\n    color: #e3342f;\n}\n.xl\\:text-red-light {\n    color: #ef5753;\n}\n.xl\\:text-red-lighter {\n    color: #f9acaa;\n}\n.xl\\:text-red-lightest {\n    color: #fcebea;\n}\n.xl\\:text-orange-darkest {\n    color: #462a16;\n}\n.xl\\:text-orange-darker {\n    color: #613b1f;\n}\n.xl\\:text-orange-dark {\n    color: #de751f;\n}\n.xl\\:text-orange {\n    color: #f6993f;\n}\n.xl\\:text-orange-light {\n    color: #faad63;\n}\n.xl\\:text-orange-lighter {\n    color: #fcd9b6;\n}\n.xl\\:text-orange-lightest {\n    color: #fff5eb;\n}\n.xl\\:text-yellow-darkest {\n    color: #453411;\n}\n.xl\\:text-yellow-darker {\n    color: #684f1d;\n}\n.xl\\:text-yellow-dark {\n    color: #f2d024;\n}\n.xl\\:text-yellow {\n    color: #ffed4a;\n}\n.xl\\:text-yellow-light {\n    color: #fff382;\n}\n.xl\\:text-yellow-lighter {\n    color: #fff9c2;\n}\n.xl\\:text-yellow-lightest {\n    color: #fcfbeb;\n}\n.xl\\:text-green-darkest {\n    color: #0f2f21;\n}\n.xl\\:text-green-darker {\n    color: #1a4731;\n}\n.xl\\:text-green-dark {\n    color: #1f9d55;\n}\n.xl\\:text-green {\n    color: #38c172;\n}\n.xl\\:text-green-light {\n    color: #51d88a;\n}\n.xl\\:text-green-lighter {\n    color: #a2f5bf;\n}\n.xl\\:text-green-lightest {\n    color: #e3fcec;\n}\n.xl\\:text-teal-darkest {\n    color: #0d3331;\n}\n.xl\\:text-teal-darker {\n    color: #20504f;\n}\n.xl\\:text-teal-dark {\n    color: #009480;\n}\n.xl\\:text-teal {\n    color: #00ae98;\n}\n.xl\\:text-teal-light {\n    color: #64d5ca;\n}\n.xl\\:text-teal-lighter {\n    color: #a0f0ed;\n}\n.xl\\:text-teal-lightest {\n    color: #e8fffe;\n}\n.xl\\:text-blue-darkest {\n    color: #12283a;\n}\n.xl\\:text-blue-darker {\n    color: #2e6da2;\n}\n.xl\\:text-blue-dark {\n    color: #2779bd;\n}\n.xl\\:text-blue {\n    color: #3490dc;\n}\n.xl\\:text-blue-light {\n    color: #6cb2eb;\n}\n.xl\\:text-blue-lighter {\n    color: #bcdefa;\n}\n.xl\\:text-blue-lightest {\n    color: #eff8ff;\n}\n.xl\\:text-indigo-darkest {\n    color: #191e38;\n}\n.xl\\:text-indigo-darker {\n    color: #2f365f;\n}\n.xl\\:text-indigo-dark {\n    color: #5661b3;\n}\n.xl\\:text-indigo {\n    color: #6574cd;\n}\n.xl\\:text-indigo-light {\n    color: #7886d7;\n}\n.xl\\:text-indigo-lighter {\n    color: #b2b7ff;\n}\n.xl\\:text-indigo-lightest {\n    color: #e6e8ff;\n}\n.xl\\:text-purple-darkest {\n    color: #21183c;\n}\n.xl\\:text-purple-darker {\n    color: #382b5f;\n}\n.xl\\:text-purple-dark {\n    color: #794acf;\n}\n.xl\\:text-purple {\n    color: #9561e2;\n}\n.xl\\:text-purple-light {\n    color: #a779e9;\n}\n.xl\\:text-purple-lighter {\n    color: #d6bbfc;\n}\n.xl\\:text-purple-lightest {\n    color: #f3ebff;\n}\n.xl\\:text-pink-darkest {\n    color: #451225;\n}\n.xl\\:text-pink-darker {\n    color: #6f213f;\n}\n.xl\\:text-pink-dark {\n    color: #eb5286;\n}\n.xl\\:text-pink {\n    color: #f66d9b;\n}\n.xl\\:text-pink-light {\n    color: #fa7ea8;\n}\n.xl\\:text-pink-lighter {\n    color: #ffbbca;\n}\n.xl\\:text-pink-lightest {\n    color: #ffebef;\n}\n.xl\\:group:hover .group-hover\\:text-transparent {\n    color: transparent;\n}\n.xl\\:group:hover .group-hover\\:text-modal {\n    color: rgba(0, 0, 0, .4);\n}\n.xl\\:group:hover .group-hover\\:text-google {\n    color: #dc5b5b;\n}\n.xl\\:group:hover .group-hover\\:text-google-dark {\n    color: #da5050;\n}\n.xl\\:group:hover .group-hover\\:text-facebook {\n    color: #3b5998;\n}\n.xl\\:group:hover .group-hover\\:text-facebook-dark {\n    color: #37548f;\n}\n.xl\\:group:hover .group-hover\\:text-primary {\n    color: #2196f3;\n}\n.xl\\:group:hover .group-hover\\:text-primary-dark {\n    color: #3b5998;\n}\n.xl\\:group:hover .group-hover\\:text-footer {\n    color: #1976d2;\n}\n.xl\\:group:hover .group-hover\\:text-black {\n    color: #22292f;\n}\n.xl\\:group:hover .group-hover\\:text-grey-darkest {\n    color: #3d4852;\n}\n.xl\\:group:hover .group-hover\\:text-grey-darker {\n    color: #606f7b;\n}\n.xl\\:group:hover .group-hover\\:text-grey-dark {\n    color: #8795a1;\n}\n.xl\\:group:hover .group-hover\\:text-grey {\n    color: #b8c2cc;\n}\n.xl\\:group:hover .group-hover\\:text-grey-light {\n    color: #dae1e7;\n}\n.xl\\:group:hover .group-hover\\:text-grey-lighter {\n    color: #f1f5f8;\n}\n.xl\\:group:hover .group-hover\\:text-grey-lightest {\n    color: #f8fafc;\n}\n.xl\\:group:hover .group-hover\\:text-white {\n    color: #fff;\n}\n.xl\\:group:hover .group-hover\\:text-whiter {\n    color: rgba(255, 255, 255, .6);\n}\n.xl\\:group:hover .group-hover\\:text-red-darkest {\n    color: #3b0d0c;\n}\n.xl\\:group:hover .group-hover\\:text-red-darker {\n    color: #621b18;\n}\n.xl\\:group:hover .group-hover\\:text-red-dark {\n    color: #cc1f1a;\n}\n.xl\\:group:hover .group-hover\\:text-red {\n    color: #e3342f;\n}\n.xl\\:group:hover .group-hover\\:text-red-light {\n    color: #ef5753;\n}\n.xl\\:group:hover .group-hover\\:text-red-lighter {\n    color: #f9acaa;\n}\n.xl\\:group:hover .group-hover\\:text-red-lightest {\n    color: #fcebea;\n}\n.xl\\:group:hover .group-hover\\:text-orange-darkest {\n    color: #462a16;\n}\n.xl\\:group:hover .group-hover\\:text-orange-darker {\n    color: #613b1f;\n}\n.xl\\:group:hover .group-hover\\:text-orange-dark {\n    color: #de751f;\n}\n.xl\\:group:hover .group-hover\\:text-orange {\n    color: #f6993f;\n}\n.xl\\:group:hover .group-hover\\:text-orange-light {\n    color: #faad63;\n}\n.xl\\:group:hover .group-hover\\:text-orange-lighter {\n    color: #fcd9b6;\n}\n.xl\\:group:hover .group-hover\\:text-orange-lightest {\n    color: #fff5eb;\n}\n.xl\\:group:hover .group-hover\\:text-yellow-darkest {\n    color: #453411;\n}\n.xl\\:group:hover .group-hover\\:text-yellow-darker {\n    color: #684f1d;\n}\n.xl\\:group:hover .group-hover\\:text-yellow-dark {\n    color: #f2d024;\n}\n.xl\\:group:hover .group-hover\\:text-yellow {\n    color: #ffed4a;\n}\n.xl\\:group:hover .group-hover\\:text-yellow-light {\n    color: #fff382;\n}\n.xl\\:group:hover .group-hover\\:text-yellow-lighter {\n    color: #fff9c2;\n}\n.xl\\:group:hover .group-hover\\:text-yellow-lightest {\n    color: #fcfbeb;\n}\n.xl\\:group:hover .group-hover\\:text-green-darkest {\n    color: #0f2f21;\n}\n.xl\\:group:hover .group-hover\\:text-green-darker {\n    color: #1a4731;\n}\n.xl\\:group:hover .group-hover\\:text-green-dark {\n    color: #1f9d55;\n}\n.xl\\:group:hover .group-hover\\:text-green {\n    color: #38c172;\n}\n.xl\\:group:hover .group-hover\\:text-green-light {\n    color: #51d88a;\n}\n.xl\\:group:hover .group-hover\\:text-green-lighter {\n    color: #a2f5bf;\n}\n.xl\\:group:hover .group-hover\\:text-green-lightest {\n    color: #e3fcec;\n}\n.xl\\:group:hover .group-hover\\:text-teal-darkest {\n    color: #0d3331;\n}\n.xl\\:group:hover .group-hover\\:text-teal-darker {\n    color: #20504f;\n}\n.xl\\:group:hover .group-hover\\:text-teal-dark {\n    color: #009480;\n}\n.xl\\:group:hover .group-hover\\:text-teal {\n    color: #00ae98;\n}\n.xl\\:group:hover .group-hover\\:text-teal-light {\n    color: #64d5ca;\n}\n.xl\\:group:hover .group-hover\\:text-teal-lighter {\n    color: #a0f0ed;\n}\n.xl\\:group:hover .group-hover\\:text-teal-lightest {\n    color: #e8fffe;\n}\n.xl\\:group:hover .group-hover\\:text-blue-darkest {\n    color: #12283a;\n}\n.xl\\:group:hover .group-hover\\:text-blue-darker {\n    color: #2e6da2;\n}\n.xl\\:group:hover .group-hover\\:text-blue-dark {\n    color: #2779bd;\n}\n.xl\\:group:hover .group-hover\\:text-blue {\n    color: #3490dc;\n}\n.xl\\:group:hover .group-hover\\:text-blue-light {\n    color: #6cb2eb;\n}\n.xl\\:group:hover .group-hover\\:text-blue-lighter {\n    color: #bcdefa;\n}\n.xl\\:group:hover .group-hover\\:text-blue-lightest {\n    color: #eff8ff;\n}\n.xl\\:group:hover .group-hover\\:text-indigo-darkest {\n    color: #191e38;\n}\n.xl\\:group:hover .group-hover\\:text-indigo-darker {\n    color: #2f365f;\n}\n.xl\\:group:hover .group-hover\\:text-indigo-dark {\n    color: #5661b3;\n}\n.xl\\:group:hover .group-hover\\:text-indigo {\n    color: #6574cd;\n}\n.xl\\:group:hover .group-hover\\:text-indigo-light {\n    color: #7886d7;\n}\n.xl\\:group:hover .group-hover\\:text-indigo-lighter {\n    color: #b2b7ff;\n}\n.xl\\:group:hover .group-hover\\:text-indigo-lightest {\n    color: #e6e8ff;\n}\n.xl\\:group:hover .group-hover\\:text-purple-darkest {\n    color: #21183c;\n}\n.xl\\:group:hover .group-hover\\:text-purple-darker {\n    color: #382b5f;\n}\n.xl\\:group:hover .group-hover\\:text-purple-dark {\n    color: #794acf;\n}\n.xl\\:group:hover .group-hover\\:text-purple {\n    color: #9561e2;\n}\n.xl\\:group:hover .group-hover\\:text-purple-light {\n    color: #a779e9;\n}\n.xl\\:group:hover .group-hover\\:text-purple-lighter {\n    color: #d6bbfc;\n}\n.xl\\:group:hover .group-hover\\:text-purple-lightest {\n    color: #f3ebff;\n}\n.xl\\:group:hover .group-hover\\:text-pink-darkest {\n    color: #451225;\n}\n.xl\\:group:hover .group-hover\\:text-pink-darker {\n    color: #6f213f;\n}\n.xl\\:group:hover .group-hover\\:text-pink-dark {\n    color: #eb5286;\n}\n.xl\\:group:hover .group-hover\\:text-pink {\n    color: #f66d9b;\n}\n.xl\\:group:hover .group-hover\\:text-pink-light {\n    color: #fa7ea8;\n}\n.xl\\:group:hover .group-hover\\:text-pink-lighter {\n    color: #ffbbca;\n}\n.xl\\:group:hover .group-hover\\:text-pink-lightest {\n    color: #ffebef;\n}\n.xl\\:hover\\:text-transparent:hover {\n    color: transparent;\n}\n.xl\\:hover\\:text-modal:hover {\n    color: rgba(0, 0, 0, .4);\n}\n.xl\\:hover\\:text-google:hover {\n    color: #dc5b5b;\n}\n.xl\\:hover\\:text-google-dark:hover {\n    color: #da5050;\n}\n.xl\\:hover\\:text-facebook:hover {\n    color: #3b5998;\n}\n.xl\\:hover\\:text-facebook-dark:hover {\n    color: #37548f;\n}\n.xl\\:hover\\:text-primary:hover {\n    color: #2196f3;\n}\n.xl\\:hover\\:text-primary-dark:hover {\n    color: #3b5998;\n}\n.xl\\:hover\\:text-footer:hover {\n    color: #1976d2;\n}\n.xl\\:hover\\:text-black:hover {\n    color: #22292f;\n}\n.xl\\:hover\\:text-grey-darkest:hover {\n    color: #3d4852;\n}\n.xl\\:hover\\:text-grey-darker:hover {\n    color: #606f7b;\n}\n.xl\\:hover\\:text-grey-dark:hover {\n    color: #8795a1;\n}\n.xl\\:hover\\:text-grey:hover {\n    color: #b8c2cc;\n}\n.xl\\:hover\\:text-grey-light:hover {\n    color: #dae1e7;\n}\n.xl\\:hover\\:text-grey-lighter:hover {\n    color: #f1f5f8;\n}\n.xl\\:hover\\:text-grey-lightest:hover {\n    color: #f8fafc;\n}\n.xl\\:hover\\:text-white:hover {\n    color: #fff;\n}\n.xl\\:hover\\:text-whiter:hover {\n    color: rgba(255, 255, 255, .6);\n}\n.xl\\:hover\\:text-red-darkest:hover {\n    color: #3b0d0c;\n}\n.xl\\:hover\\:text-red-darker:hover {\n    color: #621b18;\n}\n.xl\\:hover\\:text-red-dark:hover {\n    color: #cc1f1a;\n}\n.xl\\:hover\\:text-red:hover {\n    color: #e3342f;\n}\n.xl\\:hover\\:text-red-light:hover {\n    color: #ef5753;\n}\n.xl\\:hover\\:text-red-lighter:hover {\n    color: #f9acaa;\n}\n.xl\\:hover\\:text-red-lightest:hover {\n    color: #fcebea;\n}\n.xl\\:hover\\:text-orange-darkest:hover {\n    color: #462a16;\n}\n.xl\\:hover\\:text-orange-darker:hover {\n    color: #613b1f;\n}\n.xl\\:hover\\:text-orange-dark:hover {\n    color: #de751f;\n}\n.xl\\:hover\\:text-orange:hover {\n    color: #f6993f;\n}\n.xl\\:hover\\:text-orange-light:hover {\n    color: #faad63;\n}\n.xl\\:hover\\:text-orange-lighter:hover {\n    color: #fcd9b6;\n}\n.xl\\:hover\\:text-orange-lightest:hover {\n    color: #fff5eb;\n}\n.xl\\:hover\\:text-yellow-darkest:hover {\n    color: #453411;\n}\n.xl\\:hover\\:text-yellow-darker:hover {\n    color: #684f1d;\n}\n.xl\\:hover\\:text-yellow-dark:hover {\n    color: #f2d024;\n}\n.xl\\:hover\\:text-yellow:hover {\n    color: #ffed4a;\n}\n.xl\\:hover\\:text-yellow-light:hover {\n    color: #fff382;\n}\n.xl\\:hover\\:text-yellow-lighter:hover {\n    color: #fff9c2;\n}\n.xl\\:hover\\:text-yellow-lightest:hover {\n    color: #fcfbeb;\n}\n.xl\\:hover\\:text-green-darkest:hover {\n    color: #0f2f21;\n}\n.xl\\:hover\\:text-green-darker:hover {\n    color: #1a4731;\n}\n.xl\\:hover\\:text-green-dark:hover {\n    color: #1f9d55;\n}\n.xl\\:hover\\:text-green:hover {\n    color: #38c172;\n}\n.xl\\:hover\\:text-green-light:hover {\n    color: #51d88a;\n}\n.xl\\:hover\\:text-green-lighter:hover {\n    color: #a2f5bf;\n}\n.xl\\:hover\\:text-green-lightest:hover {\n    color: #e3fcec;\n}\n.xl\\:hover\\:text-teal-darkest:hover {\n    color: #0d3331;\n}\n.xl\\:hover\\:text-teal-darker:hover {\n    color: #20504f;\n}\n.xl\\:hover\\:text-teal-dark:hover {\n    color: #009480;\n}\n.xl\\:hover\\:text-teal:hover {\n    color: #00ae98;\n}\n.xl\\:hover\\:text-teal-light:hover {\n    color: #64d5ca;\n}\n.xl\\:hover\\:text-teal-lighter:hover {\n    color: #a0f0ed;\n}\n.xl\\:hover\\:text-teal-lightest:hover {\n    color: #e8fffe;\n}\n.xl\\:hover\\:text-blue-darkest:hover {\n    color: #12283a;\n}\n.xl\\:hover\\:text-blue-darker:hover {\n    color: #2e6da2;\n}\n.xl\\:hover\\:text-blue-dark:hover {\n    color: #2779bd;\n}\n.xl\\:hover\\:text-blue:hover {\n    color: #3490dc;\n}\n.xl\\:hover\\:text-blue-light:hover {\n    color: #6cb2eb;\n}\n.xl\\:hover\\:text-blue-lighter:hover {\n    color: #bcdefa;\n}\n.xl\\:hover\\:text-blue-lightest:hover {\n    color: #eff8ff;\n}\n.xl\\:hover\\:text-indigo-darkest:hover {\n    color: #191e38;\n}\n.xl\\:hover\\:text-indigo-darker:hover {\n    color: #2f365f;\n}\n.xl\\:hover\\:text-indigo-dark:hover {\n    color: #5661b3;\n}\n.xl\\:hover\\:text-indigo:hover {\n    color: #6574cd;\n}\n.xl\\:hover\\:text-indigo-light:hover {\n    color: #7886d7;\n}\n.xl\\:hover\\:text-indigo-lighter:hover {\n    color: #b2b7ff;\n}\n.xl\\:hover\\:text-indigo-lightest:hover {\n    color: #e6e8ff;\n}\n.xl\\:hover\\:text-purple-darkest:hover {\n    color: #21183c;\n}\n.xl\\:hover\\:text-purple-darker:hover {\n    color: #382b5f;\n}\n.xl\\:hover\\:text-purple-dark:hover {\n    color: #794acf;\n}\n.xl\\:hover\\:text-purple:hover {\n    color: #9561e2;\n}\n.xl\\:hover\\:text-purple-light:hover {\n    color: #a779e9;\n}\n.xl\\:hover\\:text-purple-lighter:hover {\n    color: #d6bbfc;\n}\n.xl\\:hover\\:text-purple-lightest:hover {\n    color: #f3ebff;\n}\n.xl\\:hover\\:text-pink-darkest:hover {\n    color: #451225;\n}\n.xl\\:hover\\:text-pink-darker:hover {\n    color: #6f213f;\n}\n.xl\\:hover\\:text-pink-dark:hover {\n    color: #eb5286;\n}\n.xl\\:hover\\:text-pink:hover {\n    color: #f66d9b;\n}\n.xl\\:hover\\:text-pink-light:hover {\n    color: #fa7ea8;\n}\n.xl\\:hover\\:text-pink-lighter:hover {\n    color: #ffbbca;\n}\n.xl\\:hover\\:text-pink-lightest:hover {\n    color: #ffebef;\n}\n.xl\\:text-xs {\n    font-size: .75rem;\n}\n.xl\\:text-sm {\n    font-size: .875rem;\n}\n.xl\\:text-base {\n    font-size: 1rem;\n}\n.xl\\:text-lg {\n    font-size: 1.125rem;\n}\n.xl\\:text-xl {\n    font-size: 1.25rem;\n}\n.xl\\:text-2xl {\n    font-size: 1.5rem;\n}\n.xl\\:text-3xl {\n    font-size: 1.875rem;\n}\n.xl\\:text-4xl {\n    font-size: 2.25rem;\n}\n.xl\\:text-5xl {\n    font-size: 3rem;\n}\n.xl\\:italic {\n    font-style: italic;\n}\n.xl\\:roman {\n    font-style: normal;\n}\n.xl\\:uppercase {\n    text-transform: uppercase;\n}\n.xl\\:lowercase {\n    text-transform: lowercase;\n}\n.xl\\:capitalize {\n    text-transform: capitalize;\n}\n.xl\\:normal-case {\n    text-transform: none;\n}\n.xl\\:underline {\n    text-decoration: underline;\n}\n.xl\\:line-through {\n    text-decoration: line-through;\n}\n.xl\\:no-underline {\n    text-decoration: none;\n}\n.xl\\:antialiased {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.xl\\:subpixel-antialiased {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n}\n.xl\\:hover\\:italic:hover {\n    font-style: italic;\n}\n.xl\\:hover\\:roman:hover {\n    font-style: normal;\n}\n.xl\\:hover\\:uppercase:hover {\n    text-transform: uppercase;\n}\n.xl\\:hover\\:lowercase:hover {\n    text-transform: lowercase;\n}\n.xl\\:hover\\:capitalize:hover {\n    text-transform: capitalize;\n}\n.xl\\:hover\\:normal-case:hover {\n    text-transform: none;\n}\n.xl\\:hover\\:underline:hover {\n    text-decoration: underline;\n}\n.xl\\:hover\\:line-through:hover {\n    text-decoration: line-through;\n}\n.xl\\:hover\\:no-underline:hover {\n    text-decoration: none;\n}\n.xl\\:hover\\:antialiased:hover {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.xl\\:hover\\:subpixel-antialiased:hover {\n    -webkit-font-smoothing: auto;\n    -moz-osx-font-smoothing: auto;\n}\n.xl\\:tracking-tight {\n    letter-spacing: -0.05em;\n}\n.xl\\:tracking-normal {\n    letter-spacing: 0;\n}\n.xl\\:tracking-wide {\n    letter-spacing: .05em;\n}\n.xl\\:select-none {\n    user-select: none;\n}\n.xl\\:select-text {\n    user-select: text;\n}\n.xl\\:align-baseline {\n    vertical-align: baseline;\n}\n.xl\\:align-top {\n    vertical-align: top;\n}\n.xl\\:align-middle {\n    vertical-align: middle;\n}\n.xl\\:align-bottom {\n    vertical-align: bottom;\n}\n.xl\\:align-text-top {\n    vertical-align: text-top;\n}\n.xl\\:align-text-bottom {\n    vertical-align: text-bottom;\n}\n.xl\\:visible {\n    visibility: visible;\n}\n.xl\\:invisible {\n    visibility: hidden;\n}\n.xl\\:whitespace-normal {\n    white-space: normal;\n}\n.xl\\:whitespace-no-wrap {\n    white-space: nowrap;\n}\n.xl\\:whitespace-pre {\n    white-space: pre;\n}\n.xl\\:whitespace-pre-line {\n    white-space: pre-line;\n}\n.xl\\:whitespace-pre-wrap {\n    white-space: pre-wrap;\n}\n.xl\\:break-words {\n    word-wrap: break-word;\n}\n.xl\\:break-normal {\n    word-wrap: normal;\n}\n.xl\\:truncate {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.xl\\:w-1 {\n    width: .25rem;\n}\n.xl\\:w-2 {\n    width: .5rem;\n}\n.xl\\:w-3 {\n    width: .75rem;\n}\n.xl\\:w-4 {\n    width: 1rem;\n}\n.xl\\:w-6 {\n    width: 1.5rem;\n}\n.xl\\:w-8 {\n    width: 2rem;\n}\n.xl\\:w-10 {\n    width: 2.5rem;\n}\n.xl\\:w-12 {\n    width: 3rem;\n}\n.xl\\:w-16 {\n    width: 4rem;\n}\n.xl\\:w-24 {\n    width: 6rem;\n}\n.xl\\:w-32 {\n    width: 8rem;\n}\n.xl\\:w-48 {\n    width: 12rem;\n}\n.xl\\:w-64 {\n    width: 16rem;\n}\n.xl\\:w-auto {\n    width: auto;\n}\n.xl\\:w-px {\n    width: 1px;\n}\n.xl\\:w-1\\/2 {\n    width: 50%;\n}\n.xl\\:w-1\\/3 {\n    width: 33.33333%;\n}\n.xl\\:w-2\\/3 {\n    width: 66.66667%;\n}\n.xl\\:w-1\\/4 {\n    width: 25%;\n}\n.xl\\:w-3\\/4 {\n    width: 75%;\n}\n.xl\\:w-1\\/5 {\n    width: 20%;\n}\n.xl\\:w-2\\/5 {\n    width: 40%;\n}\n.xl\\:w-3\\/5 {\n    width: 60%;\n}\n.xl\\:w-4\\/5 {\n    width: 80%;\n}\n.xl\\:w-1\\/6 {\n    width: 16.66667%;\n}\n.xl\\:w-5\\/6 {\n    width: 83.33333%;\n}\n.xl\\:w-full {\n    width: 100%;\n}\n.xl\\:w-screen {\n    width: 100vw;\n}\n.xl\\:z-0 {\n    z-index: 0;\n}\n.xl\\:z-10 {\n    z-index: 10;\n}\n.xl\\:z-20 {\n    z-index: 20;\n}\n.xl\\:z-30 {\n    z-index: 30;\n}\n.xl\\:z-40 {\n    z-index: 40;\n}\n.xl\\:z-50 {\n    z-index: 50;\n}\n.xl\\:z-auto {\n    z-index: auto;\n}\n.xl\\:z-max {\n    z-index: 1051 !important;\n}\n}\n", ""]);

// exports


/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative font-sans antialiased" },
    [
      _vm.patientError
        ? _c("div", { staticClass: "absolute pin-t pin-r mt-10 mr-10" }, [
            _c(
              "div",
              {
                staticClass:
                  "bg-red-light shadow border border-red-light text-white px-4 py-3 rounded relative"
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c("span", {
                  staticClass: "font-semibold",
                  domProps: { textContent: _vm._s(_vm.patientError) }
                })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("router-view", {
        staticClass: "min-h-(screen-footer-sm) md:min-h-(screen-footer-md)"
      }),
      _vm._v(" "),
      _c(
        "footer",
        { staticClass: "py-12 bg-footer text-white", attrs: { id: "footer" } },
        [
          _c("div", { staticClass: "max-w-md mx-auto px-6" }, [
            _c(
              "div",
              { staticClass: "flex items-top flex-wrap md:justify-between" },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "w-full md:w-auto flex flex-col justify-center md:justify-start"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "flex justify-center md:justify-start mb-4"
                      },
                      [
                        _c("router-link", { attrs: { to: { path: "/" } } }, [
                          _c("img", {
                            staticClass: "h-4",
                            attrs: {
                              src: "/static/img/tooddoc.png",
                              alt: "Tooddoc"
                            }
                          })
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex justify-center md:flex-col md:justify-start mb-8 md:mb-0"
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass:
                              "transition md:opacity-50 hover:opacity-100 mx-2 md:mx-0 md:mb-4",
                            attrs: {
                              href: _vm.$t("play_store_uri"),
                              target: "_blank"
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "h-10",
                              attrs: {
                                src: "/static/img/play_store_hover.svg",
                                alt: "Get it on Google Play"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "transition md:opacity-50 hover:opacity-100 mx-2 md:mx-0",
                            attrs: {
                              href: _vm.$t("app_store_uri"),
                              target: "_blank"
                            }
                          },
                          [
                            _c("img", {
                              staticClass: "h-10",
                              attrs: {
                                src: "/static/img/app_store_hover.svg",
                                alt: "Get it on the App Store"
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "w-full md:w-auto flex md:flex-col items-center justify-center md:justify-start md:items-start md:text-left mb-8 md:mb-0"
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold md:mb-4",
                        attrs: { href: _vm.$t("public_site_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("public_site_label")))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "mx-2 md:hidden" }, [
                      _vm._v("-")
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold md:mb-4",
                        attrs: { href: _vm.$t("contact_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("contact_label")))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "mx-2 md:hidden" }, [
                      _vm._v("-")
                    ]),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold md:mb-4",
                        attrs: { to: { name: "doctor.dashboard" } }
                      },
                      [_vm._v(_vm._s(_vm.$t("i_am_a_dentist_label")))]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "hidden md:flex w-auto flex-col text-left" },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold mb-4",
                        attrs: { href: _vm.$t("terms_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("terms_label")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold mb-4",
                        attrs: { href: _vm.$t("privacy_policy_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("privacy_policy_label")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold mb-4",
                        attrs: { href: _vm.$t("cookie_policy_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("cookie_policy_label")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex md:hidden w-full md:w-auto items-center justify-center text-center"
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold",
                        attrs: { href: _vm.$t("terms_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("terms_label")))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "mx-2" }, [_vm._v("-")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold",
                        attrs: { href: _vm.$t("privacy_policy_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("privacy_policy_label")))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "mx-2" }, [_vm._v("-")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass:
                          "text-white hover:underline text-xs font-semibold",
                        attrs: { href: _vm.$t("cookie_policy_uri") }
                      },
                      [_vm._v(_vm._s(_vm.$t("cookie_policy_label")))]
                    )
                  ]
                )
              ]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm.showCookieNotification
        ? _c("div", { staticClass: "fixed pin-x pin-b mb-4" }, [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center justify-between rounded bg-blue text-white max-w-sm mx-auto px-4 py-3"
              },
              [
                _c("span", {
                  domProps: {
                    textContent: _vm._s(_vm.$t("cookie_notification"))
                  }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "text-blue-lighter hover:text-blue-lightest",
                    on: {
                      click: function($event) {
                        return _vm.consentCookies()
                      }
                    }
                  },
                  [_vm._m(1)]
                )
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon mr-1 text-lg" }, [
      _c("i", { staticClass: "mdi mdi-alert-circle-outline" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "icon" }, [
      _c("i", { staticClass: "mdi mdi-close" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6de776e0", esExports)
  }
}

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorLayout_vue__ = __webpack_require__(401);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4766e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorLayout_vue__ = __webpack_require__(806);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(797)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DoctorLayout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4766e8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DoctorLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/layouts/DoctorLayout.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4a4766e8", Component.options)
  } else {
    hotAPI.reload("data-v-4a4766e8", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(798);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(20)("7849b2ef", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4a4766e8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!./app.scss", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-4a4766e8\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!./app.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(393);
exports = module.exports = __webpack_require__(19)(false);
// imports


// module
exports.push([module.i, "\n@-webkit-keyframes spinAround {\nfrom {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n@keyframes spinAround {\nfrom {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n.delete,\n.modal-close,\n.is-unselectable,\n.button,\n.file,\n.breadcrumb,\n.pagination-previous,\n.pagination-next,\n.pagination-link,\n.pagination-ellipsis,\n.tabs {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.select:not(.is-multiple):not(.is-loading)::after,\n.navbar-link:not(.is-arrowless)::after {\n  border: 3px solid transparent;\n  border-radius: 2px;\n  border-right: 0;\n  border-top: 0;\n  content: \" \";\n  display: block;\n  height: .625em;\n  margin-top: -0.4375em;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: rotate(-45deg);\n          transform: rotate(-45deg);\n  -webkit-transform-origin: center;\n           transform-origin: center;\n  width: .625em;\n}\n.box:not(:last-child),\n.content:not(:last-child),\n.notification:not(:last-child),\n.progress:not(:last-child),\n.table:not(:last-child),\n.table-container:not(:last-child),\n.title:not(:last-child),\n.subtitle:not(:last-child),\n.block:not(:last-child),\n.highlight:not(:last-child),\n.breadcrumb:not(:last-child),\n.level:not(:last-child),\n.list:not(:last-child),\n.message:not(:last-child),\n.tabs:not(:last-child) {\n  margin-bottom: 1.5rem;\n}\n.delete,\n.modal-close {\n     -moz-appearance: none;\n  -webkit-appearance: none;\n  background-color: rgba(10, 10, 10, .2);\n  border: none;\n  border-radius: 290486px;\n  cursor: pointer;\n  pointer-events: auto;\n  display: inline-block;\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  font-size: 0;\n  height: 20px;\n  max-height: 20px;\n  max-width: 20px;\n  min-height: 20px;\n  min-width: 20px;\n  outline: none;\n  position: relative;\n  vertical-align: top;\n  width: 20px;\n}\n.delete::before,\n.modal-close::before,\n.delete::after,\n.modal-close::after {\n  background-color: white;\n  content: \"\";\n  display: block;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);\n          transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  -webkit-transform-origin: center center;\n           transform-origin: center center;\n}\n.delete::before,\n.modal-close::before {\n  height: 2px;\n  width: 50%;\n}\n.delete::after,\n.modal-close::after {\n  height: 50%;\n  width: 2px;\n}\n.delete:hover,\n.modal-close:hover,\n.delete:focus,\n.modal-close:focus {\n  background-color: rgba(10, 10, 10, .3);\n}\n.delete:active,\n.modal-close:active {\n  background-color: rgba(10, 10, 10, .4);\n}\n.is-small.delete,\n.is-small.modal-close {\n  height: 16px;\n  max-height: 16px;\n  max-width: 16px;\n  min-height: 16px;\n  min-width: 16px;\n  width: 16px;\n}\n.is-medium.delete,\n.is-medium.modal-close {\n  height: 24px;\n  max-height: 24px;\n  max-width: 24px;\n  min-height: 24px;\n  min-width: 24px;\n  width: 24px;\n}\n.is-large.delete,\n.is-large.modal-close {\n  height: 32px;\n  max-height: 32px;\n  max-width: 32px;\n  min-height: 32px;\n  min-width: 32px;\n  width: 32px;\n}\n.button.is-loading::after,\n.select.is-loading::after,\n.control.is-loading::after,\n.loader {\n  -webkit-animation: spinAround 500ms infinite linear;\n          animation: spinAround 500ms infinite linear;\n  border: 2px solid #dbdbdb;\n  border-radius: 290486px;\n  border-right-color: transparent;\n  border-top-color: transparent;\n  content: \"\";\n  display: block;\n  height: 1em;\n  position: relative;\n  width: 1em;\n}\n.is-overlay,\n.image.is-square img,\n.image.is-square .has-ratio,\n.image.is-1by1 img,\n.image.is-1by1 .has-ratio,\n.image.is-5by4 img,\n.image.is-5by4 .has-ratio,\n.image.is-4by3 img,\n.image.is-4by3 .has-ratio,\n.image.is-3by2 img,\n.image.is-3by2 .has-ratio,\n.image.is-5by3 img,\n.image.is-5by3 .has-ratio,\n.image.is-16by9 img,\n.image.is-16by9 .has-ratio,\n.image.is-2by1 img,\n.image.is-2by1 .has-ratio,\n.image.is-3by1 img,\n.image.is-3by1 .has-ratio,\n.image.is-4by5 img,\n.image.is-4by5 .has-ratio,\n.image.is-3by4 img,\n.image.is-3by4 .has-ratio,\n.image.is-2by3 img,\n.image.is-2by3 .has-ratio,\n.image.is-3by5 img,\n.image.is-3by5 .has-ratio,\n.image.is-9by16 img,\n.image.is-9by16 .has-ratio,\n.image.is-1by2 img,\n.image.is-1by2 .has-ratio,\n.image.is-1by3 img,\n.image.is-1by3 .has-ratio,\n.modal,\n.modal-background,\n.hero-video {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.button,\n.input,\n.taginput .taginput-container.is-focusable,\n.textarea,\n.select select,\n.file-cta,\n.file-name,\n.pagination-previous,\n.pagination-next,\n.pagination-link,\n.pagination-ellipsis {\n     -moz-appearance: none;\n  -webkit-appearance: none;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  font-size: 1rem;\n  height: 2.25em;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  line-height: 1.5;\n  padding-bottom: calc(.375em - 1px);\n  padding-left: calc(.625em - 1px);\n  padding-right: calc(.625em - 1px);\n  padding-top: calc(.375em - 1px);\n  position: relative;\n  vertical-align: top;\n}\n.button:focus,\n.input:focus,\n.taginput .taginput-container.is-focusable:focus,\n.textarea:focus,\n.select select:focus,\n.file-cta:focus,\n.file-name:focus,\n.pagination-previous:focus,\n.pagination-next:focus,\n.pagination-link:focus,\n.pagination-ellipsis:focus,\n.is-focused.button,\n.is-focused.input,\n.taginput .is-focused.taginput-container.is-focusable,\n.is-focused.textarea,\n.select select.is-focused,\n.is-focused.file-cta,\n.is-focused.file-name,\n.is-focused.pagination-previous,\n.is-focused.pagination-next,\n.is-focused.pagination-link,\n.is-focused.pagination-ellipsis,\n.button:active,\n.input:active,\n.taginput .taginput-container.is-focusable:active,\n.textarea:active,\n.select select:active,\n.file-cta:active,\n.file-name:active,\n.pagination-previous:active,\n.pagination-next:active,\n.pagination-link:active,\n.pagination-ellipsis:active,\n.is-active.button,\n.is-active.input,\n.taginput .is-active.taginput-container.is-focusable,\n.is-active.textarea,\n.select select.is-active,\n.is-active.file-cta,\n.is-active.file-name,\n.is-active.pagination-previous,\n.is-active.pagination-next,\n.is-active.pagination-link,\n.is-active.pagination-ellipsis {\n  outline: none;\n}\n.button[disabled],\n.input[disabled],\n.taginput .taginput-container.is-focusable[disabled],\n.textarea[disabled],\n.select select[disabled],\n.file-cta[disabled],\n.file-name[disabled],\n.pagination-previous[disabled],\n.pagination-next[disabled],\n.pagination-link[disabled],\n.pagination-ellipsis[disabled],\nfieldset[disabled] .button,\nfieldset[disabled] .input,\nfieldset[disabled] .taginput .taginput-container.is-focusable,\n.taginput fieldset[disabled] .taginput-container.is-focusable,\nfieldset[disabled] .textarea,\nfieldset[disabled] .select select,\n.select fieldset[disabled] select,\nfieldset[disabled] .file-cta,\nfieldset[disabled] .file-name,\nfieldset[disabled] .pagination-previous,\nfieldset[disabled] .pagination-next,\nfieldset[disabled] .pagination-link,\nfieldset[disabled] .pagination-ellipsis {\n  cursor: not-allowed;\n}\n\n/* MaterialDesignIcons.com */\n@font-face {\n  font-family: \"Material Design Icons\";\n  src: url(" + escape(__webpack_require__(394)) + ");\n  src: url(" + escape(__webpack_require__(395)) + "?#iefix&v=2.2.43) format(\"embedded-opentype\"), url(" + escape(__webpack_require__(396)) + ") format(\"woff2\"), url(" + escape(__webpack_require__(397)) + ") format(\"woff\"), url(" + escape(__webpack_require__(398)) + ") format(\"truetype\"), url(" + escape(__webpack_require__(399)) + "#materialdesigniconsregular) format(\"svg\");\n  font-weight: normal;\n  font-style: normal;\n}\n.mdi:before,\n.mdi-set {\n  display: inline-block;\n  font: normal normal normal 24px/1 \"Material Design Icons\";\n  font-size: inherit;\n  text-rendering: auto;\n  line-height: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.mdi-access-point:before {\n  content: \"\\F002\";\n}\n.mdi-access-point-network:before {\n  content: \"\\F003\";\n}\n.mdi-account:before {\n  content: \"\\F004\";\n}\n.mdi-account-alert:before {\n  content: \"\\F005\";\n}\n.mdi-account-box:before {\n  content: \"\\F006\";\n}\n.mdi-account-box-outline:before {\n  content: \"\\F007\";\n}\n.mdi-account-card-details:before {\n  content: \"\\F5D2\";\n}\n.mdi-account-check:before {\n  content: \"\\F008\";\n}\n.mdi-account-circle:before {\n  content: \"\\F009\";\n}\n.mdi-account-convert:before {\n  content: \"\\F00A\";\n}\n.mdi-account-edit:before {\n  content: \"\\F6BB\";\n}\n.mdi-account-group:before {\n  content: \"\\F848\";\n}\n.mdi-account-heart:before {\n  content: \"\\F898\";\n}\n.mdi-account-key:before {\n  content: \"\\F00B\";\n}\n.mdi-account-location:before {\n  content: \"\\F00C\";\n}\n.mdi-account-minus:before {\n  content: \"\\F00D\";\n}\n.mdi-account-multiple:before {\n  content: \"\\F00E\";\n}\n.mdi-account-multiple-minus:before {\n  content: \"\\F5D3\";\n}\n.mdi-account-multiple-outline:before {\n  content: \"\\F00F\";\n}\n.mdi-account-multiple-plus:before {\n  content: \"\\F010\";\n}\n.mdi-account-multiple-plus-outline:before {\n  content: \"\\F7FF\";\n}\n.mdi-account-network:before {\n  content: \"\\F011\";\n}\n.mdi-account-off:before {\n  content: \"\\F012\";\n}\n.mdi-account-outline:before {\n  content: \"\\F013\";\n}\n.mdi-account-plus:before {\n  content: \"\\F014\";\n}\n.mdi-account-plus-outline:before {\n  content: \"\\F800\";\n}\n.mdi-account-remove:before {\n  content: \"\\F015\";\n}\n.mdi-account-search:before {\n  content: \"\\F016\";\n}\n.mdi-account-settings:before {\n  content: \"\\F630\";\n}\n.mdi-account-settings-variant:before {\n  content: \"\\F631\";\n}\n.mdi-account-star:before {\n  content: \"\\F017\";\n}\n.mdi-account-switch:before {\n  content: \"\\F019\";\n}\n.mdi-accusoft:before {\n  content: \"\\F849\";\n}\n.mdi-adjust:before {\n  content: \"\\F01A\";\n}\n.mdi-air-conditioner:before {\n  content: \"\\F01B\";\n}\n.mdi-airballoon:before {\n  content: \"\\F01C\";\n}\n.mdi-airplane:before {\n  content: \"\\F01D\";\n}\n.mdi-airplane-landing:before {\n  content: \"\\F5D4\";\n}\n.mdi-airplane-off:before {\n  content: \"\\F01E\";\n}\n.mdi-airplane-takeoff:before {\n  content: \"\\F5D5\";\n}\n.mdi-airplay:before {\n  content: \"\\F01F\";\n}\n.mdi-airport:before {\n  content: \"\\F84A\";\n}\n.mdi-alarm:before {\n  content: \"\\F020\";\n}\n.mdi-alarm-bell:before {\n  content: \"\\F78D\";\n}\n.mdi-alarm-check:before {\n  content: \"\\F021\";\n}\n.mdi-alarm-light:before {\n  content: \"\\F78E\";\n}\n.mdi-alarm-multiple:before {\n  content: \"\\F022\";\n}\n.mdi-alarm-off:before {\n  content: \"\\F023\";\n}\n.mdi-alarm-plus:before {\n  content: \"\\F024\";\n}\n.mdi-alarm-snooze:before {\n  content: \"\\F68D\";\n}\n.mdi-album:before {\n  content: \"\\F025\";\n}\n.mdi-alert:before {\n  content: \"\\F026\";\n}\n.mdi-alert-box:before {\n  content: \"\\F027\";\n}\n.mdi-alert-circle:before {\n  content: \"\\F028\";\n}\n.mdi-alert-circle-outline:before {\n  content: \"\\F5D6\";\n}\n.mdi-alert-decagram:before {\n  content: \"\\F6BC\";\n}\n.mdi-alert-octagon:before {\n  content: \"\\F029\";\n}\n.mdi-alert-octagram:before {\n  content: \"\\F766\";\n}\n.mdi-alert-outline:before {\n  content: \"\\F02A\";\n}\n.mdi-alien:before {\n  content: \"\\F899\";\n}\n.mdi-all-inclusive:before {\n  content: \"\\F6BD\";\n}\n.mdi-allo:before {\n  content: \"\\F801\";\n}\n.mdi-alpha:before {\n  content: \"\\F02B\";\n}\n.mdi-alphabetical:before {\n  content: \"\\F02C\";\n}\n.mdi-altimeter:before {\n  content: \"\\F5D7\";\n}\n.mdi-amazon:before {\n  content: \"\\F02D\";\n}\n.mdi-amazon-clouddrive:before {\n  content: \"\\F02E\";\n}\n.mdi-ambulance:before {\n  content: \"\\F02F\";\n}\n.mdi-amplifier:before {\n  content: \"\\F030\";\n}\n.mdi-anchor:before {\n  content: \"\\F031\";\n}\n.mdi-android:before {\n  content: \"\\F032\";\n}\n.mdi-android-debug-bridge:before {\n  content: \"\\F033\";\n}\n.mdi-android-head:before {\n  content: \"\\F78F\";\n}\n.mdi-android-studio:before {\n  content: \"\\F034\";\n}\n.mdi-angular:before {\n  content: \"\\F6B1\";\n}\n.mdi-angularjs:before {\n  content: \"\\F6BE\";\n}\n.mdi-animation:before {\n  content: \"\\F5D8\";\n}\n.mdi-anvil:before {\n  content: \"\\F89A\";\n}\n.mdi-apple:before {\n  content: \"\\F035\";\n}\n.mdi-apple-finder:before {\n  content: \"\\F036\";\n}\n.mdi-apple-ios:before {\n  content: \"\\F037\";\n}\n.mdi-apple-keyboard-caps:before {\n  content: \"\\F632\";\n}\n.mdi-apple-keyboard-command:before {\n  content: \"\\F633\";\n}\n.mdi-apple-keyboard-control:before {\n  content: \"\\F634\";\n}\n.mdi-apple-keyboard-option:before {\n  content: \"\\F635\";\n}\n.mdi-apple-keyboard-shift:before {\n  content: \"\\F636\";\n}\n.mdi-apple-mobileme:before {\n  content: \"\\F038\";\n}\n.mdi-apple-safari:before {\n  content: \"\\F039\";\n}\n.mdi-application:before {\n  content: \"\\F614\";\n}\n.mdi-approval:before {\n  content: \"\\F790\";\n}\n.mdi-apps:before {\n  content: \"\\F03B\";\n}\n.mdi-archive:before {\n  content: \"\\F03C\";\n}\n.mdi-arrange-bring-forward:before {\n  content: \"\\F03D\";\n}\n.mdi-arrange-bring-to-front:before {\n  content: \"\\F03E\";\n}\n.mdi-arrange-send-backward:before {\n  content: \"\\F03F\";\n}\n.mdi-arrange-send-to-back:before {\n  content: \"\\F040\";\n}\n.mdi-arrow-all:before {\n  content: \"\\F041\";\n}\n.mdi-arrow-bottom-left:before {\n  content: \"\\F042\";\n}\n.mdi-arrow-bottom-right:before {\n  content: \"\\F043\";\n}\n.mdi-arrow-collapse:before {\n  content: \"\\F615\";\n}\n.mdi-arrow-collapse-all:before {\n  content: \"\\F044\";\n}\n.mdi-arrow-collapse-down:before {\n  content: \"\\F791\";\n}\n.mdi-arrow-collapse-horizontal:before {\n  content: \"\\F84B\";\n}\n.mdi-arrow-collapse-left:before {\n  content: \"\\F792\";\n}\n.mdi-arrow-collapse-right:before {\n  content: \"\\F793\";\n}\n.mdi-arrow-collapse-up:before {\n  content: \"\\F794\";\n}\n.mdi-arrow-collapse-vertical:before {\n  content: \"\\F84C\";\n}\n.mdi-arrow-down:before {\n  content: \"\\F045\";\n}\n.mdi-arrow-down-bold:before {\n  content: \"\\F72D\";\n}\n.mdi-arrow-down-bold-box:before {\n  content: \"\\F72E\";\n}\n.mdi-arrow-down-bold-box-outline:before {\n  content: \"\\F72F\";\n}\n.mdi-arrow-down-bold-circle:before {\n  content: \"\\F047\";\n}\n.mdi-arrow-down-bold-circle-outline:before {\n  content: \"\\F048\";\n}\n.mdi-arrow-down-bold-hexagon-outline:before {\n  content: \"\\F049\";\n}\n.mdi-arrow-down-box:before {\n  content: \"\\F6BF\";\n}\n.mdi-arrow-down-drop-circle:before {\n  content: \"\\F04A\";\n}\n.mdi-arrow-down-drop-circle-outline:before {\n  content: \"\\F04B\";\n}\n.mdi-arrow-down-thick:before {\n  content: \"\\F046\";\n}\n.mdi-arrow-expand:before {\n  content: \"\\F616\";\n}\n.mdi-arrow-expand-all:before {\n  content: \"\\F04C\";\n}\n.mdi-arrow-expand-down:before {\n  content: \"\\F795\";\n}\n.mdi-arrow-expand-horizontal:before {\n  content: \"\\F84D\";\n}\n.mdi-arrow-expand-left:before {\n  content: \"\\F796\";\n}\n.mdi-arrow-expand-right:before {\n  content: \"\\F797\";\n}\n.mdi-arrow-expand-up:before {\n  content: \"\\F798\";\n}\n.mdi-arrow-expand-vertical:before {\n  content: \"\\F84E\";\n}\n.mdi-arrow-left:before {\n  content: \"\\F04D\";\n}\n.mdi-arrow-left-bold:before {\n  content: \"\\F730\";\n}\n.mdi-arrow-left-bold-box:before {\n  content: \"\\F731\";\n}\n.mdi-arrow-left-bold-box-outline:before {\n  content: \"\\F732\";\n}\n.mdi-arrow-left-bold-circle:before {\n  content: \"\\F04F\";\n}\n.mdi-arrow-left-bold-circle-outline:before {\n  content: \"\\F050\";\n}\n.mdi-arrow-left-bold-hexagon-outline:before {\n  content: \"\\F051\";\n}\n.mdi-arrow-left-box:before {\n  content: \"\\F6C0\";\n}\n.mdi-arrow-left-drop-circle:before {\n  content: \"\\F052\";\n}\n.mdi-arrow-left-drop-circle-outline:before {\n  content: \"\\F053\";\n}\n.mdi-arrow-left-thick:before {\n  content: \"\\F04E\";\n}\n.mdi-arrow-right:before {\n  content: \"\\F054\";\n}\n.mdi-arrow-right-bold:before {\n  content: \"\\F733\";\n}\n.mdi-arrow-right-bold-box:before {\n  content: \"\\F734\";\n}\n.mdi-arrow-right-bold-box-outline:before {\n  content: \"\\F735\";\n}\n.mdi-arrow-right-bold-circle:before {\n  content: \"\\F056\";\n}\n.mdi-arrow-right-bold-circle-outline:before {\n  content: \"\\F057\";\n}\n.mdi-arrow-right-bold-hexagon-outline:before {\n  content: \"\\F058\";\n}\n.mdi-arrow-right-box:before {\n  content: \"\\F6C1\";\n}\n.mdi-arrow-right-drop-circle:before {\n  content: \"\\F059\";\n}\n.mdi-arrow-right-drop-circle-outline:before {\n  content: \"\\F05A\";\n}\n.mdi-arrow-right-thick:before {\n  content: \"\\F055\";\n}\n.mdi-arrow-top-left:before {\n  content: \"\\F05B\";\n}\n.mdi-arrow-top-right:before {\n  content: \"\\F05C\";\n}\n.mdi-arrow-up:before {\n  content: \"\\F05D\";\n}\n.mdi-arrow-up-bold:before {\n  content: \"\\F736\";\n}\n.mdi-arrow-up-bold-box:before {\n  content: \"\\F737\";\n}\n.mdi-arrow-up-bold-box-outline:before {\n  content: \"\\F738\";\n}\n.mdi-arrow-up-bold-circle:before {\n  content: \"\\F05F\";\n}\n.mdi-arrow-up-bold-circle-outline:before {\n  content: \"\\F060\";\n}\n.mdi-arrow-up-bold-hexagon-outline:before {\n  content: \"\\F061\";\n}\n.mdi-arrow-up-box:before {\n  content: \"\\F6C2\";\n}\n.mdi-arrow-up-drop-circle:before {\n  content: \"\\F062\";\n}\n.mdi-arrow-up-drop-circle-outline:before {\n  content: \"\\F063\";\n}\n.mdi-arrow-up-thick:before {\n  content: \"\\F05E\";\n}\n.mdi-artist:before {\n  content: \"\\F802\";\n}\n.mdi-assistant:before {\n  content: \"\\F064\";\n}\n.mdi-asterisk:before {\n  content: \"\\F6C3\";\n}\n.mdi-at:before {\n  content: \"\\F065\";\n}\n.mdi-atlassian:before {\n  content: \"\\F803\";\n}\n.mdi-atom:before {\n  content: \"\\F767\";\n}\n.mdi-attachment:before {\n  content: \"\\F066\";\n}\n.mdi-audiobook:before {\n  content: \"\\F067\";\n}\n.mdi-augmented-reality:before {\n  content: \"\\F84F\";\n}\n.mdi-auto-fix:before {\n  content: \"\\F068\";\n}\n.mdi-auto-upload:before {\n  content: \"\\F069\";\n}\n.mdi-autorenew:before {\n  content: \"\\F06A\";\n}\n.mdi-av-timer:before {\n  content: \"\\F06B\";\n}\n.mdi-azure:before {\n  content: \"\\F804\";\n}\n.mdi-baby:before {\n  content: \"\\F06C\";\n}\n.mdi-baby-buggy:before {\n  content: \"\\F68E\";\n}\n.mdi-backburger:before {\n  content: \"\\F06D\";\n}\n.mdi-backspace:before {\n  content: \"\\F06E\";\n}\n.mdi-backup-restore:before {\n  content: \"\\F06F\";\n}\n.mdi-badminton:before {\n  content: \"\\F850\";\n}\n.mdi-bandcamp:before {\n  content: \"\\F674\";\n}\n.mdi-bank:before {\n  content: \"\\F070\";\n}\n.mdi-barcode:before {\n  content: \"\\F071\";\n}\n.mdi-barcode-scan:before {\n  content: \"\\F072\";\n}\n.mdi-barley:before {\n  content: \"\\F073\";\n}\n.mdi-barrel:before {\n  content: \"\\F074\";\n}\n.mdi-baseball:before {\n  content: \"\\F851\";\n}\n.mdi-baseball-bat:before {\n  content: \"\\F852\";\n}\n.mdi-basecamp:before {\n  content: \"\\F075\";\n}\n.mdi-basket:before {\n  content: \"\\F076\";\n}\n.mdi-basket-fill:before {\n  content: \"\\F077\";\n}\n.mdi-basket-unfill:before {\n  content: \"\\F078\";\n}\n.mdi-basketball:before {\n  content: \"\\F805\";\n}\n.mdi-battery:before {\n  content: \"\\F079\";\n}\n.mdi-battery-10:before {\n  content: \"\\F07A\";\n}\n.mdi-battery-20:before {\n  content: \"\\F07B\";\n}\n.mdi-battery-30:before {\n  content: \"\\F07C\";\n}\n.mdi-battery-40:before {\n  content: \"\\F07D\";\n}\n.mdi-battery-50:before {\n  content: \"\\F07E\";\n}\n.mdi-battery-60:before {\n  content: \"\\F07F\";\n}\n.mdi-battery-70:before {\n  content: \"\\F080\";\n}\n.mdi-battery-80:before {\n  content: \"\\F081\";\n}\n.mdi-battery-90:before {\n  content: \"\\F082\";\n}\n.mdi-battery-alert:before {\n  content: \"\\F083\";\n}\n.mdi-battery-charging:before {\n  content: \"\\F084\";\n}\n.mdi-battery-charging-10:before {\n  content: \"\\F89B\";\n}\n.mdi-battery-charging-100:before {\n  content: \"\\F085\";\n}\n.mdi-battery-charging-20:before {\n  content: \"\\F086\";\n}\n.mdi-battery-charging-30:before {\n  content: \"\\F087\";\n}\n.mdi-battery-charging-40:before {\n  content: \"\\F088\";\n}\n.mdi-battery-charging-50:before {\n  content: \"\\F89C\";\n}\n.mdi-battery-charging-60:before {\n  content: \"\\F089\";\n}\n.mdi-battery-charging-70:before {\n  content: \"\\F89D\";\n}\n.mdi-battery-charging-80:before {\n  content: \"\\F08A\";\n}\n.mdi-battery-charging-90:before {\n  content: \"\\F08B\";\n}\n.mdi-battery-charging-outline:before {\n  content: \"\\F89E\";\n}\n.mdi-battery-charging-wireless:before {\n  content: \"\\F806\";\n}\n.mdi-battery-charging-wireless-10:before {\n  content: \"\\F807\";\n}\n.mdi-battery-charging-wireless-20:before {\n  content: \"\\F808\";\n}\n.mdi-battery-charging-wireless-30:before {\n  content: \"\\F809\";\n}\n.mdi-battery-charging-wireless-40:before {\n  content: \"\\F80A\";\n}\n.mdi-battery-charging-wireless-50:before {\n  content: \"\\F80B\";\n}\n.mdi-battery-charging-wireless-60:before {\n  content: \"\\F80C\";\n}\n.mdi-battery-charging-wireless-70:before {\n  content: \"\\F80D\";\n}\n.mdi-battery-charging-wireless-80:before {\n  content: \"\\F80E\";\n}\n.mdi-battery-charging-wireless-90:before {\n  content: \"\\F80F\";\n}\n.mdi-battery-charging-wireless-alert:before {\n  content: \"\\F810\";\n}\n.mdi-battery-charging-wireless-outline:before {\n  content: \"\\F811\";\n}\n.mdi-battery-minus:before {\n  content: \"\\F08C\";\n}\n.mdi-battery-negative:before {\n  content: \"\\F08D\";\n}\n.mdi-battery-outline:before {\n  content: \"\\F08E\";\n}\n.mdi-battery-plus:before {\n  content: \"\\F08F\";\n}\n.mdi-battery-positive:before {\n  content: \"\\F090\";\n}\n.mdi-battery-unknown:before {\n  content: \"\\F091\";\n}\n.mdi-beach:before {\n  content: \"\\F092\";\n}\n.mdi-beaker:before {\n  content: \"\\F68F\";\n}\n.mdi-beats:before {\n  content: \"\\F097\";\n}\n.mdi-bed-empty:before {\n  content: \"\\F89F\";\n}\n.mdi-beer:before {\n  content: \"\\F098\";\n}\n.mdi-behance:before {\n  content: \"\\F099\";\n}\n.mdi-bell:before {\n  content: \"\\F09A\";\n}\n.mdi-bell-off:before {\n  content: \"\\F09B\";\n}\n.mdi-bell-outline:before {\n  content: \"\\F09C\";\n}\n.mdi-bell-plus:before {\n  content: \"\\F09D\";\n}\n.mdi-bell-ring:before {\n  content: \"\\F09E\";\n}\n.mdi-bell-ring-outline:before {\n  content: \"\\F09F\";\n}\n.mdi-bell-sleep:before {\n  content: \"\\F0A0\";\n}\n.mdi-beta:before {\n  content: \"\\F0A1\";\n}\n.mdi-bible:before {\n  content: \"\\F0A2\";\n}\n.mdi-bike:before {\n  content: \"\\F0A3\";\n}\n.mdi-bing:before {\n  content: \"\\F0A4\";\n}\n.mdi-binoculars:before {\n  content: \"\\F0A5\";\n}\n.mdi-bio:before {\n  content: \"\\F0A6\";\n}\n.mdi-biohazard:before {\n  content: \"\\F0A7\";\n}\n.mdi-bitbucket:before {\n  content: \"\\F0A8\";\n}\n.mdi-bitcoin:before {\n  content: \"\\F812\";\n}\n.mdi-black-mesa:before {\n  content: \"\\F0A9\";\n}\n.mdi-blackberry:before {\n  content: \"\\F0AA\";\n}\n.mdi-blender:before {\n  content: \"\\F0AB\";\n}\n.mdi-blinds:before {\n  content: \"\\F0AC\";\n}\n.mdi-block-helper:before {\n  content: \"\\F0AD\";\n}\n.mdi-blogger:before {\n  content: \"\\F0AE\";\n}\n.mdi-bluetooth:before {\n  content: \"\\F0AF\";\n}\n.mdi-bluetooth-audio:before {\n  content: \"\\F0B0\";\n}\n.mdi-bluetooth-connect:before {\n  content: \"\\F0B1\";\n}\n.mdi-bluetooth-off:before {\n  content: \"\\F0B2\";\n}\n.mdi-bluetooth-settings:before {\n  content: \"\\F0B3\";\n}\n.mdi-bluetooth-transfer:before {\n  content: \"\\F0B4\";\n}\n.mdi-blur:before {\n  content: \"\\F0B5\";\n}\n.mdi-blur-linear:before {\n  content: \"\\F0B6\";\n}\n.mdi-blur-off:before {\n  content: \"\\F0B7\";\n}\n.mdi-blur-radial:before {\n  content: \"\\F0B8\";\n}\n.mdi-bomb:before {\n  content: \"\\F690\";\n}\n.mdi-bomb-off:before {\n  content: \"\\F6C4\";\n}\n.mdi-bone:before {\n  content: \"\\F0B9\";\n}\n.mdi-book:before {\n  content: \"\\F0BA\";\n}\n.mdi-book-minus:before {\n  content: \"\\F5D9\";\n}\n.mdi-book-multiple:before {\n  content: \"\\F0BB\";\n}\n.mdi-book-multiple-variant:before {\n  content: \"\\F0BC\";\n}\n.mdi-book-open:before {\n  content: \"\\F0BD\";\n}\n.mdi-book-open-page-variant:before {\n  content: \"\\F5DA\";\n}\n.mdi-book-open-variant:before {\n  content: \"\\F0BE\";\n}\n.mdi-book-plus:before {\n  content: \"\\F5DB\";\n}\n.mdi-book-secure:before {\n  content: \"\\F799\";\n}\n.mdi-book-unsecure:before {\n  content: \"\\F79A\";\n}\n.mdi-book-variant:before {\n  content: \"\\F0BF\";\n}\n.mdi-bookmark:before {\n  content: \"\\F0C0\";\n}\n.mdi-bookmark-check:before {\n  content: \"\\F0C1\";\n}\n.mdi-bookmark-music:before {\n  content: \"\\F0C2\";\n}\n.mdi-bookmark-outline:before {\n  content: \"\\F0C3\";\n}\n.mdi-bookmark-plus:before {\n  content: \"\\F0C5\";\n}\n.mdi-bookmark-plus-outline:before {\n  content: \"\\F0C4\";\n}\n.mdi-bookmark-remove:before {\n  content: \"\\F0C6\";\n}\n.mdi-boombox:before {\n  content: \"\\F5DC\";\n}\n.mdi-bootstrap:before {\n  content: \"\\F6C5\";\n}\n.mdi-border-all:before {\n  content: \"\\F0C7\";\n}\n.mdi-border-all-variant:before {\n  content: \"\\F8A0\";\n}\n.mdi-border-bottom:before {\n  content: \"\\F0C8\";\n}\n.mdi-border-bottom-variant:before {\n  content: \"\\F8A1\";\n}\n.mdi-border-color:before {\n  content: \"\\F0C9\";\n}\n.mdi-border-horizontal:before {\n  content: \"\\F0CA\";\n}\n.mdi-border-inside:before {\n  content: \"\\F0CB\";\n}\n.mdi-border-left:before {\n  content: \"\\F0CC\";\n}\n.mdi-border-left-variant:before {\n  content: \"\\F8A2\";\n}\n.mdi-border-none:before {\n  content: \"\\F0CD\";\n}\n.mdi-border-none-variant:before {\n  content: \"\\F8A3\";\n}\n.mdi-border-outside:before {\n  content: \"\\F0CE\";\n}\n.mdi-border-right:before {\n  content: \"\\F0CF\";\n}\n.mdi-border-right-variant:before {\n  content: \"\\F8A4\";\n}\n.mdi-border-style:before {\n  content: \"\\F0D0\";\n}\n.mdi-border-top:before {\n  content: \"\\F0D1\";\n}\n.mdi-border-top-variant:before {\n  content: \"\\F8A5\";\n}\n.mdi-border-vertical:before {\n  content: \"\\F0D2\";\n}\n.mdi-bottle-wine:before {\n  content: \"\\F853\";\n}\n.mdi-bow-tie:before {\n  content: \"\\F677\";\n}\n.mdi-bowl:before {\n  content: \"\\F617\";\n}\n.mdi-bowling:before {\n  content: \"\\F0D3\";\n}\n.mdi-box:before {\n  content: \"\\F0D4\";\n}\n.mdi-box-cutter:before {\n  content: \"\\F0D5\";\n}\n.mdi-box-shadow:before {\n  content: \"\\F637\";\n}\n.mdi-bridge:before {\n  content: \"\\F618\";\n}\n.mdi-briefcase:before {\n  content: \"\\F0D6\";\n}\n.mdi-briefcase-check:before {\n  content: \"\\F0D7\";\n}\n.mdi-briefcase-download:before {\n  content: \"\\F0D8\";\n}\n.mdi-briefcase-outline:before {\n  content: \"\\F813\";\n}\n.mdi-briefcase-upload:before {\n  content: \"\\F0D9\";\n}\n.mdi-brightness-1:before {\n  content: \"\\F0DA\";\n}\n.mdi-brightness-2:before {\n  content: \"\\F0DB\";\n}\n.mdi-brightness-3:before {\n  content: \"\\F0DC\";\n}\n.mdi-brightness-4:before {\n  content: \"\\F0DD\";\n}\n.mdi-brightness-5:before {\n  content: \"\\F0DE\";\n}\n.mdi-brightness-6:before {\n  content: \"\\F0DF\";\n}\n.mdi-brightness-7:before {\n  content: \"\\F0E0\";\n}\n.mdi-brightness-auto:before {\n  content: \"\\F0E1\";\n}\n.mdi-broom:before {\n  content: \"\\F0E2\";\n}\n.mdi-brush:before {\n  content: \"\\F0E3\";\n}\n.mdi-buffer:before {\n  content: \"\\F619\";\n}\n.mdi-bug:before {\n  content: \"\\F0E4\";\n}\n.mdi-bulletin-board:before {\n  content: \"\\F0E5\";\n}\n.mdi-bullhorn:before {\n  content: \"\\F0E6\";\n}\n.mdi-bullseye:before {\n  content: \"\\F5DD\";\n}\n.mdi-bus:before {\n  content: \"\\F0E7\";\n}\n.mdi-bus-articulated-end:before {\n  content: \"\\F79B\";\n}\n.mdi-bus-articulated-front:before {\n  content: \"\\F79C\";\n}\n.mdi-bus-double-decker:before {\n  content: \"\\F79D\";\n}\n.mdi-bus-school:before {\n  content: \"\\F79E\";\n}\n.mdi-bus-side:before {\n  content: \"\\F79F\";\n}\n.mdi-cached:before {\n  content: \"\\F0E8\";\n}\n.mdi-cake:before {\n  content: \"\\F0E9\";\n}\n.mdi-cake-layered:before {\n  content: \"\\F0EA\";\n}\n.mdi-cake-variant:before {\n  content: \"\\F0EB\";\n}\n.mdi-calculator:before {\n  content: \"\\F0EC\";\n}\n.mdi-calendar:before {\n  content: \"\\F0ED\";\n}\n.mdi-calendar-blank:before {\n  content: \"\\F0EE\";\n}\n.mdi-calendar-check:before {\n  content: \"\\F0EF\";\n}\n.mdi-calendar-clock:before {\n  content: \"\\F0F0\";\n}\n.mdi-calendar-edit:before {\n  content: \"\\F8A6\";\n}\n.mdi-calendar-multiple:before {\n  content: \"\\F0F1\";\n}\n.mdi-calendar-multiple-check:before {\n  content: \"\\F0F2\";\n}\n.mdi-calendar-plus:before {\n  content: \"\\F0F3\";\n}\n.mdi-calendar-question:before {\n  content: \"\\F691\";\n}\n.mdi-calendar-range:before {\n  content: \"\\F678\";\n}\n.mdi-calendar-remove:before {\n  content: \"\\F0F4\";\n}\n.mdi-calendar-text:before {\n  content: \"\\F0F5\";\n}\n.mdi-calendar-today:before {\n  content: \"\\F0F6\";\n}\n.mdi-call-made:before {\n  content: \"\\F0F7\";\n}\n.mdi-call-merge:before {\n  content: \"\\F0F8\";\n}\n.mdi-call-missed:before {\n  content: \"\\F0F9\";\n}\n.mdi-call-received:before {\n  content: \"\\F0FA\";\n}\n.mdi-call-split:before {\n  content: \"\\F0FB\";\n}\n.mdi-camcorder:before {\n  content: \"\\F0FC\";\n}\n.mdi-camcorder-box:before {\n  content: \"\\F0FD\";\n}\n.mdi-camcorder-box-off:before {\n  content: \"\\F0FE\";\n}\n.mdi-camcorder-off:before {\n  content: \"\\F0FF\";\n}\n.mdi-camera:before {\n  content: \"\\F100\";\n}\n.mdi-camera-burst:before {\n  content: \"\\F692\";\n}\n.mdi-camera-enhance:before {\n  content: \"\\F101\";\n}\n.mdi-camera-front:before {\n  content: \"\\F102\";\n}\n.mdi-camera-front-variant:before {\n  content: \"\\F103\";\n}\n.mdi-camera-gopro:before {\n  content: \"\\F7A0\";\n}\n.mdi-camera-iris:before {\n  content: \"\\F104\";\n}\n.mdi-camera-metering-center:before {\n  content: \"\\F7A1\";\n}\n.mdi-camera-metering-matrix:before {\n  content: \"\\F7A2\";\n}\n.mdi-camera-metering-partial:before {\n  content: \"\\F7A3\";\n}\n.mdi-camera-metering-spot:before {\n  content: \"\\F7A4\";\n}\n.mdi-camera-off:before {\n  content: \"\\F5DF\";\n}\n.mdi-camera-party-mode:before {\n  content: \"\\F105\";\n}\n.mdi-camera-rear:before {\n  content: \"\\F106\";\n}\n.mdi-camera-rear-variant:before {\n  content: \"\\F107\";\n}\n.mdi-camera-switch:before {\n  content: \"\\F108\";\n}\n.mdi-camera-timer:before {\n  content: \"\\F109\";\n}\n.mdi-cancel:before {\n  content: \"\\F739\";\n}\n.mdi-candle:before {\n  content: \"\\F5E2\";\n}\n.mdi-candycane:before {\n  content: \"\\F10A\";\n}\n.mdi-cannabis:before {\n  content: \"\\F7A5\";\n}\n.mdi-car:before {\n  content: \"\\F10B\";\n}\n.mdi-car-battery:before {\n  content: \"\\F10C\";\n}\n.mdi-car-connected:before {\n  content: \"\\F10D\";\n}\n.mdi-car-convertible:before {\n  content: \"\\F7A6\";\n}\n.mdi-car-estate:before {\n  content: \"\\F7A7\";\n}\n.mdi-car-hatchback:before {\n  content: \"\\F7A8\";\n}\n.mdi-car-pickup:before {\n  content: \"\\F7A9\";\n}\n.mdi-car-side:before {\n  content: \"\\F7AA\";\n}\n.mdi-car-sports:before {\n  content: \"\\F7AB\";\n}\n.mdi-car-wash:before {\n  content: \"\\F10E\";\n}\n.mdi-caravan:before {\n  content: \"\\F7AC\";\n}\n.mdi-cards:before {\n  content: \"\\F638\";\n}\n.mdi-cards-outline:before {\n  content: \"\\F639\";\n}\n.mdi-cards-playing-outline:before {\n  content: \"\\F63A\";\n}\n.mdi-cards-variant:before {\n  content: \"\\F6C6\";\n}\n.mdi-carrot:before {\n  content: \"\\F10F\";\n}\n.mdi-cart:before {\n  content: \"\\F110\";\n}\n.mdi-cart-off:before {\n  content: \"\\F66B\";\n}\n.mdi-cart-outline:before {\n  content: \"\\F111\";\n}\n.mdi-cart-plus:before {\n  content: \"\\F112\";\n}\n.mdi-case-sensitive-alt:before {\n  content: \"\\F113\";\n}\n.mdi-cash:before {\n  content: \"\\F114\";\n}\n.mdi-cash-100:before {\n  content: \"\\F115\";\n}\n.mdi-cash-multiple:before {\n  content: \"\\F116\";\n}\n.mdi-cash-usd:before {\n  content: \"\\F117\";\n}\n.mdi-cast:before {\n  content: \"\\F118\";\n}\n.mdi-cast-connected:before {\n  content: \"\\F119\";\n}\n.mdi-cast-off:before {\n  content: \"\\F789\";\n}\n.mdi-castle:before {\n  content: \"\\F11A\";\n}\n.mdi-cat:before {\n  content: \"\\F11B\";\n}\n.mdi-cctv:before {\n  content: \"\\F7AD\";\n}\n.mdi-ceiling-light:before {\n  content: \"\\F768\";\n}\n.mdi-cellphone:before {\n  content: \"\\F11C\";\n}\n.mdi-cellphone-android:before {\n  content: \"\\F11D\";\n}\n.mdi-cellphone-basic:before {\n  content: \"\\F11E\";\n}\n.mdi-cellphone-dock:before {\n  content: \"\\F11F\";\n}\n.mdi-cellphone-iphone:before {\n  content: \"\\F120\";\n}\n.mdi-cellphone-link:before {\n  content: \"\\F121\";\n}\n.mdi-cellphone-link-off:before {\n  content: \"\\F122\";\n}\n.mdi-cellphone-settings:before {\n  content: \"\\F123\";\n}\n.mdi-cellphone-wireless:before {\n  content: \"\\F814\";\n}\n.mdi-certificate:before {\n  content: \"\\F124\";\n}\n.mdi-chair-school:before {\n  content: \"\\F125\";\n}\n.mdi-chart-arc:before {\n  content: \"\\F126\";\n}\n.mdi-chart-areaspline:before {\n  content: \"\\F127\";\n}\n.mdi-chart-bar:before {\n  content: \"\\F128\";\n}\n.mdi-chart-bar-stacked:before {\n  content: \"\\F769\";\n}\n.mdi-chart-bubble:before {\n  content: \"\\F5E3\";\n}\n.mdi-chart-donut:before {\n  content: \"\\F7AE\";\n}\n.mdi-chart-donut-variant:before {\n  content: \"\\F7AF\";\n}\n.mdi-chart-gantt:before {\n  content: \"\\F66C\";\n}\n.mdi-chart-histogram:before {\n  content: \"\\F129\";\n}\n.mdi-chart-line:before {\n  content: \"\\F12A\";\n}\n.mdi-chart-line-stacked:before {\n  content: \"\\F76A\";\n}\n.mdi-chart-line-variant:before {\n  content: \"\\F7B0\";\n}\n.mdi-chart-pie:before {\n  content: \"\\F12B\";\n}\n.mdi-chart-scatterplot-hexbin:before {\n  content: \"\\F66D\";\n}\n.mdi-chart-timeline:before {\n  content: \"\\F66E\";\n}\n.mdi-check:before {\n  content: \"\\F12C\";\n}\n.mdi-check-all:before {\n  content: \"\\F12D\";\n}\n.mdi-check-circle:before {\n  content: \"\\F5E0\";\n}\n.mdi-check-circle-outline:before {\n  content: \"\\F5E1\";\n}\n.mdi-check-outline:before {\n  content: \"\\F854\";\n}\n.mdi-checkbox-blank:before {\n  content: \"\\F12E\";\n}\n.mdi-checkbox-blank-circle:before {\n  content: \"\\F12F\";\n}\n.mdi-checkbox-blank-circle-outline:before {\n  content: \"\\F130\";\n}\n.mdi-checkbox-blank-outline:before {\n  content: \"\\F131\";\n}\n.mdi-checkbox-intermediate:before {\n  content: \"\\F855\";\n}\n.mdi-checkbox-marked:before {\n  content: \"\\F132\";\n}\n.mdi-checkbox-marked-circle:before {\n  content: \"\\F133\";\n}\n.mdi-checkbox-marked-circle-outline:before {\n  content: \"\\F134\";\n}\n.mdi-checkbox-marked-outline:before {\n  content: \"\\F135\";\n}\n.mdi-checkbox-multiple-blank:before {\n  content: \"\\F136\";\n}\n.mdi-checkbox-multiple-blank-circle:before {\n  content: \"\\F63B\";\n}\n.mdi-checkbox-multiple-blank-circle-outline:before {\n  content: \"\\F63C\";\n}\n.mdi-checkbox-multiple-blank-outline:before {\n  content: \"\\F137\";\n}\n.mdi-checkbox-multiple-marked:before {\n  content: \"\\F138\";\n}\n.mdi-checkbox-multiple-marked-circle:before {\n  content: \"\\F63D\";\n}\n.mdi-checkbox-multiple-marked-circle-outline:before {\n  content: \"\\F63E\";\n}\n.mdi-checkbox-multiple-marked-outline:before {\n  content: \"\\F139\";\n}\n.mdi-checkerboard:before {\n  content: \"\\F13A\";\n}\n.mdi-chemical-weapon:before {\n  content: \"\\F13B\";\n}\n.mdi-chess-bishop:before {\n  content: \"\\F85B\";\n}\n.mdi-chess-king:before {\n  content: \"\\F856\";\n}\n.mdi-chess-knight:before {\n  content: \"\\F857\";\n}\n.mdi-chess-pawn:before {\n  content: \"\\F858\";\n}\n.mdi-chess-queen:before {\n  content: \"\\F859\";\n}\n.mdi-chess-rook:before {\n  content: \"\\F85A\";\n}\n.mdi-chevron-double-down:before {\n  content: \"\\F13C\";\n}\n.mdi-chevron-double-left:before {\n  content: \"\\F13D\";\n}\n.mdi-chevron-double-right:before {\n  content: \"\\F13E\";\n}\n.mdi-chevron-double-up:before {\n  content: \"\\F13F\";\n}\n.mdi-chevron-down:before {\n  content: \"\\F140\";\n}\n.mdi-chevron-left:before {\n  content: \"\\F141\";\n}\n.mdi-chevron-right:before {\n  content: \"\\F142\";\n}\n.mdi-chevron-up:before {\n  content: \"\\F143\";\n}\n.mdi-chili-hot:before {\n  content: \"\\F7B1\";\n}\n.mdi-chili-medium:before {\n  content: \"\\F7B2\";\n}\n.mdi-chili-mild:before {\n  content: \"\\F7B3\";\n}\n.mdi-chip:before {\n  content: \"\\F61A\";\n}\n.mdi-church:before {\n  content: \"\\F144\";\n}\n.mdi-circle:before {\n  content: \"\\F764\";\n}\n.mdi-circle-outline:before {\n  content: \"\\F765\";\n}\n.mdi-cisco-webex:before {\n  content: \"\\F145\";\n}\n.mdi-city:before {\n  content: \"\\F146\";\n}\n.mdi-clipboard:before {\n  content: \"\\F147\";\n}\n.mdi-clipboard-account:before {\n  content: \"\\F148\";\n}\n.mdi-clipboard-alert:before {\n  content: \"\\F149\";\n}\n.mdi-clipboard-arrow-down:before {\n  content: \"\\F14A\";\n}\n.mdi-clipboard-arrow-left:before {\n  content: \"\\F14B\";\n}\n.mdi-clipboard-check:before {\n  content: \"\\F14C\";\n}\n.mdi-clipboard-check-outline:before {\n  content: \"\\F8A7\";\n}\n.mdi-clipboard-flow:before {\n  content: \"\\F6C7\";\n}\n.mdi-clipboard-outline:before {\n  content: \"\\F14D\";\n}\n.mdi-clipboard-plus:before {\n  content: \"\\F750\";\n}\n.mdi-clipboard-pulse:before {\n  content: \"\\F85C\";\n}\n.mdi-clipboard-pulse-outline:before {\n  content: \"\\F85D\";\n}\n.mdi-clipboard-text:before {\n  content: \"\\F14E\";\n}\n.mdi-clippy:before {\n  content: \"\\F14F\";\n}\n.mdi-clock:before {\n  content: \"\\F150\";\n}\n.mdi-clock-alert:before {\n  content: \"\\F5CE\";\n}\n.mdi-clock-end:before {\n  content: \"\\F151\";\n}\n.mdi-clock-fast:before {\n  content: \"\\F152\";\n}\n.mdi-clock-in:before {\n  content: \"\\F153\";\n}\n.mdi-clock-out:before {\n  content: \"\\F154\";\n}\n.mdi-clock-start:before {\n  content: \"\\F155\";\n}\n.mdi-close:before {\n  content: \"\\F156\";\n}\n.mdi-close-box:before {\n  content: \"\\F157\";\n}\n.mdi-close-box-outline:before {\n  content: \"\\F158\";\n}\n.mdi-close-circle:before {\n  content: \"\\F159\";\n}\n.mdi-close-circle-outline:before {\n  content: \"\\F15A\";\n}\n.mdi-close-network:before {\n  content: \"\\F15B\";\n}\n.mdi-close-octagon:before {\n  content: \"\\F15C\";\n}\n.mdi-close-octagon-outline:before {\n  content: \"\\F15D\";\n}\n.mdi-close-outline:before {\n  content: \"\\F6C8\";\n}\n.mdi-closed-caption:before {\n  content: \"\\F15E\";\n}\n.mdi-cloud:before {\n  content: \"\\F15F\";\n}\n.mdi-cloud-braces:before {\n  content: \"\\F7B4\";\n}\n.mdi-cloud-check:before {\n  content: \"\\F160\";\n}\n.mdi-cloud-circle:before {\n  content: \"\\F161\";\n}\n.mdi-cloud-download:before {\n  content: \"\\F162\";\n}\n.mdi-cloud-off-outline:before {\n  content: \"\\F164\";\n}\n.mdi-cloud-outline:before {\n  content: \"\\F163\";\n}\n.mdi-cloud-print:before {\n  content: \"\\F165\";\n}\n.mdi-cloud-print-outline:before {\n  content: \"\\F166\";\n}\n.mdi-cloud-sync:before {\n  content: \"\\F63F\";\n}\n.mdi-cloud-tags:before {\n  content: \"\\F7B5\";\n}\n.mdi-cloud-upload:before {\n  content: \"\\F167\";\n}\n.mdi-clover:before {\n  content: \"\\F815\";\n}\n.mdi-code-array:before {\n  content: \"\\F168\";\n}\n.mdi-code-braces:before {\n  content: \"\\F169\";\n}\n.mdi-code-brackets:before {\n  content: \"\\F16A\";\n}\n.mdi-code-equal:before {\n  content: \"\\F16B\";\n}\n.mdi-code-greater-than:before {\n  content: \"\\F16C\";\n}\n.mdi-code-greater-than-or-equal:before {\n  content: \"\\F16D\";\n}\n.mdi-code-less-than:before {\n  content: \"\\F16E\";\n}\n.mdi-code-less-than-or-equal:before {\n  content: \"\\F16F\";\n}\n.mdi-code-not-equal:before {\n  content: \"\\F170\";\n}\n.mdi-code-not-equal-variant:before {\n  content: \"\\F171\";\n}\n.mdi-code-parentheses:before {\n  content: \"\\F172\";\n}\n.mdi-code-string:before {\n  content: \"\\F173\";\n}\n.mdi-code-tags:before {\n  content: \"\\F174\";\n}\n.mdi-code-tags-check:before {\n  content: \"\\F693\";\n}\n.mdi-codepen:before {\n  content: \"\\F175\";\n}\n.mdi-coffee:before {\n  content: \"\\F176\";\n}\n.mdi-coffee-outline:before {\n  content: \"\\F6C9\";\n}\n.mdi-coffee-to-go:before {\n  content: \"\\F177\";\n}\n.mdi-coin:before {\n  content: \"\\F178\";\n}\n.mdi-coins:before {\n  content: \"\\F694\";\n}\n.mdi-collage:before {\n  content: \"\\F640\";\n}\n.mdi-color-helper:before {\n  content: \"\\F179\";\n}\n.mdi-comment:before {\n  content: \"\\F17A\";\n}\n.mdi-comment-account:before {\n  content: \"\\F17B\";\n}\n.mdi-comment-account-outline:before {\n  content: \"\\F17C\";\n}\n.mdi-comment-alert:before {\n  content: \"\\F17D\";\n}\n.mdi-comment-alert-outline:before {\n  content: \"\\F17E\";\n}\n.mdi-comment-check:before {\n  content: \"\\F17F\";\n}\n.mdi-comment-check-outline:before {\n  content: \"\\F180\";\n}\n.mdi-comment-multiple:before {\n  content: \"\\F85E\";\n}\n.mdi-comment-multiple-outline:before {\n  content: \"\\F181\";\n}\n.mdi-comment-outline:before {\n  content: \"\\F182\";\n}\n.mdi-comment-plus-outline:before {\n  content: \"\\F183\";\n}\n.mdi-comment-processing:before {\n  content: \"\\F184\";\n}\n.mdi-comment-processing-outline:before {\n  content: \"\\F185\";\n}\n.mdi-comment-question:before {\n  content: \"\\F816\";\n}\n.mdi-comment-question-outline:before {\n  content: \"\\F186\";\n}\n.mdi-comment-remove:before {\n  content: \"\\F5DE\";\n}\n.mdi-comment-remove-outline:before {\n  content: \"\\F187\";\n}\n.mdi-comment-text:before {\n  content: \"\\F188\";\n}\n.mdi-comment-text-multiple:before {\n  content: \"\\F85F\";\n}\n.mdi-comment-text-multiple-outline:before {\n  content: \"\\F860\";\n}\n.mdi-comment-text-outline:before {\n  content: \"\\F189\";\n}\n.mdi-compare:before {\n  content: \"\\F18A\";\n}\n.mdi-compass:before {\n  content: \"\\F18B\";\n}\n.mdi-compass-outline:before {\n  content: \"\\F18C\";\n}\n.mdi-console:before {\n  content: \"\\F18D\";\n}\n.mdi-console-line:before {\n  content: \"\\F7B6\";\n}\n.mdi-console-network:before {\n  content: \"\\F8A8\";\n}\n.mdi-contact-mail:before {\n  content: \"\\F18E\";\n}\n.mdi-contacts:before {\n  content: \"\\F6CA\";\n}\n.mdi-content-copy:before {\n  content: \"\\F18F\";\n}\n.mdi-content-cut:before {\n  content: \"\\F190\";\n}\n.mdi-content-duplicate:before {\n  content: \"\\F191\";\n}\n.mdi-content-paste:before {\n  content: \"\\F192\";\n}\n.mdi-content-save:before {\n  content: \"\\F193\";\n}\n.mdi-content-save-all:before {\n  content: \"\\F194\";\n}\n.mdi-content-save-outline:before {\n  content: \"\\F817\";\n}\n.mdi-content-save-settings:before {\n  content: \"\\F61B\";\n}\n.mdi-contrast:before {\n  content: \"\\F195\";\n}\n.mdi-contrast-box:before {\n  content: \"\\F196\";\n}\n.mdi-contrast-circle:before {\n  content: \"\\F197\";\n}\n.mdi-cookie:before {\n  content: \"\\F198\";\n}\n.mdi-copyright:before {\n  content: \"\\F5E6\";\n}\n.mdi-corn:before {\n  content: \"\\F7B7\";\n}\n.mdi-counter:before {\n  content: \"\\F199\";\n}\n.mdi-cow:before {\n  content: \"\\F19A\";\n}\n.mdi-crane:before {\n  content: \"\\F861\";\n}\n.mdi-creation:before {\n  content: \"\\F1C9\";\n}\n.mdi-credit-card:before {\n  content: \"\\F19B\";\n}\n.mdi-credit-card-multiple:before {\n  content: \"\\F19C\";\n}\n.mdi-credit-card-off:before {\n  content: \"\\F5E4\";\n}\n.mdi-credit-card-plus:before {\n  content: \"\\F675\";\n}\n.mdi-credit-card-scan:before {\n  content: \"\\F19D\";\n}\n.mdi-crop:before {\n  content: \"\\F19E\";\n}\n.mdi-crop-free:before {\n  content: \"\\F19F\";\n}\n.mdi-crop-landscape:before {\n  content: \"\\F1A0\";\n}\n.mdi-crop-portrait:before {\n  content: \"\\F1A1\";\n}\n.mdi-crop-rotate:before {\n  content: \"\\F695\";\n}\n.mdi-crop-square:before {\n  content: \"\\F1A2\";\n}\n.mdi-crosshairs:before {\n  content: \"\\F1A3\";\n}\n.mdi-crosshairs-gps:before {\n  content: \"\\F1A4\";\n}\n.mdi-crown:before {\n  content: \"\\F1A5\";\n}\n.mdi-cube:before {\n  content: \"\\F1A6\";\n}\n.mdi-cube-outline:before {\n  content: \"\\F1A7\";\n}\n.mdi-cube-send:before {\n  content: \"\\F1A8\";\n}\n.mdi-cube-unfolded:before {\n  content: \"\\F1A9\";\n}\n.mdi-cup:before {\n  content: \"\\F1AA\";\n}\n.mdi-cup-off:before {\n  content: \"\\F5E5\";\n}\n.mdi-cup-water:before {\n  content: \"\\F1AB\";\n}\n.mdi-curling:before {\n  content: \"\\F862\";\n}\n.mdi-currency-bdt:before {\n  content: \"\\F863\";\n}\n.mdi-currency-btc:before {\n  content: \"\\F1AC\";\n}\n.mdi-currency-chf:before {\n  content: \"\\F7B8\";\n}\n.mdi-currency-cny:before {\n  content: \"\\F7B9\";\n}\n.mdi-currency-eth:before {\n  content: \"\\F7BA\";\n}\n.mdi-currency-eur:before {\n  content: \"\\F1AD\";\n}\n.mdi-currency-gbp:before {\n  content: \"\\F1AE\";\n}\n.mdi-currency-inr:before {\n  content: \"\\F1AF\";\n}\n.mdi-currency-jpy:before {\n  content: \"\\F7BB\";\n}\n.mdi-currency-krw:before {\n  content: \"\\F7BC\";\n}\n.mdi-currency-kzt:before {\n  content: \"\\F864\";\n}\n.mdi-currency-ngn:before {\n  content: \"\\F1B0\";\n}\n.mdi-currency-rub:before {\n  content: \"\\F1B1\";\n}\n.mdi-currency-sign:before {\n  content: \"\\F7BD\";\n}\n.mdi-currency-try:before {\n  content: \"\\F1B2\";\n}\n.mdi-currency-twd:before {\n  content: \"\\F7BE\";\n}\n.mdi-currency-usd:before {\n  content: \"\\F1B3\";\n}\n.mdi-currency-usd-off:before {\n  content: \"\\F679\";\n}\n.mdi-cursor-default:before {\n  content: \"\\F1B4\";\n}\n.mdi-cursor-default-outline:before {\n  content: \"\\F1B5\";\n}\n.mdi-cursor-move:before {\n  content: \"\\F1B6\";\n}\n.mdi-cursor-pointer:before {\n  content: \"\\F1B7\";\n}\n.mdi-cursor-text:before {\n  content: \"\\F5E7\";\n}\n.mdi-database:before {\n  content: \"\\F1B8\";\n}\n.mdi-database-minus:before {\n  content: \"\\F1B9\";\n}\n.mdi-database-plus:before {\n  content: \"\\F1BA\";\n}\n.mdi-database-search:before {\n  content: \"\\F865\";\n}\n.mdi-debug-step-into:before {\n  content: \"\\F1BB\";\n}\n.mdi-debug-step-out:before {\n  content: \"\\F1BC\";\n}\n.mdi-debug-step-over:before {\n  content: \"\\F1BD\";\n}\n.mdi-decagram:before {\n  content: \"\\F76B\";\n}\n.mdi-decagram-outline:before {\n  content: \"\\F76C\";\n}\n.mdi-decimal-decrease:before {\n  content: \"\\F1BE\";\n}\n.mdi-decimal-increase:before {\n  content: \"\\F1BF\";\n}\n.mdi-delete:before {\n  content: \"\\F1C0\";\n}\n.mdi-delete-circle:before {\n  content: \"\\F682\";\n}\n.mdi-delete-empty:before {\n  content: \"\\F6CB\";\n}\n.mdi-delete-forever:before {\n  content: \"\\F5E8\";\n}\n.mdi-delete-restore:before {\n  content: \"\\F818\";\n}\n.mdi-delete-sweep:before {\n  content: \"\\F5E9\";\n}\n.mdi-delete-variant:before {\n  content: \"\\F1C1\";\n}\n.mdi-delta:before {\n  content: \"\\F1C2\";\n}\n.mdi-deskphone:before {\n  content: \"\\F1C3\";\n}\n.mdi-desktop-classic:before {\n  content: \"\\F7BF\";\n}\n.mdi-desktop-mac:before {\n  content: \"\\F1C4\";\n}\n.mdi-desktop-tower:before {\n  content: \"\\F1C5\";\n}\n.mdi-details:before {\n  content: \"\\F1C6\";\n}\n.mdi-developer-board:before {\n  content: \"\\F696\";\n}\n.mdi-deviantart:before {\n  content: \"\\F1C7\";\n}\n.mdi-dialpad:before {\n  content: \"\\F61C\";\n}\n.mdi-diamond:before {\n  content: \"\\F1C8\";\n}\n.mdi-dice-1:before {\n  content: \"\\F1CA\";\n}\n.mdi-dice-2:before {\n  content: \"\\F1CB\";\n}\n.mdi-dice-3:before {\n  content: \"\\F1CC\";\n}\n.mdi-dice-4:before {\n  content: \"\\F1CD\";\n}\n.mdi-dice-5:before {\n  content: \"\\F1CE\";\n}\n.mdi-dice-6:before {\n  content: \"\\F1CF\";\n}\n.mdi-dice-d10:before {\n  content: \"\\F76E\";\n}\n.mdi-dice-d12:before {\n  content: \"\\F866\";\n}\n.mdi-dice-d20:before {\n  content: \"\\F5EA\";\n}\n.mdi-dice-d4:before {\n  content: \"\\F5EB\";\n}\n.mdi-dice-d6:before {\n  content: \"\\F5EC\";\n}\n.mdi-dice-d8:before {\n  content: \"\\F5ED\";\n}\n.mdi-dice-multiple:before {\n  content: \"\\F76D\";\n}\n.mdi-dictionary:before {\n  content: \"\\F61D\";\n}\n.mdi-dip-switch:before {\n  content: \"\\F7C0\";\n}\n.mdi-directions:before {\n  content: \"\\F1D0\";\n}\n.mdi-directions-fork:before {\n  content: \"\\F641\";\n}\n.mdi-discord:before {\n  content: \"\\F66F\";\n}\n.mdi-disk:before {\n  content: \"\\F5EE\";\n}\n.mdi-disk-alert:before {\n  content: \"\\F1D1\";\n}\n.mdi-disqus:before {\n  content: \"\\F1D2\";\n}\n.mdi-disqus-outline:before {\n  content: \"\\F1D3\";\n}\n.mdi-division:before {\n  content: \"\\F1D4\";\n}\n.mdi-division-box:before {\n  content: \"\\F1D5\";\n}\n.mdi-dna:before {\n  content: \"\\F683\";\n}\n.mdi-dns:before {\n  content: \"\\F1D6\";\n}\n.mdi-do-not-disturb:before {\n  content: \"\\F697\";\n}\n.mdi-do-not-disturb-off:before {\n  content: \"\\F698\";\n}\n.mdi-docker:before {\n  content: \"\\F867\";\n}\n.mdi-dolby:before {\n  content: \"\\F6B2\";\n}\n.mdi-domain:before {\n  content: \"\\F1D7\";\n}\n.mdi-donkey:before {\n  content: \"\\F7C1\";\n}\n.mdi-door:before {\n  content: \"\\F819\";\n}\n.mdi-door-closed:before {\n  content: \"\\F81A\";\n}\n.mdi-door-open:before {\n  content: \"\\F81B\";\n}\n.mdi-doorbell-video:before {\n  content: \"\\F868\";\n}\n.mdi-dots-horizontal:before {\n  content: \"\\F1D8\";\n}\n.mdi-dots-horizontal-circle:before {\n  content: \"\\F7C2\";\n}\n.mdi-dots-vertical:before {\n  content: \"\\F1D9\";\n}\n.mdi-dots-vertical-circle:before {\n  content: \"\\F7C3\";\n}\n.mdi-douban:before {\n  content: \"\\F699\";\n}\n.mdi-download:before {\n  content: \"\\F1DA\";\n}\n.mdi-download-network:before {\n  content: \"\\F6F3\";\n}\n.mdi-drag:before {\n  content: \"\\F1DB\";\n}\n.mdi-drag-horizontal:before {\n  content: \"\\F1DC\";\n}\n.mdi-drag-vertical:before {\n  content: \"\\F1DD\";\n}\n.mdi-drawing:before {\n  content: \"\\F1DE\";\n}\n.mdi-drawing-box:before {\n  content: \"\\F1DF\";\n}\n.mdi-dribbble:before {\n  content: \"\\F1E0\";\n}\n.mdi-dribbble-box:before {\n  content: \"\\F1E1\";\n}\n.mdi-drone:before {\n  content: \"\\F1E2\";\n}\n.mdi-dropbox:before {\n  content: \"\\F1E3\";\n}\n.mdi-drupal:before {\n  content: \"\\F1E4\";\n}\n.mdi-duck:before {\n  content: \"\\F1E5\";\n}\n.mdi-dumbbell:before {\n  content: \"\\F1E6\";\n}\n.mdi-ear-hearing:before {\n  content: \"\\F7C4\";\n}\n.mdi-earth:before {\n  content: \"\\F1E7\";\n}\n.mdi-earth-box:before {\n  content: \"\\F6CC\";\n}\n.mdi-earth-box-off:before {\n  content: \"\\F6CD\";\n}\n.mdi-earth-off:before {\n  content: \"\\F1E8\";\n}\n.mdi-edge:before {\n  content: \"\\F1E9\";\n}\n.mdi-eject:before {\n  content: \"\\F1EA\";\n}\n.mdi-elephant:before {\n  content: \"\\F7C5\";\n}\n.mdi-elevation-decline:before {\n  content: \"\\F1EB\";\n}\n.mdi-elevation-rise:before {\n  content: \"\\F1EC\";\n}\n.mdi-elevator:before {\n  content: \"\\F1ED\";\n}\n.mdi-email:before {\n  content: \"\\F1EE\";\n}\n.mdi-email-alert:before {\n  content: \"\\F6CE\";\n}\n.mdi-email-open:before {\n  content: \"\\F1EF\";\n}\n.mdi-email-open-outline:before {\n  content: \"\\F5EF\";\n}\n.mdi-email-outline:before {\n  content: \"\\F1F0\";\n}\n.mdi-email-secure:before {\n  content: \"\\F1F1\";\n}\n.mdi-email-variant:before {\n  content: \"\\F5F0\";\n}\n.mdi-emby:before {\n  content: \"\\F6B3\";\n}\n.mdi-emoticon:before {\n  content: \"\\F1F2\";\n}\n.mdi-emoticon-cool:before {\n  content: \"\\F1F3\";\n}\n.mdi-emoticon-dead:before {\n  content: \"\\F69A\";\n}\n.mdi-emoticon-devil:before {\n  content: \"\\F1F4\";\n}\n.mdi-emoticon-excited:before {\n  content: \"\\F69B\";\n}\n.mdi-emoticon-happy:before {\n  content: \"\\F1F5\";\n}\n.mdi-emoticon-neutral:before {\n  content: \"\\F1F6\";\n}\n.mdi-emoticon-poop:before {\n  content: \"\\F1F7\";\n}\n.mdi-emoticon-sad:before {\n  content: \"\\F1F8\";\n}\n.mdi-emoticon-tongue:before {\n  content: \"\\F1F9\";\n}\n.mdi-engine:before {\n  content: \"\\F1FA\";\n}\n.mdi-engine-outline:before {\n  content: \"\\F1FB\";\n}\n.mdi-equal:before {\n  content: \"\\F1FC\";\n}\n.mdi-equal-box:before {\n  content: \"\\F1FD\";\n}\n.mdi-eraser:before {\n  content: \"\\F1FE\";\n}\n.mdi-eraser-variant:before {\n  content: \"\\F642\";\n}\n.mdi-escalator:before {\n  content: \"\\F1FF\";\n}\n.mdi-ethereum:before {\n  content: \"\\F869\";\n}\n.mdi-ethernet:before {\n  content: \"\\F200\";\n}\n.mdi-ethernet-cable:before {\n  content: \"\\F201\";\n}\n.mdi-ethernet-cable-off:before {\n  content: \"\\F202\";\n}\n.mdi-etsy:before {\n  content: \"\\F203\";\n}\n.mdi-ev-station:before {\n  content: \"\\F5F1\";\n}\n.mdi-eventbrite:before {\n  content: \"\\F7C6\";\n}\n.mdi-evernote:before {\n  content: \"\\F204\";\n}\n.mdi-exclamation:before {\n  content: \"\\F205\";\n}\n.mdi-exit-to-app:before {\n  content: \"\\F206\";\n}\n.mdi-export:before {\n  content: \"\\F207\";\n}\n.mdi-eye:before {\n  content: \"\\F208\";\n}\n.mdi-eye-off:before {\n  content: \"\\F209\";\n}\n.mdi-eye-off-outline:before {\n  content: \"\\F6D0\";\n}\n.mdi-eye-outline:before {\n  content: \"\\F6CF\";\n}\n.mdi-eye-plus:before {\n  content: \"\\F86A\";\n}\n.mdi-eye-plus-outline:before {\n  content: \"\\F86B\";\n}\n.mdi-eye-settings:before {\n  content: \"\\F86C\";\n}\n.mdi-eye-settings-outline:before {\n  content: \"\\F86D\";\n}\n.mdi-eyedropper:before {\n  content: \"\\F20A\";\n}\n.mdi-eyedropper-variant:before {\n  content: \"\\F20B\";\n}\n.mdi-face:before {\n  content: \"\\F643\";\n}\n.mdi-face-profile:before {\n  content: \"\\F644\";\n}\n.mdi-facebook:before {\n  content: \"\\F20C\";\n}\n.mdi-facebook-box:before {\n  content: \"\\F20D\";\n}\n.mdi-facebook-messenger:before {\n  content: \"\\F20E\";\n}\n.mdi-factory:before {\n  content: \"\\F20F\";\n}\n.mdi-fan:before {\n  content: \"\\F210\";\n}\n.mdi-fan-off:before {\n  content: \"\\F81C\";\n}\n.mdi-fast-forward:before {\n  content: \"\\F211\";\n}\n.mdi-fast-forward-outline:before {\n  content: \"\\F6D1\";\n}\n.mdi-fax:before {\n  content: \"\\F212\";\n}\n.mdi-feather:before {\n  content: \"\\F6D2\";\n}\n.mdi-ferry:before {\n  content: \"\\F213\";\n}\n.mdi-file:before {\n  content: \"\\F214\";\n}\n.mdi-file-account:before {\n  content: \"\\F73A\";\n}\n.mdi-file-chart:before {\n  content: \"\\F215\";\n}\n.mdi-file-check:before {\n  content: \"\\F216\";\n}\n.mdi-file-cloud:before {\n  content: \"\\F217\";\n}\n.mdi-file-compare:before {\n  content: \"\\F8A9\";\n}\n.mdi-file-delimited:before {\n  content: \"\\F218\";\n}\n.mdi-file-document:before {\n  content: \"\\F219\";\n}\n.mdi-file-document-box:before {\n  content: \"\\F21A\";\n}\n.mdi-file-excel:before {\n  content: \"\\F21B\";\n}\n.mdi-file-excel-box:before {\n  content: \"\\F21C\";\n}\n.mdi-file-export:before {\n  content: \"\\F21D\";\n}\n.mdi-file-find:before {\n  content: \"\\F21E\";\n}\n.mdi-file-hidden:before {\n  content: \"\\F613\";\n}\n.mdi-file-image:before {\n  content: \"\\F21F\";\n}\n.mdi-file-import:before {\n  content: \"\\F220\";\n}\n.mdi-file-lock:before {\n  content: \"\\F221\";\n}\n.mdi-file-multiple:before {\n  content: \"\\F222\";\n}\n.mdi-file-music:before {\n  content: \"\\F223\";\n}\n.mdi-file-outline:before {\n  content: \"\\F224\";\n}\n.mdi-file-pdf:before {\n  content: \"\\F225\";\n}\n.mdi-file-pdf-box:before {\n  content: \"\\F226\";\n}\n.mdi-file-percent:before {\n  content: \"\\F81D\";\n}\n.mdi-file-plus:before {\n  content: \"\\F751\";\n}\n.mdi-file-powerpoint:before {\n  content: \"\\F227\";\n}\n.mdi-file-powerpoint-box:before {\n  content: \"\\F228\";\n}\n.mdi-file-presentation-box:before {\n  content: \"\\F229\";\n}\n.mdi-file-question:before {\n  content: \"\\F86E\";\n}\n.mdi-file-restore:before {\n  content: \"\\F670\";\n}\n.mdi-file-send:before {\n  content: \"\\F22A\";\n}\n.mdi-file-tree:before {\n  content: \"\\F645\";\n}\n.mdi-file-video:before {\n  content: \"\\F22B\";\n}\n.mdi-file-word:before {\n  content: \"\\F22C\";\n}\n.mdi-file-word-box:before {\n  content: \"\\F22D\";\n}\n.mdi-file-xml:before {\n  content: \"\\F22E\";\n}\n.mdi-film:before {\n  content: \"\\F22F\";\n}\n.mdi-filmstrip:before {\n  content: \"\\F230\";\n}\n.mdi-filmstrip-off:before {\n  content: \"\\F231\";\n}\n.mdi-filter:before {\n  content: \"\\F232\";\n}\n.mdi-filter-outline:before {\n  content: \"\\F233\";\n}\n.mdi-filter-remove:before {\n  content: \"\\F234\";\n}\n.mdi-filter-remove-outline:before {\n  content: \"\\F235\";\n}\n.mdi-filter-variant:before {\n  content: \"\\F236\";\n}\n.mdi-finance:before {\n  content: \"\\F81E\";\n}\n.mdi-find-replace:before {\n  content: \"\\F6D3\";\n}\n.mdi-fingerprint:before {\n  content: \"\\F237\";\n}\n.mdi-fire:before {\n  content: \"\\F238\";\n}\n.mdi-fire-truck:before {\n  content: \"\\F8AA\";\n}\n.mdi-firefox:before {\n  content: \"\\F239\";\n}\n.mdi-fish:before {\n  content: \"\\F23A\";\n}\n.mdi-flag:before {\n  content: \"\\F23B\";\n}\n.mdi-flag-checkered:before {\n  content: \"\\F23C\";\n}\n.mdi-flag-outline:before {\n  content: \"\\F23D\";\n}\n.mdi-flag-triangle:before {\n  content: \"\\F23F\";\n}\n.mdi-flag-variant:before {\n  content: \"\\F240\";\n}\n.mdi-flag-variant-outline:before {\n  content: \"\\F23E\";\n}\n.mdi-flash:before {\n  content: \"\\F241\";\n}\n.mdi-flash-auto:before {\n  content: \"\\F242\";\n}\n.mdi-flash-circle:before {\n  content: \"\\F81F\";\n}\n.mdi-flash-off:before {\n  content: \"\\F243\";\n}\n.mdi-flash-outline:before {\n  content: \"\\F6D4\";\n}\n.mdi-flash-red-eye:before {\n  content: \"\\F67A\";\n}\n.mdi-flashlight:before {\n  content: \"\\F244\";\n}\n.mdi-flashlight-off:before {\n  content: \"\\F245\";\n}\n.mdi-flask:before {\n  content: \"\\F093\";\n}\n.mdi-flask-empty:before {\n  content: \"\\F094\";\n}\n.mdi-flask-empty-outline:before {\n  content: \"\\F095\";\n}\n.mdi-flask-outline:before {\n  content: \"\\F096\";\n}\n.mdi-flattr:before {\n  content: \"\\F246\";\n}\n.mdi-flip-to-back:before {\n  content: \"\\F247\";\n}\n.mdi-flip-to-front:before {\n  content: \"\\F248\";\n}\n.mdi-floor-plan:before {\n  content: \"\\F820\";\n}\n.mdi-floppy:before {\n  content: \"\\F249\";\n}\n.mdi-flower:before {\n  content: \"\\F24A\";\n}\n.mdi-folder:before {\n  content: \"\\F24B\";\n}\n.mdi-folder-account:before {\n  content: \"\\F24C\";\n}\n.mdi-folder-download:before {\n  content: \"\\F24D\";\n}\n.mdi-folder-google-drive:before {\n  content: \"\\F24E\";\n}\n.mdi-folder-image:before {\n  content: \"\\F24F\";\n}\n.mdi-folder-key:before {\n  content: \"\\F8AB\";\n}\n.mdi-folder-key-network:before {\n  content: \"\\F8AC\";\n}\n.mdi-folder-lock:before {\n  content: \"\\F250\";\n}\n.mdi-folder-lock-open:before {\n  content: \"\\F251\";\n}\n.mdi-folder-move:before {\n  content: \"\\F252\";\n}\n.mdi-folder-multiple:before {\n  content: \"\\F253\";\n}\n.mdi-folder-multiple-image:before {\n  content: \"\\F254\";\n}\n.mdi-folder-multiple-outline:before {\n  content: \"\\F255\";\n}\n.mdi-folder-network:before {\n  content: \"\\F86F\";\n}\n.mdi-folder-open:before {\n  content: \"\\F76F\";\n}\n.mdi-folder-outline:before {\n  content: \"\\F256\";\n}\n.mdi-folder-plus:before {\n  content: \"\\F257\";\n}\n.mdi-folder-remove:before {\n  content: \"\\F258\";\n}\n.mdi-folder-star:before {\n  content: \"\\F69C\";\n}\n.mdi-folder-upload:before {\n  content: \"\\F259\";\n}\n.mdi-font-awesome:before {\n  content: \"\\F03A\";\n}\n.mdi-food:before {\n  content: \"\\F25A\";\n}\n.mdi-food-apple:before {\n  content: \"\\F25B\";\n}\n.mdi-food-croissant:before {\n  content: \"\\F7C7\";\n}\n.mdi-food-fork-drink:before {\n  content: \"\\F5F2\";\n}\n.mdi-food-off:before {\n  content: \"\\F5F3\";\n}\n.mdi-food-variant:before {\n  content: \"\\F25C\";\n}\n.mdi-football:before {\n  content: \"\\F25D\";\n}\n.mdi-football-australian:before {\n  content: \"\\F25E\";\n}\n.mdi-football-helmet:before {\n  content: \"\\F25F\";\n}\n.mdi-forklift:before {\n  content: \"\\F7C8\";\n}\n.mdi-format-align-bottom:before {\n  content: \"\\F752\";\n}\n.mdi-format-align-center:before {\n  content: \"\\F260\";\n}\n.mdi-format-align-justify:before {\n  content: \"\\F261\";\n}\n.mdi-format-align-left:before {\n  content: \"\\F262\";\n}\n.mdi-format-align-middle:before {\n  content: \"\\F753\";\n}\n.mdi-format-align-right:before {\n  content: \"\\F263\";\n}\n.mdi-format-align-top:before {\n  content: \"\\F754\";\n}\n.mdi-format-annotation-plus:before {\n  content: \"\\F646\";\n}\n.mdi-format-bold:before {\n  content: \"\\F264\";\n}\n.mdi-format-clear:before {\n  content: \"\\F265\";\n}\n.mdi-format-color-fill:before {\n  content: \"\\F266\";\n}\n.mdi-format-color-text:before {\n  content: \"\\F69D\";\n}\n.mdi-format-float-center:before {\n  content: \"\\F267\";\n}\n.mdi-format-float-left:before {\n  content: \"\\F268\";\n}\n.mdi-format-float-none:before {\n  content: \"\\F269\";\n}\n.mdi-format-float-right:before {\n  content: \"\\F26A\";\n}\n.mdi-format-font:before {\n  content: \"\\F6D5\";\n}\n.mdi-format-header-1:before {\n  content: \"\\F26B\";\n}\n.mdi-format-header-2:before {\n  content: \"\\F26C\";\n}\n.mdi-format-header-3:before {\n  content: \"\\F26D\";\n}\n.mdi-format-header-4:before {\n  content: \"\\F26E\";\n}\n.mdi-format-header-5:before {\n  content: \"\\F26F\";\n}\n.mdi-format-header-6:before {\n  content: \"\\F270\";\n}\n.mdi-format-header-decrease:before {\n  content: \"\\F271\";\n}\n.mdi-format-header-equal:before {\n  content: \"\\F272\";\n}\n.mdi-format-header-increase:before {\n  content: \"\\F273\";\n}\n.mdi-format-header-pound:before {\n  content: \"\\F274\";\n}\n.mdi-format-horizontal-align-center:before {\n  content: \"\\F61E\";\n}\n.mdi-format-horizontal-align-left:before {\n  content: \"\\F61F\";\n}\n.mdi-format-horizontal-align-right:before {\n  content: \"\\F620\";\n}\n.mdi-format-indent-decrease:before {\n  content: \"\\F275\";\n}\n.mdi-format-indent-increase:before {\n  content: \"\\F276\";\n}\n.mdi-format-italic:before {\n  content: \"\\F277\";\n}\n.mdi-format-line-spacing:before {\n  content: \"\\F278\";\n}\n.mdi-format-line-style:before {\n  content: \"\\F5C8\";\n}\n.mdi-format-line-weight:before {\n  content: \"\\F5C9\";\n}\n.mdi-format-list-bulleted:before {\n  content: \"\\F279\";\n}\n.mdi-format-list-bulleted-type:before {\n  content: \"\\F27A\";\n}\n.mdi-format-list-checks:before {\n  content: \"\\F755\";\n}\n.mdi-format-list-numbers:before {\n  content: \"\\F27B\";\n}\n.mdi-format-page-break:before {\n  content: \"\\F6D6\";\n}\n.mdi-format-paint:before {\n  content: \"\\F27C\";\n}\n.mdi-format-paragraph:before {\n  content: \"\\F27D\";\n}\n.mdi-format-pilcrow:before {\n  content: \"\\F6D7\";\n}\n.mdi-format-quote-close:before {\n  content: \"\\F27E\";\n}\n.mdi-format-quote-open:before {\n  content: \"\\F756\";\n}\n.mdi-format-rotate-90:before {\n  content: \"\\F6A9\";\n}\n.mdi-format-section:before {\n  content: \"\\F69E\";\n}\n.mdi-format-size:before {\n  content: \"\\F27F\";\n}\n.mdi-format-strikethrough:before {\n  content: \"\\F280\";\n}\n.mdi-format-strikethrough-variant:before {\n  content: \"\\F281\";\n}\n.mdi-format-subscript:before {\n  content: \"\\F282\";\n}\n.mdi-format-superscript:before {\n  content: \"\\F283\";\n}\n.mdi-format-text:before {\n  content: \"\\F284\";\n}\n.mdi-format-textdirection-l-to-r:before {\n  content: \"\\F285\";\n}\n.mdi-format-textdirection-r-to-l:before {\n  content: \"\\F286\";\n}\n.mdi-format-title:before {\n  content: \"\\F5F4\";\n}\n.mdi-format-underline:before {\n  content: \"\\F287\";\n}\n.mdi-format-vertical-align-bottom:before {\n  content: \"\\F621\";\n}\n.mdi-format-vertical-align-center:before {\n  content: \"\\F622\";\n}\n.mdi-format-vertical-align-top:before {\n  content: \"\\F623\";\n}\n.mdi-format-wrap-inline:before {\n  content: \"\\F288\";\n}\n.mdi-format-wrap-square:before {\n  content: \"\\F289\";\n}\n.mdi-format-wrap-tight:before {\n  content: \"\\F28A\";\n}\n.mdi-format-wrap-top-bottom:before {\n  content: \"\\F28B\";\n}\n.mdi-forum:before {\n  content: \"\\F28C\";\n}\n.mdi-forum-outline:before {\n  content: \"\\F821\";\n}\n.mdi-forward:before {\n  content: \"\\F28D\";\n}\n.mdi-foursquare:before {\n  content: \"\\F28E\";\n}\n.mdi-fridge:before {\n  content: \"\\F28F\";\n}\n.mdi-fridge-filled:before {\n  content: \"\\F290\";\n}\n.mdi-fridge-filled-bottom:before {\n  content: \"\\F291\";\n}\n.mdi-fridge-filled-top:before {\n  content: \"\\F292\";\n}\n.mdi-fuel:before {\n  content: \"\\F7C9\";\n}\n.mdi-fullscreen:before {\n  content: \"\\F293\";\n}\n.mdi-fullscreen-exit:before {\n  content: \"\\F294\";\n}\n.mdi-function:before {\n  content: \"\\F295\";\n}\n.mdi-function-variant:before {\n  content: \"\\F870\";\n}\n.mdi-gamepad:before {\n  content: \"\\F296\";\n}\n.mdi-gamepad-variant:before {\n  content: \"\\F297\";\n}\n.mdi-garage:before {\n  content: \"\\F6D8\";\n}\n.mdi-garage-alert:before {\n  content: \"\\F871\";\n}\n.mdi-garage-open:before {\n  content: \"\\F6D9\";\n}\n.mdi-gas-cylinder:before {\n  content: \"\\F647\";\n}\n.mdi-gas-station:before {\n  content: \"\\F298\";\n}\n.mdi-gate:before {\n  content: \"\\F299\";\n}\n.mdi-gauge:before {\n  content: \"\\F29A\";\n}\n.mdi-gauge-empty:before {\n  content: \"\\F872\";\n}\n.mdi-gauge-full:before {\n  content: \"\\F873\";\n}\n.mdi-gauge-low:before {\n  content: \"\\F874\";\n}\n.mdi-gavel:before {\n  content: \"\\F29B\";\n}\n.mdi-gender-female:before {\n  content: \"\\F29C\";\n}\n.mdi-gender-male:before {\n  content: \"\\F29D\";\n}\n.mdi-gender-male-female:before {\n  content: \"\\F29E\";\n}\n.mdi-gender-transgender:before {\n  content: \"\\F29F\";\n}\n.mdi-gesture:before {\n  content: \"\\F7CA\";\n}\n.mdi-gesture-double-tap:before {\n  content: \"\\F73B\";\n}\n.mdi-gesture-swipe-down:before {\n  content: \"\\F73C\";\n}\n.mdi-gesture-swipe-left:before {\n  content: \"\\F73D\";\n}\n.mdi-gesture-swipe-right:before {\n  content: \"\\F73E\";\n}\n.mdi-gesture-swipe-up:before {\n  content: \"\\F73F\";\n}\n.mdi-gesture-tap:before {\n  content: \"\\F740\";\n}\n.mdi-gesture-two-double-tap:before {\n  content: \"\\F741\";\n}\n.mdi-gesture-two-tap:before {\n  content: \"\\F742\";\n}\n.mdi-ghost:before {\n  content: \"\\F2A0\";\n}\n.mdi-gift:before {\n  content: \"\\F2A1\";\n}\n.mdi-git:before {\n  content: \"\\F2A2\";\n}\n.mdi-github-box:before {\n  content: \"\\F2A3\";\n}\n.mdi-github-circle:before {\n  content: \"\\F2A4\";\n}\n.mdi-github-face:before {\n  content: \"\\F6DA\";\n}\n.mdi-glass-cocktail:before {\n  content: \"\\F356\";\n}\n.mdi-glass-flute:before {\n  content: \"\\F2A5\";\n}\n.mdi-glass-mug:before {\n  content: \"\\F2A6\";\n}\n.mdi-glass-stange:before {\n  content: \"\\F2A7\";\n}\n.mdi-glass-tulip:before {\n  content: \"\\F2A8\";\n}\n.mdi-glass-wine:before {\n  content: \"\\F875\";\n}\n.mdi-glassdoor:before {\n  content: \"\\F2A9\";\n}\n.mdi-glasses:before {\n  content: \"\\F2AA\";\n}\n.mdi-gmail:before {\n  content: \"\\F2AB\";\n}\n.mdi-gnome:before {\n  content: \"\\F2AC\";\n}\n.mdi-golf:before {\n  content: \"\\F822\";\n}\n.mdi-gondola:before {\n  content: \"\\F685\";\n}\n.mdi-google:before {\n  content: \"\\F2AD\";\n}\n.mdi-google-analytics:before {\n  content: \"\\F7CB\";\n}\n.mdi-google-assistant:before {\n  content: \"\\F7CC\";\n}\n.mdi-google-cardboard:before {\n  content: \"\\F2AE\";\n}\n.mdi-google-chrome:before {\n  content: \"\\F2AF\";\n}\n.mdi-google-circles:before {\n  content: \"\\F2B0\";\n}\n.mdi-google-circles-communities:before {\n  content: \"\\F2B1\";\n}\n.mdi-google-circles-extended:before {\n  content: \"\\F2B2\";\n}\n.mdi-google-circles-group:before {\n  content: \"\\F2B3\";\n}\n.mdi-google-controller:before {\n  content: \"\\F2B4\";\n}\n.mdi-google-controller-off:before {\n  content: \"\\F2B5\";\n}\n.mdi-google-drive:before {\n  content: \"\\F2B6\";\n}\n.mdi-google-earth:before {\n  content: \"\\F2B7\";\n}\n.mdi-google-glass:before {\n  content: \"\\F2B8\";\n}\n.mdi-google-home:before {\n  content: \"\\F823\";\n}\n.mdi-google-keep:before {\n  content: \"\\F6DB\";\n}\n.mdi-google-maps:before {\n  content: \"\\F5F5\";\n}\n.mdi-google-nearby:before {\n  content: \"\\F2B9\";\n}\n.mdi-google-pages:before {\n  content: \"\\F2BA\";\n}\n.mdi-google-photos:before {\n  content: \"\\F6DC\";\n}\n.mdi-google-physical-web:before {\n  content: \"\\F2BB\";\n}\n.mdi-google-play:before {\n  content: \"\\F2BC\";\n}\n.mdi-google-plus:before {\n  content: \"\\F2BD\";\n}\n.mdi-google-plus-box:before {\n  content: \"\\F2BE\";\n}\n.mdi-google-translate:before {\n  content: \"\\F2BF\";\n}\n.mdi-google-wallet:before {\n  content: \"\\F2C0\";\n}\n.mdi-gpu:before {\n  content: \"\\F8AD\";\n}\n.mdi-gradient:before {\n  content: \"\\F69F\";\n}\n.mdi-graphql:before {\n  content: \"\\F876\";\n}\n.mdi-grease-pencil:before {\n  content: \"\\F648\";\n}\n.mdi-grid:before {\n  content: \"\\F2C1\";\n}\n.mdi-grid-large:before {\n  content: \"\\F757\";\n}\n.mdi-grid-off:before {\n  content: \"\\F2C2\";\n}\n.mdi-group:before {\n  content: \"\\F2C3\";\n}\n.mdi-guitar-acoustic:before {\n  content: \"\\F770\";\n}\n.mdi-guitar-electric:before {\n  content: \"\\F2C4\";\n}\n.mdi-guitar-pick:before {\n  content: \"\\F2C5\";\n}\n.mdi-guitar-pick-outline:before {\n  content: \"\\F2C6\";\n}\n.mdi-guy-fawkes-mask:before {\n  content: \"\\F824\";\n}\n.mdi-hackernews:before {\n  content: \"\\F624\";\n}\n.mdi-hamburger:before {\n  content: \"\\F684\";\n}\n.mdi-hand-pointing-right:before {\n  content: \"\\F2C7\";\n}\n.mdi-hanger:before {\n  content: \"\\F2C8\";\n}\n.mdi-hangouts:before {\n  content: \"\\F2C9\";\n}\n.mdi-harddisk:before {\n  content: \"\\F2CA\";\n}\n.mdi-headphones:before {\n  content: \"\\F2CB\";\n}\n.mdi-headphones-box:before {\n  content: \"\\F2CC\";\n}\n.mdi-headphones-off:before {\n  content: \"\\F7CD\";\n}\n.mdi-headphones-settings:before {\n  content: \"\\F2CD\";\n}\n.mdi-headset:before {\n  content: \"\\F2CE\";\n}\n.mdi-headset-dock:before {\n  content: \"\\F2CF\";\n}\n.mdi-headset-off:before {\n  content: \"\\F2D0\";\n}\n.mdi-heart:before {\n  content: \"\\F2D1\";\n}\n.mdi-heart-box:before {\n  content: \"\\F2D2\";\n}\n.mdi-heart-box-outline:before {\n  content: \"\\F2D3\";\n}\n.mdi-heart-broken:before {\n  content: \"\\F2D4\";\n}\n.mdi-heart-half:before {\n  content: \"\\F6DE\";\n}\n.mdi-heart-half-full:before {\n  content: \"\\F6DD\";\n}\n.mdi-heart-half-outline:before {\n  content: \"\\F6DF\";\n}\n.mdi-heart-off:before {\n  content: \"\\F758\";\n}\n.mdi-heart-outline:before {\n  content: \"\\F2D5\";\n}\n.mdi-heart-pulse:before {\n  content: \"\\F5F6\";\n}\n.mdi-help:before {\n  content: \"\\F2D6\";\n}\n.mdi-help-box:before {\n  content: \"\\F78A\";\n}\n.mdi-help-circle:before {\n  content: \"\\F2D7\";\n}\n.mdi-help-circle-outline:before {\n  content: \"\\F625\";\n}\n.mdi-help-network:before {\n  content: \"\\F6F4\";\n}\n.mdi-hexagon:before {\n  content: \"\\F2D8\";\n}\n.mdi-hexagon-multiple:before {\n  content: \"\\F6E0\";\n}\n.mdi-hexagon-outline:before {\n  content: \"\\F2D9\";\n}\n.mdi-high-definition:before {\n  content: \"\\F7CE\";\n}\n.mdi-high-definition-box:before {\n  content: \"\\F877\";\n}\n.mdi-highway:before {\n  content: \"\\F5F7\";\n}\n.mdi-history:before {\n  content: \"\\F2DA\";\n}\n.mdi-hockey-puck:before {\n  content: \"\\F878\";\n}\n.mdi-hockey-sticks:before {\n  content: \"\\F879\";\n}\n.mdi-hololens:before {\n  content: \"\\F2DB\";\n}\n.mdi-home:before {\n  content: \"\\F2DC\";\n}\n.mdi-home-account:before {\n  content: \"\\F825\";\n}\n.mdi-home-alert:before {\n  content: \"\\F87A\";\n}\n.mdi-home-assistant:before {\n  content: \"\\F7CF\";\n}\n.mdi-home-automation:before {\n  content: \"\\F7D0\";\n}\n.mdi-home-circle:before {\n  content: \"\\F7D1\";\n}\n.mdi-home-currency-usd:before {\n  content: \"\\F8AE\";\n}\n.mdi-home-heart:before {\n  content: \"\\F826\";\n}\n.mdi-home-map-marker:before {\n  content: \"\\F5F8\";\n}\n.mdi-home-modern:before {\n  content: \"\\F2DD\";\n}\n.mdi-home-outline:before {\n  content: \"\\F6A0\";\n}\n.mdi-home-variant:before {\n  content: \"\\F2DE\";\n}\n.mdi-hook:before {\n  content: \"\\F6E1\";\n}\n.mdi-hook-off:before {\n  content: \"\\F6E2\";\n}\n.mdi-hops:before {\n  content: \"\\F2DF\";\n}\n.mdi-hospital:before {\n  content: \"\\F2E0\";\n}\n.mdi-hospital-building:before {\n  content: \"\\F2E1\";\n}\n.mdi-hospital-marker:before {\n  content: \"\\F2E2\";\n}\n.mdi-hot-tub:before {\n  content: \"\\F827\";\n}\n.mdi-hotel:before {\n  content: \"\\F2E3\";\n}\n.mdi-houzz:before {\n  content: \"\\F2E4\";\n}\n.mdi-houzz-box:before {\n  content: \"\\F2E5\";\n}\n.mdi-hulu:before {\n  content: \"\\F828\";\n}\n.mdi-human:before {\n  content: \"\\F2E6\";\n}\n.mdi-human-child:before {\n  content: \"\\F2E7\";\n}\n.mdi-human-female:before {\n  content: \"\\F649\";\n}\n.mdi-human-greeting:before {\n  content: \"\\F64A\";\n}\n.mdi-human-handsdown:before {\n  content: \"\\F64B\";\n}\n.mdi-human-handsup:before {\n  content: \"\\F64C\";\n}\n.mdi-human-male:before {\n  content: \"\\F64D\";\n}\n.mdi-human-male-female:before {\n  content: \"\\F2E8\";\n}\n.mdi-human-pregnant:before {\n  content: \"\\F5CF\";\n}\n.mdi-humble-bundle:before {\n  content: \"\\F743\";\n}\n.mdi-ice-cream:before {\n  content: \"\\F829\";\n}\n.mdi-image:before {\n  content: \"\\F2E9\";\n}\n.mdi-image-album:before {\n  content: \"\\F2EA\";\n}\n.mdi-image-area:before {\n  content: \"\\F2EB\";\n}\n.mdi-image-area-close:before {\n  content: \"\\F2EC\";\n}\n.mdi-image-broken:before {\n  content: \"\\F2ED\";\n}\n.mdi-image-broken-variant:before {\n  content: \"\\F2EE\";\n}\n.mdi-image-filter:before {\n  content: \"\\F2EF\";\n}\n.mdi-image-filter-black-white:before {\n  content: \"\\F2F0\";\n}\n.mdi-image-filter-center-focus:before {\n  content: \"\\F2F1\";\n}\n.mdi-image-filter-center-focus-weak:before {\n  content: \"\\F2F2\";\n}\n.mdi-image-filter-drama:before {\n  content: \"\\F2F3\";\n}\n.mdi-image-filter-frames:before {\n  content: \"\\F2F4\";\n}\n.mdi-image-filter-hdr:before {\n  content: \"\\F2F5\";\n}\n.mdi-image-filter-none:before {\n  content: \"\\F2F6\";\n}\n.mdi-image-filter-tilt-shift:before {\n  content: \"\\F2F7\";\n}\n.mdi-image-filter-vintage:before {\n  content: \"\\F2F8\";\n}\n.mdi-image-multiple:before {\n  content: \"\\F2F9\";\n}\n.mdi-image-off:before {\n  content: \"\\F82A\";\n}\n.mdi-image-plus:before {\n  content: \"\\F87B\";\n}\n.mdi-import:before {\n  content: \"\\F2FA\";\n}\n.mdi-inbox:before {\n  content: \"\\F686\";\n}\n.mdi-inbox-arrow-down:before {\n  content: \"\\F2FB\";\n}\n.mdi-inbox-arrow-up:before {\n  content: \"\\F3D1\";\n}\n.mdi-inbox-multiple:before {\n  content: \"\\F8AF\";\n}\n.mdi-incognito:before {\n  content: \"\\F5F9\";\n}\n.mdi-infinity:before {\n  content: \"\\F6E3\";\n}\n.mdi-information:before {\n  content: \"\\F2FC\";\n}\n.mdi-information-outline:before {\n  content: \"\\F2FD\";\n}\n.mdi-information-variant:before {\n  content: \"\\F64E\";\n}\n.mdi-instagram:before {\n  content: \"\\F2FE\";\n}\n.mdi-instapaper:before {\n  content: \"\\F2FF\";\n}\n.mdi-internet-explorer:before {\n  content: \"\\F300\";\n}\n.mdi-invert-colors:before {\n  content: \"\\F301\";\n}\n.mdi-itunes:before {\n  content: \"\\F676\";\n}\n.mdi-jeepney:before {\n  content: \"\\F302\";\n}\n.mdi-jira:before {\n  content: \"\\F303\";\n}\n.mdi-jquery:before {\n  content: \"\\F87C\";\n}\n.mdi-jsfiddle:before {\n  content: \"\\F304\";\n}\n.mdi-json:before {\n  content: \"\\F626\";\n}\n.mdi-karate:before {\n  content: \"\\F82B\";\n}\n.mdi-keg:before {\n  content: \"\\F305\";\n}\n.mdi-kettle:before {\n  content: \"\\F5FA\";\n}\n.mdi-key:before {\n  content: \"\\F306\";\n}\n.mdi-key-change:before {\n  content: \"\\F307\";\n}\n.mdi-key-minus:before {\n  content: \"\\F308\";\n}\n.mdi-key-plus:before {\n  content: \"\\F309\";\n}\n.mdi-key-remove:before {\n  content: \"\\F30A\";\n}\n.mdi-key-variant:before {\n  content: \"\\F30B\";\n}\n.mdi-keyboard:before {\n  content: \"\\F30C\";\n}\n.mdi-keyboard-backspace:before {\n  content: \"\\F30D\";\n}\n.mdi-keyboard-caps:before {\n  content: \"\\F30E\";\n}\n.mdi-keyboard-close:before {\n  content: \"\\F30F\";\n}\n.mdi-keyboard-off:before {\n  content: \"\\F310\";\n}\n.mdi-keyboard-return:before {\n  content: \"\\F311\";\n}\n.mdi-keyboard-tab:before {\n  content: \"\\F312\";\n}\n.mdi-keyboard-variant:before {\n  content: \"\\F313\";\n}\n.mdi-kickstarter:before {\n  content: \"\\F744\";\n}\n.mdi-kodi:before {\n  content: \"\\F314\";\n}\n.mdi-label:before {\n  content: \"\\F315\";\n}\n.mdi-label-outline:before {\n  content: \"\\F316\";\n}\n.mdi-ladybug:before {\n  content: \"\\F82C\";\n}\n.mdi-lambda:before {\n  content: \"\\F627\";\n}\n.mdi-lamp:before {\n  content: \"\\F6B4\";\n}\n.mdi-lan:before {\n  content: \"\\F317\";\n}\n.mdi-lan-connect:before {\n  content: \"\\F318\";\n}\n.mdi-lan-disconnect:before {\n  content: \"\\F319\";\n}\n.mdi-lan-pending:before {\n  content: \"\\F31A\";\n}\n.mdi-language-c:before {\n  content: \"\\F671\";\n}\n.mdi-language-cpp:before {\n  content: \"\\F672\";\n}\n.mdi-language-csharp:before {\n  content: \"\\F31B\";\n}\n.mdi-language-css3:before {\n  content: \"\\F31C\";\n}\n.mdi-language-go:before {\n  content: \"\\F7D2\";\n}\n.mdi-language-html5:before {\n  content: \"\\F31D\";\n}\n.mdi-language-javascript:before {\n  content: \"\\F31E\";\n}\n.mdi-language-lua:before {\n  content: \"\\F8B0\";\n}\n.mdi-language-php:before {\n  content: \"\\F31F\";\n}\n.mdi-language-python:before {\n  content: \"\\F320\";\n}\n.mdi-language-python-text:before {\n  content: \"\\F321\";\n}\n.mdi-language-r:before {\n  content: \"\\F7D3\";\n}\n.mdi-language-swift:before {\n  content: \"\\F6E4\";\n}\n.mdi-language-typescript:before {\n  content: \"\\F6E5\";\n}\n.mdi-laptop:before {\n  content: \"\\F322\";\n}\n.mdi-laptop-chromebook:before {\n  content: \"\\F323\";\n}\n.mdi-laptop-mac:before {\n  content: \"\\F324\";\n}\n.mdi-laptop-off:before {\n  content: \"\\F6E6\";\n}\n.mdi-laptop-windows:before {\n  content: \"\\F325\";\n}\n.mdi-lastfm:before {\n  content: \"\\F326\";\n}\n.mdi-lastpass:before {\n  content: \"\\F446\";\n}\n.mdi-launch:before {\n  content: \"\\F327\";\n}\n.mdi-lava-lamp:before {\n  content: \"\\F7D4\";\n}\n.mdi-layers:before {\n  content: \"\\F328\";\n}\n.mdi-layers-off:before {\n  content: \"\\F329\";\n}\n.mdi-lead-pencil:before {\n  content: \"\\F64F\";\n}\n.mdi-leaf:before {\n  content: \"\\F32A\";\n}\n.mdi-led-off:before {\n  content: \"\\F32B\";\n}\n.mdi-led-on:before {\n  content: \"\\F32C\";\n}\n.mdi-led-outline:before {\n  content: \"\\F32D\";\n}\n.mdi-led-strip:before {\n  content: \"\\F7D5\";\n}\n.mdi-led-variant-off:before {\n  content: \"\\F32E\";\n}\n.mdi-led-variant-on:before {\n  content: \"\\F32F\";\n}\n.mdi-led-variant-outline:before {\n  content: \"\\F330\";\n}\n.mdi-library:before {\n  content: \"\\F331\";\n}\n.mdi-library-books:before {\n  content: \"\\F332\";\n}\n.mdi-library-music:before {\n  content: \"\\F333\";\n}\n.mdi-library-plus:before {\n  content: \"\\F334\";\n}\n.mdi-lifebuoy:before {\n  content: \"\\F87D\";\n}\n.mdi-lightbulb:before {\n  content: \"\\F335\";\n}\n.mdi-lightbulb-on:before {\n  content: \"\\F6E7\";\n}\n.mdi-lightbulb-on-outline:before {\n  content: \"\\F6E8\";\n}\n.mdi-lightbulb-outline:before {\n  content: \"\\F336\";\n}\n.mdi-link:before {\n  content: \"\\F337\";\n}\n.mdi-link-off:before {\n  content: \"\\F338\";\n}\n.mdi-link-variant:before {\n  content: \"\\F339\";\n}\n.mdi-link-variant-off:before {\n  content: \"\\F33A\";\n}\n.mdi-linkedin:before {\n  content: \"\\F33B\";\n}\n.mdi-linkedin-box:before {\n  content: \"\\F33C\";\n}\n.mdi-linux:before {\n  content: \"\\F33D\";\n}\n.mdi-loading:before {\n  content: \"\\F771\";\n}\n.mdi-lock:before {\n  content: \"\\F33E\";\n}\n.mdi-lock-open:before {\n  content: \"\\F33F\";\n}\n.mdi-lock-open-outline:before {\n  content: \"\\F340\";\n}\n.mdi-lock-outline:before {\n  content: \"\\F341\";\n}\n.mdi-lock-pattern:before {\n  content: \"\\F6E9\";\n}\n.mdi-lock-plus:before {\n  content: \"\\F5FB\";\n}\n.mdi-lock-reset:before {\n  content: \"\\F772\";\n}\n.mdi-lock-smart:before {\n  content: \"\\F8B1\";\n}\n.mdi-locker:before {\n  content: \"\\F7D6\";\n}\n.mdi-locker-multiple:before {\n  content: \"\\F7D7\";\n}\n.mdi-login:before {\n  content: \"\\F342\";\n}\n.mdi-login-variant:before {\n  content: \"\\F5FC\";\n}\n.mdi-logout:before {\n  content: \"\\F343\";\n}\n.mdi-logout-variant:before {\n  content: \"\\F5FD\";\n}\n.mdi-looks:before {\n  content: \"\\F344\";\n}\n.mdi-loop:before {\n  content: \"\\F6EA\";\n}\n.mdi-loupe:before {\n  content: \"\\F345\";\n}\n.mdi-lumx:before {\n  content: \"\\F346\";\n}\n.mdi-magnet:before {\n  content: \"\\F347\";\n}\n.mdi-magnet-on:before {\n  content: \"\\F348\";\n}\n.mdi-magnify:before {\n  content: \"\\F349\";\n}\n.mdi-magnify-minus:before {\n  content: \"\\F34A\";\n}\n.mdi-magnify-minus-outline:before {\n  content: \"\\F6EB\";\n}\n.mdi-magnify-plus:before {\n  content: \"\\F34B\";\n}\n.mdi-magnify-plus-outline:before {\n  content: \"\\F6EC\";\n}\n.mdi-mail-ru:before {\n  content: \"\\F34C\";\n}\n.mdi-mailbox:before {\n  content: \"\\F6ED\";\n}\n.mdi-map:before {\n  content: \"\\F34D\";\n}\n.mdi-map-marker:before {\n  content: \"\\F34E\";\n}\n.mdi-map-marker-circle:before {\n  content: \"\\F34F\";\n}\n.mdi-map-marker-minus:before {\n  content: \"\\F650\";\n}\n.mdi-map-marker-multiple:before {\n  content: \"\\F350\";\n}\n.mdi-map-marker-off:before {\n  content: \"\\F351\";\n}\n.mdi-map-marker-outline:before {\n  content: \"\\F7D8\";\n}\n.mdi-map-marker-plus:before {\n  content: \"\\F651\";\n}\n.mdi-map-marker-radius:before {\n  content: \"\\F352\";\n}\n.mdi-margin:before {\n  content: \"\\F353\";\n}\n.mdi-markdown:before {\n  content: \"\\F354\";\n}\n.mdi-marker:before {\n  content: \"\\F652\";\n}\n.mdi-marker-check:before {\n  content: \"\\F355\";\n}\n.mdi-material-ui:before {\n  content: \"\\F357\";\n}\n.mdi-math-compass:before {\n  content: \"\\F358\";\n}\n.mdi-matrix:before {\n  content: \"\\F628\";\n}\n.mdi-maxcdn:before {\n  content: \"\\F359\";\n}\n.mdi-medical-bag:before {\n  content: \"\\F6EE\";\n}\n.mdi-medium:before {\n  content: \"\\F35A\";\n}\n.mdi-memory:before {\n  content: \"\\F35B\";\n}\n.mdi-menu:before {\n  content: \"\\F35C\";\n}\n.mdi-menu-down:before {\n  content: \"\\F35D\";\n}\n.mdi-menu-down-outline:before {\n  content: \"\\F6B5\";\n}\n.mdi-menu-left:before {\n  content: \"\\F35E\";\n}\n.mdi-menu-right:before {\n  content: \"\\F35F\";\n}\n.mdi-menu-up:before {\n  content: \"\\F360\";\n}\n.mdi-menu-up-outline:before {\n  content: \"\\F6B6\";\n}\n.mdi-message:before {\n  content: \"\\F361\";\n}\n.mdi-message-alert:before {\n  content: \"\\F362\";\n}\n.mdi-message-bulleted:before {\n  content: \"\\F6A1\";\n}\n.mdi-message-bulleted-off:before {\n  content: \"\\F6A2\";\n}\n.mdi-message-draw:before {\n  content: \"\\F363\";\n}\n.mdi-message-image:before {\n  content: \"\\F364\";\n}\n.mdi-message-outline:before {\n  content: \"\\F365\";\n}\n.mdi-message-plus:before {\n  content: \"\\F653\";\n}\n.mdi-message-processing:before {\n  content: \"\\F366\";\n}\n.mdi-message-reply:before {\n  content: \"\\F367\";\n}\n.mdi-message-reply-text:before {\n  content: \"\\F368\";\n}\n.mdi-message-settings:before {\n  content: \"\\F6EF\";\n}\n.mdi-message-settings-variant:before {\n  content: \"\\F6F0\";\n}\n.mdi-message-text:before {\n  content: \"\\F369\";\n}\n.mdi-message-text-outline:before {\n  content: \"\\F36A\";\n}\n.mdi-message-video:before {\n  content: \"\\F36B\";\n}\n.mdi-meteor:before {\n  content: \"\\F629\";\n}\n.mdi-metronome:before {\n  content: \"\\F7D9\";\n}\n.mdi-metronome-tick:before {\n  content: \"\\F7DA\";\n}\n.mdi-micro-sd:before {\n  content: \"\\F7DB\";\n}\n.mdi-microphone:before {\n  content: \"\\F36C\";\n}\n.mdi-microphone-minus:before {\n  content: \"\\F8B2\";\n}\n.mdi-microphone-off:before {\n  content: \"\\F36D\";\n}\n.mdi-microphone-outline:before {\n  content: \"\\F36E\";\n}\n.mdi-microphone-plus:before {\n  content: \"\\F8B3\";\n}\n.mdi-microphone-settings:before {\n  content: \"\\F36F\";\n}\n.mdi-microphone-variant:before {\n  content: \"\\F370\";\n}\n.mdi-microphone-variant-off:before {\n  content: \"\\F371\";\n}\n.mdi-microscope:before {\n  content: \"\\F654\";\n}\n.mdi-microsoft:before {\n  content: \"\\F372\";\n}\n.mdi-minecraft:before {\n  content: \"\\F373\";\n}\n.mdi-minus:before {\n  content: \"\\F374\";\n}\n.mdi-minus-box:before {\n  content: \"\\F375\";\n}\n.mdi-minus-box-outline:before {\n  content: \"\\F6F1\";\n}\n.mdi-minus-circle:before {\n  content: \"\\F376\";\n}\n.mdi-minus-circle-outline:before {\n  content: \"\\F377\";\n}\n.mdi-minus-network:before {\n  content: \"\\F378\";\n}\n.mdi-mixcloud:before {\n  content: \"\\F62A\";\n}\n.mdi-mixed-reality:before {\n  content: \"\\F87E\";\n}\n.mdi-mixer:before {\n  content: \"\\F7DC\";\n}\n.mdi-monitor:before {\n  content: \"\\F379\";\n}\n.mdi-monitor-multiple:before {\n  content: \"\\F37A\";\n}\n.mdi-more:before {\n  content: \"\\F37B\";\n}\n.mdi-motorbike:before {\n  content: \"\\F37C\";\n}\n.mdi-mouse:before {\n  content: \"\\F37D\";\n}\n.mdi-mouse-off:before {\n  content: \"\\F37E\";\n}\n.mdi-mouse-variant:before {\n  content: \"\\F37F\";\n}\n.mdi-mouse-variant-off:before {\n  content: \"\\F380\";\n}\n.mdi-move-resize:before {\n  content: \"\\F655\";\n}\n.mdi-move-resize-variant:before {\n  content: \"\\F656\";\n}\n.mdi-movie:before {\n  content: \"\\F381\";\n}\n.mdi-movie-roll:before {\n  content: \"\\F7DD\";\n}\n.mdi-multiplication:before {\n  content: \"\\F382\";\n}\n.mdi-multiplication-box:before {\n  content: \"\\F383\";\n}\n.mdi-mushroom:before {\n  content: \"\\F7DE\";\n}\n.mdi-mushroom-outline:before {\n  content: \"\\F7DF\";\n}\n.mdi-music:before {\n  content: \"\\F759\";\n}\n.mdi-music-box:before {\n  content: \"\\F384\";\n}\n.mdi-music-box-outline:before {\n  content: \"\\F385\";\n}\n.mdi-music-circle:before {\n  content: \"\\F386\";\n}\n.mdi-music-note:before {\n  content: \"\\F387\";\n}\n.mdi-music-note-bluetooth:before {\n  content: \"\\F5FE\";\n}\n.mdi-music-note-bluetooth-off:before {\n  content: \"\\F5FF\";\n}\n.mdi-music-note-eighth:before {\n  content: \"\\F388\";\n}\n.mdi-music-note-half:before {\n  content: \"\\F389\";\n}\n.mdi-music-note-off:before {\n  content: \"\\F38A\";\n}\n.mdi-music-note-quarter:before {\n  content: \"\\F38B\";\n}\n.mdi-music-note-sixteenth:before {\n  content: \"\\F38C\";\n}\n.mdi-music-note-whole:before {\n  content: \"\\F38D\";\n}\n.mdi-music-off:before {\n  content: \"\\F75A\";\n}\n.mdi-nativescript:before {\n  content: \"\\F87F\";\n}\n.mdi-nature:before {\n  content: \"\\F38E\";\n}\n.mdi-nature-people:before {\n  content: \"\\F38F\";\n}\n.mdi-navigation:before {\n  content: \"\\F390\";\n}\n.mdi-near-me:before {\n  content: \"\\F5CD\";\n}\n.mdi-needle:before {\n  content: \"\\F391\";\n}\n.mdi-nest-protect:before {\n  content: \"\\F392\";\n}\n.mdi-nest-thermostat:before {\n  content: \"\\F393\";\n}\n.mdi-netflix:before {\n  content: \"\\F745\";\n}\n.mdi-network:before {\n  content: \"\\F6F2\";\n}\n.mdi-new-box:before {\n  content: \"\\F394\";\n}\n.mdi-newspaper:before {\n  content: \"\\F395\";\n}\n.mdi-nfc:before {\n  content: \"\\F396\";\n}\n.mdi-nfc-tap:before {\n  content: \"\\F397\";\n}\n.mdi-nfc-variant:before {\n  content: \"\\F398\";\n}\n.mdi-ninja:before {\n  content: \"\\F773\";\n}\n.mdi-nintendo-switch:before {\n  content: \"\\F7E0\";\n}\n.mdi-nodejs:before {\n  content: \"\\F399\";\n}\n.mdi-note:before {\n  content: \"\\F39A\";\n}\n.mdi-note-multiple:before {\n  content: \"\\F6B7\";\n}\n.mdi-note-multiple-outline:before {\n  content: \"\\F6B8\";\n}\n.mdi-note-outline:before {\n  content: \"\\F39B\";\n}\n.mdi-note-plus:before {\n  content: \"\\F39C\";\n}\n.mdi-note-plus-outline:before {\n  content: \"\\F39D\";\n}\n.mdi-note-text:before {\n  content: \"\\F39E\";\n}\n.mdi-notebook:before {\n  content: \"\\F82D\";\n}\n.mdi-notification-clear-all:before {\n  content: \"\\F39F\";\n}\n.mdi-npm:before {\n  content: \"\\F6F6\";\n}\n.mdi-nuke:before {\n  content: \"\\F6A3\";\n}\n.mdi-null:before {\n  content: \"\\F7E1\";\n}\n.mdi-numeric:before {\n  content: \"\\F3A0\";\n}\n.mdi-numeric-0-box:before {\n  content: \"\\F3A1\";\n}\n.mdi-numeric-0-box-multiple-outline:before {\n  content: \"\\F3A2\";\n}\n.mdi-numeric-0-box-outline:before {\n  content: \"\\F3A3\";\n}\n.mdi-numeric-1-box:before {\n  content: \"\\F3A4\";\n}\n.mdi-numeric-1-box-multiple-outline:before {\n  content: \"\\F3A5\";\n}\n.mdi-numeric-1-box-outline:before {\n  content: \"\\F3A6\";\n}\n.mdi-numeric-2-box:before {\n  content: \"\\F3A7\";\n}\n.mdi-numeric-2-box-multiple-outline:before {\n  content: \"\\F3A8\";\n}\n.mdi-numeric-2-box-outline:before {\n  content: \"\\F3A9\";\n}\n.mdi-numeric-3-box:before {\n  content: \"\\F3AA\";\n}\n.mdi-numeric-3-box-multiple-outline:before {\n  content: \"\\F3AB\";\n}\n.mdi-numeric-3-box-outline:before {\n  content: \"\\F3AC\";\n}\n.mdi-numeric-4-box:before {\n  content: \"\\F3AD\";\n}\n.mdi-numeric-4-box-multiple-outline:before {\n  content: \"\\F3AE\";\n}\n.mdi-numeric-4-box-outline:before {\n  content: \"\\F3AF\";\n}\n.mdi-numeric-5-box:before {\n  content: \"\\F3B0\";\n}\n.mdi-numeric-5-box-multiple-outline:before {\n  content: \"\\F3B1\";\n}\n.mdi-numeric-5-box-outline:before {\n  content: \"\\F3B2\";\n}\n.mdi-numeric-6-box:before {\n  content: \"\\F3B3\";\n}\n.mdi-numeric-6-box-multiple-outline:before {\n  content: \"\\F3B4\";\n}\n.mdi-numeric-6-box-outline:before {\n  content: \"\\F3B5\";\n}\n.mdi-numeric-7-box:before {\n  content: \"\\F3B6\";\n}\n.mdi-numeric-7-box-multiple-outline:before {\n  content: \"\\F3B7\";\n}\n.mdi-numeric-7-box-outline:before {\n  content: \"\\F3B8\";\n}\n.mdi-numeric-8-box:before {\n  content: \"\\F3B9\";\n}\n.mdi-numeric-8-box-multiple-outline:before {\n  content: \"\\F3BA\";\n}\n.mdi-numeric-8-box-outline:before {\n  content: \"\\F3BB\";\n}\n.mdi-numeric-9-box:before {\n  content: \"\\F3BC\";\n}\n.mdi-numeric-9-box-multiple-outline:before {\n  content: \"\\F3BD\";\n}\n.mdi-numeric-9-box-outline:before {\n  content: \"\\F3BE\";\n}\n.mdi-numeric-9-plus-box:before {\n  content: \"\\F3BF\";\n}\n.mdi-numeric-9-plus-box-multiple-outline:before {\n  content: \"\\F3C0\";\n}\n.mdi-numeric-9-plus-box-outline:before {\n  content: \"\\F3C1\";\n}\n.mdi-nut:before {\n  content: \"\\F6F7\";\n}\n.mdi-nutrition:before {\n  content: \"\\F3C2\";\n}\n.mdi-oar:before {\n  content: \"\\F67B\";\n}\n.mdi-octagon:before {\n  content: \"\\F3C3\";\n}\n.mdi-octagon-outline:before {\n  content: \"\\F3C4\";\n}\n.mdi-octagram:before {\n  content: \"\\F6F8\";\n}\n.mdi-octagram-outline:before {\n  content: \"\\F774\";\n}\n.mdi-odnoklassniki:before {\n  content: \"\\F3C5\";\n}\n.mdi-office:before {\n  content: \"\\F3C6\";\n}\n.mdi-oil:before {\n  content: \"\\F3C7\";\n}\n.mdi-oil-temperature:before {\n  content: \"\\F3C8\";\n}\n.mdi-omega:before {\n  content: \"\\F3C9\";\n}\n.mdi-onedrive:before {\n  content: \"\\F3CA\";\n}\n.mdi-onenote:before {\n  content: \"\\F746\";\n}\n.mdi-onepassword:before {\n  content: \"\\F880\";\n}\n.mdi-opacity:before {\n  content: \"\\F5CC\";\n}\n.mdi-open-in-app:before {\n  content: \"\\F3CB\";\n}\n.mdi-open-in-new:before {\n  content: \"\\F3CC\";\n}\n.mdi-openid:before {\n  content: \"\\F3CD\";\n}\n.mdi-opera:before {\n  content: \"\\F3CE\";\n}\n.mdi-orbit:before {\n  content: \"\\F018\";\n}\n.mdi-ornament:before {\n  content: \"\\F3CF\";\n}\n.mdi-ornament-variant:before {\n  content: \"\\F3D0\";\n}\n.mdi-owl:before {\n  content: \"\\F3D2\";\n}\n.mdi-package:before {\n  content: \"\\F3D3\";\n}\n.mdi-package-down:before {\n  content: \"\\F3D4\";\n}\n.mdi-package-up:before {\n  content: \"\\F3D5\";\n}\n.mdi-package-variant:before {\n  content: \"\\F3D6\";\n}\n.mdi-package-variant-closed:before {\n  content: \"\\F3D7\";\n}\n.mdi-page-first:before {\n  content: \"\\F600\";\n}\n.mdi-page-last:before {\n  content: \"\\F601\";\n}\n.mdi-page-layout-body:before {\n  content: \"\\F6F9\";\n}\n.mdi-page-layout-footer:before {\n  content: \"\\F6FA\";\n}\n.mdi-page-layout-header:before {\n  content: \"\\F6FB\";\n}\n.mdi-page-layout-sidebar-left:before {\n  content: \"\\F6FC\";\n}\n.mdi-page-layout-sidebar-right:before {\n  content: \"\\F6FD\";\n}\n.mdi-palette:before {\n  content: \"\\F3D8\";\n}\n.mdi-palette-advanced:before {\n  content: \"\\F3D9\";\n}\n.mdi-palette-swatch:before {\n  content: \"\\F8B4\";\n}\n.mdi-panda:before {\n  content: \"\\F3DA\";\n}\n.mdi-pandora:before {\n  content: \"\\F3DB\";\n}\n.mdi-panorama:before {\n  content: \"\\F3DC\";\n}\n.mdi-panorama-fisheye:before {\n  content: \"\\F3DD\";\n}\n.mdi-panorama-horizontal:before {\n  content: \"\\F3DE\";\n}\n.mdi-panorama-vertical:before {\n  content: \"\\F3DF\";\n}\n.mdi-panorama-wide-angle:before {\n  content: \"\\F3E0\";\n}\n.mdi-paper-cut-vertical:before {\n  content: \"\\F3E1\";\n}\n.mdi-paperclip:before {\n  content: \"\\F3E2\";\n}\n.mdi-parking:before {\n  content: \"\\F3E3\";\n}\n.mdi-passport:before {\n  content: \"\\F7E2\";\n}\n.mdi-patreon:before {\n  content: \"\\F881\";\n}\n.mdi-pause:before {\n  content: \"\\F3E4\";\n}\n.mdi-pause-circle:before {\n  content: \"\\F3E5\";\n}\n.mdi-pause-circle-outline:before {\n  content: \"\\F3E6\";\n}\n.mdi-pause-octagon:before {\n  content: \"\\F3E7\";\n}\n.mdi-pause-octagon-outline:before {\n  content: \"\\F3E8\";\n}\n.mdi-paw:before {\n  content: \"\\F3E9\";\n}\n.mdi-paw-off:before {\n  content: \"\\F657\";\n}\n.mdi-paypal:before {\n  content: \"\\F882\";\n}\n.mdi-peace:before {\n  content: \"\\F883\";\n}\n.mdi-pen:before {\n  content: \"\\F3EA\";\n}\n.mdi-pencil:before {\n  content: \"\\F3EB\";\n}\n.mdi-pencil-box:before {\n  content: \"\\F3EC\";\n}\n.mdi-pencil-box-outline:before {\n  content: \"\\F3ED\";\n}\n.mdi-pencil-circle:before {\n  content: \"\\F6FE\";\n}\n.mdi-pencil-circle-outline:before {\n  content: \"\\F775\";\n}\n.mdi-pencil-lock:before {\n  content: \"\\F3EE\";\n}\n.mdi-pencil-off:before {\n  content: \"\\F3EF\";\n}\n.mdi-pentagon:before {\n  content: \"\\F6FF\";\n}\n.mdi-pentagon-outline:before {\n  content: \"\\F700\";\n}\n.mdi-percent:before {\n  content: \"\\F3F0\";\n}\n.mdi-periodic-table:before {\n  content: \"\\F8B5\";\n}\n.mdi-periodic-table-co2:before {\n  content: \"\\F7E3\";\n}\n.mdi-periscope:before {\n  content: \"\\F747\";\n}\n.mdi-pharmacy:before {\n  content: \"\\F3F1\";\n}\n.mdi-phone:before {\n  content: \"\\F3F2\";\n}\n.mdi-phone-bluetooth:before {\n  content: \"\\F3F3\";\n}\n.mdi-phone-classic:before {\n  content: \"\\F602\";\n}\n.mdi-phone-forward:before {\n  content: \"\\F3F4\";\n}\n.mdi-phone-hangup:before {\n  content: \"\\F3F5\";\n}\n.mdi-phone-in-talk:before {\n  content: \"\\F3F6\";\n}\n.mdi-phone-incoming:before {\n  content: \"\\F3F7\";\n}\n.mdi-phone-locked:before {\n  content: \"\\F3F8\";\n}\n.mdi-phone-log:before {\n  content: \"\\F3F9\";\n}\n.mdi-phone-minus:before {\n  content: \"\\F658\";\n}\n.mdi-phone-missed:before {\n  content: \"\\F3FA\";\n}\n.mdi-phone-outgoing:before {\n  content: \"\\F3FB\";\n}\n.mdi-phone-paused:before {\n  content: \"\\F3FC\";\n}\n.mdi-phone-plus:before {\n  content: \"\\F659\";\n}\n.mdi-phone-return:before {\n  content: \"\\F82E\";\n}\n.mdi-phone-rotate-landscape:before {\n  content: \"\\F884\";\n}\n.mdi-phone-rotate-portrait:before {\n  content: \"\\F885\";\n}\n.mdi-phone-settings:before {\n  content: \"\\F3FD\";\n}\n.mdi-phone-voip:before {\n  content: \"\\F3FE\";\n}\n.mdi-pi:before {\n  content: \"\\F3FF\";\n}\n.mdi-pi-box:before {\n  content: \"\\F400\";\n}\n.mdi-piano:before {\n  content: \"\\F67C\";\n}\n.mdi-pickaxe:before {\n  content: \"\\F8B6\";\n}\n.mdi-pier:before {\n  content: \"\\F886\";\n}\n.mdi-pier-crane:before {\n  content: \"\\F887\";\n}\n.mdi-pig:before {\n  content: \"\\F401\";\n}\n.mdi-pill:before {\n  content: \"\\F402\";\n}\n.mdi-pillar:before {\n  content: \"\\F701\";\n}\n.mdi-pin:before {\n  content: \"\\F403\";\n}\n.mdi-pin-off:before {\n  content: \"\\F404\";\n}\n.mdi-pine-tree:before {\n  content: \"\\F405\";\n}\n.mdi-pine-tree-box:before {\n  content: \"\\F406\";\n}\n.mdi-pinterest:before {\n  content: \"\\F407\";\n}\n.mdi-pinterest-box:before {\n  content: \"\\F408\";\n}\n.mdi-pipe:before {\n  content: \"\\F7E4\";\n}\n.mdi-pipe-disconnected:before {\n  content: \"\\F7E5\";\n}\n.mdi-pipe-leak:before {\n  content: \"\\F888\";\n}\n.mdi-pistol:before {\n  content: \"\\F702\";\n}\n.mdi-piston:before {\n  content: \"\\F889\";\n}\n.mdi-pizza:before {\n  content: \"\\F409\";\n}\n.mdi-plane-shield:before {\n  content: \"\\F6BA\";\n}\n.mdi-play:before {\n  content: \"\\F40A\";\n}\n.mdi-play-box-outline:before {\n  content: \"\\F40B\";\n}\n.mdi-play-circle:before {\n  content: \"\\F40C\";\n}\n.mdi-play-circle-outline:before {\n  content: \"\\F40D\";\n}\n.mdi-play-network:before {\n  content: \"\\F88A\";\n}\n.mdi-play-pause:before {\n  content: \"\\F40E\";\n}\n.mdi-play-protected-content:before {\n  content: \"\\F40F\";\n}\n.mdi-playlist-check:before {\n  content: \"\\F5C7\";\n}\n.mdi-playlist-minus:before {\n  content: \"\\F410\";\n}\n.mdi-playlist-play:before {\n  content: \"\\F411\";\n}\n.mdi-playlist-plus:before {\n  content: \"\\F412\";\n}\n.mdi-playlist-remove:before {\n  content: \"\\F413\";\n}\n.mdi-playstation:before {\n  content: \"\\F414\";\n}\n.mdi-plex:before {\n  content: \"\\F6B9\";\n}\n.mdi-plus:before {\n  content: \"\\F415\";\n}\n.mdi-plus-box:before {\n  content: \"\\F416\";\n}\n.mdi-plus-box-outline:before {\n  content: \"\\F703\";\n}\n.mdi-plus-circle:before {\n  content: \"\\F417\";\n}\n.mdi-plus-circle-multiple-outline:before {\n  content: \"\\F418\";\n}\n.mdi-plus-circle-outline:before {\n  content: \"\\F419\";\n}\n.mdi-plus-network:before {\n  content: \"\\F41A\";\n}\n.mdi-plus-one:before {\n  content: \"\\F41B\";\n}\n.mdi-plus-outline:before {\n  content: \"\\F704\";\n}\n.mdi-pocket:before {\n  content: \"\\F41C\";\n}\n.mdi-pokeball:before {\n  content: \"\\F41D\";\n}\n.mdi-poker-chip:before {\n  content: \"\\F82F\";\n}\n.mdi-polaroid:before {\n  content: \"\\F41E\";\n}\n.mdi-poll:before {\n  content: \"\\F41F\";\n}\n.mdi-poll-box:before {\n  content: \"\\F420\";\n}\n.mdi-polymer:before {\n  content: \"\\F421\";\n}\n.mdi-pool:before {\n  content: \"\\F606\";\n}\n.mdi-popcorn:before {\n  content: \"\\F422\";\n}\n.mdi-pot:before {\n  content: \"\\F65A\";\n}\n.mdi-pot-mix:before {\n  content: \"\\F65B\";\n}\n.mdi-pound:before {\n  content: \"\\F423\";\n}\n.mdi-pound-box:before {\n  content: \"\\F424\";\n}\n.mdi-power:before {\n  content: \"\\F425\";\n}\n.mdi-power-plug:before {\n  content: \"\\F6A4\";\n}\n.mdi-power-plug-off:before {\n  content: \"\\F6A5\";\n}\n.mdi-power-settings:before {\n  content: \"\\F426\";\n}\n.mdi-power-socket:before {\n  content: \"\\F427\";\n}\n.mdi-power-socket-eu:before {\n  content: \"\\F7E6\";\n}\n.mdi-power-socket-uk:before {\n  content: \"\\F7E7\";\n}\n.mdi-power-socket-us:before {\n  content: \"\\F7E8\";\n}\n.mdi-prescription:before {\n  content: \"\\F705\";\n}\n.mdi-presentation:before {\n  content: \"\\F428\";\n}\n.mdi-presentation-play:before {\n  content: \"\\F429\";\n}\n.mdi-printer:before {\n  content: \"\\F42A\";\n}\n.mdi-printer-3d:before {\n  content: \"\\F42B\";\n}\n.mdi-printer-alert:before {\n  content: \"\\F42C\";\n}\n.mdi-printer-settings:before {\n  content: \"\\F706\";\n}\n.mdi-priority-high:before {\n  content: \"\\F603\";\n}\n.mdi-priority-low:before {\n  content: \"\\F604\";\n}\n.mdi-professional-hexagon:before {\n  content: \"\\F42D\";\n}\n.mdi-projector:before {\n  content: \"\\F42E\";\n}\n.mdi-projector-screen:before {\n  content: \"\\F42F\";\n}\n.mdi-publish:before {\n  content: \"\\F6A6\";\n}\n.mdi-pulse:before {\n  content: \"\\F430\";\n}\n.mdi-puzzle:before {\n  content: \"\\F431\";\n}\n.mdi-qqchat:before {\n  content: \"\\F605\";\n}\n.mdi-qrcode:before {\n  content: \"\\F432\";\n}\n.mdi-qrcode-edit:before {\n  content: \"\\F8B7\";\n}\n.mdi-qrcode-scan:before {\n  content: \"\\F433\";\n}\n.mdi-quadcopter:before {\n  content: \"\\F434\";\n}\n.mdi-quality-high:before {\n  content: \"\\F435\";\n}\n.mdi-quicktime:before {\n  content: \"\\F436\";\n}\n.mdi-radar:before {\n  content: \"\\F437\";\n}\n.mdi-radiator:before {\n  content: \"\\F438\";\n}\n.mdi-radio:before {\n  content: \"\\F439\";\n}\n.mdi-radio-handheld:before {\n  content: \"\\F43A\";\n}\n.mdi-radio-tower:before {\n  content: \"\\F43B\";\n}\n.mdi-radioactive:before {\n  content: \"\\F43C\";\n}\n.mdi-radiobox-blank:before {\n  content: \"\\F43D\";\n}\n.mdi-radiobox-marked:before {\n  content: \"\\F43E\";\n}\n.mdi-raspberrypi:before {\n  content: \"\\F43F\";\n}\n.mdi-ray-end:before {\n  content: \"\\F440\";\n}\n.mdi-ray-end-arrow:before {\n  content: \"\\F441\";\n}\n.mdi-ray-start:before {\n  content: \"\\F442\";\n}\n.mdi-ray-start-arrow:before {\n  content: \"\\F443\";\n}\n.mdi-ray-start-end:before {\n  content: \"\\F444\";\n}\n.mdi-ray-vertex:before {\n  content: \"\\F445\";\n}\n.mdi-react:before {\n  content: \"\\F707\";\n}\n.mdi-read:before {\n  content: \"\\F447\";\n}\n.mdi-receipt:before {\n  content: \"\\F449\";\n}\n.mdi-record:before {\n  content: \"\\F44A\";\n}\n.mdi-record-rec:before {\n  content: \"\\F44B\";\n}\n.mdi-recycle:before {\n  content: \"\\F44C\";\n}\n.mdi-reddit:before {\n  content: \"\\F44D\";\n}\n.mdi-redo:before {\n  content: \"\\F44E\";\n}\n.mdi-redo-variant:before {\n  content: \"\\F44F\";\n}\n.mdi-refresh:before {\n  content: \"\\F450\";\n}\n.mdi-regex:before {\n  content: \"\\F451\";\n}\n.mdi-relative-scale:before {\n  content: \"\\F452\";\n}\n.mdi-reload:before {\n  content: \"\\F453\";\n}\n.mdi-reminder:before {\n  content: \"\\F88B\";\n}\n.mdi-remote:before {\n  content: \"\\F454\";\n}\n.mdi-remote-desktop:before {\n  content: \"\\F8B8\";\n}\n.mdi-rename-box:before {\n  content: \"\\F455\";\n}\n.mdi-reorder-horizontal:before {\n  content: \"\\F687\";\n}\n.mdi-reorder-vertical:before {\n  content: \"\\F688\";\n}\n.mdi-repeat:before {\n  content: \"\\F456\";\n}\n.mdi-repeat-off:before {\n  content: \"\\F457\";\n}\n.mdi-repeat-once:before {\n  content: \"\\F458\";\n}\n.mdi-replay:before {\n  content: \"\\F459\";\n}\n.mdi-reply:before {\n  content: \"\\F45A\";\n}\n.mdi-reply-all:before {\n  content: \"\\F45B\";\n}\n.mdi-reproduction:before {\n  content: \"\\F45C\";\n}\n.mdi-resize-bottom-right:before {\n  content: \"\\F45D\";\n}\n.mdi-responsive:before {\n  content: \"\\F45E\";\n}\n.mdi-restart:before {\n  content: \"\\F708\";\n}\n.mdi-restore:before {\n  content: \"\\F6A7\";\n}\n.mdi-rewind:before {\n  content: \"\\F45F\";\n}\n.mdi-rewind-outline:before {\n  content: \"\\F709\";\n}\n.mdi-rhombus:before {\n  content: \"\\F70A\";\n}\n.mdi-rhombus-outline:before {\n  content: \"\\F70B\";\n}\n.mdi-ribbon:before {\n  content: \"\\F460\";\n}\n.mdi-rice:before {\n  content: \"\\F7E9\";\n}\n.mdi-ring:before {\n  content: \"\\F7EA\";\n}\n.mdi-road:before {\n  content: \"\\F461\";\n}\n.mdi-road-variant:before {\n  content: \"\\F462\";\n}\n.mdi-robot:before {\n  content: \"\\F6A8\";\n}\n.mdi-rocket:before {\n  content: \"\\F463\";\n}\n.mdi-room-service:before {\n  content: \"\\F88C\";\n}\n.mdi-roomba:before {\n  content: \"\\F70C\";\n}\n.mdi-rotate-3d:before {\n  content: \"\\F464\";\n}\n.mdi-rotate-left:before {\n  content: \"\\F465\";\n}\n.mdi-rotate-left-variant:before {\n  content: \"\\F466\";\n}\n.mdi-rotate-right:before {\n  content: \"\\F467\";\n}\n.mdi-rotate-right-variant:before {\n  content: \"\\F468\";\n}\n.mdi-rounded-corner:before {\n  content: \"\\F607\";\n}\n.mdi-router-wireless:before {\n  content: \"\\F469\";\n}\n.mdi-routes:before {\n  content: \"\\F46A\";\n}\n.mdi-rowing:before {\n  content: \"\\F608\";\n}\n.mdi-rss:before {\n  content: \"\\F46B\";\n}\n.mdi-rss-box:before {\n  content: \"\\F46C\";\n}\n.mdi-ruler:before {\n  content: \"\\F46D\";\n}\n.mdi-run:before {\n  content: \"\\F70D\";\n}\n.mdi-run-fast:before {\n  content: \"\\F46E\";\n}\n.mdi-sale:before {\n  content: \"\\F46F\";\n}\n.mdi-salesforce:before {\n  content: \"\\F88D\";\n}\n.mdi-sass:before {\n  content: \"\\F7EB\";\n}\n.mdi-satellite:before {\n  content: \"\\F470\";\n}\n.mdi-satellite-variant:before {\n  content: \"\\F471\";\n}\n.mdi-sausage:before {\n  content: \"\\F8B9\";\n}\n.mdi-saxophone:before {\n  content: \"\\F609\";\n}\n.mdi-scale:before {\n  content: \"\\F472\";\n}\n.mdi-scale-balance:before {\n  content: \"\\F5D1\";\n}\n.mdi-scale-bathroom:before {\n  content: \"\\F473\";\n}\n.mdi-scanner:before {\n  content: \"\\F6AA\";\n}\n.mdi-school:before {\n  content: \"\\F474\";\n}\n.mdi-screen-rotation:before {\n  content: \"\\F475\";\n}\n.mdi-screen-rotation-lock:before {\n  content: \"\\F476\";\n}\n.mdi-screwdriver:before {\n  content: \"\\F477\";\n}\n.mdi-script:before {\n  content: \"\\F478\";\n}\n.mdi-sd:before {\n  content: \"\\F479\";\n}\n.mdi-seal:before {\n  content: \"\\F47A\";\n}\n.mdi-search-web:before {\n  content: \"\\F70E\";\n}\n.mdi-seat-flat:before {\n  content: \"\\F47B\";\n}\n.mdi-seat-flat-angled:before {\n  content: \"\\F47C\";\n}\n.mdi-seat-individual-suite:before {\n  content: \"\\F47D\";\n}\n.mdi-seat-legroom-extra:before {\n  content: \"\\F47E\";\n}\n.mdi-seat-legroom-normal:before {\n  content: \"\\F47F\";\n}\n.mdi-seat-legroom-reduced:before {\n  content: \"\\F480\";\n}\n.mdi-seat-recline-extra:before {\n  content: \"\\F481\";\n}\n.mdi-seat-recline-normal:before {\n  content: \"\\F482\";\n}\n.mdi-security:before {\n  content: \"\\F483\";\n}\n.mdi-security-account:before {\n  content: \"\\F88E\";\n}\n.mdi-security-home:before {\n  content: \"\\F689\";\n}\n.mdi-security-network:before {\n  content: \"\\F484\";\n}\n.mdi-select:before {\n  content: \"\\F485\";\n}\n.mdi-select-all:before {\n  content: \"\\F486\";\n}\n.mdi-select-inverse:before {\n  content: \"\\F487\";\n}\n.mdi-select-off:before {\n  content: \"\\F488\";\n}\n.mdi-selection:before {\n  content: \"\\F489\";\n}\n.mdi-selection-off:before {\n  content: \"\\F776\";\n}\n.mdi-send:before {\n  content: \"\\F48A\";\n}\n.mdi-send-secure:before {\n  content: \"\\F7EC\";\n}\n.mdi-serial-port:before {\n  content: \"\\F65C\";\n}\n.mdi-server:before {\n  content: \"\\F48B\";\n}\n.mdi-server-minus:before {\n  content: \"\\F48C\";\n}\n.mdi-server-network:before {\n  content: \"\\F48D\";\n}\n.mdi-server-network-off:before {\n  content: \"\\F48E\";\n}\n.mdi-server-off:before {\n  content: \"\\F48F\";\n}\n.mdi-server-plus:before {\n  content: \"\\F490\";\n}\n.mdi-server-remove:before {\n  content: \"\\F491\";\n}\n.mdi-server-security:before {\n  content: \"\\F492\";\n}\n.mdi-set-all:before {\n  content: \"\\F777\";\n}\n.mdi-set-center:before {\n  content: \"\\F778\";\n}\n.mdi-set-center-right:before {\n  content: \"\\F779\";\n}\n.mdi-set-left:before {\n  content: \"\\F77A\";\n}\n.mdi-set-left-center:before {\n  content: \"\\F77B\";\n}\n.mdi-set-left-right:before {\n  content: \"\\F77C\";\n}\n.mdi-set-none:before {\n  content: \"\\F77D\";\n}\n.mdi-set-right:before {\n  content: \"\\F77E\";\n}\n.mdi-settings:before {\n  content: \"\\F493\";\n}\n.mdi-settings-box:before {\n  content: \"\\F494\";\n}\n.mdi-settings-outline:before {\n  content: \"\\F8BA\";\n}\n.mdi-shape:before {\n  content: \"\\F830\";\n}\n.mdi-shape-circle-plus:before {\n  content: \"\\F65D\";\n}\n.mdi-shape-outline:before {\n  content: \"\\F831\";\n}\n.mdi-shape-plus:before {\n  content: \"\\F495\";\n}\n.mdi-shape-polygon-plus:before {\n  content: \"\\F65E\";\n}\n.mdi-shape-rectangle-plus:before {\n  content: \"\\F65F\";\n}\n.mdi-shape-square-plus:before {\n  content: \"\\F660\";\n}\n.mdi-share:before {\n  content: \"\\F496\";\n}\n.mdi-share-variant:before {\n  content: \"\\F497\";\n}\n.mdi-shield:before {\n  content: \"\\F498\";\n}\n.mdi-shield-half-full:before {\n  content: \"\\F77F\";\n}\n.mdi-shield-outline:before {\n  content: \"\\F499\";\n}\n.mdi-ship-wheel:before {\n  content: \"\\F832\";\n}\n.mdi-shopping:before {\n  content: \"\\F49A\";\n}\n.mdi-shopping-music:before {\n  content: \"\\F49B\";\n}\n.mdi-shovel:before {\n  content: \"\\F70F\";\n}\n.mdi-shovel-off:before {\n  content: \"\\F710\";\n}\n.mdi-shredder:before {\n  content: \"\\F49C\";\n}\n.mdi-shuffle:before {\n  content: \"\\F49D\";\n}\n.mdi-shuffle-disabled:before {\n  content: \"\\F49E\";\n}\n.mdi-shuffle-variant:before {\n  content: \"\\F49F\";\n}\n.mdi-sigma:before {\n  content: \"\\F4A0\";\n}\n.mdi-sigma-lower:before {\n  content: \"\\F62B\";\n}\n.mdi-sign-caution:before {\n  content: \"\\F4A1\";\n}\n.mdi-sign-direction:before {\n  content: \"\\F780\";\n}\n.mdi-sign-text:before {\n  content: \"\\F781\";\n}\n.mdi-signal:before {\n  content: \"\\F4A2\";\n}\n.mdi-signal-2g:before {\n  content: \"\\F711\";\n}\n.mdi-signal-3g:before {\n  content: \"\\F712\";\n}\n.mdi-signal-4g:before {\n  content: \"\\F713\";\n}\n.mdi-signal-cellular-1:before {\n  content: \"\\F8BB\";\n}\n.mdi-signal-cellular-2:before {\n  content: \"\\F8BC\";\n}\n.mdi-signal-cellular-3:before {\n  content: \"\\F8BD\";\n}\n.mdi-signal-cellular-outline:before {\n  content: \"\\F8BE\";\n}\n.mdi-signal-hspa:before {\n  content: \"\\F714\";\n}\n.mdi-signal-hspa-plus:before {\n  content: \"\\F715\";\n}\n.mdi-signal-off:before {\n  content: \"\\F782\";\n}\n.mdi-signal-variant:before {\n  content: \"\\F60A\";\n}\n.mdi-silverware:before {\n  content: \"\\F4A3\";\n}\n.mdi-silverware-fork:before {\n  content: \"\\F4A4\";\n}\n.mdi-silverware-spoon:before {\n  content: \"\\F4A5\";\n}\n.mdi-silverware-variant:before {\n  content: \"\\F4A6\";\n}\n.mdi-sim:before {\n  content: \"\\F4A7\";\n}\n.mdi-sim-alert:before {\n  content: \"\\F4A8\";\n}\n.mdi-sim-off:before {\n  content: \"\\F4A9\";\n}\n.mdi-sitemap:before {\n  content: \"\\F4AA\";\n}\n.mdi-skip-backward:before {\n  content: \"\\F4AB\";\n}\n.mdi-skip-forward:before {\n  content: \"\\F4AC\";\n}\n.mdi-skip-next:before {\n  content: \"\\F4AD\";\n}\n.mdi-skip-next-circle:before {\n  content: \"\\F661\";\n}\n.mdi-skip-next-circle-outline:before {\n  content: \"\\F662\";\n}\n.mdi-skip-previous:before {\n  content: \"\\F4AE\";\n}\n.mdi-skip-previous-circle:before {\n  content: \"\\F663\";\n}\n.mdi-skip-previous-circle-outline:before {\n  content: \"\\F664\";\n}\n.mdi-skull:before {\n  content: \"\\F68B\";\n}\n.mdi-skype:before {\n  content: \"\\F4AF\";\n}\n.mdi-skype-business:before {\n  content: \"\\F4B0\";\n}\n.mdi-slack:before {\n  content: \"\\F4B1\";\n}\n.mdi-sleep:before {\n  content: \"\\F4B2\";\n}\n.mdi-sleep-off:before {\n  content: \"\\F4B3\";\n}\n.mdi-smoking:before {\n  content: \"\\F4B4\";\n}\n.mdi-smoking-off:before {\n  content: \"\\F4B5\";\n}\n.mdi-snapchat:before {\n  content: \"\\F4B6\";\n}\n.mdi-snowflake:before {\n  content: \"\\F716\";\n}\n.mdi-snowman:before {\n  content: \"\\F4B7\";\n}\n.mdi-soccer:before {\n  content: \"\\F4B8\";\n}\n.mdi-soccer-field:before {\n  content: \"\\F833\";\n}\n.mdi-sofa:before {\n  content: \"\\F4B9\";\n}\n.mdi-solid:before {\n  content: \"\\F68C\";\n}\n.mdi-sort:before {\n  content: \"\\F4BA\";\n}\n.mdi-sort-alphabetical:before {\n  content: \"\\F4BB\";\n}\n.mdi-sort-ascending:before {\n  content: \"\\F4BC\";\n}\n.mdi-sort-descending:before {\n  content: \"\\F4BD\";\n}\n.mdi-sort-numeric:before {\n  content: \"\\F4BE\";\n}\n.mdi-sort-variant:before {\n  content: \"\\F4BF\";\n}\n.mdi-soundcloud:before {\n  content: \"\\F4C0\";\n}\n.mdi-source-branch:before {\n  content: \"\\F62C\";\n}\n.mdi-source-commit:before {\n  content: \"\\F717\";\n}\n.mdi-source-commit-end:before {\n  content: \"\\F718\";\n}\n.mdi-source-commit-end-local:before {\n  content: \"\\F719\";\n}\n.mdi-source-commit-local:before {\n  content: \"\\F71A\";\n}\n.mdi-source-commit-next-local:before {\n  content: \"\\F71B\";\n}\n.mdi-source-commit-start:before {\n  content: \"\\F71C\";\n}\n.mdi-source-commit-start-next-local:before {\n  content: \"\\F71D\";\n}\n.mdi-source-fork:before {\n  content: \"\\F4C1\";\n}\n.mdi-source-merge:before {\n  content: \"\\F62D\";\n}\n.mdi-source-pull:before {\n  content: \"\\F4C2\";\n}\n.mdi-soy-sauce:before {\n  content: \"\\F7ED\";\n}\n.mdi-speaker:before {\n  content: \"\\F4C3\";\n}\n.mdi-speaker-off:before {\n  content: \"\\F4C4\";\n}\n.mdi-speaker-wireless:before {\n  content: \"\\F71E\";\n}\n.mdi-speedometer:before {\n  content: \"\\F4C5\";\n}\n.mdi-spellcheck:before {\n  content: \"\\F4C6\";\n}\n.mdi-spotify:before {\n  content: \"\\F4C7\";\n}\n.mdi-spotlight:before {\n  content: \"\\F4C8\";\n}\n.mdi-spotlight-beam:before {\n  content: \"\\F4C9\";\n}\n.mdi-spray:before {\n  content: \"\\F665\";\n}\n.mdi-square:before {\n  content: \"\\F763\";\n}\n.mdi-square-inc:before {\n  content: \"\\F4CA\";\n}\n.mdi-square-inc-cash:before {\n  content: \"\\F4CB\";\n}\n.mdi-square-outline:before {\n  content: \"\\F762\";\n}\n.mdi-square-root:before {\n  content: \"\\F783\";\n}\n.mdi-ssh:before {\n  content: \"\\F8BF\";\n}\n.mdi-stack-overflow:before {\n  content: \"\\F4CC\";\n}\n.mdi-stackexchange:before {\n  content: \"\\F60B\";\n}\n.mdi-stadium:before {\n  content: \"\\F71F\";\n}\n.mdi-stairs:before {\n  content: \"\\F4CD\";\n}\n.mdi-standard-definition:before {\n  content: \"\\F7EE\";\n}\n.mdi-star:before {\n  content: \"\\F4CE\";\n}\n.mdi-star-circle:before {\n  content: \"\\F4CF\";\n}\n.mdi-star-half:before {\n  content: \"\\F4D0\";\n}\n.mdi-star-off:before {\n  content: \"\\F4D1\";\n}\n.mdi-star-outline:before {\n  content: \"\\F4D2\";\n}\n.mdi-steam:before {\n  content: \"\\F4D3\";\n}\n.mdi-steering:before {\n  content: \"\\F4D4\";\n}\n.mdi-step-backward:before {\n  content: \"\\F4D5\";\n}\n.mdi-step-backward-2:before {\n  content: \"\\F4D6\";\n}\n.mdi-step-forward:before {\n  content: \"\\F4D7\";\n}\n.mdi-step-forward-2:before {\n  content: \"\\F4D8\";\n}\n.mdi-stethoscope:before {\n  content: \"\\F4D9\";\n}\n.mdi-sticker:before {\n  content: \"\\F5D0\";\n}\n.mdi-sticker-emoji:before {\n  content: \"\\F784\";\n}\n.mdi-stocking:before {\n  content: \"\\F4DA\";\n}\n.mdi-stop:before {\n  content: \"\\F4DB\";\n}\n.mdi-stop-circle:before {\n  content: \"\\F666\";\n}\n.mdi-stop-circle-outline:before {\n  content: \"\\F667\";\n}\n.mdi-store:before {\n  content: \"\\F4DC\";\n}\n.mdi-store-24-hour:before {\n  content: \"\\F4DD\";\n}\n.mdi-stove:before {\n  content: \"\\F4DE\";\n}\n.mdi-subdirectory-arrow-left:before {\n  content: \"\\F60C\";\n}\n.mdi-subdirectory-arrow-right:before {\n  content: \"\\F60D\";\n}\n.mdi-subway:before {\n  content: \"\\F6AB\";\n}\n.mdi-subway-variant:before {\n  content: \"\\F4DF\";\n}\n.mdi-summit:before {\n  content: \"\\F785\";\n}\n.mdi-sunglasses:before {\n  content: \"\\F4E0\";\n}\n.mdi-surround-sound:before {\n  content: \"\\F5C5\";\n}\n.mdi-surround-sound-2-0:before {\n  content: \"\\F7EF\";\n}\n.mdi-surround-sound-3-1:before {\n  content: \"\\F7F0\";\n}\n.mdi-surround-sound-5-1:before {\n  content: \"\\F7F1\";\n}\n.mdi-surround-sound-7-1:before {\n  content: \"\\F7F2\";\n}\n.mdi-svg:before {\n  content: \"\\F720\";\n}\n.mdi-swap-horizontal:before {\n  content: \"\\F4E1\";\n}\n.mdi-swap-horizontal-variant:before {\n  content: \"\\F8C0\";\n}\n.mdi-swap-vertical:before {\n  content: \"\\F4E2\";\n}\n.mdi-swap-vertical-variant:before {\n  content: \"\\F8C1\";\n}\n.mdi-swim:before {\n  content: \"\\F4E3\";\n}\n.mdi-switch:before {\n  content: \"\\F4E4\";\n}\n.mdi-sword:before {\n  content: \"\\F4E5\";\n}\n.mdi-sword-cross:before {\n  content: \"\\F786\";\n}\n.mdi-sync:before {\n  content: \"\\F4E6\";\n}\n.mdi-sync-alert:before {\n  content: \"\\F4E7\";\n}\n.mdi-sync-off:before {\n  content: \"\\F4E8\";\n}\n.mdi-tab:before {\n  content: \"\\F4E9\";\n}\n.mdi-tab-plus:before {\n  content: \"\\F75B\";\n}\n.mdi-tab-unselected:before {\n  content: \"\\F4EA\";\n}\n.mdi-table:before {\n  content: \"\\F4EB\";\n}\n.mdi-table-column:before {\n  content: \"\\F834\";\n}\n.mdi-table-column-plus-after:before {\n  content: \"\\F4EC\";\n}\n.mdi-table-column-plus-before:before {\n  content: \"\\F4ED\";\n}\n.mdi-table-column-remove:before {\n  content: \"\\F4EE\";\n}\n.mdi-table-column-width:before {\n  content: \"\\F4EF\";\n}\n.mdi-table-edit:before {\n  content: \"\\F4F0\";\n}\n.mdi-table-large:before {\n  content: \"\\F4F1\";\n}\n.mdi-table-of-contents:before {\n  content: \"\\F835\";\n}\n.mdi-table-row:before {\n  content: \"\\F836\";\n}\n.mdi-table-row-height:before {\n  content: \"\\F4F2\";\n}\n.mdi-table-row-plus-after:before {\n  content: \"\\F4F3\";\n}\n.mdi-table-row-plus-before:before {\n  content: \"\\F4F4\";\n}\n.mdi-table-row-remove:before {\n  content: \"\\F4F5\";\n}\n.mdi-table-settings:before {\n  content: \"\\F837\";\n}\n.mdi-tablet:before {\n  content: \"\\F4F6\";\n}\n.mdi-tablet-android:before {\n  content: \"\\F4F7\";\n}\n.mdi-tablet-ipad:before {\n  content: \"\\F4F8\";\n}\n.mdi-taco:before {\n  content: \"\\F761\";\n}\n.mdi-tag:before {\n  content: \"\\F4F9\";\n}\n.mdi-tag-faces:before {\n  content: \"\\F4FA\";\n}\n.mdi-tag-heart:before {\n  content: \"\\F68A\";\n}\n.mdi-tag-multiple:before {\n  content: \"\\F4FB\";\n}\n.mdi-tag-outline:before {\n  content: \"\\F4FC\";\n}\n.mdi-tag-plus:before {\n  content: \"\\F721\";\n}\n.mdi-tag-remove:before {\n  content: \"\\F722\";\n}\n.mdi-tag-text-outline:before {\n  content: \"\\F4FD\";\n}\n.mdi-target:before {\n  content: \"\\F4FE\";\n}\n.mdi-taxi:before {\n  content: \"\\F4FF\";\n}\n.mdi-teach:before {\n  content: \"\\F88F\";\n}\n.mdi-teamviewer:before {\n  content: \"\\F500\";\n}\n.mdi-telegram:before {\n  content: \"\\F501\";\n}\n.mdi-television:before {\n  content: \"\\F502\";\n}\n.mdi-television-box:before {\n  content: \"\\F838\";\n}\n.mdi-television-classic:before {\n  content: \"\\F7F3\";\n}\n.mdi-television-classic-off:before {\n  content: \"\\F839\";\n}\n.mdi-television-guide:before {\n  content: \"\\F503\";\n}\n.mdi-television-off:before {\n  content: \"\\F83A\";\n}\n.mdi-temperature-celsius:before {\n  content: \"\\F504\";\n}\n.mdi-temperature-fahrenheit:before {\n  content: \"\\F505\";\n}\n.mdi-temperature-kelvin:before {\n  content: \"\\F506\";\n}\n.mdi-tennis:before {\n  content: \"\\F507\";\n}\n.mdi-tent:before {\n  content: \"\\F508\";\n}\n.mdi-terrain:before {\n  content: \"\\F509\";\n}\n.mdi-test-tube:before {\n  content: \"\\F668\";\n}\n.mdi-text-shadow:before {\n  content: \"\\F669\";\n}\n.mdi-text-to-speech:before {\n  content: \"\\F50A\";\n}\n.mdi-text-to-speech-off:before {\n  content: \"\\F50B\";\n}\n.mdi-textbox:before {\n  content: \"\\F60E\";\n}\n.mdi-textbox-password:before {\n  content: \"\\F7F4\";\n}\n.mdi-texture:before {\n  content: \"\\F50C\";\n}\n.mdi-theater:before {\n  content: \"\\F50D\";\n}\n.mdi-theme-light-dark:before {\n  content: \"\\F50E\";\n}\n.mdi-thermometer:before {\n  content: \"\\F50F\";\n}\n.mdi-thermometer-lines:before {\n  content: \"\\F510\";\n}\n.mdi-thermostat-box:before {\n  content: \"\\F890\";\n}\n.mdi-thought-bubble:before {\n  content: \"\\F7F5\";\n}\n.mdi-thought-bubble-outline:before {\n  content: \"\\F7F6\";\n}\n.mdi-thumb-down:before {\n  content: \"\\F511\";\n}\n.mdi-thumb-down-outline:before {\n  content: \"\\F512\";\n}\n.mdi-thumb-up:before {\n  content: \"\\F513\";\n}\n.mdi-thumb-up-outline:before {\n  content: \"\\F514\";\n}\n.mdi-thumbs-up-down:before {\n  content: \"\\F515\";\n}\n.mdi-ticket:before {\n  content: \"\\F516\";\n}\n.mdi-ticket-account:before {\n  content: \"\\F517\";\n}\n.mdi-ticket-confirmation:before {\n  content: \"\\F518\";\n}\n.mdi-ticket-percent:before {\n  content: \"\\F723\";\n}\n.mdi-tie:before {\n  content: \"\\F519\";\n}\n.mdi-tilde:before {\n  content: \"\\F724\";\n}\n.mdi-timelapse:before {\n  content: \"\\F51A\";\n}\n.mdi-timer:before {\n  content: \"\\F51B\";\n}\n.mdi-timer-10:before {\n  content: \"\\F51C\";\n}\n.mdi-timer-3:before {\n  content: \"\\F51D\";\n}\n.mdi-timer-off:before {\n  content: \"\\F51E\";\n}\n.mdi-timer-sand:before {\n  content: \"\\F51F\";\n}\n.mdi-timer-sand-empty:before {\n  content: \"\\F6AC\";\n}\n.mdi-timer-sand-full:before {\n  content: \"\\F78B\";\n}\n.mdi-timetable:before {\n  content: \"\\F520\";\n}\n.mdi-toggle-switch:before {\n  content: \"\\F521\";\n}\n.mdi-toggle-switch-off:before {\n  content: \"\\F522\";\n}\n.mdi-tooltip:before {\n  content: \"\\F523\";\n}\n.mdi-tooltip-edit:before {\n  content: \"\\F524\";\n}\n.mdi-tooltip-image:before {\n  content: \"\\F525\";\n}\n.mdi-tooltip-outline:before {\n  content: \"\\F526\";\n}\n.mdi-tooltip-outline-plus:before {\n  content: \"\\F527\";\n}\n.mdi-tooltip-text:before {\n  content: \"\\F528\";\n}\n.mdi-tooth:before {\n  content: \"\\F8C2\";\n}\n.mdi-tooth-outline:before {\n  content: \"\\F529\";\n}\n.mdi-tor:before {\n  content: \"\\F52A\";\n}\n.mdi-tower-beach:before {\n  content: \"\\F680\";\n}\n.mdi-tower-fire:before {\n  content: \"\\F681\";\n}\n.mdi-towing:before {\n  content: \"\\F83B\";\n}\n.mdi-trackpad:before {\n  content: \"\\F7F7\";\n}\n.mdi-tractor:before {\n  content: \"\\F891\";\n}\n.mdi-traffic-light:before {\n  content: \"\\F52B\";\n}\n.mdi-train:before {\n  content: \"\\F52C\";\n}\n.mdi-train-variant:before {\n  content: \"\\F8C3\";\n}\n.mdi-tram:before {\n  content: \"\\F52D\";\n}\n.mdi-transcribe:before {\n  content: \"\\F52E\";\n}\n.mdi-transcribe-close:before {\n  content: \"\\F52F\";\n}\n.mdi-transfer:before {\n  content: \"\\F530\";\n}\n.mdi-transit-transfer:before {\n  content: \"\\F6AD\";\n}\n.mdi-translate:before {\n  content: \"\\F5CA\";\n}\n.mdi-treasure-chest:before {\n  content: \"\\F725\";\n}\n.mdi-tree:before {\n  content: \"\\F531\";\n}\n.mdi-trello:before {\n  content: \"\\F532\";\n}\n.mdi-trending-down:before {\n  content: \"\\F533\";\n}\n.mdi-trending-neutral:before {\n  content: \"\\F534\";\n}\n.mdi-trending-up:before {\n  content: \"\\F535\";\n}\n.mdi-triangle:before {\n  content: \"\\F536\";\n}\n.mdi-triangle-outline:before {\n  content: \"\\F537\";\n}\n.mdi-trophy:before {\n  content: \"\\F538\";\n}\n.mdi-trophy-award:before {\n  content: \"\\F539\";\n}\n.mdi-trophy-outline:before {\n  content: \"\\F53A\";\n}\n.mdi-trophy-variant:before {\n  content: \"\\F53B\";\n}\n.mdi-trophy-variant-outline:before {\n  content: \"\\F53C\";\n}\n.mdi-truck:before {\n  content: \"\\F53D\";\n}\n.mdi-truck-delivery:before {\n  content: \"\\F53E\";\n}\n.mdi-truck-fast:before {\n  content: \"\\F787\";\n}\n.mdi-truck-trailer:before {\n  content: \"\\F726\";\n}\n.mdi-tshirt-crew:before {\n  content: \"\\F53F\";\n}\n.mdi-tshirt-v:before {\n  content: \"\\F540\";\n}\n.mdi-tumblr:before {\n  content: \"\\F541\";\n}\n.mdi-tumblr-reblog:before {\n  content: \"\\F542\";\n}\n.mdi-tune:before {\n  content: \"\\F62E\";\n}\n.mdi-tune-vertical:before {\n  content: \"\\F66A\";\n}\n.mdi-twitch:before {\n  content: \"\\F543\";\n}\n.mdi-twitter:before {\n  content: \"\\F544\";\n}\n.mdi-twitter-box:before {\n  content: \"\\F545\";\n}\n.mdi-twitter-circle:before {\n  content: \"\\F546\";\n}\n.mdi-twitter-retweet:before {\n  content: \"\\F547\";\n}\n.mdi-uber:before {\n  content: \"\\F748\";\n}\n.mdi-ubuntu:before {\n  content: \"\\F548\";\n}\n.mdi-ultra-high-definition:before {\n  content: \"\\F7F8\";\n}\n.mdi-umbraco:before {\n  content: \"\\F549\";\n}\n.mdi-umbrella:before {\n  content: \"\\F54A\";\n}\n.mdi-umbrella-outline:before {\n  content: \"\\F54B\";\n}\n.mdi-undo:before {\n  content: \"\\F54C\";\n}\n.mdi-undo-variant:before {\n  content: \"\\F54D\";\n}\n.mdi-unfold-less-horizontal:before {\n  content: \"\\F54E\";\n}\n.mdi-unfold-less-vertical:before {\n  content: \"\\F75F\";\n}\n.mdi-unfold-more-horizontal:before {\n  content: \"\\F54F\";\n}\n.mdi-unfold-more-vertical:before {\n  content: \"\\F760\";\n}\n.mdi-ungroup:before {\n  content: \"\\F550\";\n}\n.mdi-unity:before {\n  content: \"\\F6AE\";\n}\n.mdi-untappd:before {\n  content: \"\\F551\";\n}\n.mdi-update:before {\n  content: \"\\F6AF\";\n}\n.mdi-upload:before {\n  content: \"\\F552\";\n}\n.mdi-upload-multiple:before {\n  content: \"\\F83C\";\n}\n.mdi-upload-network:before {\n  content: \"\\F6F5\";\n}\n.mdi-usb:before {\n  content: \"\\F553\";\n}\n.mdi-van-passenger:before {\n  content: \"\\F7F9\";\n}\n.mdi-van-utility:before {\n  content: \"\\F7FA\";\n}\n.mdi-vanish:before {\n  content: \"\\F7FB\";\n}\n.mdi-vector-arrange-above:before {\n  content: \"\\F554\";\n}\n.mdi-vector-arrange-below:before {\n  content: \"\\F555\";\n}\n.mdi-vector-circle:before {\n  content: \"\\F556\";\n}\n.mdi-vector-circle-variant:before {\n  content: \"\\F557\";\n}\n.mdi-vector-combine:before {\n  content: \"\\F558\";\n}\n.mdi-vector-curve:before {\n  content: \"\\F559\";\n}\n.mdi-vector-difference:before {\n  content: \"\\F55A\";\n}\n.mdi-vector-difference-ab:before {\n  content: \"\\F55B\";\n}\n.mdi-vector-difference-ba:before {\n  content: \"\\F55C\";\n}\n.mdi-vector-ellipse:before {\n  content: \"\\F892\";\n}\n.mdi-vector-intersection:before {\n  content: \"\\F55D\";\n}\n.mdi-vector-line:before {\n  content: \"\\F55E\";\n}\n.mdi-vector-point:before {\n  content: \"\\F55F\";\n}\n.mdi-vector-polygon:before {\n  content: \"\\F560\";\n}\n.mdi-vector-polyline:before {\n  content: \"\\F561\";\n}\n.mdi-vector-radius:before {\n  content: \"\\F749\";\n}\n.mdi-vector-rectangle:before {\n  content: \"\\F5C6\";\n}\n.mdi-vector-selection:before {\n  content: \"\\F562\";\n}\n.mdi-vector-square:before {\n  content: \"\\F001\";\n}\n.mdi-vector-triangle:before {\n  content: \"\\F563\";\n}\n.mdi-vector-union:before {\n  content: \"\\F564\";\n}\n.mdi-venmo:before {\n  content: \"\\F578\";\n}\n.mdi-verified:before {\n  content: \"\\F565\";\n}\n.mdi-vibrate:before {\n  content: \"\\F566\";\n}\n.mdi-video:before {\n  content: \"\\F567\";\n}\n.mdi-video-3d:before {\n  content: \"\\F7FC\";\n}\n.mdi-video-4k-box:before {\n  content: \"\\F83D\";\n}\n.mdi-video-input-antenna:before {\n  content: \"\\F83E\";\n}\n.mdi-video-input-component:before {\n  content: \"\\F83F\";\n}\n.mdi-video-input-hdmi:before {\n  content: \"\\F840\";\n}\n.mdi-video-input-svideo:before {\n  content: \"\\F841\";\n}\n.mdi-video-off:before {\n  content: \"\\F568\";\n}\n.mdi-video-switch:before {\n  content: \"\\F569\";\n}\n.mdi-view-agenda:before {\n  content: \"\\F56A\";\n}\n.mdi-view-array:before {\n  content: \"\\F56B\";\n}\n.mdi-view-carousel:before {\n  content: \"\\F56C\";\n}\n.mdi-view-column:before {\n  content: \"\\F56D\";\n}\n.mdi-view-dashboard:before {\n  content: \"\\F56E\";\n}\n.mdi-view-dashboard-variant:before {\n  content: \"\\F842\";\n}\n.mdi-view-day:before {\n  content: \"\\F56F\";\n}\n.mdi-view-grid:before {\n  content: \"\\F570\";\n}\n.mdi-view-headline:before {\n  content: \"\\F571\";\n}\n.mdi-view-list:before {\n  content: \"\\F572\";\n}\n.mdi-view-module:before {\n  content: \"\\F573\";\n}\n.mdi-view-parallel:before {\n  content: \"\\F727\";\n}\n.mdi-view-quilt:before {\n  content: \"\\F574\";\n}\n.mdi-view-sequential:before {\n  content: \"\\F728\";\n}\n.mdi-view-stream:before {\n  content: \"\\F575\";\n}\n.mdi-view-week:before {\n  content: \"\\F576\";\n}\n.mdi-vimeo:before {\n  content: \"\\F577\";\n}\n.mdi-violin:before {\n  content: \"\\F60F\";\n}\n.mdi-virtual-reality:before {\n  content: \"\\F893\";\n}\n.mdi-visualstudio:before {\n  content: \"\\F610\";\n}\n.mdi-vk:before {\n  content: \"\\F579\";\n}\n.mdi-vk-box:before {\n  content: \"\\F57A\";\n}\n.mdi-vk-circle:before {\n  content: \"\\F57B\";\n}\n.mdi-vlc:before {\n  content: \"\\F57C\";\n}\n.mdi-voice:before {\n  content: \"\\F5CB\";\n}\n.mdi-voicemail:before {\n  content: \"\\F57D\";\n}\n.mdi-volume-high:before {\n  content: \"\\F57E\";\n}\n.mdi-volume-low:before {\n  content: \"\\F57F\";\n}\n.mdi-volume-medium:before {\n  content: \"\\F580\";\n}\n.mdi-volume-minus:before {\n  content: \"\\F75D\";\n}\n.mdi-volume-mute:before {\n  content: \"\\F75E\";\n}\n.mdi-volume-off:before {\n  content: \"\\F581\";\n}\n.mdi-volume-plus:before {\n  content: \"\\F75C\";\n}\n.mdi-vpn:before {\n  content: \"\\F582\";\n}\n.mdi-vuejs:before {\n  content: \"\\F843\";\n}\n.mdi-walk:before {\n  content: \"\\F583\";\n}\n.mdi-wall:before {\n  content: \"\\F7FD\";\n}\n.mdi-wallet:before {\n  content: \"\\F584\";\n}\n.mdi-wallet-giftcard:before {\n  content: \"\\F585\";\n}\n.mdi-wallet-membership:before {\n  content: \"\\F586\";\n}\n.mdi-wallet-travel:before {\n  content: \"\\F587\";\n}\n.mdi-wan:before {\n  content: \"\\F588\";\n}\n.mdi-washing-machine:before {\n  content: \"\\F729\";\n}\n.mdi-watch:before {\n  content: \"\\F589\";\n}\n.mdi-watch-export:before {\n  content: \"\\F58A\";\n}\n.mdi-watch-export-variant:before {\n  content: \"\\F894\";\n}\n.mdi-watch-import:before {\n  content: \"\\F58B\";\n}\n.mdi-watch-import-variant:before {\n  content: \"\\F895\";\n}\n.mdi-watch-variant:before {\n  content: \"\\F896\";\n}\n.mdi-watch-vibrate:before {\n  content: \"\\F6B0\";\n}\n.mdi-water:before {\n  content: \"\\F58C\";\n}\n.mdi-water-off:before {\n  content: \"\\F58D\";\n}\n.mdi-water-percent:before {\n  content: \"\\F58E\";\n}\n.mdi-water-pump:before {\n  content: \"\\F58F\";\n}\n.mdi-watermark:before {\n  content: \"\\F612\";\n}\n.mdi-waves:before {\n  content: \"\\F78C\";\n}\n.mdi-weather-cloudy:before {\n  content: \"\\F590\";\n}\n.mdi-weather-fog:before {\n  content: \"\\F591\";\n}\n.mdi-weather-hail:before {\n  content: \"\\F592\";\n}\n.mdi-weather-hurricane:before {\n  content: \"\\F897\";\n}\n.mdi-weather-lightning:before {\n  content: \"\\F593\";\n}\n.mdi-weather-lightning-rainy:before {\n  content: \"\\F67D\";\n}\n.mdi-weather-night:before {\n  content: \"\\F594\";\n}\n.mdi-weather-partlycloudy:before {\n  content: \"\\F595\";\n}\n.mdi-weather-pouring:before {\n  content: \"\\F596\";\n}\n.mdi-weather-rainy:before {\n  content: \"\\F597\";\n}\n.mdi-weather-snowy:before {\n  content: \"\\F598\";\n}\n.mdi-weather-snowy-rainy:before {\n  content: \"\\F67E\";\n}\n.mdi-weather-sunny:before {\n  content: \"\\F599\";\n}\n.mdi-weather-sunset:before {\n  content: \"\\F59A\";\n}\n.mdi-weather-sunset-down:before {\n  content: \"\\F59B\";\n}\n.mdi-weather-sunset-up:before {\n  content: \"\\F59C\";\n}\n.mdi-weather-windy:before {\n  content: \"\\F59D\";\n}\n.mdi-weather-windy-variant:before {\n  content: \"\\F59E\";\n}\n.mdi-web:before {\n  content: \"\\F59F\";\n}\n.mdi-webcam:before {\n  content: \"\\F5A0\";\n}\n.mdi-webhook:before {\n  content: \"\\F62F\";\n}\n.mdi-webpack:before {\n  content: \"\\F72A\";\n}\n.mdi-wechat:before {\n  content: \"\\F611\";\n}\n.mdi-weight:before {\n  content: \"\\F5A1\";\n}\n.mdi-weight-kilogram:before {\n  content: \"\\F5A2\";\n}\n.mdi-whatsapp:before {\n  content: \"\\F5A3\";\n}\n.mdi-wheelchair-accessibility:before {\n  content: \"\\F5A4\";\n}\n.mdi-white-balance-auto:before {\n  content: \"\\F5A5\";\n}\n.mdi-white-balance-incandescent:before {\n  content: \"\\F5A6\";\n}\n.mdi-white-balance-iridescent:before {\n  content: \"\\F5A7\";\n}\n.mdi-white-balance-sunny:before {\n  content: \"\\F5A8\";\n}\n.mdi-widgets:before {\n  content: \"\\F72B\";\n}\n.mdi-wifi:before {\n  content: \"\\F5A9\";\n}\n.mdi-wifi-off:before {\n  content: \"\\F5AA\";\n}\n.mdi-wii:before {\n  content: \"\\F5AB\";\n}\n.mdi-wiiu:before {\n  content: \"\\F72C\";\n}\n.mdi-wikipedia:before {\n  content: \"\\F5AC\";\n}\n.mdi-window-close:before {\n  content: \"\\F5AD\";\n}\n.mdi-window-closed:before {\n  content: \"\\F5AE\";\n}\n.mdi-window-maximize:before {\n  content: \"\\F5AF\";\n}\n.mdi-window-minimize:before {\n  content: \"\\F5B0\";\n}\n.mdi-window-open:before {\n  content: \"\\F5B1\";\n}\n.mdi-window-restore:before {\n  content: \"\\F5B2\";\n}\n.mdi-windows:before {\n  content: \"\\F5B3\";\n}\n.mdi-wordpress:before {\n  content: \"\\F5B4\";\n}\n.mdi-worker:before {\n  content: \"\\F5B5\";\n}\n.mdi-wrap:before {\n  content: \"\\F5B6\";\n}\n.mdi-wrench:before {\n  content: \"\\F5B7\";\n}\n.mdi-wunderlist:before {\n  content: \"\\F5B8\";\n}\n.mdi-xamarin:before {\n  content: \"\\F844\";\n}\n.mdi-xamarin-outline:before {\n  content: \"\\F845\";\n}\n.mdi-xaml:before {\n  content: \"\\F673\";\n}\n.mdi-xbox:before {\n  content: \"\\F5B9\";\n}\n.mdi-xbox-controller:before {\n  content: \"\\F5BA\";\n}\n.mdi-xbox-controller-battery-alert:before {\n  content: \"\\F74A\";\n}\n.mdi-xbox-controller-battery-empty:before {\n  content: \"\\F74B\";\n}\n.mdi-xbox-controller-battery-full:before {\n  content: \"\\F74C\";\n}\n.mdi-xbox-controller-battery-low:before {\n  content: \"\\F74D\";\n}\n.mdi-xbox-controller-battery-medium:before {\n  content: \"\\F74E\";\n}\n.mdi-xbox-controller-battery-unknown:before {\n  content: \"\\F74F\";\n}\n.mdi-xbox-controller-off:before {\n  content: \"\\F5BB\";\n}\n.mdi-xda:before {\n  content: \"\\F5BC\";\n}\n.mdi-xing:before {\n  content: \"\\F5BD\";\n}\n.mdi-xing-box:before {\n  content: \"\\F5BE\";\n}\n.mdi-xing-circle:before {\n  content: \"\\F5BF\";\n}\n.mdi-xml:before {\n  content: \"\\F5C0\";\n}\n.mdi-xmpp:before {\n  content: \"\\F7FE\";\n}\n.mdi-yammer:before {\n  content: \"\\F788\";\n}\n.mdi-yeast:before {\n  content: \"\\F5C1\";\n}\n.mdi-yelp:before {\n  content: \"\\F5C2\";\n}\n.mdi-yin-yang:before {\n  content: \"\\F67F\";\n}\n.mdi-youtube-creator-studio:before {\n  content: \"\\F846\";\n}\n.mdi-youtube-gaming:before {\n  content: \"\\F847\";\n}\n.mdi-youtube-play:before {\n  content: \"\\F5C3\";\n}\n.mdi-youtube-tv:before {\n  content: \"\\F448\";\n}\n.mdi-zip-box:before {\n  content: \"\\F5C4\";\n}\n.mdi-blank:before {\n  content: \"\\F68C\";\n  visibility: hidden;\n}\n.mdi-18px.mdi-set,\n.mdi-18px.mdi:before {\n  font-size: 18px;\n}\n.mdi-24px.mdi-set,\n.mdi-24px.mdi:before {\n  font-size: 24px;\n}\n.mdi-36px.mdi-set,\n.mdi-36px.mdi:before {\n  font-size: 36px;\n}\n.mdi-48px.mdi-set,\n.mdi-48px.mdi:before {\n  font-size: 48px;\n}\n.mdi-dark:before {\n  color: rgba(0, 0, 0, .54);\n}\n.mdi-dark.mdi-inactive:before {\n  color: rgba(0, 0, 0, .26);\n}\n.mdi-light:before {\n  color: white;\n}\n.mdi-light.mdi-inactive:before {\n  color: rgba(255, 255, 255, .3);\n}\n.mdi-rotate-45 {\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(45deg);\r\n            transform: scaleX(-1) rotate(45deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(45deg);\r\n            -ms-transform: rotate(45deg);\r\n            transform: scaleY(-1) rotate(45deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\n}\n.mdi-rotate-45:before {\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n.mdi-rotate-90 {\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(90deg);\r\n            transform: scaleX(-1) rotate(90deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(90deg);\r\n            -ms-transform: rotate(90deg);\r\n            transform: scaleY(-1) rotate(90deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\n}\n.mdi-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.mdi-rotate-135 {\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(135deg);\r\n            transform: scaleX(-1) rotate(135deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(135deg);\r\n            -ms-transform: rotate(135deg);\r\n            transform: scaleY(-1) rotate(135deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\n}\n.mdi-rotate-135:before {\n  -webkit-transform: rotate(135deg);\n          transform: rotate(135deg);\n}\n.mdi-rotate-180 {\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(180deg);\r\n            transform: scaleX(-1) rotate(180deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(180deg);\r\n            -ms-transform: rotate(180deg);\r\n            transform: scaleY(-1) rotate(180deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\n}\n.mdi-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n.mdi-rotate-225 {\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(225deg);\r\n            transform: scaleX(-1) rotate(225deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(225deg);\r\n            -ms-transform: rotate(225deg);\r\n            transform: scaleY(-1) rotate(225deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\n}\n.mdi-rotate-225:before {\n  -webkit-transform: rotate(225deg);\n          transform: rotate(225deg);\n}\n.mdi-rotate-270 {\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(270deg);\r\n            transform: scaleX(-1) rotate(270deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(270deg);\r\n            -ms-transform: rotate(270deg);\r\n            transform: scaleY(-1) rotate(270deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\n}\n.mdi-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n.mdi-rotate-315 {\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(315deg);\r\n            transform: scaleX(-1) rotate(315deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(315deg);\r\n            -ms-transform: rotate(315deg);\r\n            transform: scaleY(-1) rotate(315deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\n}\n.mdi-rotate-315:before {\n  -webkit-transform: rotate(315deg);\n          transform: rotate(315deg);\n}\n.mdi-flip-h:before {\n  -webkit-transform: scaleX(-1);\n          transform: scaleX(-1);\n  -webkit-filter: FlipH;\n          filter: FlipH;\n      -ms-filter: \"FlipH\";\n}\n.mdi-flip-v:before {\n  -webkit-transform: scaleY(-1);\n          transform: scaleY(-1);\n  -webkit-filter: FlipV;\n          filter: FlipV;\n      -ms-filter: \"FlipV\";\n}\n.mdi-spin:before {\n  -webkit-animation: mdi-spin 2s infinite linear;\n          animation: mdi-spin 2s infinite linear;\n}\n@-webkit-keyframes mdi-spin {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n@keyframes mdi-spin {\n0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\n100% {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n\n/*! bulma.io v0.7.4 | MIT License | github.com/jgthms/bulma */\n@keyframes spinAround {\nfrom {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n}\nto {\n    -webkit-transform: rotate(359deg);\n            transform: rotate(359deg);\n}\n}\n.delete,\n.modal-close,\n.is-unselectable,\n.button,\n.file,\n.breadcrumb,\n.pagination-previous,\n.pagination-next,\n.pagination-link,\n.pagination-ellipsis,\n.tabs {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.select:not(.is-multiple):not(.is-loading)::after,\n.navbar-link:not(.is-arrowless)::after {\n  border: 3px solid transparent;\n  border-radius: 2px;\n  border-right: 0;\n  border-top: 0;\n  content: \" \";\n  display: block;\n  height: .625em;\n  margin-top: -0.4375em;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: rotate(-45deg);\n          transform: rotate(-45deg);\n  -webkit-transform-origin: center;\n           transform-origin: center;\n  width: .625em;\n}\n.box:not(:last-child),\n.content:not(:last-child),\n.notification:not(:last-child),\n.progress:not(:last-child),\n.table:not(:last-child),\n.table-container:not(:last-child),\n.title:not(:last-child),\n.subtitle:not(:last-child),\n.block:not(:last-child),\n.highlight:not(:last-child),\n.breadcrumb:not(:last-child),\n.level:not(:last-child),\n.list:not(:last-child),\n.message:not(:last-child),\n.tabs:not(:last-child) {\n  margin-bottom: 1.5rem;\n}\n.delete,\n.modal-close {\n     -moz-appearance: none;\n  -webkit-appearance: none;\n  background-color: rgba(10, 10, 10, .2);\n  border: none;\n  border-radius: 290486px;\n  cursor: pointer;\n  pointer-events: auto;\n  display: inline-block;\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  font-size: 0;\n  height: 20px;\n  max-height: 20px;\n  max-width: 20px;\n  min-height: 20px;\n  min-width: 20px;\n  outline: none;\n  position: relative;\n  vertical-align: top;\n  width: 20px;\n}\n.delete::before,\n.modal-close::before,\n.delete::after,\n.modal-close::after {\n  background-color: white;\n  content: \"\";\n  display: block;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);\n          transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  -webkit-transform-origin: center center;\n           transform-origin: center center;\n}\n.delete::before,\n.modal-close::before {\n  height: 2px;\n  width: 50%;\n}\n.delete::after,\n.modal-close::after {\n  height: 50%;\n  width: 2px;\n}\n.delete:hover,\n.modal-close:hover,\n.delete:focus,\n.modal-close:focus {\n  background-color: rgba(10, 10, 10, .3);\n}\n.delete:active,\n.modal-close:active {\n  background-color: rgba(10, 10, 10, .4);\n}\n.is-small.delete,\n.is-small.modal-close {\n  height: 16px;\n  max-height: 16px;\n  max-width: 16px;\n  min-height: 16px;\n  min-width: 16px;\n  width: 16px;\n}\n.is-medium.delete,\n.is-medium.modal-close {\n  height: 24px;\n  max-height: 24px;\n  max-width: 24px;\n  min-height: 24px;\n  min-width: 24px;\n  width: 24px;\n}\n.is-large.delete,\n.is-large.modal-close {\n  height: 32px;\n  max-height: 32px;\n  max-width: 32px;\n  min-height: 32px;\n  min-width: 32px;\n  width: 32px;\n}\n.button.is-loading::after,\n.select.is-loading::after,\n.control.is-loading::after,\n.loader {\n  -webkit-animation: spinAround 500ms infinite linear;\n          animation: spinAround 500ms infinite linear;\n  border: 2px solid #dbdbdb;\n  border-radius: 290486px;\n  border-right-color: transparent;\n  border-top-color: transparent;\n  content: \"\";\n  display: block;\n  height: 1em;\n  position: relative;\n  width: 1em;\n}\n.is-overlay,\n.image.is-square img,\n.image.is-square .has-ratio,\n.image.is-1by1 img,\n.image.is-1by1 .has-ratio,\n.image.is-5by4 img,\n.image.is-5by4 .has-ratio,\n.image.is-4by3 img,\n.image.is-4by3 .has-ratio,\n.image.is-3by2 img,\n.image.is-3by2 .has-ratio,\n.image.is-5by3 img,\n.image.is-5by3 .has-ratio,\n.image.is-16by9 img,\n.image.is-16by9 .has-ratio,\n.image.is-2by1 img,\n.image.is-2by1 .has-ratio,\n.image.is-3by1 img,\n.image.is-3by1 .has-ratio,\n.image.is-4by5 img,\n.image.is-4by5 .has-ratio,\n.image.is-3by4 img,\n.image.is-3by4 .has-ratio,\n.image.is-2by3 img,\n.image.is-2by3 .has-ratio,\n.image.is-3by5 img,\n.image.is-3by5 .has-ratio,\n.image.is-9by16 img,\n.image.is-9by16 .has-ratio,\n.image.is-1by2 img,\n.image.is-1by2 .has-ratio,\n.image.is-1by3 img,\n.image.is-1by3 .has-ratio,\n.modal,\n.modal-background,\n.hero-video {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.button,\n.input,\n.taginput .taginput-container.is-focusable,\n.textarea,\n.select select,\n.file-cta,\n.file-name,\n.pagination-previous,\n.pagination-next,\n.pagination-link,\n.pagination-ellipsis {\n     -moz-appearance: none;\n  -webkit-appearance: none;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  font-size: 1rem;\n  height: 2.25em;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  line-height: 1.5;\n  padding-bottom: calc(.375em - 1px);\n  padding-left: calc(.625em - 1px);\n  padding-right: calc(.625em - 1px);\n  padding-top: calc(.375em - 1px);\n  position: relative;\n  vertical-align: top;\n}\n.button:focus,\n.input:focus,\n.taginput .taginput-container.is-focusable:focus,\n.textarea:focus,\n.select select:focus,\n.file-cta:focus,\n.file-name:focus,\n.pagination-previous:focus,\n.pagination-next:focus,\n.pagination-link:focus,\n.pagination-ellipsis:focus,\n.is-focused.button,\n.is-focused.input,\n.taginput .is-focused.taginput-container.is-focusable,\n.is-focused.textarea,\n.select select.is-focused,\n.is-focused.file-cta,\n.is-focused.file-name,\n.is-focused.pagination-previous,\n.is-focused.pagination-next,\n.is-focused.pagination-link,\n.is-focused.pagination-ellipsis,\n.button:active,\n.input:active,\n.taginput .taginput-container.is-focusable:active,\n.textarea:active,\n.select select:active,\n.file-cta:active,\n.file-name:active,\n.pagination-previous:active,\n.pagination-next:active,\n.pagination-link:active,\n.pagination-ellipsis:active,\n.is-active.button,\n.is-active.input,\n.taginput .is-active.taginput-container.is-focusable,\n.is-active.textarea,\n.select select.is-active,\n.is-active.file-cta,\n.is-active.file-name,\n.is-active.pagination-previous,\n.is-active.pagination-next,\n.is-active.pagination-link,\n.is-active.pagination-ellipsis {\n  outline: none;\n}\n.button[disabled],\n.input[disabled],\n.taginput .taginput-container.is-focusable[disabled],\n.textarea[disabled],\n.select select[disabled],\n.file-cta[disabled],\n.file-name[disabled],\n.pagination-previous[disabled],\n.pagination-next[disabled],\n.pagination-link[disabled],\n.pagination-ellipsis[disabled],\nfieldset[disabled] .button,\nfieldset[disabled] .input,\nfieldset[disabled] .taginput .taginput-container.is-focusable,\n.taginput fieldset[disabled] .taginput-container.is-focusable,\nfieldset[disabled] .textarea,\nfieldset[disabled] .select select,\n.select fieldset[disabled] select,\nfieldset[disabled] .file-cta,\nfieldset[disabled] .file-name,\nfieldset[disabled] .pagination-previous,\nfieldset[disabled] .pagination-next,\nfieldset[disabled] .pagination-link,\nfieldset[disabled] .pagination-ellipsis {\n  cursor: not-allowed;\n}\n\n/*! minireset.css v0.0.4 | MIT License | github.com/jgthms/minireset.css */\nhtml,\nbody,\np,\nol,\nul,\nli,\ndl,\ndt,\ndd,\nblockquote,\nfigure,\nfieldset,\nlegend,\ntextarea,\npre,\niframe,\nhr,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  margin: 0;\n  padding: 0;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-size: 100%;\n  font-weight: normal;\n}\nul {\n  list-style: none;\n}\nbutton,\ninput,\nselect,\ntextarea {\n  margin: 0;\n}\nhtml {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n*,\n*::before,\n*::after {\n  -webkit-box-sizing: inherit;\n          box-sizing: inherit;\n}\nimg,\nembed,\niframe,\nobject,\nvideo {\n  height: auto;\n  max-width: 100%;\n}\naudio {\n  max-width: 100%;\n}\niframe {\n  border: 0;\n}\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\ntd,\nth {\n  padding: 0;\n  text-align: left;\n}\nhtml {\n  background-color: #eeeff3;\n  font-size: 16px;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  min-width: 300px;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  text-rendering: optimizeLegibility;\n  -webkit-text-size-adjust: 100%;\n     -moz-text-size-adjust: 100%;\n      -ms-text-size-adjust: 100%;\n          text-size-adjust: 100%;\n}\narticle,\naside,\nfigure,\nfooter,\nheader,\nhgroup,\nsection {\n  display: block;\n}\nbody,\nbutton,\ninput,\nselect,\ntextarea {\n  font-family: BlinkMacSystemFont, -apple-system, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n}\ncode,\npre {\n  -moz-osx-font-smoothing: auto;\n  -webkit-font-smoothing: auto;\n  font-family: monospace;\n}\nbody {\n  color: #4a4a4a;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n}\na {\n  color: #2196f3;\n  cursor: pointer;\n  text-decoration: none;\n}\na strong {\n  color: currentColor;\n}\na:hover {\n  color: #363636;\n}\ncode {\n  background-color: whitesmoke;\n  color: #ff3860;\n  font-size: .875em;\n  font-weight: normal;\n  padding: .25em .5em .25em;\n}\nhr {\n  background-color: whitesmoke;\n  border: none;\n  display: block;\n  height: 2px;\n  margin: 1.5rem 0;\n}\nimg {\n  height: auto;\n  max-width: 100%;\n}\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  vertical-align: baseline;\n}\nsmall {\n  font-size: .875em;\n}\nspan {\n  font-style: inherit;\n  font-weight: inherit;\n}\nstrong {\n  color: #363636;\n  font-weight: 700;\n}\nfieldset {\n  border: none;\n}\npre {\n  -webkit-overflow-scrolling: touch;\n  background-color: whitesmoke;\n  color: #4a4a4a;\n  font-size: .875em;\n  overflow-x: auto;\n  padding: 1.25rem 1.5rem;\n  white-space: pre;\n  word-wrap: normal;\n}\npre code {\n  background-color: transparent;\n  color: currentColor;\n  font-size: 1em;\n  padding: 0;\n}\ntable td,\ntable th {\n  text-align: left;\n  vertical-align: top;\n}\ntable th {\n  color: #363636;\n}\n.is-clearfix::after {\n  clear: both;\n  content: \" \";\n  display: table;\n}\n.is-pulled-left {\n  float: left !important;\n}\n.is-pulled-right {\n  float: right !important;\n}\n.is-clipped {\n  overflow: hidden !important;\n}\n.is-size-1 {\n  font-size: 3rem !important;\n}\n.is-size-2 {\n  font-size: 2.5rem !important;\n}\n.is-size-3 {\n  font-size: 2rem !important;\n}\n.is-size-4 {\n  font-size: 1.5rem !important;\n}\n.is-size-5 {\n  font-size: 1.25rem !important;\n}\n.is-size-6 {\n  font-size: 1rem !important;\n}\n.is-size-7 {\n  font-size: .75rem !important;\n}\n@media screen and (max-width: 768px) {\n.is-size-1-mobile {\n    font-size: 3rem !important;\n}\n.is-size-2-mobile {\n    font-size: 2.5rem !important;\n}\n.is-size-3-mobile {\n    font-size: 2rem !important;\n}\n.is-size-4-mobile {\n    font-size: 1.5rem !important;\n}\n.is-size-5-mobile {\n    font-size: 1.25rem !important;\n}\n.is-size-6-mobile {\n    font-size: 1rem !important;\n}\n.is-size-7-mobile {\n    font-size: .75rem !important;\n}\n}\n@media screen and (min-width: 769px), print {\n.is-size-1-tablet {\n    font-size: 3rem !important;\n}\n.is-size-2-tablet {\n    font-size: 2.5rem !important;\n}\n.is-size-3-tablet {\n    font-size: 2rem !important;\n}\n.is-size-4-tablet {\n    font-size: 1.5rem !important;\n}\n.is-size-5-tablet {\n    font-size: 1.25rem !important;\n}\n.is-size-6-tablet {\n    font-size: 1rem !important;\n}\n.is-size-7-tablet {\n    font-size: .75rem !important;\n}\n}\n@media screen and (max-width: 1087px) {\n.is-size-1-touch {\n    font-size: 3rem !important;\n}\n.is-size-2-touch {\n    font-size: 2.5rem !important;\n}\n.is-size-3-touch {\n    font-size: 2rem !important;\n}\n.is-size-4-touch {\n    font-size: 1.5rem !important;\n}\n.is-size-5-touch {\n    font-size: 1.25rem !important;\n}\n.is-size-6-touch {\n    font-size: 1rem !important;\n}\n.is-size-7-touch {\n    font-size: .75rem !important;\n}\n}\n@media screen and (min-width: 1088px) {\n.is-size-1-desktop {\n    font-size: 3rem !important;\n}\n.is-size-2-desktop {\n    font-size: 2.5rem !important;\n}\n.is-size-3-desktop {\n    font-size: 2rem !important;\n}\n.is-size-4-desktop {\n    font-size: 1.5rem !important;\n}\n.is-size-5-desktop {\n    font-size: 1.25rem !important;\n}\n.is-size-6-desktop {\n    font-size: 1rem !important;\n}\n.is-size-7-desktop {\n    font-size: .75rem !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-size-1-widescreen {\n    font-size: 3rem !important;\n}\n.is-size-2-widescreen {\n    font-size: 2.5rem !important;\n}\n.is-size-3-widescreen {\n    font-size: 2rem !important;\n}\n.is-size-4-widescreen {\n    font-size: 1.5rem !important;\n}\n.is-size-5-widescreen {\n    font-size: 1.25rem !important;\n}\n.is-size-6-widescreen {\n    font-size: 1rem !important;\n}\n.is-size-7-widescreen {\n    font-size: .75rem !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-size-1-fullhd {\n    font-size: 3rem !important;\n}\n.is-size-2-fullhd {\n    font-size: 2.5rem !important;\n}\n.is-size-3-fullhd {\n    font-size: 2rem !important;\n}\n.is-size-4-fullhd {\n    font-size: 1.5rem !important;\n}\n.is-size-5-fullhd {\n    font-size: 1.25rem !important;\n}\n.is-size-6-fullhd {\n    font-size: 1rem !important;\n}\n.is-size-7-fullhd {\n    font-size: .75rem !important;\n}\n}\n.has-text-centered {\n  text-align: center !important;\n}\n.has-text-justified {\n  text-align: justify !important;\n}\n.has-text-left {\n  text-align: left !important;\n}\n.has-text-right {\n  text-align: right !important;\n}\n@media screen and (max-width: 768px) {\n.has-text-centered-mobile {\n    text-align: center !important;\n}\n}\n@media screen and (min-width: 769px), print {\n.has-text-centered-tablet {\n    text-align: center !important;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.has-text-centered-tablet-only {\n    text-align: center !important;\n}\n}\n@media screen and (max-width: 1087px) {\n.has-text-centered-touch {\n    text-align: center !important;\n}\n}\n@media screen and (min-width: 1088px) {\n.has-text-centered-desktop {\n    text-align: center !important;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.has-text-centered-desktop-only {\n    text-align: center !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.has-text-centered-widescreen {\n    text-align: center !important;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.has-text-centered-widescreen-only {\n    text-align: center !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.has-text-centered-fullhd {\n    text-align: center !important;\n}\n}\n@media screen and (max-width: 768px) {\n.has-text-justified-mobile {\n    text-align: justify !important;\n}\n}\n@media screen and (min-width: 769px), print {\n.has-text-justified-tablet {\n    text-align: justify !important;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.has-text-justified-tablet-only {\n    text-align: justify !important;\n}\n}\n@media screen and (max-width: 1087px) {\n.has-text-justified-touch {\n    text-align: justify !important;\n}\n}\n@media screen and (min-width: 1088px) {\n.has-text-justified-desktop {\n    text-align: justify !important;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.has-text-justified-desktop-only {\n    text-align: justify !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.has-text-justified-widescreen {\n    text-align: justify !important;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.has-text-justified-widescreen-only {\n    text-align: justify !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.has-text-justified-fullhd {\n    text-align: justify !important;\n}\n}\n@media screen and (max-width: 768px) {\n.has-text-left-mobile {\n    text-align: left !important;\n}\n}\n@media screen and (min-width: 769px), print {\n.has-text-left-tablet {\n    text-align: left !important;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.has-text-left-tablet-only {\n    text-align: left !important;\n}\n}\n@media screen and (max-width: 1087px) {\n.has-text-left-touch {\n    text-align: left !important;\n}\n}\n@media screen and (min-width: 1088px) {\n.has-text-left-desktop {\n    text-align: left !important;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.has-text-left-desktop-only {\n    text-align: left !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.has-text-left-widescreen {\n    text-align: left !important;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.has-text-left-widescreen-only {\n    text-align: left !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.has-text-left-fullhd {\n    text-align: left !important;\n}\n}\n@media screen and (max-width: 768px) {\n.has-text-right-mobile {\n    text-align: right !important;\n}\n}\n@media screen and (min-width: 769px), print {\n.has-text-right-tablet {\n    text-align: right !important;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.has-text-right-tablet-only {\n    text-align: right !important;\n}\n}\n@media screen and (max-width: 1087px) {\n.has-text-right-touch {\n    text-align: right !important;\n}\n}\n@media screen and (min-width: 1088px) {\n.has-text-right-desktop {\n    text-align: right !important;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.has-text-right-desktop-only {\n    text-align: right !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.has-text-right-widescreen {\n    text-align: right !important;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.has-text-right-widescreen-only {\n    text-align: right !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.has-text-right-fullhd {\n    text-align: right !important;\n}\n}\n.is-capitalized {\n  text-transform: capitalize !important;\n}\n.is-lowercase {\n  text-transform: lowercase !important;\n}\n.is-uppercase {\n  text-transform: uppercase !important;\n}\n.is-italic {\n  font-style: italic !important;\n}\n.has-text-white {\n  color: white !important;\n}\na.has-text-white:hover,\na.has-text-white:focus {\n  color: #e6e6e6 !important;\n}\n.has-background-white {\n  background-color: white !important;\n}\n.has-text-black {\n  color: #0a0a0a !important;\n}\na.has-text-black:hover,\na.has-text-black:focus {\n  color: black !important;\n}\n.has-background-black {\n  background-color: #0a0a0a !important;\n}\n.has-text-grey {\n  color: #9babb4 !important;\n}\na.has-text-grey:hover,\na.has-text-grey:focus {\n  color: #7e939e !important;\n}\n.has-background-grey {\n  background-color: #9babb4 !important;\n}\n.has-text-blue {\n  color: #3b5998 !important;\n}\na.has-text-blue:hover,\na.has-text-blue:focus {\n  color: #2d4373 !important;\n}\n.has-background-blue {\n  background-color: #3b5998 !important;\n}\n.has-text-blue-dark {\n  color: #3b5998 !important;\n}\na.has-text-blue-dark:hover,\na.has-text-blue-dark:focus {\n  color: #2d4373 !important;\n}\n.has-background-blue-dark {\n  background-color: #3b5998 !important;\n}\n.has-text-light {\n  color: whitesmoke !important;\n}\na.has-text-light:hover,\na.has-text-light:focus {\n  color: #dbdbdb !important;\n}\n.has-background-light {\n  background-color: whitesmoke !important;\n}\n.has-text-dark {\n  color: #363636 !important;\n}\na.has-text-dark:hover,\na.has-text-dark:focus {\n  color: #1c1c1c !important;\n}\n.has-background-dark {\n  background-color: #363636 !important;\n}\n.has-text-primary {\n  color: #2196f3 !important;\n}\na.has-text-primary:hover,\na.has-text-primary:focus {\n  color: #0c7cd5 !important;\n}\n.has-background-primary {\n  background-color: #2196f3 !important;\n}\n.has-text-info {\n  color: #3b5998 !important;\n}\na.has-text-info:hover,\na.has-text-info:focus {\n  color: #2d4373 !important;\n}\n.has-background-info {\n  background-color: #3b5998 !important;\n}\n.has-text-success {\n  color: #2ab27b !important;\n}\na.has-text-success:hover,\na.has-text-success:focus {\n  color: #20895e !important;\n}\n.has-background-success {\n  background-color: #2ab27b !important;\n}\n.has-text-warning {\n  color: #ffdd57 !important;\n}\na.has-text-warning:hover,\na.has-text-warning:focus {\n  color: #ffd324 !important;\n}\n.has-background-warning {\n  background-color: #ffdd57 !important;\n}\n.has-text-danger {\n  color: #dc5b5b !important;\n}\na.has-text-danger:hover,\na.has-text-danger:focus {\n  color: #d33131 !important;\n}\n.has-background-danger {\n  background-color: #dc5b5b !important;\n}\n.has-text-black-bis {\n  color: #121212 !important;\n}\n.has-background-black-bis {\n  background-color: #121212 !important;\n}\n.has-text-black-ter {\n  color: #242424 !important;\n}\n.has-background-black-ter {\n  background-color: #242424 !important;\n}\n.has-text-grey-darker {\n  color: #363636 !important;\n}\n.has-background-grey-darker {\n  background-color: #363636 !important;\n}\n.has-text-grey-dark {\n  color: #4a4a4a !important;\n}\n.has-background-grey-dark {\n  background-color: #4a4a4a !important;\n}\n.has-text-grey {\n  color: #7a7a7a !important;\n}\n.has-background-grey {\n  background-color: #7a7a7a !important;\n}\n.has-text-grey-light {\n  color: #b5b5b5 !important;\n}\n.has-background-grey-light {\n  background-color: #b5b5b5 !important;\n}\n.has-text-grey-lighter {\n  color: #dbdbdb !important;\n}\n.has-background-grey-lighter {\n  background-color: #dbdbdb !important;\n}\n.has-text-white-ter {\n  color: whitesmoke !important;\n}\n.has-background-white-ter {\n  background-color: whitesmoke !important;\n}\n.has-text-white-bis {\n  color: #fafafa !important;\n}\n.has-background-white-bis {\n  background-color: #fafafa !important;\n}\n.has-text-weight-light {\n  font-weight: 300 !important;\n}\n.has-text-weight-normal {\n  font-weight: 400 !important;\n}\n.has-text-weight-semibold {\n  font-weight: 600 !important;\n}\n.has-text-weight-bold {\n  font-weight: 700 !important;\n}\n.is-family-primary {\n  font-family: BlinkMacSystemFont, -apple-system, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif !important;\n}\n.is-family-secondary {\n  font-family: BlinkMacSystemFont, -apple-system, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif !important;\n}\n.is-family-sans-serif {\n  font-family: BlinkMacSystemFont, -apple-system, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif !important;\n}\n.is-family-monospace {\n  font-family: monospace !important;\n}\n.is-family-code {\n  font-family: monospace !important;\n}\n.is-block {\n  display: block !important;\n}\n@media screen and (max-width: 768px) {\n.is-block-mobile {\n    display: block !important;\n}\n}\n@media screen and (min-width: 769px), print {\n.is-block-tablet {\n    display: block !important;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.is-block-tablet-only {\n    display: block !important;\n}\n}\n@media screen and (max-width: 1087px) {\n.is-block-touch {\n    display: block !important;\n}\n}\n@media screen and (min-width: 1088px) {\n.is-block-desktop {\n    display: block !important;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.is-block-desktop-only {\n    display: block !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-block-widescreen {\n    display: block !important;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.is-block-widescreen-only {\n    display: block !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-block-fullhd {\n    display: block !important;\n}\n}\n.is-flex {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n@media screen and (max-width: 768px) {\n.is-flex-mobile {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n}\n@media screen and (min-width: 769px), print {\n.is-flex-tablet {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.is-flex-tablet-only {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n}\n@media screen and (max-width: 1087px) {\n.is-flex-touch {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n}\n@media screen and (min-width: 1088px) {\n.is-flex-desktop {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.is-flex-desktop-only {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-flex-widescreen {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.is-flex-widescreen-only {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-flex-fullhd {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n}\n}\n.is-inline {\n  display: inline !important;\n}\n@media screen and (max-width: 768px) {\n.is-inline-mobile {\n    display: inline !important;\n}\n}\n@media screen and (min-width: 769px), print {\n.is-inline-tablet {\n    display: inline !important;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.is-inline-tablet-only {\n    display: inline !important;\n}\n}\n@media screen and (max-width: 1087px) {\n.is-inline-touch {\n    display: inline !important;\n}\n}\n@media screen and (min-width: 1088px) {\n.is-inline-desktop {\n    display: inline !important;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.is-inline-desktop-only {\n    display: inline !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-inline-widescreen {\n    display: inline !important;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.is-inline-widescreen-only {\n    display: inline !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-inline-fullhd {\n    display: inline !important;\n}\n}\n.is-inline-block {\n  display: inline-block !important;\n}\n@media screen and (max-width: 768px) {\n.is-inline-block-mobile {\n    display: inline-block !important;\n}\n}\n@media screen and (min-width: 769px), print {\n.is-inline-block-tablet {\n    display: inline-block !important;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.is-inline-block-tablet-only {\n    display: inline-block !important;\n}\n}\n@media screen and (max-width: 1087px) {\n.is-inline-block-touch {\n    display: inline-block !important;\n}\n}\n@media screen and (min-width: 1088px) {\n.is-inline-block-desktop {\n    display: inline-block !important;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.is-inline-block-desktop-only {\n    display: inline-block !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-inline-block-widescreen {\n    display: inline-block !important;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.is-inline-block-widescreen-only {\n    display: inline-block !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-inline-block-fullhd {\n    display: inline-block !important;\n}\n}\n.is-inline-flex {\n  display: -webkit-inline-box !important;\n  display: -ms-inline-flexbox !important;\n  display: inline-flex !important;\n}\n@media screen and (max-width: 768px) {\n.is-inline-flex-mobile {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n@media screen and (min-width: 769px), print {\n.is-inline-flex-tablet {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.is-inline-flex-tablet-only {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n@media screen and (max-width: 1087px) {\n.is-inline-flex-touch {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n@media screen and (min-width: 1088px) {\n.is-inline-flex-desktop {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.is-inline-flex-desktop-only {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-inline-flex-widescreen {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.is-inline-flex-widescreen-only {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-inline-flex-fullhd {\n    display: -webkit-inline-box !important;\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n}\n}\n.is-hidden {\n  display: none !important;\n}\n.is-sr-only {\n  border: none !important;\n  clip: rect(0, 0, 0, 0) !important;\n  height: .01em !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n  position: absolute !important;\n  white-space: nowrap !important;\n  width: .01em !important;\n}\n@media screen and (max-width: 768px) {\n.is-hidden-mobile {\n    display: none !important;\n}\n}\n@media screen and (min-width: 769px), print {\n.is-hidden-tablet {\n    display: none !important;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.is-hidden-tablet-only {\n    display: none !important;\n}\n}\n@media screen and (max-width: 1087px) {\n.is-hidden-touch {\n    display: none !important;\n}\n}\n@media screen and (min-width: 1088px) {\n.is-hidden-desktop {\n    display: none !important;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.is-hidden-desktop-only {\n    display: none !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-hidden-widescreen {\n    display: none !important;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.is-hidden-widescreen-only {\n    display: none !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-hidden-fullhd {\n    display: none !important;\n}\n}\n.is-invisible {\n  visibility: hidden !important;\n}\n@media screen and (max-width: 768px) {\n.is-invisible-mobile {\n    visibility: hidden !important;\n}\n}\n@media screen and (min-width: 769px), print {\n.is-invisible-tablet {\n    visibility: hidden !important;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.is-invisible-tablet-only {\n    visibility: hidden !important;\n}\n}\n@media screen and (max-width: 1087px) {\n.is-invisible-touch {\n    visibility: hidden !important;\n}\n}\n@media screen and (min-width: 1088px) {\n.is-invisible-desktop {\n    visibility: hidden !important;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.is-invisible-desktop-only {\n    visibility: hidden !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-invisible-widescreen {\n    visibility: hidden !important;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.is-invisible-widescreen-only {\n    visibility: hidden !important;\n}\n}\n@media screen and (min-width: 1280px) {\n.is-invisible-fullhd {\n    visibility: hidden !important;\n}\n}\n.is-marginless {\n  margin: 0 !important;\n}\n.is-paddingless {\n  padding: 0 !important;\n}\n.is-radiusless {\n  border-radius: 0 !important;\n}\n.is-shadowless {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n.box {\n  background-color: white;\n  border-radius: 0;\n  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);\n          box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);\n  color: #4a4a4a;\n  display: block;\n  padding: 1.25rem;\n}\na.box:hover,\na.box:focus {\n  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px #2196f3;\n          box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px #2196f3;\n}\na.box:active {\n  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, .2), 0 0 0 1px #2196f3;\n          box-shadow: inset 0 1px 2px rgba(10, 10, 10, .2), 0 0 0 1px #2196f3;\n}\n.button {\n  background-color: white;\n  border-color: #dbdbdb;\n  border-width: 1px;\n  color: #363636;\n  cursor: pointer;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  padding-bottom: calc(.375em - 1px);\n  padding-left: .75em;\n  padding-right: .75em;\n  padding-top: calc(.375em - 1px);\n  text-align: center;\n  white-space: nowrap;\n}\n.button strong {\n  color: inherit;\n}\n.button .icon,\n.button .icon.is-small,\n.button .icon.is-medium,\n.button .icon.is-large {\n  height: 1.5em;\n  width: 1.5em;\n}\n.button .icon:first-child:not(:last-child) {\n  margin-left: calc(-0.375em - 1px);\n  margin-right: .1875em;\n}\n.button .icon:last-child:not(:first-child) {\n  margin-left: .1875em;\n  margin-right: calc(-0.375em - 1px);\n}\n.button .icon:first-child:last-child {\n  margin-left: calc(-0.375em - 1px);\n  margin-right: calc(-0.375em - 1px);\n}\n.button:hover,\n.button.is-hovered {\n  border-color: #b5b5b5;\n  color: #363636;\n}\n.button:focus,\n.button.is-focused {\n  border-color: #2196f3;\n  color: #363636;\n}\n.button:focus:not(:active),\n.button.is-focused:not(:active) {\n  -webkit-box-shadow: 0 0 0 .125em rgba(33, 150, 243, .25);\n          box-shadow: 0 0 0 .125em rgba(33, 150, 243, .25);\n}\n.button:active,\n.button.is-active {\n  border-color: #4a4a4a;\n  color: #363636;\n}\n.button.is-text {\n  background-color: transparent;\n  border-color: transparent;\n  color: #4a4a4a;\n  text-decoration: underline;\n}\n.button.is-text:hover,\n.button.is-text.is-hovered,\n.button.is-text:focus,\n.button.is-text.is-focused {\n  background-color: whitesmoke;\n  color: #363636;\n}\n.button.is-text:active,\n.button.is-text.is-active {\n  background-color: #e8e8e8;\n  color: #363636;\n}\n.button.is-text[disabled],\nfieldset[disabled] .button.is-text {\n  background-color: transparent;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.button.is-white {\n  background-color: white;\n  border-color: transparent;\n  color: #0a0a0a;\n}\n.button.is-white:hover,\n.button.is-white.is-hovered {\n  background-color: #f9f9f9;\n  border-color: transparent;\n  color: #0a0a0a;\n}\n.button.is-white:focus,\n.button.is-white.is-focused {\n  border-color: transparent;\n  color: #0a0a0a;\n}\n.button.is-white:focus:not(:active),\n.button.is-white.is-focused:not(:active) {\n  -webkit-box-shadow: 0 0 0 .125em rgba(255, 255, 255, .25);\n          box-shadow: 0 0 0 .125em rgba(255, 255, 255, .25);\n}\n.button.is-white:active,\n.button.is-white.is-active {\n  background-color: #f2f2f2;\n  border-color: transparent;\n  color: #0a0a0a;\n}\n.button.is-white[disabled],\nfieldset[disabled] .button.is-white {\n  background-color: white;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.button.is-white.is-inverted {\n  background-color: #0a0a0a;\n  color: white;\n}\n.button.is-white.is-inverted:hover {\n  background-color: black;\n}\n.button.is-white.is-inverted[disabled],\nfieldset[disabled] .button.is-white.is-inverted {\n  background-color: #0a0a0a;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: white;\n}\n.button.is-white.is-loading::after {\n  border-color: transparent transparent #0a0a0a #0a0a0a !important;\n}\n.button.is-white.is-outlined {\n  background-color: transparent;\n  border-color: white;\n  color: white;\n}\n.button.is-white.is-outlined:hover,\n.button.is-white.is-outlined:focus {\n  background-color: white;\n  border-color: white;\n  color: #0a0a0a;\n}\n.button.is-white.is-outlined.is-loading::after {\n  border-color: transparent transparent white white !important;\n}\n.button.is-white.is-outlined[disabled],\nfieldset[disabled] .button.is-white.is-outlined {\n  background-color: transparent;\n  border-color: white;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: white;\n}\n.button.is-white.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #0a0a0a;\n  color: #0a0a0a;\n}\n.button.is-white.is-inverted.is-outlined:hover,\n.button.is-white.is-inverted.is-outlined:focus {\n  background-color: #0a0a0a;\n  color: white;\n}\n.button.is-white.is-inverted.is-outlined[disabled],\nfieldset[disabled] .button.is-white.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #0a0a0a;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #0a0a0a;\n}\n.button.is-black {\n  background-color: #0a0a0a;\n  border-color: transparent;\n  color: white;\n}\n.button.is-black:hover,\n.button.is-black.is-hovered {\n  background-color: #040404;\n  border-color: transparent;\n  color: white;\n}\n.button.is-black:focus,\n.button.is-black.is-focused {\n  border-color: transparent;\n  color: white;\n}\n.button.is-black:focus:not(:active),\n.button.is-black.is-focused:not(:active) {\n  -webkit-box-shadow: 0 0 0 .125em rgba(10, 10, 10, .25);\n          box-shadow: 0 0 0 .125em rgba(10, 10, 10, .25);\n}\n.button.is-black:active,\n.button.is-black.is-active {\n  background-color: black;\n  border-color: transparent;\n  color: white;\n}\n.button.is-black[disabled],\nfieldset[disabled] .button.is-black {\n  background-color: #0a0a0a;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.button.is-black.is-inverted {\n  background-color: white;\n  color: #0a0a0a;\n}\n.button.is-black.is-inverted:hover {\n  background-color: #f2f2f2;\n}\n.button.is-black.is-inverted[disabled],\nfieldset[disabled] .button.is-black.is-inverted {\n  background-color: white;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #0a0a0a;\n}\n.button.is-black.is-loading::after {\n  border-color: transparent transparent white white !important;\n}\n.button.is-black.is-outlined {\n  background-color: transparent;\n  border-color: #0a0a0a;\n  color: #0a0a0a;\n}\n.button.is-black.is-outlined:hover,\n.button.is-black.is-outlined:focus {\n  background-color: #0a0a0a;\n  border-color: #0a0a0a;\n  color: white;\n}\n.button.is-black.is-outlined.is-loading::after {\n  border-color: transparent transparent #0a0a0a #0a0a0a !important;\n}\n.button.is-black.is-outlined[disabled],\nfieldset[disabled] .button.is-black.is-outlined {\n  background-color: transparent;\n  border-color: #0a0a0a;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #0a0a0a;\n}\n.button.is-black.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: white;\n  color: white;\n}\n.button.is-black.is-inverted.is-outlined:hover,\n.button.is-black.is-inverted.is-outlined:focus {\n  background-color: white;\n  color: #0a0a0a;\n}\n.button.is-black.is-inverted.is-outlined[disabled],\nfieldset[disabled] .button.is-black.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: white;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: white;\n}\n.button.is-grey {\n  background-color: #9babb4;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-grey:hover,\n.button.is-grey.is-hovered {\n  background-color: #94a5af;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-grey:focus,\n.button.is-grey.is-focused {\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-grey:focus:not(:active),\n.button.is-grey.is-focused:not(:active) {\n  -webkit-box-shadow: 0 0 0 .125em rgba(155, 171, 180, .25);\n          box-shadow: 0 0 0 .125em rgba(155, 171, 180, .25);\n}\n.button.is-grey:active,\n.button.is-grey.is-active {\n  background-color: #8c9fa9;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-grey[disabled],\nfieldset[disabled] .button.is-grey {\n  background-color: #9babb4;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.button.is-grey.is-inverted {\n  background-color: #fff;\n  color: #9babb4;\n}\n.button.is-grey.is-inverted:hover {\n  background-color: #f2f2f2;\n}\n.button.is-grey.is-inverted[disabled],\nfieldset[disabled] .button.is-grey.is-inverted {\n  background-color: #fff;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #9babb4;\n}\n.button.is-grey.is-loading::after {\n  border-color: transparent transparent #fff #fff !important;\n}\n.button.is-grey.is-outlined {\n  background-color: transparent;\n  border-color: #9babb4;\n  color: #9babb4;\n}\n.button.is-grey.is-outlined:hover,\n.button.is-grey.is-outlined:focus {\n  background-color: #9babb4;\n  border-color: #9babb4;\n  color: #fff;\n}\n.button.is-grey.is-outlined.is-loading::after {\n  border-color: transparent transparent #9babb4 #9babb4 !important;\n}\n.button.is-grey.is-outlined[disabled],\nfieldset[disabled] .button.is-grey.is-outlined {\n  background-color: transparent;\n  border-color: #9babb4;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #9babb4;\n}\n.button.is-grey.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #fff;\n  color: #fff;\n}\n.button.is-grey.is-inverted.is-outlined:hover,\n.button.is-grey.is-inverted.is-outlined:focus {\n  background-color: #fff;\n  color: #9babb4;\n}\n.button.is-grey.is-inverted.is-outlined[disabled],\nfieldset[disabled] .button.is-grey.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #fff;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #fff;\n}\n.button.is-blue {\n  background-color: #3b5998;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-blue:hover,\n.button.is-blue.is-hovered {\n  background-color: #37548f;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-blue:focus,\n.button.is-blue.is-focused {\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-blue:focus:not(:active),\n.button.is-blue.is-focused:not(:active) {\n  -webkit-box-shadow: 0 0 0 .125em rgba(59, 89, 152, .25);\n          box-shadow: 0 0 0 .125em rgba(59, 89, 152, .25);\n}\n.button.is-blue:active,\n.button.is-blue.is-active {\n  background-color: #344e86;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-blue[disabled],\nfieldset[disabled] .button.is-blue {\n  background-color: #3b5998;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.button.is-blue.is-inverted {\n  background-color: #fff;\n  color: #3b5998;\n}\n.button.is-blue.is-inverted:hover {\n  background-color: #f2f2f2;\n}\n.button.is-blue.is-inverted[disabled],\nfieldset[disabled] .button.is-blue.is-inverted {\n  background-color: #fff;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #3b5998;\n}\n.button.is-blue.is-loading::after {\n  border-color: transparent transparent #fff #fff !important;\n}\n.button.is-blue.is-outlined {\n  background-color: transparent;\n  border-color: #3b5998;\n  color: #3b5998;\n}\n.button.is-blue.is-outlined:hover,\n.button.is-blue.is-outlined:focus {\n  background-color: #3b5998;\n  border-color: #3b5998;\n  color: #fff;\n}\n.button.is-blue.is-outlined.is-loading::after {\n  border-color: transparent transparent #3b5998 #3b5998 !important;\n}\n.button.is-blue.is-outlined[disabled],\nfieldset[disabled] .button.is-blue.is-outlined {\n  background-color: transparent;\n  border-color: #3b5998;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #3b5998;\n}\n.button.is-blue.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #fff;\n  color: #fff;\n}\n.button.is-blue.is-inverted.is-outlined:hover,\n.button.is-blue.is-inverted.is-outlined:focus {\n  background-color: #fff;\n  color: #3b5998;\n}\n.button.is-blue.is-inverted.is-outlined[disabled],\nfieldset[disabled] .button.is-blue.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #fff;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #fff;\n}\n.button.is-blue-dark {\n  background-color: #3b5998;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-blue-dark:hover,\n.button.is-blue-dark.is-hovered {\n  background-color: #37548f;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-blue-dark:focus,\n.button.is-blue-dark.is-focused {\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-blue-dark:focus:not(:active),\n.button.is-blue-dark.is-focused:not(:active) {\n  -webkit-box-shadow: 0 0 0 .125em rgba(59, 89, 152, .25);\n          box-shadow: 0 0 0 .125em rgba(59, 89, 152, .25);\n}\n.button.is-blue-dark:active,\n.button.is-blue-dark.is-active {\n  background-color: #344e86;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-blue-dark[disabled],\nfieldset[disabled] .button.is-blue-dark {\n  background-color: #3b5998;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.button.is-blue-dark.is-inverted {\n  background-color: #fff;\n  color: #3b5998;\n}\n.button.is-blue-dark.is-inverted:hover {\n  background-color: #f2f2f2;\n}\n.button.is-blue-dark.is-inverted[disabled],\nfieldset[disabled] .button.is-blue-dark.is-inverted {\n  background-color: #fff;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #3b5998;\n}\n.button.is-blue-dark.is-loading::after {\n  border-color: transparent transparent #fff #fff !important;\n}\n.button.is-blue-dark.is-outlined {\n  background-color: transparent;\n  border-color: #3b5998;\n  color: #3b5998;\n}\n.button.is-blue-dark.is-outlined:hover,\n.button.is-blue-dark.is-outlined:focus {\n  background-color: #3b5998;\n  border-color: #3b5998;\n  color: #fff;\n}\n.button.is-blue-dark.is-outlined.is-loading::after {\n  border-color: transparent transparent #3b5998 #3b5998 !important;\n}\n.button.is-blue-dark.is-outlined[disabled],\nfieldset[disabled] .button.is-blue-dark.is-outlined {\n  background-color: transparent;\n  border-color: #3b5998;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #3b5998;\n}\n.button.is-blue-dark.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #fff;\n  color: #fff;\n}\n.button.is-blue-dark.is-inverted.is-outlined:hover,\n.button.is-blue-dark.is-inverted.is-outlined:focus {\n  background-color: #fff;\n  color: #3b5998;\n}\n.button.is-blue-dark.is-inverted.is-outlined[disabled],\nfieldset[disabled] .button.is-blue-dark.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #fff;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #fff;\n}\n.button.is-light {\n  background-color: whitesmoke;\n  border-color: transparent;\n  color: #363636;\n}\n.button.is-light:hover,\n.button.is-light.is-hovered {\n  background-color: #eee;\n  border-color: transparent;\n  color: #363636;\n}\n.button.is-light:focus,\n.button.is-light.is-focused {\n  border-color: transparent;\n  color: #363636;\n}\n.button.is-light:focus:not(:active),\n.button.is-light.is-focused:not(:active) {\n  -webkit-box-shadow: 0 0 0 .125em rgba(245, 245, 245, .25);\n          box-shadow: 0 0 0 .125em rgba(245, 245, 245, .25);\n}\n.button.is-light:active,\n.button.is-light.is-active {\n  background-color: #e8e8e8;\n  border-color: transparent;\n  color: #363636;\n}\n.button.is-light[disabled],\nfieldset[disabled] .button.is-light {\n  background-color: whitesmoke;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.button.is-light.is-inverted {\n  background-color: #363636;\n  color: whitesmoke;\n}\n.button.is-light.is-inverted:hover {\n  background-color: #292929;\n}\n.button.is-light.is-inverted[disabled],\nfieldset[disabled] .button.is-light.is-inverted {\n  background-color: #363636;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: whitesmoke;\n}\n.button.is-light.is-loading::after {\n  border-color: transparent transparent #363636 #363636 !important;\n}\n.button.is-light.is-outlined {\n  background-color: transparent;\n  border-color: whitesmoke;\n  color: whitesmoke;\n}\n.button.is-light.is-outlined:hover,\n.button.is-light.is-outlined:focus {\n  background-color: whitesmoke;\n  border-color: whitesmoke;\n  color: #363636;\n}\n.button.is-light.is-outlined.is-loading::after {\n  border-color: transparent transparent whitesmoke whitesmoke !important;\n}\n.button.is-light.is-outlined[disabled],\nfieldset[disabled] .button.is-light.is-outlined {\n  background-color: transparent;\n  border-color: whitesmoke;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: whitesmoke;\n}\n.button.is-light.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #363636;\n  color: #363636;\n}\n.button.is-light.is-inverted.is-outlined:hover,\n.button.is-light.is-inverted.is-outlined:focus {\n  background-color: #363636;\n  color: whitesmoke;\n}\n.button.is-light.is-inverted.is-outlined[disabled],\nfieldset[disabled] .button.is-light.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #363636;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #363636;\n}\n.button.is-dark {\n  background-color: #363636;\n  border-color: transparent;\n  color: whitesmoke;\n}\n.button.is-dark:hover,\n.button.is-dark.is-hovered {\n  background-color: #2f2f2f;\n  border-color: transparent;\n  color: whitesmoke;\n}\n.button.is-dark:focus,\n.button.is-dark.is-focused {\n  border-color: transparent;\n  color: whitesmoke;\n}\n.button.is-dark:focus:not(:active),\n.button.is-dark.is-focused:not(:active) {\n  -webkit-box-shadow: 0 0 0 .125em rgba(54, 54, 54, .25);\n          box-shadow: 0 0 0 .125em rgba(54, 54, 54, .25);\n}\n.button.is-dark:active,\n.button.is-dark.is-active {\n  background-color: #292929;\n  border-color: transparent;\n  color: whitesmoke;\n}\n.button.is-dark[disabled],\nfieldset[disabled] .button.is-dark {\n  background-color: #363636;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.button.is-dark.is-inverted {\n  background-color: whitesmoke;\n  color: #363636;\n}\n.button.is-dark.is-inverted:hover {\n  background-color: #e8e8e8;\n}\n.button.is-dark.is-inverted[disabled],\nfieldset[disabled] .button.is-dark.is-inverted {\n  background-color: whitesmoke;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #363636;\n}\n.button.is-dark.is-loading::after {\n  border-color: transparent transparent whitesmoke whitesmoke !important;\n}\n.button.is-dark.is-outlined {\n  background-color: transparent;\n  border-color: #363636;\n  color: #363636;\n}\n.button.is-dark.is-outlined:hover,\n.button.is-dark.is-outlined:focus {\n  background-color: #363636;\n  border-color: #363636;\n  color: whitesmoke;\n}\n.button.is-dark.is-outlined.is-loading::after {\n  border-color: transparent transparent #363636 #363636 !important;\n}\n.button.is-dark.is-outlined[disabled],\nfieldset[disabled] .button.is-dark.is-outlined {\n  background-color: transparent;\n  border-color: #363636;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #363636;\n}\n.button.is-dark.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: whitesmoke;\n  color: whitesmoke;\n}\n.button.is-dark.is-inverted.is-outlined:hover,\n.button.is-dark.is-inverted.is-outlined:focus {\n  background-color: whitesmoke;\n  color: #363636;\n}\n.button.is-dark.is-inverted.is-outlined[disabled],\nfieldset[disabled] .button.is-dark.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: whitesmoke;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: whitesmoke;\n}\n.button.is-primary {\n  background-color: #2196f3;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-primary:hover,\n.button.is-primary.is-hovered {\n  background-color: #1590f2;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-primary:focus,\n.button.is-primary.is-focused {\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-primary:focus:not(:active),\n.button.is-primary.is-focused:not(:active) {\n  -webkit-box-shadow: 0 0 0 .125em rgba(33, 150, 243, .25);\n          box-shadow: 0 0 0 .125em rgba(33, 150, 243, .25);\n}\n.button.is-primary:active,\n.button.is-primary.is-active {\n  background-color: #0d8aee;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-primary[disabled],\nfieldset[disabled] .button.is-primary {\n  background-color: #2196f3;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.button.is-primary.is-inverted {\n  background-color: #fff;\n  color: #2196f3;\n}\n.button.is-primary.is-inverted:hover {\n  background-color: #f2f2f2;\n}\n.button.is-primary.is-inverted[disabled],\nfieldset[disabled] .button.is-primary.is-inverted {\n  background-color: #fff;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #2196f3;\n}\n.button.is-primary.is-loading::after {\n  border-color: transparent transparent #fff #fff !important;\n}\n.button.is-primary.is-outlined {\n  background-color: transparent;\n  border-color: #2196f3;\n  color: #2196f3;\n}\n.button.is-primary.is-outlined:hover,\n.button.is-primary.is-outlined:focus {\n  background-color: #2196f3;\n  border-color: #2196f3;\n  color: #fff;\n}\n.button.is-primary.is-outlined.is-loading::after {\n  border-color: transparent transparent #2196f3 #2196f3 !important;\n}\n.button.is-primary.is-outlined[disabled],\nfieldset[disabled] .button.is-primary.is-outlined {\n  background-color: transparent;\n  border-color: #2196f3;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #2196f3;\n}\n.button.is-primary.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #fff;\n  color: #fff;\n}\n.button.is-primary.is-inverted.is-outlined:hover,\n.button.is-primary.is-inverted.is-outlined:focus {\n  background-color: #fff;\n  color: #2196f3;\n}\n.button.is-primary.is-inverted.is-outlined[disabled],\nfieldset[disabled] .button.is-primary.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #fff;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #fff;\n}\n.button.is-info {\n  background-color: #3b5998;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-info:hover,\n.button.is-info.is-hovered {\n  background-color: #37548f;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-info:focus,\n.button.is-info.is-focused {\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-info:focus:not(:active),\n.button.is-info.is-focused:not(:active) {\n  -webkit-box-shadow: 0 0 0 .125em rgba(59, 89, 152, .25);\n          box-shadow: 0 0 0 .125em rgba(59, 89, 152, .25);\n}\n.button.is-info:active,\n.button.is-info.is-active {\n  background-color: #344e86;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-info[disabled],\nfieldset[disabled] .button.is-info {\n  background-color: #3b5998;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.button.is-info.is-inverted {\n  background-color: #fff;\n  color: #3b5998;\n}\n.button.is-info.is-inverted:hover {\n  background-color: #f2f2f2;\n}\n.button.is-info.is-inverted[disabled],\nfieldset[disabled] .button.is-info.is-inverted {\n  background-color: #fff;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #3b5998;\n}\n.button.is-info.is-loading::after {\n  border-color: transparent transparent #fff #fff !important;\n}\n.button.is-info.is-outlined {\n  background-color: transparent;\n  border-color: #3b5998;\n  color: #3b5998;\n}\n.button.is-info.is-outlined:hover,\n.button.is-info.is-outlined:focus {\n  background-color: #3b5998;\n  border-color: #3b5998;\n  color: #fff;\n}\n.button.is-info.is-outlined.is-loading::after {\n  border-color: transparent transparent #3b5998 #3b5998 !important;\n}\n.button.is-info.is-outlined[disabled],\nfieldset[disabled] .button.is-info.is-outlined {\n  background-color: transparent;\n  border-color: #3b5998;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #3b5998;\n}\n.button.is-info.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #fff;\n  color: #fff;\n}\n.button.is-info.is-inverted.is-outlined:hover,\n.button.is-info.is-inverted.is-outlined:focus {\n  background-color: #fff;\n  color: #3b5998;\n}\n.button.is-info.is-inverted.is-outlined[disabled],\nfieldset[disabled] .button.is-info.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #fff;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #fff;\n}\n.button.is-success {\n  background-color: #2ab27b;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-success:hover,\n.button.is-success.is-hovered {\n  background-color: #28a874;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-success:focus,\n.button.is-success.is-focused {\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-success:focus:not(:active),\n.button.is-success.is-focused:not(:active) {\n  -webkit-box-shadow: 0 0 0 .125em rgba(42, 178, 123, .25);\n          box-shadow: 0 0 0 .125em rgba(42, 178, 123, .25);\n}\n.button.is-success:active,\n.button.is-success.is-active {\n  background-color: #259d6d;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-success[disabled],\nfieldset[disabled] .button.is-success {\n  background-color: #2ab27b;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.button.is-success.is-inverted {\n  background-color: #fff;\n  color: #2ab27b;\n}\n.button.is-success.is-inverted:hover {\n  background-color: #f2f2f2;\n}\n.button.is-success.is-inverted[disabled],\nfieldset[disabled] .button.is-success.is-inverted {\n  background-color: #fff;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #2ab27b;\n}\n.button.is-success.is-loading::after {\n  border-color: transparent transparent #fff #fff !important;\n}\n.button.is-success.is-outlined {\n  background-color: transparent;\n  border-color: #2ab27b;\n  color: #2ab27b;\n}\n.button.is-success.is-outlined:hover,\n.button.is-success.is-outlined:focus {\n  background-color: #2ab27b;\n  border-color: #2ab27b;\n  color: #fff;\n}\n.button.is-success.is-outlined.is-loading::after {\n  border-color: transparent transparent #2ab27b #2ab27b !important;\n}\n.button.is-success.is-outlined[disabled],\nfieldset[disabled] .button.is-success.is-outlined {\n  background-color: transparent;\n  border-color: #2ab27b;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #2ab27b;\n}\n.button.is-success.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #fff;\n  color: #fff;\n}\n.button.is-success.is-inverted.is-outlined:hover,\n.button.is-success.is-inverted.is-outlined:focus {\n  background-color: #fff;\n  color: #2ab27b;\n}\n.button.is-success.is-inverted.is-outlined[disabled],\nfieldset[disabled] .button.is-success.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #fff;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #fff;\n}\n.button.is-warning {\n  background-color: #ffdd57;\n  border-color: transparent;\n  color: rgba(0, 0, 0, .7);\n}\n.button.is-warning:hover,\n.button.is-warning.is-hovered {\n  background-color: #ffdb4a;\n  border-color: transparent;\n  color: rgba(0, 0, 0, .7);\n}\n.button.is-warning:focus,\n.button.is-warning.is-focused {\n  border-color: transparent;\n  color: rgba(0, 0, 0, .7);\n}\n.button.is-warning:focus:not(:active),\n.button.is-warning.is-focused:not(:active) {\n  -webkit-box-shadow: 0 0 0 .125em rgba(255, 221, 87, .25);\n          box-shadow: 0 0 0 .125em rgba(255, 221, 87, .25);\n}\n.button.is-warning:active,\n.button.is-warning.is-active {\n  background-color: #ffd83d;\n  border-color: transparent;\n  color: rgba(0, 0, 0, .7);\n}\n.button.is-warning[disabled],\nfieldset[disabled] .button.is-warning {\n  background-color: #ffdd57;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.button.is-warning.is-inverted {\n  background-color: rgba(0, 0, 0, .7);\n  color: #ffdd57;\n}\n.button.is-warning.is-inverted:hover {\n  background-color: rgba(0, 0, 0, .7);\n}\n.button.is-warning.is-inverted[disabled],\nfieldset[disabled] .button.is-warning.is-inverted {\n  background-color: rgba(0, 0, 0, .7);\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #ffdd57;\n}\n.button.is-warning.is-loading::after {\n  border-color: transparent transparent rgba(0, 0, 0, .7) rgba(0, 0, 0, .7) !important;\n}\n.button.is-warning.is-outlined {\n  background-color: transparent;\n  border-color: #ffdd57;\n  color: #ffdd57;\n}\n.button.is-warning.is-outlined:hover,\n.button.is-warning.is-outlined:focus {\n  background-color: #ffdd57;\n  border-color: #ffdd57;\n  color: rgba(0, 0, 0, .7);\n}\n.button.is-warning.is-outlined.is-loading::after {\n  border-color: transparent transparent #ffdd57 #ffdd57 !important;\n}\n.button.is-warning.is-outlined[disabled],\nfieldset[disabled] .button.is-warning.is-outlined {\n  background-color: transparent;\n  border-color: #ffdd57;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #ffdd57;\n}\n.button.is-warning.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: rgba(0, 0, 0, .7);\n  color: rgba(0, 0, 0, .7);\n}\n.button.is-warning.is-inverted.is-outlined:hover,\n.button.is-warning.is-inverted.is-outlined:focus {\n  background-color: rgba(0, 0, 0, .7);\n  color: #ffdd57;\n}\n.button.is-warning.is-inverted.is-outlined[disabled],\nfieldset[disabled] .button.is-warning.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: rgba(0, 0, 0, .7);\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: rgba(0, 0, 0, .7);\n}\n.button.is-danger {\n  background-color: #dc5b5b;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-danger:hover,\n.button.is-danger.is-hovered {\n  background-color: #da5050;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-danger:focus,\n.button.is-danger.is-focused {\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-danger:focus:not(:active),\n.button.is-danger.is-focused:not(:active) {\n  -webkit-box-shadow: 0 0 0 .125em rgba(220, 91, 91, .25);\n          box-shadow: 0 0 0 .125em rgba(220, 91, 91, .25);\n}\n.button.is-danger:active,\n.button.is-danger.is-active {\n  background-color: #d84646;\n  border-color: transparent;\n  color: #fff;\n}\n.button.is-danger[disabled],\nfieldset[disabled] .button.is-danger {\n  background-color: #dc5b5b;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.button.is-danger.is-inverted {\n  background-color: #fff;\n  color: #dc5b5b;\n}\n.button.is-danger.is-inverted:hover {\n  background-color: #f2f2f2;\n}\n.button.is-danger.is-inverted[disabled],\nfieldset[disabled] .button.is-danger.is-inverted {\n  background-color: #fff;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #dc5b5b;\n}\n.button.is-danger.is-loading::after {\n  border-color: transparent transparent #fff #fff !important;\n}\n.button.is-danger.is-outlined {\n  background-color: transparent;\n  border-color: #dc5b5b;\n  color: #dc5b5b;\n}\n.button.is-danger.is-outlined:hover,\n.button.is-danger.is-outlined:focus {\n  background-color: #dc5b5b;\n  border-color: #dc5b5b;\n  color: #fff;\n}\n.button.is-danger.is-outlined.is-loading::after {\n  border-color: transparent transparent #dc5b5b #dc5b5b !important;\n}\n.button.is-danger.is-outlined[disabled],\nfieldset[disabled] .button.is-danger.is-outlined {\n  background-color: transparent;\n  border-color: #dc5b5b;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #dc5b5b;\n}\n.button.is-danger.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #fff;\n  color: #fff;\n}\n.button.is-danger.is-inverted.is-outlined:hover,\n.button.is-danger.is-inverted.is-outlined:focus {\n  background-color: #fff;\n  color: #dc5b5b;\n}\n.button.is-danger.is-inverted.is-outlined[disabled],\nfieldset[disabled] .button.is-danger.is-inverted.is-outlined {\n  background-color: transparent;\n  border-color: #fff;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #fff;\n}\n.button.is-small {\n  border-radius: 2px;\n  font-size: .75rem;\n}\n.button.is-normal {\n  font-size: 1rem;\n}\n.button.is-medium {\n  font-size: 1.25rem;\n}\n.button.is-large {\n  font-size: 1.5rem;\n}\n.button[disabled],\nfieldset[disabled] .button {\n  background-color: white;\n  border-color: #dbdbdb;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  opacity: .5;\n}\n.button.is-fullwidth {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.button.is-loading {\n  color: transparent !important;\n  pointer-events: none;\n}\n.button.is-loading::after {\n  position: absolute;\n  left: calc(50% - (1em / 2));\n  top: calc(50% - (1em / 2));\n  position: absolute !important;\n}\n.button.is-static {\n  background-color: whitesmoke;\n  border-color: #dbdbdb;\n  color: #9babb4;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  pointer-events: none;\n}\n.button.is-rounded {\n  border-radius: 290486px;\n  padding-left: 1em;\n  padding-right: 1em;\n}\n.buttons {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n.buttons .button {\n  margin-bottom: .5rem;\n}\n.buttons .button:not(:last-child):not(.is-fullwidth) {\n  margin-right: .5rem;\n}\n.buttons:last-child {\n  margin-bottom: -0.5rem;\n}\n.buttons:not(:last-child) {\n  margin-bottom: 1rem;\n}\n.buttons.are-small .button:not(.is-normal):not(.is-medium):not(.is-large) {\n  border-radius: 2px;\n  font-size: .75rem;\n}\n.buttons.are-medium .button:not(.is-small):not(.is-normal):not(.is-large) {\n  font-size: 1.25rem;\n}\n.buttons.are-large .button:not(.is-small):not(.is-normal):not(.is-medium) {\n  font-size: 1.5rem;\n}\n.buttons.has-addons .button:not(:first-child) {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.buttons.has-addons .button:not(:last-child) {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n  margin-right: -1px;\n}\n.buttons.has-addons .button:last-child {\n  margin-right: 0;\n}\n.buttons.has-addons .button:hover,\n.buttons.has-addons .button.is-hovered {\n  z-index: 2;\n}\n.buttons.has-addons .button:focus,\n.buttons.has-addons .button.is-focused,\n.buttons.has-addons .button:active,\n.buttons.has-addons .button.is-active,\n.buttons.has-addons .button.is-selected {\n  z-index: 3;\n}\n.buttons.has-addons .button:focus:hover,\n.buttons.has-addons .button.is-focused:hover,\n.buttons.has-addons .button:active:hover,\n.buttons.has-addons .button.is-active:hover,\n.buttons.has-addons .button.is-selected:hover {\n  z-index: 4;\n}\n.buttons.has-addons .button.is-expanded {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n}\n.buttons.is-centered {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.buttons.is-right {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n.container {\n  margin: 0 auto;\n  position: relative;\n}\n@media screen and (min-width: 1088px) {\n.container {\n    max-width: 960px;\n    width: 960px;\n}\n.container.is-fluid {\n    margin-left: 64px;\n    margin-right: 64px;\n    max-width: none;\n    width: auto;\n}\n}\n@media screen and (max-width: 1279px) {\n.container.is-widescreen {\n    max-width: 1152px;\n    width: auto;\n}\n}\n@media screen and (max-width: 1279px) {\n.container.is-fullhd {\n    max-width: 1152px;\n    width: auto;\n}\n}\n@media screen and (min-width: 1280px) {\n.container {\n    max-width: 1152px;\n    width: 1152px;\n}\n}\n@media screen and (min-width: 1280px) {\n.container {\n    max-width: 1152px;\n    width: 1152px;\n}\n}\n.content li + li {\n  margin-top: .25em;\n}\n.content p:not(:last-child),\n.content dl:not(:last-child),\n.content ol:not(:last-child),\n.content ul:not(:last-child),\n.content blockquote:not(:last-child),\n.content pre:not(:last-child),\n.content table:not(:last-child) {\n  margin-bottom: 1em;\n}\n.content h1,\n.content h2,\n.content h3,\n.content h4,\n.content h5,\n.content h6 {\n  color: #363636;\n  font-weight: 600;\n  line-height: 1.125;\n}\n.content h1 {\n  font-size: 2em;\n  margin-bottom: .5em;\n}\n.content h1:not(:first-child) {\n  margin-top: 1em;\n}\n.content h2 {\n  font-size: 1.75em;\n  margin-bottom: .5714em;\n}\n.content h2:not(:first-child) {\n  margin-top: 1.1428em;\n}\n.content h3 {\n  font-size: 1.5em;\n  margin-bottom: .6666em;\n}\n.content h3:not(:first-child) {\n  margin-top: 1.3333em;\n}\n.content h4 {\n  font-size: 1.25em;\n  margin-bottom: .8em;\n}\n.content h5 {\n  font-size: 1.125em;\n  margin-bottom: .8888em;\n}\n.content h6 {\n  font-size: 1em;\n  margin-bottom: 1em;\n}\n.content blockquote {\n  background-color: whitesmoke;\n  border-left: 5px solid #dbdbdb;\n  padding: 1.25em 1.5em;\n}\n.content ol {\n  list-style-position: outside;\n  margin-left: 2em;\n  margin-top: 1em;\n}\n.content ol:not([type]) {\n  list-style-type: decimal;\n}\n.content ol:not([type]).is-lower-alpha {\n  list-style-type: lower-alpha;\n}\n.content ol:not([type]).is-lower-roman {\n  list-style-type: lower-roman;\n}\n.content ol:not([type]).is-upper-alpha {\n  list-style-type: upper-alpha;\n}\n.content ol:not([type]).is-upper-roman {\n  list-style-type: upper-roman;\n}\n.content ul {\n  list-style: disc outside;\n  margin-left: 2em;\n  margin-top: 1em;\n}\n.content ul ul {\n  list-style-type: circle;\n  margin-top: .5em;\n}\n.content ul ul ul {\n  list-style-type: square;\n}\n.content dd {\n  margin-left: 2em;\n}\n.content figure {\n  margin-left: 2em;\n  margin-right: 2em;\n  text-align: center;\n}\n.content figure:not(:first-child) {\n  margin-top: 2em;\n}\n.content figure:not(:last-child) {\n  margin-bottom: 2em;\n}\n.content figure img {\n  display: inline-block;\n}\n.content figure figcaption {\n  font-style: italic;\n}\n.content pre {\n  -webkit-overflow-scrolling: touch;\n  overflow-x: auto;\n  padding: 1.25em 1.5em;\n  white-space: pre;\n  word-wrap: normal;\n}\n.content sup,\n.content sub {\n  font-size: 75%;\n}\n.content table {\n  width: 100%;\n}\n.content table td,\n.content table th {\n  border: 1px solid #dbdbdb;\n  border-width: 0 0 1px;\n  padding: .5em .75em;\n  vertical-align: top;\n}\n.content table th {\n  color: #363636;\n  text-align: left;\n}\n.content table thead td,\n.content table thead th {\n  border-width: 0 0 2px;\n  color: #363636;\n}\n.content table tfoot td,\n.content table tfoot th {\n  border-width: 2px 0 0;\n  color: #363636;\n}\n.content table tbody tr:last-child td,\n.content table tbody tr:last-child th {\n  border-bottom-width: 0;\n}\n.content.is-small {\n  font-size: .75rem;\n}\n.content.is-medium {\n  font-size: 1.25rem;\n}\n.content.is-large {\n  font-size: 1.5rem;\n}\n.input,\n.taginput .taginput-container.is-focusable,\n.textarea {\n  background-color: #f8f9fb;\n  border-color: #dcdddf;\n  color: #363636;\n  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, .1);\n          box-shadow: inset 0 1px 2px rgba(10, 10, 10, .1);\n  max-width: 100%;\n  width: 100%;\n}\n.input::-moz-placeholder,\n.taginput .taginput-container.is-focusable::-moz-placeholder,\n.textarea::-moz-placeholder {\n  color: rgba(54, 54, 54, .3);\n}\n.input::-webkit-input-placeholder,\n.taginput .taginput-container.is-focusable::-webkit-input-placeholder,\n.textarea::-webkit-input-placeholder {\n  color: rgba(54, 54, 54, .3);\n}\n.input:-moz-placeholder,\n.taginput .taginput-container.is-focusable:-moz-placeholder,\n.textarea:-moz-placeholder {\n  color: rgba(54, 54, 54, .3);\n}\n.input:-ms-input-placeholder,\n.taginput .taginput-container.is-focusable:-ms-input-placeholder,\n.textarea:-ms-input-placeholder {\n  color: rgba(54, 54, 54, .3);\n}\n.input:hover,\n.taginput .taginput-container.is-focusable:hover,\n.input.is-hovered,\n.taginput .is-hovered.taginput-container.is-focusable,\n.textarea:hover,\n.textarea.is-hovered {\n  border-color: #b5b5b5;\n}\n.input:focus,\n.taginput .taginput-container.is-focusable:focus,\n.input.is-focused,\n.taginput .is-focused.taginput-container.is-focusable,\n.input:active,\n.taginput .taginput-container.is-focusable:active,\n.input.is-active,\n.taginput .is-active.taginput-container.is-focusable,\n.textarea:focus,\n.textarea.is-focused,\n.textarea:active,\n.textarea.is-active {\n  border-color: #b5b5b5;\n  -webkit-box-shadow: 0 rgba(181, 181, 181, .25);\n          box-shadow: 0 rgba(181, 181, 181, .25);\n}\n.input[disabled],\n.taginput .taginput-container.is-focusable[disabled],\nfieldset[disabled] .input,\nfieldset[disabled] .taginput .taginput-container.is-focusable,\n.taginput fieldset[disabled] .taginput-container.is-focusable,\n.textarea[disabled],\nfieldset[disabled]\n  .textarea {\n  background-color: whitesmoke;\n  border-color: whitesmoke;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #7a7a7a;\n}\n.input[disabled]::-moz-placeholder,\n.taginput .taginput-container.is-focusable[disabled]::-moz-placeholder,\nfieldset[disabled] .input::-moz-placeholder,\nfieldset[disabled] .taginput .taginput-container.is-focusable::-moz-placeholder,\n.taginput fieldset[disabled] .taginput-container.is-focusable::-moz-placeholder,\n.textarea[disabled]::-moz-placeholder,\nfieldset[disabled]\n    .textarea::-moz-placeholder {\n  color: rgba(122, 122, 122, .3);\n}\n.input[disabled]::-webkit-input-placeholder,\n.taginput .taginput-container.is-focusable[disabled]::-webkit-input-placeholder,\nfieldset[disabled] .input::-webkit-input-placeholder,\nfieldset[disabled] .taginput .taginput-container.is-focusable::-webkit-input-placeholder,\n.taginput fieldset[disabled] .taginput-container.is-focusable::-webkit-input-placeholder,\n.textarea[disabled]::-webkit-input-placeholder,\nfieldset[disabled]\n    .textarea::-webkit-input-placeholder {\n  color: rgba(122, 122, 122, .3);\n}\n.input[disabled]:-moz-placeholder,\n.taginput .taginput-container.is-focusable[disabled]:-moz-placeholder,\nfieldset[disabled] .input:-moz-placeholder,\nfieldset[disabled] .taginput .taginput-container.is-focusable:-moz-placeholder,\n.taginput fieldset[disabled] .taginput-container.is-focusable:-moz-placeholder,\n.textarea[disabled]:-moz-placeholder,\nfieldset[disabled]\n    .textarea:-moz-placeholder {\n  color: rgba(122, 122, 122, .3);\n}\n.input[disabled]:-ms-input-placeholder,\n.taginput .taginput-container.is-focusable[disabled]:-ms-input-placeholder,\nfieldset[disabled] .input:-ms-input-placeholder,\nfieldset[disabled] .taginput .taginput-container.is-focusable:-ms-input-placeholder,\n.taginput fieldset[disabled] .taginput-container.is-focusable:-ms-input-placeholder,\n.textarea[disabled]:-ms-input-placeholder,\nfieldset[disabled]\n    .textarea:-ms-input-placeholder {\n  color: rgba(122, 122, 122, .3);\n}\n.input[readonly],\n.taginput .taginput-container.is-focusable[readonly],\n.textarea[readonly] {\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.input.is-white,\n.taginput .is-white.taginput-container.is-focusable,\n.textarea.is-white {\n  border-color: white;\n}\n.input.is-white:focus,\n.taginput .is-white.taginput-container.is-focusable:focus,\n.input.is-white.is-focused,\n.taginput .is-white.is-focused.taginput-container.is-focusable,\n.input.is-white:active,\n.taginput .is-white.taginput-container.is-focusable:active,\n.input.is-white.is-active,\n.taginput .is-white.is-active.taginput-container.is-focusable,\n.textarea.is-white:focus,\n.textarea.is-white.is-focused,\n.textarea.is-white:active,\n.textarea.is-white.is-active {\n  -webkit-box-shadow: 0 rgba(255, 255, 255, .25);\n          box-shadow: 0 rgba(255, 255, 255, .25);\n}\n.input.is-black,\n.taginput .is-black.taginput-container.is-focusable,\n.textarea.is-black {\n  border-color: #0a0a0a;\n}\n.input.is-black:focus,\n.taginput .is-black.taginput-container.is-focusable:focus,\n.input.is-black.is-focused,\n.taginput .is-black.is-focused.taginput-container.is-focusable,\n.input.is-black:active,\n.taginput .is-black.taginput-container.is-focusable:active,\n.input.is-black.is-active,\n.taginput .is-black.is-active.taginput-container.is-focusable,\n.textarea.is-black:focus,\n.textarea.is-black.is-focused,\n.textarea.is-black:active,\n.textarea.is-black.is-active {\n  -webkit-box-shadow: 0 rgba(10, 10, 10, .25);\n          box-shadow: 0 rgba(10, 10, 10, .25);\n}\n.input.is-grey,\n.taginput .is-grey.taginput-container.is-focusable,\n.textarea.is-grey {\n  border-color: #9babb4;\n}\n.input.is-grey:focus,\n.taginput .is-grey.taginput-container.is-focusable:focus,\n.input.is-grey.is-focused,\n.taginput .is-grey.is-focused.taginput-container.is-focusable,\n.input.is-grey:active,\n.taginput .is-grey.taginput-container.is-focusable:active,\n.input.is-grey.is-active,\n.taginput .is-grey.is-active.taginput-container.is-focusable,\n.textarea.is-grey:focus,\n.textarea.is-grey.is-focused,\n.textarea.is-grey:active,\n.textarea.is-grey.is-active {\n  -webkit-box-shadow: 0 rgba(155, 171, 180, .25);\n          box-shadow: 0 rgba(155, 171, 180, .25);\n}\n.input.is-blue,\n.taginput .is-blue.taginput-container.is-focusable,\n.textarea.is-blue {\n  border-color: #3b5998;\n}\n.input.is-blue:focus,\n.taginput .is-blue.taginput-container.is-focusable:focus,\n.input.is-blue.is-focused,\n.taginput .is-blue.is-focused.taginput-container.is-focusable,\n.input.is-blue:active,\n.taginput .is-blue.taginput-container.is-focusable:active,\n.input.is-blue.is-active,\n.taginput .is-blue.is-active.taginput-container.is-focusable,\n.textarea.is-blue:focus,\n.textarea.is-blue.is-focused,\n.textarea.is-blue:active,\n.textarea.is-blue.is-active {\n  -webkit-box-shadow: 0 rgba(59, 89, 152, .25);\n          box-shadow: 0 rgba(59, 89, 152, .25);\n}\n.input.is-blue-dark,\n.taginput .is-blue-dark.taginput-container.is-focusable,\n.textarea.is-blue-dark {\n  border-color: #3b5998;\n}\n.input.is-blue-dark:focus,\n.taginput .is-blue-dark.taginput-container.is-focusable:focus,\n.input.is-blue-dark.is-focused,\n.taginput .is-blue-dark.is-focused.taginput-container.is-focusable,\n.input.is-blue-dark:active,\n.taginput .is-blue-dark.taginput-container.is-focusable:active,\n.input.is-blue-dark.is-active,\n.taginput .is-blue-dark.is-active.taginput-container.is-focusable,\n.textarea.is-blue-dark:focus,\n.textarea.is-blue-dark.is-focused,\n.textarea.is-blue-dark:active,\n.textarea.is-blue-dark.is-active {\n  -webkit-box-shadow: 0 rgba(59, 89, 152, .25);\n          box-shadow: 0 rgba(59, 89, 152, .25);\n}\n.input.is-light,\n.taginput .is-light.taginput-container.is-focusable,\n.textarea.is-light {\n  border-color: whitesmoke;\n}\n.input.is-light:focus,\n.taginput .is-light.taginput-container.is-focusable:focus,\n.input.is-light.is-focused,\n.taginput .is-light.is-focused.taginput-container.is-focusable,\n.input.is-light:active,\n.taginput .is-light.taginput-container.is-focusable:active,\n.input.is-light.is-active,\n.taginput .is-light.is-active.taginput-container.is-focusable,\n.textarea.is-light:focus,\n.textarea.is-light.is-focused,\n.textarea.is-light:active,\n.textarea.is-light.is-active {\n  -webkit-box-shadow: 0 rgba(245, 245, 245, .25);\n          box-shadow: 0 rgba(245, 245, 245, .25);\n}\n.input.is-dark,\n.taginput .is-dark.taginput-container.is-focusable,\n.textarea.is-dark {\n  border-color: #363636;\n}\n.input.is-dark:focus,\n.taginput .is-dark.taginput-container.is-focusable:focus,\n.input.is-dark.is-focused,\n.taginput .is-dark.is-focused.taginput-container.is-focusable,\n.input.is-dark:active,\n.taginput .is-dark.taginput-container.is-focusable:active,\n.input.is-dark.is-active,\n.taginput .is-dark.is-active.taginput-container.is-focusable,\n.textarea.is-dark:focus,\n.textarea.is-dark.is-focused,\n.textarea.is-dark:active,\n.textarea.is-dark.is-active {\n  -webkit-box-shadow: 0 rgba(54, 54, 54, .25);\n          box-shadow: 0 rgba(54, 54, 54, .25);\n}\n.input.is-primary,\n.taginput .is-primary.taginput-container.is-focusable,\n.textarea.is-primary {\n  border-color: #2196f3;\n}\n.input.is-primary:focus,\n.taginput .is-primary.taginput-container.is-focusable:focus,\n.input.is-primary.is-focused,\n.taginput .is-primary.is-focused.taginput-container.is-focusable,\n.input.is-primary:active,\n.taginput .is-primary.taginput-container.is-focusable:active,\n.input.is-primary.is-active,\n.taginput .is-primary.is-active.taginput-container.is-focusable,\n.textarea.is-primary:focus,\n.textarea.is-primary.is-focused,\n.textarea.is-primary:active,\n.textarea.is-primary.is-active {\n  -webkit-box-shadow: 0 rgba(33, 150, 243, .25);\n          box-shadow: 0 rgba(33, 150, 243, .25);\n}\n.input.is-info,\n.taginput .is-info.taginput-container.is-focusable,\n.textarea.is-info {\n  border-color: #3b5998;\n}\n.input.is-info:focus,\n.taginput .is-info.taginput-container.is-focusable:focus,\n.input.is-info.is-focused,\n.taginput .is-info.is-focused.taginput-container.is-focusable,\n.input.is-info:active,\n.taginput .is-info.taginput-container.is-focusable:active,\n.input.is-info.is-active,\n.taginput .is-info.is-active.taginput-container.is-focusable,\n.textarea.is-info:focus,\n.textarea.is-info.is-focused,\n.textarea.is-info:active,\n.textarea.is-info.is-active {\n  -webkit-box-shadow: 0 rgba(59, 89, 152, .25);\n          box-shadow: 0 rgba(59, 89, 152, .25);\n}\n.input.is-success,\n.taginput .is-success.taginput-container.is-focusable,\n.textarea.is-success {\n  border-color: #2ab27b;\n}\n.input.is-success:focus,\n.taginput .is-success.taginput-container.is-focusable:focus,\n.input.is-success.is-focused,\n.taginput .is-success.is-focused.taginput-container.is-focusable,\n.input.is-success:active,\n.taginput .is-success.taginput-container.is-focusable:active,\n.input.is-success.is-active,\n.taginput .is-success.is-active.taginput-container.is-focusable,\n.textarea.is-success:focus,\n.textarea.is-success.is-focused,\n.textarea.is-success:active,\n.textarea.is-success.is-active {\n  -webkit-box-shadow: 0 rgba(42, 178, 123, .25);\n          box-shadow: 0 rgba(42, 178, 123, .25);\n}\n.input.is-warning,\n.taginput .is-warning.taginput-container.is-focusable,\n.textarea.is-warning {\n  border-color: #ffdd57;\n}\n.input.is-warning:focus,\n.taginput .is-warning.taginput-container.is-focusable:focus,\n.input.is-warning.is-focused,\n.taginput .is-warning.is-focused.taginput-container.is-focusable,\n.input.is-warning:active,\n.taginput .is-warning.taginput-container.is-focusable:active,\n.input.is-warning.is-active,\n.taginput .is-warning.is-active.taginput-container.is-focusable,\n.textarea.is-warning:focus,\n.textarea.is-warning.is-focused,\n.textarea.is-warning:active,\n.textarea.is-warning.is-active {\n  -webkit-box-shadow: 0 rgba(255, 221, 87, .25);\n          box-shadow: 0 rgba(255, 221, 87, .25);\n}\n.input.is-danger,\n.taginput .is-danger.taginput-container.is-focusable,\n.textarea.is-danger {\n  border-color: #dc5b5b;\n}\n.input.is-danger:focus,\n.taginput .is-danger.taginput-container.is-focusable:focus,\n.input.is-danger.is-focused,\n.taginput .is-danger.is-focused.taginput-container.is-focusable,\n.input.is-danger:active,\n.taginput .is-danger.taginput-container.is-focusable:active,\n.input.is-danger.is-active,\n.taginput .is-danger.is-active.taginput-container.is-focusable,\n.textarea.is-danger:focus,\n.textarea.is-danger.is-focused,\n.textarea.is-danger:active,\n.textarea.is-danger.is-active {\n  -webkit-box-shadow: 0 rgba(220, 91, 91, .25);\n          box-shadow: 0 rgba(220, 91, 91, .25);\n}\n.input.is-small,\n.taginput .is-small.taginput-container.is-focusable,\n.textarea.is-small {\n  border-radius: 2px;\n  font-size: .75rem;\n}\n.input.is-medium,\n.taginput .is-medium.taginput-container.is-focusable,\n.textarea.is-medium {\n  font-size: 1.25rem;\n}\n.input.is-large,\n.taginput .is-large.taginput-container.is-focusable,\n.textarea.is-large {\n  font-size: 1.5rem;\n}\n.input.is-fullwidth,\n.taginput .is-fullwidth.taginput-container.is-focusable,\n.textarea.is-fullwidth {\n  display: block;\n  width: 100%;\n}\n.input.is-inline,\n.taginput .is-inline.taginput-container.is-focusable,\n.textarea.is-inline {\n  display: inline;\n  width: auto;\n}\n.input.is-rounded,\n.taginput .is-rounded.taginput-container.is-focusable {\n  border-radius: 290486px;\n  padding-left: 1em;\n  padding-right: 1em;\n}\n.input.is-static,\n.taginput .is-static.taginput-container.is-focusable {\n  background-color: transparent;\n  border-color: transparent;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  padding-left: 0;\n  padding-right: 0;\n}\n.textarea {\n  display: block;\n  max-width: 100%;\n  min-width: 100%;\n  padding: .625em;\n  resize: vertical;\n}\n.textarea:not([rows]) {\n  max-height: 600px;\n  min-height: 120px;\n}\n.textarea[rows] {\n  height: initial;\n}\n.textarea.has-fixed-size {\n  resize: none;\n}\n.checkbox,\n.radio {\n  cursor: pointer;\n  display: inline-block;\n  line-height: 1.25;\n  position: relative;\n}\n.checkbox input,\n.radio input {\n  cursor: pointer;\n}\n.checkbox:hover,\n.radio:hover {\n  color: #363636;\n}\n.checkbox[disabled],\nfieldset[disabled] .checkbox,\n.radio[disabled],\nfieldset[disabled]\n  .radio {\n  color: #7a7a7a;\n  cursor: not-allowed;\n}\n.radio + .radio {\n  margin-left: .5em;\n}\n.select {\n  display: inline-block;\n  max-width: 100%;\n  position: relative;\n  vertical-align: top;\n}\n.select:not(.is-multiple) {\n  height: 2.25em;\n}\n.select:not(.is-multiple):not(.is-loading)::after {\n  border-color: #2196f3;\n  right: 1.125em;\n  z-index: 4;\n}\n.select.is-rounded select {\n  border-radius: 290486px;\n  padding-left: 1em;\n}\n.select select {\n  background-color: #f8f9fb;\n  border-color: #dcdddf;\n  color: #363636;\n  cursor: pointer;\n  display: block;\n  font-size: 1em;\n  max-width: 100%;\n  outline: none;\n}\n.select select::-moz-placeholder {\n  color: rgba(54, 54, 54, .3);\n}\n.select select::-webkit-input-placeholder {\n  color: rgba(54, 54, 54, .3);\n}\n.select select:-moz-placeholder {\n  color: rgba(54, 54, 54, .3);\n}\n.select select:-ms-input-placeholder {\n  color: rgba(54, 54, 54, .3);\n}\n.select select:hover,\n.select select.is-hovered {\n  border-color: #b5b5b5;\n}\n.select select:focus,\n.select select.is-focused,\n.select select:active,\n.select select.is-active {\n  border-color: #b5b5b5;\n  -webkit-box-shadow: 0 rgba(181, 181, 181, .25);\n          box-shadow: 0 rgba(181, 181, 181, .25);\n}\n.select select[disabled],\nfieldset[disabled] .select select {\n  background-color: whitesmoke;\n  border-color: whitesmoke;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #7a7a7a;\n}\n.select select[disabled]::-moz-placeholder,\nfieldset[disabled] .select select::-moz-placeholder {\n  color: rgba(122, 122, 122, .3);\n}\n.select select[disabled]::-webkit-input-placeholder,\nfieldset[disabled] .select select::-webkit-input-placeholder {\n  color: rgba(122, 122, 122, .3);\n}\n.select select[disabled]:-moz-placeholder,\nfieldset[disabled] .select select:-moz-placeholder {\n  color: rgba(122, 122, 122, .3);\n}\n.select select[disabled]:-ms-input-placeholder,\nfieldset[disabled] .select select:-ms-input-placeholder {\n  color: rgba(122, 122, 122, .3);\n}\n.select select::-ms-expand {\n  display: none;\n}\n.select select[disabled]:hover,\nfieldset[disabled] .select select:hover {\n  border-color: whitesmoke;\n}\n.select select:not([multiple]) {\n  padding-right: 2.5em;\n}\n.select select[multiple] {\n  height: auto;\n  padding: 0;\n}\n.select select[multiple] option {\n  padding: .5em 1em;\n}\n.select:not(.is-multiple):not(.is-loading):hover::after {\n  border-color: #363636;\n}\n.select.is-white:not(:hover)::after {\n  border-color: white;\n}\n.select.is-white select {\n  border-color: white;\n}\n.select.is-white select:hover,\n.select.is-white select.is-hovered {\n  border-color: #f2f2f2;\n}\n.select.is-white select:focus,\n.select.is-white select.is-focused,\n.select.is-white select:active,\n.select.is-white select.is-active {\n  -webkit-box-shadow: 0 rgba(255, 255, 255, .25);\n          box-shadow: 0 rgba(255, 255, 255, .25);\n}\n.select.is-black:not(:hover)::after {\n  border-color: #0a0a0a;\n}\n.select.is-black select {\n  border-color: #0a0a0a;\n}\n.select.is-black select:hover,\n.select.is-black select.is-hovered {\n  border-color: black;\n}\n.select.is-black select:focus,\n.select.is-black select.is-focused,\n.select.is-black select:active,\n.select.is-black select.is-active {\n  -webkit-box-shadow: 0 rgba(10, 10, 10, .25);\n          box-shadow: 0 rgba(10, 10, 10, .25);\n}\n.select.is-grey:not(:hover)::after {\n  border-color: #9babb4;\n}\n.select.is-grey select {\n  border-color: #9babb4;\n}\n.select.is-grey select:hover,\n.select.is-grey select.is-hovered {\n  border-color: #8c9fa9;\n}\n.select.is-grey select:focus,\n.select.is-grey select.is-focused,\n.select.is-grey select:active,\n.select.is-grey select.is-active {\n  -webkit-box-shadow: 0 rgba(155, 171, 180, .25);\n          box-shadow: 0 rgba(155, 171, 180, .25);\n}\n.select.is-blue:not(:hover)::after {\n  border-color: #3b5998;\n}\n.select.is-blue select {\n  border-color: #3b5998;\n}\n.select.is-blue select:hover,\n.select.is-blue select.is-hovered {\n  border-color: #344e86;\n}\n.select.is-blue select:focus,\n.select.is-blue select.is-focused,\n.select.is-blue select:active,\n.select.is-blue select.is-active {\n  -webkit-box-shadow: 0 rgba(59, 89, 152, .25);\n          box-shadow: 0 rgba(59, 89, 152, .25);\n}\n.select.is-blue-dark:not(:hover)::after {\n  border-color: #3b5998;\n}\n.select.is-blue-dark select {\n  border-color: #3b5998;\n}\n.select.is-blue-dark select:hover,\n.select.is-blue-dark select.is-hovered {\n  border-color: #344e86;\n}\n.select.is-blue-dark select:focus,\n.select.is-blue-dark select.is-focused,\n.select.is-blue-dark select:active,\n.select.is-blue-dark select.is-active {\n  -webkit-box-shadow: 0 rgba(59, 89, 152, .25);\n          box-shadow: 0 rgba(59, 89, 152, .25);\n}\n.select.is-light:not(:hover)::after {\n  border-color: whitesmoke;\n}\n.select.is-light select {\n  border-color: whitesmoke;\n}\n.select.is-light select:hover,\n.select.is-light select.is-hovered {\n  border-color: #e8e8e8;\n}\n.select.is-light select:focus,\n.select.is-light select.is-focused,\n.select.is-light select:active,\n.select.is-light select.is-active {\n  -webkit-box-shadow: 0 rgba(245, 245, 245, .25);\n          box-shadow: 0 rgba(245, 245, 245, .25);\n}\n.select.is-dark:not(:hover)::after {\n  border-color: #363636;\n}\n.select.is-dark select {\n  border-color: #363636;\n}\n.select.is-dark select:hover,\n.select.is-dark select.is-hovered {\n  border-color: #292929;\n}\n.select.is-dark select:focus,\n.select.is-dark select.is-focused,\n.select.is-dark select:active,\n.select.is-dark select.is-active {\n  -webkit-box-shadow: 0 rgba(54, 54, 54, .25);\n          box-shadow: 0 rgba(54, 54, 54, .25);\n}\n.select.is-primary:not(:hover)::after {\n  border-color: #2196f3;\n}\n.select.is-primary select {\n  border-color: #2196f3;\n}\n.select.is-primary select:hover,\n.select.is-primary select.is-hovered {\n  border-color: #0d8aee;\n}\n.select.is-primary select:focus,\n.select.is-primary select.is-focused,\n.select.is-primary select:active,\n.select.is-primary select.is-active {\n  -webkit-box-shadow: 0 rgba(33, 150, 243, .25);\n          box-shadow: 0 rgba(33, 150, 243, .25);\n}\n.select.is-info:not(:hover)::after {\n  border-color: #3b5998;\n}\n.select.is-info select {\n  border-color: #3b5998;\n}\n.select.is-info select:hover,\n.select.is-info select.is-hovered {\n  border-color: #344e86;\n}\n.select.is-info select:focus,\n.select.is-info select.is-focused,\n.select.is-info select:active,\n.select.is-info select.is-active {\n  -webkit-box-shadow: 0 rgba(59, 89, 152, .25);\n          box-shadow: 0 rgba(59, 89, 152, .25);\n}\n.select.is-success:not(:hover)::after {\n  border-color: #2ab27b;\n}\n.select.is-success select {\n  border-color: #2ab27b;\n}\n.select.is-success select:hover,\n.select.is-success select.is-hovered {\n  border-color: #259d6d;\n}\n.select.is-success select:focus,\n.select.is-success select.is-focused,\n.select.is-success select:active,\n.select.is-success select.is-active {\n  -webkit-box-shadow: 0 rgba(42, 178, 123, .25);\n          box-shadow: 0 rgba(42, 178, 123, .25);\n}\n.select.is-warning:not(:hover)::after {\n  border-color: #ffdd57;\n}\n.select.is-warning select {\n  border-color: #ffdd57;\n}\n.select.is-warning select:hover,\n.select.is-warning select.is-hovered {\n  border-color: #ffd83d;\n}\n.select.is-warning select:focus,\n.select.is-warning select.is-focused,\n.select.is-warning select:active,\n.select.is-warning select.is-active {\n  -webkit-box-shadow: 0 rgba(255, 221, 87, .25);\n          box-shadow: 0 rgba(255, 221, 87, .25);\n}\n.select.is-danger:not(:hover)::after {\n  border-color: #dc5b5b;\n}\n.select.is-danger select {\n  border-color: #dc5b5b;\n}\n.select.is-danger select:hover,\n.select.is-danger select.is-hovered {\n  border-color: #d84646;\n}\n.select.is-danger select:focus,\n.select.is-danger select.is-focused,\n.select.is-danger select:active,\n.select.is-danger select.is-active {\n  -webkit-box-shadow: 0 rgba(220, 91, 91, .25);\n          box-shadow: 0 rgba(220, 91, 91, .25);\n}\n.select.is-small {\n  border-radius: 2px;\n  font-size: .75rem;\n}\n.select.is-medium {\n  font-size: 1.25rem;\n}\n.select.is-large {\n  font-size: 1.5rem;\n}\n.select.is-disabled::after {\n  border-color: #7a7a7a;\n}\n.select.is-fullwidth {\n  width: 100%;\n}\n.select.is-fullwidth select {\n  width: 100%;\n}\n.select.is-loading::after {\n  margin-top: 0;\n  position: absolute;\n  right: .625em;\n  top: .625em;\n  -webkit-transform: none;\n          transform: none;\n}\n.select.is-loading.is-small:after {\n  font-size: .75rem;\n}\n.select.is-loading.is-medium:after {\n  font-size: 1.25rem;\n}\n.select.is-loading.is-large:after {\n  font-size: 1.5rem;\n}\n.file {\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  position: relative;\n}\n.file.is-white .file-cta {\n  background-color: white;\n  border-color: transparent;\n  color: #0a0a0a;\n}\n.file.is-white:hover .file-cta,\n.file.is-white.is-hovered .file-cta {\n  background-color: #f9f9f9;\n  border-color: transparent;\n  color: #0a0a0a;\n}\n.file.is-white:focus .file-cta,\n.file.is-white.is-focused .file-cta {\n  border-color: transparent;\n  -webkit-box-shadow: 0 0 .5em rgba(255, 255, 255, .25);\n          box-shadow: 0 0 .5em rgba(255, 255, 255, .25);\n  color: #0a0a0a;\n}\n.file.is-white:active .file-cta,\n.file.is-white.is-active .file-cta {\n  background-color: #f2f2f2;\n  border-color: transparent;\n  color: #0a0a0a;\n}\n.file.is-black .file-cta {\n  background-color: #0a0a0a;\n  border-color: transparent;\n  color: white;\n}\n.file.is-black:hover .file-cta,\n.file.is-black.is-hovered .file-cta {\n  background-color: #040404;\n  border-color: transparent;\n  color: white;\n}\n.file.is-black:focus .file-cta,\n.file.is-black.is-focused .file-cta {\n  border-color: transparent;\n  -webkit-box-shadow: 0 0 .5em rgba(10, 10, 10, .25);\n          box-shadow: 0 0 .5em rgba(10, 10, 10, .25);\n  color: white;\n}\n.file.is-black:active .file-cta,\n.file.is-black.is-active .file-cta {\n  background-color: black;\n  border-color: transparent;\n  color: white;\n}\n.file.is-grey .file-cta {\n  background-color: #9babb4;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-grey:hover .file-cta,\n.file.is-grey.is-hovered .file-cta {\n  background-color: #94a5af;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-grey:focus .file-cta,\n.file.is-grey.is-focused .file-cta {\n  border-color: transparent;\n  -webkit-box-shadow: 0 0 .5em rgba(155, 171, 180, .25);\n          box-shadow: 0 0 .5em rgba(155, 171, 180, .25);\n  color: #fff;\n}\n.file.is-grey:active .file-cta,\n.file.is-grey.is-active .file-cta {\n  background-color: #8c9fa9;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-blue .file-cta {\n  background-color: #3b5998;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-blue:hover .file-cta,\n.file.is-blue.is-hovered .file-cta {\n  background-color: #37548f;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-blue:focus .file-cta,\n.file.is-blue.is-focused .file-cta {\n  border-color: transparent;\n  -webkit-box-shadow: 0 0 .5em rgba(59, 89, 152, .25);\n          box-shadow: 0 0 .5em rgba(59, 89, 152, .25);\n  color: #fff;\n}\n.file.is-blue:active .file-cta,\n.file.is-blue.is-active .file-cta {\n  background-color: #344e86;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-blue-dark .file-cta {\n  background-color: #3b5998;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-blue-dark:hover .file-cta,\n.file.is-blue-dark.is-hovered .file-cta {\n  background-color: #37548f;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-blue-dark:focus .file-cta,\n.file.is-blue-dark.is-focused .file-cta {\n  border-color: transparent;\n  -webkit-box-shadow: 0 0 .5em rgba(59, 89, 152, .25);\n          box-shadow: 0 0 .5em rgba(59, 89, 152, .25);\n  color: #fff;\n}\n.file.is-blue-dark:active .file-cta,\n.file.is-blue-dark.is-active .file-cta {\n  background-color: #344e86;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-light .file-cta {\n  background-color: whitesmoke;\n  border-color: transparent;\n  color: #363636;\n}\n.file.is-light:hover .file-cta,\n.file.is-light.is-hovered .file-cta {\n  background-color: #eee;\n  border-color: transparent;\n  color: #363636;\n}\n.file.is-light:focus .file-cta,\n.file.is-light.is-focused .file-cta {\n  border-color: transparent;\n  -webkit-box-shadow: 0 0 .5em rgba(245, 245, 245, .25);\n          box-shadow: 0 0 .5em rgba(245, 245, 245, .25);\n  color: #363636;\n}\n.file.is-light:active .file-cta,\n.file.is-light.is-active .file-cta {\n  background-color: #e8e8e8;\n  border-color: transparent;\n  color: #363636;\n}\n.file.is-dark .file-cta {\n  background-color: #363636;\n  border-color: transparent;\n  color: whitesmoke;\n}\n.file.is-dark:hover .file-cta,\n.file.is-dark.is-hovered .file-cta {\n  background-color: #2f2f2f;\n  border-color: transparent;\n  color: whitesmoke;\n}\n.file.is-dark:focus .file-cta,\n.file.is-dark.is-focused .file-cta {\n  border-color: transparent;\n  -webkit-box-shadow: 0 0 .5em rgba(54, 54, 54, .25);\n          box-shadow: 0 0 .5em rgba(54, 54, 54, .25);\n  color: whitesmoke;\n}\n.file.is-dark:active .file-cta,\n.file.is-dark.is-active .file-cta {\n  background-color: #292929;\n  border-color: transparent;\n  color: whitesmoke;\n}\n.file.is-primary .file-cta {\n  background-color: #2196f3;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-primary:hover .file-cta,\n.file.is-primary.is-hovered .file-cta {\n  background-color: #1590f2;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-primary:focus .file-cta,\n.file.is-primary.is-focused .file-cta {\n  border-color: transparent;\n  -webkit-box-shadow: 0 0 .5em rgba(33, 150, 243, .25);\n          box-shadow: 0 0 .5em rgba(33, 150, 243, .25);\n  color: #fff;\n}\n.file.is-primary:active .file-cta,\n.file.is-primary.is-active .file-cta {\n  background-color: #0d8aee;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-info .file-cta {\n  background-color: #3b5998;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-info:hover .file-cta,\n.file.is-info.is-hovered .file-cta {\n  background-color: #37548f;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-info:focus .file-cta,\n.file.is-info.is-focused .file-cta {\n  border-color: transparent;\n  -webkit-box-shadow: 0 0 .5em rgba(59, 89, 152, .25);\n          box-shadow: 0 0 .5em rgba(59, 89, 152, .25);\n  color: #fff;\n}\n.file.is-info:active .file-cta,\n.file.is-info.is-active .file-cta {\n  background-color: #344e86;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-success .file-cta {\n  background-color: #2ab27b;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-success:hover .file-cta,\n.file.is-success.is-hovered .file-cta {\n  background-color: #28a874;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-success:focus .file-cta,\n.file.is-success.is-focused .file-cta {\n  border-color: transparent;\n  -webkit-box-shadow: 0 0 .5em rgba(42, 178, 123, .25);\n          box-shadow: 0 0 .5em rgba(42, 178, 123, .25);\n  color: #fff;\n}\n.file.is-success:active .file-cta,\n.file.is-success.is-active .file-cta {\n  background-color: #259d6d;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-warning .file-cta {\n  background-color: #ffdd57;\n  border-color: transparent;\n  color: rgba(0, 0, 0, .7);\n}\n.file.is-warning:hover .file-cta,\n.file.is-warning.is-hovered .file-cta {\n  background-color: #ffdb4a;\n  border-color: transparent;\n  color: rgba(0, 0, 0, .7);\n}\n.file.is-warning:focus .file-cta,\n.file.is-warning.is-focused .file-cta {\n  border-color: transparent;\n  -webkit-box-shadow: 0 0 .5em rgba(255, 221, 87, .25);\n          box-shadow: 0 0 .5em rgba(255, 221, 87, .25);\n  color: rgba(0, 0, 0, .7);\n}\n.file.is-warning:active .file-cta,\n.file.is-warning.is-active .file-cta {\n  background-color: #ffd83d;\n  border-color: transparent;\n  color: rgba(0, 0, 0, .7);\n}\n.file.is-danger .file-cta {\n  background-color: #dc5b5b;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-danger:hover .file-cta,\n.file.is-danger.is-hovered .file-cta {\n  background-color: #da5050;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-danger:focus .file-cta,\n.file.is-danger.is-focused .file-cta {\n  border-color: transparent;\n  -webkit-box-shadow: 0 0 .5em rgba(220, 91, 91, .25);\n          box-shadow: 0 0 .5em rgba(220, 91, 91, .25);\n  color: #fff;\n}\n.file.is-danger:active .file-cta,\n.file.is-danger.is-active .file-cta {\n  background-color: #d84646;\n  border-color: transparent;\n  color: #fff;\n}\n.file.is-small {\n  font-size: .75rem;\n}\n.file.is-medium {\n  font-size: 1.25rem;\n}\n.file.is-medium .file-icon .fa {\n  font-size: 21px;\n}\n.file.is-large {\n  font-size: 1.5rem;\n}\n.file.is-large .file-icon .fa {\n  font-size: 28px;\n}\n.file.has-name .file-cta {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.file.has-name .file-name {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.file.has-name.is-empty .file-cta {\n  border-radius: 4px;\n}\n.file.has-name.is-empty .file-name {\n  display: none;\n}\n.file.is-boxed .file-label {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.file.is-boxed .file-cta {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  height: auto;\n  padding: 1em 3em;\n}\n.file.is-boxed .file-name {\n  border-width: 0 1px 1px;\n}\n.file.is-boxed .file-icon {\n  height: 1.5em;\n  width: 1.5em;\n}\n.file.is-boxed .file-icon .fa {\n  font-size: 21px;\n}\n.file.is-boxed.is-small .file-icon .fa {\n  font-size: 14px;\n}\n.file.is-boxed.is-medium .file-icon .fa {\n  font-size: 28px;\n}\n.file.is-boxed.is-large .file-icon .fa {\n  font-size: 35px;\n}\n.file.is-boxed.has-name .file-cta {\n  border-radius: 4px 4px 0 0;\n}\n.file.is-boxed.has-name .file-name {\n  border-radius: 0 0 4px 4px;\n  border-width: 0 1px 1px;\n}\n.file.is-centered {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.file.is-fullwidth .file-label {\n  width: 100%;\n}\n.file.is-fullwidth .file-name {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  max-width: none;\n}\n.file.is-right {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n.file.is-right .file-cta {\n  border-radius: 0 4px 4px 0;\n}\n.file.is-right .file-name {\n  border-radius: 4px 0 0 4px;\n  border-width: 1px 0 1px 1px;\n  -webkit-box-ordinal-group: 0;\n  -ms-flex-order: -1;\n  order: -1;\n}\n.file-label {\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  overflow: hidden;\n  position: relative;\n}\n.file-label:hover .file-cta {\n  background-color: #eee;\n  color: #363636;\n}\n.file-label:hover .file-name {\n  border-color: #d5d5d5;\n}\n.file-label:active .file-cta {\n  background-color: #e8e8e8;\n  color: #363636;\n}\n.file-label:active .file-name {\n  border-color: #cfcfcf;\n}\n.file-input {\n  height: 100%;\n  left: 0;\n  opacity: 0;\n  outline: none;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.file-cta,\n.file-name {\n  border-color: #dbdbdb;\n  border-radius: 4px;\n  font-size: 1em;\n  padding-left: 1em;\n  padding-right: 1em;\n  white-space: nowrap;\n}\n.file-cta {\n  background-color: whitesmoke;\n  color: #4a4a4a;\n}\n.file-name {\n  border-color: #dbdbdb;\n  border-style: solid;\n  border-width: 1px 1px 1px 0;\n  display: block;\n  max-width: 16em;\n  overflow: hidden;\n  text-align: left;\n  text-overflow: ellipsis;\n}\n.file-icon {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  height: 1em;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  margin-right: .5em;\n  width: 1em;\n}\n.file-icon .fa {\n  font-size: 14px;\n}\n.label {\n  color: #363636;\n  display: block;\n  font-size: 1rem;\n  font-weight: 700;\n}\n.label:not(:last-child) {\n  margin-bottom: .5em;\n}\n.label.is-small {\n  font-size: .75rem;\n}\n.label.is-medium {\n  font-size: 1.25rem;\n}\n.label.is-large {\n  font-size: 1.5rem;\n}\n.help {\n  display: block;\n  font-size: .75rem;\n  margin-top: .25rem;\n}\n.help.is-white {\n  color: white;\n}\n.help.is-black {\n  color: #0a0a0a;\n}\n.help.is-grey {\n  color: #9babb4;\n}\n.help.is-blue {\n  color: #3b5998;\n}\n.help.is-blue-dark {\n  color: #3b5998;\n}\n.help.is-light {\n  color: whitesmoke;\n}\n.help.is-dark {\n  color: #363636;\n}\n.help.is-primary {\n  color: #2196f3;\n}\n.help.is-info {\n  color: #3b5998;\n}\n.help.is-success {\n  color: #2ab27b;\n}\n.help.is-warning {\n  color: #ffdd57;\n}\n.help.is-danger {\n  color: #dc5b5b;\n}\n.field:not(:last-child) {\n  margin-bottom: .75rem;\n}\n.field.has-addons {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n.field.has-addons .control:not(:last-child) {\n  margin-right: -1px;\n}\n.field.has-addons .control:not(:first-child):not(:last-child) .button,\n.field.has-addons .control:not(:first-child):not(:last-child) .input,\n.field.has-addons .control:not(:first-child):not(:last-child) .taginput .taginput-container.is-focusable,\n.taginput .field.has-addons .control:not(:first-child):not(:last-child) .taginput-container.is-focusable,\n.field.has-addons .control:not(:first-child):not(:last-child) .select select {\n  border-radius: 0;\n}\n.field.has-addons .control:first-child:not(:only-child) .button,\n.field.has-addons .control:first-child:not(:only-child) .input,\n.field.has-addons .control:first-child:not(:only-child) .taginput .taginput-container.is-focusable,\n.taginput .field.has-addons .control:first-child:not(:only-child) .taginput-container.is-focusable,\n.field.has-addons .control:first-child:not(:only-child) .select select {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.field.has-addons .control:last-child:not(:only-child) .button,\n.field.has-addons .control:last-child:not(:only-child) .input,\n.field.has-addons .control:last-child:not(:only-child) .taginput .taginput-container.is-focusable,\n.taginput .field.has-addons .control:last-child:not(:only-child) .taginput-container.is-focusable,\n.field.has-addons .control:last-child:not(:only-child) .select select {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.field.has-addons .control .button:not([disabled]):hover,\n.field.has-addons .control .button:not([disabled]).is-hovered,\n.field.has-addons .control .input:not([disabled]):hover,\n.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]):hover,\n.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]):hover,\n.field.has-addons .control .input:not([disabled]).is-hovered,\n.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]).is-hovered,\n.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]).is-hovered,\n.field.has-addons .control .select select:not([disabled]):hover,\n.field.has-addons .control .select select:not([disabled]).is-hovered {\n  z-index: 2;\n}\n.field.has-addons .control .button:not([disabled]):focus,\n.field.has-addons .control .button:not([disabled]).is-focused,\n.field.has-addons .control .button:not([disabled]):active,\n.field.has-addons .control .button:not([disabled]).is-active,\n.field.has-addons .control .input:not([disabled]):focus,\n.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]):focus,\n.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]):focus,\n.field.has-addons .control .input:not([disabled]).is-focused,\n.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]).is-focused,\n.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]).is-focused,\n.field.has-addons .control .input:not([disabled]):active,\n.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]):active,\n.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]):active,\n.field.has-addons .control .input:not([disabled]).is-active,\n.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]).is-active,\n.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]).is-active,\n.field.has-addons .control .select select:not([disabled]):focus,\n.field.has-addons .control .select select:not([disabled]).is-focused,\n.field.has-addons .control .select select:not([disabled]):active,\n.field.has-addons .control .select select:not([disabled]).is-active {\n  z-index: 3;\n}\n.field.has-addons .control .button:not([disabled]):focus:hover,\n.field.has-addons .control .button:not([disabled]).is-focused:hover,\n.field.has-addons .control .button:not([disabled]):active:hover,\n.field.has-addons .control .button:not([disabled]).is-active:hover,\n.field.has-addons .control .input:not([disabled]):focus:hover,\n.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]):focus:hover,\n.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]):focus:hover,\n.field.has-addons .control .input:not([disabled]).is-focused:hover,\n.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]).is-focused:hover,\n.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]).is-focused:hover,\n.field.has-addons .control .input:not([disabled]):active:hover,\n.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]):active:hover,\n.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]):active:hover,\n.field.has-addons .control .input:not([disabled]).is-active:hover,\n.field.has-addons .control .taginput .taginput-container.is-focusable:not([disabled]).is-active:hover,\n.taginput .field.has-addons .control .taginput-container.is-focusable:not([disabled]).is-active:hover,\n.field.has-addons .control .select select:not([disabled]):focus:hover,\n.field.has-addons .control .select select:not([disabled]).is-focused:hover,\n.field.has-addons .control .select select:not([disabled]):active:hover,\n.field.has-addons .control .select select:not([disabled]).is-active:hover {\n  z-index: 4;\n}\n.field.has-addons .control.is-expanded {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n}\n.field.has-addons.has-addons-centered {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.field.has-addons.has-addons-right {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n.field.has-addons.has-addons-fullwidth .control {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n.field.is-grouped {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n.field.is-grouped > .control {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n.field.is-grouped > .control:not(:last-child) {\n  margin-bottom: 0;\n  margin-right: .75rem;\n}\n.field.is-grouped > .control.is-expanded {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1;\n}\n.field.is-grouped.is-grouped-centered {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.field.is-grouped.is-grouped-right {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n.field.is-grouped.is-grouped-multiline {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.field.is-grouped.is-grouped-multiline > .control:last-child,\n.field.is-grouped.is-grouped-multiline > .control:not(:last-child) {\n  margin-bottom: .75rem;\n}\n.field.is-grouped.is-grouped-multiline:last-child {\n  margin-bottom: -0.75rem;\n}\n.field.is-grouped.is-grouped-multiline:not(:last-child) {\n  margin-bottom: 0;\n}\n@media screen and (min-width: 769px), print {\n.field.is-horizontal {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n}\n.field-label .label {\n  font-size: inherit;\n}\n@media screen and (max-width: 768px) {\n.field-label {\n    margin-bottom: .5rem;\n}\n}\n@media screen and (min-width: 769px), print {\n.field-label {\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n    margin-right: 1.5rem;\n    text-align: right;\n}\n.field-label.is-small {\n    font-size: .75rem;\n    padding-top: .375em;\n}\n.field-label.is-normal {\n    padding-top: .375em;\n}\n.field-label.is-medium {\n    font-size: 1.25rem;\n    padding-top: .375em;\n}\n.field-label.is-large {\n    font-size: 1.5rem;\n    padding-top: .375em;\n}\n}\n.field-body .field .field {\n  margin-bottom: 0;\n}\n@media screen and (min-width: 769px), print {\n.field-body {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-preferred-size: 0;\n    flex-basis: 0;\n    -webkit-box-flex: 5;\n    -ms-flex-positive: 5;\n    flex-grow: 5;\n    -ms-flex-negative: 1;\n    flex-shrink: 1;\n}\n.field-body .field {\n    margin-bottom: 0;\n}\n.field-body > .field {\n    -ms-flex-negative: 1;\n    flex-shrink: 1;\n}\n.field-body > .field:not(.is-narrow) {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n.field-body > .field:not(:last-child) {\n    margin-right: .75rem;\n}\n}\n.control {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  clear: both;\n  font-size: 1rem;\n  position: relative;\n  text-align: left;\n}\n.control.has-icons-left .input:focus ~ .icon,\n.control.has-icons-left .taginput .taginput-container.is-focusable:focus ~ .icon,\n.taginput .control.has-icons-left .taginput-container.is-focusable:focus ~ .icon,\n.control.has-icons-left .select:focus ~ .icon,\n.control.has-icons-right .input:focus ~ .icon,\n.control.has-icons-right .taginput .taginput-container.is-focusable:focus ~ .icon,\n.taginput .control.has-icons-right .taginput-container.is-focusable:focus ~ .icon,\n.control.has-icons-right .select:focus ~ .icon {\n  color: #9babb4;\n}\n.control.has-icons-left .input.is-small ~ .icon,\n.control.has-icons-left .taginput .is-small.taginput-container.is-focusable ~ .icon,\n.taginput .control.has-icons-left .is-small.taginput-container.is-focusable ~ .icon,\n.control.has-icons-left .select.is-small ~ .icon,\n.control.has-icons-right .input.is-small ~ .icon,\n.control.has-icons-right .taginput .is-small.taginput-container.is-focusable ~ .icon,\n.taginput .control.has-icons-right .is-small.taginput-container.is-focusable ~ .icon,\n.control.has-icons-right .select.is-small ~ .icon {\n  font-size: .75rem;\n}\n.control.has-icons-left .input.is-medium ~ .icon,\n.control.has-icons-left .taginput .is-medium.taginput-container.is-focusable ~ .icon,\n.taginput .control.has-icons-left .is-medium.taginput-container.is-focusable ~ .icon,\n.control.has-icons-left .select.is-medium ~ .icon,\n.control.has-icons-right .input.is-medium ~ .icon,\n.control.has-icons-right .taginput .is-medium.taginput-container.is-focusable ~ .icon,\n.taginput .control.has-icons-right .is-medium.taginput-container.is-focusable ~ .icon,\n.control.has-icons-right .select.is-medium ~ .icon {\n  font-size: 1.25rem;\n}\n.control.has-icons-left .input.is-large ~ .icon,\n.control.has-icons-left .taginput .is-large.taginput-container.is-focusable ~ .icon,\n.taginput .control.has-icons-left .is-large.taginput-container.is-focusable ~ .icon,\n.control.has-icons-left .select.is-large ~ .icon,\n.control.has-icons-right .input.is-large ~ .icon,\n.control.has-icons-right .taginput .is-large.taginput-container.is-focusable ~ .icon,\n.taginput .control.has-icons-right .is-large.taginput-container.is-focusable ~ .icon,\n.control.has-icons-right .select.is-large ~ .icon {\n  font-size: 1.5rem;\n}\n.control.has-icons-left .icon,\n.control.has-icons-right .icon {\n  color: #dbdbdb;\n  height: 2.25em;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  width: 2.25em;\n  z-index: 4;\n}\n.control.has-icons-left .input,\n.control.has-icons-left .taginput .taginput-container.is-focusable,\n.taginput .control.has-icons-left .taginput-container.is-focusable,\n.control.has-icons-left .select select {\n  padding-left: 2.25em;\n}\n.control.has-icons-left .icon.is-left {\n  left: 0;\n}\n.control.has-icons-right .input,\n.control.has-icons-right .taginput .taginput-container.is-focusable,\n.taginput .control.has-icons-right .taginput-container.is-focusable,\n.control.has-icons-right .select select {\n  padding-right: 2.25em;\n}\n.control.has-icons-right .icon.is-right {\n  right: 0;\n}\n.control.is-loading::after {\n  position: absolute !important;\n  right: .625em;\n  top: .625em;\n  z-index: 4;\n}\n.control.is-loading.is-small:after {\n  font-size: .75rem;\n}\n.control.is-loading.is-medium:after {\n  font-size: 1.25rem;\n}\n.control.is-loading.is-large:after {\n  font-size: 1.5rem;\n}\n.icon {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  height: 1.5rem;\n  width: 1.5rem;\n}\n.icon.is-small {\n  height: 1rem;\n  width: 1rem;\n}\n.icon.is-medium {\n  height: 2rem;\n  width: 2rem;\n}\n.icon.is-large {\n  height: 3rem;\n  width: 3rem;\n}\n.image {\n  display: block;\n  position: relative;\n}\n.image img {\n  display: block;\n  height: auto;\n  width: 100%;\n}\n.image img.is-rounded {\n  border-radius: 290486px;\n}\n.image.is-square img,\n.image.is-square .has-ratio,\n.image.is-1by1 img,\n.image.is-1by1 .has-ratio,\n.image.is-5by4 img,\n.image.is-5by4 .has-ratio,\n.image.is-4by3 img,\n.image.is-4by3 .has-ratio,\n.image.is-3by2 img,\n.image.is-3by2 .has-ratio,\n.image.is-5by3 img,\n.image.is-5by3 .has-ratio,\n.image.is-16by9 img,\n.image.is-16by9 .has-ratio,\n.image.is-2by1 img,\n.image.is-2by1 .has-ratio,\n.image.is-3by1 img,\n.image.is-3by1 .has-ratio,\n.image.is-4by5 img,\n.image.is-4by5 .has-ratio,\n.image.is-3by4 img,\n.image.is-3by4 .has-ratio,\n.image.is-2by3 img,\n.image.is-2by3 .has-ratio,\n.image.is-3by5 img,\n.image.is-3by5 .has-ratio,\n.image.is-9by16 img,\n.image.is-9by16 .has-ratio,\n.image.is-1by2 img,\n.image.is-1by2 .has-ratio,\n.image.is-1by3 img,\n.image.is-1by3 .has-ratio {\n  height: 100%;\n  width: 100%;\n}\n.image.is-square,\n.image.is-1by1 {\n  padding-top: 100%;\n}\n.image.is-5by4 {\n  padding-top: 80%;\n}\n.image.is-4by3 {\n  padding-top: 75%;\n}\n.image.is-3by2 {\n  padding-top: 66.6666%;\n}\n.image.is-5by3 {\n  padding-top: 60%;\n}\n.image.is-16by9 {\n  padding-top: 56.25%;\n}\n.image.is-2by1 {\n  padding-top: 50%;\n}\n.image.is-3by1 {\n  padding-top: 33.3333%;\n}\n.image.is-4by5 {\n  padding-top: 125%;\n}\n.image.is-3by4 {\n  padding-top: 133.3333%;\n}\n.image.is-2by3 {\n  padding-top: 150%;\n}\n.image.is-3by5 {\n  padding-top: 166.6666%;\n}\n.image.is-9by16 {\n  padding-top: 177.7777%;\n}\n.image.is-1by2 {\n  padding-top: 200%;\n}\n.image.is-1by3 {\n  padding-top: 300%;\n}\n.image.is-16x16 {\n  height: 16px;\n  width: 16px;\n}\n.image.is-24x24 {\n  height: 24px;\n  width: 24px;\n}\n.image.is-32x32 {\n  height: 32px;\n  width: 32px;\n}\n.image.is-48x48 {\n  height: 48px;\n  width: 48px;\n}\n.image.is-64x64 {\n  height: 64px;\n  width: 64px;\n}\n.image.is-96x96 {\n  height: 96px;\n  width: 96px;\n}\n.image.is-128x128 {\n  height: 128px;\n  width: 128px;\n}\n.notification {\n  background-color: whitesmoke;\n  border-radius: 4px;\n  padding: 1.25rem 2.5rem 1.25rem 1.5rem;\n  position: relative;\n}\n.notification a:not(.button):not(.dropdown-item) {\n  color: currentColor;\n  text-decoration: underline;\n}\n.notification strong {\n  color: currentColor;\n}\n.notification code,\n.notification pre {\n  background: white;\n}\n.notification pre code {\n  background: transparent;\n}\n.notification > .delete {\n  position: absolute;\n  right: .5rem;\n  top: .5rem;\n}\n.notification .title,\n.notification .subtitle,\n.notification .content {\n  color: currentColor;\n}\n.notification.is-white {\n  background-color: white;\n  color: #0a0a0a;\n}\n.notification.is-black {\n  background-color: #0a0a0a;\n  color: white;\n}\n.notification.is-grey {\n  background-color: #9babb4;\n  color: #fff;\n}\n.notification.is-blue {\n  background-color: #3b5998;\n  color: #fff;\n}\n.notification.is-blue-dark {\n  background-color: #3b5998;\n  color: #fff;\n}\n.notification.is-light {\n  background-color: whitesmoke;\n  color: #363636;\n}\n.notification.is-dark {\n  background-color: #363636;\n  color: whitesmoke;\n}\n.notification.is-primary {\n  background-color: #2196f3;\n  color: #fff;\n}\n.notification.is-info {\n  background-color: #3b5998;\n  color: #fff;\n}\n.notification.is-success {\n  background-color: #2ab27b;\n  color: #fff;\n}\n.notification.is-warning {\n  background-color: #ffdd57;\n  color: rgba(0, 0, 0, .7);\n}\n.notification.is-danger {\n  background-color: #dc5b5b;\n  color: #fff;\n}\n.progress {\n     -moz-appearance: none;\n  -webkit-appearance: none;\n  border: none;\n  border-radius: 290486px;\n  display: block;\n  height: 1rem;\n  overflow: hidden;\n  padding: 0;\n  width: 100%;\n}\n.progress::-webkit-progress-bar {\n  background-color: #dbdbdb;\n}\n.progress::-webkit-progress-value {\n  background-color: #4a4a4a;\n}\n.progress::-moz-progress-bar {\n  background-color: #4a4a4a;\n}\n.progress::-ms-fill {\n  background-color: #4a4a4a;\n  border: none;\n}\n.progress:indeterminate {\n  -webkit-animation-duration: 1.5s;\n          animation-duration: 1.5s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-name: moveIndeterminate;\n          animation-name: moveIndeterminate;\n  -webkit-animation-timing-function: linear;\n          animation-timing-function: linear;\n  background-color: #dbdbdb;\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(30%, #4a4a4a), color-stop(30%, #dbdbdb));\n  background-image: linear-gradient(to right, #4a4a4a 30%, #dbdbdb 30%);\n  background-position: top left;\n  background-repeat: no-repeat;\n  background-size: 150% 150%;\n}\n.progress:indeterminate::-webkit-progress-bar {\n  background-color: transparent;\n}\n.progress:indeterminate::-moz-progress-bar {\n  background-color: transparent;\n}\n.progress.is-white::-webkit-progress-value {\n  background-color: white;\n}\n.progress.is-white::-moz-progress-bar {\n  background-color: white;\n}\n.progress.is-white::-ms-fill {\n  background-color: white;\n}\n.progress.is-white:indeterminate {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(30%, white), color-stop(30%, #dbdbdb));\n  background-image: linear-gradient(to right, white 30%, #dbdbdb 30%);\n}\n.progress.is-black::-webkit-progress-value {\n  background-color: #0a0a0a;\n}\n.progress.is-black::-moz-progress-bar {\n  background-color: #0a0a0a;\n}\n.progress.is-black::-ms-fill {\n  background-color: #0a0a0a;\n}\n.progress.is-black:indeterminate {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(30%, #0a0a0a), color-stop(30%, #dbdbdb));\n  background-image: linear-gradient(to right, #0a0a0a 30%, #dbdbdb 30%);\n}\n.progress.is-grey::-webkit-progress-value {\n  background-color: #9babb4;\n}\n.progress.is-grey::-moz-progress-bar {\n  background-color: #9babb4;\n}\n.progress.is-grey::-ms-fill {\n  background-color: #9babb4;\n}\n.progress.is-grey:indeterminate {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(30%, #9babb4), color-stop(30%, #dbdbdb));\n  background-image: linear-gradient(to right, #9babb4 30%, #dbdbdb 30%);\n}\n.progress.is-blue::-webkit-progress-value {\n  background-color: #3b5998;\n}\n.progress.is-blue::-moz-progress-bar {\n  background-color: #3b5998;\n}\n.progress.is-blue::-ms-fill {\n  background-color: #3b5998;\n}\n.progress.is-blue:indeterminate {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(30%, #3b5998), color-stop(30%, #dbdbdb));\n  background-image: linear-gradient(to right, #3b5998 30%, #dbdbdb 30%);\n}\n.progress.is-blue-dark::-webkit-progress-value {\n  background-color: #3b5998;\n}\n.progress.is-blue-dark::-moz-progress-bar {\n  background-color: #3b5998;\n}\n.progress.is-blue-dark::-ms-fill {\n  background-color: #3b5998;\n}\n.progress.is-blue-dark:indeterminate {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(30%, #3b5998), color-stop(30%, #dbdbdb));\n  background-image: linear-gradient(to right, #3b5998 30%, #dbdbdb 30%);\n}\n.progress.is-light::-webkit-progress-value {\n  background-color: whitesmoke;\n}\n.progress.is-light::-moz-progress-bar {\n  background-color: whitesmoke;\n}\n.progress.is-light::-ms-fill {\n  background-color: whitesmoke;\n}\n.progress.is-light:indeterminate {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(30%, whitesmoke), color-stop(30%, #dbdbdb));\n  background-image: linear-gradient(to right, whitesmoke 30%, #dbdbdb 30%);\n}\n.progress.is-dark::-webkit-progress-value {\n  background-color: #363636;\n}\n.progress.is-dark::-moz-progress-bar {\n  background-color: #363636;\n}\n.progress.is-dark::-ms-fill {\n  background-color: #363636;\n}\n.progress.is-dark:indeterminate {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(30%, #363636), color-stop(30%, #dbdbdb));\n  background-image: linear-gradient(to right, #363636 30%, #dbdbdb 30%);\n}\n.progress.is-primary::-webkit-progress-value {\n  background-color: #2196f3;\n}\n.progress.is-primary::-moz-progress-bar {\n  background-color: #2196f3;\n}\n.progress.is-primary::-ms-fill {\n  background-color: #2196f3;\n}\n.progress.is-primary:indeterminate {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(30%, #2196f3), color-stop(30%, #dbdbdb));\n  background-image: linear-gradient(to right, #2196f3 30%, #dbdbdb 30%);\n}\n.progress.is-info::-webkit-progress-value {\n  background-color: #3b5998;\n}\n.progress.is-info::-moz-progress-bar {\n  background-color: #3b5998;\n}\n.progress.is-info::-ms-fill {\n  background-color: #3b5998;\n}\n.progress.is-info:indeterminate {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(30%, #3b5998), color-stop(30%, #dbdbdb));\n  background-image: linear-gradient(to right, #3b5998 30%, #dbdbdb 30%);\n}\n.progress.is-success::-webkit-progress-value {\n  background-color: #2ab27b;\n}\n.progress.is-success::-moz-progress-bar {\n  background-color: #2ab27b;\n}\n.progress.is-success::-ms-fill {\n  background-color: #2ab27b;\n}\n.progress.is-success:indeterminate {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(30%, #2ab27b), color-stop(30%, #dbdbdb));\n  background-image: linear-gradient(to right, #2ab27b 30%, #dbdbdb 30%);\n}\n.progress.is-warning::-webkit-progress-value {\n  background-color: #ffdd57;\n}\n.progress.is-warning::-moz-progress-bar {\n  background-color: #ffdd57;\n}\n.progress.is-warning::-ms-fill {\n  background-color: #ffdd57;\n}\n.progress.is-warning:indeterminate {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(30%, #ffdd57), color-stop(30%, #dbdbdb));\n  background-image: linear-gradient(to right, #ffdd57 30%, #dbdbdb 30%);\n}\n.progress.is-danger::-webkit-progress-value {\n  background-color: #dc5b5b;\n}\n.progress.is-danger::-moz-progress-bar {\n  background-color: #dc5b5b;\n}\n.progress.is-danger::-ms-fill {\n  background-color: #dc5b5b;\n}\n.progress.is-danger:indeterminate {\n  background-image: -webkit-gradient(linear, left top, right top, color-stop(30%, #dc5b5b), color-stop(30%, #dbdbdb));\n  background-image: linear-gradient(to right, #dc5b5b 30%, #dbdbdb 30%);\n}\n.progress.is-small {\n  height: .75rem;\n}\n.progress.is-medium {\n  height: 1.25rem;\n}\n.progress.is-large {\n  height: 1.5rem;\n}\n@-webkit-keyframes moveIndeterminate {\nfrom {\n    background-position: 200% 0;\n}\nto {\n    background-position: -200% 0;\n}\n}\n@keyframes moveIndeterminate {\nfrom {\n    background-position: 200% 0;\n}\nto {\n    background-position: -200% 0;\n}\n}\n.table {\n  background-color: white;\n  color: #363636;\n}\n.table td,\n.table th {\n  border: 1px solid #dbdbdb;\n  border-width: 0 0 1px;\n  padding: .5em .75em;\n  vertical-align: top;\n}\n.table td.is-white,\n.table th.is-white {\n  background-color: white;\n  border-color: white;\n  color: #0a0a0a;\n}\n.table td.is-black,\n.table th.is-black {\n  background-color: #0a0a0a;\n  border-color: #0a0a0a;\n  color: white;\n}\n.table td.is-grey,\n.table th.is-grey {\n  background-color: #9babb4;\n  border-color: #9babb4;\n  color: #fff;\n}\n.table td.is-blue,\n.table th.is-blue {\n  background-color: #3b5998;\n  border-color: #3b5998;\n  color: #fff;\n}\n.table td.is-blue-dark,\n.table th.is-blue-dark {\n  background-color: #3b5998;\n  border-color: #3b5998;\n  color: #fff;\n}\n.table td.is-light,\n.table th.is-light {\n  background-color: whitesmoke;\n  border-color: whitesmoke;\n  color: #363636;\n}\n.table td.is-dark,\n.table th.is-dark {\n  background-color: #363636;\n  border-color: #363636;\n  color: whitesmoke;\n}\n.table td.is-primary,\n.table th.is-primary {\n  background-color: #2196f3;\n  border-color: #2196f3;\n  color: #fff;\n}\n.table td.is-info,\n.table th.is-info {\n  background-color: #3b5998;\n  border-color: #3b5998;\n  color: #fff;\n}\n.table td.is-success,\n.table th.is-success {\n  background-color: #2ab27b;\n  border-color: #2ab27b;\n  color: #fff;\n}\n.table td.is-warning,\n.table th.is-warning {\n  background-color: #ffdd57;\n  border-color: #ffdd57;\n  color: rgba(0, 0, 0, .7);\n}\n.table td.is-danger,\n.table th.is-danger {\n  background-color: #dc5b5b;\n  border-color: #dc5b5b;\n  color: #fff;\n}\n.table td.is-narrow,\n.table th.is-narrow {\n  white-space: nowrap;\n  width: 1%;\n}\n.table td.is-selected,\n.table th.is-selected {\n  background-color: #2196f3;\n  color: #fff;\n}\n.table td.is-selected a,\n.table td.is-selected strong,\n.table th.is-selected a,\n.table th.is-selected strong {\n  color: currentColor;\n}\n.table th {\n  color: #363636;\n  text-align: left;\n}\n.table tr.is-selected {\n  background-color: #2196f3;\n  color: #fff;\n}\n.table tr.is-selected a,\n.table tr.is-selected strong {\n  color: currentColor;\n}\n.table tr.is-selected td,\n.table tr.is-selected th {\n  border-color: #fff;\n  color: currentColor;\n}\n.table thead {\n  background-color: transparent;\n}\n.table thead td,\n.table thead th {\n  border-width: 0 0 2px;\n  color: #363636;\n}\n.table tfoot {\n  background-color: transparent;\n}\n.table tfoot td,\n.table tfoot th {\n  border-width: 2px 0 0;\n  color: #363636;\n}\n.table tbody {\n  background-color: transparent;\n}\n.table tbody tr:last-child td,\n.table tbody tr:last-child th {\n  border-bottom-width: 0;\n}\n.table.is-bordered td,\n.table.is-bordered th {\n  border-width: 1px;\n}\n.table.is-bordered tr:last-child td,\n.table.is-bordered tr:last-child th {\n  border-bottom-width: 1px;\n}\n.table.is-fullwidth {\n  width: 100%;\n}\n.table.is-hoverable tbody tr:not(.is-selected):hover {\n  background-color: #fafafa;\n}\n.table.is-hoverable.is-striped tbody tr:not(.is-selected):hover {\n  background-color: #fafafa;\n}\n.table.is-hoverable.is-striped tbody tr:not(.is-selected):hover:nth-child(even) {\n  background-color: whitesmoke;\n}\n.table.is-narrow td,\n.table.is-narrow th {\n  padding: .25em .5em;\n}\n.table.is-striped tbody tr:not(.is-selected):nth-child(even) {\n  background-color: #fafafa;\n}\n.table-container {\n  -webkit-overflow-scrolling: touch;\n  overflow: auto;\n  overflow-y: hidden;\n  max-width: 100%;\n}\n.tags {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n.tags .tag {\n  margin-bottom: .5rem;\n}\n.tags .tag:not(:last-child) {\n  margin-right: .5rem;\n}\n.tags:last-child {\n  margin-bottom: -0.5rem;\n}\n.tags:not(:last-child) {\n  margin-bottom: 1rem;\n}\n.tags.are-medium .tag:not(.is-normal):not(.is-large) {\n  font-size: 1rem;\n}\n.tags.are-large .tag:not(.is-normal):not(.is-medium) {\n  font-size: 1.25rem;\n}\n.tags.has-addons .tag {\n  margin-right: 0;\n}\n.tags.has-addons .tag:not(:first-child) {\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.tags.has-addons .tag:not(:last-child) {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.tags.is-centered {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.tags.is-centered .tag {\n  margin-right: .25rem;\n  margin-left: .25rem;\n}\n.tags.is-right {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n.tags.is-right .tag:not(:first-child) {\n  margin-left: .5rem;\n}\n.tags.is-right .tag:not(:last-child) {\n  margin-right: 0;\n}\n.tags.has-addons .tag {\n  margin-right: 0;\n}\n.tags.has-addons .tag:not(:first-child) {\n  margin-left: 0;\n  border-bottom-left-radius: 0;\n  border-top-left-radius: 0;\n}\n.tags.has-addons .tag:not(:last-child) {\n  border-bottom-right-radius: 0;\n  border-top-right-radius: 0;\n}\n.tag:not(body) {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: whitesmoke;\n  border-radius: 4px;\n  color: #4a4a4a;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  font-size: .75rem;\n  height: 2em;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  line-height: 1.5;\n  padding-left: .75em;\n  padding-right: .75em;\n  white-space: nowrap;\n}\n.tag:not(body) .delete {\n  margin-left: .25rem;\n  margin-right: -0.375rem;\n}\n.tag:not(body).is-white {\n  background-color: white;\n  color: #0a0a0a;\n}\n.tag:not(body).is-black {\n  background-color: #0a0a0a;\n  color: white;\n}\n.tag:not(body).is-grey {\n  background-color: #9babb4;\n  color: #fff;\n}\n.tag:not(body).is-blue {\n  background-color: #3b5998;\n  color: #fff;\n}\n.tag:not(body).is-blue-dark {\n  background-color: #3b5998;\n  color: #fff;\n}\n.tag:not(body).is-light {\n  background-color: whitesmoke;\n  color: #363636;\n}\n.tag:not(body).is-dark {\n  background-color: #363636;\n  color: whitesmoke;\n}\n.tag:not(body).is-primary {\n  background-color: #2196f3;\n  color: #fff;\n}\n.tag:not(body).is-info {\n  background-color: #3b5998;\n  color: #fff;\n}\n.tag:not(body).is-success {\n  background-color: #2ab27b;\n  color: #fff;\n}\n.tag:not(body).is-warning {\n  background-color: #ffdd57;\n  color: rgba(0, 0, 0, .7);\n}\n.tag:not(body).is-danger {\n  background-color: #dc5b5b;\n  color: #fff;\n}\n.tag:not(body).is-normal {\n  font-size: .75rem;\n}\n.tag:not(body).is-medium {\n  font-size: 1rem;\n}\n.tag:not(body).is-large {\n  font-size: 1.25rem;\n}\n.tag:not(body) .icon:first-child:not(:last-child) {\n  margin-left: -0.375em;\n  margin-right: .1875em;\n}\n.tag:not(body) .icon:last-child:not(:first-child) {\n  margin-left: .1875em;\n  margin-right: -0.375em;\n}\n.tag:not(body) .icon:first-child:last-child {\n  margin-left: -0.375em;\n  margin-right: -0.375em;\n}\n.tag:not(body).is-delete {\n  margin-left: 1px;\n  padding: 0;\n  position: relative;\n  width: 2em;\n}\n.tag:not(body).is-delete::before,\n.tag:not(body).is-delete::after {\n  background-color: currentColor;\n  content: \"\";\n  display: block;\n  left: 50%;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);\n          transform: translateX(-50%) translateY(-50%) rotate(45deg);\n  -webkit-transform-origin: center center;\n           transform-origin: center center;\n}\n.tag:not(body).is-delete::before {\n  height: 1px;\n  width: 50%;\n}\n.tag:not(body).is-delete::after {\n  height: 50%;\n  width: 1px;\n}\n.tag:not(body).is-delete:hover,\n.tag:not(body).is-delete:focus {\n  background-color: #e8e8e8;\n}\n.tag:not(body).is-delete:active {\n  background-color: #dbdbdb;\n}\n.tag:not(body).is-rounded {\n  border-radius: 290486px;\n}\na.tag:hover {\n  text-decoration: underline;\n}\n.title,\n.subtitle {\n  word-break: break-word;\n}\n.title em,\n.title span,\n.subtitle em,\n.subtitle span {\n  font-weight: inherit;\n}\n.title sub,\n.subtitle sub {\n  font-size: .75em;\n}\n.title sup,\n.subtitle sup {\n  font-size: .75em;\n}\n.title .tag,\n.subtitle .tag {\n  vertical-align: middle;\n}\n.title {\n  color: #363636;\n  font-size: 2rem;\n  font-weight: 600;\n  line-height: 1.125;\n}\n.title strong {\n  color: inherit;\n  font-weight: inherit;\n}\n.title + .highlight {\n  margin-top: -0.75rem;\n}\n.title:not(.is-spaced) + .subtitle {\n  margin-top: -1.25rem;\n}\n.title.is-1 {\n  font-size: 3rem;\n}\n.title.is-2 {\n  font-size: 2.5rem;\n}\n.title.is-3 {\n  font-size: 2rem;\n}\n.title.is-4 {\n  font-size: 1.5rem;\n}\n.title.is-5 {\n  font-size: 1.25rem;\n}\n.title.is-6 {\n  font-size: 1rem;\n}\n.title.is-7 {\n  font-size: .75rem;\n}\n.subtitle {\n  color: #4a4a4a;\n  font-size: 1.25rem;\n  font-weight: 400;\n  line-height: 1.25;\n}\n.subtitle strong {\n  color: #363636;\n  font-weight: 600;\n}\n.subtitle:not(.is-spaced) + .title {\n  margin-top: -1.25rem;\n}\n.subtitle.is-1 {\n  font-size: 3rem;\n}\n.subtitle.is-2 {\n  font-size: 2.5rem;\n}\n.subtitle.is-3 {\n  font-size: 2rem;\n}\n.subtitle.is-4 {\n  font-size: 1.5rem;\n}\n.subtitle.is-5 {\n  font-size: 1.25rem;\n}\n.subtitle.is-6 {\n  font-size: 1rem;\n}\n.subtitle.is-7 {\n  font-size: .75rem;\n}\n.heading {\n  display: block;\n  font-size: 11px;\n  letter-spacing: 1px;\n  margin-bottom: 5px;\n  text-transform: uppercase;\n}\n.highlight {\n  font-weight: 400;\n  max-width: 100%;\n  overflow: hidden;\n  padding: 0;\n}\n.highlight pre {\n  overflow: auto;\n  max-width: 100%;\n}\n.number {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: whitesmoke;\n  border-radius: 290486px;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  font-size: 1.25rem;\n  height: 2em;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  margin-right: 1.5rem;\n  min-width: 2.5em;\n  padding: .25rem .5rem;\n  text-align: center;\n  vertical-align: top;\n}\n.breadcrumb {\n  font-size: 1rem;\n  white-space: nowrap;\n}\n.breadcrumb a {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  color: #2196f3;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  padding: 0 .75em;\n}\n.breadcrumb a:hover {\n  color: #363636;\n}\n.breadcrumb li {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.breadcrumb li:first-child a {\n  padding-left: 0;\n}\n.breadcrumb li.is-active a {\n  color: #363636;\n  cursor: default;\n  pointer-events: none;\n}\n.breadcrumb li + li::before {\n  color: #b5b5b5;\n  content: \"/\";\n}\n.breadcrumb ul,\n.breadcrumb ol {\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n.breadcrumb .icon:first-child {\n  margin-right: .5em;\n}\n.breadcrumb .icon:last-child {\n  margin-left: .5em;\n}\n.breadcrumb.is-centered ol,\n.breadcrumb.is-centered ul {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.breadcrumb.is-right ol,\n.breadcrumb.is-right ul {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n.breadcrumb.is-small {\n  font-size: .75rem;\n}\n.breadcrumb.is-medium {\n  font-size: 1.25rem;\n}\n.breadcrumb.is-large {\n  font-size: 1.5rem;\n}\n.breadcrumb.has-arrow-separator li + li::before {\n  content: \"\\2192\";\n}\n.breadcrumb.has-bullet-separator li + li::before {\n  content: \"\\2022\";\n}\n.breadcrumb.has-dot-separator li + li::before {\n  content: \"\\B7\";\n}\n.breadcrumb.has-succeeds-separator li + li::before {\n  content: \"\\227B\";\n}\n.card {\n  background-color: white;\n  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);\n          box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);\n  color: #4a4a4a;\n  max-width: 100%;\n  position: relative;\n}\n.card-header {\n  background-color: transparent;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  -webkit-box-shadow: 0 1px 2px rgba(10, 10, 10, .1);\n          box-shadow: 0 1px 2px rgba(10, 10, 10, .1);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.card-header-title {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  color: #363636;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  font-weight: 700;\n  padding: .75rem;\n}\n.card-header-title.is-centered {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.card-header-icon {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  cursor: pointer;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  padding: .75rem;\n}\n.card-image {\n  display: block;\n  position: relative;\n}\n.card-content {\n  background-color: transparent;\n  padding: 1.5rem;\n}\n.card-footer {\n  background-color: transparent;\n  border-top: 1px solid #dbdbdb;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.card-footer-item {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  padding: .75rem;\n}\n.card-footer-item:not(:last-child) {\n  border-right: 1px solid #dbdbdb;\n}\n.card .media:not(:last-child) {\n  margin-bottom: .75rem;\n}\n.dropdown {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  position: relative;\n  vertical-align: top;\n}\n.dropdown.is-active .dropdown-menu,\n.dropdown.is-hoverable:hover .dropdown-menu {\n  display: block;\n}\n.dropdown.is-right .dropdown-menu {\n  left: auto;\n  right: 0;\n}\n.dropdown.is-up .dropdown-menu {\n  bottom: 100%;\n  padding-bottom: 4px;\n  padding-top: initial;\n  top: auto;\n}\n.dropdown-menu {\n  display: none;\n  left: 0;\n  min-width: 12rem;\n  padding-top: 4px;\n  position: absolute;\n  top: 100%;\n  z-index: 20;\n}\n.dropdown-content {\n  background-color: white;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);\n          box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);\n  padding-bottom: .5rem;\n  padding-top: .5rem;\n}\n.dropdown-item,\n.dropdown .dropdown-menu .has-link a {\n  color: #4a4a4a;\n  display: block;\n  font-size: .875rem;\n  line-height: 1.5;\n  padding: .375rem 1rem;\n  position: relative;\n}\na.dropdown-item,\n.dropdown .dropdown-menu .has-link a,\nbutton.dropdown-item {\n  padding-right: 3rem;\n  text-align: left;\n  white-space: nowrap;\n  width: 100%;\n}\na.dropdown-item:hover,\n.dropdown .dropdown-menu .has-link a:hover,\nbutton.dropdown-item:hover {\n  background-color: whitesmoke;\n  color: #0a0a0a;\n}\na.dropdown-item.is-active,\n.dropdown .dropdown-menu .has-link a.is-active,\nbutton.dropdown-item.is-active {\n  background-color: #2196f3;\n  color: #fff;\n}\n.dropdown-divider {\n  background-color: #dbdbdb;\n  border: none;\n  display: block;\n  height: 1px;\n  margin: .5rem 0;\n}\n.level {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.level code {\n  border-radius: 4px;\n}\n.level img {\n  display: inline-block;\n  vertical-align: top;\n}\n.level.is-mobile {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.level.is-mobile .level-left,\n.level.is-mobile .level-right {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.level.is-mobile .level-left + .level-right {\n  margin-top: 0;\n}\n.level.is-mobile .level-item:not(:last-child) {\n  margin-bottom: 0;\n  margin-right: .75rem;\n}\n.level.is-mobile .level-item:not(.is-narrow) {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n}\n@media screen and (min-width: 769px), print {\n.level {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.level > .level-item:not(.is-narrow) {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n}\n}\n.level-item {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-preferred-size: auto;\n  flex-basis: auto;\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.level-item .title,\n.level-item .subtitle {\n  margin-bottom: 0;\n}\n@media screen and (max-width: 768px) {\n.level-item:not(:last-child) {\n    margin-bottom: .75rem;\n}\n}\n.level-left,\n.level-right {\n  -ms-flex-preferred-size: auto;\n  flex-basis: auto;\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n.level-left .level-item.is-flexible,\n.level-right .level-item.is-flexible {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n}\n@media screen and (min-width: 769px), print {\n.level-left .level-item:not(:last-child),\n  .level-right .level-item:not(:last-child) {\n    margin-right: .75rem;\n}\n}\n.level-left {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n@media screen and (max-width: 768px) {\n.level-left + .level-right {\n    margin-top: 1.5rem;\n}\n}\n@media screen and (min-width: 769px), print {\n.level-left {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n}\n.level-right {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n@media screen and (min-width: 769px), print {\n.level-right {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n}\n.list {\n  background-color: white;\n  border-radius: 4px;\n  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);\n          box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);\n}\n.list-item {\n  display: block;\n  padding: .5em 1em;\n}\n.list-item:not(a) {\n  color: #4a4a4a;\n}\n.list-item:first-child {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.list-item:last-child {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.list-item:not(:last-child) {\n  border-bottom: 1px solid #dbdbdb;\n}\n.list-item.is-active {\n  background-color: #2196f3;\n  color: #fff;\n}\na.list-item {\n  background-color: whitesmoke;\n  cursor: pointer;\n}\n.media {\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  text-align: left;\n}\n.media .content:not(:last-child) {\n  margin-bottom: .75rem;\n}\n.media .media {\n  border-top: 1px solid rgba(219, 219, 219, .5);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-top: .75rem;\n}\n.media .media .content:not(:last-child),\n.media .media .control:not(:last-child) {\n  margin-bottom: .5rem;\n}\n.media .media .media {\n  padding-top: .5rem;\n}\n.media .media .media + .media {\n  margin-top: .5rem;\n}\n.media + .media {\n  border-top: 1px solid rgba(219, 219, 219, .5);\n  margin-top: 1rem;\n  padding-top: 1rem;\n}\n.media.is-large + .media {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n}\n.media-left,\n.media-right {\n  -ms-flex-preferred-size: auto;\n  flex-basis: auto;\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n.media-left {\n  margin-right: 1rem;\n}\n.media-right {\n  margin-left: 1rem;\n}\n.media-content {\n  -ms-flex-preferred-size: auto;\n  flex-basis: auto;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1;\n  text-align: left;\n}\n@media screen and (max-width: 768px) {\n.media-content {\n    overflow-x: auto;\n}\n}\n.menu {\n  font-size: 1rem;\n}\n.menu.is-small {\n  font-size: .75rem;\n}\n.menu.is-medium {\n  font-size: 1.25rem;\n}\n.menu.is-large {\n  font-size: 1.5rem;\n}\n.menu-list {\n  line-height: 1.25;\n}\n.menu-list a {\n  border-radius: 2px;\n  color: #4a4a4a;\n  display: block;\n  padding: .5em .75em;\n}\n.menu-list a:hover {\n  background-color: whitesmoke;\n  color: #363636;\n}\n.menu-list a.is-active {\n  background-color: #2196f3;\n  color: #fff;\n}\n.menu-list li ul {\n  border-left: 1px solid #dbdbdb;\n  margin: .75em;\n  padding-left: .75em;\n}\n.menu-label {\n  color: #7a7a7a;\n  font-size: .75em;\n  letter-spacing: .1em;\n  text-transform: uppercase;\n}\n.menu-label:not(:first-child) {\n  margin-top: 1em;\n}\n.menu-label:not(:last-child) {\n  margin-bottom: 1em;\n}\n.message {\n  background-color: whitesmoke;\n  border-radius: 4px;\n  font-size: 1rem;\n}\n.message strong {\n  color: currentColor;\n}\n.message a:not(.button):not(.tag):not(.dropdown-item) {\n  color: currentColor;\n  text-decoration: underline;\n}\n.message.is-small {\n  font-size: .75rem;\n}\n.message.is-medium {\n  font-size: 1.25rem;\n}\n.message.is-large {\n  font-size: 1.5rem;\n}\n.message.is-white {\n  background-color: white;\n}\n.message.is-white .message-header {\n  background-color: white;\n  color: #0a0a0a;\n}\n.message.is-white .message-body {\n  border-color: white;\n  color: #4d4d4d;\n}\n.message.is-black {\n  background-color: #fafafa;\n}\n.message.is-black .message-header {\n  background-color: #0a0a0a;\n  color: white;\n}\n.message.is-black .message-body {\n  border-color: #0a0a0a;\n  color: #090909;\n}\n.message.is-grey {\n  background-color: #f9fafb;\n}\n.message.is-grey .message-header {\n  background-color: #9babb4;\n  color: #fff;\n}\n.message.is-grey .message-body {\n  border-color: #9babb4;\n  color: #555656;\n}\n.message.is-blue {\n  background-color: #f8f9fc;\n}\n.message.is-blue .message-header {\n  background-color: #3b5998;\n  color: #fff;\n}\n.message.is-blue .message-body {\n  border-color: #3b5998;\n  color: #30446e;\n}\n.message.is-blue-dark {\n  background-color: #f8f9fc;\n}\n.message.is-blue-dark .message-header {\n  background-color: #3b5998;\n  color: #fff;\n}\n.message.is-blue-dark .message-body {\n  border-color: #3b5998;\n  color: #30446e;\n}\n.message.is-light {\n  background-color: #fafafa;\n}\n.message.is-light .message-header {\n  background-color: whitesmoke;\n  color: #363636;\n}\n.message.is-light .message-body {\n  border-color: whitesmoke;\n  color: #505050;\n}\n.message.is-dark {\n  background-color: #fafafa;\n}\n.message.is-dark .message-header {\n  background-color: #363636;\n  color: whitesmoke;\n}\n.message.is-dark .message-body {\n  border-color: #363636;\n  color: #2a2a2a;\n}\n.message.is-primary {\n  background-color: #f5fafe;\n}\n.message.is-primary .message-header {\n  background-color: #2196f3;\n  color: #fff;\n}\n.message.is-primary .message-body {\n  border-color: #2196f3;\n  color: #10558b;\n}\n.message.is-info {\n  background-color: #f8f9fc;\n}\n.message.is-info .message-header {\n  background-color: #3b5998;\n  color: #fff;\n}\n.message.is-info .message-body {\n  border-color: #3b5998;\n  color: #30446e;\n}\n.message.is-success {\n  background-color: #f7fdfb;\n}\n.message.is-success .message-header {\n  background-color: #2ab27b;\n  color: #fff;\n}\n.message.is-success .message-body {\n  border-color: #2ab27b;\n  color: #143c2c;\n}\n.message.is-warning {\n  background-color: #fffdf5;\n}\n.message.is-warning .message-header {\n  background-color: #ffdd57;\n  color: rgba(0, 0, 0, .7);\n}\n.message.is-warning .message-body {\n  border-color: #ffdd57;\n  color: #3b3108;\n}\n.message.is-danger {\n  background-color: #fdf7f7;\n}\n.message.is-danger .message-header {\n  background-color: #dc5b5b;\n  color: #fff;\n}\n.message.is-danger .message-body {\n  border-color: #dc5b5b;\n  color: #a52e2e;\n}\n.message-header {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: #4a4a4a;\n  border-radius: 4px 4px 0 0;\n  color: #fff;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-weight: 700;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  line-height: 1.25;\n  padding: .75em 1em;\n  position: relative;\n}\n.message-header .delete {\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  margin-left: .75em;\n}\n.message-header + .message-body {\n  border-width: 0;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.message-body {\n  border-color: #dbdbdb;\n  border-radius: 4px;\n  border-style: solid;\n  border-width: 0 0 0 4px;\n  color: #4a4a4a;\n  padding: 1.25em 1.5em;\n}\n.message-body code,\n.message-body pre {\n  background-color: white;\n}\n.message-body pre code {\n  background-color: transparent;\n}\n.modal {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: none;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  overflow: hidden;\n  position: fixed;\n  z-index: 40;\n}\n.modal.is-active {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.modal-background {\n  background-color: rgba(10, 10, 10, .86);\n}\n.modal-content,\n.modal-card {\n  margin: 0 20px;\n  max-height: calc(100vh - 160px);\n  overflow: auto;\n  position: relative;\n  width: 100%;\n}\n@media screen and (min-width: 769px), print {\n.modal-content,\n  .modal-card {\n    margin: 0 auto;\n    max-height: calc(100vh - 40px);\n    width: 640px;\n}\n}\n.modal-close {\n  background: none;\n  height: 40px;\n  position: fixed;\n  right: 20px;\n  top: 20px;\n  width: 40px;\n}\n.modal-card {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  max-height: calc(100vh - 40px);\n  overflow: hidden;\n  -ms-overflow-y: visible;\n}\n.modal-card-head,\n.modal-card-foot {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: whitesmoke;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  padding: 20px;\n  position: relative;\n}\n.modal-card-head {\n  border-bottom: 1px solid #dbdbdb;\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n}\n.modal-card-title {\n  color: #363636;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  font-size: 1.5rem;\n  line-height: 1;\n}\n.modal-card-foot {\n  border-bottom-left-radius: 6px;\n  border-bottom-right-radius: 6px;\n  border-top: 1px solid #dbdbdb;\n}\n.modal-card-foot .button:not(:last-child) {\n  margin-right: 10px;\n}\n.modal-card-body {\n  -webkit-overflow-scrolling: touch;\n  background-color: white;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1;\n  overflow: auto;\n  padding: 20px;\n}\n.navbar {\n  background-color: white;\n  min-height: 3.25rem;\n  position: relative;\n  z-index: 30;\n}\n.navbar.is-white {\n  background-color: white;\n  color: #0a0a0a;\n}\n.navbar.is-white .navbar-brand > .navbar-item,\n.navbar.is-white .navbar-brand .navbar-link {\n  color: #0a0a0a;\n}\n.navbar.is-white .navbar-brand > a.navbar-item:hover,\n.navbar.is-white .navbar-brand > a.navbar-item.is-active,\n.navbar.is-white .navbar-brand .navbar-link:hover,\n.navbar.is-white .navbar-brand .navbar-link.is-active {\n  background-color: #f2f2f2;\n  color: #0a0a0a;\n}\n.navbar.is-white .navbar-brand .navbar-link::after {\n  border-color: #0a0a0a;\n}\n.navbar.is-white .navbar-burger {\n  color: #0a0a0a;\n}\n@media screen and (min-width: 1088px) {\n.navbar.is-white .navbar-start > .navbar-item,\n  .navbar.is-white .navbar-start .navbar-link,\n  .navbar.is-white .navbar-end > .navbar-item,\n  .navbar.is-white .navbar-end .navbar-link {\n    color: #0a0a0a;\n}\n.navbar.is-white .navbar-start > a.navbar-item:hover,\n  .navbar.is-white .navbar-start > a.navbar-item.is-active,\n  .navbar.is-white .navbar-start .navbar-link:hover,\n  .navbar.is-white .navbar-start .navbar-link.is-active,\n  .navbar.is-white .navbar-end > a.navbar-item:hover,\n  .navbar.is-white .navbar-end > a.navbar-item.is-active,\n  .navbar.is-white .navbar-end .navbar-link:hover,\n  .navbar.is-white .navbar-end .navbar-link.is-active {\n    background-color: #f2f2f2;\n    color: #0a0a0a;\n}\n.navbar.is-white .navbar-start .navbar-link::after,\n  .navbar.is-white .navbar-end .navbar-link::after {\n    border-color: #0a0a0a;\n}\n.navbar.is-white .navbar-item.has-dropdown:hover .navbar-link,\n  .navbar.is-white .navbar-item.has-dropdown.is-active .navbar-link {\n    background-color: #f2f2f2;\n    color: #0a0a0a;\n}\n.navbar.is-white .navbar-dropdown a.navbar-item.is-active {\n    background-color: white;\n    color: #0a0a0a;\n}\n}\n.navbar.is-black {\n  background-color: #0a0a0a;\n  color: white;\n}\n.navbar.is-black .navbar-brand > .navbar-item,\n.navbar.is-black .navbar-brand .navbar-link {\n  color: white;\n}\n.navbar.is-black .navbar-brand > a.navbar-item:hover,\n.navbar.is-black .navbar-brand > a.navbar-item.is-active,\n.navbar.is-black .navbar-brand .navbar-link:hover,\n.navbar.is-black .navbar-brand .navbar-link.is-active {\n  background-color: black;\n  color: white;\n}\n.navbar.is-black .navbar-brand .navbar-link::after {\n  border-color: white;\n}\n.navbar.is-black .navbar-burger {\n  color: white;\n}\n@media screen and (min-width: 1088px) {\n.navbar.is-black .navbar-start > .navbar-item,\n  .navbar.is-black .navbar-start .navbar-link,\n  .navbar.is-black .navbar-end > .navbar-item,\n  .navbar.is-black .navbar-end .navbar-link {\n    color: white;\n}\n.navbar.is-black .navbar-start > a.navbar-item:hover,\n  .navbar.is-black .navbar-start > a.navbar-item.is-active,\n  .navbar.is-black .navbar-start .navbar-link:hover,\n  .navbar.is-black .navbar-start .navbar-link.is-active,\n  .navbar.is-black .navbar-end > a.navbar-item:hover,\n  .navbar.is-black .navbar-end > a.navbar-item.is-active,\n  .navbar.is-black .navbar-end .navbar-link:hover,\n  .navbar.is-black .navbar-end .navbar-link.is-active {\n    background-color: black;\n    color: white;\n}\n.navbar.is-black .navbar-start .navbar-link::after,\n  .navbar.is-black .navbar-end .navbar-link::after {\n    border-color: white;\n}\n.navbar.is-black .navbar-item.has-dropdown:hover .navbar-link,\n  .navbar.is-black .navbar-item.has-dropdown.is-active .navbar-link {\n    background-color: black;\n    color: white;\n}\n.navbar.is-black .navbar-dropdown a.navbar-item.is-active {\n    background-color: #0a0a0a;\n    color: white;\n}\n}\n.navbar.is-grey {\n  background-color: #9babb4;\n  color: #fff;\n}\n.navbar.is-grey .navbar-brand > .navbar-item,\n.navbar.is-grey .navbar-brand .navbar-link {\n  color: #fff;\n}\n.navbar.is-grey .navbar-brand > a.navbar-item:hover,\n.navbar.is-grey .navbar-brand > a.navbar-item.is-active,\n.navbar.is-grey .navbar-brand .navbar-link:hover,\n.navbar.is-grey .navbar-brand .navbar-link.is-active {\n  background-color: #8c9fa9;\n  color: #fff;\n}\n.navbar.is-grey .navbar-brand .navbar-link::after {\n  border-color: #fff;\n}\n.navbar.is-grey .navbar-burger {\n  color: #fff;\n}\n@media screen and (min-width: 1088px) {\n.navbar.is-grey .navbar-start > .navbar-item,\n  .navbar.is-grey .navbar-start .navbar-link,\n  .navbar.is-grey .navbar-end > .navbar-item,\n  .navbar.is-grey .navbar-end .navbar-link {\n    color: #fff;\n}\n.navbar.is-grey .navbar-start > a.navbar-item:hover,\n  .navbar.is-grey .navbar-start > a.navbar-item.is-active,\n  .navbar.is-grey .navbar-start .navbar-link:hover,\n  .navbar.is-grey .navbar-start .navbar-link.is-active,\n  .navbar.is-grey .navbar-end > a.navbar-item:hover,\n  .navbar.is-grey .navbar-end > a.navbar-item.is-active,\n  .navbar.is-grey .navbar-end .navbar-link:hover,\n  .navbar.is-grey .navbar-end .navbar-link.is-active {\n    background-color: #8c9fa9;\n    color: #fff;\n}\n.navbar.is-grey .navbar-start .navbar-link::after,\n  .navbar.is-grey .navbar-end .navbar-link::after {\n    border-color: #fff;\n}\n.navbar.is-grey .navbar-item.has-dropdown:hover .navbar-link,\n  .navbar.is-grey .navbar-item.has-dropdown.is-active .navbar-link {\n    background-color: #8c9fa9;\n    color: #fff;\n}\n.navbar.is-grey .navbar-dropdown a.navbar-item.is-active {\n    background-color: #9babb4;\n    color: #fff;\n}\n}\n.navbar.is-blue {\n  background-color: #3b5998;\n  color: #fff;\n}\n.navbar.is-blue .navbar-brand > .navbar-item,\n.navbar.is-blue .navbar-brand .navbar-link {\n  color: #fff;\n}\n.navbar.is-blue .navbar-brand > a.navbar-item:hover,\n.navbar.is-blue .navbar-brand > a.navbar-item.is-active,\n.navbar.is-blue .navbar-brand .navbar-link:hover,\n.navbar.is-blue .navbar-brand .navbar-link.is-active {\n  background-color: #344e86;\n  color: #fff;\n}\n.navbar.is-blue .navbar-brand .navbar-link::after {\n  border-color: #fff;\n}\n.navbar.is-blue .navbar-burger {\n  color: #fff;\n}\n@media screen and (min-width: 1088px) {\n.navbar.is-blue .navbar-start > .navbar-item,\n  .navbar.is-blue .navbar-start .navbar-link,\n  .navbar.is-blue .navbar-end > .navbar-item,\n  .navbar.is-blue .navbar-end .navbar-link {\n    color: #fff;\n}\n.navbar.is-blue .navbar-start > a.navbar-item:hover,\n  .navbar.is-blue .navbar-start > a.navbar-item.is-active,\n  .navbar.is-blue .navbar-start .navbar-link:hover,\n  .navbar.is-blue .navbar-start .navbar-link.is-active,\n  .navbar.is-blue .navbar-end > a.navbar-item:hover,\n  .navbar.is-blue .navbar-end > a.navbar-item.is-active,\n  .navbar.is-blue .navbar-end .navbar-link:hover,\n  .navbar.is-blue .navbar-end .navbar-link.is-active {\n    background-color: #344e86;\n    color: #fff;\n}\n.navbar.is-blue .navbar-start .navbar-link::after,\n  .navbar.is-blue .navbar-end .navbar-link::after {\n    border-color: #fff;\n}\n.navbar.is-blue .navbar-item.has-dropdown:hover .navbar-link,\n  .navbar.is-blue .navbar-item.has-dropdown.is-active .navbar-link {\n    background-color: #344e86;\n    color: #fff;\n}\n.navbar.is-blue .navbar-dropdown a.navbar-item.is-active {\n    background-color: #3b5998;\n    color: #fff;\n}\n}\n.navbar.is-blue-dark {\n  background-color: #3b5998;\n  color: #fff;\n}\n.navbar.is-blue-dark .navbar-brand > .navbar-item,\n.navbar.is-blue-dark .navbar-brand .navbar-link {\n  color: #fff;\n}\n.navbar.is-blue-dark .navbar-brand > a.navbar-item:hover,\n.navbar.is-blue-dark .navbar-brand > a.navbar-item.is-active,\n.navbar.is-blue-dark .navbar-brand .navbar-link:hover,\n.navbar.is-blue-dark .navbar-brand .navbar-link.is-active {\n  background-color: #344e86;\n  color: #fff;\n}\n.navbar.is-blue-dark .navbar-brand .navbar-link::after {\n  border-color: #fff;\n}\n.navbar.is-blue-dark .navbar-burger {\n  color: #fff;\n}\n@media screen and (min-width: 1088px) {\n.navbar.is-blue-dark .navbar-start > .navbar-item,\n  .navbar.is-blue-dark .navbar-start .navbar-link,\n  .navbar.is-blue-dark .navbar-end > .navbar-item,\n  .navbar.is-blue-dark .navbar-end .navbar-link {\n    color: #fff;\n}\n.navbar.is-blue-dark .navbar-start > a.navbar-item:hover,\n  .navbar.is-blue-dark .navbar-start > a.navbar-item.is-active,\n  .navbar.is-blue-dark .navbar-start .navbar-link:hover,\n  .navbar.is-blue-dark .navbar-start .navbar-link.is-active,\n  .navbar.is-blue-dark .navbar-end > a.navbar-item:hover,\n  .navbar.is-blue-dark .navbar-end > a.navbar-item.is-active,\n  .navbar.is-blue-dark .navbar-end .navbar-link:hover,\n  .navbar.is-blue-dark .navbar-end .navbar-link.is-active {\n    background-color: #344e86;\n    color: #fff;\n}\n.navbar.is-blue-dark .navbar-start .navbar-link::after,\n  .navbar.is-blue-dark .navbar-end .navbar-link::after {\n    border-color: #fff;\n}\n.navbar.is-blue-dark .navbar-item.has-dropdown:hover .navbar-link,\n  .navbar.is-blue-dark .navbar-item.has-dropdown.is-active .navbar-link {\n    background-color: #344e86;\n    color: #fff;\n}\n.navbar.is-blue-dark .navbar-dropdown a.navbar-item.is-active {\n    background-color: #3b5998;\n    color: #fff;\n}\n}\n.navbar.is-light {\n  background-color: whitesmoke;\n  color: #363636;\n}\n.navbar.is-light .navbar-brand > .navbar-item,\n.navbar.is-light .navbar-brand .navbar-link {\n  color: #363636;\n}\n.navbar.is-light .navbar-brand > a.navbar-item:hover,\n.navbar.is-light .navbar-brand > a.navbar-item.is-active,\n.navbar.is-light .navbar-brand .navbar-link:hover,\n.navbar.is-light .navbar-brand .navbar-link.is-active {\n  background-color: #e8e8e8;\n  color: #363636;\n}\n.navbar.is-light .navbar-brand .navbar-link::after {\n  border-color: #363636;\n}\n.navbar.is-light .navbar-burger {\n  color: #363636;\n}\n@media screen and (min-width: 1088px) {\n.navbar.is-light .navbar-start > .navbar-item,\n  .navbar.is-light .navbar-start .navbar-link,\n  .navbar.is-light .navbar-end > .navbar-item,\n  .navbar.is-light .navbar-end .navbar-link {\n    color: #363636;\n}\n.navbar.is-light .navbar-start > a.navbar-item:hover,\n  .navbar.is-light .navbar-start > a.navbar-item.is-active,\n  .navbar.is-light .navbar-start .navbar-link:hover,\n  .navbar.is-light .navbar-start .navbar-link.is-active,\n  .navbar.is-light .navbar-end > a.navbar-item:hover,\n  .navbar.is-light .navbar-end > a.navbar-item.is-active,\n  .navbar.is-light .navbar-end .navbar-link:hover,\n  .navbar.is-light .navbar-end .navbar-link.is-active {\n    background-color: #e8e8e8;\n    color: #363636;\n}\n.navbar.is-light .navbar-start .navbar-link::after,\n  .navbar.is-light .navbar-end .navbar-link::after {\n    border-color: #363636;\n}\n.navbar.is-light .navbar-item.has-dropdown:hover .navbar-link,\n  .navbar.is-light .navbar-item.has-dropdown.is-active .navbar-link {\n    background-color: #e8e8e8;\n    color: #363636;\n}\n.navbar.is-light .navbar-dropdown a.navbar-item.is-active {\n    background-color: whitesmoke;\n    color: #363636;\n}\n}\n.navbar.is-dark {\n  background-color: #363636;\n  color: whitesmoke;\n}\n.navbar.is-dark .navbar-brand > .navbar-item,\n.navbar.is-dark .navbar-brand .navbar-link {\n  color: whitesmoke;\n}\n.navbar.is-dark .navbar-brand > a.navbar-item:hover,\n.navbar.is-dark .navbar-brand > a.navbar-item.is-active,\n.navbar.is-dark .navbar-brand .navbar-link:hover,\n.navbar.is-dark .navbar-brand .navbar-link.is-active {\n  background-color: #292929;\n  color: whitesmoke;\n}\n.navbar.is-dark .navbar-brand .navbar-link::after {\n  border-color: whitesmoke;\n}\n.navbar.is-dark .navbar-burger {\n  color: whitesmoke;\n}\n@media screen and (min-width: 1088px) {\n.navbar.is-dark .navbar-start > .navbar-item,\n  .navbar.is-dark .navbar-start .navbar-link,\n  .navbar.is-dark .navbar-end > .navbar-item,\n  .navbar.is-dark .navbar-end .navbar-link {\n    color: whitesmoke;\n}\n.navbar.is-dark .navbar-start > a.navbar-item:hover,\n  .navbar.is-dark .navbar-start > a.navbar-item.is-active,\n  .navbar.is-dark .navbar-start .navbar-link:hover,\n  .navbar.is-dark .navbar-start .navbar-link.is-active,\n  .navbar.is-dark .navbar-end > a.navbar-item:hover,\n  .navbar.is-dark .navbar-end > a.navbar-item.is-active,\n  .navbar.is-dark .navbar-end .navbar-link:hover,\n  .navbar.is-dark .navbar-end .navbar-link.is-active {\n    background-color: #292929;\n    color: whitesmoke;\n}\n.navbar.is-dark .navbar-start .navbar-link::after,\n  .navbar.is-dark .navbar-end .navbar-link::after {\n    border-color: whitesmoke;\n}\n.navbar.is-dark .navbar-item.has-dropdown:hover .navbar-link,\n  .navbar.is-dark .navbar-item.has-dropdown.is-active .navbar-link {\n    background-color: #292929;\n    color: whitesmoke;\n}\n.navbar.is-dark .navbar-dropdown a.navbar-item.is-active {\n    background-color: #363636;\n    color: whitesmoke;\n}\n}\n.navbar.is-primary {\n  background-color: #2196f3;\n  color: #fff;\n}\n.navbar.is-primary .navbar-brand > .navbar-item,\n.navbar.is-primary .navbar-brand .navbar-link {\n  color: #fff;\n}\n.navbar.is-primary .navbar-brand > a.navbar-item:hover,\n.navbar.is-primary .navbar-brand > a.navbar-item.is-active,\n.navbar.is-primary .navbar-brand .navbar-link:hover,\n.navbar.is-primary .navbar-brand .navbar-link.is-active {\n  background-color: #0d8aee;\n  color: #fff;\n}\n.navbar.is-primary .navbar-brand .navbar-link::after {\n  border-color: #fff;\n}\n.navbar.is-primary .navbar-burger {\n  color: #fff;\n}\n@media screen and (min-width: 1088px) {\n.navbar.is-primary .navbar-start > .navbar-item,\n  .navbar.is-primary .navbar-start .navbar-link,\n  .navbar.is-primary .navbar-end > .navbar-item,\n  .navbar.is-primary .navbar-end .navbar-link {\n    color: #fff;\n}\n.navbar.is-primary .navbar-start > a.navbar-item:hover,\n  .navbar.is-primary .navbar-start > a.navbar-item.is-active,\n  .navbar.is-primary .navbar-start .navbar-link:hover,\n  .navbar.is-primary .navbar-start .navbar-link.is-active,\n  .navbar.is-primary .navbar-end > a.navbar-item:hover,\n  .navbar.is-primary .navbar-end > a.navbar-item.is-active,\n  .navbar.is-primary .navbar-end .navbar-link:hover,\n  .navbar.is-primary .navbar-end .navbar-link.is-active {\n    background-color: #0d8aee;\n    color: #fff;\n}\n.navbar.is-primary .navbar-start .navbar-link::after,\n  .navbar.is-primary .navbar-end .navbar-link::after {\n    border-color: #fff;\n}\n.navbar.is-primary .navbar-item.has-dropdown:hover .navbar-link,\n  .navbar.is-primary .navbar-item.has-dropdown.is-active .navbar-link {\n    background-color: #0d8aee;\n    color: #fff;\n}\n.navbar.is-primary .navbar-dropdown a.navbar-item.is-active {\n    background-color: #2196f3;\n    color: #fff;\n}\n}\n.navbar.is-info {\n  background-color: #3b5998;\n  color: #fff;\n}\n.navbar.is-info .navbar-brand > .navbar-item,\n.navbar.is-info .navbar-brand .navbar-link {\n  color: #fff;\n}\n.navbar.is-info .navbar-brand > a.navbar-item:hover,\n.navbar.is-info .navbar-brand > a.navbar-item.is-active,\n.navbar.is-info .navbar-brand .navbar-link:hover,\n.navbar.is-info .navbar-brand .navbar-link.is-active {\n  background-color: #344e86;\n  color: #fff;\n}\n.navbar.is-info .navbar-brand .navbar-link::after {\n  border-color: #fff;\n}\n.navbar.is-info .navbar-burger {\n  color: #fff;\n}\n@media screen and (min-width: 1088px) {\n.navbar.is-info .navbar-start > .navbar-item,\n  .navbar.is-info .navbar-start .navbar-link,\n  .navbar.is-info .navbar-end > .navbar-item,\n  .navbar.is-info .navbar-end .navbar-link {\n    color: #fff;\n}\n.navbar.is-info .navbar-start > a.navbar-item:hover,\n  .navbar.is-info .navbar-start > a.navbar-item.is-active,\n  .navbar.is-info .navbar-start .navbar-link:hover,\n  .navbar.is-info .navbar-start .navbar-link.is-active,\n  .navbar.is-info .navbar-end > a.navbar-item:hover,\n  .navbar.is-info .navbar-end > a.navbar-item.is-active,\n  .navbar.is-info .navbar-end .navbar-link:hover,\n  .navbar.is-info .navbar-end .navbar-link.is-active {\n    background-color: #344e86;\n    color: #fff;\n}\n.navbar.is-info .navbar-start .navbar-link::after,\n  .navbar.is-info .navbar-end .navbar-link::after {\n    border-color: #fff;\n}\n.navbar.is-info .navbar-item.has-dropdown:hover .navbar-link,\n  .navbar.is-info .navbar-item.has-dropdown.is-active .navbar-link {\n    background-color: #344e86;\n    color: #fff;\n}\n.navbar.is-info .navbar-dropdown a.navbar-item.is-active {\n    background-color: #3b5998;\n    color: #fff;\n}\n}\n.navbar.is-success {\n  background-color: #2ab27b;\n  color: #fff;\n}\n.navbar.is-success .navbar-brand > .navbar-item,\n.navbar.is-success .navbar-brand .navbar-link {\n  color: #fff;\n}\n.navbar.is-success .navbar-brand > a.navbar-item:hover,\n.navbar.is-success .navbar-brand > a.navbar-item.is-active,\n.navbar.is-success .navbar-brand .navbar-link:hover,\n.navbar.is-success .navbar-brand .navbar-link.is-active {\n  background-color: #259d6d;\n  color: #fff;\n}\n.navbar.is-success .navbar-brand .navbar-link::after {\n  border-color: #fff;\n}\n.navbar.is-success .navbar-burger {\n  color: #fff;\n}\n@media screen and (min-width: 1088px) {\n.navbar.is-success .navbar-start > .navbar-item,\n  .navbar.is-success .navbar-start .navbar-link,\n  .navbar.is-success .navbar-end > .navbar-item,\n  .navbar.is-success .navbar-end .navbar-link {\n    color: #fff;\n}\n.navbar.is-success .navbar-start > a.navbar-item:hover,\n  .navbar.is-success .navbar-start > a.navbar-item.is-active,\n  .navbar.is-success .navbar-start .navbar-link:hover,\n  .navbar.is-success .navbar-start .navbar-link.is-active,\n  .navbar.is-success .navbar-end > a.navbar-item:hover,\n  .navbar.is-success .navbar-end > a.navbar-item.is-active,\n  .navbar.is-success .navbar-end .navbar-link:hover,\n  .navbar.is-success .navbar-end .navbar-link.is-active {\n    background-color: #259d6d;\n    color: #fff;\n}\n.navbar.is-success .navbar-start .navbar-link::after,\n  .navbar.is-success .navbar-end .navbar-link::after {\n    border-color: #fff;\n}\n.navbar.is-success .navbar-item.has-dropdown:hover .navbar-link,\n  .navbar.is-success .navbar-item.has-dropdown.is-active .navbar-link {\n    background-color: #259d6d;\n    color: #fff;\n}\n.navbar.is-success .navbar-dropdown a.navbar-item.is-active {\n    background-color: #2ab27b;\n    color: #fff;\n}\n}\n.navbar.is-warning {\n  background-color: #ffdd57;\n  color: rgba(0, 0, 0, .7);\n}\n.navbar.is-warning .navbar-brand > .navbar-item,\n.navbar.is-warning .navbar-brand .navbar-link {\n  color: rgba(0, 0, 0, .7);\n}\n.navbar.is-warning .navbar-brand > a.navbar-item:hover,\n.navbar.is-warning .navbar-brand > a.navbar-item.is-active,\n.navbar.is-warning .navbar-brand .navbar-link:hover,\n.navbar.is-warning .navbar-brand .navbar-link.is-active {\n  background-color: #ffd83d;\n  color: rgba(0, 0, 0, .7);\n}\n.navbar.is-warning .navbar-brand .navbar-link::after {\n  border-color: rgba(0, 0, 0, .7);\n}\n.navbar.is-warning .navbar-burger {\n  color: rgba(0, 0, 0, .7);\n}\n@media screen and (min-width: 1088px) {\n.navbar.is-warning .navbar-start > .navbar-item,\n  .navbar.is-warning .navbar-start .navbar-link,\n  .navbar.is-warning .navbar-end > .navbar-item,\n  .navbar.is-warning .navbar-end .navbar-link {\n    color: rgba(0, 0, 0, .7);\n}\n.navbar.is-warning .navbar-start > a.navbar-item:hover,\n  .navbar.is-warning .navbar-start > a.navbar-item.is-active,\n  .navbar.is-warning .navbar-start .navbar-link:hover,\n  .navbar.is-warning .navbar-start .navbar-link.is-active,\n  .navbar.is-warning .navbar-end > a.navbar-item:hover,\n  .navbar.is-warning .navbar-end > a.navbar-item.is-active,\n  .navbar.is-warning .navbar-end .navbar-link:hover,\n  .navbar.is-warning .navbar-end .navbar-link.is-active {\n    background-color: #ffd83d;\n    color: rgba(0, 0, 0, .7);\n}\n.navbar.is-warning .navbar-start .navbar-link::after,\n  .navbar.is-warning .navbar-end .navbar-link::after {\n    border-color: rgba(0, 0, 0, .7);\n}\n.navbar.is-warning .navbar-item.has-dropdown:hover .navbar-link,\n  .navbar.is-warning .navbar-item.has-dropdown.is-active .navbar-link {\n    background-color: #ffd83d;\n    color: rgba(0, 0, 0, .7);\n}\n.navbar.is-warning .navbar-dropdown a.navbar-item.is-active {\n    background-color: #ffdd57;\n    color: rgba(0, 0, 0, .7);\n}\n}\n.navbar.is-danger {\n  background-color: #dc5b5b;\n  color: #fff;\n}\n.navbar.is-danger .navbar-brand > .navbar-item,\n.navbar.is-danger .navbar-brand .navbar-link {\n  color: #fff;\n}\n.navbar.is-danger .navbar-brand > a.navbar-item:hover,\n.navbar.is-danger .navbar-brand > a.navbar-item.is-active,\n.navbar.is-danger .navbar-brand .navbar-link:hover,\n.navbar.is-danger .navbar-brand .navbar-link.is-active {\n  background-color: #d84646;\n  color: #fff;\n}\n.navbar.is-danger .navbar-brand .navbar-link::after {\n  border-color: #fff;\n}\n.navbar.is-danger .navbar-burger {\n  color: #fff;\n}\n@media screen and (min-width: 1088px) {\n.navbar.is-danger .navbar-start > .navbar-item,\n  .navbar.is-danger .navbar-start .navbar-link,\n  .navbar.is-danger .navbar-end > .navbar-item,\n  .navbar.is-danger .navbar-end .navbar-link {\n    color: #fff;\n}\n.navbar.is-danger .navbar-start > a.navbar-item:hover,\n  .navbar.is-danger .navbar-start > a.navbar-item.is-active,\n  .navbar.is-danger .navbar-start .navbar-link:hover,\n  .navbar.is-danger .navbar-start .navbar-link.is-active,\n  .navbar.is-danger .navbar-end > a.navbar-item:hover,\n  .navbar.is-danger .navbar-end > a.navbar-item.is-active,\n  .navbar.is-danger .navbar-end .navbar-link:hover,\n  .navbar.is-danger .navbar-end .navbar-link.is-active {\n    background-color: #d84646;\n    color: #fff;\n}\n.navbar.is-danger .navbar-start .navbar-link::after,\n  .navbar.is-danger .navbar-end .navbar-link::after {\n    border-color: #fff;\n}\n.navbar.is-danger .navbar-item.has-dropdown:hover .navbar-link,\n  .navbar.is-danger .navbar-item.has-dropdown.is-active .navbar-link {\n    background-color: #d84646;\n    color: #fff;\n}\n.navbar.is-danger .navbar-dropdown a.navbar-item.is-active {\n    background-color: #dc5b5b;\n    color: #fff;\n}\n}\n.navbar > .container {\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  min-height: 3.25rem;\n  width: 100%;\n}\n.navbar.has-shadow {\n  -webkit-box-shadow: 0 2px 0 0 whitesmoke;\n          box-shadow: 0 2px 0 0 whitesmoke;\n}\n.navbar.is-fixed-bottom,\n.navbar.is-fixed-top {\n  left: 0;\n  position: fixed;\n  right: 0;\n  z-index: 30;\n}\n.navbar.is-fixed-bottom {\n  bottom: 0;\n}\n.navbar.is-fixed-bottom.has-shadow {\n  -webkit-box-shadow: 0 -2px 0 0 whitesmoke;\n          box-shadow: 0 -2px 0 0 whitesmoke;\n}\n.navbar.is-fixed-top {\n  top: 0;\n}\nhtml.has-navbar-fixed-top,\nbody.has-navbar-fixed-top {\n  padding-top: 3.25rem;\n}\nhtml.has-navbar-fixed-bottom,\nbody.has-navbar-fixed-bottom {\n  padding-bottom: 3.25rem;\n}\n.navbar-brand,\n.navbar-tabs {\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  min-height: 3.25rem;\n}\n.navbar-brand a.navbar-item:hover {\n  background-color: transparent;\n}\n.navbar-tabs {\n  -webkit-overflow-scrolling: touch;\n  max-width: 100vw;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n.navbar-burger {\n  color: #4a4a4a;\n  cursor: pointer;\n  display: block;\n  height: 3.25rem;\n  position: relative;\n  width: 3.25rem;\n  margin-left: auto;\n}\n.navbar-burger span {\n  background-color: currentColor;\n  display: block;\n  height: 1px;\n  left: calc(50% - 8px);\n  position: absolute;\n  -webkit-transform-origin: center;\n          transform-origin: center;\n  -webkit-transition-duration: 86ms;\n          transition-duration: 86ms;\n  -webkit-transition-property: background-color, opacity, -webkit-transform;\n          transition-property: background-color, opacity, -webkit-transform;\n          transition-property: background-color, opacity, transform;\n          transition-property: background-color, opacity, transform, -webkit-transform;\n  -webkit-transition-timing-function: ease-out;\n          transition-timing-function: ease-out;\n  width: 16px;\n}\n.navbar-burger span:nth-child(1) {\n  top: calc(50% - 6px);\n}\n.navbar-burger span:nth-child(2) {\n  top: calc(50% - 1px);\n}\n.navbar-burger span:nth-child(3) {\n  top: calc(50% + 4px);\n}\n.navbar-burger:hover {\n  background-color: rgba(0, 0, 0, .05);\n}\n.navbar-burger.is-active span:nth-child(1) {\n  -webkit-transform: translateY(5px) rotate(45deg);\n          transform: translateY(5px) rotate(45deg);\n}\n.navbar-burger.is-active span:nth-child(2) {\n  opacity: 0;\n}\n.navbar-burger.is-active span:nth-child(3) {\n  -webkit-transform: translateY(-5px) rotate(-45deg);\n          transform: translateY(-5px) rotate(-45deg);\n}\n.navbar-menu {\n  display: none;\n}\n.navbar-item,\n.navbar-link {\n  color: #4a4a4a;\n  display: block;\n  line-height: 1.5;\n  padding: .5rem .75rem;\n  position: relative;\n}\n.navbar-item .icon:only-child,\n.navbar-link .icon:only-child {\n  margin-left: -0.25rem;\n  margin-right: -0.25rem;\n}\na.navbar-item,\n.navbar-link {\n  cursor: pointer;\n}\na.navbar-item:hover,\na.navbar-item.is-active,\n.navbar-link:hover,\n.navbar-link.is-active {\n  background-color: #fafafa;\n  color: #2196f3;\n}\n.navbar-item {\n  display: block;\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n.navbar-item img {\n  max-height: 1.75rem;\n}\n.navbar-item.has-dropdown {\n  padding: 0;\n}\n.navbar-item.is-expanded {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1;\n}\n.navbar-item.is-tab {\n  border-bottom: 1px solid transparent;\n  min-height: 3.25rem;\n  padding-bottom: calc(.5rem - 1px);\n}\n.navbar-item.is-tab:hover {\n  background-color: transparent;\n  border-bottom-color: #2196f3;\n}\n.navbar-item.is-tab.is-active {\n  background-color: transparent;\n  border-bottom-color: #2196f3;\n  border-bottom-style: solid;\n  border-bottom-width: 3px;\n  color: #2196f3;\n  padding-bottom: calc(.5rem - 3px);\n}\n.navbar-content {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1;\n}\n.navbar-link:not(.is-arrowless) {\n  padding-right: 2.5em;\n}\n.navbar-link:not(.is-arrowless)::after {\n  border-color: #2196f3;\n  margin-top: -0.375em;\n  right: 1.125em;\n}\n.navbar-dropdown {\n  font-size: .875rem;\n  padding-bottom: .5rem;\n  padding-top: .5rem;\n}\n.navbar-dropdown .navbar-item {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n.navbar-divider {\n  background-color: whitesmoke;\n  border: none;\n  display: none;\n  height: 2px;\n  margin: .5rem 0;\n}\n@media screen and (max-width: 1087px) {\n.navbar > .container {\n    display: block;\n}\n.navbar-brand .navbar-item,\n  .navbar-tabs .navbar-item {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.navbar-link::after {\n    display: none;\n}\n.navbar-menu {\n    background-color: white;\n    -webkit-box-shadow: 0 8px 16px rgba(10, 10, 10, .1);\n            box-shadow: 0 8px 16px rgba(10, 10, 10, .1);\n    padding: .5rem 0;\n}\n.navbar-menu.is-active {\n    display: block;\n}\n.navbar.is-fixed-bottom-touch,\n  .navbar.is-fixed-top-touch {\n    left: 0;\n    position: fixed;\n    right: 0;\n    z-index: 30;\n}\n.navbar.is-fixed-bottom-touch {\n    bottom: 0;\n}\n.navbar.is-fixed-bottom-touch.has-shadow {\n    -webkit-box-shadow: 0 -2px 3px rgba(10, 10, 10, .1);\n            box-shadow: 0 -2px 3px rgba(10, 10, 10, .1);\n}\n.navbar.is-fixed-top-touch {\n    top: 0;\n}\n.navbar.is-fixed-top .navbar-menu,\n  .navbar.is-fixed-top-touch .navbar-menu {\n    -webkit-overflow-scrolling: touch;\n    max-height: calc(100vh - 3.25rem);\n    overflow: auto;\n}\nhtml.has-navbar-fixed-top-touch,\n  body.has-navbar-fixed-top-touch {\n    padding-top: 3.25rem;\n}\nhtml.has-navbar-fixed-bottom-touch,\n  body.has-navbar-fixed-bottom-touch {\n    padding-bottom: 3.25rem;\n}\n}\n@media screen and (min-width: 1088px) {\n.navbar,\n  .navbar-menu,\n  .navbar-start,\n  .navbar-end {\n    -webkit-box-align: stretch;\n    -ms-flex-align: stretch;\n    align-items: stretch;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.navbar {\n    min-height: 3.25rem;\n}\n.navbar.is-spaced {\n    padding: 1rem 2rem;\n}\n.navbar.is-spaced .navbar-start,\n  .navbar.is-spaced .navbar-end {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n.navbar.is-spaced a.navbar-item,\n  .navbar.is-spaced .navbar-link {\n    border-radius: 4px;\n}\n.navbar.is-transparent a.navbar-item:hover,\n  .navbar.is-transparent a.navbar-item.is-active,\n  .navbar.is-transparent .navbar-link:hover,\n  .navbar.is-transparent .navbar-link.is-active {\n    background-color: transparent !important;\n}\n.navbar.is-transparent .navbar-item.has-dropdown.is-active .navbar-link,\n  .navbar.is-transparent .navbar-item.has-dropdown.is-hoverable:hover .navbar-link {\n    background-color: transparent !important;\n}\n.navbar.is-transparent .navbar-dropdown a.navbar-item:hover {\n    background-color: whitesmoke;\n    color: #0a0a0a;\n}\n.navbar.is-transparent .navbar-dropdown a.navbar-item.is-active {\n    background-color: whitesmoke;\n    color: #2196f3;\n}\n.navbar-burger {\n    display: none;\n}\n.navbar-item,\n  .navbar-link {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.navbar-item {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.navbar-item.has-dropdown {\n    -webkit-box-align: stretch;\n    -ms-flex-align: stretch;\n    align-items: stretch;\n}\n.navbar-item.has-dropdown-up .navbar-link::after {\n    -webkit-transform: rotate(135deg) translate(.25em, -0.25em);\n            transform: rotate(135deg) translate(.25em, -0.25em);\n}\n.navbar-item.has-dropdown-up .navbar-dropdown {\n    border-bottom: 2px solid #dbdbdb;\n    border-radius: 6px 6px 0 0;\n    border-top: none;\n    bottom: 100%;\n    -webkit-box-shadow: 0 -8px 8px rgba(10, 10, 10, .1);\n            box-shadow: 0 -8px 8px rgba(10, 10, 10, .1);\n    top: auto;\n}\n.navbar-item.is-active .navbar-dropdown,\n  .navbar-item.is-hoverable:hover .navbar-dropdown {\n    display: block;\n}\n.navbar.is-spaced .navbar-item.is-active .navbar-dropdown,\n  .navbar-item.is-active .navbar-dropdown.is-boxed,\n  .navbar.is-spaced .navbar-item.is-hoverable:hover .navbar-dropdown,\n  .navbar-item.is-hoverable:hover .navbar-dropdown.is-boxed {\n    opacity: 1;\n    pointer-events: auto;\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n}\n.navbar-menu {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    -ms-flex-negative: 0;\n    flex-shrink: 0;\n}\n.navbar-start {\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    margin-right: auto;\n}\n.navbar-end {\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    justify-content: flex-end;\n    margin-left: auto;\n}\n.navbar-dropdown {\n    background-color: white;\n    border-bottom-left-radius: 6px;\n    border-bottom-right-radius: 6px;\n    border-top: 2px solid #dbdbdb;\n    -webkit-box-shadow: 0 8px 8px rgba(10, 10, 10, .1);\n            box-shadow: 0 8px 8px rgba(10, 10, 10, .1);\n    display: none;\n    font-size: .875rem;\n    left: 0;\n    min-width: 100%;\n    position: absolute;\n    top: 100%;\n    z-index: 20;\n}\n.navbar-dropdown .navbar-item {\n    padding: .375rem 1rem;\n    white-space: nowrap;\n}\n.navbar-dropdown a.navbar-item {\n    padding-right: 3rem;\n}\n.navbar-dropdown a.navbar-item:hover {\n    background-color: whitesmoke;\n    color: #0a0a0a;\n}\n.navbar-dropdown a.navbar-item.is-active {\n    background-color: whitesmoke;\n    color: #2196f3;\n}\n.navbar.is-spaced .navbar-dropdown,\n  .navbar-dropdown.is-boxed {\n    border-radius: 6px;\n    border-top: none;\n    -webkit-box-shadow: 0 8px 8px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);\n            box-shadow: 0 8px 8px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);\n    display: block;\n    opacity: 0;\n    pointer-events: none;\n    top: calc(100% + (-4px));\n    -webkit-transform: translateY(-5px);\n            transform: translateY(-5px);\n    -webkit-transition-duration: 86ms;\n            transition-duration: 86ms;\n    -webkit-transition-property: opacity, -webkit-transform;\n            transition-property: opacity, -webkit-transform;\n            transition-property: opacity, transform;\n            transition-property: opacity, transform, -webkit-transform;\n}\n.navbar-dropdown.is-right {\n    left: auto;\n    right: 0;\n}\n.navbar-divider {\n    display: block;\n}\n.navbar > .container .navbar-brand,\n  .container > .navbar .navbar-brand {\n    margin-left: -.75rem;\n}\n.navbar > .container .navbar-menu,\n  .container > .navbar .navbar-menu {\n    margin-right: -.75rem;\n}\n.navbar.is-fixed-bottom-desktop,\n  .navbar.is-fixed-top-desktop {\n    left: 0;\n    position: fixed;\n    right: 0;\n    z-index: 30;\n}\n.navbar.is-fixed-bottom-desktop {\n    bottom: 0;\n}\n.navbar.is-fixed-bottom-desktop.has-shadow {\n    -webkit-box-shadow: 0 -2px 3px rgba(10, 10, 10, .1);\n            box-shadow: 0 -2px 3px rgba(10, 10, 10, .1);\n}\n.navbar.is-fixed-top-desktop {\n    top: 0;\n}\nhtml.has-navbar-fixed-top-desktop,\n  body.has-navbar-fixed-top-desktop {\n    padding-top: 3.25rem;\n}\nhtml.has-navbar-fixed-bottom-desktop,\n  body.has-navbar-fixed-bottom-desktop {\n    padding-bottom: 3.25rem;\n}\nhtml.has-spaced-navbar-fixed-top,\n  body.has-spaced-navbar-fixed-top {\n    padding-top: 5.25rem;\n}\nhtml.has-spaced-navbar-fixed-bottom,\n  body.has-spaced-navbar-fixed-bottom {\n    padding-bottom: 5.25rem;\n}\na.navbar-item.is-active,\n  .navbar-link.is-active {\n    color: #0a0a0a;\n}\na.navbar-item.is-active:not(:hover),\n  .navbar-link.is-active:not(:hover) {\n    background-color: transparent;\n}\n.navbar-item.has-dropdown:hover .navbar-link,\n  .navbar-item.has-dropdown.is-active .navbar-link {\n    background-color: #fafafa;\n}\n}\n.hero.is-fullheight-with-navbar {\n  min-height: calc(100vh - 3.25rem);\n}\n.pagination {\n  font-size: 1rem;\n  margin: -0.25rem;\n}\n.pagination.is-small {\n  font-size: .75rem;\n}\n.pagination.is-medium {\n  font-size: 1.25rem;\n}\n.pagination.is-large {\n  font-size: 1.5rem;\n}\n.pagination.is-rounded .pagination-previous,\n.pagination.is-rounded .pagination-next {\n  padding-left: 1em;\n  padding-right: 1em;\n  border-radius: 290486px;\n}\n.pagination.is-rounded .pagination-link {\n  border-radius: 290486px;\n}\n.pagination,\n.pagination-list {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  text-align: center;\n}\n.pagination-previous,\n.pagination-next,\n.pagination-link,\n.pagination-ellipsis {\n  font-size: 1em;\n  padding-left: .5em;\n  padding-right: .5em;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  margin: .25rem;\n  text-align: center;\n}\n.pagination-previous,\n.pagination-next,\n.pagination-link {\n  border-color: #dbdbdb;\n  color: #363636;\n  min-width: 2.25em;\n}\n.pagination-previous:hover,\n.pagination-next:hover,\n.pagination-link:hover {\n  border-color: #b5b5b5;\n  color: #363636;\n}\n.pagination-previous:focus,\n.pagination-next:focus,\n.pagination-link:focus {\n  border-color: #2196f3;\n}\n.pagination-previous:active,\n.pagination-next:active,\n.pagination-link:active {\n  -webkit-box-shadow: inset 0 1px 2px rgba(10, 10, 10, .2);\n          box-shadow: inset 0 1px 2px rgba(10, 10, 10, .2);\n}\n.pagination-previous[disabled],\n.pagination-next[disabled],\n.pagination-link[disabled] {\n  background-color: #dbdbdb;\n  border-color: #dbdbdb;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  color: #9babb4;\n  opacity: .5;\n}\n.pagination-previous,\n.pagination-next {\n  padding-left: .75em;\n  padding-right: .75em;\n  white-space: nowrap;\n}\n.pagination-link.is-current {\n  background-color: #2196f3;\n  border-color: #2196f3;\n  color: #fff;\n}\n.pagination-ellipsis {\n  color: #b5b5b5;\n  pointer-events: none;\n}\n.pagination-list {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n@media screen and (max-width: 768px) {\n.pagination {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.pagination-previous,\n  .pagination-next {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    -ms-flex-negative: 1;\n    flex-shrink: 1;\n}\n.pagination-list li {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    -ms-flex-negative: 1;\n    flex-shrink: 1;\n}\n}\n@media screen and (min-width: 769px), print {\n.pagination-list {\n    -webkit-box-flex: 1;\n    -ms-flex-positive: 1;\n    flex-grow: 1;\n    -ms-flex-negative: 1;\n    flex-shrink: 1;\n    -webkit-box-pack: start;\n    -ms-flex-pack: start;\n    justify-content: flex-start;\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n}\n.pagination-previous {\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    order: 2;\n}\n.pagination-next {\n    -webkit-box-ordinal-group: 4;\n    -ms-flex-order: 3;\n    order: 3;\n}\n.pagination {\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n}\n.pagination.is-centered .pagination-previous {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n}\n.pagination.is-centered .pagination-list {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    order: 2;\n}\n.pagination.is-centered .pagination-next {\n    -webkit-box-ordinal-group: 4;\n    -ms-flex-order: 3;\n    order: 3;\n}\n.pagination.is-right .pagination-previous {\n    -webkit-box-ordinal-group: 2;\n    -ms-flex-order: 1;\n    order: 1;\n}\n.pagination.is-right .pagination-next {\n    -webkit-box-ordinal-group: 3;\n    -ms-flex-order: 2;\n    order: 2;\n}\n.pagination.is-right .pagination-list {\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    justify-content: flex-end;\n    -webkit-box-ordinal-group: 4;\n    -ms-flex-order: 3;\n    order: 3;\n}\n}\n.panel {\n  font-size: 1rem;\n}\n.panel:not(:last-child) {\n  margin-bottom: 1.5rem;\n}\n.panel-heading,\n.panel-tabs,\n.panel-block {\n  border-bottom: 1px solid #dbdbdb;\n  border-left: 1px solid #dbdbdb;\n  border-right: 1px solid #dbdbdb;\n}\n.panel-heading:first-child,\n.panel-tabs:first-child,\n.panel-block:first-child {\n  border-top: 1px solid #dbdbdb;\n}\n.panel-heading {\n  background-color: whitesmoke;\n  border-radius: 4px 4px 0 0;\n  color: #363636;\n  font-size: 1.25em;\n  font-weight: 300;\n  line-height: 1.25;\n  padding: .5em .75em;\n}\n.panel-tabs {\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: .875em;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.panel-tabs a {\n  border-bottom: 1px solid #dbdbdb;\n  margin-bottom: -1px;\n  padding: .5em;\n}\n.panel-tabs a.is-active {\n  border-bottom-color: #4a4a4a;\n  color: #363636;\n}\n.panel-list a {\n  color: #4a4a4a;\n}\n.panel-list a:hover {\n  color: #2196f3;\n}\n.panel-block {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  color: #363636;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  padding: .5em .75em;\n}\n.panel-block input[type=\"checkbox\"] {\n  margin-right: .75em;\n}\n.panel-block > .control {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1;\n  width: 100%;\n}\n.panel-block.is-wrapped {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.panel-block.is-active {\n  border-left-color: #2196f3;\n  color: #363636;\n}\n.panel-block.is-active .panel-icon {\n  color: #2196f3;\n}\na.panel-block,\nlabel.panel-block {\n  cursor: pointer;\n}\na.panel-block:hover,\nlabel.panel-block:hover {\n  background-color: whitesmoke;\n}\n.panel-icon {\n  display: inline-block;\n  font-size: 14px;\n  height: 1em;\n  line-height: 1em;\n  text-align: center;\n  vertical-align: top;\n  width: 1em;\n  color: #7a7a7a;\n  margin-right: .75em;\n}\n.panel-icon .fa {\n  font-size: inherit;\n  line-height: inherit;\n}\n.tabs {\n  -webkit-overflow-scrolling: touch;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-size: 1rem;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  overflow: hidden;\n  overflow-x: auto;\n  white-space: nowrap;\n}\n.tabs a {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-bottom-color: #dbdbdb;\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  color: #4a4a4a;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  margin-bottom: -1px;\n  padding: .5em 1em;\n  vertical-align: top;\n}\n.tabs a:hover {\n  border-bottom-color: #363636;\n  color: #363636;\n}\n.tabs li {\n  display: block;\n}\n.tabs li.is-active a {\n  border-bottom-color: #2196f3;\n  color: #2196f3;\n}\n.tabs ul {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  border-bottom-color: #dbdbdb;\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n}\n.tabs ul.is-left {\n  padding-right: .75em;\n}\n.tabs ul.is-center {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  padding-left: .75em;\n  padding-right: .75em;\n}\n.tabs ul.is-right {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  padding-left: .75em;\n}\n.tabs .icon:first-child {\n  margin-right: .5em;\n}\n.tabs .icon:last-child {\n  margin-left: .5em;\n}\n.tabs.is-centered ul {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.tabs.is-right ul {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n.tabs.is-boxed a {\n  border: 1px solid transparent;\n  border-radius: 4px 4px 0 0;\n}\n.tabs.is-boxed a:hover {\n  background-color: whitesmoke;\n  border-bottom-color: #dbdbdb;\n}\n.tabs.is-boxed li.is-active a {\n  background-color: white;\n  border-color: #dbdbdb;\n  border-bottom-color: transparent !important;\n}\n.tabs.is-fullwidth li {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n.tabs.is-toggle a {\n  border-color: #dbdbdb;\n  border-style: solid;\n  border-width: 1px;\n  margin-bottom: 0;\n  position: relative;\n}\n.tabs.is-toggle a:hover {\n  background-color: whitesmoke;\n  border-color: #b5b5b5;\n  z-index: 2;\n}\n.tabs.is-toggle li + li {\n  margin-left: -1px;\n}\n.tabs.is-toggle li:first-child a {\n  border-radius: 4px 0 0 4px;\n}\n.tabs.is-toggle li:last-child a {\n  border-radius: 0 4px 4px 0;\n}\n.tabs.is-toggle li.is-active a {\n  background-color: #2196f3;\n  border-color: #2196f3;\n  color: #fff;\n  z-index: 1;\n}\n.tabs.is-toggle ul {\n  border-bottom: none;\n}\n.tabs.is-toggle.is-toggle-rounded li:first-child a {\n  border-bottom-left-radius: 290486px;\n  border-top-left-radius: 290486px;\n  padding-left: 1.25em;\n}\n.tabs.is-toggle.is-toggle-rounded li:last-child a {\n  border-bottom-right-radius: 290486px;\n  border-top-right-radius: 290486px;\n  padding-right: 1.25em;\n}\n.tabs.is-small {\n  font-size: .75rem;\n}\n.tabs.is-medium {\n  font-size: 1.25rem;\n}\n.tabs.is-large {\n  font-size: 1.5rem;\n}\n.column {\n  display: block;\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1;\n  padding: .75rem;\n}\n.columns.is-mobile > .column.is-narrow {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n}\n.columns.is-mobile > .column.is-full {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 100%;\n}\n.columns.is-mobile > .column.is-three-quarters {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 75%;\n}\n.columns.is-mobile > .column.is-two-thirds {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 66.6666%;\n}\n.columns.is-mobile > .column.is-half {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 50%;\n}\n.columns.is-mobile > .column.is-one-third {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 33.3333%;\n}\n.columns.is-mobile > .column.is-one-quarter {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 25%;\n}\n.columns.is-mobile > .column.is-one-fifth {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 20%;\n}\n.columns.is-mobile > .column.is-two-fifths {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 40%;\n}\n.columns.is-mobile > .column.is-three-fifths {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 60%;\n}\n.columns.is-mobile > .column.is-four-fifths {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 80%;\n}\n.columns.is-mobile > .column.is-offset-three-quarters {\n  margin-left: 75%;\n}\n.columns.is-mobile > .column.is-offset-two-thirds {\n  margin-left: 66.6666%;\n}\n.columns.is-mobile > .column.is-offset-half {\n  margin-left: 50%;\n}\n.columns.is-mobile > .column.is-offset-one-third {\n  margin-left: 33.3333%;\n}\n.columns.is-mobile > .column.is-offset-one-quarter {\n  margin-left: 25%;\n}\n.columns.is-mobile > .column.is-offset-one-fifth {\n  margin-left: 20%;\n}\n.columns.is-mobile > .column.is-offset-two-fifths {\n  margin-left: 40%;\n}\n.columns.is-mobile > .column.is-offset-three-fifths {\n  margin-left: 60%;\n}\n.columns.is-mobile > .column.is-offset-four-fifths {\n  margin-left: 80%;\n}\n.columns.is-mobile > .column.is-1 {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 8.33333%;\n}\n.columns.is-mobile > .column.is-offset-1 {\n  margin-left: 8.33333%;\n}\n.columns.is-mobile > .column.is-2 {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 16.66667%;\n}\n.columns.is-mobile > .column.is-offset-2 {\n  margin-left: 16.66667%;\n}\n.columns.is-mobile > .column.is-3 {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 25%;\n}\n.columns.is-mobile > .column.is-offset-3 {\n  margin-left: 25%;\n}\n.columns.is-mobile > .column.is-4 {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 33.33333%;\n}\n.columns.is-mobile > .column.is-offset-4 {\n  margin-left: 33.33333%;\n}\n.columns.is-mobile > .column.is-5 {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 41.66667%;\n}\n.columns.is-mobile > .column.is-offset-5 {\n  margin-left: 41.66667%;\n}\n.columns.is-mobile > .column.is-6 {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 50%;\n}\n.columns.is-mobile > .column.is-offset-6 {\n  margin-left: 50%;\n}\n.columns.is-mobile > .column.is-7 {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 58.33333%;\n}\n.columns.is-mobile > .column.is-offset-7 {\n  margin-left: 58.33333%;\n}\n.columns.is-mobile > .column.is-8 {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 66.66667%;\n}\n.columns.is-mobile > .column.is-offset-8 {\n  margin-left: 66.66667%;\n}\n.columns.is-mobile > .column.is-9 {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 75%;\n}\n.columns.is-mobile > .column.is-offset-9 {\n  margin-left: 75%;\n}\n.columns.is-mobile > .column.is-10 {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 83.33333%;\n}\n.columns.is-mobile > .column.is-offset-10 {\n  margin-left: 83.33333%;\n}\n.columns.is-mobile > .column.is-11 {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 91.66667%;\n}\n.columns.is-mobile > .column.is-offset-11 {\n  margin-left: 91.66667%;\n}\n.columns.is-mobile > .column.is-12 {\n  -webkit-box-flex: 0;\n  -ms-flex: none;\n      flex: none;\n  width: 100%;\n}\n.columns.is-mobile > .column.is-offset-12 {\n  margin-left: 100%;\n}\n@media screen and (max-width: 768px) {\n.column.is-narrow-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n}\n.column.is-full-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 100%;\n}\n.column.is-three-quarters-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 75%;\n}\n.column.is-two-thirds-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 66.6666%;\n}\n.column.is-half-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 50%;\n}\n.column.is-one-third-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 33.3333%;\n}\n.column.is-one-quarter-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 25%;\n}\n.column.is-one-fifth-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 20%;\n}\n.column.is-two-fifths-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 40%;\n}\n.column.is-three-fifths-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 60%;\n}\n.column.is-four-fifths-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 80%;\n}\n.column.is-offset-three-quarters-mobile {\n    margin-left: 75%;\n}\n.column.is-offset-two-thirds-mobile {\n    margin-left: 66.6666%;\n}\n.column.is-offset-half-mobile {\n    margin-left: 50%;\n}\n.column.is-offset-one-third-mobile {\n    margin-left: 33.3333%;\n}\n.column.is-offset-one-quarter-mobile {\n    margin-left: 25%;\n}\n.column.is-offset-one-fifth-mobile {\n    margin-left: 20%;\n}\n.column.is-offset-two-fifths-mobile {\n    margin-left: 40%;\n}\n.column.is-offset-three-fifths-mobile {\n    margin-left: 60%;\n}\n.column.is-offset-four-fifths-mobile {\n    margin-left: 80%;\n}\n.column.is-1-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 8.33333%;\n}\n.column.is-offset-1-mobile {\n    margin-left: 8.33333%;\n}\n.column.is-2-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 16.66667%;\n}\n.column.is-offset-2-mobile {\n    margin-left: 16.66667%;\n}\n.column.is-3-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 25%;\n}\n.column.is-offset-3-mobile {\n    margin-left: 25%;\n}\n.column.is-4-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 33.33333%;\n}\n.column.is-offset-4-mobile {\n    margin-left: 33.33333%;\n}\n.column.is-5-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 41.66667%;\n}\n.column.is-offset-5-mobile {\n    margin-left: 41.66667%;\n}\n.column.is-6-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 50%;\n}\n.column.is-offset-6-mobile {\n    margin-left: 50%;\n}\n.column.is-7-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 58.33333%;\n}\n.column.is-offset-7-mobile {\n    margin-left: 58.33333%;\n}\n.column.is-8-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 66.66667%;\n}\n.column.is-offset-8-mobile {\n    margin-left: 66.66667%;\n}\n.column.is-9-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 75%;\n}\n.column.is-offset-9-mobile {\n    margin-left: 75%;\n}\n.column.is-10-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 83.33333%;\n}\n.column.is-offset-10-mobile {\n    margin-left: 83.33333%;\n}\n.column.is-11-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 91.66667%;\n}\n.column.is-offset-11-mobile {\n    margin-left: 91.66667%;\n}\n.column.is-12-mobile {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 100%;\n}\n.column.is-offset-12-mobile {\n    margin-left: 100%;\n}\n}\n@media screen and (min-width: 769px), print {\n.column.is-narrow,\n  .column.is-narrow-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n}\n.column.is-full,\n  .column.is-full-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 100%;\n}\n.column.is-three-quarters,\n  .column.is-three-quarters-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 75%;\n}\n.column.is-two-thirds,\n  .column.is-two-thirds-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 66.6666%;\n}\n.column.is-half,\n  .column.is-half-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 50%;\n}\n.column.is-one-third,\n  .column.is-one-third-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 33.3333%;\n}\n.column.is-one-quarter,\n  .column.is-one-quarter-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 25%;\n}\n.column.is-one-fifth,\n  .column.is-one-fifth-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 20%;\n}\n.column.is-two-fifths,\n  .column.is-two-fifths-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 40%;\n}\n.column.is-three-fifths,\n  .column.is-three-fifths-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 60%;\n}\n.column.is-four-fifths,\n  .column.is-four-fifths-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 80%;\n}\n.column.is-offset-three-quarters,\n  .column.is-offset-three-quarters-tablet {\n    margin-left: 75%;\n}\n.column.is-offset-two-thirds,\n  .column.is-offset-two-thirds-tablet {\n    margin-left: 66.6666%;\n}\n.column.is-offset-half,\n  .column.is-offset-half-tablet {\n    margin-left: 50%;\n}\n.column.is-offset-one-third,\n  .column.is-offset-one-third-tablet {\n    margin-left: 33.3333%;\n}\n.column.is-offset-one-quarter,\n  .column.is-offset-one-quarter-tablet {\n    margin-left: 25%;\n}\n.column.is-offset-one-fifth,\n  .column.is-offset-one-fifth-tablet {\n    margin-left: 20%;\n}\n.column.is-offset-two-fifths,\n  .column.is-offset-two-fifths-tablet {\n    margin-left: 40%;\n}\n.column.is-offset-three-fifths,\n  .column.is-offset-three-fifths-tablet {\n    margin-left: 60%;\n}\n.column.is-offset-four-fifths,\n  .column.is-offset-four-fifths-tablet {\n    margin-left: 80%;\n}\n.column.is-1,\n  .column.is-1-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 8.33333%;\n}\n.column.is-offset-1,\n  .column.is-offset-1-tablet {\n    margin-left: 8.33333%;\n}\n.column.is-2,\n  .column.is-2-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 16.66667%;\n}\n.column.is-offset-2,\n  .column.is-offset-2-tablet {\n    margin-left: 16.66667%;\n}\n.column.is-3,\n  .column.is-3-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 25%;\n}\n.column.is-offset-3,\n  .column.is-offset-3-tablet {\n    margin-left: 25%;\n}\n.column.is-4,\n  .column.is-4-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 33.33333%;\n}\n.column.is-offset-4,\n  .column.is-offset-4-tablet {\n    margin-left: 33.33333%;\n}\n.column.is-5,\n  .column.is-5-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 41.66667%;\n}\n.column.is-offset-5,\n  .column.is-offset-5-tablet {\n    margin-left: 41.66667%;\n}\n.column.is-6,\n  .column.is-6-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 50%;\n}\n.column.is-offset-6,\n  .column.is-offset-6-tablet {\n    margin-left: 50%;\n}\n.column.is-7,\n  .column.is-7-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 58.33333%;\n}\n.column.is-offset-7,\n  .column.is-offset-7-tablet {\n    margin-left: 58.33333%;\n}\n.column.is-8,\n  .column.is-8-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 66.66667%;\n}\n.column.is-offset-8,\n  .column.is-offset-8-tablet {\n    margin-left: 66.66667%;\n}\n.column.is-9,\n  .column.is-9-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 75%;\n}\n.column.is-offset-9,\n  .column.is-offset-9-tablet {\n    margin-left: 75%;\n}\n.column.is-10,\n  .column.is-10-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 83.33333%;\n}\n.column.is-offset-10,\n  .column.is-offset-10-tablet {\n    margin-left: 83.33333%;\n}\n.column.is-11,\n  .column.is-11-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 91.66667%;\n}\n.column.is-offset-11,\n  .column.is-offset-11-tablet {\n    margin-left: 91.66667%;\n}\n.column.is-12,\n  .column.is-12-tablet {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 100%;\n}\n.column.is-offset-12,\n  .column.is-offset-12-tablet {\n    margin-left: 100%;\n}\n}\n@media screen and (max-width: 1087px) {\n.column.is-narrow-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n}\n.column.is-full-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 100%;\n}\n.column.is-three-quarters-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 75%;\n}\n.column.is-two-thirds-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 66.6666%;\n}\n.column.is-half-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 50%;\n}\n.column.is-one-third-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 33.3333%;\n}\n.column.is-one-quarter-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 25%;\n}\n.column.is-one-fifth-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 20%;\n}\n.column.is-two-fifths-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 40%;\n}\n.column.is-three-fifths-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 60%;\n}\n.column.is-four-fifths-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 80%;\n}\n.column.is-offset-three-quarters-touch {\n    margin-left: 75%;\n}\n.column.is-offset-two-thirds-touch {\n    margin-left: 66.6666%;\n}\n.column.is-offset-half-touch {\n    margin-left: 50%;\n}\n.column.is-offset-one-third-touch {\n    margin-left: 33.3333%;\n}\n.column.is-offset-one-quarter-touch {\n    margin-left: 25%;\n}\n.column.is-offset-one-fifth-touch {\n    margin-left: 20%;\n}\n.column.is-offset-two-fifths-touch {\n    margin-left: 40%;\n}\n.column.is-offset-three-fifths-touch {\n    margin-left: 60%;\n}\n.column.is-offset-four-fifths-touch {\n    margin-left: 80%;\n}\n.column.is-1-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 8.33333%;\n}\n.column.is-offset-1-touch {\n    margin-left: 8.33333%;\n}\n.column.is-2-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 16.66667%;\n}\n.column.is-offset-2-touch {\n    margin-left: 16.66667%;\n}\n.column.is-3-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 25%;\n}\n.column.is-offset-3-touch {\n    margin-left: 25%;\n}\n.column.is-4-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 33.33333%;\n}\n.column.is-offset-4-touch {\n    margin-left: 33.33333%;\n}\n.column.is-5-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 41.66667%;\n}\n.column.is-offset-5-touch {\n    margin-left: 41.66667%;\n}\n.column.is-6-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 50%;\n}\n.column.is-offset-6-touch {\n    margin-left: 50%;\n}\n.column.is-7-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 58.33333%;\n}\n.column.is-offset-7-touch {\n    margin-left: 58.33333%;\n}\n.column.is-8-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 66.66667%;\n}\n.column.is-offset-8-touch {\n    margin-left: 66.66667%;\n}\n.column.is-9-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 75%;\n}\n.column.is-offset-9-touch {\n    margin-left: 75%;\n}\n.column.is-10-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 83.33333%;\n}\n.column.is-offset-10-touch {\n    margin-left: 83.33333%;\n}\n.column.is-11-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 91.66667%;\n}\n.column.is-offset-11-touch {\n    margin-left: 91.66667%;\n}\n.column.is-12-touch {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 100%;\n}\n.column.is-offset-12-touch {\n    margin-left: 100%;\n}\n}\n@media screen and (min-width: 1088px) {\n.column.is-narrow-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n}\n.column.is-full-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 100%;\n}\n.column.is-three-quarters-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 75%;\n}\n.column.is-two-thirds-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 66.6666%;\n}\n.column.is-half-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 50%;\n}\n.column.is-one-third-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 33.3333%;\n}\n.column.is-one-quarter-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 25%;\n}\n.column.is-one-fifth-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 20%;\n}\n.column.is-two-fifths-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 40%;\n}\n.column.is-three-fifths-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 60%;\n}\n.column.is-four-fifths-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 80%;\n}\n.column.is-offset-three-quarters-desktop {\n    margin-left: 75%;\n}\n.column.is-offset-two-thirds-desktop {\n    margin-left: 66.6666%;\n}\n.column.is-offset-half-desktop {\n    margin-left: 50%;\n}\n.column.is-offset-one-third-desktop {\n    margin-left: 33.3333%;\n}\n.column.is-offset-one-quarter-desktop {\n    margin-left: 25%;\n}\n.column.is-offset-one-fifth-desktop {\n    margin-left: 20%;\n}\n.column.is-offset-two-fifths-desktop {\n    margin-left: 40%;\n}\n.column.is-offset-three-fifths-desktop {\n    margin-left: 60%;\n}\n.column.is-offset-four-fifths-desktop {\n    margin-left: 80%;\n}\n.column.is-1-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 8.33333%;\n}\n.column.is-offset-1-desktop {\n    margin-left: 8.33333%;\n}\n.column.is-2-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 16.66667%;\n}\n.column.is-offset-2-desktop {\n    margin-left: 16.66667%;\n}\n.column.is-3-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 25%;\n}\n.column.is-offset-3-desktop {\n    margin-left: 25%;\n}\n.column.is-4-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 33.33333%;\n}\n.column.is-offset-4-desktop {\n    margin-left: 33.33333%;\n}\n.column.is-5-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 41.66667%;\n}\n.column.is-offset-5-desktop {\n    margin-left: 41.66667%;\n}\n.column.is-6-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 50%;\n}\n.column.is-offset-6-desktop {\n    margin-left: 50%;\n}\n.column.is-7-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 58.33333%;\n}\n.column.is-offset-7-desktop {\n    margin-left: 58.33333%;\n}\n.column.is-8-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 66.66667%;\n}\n.column.is-offset-8-desktop {\n    margin-left: 66.66667%;\n}\n.column.is-9-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 75%;\n}\n.column.is-offset-9-desktop {\n    margin-left: 75%;\n}\n.column.is-10-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 83.33333%;\n}\n.column.is-offset-10-desktop {\n    margin-left: 83.33333%;\n}\n.column.is-11-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 91.66667%;\n}\n.column.is-offset-11-desktop {\n    margin-left: 91.66667%;\n}\n.column.is-12-desktop {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 100%;\n}\n.column.is-offset-12-desktop {\n    margin-left: 100%;\n}\n}\n@media screen and (min-width: 1280px) {\n.column.is-narrow-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n}\n.column.is-full-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 100%;\n}\n.column.is-three-quarters-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 75%;\n}\n.column.is-two-thirds-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 66.6666%;\n}\n.column.is-half-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 50%;\n}\n.column.is-one-third-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 33.3333%;\n}\n.column.is-one-quarter-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 25%;\n}\n.column.is-one-fifth-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 20%;\n}\n.column.is-two-fifths-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 40%;\n}\n.column.is-three-fifths-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 60%;\n}\n.column.is-four-fifths-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 80%;\n}\n.column.is-offset-three-quarters-widescreen {\n    margin-left: 75%;\n}\n.column.is-offset-two-thirds-widescreen {\n    margin-left: 66.6666%;\n}\n.column.is-offset-half-widescreen {\n    margin-left: 50%;\n}\n.column.is-offset-one-third-widescreen {\n    margin-left: 33.3333%;\n}\n.column.is-offset-one-quarter-widescreen {\n    margin-left: 25%;\n}\n.column.is-offset-one-fifth-widescreen {\n    margin-left: 20%;\n}\n.column.is-offset-two-fifths-widescreen {\n    margin-left: 40%;\n}\n.column.is-offset-three-fifths-widescreen {\n    margin-left: 60%;\n}\n.column.is-offset-four-fifths-widescreen {\n    margin-left: 80%;\n}\n.column.is-1-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 8.33333%;\n}\n.column.is-offset-1-widescreen {\n    margin-left: 8.33333%;\n}\n.column.is-2-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 16.66667%;\n}\n.column.is-offset-2-widescreen {\n    margin-left: 16.66667%;\n}\n.column.is-3-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 25%;\n}\n.column.is-offset-3-widescreen {\n    margin-left: 25%;\n}\n.column.is-4-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 33.33333%;\n}\n.column.is-offset-4-widescreen {\n    margin-left: 33.33333%;\n}\n.column.is-5-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 41.66667%;\n}\n.column.is-offset-5-widescreen {\n    margin-left: 41.66667%;\n}\n.column.is-6-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 50%;\n}\n.column.is-offset-6-widescreen {\n    margin-left: 50%;\n}\n.column.is-7-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 58.33333%;\n}\n.column.is-offset-7-widescreen {\n    margin-left: 58.33333%;\n}\n.column.is-8-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 66.66667%;\n}\n.column.is-offset-8-widescreen {\n    margin-left: 66.66667%;\n}\n.column.is-9-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 75%;\n}\n.column.is-offset-9-widescreen {\n    margin-left: 75%;\n}\n.column.is-10-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 83.33333%;\n}\n.column.is-offset-10-widescreen {\n    margin-left: 83.33333%;\n}\n.column.is-11-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 91.66667%;\n}\n.column.is-offset-11-widescreen {\n    margin-left: 91.66667%;\n}\n.column.is-12-widescreen {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 100%;\n}\n.column.is-offset-12-widescreen {\n    margin-left: 100%;\n}\n}\n@media screen and (min-width: 1280px) {\n.column.is-narrow-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n}\n.column.is-full-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 100%;\n}\n.column.is-three-quarters-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 75%;\n}\n.column.is-two-thirds-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 66.6666%;\n}\n.column.is-half-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 50%;\n}\n.column.is-one-third-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 33.3333%;\n}\n.column.is-one-quarter-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 25%;\n}\n.column.is-one-fifth-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 20%;\n}\n.column.is-two-fifths-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 40%;\n}\n.column.is-three-fifths-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 60%;\n}\n.column.is-four-fifths-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 80%;\n}\n.column.is-offset-three-quarters-fullhd {\n    margin-left: 75%;\n}\n.column.is-offset-two-thirds-fullhd {\n    margin-left: 66.6666%;\n}\n.column.is-offset-half-fullhd {\n    margin-left: 50%;\n}\n.column.is-offset-one-third-fullhd {\n    margin-left: 33.3333%;\n}\n.column.is-offset-one-quarter-fullhd {\n    margin-left: 25%;\n}\n.column.is-offset-one-fifth-fullhd {\n    margin-left: 20%;\n}\n.column.is-offset-two-fifths-fullhd {\n    margin-left: 40%;\n}\n.column.is-offset-three-fifths-fullhd {\n    margin-left: 60%;\n}\n.column.is-offset-four-fifths-fullhd {\n    margin-left: 80%;\n}\n.column.is-1-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 8.33333%;\n}\n.column.is-offset-1-fullhd {\n    margin-left: 8.33333%;\n}\n.column.is-2-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 16.66667%;\n}\n.column.is-offset-2-fullhd {\n    margin-left: 16.66667%;\n}\n.column.is-3-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 25%;\n}\n.column.is-offset-3-fullhd {\n    margin-left: 25%;\n}\n.column.is-4-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 33.33333%;\n}\n.column.is-offset-4-fullhd {\n    margin-left: 33.33333%;\n}\n.column.is-5-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 41.66667%;\n}\n.column.is-offset-5-fullhd {\n    margin-left: 41.66667%;\n}\n.column.is-6-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 50%;\n}\n.column.is-offset-6-fullhd {\n    margin-left: 50%;\n}\n.column.is-7-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 58.33333%;\n}\n.column.is-offset-7-fullhd {\n    margin-left: 58.33333%;\n}\n.column.is-8-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 66.66667%;\n}\n.column.is-offset-8-fullhd {\n    margin-left: 66.66667%;\n}\n.column.is-9-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 75%;\n}\n.column.is-offset-9-fullhd {\n    margin-left: 75%;\n}\n.column.is-10-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 83.33333%;\n}\n.column.is-offset-10-fullhd {\n    margin-left: 83.33333%;\n}\n.column.is-11-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 91.66667%;\n}\n.column.is-offset-11-fullhd {\n    margin-left: 91.66667%;\n}\n.column.is-12-fullhd {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 100%;\n}\n.column.is-offset-12-fullhd {\n    margin-left: 100%;\n}\n}\n.columns {\n  margin-left: -0.75rem;\n  margin-right: -0.75rem;\n  margin-top: -0.75rem;\n}\n.columns:last-child {\n  margin-bottom: -0.75rem;\n}\n.columns:not(:last-child) {\n  margin-bottom: calc(1.5rem - .75rem);\n}\n.columns.is-centered {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.columns.is-gapless {\n  margin-left: 0;\n  margin-right: 0;\n  margin-top: 0;\n}\n.columns.is-gapless > .column {\n  margin: 0;\n  padding: 0 !important;\n}\n.columns.is-gapless:not(:last-child) {\n  margin-bottom: 1.5rem;\n}\n.columns.is-gapless:last-child {\n  margin-bottom: 0;\n}\n.columns.is-mobile {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.columns.is-multiline {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.columns.is-vcentered {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n@media screen and (min-width: 769px), print {\n.columns:not(.is-desktop) {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n}\n@media screen and (min-width: 1088px) {\n.columns.is-desktop {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n}\n.columns.is-variable {\n  --columnGap: .75rem;\n  margin-left: calc(-1 * var(--columnGap));\n  margin-right: calc(-1 * var(--columnGap));\n}\n.columns.is-variable .column {\n  padding-left: var(--columnGap);\n  padding-right: var(--columnGap);\n}\n.columns.is-variable.is-0 {\n  --columnGap: 0;\n}\n@media screen and (max-width: 768px) {\n.columns.is-variable.is-0-mobile {\n    --columnGap: 0;\n}\n}\n@media screen and (min-width: 769px), print {\n.columns.is-variable.is-0-tablet {\n    --columnGap: 0;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.columns.is-variable.is-0-tablet-only {\n    --columnGap: 0;\n}\n}\n@media screen and (max-width: 1087px) {\n.columns.is-variable.is-0-touch {\n    --columnGap: 0;\n}\n}\n@media screen and (min-width: 1088px) {\n.columns.is-variable.is-0-desktop {\n    --columnGap: 0;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.columns.is-variable.is-0-desktop-only {\n    --columnGap: 0;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-0-widescreen {\n    --columnGap: 0;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.columns.is-variable.is-0-widescreen-only {\n    --columnGap: 0;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-0-fullhd {\n    --columnGap: 0;\n}\n}\n.columns.is-variable.is-1 {\n  --columnGap: .25rem;\n}\n@media screen and (max-width: 768px) {\n.columns.is-variable.is-1-mobile {\n    --columnGap: .25rem;\n}\n}\n@media screen and (min-width: 769px), print {\n.columns.is-variable.is-1-tablet {\n    --columnGap: .25rem;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.columns.is-variable.is-1-tablet-only {\n    --columnGap: .25rem;\n}\n}\n@media screen and (max-width: 1087px) {\n.columns.is-variable.is-1-touch {\n    --columnGap: .25rem;\n}\n}\n@media screen and (min-width: 1088px) {\n.columns.is-variable.is-1-desktop {\n    --columnGap: .25rem;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.columns.is-variable.is-1-desktop-only {\n    --columnGap: .25rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-1-widescreen {\n    --columnGap: .25rem;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.columns.is-variable.is-1-widescreen-only {\n    --columnGap: .25rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-1-fullhd {\n    --columnGap: .25rem;\n}\n}\n.columns.is-variable.is-2 {\n  --columnGap: .5rem;\n}\n@media screen and (max-width: 768px) {\n.columns.is-variable.is-2-mobile {\n    --columnGap: .5rem;\n}\n}\n@media screen and (min-width: 769px), print {\n.columns.is-variable.is-2-tablet {\n    --columnGap: .5rem;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.columns.is-variable.is-2-tablet-only {\n    --columnGap: .5rem;\n}\n}\n@media screen and (max-width: 1087px) {\n.columns.is-variable.is-2-touch {\n    --columnGap: .5rem;\n}\n}\n@media screen and (min-width: 1088px) {\n.columns.is-variable.is-2-desktop {\n    --columnGap: .5rem;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.columns.is-variable.is-2-desktop-only {\n    --columnGap: .5rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-2-widescreen {\n    --columnGap: .5rem;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.columns.is-variable.is-2-widescreen-only {\n    --columnGap: .5rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-2-fullhd {\n    --columnGap: .5rem;\n}\n}\n.columns.is-variable.is-3 {\n  --columnGap: .75rem;\n}\n@media screen and (max-width: 768px) {\n.columns.is-variable.is-3-mobile {\n    --columnGap: .75rem;\n}\n}\n@media screen and (min-width: 769px), print {\n.columns.is-variable.is-3-tablet {\n    --columnGap: .75rem;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.columns.is-variable.is-3-tablet-only {\n    --columnGap: .75rem;\n}\n}\n@media screen and (max-width: 1087px) {\n.columns.is-variable.is-3-touch {\n    --columnGap: .75rem;\n}\n}\n@media screen and (min-width: 1088px) {\n.columns.is-variable.is-3-desktop {\n    --columnGap: .75rem;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.columns.is-variable.is-3-desktop-only {\n    --columnGap: .75rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-3-widescreen {\n    --columnGap: .75rem;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.columns.is-variable.is-3-widescreen-only {\n    --columnGap: .75rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-3-fullhd {\n    --columnGap: .75rem;\n}\n}\n.columns.is-variable.is-4 {\n  --columnGap: 1rem;\n}\n@media screen and (max-width: 768px) {\n.columns.is-variable.is-4-mobile {\n    --columnGap: 1rem;\n}\n}\n@media screen and (min-width: 769px), print {\n.columns.is-variable.is-4-tablet {\n    --columnGap: 1rem;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.columns.is-variable.is-4-tablet-only {\n    --columnGap: 1rem;\n}\n}\n@media screen and (max-width: 1087px) {\n.columns.is-variable.is-4-touch {\n    --columnGap: 1rem;\n}\n}\n@media screen and (min-width: 1088px) {\n.columns.is-variable.is-4-desktop {\n    --columnGap: 1rem;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.columns.is-variable.is-4-desktop-only {\n    --columnGap: 1rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-4-widescreen {\n    --columnGap: 1rem;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.columns.is-variable.is-4-widescreen-only {\n    --columnGap: 1rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-4-fullhd {\n    --columnGap: 1rem;\n}\n}\n.columns.is-variable.is-5 {\n  --columnGap: 1.25rem;\n}\n@media screen and (max-width: 768px) {\n.columns.is-variable.is-5-mobile {\n    --columnGap: 1.25rem;\n}\n}\n@media screen and (min-width: 769px), print {\n.columns.is-variable.is-5-tablet {\n    --columnGap: 1.25rem;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.columns.is-variable.is-5-tablet-only {\n    --columnGap: 1.25rem;\n}\n}\n@media screen and (max-width: 1087px) {\n.columns.is-variable.is-5-touch {\n    --columnGap: 1.25rem;\n}\n}\n@media screen and (min-width: 1088px) {\n.columns.is-variable.is-5-desktop {\n    --columnGap: 1.25rem;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.columns.is-variable.is-5-desktop-only {\n    --columnGap: 1.25rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-5-widescreen {\n    --columnGap: 1.25rem;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.columns.is-variable.is-5-widescreen-only {\n    --columnGap: 1.25rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-5-fullhd {\n    --columnGap: 1.25rem;\n}\n}\n.columns.is-variable.is-6 {\n  --columnGap: 1.5rem;\n}\n@media screen and (max-width: 768px) {\n.columns.is-variable.is-6-mobile {\n    --columnGap: 1.5rem;\n}\n}\n@media screen and (min-width: 769px), print {\n.columns.is-variable.is-6-tablet {\n    --columnGap: 1.5rem;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.columns.is-variable.is-6-tablet-only {\n    --columnGap: 1.5rem;\n}\n}\n@media screen and (max-width: 1087px) {\n.columns.is-variable.is-6-touch {\n    --columnGap: 1.5rem;\n}\n}\n@media screen and (min-width: 1088px) {\n.columns.is-variable.is-6-desktop {\n    --columnGap: 1.5rem;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.columns.is-variable.is-6-desktop-only {\n    --columnGap: 1.5rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-6-widescreen {\n    --columnGap: 1.5rem;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.columns.is-variable.is-6-widescreen-only {\n    --columnGap: 1.5rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-6-fullhd {\n    --columnGap: 1.5rem;\n}\n}\n.columns.is-variable.is-7 {\n  --columnGap: 1.75rem;\n}\n@media screen and (max-width: 768px) {\n.columns.is-variable.is-7-mobile {\n    --columnGap: 1.75rem;\n}\n}\n@media screen and (min-width: 769px), print {\n.columns.is-variable.is-7-tablet {\n    --columnGap: 1.75rem;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.columns.is-variable.is-7-tablet-only {\n    --columnGap: 1.75rem;\n}\n}\n@media screen and (max-width: 1087px) {\n.columns.is-variable.is-7-touch {\n    --columnGap: 1.75rem;\n}\n}\n@media screen and (min-width: 1088px) {\n.columns.is-variable.is-7-desktop {\n    --columnGap: 1.75rem;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.columns.is-variable.is-7-desktop-only {\n    --columnGap: 1.75rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-7-widescreen {\n    --columnGap: 1.75rem;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.columns.is-variable.is-7-widescreen-only {\n    --columnGap: 1.75rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-7-fullhd {\n    --columnGap: 1.75rem;\n}\n}\n.columns.is-variable.is-8 {\n  --columnGap: 2rem;\n}\n@media screen and (max-width: 768px) {\n.columns.is-variable.is-8-mobile {\n    --columnGap: 2rem;\n}\n}\n@media screen and (min-width: 769px), print {\n.columns.is-variable.is-8-tablet {\n    --columnGap: 2rem;\n}\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.columns.is-variable.is-8-tablet-only {\n    --columnGap: 2rem;\n}\n}\n@media screen and (max-width: 1087px) {\n.columns.is-variable.is-8-touch {\n    --columnGap: 2rem;\n}\n}\n@media screen and (min-width: 1088px) {\n.columns.is-variable.is-8-desktop {\n    --columnGap: 2rem;\n}\n}\n@media screen and (min-width: 1088px) and (max-width: 1279px) {\n.columns.is-variable.is-8-desktop-only {\n    --columnGap: 2rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-8-widescreen {\n    --columnGap: 2rem;\n}\n}\n@media screen and (min-width: 1280px) and (max-width: 1279px) {\n.columns.is-variable.is-8-widescreen-only {\n    --columnGap: 2rem;\n}\n}\n@media screen and (min-width: 1280px) {\n.columns.is-variable.is-8-fullhd {\n    --columnGap: 2rem;\n}\n}\n.tile {\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  display: block;\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1;\n  min-height: -webkit-min-content;\n  min-height: -moz-min-content;\n  min-height: min-content;\n}\n.tile.is-ancestor {\n  margin-left: -0.75rem;\n  margin-right: -0.75rem;\n  margin-top: -0.75rem;\n}\n.tile.is-ancestor:last-child {\n  margin-bottom: -0.75rem;\n}\n.tile.is-ancestor:not(:last-child) {\n  margin-bottom: .75rem;\n}\n.tile.is-child {\n  margin: 0 !important;\n}\n.tile.is-parent {\n  padding: .75rem;\n}\n.tile.is-vertical {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.tile.is-vertical > .tile.is-child:not(:last-child) {\n  margin-bottom: 1.5rem !important;\n}\n@media screen and (min-width: 769px), print {\n.tile:not(.is-child) {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.tile.is-1 {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 8.33333%;\n}\n.tile.is-2 {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 16.66667%;\n}\n.tile.is-3 {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 25%;\n}\n.tile.is-4 {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 33.33333%;\n}\n.tile.is-5 {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 41.66667%;\n}\n.tile.is-6 {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 50%;\n}\n.tile.is-7 {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 58.33333%;\n}\n.tile.is-8 {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 66.66667%;\n}\n.tile.is-9 {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 75%;\n}\n.tile.is-10 {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 83.33333%;\n}\n.tile.is-11 {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 91.66667%;\n}\n.tile.is-12 {\n    -webkit-box-flex: 0;\n    -ms-flex: none;\n        flex: none;\n    width: 100%;\n}\n}\n.hero {\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.hero .navbar {\n  background: none;\n}\n.hero .tabs ul {\n  border-bottom: none;\n}\n.hero.is-white {\n  background-color: white;\n  color: #0a0a0a;\n}\n.hero.is-white a:not(.button):not(.dropdown-item):not(.tag),\n.hero.is-white strong {\n  color: inherit;\n}\n.hero.is-white .title {\n  color: #0a0a0a;\n}\n.hero.is-white .subtitle {\n  color: rgba(10, 10, 10, .9);\n}\n.hero.is-white .subtitle a:not(.button),\n.hero.is-white .subtitle strong {\n  color: #0a0a0a;\n}\n@media screen and (max-width: 1087px) {\n.hero.is-white .navbar-menu {\n    background-color: white;\n}\n}\n.hero.is-white .navbar-item,\n.hero.is-white .navbar-link {\n  color: rgba(10, 10, 10, .7);\n}\n.hero.is-white a.navbar-item:hover,\n.hero.is-white a.navbar-item.is-active,\n.hero.is-white .navbar-link:hover,\n.hero.is-white .navbar-link.is-active {\n  background-color: #f2f2f2;\n  color: #0a0a0a;\n}\n.hero.is-white .tabs a {\n  color: #0a0a0a;\n  opacity: .9;\n}\n.hero.is-white .tabs a:hover {\n  opacity: 1;\n}\n.hero.is-white .tabs li.is-active a {\n  opacity: 1;\n}\n.hero.is-white .tabs.is-boxed a,\n.hero.is-white .tabs.is-toggle a {\n  color: #0a0a0a;\n}\n.hero.is-white .tabs.is-boxed a:hover,\n.hero.is-white .tabs.is-toggle a:hover {\n  background-color: rgba(10, 10, 10, .1);\n}\n.hero.is-white .tabs.is-boxed li.is-active a,\n.hero.is-white .tabs.is-boxed li.is-active a:hover,\n.hero.is-white .tabs.is-toggle li.is-active a,\n.hero.is-white .tabs.is-toggle li.is-active a:hover {\n  background-color: #0a0a0a;\n  border-color: #0a0a0a;\n  color: white;\n}\n.hero.is-white.is-bold {\n  background-image: linear-gradient(141deg, #e6e6e6 0%, white 71%, white 100%);\n}\n@media screen and (max-width: 768px) {\n.hero.is-white.is-bold .navbar-menu {\n    background-image: linear-gradient(141deg, #e6e6e6 0%, white 71%, white 100%);\n}\n}\n.hero.is-black {\n  background-color: #0a0a0a;\n  color: white;\n}\n.hero.is-black a:not(.button):not(.dropdown-item):not(.tag),\n.hero.is-black strong {\n  color: inherit;\n}\n.hero.is-black .title {\n  color: white;\n}\n.hero.is-black .subtitle {\n  color: rgba(255, 255, 255, .9);\n}\n.hero.is-black .subtitle a:not(.button),\n.hero.is-black .subtitle strong {\n  color: white;\n}\n@media screen and (max-width: 1087px) {\n.hero.is-black .navbar-menu {\n    background-color: #0a0a0a;\n}\n}\n.hero.is-black .navbar-item,\n.hero.is-black .navbar-link {\n  color: rgba(255, 255, 255, .7);\n}\n.hero.is-black a.navbar-item:hover,\n.hero.is-black a.navbar-item.is-active,\n.hero.is-black .navbar-link:hover,\n.hero.is-black .navbar-link.is-active {\n  background-color: black;\n  color: white;\n}\n.hero.is-black .tabs a {\n  color: white;\n  opacity: .9;\n}\n.hero.is-black .tabs a:hover {\n  opacity: 1;\n}\n.hero.is-black .tabs li.is-active a {\n  opacity: 1;\n}\n.hero.is-black .tabs.is-boxed a,\n.hero.is-black .tabs.is-toggle a {\n  color: white;\n}\n.hero.is-black .tabs.is-boxed a:hover,\n.hero.is-black .tabs.is-toggle a:hover {\n  background-color: rgba(10, 10, 10, .1);\n}\n.hero.is-black .tabs.is-boxed li.is-active a,\n.hero.is-black .tabs.is-boxed li.is-active a:hover,\n.hero.is-black .tabs.is-toggle li.is-active a,\n.hero.is-black .tabs.is-toggle li.is-active a:hover {\n  background-color: white;\n  border-color: white;\n  color: #0a0a0a;\n}\n.hero.is-black.is-bold {\n  background-image: linear-gradient(141deg, black 0%, #0a0a0a 71%, #181616 100%);\n}\n@media screen and (max-width: 768px) {\n.hero.is-black.is-bold .navbar-menu {\n    background-image: linear-gradient(141deg, black 0%, #0a0a0a 71%, #181616 100%);\n}\n}\n.hero.is-grey {\n  background-color: #9babb4;\n  color: #fff;\n}\n.hero.is-grey a:not(.button):not(.dropdown-item):not(.tag),\n.hero.is-grey strong {\n  color: inherit;\n}\n.hero.is-grey .title {\n  color: #fff;\n}\n.hero.is-grey .subtitle {\n  color: rgba(255, 255, 255, .9);\n}\n.hero.is-grey .subtitle a:not(.button),\n.hero.is-grey .subtitle strong {\n  color: #fff;\n}\n@media screen and (max-width: 1087px) {\n.hero.is-grey .navbar-menu {\n    background-color: #9babb4;\n}\n}\n.hero.is-grey .navbar-item,\n.hero.is-grey .navbar-link {\n  color: rgba(255, 255, 255, .7);\n}\n.hero.is-grey a.navbar-item:hover,\n.hero.is-grey a.navbar-item.is-active,\n.hero.is-grey .navbar-link:hover,\n.hero.is-grey .navbar-link.is-active {\n  background-color: #8c9fa9;\n  color: #fff;\n}\n.hero.is-grey .tabs a {\n  color: #fff;\n  opacity: .9;\n}\n.hero.is-grey .tabs a:hover {\n  opacity: 1;\n}\n.hero.is-grey .tabs li.is-active a {\n  opacity: 1;\n}\n.hero.is-grey .tabs.is-boxed a,\n.hero.is-grey .tabs.is-toggle a {\n  color: #fff;\n}\n.hero.is-grey .tabs.is-boxed a:hover,\n.hero.is-grey .tabs.is-toggle a:hover {\n  background-color: rgba(10, 10, 10, .1);\n}\n.hero.is-grey .tabs.is-boxed li.is-active a,\n.hero.is-grey .tabs.is-boxed li.is-active a:hover,\n.hero.is-grey .tabs.is-toggle li.is-active a,\n.hero.is-grey .tabs.is-toggle li.is-active a:hover {\n  background-color: #fff;\n  border-color: #fff;\n  color: #9babb4;\n}\n.hero.is-grey.is-bold {\n  background-image: linear-gradient(141deg, #739fa9 0%, #9babb4 71%, #a6b3c3 100%);\n}\n@media screen and (max-width: 768px) {\n.hero.is-grey.is-bold .navbar-menu {\n    background-image: linear-gradient(141deg, #739fa9 0%, #9babb4 71%, #a6b3c3 100%);\n}\n}\n.hero.is-blue {\n  background-color: #3b5998;\n  color: #fff;\n}\n.hero.is-blue a:not(.button):not(.dropdown-item):not(.tag),\n.hero.is-blue strong {\n  color: inherit;\n}\n.hero.is-blue .title {\n  color: #fff;\n}\n.hero.is-blue .subtitle {\n  color: rgba(255, 255, 255, .9);\n}\n.hero.is-blue .subtitle a:not(.button),\n.hero.is-blue .subtitle strong {\n  color: #fff;\n}\n@media screen and (max-width: 1087px) {\n.hero.is-blue .navbar-menu {\n    background-color: #3b5998;\n}\n}\n.hero.is-blue .navbar-item,\n.hero.is-blue .navbar-link {\n  color: rgba(255, 255, 255, .7);\n}\n.hero.is-blue a.navbar-item:hover,\n.hero.is-blue a.navbar-item.is-active,\n.hero.is-blue .navbar-link:hover,\n.hero.is-blue .navbar-link.is-active {\n  background-color: #344e86;\n  color: #fff;\n}\n.hero.is-blue .tabs a {\n  color: #fff;\n  opacity: .9;\n}\n.hero.is-blue .tabs a:hover {\n  opacity: 1;\n}\n.hero.is-blue .tabs li.is-active a {\n  opacity: 1;\n}\n.hero.is-blue .tabs.is-boxed a,\n.hero.is-blue .tabs.is-toggle a {\n  color: #fff;\n}\n.hero.is-blue .tabs.is-boxed a:hover,\n.hero.is-blue .tabs.is-toggle a:hover {\n  background-color: rgba(10, 10, 10, .1);\n}\n.hero.is-blue .tabs.is-boxed li.is-active a,\n.hero.is-blue .tabs.is-boxed li.is-active a:hover,\n.hero.is-blue .tabs.is-toggle li.is-active a,\n.hero.is-blue .tabs.is-toggle li.is-active a:hover {\n  background-color: #fff;\n  border-color: #fff;\n  color: #3b5998;\n}\n.hero.is-blue.is-bold {\n  background-image: linear-gradient(141deg, #254f7b 0%, #3b5998 71%, #3c4eb0 100%);\n}\n@media screen and (max-width: 768px) {\n.hero.is-blue.is-bold .navbar-menu {\n    background-image: linear-gradient(141deg, #254f7b 0%, #3b5998 71%, #3c4eb0 100%);\n}\n}\n.hero.is-blue-dark {\n  background-color: #3b5998;\n  color: #fff;\n}\n.hero.is-blue-dark a:not(.button):not(.dropdown-item):not(.tag),\n.hero.is-blue-dark strong {\n  color: inherit;\n}\n.hero.is-blue-dark .title {\n  color: #fff;\n}\n.hero.is-blue-dark .subtitle {\n  color: rgba(255, 255, 255, .9);\n}\n.hero.is-blue-dark .subtitle a:not(.button),\n.hero.is-blue-dark .subtitle strong {\n  color: #fff;\n}\n@media screen and (max-width: 1087px) {\n.hero.is-blue-dark .navbar-menu {\n    background-color: #3b5998;\n}\n}\n.hero.is-blue-dark .navbar-item,\n.hero.is-blue-dark .navbar-link {\n  color: rgba(255, 255, 255, .7);\n}\n.hero.is-blue-dark a.navbar-item:hover,\n.hero.is-blue-dark a.navbar-item.is-active,\n.hero.is-blue-dark .navbar-link:hover,\n.hero.is-blue-dark .navbar-link.is-active {\n  background-color: #344e86;\n  color: #fff;\n}\n.hero.is-blue-dark .tabs a {\n  color: #fff;\n  opacity: .9;\n}\n.hero.is-blue-dark .tabs a:hover {\n  opacity: 1;\n}\n.hero.is-blue-dark .tabs li.is-active a {\n  opacity: 1;\n}\n.hero.is-blue-dark .tabs.is-boxed a,\n.hero.is-blue-dark .tabs.is-toggle a {\n  color: #fff;\n}\n.hero.is-blue-dark .tabs.is-boxed a:hover,\n.hero.is-blue-dark .tabs.is-toggle a:hover {\n  background-color: rgba(10, 10, 10, .1);\n}\n.hero.is-blue-dark .tabs.is-boxed li.is-active a,\n.hero.is-blue-dark .tabs.is-boxed li.is-active a:hover,\n.hero.is-blue-dark .tabs.is-toggle li.is-active a,\n.hero.is-blue-dark .tabs.is-toggle li.is-active a:hover {\n  background-color: #fff;\n  border-color: #fff;\n  color: #3b5998;\n}\n.hero.is-blue-dark.is-bold {\n  background-image: linear-gradient(141deg, #254f7b 0%, #3b5998 71%, #3c4eb0 100%);\n}\n@media screen and (max-width: 768px) {\n.hero.is-blue-dark.is-bold .navbar-menu {\n    background-image: linear-gradient(141deg, #254f7b 0%, #3b5998 71%, #3c4eb0 100%);\n}\n}\n.hero.is-light {\n  background-color: whitesmoke;\n  color: #363636;\n}\n.hero.is-light a:not(.button):not(.dropdown-item):not(.tag),\n.hero.is-light strong {\n  color: inherit;\n}\n.hero.is-light .title {\n  color: #363636;\n}\n.hero.is-light .subtitle {\n  color: rgba(54, 54, 54, .9);\n}\n.hero.is-light .subtitle a:not(.button),\n.hero.is-light .subtitle strong {\n  color: #363636;\n}\n@media screen and (max-width: 1087px) {\n.hero.is-light .navbar-menu {\n    background-color: whitesmoke;\n}\n}\n.hero.is-light .navbar-item,\n.hero.is-light .navbar-link {\n  color: rgba(54, 54, 54, .7);\n}\n.hero.is-light a.navbar-item:hover,\n.hero.is-light a.navbar-item.is-active,\n.hero.is-light .navbar-link:hover,\n.hero.is-light .navbar-link.is-active {\n  background-color: #e8e8e8;\n  color: #363636;\n}\n.hero.is-light .tabs a {\n  color: #363636;\n  opacity: .9;\n}\n.hero.is-light .tabs a:hover {\n  opacity: 1;\n}\n.hero.is-light .tabs li.is-active a {\n  opacity: 1;\n}\n.hero.is-light .tabs.is-boxed a,\n.hero.is-light .tabs.is-toggle a {\n  color: #363636;\n}\n.hero.is-light .tabs.is-boxed a:hover,\n.hero.is-light .tabs.is-toggle a:hover {\n  background-color: rgba(10, 10, 10, .1);\n}\n.hero.is-light .tabs.is-boxed li.is-active a,\n.hero.is-light .tabs.is-boxed li.is-active a:hover,\n.hero.is-light .tabs.is-toggle li.is-active a,\n.hero.is-light .tabs.is-toggle li.is-active a:hover {\n  background-color: #363636;\n  border-color: #363636;\n  color: whitesmoke;\n}\n.hero.is-light.is-bold {\n  background-image: linear-gradient(141deg, #dfd8d9 0%, whitesmoke 71%, white 100%);\n}\n@media screen and (max-width: 768px) {\n.hero.is-light.is-bold .navbar-menu {\n    background-image: linear-gradient(141deg, #dfd8d9 0%, whitesmoke 71%, white 100%);\n}\n}\n.hero.is-dark {\n  background-color: #363636;\n  color: whitesmoke;\n}\n.hero.is-dark a:not(.button):not(.dropdown-item):not(.tag),\n.hero.is-dark strong {\n  color: inherit;\n}\n.hero.is-dark .title {\n  color: whitesmoke;\n}\n.hero.is-dark .subtitle {\n  color: rgba(245, 245, 245, .9);\n}\n.hero.is-dark .subtitle a:not(.button),\n.hero.is-dark .subtitle strong {\n  color: whitesmoke;\n}\n@media screen and (max-width: 1087px) {\n.hero.is-dark .navbar-menu {\n    background-color: #363636;\n}\n}\n.hero.is-dark .navbar-item,\n.hero.is-dark .navbar-link {\n  color: rgba(245, 245, 245, .7);\n}\n.hero.is-dark a.navbar-item:hover,\n.hero.is-dark a.navbar-item.is-active,\n.hero.is-dark .navbar-link:hover,\n.hero.is-dark .navbar-link.is-active {\n  background-color: #292929;\n  color: whitesmoke;\n}\n.hero.is-dark .tabs a {\n  color: whitesmoke;\n  opacity: .9;\n}\n.hero.is-dark .tabs a:hover {\n  opacity: 1;\n}\n.hero.is-dark .tabs li.is-active a {\n  opacity: 1;\n}\n.hero.is-dark .tabs.is-boxed a,\n.hero.is-dark .tabs.is-toggle a {\n  color: whitesmoke;\n}\n.hero.is-dark .tabs.is-boxed a:hover,\n.hero.is-dark .tabs.is-toggle a:hover {\n  background-color: rgba(10, 10, 10, .1);\n}\n.hero.is-dark .tabs.is-boxed li.is-active a,\n.hero.is-dark .tabs.is-boxed li.is-active a:hover,\n.hero.is-dark .tabs.is-toggle li.is-active a,\n.hero.is-dark .tabs.is-toggle li.is-active a:hover {\n  background-color: whitesmoke;\n  border-color: whitesmoke;\n  color: #363636;\n}\n.hero.is-dark.is-bold {\n  background-image: linear-gradient(141deg, #1f191a 0%, #363636 71%, #46403f 100%);\n}\n@media screen and (max-width: 768px) {\n.hero.is-dark.is-bold .navbar-menu {\n    background-image: linear-gradient(141deg, #1f191a 0%, #363636 71%, #46403f 100%);\n}\n}\n.hero.is-primary {\n  background-color: #2196f3;\n  color: #fff;\n}\n.hero.is-primary a:not(.button):not(.dropdown-item):not(.tag),\n.hero.is-primary strong {\n  color: inherit;\n}\n.hero.is-primary .title {\n  color: #fff;\n}\n.hero.is-primary .subtitle {\n  color: rgba(255, 255, 255, .9);\n}\n.hero.is-primary .subtitle a:not(.button),\n.hero.is-primary .subtitle strong {\n  color: #fff;\n}\n@media screen and (max-width: 1087px) {\n.hero.is-primary .navbar-menu {\n    background-color: #2196f3;\n}\n}\n.hero.is-primary .navbar-item,\n.hero.is-primary .navbar-link {\n  color: rgba(255, 255, 255, .7);\n}\n.hero.is-primary a.navbar-item:hover,\n.hero.is-primary a.navbar-item.is-active,\n.hero.is-primary .navbar-link:hover,\n.hero.is-primary .navbar-link.is-active {\n  background-color: #0d8aee;\n  color: #fff;\n}\n.hero.is-primary .tabs a {\n  color: #fff;\n  opacity: .9;\n}\n.hero.is-primary .tabs a:hover {\n  opacity: 1;\n}\n.hero.is-primary .tabs li.is-active a {\n  opacity: 1;\n}\n.hero.is-primary .tabs.is-boxed a,\n.hero.is-primary .tabs.is-toggle a {\n  color: #fff;\n}\n.hero.is-primary .tabs.is-boxed a:hover,\n.hero.is-primary .tabs.is-toggle a:hover {\n  background-color: rgba(10, 10, 10, .1);\n}\n.hero.is-primary .tabs.is-boxed li.is-active a,\n.hero.is-primary .tabs.is-boxed li.is-active a:hover,\n.hero.is-primary .tabs.is-toggle li.is-active a,\n.hero.is-primary .tabs.is-toggle li.is-active a:hover {\n  background-color: #fff;\n  border-color: #fff;\n  color: #2196f3;\n}\n.hero.is-primary.is-bold {\n  background-image: linear-gradient(141deg, #00a3e1 0%, #2196f3 71%, #3481fa 100%);\n}\n@media screen and (max-width: 768px) {\n.hero.is-primary.is-bold .navbar-menu {\n    background-image: linear-gradient(141deg, #00a3e1 0%, #2196f3 71%, #3481fa 100%);\n}\n}\n.hero.is-info {\n  background-color: #3b5998;\n  color: #fff;\n}\n.hero.is-info a:not(.button):not(.dropdown-item):not(.tag),\n.hero.is-info strong {\n  color: inherit;\n}\n.hero.is-info .title {\n  color: #fff;\n}\n.hero.is-info .subtitle {\n  color: rgba(255, 255, 255, .9);\n}\n.hero.is-info .subtitle a:not(.button),\n.hero.is-info .subtitle strong {\n  color: #fff;\n}\n@media screen and (max-width: 1087px) {\n.hero.is-info .navbar-menu {\n    background-color: #3b5998;\n}\n}\n.hero.is-info .navbar-item,\n.hero.is-info .navbar-link {\n  color: rgba(255, 255, 255, .7);\n}\n.hero.is-info a.navbar-item:hover,\n.hero.is-info a.navbar-item.is-active,\n.hero.is-info .navbar-link:hover,\n.hero.is-info .navbar-link.is-active {\n  background-color: #344e86;\n  color: #fff;\n}\n.hero.is-info .tabs a {\n  color: #fff;\n  opacity: .9;\n}\n.hero.is-info .tabs a:hover {\n  opacity: 1;\n}\n.hero.is-info .tabs li.is-active a {\n  opacity: 1;\n}\n.hero.is-info .tabs.is-boxed a,\n.hero.is-info .tabs.is-toggle a {\n  color: #fff;\n}\n.hero.is-info .tabs.is-boxed a:hover,\n.hero.is-info .tabs.is-toggle a:hover {\n  background-color: rgba(10, 10, 10, .1);\n}\n.hero.is-info .tabs.is-boxed li.is-active a,\n.hero.is-info .tabs.is-boxed li.is-active a:hover,\n.hero.is-info .tabs.is-toggle li.is-active a,\n.hero.is-info .tabs.is-toggle li.is-active a:hover {\n  background-color: #fff;\n  border-color: #fff;\n  color: #3b5998;\n}\n.hero.is-info.is-bold {\n  background-image: linear-gradient(141deg, #254f7b 0%, #3b5998 71%, #3c4eb0 100%);\n}\n@media screen and (max-width: 768px) {\n.hero.is-info.is-bold .navbar-menu {\n    background-image: linear-gradient(141deg, #254f7b 0%, #3b5998 71%, #3c4eb0 100%);\n}\n}\n.hero.is-success {\n  background-color: #2ab27b;\n  color: #fff;\n}\n.hero.is-success a:not(.button):not(.dropdown-item):not(.tag),\n.hero.is-success strong {\n  color: inherit;\n}\n.hero.is-success .title {\n  color: #fff;\n}\n.hero.is-success .subtitle {\n  color: rgba(255, 255, 255, .9);\n}\n.hero.is-success .subtitle a:not(.button),\n.hero.is-success .subtitle strong {\n  color: #fff;\n}\n@media screen and (max-width: 1087px) {\n.hero.is-success .navbar-menu {\n    background-color: #2ab27b;\n}\n}\n.hero.is-success .navbar-item,\n.hero.is-success .navbar-link {\n  color: rgba(255, 255, 255, .7);\n}\n.hero.is-success a.navbar-item:hover,\n.hero.is-success a.navbar-item.is-active,\n.hero.is-success .navbar-link:hover,\n.hero.is-success .navbar-link.is-active {\n  background-color: #259d6d;\n  color: #fff;\n}\n.hero.is-success .tabs a {\n  color: #fff;\n  opacity: .9;\n}\n.hero.is-success .tabs a:hover {\n  opacity: 1;\n}\n.hero.is-success .tabs li.is-active a {\n  opacity: 1;\n}\n.hero.is-success .tabs.is-boxed a,\n.hero.is-success .tabs.is-toggle a {\n  color: #fff;\n}\n.hero.is-success .tabs.is-boxed a:hover,\n.hero.is-success .tabs.is-toggle a:hover {\n  background-color: rgba(10, 10, 10, .1);\n}\n.hero.is-success .tabs.is-boxed li.is-active a,\n.hero.is-success .tabs.is-boxed li.is-active a:hover,\n.hero.is-success .tabs.is-toggle li.is-active a,\n.hero.is-success .tabs.is-toggle li.is-active a:hover {\n  background-color: #fff;\n  border-color: #fff;\n  color: #2ab27b;\n}\n.hero.is-success.is-bold {\n  background-image: linear-gradient(141deg, #18914c 0%, #2ab27b 71%, #29cda6 100%);\n}\n@media screen and (max-width: 768px) {\n.hero.is-success.is-bold .navbar-menu {\n    background-image: linear-gradient(141deg, #18914c 0%, #2ab27b 71%, #29cda6 100%);\n}\n}\n.hero.is-warning {\n  background-color: #ffdd57;\n  color: rgba(0, 0, 0, .7);\n}\n.hero.is-warning a:not(.button):not(.dropdown-item):not(.tag),\n.hero.is-warning strong {\n  color: inherit;\n}\n.hero.is-warning .title {\n  color: rgba(0, 0, 0, .7);\n}\n.hero.is-warning .subtitle {\n  color: rgba(0, 0, 0, .9);\n}\n.hero.is-warning .subtitle a:not(.button),\n.hero.is-warning .subtitle strong {\n  color: rgba(0, 0, 0, .7);\n}\n@media screen and (max-width: 1087px) {\n.hero.is-warning .navbar-menu {\n    background-color: #ffdd57;\n}\n}\n.hero.is-warning .navbar-item,\n.hero.is-warning .navbar-link {\n  color: rgba(0, 0, 0, .7);\n}\n.hero.is-warning a.navbar-item:hover,\n.hero.is-warning a.navbar-item.is-active,\n.hero.is-warning .navbar-link:hover,\n.hero.is-warning .navbar-link.is-active {\n  background-color: #ffd83d;\n  color: rgba(0, 0, 0, .7);\n}\n.hero.is-warning .tabs a {\n  color: rgba(0, 0, 0, .7);\n  opacity: .9;\n}\n.hero.is-warning .tabs a:hover {\n  opacity: 1;\n}\n.hero.is-warning .tabs li.is-active a {\n  opacity: 1;\n}\n.hero.is-warning .tabs.is-boxed a,\n.hero.is-warning .tabs.is-toggle a {\n  color: rgba(0, 0, 0, .7);\n}\n.hero.is-warning .tabs.is-boxed a:hover,\n.hero.is-warning .tabs.is-toggle a:hover {\n  background-color: rgba(10, 10, 10, .1);\n}\n.hero.is-warning .tabs.is-boxed li.is-active a,\n.hero.is-warning .tabs.is-boxed li.is-active a:hover,\n.hero.is-warning .tabs.is-toggle li.is-active a,\n.hero.is-warning .tabs.is-toggle li.is-active a:hover {\n  background-color: rgba(0, 0, 0, .7);\n  border-color: rgba(0, 0, 0, .7);\n  color: #ffdd57;\n}\n.hero.is-warning.is-bold {\n  background-image: linear-gradient(141deg, #ffaf24 0%, #ffdd57 71%, #fffa70 100%);\n}\n@media screen and (max-width: 768px) {\n.hero.is-warning.is-bold .navbar-menu {\n    background-image: linear-gradient(141deg, #ffaf24 0%, #ffdd57 71%, #fffa70 100%);\n}\n}\n.hero.is-danger {\n  background-color: #dc5b5b;\n  color: #fff;\n}\n.hero.is-danger a:not(.button):not(.dropdown-item):not(.tag),\n.hero.is-danger strong {\n  color: inherit;\n}\n.hero.is-danger .title {\n  color: #fff;\n}\n.hero.is-danger .subtitle {\n  color: rgba(255, 255, 255, .9);\n}\n.hero.is-danger .subtitle a:not(.button),\n.hero.is-danger .subtitle strong {\n  color: #fff;\n}\n@media screen and (max-width: 1087px) {\n.hero.is-danger .navbar-menu {\n    background-color: #dc5b5b;\n}\n}\n.hero.is-danger .navbar-item,\n.hero.is-danger .navbar-link {\n  color: rgba(255, 255, 255, .7);\n}\n.hero.is-danger a.navbar-item:hover,\n.hero.is-danger a.navbar-item.is-active,\n.hero.is-danger .navbar-link:hover,\n.hero.is-danger .navbar-link.is-active {\n  background-color: #d84646;\n  color: #fff;\n}\n.hero.is-danger .tabs a {\n  color: #fff;\n  opacity: .9;\n}\n.hero.is-danger .tabs a:hover {\n  opacity: 1;\n}\n.hero.is-danger .tabs li.is-active a {\n  opacity: 1;\n}\n.hero.is-danger .tabs.is-boxed a,\n.hero.is-danger .tabs.is-toggle a {\n  color: #fff;\n}\n.hero.is-danger .tabs.is-boxed a:hover,\n.hero.is-danger .tabs.is-toggle a:hover {\n  background-color: rgba(10, 10, 10, .1);\n}\n.hero.is-danger .tabs.is-boxed li.is-active a,\n.hero.is-danger .tabs.is-boxed li.is-active a:hover,\n.hero.is-danger .tabs.is-toggle li.is-active a,\n.hero.is-danger .tabs.is-toggle li.is-active a:hover {\n  background-color: #fff;\n  border-color: #fff;\n  color: #dc5b5b;\n}\n.hero.is-danger.is-bold {\n  background-image: linear-gradient(141deg, #e02444 0%, #dc5b5b 71%, #e5806c 100%);\n}\n@media screen and (max-width: 768px) {\n.hero.is-danger.is-bold .navbar-menu {\n    background-image: linear-gradient(141deg, #e02444 0%, #dc5b5b 71%, #e5806c 100%);\n}\n}\n.hero.is-small .hero-body {\n  padding-bottom: 1.5rem;\n  padding-top: 1.5rem;\n}\n@media screen and (min-width: 769px), print {\n.hero.is-medium .hero-body {\n    padding-bottom: 9rem;\n    padding-top: 9rem;\n}\n}\n@media screen and (min-width: 769px), print {\n.hero.is-large .hero-body {\n    padding-bottom: 18rem;\n    padding-top: 18rem;\n}\n}\n.hero.is-halfheight .hero-body,\n.hero.is-fullheight .hero-body,\n.hero.is-fullheight-with-navbar .hero-body {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.hero.is-halfheight .hero-body > .container,\n.hero.is-fullheight .hero-body > .container,\n.hero.is-fullheight-with-navbar .hero-body > .container {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1;\n}\n.hero.is-halfheight {\n  min-height: 50vh;\n}\n.hero.is-fullheight {\n  min-height: 100vh;\n}\n.hero-video {\n  overflow: hidden;\n}\n.hero-video video {\n  left: 50%;\n  min-height: 100%;\n  min-width: 100%;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translate3d(-50%, -50%, 0);\n          transform: translate3d(-50%, -50%, 0);\n}\n.hero-video.is-transparent {\n  opacity: .3;\n}\n@media screen and (max-width: 768px) {\n.hero-video {\n    display: none;\n}\n}\n.hero-buttons {\n  margin-top: 1.5rem;\n}\n@media screen and (max-width: 768px) {\n.hero-buttons .button {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n}\n.hero-buttons .button:not(:last-child) {\n    margin-bottom: .75rem;\n}\n}\n@media screen and (min-width: 769px), print {\n.hero-buttons {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n.hero-buttons .button:not(:last-child) {\n    margin-right: 1.5rem;\n}\n}\n.hero-head,\n.hero-foot {\n  -webkit-box-flex: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n.hero-body {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  padding: 3rem 1.5rem;\n}\n.section {\n  padding: 3rem 1.5rem;\n}\n@media screen and (min-width: 1088px) {\n.section.is-medium {\n    padding: 9rem 1.5rem;\n}\n.section.is-large {\n    padding: 18rem 1.5rem;\n}\n}\n.footer {\n  background-color: #fafafa;\n  padding: 3rem 1.5rem 6rem;\n}\n.is-noscroll {\n  position: fixed;\n  overflow-y: hidden;\n  width: 100%;\n  bottom: 0;\n}\n@-webkit-keyframes fadeOut {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n@keyframes fadeOut {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n          animation-name: fadeOut;\n}\n@-webkit-keyframes fadeOutDown {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n            transform: translate3d(0, 100%, 0);\n}\n}\n@keyframes fadeOutDown {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n            transform: translate3d(0, 100%, 0);\n}\n}\n.fadeOutDown {\n  -webkit-animation-name: fadeOutDown;\n          animation-name: fadeOutDown;\n}\n@-webkit-keyframes fadeOutUp {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n            transform: translate3d(0, -100%, 0);\n}\n}\n@keyframes fadeOutUp {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n            transform: translate3d(0, -100%, 0);\n}\n}\n.fadeOutUp {\n  -webkit-animation-name: fadeOutUp;\n          animation-name: fadeOutUp;\n}\n@-webkit-keyframes fadeIn {\nfrom {\n    opacity: 0;\n}\nto {\n    opacity: 1;\n}\n}\n@keyframes fadeIn {\nfrom {\n    opacity: 0;\n}\nto {\n    opacity: 1;\n}\n}\n.fadeIn {\n  -webkit-animation-name: fadeIn;\n          animation-name: fadeIn;\n}\n@-webkit-keyframes fadeInDown {\nfrom {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n            transform: translate3d(0, -100%, 0);\n}\nto {\n    opacity: 1;\n    -webkit-transform: none;\n            transform: none;\n}\n}\n@keyframes fadeInDown {\nfrom {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n            transform: translate3d(0, -100%, 0);\n}\nto {\n    opacity: 1;\n    -webkit-transform: none;\n            transform: none;\n}\n}\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n          animation-name: fadeInDown;\n}\n@-webkit-keyframes fadeInUp {\nfrom {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n            transform: translate3d(0, 100%, 0);\n}\nto {\n    opacity: 1;\n    -webkit-transform: none;\n            transform: none;\n}\n}\n@keyframes fadeInUp {\nfrom {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n            transform: translate3d(0, 100%, 0);\n}\nto {\n    opacity: 1;\n    -webkit-transform: none;\n            transform: none;\n}\n}\n.fadeInUp {\n  -webkit-animation-name: fadeInUp;\n          animation-name: fadeInUp;\n}\n\n/**\r\n * Vue Transitions\r\n */\n.fade-enter-active,\n.fade-leave-active {\n  -webkit-transition: opacity 150ms ease-out;\n          transition: opacity 150ms ease-out;\n}\n.fade-enter,\n.fade-leave-to {\n  opacity: 0;\n}\n.zoom-in-enter-active,\n.zoom-in-leave-active {\n  -webkit-transition: opacity 150ms ease-out;\n          transition: opacity 150ms ease-out;\n}\n.zoom-in-enter-active .animation-content,\n.zoom-in-enter-active .animation-content,\n.zoom-in-leave-active .animation-content,\n.zoom-in-leave-active .animation-content {\n  -webkit-transition: -webkit-transform 150ms ease-out;\n          transition: -webkit-transform 150ms ease-out;\n          transition: transform 150ms ease-out;\n          transition: transform 150ms ease-out, -webkit-transform 150ms ease-out;\n}\n.zoom-in-enter,\n.zoom-in-leave-active {\n  opacity: 0;\n}\n.zoom-in-enter .animation-content,\n.zoom-in-enter .animation-content,\n.zoom-in-leave-active .animation-content,\n.zoom-in-leave-active .animation-content {\n  -webkit-transform: scale(.95);\n          transform: scale(.95);\n}\n.zoom-out-enter-active,\n.zoom-out-leave-active {\n  -webkit-transition: opacity 150ms ease-out;\n          transition: opacity 150ms ease-out;\n}\n.zoom-out-enter-active .animation-content,\n.zoom-out-enter-active .animation-content,\n.zoom-out-leave-active .animation-content,\n.zoom-out-leave-active .animation-content {\n  -webkit-transition: -webkit-transform 150ms ease-out;\n          transition: -webkit-transform 150ms ease-out;\n          transition: transform 150ms ease-out;\n          transition: transform 150ms ease-out, -webkit-transform 150ms ease-out;\n}\n.zoom-out-enter,\n.zoom-out-leave-active {\n  opacity: 0;\n}\n.zoom-out-enter .animation-content,\n.zoom-out-enter .animation-content,\n.zoom-out-leave-active .animation-content,\n.zoom-out-leave-active .animation-content {\n  -webkit-transform: scale(1.05);\n          transform: scale(1.05);\n}\n.slide-next-enter-active,\n.slide-next-leave-active,\n.slide-prev-enter-active,\n.slide-prev-leave-active {\n  -webkit-transition: -webkit-transform 250ms cubic-bezier(.785, .135, .15, .86);\n          transition: -webkit-transform 250ms cubic-bezier(.785, .135, .15, .86);\n          transition: transform 250ms cubic-bezier(.785, .135, .15, .86);\n          transition: transform 250ms cubic-bezier(.785, .135, .15, .86), -webkit-transform 250ms cubic-bezier(.785, .135, .15, .86);\n}\n.slide-prev-leave-to,\n.slide-next-enter {\n  -webkit-transform: translate3d(-100%, 0, 0);\n          transform: translate3d(-100%, 0, 0);\n  position: absolute;\n  width: 100%;\n}\n.slide-prev-enter,\n.slide-next-leave-to {\n  -webkit-transform: translate3d(100%, 0, 0);\n          transform: translate3d(100%, 0, 0);\n  position: absolute;\n  width: 100%;\n}\n.autocomplete {\n  position: relative;\n}\n.autocomplete .dropdown-menu {\n  display: block;\n  min-width: 100%;\n  max-width: 100%;\n}\n.autocomplete .dropdown-menu.is-opened-top {\n  top: auto;\n  bottom: 100%;\n}\n.autocomplete .dropdown-content {\n  overflow: auto;\n  max-height: 200px;\n}\n.autocomplete .dropdown-item,\n.autocomplete .dropdown .dropdown-menu .has-link a,\n.dropdown .dropdown-menu .has-link .autocomplete a {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.autocomplete .dropdown-item.is-hovered,\n.autocomplete .dropdown .dropdown-menu .has-link a.is-hovered,\n.dropdown .dropdown-menu .has-link .autocomplete a.is-hovered {\n  background: whitesmoke;\n  color: #0a0a0a;\n}\n.autocomplete .dropdown-item.is-disabled,\n.autocomplete .dropdown .dropdown-menu .has-link a.is-disabled,\n.dropdown .dropdown-menu .has-link .autocomplete a.is-disabled {\n  opacity: .5;\n  cursor: not-allowed;\n}\n.autocomplete.is-small {\n  border-radius: 2px;\n  font-size: .75rem;\n}\n.autocomplete.is-medium {\n  font-size: 1.25rem;\n}\n.autocomplete.is-large {\n  font-size: 1.5rem;\n}\n.b-checkbox.checkbox {\n  outline: none;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.b-checkbox.checkbox + .checkbox {\n  margin-left: .5em;\n}\n.b-checkbox.checkbox input[type=checkbox] {\n  position: absolute;\n  left: 0;\n  opacity: 0;\n  outline: none;\n  z-index: -1;\n}\n.b-checkbox.checkbox input[type=checkbox] + .check {\n  width: 1.25em;\n  height: 1.25em;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  border-radius: 4px;\n  border: 2px solid #9babb4;\n  -webkit-transition: background 150ms ease-out;\n          transition: background 150ms ease-out;\n}\n.b-checkbox.checkbox input[type=checkbox]:checked + .check {\n  background: #2196f3 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%23fff' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #2196f3;\n}\n.b-checkbox.checkbox input[type=checkbox]:checked + .check.is-white {\n  background: white url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%230a0a0a' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n  border-color: white;\n}\n.b-checkbox.checkbox input[type=checkbox]:checked + .check.is-black {\n  background: #0a0a0a url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:white' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #0a0a0a;\n}\n.b-checkbox.checkbox input[type=checkbox]:checked + .check.is-grey {\n  background: #9babb4 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%23fff' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #9babb4;\n}\n.b-checkbox.checkbox input[type=checkbox]:checked + .check.is-blue {\n  background: #3b5998 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%23fff' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #3b5998;\n}\n.b-checkbox.checkbox input[type=checkbox]:checked + .check.is-blue-dark {\n  background: #3b5998 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%23fff' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #3b5998;\n}\n.b-checkbox.checkbox input[type=checkbox]:checked + .check.is-light {\n  background: whitesmoke url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%23363636' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n  border-color: whitesmoke;\n}\n.b-checkbox.checkbox input[type=checkbox]:checked + .check.is-dark {\n  background: #363636 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:whitesmoke' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #363636;\n}\n.b-checkbox.checkbox input[type=checkbox]:checked + .check.is-primary {\n  background: #2196f3 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%23fff' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #2196f3;\n}\n.b-checkbox.checkbox input[type=checkbox]:checked + .check.is-info {\n  background: #3b5998 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%23fff' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #3b5998;\n}\n.b-checkbox.checkbox input[type=checkbox]:checked + .check.is-success {\n  background: #2ab27b url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%23fff' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #2ab27b;\n}\n.b-checkbox.checkbox input[type=checkbox]:checked + .check.is-warning {\n  background: #ffdd57 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:rgba(0, 0, 0, 0.7)' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #ffdd57;\n}\n.b-checkbox.checkbox input[type=checkbox]:checked + .check.is-danger {\n  background: #dc5b5b url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%23fff' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #dc5b5b;\n}\n.b-checkbox.checkbox input[type=checkbox]:indeterminate + .check {\n  background: #2196f3 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Crect style='fill:%23fff' width='0.7' height='0.2' x='.15' y='.4'%3E%3C/rect%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #2196f3;\n}\n.b-checkbox.checkbox input[type=checkbox]:indeterminate + .check.is-white {\n  background: white url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Crect style='fill:%230a0a0a' width='0.7' height='0.2' x='.15' y='.4'%3E%3C/rect%3E%3C/svg%3E\") no-repeat center center;\n  border-color: white;\n}\n.b-checkbox.checkbox input[type=checkbox]:indeterminate + .check.is-black {\n  background: #0a0a0a url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Crect style='fill:white' width='0.7' height='0.2' x='.15' y='.4'%3E%3C/rect%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #0a0a0a;\n}\n.b-checkbox.checkbox input[type=checkbox]:indeterminate + .check.is-grey {\n  background: #9babb4 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Crect style='fill:%23fff' width='0.7' height='0.2' x='.15' y='.4'%3E%3C/rect%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #9babb4;\n}\n.b-checkbox.checkbox input[type=checkbox]:indeterminate + .check.is-blue {\n  background: #3b5998 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Crect style='fill:%23fff' width='0.7' height='0.2' x='.15' y='.4'%3E%3C/rect%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #3b5998;\n}\n.b-checkbox.checkbox input[type=checkbox]:indeterminate + .check.is-blue-dark {\n  background: #3b5998 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Crect style='fill:%23fff' width='0.7' height='0.2' x='.15' y='.4'%3E%3C/rect%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #3b5998;\n}\n.b-checkbox.checkbox input[type=checkbox]:indeterminate + .check.is-light {\n  background: whitesmoke url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Crect style='fill:%23363636' width='0.7' height='0.2' x='.15' y='.4'%3E%3C/rect%3E%3C/svg%3E\") no-repeat center center;\n  border-color: whitesmoke;\n}\n.b-checkbox.checkbox input[type=checkbox]:indeterminate + .check.is-dark {\n  background: #363636 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Crect style='fill:whitesmoke' width='0.7' height='0.2' x='.15' y='.4'%3E%3C/rect%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #363636;\n}\n.b-checkbox.checkbox input[type=checkbox]:indeterminate + .check.is-primary {\n  background: #2196f3 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Crect style='fill:%23fff' width='0.7' height='0.2' x='.15' y='.4'%3E%3C/rect%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #2196f3;\n}\n.b-checkbox.checkbox input[type=checkbox]:indeterminate + .check.is-info {\n  background: #3b5998 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Crect style='fill:%23fff' width='0.7' height='0.2' x='.15' y='.4'%3E%3C/rect%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #3b5998;\n}\n.b-checkbox.checkbox input[type=checkbox]:indeterminate + .check.is-success {\n  background: #2ab27b url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Crect style='fill:%23fff' width='0.7' height='0.2' x='.15' y='.4'%3E%3C/rect%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #2ab27b;\n}\n.b-checkbox.checkbox input[type=checkbox]:indeterminate + .check.is-warning {\n  background: #ffdd57 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Crect style='fill:rgba(0, 0, 0, 0.7)' width='0.7' height='0.2' x='.15' y='.4'%3E%3C/rect%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #ffdd57;\n}\n.b-checkbox.checkbox input[type=checkbox]:indeterminate + .check.is-danger {\n  background: #dc5b5b url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Crect style='fill:%23fff' width='0.7' height='0.2' x='.15' y='.4'%3E%3C/rect%3E%3C/svg%3E\") no-repeat center center;\n  border-color: #dc5b5b;\n}\n.b-checkbox.checkbox .control-label {\n  padding-left: .5em;\n}\n.b-checkbox.checkbox[disabled] {\n  opacity: .5;\n}\n.b-checkbox.checkbox:hover input[type=checkbox] + .check {\n  border-color: #2196f3;\n}\n.b-checkbox.checkbox:hover input[type=checkbox] + .check.is-white {\n  border-color: white;\n}\n.b-checkbox.checkbox:hover input[type=checkbox] + .check.is-black {\n  border-color: #0a0a0a;\n}\n.b-checkbox.checkbox:hover input[type=checkbox] + .check.is-grey {\n  border-color: #9babb4;\n}\n.b-checkbox.checkbox:hover input[type=checkbox] + .check.is-blue {\n  border-color: #3b5998;\n}\n.b-checkbox.checkbox:hover input[type=checkbox] + .check.is-blue-dark {\n  border-color: #3b5998;\n}\n.b-checkbox.checkbox:hover input[type=checkbox] + .check.is-light {\n  border-color: whitesmoke;\n}\n.b-checkbox.checkbox:hover input[type=checkbox] + .check.is-dark {\n  border-color: #363636;\n}\n.b-checkbox.checkbox:hover input[type=checkbox] + .check.is-primary {\n  border-color: #2196f3;\n}\n.b-checkbox.checkbox:hover input[type=checkbox] + .check.is-info {\n  border-color: #3b5998;\n}\n.b-checkbox.checkbox:hover input[type=checkbox] + .check.is-success {\n  border-color: #2ab27b;\n}\n.b-checkbox.checkbox:hover input[type=checkbox] + .check.is-warning {\n  border-color: #ffdd57;\n}\n.b-checkbox.checkbox:hover input[type=checkbox] + .check.is-danger {\n  border-color: #dc5b5b;\n}\n.b-checkbox.checkbox:focus input[type=checkbox] + .check {\n  -webkit-box-shadow: 0 0 .5em rgba(155, 171, 180, .8);\n          box-shadow: 0 0 .5em rgba(155, 171, 180, .8);\n}\n.b-checkbox.checkbox:focus input[type=checkbox]:checked + .check {\n  -webkit-box-shadow: 0 0 .5em rgba(33, 150, 243, .8);\n          box-shadow: 0 0 .5em rgba(33, 150, 243, .8);\n}\n.b-checkbox.checkbox:focus input[type=checkbox]:checked + .check.is-white {\n  -webkit-box-shadow: 0 0 .5em rgba(255, 255, 255, .8);\n          box-shadow: 0 0 .5em rgba(255, 255, 255, .8);\n}\n.b-checkbox.checkbox:focus input[type=checkbox]:checked + .check.is-black {\n  -webkit-box-shadow: 0 0 .5em rgba(10, 10, 10, .8);\n          box-shadow: 0 0 .5em rgba(10, 10, 10, .8);\n}\n.b-checkbox.checkbox:focus input[type=checkbox]:checked + .check.is-grey {\n  -webkit-box-shadow: 0 0 .5em rgba(155, 171, 180, .8);\n          box-shadow: 0 0 .5em rgba(155, 171, 180, .8);\n}\n.b-checkbox.checkbox:focus input[type=checkbox]:checked + .check.is-blue {\n  -webkit-box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n          box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n}\n.b-checkbox.checkbox:focus input[type=checkbox]:checked + .check.is-blue-dark {\n  -webkit-box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n          box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n}\n.b-checkbox.checkbox:focus input[type=checkbox]:checked + .check.is-light {\n  -webkit-box-shadow: 0 0 .5em rgba(245, 245, 245, .8);\n          box-shadow: 0 0 .5em rgba(245, 245, 245, .8);\n}\n.b-checkbox.checkbox:focus input[type=checkbox]:checked + .check.is-dark {\n  -webkit-box-shadow: 0 0 .5em rgba(54, 54, 54, .8);\n          box-shadow: 0 0 .5em rgba(54, 54, 54, .8);\n}\n.b-checkbox.checkbox:focus input[type=checkbox]:checked + .check.is-primary {\n  -webkit-box-shadow: 0 0 .5em rgba(33, 150, 243, .8);\n          box-shadow: 0 0 .5em rgba(33, 150, 243, .8);\n}\n.b-checkbox.checkbox:focus input[type=checkbox]:checked + .check.is-info {\n  -webkit-box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n          box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n}\n.b-checkbox.checkbox:focus input[type=checkbox]:checked + .check.is-success {\n  -webkit-box-shadow: 0 0 .5em rgba(42, 178, 123, .8);\n          box-shadow: 0 0 .5em rgba(42, 178, 123, .8);\n}\n.b-checkbox.checkbox:focus input[type=checkbox]:checked + .check.is-warning {\n  -webkit-box-shadow: 0 0 .5em rgba(255, 221, 87, .8);\n          box-shadow: 0 0 .5em rgba(255, 221, 87, .8);\n}\n.b-checkbox.checkbox:focus input[type=checkbox]:checked + .check.is-danger {\n  -webkit-box-shadow: 0 0 .5em rgba(220, 91, 91, .8);\n          box-shadow: 0 0 .5em rgba(220, 91, 91, .8);\n}\n.b-checkbox.checkbox.is-small {\n  border-radius: 2px;\n  font-size: .75rem;\n}\n.b-checkbox.checkbox.is-medium {\n  font-size: 1.25rem;\n}\n.b-checkbox.checkbox.is-large {\n  font-size: 1.5rem;\n}\n.collapse .collapse-trigger {\n  display: inline;\n  cursor: pointer;\n}\n.collapse .collapse-content {\n  display: inherit;\n}\n.datepicker {\n  font-size: .875rem;\n}\n.datepicker .dropdown,\n.datepicker .dropdown-trigger {\n  width: 100%;\n}\n.datepicker .dropdown-item,\n.datepicker .dropdown .dropdown-menu .has-link a,\n.dropdown .dropdown-menu .has-link .datepicker a {\n  font-size: inherit;\n}\n.datepicker .datepicker-header {\n  padding-bottom: .875rem;\n  margin-bottom: .875rem;\n  border-bottom: 1px solid #dbdbdb;\n}\n.datepicker .datepicker-content {\n  height: 16.25rem;\n}\n.datepicker .datepicker-footer {\n  margin-top: .875rem;\n  padding-top: .875rem;\n  border-top: 1px solid #dbdbdb;\n}\n.datepicker .datepicker-table {\n  display: table;\n  margin: 0 auto 0 auto;\n}\n.datepicker .datepicker-table .datepicker-cell {\n  text-align: center;\n  vertical-align: middle;\n  display: table-cell;\n  border-radius: 4px;\n  padding: .5rem .75rem;\n}\n.datepicker .datepicker-table .datepicker-header {\n  display: table-header-group;\n}\n.datepicker .datepicker-table .datepicker-header .datepicker-cell {\n  color: #9babb4;\n  font-weight: 600;\n}\n.datepicker .datepicker-table .datepicker-body {\n  display: table-row-group;\n}\n.datepicker .datepicker-table .datepicker-body .datepicker-row {\n  display: table-row;\n}\n.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-unselectable {\n  color: #b5b5b5;\n}\n.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-today {\n  border: solid 1px rgba(33, 150, 243, .5);\n}\n.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-selectable {\n  color: #4a4a4a;\n}\n.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-selectable:hover:not(.is-selected),\n.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-selectable:focus:not(.is-selected) {\n  background-color: whitesmoke;\n  color: #0a0a0a;\n  cursor: pointer;\n}\n.datepicker .datepicker-table .datepicker-body .datepicker-row .datepicker-cell.is-selected {\n  background-color: #2196f3;\n  color: #fff;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell {\n  padding: .3rem .75rem .75rem;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event {\n  position: relative;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events {\n  bottom: .425rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  left: 0;\n  padding: 0 .35rem;\n  position: absolute;\n  width: 100%;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-white {\n  background-color: white;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-black {\n  background-color: #0a0a0a;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-grey {\n  background-color: #9babb4;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-blue {\n  background-color: #3b5998;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-blue-dark {\n  background-color: #3b5998;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-light {\n  background-color: whitesmoke;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-dark {\n  background-color: #363636;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-primary {\n  background-color: #2196f3;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-info {\n  background-color: #3b5998;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-success {\n  background-color: #2ab27b;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-warning {\n  background-color: #ffdd57;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event .events .event.is-danger {\n  background-color: #dc5b5b;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event.dots .event {\n  border-radius: 50%;\n  height: .35em;\n  margin: 0 .1em;\n  width: .35em;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.has-event.bars .event {\n  height: .25em;\n  width: 100%;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.is-selected {\n  overflow: hidden;\n}\n.datepicker .datepicker-table .datepicker-body.has-events .datepicker-cell.is-selected .events .event.is-primary {\n  background-color: #6ab8f7;\n}\n.datepicker.is-small {\n  border-radius: 2px;\n  font-size: .75rem;\n}\n.datepicker.is-medium {\n  font-size: 1.25rem;\n}\n.datepicker.is-large {\n  font-size: 1.5rem;\n}\n@media screen and (min-width: 769px) and (max-width: 1087px) {\n.datepicker .datepicker-content {\n    height: 19.75rem;\n}\n.datepicker .datepicker-table .datepicker-cell {\n    padding: .75rem 1rem;\n}\n}\n@media screen and (max-width: 768px) {\n.datepicker .datepicker-content {\n    height: 12.75rem;\n}\n.datepicker .datepicker-table .datepicker-cell {\n    padding: .25rem .5rem;\n}\n}\n.dialog .modal-card {\n  max-width: 460px;\n  width: auto;\n}\n.dialog .modal-card .modal-card-head {\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n.dialog .modal-card .modal-card-body .field {\n  margin-top: 16px;\n}\n.dialog .modal-card .modal-card-body.is-titleless {\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n}\n.dialog .modal-card .modal-card-foot {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n.dialog .modal-card .modal-card-foot .button {\n  display: inline;\n  min-width: 5em;\n  font-weight: 600;\n}\n@media screen and (min-width: 769px), print {\n.dialog .modal-card {\n    min-width: 320px;\n}\n}\n.dialog.is-small .modal-card,\n.dialog.is-small .input,\n.dialog.is-small .taginput .taginput-container.is-focusable,\n.taginput .dialog.is-small .taginput-container.is-focusable,\n.dialog.is-small .button {\n  border-radius: 2px;\n  font-size: .75rem;\n}\n.dialog.is-medium .modal-card,\n.dialog.is-medium .input,\n.dialog.is-medium .taginput .taginput-container.is-focusable,\n.taginput .dialog.is-medium .taginput-container.is-focusable,\n.dialog.is-medium .button {\n  font-size: 1.25rem;\n}\n.dialog.is-large .modal-card,\n.dialog.is-large .input,\n.dialog.is-large .taginput .taginput-container.is-focusable,\n.taginput .dialog.is-large .taginput-container.is-focusable,\n.dialog.is-large .button {\n  font-size: 1.5rem;\n}\n.dropdown + .dropdown {\n  margin-left: .5em;\n}\n.dropdown .background {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  position: fixed;\n  background-color: rgba(10, 10, 10, .86);\n  z-index: 10;\n  cursor: pointer;\n}\n@media screen and (min-width: 1088px) {\n.dropdown .background {\n    display: none;\n}\n}\n.dropdown .dropdown-menu .dropdown-item.is-disabled,\n.dropdown .dropdown-menu .has-link a.is-disabled {\n  cursor: not-allowed;\n}\n.dropdown .dropdown-menu .dropdown-item.is-disabled:hover,\n.dropdown .dropdown-menu .has-link a.is-disabled:hover {\n  background: inherit;\n  color: inherit;\n}\n.dropdown .dropdown-menu .has-link a {\n  padding-right: 3rem;\n  white-space: nowrap;\n}\n.dropdown:not(.is-disabled) .dropdown-menu .dropdown-item.is-disabled,\n.dropdown:not(.is-disabled) .dropdown-menu .has-link a.is-disabled {\n  opacity: .5;\n}\n.dropdown .navbar-item {\n  height: 100%;\n}\n.dropdown.is-disabled {\n  opacity: .5;\n  cursor: not-allowed;\n}\n.dropdown.is-disabled .dropdown-trigger {\n  pointer-events: none;\n}\n.dropdown.is-inline .dropdown-menu {\n  position: static;\n  display: inline-block;\n  padding: 0;\n}\n.dropdown.is-top-right .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n}\n.dropdown.is-top-left .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  right: 0;\n  left: auto;\n}\n.dropdown.is-bottom-left .dropdown-menu {\n  right: 0;\n  left: auto;\n}\n@media screen and (max-width: 1087px) {\n.dropdown.is-mobile-modal .dropdown-menu {\n    position: fixed;\n    width: calc(100vw - 40px);\n    max-width: 460px;\n    max-height: calc(100vh - 120px);\n    top: 25% !important;\n    left: 50% !important;\n    bottom: auto !important;\n    right: auto !important;\n    -webkit-transform: translate3d(-50%, -25%, 0);\n            transform: translate3d(-50%, -25%, 0);\n    white-space: normal;\n    overflow-y: auto;\n}\n.dropdown.is-mobile-modal .dropdown-menu .dropdown-item,\n  .dropdown.is-mobile-modal .dropdown-menu .has-link a {\n    padding: 1rem 1.5rem;\n}\n}\n.label {\n  font-weight: 600;\n}\n.field.is-grouped .field {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n.field.is-grouped .field:not(:last-child) {\n  margin-right: .75rem;\n}\n.field.is-grouped .field.is-expanded {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  -ms-flex-negative: 1;\n  flex-shrink: 1;\n}\n.field.has-addons .control:first-child .control .button,\n.field.has-addons .control:first-child .control .input,\n.field.has-addons .control:first-child .control .taginput .taginput-container.is-focusable,\n.taginput .field.has-addons .control:first-child .control .taginput-container.is-focusable,\n.field.has-addons .control:first-child .control .select select {\n  border-bottom-left-radius: 4px;\n  border-top-left-radius: 4px;\n}\n.field.has-addons .control:last-child .control .button,\n.field.has-addons .control:last-child .control .input,\n.field.has-addons .control:last-child .control .taginput .taginput-container.is-focusable,\n.taginput .field.has-addons .control:last-child .control .taginput-container.is-focusable,\n.field.has-addons .control:last-child .control .select select {\n  border-bottom-right-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.field.has-addons .control .control .button,\n.field.has-addons .control .control .input,\n.field.has-addons .control .control .taginput .taginput-container.is-focusable,\n.taginput .field.has-addons .control .control .taginput-container.is-focusable,\n.field.has-addons .control .control .select select {\n  border-radius: 0;\n}\n.control .help.counter {\n  float: right;\n  margin-left: .5em;\n}\n.control .icon.is-clickable {\n  pointer-events: auto;\n  cursor: pointer;\n}\n.icon {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: inherit;\n}\n.icon svg {\n  background-color: transparent;\n  fill: currentColor;\n  stroke-width: 0;\n  stroke: currentColor;\n  pointer-events: none;\n  width: 1.5rem;\n  height: 1.5rem;\n}\n.loading-overlay {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: none;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  overflow: hidden;\n}\n.loading-overlay.is-active {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.loading-overlay.is-full-page {\n  z-index: 999;\n  position: fixed;\n}\n.loading-overlay.is-full-page .loading-icon:after {\n  top: calc(50% - 2.5em);\n  left: calc(50% - 2.5em);\n  width: 5em;\n  height: 5em;\n}\n.loading-overlay .loading-background {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  background: #7f7f7f;\n  background: rgba(255, 255, 255, .5);\n}\n.loading-overlay .loading-icon {\n  position: relative;\n}\n.loading-overlay .loading-icon:after {\n  -webkit-animation: spinAround 500ms infinite linear;\n          animation: spinAround 500ms infinite linear;\n  border: 2px solid #dbdbdb;\n  border-radius: 290486px;\n  border-right-color: transparent;\n  border-top-color: transparent;\n  content: \"\";\n  display: block;\n  height: 1em;\n  position: relative;\n  width: 1em;\n  position: absolute;\n  top: calc(50% - 1.5em);\n  left: calc(50% - 1.5em);\n  width: 3em;\n  height: 3em;\n  border-width: .25em;\n}\n.message .media,\n.notification .media {\n  padding-top: 0;\n  border: 0;\n}\n.notification > .delete {\n  right: .5rem !important;\n  top: .5rem !important;\n}\n.modal .animation-content {\n  margin: 0 20px;\n}\n.modal .animation-content .modal-card {\n  margin: 0;\n}\n@media screen and (max-width: 768px) {\n.modal .animation-content {\n    width: 100%;\n}\n}\n.modal .modal-content {\n  width: 100%;\n}\n.notices {\n  position: fixed;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 2em;\n  overflow: hidden;\n  z-index: 1000;\n  pointer-events: none;\n}\n.notices .toast {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-animation-duration: 150ms;\n          animation-duration: 150ms;\n  margin: .5em 0;\n  text-align: center;\n  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);\n          box-shadow: 0 1px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);\n  border-radius: 2em;\n  padding: .75em 1.5em;\n  pointer-events: auto;\n  opacity: .92;\n}\n.notices .toast.is-white {\n  color: #0a0a0a;\n  background: white;\n}\n.notices .toast.is-black {\n  color: white;\n  background: #0a0a0a;\n}\n.notices .toast.is-grey {\n  color: #fff;\n  background: #9babb4;\n}\n.notices .toast.is-blue {\n  color: #fff;\n  background: #3b5998;\n}\n.notices .toast.is-blue-dark {\n  color: #fff;\n  background: #3b5998;\n}\n.notices .toast.is-light {\n  color: #363636;\n  background: whitesmoke;\n}\n.notices .toast.is-dark {\n  color: whitesmoke;\n  background: #363636;\n}\n.notices .toast.is-primary {\n  color: #fff;\n  background: #2196f3;\n}\n.notices .toast.is-info {\n  color: #fff;\n  background: #3b5998;\n}\n.notices .toast.is-success {\n  color: #fff;\n  background: #2ab27b;\n}\n.notices .toast.is-warning {\n  color: rgba(0, 0, 0, .7);\n  background: #ffdd57;\n}\n.notices .toast.is-danger {\n  color: #fff;\n  background: #dc5b5b;\n}\n.notices .snackbar {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: distribute;\n  justify-content: space-around;\n  -webkit-animation-duration: 150ms;\n          animation-duration: 150ms;\n  margin: .5em 0;\n  -webkit-box-shadow: 0 1px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);\n          box-shadow: 0 1px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);\n  border-radius: 4px;\n  pointer-events: auto;\n  background: #363636;\n  color: whitesmoke;\n  min-height: 3em;\n}\n.notices .snackbar .text {\n  padding: .5em 1em;\n}\n.notices .snackbar .action {\n  margin-left: auto;\n  padding: .5em;\n  padding-left: 0;\n}\n.notices .snackbar .action .button {\n  font-weight: 600;\n  text-transform: uppercase;\n}\n.notices .snackbar .action.is-white .button {\n  color: white;\n}\n.notices .snackbar .action.is-black .button {\n  color: #0a0a0a;\n}\n.notices .snackbar .action.is-grey .button {\n  color: #9babb4;\n}\n.notices .snackbar .action.is-blue .button {\n  color: #3b5998;\n}\n.notices .snackbar .action.is-blue-dark .button {\n  color: #3b5998;\n}\n.notices .snackbar .action.is-light .button {\n  color: whitesmoke;\n}\n.notices .snackbar .action.is-dark .button {\n  color: #363636;\n}\n.notices .snackbar .action.is-primary .button {\n  color: #2196f3;\n}\n.notices .snackbar .action.is-info .button {\n  color: #3b5998;\n}\n.notices .snackbar .action.is-success .button {\n  color: #2ab27b;\n}\n.notices .snackbar .action.is-warning .button {\n  color: #ffdd57;\n}\n.notices .snackbar .action.is-danger .button {\n  color: #dc5b5b;\n}\n@media screen and (max-width: 768px) {\n.notices .snackbar {\n    width: 100%;\n    margin: 0;\n    border-radius: 0;\n}\n}\n@media screen and (min-width: 769px), print {\n.notices .snackbar {\n    min-width: 350px;\n    max-width: 600px;\n    overflow: hidden;\n}\n}\n.notices .toast.is-top,\n.notices .toast.is-bottom,\n.notices .snackbar.is-top,\n.notices .snackbar.is-bottom {\n  -ms-flex-item-align: center;\n  align-self: center;\n}\n.notices .toast.is-top-right,\n.notices .toast.is-bottom-right,\n.notices .snackbar.is-top-right,\n.notices .snackbar.is-bottom-right {\n  -ms-flex-item-align: end;\n  align-self: flex-end;\n}\n.notices .toast.is-top-left,\n.notices .toast.is-bottom-left,\n.notices .snackbar.is-top-left,\n.notices .snackbar.is-bottom-left {\n  -ms-flex-item-align: start;\n  align-self: flex-start;\n}\n.notices .toast.is-toast,\n.notices .snackbar.is-toast {\n  opacity: .92;\n}\n.notices.is-top {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.notices.is-bottom {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: reverse;\n  -ms-flex-direction: column-reverse;\n      flex-direction: column-reverse;\n}\n.notices.has-custom-container {\n  position: absolute;\n}\n@media screen and (max-width: 768px) {\n.notices {\n    padding: 0;\n    position: fixed !important;\n}\n}\n.pagination .pagination-next,\n.pagination .pagination-previous {\n  padding-left: .25em;\n  padding-right: .25em;\n}\n.pagination .pagination-next.is-disabled,\n.pagination .pagination-previous.is-disabled {\n  pointer-events: none;\n  cursor: not-allowed;\n  opacity: .5;\n}\n.pagination.is-simple {\n  -webkit-box-pack: normal;\n  -ms-flex-pack: normal;\n  justify-content: normal;\n}\n.pagination.is-simple.is-centered {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.pagination.is-simple.is-right {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n.pagination .is-current {\n  pointer-events: none;\n  cursor: not-allowed;\n}\n.b-radio.radio {\n  outline: none;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.b-radio.radio + .radio {\n  margin-left: .5em;\n}\n.b-radio.radio input[type=radio] {\n  position: absolute;\n  left: 0;\n  opacity: 0;\n  outline: none;\n  z-index: -1;\n}\n.b-radio.radio input[type=radio] + .check {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  width: 1.25em;\n  height: 1.25em;\n  border: 2px solid #9babb4;\n  border-radius: 50%;\n  -webkit-transition: background 150ms ease-out;\n          transition: background 150ms ease-out;\n}\n.b-radio.radio input[type=radio] + .check:before {\n  content: \"\";\n  border-radius: 50%;\n  width: .625em;\n  height: .625em;\n  background: #2196f3;\n  -webkit-transform: scale(0);\n          transform: scale(0);\n  -webkit-transition: -webkit-transform 150ms ease-out;\n          transition: -webkit-transform 150ms ease-out;\n          transition: transform 150ms ease-out;\n          transition: transform 150ms ease-out, -webkit-transform 150ms ease-out;\n}\n.b-radio.radio input[type=radio] + .check.is-white:before {\n  background: white;\n}\n.b-radio.radio input[type=radio] + .check.is-black:before {\n  background: #0a0a0a;\n}\n.b-radio.radio input[type=radio] + .check.is-grey:before {\n  background: #9babb4;\n}\n.b-radio.radio input[type=radio] + .check.is-blue:before {\n  background: #3b5998;\n}\n.b-radio.radio input[type=radio] + .check.is-blue-dark:before {\n  background: #3b5998;\n}\n.b-radio.radio input[type=radio] + .check.is-light:before {\n  background: whitesmoke;\n}\n.b-radio.radio input[type=radio] + .check.is-dark:before {\n  background: #363636;\n}\n.b-radio.radio input[type=radio] + .check.is-primary:before {\n  background: #2196f3;\n}\n.b-radio.radio input[type=radio] + .check.is-info:before {\n  background: #3b5998;\n}\n.b-radio.radio input[type=radio] + .check.is-success:before {\n  background: #2ab27b;\n}\n.b-radio.radio input[type=radio] + .check.is-warning:before {\n  background: #ffdd57;\n}\n.b-radio.radio input[type=radio] + .check.is-danger:before {\n  background: #dc5b5b;\n}\n.b-radio.radio input[type=radio]:checked + .check {\n  border-color: #2196f3;\n}\n.b-radio.radio input[type=radio]:checked + .check.is-white {\n  border-color: white;\n}\n.b-radio.radio input[type=radio]:checked + .check.is-black {\n  border-color: #0a0a0a;\n}\n.b-radio.radio input[type=radio]:checked + .check.is-grey {\n  border-color: #9babb4;\n}\n.b-radio.radio input[type=radio]:checked + .check.is-blue {\n  border-color: #3b5998;\n}\n.b-radio.radio input[type=radio]:checked + .check.is-blue-dark {\n  border-color: #3b5998;\n}\n.b-radio.radio input[type=radio]:checked + .check.is-light {\n  border-color: whitesmoke;\n}\n.b-radio.radio input[type=radio]:checked + .check.is-dark {\n  border-color: #363636;\n}\n.b-radio.radio input[type=radio]:checked + .check.is-primary {\n  border-color: #2196f3;\n}\n.b-radio.radio input[type=radio]:checked + .check.is-info {\n  border-color: #3b5998;\n}\n.b-radio.radio input[type=radio]:checked + .check.is-success {\n  border-color: #2ab27b;\n}\n.b-radio.radio input[type=radio]:checked + .check.is-warning {\n  border-color: #ffdd57;\n}\n.b-radio.radio input[type=radio]:checked + .check.is-danger {\n  border-color: #dc5b5b;\n}\n.b-radio.radio input[type=radio]:checked + .check:before {\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n.b-radio.radio .control-label {\n  padding-left: .5em;\n}\n.b-radio.radio[disabled] {\n  opacity: .5;\n}\n.b-radio.radio:hover input[type=radio] + .check {\n  border-color: #2196f3;\n}\n.b-radio.radio:hover input[type=radio] + .check.is-white {\n  border-color: white;\n}\n.b-radio.radio:hover input[type=radio] + .check.is-black {\n  border-color: #0a0a0a;\n}\n.b-radio.radio:hover input[type=radio] + .check.is-grey {\n  border-color: #9babb4;\n}\n.b-radio.radio:hover input[type=radio] + .check.is-blue {\n  border-color: #3b5998;\n}\n.b-radio.radio:hover input[type=radio] + .check.is-blue-dark {\n  border-color: #3b5998;\n}\n.b-radio.radio:hover input[type=radio] + .check.is-light {\n  border-color: whitesmoke;\n}\n.b-radio.radio:hover input[type=radio] + .check.is-dark {\n  border-color: #363636;\n}\n.b-radio.radio:hover input[type=radio] + .check.is-primary {\n  border-color: #2196f3;\n}\n.b-radio.radio:hover input[type=radio] + .check.is-info {\n  border-color: #3b5998;\n}\n.b-radio.radio:hover input[type=radio] + .check.is-success {\n  border-color: #2ab27b;\n}\n.b-radio.radio:hover input[type=radio] + .check.is-warning {\n  border-color: #ffdd57;\n}\n.b-radio.radio:hover input[type=radio] + .check.is-danger {\n  border-color: #dc5b5b;\n}\n.b-radio.radio:focus input[type=radio] + .check {\n  -webkit-box-shadow: 0 0 .5em rgba(155, 171, 180, .8);\n          box-shadow: 0 0 .5em rgba(155, 171, 180, .8);\n}\n.b-radio.radio:focus input[type=radio]:checked + .check {\n  -webkit-box-shadow: 0 0 .5em rgba(33, 150, 243, .8);\n          box-shadow: 0 0 .5em rgba(33, 150, 243, .8);\n}\n.b-radio.radio:focus input[type=radio]:checked + .check.is-white {\n  -webkit-box-shadow: 0 0 .5em rgba(255, 255, 255, .8);\n          box-shadow: 0 0 .5em rgba(255, 255, 255, .8);\n}\n.b-radio.radio:focus input[type=radio]:checked + .check.is-black {\n  -webkit-box-shadow: 0 0 .5em rgba(10, 10, 10, .8);\n          box-shadow: 0 0 .5em rgba(10, 10, 10, .8);\n}\n.b-radio.radio:focus input[type=radio]:checked + .check.is-grey {\n  -webkit-box-shadow: 0 0 .5em rgba(155, 171, 180, .8);\n          box-shadow: 0 0 .5em rgba(155, 171, 180, .8);\n}\n.b-radio.radio:focus input[type=radio]:checked + .check.is-blue {\n  -webkit-box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n          box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n}\n.b-radio.radio:focus input[type=radio]:checked + .check.is-blue-dark {\n  -webkit-box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n          box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n}\n.b-radio.radio:focus input[type=radio]:checked + .check.is-light {\n  -webkit-box-shadow: 0 0 .5em rgba(245, 245, 245, .8);\n          box-shadow: 0 0 .5em rgba(245, 245, 245, .8);\n}\n.b-radio.radio:focus input[type=radio]:checked + .check.is-dark {\n  -webkit-box-shadow: 0 0 .5em rgba(54, 54, 54, .8);\n          box-shadow: 0 0 .5em rgba(54, 54, 54, .8);\n}\n.b-radio.radio:focus input[type=radio]:checked + .check.is-primary {\n  -webkit-box-shadow: 0 0 .5em rgba(33, 150, 243, .8);\n          box-shadow: 0 0 .5em rgba(33, 150, 243, .8);\n}\n.b-radio.radio:focus input[type=radio]:checked + .check.is-info {\n  -webkit-box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n          box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n}\n.b-radio.radio:focus input[type=radio]:checked + .check.is-success {\n  -webkit-box-shadow: 0 0 .5em rgba(42, 178, 123, .8);\n          box-shadow: 0 0 .5em rgba(42, 178, 123, .8);\n}\n.b-radio.radio:focus input[type=radio]:checked + .check.is-warning {\n  -webkit-box-shadow: 0 0 .5em rgba(255, 221, 87, .8);\n          box-shadow: 0 0 .5em rgba(255, 221, 87, .8);\n}\n.b-radio.radio:focus input[type=radio]:checked + .check.is-danger {\n  -webkit-box-shadow: 0 0 .5em rgba(220, 91, 91, .8);\n          box-shadow: 0 0 .5em rgba(220, 91, 91, .8);\n}\n.b-radio.radio.is-small {\n  border-radius: 2px;\n  font-size: .75rem;\n}\n.b-radio.radio.is-medium {\n  font-size: 1.25rem;\n}\n.b-radio.radio.is-large {\n  font-size: 1.5rem;\n}\n.select select {\n  padding-right: 2.5em;\n}\n.select select option {\n  color: #4a4a4a;\n  padding: .25em .5em;\n}\n.select select option:disabled {\n  cursor: not-allowed;\n  opacity: .5;\n}\n.select select optgroup {\n  color: #b5b5b5;\n  font-weight: 400;\n  font-style: normal;\n  padding: .25em 0;\n}\n.select.is-empty select {\n  color: rgba(155, 171, 180, .7);\n}\n.switch {\n  cursor: pointer;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.switch + .switch {\n  margin-left: .5em;\n}\n.switch input[type=checkbox] {\n  position: absolute;\n  left: 0;\n  opacity: 0;\n  outline: none;\n  z-index: -1;\n}\n.switch input[type=checkbox] + .check {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  width: 2.75em;\n  height: 1.575em;\n  padding: .2em;\n  background: #b5b5b5;\n  border-radius: 1em;\n  -webkit-transition: background 150ms ease-out;\n          transition: background 150ms ease-out;\n}\n.switch input[type=checkbox] + .check:before {\n  content: \"\";\n  display: block;\n  border-radius: 1em;\n  width: 1.175em;\n  height: 1.175em;\n  background: whitesmoke;\n  -webkit-box-shadow: 0 3px 1px 0 rgba(0, 0, 0, .05), 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 3px 0 rgba(0, 0, 0, .05);\n          box-shadow: 0 3px 1px 0 rgba(0, 0, 0, .05), 0 2px 2px 0 rgba(0, 0, 0, .1), 0 3px 3px 0 rgba(0, 0, 0, .05);\n  -webkit-transition: width 150ms ease-out, -webkit-transform 150ms ease-out;\n          transition: width 150ms ease-out, -webkit-transform 150ms ease-out;\n          transition: transform 150ms ease-out, width 150ms ease-out;\n          transition: transform 150ms ease-out, width 150ms ease-out, -webkit-transform 150ms ease-out;\n  will-change: transform;\n}\n.switch input[type=checkbox] + .check.is-elastic:before {\n  width: 1.75em;\n}\n.switch input[type=checkbox]:checked + .check {\n  background: #2196f3;\n}\n.switch input[type=checkbox]:checked + .check.is-white {\n  background: white;\n}\n.switch input[type=checkbox]:checked + .check.is-black {\n  background: #0a0a0a;\n}\n.switch input[type=checkbox]:checked + .check.is-grey {\n  background: #9babb4;\n}\n.switch input[type=checkbox]:checked + .check.is-blue {\n  background: #3b5998;\n}\n.switch input[type=checkbox]:checked + .check.is-blue-dark {\n  background: #3b5998;\n}\n.switch input[type=checkbox]:checked + .check.is-light {\n  background: whitesmoke;\n}\n.switch input[type=checkbox]:checked + .check.is-dark {\n  background: #363636;\n}\n.switch input[type=checkbox]:checked + .check.is-primary {\n  background: #2196f3;\n}\n.switch input[type=checkbox]:checked + .check.is-info {\n  background: #3b5998;\n}\n.switch input[type=checkbox]:checked + .check.is-success {\n  background: #2ab27b;\n}\n.switch input[type=checkbox]:checked + .check.is-warning {\n  background: #ffdd57;\n}\n.switch input[type=checkbox]:checked + .check.is-danger {\n  background: #dc5b5b;\n}\n.switch input[type=checkbox]:checked + .check:before {\n  -webkit-transform: translate3d(100%, 0, 0);\n          transform: translate3d(100%, 0, 0);\n}\n.switch input[type=checkbox]:checked + .check.is-elastic:before {\n  -webkit-transform: translate3d(36.36364%, 0, 0);\n          transform: translate3d(36.36364%, 0, 0);\n}\n.switch .control-label {\n  padding-left: .5em;\n}\n.switch:hover input[type=checkbox] + .check {\n  background: rgba(181, 181, 181, .9);\n}\n.switch:hover input[type=checkbox]:checked + .check {\n  background: rgba(33, 150, 243, .9);\n}\n.switch:hover input[type=checkbox]:checked + .check.is-white {\n  background: rgba(255, 255, 255, .9);\n}\n.switch:hover input[type=checkbox]:checked + .check.is-black {\n  background: rgba(10, 10, 10, .9);\n}\n.switch:hover input[type=checkbox]:checked + .check.is-grey {\n  background: rgba(155, 171, 180, .9);\n}\n.switch:hover input[type=checkbox]:checked + .check.is-blue {\n  background: rgba(59, 89, 152, .9);\n}\n.switch:hover input[type=checkbox]:checked + .check.is-blue-dark {\n  background: rgba(59, 89, 152, .9);\n}\n.switch:hover input[type=checkbox]:checked + .check.is-light {\n  background: rgba(245, 245, 245, .9);\n}\n.switch:hover input[type=checkbox]:checked + .check.is-dark {\n  background: rgba(54, 54, 54, .9);\n}\n.switch:hover input[type=checkbox]:checked + .check.is-primary {\n  background: rgba(33, 150, 243, .9);\n}\n.switch:hover input[type=checkbox]:checked + .check.is-info {\n  background: rgba(59, 89, 152, .9);\n}\n.switch:hover input[type=checkbox]:checked + .check.is-success {\n  background: rgba(42, 178, 123, .9);\n}\n.switch:hover input[type=checkbox]:checked + .check.is-warning {\n  background: rgba(255, 221, 87, .9);\n}\n.switch:hover input[type=checkbox]:checked + .check.is-danger {\n  background: rgba(220, 91, 91, .9);\n}\n.switch:focus {\n  outline: none;\n}\n.switch:focus input[type=checkbox] + .check {\n  -webkit-box-shadow: 0 0 .5em rgba(155, 171, 180, .6);\n          box-shadow: 0 0 .5em rgba(155, 171, 180, .6);\n}\n.switch:focus input[type=checkbox]:checked + .check {\n  -webkit-box-shadow: 0 0 .5em rgba(33, 150, 243, .8);\n          box-shadow: 0 0 .5em rgba(33, 150, 243, .8);\n}\n.switch:focus input[type=checkbox]:checked + .check.is-white {\n  -webkit-box-shadow: 0 0 .5em rgba(255, 255, 255, .8);\n          box-shadow: 0 0 .5em rgba(255, 255, 255, .8);\n}\n.switch:focus input[type=checkbox]:checked + .check.is-black {\n  -webkit-box-shadow: 0 0 .5em rgba(10, 10, 10, .8);\n          box-shadow: 0 0 .5em rgba(10, 10, 10, .8);\n}\n.switch:focus input[type=checkbox]:checked + .check.is-grey {\n  -webkit-box-shadow: 0 0 .5em rgba(155, 171, 180, .8);\n          box-shadow: 0 0 .5em rgba(155, 171, 180, .8);\n}\n.switch:focus input[type=checkbox]:checked + .check.is-blue {\n  -webkit-box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n          box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n}\n.switch:focus input[type=checkbox]:checked + .check.is-blue-dark {\n  -webkit-box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n          box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n}\n.switch:focus input[type=checkbox]:checked + .check.is-light {\n  -webkit-box-shadow: 0 0 .5em rgba(245, 245, 245, .8);\n          box-shadow: 0 0 .5em rgba(245, 245, 245, .8);\n}\n.switch:focus input[type=checkbox]:checked + .check.is-dark {\n  -webkit-box-shadow: 0 0 .5em rgba(54, 54, 54, .8);\n          box-shadow: 0 0 .5em rgba(54, 54, 54, .8);\n}\n.switch:focus input[type=checkbox]:checked + .check.is-primary {\n  -webkit-box-shadow: 0 0 .5em rgba(33, 150, 243, .8);\n          box-shadow: 0 0 .5em rgba(33, 150, 243, .8);\n}\n.switch:focus input[type=checkbox]:checked + .check.is-info {\n  -webkit-box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n          box-shadow: 0 0 .5em rgba(59, 89, 152, .8);\n}\n.switch:focus input[type=checkbox]:checked + .check.is-success {\n  -webkit-box-shadow: 0 0 .5em rgba(42, 178, 123, .8);\n          box-shadow: 0 0 .5em rgba(42, 178, 123, .8);\n}\n.switch:focus input[type=checkbox]:checked + .check.is-warning {\n  -webkit-box-shadow: 0 0 .5em rgba(255, 221, 87, .8);\n          box-shadow: 0 0 .5em rgba(255, 221, 87, .8);\n}\n.switch:focus input[type=checkbox]:checked + .check.is-danger {\n  -webkit-box-shadow: 0 0 .5em rgba(220, 91, 91, .8);\n          box-shadow: 0 0 .5em rgba(220, 91, 91, .8);\n}\n.switch.is-small {\n  border-radius: 2px;\n  font-size: .75rem;\n}\n.switch.is-medium {\n  font-size: 1.25rem;\n}\n.switch.is-large {\n  font-size: 1.5rem;\n}\n.switch[disabled] {\n  opacity: .5;\n  cursor: not-allowed;\n  color: #9babb4;\n}\n.table-wrapper .table {\n  margin-bottom: 0;\n}\n.table-wrapper:not(:last-child) {\n  margin-bottom: 1.5rem;\n}\n@media screen and (max-width: 1087px) {\n.table-wrapper {\n    overflow-x: auto;\n}\n}\n.b-table {\n  -webkit-transition: opacity 86ms ease-out;\n          transition: opacity 86ms ease-out;\n}\n@media screen and (min-width: 769px), print {\n.b-table .table-mobile-sort {\n    display: none;\n}\n}\n.b-table .icon {\n  -webkit-transition: opacity 86ms ease-out, -webkit-transform 150ms ease-out;\n          transition: opacity 86ms ease-out, -webkit-transform 150ms ease-out;\n          transition: transform 150ms ease-out, opacity 86ms ease-out;\n          transition: transform 150ms ease-out, opacity 86ms ease-out, -webkit-transform 150ms ease-out;\n}\n.b-table .icon.is-desc {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n.b-table .icon.is-expanded {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.b-table .table {\n  width: 100%;\n  border: 1px solid transparent;\n  border-radius: 4px;\n  border-collapse: separate;\n}\n.b-table .table th {\n  font-weight: 600;\n}\n.b-table .table th .th-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.b-table .table th .th-wrap .icon {\n  margin-left: .5rem;\n  margin-right: 0;\n  font-size: 1rem;\n}\n.b-table .table th .th-wrap.is-numeric {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n  -ms-flex-direction: row-reverse;\n      flex-direction: row-reverse;\n  text-align: right;\n}\n.b-table .table th .th-wrap.is-numeric .icon {\n  margin-left: 0;\n  margin-right: .5rem;\n}\n.b-table .table th .th-wrap.is-centered {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  text-align: center;\n}\n.b-table .table th.is-current-sort {\n  border-color: #9babb4;\n  font-weight: 700;\n}\n.b-table .table th.is-sortable:hover {\n  border-color: #9babb4;\n}\n.b-table .table th.is-sortable,\n.b-table .table th.is-sortable .th-wrap {\n  cursor: pointer;\n}\n.b-table .table tr.is-selected .checkbox input:checked + .check {\n  background: #fff url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1 1'%3E%3Cpath style='fill:%232196F3' d='M 0.04038059,0.6267767 0.14644661,0.52071068 0.42928932,0.80355339 0.3232233,0.90961941 z M 0.21715729,0.80355339 0.85355339,0.16715729 0.95961941,0.2732233 0.3232233,0.90961941 z'%3E%3C/path%3E%3C/svg%3E\") no-repeat center center;\n}\n.b-table .table tr.is-selected .checkbox input + .check {\n  border-color: #fff;\n}\n.b-table .table tr.is-empty:hover {\n  background-color: transparent;\n}\n.b-table .table .chevron-cell {\n  vertical-align: middle;\n}\n.b-table .table .checkbox-cell {\n  width: 40px;\n}\n.b-table .table .checkbox-cell .checkbox {\n  vertical-align: middle;\n}\n.b-table .table .checkbox-cell .checkbox .check {\n  -webkit-transition: none;\n          transition: none;\n}\n.b-table .table tr.detail {\n  -webkit-box-shadow: inset 0 1px 3px #dbdbdb;\n          box-shadow: inset 0 1px 3px #dbdbdb;\n  background: #fafafa;\n}\n.b-table .table tr.detail .detail-container {\n  padding: 1rem;\n}\n.b-table .table:focus {\n  border-color: #2196f3;\n  -webkit-box-shadow: 0 0 0 .125em rgba(33, 150, 243, .25);\n          box-shadow: 0 0 0 .125em rgba(33, 150, 243, .25);\n}\n.b-table .table.is-bordered th.is-current-sort,\n.b-table .table.is-bordered th.is-sortable:hover {\n  border-color: #dbdbdb;\n  background: whitesmoke;\n}\n@media screen and (max-width: 768px) {\n.b-table .table.has-mobile-cards thead {\n    display: none;\n}\n.b-table .table.has-mobile-cards tfoot th {\n    border: 0;\n    display: inherit;\n}\n.b-table .table.has-mobile-cards tr {\n    -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);\n            box-shadow: 0 2px 3px rgba(10, 10, 10, .1), 0 0 0 1px rgba(10, 10, 10, .1);\n    max-width: 100%;\n    position: relative;\n    display: block;\n}\n.b-table .table.has-mobile-cards tr td {\n    border: 0;\n    display: inherit;\n}\n.b-table .table.has-mobile-cards tr td:last-child {\n    border-bottom: 0;\n}\n.b-table .table.has-mobile-cards tr:not(:last-child) {\n    margin-bottom: 1rem;\n}\n.b-table .table.has-mobile-cards tr:not([class*=\"is-\"]) {\n    background: inherit;\n}\n.b-table .table.has-mobile-cards tr:not([class*=\"is-\"]):hover {\n    background-color: inherit;\n}\n.b-table .table.has-mobile-cards tr.detail {\n    margin-top: -1rem;\n}\n.b-table .table.has-mobile-cards tr:not(.detail):not(.is-empty):not(.table-footer) td {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    width: auto;\n    -webkit-box-pack: justify;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    text-align: right;\n    border-bottom: 1px solid whitesmoke;\n}\n.b-table .table.has-mobile-cards tr:not(.detail):not(.is-empty):not(.table-footer) td:before {\n    content: attr(data-label);\n    font-weight: 600;\n    padding-right: .5em;\n    text-align: left;\n}\n}\n.b-table .level {\n  padding-bottom: 1.5rem;\n}\n.b-table.is-loading {\n  position: relative;\n  pointer-events: none;\n  opacity: .5;\n}\n.b-table.is-loading:after {\n  -webkit-animation: spinAround 500ms infinite linear;\n          animation: spinAround 500ms infinite linear;\n  border: 2px solid #dbdbdb;\n  border-radius: 290486px;\n  border-right-color: transparent;\n  border-top-color: transparent;\n  content: \"\";\n  display: block;\n  height: 1em;\n  position: relative;\n  width: 1em;\n  position: absolute;\n  top: 4em;\n  left: calc(50% - 2.5em);\n  width: 5em;\n  height: 5em;\n  border-width: .25em;\n}\n.b-tabs .tabs {\n  margin-bottom: 0;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n.b-tabs .is-disabled {\n  pointer-events: none;\n  cursor: not-allowed;\n  opacity: .5;\n}\n.b-tabs .tab-content {\n  position: relative;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding: 1rem;\n}\n.b-tabs .tab-content .tab-item {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  -ms-flex-preferred-size: auto;\n  flex-basis: auto;\n}\n.b-tabs:not(:last-child) {\n  margin-bottom: 1.5rem;\n}\n.b-tabs.is-fullwidth {\n  width: 100%;\n}\n.tag .has-ellipsis {\n  max-width: 10em;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.taginput .taginput-container.is-focusable {\n  padding-bottom: 0;\n  padding-top: calc(.275em - 1px);\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  height: auto;\n  cursor: text;\n}\n.taginput .taginput-container > .tag,\n.taginput .taginput-container > .tags {\n  margin-bottom: calc(.275em - 1px);\n  font-size: .9em;\n  height: 1.7em;\n}\n.taginput .taginput-container > .tag .tag,\n.taginput .taginput-container > .tags .tag {\n  margin-bottom: 0;\n  font-size: .9em;\n  height: 1.7em;\n}\n.taginput .taginput-container > .tag:not(:last-child),\n.taginput .taginput-container > .tags:not(:last-child) {\n  margin-right: .275rem;\n}\n.taginput .taginput-container .autocomplete {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n      flex: 1;\n}\n.taginput .taginput-container .autocomplete input {\n  height: 1.7em;\n  margin-bottom: calc(.275em - 1px);\n  padding-top: 0;\n  padding-bottom: 0;\n  border: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  min-width: 8em;\n}\n.taginput .taginput-container .autocomplete input:focus {\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n}\n.taginput .taginput-container .autocomplete .icon {\n  height: 1.7em;\n}\n.taginput .taginput-container .autocomplete > .control.is-loading::after {\n  top: .375em;\n}\n.timepicker .dropdown-menu {\n  min-width: 0;\n}\n.timepicker .dropdown,\n.timepicker .dropdown-trigger {\n  width: 100%;\n}\n.timepicker .dropdown-item,\n.timepicker .dropdown .dropdown-menu .has-link a,\n.dropdown .dropdown-menu .has-link .timepicker a {\n  font-size: inherit;\n  padding: 0;\n}\n.timepicker .timepicker-footer {\n  padding: 0 .5rem 0 .5rem;\n}\n.timepicker .dropdown-content .control {\n  font-size: 1.25em;\n  margin-right: 0 !important;\n}\n.timepicker .dropdown-content .control .select select {\n  font-weight: 600;\n  padding-right: calc(.625em - 1px);\n  border: 0;\n}\n.timepicker .dropdown-content .control .select select option:disabled {\n  color: rgba(155, 171, 180, .7);\n}\n.timepicker .dropdown-content .control .select:after {\n  display: none;\n}\n.timepicker .dropdown-content .control.is-colon {\n  font-size: 1.7em;\n}\n.timepicker.is-small {\n  border-radius: 2px;\n  font-size: .75rem;\n}\n.timepicker.is-medium {\n  font-size: 1.25rem;\n}\n.timepicker.is-large {\n  font-size: 1.5rem;\n}\n.b-tooltip {\n  position: relative;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n.b-tooltip.is-top:before,\n.b-tooltip.is-top:after {\n  top: auto;\n  right: auto;\n  bottom: calc(100% + 5px + 2px);\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n.b-tooltip.is-top.is-white:before {\n  border-top: 5px solid white;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  bottom: calc(100% + 2px);\n}\n.b-tooltip.is-top.is-black:before {\n  border-top: 5px solid #0a0a0a;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  bottom: calc(100% + 2px);\n}\n.b-tooltip.is-top.is-grey:before {\n  border-top: 5px solid #9babb4;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  bottom: calc(100% + 2px);\n}\n.b-tooltip.is-top.is-blue:before {\n  border-top: 5px solid #3b5998;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  bottom: calc(100% + 2px);\n}\n.b-tooltip.is-top.is-blue-dark:before {\n  border-top: 5px solid #3b5998;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  bottom: calc(100% + 2px);\n}\n.b-tooltip.is-top.is-light:before {\n  border-top: 5px solid whitesmoke;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  bottom: calc(100% + 2px);\n}\n.b-tooltip.is-top.is-dark:before {\n  border-top: 5px solid #363636;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  bottom: calc(100% + 2px);\n}\n.b-tooltip.is-top.is-primary:before {\n  border-top: 5px solid #2196f3;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  bottom: calc(100% + 2px);\n}\n.b-tooltip.is-top.is-info:before {\n  border-top: 5px solid #3b5998;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  bottom: calc(100% + 2px);\n}\n.b-tooltip.is-top.is-success:before {\n  border-top: 5px solid #2ab27b;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  bottom: calc(100% + 2px);\n}\n.b-tooltip.is-top.is-warning:before {\n  border-top: 5px solid #ffdd57;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  bottom: calc(100% + 2px);\n}\n.b-tooltip.is-top.is-danger:before {\n  border-top: 5px solid #dc5b5b;\n  border-right: 5px solid transparent;\n  border-left: 5px solid transparent;\n  bottom: calc(100% + 2px);\n}\n.b-tooltip.is-top.is-multiline.is-small:after {\n  width: 180px;\n}\n.b-tooltip.is-top.is-multiline.is-medium:after {\n  width: 240px;\n}\n.b-tooltip.is-top.is-multiline.is-large:after {\n  width: 300px;\n}\n.b-tooltip.is-right:before,\n.b-tooltip.is-right:after {\n  top: 50%;\n  right: auto;\n  bottom: auto;\n  left: calc(100% + 5px + 2px);\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n}\n.b-tooltip.is-right.is-white:before {\n  border-top: 5px solid transparent;\n  border-right: 5px solid white;\n  border-bottom: 5px solid transparent;\n  left: calc(100% + 2px);\n}\n.b-tooltip.is-right.is-black:before {\n  border-top: 5px solid transparent;\n  border-right: 5px solid #0a0a0a;\n  border-bottom: 5px solid transparent;\n  left: calc(100% + 2px);\n}\n.b-tooltip.is-right.is-grey:before {\n  border-top: 5px solid transparent;\n  border-right: 5px solid #9babb4;\n  border-bottom: 5px solid transparent;\n  left: calc(100% + 2px);\n}\n.b-tooltip.is-right.is-blue:before {\n  border-top: 5px solid transparent;\n  border-right: 5px solid #3b5998;\n  border-bottom: 5px solid transparent;\n  left: calc(100% + 2px);\n}\n.b-tooltip.is-right.is-blue-dark:before {\n  border-top: 5px solid transparent;\n  border-right: 5px solid #3b5998;\n  border-bottom: 5px solid transparent;\n  left: calc(100% + 2px);\n}\n.b-tooltip.is-right.is-light:before {\n  border-top: 5px solid transparent;\n  border-right: 5px solid whitesmoke;\n  border-bottom: 5px solid transparent;\n  left: calc(100% + 2px);\n}\n.b-tooltip.is-right.is-dark:before {\n  border-top: 5px solid transparent;\n  border-right: 5px solid #363636;\n  border-bottom: 5px solid transparent;\n  left: calc(100% + 2px);\n}\n.b-tooltip.is-right.is-primary:before {\n  border-top: 5px solid transparent;\n  border-right: 5px solid #2196f3;\n  border-bottom: 5px solid transparent;\n  left: calc(100% + 2px);\n}\n.b-tooltip.is-right.is-info:before {\n  border-top: 5px solid transparent;\n  border-right: 5px solid #3b5998;\n  border-bottom: 5px solid transparent;\n  left: calc(100% + 2px);\n}\n.b-tooltip.is-right.is-success:before {\n  border-top: 5px solid transparent;\n  border-right: 5px solid #2ab27b;\n  border-bottom: 5px solid transparent;\n  left: calc(100% + 2px);\n}\n.b-tooltip.is-right.is-warning:before {\n  border-top: 5px solid transparent;\n  border-right: 5px solid #ffdd57;\n  border-bottom: 5px solid transparent;\n  left: calc(100% + 2px);\n}\n.b-tooltip.is-right.is-danger:before {\n  border-top: 5px solid transparent;\n  border-right: 5px solid #dc5b5b;\n  border-bottom: 5px solid transparent;\n  left: calc(100% + 2px);\n}\n.b-tooltip.is-right.is-multiline.is-small:after {\n  width: 180px;\n}\n.b-tooltip.is-right.is-multiline.is-medium:after {\n  width: 240px;\n}\n.b-tooltip.is-right.is-multiline.is-large:after {\n  width: 300px;\n}\n.b-tooltip.is-bottom:before,\n.b-tooltip.is-bottom:after {\n  top: calc(100% + 5px + 2px);\n  right: auto;\n  bottom: auto;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\n.b-tooltip.is-bottom.is-white:before {\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid white;\n  border-left: 5px solid transparent;\n  top: calc(100% + 2px);\n}\n.b-tooltip.is-bottom.is-black:before {\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid #0a0a0a;\n  border-left: 5px solid transparent;\n  top: calc(100% + 2px);\n}\n.b-tooltip.is-bottom.is-grey:before {\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid #9babb4;\n  border-left: 5px solid transparent;\n  top: calc(100% + 2px);\n}\n.b-tooltip.is-bottom.is-blue:before {\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid #3b5998;\n  border-left: 5px solid transparent;\n  top: calc(100% + 2px);\n}\n.b-tooltip.is-bottom.is-blue-dark:before {\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid #3b5998;\n  border-left: 5px solid transparent;\n  top: calc(100% + 2px);\n}\n.b-tooltip.is-bottom.is-light:before {\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid whitesmoke;\n  border-left: 5px solid transparent;\n  top: calc(100% + 2px);\n}\n.b-tooltip.is-bottom.is-dark:before {\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid #363636;\n  border-left: 5px solid transparent;\n  top: calc(100% + 2px);\n}\n.b-tooltip.is-bottom.is-primary:before {\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid #2196f3;\n  border-left: 5px solid transparent;\n  top: calc(100% + 2px);\n}\n.b-tooltip.is-bottom.is-info:before {\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid #3b5998;\n  border-left: 5px solid transparent;\n  top: calc(100% + 2px);\n}\n.b-tooltip.is-bottom.is-success:before {\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid #2ab27b;\n  border-left: 5px solid transparent;\n  top: calc(100% + 2px);\n}\n.b-tooltip.is-bottom.is-warning:before {\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid #ffdd57;\n  border-left: 5px solid transparent;\n  top: calc(100% + 2px);\n}\n.b-tooltip.is-bottom.is-danger:before {\n  border-right: 5px solid transparent;\n  border-bottom: 5px solid #dc5b5b;\n  border-left: 5px solid transparent;\n  top: calc(100% + 2px);\n}\n.b-tooltip.is-bottom.is-multiline.is-small:after {\n  width: 180px;\n}\n.b-tooltip.is-bottom.is-multiline.is-medium:after {\n  width: 240px;\n}\n.b-tooltip.is-bottom.is-multiline.is-large:after {\n  width: 300px;\n}\n.b-tooltip.is-left:before,\n.b-tooltip.is-left:after {\n  top: 50%;\n  right: calc(100% + 5px + 2px);\n  bottom: auto;\n  left: auto;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n}\n.b-tooltip.is-left.is-white:before {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid white;\n  right: calc(100% + 2px);\n}\n.b-tooltip.is-left.is-black:before {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid #0a0a0a;\n  right: calc(100% + 2px);\n}\n.b-tooltip.is-left.is-grey:before {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid #9babb4;\n  right: calc(100% + 2px);\n}\n.b-tooltip.is-left.is-blue:before {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid #3b5998;\n  right: calc(100% + 2px);\n}\n.b-tooltip.is-left.is-blue-dark:before {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid #3b5998;\n  right: calc(100% + 2px);\n}\n.b-tooltip.is-left.is-light:before {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid whitesmoke;\n  right: calc(100% + 2px);\n}\n.b-tooltip.is-left.is-dark:before {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid #363636;\n  right: calc(100% + 2px);\n}\n.b-tooltip.is-left.is-primary:before {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid #2196f3;\n  right: calc(100% + 2px);\n}\n.b-tooltip.is-left.is-info:before {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid #3b5998;\n  right: calc(100% + 2px);\n}\n.b-tooltip.is-left.is-success:before {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid #2ab27b;\n  right: calc(100% + 2px);\n}\n.b-tooltip.is-left.is-warning:before {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid #ffdd57;\n  right: calc(100% + 2px);\n}\n.b-tooltip.is-left.is-danger:before {\n  border-top: 5px solid transparent;\n  border-bottom: 5px solid transparent;\n  border-left: 5px solid #dc5b5b;\n  right: calc(100% + 2px);\n}\n.b-tooltip.is-left.is-multiline.is-small:after {\n  width: 180px;\n}\n.b-tooltip.is-left.is-multiline.is-medium:after {\n  width: 240px;\n}\n.b-tooltip.is-left.is-multiline.is-large:after {\n  width: 300px;\n}\n.b-tooltip:before,\n.b-tooltip:after {\n  position: absolute;\n  content: \"\";\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n}\n.b-tooltip:before {\n  z-index: 889;\n}\n.b-tooltip:after {\n  content: attr(data-label);\n  width: auto;\n  padding: .35rem .75rem;\n  border-radius: 6px;\n  font-size: .85rem;\n  font-weight: 400;\n  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 1, 0, .2);\n          box-shadow: 0 1px 2px 1px rgba(0, 1, 0, .2);\n  z-index: 888;\n  white-space: nowrap;\n}\n.b-tooltip:not([data-label=\"\"]):hover:before,\n.b-tooltip:not([data-label=\"\"]):hover:after {\n  opacity: 1;\n  visibility: visible;\n}\n.b-tooltip.is-white:after {\n  background: white;\n  color: #0a0a0a;\n}\n.b-tooltip.is-black:after {\n  background: #0a0a0a;\n  color: white;\n}\n.b-tooltip.is-grey:after {\n  background: #9babb4;\n  color: #fff;\n}\n.b-tooltip.is-blue:after {\n  background: #3b5998;\n  color: #fff;\n}\n.b-tooltip.is-blue-dark:after {\n  background: #3b5998;\n  color: #fff;\n}\n.b-tooltip.is-light:after {\n  background: whitesmoke;\n  color: #363636;\n}\n.b-tooltip.is-dark:after {\n  background: #363636;\n  color: whitesmoke;\n}\n.b-tooltip.is-primary:after {\n  background: #2196f3;\n  color: #fff;\n}\n.b-tooltip.is-info:after {\n  background: #3b5998;\n  color: #fff;\n}\n.b-tooltip.is-success:after {\n  background: #2ab27b;\n  color: #fff;\n}\n.b-tooltip.is-warning:after {\n  background: #ffdd57;\n  color: rgba(0, 0, 0, .7);\n}\n.b-tooltip.is-danger:after {\n  background: #dc5b5b;\n  color: #fff;\n}\n.b-tooltip:not([data-label=\"\"]).is-always:before,\n.b-tooltip:not([data-label=\"\"]).is-always:after {\n  opacity: 1;\n  visibility: visible;\n}\n.b-tooltip.is-multiline:after {\n  display: flex-block;\n  text-align: center;\n  white-space: normal;\n}\n.b-tooltip.is-dashed {\n  border-bottom: 1px dashed #b5b5b5;\n  cursor: default;\n}\n.b-tooltip.is-square:after {\n  border-radius: 0;\n}\n.b-tooltip.is-animated:before,\n.b-tooltip.is-animated:after {\n  -webkit-transition: opacity 86ms ease-out, visibility 86ms ease-out;\n          transition: opacity 86ms ease-out, visibility 86ms ease-out;\n}\n.upload {\n  position: relative;\n}\n.upload input[type=file] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  opacity: 0;\n  outline: none;\n  z-index: -1;\n}\n.upload .upload-draggable {\n  display: inline-block;\n  cursor: pointer;\n  padding: .25em;\n  border: 1px dashed #b5b5b5;\n  border-radius: 6px;\n}\n.upload .upload-draggable.is-disabled {\n  opacity: .5;\n  cursor: not-allowed;\n}\n.upload .upload-draggable.is-loading {\n  position: relative;\n  pointer-events: none;\n  opacity: .5;\n}\n.upload .upload-draggable.is-loading:after {\n  -webkit-animation: spinAround 500ms infinite linear;\n          animation: spinAround 500ms infinite linear;\n  border: 2px solid #dbdbdb;\n  border-radius: 290486px;\n  border-right-color: transparent;\n  border-top-color: transparent;\n  content: \"\";\n  display: block;\n  height: 1em;\n  position: relative;\n  width: 1em;\n  top: 0;\n  left: calc(50% - 1.5em);\n  width: 3em;\n  height: 3em;\n  border-width: .25em;\n}\n.upload .upload-draggable:hover.is-white,\n.upload .upload-draggable.is-hovered.is-white {\n  border-color: white;\n  background: rgba(255, 255, 255, .05);\n}\n.upload .upload-draggable:hover.is-black,\n.upload .upload-draggable.is-hovered.is-black {\n  border-color: #0a0a0a;\n  background: rgba(10, 10, 10, .05);\n}\n.upload .upload-draggable:hover.is-grey,\n.upload .upload-draggable.is-hovered.is-grey {\n  border-color: #9babb4;\n  background: rgba(155, 171, 180, .05);\n}\n.upload .upload-draggable:hover.is-blue,\n.upload .upload-draggable.is-hovered.is-blue {\n  border-color: #3b5998;\n  background: rgba(59, 89, 152, .05);\n}\n.upload .upload-draggable:hover.is-blue-dark,\n.upload .upload-draggable.is-hovered.is-blue-dark {\n  border-color: #3b5998;\n  background: rgba(59, 89, 152, .05);\n}\n.upload .upload-draggable:hover.is-light,\n.upload .upload-draggable.is-hovered.is-light {\n  border-color: whitesmoke;\n  background: rgba(245, 245, 245, .05);\n}\n.upload .upload-draggable:hover.is-dark,\n.upload .upload-draggable.is-hovered.is-dark {\n  border-color: #363636;\n  background: rgba(54, 54, 54, .05);\n}\n.upload .upload-draggable:hover.is-primary,\n.upload .upload-draggable.is-hovered.is-primary {\n  border-color: #2196f3;\n  background: rgba(33, 150, 243, .05);\n}\n.upload .upload-draggable:hover.is-info,\n.upload .upload-draggable.is-hovered.is-info {\n  border-color: #3b5998;\n  background: rgba(59, 89, 152, .05);\n}\n.upload .upload-draggable:hover.is-success,\n.upload .upload-draggable.is-hovered.is-success {\n  border-color: #2ab27b;\n  background: rgba(42, 178, 123, .05);\n}\n.upload .upload-draggable:hover.is-warning,\n.upload .upload-draggable.is-hovered.is-warning {\n  border-color: #ffdd57;\n  background: rgba(255, 221, 87, .05);\n}\n.upload .upload-draggable:hover.is-danger,\n.upload .upload-draggable.is-hovered.is-danger {\n  border-color: #dc5b5b;\n  background: rgba(220, 91, 91, .05);\n}\n.is-aligned-right {\n  text-align: right;\n}\n.is-aligned-left {\n  text-align: left;\n}\n.is-aligned-center {\n  text-align: center;\n}\n.is-pulled-right {\n  float: right;\n}\n.is-pulled-left {\n  float: left;\n}\n.is-absolutely-right {\n  right: 0;\n  position: absolute;\n}\n.is-absolutely-left {\n  left: 0;\n  position: absolute;\n}\n.card-header {\n  background-color: #f5f5f5;\n}\n.card-header.clickable:hover {\n  background: #f2f2f2;\n  cursor: pointer;\n}\n.image.thumbnail {\n  margin: .75rem;\n}\n.image.thumbnail:first-of-type {\n  margin-left: 0;\n}\n.image.thumbnail img {\n  height: 128px;\n  -o-object-fit: cover;\n     object-fit: cover;\n  width: 100%;\n}\n.emergencies .card .card-header .meta {\n  font-size: .75rem;\n  font-weight: normal;\n  color: #4c4c4d;\n}\n.emergencies .card .card-header .image {\n  height: 48px;\n  width: auto !important;\n  max-width: 72px;\n  margin-top: -8px;\n  margin-bottom: -8px;\n}\n.emergencies .card .card-header .image img {\n  max-height: 100%;\n  max-width: 100%;\n}\n.mt-0 {\n  margin-top: 0 !important;\n}\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n.mr-0 {\n  margin-right: 0 !important;\n}\n.ml-0 {\n  margin-left: 0 !important;\n}\n.mx-0 {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n.m-0 {\n  margin: 0 !important;\n}\n.mt-1 {\n  margin-top: .25rem !important;\n}\n.mb-1 {\n  margin-bottom: .25rem !important;\n}\n.mr-1 {\n  margin-right: .25rem !important;\n}\n.ml-1 {\n  margin-left: .25rem !important;\n}\n.mx-1 {\n  margin-left: .25rem !important;\n  margin-right: .25rem !important;\n}\n.my-1 {\n  margin-top: .25rem !important;\n  margin-bottom: .25rem !important;\n}\n.m-1 {\n  margin: .25rem !important;\n}\n.mt-2 {\n  margin-top: .5rem !important;\n}\n.mb-2 {\n  margin-bottom: .5rem !important;\n}\n.mr-2 {\n  margin-right: .5rem !important;\n}\n.ml-2 {\n  margin-left: .5rem !important;\n}\n.mx-2 {\n  margin-left: .5rem !important;\n  margin-right: .5rem !important;\n}\n.my-2 {\n  margin-top: .5rem !important;\n  margin-bottom: .5rem !important;\n}\n.m-2 {\n  margin: .5rem !important;\n}\n.mt-3 {\n  margin-top: .75rem !important;\n}\n.mb-3 {\n  margin-bottom: .75rem !important;\n}\n.mr-3 {\n  margin-right: .75rem !important;\n}\n.ml-3 {\n  margin-left: .75rem !important;\n}\n.mx-3 {\n  margin-left: .75rem !important;\n  margin-right: .75rem !important;\n}\n.my-3 {\n  margin-top: .75rem !important;\n  margin-bottom: .75rem !important;\n}\n.m-3 {\n  margin: .75rem !important;\n}\n.mt-4 {\n  margin-top: 1rem !important;\n}\n.mb-4 {\n  margin-bottom: 1rem !important;\n}\n.mr-4 {\n  margin-right: 1rem !important;\n}\n.ml-4 {\n  margin-left: 1rem !important;\n}\n.mx-4 {\n  margin-left: 1rem !important;\n  margin-right: 1rem !important;\n}\n.my-4 {\n  margin-top: 1rem !important;\n  margin-bottom: 1rem !important;\n}\n.m-4 {\n  margin: 1rem !important;\n}\n.mt-5 {\n  margin-top: 1.5rem !important;\n}\n.mb-5 {\n  margin-bottom: 1.5rem !important;\n}\n.mr-5 {\n  margin-right: 1.5rem !important;\n}\n.ml-5 {\n  margin-left: 1.5rem !important;\n}\n.mx-5 {\n  margin-left: 1.5rem !important;\n  margin-right: 1.5rem !important;\n}\n.my-5 {\n  margin-top: 1.5rem !important;\n  margin-bottom: 1.5rem !important;\n}\n.m-5 {\n  margin: 1.5rem !important;\n}\n.mt-6 {\n  margin-top: 2rem !important;\n}\n.mb-6 {\n  margin-bottom: 2rem !important;\n}\n.mr-6 {\n  margin-right: 2rem !important;\n}\n.ml-6 {\n  margin-left: 2rem !important;\n}\n.mx-6 {\n  margin-left: 2rem !important;\n  margin-right: 2rem !important;\n}\n.my-6 {\n  margin-top: 2rem !important;\n  margin-bottom: 2rem !important;\n}\n.m-6 {\n  margin: 2rem !important;\n}\n.mt-7 {\n  margin-top: 3rem !important;\n}\n.mb-7 {\n  margin-bottom: 3rem !important;\n}\n.mr-7 {\n  margin-right: 3rem !important;\n}\n.ml-7 {\n  margin-left: 3rem !important;\n}\n.mx-7 {\n  margin-left: 3rem !important;\n  margin-right: 3rem !important;\n}\n.my-7 {\n  margin-top: 3rem !important;\n  margin-bottom: 3rem !important;\n}\n.m-7 {\n  margin: 3rem !important;\n}\n.mt-8 {\n  margin-top: 4rem !important;\n}\n.mb-8 {\n  margin-bottom: 4rem !important;\n}\n.mr-8 {\n  margin-right: 4rem !important;\n}\n.ml-8 {\n  margin-left: 4rem !important;\n}\n.mx-8 {\n  margin-left: 4rem !important;\n  margin-right: 4rem !important;\n}\n.my-8 {\n  margin-top: 4rem !important;\n  margin-bottom: 4rem !important;\n}\n.m-8 {\n  margin: 4rem !important;\n}\n.mt-9 {\n  margin-top: 5rem !important;\n}\n.mb-9 {\n  margin-bottom: 5rem !important;\n}\n.mr-9 {\n  margin-right: 5rem !important;\n}\n.ml-9 {\n  margin-left: 5rem !important;\n}\n.mx-9 {\n  margin-left: 5rem !important;\n  margin-right: 5rem !important;\n}\n.my-9 {\n  margin-top: 5rem !important;\n  margin-bottom: 5rem !important;\n}\n.m-9 {\n  margin: 5rem !important;\n}\n.mt-10 {\n  margin-top: 6rem !important;\n}\n.mb-10 {\n  margin-bottom: 6rem !important;\n}\n.mr-10 {\n  margin-right: 6rem !important;\n}\n.ml-10 {\n  margin-left: 6rem !important;\n}\n.mx-10 {\n  margin-left: 6rem !important;\n  margin-right: 6rem !important;\n}\n.my-10 {\n  margin-top: 6rem !important;\n  margin-bottom: 6rem !important;\n}\n.m-10 {\n  margin: 6rem !important;\n}\n.mt-11 {\n  margin-top: 8rem !important;\n}\n.mb-11 {\n  margin-bottom: 8rem !important;\n}\n.mr-11 {\n  margin-right: 8rem !important;\n}\n.ml-11 {\n  margin-left: 8rem !important;\n}\n.mx-11 {\n  margin-left: 8rem !important;\n  margin-right: 8rem !important;\n}\n.my-11 {\n  margin-top: 8rem !important;\n  margin-bottom: 8rem !important;\n}\n.m-11 {\n  margin: 8rem !important;\n}\n.mt-12 {\n  margin-top: 10rem !important;\n}\n.mb-12 {\n  margin-bottom: 10rem !important;\n}\n.mr-12 {\n  margin-right: 10rem !important;\n}\n.ml-12 {\n  margin-left: 10rem !important;\n}\n.mx-12 {\n  margin-left: 10rem !important;\n  margin-right: 10rem !important;\n}\n.my-12 {\n  margin-top: 10rem !important;\n  margin-bottom: 10rem !important;\n}\n.m-12 {\n  margin: 10rem !important;\n}\n.pt-0 {\n  padding-top: 0 !important;\n}\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n.pr-0 {\n  padding-right: 0 !important;\n}\n.pl-0 {\n  padding-left: 0 !important;\n}\n.px-0 {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.p-0 {\n  padding: 0 !important;\n}\n.pt-1 {\n  padding-top: .25rem !important;\n}\n.pb-1 {\n  padding-bottom: .25rem !important;\n}\n.pr-1 {\n  padding-right: .25rem !important;\n}\n.pl-1 {\n  padding-left: .25rem !important;\n}\n.px-1 {\n  padding-left: .25rem !important;\n  padding-right: .25rem !important;\n}\n.py-1 {\n  padding-top: .25rem !important;\n  padding-bottom: .25rem !important;\n}\n.p-1 {\n  padding: .25rem !important;\n}\n.pt-2 {\n  padding-top: .5rem !important;\n}\n.pb-2 {\n  padding-bottom: .5rem !important;\n}\n.pr-2 {\n  padding-right: .5rem !important;\n}\n.pl-2 {\n  padding-left: .5rem !important;\n}\n.px-2 {\n  padding-left: .5rem !important;\n  padding-right: .5rem !important;\n}\n.py-2 {\n  padding-top: .5rem !important;\n  padding-bottom: .5rem !important;\n}\n.p-2 {\n  padding: .5rem !important;\n}\n.pt-3 {\n  padding-top: .75rem !important;\n}\n.pb-3 {\n  padding-bottom: .75rem !important;\n}\n.pr-3 {\n  padding-right: .75rem !important;\n}\n.pl-3 {\n  padding-left: .75rem !important;\n}\n.px-3 {\n  padding-left: .75rem !important;\n  padding-right: .75rem !important;\n}\n.py-3 {\n  padding-top: .75rem !important;\n  padding-bottom: .75rem !important;\n}\n.p-3 {\n  padding: .75rem !important;\n}\n.pt-4 {\n  padding-top: 1rem !important;\n}\n.pb-4 {\n  padding-bottom: 1rem !important;\n}\n.pr-4 {\n  padding-right: 1rem !important;\n}\n.pl-4 {\n  padding-left: 1rem !important;\n}\n.px-4 {\n  padding-left: 1rem !important;\n  padding-right: 1rem !important;\n}\n.py-4 {\n  padding-top: 1rem !important;\n  padding-bottom: 1rem !important;\n}\n.p-4 {\n  padding: 1rem !important;\n}\n.pt-5 {\n  padding-top: 1.5rem !important;\n}\n.pb-5 {\n  padding-bottom: 1.5rem !important;\n}\n.pr-5 {\n  padding-right: 1.5rem !important;\n}\n.pl-5 {\n  padding-left: 1.5rem !important;\n}\n.px-5 {\n  padding-left: 1.5rem !important;\n  padding-right: 1.5rem !important;\n}\n.py-5 {\n  padding-top: 1.5rem !important;\n  padding-bottom: 1.5rem !important;\n}\n.p-5 {\n  padding: 1.5rem !important;\n}\n.pt-6 {\n  padding-top: 2rem !important;\n}\n.pb-6 {\n  padding-bottom: 2rem !important;\n}\n.pr-6 {\n  padding-right: 2rem !important;\n}\n.pl-6 {\n  padding-left: 2rem !important;\n}\n.px-6 {\n  padding-left: 2rem !important;\n  padding-right: 2rem !important;\n}\n.py-6 {\n  padding-top: 2rem !important;\n  padding-bottom: 2rem !important;\n}\n.p-6 {\n  padding: 2rem !important;\n}\n.pt-7 {\n  padding-top: 3rem !important;\n}\n.pb-7 {\n  padding-bottom: 3rem !important;\n}\n.pr-7 {\n  padding-right: 3rem !important;\n}\n.pl-7 {\n  padding-left: 3rem !important;\n}\n.px-7 {\n  padding-left: 3rem !important;\n  padding-right: 3rem !important;\n}\n.py-7 {\n  padding-top: 3rem !important;\n  padding-bottom: 3rem !important;\n}\n.p-7 {\n  padding: 3rem !important;\n}\n.pt-8 {\n  padding-top: 4rem !important;\n}\n.pb-8 {\n  padding-bottom: 4rem !important;\n}\n.pr-8 {\n  padding-right: 4rem !important;\n}\n.pl-8 {\n  padding-left: 4rem !important;\n}\n.px-8 {\n  padding-left: 4rem !important;\n  padding-right: 4rem !important;\n}\n.py-8 {\n  padding-top: 4rem !important;\n  padding-bottom: 4rem !important;\n}\n.p-8 {\n  padding: 4rem !important;\n}\n.pt-9 {\n  padding-top: 5rem !important;\n}\n.pb-9 {\n  padding-bottom: 5rem !important;\n}\n.pr-9 {\n  padding-right: 5rem !important;\n}\n.pl-9 {\n  padding-left: 5rem !important;\n}\n.px-9 {\n  padding-left: 5rem !important;\n  padding-right: 5rem !important;\n}\n.py-9 {\n  padding-top: 5rem !important;\n  padding-bottom: 5rem !important;\n}\n.p-9 {\n  padding: 5rem !important;\n}\n.pt-10 {\n  padding-top: 6rem !important;\n}\n.pb-10 {\n  padding-bottom: 6rem !important;\n}\n.pr-10 {\n  padding-right: 6rem !important;\n}\n.pl-10 {\n  padding-left: 6rem !important;\n}\n.px-10 {\n  padding-left: 6rem !important;\n  padding-right: 6rem !important;\n}\n.py-10 {\n  padding-top: 6rem !important;\n  padding-bottom: 6rem !important;\n}\n.p-10 {\n  padding: 6rem !important;\n}\n.pt-11 {\n  padding-top: 8rem !important;\n}\n.pb-11 {\n  padding-bottom: 8rem !important;\n}\n.pr-11 {\n  padding-right: 8rem !important;\n}\n.pl-11 {\n  padding-left: 8rem !important;\n}\n.px-11 {\n  padding-left: 8rem !important;\n  padding-right: 8rem !important;\n}\n.py-11 {\n  padding-top: 8rem !important;\n  padding-bottom: 8rem !important;\n}\n.p-11 {\n  padding: 8rem !important;\n}\n.pt-12 {\n  padding-top: 10rem !important;\n}\n.pb-12 {\n  padding-bottom: 10rem !important;\n}\n.pr-12 {\n  padding-right: 10rem !important;\n}\n.pl-12 {\n  padding-left: 10rem !important;\n}\n.px-12 {\n  padding-left: 10rem !important;\n  padding-right: 10rem !important;\n}\n.py-12 {\n  padding-top: 10rem !important;\n  padding-bottom: 10rem !important;\n}\n.p-12 {\n  padding: 10rem !important;\n}\n.panel {\n  background: #fff;\n}\n.section {\n  background: #fff;\n  border: 1px solid #efefef;\n  border-radius: 5px;\n}\n.bg-white {\n  background-color: white;\n  color: #0a0a0a;\n}\n.bg-black {\n  background-color: #0a0a0a;\n  color: white;\n}\n.bg-grey {\n  background-color: #9babb4;\n  color: #fff;\n}\n.bg-blue {\n  background-color: #3b5998;\n  color: #fff;\n}\n.bg-blue-dark {\n  background-color: #3b5998;\n  color: #fff;\n}\n.bg-light {\n  background-color: whitesmoke;\n  color: #363636;\n}\n.bg-dark {\n  background-color: #363636;\n  color: whitesmoke;\n}\n.bg-primary {\n  background-color: #2196f3;\n  color: #fff;\n}\n.bg-info {\n  background-color: #3b5998;\n  color: #fff;\n}\n.bg-success {\n  background-color: #2ab27b;\n  color: #fff;\n}\n.bg-warning {\n  background-color: #ffdd57;\n  color: rgba(0, 0, 0, .7);\n}\n.bg-danger {\n  background-color: #dc5b5b;\n  color: #fff;\n}\n.is-fullwidth {\n  width: 100%;\n}\n.v-level {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.v-flex {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n      flex: 1;\n}\n.justify-center {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.flex-wrap {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.data-title {\n  display: block;\n  font-weight: bold;\n  font-size: 11px;\n  color: #363636;\n}\n.data-value {\n  color: #636b6f;\n  display: block;\n  font-size: 14px;\n}\n.availability-switch {\n  margin-top: 6px;\n}\n.availability-switch .control-label {\n  display: none;\n}\n.google-map {\n  width: 100%;\n  height: 300px;\n  margin: 0 auto;\n  background: lightgray;\n}\n.selected-avatar img {\n  opacity: 1;\n}\n.unselected-avatar img {\n  opacity: .5;\n}\n.unselected-avatar img:hover {\n  opacity: 1;\n}\n.navbar .navbar-start > a.navbar-item,\n.navbar .navbar-start .navbar-link,\n.navbar .navbar-end > a.navbar-item,\n.navbar .navbar-end .navbar-link {\n  border-bottom: 3px solid transparent;\n}\n.navbar .navbar-start > a.navbar-item:hover,\n.navbar .navbar-start > a.navbar-item.is-active,\n.navbar .navbar-start .navbar-link:hover,\n.navbar .navbar-start .navbar-link.is-active,\n.navbar .navbar-end > a.navbar-item:hover,\n.navbar .navbar-end > a.navbar-item.is-active,\n.navbar .navbar-end .navbar-link:hover,\n.navbar .navbar-end .navbar-link.is-active {\n  background: initial;\n  border-bottom: 3px solid #2196f3;\n  color: #0a0a0a;\n}\n.navbar.is-dark .navbar-start > a.navbar-item:hover,\n.navbar.is-dark .navbar-start > a.navbar-item.is-active,\n.navbar.is-dark .navbar-start .navbar-link:hover,\n.navbar.is-dark .navbar-start .navbar-link.is-active,\n.navbar.is-dark .navbar-end > a.navbar-item:hover,\n.navbar.is-dark .navbar-end > a.navbar-item.is-active,\n.navbar.is-dark .navbar-end .navbar-link:hover,\n.navbar.is-dark .navbar-end .navbar-link.is-active {\n  background: #363636;\n}\n.is-vcentered table.table tr,\n.is-vcentered table.table td {\n  vertical-align: middle;\n}\n.cookie-notification-container {\n  display: block;\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 10px;\n  text-align: center;\n  z-index: 1100;\n}\n.cookie-notification-container > .notification {\n  -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, .11), 0 1px 3px rgba(0, 0, 0, .08);\n          box-shadow: 0 4px 6px rgba(50, 50, 93, .11), 0 1px 3px rgba(0, 0, 0, .08);\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  padding: .75rem !important;\n}\n.cookie-notification-container > .notification > .delete {\n  right: -0.5rem !important;\n  top: -0.5rem !important;\n}\n.admin-doctors-office:not(:last-of-type) {\n  border-bottom: 1px solid #dbdbdb;\n  padding-bottom: 10px;\n  margin-bottom: 10px;\n}\n.clickable {\n  cursor: pointer;\n}\n.notifications-wrapper {\n  position: absolute;\n  top: 25px;\n  right: 15px;\n  width: 350px;\n  max-width: 90%;\n}\n.mx-auto {\n  margin-left: auto;\n  margin-right: auto;\n}\n.select:not(.is-multiple):not(.is-loading)::after {\n  border-color: #dbdbdb;\n}\n@media screen and (max-width: 768px) {\n.advertisements-wrapper {\n    display: none;\n}\n}\n.z-10 {\n  z-index: 10;\n}\n.z-50 {\n  z-index: 50;\n}\n", ""]);

// exports


/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecommendationsModal_vue__ = __webpack_require__(402);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1085ce83_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecommendationsModal_vue__ = __webpack_require__(801);
var disposed = false
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecommendationsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1085ce83_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecommendationsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/RecommendationsModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1085ce83", Component.options)
  } else {
    hotAPI.reload("data-v-1085ce83", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);











// Extend EventEmitter so user of EmergencyRepository can react to our own defined events. (ex: emergencyRepository.on('added'))

var RecommendationRepository = function (_EventEmitter) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(RecommendationRepository, _EventEmitter);

    function RecommendationRepository() {
        var _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RecommendationRepository);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RecommendationRepository.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(RecommendationRepository)).call(this));

        _this.collection = __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('recommendations');

        return _ret = _this, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(RecommendationRepository, [{
        key: 'all',
        value: function all(onSuccess, onError) {
            __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('recommendations').get().then(function (querySnapshot) {
                var recommendations = [];

                querySnapshot.forEach(function (doc) {
                    var recommendation = doc.data();

                    recommendations.push(recommendation);
                });

                onSuccess(recommendations);
            }).catch(function (error) {
                onError(error);
            });
        }
    }, {
        key: 'createMany',
        value: function createMany(doctor, recommendations, onSuccess, onError) {
            var batch = __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].batch();
            var recommendationDocs = {};

            recommendations.forEach(function (item, index, array) {
                var recommendationRef = __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('recommendations').doc();

                recommendationDocs[recommendationRef.id] = {
                    id: recommendationRef.id,
                    fromFirstName: doctor.firstName,
                    fromLanguage: doctor.language,
                    fromLastName: doctor.lastName,
                    fromId: doctor.id,
                    toEmail: item.email,
                    toName: item.name,
                    toId: null
                };

                batch.set(recommendationRef, recommendationDocs[recommendationRef.id]);
            });

            batch.commit().then(function () {
                __WEBPACK_IMPORTED_MODULE_7__store__["a" /* store */].dispatch('setRecommendations', recommendationDocs);
                __WEBPACK_IMPORTED_MODULE_7__store__["a" /* store */].dispatch('setLoaded', true);
                __WEBPACK_IMPORTED_MODULE_7__store__["a" /* store */].dispatch('setLoading', false);
                onSuccess();
            }).catch(function (error) {
                console.log('commit error');
                console.error(error);
                onError(error);
            });
        }
    }]);

    return RecommendationRepository;
}(__WEBPACK_IMPORTED_MODULE_6_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new RecommendationRepository());

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal", class: { "is-active": _vm.active } },
    [
      _c("div", { staticClass: "modal-background" }),
      _vm._v(" "),
      _c("div", { staticClass: "modal-card" }, [
        _c("header", { staticClass: "modal-card-head" }, [
          _c("p", { staticClass: "modal-card-title" }, [
            _vm._v(_vm._s(_vm.$t("recommandation_title")))
          ])
        ]),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "modal-card-body" },
          [
            _c("div", { staticClass: "notification is-primary" }, [
              _vm._v(_vm._s(_vm.$t("intro_text")))
            ]),
            _vm._v(" "),
            _vm._l(_vm.newRecommendations, function(recommendation, key) {
              return _c("div", { key: key }, [
                _c("div", { staticClass: "columns" }, [
                  _c("div", { staticClass: "column is-5" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", {
                        staticClass: "label",
                        domProps: {
                          textContent: _vm._s(_vm.$t("contact_name_label"))
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "control has-icon has-icons-right" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: recommendation.name,
                                expression: "recommendation.name"
                              }
                            ],
                            class: {
                              input: true,
                              "is-danger": _vm.errors.has(
                                "newRecommendations." + key + ".name"
                              )
                            },
                            attrs: {
                              name: "newRecommendations." + key + ".name",
                              type: "text"
                            },
                            domProps: { value: recommendation.name },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  recommendation,
                                  "name",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has(
                                    "newRecommendations." + key + ".name"
                                  ),
                                  expression:
                                    "errors.has('newRecommendations.' + key + '.name')"
                                }
                              ],
                              staticClass: "icon is-right is-danger"
                            },
                            [
                              _c("i", {
                                staticClass: "mdi mdi-alert-circle mdi-24px"
                              })
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column is-5" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", {
                        staticClass: "label",
                        domProps: {
                          textContent: _vm._s(_vm.$t("contact_email_label"))
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "control has-icon has-icons-right" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|email",
                                expression: "'required|email'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: recommendation.email,
                                expression: "recommendation.email"
                              }
                            ],
                            class: {
                              input: true,
                              "is-danger": _vm.errors.has(
                                "newRecommendations." + key + ".email"
                              )
                            },
                            attrs: {
                              name: "newRecommendations." + key + ".email",
                              type: "email"
                            },
                            domProps: { value: recommendation.email },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  recommendation,
                                  "email",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has(
                                    "newRecommendations." + key + ".email"
                                  ),
                                  expression:
                                    "errors.has('newRecommendations.' + key + '.email')"
                                }
                              ],
                              staticClass: "icon is-right is-danger"
                            },
                            [
                              _c("i", {
                                staticClass: "mdi mdi-alert-circle mdi-24px"
                              })
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column is-2" }, [
                    key >= 2
                      ? _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [_vm._v(" ")]),
                          _vm._v(" "),
                          _c("p", { staticClass: "control" }, [
                            _c(
                              "button",
                              {
                                staticClass: "button is-danger is-outlined",
                                attrs: { disabled: _vm.isModalLoading },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.removeRecommendation(key)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("remove_doctor")))]
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button is-info is-outlined mt-3",
                attrs: { disabled: _vm.isModalLoading },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.addRecommendation()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("add_another_doctor")))]
            )
          ],
          2
        ),
        _vm._v(" "),
        _c("footer", { staticClass: "modal-card-foot" }, [
          _c(
            "button",
            {
              staticClass: "button",
              attrs: { type: "button", disabled: _vm.isModalLoading },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.close()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("close_button_label")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button is-primary",
              class: { "is-loading": _vm.isModalLoading },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.confirm()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("submit_button_label")))]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1085ce83", esExports)
  }
}

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnersList_vue__ = __webpack_require__(403);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5c6770e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnersList_vue__ = __webpack_require__(805);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(803)
}
var normalizeComponent = __webpack_require__(1)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnersList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5c6770e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PartnersList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/Doctor/PartnersList.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b5c6770e", Component.options)
  } else {
    hotAPI.reload("data-v-b5c6770e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(804);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(20)("002b9dce", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b5c6770e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PartnersList.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-b5c6770e\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/lib/loader.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PartnersList.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(19)(false);
// imports


// module
exports.push([module.i, "\n.flex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.justify-around {\n  -ms-flex-pack: distribute;\n  justify-content: space-around;\n}\n.justify-between {\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n.justify-center {\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n.items-center {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n.w-1\\/7 {\n  width: calc(100% / 7);\n}\n.w-1\\/8 {\n  width: calc(100% / 8);\n}\n", ""]);

// exports


/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "container is-hidden-mobile" }, [
    _c(
      "div",
      { staticClass: "flex justify-around items-center flex-wrap mx-4 my-4" },
      _vm._l(_vm.partners, function(partner) {
        return _c("div", { staticClass: "w-1/8 text-center" }, [
          _c("a", { attrs: { href: partner.url[_vm.currentLanguage] } }, [
            _c("img", {
              attrs: {
                src: "/static/partners/" + partner.id + "-square.png",
                alt: ""
              }
            })
          ])
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b5c6770e", esExports)
  }
}

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("router-view", {
        staticStyle: { "min-height": "calc(100vh - 14rem)" }
      }),
      _vm._v(" "),
      _c("partners-list"),
      _vm._v(" "),
      _c("footer", { staticClass: "my-5" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "content has-text-centered" }, [
            _c("p", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("footer_copyrights", {
                    year: new Date().getFullYear()
                  })
                )
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "is-size-7" }, [
              _c(
                "a",
                {
                  attrs: { href: _vm.$t("public_site_uri"), target: "_blank" }
                },
                [_vm._v(_vm._s(_vm.$t("public_site_label")))]
              ),
              _vm._v(" · "),
              _c(
                "a",
                { attrs: { href: _vm.$t("terms_uri"), target: "_blank" } },
                [_vm._v(_vm._s(_vm.$t("terms_label")))]
              ),
              _vm._v(" · "),
              _c(
                "a",
                {
                  attrs: {
                    href: _vm.$t("privacy_policy_uri"),
                    target: "_blank"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("privacy_policy_label")))]
              ),
              _vm._v(" · "),
              _c(
                "a",
                {
                  attrs: { href: _vm.$t("cookie_policy_uri"), target: "_blank" }
                },
                [_vm._v(_vm._s(_vm.$t("cookie_policy_label")))]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.showCookieNotification
        ? _c("div", { staticClass: "cookie-notification-container" }, [
            _c("div", { staticClass: "notification is-info" }, [
              _c("span", {
                domProps: { textContent: _vm._s(_vm.$t("cookie_notification")) }
              }),
              _vm._v(" "),
              _c("button", {
                staticClass: "delete",
                on: {
                  click: function($event) {
                    return _vm.consentCookies()
                  }
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("recommendations-modal", {
        attrs: { active: _vm.showRecommendationsModal },
        on: {
          close: function($event) {
            return _vm.closeRecommendationsModal()
          }
        }
      }),
      _vm._v(" "),
      _c("b-loading", { attrs: { active: _vm.isLoading } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a4766e8", esExports)
  }
}

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [_vm.layout ? _c(_vm.layout, { tag: "component" }) : _vm._e()],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(3);









// Extend EventEmitter so user of CountryRepository can react to our own defined events. (ex: countryRepository.on('added'))

var CountryRepository = function (_EventEmitter) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CountryRepository, _EventEmitter);

    function CountryRepository() {
        var _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CountryRepository);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CountryRepository.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CountryRepository)).call(this));

        _this.collection = __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('countries');

        return _ret = _this, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    // Check if a Country exists


    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CountryRepository, [{
        key: 'list',
        value: function list(onSuccess, onError) {
            this.collection.get().then(function (querySnapshot) {
                var countries = {};

                querySnapshot.forEach(function (doc) {
                    countries[doc.id] = doc.data();
                });

                onSuccess(countries);
            }).catch(function (error) {
                onError(error);
            });
        }
    }]);

    return CountryRepository;
}(__WEBPACK_IMPORTED_MODULE_6_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new CountryRepository());

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(3);









// Extend EventEmitter so user of LanguageRepository can react to our own defined events. (ex: languageRepository.on('added'))

var LanguageRepository = function (_EventEmitter) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(LanguageRepository, _EventEmitter);

    function LanguageRepository() {
        var _ret;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LanguageRepository);

        var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (LanguageRepository.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(LanguageRepository)).call(this));

        _this.collection = __WEBPACK_IMPORTED_MODULE_5__firebase__["c" /* db */].collection('languages');

        return _ret = _this, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
    }

    // Check if a Language exists


    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(LanguageRepository, [{
        key: 'list',
        value: function list(onSuccess, onError) {
            this.collection.get().then(function (querySnapshot) {
                var countries = {};

                querySnapshot.forEach(function (doc) {
                    countries[doc.id] = doc.data();
                });

                onSuccess(countries);
            }).catch(function (error) {
                onError(error);
            });
        }
    }]);

    return LanguageRepository;
}(__WEBPACK_IMPORTED_MODULE_6_events___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new LanguageRepository());

/***/ })
],[404]);


// WEBPACK FOOTER //
// static/js/app.46428e4293b53bbd88d2.js